import './index.css';var cU = Object.defineProperty;
var dU = (d, l, u) => l in d ? cU(d, l, { enumerable: !0, configurable: !0, writable: !0, value: u }) : d[l] = u;
var P = (d, l, u) => dU(d, typeof l != "symbol" ? l + "" : l, u);
class d8 {
  addEventListener(l, u) {
    return {
      remove: () => {
      }
    };
  }
  getInstance() {
    return this;
  }
}
var Pl;
// @__NO_SIDE_EFFECTS__
function a5(d) {
  return {
    lang: (d == null ? void 0 : d.lang) ?? (Pl == null ? void 0 : Pl.lang),
    message: d == null ? void 0 : d.message,
    abortEarly: (d == null ? void 0 : d.abortEarly) ?? (Pl == null ? void 0 : Pl.abortEarly),
    abortPipeEarly: (d == null ? void 0 : d.abortPipeEarly) ?? (Pl == null ? void 0 : Pl.abortPipeEarly)
  };
}
var vS;
// @__NO_SIDE_EFFECTS__
function uU(d) {
  return vS == null ? void 0 : vS.get(d);
}
var SS;
// @__NO_SIDE_EFFECTS__
function hU(d) {
  return SS == null ? void 0 : SS.get(d);
}
var RS;
// @__NO_SIDE_EFFECTS__
function mU(d, l) {
  var u;
  return (u = RS == null ? void 0 : RS.get(d)) == null ? void 0 : u.get(l);
}
// @__NO_SIDE_EFFECTS__
function zS(d) {
  var u, p;
  const l = typeof d;
  return l === "string" ? `"${d}"` : l === "number" || l === "bigint" || l === "boolean" ? `${d}` : l === "object" || l === "function" ? (d && ((p = (u = Object.getPrototypeOf(d)) == null ? void 0 : u.constructor) == null ? void 0 : p.name)) ?? "null" : l;
}
function po(d, l, u, p, g) {
  const R = g && "input" in g ? g.input : u.value, y = (g == null ? void 0 : g.expected) ?? d.expects ?? null, Q = (g == null ? void 0 : g.received) ?? /* @__PURE__ */ zS(R), T = {
    kind: d.kind,
    type: d.type,
    input: R,
    expected: y,
    received: Q,
    message: `Invalid ${l}: ${y ? `Expected ${y} but r` : "R"}eceived ${Q}`,
    requirement: d.requirement,
    path: g == null ? void 0 : g.path,
    issues: g == null ? void 0 : g.issues,
    lang: p.lang,
    abortEarly: p.abortEarly,
    abortPipeEarly: p.abortPipeEarly
  }, k = d.kind === "schema", V = (g == null ? void 0 : g.message) ?? d.message ?? /* @__PURE__ */ mU(d.reference, T.lang) ?? (k ? /* @__PURE__ */ hU(T.lang) : null) ?? p.message ?? /* @__PURE__ */ uU(T.lang);
  V !== void 0 && (T.message = typeof V == "function" ? (
    // @ts-expect-error
    V(T)
  ) : V), k && (u.typed = !1), u.issues ? u.issues.push(T) : u.issues = [T];
}
// @__NO_SIDE_EFFECTS__
function er(d) {
  return {
    version: 1,
    vendor: "valibot",
    validate(l) {
      return d["~run"]({ value: l }, /* @__PURE__ */ a5());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function pU(d, l) {
  return Object.hasOwn(d, l) && l !== "__proto__" && l !== "prototype" && l !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function r5(d, l) {
  const u = [...new Set(d)];
  return u.length > 1 ? `(${u.join(` ${l} `)})` : u[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function fU(d, l, u) {
  return typeof d.fallback == "function" ? (
    // @ts-expect-error
    d.fallback(l, u)
  ) : (
    // @ts-expect-error
    d.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function o5(d, l, u) {
  return typeof d.default == "function" ? (
    // @ts-expect-error
    d.default(l, u)
  ) : (
    // @ts-expect-error
    d.default
  );
}
// @__NO_SIDE_EFFECTS__
function s5() {
  return {
    kind: "schema",
    type: "any",
    reference: s5,
    expects: "any",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(d) {
      return d.typed = !0, d;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Qf(d, l) {
  return {
    kind: "schema",
    type: "array",
    reference: Qf,
    expects: "Array",
    async: !1,
    item: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      var R;
      const g = u.value;
      if (Array.isArray(g)) {
        u.typed = !0, u.value = [];
        for (let y = 0; y < g.length; y++) {
          const Q = g[y], T = this.item["~run"]({ value: Q }, p);
          if (T.issues) {
            const k = {
              type: "array",
              origin: "value",
              input: g,
              key: y,
              value: Q
            };
            for (const V of T.issues)
              V.path ? V.path.unshift(k) : V.path = [k], (R = u.issues) == null || R.push(V);
            if (u.issues || (u.issues = T.issues), p.abortEarly) {
              u.typed = !1;
              break;
            }
          }
          T.typed || (u.typed = !1), u.value.push(T.value);
        }
      } else
        po(this, "type", u, p);
      return u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Fa(d) {
  return {
    kind: "schema",
    type: "boolean",
    reference: Fa,
    expects: "boolean",
    async: !1,
    message: d,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(l, u) {
      return typeof l.value == "boolean" ? l.typed = !0 : po(this, "type", l, u), l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Zg(d, l) {
  return {
    kind: "schema",
    type: "literal",
    reference: Zg,
    expects: /* @__PURE__ */ zS(d),
    async: !1,
    literal: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      return u.value === this.literal ? u.typed = !0 : po(this, "type", u, p), u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function QS(d, l, u) {
  return {
    kind: "schema",
    type: "map",
    reference: QS,
    expects: "Map",
    async: !1,
    key: d,
    value: l,
    message: u,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(p, g) {
      var y, Q;
      const R = p.value;
      if (R instanceof Map) {
        p.typed = !0, p.value = /* @__PURE__ */ new Map();
        for (const [T, k] of R) {
          const V = this.key["~run"]({ value: T }, g);
          if (V.issues) {
            const b = {
              type: "map",
              origin: "key",
              input: R,
              key: T,
              value: k
            };
            for (const A of V.issues)
              A.path ? A.path.unshift(b) : A.path = [b], (y = p.issues) == null || y.push(A);
            if (p.issues || (p.issues = V.issues), g.abortEarly) {
              p.typed = !1;
              break;
            }
          }
          const N = this.value["~run"](
            { value: k },
            g
          );
          if (N.issues) {
            const b = {
              type: "map",
              origin: "value",
              input: R,
              key: T,
              value: k
            };
            for (const A of N.issues)
              A.path ? A.path.unshift(b) : A.path = [b], (Q = p.issues) == null || Q.push(A);
            if (p.issues || (p.issues = N.issues), g.abortEarly) {
              p.typed = !1;
              break;
            }
          }
          (!V.typed || !N.typed) && (p.typed = !1), p.value.set(V.value, N.value);
        }
      } else
        po(this, "type", p, g);
      return p;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function _a(d) {
  return {
    kind: "schema",
    type: "number",
    reference: _a,
    expects: "number",
    async: !1,
    message: d,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(l, u) {
      return typeof l.value == "number" && !isNaN(l.value) ? l.typed = !0 : po(this, "type", l, u), l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function hi(d, l) {
  return {
    kind: "schema",
    type: "object",
    reference: hi,
    expects: "Object",
    async: !1,
    entries: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      var R;
      const g = u.value;
      if (g && typeof g == "object") {
        u.typed = !0, u.value = {};
        for (const y in this.entries) {
          const Q = this.entries[y];
          if (y in g || (Q.type === "exact_optional" || Q.type === "optional" || Q.type === "nullish") && // @ts-expect-error
          Q.default !== void 0) {
            const T = y in g ? (
              // @ts-expect-error
              g[y]
            ) : /* @__PURE__ */ o5(Q), k = Q["~run"]({ value: T }, p);
            if (k.issues) {
              const V = {
                type: "object",
                origin: "value",
                input: g,
                key: y,
                value: T
              };
              for (const N of k.issues)
                N.path ? N.path.unshift(V) : N.path = [V], (R = u.issues) == null || R.push(N);
              if (u.issues || (u.issues = k.issues), p.abortEarly) {
                u.typed = !1;
                break;
              }
            }
            k.typed || (u.typed = !1), u.value[y] = k.value;
          } else if (Q.fallback !== void 0)
            u.value[y] = /* @__PURE__ */ fU(Q);
          else if (Q.type !== "exact_optional" && Q.type !== "optional" && Q.type !== "nullish" && (po(this, "key", u, p, {
            input: void 0,
            expected: `"${y}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: g,
                key: y,
                // @ts-expect-error
                value: g[y]
              }
            ]
          }), p.abortEarly))
            break;
        }
      } else
        po(this, "type", u, p);
      return u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Xe(d, l) {
  return {
    kind: "schema",
    type: "optional",
    reference: Xe,
    expects: `(${d.expects} | undefined)`,
    async: !1,
    wrapped: d,
    default: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      return u.value === void 0 && (this.default !== void 0 && (u.value = /* @__PURE__ */ o5(this, u, p)), u.value === void 0) ? (u.typed = !0, u) : this.wrapped["~run"](u, p);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function l5(d, l) {
  return {
    kind: "schema",
    type: "picklist",
    reference: l5,
    expects: /* @__PURE__ */ r5(d.map(zS), "|"),
    async: !1,
    options: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      return this.options.includes(u.value) ? u.typed = !0 : po(this, "type", u, p), u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function c5(d, l, u) {
  return {
    kind: "schema",
    type: "record",
    reference: c5,
    expects: "Object",
    async: !1,
    key: d,
    value: l,
    message: u,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(p, g) {
      var y, Q;
      const R = p.value;
      if (R && typeof R == "object") {
        p.typed = !0, p.value = {};
        for (const T in R)
          if (/* @__PURE__ */ pU(R, T)) {
            const k = R[T], V = this.key["~run"]({ value: T }, g);
            if (V.issues) {
              const b = {
                type: "object",
                origin: "key",
                input: R,
                key: T,
                value: k
              };
              for (const A of V.issues)
                A.path = [b], (y = p.issues) == null || y.push(A);
              if (p.issues || (p.issues = V.issues), g.abortEarly) {
                p.typed = !1;
                break;
              }
            }
            const N = this.value["~run"](
              { value: k },
              g
            );
            if (N.issues) {
              const b = {
                type: "object",
                origin: "value",
                input: R,
                key: T,
                value: k
              };
              for (const A of N.issues)
                A.path ? A.path.unshift(b) : A.path = [b], (Q = p.issues) == null || Q.push(A);
              if (p.issues || (p.issues = N.issues), g.abortEarly) {
                p.typed = !1;
                break;
              }
            }
            (!V.typed || !N.typed) && (p.typed = !1), V.typed && (p.value[V.value] = N.value);
          }
      } else
        po(this, "type", p, g);
      return p;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Kt(d) {
  return {
    kind: "schema",
    type: "string",
    reference: Kt,
    expects: "string",
    async: !1,
    message: d,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(l, u) {
      return typeof l.value == "string" ? l.typed = !0 : po(this, "type", l, u), l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function l3(d) {
  let l;
  if (d)
    for (const u of d)
      l ? l.push(...u.issues) : l = u.issues;
  return l;
}
// @__NO_SIDE_EFFECTS__
function d5(d, l) {
  return {
    kind: "schema",
    type: "union",
    reference: d5,
    expects: /* @__PURE__ */ r5(
      d.map((u) => u.expects),
      "|"
    ),
    async: !1,
    options: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(u, p) {
      let g, R, y;
      for (const Q of this.options) {
        const T = Q["~run"]({ value: u.value }, p);
        if (T.typed)
          if (T.issues)
            R ? R.push(T) : R = [T];
          else {
            g = T;
            break;
          }
        else
          y ? y.push(T) : y = [T];
      }
      if (g)
        return g;
      if (R) {
        if (R.length === 1)
          return R[0];
        po(this, "type", u, p, {
          issues: /* @__PURE__ */ l3(R)
        }), u.typed = !0;
      } else {
        if ((y == null ? void 0 : y.length) === 1)
          return y[0];
        po(this, "type", u, p, {
          issues: /* @__PURE__ */ l3(y)
        });
      }
      return u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function u5() {
  return {
    kind: "schema",
    type: "unknown",
    reference: u5,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    },
    "~run"(d) {
      return d.typed = !0, d;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function gU(d, l) {
  const u = {};
  for (const p of l)
    u[p] = d.entries[p];
  return {
    ...d,
    entries: u,
    get "~standard"() {
      return /* @__PURE__ */ er(this);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function zg(d, l, u) {
  const p = d["~run"]({ value: l }, /* @__PURE__ */ a5(u));
  return {
    typed: p.typed,
    success: !p.issues,
    output: p.value,
    issues: p.issues
  };
}
class vU {
  constructor() {
    P(this, "actionListenersMap");
    P(this, "emittingEvents", !1);
    this.actionListenersMap = /* @__PURE__ */ new Map();
  }
  startEmitting() {
    this.emittingEvents = !0;
  }
  stopEmitting() {
    this.emittingEvents = !1;
  }
  publish(l, u = !1) {
    const p = l.type.startsWith("internal.");
    if (!this.emittingEvents && !u && !p)
      return;
    const g = this.actionListenersMap.get(l.type);
    if (g)
      for (const R of g)
        typeof R == "function" && ("payload" in l ? R(l.payload) : R());
  }
  // Subscribe to actions
  subscribe(l, u) {
    var p;
    return this.actionListenersMap.get(l) || this.actionListenersMap.set(l, []), (p = this.actionListenersMap.get(l)) == null || p.push(u), () => {
      const g = this.actionListenersMap.get(l);
      g && this.actionListenersMap.set(
        l,
        g.filter((R) => R !== u)
      );
    };
  }
}
const Ye = new vU(), c3 = (d) => {
  let l;
  const u = /* @__PURE__ */ new Set(), p = (k, V) => {
    const N = typeof k == "function" ? k(l) : k;
    if (!Object.is(N, l)) {
      const b = l;
      l = V ?? (typeof N != "object" || N === null) ? N : Object.assign({}, l, N), u.forEach((A) => A(l, b));
    }
  }, g = () => l, Q = { setState: p, getState: g, getInitialState: () => T, subscribe: (k) => (u.add(k), () => u.delete(k)) }, T = l = d(p, g, Q);
  return Q;
}, SU = (d) => d ? c3(d) : c3;
function RU(d) {
  return d && d.__esModule && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d;
}
var Vg = { exports: {} }, kt = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var d3;
function EU() {
  if (d3) return kt;
  d3 = 1;
  var d = Symbol.for("react.transitional.element"), l = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), p = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), R = Symbol.for("react.consumer"), y = Symbol.for("react.context"), Q = Symbol.for("react.forward_ref"), T = Symbol.for("react.suspense"), k = Symbol.for("react.memo"), V = Symbol.for("react.lazy"), N = Symbol.iterator;
  function b(F) {
    return F === null || typeof F != "object" ? null : (F = N && F[N] || F["@@iterator"], typeof F == "function" ? F : null);
  }
  var A = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, Ne = Object.assign, Ee = {};
  function Fe(F, H, L) {
    this.props = F, this.context = H, this.refs = Ee, this.updater = L || A;
  }
  Fe.prototype.isReactComponent = {}, Fe.prototype.setState = function(F, H) {
    if (typeof F != "object" && typeof F != "function" && F != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, F, H, "setState");
  }, Fe.prototype.forceUpdate = function(F) {
    this.updater.enqueueForceUpdate(this, F, "forceUpdate");
  };
  function he() {
  }
  he.prototype = Fe.prototype;
  function ie(F, H, L) {
    this.props = F, this.context = H, this.refs = Ee, this.updater = L || A;
  }
  var Ve = ie.prototype = new he();
  Ve.constructor = ie, Ne(Ve, Fe.prototype), Ve.isPureReactComponent = !0;
  var _e = Array.isArray, z = { H: null, A: null, T: null, S: null, V: null }, Ce = Object.prototype.hasOwnProperty;
  function Re(F, H, L, de, ye, Ae) {
    return L = Ae.ref, {
      $$typeof: d,
      type: F,
      key: H,
      ref: L !== void 0 ? L : null,
      props: Ae
    };
  }
  function Ue(F, H) {
    return Re(
      F.type,
      H,
      void 0,
      void 0,
      void 0,
      F.props
    );
  }
  function Se(F) {
    return typeof F == "object" && F !== null && F.$$typeof === d;
  }
  function xe(F) {
    var H = { "=": "=0", ":": "=2" };
    return "$" + F.replace(/[=:]/g, function(L) {
      return H[L];
    });
  }
  var Qe = /\/+/g;
  function fe(F, H) {
    return typeof F == "object" && F !== null && F.key != null ? xe("" + F.key) : H.toString(36);
  }
  function be() {
  }
  function Be(F) {
    switch (F.status) {
      case "fulfilled":
        return F.value;
      case "rejected":
        throw F.reason;
      default:
        switch (typeof F.status == "string" ? F.then(be, be) : (F.status = "pending", F.then(
          function(H) {
            F.status === "pending" && (F.status = "fulfilled", F.value = H);
          },
          function(H) {
            F.status === "pending" && (F.status = "rejected", F.reason = H);
          }
        )), F.status) {
          case "fulfilled":
            return F.value;
          case "rejected":
            throw F.reason;
        }
    }
    throw F;
  }
  function De(F, H, L, de, ye) {
    var Ae = typeof F;
    (Ae === "undefined" || Ae === "boolean") && (F = null);
    var Ze = !1;
    if (F === null) Ze = !0;
    else
      switch (Ae) {
        case "bigint":
        case "string":
        case "number":
          Ze = !0;
          break;
        case "object":
          switch (F.$$typeof) {
            case d:
            case l:
              Ze = !0;
              break;
            case V:
              return Ze = F._init, De(
                Ze(F._payload),
                H,
                L,
                de,
                ye
              );
          }
      }
    if (Ze)
      return ye = ye(F), Ze = de === "" ? "." + fe(F, 0) : de, _e(ye) ? (L = "", Ze != null && (L = Ze.replace(Qe, "$&/") + "/"), De(ye, H, L, "", function(Ht) {
        return Ht;
      })) : ye != null && (Se(ye) && (ye = Ue(
        ye,
        L + (ye.key == null || F && F.key === ye.key ? "" : ("" + ye.key).replace(
          Qe,
          "$&/"
        ) + "/") + Ze
      )), H.push(ye)), 1;
    Ze = 0;
    var Bt = de === "" ? "." : de + ":";
    if (_e(F))
      for (var $e = 0; $e < F.length; $e++)
        de = F[$e], Ae = Bt + fe(de, $e), Ze += De(
          de,
          H,
          L,
          Ae,
          ye
        );
    else if ($e = b(F), typeof $e == "function")
      for (F = $e.call(F), $e = 0; !(de = F.next()).done; )
        de = de.value, Ae = Bt + fe(de, $e++), Ze += De(
          de,
          H,
          L,
          Ae,
          ye
        );
    else if (Ae === "object") {
      if (typeof F.then == "function")
        return De(
          Be(F),
          H,
          L,
          de,
          ye
        );
      throw H = String(F), Error(
        "Objects are not valid as a React child (found: " + (H === "[object Object]" ? "object with keys {" + Object.keys(F).join(", ") + "}" : H) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return Ze;
  }
  function Z(F, H, L) {
    if (F == null) return F;
    var de = [], ye = 0;
    return De(F, de, "", "", function(Ae) {
      return H.call(L, Ae, ye++);
    }), de;
  }
  function X(F) {
    if (F._status === -1) {
      var H = F._result;
      H = H(), H.then(
        function(L) {
          (F._status === 0 || F._status === -1) && (F._status = 1, F._result = L);
        },
        function(L) {
          (F._status === 0 || F._status === -1) && (F._status = 2, F._result = L);
        }
      ), F._status === -1 && (F._status = 0, F._result = H);
    }
    if (F._status === 1) return F._result.default;
    throw F._result;
  }
  var ae = typeof reportError == "function" ? reportError : function(F) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var H = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof F == "object" && F !== null && typeof F.message == "string" ? String(F.message) : String(F),
        error: F
      });
      if (!window.dispatchEvent(H)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", F);
      return;
    }
    console.error(F);
  };
  function Te() {
  }
  return kt.Children = {
    map: Z,
    forEach: function(F, H, L) {
      Z(
        F,
        function() {
          H.apply(this, arguments);
        },
        L
      );
    },
    count: function(F) {
      var H = 0;
      return Z(F, function() {
        H++;
      }), H;
    },
    toArray: function(F) {
      return Z(F, function(H) {
        return H;
      }) || [];
    },
    only: function(F) {
      if (!Se(F))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return F;
    }
  }, kt.Component = Fe, kt.Fragment = u, kt.Profiler = g, kt.PureComponent = ie, kt.StrictMode = p, kt.Suspense = T, kt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = z, kt.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(F) {
      return z.H.useMemoCache(F);
    }
  }, kt.cache = function(F) {
    return function() {
      return F.apply(null, arguments);
    };
  }, kt.cloneElement = function(F, H, L) {
    if (F == null)
      throw Error(
        "The argument must be a React element, but you passed " + F + "."
      );
    var de = Ne({}, F.props), ye = F.key, Ae = void 0;
    if (H != null)
      for (Ze in H.ref !== void 0 && (Ae = void 0), H.key !== void 0 && (ye = "" + H.key), H)
        !Ce.call(H, Ze) || Ze === "key" || Ze === "__self" || Ze === "__source" || Ze === "ref" && H.ref === void 0 || (de[Ze] = H[Ze]);
    var Ze = arguments.length - 2;
    if (Ze === 1) de.children = L;
    else if (1 < Ze) {
      for (var Bt = Array(Ze), $e = 0; $e < Ze; $e++)
        Bt[$e] = arguments[$e + 2];
      de.children = Bt;
    }
    return Re(F.type, ye, void 0, void 0, Ae, de);
  }, kt.createContext = function(F) {
    return F = {
      $$typeof: y,
      _currentValue: F,
      _currentValue2: F,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, F.Provider = F, F.Consumer = {
      $$typeof: R,
      _context: F
    }, F;
  }, kt.createElement = function(F, H, L) {
    var de, ye = {}, Ae = null;
    if (H != null)
      for (de in H.key !== void 0 && (Ae = "" + H.key), H)
        Ce.call(H, de) && de !== "key" && de !== "__self" && de !== "__source" && (ye[de] = H[de]);
    var Ze = arguments.length - 2;
    if (Ze === 1) ye.children = L;
    else if (1 < Ze) {
      for (var Bt = Array(Ze), $e = 0; $e < Ze; $e++)
        Bt[$e] = arguments[$e + 2];
      ye.children = Bt;
    }
    if (F && F.defaultProps)
      for (de in Ze = F.defaultProps, Ze)
        ye[de] === void 0 && (ye[de] = Ze[de]);
    return Re(F, Ae, void 0, void 0, null, ye);
  }, kt.createRef = function() {
    return { current: null };
  }, kt.forwardRef = function(F) {
    return { $$typeof: Q, render: F };
  }, kt.isValidElement = Se, kt.lazy = function(F) {
    return {
      $$typeof: V,
      _payload: { _status: -1, _result: F },
      _init: X
    };
  }, kt.memo = function(F, H) {
    return {
      $$typeof: k,
      type: F,
      compare: H === void 0 ? null : H
    };
  }, kt.startTransition = function(F) {
    var H = z.T, L = {};
    z.T = L;
    try {
      var de = F(), ye = z.S;
      ye !== null && ye(L, de), typeof de == "object" && de !== null && typeof de.then == "function" && de.then(Te, ae);
    } catch (Ae) {
      ae(Ae);
    } finally {
      z.T = H;
    }
  }, kt.unstable_useCacheRefresh = function() {
    return z.H.useCacheRefresh();
  }, kt.use = function(F) {
    return z.H.use(F);
  }, kt.useActionState = function(F, H, L) {
    return z.H.useActionState(F, H, L);
  }, kt.useCallback = function(F, H) {
    return z.H.useCallback(F, H);
  }, kt.useContext = function(F) {
    return z.H.useContext(F);
  }, kt.useDebugValue = function() {
  }, kt.useDeferredValue = function(F, H) {
    return z.H.useDeferredValue(F, H);
  }, kt.useEffect = function(F, H, L) {
    var de = z.H;
    if (typeof L == "function")
      throw Error(
        "useEffect CRUD overload is not enabled in this build of React."
      );
    return de.useEffect(F, H);
  }, kt.useId = function() {
    return z.H.useId();
  }, kt.useImperativeHandle = function(F, H, L) {
    return z.H.useImperativeHandle(F, H, L);
  }, kt.useInsertionEffect = function(F, H) {
    return z.H.useInsertionEffect(F, H);
  }, kt.useLayoutEffect = function(F, H) {
    return z.H.useLayoutEffect(F, H);
  }, kt.useMemo = function(F, H) {
    return z.H.useMemo(F, H);
  }, kt.useOptimistic = function(F, H) {
    return z.H.useOptimistic(F, H);
  }, kt.useReducer = function(F, H, L) {
    return z.H.useReducer(F, H, L);
  }, kt.useRef = function(F) {
    return z.H.useRef(F);
  }, kt.useState = function(F) {
    return z.H.useState(F);
  }, kt.useSyncExternalStore = function(F, H, L) {
    return z.H.useSyncExternalStore(
      F,
      H,
      L
    );
  }, kt.useTransition = function() {
    return z.H.useTransition();
  }, kt.version = "19.1.0", kt;
}
var _f = { exports: {} };
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
_f.exports;
var u3;
function UU() {
  return u3 || (u3 = 1, function(d, l) {
    process.env.NODE_ENV !== "production" && function() {
      function u(C, j) {
        Object.defineProperty(R.prototype, C, {
          get: function() {
            j[0], j[1];
          }
        });
      }
      function p(C) {
        return C === null || typeof C != "object" ? null : (C = rn && C[rn] || C["@@iterator"], typeof C == "function" ? C : null);
      }
      function g(C, j) {
        C = (C = C.constructor) && (C.displayName || C.name) || "ReactClass";
        var ke = C + "." + j;
        tn[ke] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          j,
          C
        ), tn[ke] = !0);
      }
      function R(C, j, ke) {
        this.props = C, this.context = j, this.refs = go, this.updater = ke || gn;
      }
      function y() {
      }
      function Q(C, j, ke) {
        this.props = C, this.context = j, this.refs = go, this.updater = ke || gn;
      }
      function T(C) {
        return "" + C;
      }
      function k(C) {
        try {
          T(C);
          var j = !1;
        } catch {
          j = !0;
        }
        if (j) {
          j = console;
          var ke = j.error, Oe = typeof Symbol == "function" && Symbol.toStringTag && C[Symbol.toStringTag] || C.constructor.name || "Object";
          return ke.call(
            j,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            Oe
          ), T(C);
        }
      }
      function V(C) {
        if (C == null) return null;
        if (typeof C == "function")
          return C.$$typeof === Rr ? null : C.displayName || C.name || null;
        if (typeof C == "string") return C;
        switch (C) {
          case F:
            return "Fragment";
          case L:
            return "Profiler";
          case H:
            return "StrictMode";
          case Ze:
            return "Suspense";
          case Bt:
            return "SuspenseList";
          case Nn:
            return "Activity";
        }
        if (typeof C == "object")
          switch (typeof C.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), C.$$typeof) {
            case Te:
              return "Portal";
            case ye:
              return (C.displayName || "Context") + ".Provider";
            case de:
              return (C._context.displayName || "Context") + ".Consumer";
            case Ae:
              var j = C.render;
              return C = C.displayName, C || (C = j.displayName || j.name || "", C = C !== "" ? "ForwardRef(" + C + ")" : "ForwardRef"), C;
            case $e:
              return j = C.displayName || null, j !== null ? j : V(C.type) || "Memo";
            case Ht:
              j = C._payload, C = C._init;
              try {
                return V(C(j));
              } catch {
              }
          }
        return null;
      }
      function N(C) {
        if (C === F) return "<>";
        if (typeof C == "object" && C !== null && C.$$typeof === Ht)
          return "<...>";
        try {
          var j = V(C);
          return j ? "<" + j + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function b() {
        var C = gt.A;
        return C === null ? null : C.getOwner();
      }
      function A() {
        return Error("react-stack-top-frame");
      }
      function Ne(C) {
        if (bi.call(C, "key")) {
          var j = Object.getOwnPropertyDescriptor(C, "key").get;
          if (j && j.isReactWarning) return !1;
        }
        return C.key !== void 0;
      }
      function Ee(C, j) {
        function ke() {
          xi || (xi = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            j
          ));
        }
        ke.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: ke,
          configurable: !0
        });
      }
      function Fe() {
        var C = V(this.type);
        return vo[C] || (vo[C] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), C = this.props.ref, C !== void 0 ? C : null;
      }
      function he(C, j, ke, Oe, Je, nt, mt, Ct) {
        return ke = nt.ref, C = {
          $$typeof: ae,
          type: C,
          key: j,
          props: nt,
          _owner: Je
        }, (ke !== void 0 ? ke : null) !== null ? Object.defineProperty(C, "ref", {
          enumerable: !1,
          get: Fe
        }) : Object.defineProperty(C, "ref", { enumerable: !1, value: null }), C._store = {}, Object.defineProperty(C._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(C, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(C, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: mt
        }), Object.defineProperty(C, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: Ct
        }), Object.freeze && (Object.freeze(C.props), Object.freeze(C)), C;
      }
      function ie(C, j) {
        return j = he(
          C.type,
          j,
          void 0,
          void 0,
          C._owner,
          C.props,
          C._debugStack,
          C._debugTask
        ), C._store && (j._store.validated = C._store.validated), j;
      }
      function Ve(C) {
        return typeof C == "object" && C !== null && C.$$typeof === ae;
      }
      function _e(C) {
        var j = { "=": "=0", ":": "=2" };
        return "$" + C.replace(/[=:]/g, function(ke) {
          return j[ke];
        });
      }
      function z(C, j) {
        return typeof C == "object" && C !== null && C.key != null ? (k(C.key), _e("" + C.key)) : j.toString(36);
      }
      function Ce() {
      }
      function Re(C) {
        switch (C.status) {
          case "fulfilled":
            return C.value;
          case "rejected":
            throw C.reason;
          default:
            switch (typeof C.status == "string" ? C.then(Ce, Ce) : (C.status = "pending", C.then(
              function(j) {
                C.status === "pending" && (C.status = "fulfilled", C.value = j);
              },
              function(j) {
                C.status === "pending" && (C.status = "rejected", C.reason = j);
              }
            )), C.status) {
              case "fulfilled":
                return C.value;
              case "rejected":
                throw C.reason;
            }
        }
        throw C;
      }
      function Ue(C, j, ke, Oe, Je) {
        var nt = typeof C;
        (nt === "undefined" || nt === "boolean") && (C = null);
        var mt = !1;
        if (C === null) mt = !0;
        else
          switch (nt) {
            case "bigint":
            case "string":
            case "number":
              mt = !0;
              break;
            case "object":
              switch (C.$$typeof) {
                case ae:
                case Te:
                  mt = !0;
                  break;
                case Ht:
                  return mt = C._init, Ue(
                    mt(C._payload),
                    j,
                    ke,
                    Oe,
                    Je
                  );
              }
          }
        if (mt) {
          mt = C, Je = Je(mt);
          var Ct = Oe === "" ? "." + z(mt, 0) : Oe;
          return ka(Je) ? (ke = "", Ct != null && (ke = Ct.replace(Ln, "$&/") + "/"), Ue(Je, j, ke, "", function(Sn) {
            return Sn;
          })) : Je != null && (Ve(Je) && (Je.key != null && (mt && mt.key === Je.key || k(Je.key)), ke = ie(
            Je,
            ke + (Je.key == null || mt && mt.key === Je.key ? "" : ("" + Je.key).replace(
              Ln,
              "$&/"
            ) + "/") + Ct
          ), Oe !== "" && mt != null && Ve(mt) && mt.key == null && mt._store && !mt._store.validated && (ke._store.validated = 2), Je = ke), j.push(Je)), 1;
        }
        if (mt = 0, Ct = Oe === "" ? "." : Oe + ":", ka(C))
          for (var ct = 0; ct < C.length; ct++)
            Oe = C[ct], nt = Ct + z(Oe, ct), mt += Ue(
              Oe,
              j,
              ke,
              nt,
              Je
            );
        else if (ct = p(C), typeof ct == "function")
          for (ct === C.entries && (un = !0), C = ct.call(C), ct = 0; !(Oe = C.next()).done; )
            Oe = Oe.value, nt = Ct + z(Oe, ct++), mt += Ue(
              Oe,
              j,
              ke,
              nt,
              Je
            );
        else if (nt === "object") {
          if (typeof C.then == "function")
            return Ue(
              Re(C),
              j,
              ke,
              Oe,
              Je
            );
          throw j = String(C), Error(
            "Objects are not valid as a React child (found: " + (j === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : j) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return mt;
      }
      function Se(C, j, ke) {
        if (C == null) return C;
        var Oe = [], Je = 0;
        return Ue(C, Oe, "", "", function(nt) {
          return j.call(ke, nt, Je++);
        }), Oe;
      }
      function xe(C) {
        if (C._status === -1) {
          var j = C._result;
          j = j(), j.then(
            function(ke) {
              (C._status === 0 || C._status === -1) && (C._status = 1, C._result = ke);
            },
            function(ke) {
              (C._status === 0 || C._status === -1) && (C._status = 2, C._result = ke);
            }
          ), C._status === -1 && (C._status = 0, C._result = j);
        }
        if (C._status === 1)
          return j = C._result, j === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            j
          ), "default" in j || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            j
          ), j.default;
        throw C._result;
      }
      function Qe() {
        var C = gt.H;
        return C === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), C;
      }
      function fe() {
      }
      function be(C) {
        if (Er === null)
          try {
            var j = ("require" + Math.random()).slice(0, 7);
            Er = (d && d[j]).call(
              d,
              "timers"
            ).setImmediate;
          } catch {
            Er = function(Oe) {
              So === !1 && (So = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var Je = new MessageChannel();
              Je.port1.onmessage = Oe, Je.port2.postMessage(void 0);
            };
          }
        return Er(C);
      }
      function Be(C) {
        return 1 < C.length && typeof AggregateError == "function" ? new AggregateError(C) : C[0];
      }
      function De(C, j) {
        j !== Zi - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), Zi = j;
      }
      function Z(C, j, ke) {
        var Oe = gt.actQueue;
        if (Oe !== null)
          if (Oe.length !== 0)
            try {
              X(Oe), be(function() {
                return Z(C, j, ke);
              });
              return;
            } catch (Je) {
              gt.thrownErrors.push(Je);
            }
          else gt.actQueue = null;
        0 < gt.thrownErrors.length ? (Oe = Be(gt.thrownErrors), gt.thrownErrors.length = 0, ke(Oe)) : j(C);
      }
      function X(C) {
        if (!In) {
          In = !0;
          var j = 0;
          try {
            for (; j < C.length; j++) {
              var ke = C[j];
              do {
                gt.didUsePromise = !1;
                var Oe = ke(!1);
                if (Oe !== null) {
                  if (gt.didUsePromise) {
                    C[j] = ke, C.splice(0, j);
                    return;
                  }
                  ke = Oe;
                } else break;
              } while (!0);
            }
            C.length = 0;
          } catch (Je) {
            C.splice(0, j + 1), gt.thrownErrors.push(Je);
          } finally {
            In = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var ae = Symbol.for("react.transitional.element"), Te = Symbol.for("react.portal"), F = Symbol.for("react.fragment"), H = Symbol.for("react.strict_mode"), L = Symbol.for("react.profiler"), de = Symbol.for("react.consumer"), ye = Symbol.for("react.context"), Ae = Symbol.for("react.forward_ref"), Ze = Symbol.for("react.suspense"), Bt = Symbol.for("react.suspense_list"), $e = Symbol.for("react.memo"), Ht = Symbol.for("react.lazy"), Nn = Symbol.for("react.activity"), rn = Symbol.iterator, tn = {}, gn = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(C) {
          g(C, "forceUpdate");
        },
        enqueueReplaceState: function(C) {
          g(C, "replaceState");
        },
        enqueueSetState: function(C) {
          g(C, "setState");
        }
      }, Ma = Object.assign, go = {};
      Object.freeze(go), R.prototype.isReactComponent = {}, R.prototype.setState = function(C, j) {
        if (typeof C != "object" && typeof C != "function" && C != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, C, j, "setState");
      }, R.prototype.forceUpdate = function(C) {
        this.updater.enqueueForceUpdate(this, C, "forceUpdate");
      };
      var Qt = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      }, vn;
      for (vn in Qt)
        Qt.hasOwnProperty(vn) && u(vn, Qt[vn]);
      y.prototype = R.prototype, Qt = Q.prototype = new y(), Qt.constructor = Q, Ma(Qt, R.prototype), Qt.isPureReactComponent = !0;
      var ka = Array.isArray, Rr = Symbol.for("react.client.reference"), gt = {
        H: null,
        A: null,
        T: null,
        S: null,
        V: null,
        actQueue: null,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, bi = Object.prototype.hasOwnProperty, Lt = console.createTask ? console.createTask : function() {
        return null;
      };
      Qt = {
        "react-stack-bottom-frame": function(C) {
          return C();
        }
      };
      var xi, qo, vo = {}, ni = Qt["react-stack-bottom-frame"].bind(Qt, A)(), Jn = Lt(N(A)), un = !1, Ln = /\/+/g, Qa = typeof reportError == "function" ? reportError : function(C) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var j = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof C == "object" && C !== null && typeof C.message == "string" ? String(C.message) : String(C),
            error: C
          });
          if (!window.dispatchEvent(j)) return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", C);
          return;
        }
        console.error(C);
      }, So = !1, Er = null, Zi = 0, ii = !1, In = !1, Oi = typeof queueMicrotask == "function" ? function(C) {
        queueMicrotask(function() {
          return queueMicrotask(C);
        });
      } : be;
      Qt = Object.freeze({
        __proto__: null,
        c: function(C) {
          return Qe().useMemoCache(C);
        }
      }), l.Children = {
        map: Se,
        forEach: function(C, j, ke) {
          Se(
            C,
            function() {
              j.apply(this, arguments);
            },
            ke
          );
        },
        count: function(C) {
          var j = 0;
          return Se(C, function() {
            j++;
          }), j;
        },
        toArray: function(C) {
          return Se(C, function(j) {
            return j;
          }) || [];
        },
        only: function(C) {
          if (!Ve(C))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return C;
        }
      }, l.Component = R, l.Fragment = F, l.Profiler = L, l.PureComponent = Q, l.StrictMode = H, l.Suspense = Ze, l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = gt, l.__COMPILER_RUNTIME = Qt, l.act = function(C) {
        var j = gt.actQueue, ke = Zi;
        Zi++;
        var Oe = gt.actQueue = j !== null ? j : [], Je = !1;
        try {
          var nt = C();
        } catch (ct) {
          gt.thrownErrors.push(ct);
        }
        if (0 < gt.thrownErrors.length)
          throw De(j, ke), C = Be(gt.thrownErrors), gt.thrownErrors.length = 0, C;
        if (nt !== null && typeof nt == "object" && typeof nt.then == "function") {
          var mt = nt;
          return Oi(function() {
            Je || ii || (ii = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(ct, Sn) {
              Je = !0, mt.then(
                function(Bi) {
                  if (De(j, ke), ke === 0) {
                    try {
                      X(Oe), be(function() {
                        return Z(
                          Bi,
                          ct,
                          Sn
                        );
                      });
                    } catch (Ws) {
                      gt.thrownErrors.push(Ws);
                    }
                    if (0 < gt.thrownErrors.length) {
                      var $o = Be(
                        gt.thrownErrors
                      );
                      gt.thrownErrors.length = 0, Sn($o);
                    }
                  } else ct(Bi);
                },
                function(Bi) {
                  De(j, ke), 0 < gt.thrownErrors.length && (Bi = Be(
                    gt.thrownErrors
                  ), gt.thrownErrors.length = 0), Sn(Bi);
                }
              );
            }
          };
        }
        var Ct = nt;
        if (De(j, ke), ke === 0 && (X(Oe), Oe.length !== 0 && Oi(function() {
          Je || ii || (ii = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), gt.actQueue = null), 0 < gt.thrownErrors.length)
          throw C = Be(gt.thrownErrors), gt.thrownErrors.length = 0, C;
        return {
          then: function(ct, Sn) {
            Je = !0, ke === 0 ? (gt.actQueue = Oe, be(function() {
              return Z(
                Ct,
                ct,
                Sn
              );
            })) : ct(Ct);
          }
        };
      }, l.cache = function(C) {
        return function() {
          return C.apply(null, arguments);
        };
      }, l.captureOwnerStack = function() {
        var C = gt.getCurrentStack;
        return C === null ? null : C();
      }, l.cloneElement = function(C, j, ke) {
        if (C == null)
          throw Error(
            "The argument must be a React element, but you passed " + C + "."
          );
        var Oe = Ma({}, C.props), Je = C.key, nt = C._owner;
        if (j != null) {
          var mt;
          e: {
            if (bi.call(j, "ref") && (mt = Object.getOwnPropertyDescriptor(
              j,
              "ref"
            ).get) && mt.isReactWarning) {
              mt = !1;
              break e;
            }
            mt = j.ref !== void 0;
          }
          mt && (nt = b()), Ne(j) && (k(j.key), Je = "" + j.key);
          for (Ct in j)
            !bi.call(j, Ct) || Ct === "key" || Ct === "__self" || Ct === "__source" || Ct === "ref" && j.ref === void 0 || (Oe[Ct] = j[Ct]);
        }
        var Ct = arguments.length - 2;
        if (Ct === 1) Oe.children = ke;
        else if (1 < Ct) {
          mt = Array(Ct);
          for (var ct = 0; ct < Ct; ct++)
            mt[ct] = arguments[ct + 2];
          Oe.children = mt;
        }
        for (Oe = he(
          C.type,
          Je,
          void 0,
          void 0,
          nt,
          Oe,
          C._debugStack,
          C._debugTask
        ), Je = 2; Je < arguments.length; Je++)
          nt = arguments[Je], Ve(nt) && nt._store && (nt._store.validated = 1);
        return Oe;
      }, l.createContext = function(C) {
        return C = {
          $$typeof: ye,
          _currentValue: C,
          _currentValue2: C,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, C.Provider = C, C.Consumer = {
          $$typeof: de,
          _context: C
        }, C._currentRenderer = null, C._currentRenderer2 = null, C;
      }, l.createElement = function(C, j, ke) {
        for (var Oe = 2; Oe < arguments.length; Oe++) {
          var Je = arguments[Oe];
          Ve(Je) && Je._store && (Je._store.validated = 1);
        }
        if (Oe = {}, Je = null, j != null)
          for (ct in qo || !("__self" in j) || "key" in j || (qo = !0), Ne(j) && (k(j.key), Je = "" + j.key), j)
            bi.call(j, ct) && ct !== "key" && ct !== "__self" && ct !== "__source" && (Oe[ct] = j[ct]);
        var nt = arguments.length - 2;
        if (nt === 1) Oe.children = ke;
        else if (1 < nt) {
          for (var mt = Array(nt), Ct = 0; Ct < nt; Ct++)
            mt[Ct] = arguments[Ct + 2];
          Object.freeze && Object.freeze(mt), Oe.children = mt;
        }
        if (C && C.defaultProps)
          for (ct in nt = C.defaultProps, nt)
            Oe[ct] === void 0 && (Oe[ct] = nt[ct]);
        Je && Ee(
          Oe,
          typeof C == "function" ? C.displayName || C.name || "Unknown" : C
        );
        var ct = 1e4 > gt.recentlyCreatedOwnerStacks++;
        return he(
          C,
          Je,
          void 0,
          void 0,
          b(),
          Oe,
          ct ? Error("react-stack-top-frame") : ni,
          ct ? Lt(N(C)) : Jn
        );
      }, l.createRef = function() {
        var C = { current: null };
        return Object.seal(C), C;
      }, l.forwardRef = function(C) {
        C != null && C.$$typeof === $e ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof C != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          C === null ? "null" : typeof C
        ) : C.length !== 0 && C.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          C.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), C != null && C.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var j = { $$typeof: Ae, render: C }, ke;
        return Object.defineProperty(j, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return ke;
          },
          set: function(Oe) {
            ke = Oe, C.name || C.displayName || (Object.defineProperty(C, "name", { value: Oe }), C.displayName = Oe);
          }
        }), j;
      }, l.isValidElement = Ve, l.lazy = function(C) {
        return {
          $$typeof: Ht,
          _payload: { _status: -1, _result: C },
          _init: xe
        };
      }, l.memo = function(C, j) {
        C == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          C === null ? "null" : typeof C
        ), j = {
          $$typeof: $e,
          type: C,
          compare: j === void 0 ? null : j
        };
        var ke;
        return Object.defineProperty(j, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return ke;
          },
          set: function(Oe) {
            ke = Oe, C.name || C.displayName || (Object.defineProperty(C, "name", { value: Oe }), C.displayName = Oe);
          }
        }), j;
      }, l.startTransition = function(C) {
        var j = gt.T, ke = {};
        gt.T = ke, ke._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var Oe = C(), Je = gt.S;
          Je !== null && Je(ke, Oe), typeof Oe == "object" && Oe !== null && typeof Oe.then == "function" && Oe.then(fe, Qa);
        } catch (nt) {
          Qa(nt);
        } finally {
          j === null && ke._updatedFibers && (C = ke._updatedFibers.size, ke._updatedFibers.clear(), 10 < C), gt.T = j;
        }
      }, l.unstable_useCacheRefresh = function() {
        return Qe().useCacheRefresh();
      }, l.use = function(C) {
        return Qe().use(C);
      }, l.useActionState = function(C, j, ke) {
        return Qe().useActionState(
          C,
          j,
          ke
        );
      }, l.useCallback = function(C, j) {
        return Qe().useCallback(C, j);
      }, l.useContext = function(C) {
        var j = Qe();
        return C.$$typeof === de && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), j.useContext(C);
      }, l.useDebugValue = function(C, j) {
        return Qe().useDebugValue(C, j);
      }, l.useDeferredValue = function(C, j) {
        return Qe().useDeferredValue(C, j);
      }, l.useEffect = function(C, j, ke) {
        C == null;
        var Oe = Qe();
        if (typeof ke == "function")
          throw Error(
            "useEffect CRUD overload is not enabled in this build of React."
          );
        return Oe.useEffect(C, j);
      }, l.useId = function() {
        return Qe().useId();
      }, l.useImperativeHandle = function(C, j, ke) {
        return Qe().useImperativeHandle(C, j, ke);
      }, l.useInsertionEffect = function(C, j) {
        return C == null, Qe().useInsertionEffect(C, j);
      }, l.useLayoutEffect = function(C, j) {
        return C == null, Qe().useLayoutEffect(C, j);
      }, l.useMemo = function(C, j) {
        return Qe().useMemo(C, j);
      }, l.useOptimistic = function(C, j) {
        return Qe().useOptimistic(C, j);
      }, l.useReducer = function(C, j, ke) {
        return Qe().useReducer(C, j, ke);
      }, l.useRef = function(C) {
        return Qe().useRef(C);
      }, l.useState = function(C) {
        return Qe().useState(C);
      }, l.useSyncExternalStore = function(C, j, ke) {
        return Qe().useSyncExternalStore(
          C,
          j,
          ke
        );
      }, l.useTransition = function() {
        return Qe().useTransition();
      }, l.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(_f, _f.exports)), _f.exports;
}
var h3;
function Qh() {
  return h3 || (h3 = 1, process.env.NODE_ENV === "production" ? Vg.exports = EU() : Vg.exports = UU()), Vg.exports;
}
var re = Qh();
const md = /* @__PURE__ */ RU(re), TU = (d) => d;
function yU(d, l = TU) {
  const u = md.useSyncExternalStore(
    d.subscribe,
    () => l(d.getState()),
    () => l(d.getInitialState())
  );
  return md.useDebugValue(u), u;
}
const m3 = (d) => {
  const l = SU(d), u = (p) => yU(l, p);
  return Object.assign(u, l), u;
}, nu = (d) => d ? m3(d) : m3, NU = (d) => (l, u, p) => {
  const g = p.subscribe;
  return p.subscribe = (y, Q, T) => {
    let k = y;
    if (Q) {
      const V = (T == null ? void 0 : T.equalityFn) || Object.is;
      let N = y(p.getState());
      k = (b) => {
        const A = y(b);
        if (!V(N, A)) {
          const Ne = N;
          Q(N = A, Ne);
        }
      }, T != null && T.fireImmediately && Q(N, N);
    }
    return g(k);
  }, d(l, u, p);
}, iu = NU;
function au(d, l) {
  return (...u) => Object.assign({}, d, l(...u));
}
function bU(d, l) {
  let u;
  try {
    u = d();
  } catch {
    return;
  }
  return {
    getItem: (g) => {
      var R;
      const y = (T) => T === null ? null : JSON.parse(T, void 0), Q = (R = u.getItem(g)) != null ? R : null;
      return Q instanceof Promise ? Q.then(y) : y(Q);
    },
    setItem: (g, R) => u.setItem(g, JSON.stringify(R, void 0)),
    removeItem: (g) => u.removeItem(g)
  };
}
const DS = (d) => (l) => {
  try {
    const u = d(l);
    return u instanceof Promise ? u : {
      then(p) {
        return DS(p)(u);
      },
      catch(p) {
        return this;
      }
    };
  } catch (u) {
    return {
      then(p) {
        return this;
      },
      catch(p) {
        return DS(p)(u);
      }
    };
  }
}, VU = (d, l) => (u, p, g) => {
  let R = {
    storage: bU(() => localStorage),
    partialize: (Ee) => Ee,
    version: 0,
    merge: (Ee, Fe) => ({
      ...Fe,
      ...Ee
    }),
    ...l
  }, y = !1;
  const Q = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new Set();
  let k = R.storage;
  if (!k)
    return d(
      (...Ee) => {
        `${R.name}`, u(...Ee);
      },
      p,
      g
    );
  const V = () => {
    const Ee = R.partialize({ ...p() });
    return k.setItem(R.name, {
      state: Ee,
      version: R.version
    });
  }, N = g.setState;
  g.setState = (Ee, Fe) => {
    N(Ee, Fe), V();
  };
  const b = d(
    (...Ee) => {
      u(...Ee), V();
    },
    p,
    g
  );
  g.getInitialState = () => b;
  let A;
  const Ne = () => {
    var Ee, Fe;
    if (!k) return;
    y = !1, Q.forEach((ie) => {
      var Ve;
      return ie((Ve = p()) != null ? Ve : b);
    });
    const he = ((Fe = R.onRehydrateStorage) == null ? void 0 : Fe.call(R, (Ee = p()) != null ? Ee : b)) || void 0;
    return DS(k.getItem.bind(k))(R.name).then((ie) => {
      if (ie)
        if (typeof ie.version == "number" && ie.version !== R.version) {
          if (R.migrate) {
            const Ve = R.migrate(
              ie.state,
              ie.version
            );
            return Ve instanceof Promise ? Ve.then((_e) => [!0, _e]) : [!0, Ve];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, ie.state];
      return [!1, void 0];
    }).then((ie) => {
      var Ve;
      const [_e, z] = ie;
      if (A = R.merge(
        z,
        (Ve = p()) != null ? Ve : b
      ), u(A, !0), _e)
        return V();
    }).then(() => {
      he == null || he(A, void 0), A = p(), y = !0, T.forEach((ie) => ie(A));
    }).catch((ie) => {
      he == null || he(void 0, ie);
    });
  };
  return g.persist = {
    setOptions: (Ee) => {
      R = {
        ...R,
        ...Ee
      }, Ee.storage && (k = Ee.storage);
    },
    clearStorage: () => {
      k == null || k.removeItem(R.name);
    },
    getOptions: () => R,
    rehydrate: () => Ne(),
    hasHydrated: () => y,
    onHydrate: (Ee) => (Q.add(Ee), () => {
      Q.delete(Ee);
    }),
    onFinishHydration: (Ee) => (T.add(Ee), () => {
      T.delete(Ee);
    })
  }, R.skipHydration || Ne(), A || b;
}, CU = VU, Cg = 3 / 4, yf = 16 / 9, Kl = 8, ES = 240, xS = {
  MODERATOR: "moderator",
  NONE: "none"
}, We = {
  AUDIO: "audio",
  VIDEO: "video",
  SCREENSHARE: "screenshare"
}, ha = {
  TILE: "TILE",
  SIDEBAR: "SIDEBAR",
  SPOTLIGHT: "SPOTLIGHT"
}, jS = {
  VOICE: "VOICE",
  VIDEO: "VIDEO"
}, Lg = {
  FRONT: "FRONT",
  REAR: "REAR"
}, hd = {
  USER: "user",
  ENVIRONMENT: "environment"
}, GS = {
  USER: 1
}, h5 = {
  userInfo: "user-info"
}, _h = {
  HIGH: 720,
  STANDARD: 360,
  LOW: 180,
  NONE: 0
}, FU = {
  WEB: "web"
}, Vt = {
  SessionStatusListener: {
    onSessionJoined: "onSessionJoined",
    onSessionLeft: "onSessionLeft",
    onConnectionClosed: "onConnectionClosed"
  },
  MediaEventsListener: {
    onAudioMuted: "onAudioMuted",
    onAudioUnMuted: "onAudioUnMuted",
    onVideoPaused: "onVideoPaused",
    onVideoResumed: "onVideoResumed",
    onRecordingStarted: "onRecordingStarted",
    onRecordingStopped: "onRecordingStopped",
    onScreenShareStarted: "onScreenShareStarted",
    onScreenShareStopped: "onScreenShareStopped"
  },
  ParticipantEventsListner: {
    onParticipantJoined: "onParticipantJoined",
    onParticipantLeft: "onParticipantLeft",
    onParticipantAudioMuted: "onParticipantAudioMuted",
    onParticipantAudioUnmuted: "onParticipantAudioUnmuted",
    onParticipantVideoPaused: "onParticipantVideoPaused",
    onParticipantVideoResumed: "onParticipantVideoResumed",
    onParticipantHandRaised: "onParticipantHandRaised",
    onParticipantHandLowered: "onParticipantHandLowered",
    onParticipantStartedScreenShare: "onParticipantStartedScreenShare",
    onParticipantStoppedScreenShare: "onParticipantStoppedScreenShare",
    onParticipantStartedRecording: "onParticipantStartedRecording",
    onParticipantStoppedRecording: "onParticipantStoppedRecording",
    onDominantSpeakerChanged: "onDominantSpeakerChanged",
    onParticipantListChanged: "onParticipantListChanged"
  },
  ButtonClickListener: {
    onLeaveSessionButtonClicked: "onLeaveSessionButtonClicked",
    onRaiseHandButtonClicked: "onRaiseHandButtonClicked",
    onShareInviteButtonClicked: "onShareInviteButtonClicked",
    onChangeLayoutButtonClicked: "onChangeLayoutButtonClicked",
    onParticipantListButtonClicked: "onParticipantListButtonClicked",
    onToggleAudioButtonClicked: "onToggleAudioButtonClicked",
    onToggleVideoButtonClicked: "onToggleVideoButtonClicked",
    onRecordingToggleButtonClicked: "onRecordingToggleButtonClicked",
    onScreenShareButtonClicked: "onScreenShareButtonClicked",
    onChatButtonClicked: "onChatButtonClicked"
  },
  CallLayoutListener: {
    onCallLayoutChanged: "onCallLayoutChanged",
    onParticipantListVisible: "onParticipantListVisible",
    onParticipantListHidden: "onParticipantListHidden"
  }
}, Dh = {
  MediaEventsListener: {
    ...Vt.MediaEventsListener,
    onAudioInputDeviceChanged: "onAudioInputDeviceChanged",
    onVideoInputDeviceChanged: "onVideoInputDeviceChanged",
    onAudioOutputDeviceChanged: "onAudioOutputDeviceChanged",
    onAudioInputDevicesChanged: "onAudioInputDevicesChanged",
    onVideoInputDevicesChanged: "onVideoInputDevicesChanged",
    onAudioOutputDevicesChanged: "onAudioOutputDevicesChanged"
  }
}, Vh = {
  MediaEventsListener: {
    ...Vt.MediaEventsListener,
    onAudioModeChanged: "onAudioModeChanged",
    onCameraFacingChanged: "onCameraFacingChanged"
  },
  ButtonClickListener: {
    ...Vt.ButtonClickListener
  },
  CallLayoutListener: {
    ...Vt.CallLayoutListener,
    onPictureInPictureLayoutEnabled: "onPictureInPictureLayoutEnabled",
    onPictureInPictureLayoutDisabled: "onPictureInPictureLayoutDisabled"
  }
}, An = {
  connectionWillClose: "internal.sessionWillClose",
  onConnectionEstablished: "internal.onConnectionEstablished",
  onSessionJoined: "internal.onSessionJoined",
  notification: "internal.notification",
  queryPermission: "internal.queryPermission",
  lifecycle: {
    componentDidMount: "internal.componentDidMount",
    componentWillUnmount: "internal.componentWillUnmount",
    SDKInitialized: "internal.SDKInitialized"
  }
};
function _U(d, l, u) {
  if (d <= 0 || l <= 0 || u <= 0)
    throw new Error(
      "Container dimensions and number of tiles must be positive"
    );
  const g = d * l / u, R = ES * ES * Cg;
  if (g < R) {
    const Ve = Math.floor(d / ES), _e = Math.ceil(u / Ve), z = Ve * Kl, Ce = (d - z) / Ve, Re = Ce * Cg;
    return {
      rows: _e,
      columns: Ve,
      tileWidth: Ce,
      tileHeight: Re,
      paddingVertical: 0,
      allocatedWidth: d,
      allocatedHeight: l
    };
  }
  const y = Math.sqrt(u);
  let Q = Math.floor(y), T = Math.ceil(u / Q), k = US(
    d,
    l,
    T,
    Q
  );
  if (k < Cg)
    for (; k < Cg && T > 1; )
      T--, Q = Math.ceil(u / T), k = US(
        d,
        l,
        T,
        Q
      );
  else
    for (; k > yf && T < u; )
      T++, Q = Math.ceil(u / T), k = US(
        d,
        l,
        T,
        Q
      );
  Math.ceil(u / (T - 1)) === Q && T--;
  const N = T * Kl, b = Q * Kl;
  let A = (d - N) / T, Ne = (l - b) / Q, Ee = 0;
  const Fe = A / Ne;
  Fe < 9 / 16 ? (Ee = (Ne - A * yf) * Q / 2, Ne = A * yf) : Fe > yf && (A = Ne * yf);
  const he = A * T + N, ie = Ne * Q + b;
  return {
    rows: Q,
    columns: T,
    tileWidth: A,
    tileHeight: Ne,
    paddingVertical: Ee,
    allocatedWidth: he,
    allocatedHeight: ie
  };
}
function US(d, l, u, p) {
  const g = u * Kl, R = p * Kl, y = (d - g) / u, Q = (l - R) / p;
  return y / Q;
}
const p3 = (d) => Symbol.iterator in d, f3 = (d) => (
  // HACK: avoid checking entries type
  "entries" in d
), g3 = (d, l) => {
  const u = d instanceof Map ? d : new Map(d.entries()), p = l instanceof Map ? l : new Map(l.entries());
  if (u.size !== p.size)
    return !1;
  for (const [g, R] of u)
    if (!Object.is(R, p.get(g)))
      return !1;
  return !0;
}, MU = (d, l) => {
  const u = d[Symbol.iterator](), p = l[Symbol.iterator]();
  let g = u.next(), R = p.next();
  for (; !g.done && !R.done; ) {
    if (!Object.is(g.value, R.value))
      return !1;
    g = u.next(), R = p.next();
  }
  return !!g.done && !!R.done;
};
function kU(d, l) {
  return Object.is(d, l) ? !0 : typeof d != "object" || d === null || typeof l != "object" || l === null || Object.getPrototypeOf(d) !== Object.getPrototypeOf(l) ? !1 : p3(d) && p3(l) ? f3(d) && f3(l) ? g3(d, l) : MU(d, l) : g3(
    { entries: () => Object.entries(d) },
    { entries: () => Object.entries(l) }
  );
}
const QU = (d) => d.split(" ").map((l) => l[0]).join("").toUpperCase().slice(0, 2), DU = (d) => {
  const l = Math.floor(d / 1e3), u = Math.floor(l / 3600), p = Math.floor(l % 3600 / 60), g = l % 60, R = p.toString().padStart(2, "0"), y = g.toString().padStart(2, "0");
  return u > 0 ? `${u.toString().padStart(2, "0")}:${R}:${y}` : `${R}:${y}`;
};
function m5(d) {
  try {
    return JSON.parse(d);
  } catch (l) {
    return console.error("Failed to parse JSON:", l), null;
  }
}
const ZS = (d) => d.getType() === "audio" ? We.AUDIO : d.getVideoType() === "desktop" ? We.SCREENSHARE : We.VIDEO;
function OS(d, l, u) {
  const p = new Set(l.map(u));
  return d.filter((g) => !p.has(u(g)));
}
function PS(d, l) {
  if (d.length !== l.length)
    return !1;
  for (let u = 0; u < d.length; u++)
    if (!kU(d[u], l[u]))
      return !1;
  return !0;
}
function p5(d, l) {
  return (d == null ? void 0 : d.deviceId) === (l == null ? void 0 : l.deviceId) && (d == null ? void 0 : d.label) === (l == null ? void 0 : l.label);
}
function Ch(d) {
  return d.find((l) => l.deviceId === "default") || d[0];
}
async function Is(d) {
  try {
    return { data: await d, error: null };
  } catch (l) {
    return { data: null, error: l };
  }
}
function f5(d) {
  try {
    return { data: d(), error: null };
  } catch (l) {
    return { data: null, error: l };
  }
}
function g5(d, l) {
  let u = null;
  return (...p) => {
    u && clearTimeout(u), u = setTimeout(() => {
      f5(() => d(...p));
    }, l);
  };
}
class xU {
  /**
   * Mutes the local user's audio during the call.
   */
  static muteAudio() {
    jg();
  }
  /**
   * Unmutes the local user's audio during the call.
   */
  static unmuteAudio() {
    C5();
  }
  /**
   * Pauses the local user's video stream.
   */
  static pauseVideo() {
    Gg();
  }
  /**
   * Resumes the local user's video stream.
   */
  static resumeVideo() {
    F5();
  }
  /**
   * Local user leaves the current session.
   */
  static leaveSession() {
    Kg();
  }
  /**
   * Raises the user's virtual hand in the call.
   */
  static raiseHand() {
    y5();
  }
  /**
   * Lowers the user's virtual hand in the call.
   */
  static lowerHand() {
    Ig();
  }
  /**
   * Switches between the front and rear camera.
   */
  static switchCamera() {
    x5();
  }
  /**
   * Sets the layout type for the call.
   * @param layout - The type of layout to set (tile, sidebar or spotlight).
   */
  static setLayout(l) {
    eu(l);
  }
  /**
   * Starts recording the call.
   */
  static startRecording() {
  }
  /**
   * Stops the ongoing call recording.
   */
  static stopRecording() {
  }
  /**
   * Pins a participant's video to focus on them.
   * @param participantId - The ID of the participant to pin.
   * @param type - The type of the participant.
   */
  static pinParticipant(l, u) {
    U5(l, u);
  }
  /**
   * Unpins a participant's video.
   */
  static unpinParticipant() {
    T5();
  }
  /**
   * Mutes the audio of a specific participant.
   * @param participantId - The ID of the participant to mute.
   */
  static muteParticipant(l) {
    Z5(l);
  }
  /**
   * Pauses the video stream of a specific participant.
   * @param participantId - The ID of the participant whose video to pause.
   */
  static pauseParticipantVideo(l) {
    QT(l);
  }
  /**
   * Sets the unread message count displayed on the chat button.
   * @param count - The number of unread messages.
   */
  static setChatButtonUnreadCount(l) {
    lT(l);
  }
  // Legacy Methods
  // /**
  //  * @deprecated use setLayout() instead
  //  */
  // public static setMode(
  //   mode: (typeof CallConstants.MODE)[keyof typeof CallConstants.MODE],
  // ) {
  //   const layout = mode === 'DEFAULT' ? 'SIDEBAR' : mode;
  //   this.setLayout(layout);
  // }
  /**
   * @deprecated switchToVideoCall is deprecated and not supported.
   */
  static switchToVideoCall() {
    console.error("switchToVideoCall method deprecated and not supported.");
  }
  /**
   * @deprecated use leaveSession() instead
   */
  static endSession() {
    this.leaveSession();
  }
  /**
   * Retrieves call details for a given session ID and auth token.
   * @param sessionID - The session ID of the call.
   * @param authToken - The authentication token required to make the API call.
   * @returns A Promise that resolves to a CallLog object containing the call details.
   * @throws {CometChatCallsException} If there is an error retrieving the call details.
   * @deprecated This method is deprecated and not supported.
   */
  static getCallDetails(l, u) {
    throw new Error("This method is deprecated and not supported.");
  }
}
const ZU = '/*! For license information please see lib-jitsi-meet.min.js.LICENSE.txt */\n!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.JitsiMeetJS=t():e.JitsiMeetJS=t()}(self,(()=>(()=>{var __webpack_modules__={449:(e,t,n)=>{const i=n(526).Z;e.exports=function(e){return"object"==typeof window.JitsiMeetJS?Object.assign({},window.JitsiMeetJS,e):e}(i)},444:e=>{e.exports=class{constructor(e,t,n){this._userId=e,this.setDisplayName(t),this._isLocalStats=n||!1,this.setDominantSpeaker(!1),this.totalDominantSpeakerTime=0,this._dominantSpeakerStart=0,this._isDominantSpeaker=!1,this._isSilent=!1,this._hasLeft=!1,this._faceLandmarks=[]}getUserId(){return this._userId}getDisplayName(){return this.displayName}setDisplayName(e){this.displayName=e}isLocalStats(){return this._isLocalStats}isDominantSpeaker(){return this._isDominantSpeaker}setDominantSpeaker(e,t){if(this.isDominantSpeaker()||!e||t){if(this.isDominantSpeaker())if(e){if(this._isSilent&&!t)this._dominantSpeakerStart=Date.now();else if(!this._isSilent&&t){const e=Date.now()-this._dominantSpeakerStart;this.totalDominantSpeakerTime+=e,this._dominantSpeakerStart=0}}else if(!this._isSilent){const e=Date.now()-this._dominantSpeakerStart;this.totalDominantSpeakerTime+=e,this._dominantSpeakerStart=0}}else this._dominantSpeakerStart=Date.now();this._isDominantSpeaker=e,this._isSilent=t}getTotalDominantSpeakerTime(){let e=this.totalDominantSpeakerTime;return this.isDominantSpeaker()&&!this._isSilent&&(e+=Date.now()-this._dominantSpeakerStart),e}hasLeft(){return this._hasLeft}markAsHasLeft(){this._hasLeft=!0,this.setDominantSpeaker(!1)}getFaceLandmarks(){return this._faceLandmarks}setFaceLandmarks(e){this._faceLandmarks=e}addFaceLandmarks(e){this._faceLandmarks.push(e)}}},832:e=>{function t(e,t){if(!e||!t||"function"!=typeof e.addListener||"function"!=typeof t.emit)throw new Error("Invalid arguments passed to EventEmitterForwarder");this.src=e,this.dest=t,this.listeners=new Map}t.prototype.forward=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];const i=t[0];t[0]=this.dest;const r=Function.prototype.bind.apply(this.dest.emit,t);this.src.addListener(i,r),this.listeners.set(i,r)},t.prototype.removeListeners=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];t.forEach((e=>{const t=this.listeners.get(e);t&&(this.src.removeListener(e,t),this.listeners.delete(e))}))},e.exports=t},399:e=>{function t(e,t){return Math.floor(Math.random()*(t-e+1))+e}function n(e){return e[t(0,e.length-1)]}const i={randomHexDigit:()=>n("0123456789abcdef"),randomHexString(e){let t="";for(;e--;)t+=this.randomHexDigit();return t},randomElement:n,randomAlphanumStr:function(e){let t="";for(let i=0;i<e;i+=1)t+=n("0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ");return t},randomInt:t};e.exports=i},549:(e,t,n)=>{const i=n(799),r={loadScript(e,t,n,r,o,s){const a=document,d="script",c=a.createElement(d),l=a.getElementsByTagName(d)[0];if(c.async=t,r){const t=i();if(t){const n=t.src,i=n.substring(0,n.lastIndexOf("/")+1);n&&i&&(e=i+e)}}o&&(c.onload=o),s&&(c.onerror=s),c.src=e,n?l.parentNode.insertBefore(c,l):l.parentNode.appendChild(c)}};e.exports=r},667:(e,t,n)=>{const i=n(399),r=["Aaliyah","Aaron","Abagail","Abbey","Abbie","Abbigail","Abby","Abdiel","Abdul","Abdullah","Abe","Abel","Abelardo","Abigail","Abigale","Abigayle","Abner","Abraham","Ada","Adah","Adalberto","Adaline","Adam","Adan","Addie","Addison","Adela","Adelbert","Adele","Adelia","Adeline","Adell","Adella","Adelle","Aditya","Adolf","Adolfo","Adolph","Adolphus","Adonis","Adrain","Adrian","Adriana","Adrianna","Adriel","Adrien","Adrienne","Afton","Aglae","Agnes","Agustin","Agustina","Ahmad","Ahmed","Aida","Aidan","Aiden","Aileen","Aisha","Aiyana","Akeem","Al","Alaina","Alan","Alana","Alanis","Alanna","Alayna","Alba","Albert","Alberta","Albertha","Alberto","Albin","Albina","Alda","Alden","Alec","Aleen","Alejandra","Alejandrin","Alek","Alena","Alene","Alessandra","Alessandro","Alessia","Aletha","Alex","Alexa","Alexander","Alexandra","Alexandre","Alexandrea","Alexandria","Alexandrine","Alexandro","Alexane","Alexanne","Alexie","Alexis","Alexys","Alexzander","Alf","Alfonso","Alfonzo","Alford","Alfred","Alfreda","Alfredo","Ali","Alia","Alice","Alicia","Alisa","Alisha","Alison","Alivia","Aliya","Aliyah","Aliza","Alize","Allan","Allen","Allene","Allie","Allison","Ally","Alphonso","Alta","Althea","Alva","Alvah","Alvena","Alvera","Alverta","Alvina","Alvis","Alyce","Alycia","Alysa","Alysha","Alyson","Alysson","Amalia","Amanda","Amani","Amara","Amari","Amaya","Amber","Ambrose","Amelia","Amelie","Amely","America","Americo","Amie","Amina","Amir","Amira","Amiya","Amos","Amparo","Amy","Amya","Ana","Anabel","Anabelle","Anahi","Anais","Anastacio","Anastasia","Anderson","Andre","Andreane","Andreanne","Andres","Andrew","Andy","Angel","Angela","Angelica","Angelina","Angeline","Angelita","Angelo","Angie","Angus","Anibal","Anika","Anissa","Anita","Aniya","Aniyah","Anjali","Anna","Annabel","Annabell","Annabelle","Annalise","Annamae","Annamarie","Anne","Annetta","Annette","Annie","Ansel","Ansley","Anthony","Antoinette","Antone","Antonetta","Antonette","Antonia","Antonietta","Antonina","Antonio","Antwan","Antwon","Anya","April","Ara","Araceli","Aracely","Arch","Archibald","Ardella","Arden","Ardith","Arely","Ari","Ariane","Arianna","Aric","Ariel","Arielle","Arjun","Arlene","Arlie","Arlo","Armand","Armando","Armani","Arnaldo","Arne","Arno","Arnold","Arnoldo","Arnulfo","Aron","Art","Arthur","Arturo","Arvel","Arvid","Arvilla","Aryanna","Asa","Asha","Ashlee","Ashleigh","Ashley","Ashly","Ashlynn","Ashton","Ashtyn","Asia","Assunta","Astrid","Athena","Aubree","Aubrey","Audie","Audra","Audreanne","Audrey","August","Augusta","Augustine","Augustus","Aurelia","Aurelie","Aurelio","Aurore","Austen","Austin","Austyn","Autumn","Ava","Avery","Avis","Axel","Ayana","Ayden","Ayla","Aylin","Baby","Bailee","Bailey","Barbara","Barney","Baron","Barrett","Barry","Bart","Bartholome","Barton","Baylee","Beatrice","Beau","Beaulah","Bell","Bella","Belle","Ben","Benedict","Benjamin","Bennett","Bennie","Benny","Benton","Berenice","Bernadette","Bernadine","Bernard","Bernardo","Berneice","Bernhard","Bernice","Bernie","Berniece","Bernita","Berry","Bert","Berta","Bertha","Bertram","Bertrand","Beryl","Bessie","Beth","Bethany","Bethel","Betsy","Bette","Bettie","Betty","Bettye","Beulah","Beverly","Bianka","Bill","Billie","Billy","Birdie","Blair","Blaise","Blake","Blanca","Blanche","Blaze","Bo","Bobbie","Bobby","Bonita","Bonnie","Boris","Boyd","Brad","Braden","Bradford","Bradley","Bradly","Brady","Braeden","Brain","Brandi","Brando","Brandon","Brandt","Brandy","Brandyn","Brannon","Branson","Brant","Braulio","Braxton","Brayan","Breana","Breanna","Breanne","Brenda","Brendan","Brenden","Brendon","Brenna","Brennan","Brennon","Brent","Bret","Brett","Bria","Brian","Briana","Brianne","Brice","Bridget","Bridgette","Bridie","Brielle","Brigitte","Brionna","Brisa","Britney","Brittany","Brock","Broderick","Brody","Brook","Brooke","Brooklyn","Brooks","Brown","Bruce","Bryana","Bryce","Brycen","Bryon","Buck","Bud","Buddy","Buford","Bulah","Burdette","Burley","Burnice","Buster","Cade","Caden","Caesar","Caitlyn","Cale","Caleb","Caleigh","Cali","Calista","Callie","Camden","Cameron","Camila","Camilla","Camille","Camren","Camron","Camryn","Camylle","Candace","Candelario","Candice","Candida","Candido","Cara","Carey","Carissa","Carlee","Carleton","Carley","Carli","Carlie","Carlo","Carlos","Carlotta","Carmel","Carmela","Carmella","Carmelo","Carmen","Carmine","Carol","Carolanne","Carole","Carolina","Caroline","Carolyn","Carolyne","Carrie","Carroll","Carson","Carter","Cary","Casandra","Casey","Casimer","Casimir","Casper","Cassandra","Cassandre","Cassidy","Cassie","Catalina","Caterina","Catharine","Catherine","Cathrine","Cathryn","Cathy","Cayla","Ceasar","Cecelia","Cecil","Cecile","Cecilia","Cedrick","Celestine","Celestino","Celia","Celine","Cesar","Chad","Chadd","Chadrick","Chaim","Chance","Chandler","Chanel","Chanelle","Charity","Charlene","Charles","Charley","Charlie","Charlotte","Chase","Chasity","Chauncey","Chaya","Chaz","Chelsea","Chelsey","Chelsie","Chesley","Chester","Chet","Cheyanne","Cheyenne","Chloe","Chris","Christ","Christa","Christelle","Christian","Christiana","Christina","Christine","Christop","Christophe","Christopher","Christy","Chyna","Ciara","Cicero","Cielo","Cierra","Cindy","Citlalli","Clair","Claire","Clara","Clarabelle","Clare","Clarissa","Clark","Claud","Claude","Claudia","Claudie","Claudine","Clay","Clemens","Clement","Clementina","Clementine","Clemmie","Cleo","Cleora","Cleta","Cletus","Cleve","Cleveland","Clifford","Clifton","Clint","Clinton","Clotilde","Clovis","Cloyd","Clyde","Coby","Cody","Colby","Cole","Coleman","Colin","Colleen","Collin","Colt","Colten","Colton","Columbus","Concepcion","Conner","Connie","Connor","Conor","Conrad","Constance","Constantin","Consuelo","Cooper","Cora","Coralie","Corbin","Cordelia","Cordell","Cordia","Cordie","Corene","Corine","Cornelius","Cornell","Corrine","Cortez","Cortney","Cory","Coty","Courtney","Coy","Craig","Crawford","Creola","Cristal","Cristian","Cristina","Cristobal","Cristopher","Cruz","Crystal","Crystel","Cullen","Curt","Curtis","Cydney","Cynthia","Cyril","Cyrus","Dagmar","Dahlia","Daija","Daisha","Daisy","Dakota","Dale","Dallas","Dallin","Dalton","Damaris","Dameon","Damian","Damien","Damion","Damon","Dan","Dana","Dandre","Dane","D\'angelo","Dangelo","Danial","Daniela","Daniella","Danielle","Danika","Dannie","Danny","Dante","Danyka","Daphne","Daphnee","Daphney","Darby","Daren","Darian","Dariana","Darien","Dario","Darion","Darius","Darlene","Daron","Darrel","Darrell","Darren","Darrick","Darrin","Darrion","Darron","Darryl","Darwin","Daryl","Dashawn","Dasia","Dave","David","Davin","Davion","Davon","Davonte","Dawn","Dawson","Dax","Dayana","Dayna","Dayne","Dayton","Dean","Deangelo","Deanna","Deborah","Declan","Dedric","Dedrick","Dee","Deion","Deja","Dejah","Dejon","Dejuan","Delaney","Delbert","Delfina","Delia","Delilah","Dell","Della","Delmer","Delores","Delpha","Delphia","Delphine","Delta","Demarco","Demarcus","Demario","Demetris","Demetrius","Demond","Dena","Denis","Dennis","Deon","Deondre","Deontae","Deonte","Dereck","Derek","Derick","Deron","Derrick","Deshaun","Deshawn","Desiree","Desmond","Dessie","Destany","Destin","Destinee","Destiney","Destini","Destiny","Devan","Devante","Deven","Devin","Devon","Devonte","Devyn","Dewayne","Dewitt","Dexter","Diamond","Diana","Dianna","Diego","Dillan","Dillon","Dimitri","Dina","Dino","Dion","Dixie","Dock","Dolly","Dolores","Domenic","Domenica","Domenick","Domenico","Domingo","Dominic","Dominique","Don","Donald","Donato","Donavon","Donna","Donnell","Donnie","Donny","Dora","Dorcas","Dorian","Doris","Dorothea","Dorothy","Dorris","Dortha","Dorthy","Doug","Douglas","Dovie","Doyle","Drake","Drew","Duane","Dudley","Dulce","Duncan","Durward","Dustin","Dusty","Dwight","Dylan","Earl","Earlene","Earline","Earnest","Earnestine","Easter","Easton","Ebba","Ebony","Ed","Eda","Edd","Eddie","Eden","Edgar","Edgardo","Edison","Edmond","Edmund","Edna","Eduardo","Edward","Edwardo","Edwin","Edwina","Edyth","Edythe","Effie","Efrain","Efren","Eileen","Einar","Eino","Eladio","Elaina","Elbert","Elda","Eldon","Eldora","Eldred","Eldridge","Eleanora","Eleanore","Eleazar","Electa","Elena","Elenor","Elenora","Eleonore","Elfrieda","Eli","Elian","Eliane","Elias","Eliezer","Elijah","Elinor","Elinore","Elisa","Elisabeth","Elise","Eliseo","Elisha","Elissa","Eliza","Elizabeth","Ella","Ellen","Ellie","Elliot","Elliott","Ellis","Ellsworth","Elmer","Elmira","Elmo","Elmore","Elna","Elnora","Elody","Eloisa","Eloise","Elouise","Eloy","Elroy","Elsa","Else","Elsie","Elta","Elton","Elva","Elvera","Elvie","Elvis","Elwin","Elwyn","Elyse","Elyssa","Elza","Emanuel","Emelia","Emelie","Emely","Emerald","Emerson","Emery","Emie","Emil","Emile","Emilia","Emiliano","Emilie","Emilio","Emily","Emma","Emmalee","Emmanuel","Emmanuelle","Emmet","Emmett","Emmie","Emmitt","Emmy","Emory","Ena","Enid","Enoch","Enola","Enos","Enrico","Enrique","Ephraim","Era","Eriberto","Eric","Erica","Erich","Erick","Ericka","Erik","Erika","Erin","Erling","Erna","Ernest","Ernestina","Ernestine","Ernesto","Ernie","Ervin","Erwin","Eryn","Esmeralda","Esperanza","Esta","Esteban","Estefania","Estel","Estell","Estella","Estelle","Estevan","Esther","Estrella","Etha","Ethan","Ethel","Ethelyn","Ethyl","Ettie","Eudora","Eugene","Eugenia","Eula","Eulah","Eulalia","Euna","Eunice","Eusebio","Eva","Evalyn","Evan","Evangeline","Evans","Eve","Eveline","Evelyn","Everardo","Everett","Everette","Evert","Evie","Ewald","Ewell","Ezekiel","Ezequiel","Ezra","Fabian","Fabiola","Fae","Fannie","Fanny","Fatima","Faustino","Fausto","Favian","Fay","Faye","Federico","Felicia","Felicita","Felicity","Felipa","Felipe","Felix","Felton","Fermin","Fern","Fernando","Ferne","Fidel","Filiberto","Filomena","Finn","Fiona","Flavie","Flavio","Fleta","Fletcher","Flo","Florence","Florencio","Florian","Florida","Florine","Flossie","Floy","Floyd","Ford","Forest","Forrest","Foster","Frances","Francesca","Francesco","Francis","Francisca","Francisco","Franco","Frank","Frankie","Franz","Fred","Freda","Freddie","Freddy","Frederic","Frederick","Frederik","Frederique","Fredrick","Fredy","Freeda","Freeman","Freida","Frida","Frieda","Friedrich","Fritz","Furman","Gabe","Gabriel","Gabriella","Gabrielle","Gaetano","Gage","Gail","Gardner","Garett","Garfield","Garland","Garnet","Garnett","Garret","Garrett","Garrick","Garrison","Garry","Garth","Gaston","Gavin","Gay","Gayle","Gaylord","Gene","General","Genesis","Genevieve","Gennaro","Genoveva","Geo","Geoffrey","George","Georgette","Georgiana","Georgianna","Geovanni","Geovanny","Geovany","Gerald","Geraldine","Gerard","Gerardo","Gerda","Gerhard","Germaine","German","Gerry","Gerson","Gertrude","Gia","Gianni","Gideon","Gilbert","Gilberto","Gilda","Giles","Gillian","Gina","Gino","Giovani","Giovanna","Giovanni","Giovanny","Gisselle","Giuseppe","Gladyce","Gladys","Glen","Glenda","Glenna","Glennie","Gloria","Godfrey","Golda","Golden","Gonzalo","Gordon","Grace","Gracie","Graciela","Grady","Graham","Grant","Granville","Grayce","Grayson","Green","Greg","Gregg","Gregoria","Gregorio","Gregory","Greta","Gretchen","Greyson","Griffin","Grover","Guadalupe","Gudrun","Guido","Guillermo","Guiseppe","Gunnar","Gunner","Gus","Gussie","Gust","Gustave","Guy","Gwen","Gwendolyn","Hadley","Hailee","Hailey","Hailie","Hal","Haleigh","Haley","Halie","Halle","Hallie","Hank","Hanna","Hannah","Hans","Hardy","Harley","Harmon","Harmony","Harold","Harrison","Harry","Harvey","Haskell","Hassan","Hassie","Hattie","Haven","Hayden","Haylee","Hayley","Haylie","Hazel","Hazle","Heath","Heather","Heaven","Heber","Hector","Heidi","Helen","Helena","Helene","Helga","Hellen","Helmer","Heloise","Henderson","Henri","Henriette","Henry","Herbert","Herman","Hermann","Hermina","Herminia","Herminio","Hershel","Herta","Hertha","Hester","Hettie","Hilario","Hilbert","Hilda","Hildegard","Hillard","Hillary","Hilma","Hilton","Hipolito","Hiram","Hobart","Holden","Hollie","Hollis","Holly","Hope","Horace","Horacio","Hortense","Hosea","Houston","Howard","Howell","Hoyt","Hubert","Hudson","Hugh","Hulda","Humberto","Hunter","Hyman","Ian","Ibrahim","Icie","Ida","Idell","Idella","Ignacio","Ignatius","Ike","Ila","Ilene","Iliana","Ima","Imani","Imelda","Immanuel","Imogene","Ines","Irma","Irving","Irwin","Isaac","Isabel","Isabell","Isabella","Isabelle","Isac","Isadore","Isai","Isaiah","Isaias","Isidro","Ismael","Isobel","Isom","Israel","Issac","Itzel","Iva","Ivah","Ivory","Ivy","Izabella","Izaiah","Jabari","Jace","Jacey","Jacinthe","Jacinto","Jack","Jackeline","Jackie","Jacklyn","Jackson","Jacky","Jaclyn","Jacquelyn","Jacques","Jacynthe","Jada","Jade","Jaden","Jadon","Jadyn","Jaeden","Jaida","Jaiden","Jailyn","Jaime","Jairo","Jakayla","Jake","Jakob","Jaleel","Jalen","Jalon","Jalyn","Jamaal","Jamal","Jamar","Jamarcus","Jamel","Jameson","Jamey","Jamie","Jamil","Jamir","Jamison","Jammie","Jan","Jana","Janae","Jane","Janelle","Janessa","Janet","Janice","Janick","Janie","Janis","Janiya","Jannie","Jany","Jaquan","Jaquelin","Jaqueline","Jared","Jaren","Jarod","Jaron","Jarred","Jarrell","Jarret","Jarrett","Jarrod","Jarvis","Jasen","Jasmin","Jason","Jasper","Jaunita","Javier","Javon","Javonte","Jay","Jayce","Jaycee","Jayda","Jayde","Jayden","Jaydon","Jaylan","Jaylen","Jaylin","Jaylon","Jayme","Jayne","Jayson","Jazlyn","Jazmin","Jazmyn","Jazmyne","Jean","Jeanette","Jeanie","Jeanne","Jed","Jedediah","Jedidiah","Jeff","Jefferey","Jeffery","Jeffrey","Jeffry","Jena","Jenifer","Jennie","Jennifer","Jennings","Jennyfer","Jensen","Jerad","Jerald","Jeramie","Jeramy","Jerel","Jeremie","Jeremy","Jermain","Jermaine","Jermey","Jerod","Jerome","Jeromy","Jerrell","Jerrod","Jerrold","Jerry","Jess","Jesse","Jessica","Jessie","Jessika","Jessy","Jessyca","Jesus","Jett","Jettie","Jevon","Jewel","Jewell","Jillian","Jimmie","Jimmy","Jo","Joan","Joana","Joanie","Joanne","Joannie","Joanny","Joany","Joaquin","Jocelyn","Jodie","Jody","Joe","Joel","Joelle","Joesph","Joey","Johan","Johann","Johanna","Johathan","John","Johnathan","Johnathon","Johnnie","Johnny","Johnpaul","Johnson","Jolie","Jon","Jonas","Jonatan","Jonathan","Jonathon","Jordan","Jordane","Jordi","Jordon","Jordy","Jordyn","Jorge","Jose","Josefa","Josefina","Joseph","Josephine","Josh","Joshua","Joshuah","Josiah","Josiane","Josianne","Josie","Josue","Jovan","Jovani","Jovanny","Jovany","Joy","Joyce","Juana","Juanita","Judah","Judd","Jude","Judge","Judson","Judy","Jules","Julia","Julian","Juliana","Julianne","Julie","Julien","Juliet","Julio","Julius","June","Junior","Junius","Justen","Justice","Justina","Justine","Juston","Justus","Justyn","Juvenal","Juwan","Kacey","Kaci","Kacie","Kade","Kaden","Kadin","Kaela","Kaelyn","Kaia","Kailee","Kailey","Kailyn","Kaitlin","Kaitlyn","Kale","Kaleb","Kaleigh","Kaley","Kali","Kallie","Kameron","Kamille","Kamren","Kamron","Kamryn","Kane","Kara","Kareem","Karelle","Karen","Kari","Kariane","Karianne","Karina","Karine","Karl","Karlee","Karley","Karli","Karlie","Karolann","Karson","Kasandra","Kasey","Kassandra","Katarina","Katelin","Katelyn","Katelynn","Katharina","Katherine","Katheryn","Kathleen","Kathlyn","Kathryn","Kathryne","Katlyn","Katlynn","Katrina","Katrine","Kattie","Kavon","Kay","Kaya","Kaycee","Kayden","Kayla","Kaylah","Kaylee","Kayleigh","Kayley","Kayli","Kaylie","Kaylin","Keagan","Keanu","Keara","Keaton","Keegan","Keeley","Keely","Keenan","Keira","Keith","Kellen","Kelley","Kelli","Kellie","Kelly","Kelsi","Kelsie","Kelton","Kelvin","Ken","Kendall","Kendra","Kendrick","Kenna","Kennedi","Kennedy","Kenneth","Kennith","Kenny","Kenton","Kenya","Kenyatta","Kenyon","Keon","Keshaun","Keshawn","Keven","Kevin","Kevon","Keyon","Keyshawn","Khalid","Khalil","Kian","Kiana","Kianna","Kiara","Kiarra","Kiel","Kiera","Kieran","Kiley","Kim","Kimberly","King","Kip","Kira","Kirk","Kirsten","Kirstin","Kitty","Kobe","Koby","Kody","Kolby","Kole","Korbin","Korey","Kory","Kraig","Kris","Krista","Kristian","Kristin","Kristina","Kristofer","Kristoffer","Kristopher","Kristy","Krystal","Krystel","Krystina","Kurt","Kurtis","Kyla","Kyle","Kylee","Kyleigh","Kyler","Kylie","Kyra","Lacey","Lacy","Ladarius","Lafayette","Laila","Laisha","Lamar","Lambert","Lamont","Lance","Landen","Lane","Laney","Larissa","Laron","Larry","Larue","Laura","Laurel","Lauren","Laurence","Lauretta","Lauriane","Laurianne","Laurie","Laurine","Laury","Lauryn","Lavada","Lavern","Laverna","Laverne","Lavina","Lavinia","Lavon","Lavonne","Lawrence","Lawson","Layla","Layne","Lazaro","Lea","Leann","Leanna","Leanne","Leatha","Leda","Lee","Leif","Leila","Leilani","Lela","Lelah","Leland","Lelia","Lempi","Lemuel","Lenna","Lennie","Lenny","Lenora","Lenore","Leo","Leola","Leon","Leonard","Leonardo","Leone","Leonel","Leonie","Leonor","Leonora","Leopold","Leopoldo","Leora","Lera","Lesley","Leslie","Lesly","Lessie","Lester","Leta","Letha","Letitia","Levi","Lew","Lewis","Lexi","Lexie","Lexus","Lia","Liam","Liana","Libbie","Libby","Lila","Lilian","Liliana","Liliane","Lilla","Lillian","Lilliana","Lillie","Lilly","Lily","Lilyan","Lina","Lincoln","Linda","Lindsay","Lindsey","Linnea","Linnie","Linwood","Lionel","Lisa","Lisandro","Lisette","Litzy","Liza","Lizeth","Lizzie","Llewellyn","Lloyd","Logan","Lois","Lola","Lolita","Loma","Lon","London","Lonie","Lonnie","Lonny","Lonzo","Lora","Loraine","Loren","Lorena","Lorenz","Lorenza","Lorenzo","Lori","Lorine","Lorna","Lottie","Lou","Louie","Louisa","Lourdes","Louvenia","Lowell","Loy","Loyal","Loyce","Lucas","Luciano","Lucie","Lucienne","Lucile","Lucinda","Lucio","Lucious","Lucius","Lucy","Ludie","Ludwig","Lue","Luella","Luigi","Luis","Luisa","Lukas","Lula","Lulu","Luna","Lupe","Lura","Lurline","Luther","Luz","Lyda","Lydia","Lyla","Lynn","Lyric","Lysanne","Mabel","Mabelle","Mable","Mac","Macey","Maci","Macie","Mack","Mackenzie","Macy","Madaline","Madalyn","Maddison","Madeline","Madelyn","Madelynn","Madge","Madie","Madilyn","Madisen","Madison","Madisyn","Madonna","Madyson","Mae","Maegan","Maeve","Mafalda","Magali","Magdalen","Magdalena","Maggie","Magnolia","Magnus","Maia","Maida","Maiya","Major","Makayla","Makenna","Makenzie","Malachi","Malcolm","Malika","Malinda","Mallie","Mallory","Malvina","Mandy","Manley","Manuel","Manuela","Mara","Marc","Marcel","Marcelina","Marcelino","Marcella","Marcelle","Marcellus","Marcelo","Marcia","Marco","Marcos","Marcus","Margaret","Margarete","Margarett","Margaretta","Margarette","Margarita","Marge","Margie","Margot","Margret","Marguerite","Maria","Mariah","Mariam","Marian","Mariana","Mariane","Marianna","Marianne","Mariano","Maribel","Marie","Mariela","Marielle","Marietta","Marilie","Marilou","Marilyne","Marina","Mario","Marion","Marisa","Marisol","Maritza","Marjolaine","Marjorie","Marjory","Mark","Markus","Marlee","Marlen","Marlene","Marley","Marlin","Marlon","Marques","Marquis","Marquise","Marshall","Marta","Martin","Martina","Martine","Marty","Marvin","Mary","Maryam","Maryjane","Maryse","Mason","Mateo","Mathew","Mathias","Mathilde","Matilda","Matilde","Matt","Matteo","Mattie","Maud","Maude","Maudie","Maureen","Maurice","Mauricio","Maurine","Maverick","Mavis","Max","Maxie","Maxime","Maximilian","Maximillia","Maximillian","Maximo","Maximus","Maxine","Maxwell","May","Maya","Maybell","Maybelle","Maye","Maymie","Maynard","Mayra","Mazie","Mckayla","Mckenna","Mckenzie","Meagan","Meaghan","Meda","Megane","Meggie","Meghan","Mekhi","Melany","Melba","Melisa","Melissa","Mellie","Melody","Melvin","Melvina","Melyna","Melyssa","Mercedes","Meredith","Merl","Merle","Merlin","Merritt","Mertie","Mervin","Meta","Mia","Micaela","Micah","Michael","Michaela","Michale","Micheal","Michel","Michele","Michelle","Miguel","Mikayla","Mike","Mikel","Milan","Miles","Milford","Miller","Millie","Milo","Milton","Mina","Minerva","Minnie","Miracle","Mireille","Mireya","Misael","Missouri","Misty","Mitchel","Mitchell","Mittie","Modesta","Modesto","Mohamed","Mohammad","Mohammed","Moises","Mollie","Molly","Mona","Monica","Monique","Monroe","Monserrat","Monserrate","Montana","Monte","Monty","Morgan","Moriah","Morris","Mortimer","Morton","Mose","Moses","Moshe","Mossie","Mozell","Mozelle","Muhammad","Muriel","Murl","Murphy","Murray","Mustafa","Mya","Myah","Mylene","Myles","Myra","Myriam","Myrl","Myrna","Myron","Myrtice","Myrtie","Myrtis","Myrtle","Nadia","Nakia","Name","Nannie","Naomi","Naomie","Napoleon","Narciso","Nash","Nasir","Nat","Natalia","Natalie","Natasha","Nathan","Nathanael","Nathanial","Nathaniel","Nathen","Nayeli","Neal","Ned","Nedra","Neha","Neil","Nelda","Nella","Nelle","Nellie","Nels","Nelson","Neoma","Nestor","Nettie","Neva","Newell","Newton","Nia","Nicholas","Nicholaus","Nichole","Nick","Nicklaus","Nickolas","Nico","Nicola","Nicolas","Nicole","Nicolette","Nigel","Nikita","Nikki","Nikko","Niko","Nikolas","Nils","Nina","Noah","Noble","Noe","Noel","Noelia","Noemi","Noemie","Noemy","Nola","Nolan","Nona","Nora","Norbert","Norberto","Norene","Norma","Norris","Norval","Norwood","Nova","Novella","Nya","Nyah","Nyasia","Obie","Oceane","Ocie","Octavia","Oda","Odell","Odessa","Odie","Ofelia","Okey","Ola","Olaf","Ole","Olen","Oleta","Olga","Olin","Oliver","Ollie","Oma","Omari","Omer","Ona","Onie","Opal","Ophelia","Ora","Oral","Oran","Oren","Orie","Orin","Orion","Orland","Orlando","Orlo","Orpha","Orrin","Orval","Orville","Osbaldo","Osborne","Oscar","Osvaldo","Oswald","Oswaldo","Otha","Otho","Otilia","Otis","Ottilie","Ottis","Otto","Ova","Owen","Ozella","Pablo","Paige","Palma","Pamela","Pansy","Paolo","Paris","Parker","Pascale","Pasquale","Pat","Patience","Patricia","Patrick","Patsy","Pattie","Paul","Paula","Pauline","Paxton","Payton","Pearl","Pearlie","Pearline","Pedro","Peggie","Penelope","Percival","Percy","Perry","Pete","Peter","Petra","Peyton","Philip","Phoebe","Phyllis","Pierce","Pierre","Pietro","Pink","Pinkie","Piper","Polly","Porter","Precious","Presley","Preston","Price","Prince","Princess","Priscilla","Providenci","Prudence","Queen","Queenie","Quentin","Quincy","Quinn","Quinten","Quinton","Rachael","Rachel","Rachelle","Rae","Raegan","Rafael","Rafaela","Raheem","Rahsaan","Rahul","Raina","Raleigh","Ralph","Ramiro","Ramon","Ramona","Randal","Randall","Randi","Randy","Ransom","Raoul","Raphael","Raphaelle","Raquel","Rashad","Rashawn","Rasheed","Raul","Raven","Ray","Raymond","Raymundo","Reagan","Reanna","Reba","Rebeca","Rebecca","Rebeka","Rebekah","Reece","Reed","Reese","Regan","Reggie","Reginald","Reid","Reilly","Reina","Reinhold","Remington","Rene","Renee","Ressie","Reta","Retha","Retta","Reuben","Reva","Rex","Rey","Reyes","Reymundo","Reyna","Reynold","Rhea","Rhett","Rhianna","Rhiannon","Rhoda","Ricardo","Richard","Richie","Richmond","Rick","Rickey","Rickie","Ricky","Rico","Rigoberto","Riley","Rita","River","Robb","Robbie","Robert","Roberta","Roberto","Robin","Robyn","Rocio","Rocky","Rod","Roderick","Rodger","Rodolfo","Rodrick","Rodrigo","Roel","Rogelio","Roger","Rogers","Rolando","Rollin","Roma","Romaine","Roman","Ron","Ronaldo","Ronny","Roosevelt","Rory","Rosa","Rosalee","Rosalia","Rosalind","Rosalinda","Rosalyn","Rosamond","Rosanna","Rosario","Roscoe","Rose","Rosella","Roselyn","Rosemarie","Rosemary","Rosendo","Rosetta","Rosie","Rosina","Roslyn","Ross","Rossie","Rowan","Rowena","Rowland","Roxane","Roxanne","Roy","Royal","Royce","Rozella","Ruben","Rubie","Ruby","Rubye","Rudolph","Rudy","Rupert","Russ","Russel","Russell","Rusty","Ruth","Ruthe","Ruthie","Ryan","Ryann","Ryder","Rylan","Rylee","Ryleigh","Ryley","Sabina","Sabrina","Sabryna","Sadie","Sadye","Sage","Saige","Sallie","Sally","Salma","Salvador","Salvatore","Sam","Samanta","Samantha","Samara","Samir","Sammie","Sammy","Samson","Sandra","Sandrine","Sandy","Sanford","Santa","Santiago","Santina","Santino","Santos","Sarah","Sarai","Sarina","Sasha","Saul","Savanah","Savanna","Savannah","Savion","Scarlett","Schuyler","Scot","Scottie","Scotty","Seamus","Sean","Sebastian","Sedrick","Selena","Selina","Selmer","Serena","Serenity","Seth","Shad","Shaina","Shakira","Shana","Shane","Shanel","Shanelle","Shania","Shanie","Shaniya","Shanna","Shannon","Shanny","Shanon","Shany","Sharon","Shaun","Shawn","Shawna","Shaylee","Shayna","Shayne","Shea","Sheila","Sheldon","Shemar","Sheridan","Sherman","Sherwood","Shirley","Shyann","Shyanne","Sibyl","Sid","Sidney","Sienna","Sierra","Sigmund","Sigrid","Sigurd","Silas","Sim","Simeon","Simone","Sincere","Sister","Skye","Skyla","Skylar","Sofia","Soledad","Solon","Sonia","Sonny","Sonya","Sophia","Sophie","Spencer","Stacey","Stacy","Stan","Stanford","Stanley","Stanton","Stefan","Stefanie","Stella","Stephan","Stephania","Stephanie","Stephany","Stephen","Stephon","Sterling","Steve","Stevie","Stewart","Stone","Stuart","Summer","Sunny","Susan","Susana","Susanna","Susie","Suzanne","Sven","Syble","Sydnee","Sydney","Sydni","Sydnie","Sylvan","Sylvester","Sylvia","Tabitha","Tad","Talia","Talon","Tamara","Tamia","Tania","Tanner","Tanya","Tara","Taryn","Tate","Tatum","Tatyana","Taurean","Tavares","Taya","Taylor","Teagan","Ted","Telly","Terence","Teresa","Terrance","Terrell","Terrence","Terrill","Terry","Tess","Tessie","Tevin","Thad","Thaddeus","Thalia","Thea","Thelma","Theo","Theodora","Theodore","Theresa","Therese","Theresia","Theron","Thomas","Thora","Thurman","Tia","Tiana","Tianna","Tiara","Tierra","Tiffany","Tillman","Timmothy","Timmy","Timothy","Tina","Tito","Titus","Tobin","Toby","Tod","Tom","Tomas","Tomasa","Tommie","Toney","Toni","Tony","Torey","Torrance","Torrey","Toy","Trace","Tracey","Tracy","Travis","Travon","Tre","Tremaine","Tremayne","Trent","Trenton","Tressa","Tressie","Treva","Trever","Trevion","Trevor","Trey","Trinity","Trisha","Tristian","Tristin","Triston","Troy","Trudie","Trycia","Trystan","Turner","Twila","Tyler","Tyra","Tyree","Tyreek","Tyrel","Tyrell","Tyrese","Tyrique","Tyshawn","Tyson","Ubaldo","Ulices","Ulises","Una","Unique","Urban","Uriah","Uriel","Ursula","Vada","Valentin","Valentina","Valentine","Valerie","Vallie","Van","Vance","Vanessa","Vaughn","Veda","Velda","Vella","Velma","Velva","Vena","Verda","Verdie","Vergie","Verla","Verlie","Vern","Verna","Verner","Vernice","Vernie","Vernon","Verona","Veronica","Vesta","Vicenta","Vicente","Vickie","Vicky","Victor","Victoria","Vida","Vidal","Vilma","Vince","Vincent","Vincenza","Vincenzo","Vinnie","Viola","Violet","Violette","Virgie","Virgil","Virginia","Virginie","Vita","Vito","Viva","Vivian","Viviane","Vivianne","Vivien","Vivienne","Vladimir","Wade","Waino","Waldo","Walker","Wallace","Walter","Walton","Wanda","Ward","Warren","Watson","Wava","Waylon","Wayne","Webster","Weldon","Wellington","Wendell","Wendy","Werner","Westley","Weston","Whitney","Wilber","Wilbert","Wilburn","Wiley","Wilford","Wilfred","Wilfredo","Wilfrid","Wilhelm","Wilhelmine","Will","Willa","Willard","William","Willie","Willis","Willow","Willy","Wilma","Wilmer","Wilson","Wilton","Winfield","Winifred","Winnifred","Winona","Winston","Woodrow","Wyatt","Wyman","Xander","Xavier","Xzavier","Yadira","Yasmeen","Yasmin","Yasmine","Yazmin","Yesenia","Yessenia","Yolanda","Yoshiko","Yvette","Yvonne","Zachariah","Zachary","Zachery","Zack","Zackary","Zackery","Zakary","Zander","Zane","Zaria","Zechariah","Zelda","Zella","Zelma","Zena","Zetta","Zion","Zita","Zoe","Zoey","Zoie","Zoila","Zola","Zora","Zula"];e.exports={generateUsername:function(){return`${i.randomElement(r)}-${i.randomAlphanumStr(3)}`}}},32:(e,t)=>{"use strict";const n=/"(?:_|\\\\u005[Ff])(?:_|\\\\u005[Ff])(?:p|\\\\u0070)(?:r|\\\\u0072)(?:o|\\\\u006[Ff])(?:t|\\\\u0074)(?:o|\\\\u006[Ff])(?:_|\\\\u005[Ff])(?:_|\\\\u005[Ff])"\\s*\\:/;t.parse=function(e){const i="object"==typeof(arguments.length<=1?void 0:arguments[1])&&(arguments.length<=1?void 0:arguments[1]),r=(arguments.length<=1?0:arguments.length-1)>1||!i?arguments.length<=1?void 0:arguments[1]:void 0,o=(arguments.length<=1?0:arguments.length-1)>1&&(arguments.length<=2?void 0:arguments[2])||i||{},s=JSON.parse(e,r);return"ignore"===o.protoAction?s:s&&"object"==typeof s&&e.match(n)?(t.scan(s,o),s):s},t.scan=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=[e];for(;n.length;){const e=n;n=[];for(const i of e){if(Object.prototype.hasOwnProperty.call(i,"__proto__")){if("remove"!==t.protoAction)throw new SyntaxError("Object contains forbidden prototype property");delete i.__proto__}for(const e in i){const t=i[e];t&&"object"==typeof t&&n.push(i[e])}}}},t.safeParse=function(e,n){try{return t.parse(e,n)}catch(e){return null}}},122:function(e,t,n){var i;!function(r,o){"use strict";var s="function",a="undefined",d="object",c="string",l="major",h="model",u="name",p="type",m="vendor",g="version",f="architecture",v="console",_="mobile",E="tablet",y="smarttv",S="wearable",b="embedded",T="Amazon",C="Apple",x="ASUS",R="BlackBerry",A="Browser",w="Chrome",I="Firefox",P="Google",D="Huawei",O="LG",k="Microsoft",N="Motorola",M="Opera",L="Samsung",F="Sharp",j="Sony",V="Xiaomi",U="Zebra",H="Facebook",$="Chromium OS",J="Mac OS",B=function(e){for(var t={},n=0;n<e.length;n++)t[e[n].toUpperCase()]=e[n];return t},q=function(e,t){return typeof e===c&&-1!==G(t).indexOf(G(e))},G=function(e){return e.toLowerCase()},z=function(e,t){if(typeof e===c)return e=e.replace(/^\\s\\s*/,""),typeof t===a?e:e.substring(0,350)},K=function(e,t){for(var n,i,r,a,c,l,h=0;h<t.length&&!c;){var u=t[h],p=t[h+1];for(n=i=0;n<u.length&&!c&&u[n];)if(c=u[n++].exec(e))for(r=0;r<p.length;r++)l=c[++i],typeof(a=p[r])===d&&a.length>0?2===a.length?typeof a[1]==s?this[a[0]]=a[1].call(this,l):this[a[0]]=a[1]:3===a.length?typeof a[1]!==s||a[1].exec&&a[1].test?this[a[0]]=l?l.replace(a[1],a[2]):o:this[a[0]]=l?a[1].call(this,l,a[2]):o:4===a.length&&(this[a[0]]=l?a[3].call(this,l.replace(a[1],a[2])):o):this[a]=l||o;h+=2}},W=function(e,t){for(var n in t)if(typeof t[n]===d&&t[n].length>0){for(var i=0;i<t[n].length;i++)if(q(t[n][i],e))return"?"===n?o:n}else if(q(t[n],e))return"?"===n?o:n;return e},X={ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2e3:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"},Y={browser:[[/\\b(?:crmo|crios)\\/([\\w\\.]+)/i],[g,[u,"Chrome"]],[/edg(?:e|ios|a)?\\/([\\w\\.]+)/i],[g,[u,"Edge"]],[/(opera mini)\\/([-\\w\\.]+)/i,/(opera [mobiletab]{3,6})\\b.+version\\/([-\\w\\.]+)/i,/(opera)(?:.+version\\/|[\\/ ]+)([\\w\\.]+)/i],[u,g],[/opios[\\/ ]+([\\w\\.]+)/i],[g,[u,M+" Mini"]],[/\\bopr\\/([\\w\\.]+)/i],[g,[u,M]],[/(kindle)\\/([\\w\\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\\/ ]?([\\w\\.]*)/i,/(avant |iemobile|slim)(?:browser)?[\\/ ]?([\\w\\.]*)/i,/(ba?idubrowser)[\\/ ]?([\\w\\.]+)/i,/(?:ms|\\()(ie) ([\\w\\.]+)/i,/(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\\/([-\\w\\.]+)/i,/(heytap|ovi)browser\\/([\\d\\.]+)/i,/(weibo)__([\\d\\.]+)/i],[u,g],[/(?:\\buc? ?browser|(?:juc.+)ucweb)[\\/ ]?([\\w\\.]+)/i],[g,[u,"UC"+A]],[/microm.+\\bqbcore\\/([\\w\\.]+)/i,/\\bqbcore\\/([\\w\\.]+).+microm/i],[g,[u,"WeChat(Win) Desktop"]],[/micromessenger\\/([\\w\\.]+)/i],[g,[u,"WeChat"]],[/konqueror\\/([\\w\\.]+)/i],[g,[u,"Konqueror"]],[/trident.+rv[: ]([\\w\\.]{1,9})\\b.+like gecko/i],[g,[u,"IE"]],[/ya(?:search)?browser\\/([\\w\\.]+)/i],[g,[u,"Yandex"]],[/(avast|avg)\\/([\\w\\.]+)/i],[[u,/(.+)/,"$1 Secure "+A],g],[/\\bfocus\\/([\\w\\.]+)/i],[g,[u,I+" Focus"]],[/\\bopt\\/([\\w\\.]+)/i],[g,[u,M+" Touch"]],[/coc_coc\\w+\\/([\\w\\.]+)/i],[g,[u,"Coc Coc"]],[/dolfin\\/([\\w\\.]+)/i],[g,[u,"Dolphin"]],[/coast\\/([\\w\\.]+)/i],[g,[u,M+" Coast"]],[/miuibrowser\\/([\\w\\.]+)/i],[g,[u,"MIUI "+A]],[/fxios\\/([-\\w\\.]+)/i],[g,[u,I]],[/\\bqihu|(qi?ho?o?|360)browser/i],[[u,"360 "+A]],[/(oculus|samsung|sailfish|huawei)browser\\/([\\w\\.]+)/i],[[u,/(.+)/,"$1 "+A],g],[/(comodo_dragon)\\/([\\w\\.]+)/i],[[u,/_/g," "],g],[/(electron)\\/([\\w\\.]+) safari/i,/(tesla)(?: qtcarbrowser|\\/(20\\d\\d\\.[-\\w\\.]+))/i,/m?(qqbrowser|baiduboxapp|2345Explorer)[\\/ ]?([\\w\\.]+)/i],[u,g],[/(metasr)[\\/ ]?([\\w\\.]+)/i,/(lbbrowser)/i,/\\[(linkedin)app\\]/i],[u],[/((?:fban\\/fbios|fb_iab\\/fb4a)(?!.+fbav)|;fbav\\/([\\w\\.]+);)/i],[[u,H],g],[/(kakao(?:talk|story))[\\/ ]([\\w\\.]+)/i,/(naver)\\(.*?(\\d+\\.[\\w\\.]+).*\\)/i,/safari (line)\\/([\\w\\.]+)/i,/\\b(line)\\/([\\w\\.]+)\\/iab/i,/(chromium|instagram)[\\/ ]([-\\w\\.]+)/i],[u,g],[/\\bgsa\\/([\\w\\.]+) .*safari\\//i],[g,[u,"GSA"]],[/musical_ly(?:.+app_?version\\/|_)([\\w\\.]+)/i],[g,[u,"TikTok"]],[/headlesschrome(?:\\/([\\w\\.]+)| )/i],[g,[u,w+" Headless"]],[/ wv\\).+(chrome)\\/([\\w\\.]+)/i],[[u,w+" WebView"],g],[/droid.+ version\\/([\\w\\.]+)\\b.+(?:mobile safari|safari)/i],[g,[u,"Android "+A]],[/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\\/v?([\\w\\.]+)/i],[u,g],[/version\\/([\\w\\.\\,]+) .*mobile\\/\\w+ (safari)/i],[g,[u,"Mobile Safari"]],[/version\\/([\\w(\\.|\\,)]+) .*(mobile ?safari|safari)/i],[g,u],[/webkit.+?(mobile ?safari|safari)(\\/[\\w\\.]+)/i],[u,[g,W,{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}]],[/(webkit|khtml)\\/([\\w\\.]+)/i],[u,g],[/(navigator|netscape\\d?)\\/([-\\w\\.]+)/i],[[u,"Netscape"],g],[/mobile vr; rv:([\\w\\.]+)\\).+firefox/i],[g,[u,I+" Reality"]],[/ekiohf.+(flow)\\/([\\w\\.]+)/i,/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\\/ ]?([\\w\\.\\+]+)/i,/(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\\/([-\\w\\.]+)$/i,/(firefox)\\/([\\w\\.]+)/i,/(mozilla)\\/([\\w\\.]+) .+rv\\:.+gecko\\/\\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\\. ]?browser)[-\\/ ]?v?([\\w\\.]+)/i,/(links) \\(([\\w\\.]+)/i,/panasonic;(viera)/i],[u,g],[/(cobalt)\\/([\\w\\.]+)/i],[u,[g,/master.|lts./,""]]],cpu:[[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\\)]/i],[[f,"amd64"]],[/(ia32(?=;))/i],[[f,G]],[/((?:i[346]|x)86)[;\\)]/i],[[f,"ia32"]],[/\\b(aarch64|arm(v?8e?l?|_?64))\\b/i],[[f,"arm64"]],[/\\b(arm(?:v[67])?ht?n?[fl]p?)\\b/i],[[f,"armhf"]],[/windows (ce|mobile); ppc;/i],[[f,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?: mac|;|\\))/i],[[f,/ower/,"",G]],[/(sun4\\w)[;\\)]/i],[[f,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\\))|\\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\\b|pa-risc)/i],[[f,G]]],device:[[/\\b(sch-i[89]0\\d|shw-m380s|sm-[ptx]\\w{2,4}|gt-[pn]\\d{2,4}|sgh-t8[56]9|nexus 10)/i],[h,[m,L],[p,E]],[/\\b((?:s[cgp]h|gt|sm)-\\w+|sc[g-]?[\\d]+a?|galaxy nexus)/i,/samsung[- ]([-\\w]+)/i,/sec-(sgh\\w+)/i],[h,[m,L],[p,_]],[/(?:\\/|\\()(ip(?:hone|od)[\\w, ]*)(?:\\/|;)/i],[h,[m,C],[p,_]],[/\\((ipad);[-\\w\\),; ]+apple/i,/applecoremedia\\/[\\w\\.]+ \\((ipad)/i,/\\b(ipad)\\d\\d?,\\d\\d?[;\\]].+ios/i],[h,[m,C],[p,E]],[/(macintosh);/i],[h,[m,C]],[/\\b(sh-?[altvz]?\\d\\d[a-ekm]?)/i],[h,[m,F],[p,_]],[/\\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\\d{2})\\b(?!.+d\\/s)/i],[h,[m,D],[p,E]],[/(?:huawei|honor)([-\\w ]+)[;\\)]/i,/\\b(nexus 6p|\\w{2,4}e?-[atu]?[ln][\\dx][012359c][adn]?)\\b(?!.+d\\/s)/i],[h,[m,D],[p,_]],[/\\b(poco[\\w ]+)(?: bui|\\))/i,/\\b; (\\w+) build\\/hm\\1/i,/\\b(hm[-_ ]?note?[_ ]?(?:\\d\\w)?) bui/i,/\\b(redmi[\\-_ ]?(?:note|k)?[\\w_ ]+)(?: bui|\\))/i,/\\b(mi[-_ ]?(?:a\\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\\d?\\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\\))/i],[[h,/_/g," "],[m,V],[p,_]],[/\\b(mi[-_ ]?(?:pad)(?:[\\w_ ]+))(?: bui|\\))/i],[[h,/_/g," "],[m,V],[p,E]],[/; (\\w+) bui.+ oppo/i,/\\b(cph[12]\\d{3}|p(?:af|c[al]|d\\w|e[ar])[mt]\\d0|x9007|a101op)\\b/i],[h,[m,"OPPO"],[p,_]],[/vivo (\\w+)(?: bui|\\))/i,/\\b(v[12]\\d{3}\\w?[at])(?: bui|;)/i],[h,[m,"Vivo"],[p,_]],[/\\b(rmx[12]\\d{3})(?: bui|;|\\))/i],[h,[m,"Realme"],[p,_]],[/\\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\\b[\\w ]+build\\//i,/\\bmot(?:orola)?[- ](\\w*)/i,/((?:moto[\\w\\(\\) ]+|xt\\d{3,4}|nexus 6)(?= bui|\\)))/i],[h,[m,N],[p,_]],[/\\b(mz60\\d|xoom[2 ]{0,2}) build\\//i],[h,[m,N],[p,E]],[/((?=lg)?[vl]k\\-?\\d{3}) bui| 3\\.[-\\w; ]{10}lg?-([06cv9]{3,4})/i],[h,[m,O],[p,E]],[/(lm(?:-?f100[nv]?|-[\\w\\.]+)(?= bui|\\))|nexus [45])/i,/\\blg[-e;\\/ ]+((?!browser|netcast|android tv)\\w+)/i,/\\blg-?([\\d\\w]+) bui/i],[h,[m,O],[p,_]],[/(ideatab[-\\w ]+)/i,/lenovo ?(s[56]000[-\\w]+|tab(?:[\\w ]+)|yt[-\\d\\w]{6}|tb[-\\d\\w]{6})/i],[h,[m,"Lenovo"],[p,E]],[/(?:maemo|nokia).*(n900|lumia \\d+)/i,/nokia[-_ ]?([-\\w\\.]*)/i],[[h,/_/g," "],[m,"Nokia"],[p,_]],[/(pixel c)\\b/i],[h,[m,P],[p,E]],[/droid.+; (pixel[\\daxl ]{0,6})(?: bui|\\))/i],[h,[m,P],[p,_]],[/droid.+ (a?\\d[0-2]{2}so|[c-g]\\d{4}|so[-gl]\\w+|xq-a\\w[4-7][12])(?= bui|\\).+chrome\\/(?![1-6]{0,1}\\d\\.))/i],[h,[m,j],[p,_]],[/sony tablet [ps]/i,/\\b(?:sony)?sgp\\w+(?: bui|\\))/i],[[h,"Xperia Tablet"],[m,j],[p,E]],[/ (kb2005|in20[12]5|be20[12][59])\\b/i,/(?:one)?(?:plus)? (a\\d0\\d\\d)(?: b|\\))/i],[h,[m,"OnePlus"],[p,_]],[/(alexa)webm/i,/(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\\))/i,/(kf[a-z]+)( bui|\\)).+silk\\//i],[h,[m,T],[p,E]],[/((?:sd|kf)[0349hijorstuw]+)( bui|\\)).+silk\\//i],[[h,/(.+)/g,"Fire Phone $1"],[m,T],[p,_]],[/(playbook);[-\\w\\),; ]+(rim)/i],[h,m,[p,E]],[/\\b((?:bb[a-f]|st[hv])100-\\d)/i,/\\(bb10; (\\w+)/i],[h,[m,R],[p,_]],[/(?:\\b|asus_)(transfo[prime ]{4,10} \\w+|eeepc|slider \\w+|nexus 7|padfone|p00[cj])/i],[h,[m,x],[p,E]],[/ (z[bes]6[027][012][km][ls]|zenfone \\d\\w?)\\b/i],[h,[m,x],[p,_]],[/(nexus 9)/i],[h,[m,"HTC"],[p,E]],[/(htc)[-;_ ]{1,2}([\\w ]+(?=\\)| bui)|\\w+)/i,/(zte)[- ]([\\w ]+?)(?: bui|\\/|\\))/i,/(alcatel|geeksphone|nexian|panasonic(?!(?:;|\\.))|sony(?!-bra))[-_ ]?([-\\w]*)/i],[m,[h,/_/g," "],[p,_]],[/droid.+; ([ab][1-7]-?[0178a]\\d\\d?)/i],[h,[m,"Acer"],[p,E]],[/droid.+; (m[1-5] note) bui/i,/\\bmz-([-\\w]{2,})/i],[h,[m,"Meizu"],[p,_]],[/(blackberry|benq|palm(?=\\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\\w]*)/i,/(hp) ([\\w ]+\\w)/i,/(asus)-?(\\w+)/i,/(microsoft); (lumia[\\w ]+)/i,/(lenovo)[-_ ]?([-\\w]+)/i,/(jolla)/i,/(oppo) ?([\\w ]+) bui/i],[m,h,[p,_]],[/(kobo)\\s(ereader|touch)/i,/(archos) (gamepad2?)/i,/(hp).+(touchpad(?!.+tablet)|tablet)/i,/(kindle)\\/([\\w\\.]+)/i,/(nook)[\\w ]+build\\/(\\w+)/i,/(dell) (strea[kpr\\d ]*[\\dko])/i,/(le[- ]+pan)[- ]+(\\w{1,9}) bui/i,/(trinity)[- ]*(t\\d{3}) bui/i,/(gigaset)[- ]+(q\\w{1,9}) bui/i,/(vodafone) ([\\w ]+)(?:\\)| bui)/i],[m,h,[p,E]],[/(surface duo)/i],[h,[m,k],[p,E]],[/droid [\\d\\.]+; (fp\\du?)(?: b|\\))/i],[h,[m,"Fairphone"],[p,_]],[/(u304aa)/i],[h,[m,"AT&T"],[p,_]],[/\\bsie-(\\w*)/i],[h,[m,"Siemens"],[p,_]],[/\\b(rct\\w+) b/i],[h,[m,"RCA"],[p,E]],[/\\b(venue[\\d ]{2,7}) b/i],[h,[m,"Dell"],[p,E]],[/\\b(q(?:mv|ta)\\w+) b/i],[h,[m,"Verizon"],[p,E]],[/\\b(?:barnes[& ]+noble |bn[rt])([\\w\\+ ]*) b/i],[h,[m,"Barnes & Noble"],[p,E]],[/\\b(tm\\d{3}\\w+) b/i],[h,[m,"NuVision"],[p,E]],[/\\b(k88) b/i],[h,[m,"ZTE"],[p,E]],[/\\b(nx\\d{3}j) b/i],[h,[m,"ZTE"],[p,_]],[/\\b(gen\\d{3}) b.+49h/i],[h,[m,"Swiss"],[p,_]],[/\\b(zur\\d{3}) b/i],[h,[m,"Swiss"],[p,E]],[/\\b((zeki)?tb.*\\b) b/i],[h,[m,"Zeki"],[p,E]],[/\\b([yr]\\d{2}) b/i,/\\b(dragon[- ]+touch |dt)(\\w{5}) b/i],[[m,"Dragon Touch"],h,[p,E]],[/\\b(ns-?\\w{0,9}) b/i],[h,[m,"Insignia"],[p,E]],[/\\b((nxa|next)-?\\w{0,9}) b/i],[h,[m,"NextBook"],[p,E]],[/\\b(xtreme\\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i],[[m,"Voice"],h,[p,_]],[/\\b(lvtel\\-)?(v1[12]) b/i],[[m,"LvTel"],h,[p,_]],[/\\b(ph-1) /i],[h,[m,"Essential"],[p,_]],[/\\b(v(100md|700na|7011|917g).*\\b) b/i],[h,[m,"Envizen"],[p,E]],[/\\b(trio[-\\w\\. ]+) b/i],[h,[m,"MachSpeed"],[p,E]],[/\\btu_(1491) b/i],[h,[m,"Rotor"],[p,E]],[/(shield[\\w ]+) b/i],[h,[m,"Nvidia"],[p,E]],[/(sprint) (\\w+)/i],[m,h,[p,_]],[/(kin\\.[onetw]{3})/i],[[h,/\\./g," "],[m,k],[p,_]],[/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\\)/i],[h,[m,U],[p,E]],[/droid.+; (ec30|ps20|tc[2-8]\\d[kx])\\)/i],[h,[m,U],[p,_]],[/smart-tv.+(samsung)/i],[m,[p,y]],[/hbbtv.+maple;(\\d+)/i],[[h,/^/,"SmartTV"],[m,L],[p,y]],[/(nux; netcast.+smarttv|lg (netcast\\.tv-201\\d|android tv))/i],[[m,O],[p,y]],[/(apple) ?tv/i],[m,[h,C+" TV"],[p,y]],[/crkey/i],[[h,w+"cast"],[m,P],[p,y]],[/droid.+aft(\\w)( bui|\\))/i],[h,[m,T],[p,y]],[/\\(dtv[\\);].+(aquos)/i,/(aquos-tv[\\w ]+)\\)/i],[h,[m,F],[p,y]],[/(bravia[\\w ]+)( bui|\\))/i],[h,[m,j],[p,y]],[/(mitv-\\w{5}) bui/i],[h,[m,V],[p,y]],[/Hbbtv.*(technisat) (.*);/i],[m,h,[p,y]],[/\\b(roku)[\\dx]*[\\)\\/]((?:dvp-)?[\\d\\.]*)/i,/hbbtv\\/\\d+\\.\\d+\\.\\d+ +\\([\\w\\+ ]*; *([\\w\\d][^;]*);([^;]*)/i],[[m,z],[h,z],[p,y]],[/\\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\\b/i],[[p,y]],[/(ouya)/i,/(nintendo) ([wids3utch]+)/i],[m,h,[p,v]],[/droid.+; (shield) bui/i],[h,[m,"Nvidia"],[p,v]],[/(playstation [345portablevi]+)/i],[h,[m,j],[p,v]],[/\\b(xbox(?: one)?(?!; xbox))[\\); ]/i],[h,[m,k],[p,v]],[/((pebble))app/i],[m,h,[p,S]],[/(watch)(?: ?os[,\\/]|\\d,\\d\\/)[\\d\\.]+/i],[h,[m,C],[p,S]],[/droid.+; (glass) \\d/i],[h,[m,P],[p,S]],[/droid.+; (wt63?0{2,3})\\)/i],[h,[m,U],[p,S]],[/(quest( 2| pro)?)/i],[h,[m,H],[p,S]],[/(tesla)(?: qtcarbrowser|\\/[-\\w\\.]+)/i],[m,[p,b]],[/(aeobc)\\b/i],[h,[m,T],[p,b]],[/droid .+?; ([^;]+?)(?: bui|\\) applew).+? mobile safari/i],[h,[p,_]],[/droid .+?; ([^;]+?)(?: bui|\\) applew).+?(?! mobile) safari/i],[h,[p,E]],[/\\b((tablet|tab)[;\\/]|focus\\/\\d(?!.+mobile))/i],[[p,E]],[/(phone|mobile(?:[;\\/]| [ \\w\\/\\.]*safari)|pda(?=.+windows ce))/i],[[p,_]],[/(android[-\\w\\. ]{0,9});.+buil/i],[h,[m,"Generic"]]],engine:[[/windows.+ edge\\/([\\w\\.]+)/i],[g,[u,"EdgeHTML"]],[/webkit\\/537\\.36.+chrome\\/(?!27)([\\w\\.]+)/i],[g,[u,"Blink"]],[/(presto)\\/([\\w\\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\\/([\\w\\.]+)/i,/ekioh(flow)\\/([\\w\\.]+)/i,/(khtml|tasman|links)[\\/ ]\\(?([\\w\\.]+)/i,/(icab)[\\/ ]([23]\\.[\\d\\.]+)/i,/\\b(libweb)/i],[u,g],[/rv\\:([\\w\\.]{1,9})\\b.+(gecko)/i],[g,u]],os:[[/microsoft (windows) (vista|xp)/i],[u,g],[/(windows) nt 6\\.2; (arm)/i,/(windows (?:phone(?: os)?|mobile))[\\/ ]?([\\d\\.\\w ]*)/i,/(windows)[\\/ ]?([ntce\\d\\. ]+\\w)(?!.+xbox)/i],[u,[g,W,X]],[/(win(?=3|9|n)|win 9x )([nt\\d\\.]+)/i],[[u,"Windows"],[g,W,X]],[/ip[honead]{2,4}\\b(?:.*os ([\\w]+) like mac|; opera)/i,/ios;fbsv\\/([\\d\\.]+)/i,/cfnetwork\\/.+darwin/i],[[g,/_/g,"."],[u,"iOS"]],[/(mac os x) ?([\\w\\. ]*)/i,/(macintosh|mac_powerpc\\b)(?!.+haiku)/i],[[u,J],[g,/_/g,"."]],[/droid ([\\w\\.]+)\\b.+(android[- ]x86|harmonyos)/i],[g,u],[/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\\/ ]?([\\w\\.]*)/i,/(blackberry)\\w*\\/([\\w\\.]*)/i,/(tizen|kaios)[\\/ ]([\\w\\.]+)/i,/\\((series40);/i],[u,g],[/\\(bb(10);/i],[g,[u,R]],[/(?:symbian ?os|symbos|s60(?=;)|series60)[-\\/ ]?([\\w\\.]*)/i],[g,[u,"Symbian"]],[/mozilla\\/[\\d\\.]+ \\((?:mobile|tablet|tv|mobile; [\\w ]+); rv:.+ gecko\\/([\\w\\.]+)/i],[g,[u,I+" OS"]],[/web0s;.+rt(tv)/i,/\\b(?:hp)?wos(?:browser)?\\/([\\w\\.]+)/i],[g,[u,"webOS"]],[/watch(?: ?os[,\\/]|\\d,\\d\\/)([\\d\\.]+)/i],[g,[u,"watchOS"]],[/crkey\\/([\\d\\.]+)/i],[g,[u,w+"cast"]],[/(cros) [\\w]+(?:\\)| ([\\w\\.]+)\\b)/i],[[u,$],g],[/panasonic;(viera)/i,/(netrange)mmh/i,/(nettv)\\/(\\d+\\.[\\w\\.]+)/i,/(nintendo|playstation) ([wids345portablevuch]+)/i,/(xbox); +xbox ([^\\);]+)/i,/\\b(joli|palm)\\b ?(?:os)?\\/?([\\w\\.]*)/i,/(mint)[\\/\\(\\) ]?(\\w*)/i,/(mageia|vectorlinux)[; ]/i,/([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\\/ ]?(?!chrom|package)([-\\w\\.]*)/i,/(hurd|linux) ?([\\w\\.]*)/i,/(gnu) ?([\\w\\.]*)/i,/\\b([-frentopcghs]{0,5}bsd|dragonfly)[\\/ ]?(?!amd|[ix346]{1,2}86)([\\w\\.]*)/i,/(haiku) (\\w+)/i],[u,g],[/(sunos) ?([\\w\\.\\d]*)/i],[[u,"Solaris"],g],[/((?:open)?solaris)[-\\/ ]?([\\w\\.]*)/i,/(aix) ((\\d)(?=\\.|\\)| )[\\w\\.])*/i,/\\b(beos|os\\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,/(unix) ?([\\w\\.]*)/i],[u,g]]},Q=function(e,t){if(typeof e===d&&(t=e,e=o),!(this instanceof Q))return new Q(e,t).getResult();var n=typeof r!==a&&r.navigator?r.navigator:o,i=e||(n&&n.userAgent?n.userAgent:""),v=n&&n.userAgentData?n.userAgentData:o,y=t?function(e,t){var n={};for(var i in e)t[i]&&t[i].length%2==0?n[i]=t[i].concat(e[i]):n[i]=e[i];return n}(Y,t):Y,S=n&&n.userAgent==i;return this.getBrowser=function(){var e,t={};return t[u]=o,t[g]=o,K.call(t,i,y.browser),t[l]=typeof(e=t[g])===c?e.replace(/[^\\d\\.]/g,"").split(".")[0]:o,S&&n&&n.brave&&typeof n.brave.isBrave==s&&(t[u]="Brave"),t},this.getCPU=function(){var e={};return e[f]=o,K.call(e,i,y.cpu),e},this.getDevice=function(){var e={};return e[m]=o,e[h]=o,e[p]=o,K.call(e,i,y.device),S&&!e[p]&&v&&v.mobile&&(e[p]=_),S&&"Macintosh"==e[h]&&n&&typeof n.standalone!==a&&n.maxTouchPoints&&n.maxTouchPoints>2&&(e[h]="iPad",e[p]=E),e},this.getEngine=function(){var e={};return e[u]=o,e[g]=o,K.call(e,i,y.engine),e},this.getOS=function(){var e={};return e[u]=o,e[g]=o,K.call(e,i,y.os),S&&!e[u]&&v&&"Unknown"!=v.platform&&(e[u]=v.platform.replace(/chrome os/i,$).replace(/macos/i,J)),e},this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}},this.getUA=function(){return i},this.setUA=function(e){return i=typeof e===c&&e.length>350?z(e,350):e,this},this.setUA(i),this};Q.VERSION="1.0.35",Q.BROWSER=B([u,g,l]),Q.CPU=B([f]),Q.DEVICE=B([h,m,p,v,_,y,E,S,b]),Q.ENGINE=Q.OS=B([u,g]),typeof t!==a?(e.exports&&(t=e.exports=Q),t.UAParser=Q):n.amdO?(i=function(){return Q}.call(t,n,t,e))===o||(e.exports=i):typeof r!==a&&(r.UAParser=Q);var Z=typeof r!==a&&(r.jQuery||r.Zepto);if(Z&&!Z.ua){var ee=new Q;Z.ua=ee.getResult(),Z.ua.get=function(){return ee.getUA()},Z.ua.set=function(e){ee.setUA(e);var t=ee.getResult();for(var n in t)Z.ua[n]=t[n]}}}("object"==typeof window?window:this)},505:(e,t,n)=>{var i=n(350);function r(e,t){this.logStorage=e,this.stringifyObjects=!(!t||!t.stringifyObjects)&&t.stringifyObjects,this.storeInterval=t&&t.storeInterval?t.storeInterval:3e4,this.maxEntryLength=t&&t.maxEntryLength?t.maxEntryLength:1e4,Object.values(i.levels).forEach(function(e){this[e]=function(){this._log.apply(this,arguments)}.bind(this,e)}.bind(this)),this.storeLogsIntervalID=null,this.queue=[],this.totalLen=0,this.outputCache=[]}r.prototype.stringify=function(e){try{return JSON.stringify(e)}catch(e){return"[object with circular refs?]"}},r.prototype.formatLogMessage=function(e){for(var t="",n=1,i=arguments.length;n<i;n++){var r=arguments[n];r instanceof Error?t+=r.toString()+": "+r.stack:this.stringifyObjects&&"object"==typeof r?t+=this.stringify(r):t+=r,n!==i-1&&(t+=" ")}return t.length?t:null},r.prototype._log=function(){var e=arguments[1],t=this.formatLogMessage.apply(this,arguments);if(t){var n=this.queue[this.queue.length-1];(n&&n.text)===t?n.count+=1:(this.queue.push({text:t,timestamp:e,count:1}),this.totalLen+=t.length)}this.totalLen>=this.maxEntryLength&&this._flush(!0,!0)},r.prototype.start=function(){this._reschedulePublishInterval()},r.prototype._reschedulePublishInterval=function(){this.storeLogsIntervalID&&(window.clearTimeout(this.storeLogsIntervalID),this.storeLogsIntervalID=null),this.storeLogsIntervalID=window.setTimeout(this._flush.bind(this,!1,!0),this.storeInterval)},r.prototype.flush=function(){this._flush(!1,!0)},r.prototype._storeLogs=function(e){try{this.logStorage.storeLogs(e)}catch(e){console.error("LogCollector error when calling logStorage.storeLogs(): ",e)}},r.prototype._flush=function(e,t){var n=!1;try{n=this.logStorage.isReady()}catch(e){console.error("LogCollector error when calling logStorage.isReady(): ",e)}this.totalLen>0&&(n||e)&&(n?(this.outputCache.length&&(this.outputCache.forEach(function(e){this._storeLogs(e)}.bind(this)),this.outputCache=[]),this._storeLogs(this.queue)):this.outputCache.push(this.queue),this.queue=[],this.totalLen=0),t&&this._reschedulePublishInterval()},r.prototype.stop=function(){this._flush(!1,!1)},e.exports=r},350:e=>{var t={trace:0,debug:1,info:2,log:3,warn:4,error:5};o.consoleTransport=console;var n=[o.consoleTransport];o.addGlobalTransport=function(e){-1===n.indexOf(e)&&n.push(e)},o.removeGlobalTransport=function(e){var t=n.indexOf(e);-1!==t&&n.splice(t,1)};var i={};function r(){var e=arguments[0],r=arguments[1],o=Array.prototype.slice.call(arguments,2);if(!(t[r]<e.level))for(var s=!(e.options.disableCallerInfo||i.disableCallerInfo)&&function(){var e={methodName:"",fileLocation:"",line:null,column:null},t=new Error,n=t.stack?t.stack.split("\\n"):[];if(!n||n.length<3)return e;var i=null;return n[3]&&(i=n[3].match(/\\s*at\\s*(.+?)\\s*\\((\\S*)\\s*:(\\d*)\\s*:(\\d*)\\)/)),!i||i.length<=4?(0===n[2].indexOf("log@")?e.methodName=n[3].substr(0,n[3].indexOf("@")):e.methodName=n[2].substr(0,n[2].indexOf("@")),e):(e.methodName=i[1],e.fileLocation=i[2],e.line=i[3],e.column=i[4],e)}(),a=n.concat(e.transports),d=0;d<a.length;d++){var c=a[d],l=c[r];if(l&&"function"==typeof l){var h=[];h.push((new Date).toISOString()),e.id&&h.push("["+e.id+"]"),s&&s.methodName.length>1&&h.push("<"+s.methodName+">: ");var u=h.concat(o);try{l.bind(c).apply(c,u)}catch(e){console.error("An error occured when trying to log with one of the available transports",e)}}}}function o(e,n,i,o){this.id=n,this.options=o||{},this.transports=i,this.transports||(this.transports=[]),this.level=t[e];for(var s=Object.keys(t),a=0;a<s.length;a++)this[s[a]]=r.bind(null,this,s[a])}o.setGlobalOptions=function(e){i=e||{}},o.prototype.setLevel=function(e){this.level=t[e]},e.exports=o,o.levels={TRACE:"trace",DEBUG:"debug",INFO:"info",LOG:"log",WARN:"warn",ERROR:"error"}},810:(e,t,n)=>{var i=n(350),r=n(505),o={},s=[],a=i.levels.TRACE;e.exports={addGlobalTransport:function(e){i.addGlobalTransport(e)},removeGlobalTransport:function(e){i.removeGlobalTransport(e)},setGlobalOptions:function(e){i.setGlobalOptions(e)},getLogger:function(e,t,n){var r=new i(a,e,t,n);return e?(o[e]=o[e]||[],o[e].push(r)):s.push(r),r},getUntrackedLogger:function(e,t,n){return new i(a,e,t,n)},setLogLevelById:function(e,t){for(var n=t?o[t]||[]:s,i=0;i<n.length;i++)n[i].setLevel(e)},setLogLevel:function(e){a=e;for(var t=0;t<s.length;t++)s[t].setLevel(e);for(var n in o){var i=o[n]||[];for(t=0;t<i.length;t++)i[t].setLevel(e)}},levels:i.levels,LogCollector:r}},22:e=>{var t=e.exports={v:[{name:"version",reg:/^(\\d*)$/}],o:[{name:"origin",reg:/^(\\S*) (\\d*) (\\d*) (\\S*) IP(\\d) (\\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\\d*) (\\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\\d) (\\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\\w*) (\\d*) ([\\w/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\\d*) ([\\w\\-.]*)(?:\\s*\\/(\\d*)(?:\\s*\\/(\\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(e){return e.encoding?"rtpmap:%d %s/%s/%s":e.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\\d*) ([\\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\\d*)(?: (\\S*) IP(\\d) (\\S*))?/,names:["port","netType","ipVer","address"],format:function(e){return null!=e.address?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\\*|\\d*) trr-int (\\d*)/,names:["payload","value"],format:"rtcp-fb:%s trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\\*|\\d*) ([\\w-_]*)(?: ([\\w-_]*))?/,names:["payload","type","subtype"],format:function(e){return null!=e.subtype?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\\d+)(?:\\/(\\w+))?(?: (urn:ietf:params:rtp-hdrext:encrypt))? (\\S*)(?: (\\S*))?/,names:["value","direction","encrypt-uri","uri","config"],format:function(e){return"extmap:%d"+(e.direction?"/%s":"%v")+(e["encrypt-uri"]?" %s":"%v")+" %s"+(e.config?" %s":"")}},{name:"extmapAllowMixed",reg:/^(extmap-allow-mixed)/},{push:"crypto",reg:/^crypto:(\\d*) ([\\w_]*) (\\S*)(?: (\\S*))?/,names:["id","suite","config","sessionConfig"],format:function(e){return null!=e.sessionConfig?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\\w*)/,format:"setup:%s"},{name:"connectionType",reg:/^connection:(new|existing)/,format:"connection:%s"},{name:"mid",reg:/^mid:([^\\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\\d*(?:\\.\\d*)*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\\d*(?:\\.\\d*)*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\\S*) (\\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\\S*) (\\d*) (\\S*) (\\d*) (\\S*) (\\d*) typ (\\S*)(?: raddr (\\S*) rport (\\d*))?(?: tcptype (\\S*))?(?: generation (\\d*))?(?: network-id (\\d*))?(?: network-cost (\\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(e){var t="candidate:%s %d %s %d %s %d typ %s";return t+=null!=e.raddr?" raddr %s rport %d":"%v%v",t+=null!=e.tcptype?" tcptype %s":"%v",null!=e.generation&&(t+=" generation %d"),(t+=null!=e["network-id"]?" network-id %d":"%v")+(null!=e["network-cost"]?" network-cost %d":"%v")}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\\d*) ([\\w_-]*)(?::(.*))?/,names:["id","attribute","value"],format:function(e){var t="ssrc:%d";return null!=e.attribute&&(t+=" %s",null!=e.value&&(t+=":%s")),t}},{push:"ssrcGroups",reg:/^ssrc-group:([\\x21\\x23\\x24\\x25\\x26\\x27\\x2A\\x2B\\x2D\\x2E\\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\\s?(\\w*) (\\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\\w_/]*) (\\S*)(?: (\\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(e){return null!=e.maxMessageSize?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\\d\\w]+) (\\w+)(?: ([\\S| ]*))?/,names:["id","direction","params"],format:function(e){return e.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\\\d+|\\\\*)[\\\\s\\\\t]+(send|recv)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*)(?:[\\\\s\\\\t]+(recv|send)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(e){return"imageattr:%s %s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\\\-_~;,]+)(?:\\\\s?(send|recv) ([a-zA-Z0-9\\\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(e){return"simulcast:%s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\\s\\t]+([\\S+\\s\\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\\d+(?:$|\\.\\d+))/,format:"framerate:%s"},{name:"sourceFilter",reg:/^source-filter: *(excl|incl) (\\S*) (IP4|IP6|\\*) (\\S*) (.*)/,names:["filterMode","netType","addressTypes","destAddress","srcList"],format:"source-filter: %s %s %s %s %s"},{name:"bundleOnly",reg:/^(bundle-only)/},{name:"label",reg:/^label:(.+)/,format:"label:%s"},{name:"sctpPort",reg:/^sctp-port:(\\d+)$/,format:"sctp-port:%s"},{name:"maxMessageSize",reg:/^max-message-size:(\\d+)$/,format:"max-message-size:%s"},{push:"tsRefClocks",reg:/^ts-refclk:([^\\s=]*)(?:=(\\S*))?/,names:["clksrc","clksrcExt"],format:function(e){return"ts-refclk:%s"+(null!=e.clksrcExt?"=%s":"")}},{name:"mediaClk",reg:/^mediaclk:(?:id=(\\S*))? *([^\\s=]*)(?:=(\\S*))?(?: *rate=(\\d+)\\/(\\d+))?/,names:["id","mediaClockName","mediaClockValue","rateNumerator","rateDenominator"],format:function(e){var t="mediaclk:";return t+=null!=e.id?"id=%s %s":"%v%s",t+=null!=e.mediaClockValue?"=%s":"",(t+=null!=e.rateNumerator?" rate=%s":"")+(null!=e.rateDenominator?"/%s":"")}},{name:"keywords",reg:/^keywds:(.+)$/,format:"keywds:%s"},{name:"content",reg:/^content:(.+)/,format:"content:%s"},{name:"bfcpFloorCtrl",reg:/^floorctrl:(c-only|s-only|c-s)/,format:"floorctrl:%s"},{name:"bfcpConfId",reg:/^confid:(\\d+)/,format:"confid:%s"},{name:"bfcpUserId",reg:/^userid:(\\d+)/,format:"userid:%s"},{name:"bfcpFloorId",reg:/^floorid:(.+) (?:m-stream|mstrm):(.+)/,names:["id","mStream"],format:"floorid:%s mstrm:%s"},{push:"invalid",names:["value"]}]};Object.keys(t).forEach((function(e){t[e].forEach((function(e){e.reg||(e.reg=/(.*)/),e.format||(e.format="%s")}))}))},561:(e,t,n)=>{var i=n(92),r=n(508);t.write=r,t.parse=i.parse,t.parseParams=i.parseParams,t.parseFmtpConfig=i.parseFmtpConfig,t.parsePayloads=i.parsePayloads,t.parseRemoteCandidates=i.parseRemoteCandidates,t.parseImageAttributes=i.parseImageAttributes,t.parseSimulcastStreamList=i.parseSimulcastStreamList},92:(e,t,n)=>{var i=function(e){return String(Number(e))===e?Number(e):e},r=function(e,t,n){var r=e.name&&e.names;e.push&&!t[e.push]?t[e.push]=[]:r&&!t[e.name]&&(t[e.name]={});var o=e.push?{}:r?t[e.name]:t;!function(e,t,n,r){if(r&&!n)t[r]=i(e[1]);else for(var o=0;o<n.length;o+=1)null!=e[o+1]&&(t[n[o]]=i(e[o+1]))}(n.match(e.reg),o,e.names,e.name),e.push&&t[e.push].push(o)},o=n(22),s=RegExp.prototype.test.bind(/^([a-z])=(.*)/);t.parse=function(e){var t={},n=[],i=t;return e.split(/(\\r\\n|\\r|\\n)/).filter(s).forEach((function(e){var t=e[0],s=e.slice(2);"m"===t&&(n.push({rtp:[],fmtp:[]}),i=n[n.length-1]);for(var a=0;a<(o[t]||[]).length;a+=1){var d=o[t][a];if(d.reg.test(s))return r(d,i,s)}})),t.media=n,t};var a=function(e,t){var n=t.split(/=(.+)/,2);return 2===n.length?e[n[0]]=i(n[1]):1===n.length&&t.length>1&&(e[n[0]]=void 0),e};t.parseParams=function(e){return e.split(/;\\s?/).reduce(a,{})},t.parseFmtpConfig=t.parseParams,t.parsePayloads=function(e){return e.toString().split(" ").map(Number)},t.parseRemoteCandidates=function(e){for(var t=[],n=e.split(" ").map(i),r=0;r<n.length;r+=3)t.push({component:n[r],ip:n[r+1],port:n[r+2]});return t},t.parseImageAttributes=function(e){return e.split(" ").map((function(e){return e.substring(1,e.length-1).split(",").reduce(a,{})}))},t.parseSimulcastStreamList=function(e){return e.split(";").map((function(e){return e.split(",").map((function(e){var t,n=!1;return"~"!==e[0]?t=i(e):(t=i(e.substring(1,e.length)),n=!0),{scid:t,paused:n}}))}))}},508:(e,t,n)=>{var i=n(22),r=/%[sdv%]/g,o=function(e){var t=1,n=arguments,i=n.length;return e.replace(r,(function(e){if(t>=i)return e;var r=n[t];switch(t+=1,e){case"%%":return"%";case"%s":return String(r);case"%d":return Number(r);case"%v":return""}}))},s=function(e,t,n){var i=[e+"="+(t.format instanceof Function?t.format(t.push?n:n[t.name]):t.format)];if(t.names)for(var r=0;r<t.names.length;r+=1){var s=t.names[r];t.name?i.push(n[t.name][s]):i.push(n[t.names[r]])}else i.push(n[t.name]);return o.apply(null,i)},a=["v","o","s","i","u","e","p","c","b","t","r","z","a"],d=["i","c","b","a"];e.exports=function(e,t){t=t||{},null==e.version&&(e.version=0),null==e.name&&(e.name=" "),e.media.forEach((function(e){null==e.payloads&&(e.payloads="")}));var n=t.outerOrder||a,r=t.innerOrder||d,o=[];return n.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))})),e.media.forEach((function(e){o.push(s("m",i.m[0],e)),r.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))}))})),o.join("\\r\\n")+"\\r\\n"}},803:function(e){e.exports=(()=>{var e={607:(e,t,n)=>{"use strict";t.ap=t.Tk=t.Vk=t.b1=t.zP=t.$j=t.dL=t.aM=t.vP=t.xt=t.Zt=t.UN=t.IO=t.zl=t.v6=t.S1=void 0,n(699);var i=n(231);t.S1=function(e,t){(0,i.initSDK)(e||{},[""],t)},t.v6=function(e){(0,i.setConfig)(e)},t.zl=function(e){},t.IO=function(e,t){(0,i.setUserRating)(e,t)},t.UN=function(e){(0,i.addKeys)(e)},t.Zt=function(){(0,i.disableDataCollection)()},t.xt=function(){(0,i.enableDataCollection)()},t.vP=function(e){(0,i.addEvent)(e)},t.aM=function(e,t){(0,i.mapStream)(e,t)},t.dL=function(e,t){(0,i.mapTrack)(e,t)},t.$j=function(){(0,i.connect)()},t.zP=function(){(0,i.disconnect)()},t.b1=function(e){(0,i.registerOnStatsListener)(e)},t.Vk=function(e){(0,i.persistentEnd)(e)},t.Tk=function(e,t){(0,i.persistentStart)(e,t)},t.ap=function(e){(0,i.registerStateListener)(e)},t.default={init:t.S1,addTags:t.zl,setUserRating:t.IO,addKeys:t.UN,setConfig:t.v6,disableDataCollection:t.Zt,enableDataCollection:t.xt,addEvent:t.vP,mapStream:t.aM,mapTrack:t.dL,connect:t.$j,disconnect:t.zP,addStatsListener:t.b1,persistentEnd:t.Vk,persistentStart:t.Tk,addStateListener:t.ap,qualityrtc:{run:i.qrtcRun,stop:i.qrtcStop}}},231:function(e,t,n){"use strict";var i=this&&this.__assign||function(){return i=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},i.apply(this,arguments)},r=this&&this.__awaiter||function(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))},o=this&&this.__generator||function(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(a){return function(d){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,a[0]&&(s=0)),s;)try{if(n=1,i&&(r=2&a[0]?i.return:a[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,a[1])).done)return r;switch(i=0,r&&(a=[2&a[0],r.value]),a[0]){case 0:case 1:r=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,i=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!r||a[1]>r[0]&&a[1]<r[3])){s.label=a[1];break}if(6===a[0]&&s.label<r[1]){s.label=r[1],r=a;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(a);break}r[2]&&s.ops.pop(),s.trys.pop();continue}a=t.call(e,s)}catch(e){a=[6,e],i=0}finally{n=r=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,d])}}},s=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.qrtcStop=t.qrtcRun=t.persistentStart=t.persistentEnd=t.registerStateListener=t.registerOnStatsListener=t.disconnect=t.connect=t.mapTrack=t.mapStream=t.addEvent=t.enableDataCollection=t.disableDataCollection=t.addKeys=t.setUserRating=t.setConfig=t.initSDK=t.sdkLogWithoutTrace=t.sdkLog=void 0;var a,d,c,l,h,u=n(85),p=n(911),m=n(593),g=n(412),f="undefined"!=typeof window,v=f?window:n.g,_=!!f&&!!v.mozRTCPeerConnection,E=(!!f&&!_&&v.RTCPeerConnection&&v.navigator.webkitGetUserMedia,{}),y=0,S={},b={rtcRoomId:void 0,rtcPeerId:void 0,projectId:void 0},T=null,C=null,x=null,R=0,A=!1,w=!1,I=0,P=!1,D=!1,O=null,k=null,N=!0;t.sdkLog=(0,m.getSdkLogger)((function(){return null==T?void 0:T.logLevel})),t.sdkLogWithoutTrace=(0,m.getSdkLogWithoutTrace)((function(){return null==T?void 0:T.logLevel}));var M=function(e){return e?"".concat(e.kind,":").concat(e.id," state:").concat(e.readyState," muted:").concat(e.muted," label:").concat(e.label):"no track"},L={},F=function(e){var n,r=e.forceRecreate,o=void 0!==r&&r,s=e.reconnecting,d=void 0!==s&&s,l=e.pcId,u=void 0===l?"PC_unknown":l,p=e.nailUp,f=void 0!==p&&p;if(null==x?void 0:x.isDisabledDataCollection())(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. disabledDataCollection, ignore [".concat(u,"]"));else{if((0,t.sdkLog)("debug","maybeOpenWebsocketConnection called: [".concat(u,"]"),{forceRecreate:o,reconnecting:d,isManualDisconnect:D,isManualConnect:P,tryingToConnectSocket:A,watchrtcConfig:JSON.stringify(T),disabled:null==x?void 0:x.isDisabledDataCollection(),openChannels:JSON.stringify(E)}),D=!1,(null===(n=null==x?void 0:x.connection)||void 0===n?void 0:n.readyState)===v.WebSocket.OPEN){if(!(0,m.isRoomIdOrPeerIdChanged)(b,T)||!o)return void(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection already opened [".concat(u,"]"));(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Closing WS connection. [".concat(u,"]")),null==x||x.close()}var _=(0,m.countOfValidConnections)(E);if(!P&&_<1&&!A)(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection not opened - previous connect call not finished or missing peer connection [".concat(u,"]"),{openChannels:JSON.stringify(E),connectionCount:_,tryingToConnectSocket:A,isManualConnect:P});else{var y=(0,m.validateConfig)(T),C=Object.keys(E)[_-1];if(!y)return A=!1,void(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS connection not opened - invalid config [".concat(u,"]"),{watchrtcConfig:T});T.keys&&Object.keys(T.keys||{}).forEach((function(e){"string"==typeof T.keys[e]&&(T.keys[e]=[T.keys[e]])}));var O=!!T.rtcToken,M=(0,m.getConnectionData)("ws",O?T.rtcToken:T.rtcApiKey,T.proxyUrl);x||(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. WS socket wasn\'t initialized [".concat(u,"]")),A=!0,R=Date.now(),(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Opening websocket connection [".concat(u,"]")),j(f);var L=Date.now();null==x||x.connect({url:"".concat(M.url,"?").concat(O?"token":"apiKey","=").concat(M.key,"&timestamp=").concat(Date.now()),options:{cleanOldTraces:N},onData:function(e){for(var n,r=0,o=Object.entries(e);r<o.length;r++){var s=o[r],l=s[0],h=s[1];S[l]=h}if(b.projectId=e.projectId,A=!1,T.allowBrowserLogCollection=Boolean(e.collectConsoleLogEnabled),T.allowBrowserLogCollection?!(null===(n=null==T?void 0:T.console)||void 0===n?void 0:n.override)&&e.collectConsoleLogLevel&&(0,m.setConsoleLevel)(e.collectConsoleLogLevel,a):((0,m.restoreOriginalConsoleMethods)(),(null==x?void 0:x.buffer)&&(x.buffer=x.buffer.filter((function(e){return"log"!==e[0]})))),(0,t.sdkLog)("info","Connection established. watchRTCConnectionId: ".concat(e.connectionId," sdkVersion:").concat(g.default," [").concat(u,"]")),e.interval!==T.collectionInterval){var p=T.collectionInterval;T.collectionInterval=e.interval,$(),j(),(0,t.sdkLog)("error","Collection interval mismatch - connection state reset"),a({data:["collectionIntervalChange",null,{oldInterval:p}]})}a({data:["watchrtc",C,i(i(i({},T),e),{sdkVersion:g.default})]}),d&&((0,t.sdkLog)("debug","websocket onData reconnecting"),a({data:["reconnect",null,null]})),c&&a({data:["hardware",null,c]}),a({data:["sessionId",null,v.watchRTCSessionId]})},onError:function(e,n){(0,t.sdkLog)("debug","websocket onError ".concat(n)),"auth"===n&&(w=!0),A=!1,R=0},onOpen:function(){if(N=!1,k&&k({connectionStatus:"connected"}),d){var e=Date.now()-I;a({data:["reconnectDuration",null,e]})}w=!1,h&&(clearInterval(h),h=void 0);var n=Date.now()-L;(0,t.sdkLog)("debug","maybeOpenWebsocketConnection. Connection opened. Opening time - ".concat(n," ms [").concat(u,"]"))},onClose:function(e){k&&k({connectionStatus:"disconnected"});var n=e.code,i=e.reason,r=e.wasClean;(0,t.sdkLog)("debug","close event. authFailed: ".concat(w," code: ").concat(n," reason: ").concat(i," wasClean: ").concat(r," reconnectTimerId: ").concat(h),{authFailed:w,code:n,reason:i,wasClean:r,reconnectTimerId:h}),w?((0,t.sdkLog)("debug","websocket authFailed"),h&&clearInterval(h)):h||D||((0,t.sdkLog)("debug","websocket onClose reconnecting"),I=Date.now(),F({reconnecting:!0,pcId:u}),h=setInterval((function(){F({reconnecting:!0,pcId:u})}),3e4))}})}}},j=function(e){if(void 0===e&&(e=!1),v.clearInterval(d),e){(0,t.sdkLog)("debug","startStatsCollection - nail up");for(var n=function(e){"closed"!==e.pc.signalingState&&e.pc.getStats(null).then((function(t){var n={};_?t.forEach((function(e){n["".concat(e.type,"_").concat(e.id)]=e})):n=(0,m.map2obj)(t),e.nailUpRef=JSON.parse(JSON.stringify(n))}))},s=0,a=Object.values(E);s<a.length;s++)n(a[s])}d=v.setInterval((function(){return r(this,void 0,void 0,(function(){var e,n,r,s,a,c,l;return o(this,(function(o){switch(o.label){case 0:return P||0!==(0,m.countOfValidConnections)(E)?[3,1]:((null==T?void 0:T.logGetStats)&&(0,t.sdkLog)("debug","getStatsInterval. No valid connections at this time"),R&&R+2e4<Date.now()&&(N=!0,v.clearInterval(d),null==x||x.close(),(0,t.sdkLog)("info","Last connection closed. watchRTCConnectionId: ".concat(null==S?void 0:S.connectionId," sdkVersion: ").concat(g.default))),[3,6]);case 1:R=Date.now(),e={connections:{},streams:{}},n=0,r=Object.values(E),o.label=2;case 2:return n<r.length?(s=r[n],(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStatsInterval. ".concat(s.id," signalingState: ").concat(s.pc.signalingState)),"closed"===s.pc.signalingState?[3,4]:[4,V(s)]):[3,5];case 3:a=o.sent(),c=a.peer,l=a.streams,e.connections=i(i({},e.connections),c),e.streams=i(i({},e.streams),l),o.label=4;case 4:return n++,[3,2];case 5:O&&O(e),o.label=6;case 6:return[2]}}))}))}),T.collectionInterval)},V=function(e){return new Promise((function(n,i){if(e){var r=e.id,o=e.pc,s=e.prev,d=e.nailUpRef;o.getStats(null).then((function(i){(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStats res",{res:i});var o={};_?i.forEach((function(e){o["".concat(e.type,"_").concat(e.id)]=e})):o=(0,m.map2obj)(i);var c=JSON.parse(JSON.stringify(o));o=(0,m.applyPatchForRTT)(s,o),d&&(o=(0,m.subtractNailUpReferenceStats)(d,o));var l=(0,m.deltaCompression)(s,o);(null==T?void 0:T.logGetStats)&&(0,t.sdkLogWithoutTrace)("debug","getStats(null) [".concat(r,"]"),{data:l}),null!==(null==l?void 0:l.timestamp)&&(null==l?void 0:l.timestamp)!==-1/0&&a({data:["getstats",r,l]}),e.prev=c,n((0,m.exposeApplicationStatsForPC)(r,s,o,L))}))}}))};t.initSDK=function(e,n,r){var o,s;if(v.watchRTCInitialized)(0,t.sdkLogWithoutTrace)("info","init. watchRTC SDK already has been initialized");else if(v.RTCPeerConnection){if(!(-1!==v.RTCPeerConnection.toString().indexOf("[native code]"))&&f&&(0,t.sdkLog)("info","init. RTCPeerConnection object has been already overridden"),v.watchRTCInitialized=!0,v.watchRTCSessionId=(0,m.generateID)(),setTimeout((function(){var e=Date.now();(0,m.getHardwareInfo)().then((function(n){var i=Date.now()-e;i<=5e4?(c=n,(0,t.sdkLog)("debug","getHardware",{hardwareInfo:c})):(0,t.sdkLog)("debug","getHardware failure: getHardwareTime: ".concat(i),{hardwareInfo:c})})).catch((function(e){(0,t.sdkLog)("error","Error. Get hardware info: ".concat(e.message))}))}),0),f){var d=new URLSearchParams(location.search);d.has("watchrtc")&&"debug"===d.get("watchrtc")&&(e.logLevel="debug")}if(x=(null==r?void 0:r.socketService)||new u.default,C=(null==r?void 0:r.httpService)||new p.default,e.collectionInterval=null!==(o=e.collectionInterval)&&void 0!==o?o:8e3,e.logLevel=e.logLevel||"debug",T=e,b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId,a=x.trace,T.wsUrl&&(0,t.sdkLog)("info",\'"wsUrl" config property is deprecated. Use "proxyUrl" instead of it\'),T.proxyUrl&&(0,t.sdkLog)("info",\'"proxyUrl" is used\'),(null==T?void 0:T.debug)&&(0,t.sdkLog)("info",\'"debug" config property is deprecated. Use "logLevel" instead of it\'),n.forEach((function(e){if(v[e+"RTCPeerConnection"]){var n=v[e+"RTCPeerConnection"],r=function(e,r){(null==e?void 0:e.watchrtc)&&(T=i(i({},T),e.watchrtc),b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId);var o=new n(e,r),s="PC_"+y++;return o.__rtcStatsId=s,E[s]={id:s,pc:o,validConnection:!1},e||(e={nullConfig:!0}),((e=JSON.parse(JSON.stringify(e)))&&e.iceServers||[]).forEach((function(e){delete e.credential})),(null==e?void 0:e.watchrtc)&&delete e.watchrtc,e.browserType=_?"moz":"webkit",(0,t.sdkLog)("debug","new RTCPeerConnection called.",{config:JSON.stringify(e),constraints:r}),a({data:["create",s,e]}),r&&a({data:["constraints",s,r]}),o.addEventListener("icecandidate",(function(e){(0,t.sdkLog)("debug","onicecandidate id:[".concat(s,"], candidate:[").concat(e.candidate,"]")),a({data:["onicecandidate",s,e.candidate]})})),o.addEventListener("icecandidateerror",(function(e){(0,t.sdkLog)("debug","onicecandidateerror id:[".concat(s,"], error:[").concat(e.errorCode,":").concat(e.errorText,"]")),a({data:["onicecandidateerror",s,"".concat(e.errorCode,":").concat(e.errorText)]})})),o.addEventListener("addstream",(function(e){a({data:["onaddstream",s,e.stream.id+" "+e.stream.getTracks().map((function(e){return e.kind+":"+e.id}))]})})),o.addEventListener("track",(function(e){a({data:["ontrack",s,M(e.track)+" "+e.streams.map((function(e){return"stream:"+e.id}))]}),e.track.addEventListener("ended",(function(){a({data:["ontrack",s,M(e.track)+" "+e.streams.map((function(e){return"stream:"+e.id}))]})}))})),o.addEventListener("removestream",(function(e){a({data:["onremovestream",s,e.stream.id+" "+e.stream.getTracks().map((function(e){return e.kind+":"+e.id}))]})})),o.addEventListener("signalingstatechange",(function(){E[s]&&!E[s].validConnection?(E[s].validConnection=!0,setTimeout((function(){(0,t.sdkLog)("debug","signalingstatechage. forceRecreate websocket connection[".concat(s,"]"),{openChannels:JSON.stringify(E)}),F({forceRecreate:!0,pcId:s})}),5e3)):(0,t.sdkLog)("debug","signalingstatechage. WS connection opening not triggered - peer connection not in channels or was already opened [".concat(s,"]"),{openChannels:JSON.stringify(E)}),a({data:["onsignalingstatechange",s,o.signalingState]})})),o.addEventListener("iceconnectionstatechange",(function(){(0,t.sdkLog)("debug","oniceconnectionstatechange id:[".concat(s,"], state:[").concat(o.iceConnectionState,"]")),a({data:["oniceconnectionstatechange",s,o.iceConnectionState]})})),o.addEventListener("icegatheringstatechange",(function(){(0,t.sdkLog)("debug","onicegatheringstatechange id:[".concat(s,"], state:[").concat(o.iceGatheringState,"]")),a({data:["onicegatheringstatechange",s,o.iceGatheringState]})})),o.addEventListener("connectionstatechange",(function(){(0,t.sdkLog)("debug","onconnectionstatechange id:[".concat(s,"], state:[").concat(o.connectionState,"]")),a({data:["onconnectionstatechange",s,o.connectionState]})})),o.addEventListener("negotiationneeded",(function(){(0,t.sdkLog)("debug","onnegotiationneeded id:[".concat(s,"]")),a({data:["onnegotiationneeded",s,void 0]})})),o.addEventListener("datachannel",(function(e){(0,t.sdkLog)("debug","ondatachannel id:[".concat(s,"], data:[").concat(e.channel.id," ").concat(e.channel.label,"]")),a({data:["ondatachannel",s,[e.channel.id,e.channel.label]]})})),(0,t.sdkLog)("debug","RTCPeerConnection override complete [".concat(s,"].")),o};if("HTMLMediaElement"in v&&"setSinkId"in HTMLMediaElement.prototype){var o=HTMLMediaElement.prototype.setSinkId;HTMLMediaElement.prototype.setSinkId=function(){var e=arguments[0];return navigator.mediaDevices.enumerateDevices().then((function(t){var n=t.find((function(t){return t.deviceId===e}));n&&n.deviceId!==l&&a({data:["audioOutputChange",null,n.label]}),l=e})).catch((function(e){(0,t.sdkLog)("debug",e.message,{error:e})})),o.apply(this,arguments)}}if("RTCRtpTransceiver"in v&&"setCodecPreferences"in v.RTCRtpTransceiver.prototype){var s=v.RTCRtpTransceiver,d=s.prototype.setCodecPreferences;s.prototype.setCodecPreferences=function(){return a({data:["setCodecPreferences",this.__pcId,arguments]}),d.apply(this,arguments)}}if("RTCRtpSender"in v&&"setParameters"in v.RTCRtpSender.prototype){var c=(h=v.RTCRtpSender).prototype.setParameters;h.prototype.setParameters=function(){return a({data:["setParameters",this.__pcId,arguments]}),c.apply(this,arguments)}}if("RTCRtpSender"in v&&"replaceTrack"in v.RTCRtpSender.prototype){var h,u=(h=v.RTCRtpSender).prototype.replaceTrack;h.prototype.replaceTrack=function(){var e=arguments[0];if(e){a({data:["replaceTrack",this.__pcId,M(e)]});var t=this.track;t&&t.label!==e.label&&a({data:["".concat(e.kind,"InputChange"),this.__pcId,e.label]})}else a({data:["replaceTrack",this.__pcId,null]});return u.apply(this,arguments)}}["addTransceiver"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,r="";arguments[1]&&arguments[1].streams&&(r=arguments[1].streams.map((function(e){return"stream:"+e.id})).join(";"));var o="string"==typeof arguments[0]?arguments[0]:arguments[0].kind+":"+arguments[0].id+" "+arguments[0].label,s=arguments[1]?i(i({},arguments[1]),{streams:r}):null;a({data:[e,this.__rtcStatsId,[o,s]]});var d=t.apply(this,arguments);d.sender.__pcId=this.__rtcStatsId;var c=arguments[0];return"object"==typeof c&&(a({data:["onlocaltrack",this.__rtcStatsId,M(c)]}),c.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(c)]})}))),d})})),["createDataChannel","restartIce"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){return a({data:[e,this.__rtcStatsId,arguments]}),t.apply(this,arguments)})})),["close"].forEach((function(e){var i=n.prototype[e];i&&(n.prototype[e]=function(){return a({data:[e,this.__rtcStatsId,arguments]}),delete E[this.__rtcStatsId],D=!0,(0,t.sdkLog)("debug","on RTCPeerConnection(".concat(this.__rtcStatsId,") close")),i.apply(this,arguments)})})),["addStream","removeStream"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,i=arguments[0],r=i.getTracks().map((function(e){return e.kind+":"+e.id})).join(",");return a({data:[e,this.__rtcStatsId,i.id+" "+r]}),"addStream"===e&&i.getTracks().map((function(e){a({data:["onlocaltrack",n.__rtcStatsId,M(e)+" "+i.id]}),e.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(e)+" "+i.id]})}))})),t.apply(this,arguments)})})),["addTrack"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this,i=arguments[0],r=[].slice.call(arguments,1);a({data:[e,this.__rtcStatsId,M(i)+" "+(r.map((function(e){return"stream:"+e.id})).join(";")||"-")]}),a({data:["onlocaltrack",this.__rtcStatsId,M(i)+" "+r.map((function(e){return"stream:"+e.id}))]}),i.addEventListener("ended",(function(){a({data:["onlocaltrack",n.__rtcStatsId,M(i)+" "+r.map((function(e){return"stream:"+e.id}))]})}));var o=t.apply(this,arguments);o.__pcId=this.__rtcStatsId;var s=this.getTransceivers();return s&&s.forEach((function(e){e.__pcId=n.__rtcStatsId})),o})})),["removeTrack"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=arguments[0].track;return a({data:[e,this.__rtcStatsId,n?M(n):"null"]}),t.apply(this,arguments)})})),["createOffer","createAnswer"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n,i=this.__rtcStatsId,r=arguments;return 1===arguments.length&&"object"==typeof arguments[0]?n=arguments[0]:3===arguments.length&&"object"==typeof arguments[2]&&(n=arguments[2]),a({data:[e,this.__rtcStatsId,n]}),t.apply(this,n?[n]:void 0).then((function(t){if(a({data:[e+"OnSuccess",i,t]}),!(r.length>0&&"function"==typeof r[0]))return t;r[0].apply(null,[t])}),(function(t){if(a({data:[e+"OnFailure",i,t.toString()]}),!(r.length>1&&"function"==typeof r[1]))throw t;r[1].apply(null,[t])}))})})),["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(e){var t=n.prototype[e];t&&(n.prototype[e]=function(){var n=this.__rtcStatsId,i=arguments,r=this,o="setLocalDescription"===e&&(!i[0]||i[0]&&!i[0].sdp);return a({data:[e,this.__rtcStatsId,o?{parameterless:!0}:i[0]]}),t.apply(this,[i[0]]).then((function(){a({data:[e+"OnSuccess",n,o?null==r?void 0:r.localDescription:void 0]}),i.length>=2&&"function"==typeof i[1]&&i[1].apply(null,[])}),(function(t){if(a({data:[e+"OnFailure",n,t.toString()]}),!(i.length>=3&&"function"==typeof i[2]))throw t;i[2].apply(null,[t])}))})})),n.generateCertificate&&Object.defineProperty(r,"generateCertificate",{get:function(){return arguments.length?n.generateCertificate.apply(null,arguments):n.generateCertificate}}),v[e+"RTCPeerConnection"]=r,v[e+"RTCPeerConnection"].prototype=n.prototype,(0,t.sdkLog)("debug","RTCPeerConnection prefixes override complete")}else(0,t.sdkLog)("debug","RTCPeerConnection prefixes override failed")})),f){if(n.forEach((function(e){var t=e+(e.length?"GetUserMedia":"getUserMedia");if(navigator[t]){var n=navigator[t].bind(navigator);navigator[t]=function(){a({data:["getUserMedia",null,arguments[0]]});var e=arguments[1],t=arguments[2];n(arguments[0],(function(t){a({data:["getUserMediaOnSuccess",null,(0,m.dumpStream)(t)]}),e&&e(t)}),(function(e){var n=["getUserMediaOnFailure",null,e.name];a({data:n}),H(n),t&&t(e)}))}.bind(navigator)}})),navigator.mediaDevices&&navigator.mediaDevices.getUserMedia){var h=navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices);navigator.mediaDevices.getUserMedia=function(){return a({data:["navigator.mediaDevices.getUserMedia",null,arguments[0]]}),h.apply(navigator.mediaDevices,arguments).then((function(e){return a({data:["navigator.mediaDevices.getUserMediaOnSuccess",null,(0,m.dumpStream)(e)]}),e}),(function(e){var t=["navigator.mediaDevices.getUserMediaOnFailure",null,e.name];return a({data:t}),H(t),Promise.reject(e)}))}.bind(navigator.mediaDevices)}if(navigator.mediaDevices&&navigator.mediaDevices.getDisplayMedia){var g=navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);navigator.mediaDevices.getDisplayMedia=function(){return a({data:["navigator.mediaDevices.getDisplayMedia",null,arguments[0]]}),g.apply(navigator.mediaDevices,arguments).then((function(e){return a({data:["navigator.mediaDevices.getDisplayMediaOnSuccess",null,(0,m.dumpStream)(e)]}),e}),(function(e){var t=["navigator.mediaDevices.getDisplayMediaOnFailure",null,e.name];return a({data:t}),H(t),Promise.reject(e)}))}.bind(navigator.mediaDevices)}}(null===(s=e.console)||void 0===s?void 0:s.level)&&(0,m.setConsoleLevel)(e.console.level,a)}else(0,t.sdkLogWithoutTrace)("info","init. RTCPeerConnection does not exist in global globalContext")},t.setConfig=function(e){var n;v.watchRTCInitialized?(!(!1===(null==T?void 0:T.allowBrowserLogCollection))&&!0===(null===(n=null==e?void 0:e.console)||void 0===n?void 0:n.override)&&e.console.level&&(0,m.setConsoleLevel)(e.console.level,a),"collectionInterval"in e&&delete e.collectionInterval,T=i(i({},T),e),b.rtcRoomId=T.rtcRoomId,b.rtcPeerId=T.rtcPeerId,(0,t.sdkLog)("debug","setConfig",{newWatchrtcConfig:JSON.stringify(e),watchrtcConfig:JSON.stringify(T)}),F({})):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.setUserRating=function(e,n){var i;if(!v.watchRTCInitialized)return(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first."),Promise.resolve({error:"SDK is not initialized. Use \'init\' function first."});if(!(0,m.validateRating)(e))return Promise.resolve({error:"Rating is invalid"});var r=(null===(i=null==x?void 0:x.connection)||void 0===i?void 0:i.readyState)===v.WebSocket.OPEN,o=["userRating",null,{rating:e,ratingComment:n}];return new Promise((function(e,t){r?a({data:o,options:{promiseFuncs:{resolve:e,reject:t}}}):U.apply(void 0,o).then((function(){return e({})})).catch((function(t){return e({error:t})}))}))},t.addKeys=function(e){var n;if(v.watchRTCInitialized){Object.keys(e||{}).forEach((function(t){"string"==typeof e[t]&&(e[t]=[e[t]])}));var i=["keys",null,e],r=(null===(n=null==x?void 0:x.connection)||void 0===n?void 0:n.readyState)===v.WebSocket.OPEN,o=null==x?void 0:x.wasConnected;return new Promise((function(e,t){var n={promiseFuncs:{resolve:e,reject:t}};r?a({data:i,options:n}):o?U.apply(void 0,i).then((function(){return e({})})).catch((function(t){return e({error:t})})):a({data:i,options:n})}))}(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.disableDataCollection=function(){v.watchRTCInitialized?(a({data:["disableDataCollection",null,null]}),null==x||x.disableDataCollection()):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.enableDataCollection=function(){v.watchRTCInitialized?(a({data:["enableDataCollection",null,null]}),null==x||x.enableDataCollection()):(0,t.sdkLog)("error","SDK is not initialized. Use \'init\' function first.")},t.addEvent=function(e){if(v.watchRTCInitialized){if((0,m.validateEvent)(e,E)){var n=i({},e),r=null;n.pc&&(r=n.pc.__rtcStatsId||null,delete n.pc);var o=["event",r,n];return new Promise((function(e,t){a({data:o,options:{promiseFuncs:{resolve:e,reject:t}}})}))}}else(0,t.sdkLog)("error","addEvent error. SDK is not initialized. Use \'init\' function first.")},t.mapStream=function(e,n){if(v.watchRTCInitialized){if(e&&n){var i=["mapStream",null,{id:e,name:n}];(0,t.sdkLog)("info","mapStream method is deprecated. Please use mapTrack instead."),a({data:i})}}else(0,t.sdkLog)("error","mapStream error. SDK is not initialized. Use \'init\' function first.")},t.mapTrack=function(e,n){v.watchRTCInitialized?!e||!n||(L[e]=n,a({data:["mapTrack",null,{id:e,name:n}]})):(0,t.sdkLog)("error","mapTrack error. SDK is not initialized. Use \'init\' function first.")},t.connect=function(){v.watchRTCInitialized?(N=!0,P=!0,(0,t.sdkLog)("debug","manual connect"),F({})):(0,t.sdkLog)("error","connect error. SDK is not initialized. Use \'init\' function first.")},t.disconnect=function(){v.watchRTCInitialized?(P=!1,D=!0,null==x||x.close(),(0,t.sdkLog)("debug","manual disconnect")):(0,t.sdkLog)("error","disconnect error. SDK is not initialized. Use \'init\' function first.")},t.registerOnStatsListener=function(e){O=e},t.registerStateListener=function(e){k=e};var U=function(){for(var e,n=[],i=0;i<arguments.length;i++)n[i]=arguments[i];if(!b.rtcRoomId||!b.rtcPeerId){var r="Missing configuration parameters rtcPeerId and rtcRoomId to connect";return!b.rtcRoomId&&b.rtcPeerId?r="Missing configuration parameter rtcRoomId to connect":!b.rtcPeerId&&b.rtcRoomId&&(r="Missing configuration parameter rtcPeerId to connect"),(0,t.sdkLog)("error",r),Promise.reject(r)}if(!b.projectId&&!T.rtcApiKey)return r="Missing apiKey to enable trace before connection establishment",(0,t.sdkLog)("info",r),Promise.reject(r);var o=(0,m.getConnectionData)("http",T.rtcApiKey,T.proxyUrl);return C?C.trace.apply(C,s(["".concat(o.url,"/trace"),null!==(e=b.projectId)&&void 0!==e?e:o.key,b.rtcRoomId,b.rtcPeerId],n,!1)):Promise.reject("Invalid configuration of http service")},H=function(e){var n=null==T?void 0:T.rtcApiKey,i=null==T?void 0:T.rtcRoomId,r=null==T?void 0:T.rtcPeerId;if(n&&i&&r){var o=(0,m.getConnectionData)("http",null==T?void 0:T.rtcApiKey,T.proxyUrl);e=e||(null==x?void 0:x.buffer)||[],null==C||C.trace("".concat(o.url,"/error"),o.key,i,r,e)}else(0,t.sdkLog)("error","Cannot report an error. Please provide rtcApiKey, rtcRoomId and rtcPeerId ")};t.persistentEnd=function(e){v.watchRTCInitialized?(clearInterval(d),P=!1,D=!0,null==x||x.close(e),(0,t.sdkLog)("debug","persistentEnd. sessionId: ".concat(v.watchRTCSessionId))):(0,t.sdkLog)("error","persistentEnd error. SDK is not initialized. Use \'init\' function first.")};var $=function(){var e;(0,t.sdkLog)("debug","resetConnectionState sessionId: ".concat(v.watchRTCSessionId));for(var n=0,i=Object.values(E);n<i.length;n++)i[n].prev=null;(null===(e=null==x?void 0:x.buffer)||void 0===e?void 0:e.length)&&(x.buffer=x.buffer.filter((function(e){return"getstats"!==e[0]})))};t.persistentStart=function(e,n){v.watchRTCInitialized?(T=i(i({},T),{rtcRoomId:e,rtcPeerId:n}),b.rtcRoomId=e,b.rtcPeerId=n,$(),F({nailUp:!0}),(0,t.sdkLog)("debug","persistentStart. sessionId: ".concat(v.watchRTCSessionId),{watchrtcConfig:T})):(0,t.sdkLog)("error","persistentStart error. SDK is not initialized. Use \'init\' function first.")};var J=function(e){return new Promise((function(t,n){var i=document.createElement("script");i.src=e,i.onload=t,i.onerror=n,document.head.appendChild(i)}))},B=!1;t.qrtcRun=function(e){var n=e.options,s=e.progressCallback;return r(void 0,void 0,void 0,(function(){var e,a,d,c,l,h,u,p,_,E,y,S,b,C;return o(this,(function(x){switch(x.label){case 0:if(!f)return(0,t.sdkLogWithoutTrace)("info","Cannot run qualityRTC test in non-browser environment"),[2];B=!1,(0,t.disableDataCollection)(),x.label=1;case 1:return x.trys.push([1,,4,5]),a=(null==n?void 0:n.codeUrl)||"https://qualityrtc-sdk.s3.amazonaws.com/".concat(g.default,"/main.bundle.js"),d={},n&&Object.keys(n||{}).forEach((function(e){"string"==typeof n[e]&&(d[e]=n[e])})),c=(0,m.getConnectionData)("http",null==T?void 0:T.rtcApiKey,T.proxyUrl),l=!!(null==n?void 0:n.configUrl),h=l?"".concat(n.configUrl,"/.netlify/functions/get-config"):c.url+"/get-qualityrtc-config?apiKey=".concat(c.key,"&").concat(new URLSearchParams(d)),console.log("runNetworkTest: request to run, loading lib and config",{codeUrl:a,configUrl:h}),[4,Promise.all([(R=h,r(void 0,void 0,void 0,(function(){return o(this,(function(e){switch(e.label){case 0:return[4,fetch(R)];case 1:return[4,e.sent().json()];case 2:return[2,e.sent()]}}))}))),J(a)])];case 2:if(u=x.sent(),p=u[0],_=u[1],console.log("runNetworkTest:JS code & config loaded",{codeLoad:_,configAnswer:p}),!(E=v.__qualityRTC))throw new Error("runNetworkTest:Failed to load qualityRTC, __qualityRTC is undefined");return y=function(e){return!B&&(s&&s(e),!0)},S=l?p.config:p.jsonConfig.config,b=l?null==n?void 0:n.configUrl:new URL(p.url).origin,C=i(i({},S),{isProbe:!0,options:i(i(i({},S.options),n),{wakeLock:!0,netlifyBaseUrl:b})}),console.log("runNetworkTest: code & config loaded, running test",{config:C,configData:S,qualityRTC:E,netlifyBaseUrl:b}),[4,E.run({config:C,progressCallback:y})];case 3:return e=x.sent(),console.log("runNetworkTest:JS Test completed",{answer:e}),[3,5];case 4:return(0,t.enableDataCollection)(),[7];case 5:return[2,e]}var R}))}))},t.qrtcStop=function(){f?B=!0:(0,t.sdkLogWithoutTrace)("info","Cannot run qualityRTC test in non-browser environment")}},527:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.getStreamsFromStats=t.getTransportFromStats=void 0,t.getTransportFromStats=function(e,t){if(!t)return null;var n=Object.keys(t),i=n.filter((function(e){return"candidate-pair"===t[e].type&&t[e].nominated}));if(i.length>0){var r=t[i[0]],o=r.localCandidateId,s=r.remoteCandidateId,a=n.find((function(e){return"local-candidate"===t[e].type&&t[e].id===o})),d=n.find((function(e){return"remote-candidate"===t[e].type&&t[e].id===s}));if(a&&d){var c=t[a],l=t[d],h={};return h[e]={connection:"relay"===c.candidateType?"relay":"direct",transport:"relay"===c.candidateType?c.relayProtocol:"udp",address:"".concat(l.address,":").concat(l.port)},h}}return null},t.getStreamsFromStats=function(e,t,n,i){var r={},o=Object.keys(n);return o.filter((function(e){return"inbound-rtp"===n[e].type||"outbound-rtp"===n[e].type})).forEach((function(s){var a=n[s],d=t&&s in t?t[s]:null,c="inbound-rtp"===a.type?"inbound":"outbound",l=a.kind,h=a.remoteId in n?n[a.remoteId]:null,u=d&&d.remoteId in t?t[d.remoteId]:null,p=d?(a.timestamp-d.timestamp)/1e3:null,m={direction:c,kind:l,peerId:e};if("video"===l&&(m.frameWidth=a.frameWidth,m.frameHeight=a.frameHeight,m.framerate=a.framesPerSecond),"inbound-rtp"===a.type)m.jitter=a.jitter,m.mappedName=a.trackIdentifier in i?i[a.trackIdentifier]:null,m.bytesReceived=d?a.bytesReceived-d.bytesReceived:null,m.packetsReceived=d?a.packetsReceived-d.packetsReceived:null,m.packetsLost=d?a.packetsLost-d.packetsLost:null,m.packetsLoss=m.packetsLost+m.packetsReceived>0?100*m.packetsLost/(m.packetsLost+m.packetsReceived):null,m.bitrate=p?8*m.bytesReceived/p:null,m.roundTripTime=h&&"roundTripTime"in h?h.roundTripTime:null;else{m.bytesSent=d?a.bytesSent-d.bytesSent:null,m.packetsSent=d?a.packetsSent-d.packetsSent:null,m.bitrate=p?8*m.bytesSent/p:null,m.roundTripTime=h&&"roundTripTime"in h?h.roundTripTime:null,m.jitter=h&&"jitter"in h?h.jitter:null,m.packetsLost=h&&u?h.packetsLost-u.packetsLost:null,m.packetsLoss=h&&"fractionLost"in h?h.fractionLost:null;var g=o.find((function(e){return n[e].id===a.mediaSourceId}));if(g){var f=n[g].trackIdentifier;m.mappedName=f in i?i[f]:null}}var v=o.find((function(e){return n[e].id===a.codecId}));if(v){var _=n[v].mimeType||"";m.codec=_.includes("/")?_.split("/")[1]:_}r[n[s].id]=m})),r}},699:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0})},593:function(e,t,n){"use strict";var i,r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var t,n=1,i=arguments.length;n<i;n++)for(var r in t=arguments[n])Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e},r.apply(this,arguments)},o=this&&this.__awaiter||function(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))},s=this&&this.__generator||function(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(a){return function(d){return function(a){if(n)throw new TypeError("Generator is already executing.");for(;o&&(o=0,a[0]&&(s=0)),s;)try{if(n=1,i&&(r=2&a[0]?i.return:a[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,a[1])).done)return r;switch(i=0,r&&(a=[2&a[0],r.value]),a[0]){case 0:case 1:r=a;break;case 4:return s.label++,{value:a[1],done:!1};case 5:s.label++,i=a[1],a=[0];continue;case 7:a=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==a[0]&&2!==a[0])){s=0;continue}if(3===a[0]&&(!r||a[1]>r[0]&&a[1]<r[3])){s.label=a[1];break}if(6===a[0]&&s.label<r[1]){s.label=r[1],r=a;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(a);break}r[2]&&s.ops.pop(),s.trys.pop();continue}a=t.call(e,s)}catch(e){a=[6,e],i=0}finally{n=r=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,d])}}},a=this&&this.__spreadArray||function(e,t,n){if(n||2===arguments.length)for(var i,r=0,o=t.length;r<o;r++)!i&&r in t||(i||(i=Array.prototype.slice.call(t,0,r)),i[r]=t[r]);return e.concat(i||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.generateID=t.subtractNailUpReferenceStats=t.applyPatchForRTT=t.exposeApplicationStatsForPC=t.restoreOriginalConsoleMethods=t.setConsoleLevel=t.getHardwareInfo=t.validateEvent=t.validateRating=t.isRoomIdOrPeerIdChanged=t.countOfValidConnections=t.validateConfig=t.getConnectionData=t.dumpStream=t.map2obj=t.mangleChromeStats=t.deltaCompression=t.getSdkLogWithoutTrace=t.getSdkLogger=t.logPrefix=void 0;var d=n(240),c=n(527),l=n(231),h=function(){var e=new Date;return("00"+(e.getMonth()+1)).slice(-2)+"/"+("00"+e.getDate()).slice(-2)+"/"+e.getFullYear()+" "+("00"+e.getHours()).slice(-2)+":"+("00"+e.getMinutes()).slice(-2)+":"+("00"+e.getSeconds()).slice(-2)+":"+("000"+e.getMilliseconds()).slice(-3)};t.logPrefix=function(e){return void 0===e&&(e="info"),"error"===e?["".concat(h()," %cwatchRTC %cERROR"),"background: ".concat("gold","; color: black; padding: 2px 0.5em; border-radius: 0.5em;"),"background: ".concat("red","; color: white; padding: 2px 0.5em; border-radius: 0.5em;")]:["".concat(h()," %cwatchRTC"),"background: ".concat("gold","; color: black; padding: 2px 0.5em; border-radius: 0.5em;")]};var u=["debug","info","error"],p=function(e,n){return void 0===e&&(e=console.log),function(i,r,o){var s=n(),d=u.indexOf(s),c=u.indexOf(i);if(!("silent"===s||c<d)){var l=a(a([],(0,t.logPrefix)(i),!0),[r],!1);o&&l.push(o),e.apply(void 0,l)}}};t.getSdkLogger=p.bind(null,console.log),t.getSdkLogWithoutTrace=p.bind(null,null!==(i=console._original_log)&&void 0!==i?i:console.log),t.deltaCompression=function(e,t){e=e||{},t=t||{},t=JSON.parse(JSON.stringify(t)),Object.keys(t).forEach((function(n){var i=t[n];delete i.id,e[n]&&Object.keys(i).forEach((function(r){i.timestamp&&"string"==typeof i.timestamp&&(i.timestamp=new Date(i.timestamp).getTime()),(i[r]===e[n][r]||Array.isArray(i[r])&&JSON.stringify(i[r])===JSON.stringify(e[n][r]))&&delete t[n][r],(0===Object.keys(i).length||1===Object.keys(i).length&&i.timestamp)&&delete t[n]}))}));var n=-1/0;return Object.keys(t).forEach((function(e){var i=t[e];i.timestamp>n&&(n=i.timestamp)})),Object.keys(t).forEach((function(e){var i=t[e];i.timestamp===n&&(i.timestamp=0)})),t.timestamp=n,t},t.mangleChromeStats=function(e,t){var n={};return t.result().forEach((function(e){var t={id:e.id,timestamp:e.timestamp.getTime(),type:e.type};e.names().forEach((function(n){t[n]=e.stat(n)})),n[t.id]=t})),n},t.map2obj=function(e){if(!e.entries)return e;var t={};return e.forEach((function(e,n){t[n]=e})),t},t.dumpStream=function(e){return{id:e.id,tracks:e.getTracks().map((function(e){return{id:e.id,kind:e.kind,label:e.label,enabled:e.enabled,muted:e.muted,readyState:e.readyState}}))}},t.getConnectionData=function(e,t,n){var i="".concat("ws"==e?"ws":"http","://localhost:9101"),r="".concat("ws"==e?"wss":"https","://watchrtc-staging1.testrtc.com"),o="".concat("ws"==e?"wss":"https","://watchrtc-staging2.testrtc.com"),s="".concat("ws"==e?"wss":"https","://watchrtc.testrtc.com"),a="".concat("ws"==e?"wss":"https","://watchrtc-app1.testrtc.com");n&&"http"===e&&(n=n.includes("wss://")?n.replace("wss://","https://"):n.replace("ws://","http://"));var d=t.split(":");return-1!==t.indexOf("local")?{url:n||i,key:d[1]}:-1!==t.indexOf("staging1")?{url:n||r,key:d[1]}:-1!==t.indexOf("staging")?{url:n||o,key:d[1]}:-1!==t.indexOf("production1")?{url:n||a,key:d[1]}:-1!==t.indexOf("production")?{url:n||s,key:d[1]}:{url:n||s,key:d[0]}},t.validateConfig=function(e){return(null==e?void 0:e.rtcApiKey)?!(!(null==e?void 0:e.rtcRoomId)||!(null==e?void 0:e.rtcPeerId))||((0,l.sdkLog)("debug","config.rtcRoomId or config.rtcPeerId is empty."),!1):((0,l.sdkLog)("debug","config.rtcApiKey or config.rtcToken need to be provided."),!1)},t.countOfValidConnections=function(e){return Object.keys(e).filter((function(t){return e[t].validConnection})).length},t.isRoomIdOrPeerIdChanged=function(e,t){var n=!1;return t.rtcRoomId&&e.rtcRoomId&&e.rtcRoomId!==t.rtcRoomId&&(n=!0),t.rtcPeerId&&e.rtcPeerId&&e.rtcPeerId!==t.rtcPeerId&&(n=!0),n&&(0,l.sdkLog)("debug","maybeOpenWebsocketConnection. rtcRoomId or rtcPeerId has been changed",{old:{rtcRoomId:e.rtcRoomId,rtcPeerId:e.rtcPeerId},new:{rtcRoomId:t.rtcRoomId,rtcPeerId:t.rtcPeerId}}),n},t.validateRating=function(e){return e?!("number"!=typeof e||e<1||e>5)||((0,l.sdkLog)("error","rating parameter should be number from 1 to 5"),!1):((0,l.sdkLog)("error","rating parameter is required"),!1)},t.validateEvent=function(e,t){return e?["global","local","log"].includes(e.type)?e.parameters&&"object"!=typeof e.parameters?((0,l.sdkLog)("error",\'event.parameters should be JSON object"\'),!1):!e.pc||e.pc.__rtcStatsId in t||((0,l.sdkLog)("error",\'event.pc should be a RTCPeerConnection used in the call"\'),!1):((0,l.sdkLog)("error",\'event.type should be either "global" or "local" or "log"\'),!1):((0,l.sdkLog)("error","event parameter is required"),!1)},t.getHardwareInfo=function(){return o(void 0,void 0,void 0,(function(){function e(e){return(Math.round(100*e)/100).toFixed(2)}var t,i,a,c;return s(this,(function(h){switch(h.label){case 0:return"undefined"==typeof window?[2]:(t=function(e){return o(void 0,void 0,void 0,(function(){return s(this,(function(t){switch(t.label){case 0:return[4,new Promise((function(t){try{var i=n(804)("./".concat(e));return i.shift(),t(i)}catch(n){(0,l.sdkLog)("error","Error. getHardwareInfo. loadBenchmarks",{err:n.stack,fileName:e}),t([])}}))];case 1:return[2,t.sent()]}}))}))},[4,d.getGPUTier({override:{loadBenchmarks:t}})]);case 1:return i=h.sent(),a=r(r({},i),{cores_count:window.navigator.hardwareConcurrency}),(c=window.performance.memory)&&(a.jsHeapSizeLimit=e(c.jsHeapSizeLimit/1048576),a.totalJSHeapSize=e(c.totalJSHeapSize/1048576),a.usedJSHeapSize=e(c.usedJSHeapSize/1048576)),[2,a]}}))}))};var m={originalMethodPrefix:"_original_",methodsToPatch:["log","debug","info","warn","error"],level:""},g=function(e,t){var n=console[e];n&&(console[m.originalMethodPrefix+e]=n,console[e]=function(){for(var i=[],r=0;r<arguments.length;r++)i[r]=arguments[r];if(m.level&&i.length&&t){var o=m.methodsToPatch.indexOf(e),s=m.methodsToPatch.indexOf(m.level);if(o>=0&&o>=s){var a=f(i);t({data:["log",null,{type:e,text:a}]})}}n.apply(console,i)})};t.setConsoleLevel=function(e,t){if(e&&m.methodsToPatch.includes(e)&&e!==m.level){var n=m.methodsToPatch.indexOf(e),i=m.methodsToPatch.indexOf(m.level);if(i<0)for(var r=0,o=m.methodsToPatch.slice(n);r<o.length;r++){var s=o[r];g(s,t)}else if(n<i)for(var a=0,d=m.methodsToPatch.slice(n,i);a<d.length;a++)s=d[a],g(s,t);m.level=e}},t.restoreOriginalConsoleMethods=function(){if("console"in window)for(var e=0,t=m.methodsToPatch;e<t.length;e++){var n=t[e],i=console[m.originalMethodPrefix+n];i&&(console[n]=i.bind(console),delete console[m.originalMethodPrefix+n])}},t.exposeApplicationStatsForPC=function(e,t,n,i){return{peer:(0,c.getTransportFromStats)(e,n),streams:(0,c.getStreamsFromStats)(e,t,n,i)}};var f=function(e){try{return e.map((function(e){return"string"==typeof e?e:JSON.stringify(e,v())})).join(" ")}catch(e){return""}},v=function(){var e=new WeakSet;return function(t,n){if("object"==typeof n&&null!==n){if(e.has(n))return;e.add(n)}return n}};t.applyPatchForRTT=function(e,t){e=e||{},t=t||{};var n=!0;return 0===Object.keys(e).length&&(n=!1),Object.keys(t).filter((function(e){return"remote-outbound-rtp"===t[e].type||"remote-inbound-rtp"===t[e].type})).forEach((function(i){if("roundTripTime"in t[i]){var r="roundTripTimeMeasurements"in t[i]&&Boolean(e[i])&&"roundTripTimeMeasurements"in e[i];n&&r&&t[i].roundTripTimeMeasurements===e[i].roundTripTimeMeasurements&&(t[i].roundTripTime=NaN)}else t[i].roundTripTime=NaN})),t},t.subtractNailUpReferenceStats=function(e,t){for(var n=function(t,n){if(t in e){var i=e[t];switch(n.type){case"inbound-rtp":["bytesReceived","packetsReceived","packetsLost","framesDecoded","keyFramesDecoded","framesRendered","framesDropped","qpSum","totalDecodeTime","totalInterFrameDelay","totalSquaredInterFrameDelay","pauseCount","totalPausesDuration","freezeCount","totalFreezesDuration","headerBytesReceived","packetsDiscarded","fecBytesReceived","fecPacketsReceived","fecPacketsDiscarded","firCount","pliCount","totalProcessingDelay","nackCount","jitterBufferEmittedCount","totalSamplesReceived","concealedSamples","silentConcealedSamples","concealmentEvents","totalAudioEnergy","totalSamplesDuration","framesReceived","framesAssembledFromMultiplePackets","totalAssemblyTime","retransmittedPacketsReceived","retransmittedBytesReceived"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"outbound-rtp":["packetsSent","bytesSent","headerBytesSent","retransmittedPacketsSent","retransmittedBytesSent","totalEncodedBytesTarget","framesSent","hugeFramesSent","framesEncoded","keyFramesEncoded","qpSum","totalEncodeTime","totalPacketsSendDelay","qualityLimitationResolutionChanges","qualityLimitationDurations","nackCount","firCount","pliCount"].forEach((function(e){e in n&&("qualityLimitationDurations"===e?(n[e].bandwidth=Math.max(n[e].bandwidth-i[e].bandwidth,0),n[e].cpu=Math.max(n[e].cpu-i[e].cpu,0),n[e].other=Math.max(n[e].other-i[e].other,0),n[e].none=Math.max(n[e].none-i[e].none,0)):n[e]=Math.max(n[e]-i[e],0))}));break;case"remote-inbound-rtp":["packetsReceived","packetsLost","totalRoundTripTime","roundTripTimeMeasurements"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"remote-outbound-rtp":["packetsSent","bytesSent","totalRoundTripTime","roundTripTimeMeasurements"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"media-source":["totalAudioEnergy","totalSamplesDuration","droppedSamplesDuration","droppedSamplesEvents","totalCaptureDelay","totalSamplesCaptured","frames"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"media-playout":["synthesizedSamplesDuration","synthesizedSamplesEvents","totalSamplesDuration","totalPlayoutDelay","totalSamplesCount"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"peer-connection":["dataChannelsOpened","dataChannelsClosed"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"data-channel":["messagesSent","bytesSent","messagesReceived","bytesReceived"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"transport":["packetsSent","packetsReceived","bytesSent","bytesReceived","selectedCandidatePairChanges"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}));break;case"candidate-pair":["packetsSent","packetsReceived","bytesSent","bytesReceived","totalRoundTripTime","requestsReceived","requestsSent","responsesReceived","responsesSent","consentRequestsSent","packetsDiscardedOnSend","bytesDiscardedOnSend"].forEach((function(e){e in n&&(n[e]=Math.max(n[e]-i[e],0))}))}}},i=0,r=Object.entries(t);i<r.length;i++){var o=r[i];n(o[0],o[1])}return t},t.generateID=function(){return Math.random().toString(36).substring(2,15)+Math.random().toString(36).substring(2,15)}},412:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default="1.38.2"},911:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(231),r=function(){function e(){e._instance?(0,i.sdkLog)("info","WatchRTCSocket instance already created"):e._instance=this}return e.prototype.trace=function(e,t,n,r){for(var o=[],s=4;s<arguments.length;s++)o[s-4]=arguments[s];var a=Array.prototype.slice.call(o);return a.push(Date.now()),a[1]instanceof RTCPeerConnection&&(a[1]=a[1].__rtcStatsId),fetch(e,{method:"POST",mode:"cors",cache:"no-cache",credentials:"same-origin",headers:{"Content-Type":"application/json"},body:JSON.stringify({data:o,projectId:t,rtcRoomId:n,rtcPeerId:r})}).then((function(){return{}})).catch((function(e){return(0,i.sdkLog)("error",e.message,{err:e.stack}),{error:e}}))},e}();t.default=r},85:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0});var i=n(231),r=n(354),o="undefined"!=typeof window?window:n.g,s=function(){function e(){var t=this;this.connection=null,this.wasConnected=!1,this.buffer=[],this.sendInterval=1,this.onClose=function(){},this.dataCollection=!0,this.sendPromises=[],this.prevMessageTs=Date.now(),this.trace=function(n){var s=n.data,a=n.options,d=Array.prototype.slice.call(s),c=t.prevMessageTs,l=Date.now(),h=l-c;if(Math.abs(h)>=432e5&&t.trace({data:["timeChange",null,{now:l,prevMessageTs:c,timeSinceLastMessage:h}]}),d.push(l),d[1]instanceof RTCPeerConnection&&(d[1]=d[1].__rtcStatsId),e._instance.dataCollection)if(e._instance.connection&&e._instance.connection.readyState===o.WebSocket.OPEN||!(e._instance.buffer.length>1e3)){if(e._instance.buffer.push(d),(null==a?void 0:a.promiseFuncs)&&e._instance.sendPromises.push(a.promiseFuncs),e._instance.connection&&e._instance.connection.readyState===o.WebSocket.OPEN&&e._instance.buffer.length>=e._instance.sendInterval){var u=JSON.stringify(e._instance.buffer),p=r.compressToEncodedURIComponent(u);(0,i.sdkLogWithoutTrace)("debug","lines: ".concat(u.length)),(0,i.sdkLogWithoutTrace)("debug","compressedMessage: ".concat(p.length)),e._instance.buffer=[],e._instance.connection.send(p),e._instance.sendPromises.forEach((function(e){return(0,e.resolve)({})})),e._instance.sendPromises=[]}}else(null==a?void 0:a.promiseFuncs)&&a.promiseFuncs.resolve({error:"Message buffer size exceeded"});else(null==a?void 0:a.promiseFuncs)&&a.promiseFuncs.resolve({error:"Data collection disabled"})},e._instance?(0,i.sdkLog)("info","WatchRTCSocket instance already created"):e._instance=this}return e.prototype.connect=function(t){var n=t.url,r=t.onData,s=t.onError,a=t.onOpen,d=t.onClose,c=t.options,l=(void 0===c?{}:c).cleanOldTraces;e._instance.connection&&(e._instance.connection.close(),e._instance.connection=null);var h=e._instance;if(l){var u=Date.now()-6e5,p=h.buffer.filter((function(e){return e[3]>u})),m=h.buffer.length-p.length;h.buffer=p;var g=["oldTracesCleanup",null,{filteredCount:m},Date.now()];(0,i.sdkLog)("info","watchRTC SDK flushed ".concat(m," messages")),h.buffer.push(g)}e._instance.connection=new o.WebSocket(n,"2.0"),e._instance.connection.onopen=a||null,e._instance.connection.onclose=d||null,e._instance.connection.onmessage=function(t){var n;try{var o=JSON.parse(t.data);o.error?(null===(n=null==h?void 0:h.connection)||void 0===n||n.close(),h.connection=null,(0,i.sdkLog)("error","\\n"+o.error),s(o.error,"auth")):(o.sendInterval&&(e._instance.sendInterval=o.sendInterval),r(o),e._instance.wasConnected=!0)}catch(e){(0,i.sdkLog)("error","\\n",{err:e.stack}),s(e.message)}},e._instance.connection.onerror=function(e){(0,i.sdkLog)("error","\\n",e),s(e,"connection")}},e.prototype.close=function(t){var n,i;if(t&&(null===(i=null===(n=e._instance)||void 0===n?void 0:n.connection)||void 0===i?void 0:i.readyState)===o.WebSocket.OPEN){var s=JSON.stringify(["nailUpCallEnd",null,null,Date.now()]),a=r.compressToEncodedURIComponent(s);e._instance.connection.send(a)}e._instance.buffer=[],e._instance.sendPromises.forEach((function(e){return(0,e.resolve)({error:"Connection was close"})})),e._instance.sendPromises=[],e._instance.connection&&(e._instance.connection.close(),e._instance.onClose(),e._instance.connection=null)},e.prototype.disableDataCollection=function(){(0,i.sdkLog)("debug","Data collection disabled."),e._instance.dataCollection=!1},e.prototype.enableDataCollection=function(){(0,i.sdkLog)("debug","Data collection enabled."),e._instance.dataCollection=!0},e.prototype.isDisabledDataCollection=function(){return!e._instance.dataCollection},e}();t.default=s},240:function(e,t){!function(e){"use strict";var t=function(e,n){return(t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var n in t)Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n])})(e,n)};function n(e,t,n,i){return new(n||(n=Promise))((function(r,o){function s(e){try{d(i.next(e))}catch(e){o(e)}}function a(e){try{d(i.throw(e))}catch(e){o(e)}}function d(e){var t;e.done?r(e.value):(t=e.value,t instanceof n?t:new n((function(e){e(t)}))).then(s,a)}d((i=i.apply(e,t||[])).next())}))}function i(e,t){var n,i,r,o,s={label:0,sent:function(){if(1&r[0])throw r[1];return r[1]},trys:[],ops:[]};return o={next:a(0),throw:a(1),return:a(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function a(o){return function(a){return function(o){if(n)throw new TypeError("Generator is already executing.");for(;s;)try{if(n=1,i&&(r=2&o[0]?i.return:o[0]?i.throw||((r=i.return)&&r.call(i),0):i.next)&&!(r=r.call(i,o[1])).done)return r;switch(i=0,r&&(o=[2&o[0],r.value]),o[0]){case 0:case 1:r=o;break;case 4:return s.label++,{value:o[1],done:!1};case 5:s.label++,i=o[1],o=[0];continue;case 7:o=s.ops.pop(),s.trys.pop();continue;default:if(!((r=(r=s.trys).length>0&&r[r.length-1])||6!==o[0]&&2!==o[0])){s=0;continue}if(3===o[0]&&(!r||o[1]>r[0]&&o[1]<r[3])){s.label=o[1];break}if(6===o[0]&&s.label<r[1]){s.label=r[1],r=o;break}if(r&&s.label<r[2]){s.label=r[2],s.ops.push(o);break}r[2]&&s.ops.pop(),s.trys.pop();continue}o=t.call(e,s)}catch(e){o=[6,e],i=0}finally{n=r=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,a])}}}var r=["geforce 320m","geforce 8600","geforce 8600m gt","geforce 8800 gs","geforce 8800 gt","geforce 9400","geforce 9400m g","geforce 9400m","geforce 9600m gt","geforce 9600m","geforce fx go5200","geforce gt 120","geforce gt 130","geforce gt 330m","geforce gtx 285","google swiftshader","intel g41","intel g45","intel gma 4500mhd","intel gma x3100","intel hd 3000","intel q45","legacy","mali-2","mali-3","mali-4","quadro fx 1500","quadro fx 4","quadro fx 5","radeon hd 2400","radeon hd 2600","radeon hd 4670","radeon hd 4850","radeon hd 4870","radeon hd 5670","radeon hd 5750","radeon hd 6290","radeon hd 6300","radeon hd 6310","radeon hd 6320","radeon hd 6490m","radeon hd 6630m","radeon hd 6750m","radeon hd 6770m","radeon hd 6970m","sgx 543","sgx543"];function o(e){return e.toLowerCase().replace(/^angle ?\\((.+)\\)*$/,"$1").replace(/\\s(\\d{1,2}gb|direct3d.+$)|\\(r\\)| \\([^)]+\\)$/g,"")}var s="undefined"==typeof window,a=function(){if(!s){var e=window.navigator,t=e.userAgent,n=e.platform,i=e.maxTouchPoints,r=/(iphone|ipod|ipad)/i.test(t),o="iPad"===n||"MacIntel"===n&&i>0&&!window.MSStream;return{isIpad:o,isMobile:/android/i.test(t)||r||o,isSafari12:/Version\\/12.+Safari/.test(t)}}}();var d=[],c=[];function l(e,t){if(e===t)return 0;var n=e;e.length>t.length&&(e=t,t=n);for(var i=e.length,r=t.length;i>0&&e.charCodeAt(~-i)===t.charCodeAt(~-r);)i--,r--;for(var o,s=0;s<i&&e.charCodeAt(s)===t.charCodeAt(s);)s++;if(r-=s,0==(i-=s))return r;for(var a,l,h=0,u=0,p=0;u<i;)c[u]=e.charCodeAt(s+u),d[u]=++u;for(;p<r;)for(o=t.charCodeAt(s+p),a=p++,h=p,u=0;u<i;u++)l=o===c[u]?a:a+1,a=d[u],h=d[u]=a>h?l>h?h+1:l:l>a?a+1:l;return h}function h(e){return null!=e}var u=function(e){function n(t){var n=this.constructor,i=e.call(this,t)||this;return Object.setPrototypeOf(i,n.prototype),i}return function(e,n){if("function"!=typeof n&&null!==n)throw new TypeError("Class extends value "+String(n)+" is not a constructor or null");function i(){this.constructor=e}t(e,n),e.prototype=null===n?Object.create(n):(i.prototype=n.prototype,new i)}(n,e),n}(Error);e.getGPUTier=function(e){var t=void 0===e?{}:e,d=t.mobileTiers,c=void 0===d?[0,15,30,60]:d,p=t.desktopTiers,m=void 0===p?[0,15,30,60]:p,g=t.override,f=void 0===g?{}:g,v=t.glContext,_=t.failIfMajorPerformanceCaveat,E=void 0!==_&&_,y=t.benchmarksURL,S=void 0===y?"https://unpkg.com/detect-gpu@".concat("4.0.8","/dist/benchmarks"):y;return n(void 0,void 0,void 0,(function(){var e,t,d,p,g,_,y,b,T,C,x,R,A,w,I,P,D,O,k,N,M,L,F,j,V,U;return i(this,(function(H){switch(H.label){case 0:if(e={},s)return[2,{tier:0,type:"SSR"}];if(t=f.isIpad,d=void 0===t?!!(null==a?void 0:a.isIpad):t,p=f.isMobile,g=void 0===p?!!(null==a?void 0:a.isMobile):p,_=f.screenSize,y=void 0===_?window.screen:_,b=f.loadBenchmarks,T=void 0===b?function(e){return n(void 0,void 0,void 0,(function(){var t;return i(this,(function(n){switch(n.label){case 0:return[4,fetch("".concat(S,"/").concat(e)).then((function(e){return e.json()}))];case 1:if(t=n.sent(),parseInt(t.shift().split(".")[0],10)<4)throw new u("Detect GPU benchmark data is out of date. Please update to version 4x");return[2,t]}}))}))}:b,C=f.renderer,x=function(e){for(var t=0,n=g?["adreno","apple","mali-t","mali","nvidia","powervr"]:["intel","apple","amd","radeon","nvidia","geforce"];t<n.length;t++){var i=n[t];if(e.includes(i))return i}},R=function(t){return n(void 0,void 0,void 0,(function(){var n,r,o,s,a,c,h,p,m,f,v,_,E,S,b,C,R,A,w,I,P,D,O,k,N,M;return i(this,(function(i){switch(i.label){case 0:if(!(n=x(t)))return[2];r="".concat(g?"m":"d","-").concat(n).concat(d?"-ipad":"",".json"),o=e[r]=null!==(M=e[r])&&void 0!==M?M:T(r),i.label=1;case 1:return i.trys.push([1,3,,4]),[4,o];case 2:return s=i.sent(),[3,4];case 3:if((a=i.sent())instanceof u)throw a;return[2];case 4:if(c=function(e){var t,n=(e=e.replace(/\\([^)]+\\)/,"")).match(/\\d+/)||e.match(/(\\W|^)([A-Za-z]{1,3})(\\W|$)/g);return null!==(t=null==n?void 0:n.join("").replace(/\\W|amd/g,""))&&void 0!==t?t:""}(t),(h=s.filter((function(e){return e[1]===c}))).length||(h=s.filter((function(e){return e[0].includes(t)}))),0===(p=h.length))return[2];for(m=p>1?h.map((function(e){return[e,l(t,e[0])]})).sort((function(e,t){return e[1]-t[1]}))[0][0]:h[0],f=m[0],v=m[3],_=Number.MAX_VALUE,S=window.devicePixelRatio,b=y.width*S*y.height*S,C=0,R=v;C<R.length;C++)A=R[C],w=A[0],I=A[1],P=w*I,(D=Math.abs(b-P))<_&&(_=D,E=A);return E?(k=(O=E)[2],N=O[3],[2,[_,k,f,N]]):[2]}}))}))},A=function(e,t,n,i,r){return{device:r,fps:i,gpu:n,isMobile:g,tier:e,type:t}},I="",C)C=o(C),w=[C];else{if(!(P=v||function(e,t){void 0===t&&(t=!1);var n={alpha:!1,antialias:!1,depth:!1,failIfMajorPerformanceCaveat:t,powerPreference:"high-performance",stencil:!1};e&&delete n.powerPreference;var i=window.document.createElement("canvas"),r=i.getContext("webgl",n)||i.getContext("experimental-webgl",n);return null!=r?r:void 0}(null==a?void 0:a.isSafari12,E)))return[2,A(0,"WEBGL_UNSUPPORTED")];if((D=P.getExtension("WEBGL_debug_renderer_info"))&&(C=P.getParameter(D.UNMASKED_RENDERER_WEBGL)),!C)return[2,A(1,"FALLBACK")];I=C,C=o(C),w=function(e,t,n){return"apple gpu"===t?function(e,t,n){if(!n)return[t];var i,r=function(e){var t=e.createShader(35633),n=e.createShader(35632),i=e.createProgram();if(n&&t&&i){e.shaderSource(t,"\\n    precision highp float;\\n    attribute vec3 aPosition;\\n    varying float vvv;\\n    void main() {\\n      vvv = 0.31622776601683794;\\n      gl_Position = vec4(aPosition, 1.0);\\n    }\\n  "),e.shaderSource(n,"\\n    precision highp float;\\n    varying float vvv;\\n    void main() {\\n      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;\\n      enc = fract(enc);\\n      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);\\n      gl_FragColor = enc;\\n    }\\n  "),e.compileShader(t),e.compileShader(n),e.attachShader(i,t),e.attachShader(i,n),e.linkProgram(i),e.detachShader(i,t),e.detachShader(i,n),e.deleteShader(t),e.deleteShader(n),e.useProgram(i);var r=e.createBuffer();e.bindBuffer(34962,r),e.bufferData(34962,new Float32Array([-1,-1,0,3,-1,0,-1,3,0]),35044);var o=e.getAttribLocation(i,"aPosition");e.vertexAttribPointer(o,3,5126,!1,0,0),e.enableVertexAttribArray(o),e.clearColor(1,1,1,1),e.clear(16384),e.viewport(0,0,1,1),e.drawArrays(4,0,3);var s=new Uint8Array(4);return e.readPixels(0,0,1,1,6408,5121,s),e.deleteProgram(i),e.deleteBuffer(r),s.join("")}}(e),o="801621810",s="8016218135",d="80162181161",c=(null==a?void 0:a.isIpad)?[["a7",d,12],["a8",s,15],["a8x",s,15],["a9",s,15],["a9x",s,15],["a10",s,15],["a10x",s,15],["a12",o,15],["a12x",o,15],["a12z",o,15],["a14",o,15],["m1",o,15]]:[["a7",d,12],["a8",s,12],["a9",s,15],["a10",s,15],["a11",o,15],["a12",o,15],["a13",o,15],["a14",o,15]];return"80162181255"===r?i=c.filter((function(e){return e[2]>=14})):(i=c.filter((function(e){return e[1]===r}))).length||(i=c),i.map((function(e){var t=e[0];return"apple ".concat(t," gpu")}))}(e,t,n):[t]}(P,C,g)}return[4,Promise.all(w.map(R))];case 1:if(!(O=H.sent().filter(h).sort((function(e,t){var n=e[0],i=void 0===n?Number.MAX_VALUE:n,r=e[1],o=t[0],s=void 0===o?Number.MAX_VALUE:o,a=t[1];return i===s?r-a:i-s}))).length)return[2,(k=r.find((function(e){return C.includes(e)})))?A(0,"BLOCKLISTED",k):A(1,"FALLBACK","".concat(C," (").concat(I,")"))];if(N=O[0],M=N[1],L=N[2],F=N[3],-1===M)return[2,A(0,"BLOCKLISTED",L,M,F)];for(j=g?c:m,V=0,U=0;U<j.length;U++)M>=j[U]&&(V=U);return[2,A(V,"BENCHMARK",L,M,F)]}}))}))},Object.defineProperty(e,"__esModule",{value:!0})}(t)},622:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["qualcomm adreno 540","540",0,[[1919,1279,19]]],["qualcomm adreno 540 gpu","540",0,[[1919,1279,24]]],["qualcomm adreno 618 gpu","618",0,[[1920,1080,20]]],["qualcomm adreno 630 gpu","630",0,[[1920,1080,21]]],["qualcomm adreno 680 gpu","680",0,[[2880,1920,25]]],["qualcomm adreno 685 gpu","685",0,[[1920,1080,28]]],["qualcomm adreno 690 gpu","690",0,[[1920,1280,28]]],["qualcomm adreno 8cx gen 3","8",0,[[1920,1080,22]]]]\')},183:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["amd ???","",0,[[1920,1080,144]]],["amd [amd/ati] fiji [radeon r9 fury / nano series]","9",0,[[1920,1200,162]]],["amd 15dd","15",0,[[3840,2160,14]]],["amd 66af:f1","66",0,[[3840,2160,181]]],["amd 67df:c4","67",0,[[2560,1600,59]]],["amd 67e8:00","67",0,[[1920,1080,59]]],["amd 67ef:c5","67",0,[[1920,1080,52]]],["amd 67ef:cf","67",0,[[1920,1080,74]]],["amd 67ef:e7","67",0,[[1920,1080,60]]],["amd 67ff:08","67",0,[[1920,1200,31]]],["amd 694c:c0","694",0,[[1919,1080,28],[3840,2160,12]]],["amd 694e:c0","694",0,[[3840,2160,27]]],["amd 6980:00","6980",0,[[1920,1200,59]]],["amd 699f:c1","699",0,[[1920,1080,48]]],["amd 7310:00","7310",0,[[3840,2160,55]]],["amd 731f:c1","731",0,[[1920,1080,60]]],["amd 7340:c5","7340",0,[[2560,1600,44]]],["amd advanced micro devices [amd] nee ati device","nee",0,[[1920,1200,157]]],["amd asus amd radeon r9-990x","9",0,[[1920,1080,60]]],["amd asus eah5450","5450",0,[[1600,900,12],[1680,1050,11],[1920,1200,12]]],["amd asus eah5670","5670",0,[[1920,1080,28]]],["amd asus eah6450","6450",0,[[1920,1080,12]]],["amd asus hd7750","7750",0,[[1920,1080,105]]],["amd asus hd7770","7770",0,[[1680,1050,60]]],["amd asus hd7850","7850",0,[[1920,1080,60]]],["amd asus hd7970","7970",0,[[3840,2160,50]]],["amd asus hd8760","8760",0,[[1680,1050,59]]],["amd asus r5 230","5",0,[[1920,1080,12]]],["amd asus r7 240","7",0,[[1600,900,28],[1920,1080,31]]],["amd asus r7 250","7",0,[[1920,1080,59]]],["amd asus r7 250x","7",0,[[1920,1080,60]]],["amd asus r7 265","7",0,[[1920,1080,60]]],["amd asus r7 360","7",0,[[1920,1080,78]]],["amd asus r7 370","7",0,[[1600,900,60],[1920,1080,143]]],["amd asus r9 270","9",0,[[1600,900,60]]],["amd asus r9 280x","9",0,[[1920,1080,146]]],["amd asus r9 295x2","9",0,[[2560,1440,93]]],["amd asus r9 380","9",0,[[1920,1080,60]]],["amd asus r9 390","9",0,[[1920,1080,235]]],["amd asus radeon r7 250","7",0,[[800,638,60]]],["amd asus radeon r7 260x","7",0,[[2560,1080,65]]],["amd asus radeon r9 270x","9",0,[[1024,768,85],[1920,1080,60]]],["amd asus radeon r9 280","9",0,[[1920,1080,60]]],["amd asus radeon rx 460","460",0,[[1360,768,104]]],["amd asus radeon rx 470","470",0,[[1920,1080,60]]],["amd asus radeon rx 480","480",0,[[1920,1080,124]]],["amd asus radeon rx 550","550",0,[[1440,900,60],[1920,1080,49]]],["amd asus radeon rx 5500 xt","5500",0,[[1920,1080,325]]],["amd asus radeon rx 560","560",0,[[1360,768,60],[1920,1080,85]]],["amd asus radeon rx 570","570",0,[[1600,900,202],[1920,1080,60]]],["amd asus radeon rx 5700","5700",0,[[1920,1080,327]]],["amd asus radeon rx 5700 xt","5700",0,[[1920,1080,224],[2560,1440,60]]],["amd asus radeon rx 580","580",0,[[1920,1080,177],[2560,1080,60]]],["amd asus radeon rx vega","rx",0,[[2560,1440,117]]],["amd asus rx 6600xt macos","6600",0,[[3840,2160,60]]],["amd ati mobility radeon hd 5870","5870",0,[[1920,1200,19]]],["amd baffin amd radeon rx 560","560",0,[[1920,1080,60]]],["amd barco mxrt 5600","5600",0,[[2800,2100,30]]],["amd carrizo 9874","9874",0,[[1920,1200,11]]],["amd cezanne","",0,[[1920,1080,162]]],["amd device","",0,[[1920,1080,188]]],["amd ellesmere radeon rx 570","570",0,[[1920,1080,60]]],["amd embedded radeon e9171","9171",0,[[3840,2160,26]]],["amd embedded radeon e9173","9173",0,[[3840,2160,16]]],["amd firepro 2270","2270",0,[[1245,768,19],[1920,1200,9]]],["amd firepro 3800 graphics adapter","3800",0,[[1920,1080,18]]],["amd firepro d300","300",0,[[1920,1080,60],[2560,1440,60],[3440,1440,60],[3840,2160,30]]],["amd firepro d500","500",0,[[1600,900,60],[2560,1440,59],[2560,1600,87],[3840,2160,57]]],["amd firepro d700","700",0,[[2048,1152,59],[2560,1440,59]]],["amd firepro m2000","2000",0,[[1600,900,28],[1920,1080,24]]],["amd firepro m4000","4000",0,[[1920,1080,57]]],["amd firepro m4000 mobility pro","4000",0,[[1920,1080,57]]],["amd firepro m4100","4100",0,[[1920,1080,58]]],["amd firepro m4100 firegl v","4100",0,[[1920,1080,24]]],["amd firepro m4150","4150",0,[[1600,900,51]]],["amd firepro m4170","4170",0,[[1920,1080,43]]],["amd firepro m5100","5100",0,[[1920,1080,60]]],["amd firepro m5100 firegl v","5100",0,[[1920,1080,29]]],["amd firepro m5950","5950",0,[[1920,1080,42]]],["amd firepro m6000 mobility pro","6000",0,[[1600,900,33],[1920,1080,60]]],["amd firepro m6100","6100",0,[[1920,1080,60]]],["amd firepro m6100 firegl v","6100",0,[[1920,1080,60]]],["amd firepro m7820","7820",0,[[1680,1050,44]]],["amd firepro r5000","5000",0,[[1920,1080,60]]],["amd firepro s10000","10000",0,[[2560,1440,58]]],["amd firepro s7150","7150",0,[[1440,900,70]]],["amd firepro s9000","9000",0,[[1920,1080,60]]],["amd firepro s9050","9050",0,[[1920,1080,101]]],["amd firepro v graphics adapter","v",0,[[1680,1050,53],[1920,1080,54]]],["amd firepro v3800","3800",0,[[1280,992,28],[1680,1050,25]]],["amd firepro v3900","3900",0,[[1920,1080,28],[2560,1440,26]]],["amd firepro v4800","4800",0,[[1440,900,37],[1920,1080,50]]],["amd firepro v4800 graphics adapter","4800",0,[[1920,1080,46]]],["amd firepro v4900","4900",0,[[1600,900,76],[1920,1080,53]]],["amd firepro v4900 graphics adapter","4900",0,[[1920,1200,40]]],["amd firepro v5800","5800",0,[[1366,768,60],[1920,1200,62]]],["amd firepro v5800 graphics adapter","5800",0,[[1360,768,83],[1280,1024,58]]],["amd firepro v5900","5900",0,[[1920,1080,53],[1920,1200,58],[3440,1440,34]]],["amd firepro v5900 graphics adapter","5900",0,[[1600,1200,54],[1920,1080,65]]],["amd firepro v7800 graphics adapter","7800",0,[[1680,1050,60],[1920,1080,60]]],["amd firepro v7900","7900",0,[[1920,1080,135],[1920,1200,60],[2560,1080,124]]],["amd firepro v7900 graphics adapter","7900",0,[[1920,1080,58]]],["amd firepro v8800","8800",0,[[2560,1440,58]]],["amd firepro w2100","2100",0,[[1920,1080,33]]],["amd firepro w4100","4100",0,[[1920,1080,55]]],["amd firepro w4100 graphics adapter","4100",0,[[1600,1200,70],[1920,1080,56]]],["amd firepro w4150m firegl v","4150",0,[[1920,1080,45]]],["amd firepro w4170m","4170",0,[[1366,768,11]]],["amd firepro w4190m","4190",0,[[1920,1080,42]]],["amd firepro w4300","4300",0,[[1280,1024,116]]],["amd firepro w5000","5000",0,[[1920,1080,60],[2560,1600,75]]],["amd firepro w5000 graphics adapter","5000",0,[[1280,1024,60],[1920,1080,117]]],["amd firepro w5100","5100",0,[[1920,1080,60],[1920,1200,59]]],["amd firepro w5100 graphics adapter","5100",0,[[1920,1080,89],[3840,2160,29]]],["amd firepro w5130m","5130",0,[[1920,1080,60]]],["amd firepro w5170m","5170",0,[[1920,1080,84],[2560,1440,51]]],["amd firepro w600","600",0,[[3840,2160,25]]],["amd firepro w6150m","6150",0,[[1920,1080,45]]],["amd firepro w7000","7000",0,[[1920,1080,60],[1920,1200,136]]],["amd firepro w7000 graphics adapter","7000",0,[[1920,1080,60]]],["amd firepro w7100","7100",0,[[1920,1080,60],[1920,1200,141]]],["amd firepro w7100 graphics adapter","7100",0,[[1200,900,60]]],["amd firepro w7170m","7170",0,[[1920,1080,60]]],["amd firepro w8000","8000",0,[[1920,1200,110],[2560,1440,60]]],["amd firepro w8100","8100",0,[[1920,1080,60],[1920,1200,60]]],["amd firepro w8100 graphic adapter","8100",0,[[1280,1024,113]]],["amd firepro w9100","9100",0,[[1920,1080,60],[1920,1200,188],[2560,1600,59]]],["amd gigabyte radeon rx 580","580",0,[[1920,1080,60]]],["amd gigabyte vega 64 macos","64",0,[[1920,1080,60]]],["amd hd7950 martin rev.","7950",0,[[2560,1440,101]]],["amd hd7950 martin ver.","7950",0,[[2560,1440,104]]],["amd kamen rider black rx","rx",0,[[1920,1080,60]]],["amd kaveri","",0,[[1920,1080,9]]],["amd madison [mobility radeon hd 5650 / 6530m/6550m]","5650",0,[[1366,768,43]]],["amd matrox c680 pcie x16","680",0,[[2560,1440,49]]],["amd matrox c900 pcie x16","900",0,[[5760,3240,9]]],["amd metal","",0,[[1920,1080,120]]],["amd mobility radeon hd 4250","4250",0,[[963,722,26]]],["amd mobility radeon hd 5000","5000",0,[[1366,768,47]]],["amd mobility radeon hd 5400","5400",0,[[1366,768,24]]],["amd mobility radeon hd 5430","5430",0,[[1600,900,15],[1920,1080,60]]],["amd mobility radeon hd 5470","5470",0,[[1366,768,24]]],["amd mobility radeon hd 5570","5570",0,[[1920,1080,27]]],["amd mobility radeon hd 5730 / 6570m","5730",0,[[1366,768,58]]],["amd mobility radeon hd 5850","5850",0,[[1600,900,55]]],["amd mobility radeon hd 5870","5870",0,[[1600,900,64],[1920,1200,53]]],["amd msi / amd rx 560","560",0,[[1920,1080,60]]],["amd msi / amd rx 560 4g","560",0,[[1920,1080,60]]],["amd msi baffin rx650","650",0,[[1920,1080,399]]],["amd msi rx560","560",0,[[1920,1080,343]]],["amd msi rx650","650",0,[[1920,1080,60]]],["amd mxgpu","",0,[[1920,1012,67],[1920,1080,106]]],["amd navi 10 5700 xt","10",0,[[3840,2160,60]]],["amd opal xt/gl","xt",0,[[1366,768,60]]],["amd park [mobility radeon hd 5430","5430",0,[[1280,720,11]]],["amd picasso","",0,[[1920,1080,48]]],["amd pitcairn pro radeon hd 7850","7850",0,[[1920,1080,60]]],["amd powercolor radeon r9 280","9",0,[[1920,1080,60]]],["amd r9 270x devil","9",0,[[1920,1080,60]]],["amd r9 280x dual-x","9",0,[[1920,1080,60]]],["amd r9 380","9",0,[[2560,1440,119]]],["amd r9 xxx","9",0,[[1920,1080,60]]],["amd radeon","",0,[[1920,1080,299],[3440,1440,60]]],["amd radeon 500","500",0,[[1920,1080,73]]],["amd radeon 520","520",0,[[1920,1080,35],[2560,1440,29]]],["amd radeon 530","530",0,[[1366,768,60],[1920,1080,30]]],["amd radeon 535","535",0,[[1920,1080,35]]],["amd radeon 535dx","535",0,[[1366,768,31],[1920,1080,37]]],["amd radeon 540","540",0,[[1920,1080,38]]],["amd radeon 540 / rx 540x/550/550x","540",0,[[2560,1440,88]]],["amd radeon 540x","540",0,[[1920,1080,59]]],["amd radeon 550","550",0,[[1920,1080,115]]],["amd radeon 550x","550",0,[[1920,1080,28]]],["amd radeon 610","610",0,[[1920,1080,29]]],["amd radeon 620","620",0,[[1920,1080,18]]],["amd radeon 625","625",0,[[1366,768,55],[1920,1080,47]]],["amd radeon 630","630",0,[[1920,1080,29]]],["amd radeon 6600m and 6700m","6600",0,[[1366,768,36],[1440,900,60]]],["amd radeon 6800","6800",0,[[3440,1440,100]]],["amd radeon 7500m/7600m","7500",0,[[1366,768,37]]],["amd radeon 7950 x2","7950",0,[[2560,1440,174]]],["amd radeon d700","700",0,[[2560,1440,120]]],["amd radeon e6460","6460",0,[[1600,1200,13]]],["amd radeon e6760","6760",0,[[1200,900,54],[1920,1080,42]]],["amd radeon e8860","8860",0,[[1920,1200,27],[2560,1374,88]]],["amd radeon e8870","8870",0,[[1920,1080,81]]],["amd radeon e8870mxm","8870",0,[[1920,1080,60]]],["amd radeon e9260","9260",0,[[1680,1050,60],[3840,2160,38]]],["amd radeon e9550","9550",0,[[1680,1050,60],[3840,2160,58]]],["amd radeon embedded e9560","9560",0,[[1920,1200,60]]],["amd radeon fury","",0,[[1920,1080,60]]],["amd radeon fury x","x",0,[[1920,1080,60],[2560,1440,144]]],["amd radeon hd - firepro d300","300",0,[[1920,1080,60]]],["amd radeon hd - firepro d300 opengl engine","300",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d500 opengl engine","500",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d700 opengl engine","700",0,[[3840,2160,52]]],["amd radeon hd 2600 xt","2600",1,[[2560,1600,-1]]],["amd radeon hd 5000","5000",0,[[1920,1080,8]]],["amd radeon hd 5400","5400",0,[[1920,1080,12]]],["amd radeon hd 5450","5450",0,[[1920,1080,13]]],["amd radeon hd 5470","5470",0,[[1280,1024,16]]],["amd radeon hd 5500","5500",0,[[1920,1080,27]]],["amd radeon hd 5570","5570",0,[[1920,1080,60],[2048,1152,31]]],["amd radeon hd 5600","5600",0,[[1920,1080,56]]],["amd radeon hd 5650","5650",0,[[1366,768,53]]],["amd radeon hd 5670","5670",1,[[1920,1080,-1],[2560,1440,-1]]],["amd radeon hd 5670 opengl engine","5670",1,[[2560,1440,-1]]],["amd radeon hd 5700","5700",0,[[1920,1080,59]]],["amd radeon hd 5730","5730",0,[[1366,768,46],[1680,1050,40]]],["amd radeon hd 5750","5750",1,[[1920,1080,-1],[1920,1200,-1],[2560,1440,-1]]],["amd radeon hd 5750 opengl engine","5750",1,[[2560,1440,-1]]],["amd radeon hd 5770","5770",0,[[1776,1000,43],[1920,1080,59]]],["amd radeon hd 5800","5800",0,[[1366,768,60],[1920,1200,102]]],["amd radeon hd 5850","5850",0,[[1920,1080,60]]],["amd radeon hd 5870","5870",0,[[1280,960,75],[1920,1080,60],[2048,1280,60]]],["amd radeon hd 5870m","5870",0,[[2560,1080,31]]],["amd radeon hd 5970","5970",0,[[1360,768,60],[1920,1080,60]]],["amd radeon hd 6230","6230",0,[[1366,768,13]]],["amd radeon hd 6250","6250",0,[[1280,800,8],[1366,768,8]]],["amd radeon hd 6290","6290",1,[[1366,768,-1]]],["amd radeon hd 6300m","6300",1,[[1366,768,-1]]],["amd radeon hd 6310","6310",1,[[1366,768,-1]]],["amd radeon hd 6320","6320",1,[[1366,768,-1]]],["amd radeon hd 6350","6350",0,[[1280,1024,18],[1920,1080,14]]],["amd radeon hd 6370d","6370",0,[[1920,1080,14]]],["amd radeon hd 6370m","6370",0,[[1366,768,25]]],["amd radeon hd 6380g","6380",0,[[1366,768,19]]],["amd radeon hd 6400","6400",0,[[1920,1080,13]]],["amd radeon hd 6400m","6400",0,[[1366,768,28]]],["amd radeon hd 6400m/7400m","6400",0,[[1366,768,28]]],["amd radeon hd 6410d","6410",0,[[1920,1080,11]]],["amd radeon hd 6450","6450",0,[[1920,1080,14]]],["amd radeon hd 6450 / r5 230","6450",0,[[1440,900,12]]],["amd radeon hd 6450 230","6450",0,[[1920,1080,15]]],["amd radeon hd 6470m","6470",0,[[1366,768,27],[1600,900,21]]],["amd radeon hd 6470m/7400m","6470",0,[[1366,768,44]]],["amd radeon hd 6480g","6480",0,[[1280,768,19],[1366,768,27],[1600,900,18]]],["amd radeon hd 6490m","6490",1,[[1366,768,-1],[1440,900,-1],[1680,1050,-1]]],["amd radeon hd 6500","6500",0,[[1920,1080,25]]],["amd radeon hd 6500m/5600","6500",0,[[1920,1080,27]]],["amd radeon hd 6510","6510",0,[[1600,900,32]]],["amd radeon hd 6520g","6520",0,[[1366,768,21],[1600,900,20]]],["amd radeon hd 6530d","6530",0,[[1366,768,31],[1440,900,36],[1920,1080,24]]],["amd radeon hd 6540","6540",0,[[1600,1200,13]]],["amd radeon hd 6550d","6550",0,[[1920,1080,28]]],["amd radeon hd 6570","6570",0,[[1920,1080,52],[2560,1440,17]]],["amd radeon hd 6620g","6620",0,[[1360,768,43],[1366,768,28]]],["amd radeon hd 6630m","6630",1,[[1366,768,-1],[1600,900,-1],[1920,1080,-1]]],["amd radeon hd 6630m/6650m/6750m/7670m/7690m","6630",1,[[1366,768,-1],[1920,1080,-1]]],["amd radeon hd 6650m","6650",0,[[1366,768,51],[1600,900,31]]],["amd radeon hd 6670","6670",0,[[1920,1080,55]]],["amd radeon hd 6700","6700",0,[[1920,1080,56]]],["amd radeon hd 6700 green","6700",0,[[1360,768,89]]],["amd radeon hd 6700m/7700m/7900m","6700",0,[[1366,768,59]]],["amd radeon hd 6730m/6770m","6730",0,[[1366,768,58],[1920,1080,46]]],["amd radeon hd 6730m/6770m/7690m xt","6730",0,[[1920,1080,48]]],["amd radeon hd 6750","6750",0,[[1440,900,72],[1920,1080,60]]],["amd radeon hd 6750m","6750",1,[[1440,900,-1],[1920,1080,-1],[1920,1200,-1]]],["amd radeon hd 6770","6770",0,[[1920,1080,60]]],["amd radeon hd 6770m","6770",1,[[1440,900,-1],[2560,1440,-1]]],["amd radeon hd 6770m opengl engine","6770",1,[[2560,1440,-1]]],["amd radeon hd 6790","6790",0,[[1920,1080,59]]],["amd radeon hd 6800","6800",0,[[1280,1024,89],[1920,1080,60]]],["amd radeon hd 6800m","6800",0,[[1600,900,18],[1920,1080,40]]],["amd radeon hd 6850","6850",0,[[1920,1080,59],[2560,1600,54]]],["amd radeon hd 6870","6870",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd 6900","6900",0,[[1920,1080,60]]],["amd radeon hd 6900m","6900",0,[[1920,1080,60]]],["amd radeon hd 6950","6950",0,[[1680,1050,60],[1920,1080,41]]],["amd radeon hd 6970","6970",0,[[1920,1080,60]]],["amd radeon hd 6970m","6970",1,[[2560,1440,-1]]],["amd radeon hd 6970m opengl engine","6970",1,[[2560,1440,-1]]],["amd radeon hd 6990","6990",0,[[1920,1080,60]]],["amd radeon hd 7000","7000",0,[[1920,1080,24]]],["amd radeon hd 7290","7290",0,[[1366,768,9]]],["amd radeon hd 7310","7310",0,[[1366,768,14]]],["amd radeon hd 7340","7340",0,[[1366,768,17],[1920,1080,10]]],["amd radeon hd 7340g","7340",0,[[1366,768,15]]],["amd radeon hd 7340m","7340",0,[[1366,768,15]]],["amd radeon hd 7350","7350",0,[[1920,1080,13]]],["amd radeon hd 7400","7400",0,[[1920,1080,18]]],["amd radeon hd 7400g","7400",0,[[963,768,31]]],["amd radeon hd 7400m","7400",0,[[1366,768,44]]],["amd radeon hd 7420g","7420",0,[[1366,768,28],[1600,900,26]]],["amd radeon hd 7450","7450",0,[[1920,1080,15]]],["amd radeon hd 7450a","7450",0,[[1920,1080,15]]],["amd radeon hd 7450m","7450",0,[[1366,768,30]]],["amd radeon hd 7470","7470",0,[[1680,1050,22],[1920,1080,144]]],["amd radeon hd 7470m","7470",0,[[1366,768,31],[1600,900,23]]],["amd radeon hd 7480d","7480",0,[[1280,1024,25],[1920,1080,24],[1920,1200,18]]],["amd radeon hd 7500","7500",0,[[1366,696,49],[1366,768,49]]],["amd radeon hd 7500g","7500",0,[[1366,768,26]]],["amd radeon hd 7500m/7600m","7500",0,[[1366,768,46]]],["amd radeon hd 7520g","7520",0,[[1366,768,33]]],["amd radeon hd 7520g + hd 7400m dual","7520",0,[[1366,768,34]]],["amd radeon hd 7520g + hd 7600m dual","7520",0,[[1366,768,31],[1600,900,41]]],["amd radeon hd 7540d","7540",0,[[1024,768,55],[1280,1024,44],[1920,1080,22]]],["amd radeon hd 7540d + hd 6670 dual","7540",0,[[1280,1024,36]]],["amd radeon hd 7550m/7650m","7550",0,[[1366,768,57]]],["amd radeon hd 7560d","7560",0,[[1920,1080,34]]],["amd radeon hd 7560d + hd 6570 dual","7560",0,[[1680,1050,44]]],["amd radeon hd 7560d + hd 6670 dual","7560",0,[[800,638,60]]],["amd radeon hd 7570","7570",0,[[1024,768,72],[1920,1080,52]]],["amd radeon hd 7570m","7570",0,[[1366,768,35]]],["amd radeon hd 7570m/hd 7670m","7570",0,[[1366,768,50],[1600,900,29]]],["amd radeon hd 7600","7600",0,[[1920,1080,60]]],["amd radeon hd 7600a","7600",0,[[1920,1080,28]]],["amd radeon hd 7600g","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + 7500m/7600m dual","7600",0,[[1366,768,19]]],["amd radeon hd 7600g + hd 8670m dual","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + hd dual","7600",0,[[1366,768,20]]],["amd radeon hd 7600m","7600",0,[[1366,768,56]]],["amd radeon hd 7600m/7700m","7600",0,[[1366,768,31]]],["amd radeon hd 7610m","7610",0,[[1366,768,43]]],["amd radeon hd 7620g","7620",0,[[1366,768,22],[1920,1080,19]]],["amd radeon hd 7640g","7640",0,[[1366,768,38]]],["amd radeon hd 7640g + 7470m dual","7640",0,[[1366,768,32]]],["amd radeon hd 7640g + 7600m dual","7640",0,[[1366,768,23]]],["amd radeon hd 7640g + 7670m dual","7640",0,[[1600,900,15]]],["amd radeon hd 7640g + 8500m dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7400m dual","7640",0,[[1366,768,37]]],["amd radeon hd 7640g + hd 7500 dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7670m dual","7640",0,[[1366,768,34]]],["amd radeon hd 7640g + hd 8500m dual","7640",0,[[1366,768,40]]],["amd radeon hd 7640g + hd 8570m dual","7640",0,[[1366,768,31]]],["amd radeon hd 7650a","7650",0,[[1680,1050,43],[1920,1080,15]]],["amd radeon hd 7650m","7650",0,[[1366,768,41],[1600,900,45]]],["amd radeon hd 7660d","7660",0,[[1680,1050,40],[1920,1008,60],[1920,1080,38]]],["amd radeon hd 7660d + hd 6570 dual","7660",0,[[1200,900,32]]],["amd radeon hd 7660d + hd 6670 dual","7660",0,[[1360,768,57],[1920,1080,53]]],["amd radeon hd 7660g","7660",0,[[1366,768,44],[1600,900,41],[1920,1080,34],[1920,1200,27]]],["amd radeon hd 7660g + 7600m dual","7660",0,[[1366,768,53],[1600,900,45]]],["amd radeon hd 7660g + 7670m dual","7660",0,[[1366,768,52]]],["amd radeon hd 7660g + 8670m dual","7660",0,[[1600,900,46]]],["amd radeon hd 7660g + hd 7600m dual","7660",0,[[1366,768,50]]],["amd radeon hd 7660g + hd 7670m dual","7660",0,[[1366,768,35]]],["amd radeon hd 7660g + hd 8600m dual","7660",0,[[1600,900,29]]],["amd radeon hd 7670","7670",0,[[1920,1080,39]]],["amd radeon hd 7670m","7670",0,[[1366,768,49],[1920,1080,36]]],["amd radeon hd 7700","7700",0,[[1400,1050,45],[1920,1080,60]]],["amd radeon hd 7700m","7700",0,[[1920,1080,54]]],["amd radeon hd 7730m","7730",0,[[1920,1080,57]]],["amd radeon hd 7750","7750",0,[[1280,1024,60],[1600,900,60],[1400,1050,98],[1920,1080,60],[3840,2160,23]]],["amd radeon hd 7750 / r7 250e","7750",0,[[2560,1080,69]]],["amd radeon hd 7750m","7750",0,[[1680,1050,57]]],["amd radeon hd 7770","7770",0,[[1920,1080,60]]],["amd radeon hd 7770 / r7 250x","7770",0,[[1680,1050,78]]],["amd radeon hd 7770 ghz","7770",0,[[1920,1080,78]]],["amd radeon hd 7790","7790",0,[[1920,1080,16]]],["amd radeon hd 7790 / r7 360 / r9 260/360","7790",0,[[1280,1024,131]]],["amd radeon hd 7800","7800",0,[[1920,1080,60]]],["amd radeon hd 7800m","7800",0,[[1920,1080,57]]],["amd radeon hd 7850","7850",0,[[1920,1080,60]]],["amd radeon hd 7850 / r7 265 / r9 270 1024sp","7850",0,[[1280,1024,87]]],["amd radeon hd 7870","7870",0,[[1920,1080,120],[2560,1440,60],[2560,1600,114],[3840,2160,30]]],["amd radeon hd 7870 ghz","7870",0,[[1920,1080,75]]],["amd radeon hd 7870 xt","7870",0,[[1920,1080,57],[3840,2160,53]]],["amd radeon hd 7870m","7870",0,[[1920,1080,22],[2732,1536,40]]],["amd radeon hd 7900","7900",0,[[2560,1600,59]]],["amd radeon hd 7950","7950",0,[[1920,1080,50]]],["amd radeon hd 7950 / r9 280","7950",0,[[1920,1080,59]]],["amd radeon hd 7950 oem / r9 280","7950",0,[[1920,1080,60]]],["amd radeon hd 7970","7970",0,[[1920,1080,60]]],["amd radeon hd 7970 / r9 280x","7970",0,[[1920,1080,193]]],["amd radeon hd 7970m","7970",0,[[1366,768,60],[1920,1080,60]]],["amd radeon hd 7970x/8970 280x","7970",0,[[1920,1080,60]]],["amd radeon hd 7990","7990",0,[[1920,1080,60],[5120,2880,63]]],["amd radeon hd 7xxx","7",0,[[1920,1080,60]]],["amd radeon hd 8180","8180",0,[[1366,768,10]]],["amd radeon hd 8200 / r3","8200",0,[[1366,768,21],[1600,900,13],[1680,1050,13]]],["amd radeon hd 8210","8210",0,[[1366,768,18]]],["amd radeon hd 8240","8240",0,[[1600,900,17]]],["amd radeon hd 8240 / r3","8240",0,[[1366,768,14]]],["amd radeon hd 8250","8250",0,[[1366,768,14],[1920,1200,10]]],["amd radeon hd 8280","8280",0,[[1600,900,60]]],["amd radeon hd 8280 / r3","8280",0,[[1366,768,22]]],["amd radeon hd 8280e","8280",0,[[2880,1620,6]]],["amd radeon hd 8330","8330",0,[[1366,768,24]]],["amd radeon hd 8350","8350",0,[[1920,1080,57]]],["amd radeon hd 8350g","8350",0,[[1366,768,18]]],["amd radeon hd 8370d","8370",0,[[1366,768,60],[1280,1024,26],[1920,1080,22]]],["amd radeon hd 8400","8400",0,[[1366,768,30],[1920,1080,16]]],["amd radeon hd 8400 / r3","8400",0,[[1360,768,19],[1366,768,22],[1920,1080,12]]],["amd radeon hd 8400e","8400",0,[[1680,1050,17],[1920,1080,16],[1920,1200,14]]],["amd radeon hd 8410g","8410",0,[[1366,768,32]]],["amd radeon hd 8450g","8450",0,[[1366,768,23]]],["amd radeon hd 8450g + hd 8750m dual","8450",0,[[1366,768,21]]],["amd radeon hd 8470","8470",0,[[1920,1080,17]]],["amd radeon hd 8470 + 7660d dual","8470",0,[[1920,1080,60]]],["amd radeon hd 8470d","8470",0,[[1280,1024,44],[1920,1080,21]]],["amd radeon hd 8470d + hd 6450 dual","8470",0,[[1600,900,37]]],["amd radeon hd 8490","8490",0,[[1920,1080,18],[1920,1200,20]]],["amd radeon hd 8500m","8500",0,[[1366,768,41],[1920,1080,19]]],["amd radeon hd 8500m/8700m","8500",0,[[1920,1080,30]]],["amd radeon hd 8510g","8510",0,[[1366,768,29],[1920,1080,17]]],["amd radeon hd 8550","8550",0,[[1920,1080,25]]],["amd radeon hd 8550g","8550",0,[[1366,768,34],[1600,900,41],[1920,1080,34]]],["amd radeon hd 8550g + 8500m dual","8550",0,[[1366,768,42]]],["amd radeon hd 8550g + 8600 dual","8550",0,[[1920,1080,27]]],["amd radeon hd 8550g + hd 8570m dual","8550",0,[[1366,768,32]]],["amd radeon hd 8550g + hd 8600 dual","8550",0,[[1366,768,60]]],["amd radeon hd 8550g + hd 8750m dual","8550",0,[[1366,768,37]]],["amd radeon hd 8550g + r5 m230 dual","8550",0,[[1366,768,29]]],["amd radeon hd 8570","8570",0,[[1280,1024,60],[1680,1050,54],[1920,1080,50]]],["amd radeon hd 8570 / r5 430 / r7 240 / radeon 520","8570",0,[[1920,1080,25]]],["amd radeon hd 8570d","8570",0,[[1920,1080,16]]],["amd radeon hd 8570d + r7 240 dual","8570",0,[[1920,1080,45]]],["amd radeon hd 8570m","8570",0,[[1366,768,40]]],["amd radeon hd 8600","8600",0,[[1366,768,41]]],["amd radeon hd 8600m","8600",0,[[1366,768,42],[1920,1080,14]]],["amd radeon hd 8610g","8610",0,[[1366,768,31],[1920,1080,16]]],["amd radeon hd 8610g + 8600m dual","8610",0,[[1366,768,22]]],["amd radeon hd 8610g + hd 8600m dual","8610",0,[[1366,768,41]]],["amd radeon hd 8610g + hd 8670m dual","8610",0,[[1366,768,33]]],["amd radeon hd 8650g","8650",0,[[1360,768,44],[1366,768,44]]],["amd radeon hd 8650g + 8500m dual","8650",0,[[1366,768,35]]],["amd radeon hd 8650g + 8600 dual","8650",0,[[1920,1080,38]]],["amd radeon hd 8650g + 8600m dual","8650",0,[[1366,768,21]]],["amd radeon hd 8650g + 8670m dual","8650",0,[[1366,768,66]]],["amd radeon hd 8650g + 8750m dual","8650",0,[[1920,1080,28]]],["amd radeon hd 8650g + hd 7600m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8500m dual","8650",0,[[1366,768,23]]],["amd radeon hd 8650g + hd 8570m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8600m dual","8650",0,[[1366,768,46],[1600,900,29]]],["amd radeon hd 8650g + hd 8750m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + r5 m200 dual","8650",0,[[1366,768,35]]],["amd radeon hd 8670 / r7 250","8670",0,[[1024,768,1]]],["amd radeon hd 8670a/8670m/8690m","8670",0,[[1366,768,47]]],["amd radeon hd 8670a/8670m/8750m","8670",0,[[1366,768,60]]],["amd radeon hd 8670d","8670",0,[[1024,768,45],[1280,1024,69],[1920,1080,38]]],["amd radeon hd 8670d + 7700 dual","8670",0,[[1680,1050,58]]],["amd radeon hd 8670d + hd 6670 dual","8670",0,[[1680,1050,33]]],["amd radeon hd 8670d + r5 200 dual","8670",0,[[2560,1080,14]]],["amd radeon hd 8670d + r7 200 dual","8670",0,[[1920,1080,37]]],["amd radeon hd 8670m","8670",0,[[1366,768,41]]],["amd radeon hd 8690a","8690",0,[[1920,1080,31]]],["amd radeon hd 8690m","8690",0,[[1600,900,35]]],["amd radeon hd 8700m","8700",0,[[1366,768,60]]],["amd radeon hd 8730m","8730",0,[[1366,768,59]]],["amd radeon hd 8750m","8750",0,[[1366,768,60]]],["amd radeon hd 8770","8770",0,[[1920,1080,111]]],["amd radeon hd 8790m","8790",0,[[1600,900,78],[1920,1080,60]]],["amd radeon hd 8800m","8800",0,[[1920,1080,60],[2880,1800,45]]],["amd radeon hd 8830m","8830",0,[[1920,1080,82]]],["amd radeon hd 8850m","8850",0,[[1366,768,45]]],["amd radeon hd 8870m","8870",0,[[1280,1024,60],[1600,900,60]]],["amd radeon hd 8950","8950",0,[[1920,1080,60],[1920,1200,59]]],["amd radeon hd 8970","8970",0,[[2560,1600,60]]],["amd radeon hd 8970m","8970",0,[[1920,1080,146],[1920,1200,60]]],["amd radeon hd 8xxx","8",0,[[1920,1080,120],[2560,1440,58]]],["amd radeon hd5450","5450",0,[[1280,720,24]]],["amd radeon hd6870","6870",0,[[1920,1080,60]]],["amd radeon hd7970m","7970",0,[[2560,1440,116]]],["amd radeon hd8530m","8530",0,[[1366,768,40]]],["amd radeon hd8730","8730",0,[[1680,1050,42]]],["amd radeon hd8970m","8970",0,[[1920,1080,74]]],["amd radeon hybrid","",0,[[1366,768,27]]],["amd radeon infoshock rx 460","460",0,[[1360,768,102]]],["amd radeon instinct mi25","25",0,[[1920,1200,26]]],["amd radeon instinct mi25 mxgpu","25",0,[[1920,1080,20],[1920,1200,32]]],["amd radeon m535dx","535",0,[[1366,768,58]]],["amd radeon navi14","14",0,[[3840,2160,60]]],["amd radeon polaris","",0,[[3840,2160,60],[5120,2880,44]]],["amd radeon polaris 10","10",0,[[1920,1200,60]]],["amd radeon pro","pro",0,[[1920,1080,114]]],["amd radeon pro 270x","270",0,[[2560,1440,74]]],["amd radeon pro 450","450",0,[[1920,1080,30],[2880,1800,43],[3360,2100,36],[5120,2880,30]]],["amd radeon pro 450 opengl engine","450",0,[[1920,1200,60]]],["amd radeon pro 455","455",0,[[2879,1800,54],[2880,1800,48],[3360,2100,37]]],["amd radeon pro 455 opengl engine","455",0,[[3360,2100,36]]],["amd radeon pro 460","460",0,[[2880,1800,50],[3360,2100,42]]],["amd radeon pro 460 opengl engine","460",0,[[5760,3240,15]]],["amd radeon pro 470","470",0,[[6016,3384,49]]],["amd radeon pro 480","480",0,[[1920,1080,60]]],["amd radeon pro 5300","5300",0,[[5120,2880,60]]],["amd radeon pro 5300m","5300",0,[[1920,1080,214],[3584,2240,130]]],["amd radeon pro 5500 xt","5500",0,[[5120,2880,51]]],["amd radeon pro 5500m","5500",0,[[3072,1920,60],[3584,2240,139]]],["amd radeon pro 555","555",0,[[2879,1800,54],[2880,1800,36],[3360,2100,40]]],["amd radeon pro 555x","555",0,[[2880,1800,42],[3360,2100,39]]],["amd radeon pro 560","560",0,[[2879,1800,56],[2880,1800,56],[3360,2100,42]]],["amd radeon pro 5600m","5600",0,[[3072,1920,60],[3584,2240,60]]],["amd radeon pro 560x","560",0,[[2879,1800,59],[2880,1800,71],[3360,2100,43]]],["amd radeon pro 570","570",0,[[5120,2880,48]]],["amd radeon pro 570 opengl engine","570",0,[[5120,2880,46]]],["amd radeon pro 5700","5700",0,[[5120,2880,60]]],["amd radeon pro 5700 xt","5700",0,[[5120,2880,60]]],["amd radeon pro 570x","570",0,[[5120,2880,50]]],["amd radeon pro 575","575",0,[[4096,2304,60],[5120,2880,50]]],["amd radeon pro 575 opengl engine","575",0,[[5120,2880,48]]],["amd radeon pro 575x","575",0,[[5120,2880,56]]],["amd radeon pro 580","580",0,[[5120,2880,54]]],["amd radeon pro 580 opengl engine","580",0,[[5120,2880,50]]],["amd radeon pro 580x","580",0,[[5120,2880,52]]],["amd radeon pro duo","pro",0,[[1920,1080,234],[1800,1350,59],[3840,2160,82],[4096,2160,60]]],["amd radeon pro rx 560","560",0,[[2560,1080,60]]],["amd radeon pro ssg","pro",0,[[3440,1440,125]]],["amd radeon pro v340","340",0,[[1920,1080,112]]],["amd radeon pro v520 mxgpu","520",0,[[1920,1080,271]]],["amd radeon pro v7350x2","7350",0,[[1920,1080,60]]],["amd radeon pro vega 16","16",0,[[2879,1800,60],[3360,2100,60]]],["amd radeon pro vega 20","20",0,[[2880,1800,120],[3360,2100,121],[3840,2160,30]]],["amd radeon pro vega 48","48",0,[[5120,2880,86]]],["amd radeon pro vega 56","56",0,[[1920,1080,60],[5120,2880,60]]],["amd radeon pro vega 56 opengl engine","56",0,[[5120,2880,60]]],["amd radeon pro vega 64","64",0,[[5120,2880,60]]],["amd radeon pro vega 64 opengl engine","64",0,[[5120,2880,60]]],["amd radeon pro vega 64x","64",0,[[2560,1440,206],[4096,2304,60],[5120,2880,60]]],["amd radeon pro vega ii","proii",0,[[3840,1600,60],[5120,2880,60]]],["amd radeon pro vega ii duo","proii",0,[[2560,1440,239],[5120,2880,60]]],["amd radeon pro w5500","5500",0,[[1920,1080,195],[3840,2160,59],[7680,3240,56]]],["amd radeon pro w5500m","5500",0,[[1920,1080,60]]],["amd radeon pro w5500x","5500",0,[[1920,1200,60]]],["amd radeon pro w5700","5700",0,[[1680,1050,253],[5120,1440,120],[3840,2160,60]]],["amd radeon pro w5700x","5700",0,[[3840,2160,60]]],["amd radeon pro w6600","6600",0,[[1920,1200,60],[3840,2160,166]]],["amd radeon pro w6600m","6600",0,[[1920,1080,60]]],["amd radeon pro w6800","6800",0,[[1920,1080,60],[3840,2160,237]]],["amd radeon pro w6800x","6800",0,[[6016,3384,60]]],["amd radeon pro w6800x duo","6800",0,[[3840,1600,60],[5120,2880,45]]],["amd radeon pro w6900x","6900",0,[[3840,2160,60]]],["amd radeon pro wx","pro",0,[[2560,1080,69]]],["amd radeon pro wx 2100","2100",0,[[1280,1024,145],[1920,1080,60]]],["amd radeon pro wx 3100","3100",0,[[1919,1080,58],[1920,1080,123],[2560,1440,82]]],["amd radeon pro wx 3200","3200",0,[[2560,1440,92]]],["amd radeon pro wx 4100","4100",0,[[1920,1080,60],[1920,1200,60],[3840,2160,30],[5120,2880,18]]],["amd radeon pro wx 4130","4130",0,[[1920,1080,60],[3840,2160,30]]],["amd radeon pro wx 4150","4150",0,[[1920,1080,56],[3840,2160,37],[4096,2160,34]]],["amd radeon pro wx 5100","5100",0,[[1920,1080,60],[2560,1440,91],[3840,2160,55]]],["amd radeon pro wx 5100 opengl engine","5100",0,[[2560,1440,60]]],["amd radeon pro wx 7100","7100",0,[[1920,1080,122],[2560,1080,58],[3840,2160,60],[5120,2880,60]]],["amd radeon pro wx 7100 mobile","7100",0,[[2560,1440,60]]],["amd radeon pro wx 7100 opengl engine","7100",0,[[3840,2160,60]]],["amd radeon pro wx 8200","8200",0,[[3440,1440,124]]],["amd radeon pro wx 9100","9100",0,[[1920,1080,60],[4096,2160,101]]],["amd radeon pro wx 9100 opengl engine","9100",0,[[1920,1080,60]]],["amd radeon pro wx vega m gl","prom",0,[[3840,2160,14]]],["amd radeon pro wx3200","3200",0,[[1920,1080,55]]],["amd radeon pro wx9100","9100",0,[[2560,1440,60]]],["amd radeon r2","2",0,[[1366,768,13],[1600,900,14]]],["amd radeon r2e","2",0,[[1366,768,16],[1920,1080,45],[3840,2160,4]]],["amd radeon r3","3",0,[[1366,768,17],[1920,1080,15]]],["amd radeon r4","4",0,[[1366,768,19],[1920,1080,13]]],["amd radeon r4e","4",0,[[3840,2160,6]]],["amd radeon r5","5",0,[[1024,768,38],[1360,768,25],[1366,768,21],[1280,1024,33],[1920,1080,14],[3200,1800,7]]],["amd radeon r5 220","5",0,[[1366,768,19],[1920,1080,12]]],["amd radeon r5 230","5",0,[[1920,1080,21]]],["amd radeon r5 235","5",0,[[1920,1080,17]]],["amd radeon r5 240","5",0,[[1280,1024,34],[1920,1080,24]]],["amd radeon r5 340","5",0,[[1920,1080,27]]],["amd radeon r5 340x","5",0,[[1920,1080,31]]],["amd radeon r5 430","5",0,[[1280,1024,31],[1680,1050,54],[1920,1080,54]]],["amd radeon r5 435","5",0,[[1920,1080,30]]],["amd radeon r5 m200","5",0,[[1600,900,45],[1920,1080,20]]],["amd radeon r5 m200 / hd 8500m","5",0,[[1366,768,31],[1920,1080,24]]],["amd radeon r5 m230","5",0,[[1366,768,37]]],["amd radeon r5 m240","5",0,[[1366,768,42],[1920,1080,23]]],["amd radeon r5 m255","5",0,[[1366,768,59],[1600,900,33]]],["amd radeon r5 m315","5",0,[[1366,768,45]]],["amd radeon r5 m320","5",0,[[1920,1080,19]]],["amd radeon r5 m330","5",0,[[1366,768,27],[1920,1080,26]]],["amd radeon r5 m335","5",0,[[1366,768,55],[1920,1080,19]]],["amd radeon r5 m420","5",0,[[1366,768,49]]],["amd radeon r5 m430","5",0,[[1366,768,36],[1920,1080,20]]],["amd radeon r5 m435","5",0,[[1920,1080,41],[2560,1440,67]]],["amd radeon r5 m445","5",0,[[1920,1080,32]]],["amd radeon r5e","5",0,[[1600,768,14],[1920,1080,16]]],["amd radeon r6","6",0,[[1366,768,30],[1280,1024,23],[1920,1080,12]]],["amd radeon r6 m255dx","6",0,[[1366,768,25]]],["amd radeon r6 m340dx","6",0,[[1366,768,31],[1920,1080,15]]],["amd radeon r6e","6",0,[[3840,2160,5]]],["amd radeon r7","7",0,[[1366,768,35],[1280,1024,31],[1680,1050,39],[1920,1080,12],[1920,1200,16],[2560,1080,15],[2560,1440,21],[3840,2160,8]]],["amd radeon r7 200","7",0,[[1280,1024,45],[1920,1080,120]]],["amd radeon r7 200 series","7",0,[[1920,1080,43]]],["amd radeon r7 240","7",0,[[1920,1080,29]]],["amd radeon r7 240 + hd 8570d dual","7",0,[[1920,1080,43]]],["amd radeon r7 250","7",0,[[1920,1080,49]]],["amd radeon r7 250e","7",0,[[1920,1080,60]]],["amd radeon r7 250x","7",0,[[1920,1080,60]]],["amd radeon r7 260x","7",0,[[1920,1080,56]]],["amd radeon r7 260x/360","7",0,[[1920,1200,102]]],["amd radeon r7 350","7",0,[[1024,768,60],[1280,1024,79],[1920,1080,59]]],["amd radeon r7 350x","7",0,[[1920,1080,50]]],["amd radeon r7 360","7",0,[[1920,1048,60],[1920,1080,102]]],["amd radeon r7 360 / r9 360","7",0,[[1920,1080,60]]],["amd radeon r7 370","7",0,[[1600,900,60],[1920,1080,75]]],["amd radeon r7 370 / r9 270","7",0,[[1920,1080,74]]],["amd radeon r7 370 / r9 270x/370","7",0,[[1600,900,115],[1920,1080,60]]],["amd radeon r7 370 / r9 270x/370x","7",0,[[1920,1080,115]]],["amd radeon r7 370 series","7",0,[[1920,1080,212],[3840,2160,60]]],["amd radeon r7 430","7",0,[[1920,1080,55],[3840,2160,10]]],["amd radeon r7 450","7",0,[[1920,1080,60]]],["amd radeon r7 a360","7",0,[[1920,1080,28]]],["amd radeon r7 graphics + hd 7700 dual","7",0,[[1600,1200,72]]],["amd radeon r7 graphics + r5 340 dual","7",0,[[1920,1080,47]]],["amd radeon r7 graphics + r7 200 dual","7",0,[[1920,1080,45],[1920,1200,47]]],["amd radeon r7 graphics + r7 350 dual","7",0,[[1919,1080,60]]],["amd radeon r7 m260","7",0,[[1600,900,44],[1920,1080,13]]],["amd radeon r7 m260dx","7",0,[[1366,768,46],[1920,1080,18]]],["amd radeon r7 m260x","7",0,[[1920,1080,29]]],["amd radeon r7 m265","7",0,[[1366,768,48],[1920,1080,27]]],["amd radeon r7 m270","7",0,[[1920,1080,31],[3840,2160,10]]],["amd radeon r7 m340","7",0,[[1366,768,60],[1920,1080,32]]],["amd radeon r7 m350","7",0,[[3840,2160,12]]],["amd radeon r7 m360","7",0,[[1366,768,40],[1920,1080,22]]],["amd radeon r7 m370","7",0,[[1920,1080,24]]],["amd radeon r7 m440","7",0,[[1920,1080,39]]],["amd radeon r7 m445","7",0,[[1920,1080,36]]],["amd radeon r7 m460","7",0,[[1919,1080,24],[1920,1080,29]]],["amd radeon r7 m520","7",0,[[1919,1080,17]]],["amd radeon r7 series / hd 9000","7",0,[[1920,1080,71],[2560,1080,59]]],["amd radeon r7e","7",0,[[1024,768,41]]],["amd radeon r8 m350dx","8",0,[[1366,768,30]]],["amd radeon r8 m365dx","8",0,[[1920,1080,28]]],["amd radeon r8 m435dx","8",0,[[1920,1080,22]]],["amd radeon r8 m445dx","8",0,[[1366,768,38],[1920,1080,27]]],["amd radeon r8 m535dx","8",0,[[1366,768,55]]],["amd radeon r9","9",0,[[1920,1080,60]]],["amd radeon r9 200","9",0,[[1920,1080,60]]],["amd radeon r9 200 / hd 7900","9",0,[[1920,1080,250]]],["amd radeon r9 255","9",0,[[1600,900,52],[1920,1080,51]]],["amd radeon r9 260","9",0,[[1920,1080,16]]],["amd radeon r9 270","9",0,[[1280,1024,60],[1920,1080,60]]],["amd radeon r9 270 1024sp","9",0,[[1920,1080,135]]],["amd radeon r9 270x","9",0,[[1920,1080,30]]],["amd radeon r9 280","9",0,[[1920,1080,75],[1920,1200,428],[2560,1440,60]]],["amd radeon r9 280,","9",0,[[5120,2880,39]]],["amd radeon r9 280x","9",0,[[1920,1080,137]]],["amd radeon r9 285","9",0,[[1920,1080,60],[1920,1200,129]]],["amd radeon r9 290","9",0,[[1920,1080,60]]],["amd radeon r9 290x","9",0,[[1920,1080,60],[2560,1440,60],[3840,2160,118]]],["amd radeon r9 300","9",0,[[1920,1080,59]]],["amd radeon r9 350","9",0,[[1920,1200,63]]],["amd radeon r9 360","9",0,[[1600,900,83],[1920,1080,60],[2560,1440,59]]],["amd radeon r9 370","9",0,[[1680,1050,205],[1920,1080,60],[3840,2160,49]]],["amd radeon r9 370x","9",0,[[1920,1080,60]]],["amd radeon r9 380","9",0,[[1920,1080,41],[2560,1440,75]]],["amd radeon r9 380x","9",0,[[2560,1600,60]]],["amd radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["amd radeon r9 390x","9",0,[[2560,1440,60],[3840,2160,60]]],["amd radeon r9 a375","9",0,[[1920,1080,28]]],["amd radeon r9 fury","9",0,[[1920,1080,75],[3840,2160,133]]],["amd radeon r9 fury / nano","9",0,[[1920,1200,155]]],["amd radeon r9 m200x","9",0,[[1366,768,104],[1920,1080,60]]],["amd radeon r9 m265x","9",0,[[1920,1080,33]]],["amd radeon r9 m270x","9",0,[[1600,900,60],[1920,1080,68]]],["amd radeon r9 m275","9",0,[[1920,1080,29]]],["amd radeon r9 m275x","9",0,[[1920,1080,20]]],["amd radeon r9 m280x","9",0,[[1920,1080,60],[2560,1440,25]]],["amd radeon r9 m290","9",0,[[5120,2880,33]]],["amd radeon r9 m290x","9",0,[[1920,1080,60],[3840,2160,61],[5120,2880,33]]],["amd radeon r9 m295x","9",0,[[3840,2160,33],[5120,2880,36]]],["amd radeon r9 m295x mac","9",0,[[5120,2880,42]]],["amd radeon r9 m295x mac edition / r9 380x","9",0,[[1920,1080,128]]],["amd radeon r9 m360","9",0,[[1920,1080,60],[3840,2160,26]]],["amd radeon r9 m370x","9",0,[[2560,1440,30],[2880,1800,27]]],["amd radeon r9 m370x opengl engine","9",0,[[5120,2880,14]]],["amd radeon r9 m375","9",0,[[1920,1080,29]]],["amd radeon r9 m375x","9",0,[[1920,1080,60],[3840,2160,22]]],["amd radeon r9 m380","9",0,[[1920,1080,50],[3840,2160,8],[5120,2880,9]]],["amd radeon r9 m380 opengl engine","9",0,[[5120,2880,15]]],["amd radeon r9 m385","9",0,[[1920,1080,58]]],["amd radeon r9 m385x","9",0,[[1920,1080,60]]],["amd radeon r9 m390","9",0,[[5119,2879,29],[5120,2880,21],[5760,3240,32]]],["amd radeon r9 m390 opengl engine","9",0,[[5120,2880,27]]],["amd radeon r9 m390x","9",0,[[1920,1080,140]]],["amd radeon r9 m395","9",0,[[2560,1440,59],[5120,2880,19]]],["amd radeon r9 m395 opengl engine","9",0,[[5120,2880,38]]],["amd radeon r9 m395x","9",0,[[3840,2160,58],[5120,2880,36]]],["amd radeon r9 m395x opengl engine","9",0,[[5120,2880,35]]],["amd radeon r9 m470","9",0,[[3840,2160,29]]],["amd radeon r9 m470x","9",0,[[1920,1080,60]]],["amd radeon r9-290x","9",0,[[1920,1080,60]]],["amd radeon renoir graphics d1","1",0,[[1366,768,60]]],["amd radeon rro 580x","580",0,[[5120,2880,59]]],["amd radeon rx 460","460",0,[[1920,1080,55],[2560,1080,60],[3840,2160,31]]],["amd radeon rx 460 / pro 450/455/460/555/555x/560/560x","460",0,[[3440,1440,93]]],["amd radeon rx 460 / pro 450/455/460/560","460",0,[[1920,1080,72]]],["amd radeon rx 470","470",0,[[1280,1024,73],[1920,1080,58],[1920,1200,147],[3840,2160,51]]],["amd radeon rx 470 opengl engine","470",0,[[2560,1440,60]]],["amd radeon rx 475m","475",0,[[1920,1080,60]]],["amd radeon rx 480","480",0,[[1400,1050,267],[1920,1080,60],[2560,1080,71]]],["amd radeon rx 480 opengl engine","480",0,[[1920,1080,60]]],["amd radeon rx 5300m","5300",0,[[1920,1080,60],[3840,2160,60]]],["amd radeon rx 540","540",0,[[1919,1080,52],[1920,1080,36]]],["amd radeon rx 550","550",0,[[1280,1024,135],[1920,1080,60],[1920,1200,60],[6016,3384,15]]],["amd radeon rx 550 640sp / rx 560","550",0,[[1920,1080,60]]],["amd radeon rx 5500","5500",0,[[1920,1080,139]]],["amd radeon rx 5500 / pro 5500m","5500",0,[[1920,1080,60],[2560,1440,227]]],["amd radeon rx 5500 xt","5500",0,[[1920,1080,239]]],["amd radeon rx 5500m","5500",0,[[1920,1048,144],[1920,1080,144],[3840,2160,60]]],["amd radeon rx 550x","550",0,[[1920,1080,52]]],["amd radeon rx 560","560",0,[[1920,1080,60],[1920,1200,42],[2560,1440,60]]],["amd radeon rx 560 [baffin]","560",0,[[1920,1080,60]]],["amd radeon rx 5600 oem/5600 xt / 5700 xt","5600",0,[[1920,1080,360],[2560,1440,164]]],["amd radeon rx 5600 xt","5600",0,[[1920,1080,75]]],["amd radeon rx 5600m","5600",0,[[1920,1080,144]]],["amd radeon rx 560d","560",0,[[2560,1080,60]]],["amd radeon rx 560x","560",0,[[1920,1080,115],[3840,2160,35]]],["amd radeon rx 570","570",0,[[1920,1080,60],[3072,1728,60]]],["amd radeon rx 570 opengl engine","570",0,[[1920,1080,226]]],["amd radeon rx 5700","5700",0,[[1920,1080,144]]],["amd radeon rx 5700 / 5700 xt","5700",0,[[3840,2160,201]]],["amd radeon rx 5700 xt","5700",0,[[1920,1080,464],[3840,2160,60],[6016,3384,34]]],["amd radeon rx 5700 xt 50th anniversary","5700",0,[[2560,1440,144],[3840,1600,60],[3840,2160,222],[5120,2880,60]]],["amd radeon rx 5700xt","5700",0,[[1920,1080,369]]],["amd radeon rx 580","580",0,[[1920,1080,60],[1920,1200,97],[2560,1440,60],[3840,2160,60]]],["amd radeon rx 580 2048sp","580",0,[[1920,1080,60]]],["amd radeon rx 580 opengl engine","580",0,[[1920,1080,145]]],["amd radeon rx 580 special","580",0,[[2560,1440,60]]],["amd radeon rx 580x","580",0,[[1920,1200,60],[3840,2160,79]]],["amd radeon rx 590","590",0,[[1920,1080,75],[2560,1440,164],[3584,2240,60]]],["amd radeon rx 640","640",0,[[1920,1080,39]]],["amd radeon rx 6500 xt","6500",0,[[1920,1080,60]]],["amd radeon rx 6600","6600",0,[[1920,1080,433],[3840,2160,57]]],["amd radeon rx 6600 xt","6600",0,[[1920,1080,60]]],["amd radeon rx 6600 xt/6600m","6600",0,[[2560,1440,60]]],["amd radeon rx 6600m","6600",0,[[1920,1080,139]]],["amd radeon rx 6700 xt","6700",0,[[1920,1080,451]]],["amd radeon rx 6700 xt / 6800m","6700",0,[[2560,1440,144]]],["amd radeon rx 6700m","6700",0,[[1920,1080,240]]],["amd radeon rx 6800","6800",0,[[2560,1440,564],[3840,2160,60]]],["amd radeon rx 6800 xt","6800",0,[[2560,1440,446],[3440,1440,144],[3840,2160,60]]],["amd radeon rx 6800 xt / 6900 xt","6800",0,[[2560,1440,239]]],["amd radeon rx 6800 xt 16gb","6800",0,[[6400,2666,60]]],["amd radeon rx 6800m","6800",0,[[1920,1080,300]]],["amd radeon rx 6900 xt","6900",0,[[3840,2160,60]]],["amd radeon rx rx 560","560",0,[[1920,1080,60]]],["amd radeon rx vega","rx",0,[[1920,1080,39]]],["amd radeon rx vega 10","10",0,[[1920,1080,38]]],["amd radeon rx vega 11","11",0,[[1920,1080,35]]],["amd radeon rx vega 56","56",0,[[1920,1080,144],[3440,1440,60],[3840,2160,60]]],["amd radeon rx vega 56 8gb","56",0,[[2560,1600,60]]],["amd radeon rx vega 56 opengl engine","56",0,[[2560,1440,60]]],["amd radeon rx vega 64","64",0,[[2560,1440,518]]],["amd radeon rx vega 64 8gb","64",0,[[2560,1440,60]]],["amd radeon rx vega 64 opengl engine","64",0,[[3840,2160,119]]],["amd radeon rx vega 64.1","64",0,[[6016,3384,60]]],["amd radeon rx vega 8","8",0,[[1920,1080,53]]],["amd radeon rx vega m gh","rxm",0,[[1920,1080,60],[2560,1440,60],[3840,2160,51]]],["amd radeon rx vega m gl","rxm",0,[[2560,1440,567],[3840,2160,59]]],["amd radeon rx vega11","11",0,[[2496,1664,30]]],["amd radeon rx460","460",0,[[1920,1080,60]]],["amd radeon rx480","480",0,[[1920,1080,102],[2560,1080,71]]],["amd radeon rx540","540",0,[[2400,1800,37]]],["amd radeon rx550","550",0,[[1920,1080,60]]],["amd radeon rx560","560",0,[[1920,1080,93]]],["amd radeon rx5600","5600",0,[[3840,2160,129]]],["amd radeon rx570","570",0,[[5120,2880,59]]],["amd radeon rx5700","5700",0,[[1920,1080,60]]],["amd radeon rx580","580",0,[[1920,1080,60]]],["amd radeon rx590 gme","590",0,[[1920,1080,112]]],["amd radeon rx6600xt","6600",0,[[3840,2160,60]]],["amd radeon sky 500","500",0,[[4096,2160,34]]],["amd radeon vega","",0,[[5120,2880,32]]],["amd radeon vega 10","10",0,[[1920,1080,44]]],["amd radeon vega 10 mobile","10",0,[[1920,1080,30]]],["amd radeon vega 11","11",0,[[1280,1024,60],[1920,1080,60],[3840,2160,17]]],["amd radeon vega 2","2",0,[[1366,768,30]]],["amd radeon vega 3","3",0,[[1440,900,44],[1920,1080,29],[3840,2160,8]]],["amd radeon vega 3 mobile","3",0,[[1920,1080,30]]],["amd radeon vega 56","56",0,[[2560,1440,144]]],["amd radeon vega 6","6",0,[[1366,768,61],[1920,1080,23]]],["amd radeon vega 64","64",0,[[6016,3384,35]]],["amd radeon vega 64 lc","64",0,[[2560,1080,60]]],["amd radeon vega 8","8",0,[[1920,1080,35],[2560,1440,24],[4096,2160,15]]],["amd radeon vega 8 mobile","8",0,[[1920,1080,36]]],["amd radeon vega 9","9",0,[[2496,1663,32],[2496,1664,39]]],["amd radeon vega fe","fe",0,[[1920,1080,120],[2560,1440,60]]],["amd radeon vega frontier","",0,[[1920,1080,120],[3840,2160,60]]],["amd radeon vega frontier edition opengl engine","",0,[[3440,1440,60]]],["amd radeon vega series / radeon vega mobile","",0,[[1920,1080,67]]],["amd radeon vii","vii",0,[[1920,1080,468],[2560,1440,60],[3840,2160,60]]],["amd radeont 540x","540",0,[[1920,1080,74],[3840,2160,22]]],["amd radeont rx 5300","5300",0,[[1920,1080,60]]],["amd radeont rx 5500m","5500",0,[[1920,1080,303]]],["amd radeont rx 560x","560",0,[[1920,1080,60]]],["amd renoir","",0,[[1920,1080,60]]],["amd rx 480","480",0,[[1680,1050,119]]],["amd rx 560","560",0,[[5120,2880,37]]],["amd rx 5700xt","5700",0,[[3840,2160,60]]],["amd rx 580","580",0,[[1920,1200,60],[5120,2880,60]]],["amd rx 590","590",0,[[5120,2880,60]]],["amd rx vega 64","64",0,[[1920,1080,60]]],["amd rx xxx","xxx",0,[[1920,1080,60],[2560,1440,144]]],["amd saphire radeon rx 580","580",0,[[1920,1080,57]]],["amd sapphire hd 5770","5770",0,[[1440,900,60]]],["amd sapphire nitro+ rx 6800","6800",0,[[1920,1080,75]]],["amd sapphire radeon hd6870","6870",0,[[1680,1050,60]]],["amd sapphire radeon rx 560","560",0,[[1280,1024,60]]],["amd sapphire radeon rx vega 64 8gb","64",0,[[2560,1440,144]]],["amd tonga pro gl [firepro w7100]","7100",0,[[1920,1200,127]]],["amd video controller","",0,[[1919,1079,60],[1920,1080,291]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["radeong 0.4 on amd polaris10","0",0,[[3840,2160,109]]],["radeong 0.4 on amd tahiti","0",0,[[1920,1080,223]]]]\')},732:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a14","14",0,[[2704,1756,120]]],["apple m1","1",0,[[2880,1800,60]]],["apple m1 max","1",0,[[3456,2234,120]]],["apple m1 pro","1",0,[[3024,1964,120]]],["apple paravirtual device","",0,[[1024,768,30]]]]\')},405:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel geforce gtx 960","960",0,[[1920,1080,26]]],["nvidia asus geforce gt 430","430",0,[[1366,768,35]]],["nvidia asus geforce gt 440","440",0,[[1920,1080,28]]],["nvidia asus geforce gt 520","520",0,[[1680,1050,12]]],["nvidia asus geforce gt 610","610",0,[[1920,1200,15]]],["nvidia asus geforce gt 630","630",0,[[1680,1050,41]]],["nvidia asus geforce gt 640","640",0,[[2560,1440,34]]],["nvidia asus geforce gt 710","710",0,[[1920,1080,31]]],["nvidia asus geforce gt 730","730",0,[[2560,1080,28],[3840,2160,12]]],["nvidia asus geforce gts 450","450",0,[[1920,1080,54]]],["nvidia asus geforce gtx 1060","1060",0,[[3840,2160,38]]],["nvidia asus geforce gtx 1080","1080",0,[[2560,1440,120]]],["nvidia asus geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia asus geforce gtx 480","480",0,[[1920,1080,59]]],["nvidia asus geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia asus geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia asus geforce gtx 560 se","560",0,[[1920,1080,59]]],["nvidia asus geforce gtx 560 ti","560",0,[[1680,1050,58]]],["nvidia asus geforce gtx 570","570",0,[[1280,1024,74]]],["nvidia asus geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia asus geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia asus geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia asus geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia asus geforce gtx 750 ti","750",0,[[1360,768,59],[1920,1080,118]]],["nvidia asus geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia asus geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia asus geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia asus geforce gtx 950","950",0,[[1920,1080,60]]],["nvidia asus geforce gtx 960","960",0,[[1920,1080,60],[2560,1600,117]]],["nvidia asus geforce gtx 970","970",0,[[2560,1600,60]]],["nvidia asus geforce gtx 980 ti","980",0,[[2560,1440,131]]],["nvidia colorful geforce gtx 960","960",0,[[2560,1440,60]]],["nvidia elitegroup geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia evga geforce gt 545","545",0,[[1920,1080,37]]],["nvidia evga geforce gt 640","640",0,[[1366,768,60]]],["nvidia evga geforce gt 710","710",0,[[1680,1050,36],[1920,1080,29]]],["nvidia evga geforce gt 730","730",0,[[1600,900,59]]],["nvidia evga geforce gt 740","740",0,[[1280,1024,45]]],["nvidia evga geforce gtx 1050 ti","1050",0,[[2560,1440,60],[4096,2304,58]]],["nvidia evga geforce gtx 1070","1070",0,[[5120,2880,60]]],["nvidia evga geforce gtx 1080 ti","1080",0,[[1920,1200,60]]],["nvidia evga geforce gtx 560 ti","560",0,[[1680,1050,59]]],["nvidia evga geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia evga geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia evga geforce gtx 650","650",0,[[1920,1200,87],[2560,1600,43]]],["nvidia evga geforce gtx 650 ti","650",0,[[1680,1050,116],[2560,1440,55]]],["nvidia evga geforce gtx 650 ti boost","650",0,[[1920,1080,56]]],["nvidia evga geforce gtx 660 ti","660",0,[[1920,1200,60]]],["nvidia evga geforce gtx 680","680",0,[[1600,1200,60]]],["nvidia evga geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia evga geforce gtx 760","760",0,[[1920,1080,119],[1920,1200,60]]],["nvidia evga geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia evga geforce gtx 960","960",0,[[1920,1080,60],[2560,1440,115]]],["nvidia evga geforce gtx 970","970",0,[[1920,1080,120]]],["nvidia evga geforce gtx 980","980",0,[[3440,1440,60]]],["nvidia evga geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia gainward geforce gt 630","630",0,[[1920,1080,28]]],["nvidia gainward geforce gts 450","450",0,[[1920,1080,55]]],["nvidia gainward geforce gtx 460","460",0,[[1920,1080,58]]],["nvidia gainward geforce gtx 550 ti","550",0,[[1280,1024,67]]],["nvidia gainward geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia geforce 210","210",0,[[1920,1080,8]]],["nvidia geforce 410m","410",0,[[1366,768,25],[1600,900,19]]],["nvidia geforce 510","510",0,[[1280,960,20]]],["nvidia geforce 605","605",0,[[1768,992,17],[1920,1080,15]]],["nvidia geforce 610m","610",0,[[1366,768,26]]],["nvidia geforce 610m/710m/810m/820m / gt 620m/625m/630m/720m","610",0,[[1366,768,51]]],["nvidia geforce 615","615",0,[[1920,1080,21]]],["nvidia geforce 705m","705",0,[[1920,1080,18]]],["nvidia geforce 710a","710",0,[[1920,1080,32]]],["nvidia geforce 710m","710",0,[[1366,768,55]]],["nvidia geforce 730a","730",0,[[1920,1080,37]]],["nvidia geforce 800m","800",0,[[1920,1080,18]]],["nvidia geforce 810m","810",0,[[1366,768,44],[1920,1080,31]]],["nvidia geforce 820a","820",0,[[1920,1080,28]]],["nvidia geforce 820m","820",0,[[1366,768,57],[1920,1080,23]]],["nvidia geforce 830a","830",0,[[1920,1080,53]]],["nvidia geforce 830m","830",0,[[1366,768,60]]],["nvidia geforce 8400 gs","8400",0,[[1680,1050,4]]],["nvidia geforce 8400 gs rev. 3","8400",0,[[1920,1080,4]]],["nvidia geforce 840a","840",0,[[1920,1080,56]]],["nvidia geforce 840m","840",0,[[1920,1080,56]]],["nvidia geforce 845m","845",0,[[1920,1080,59]]],["nvidia geforce 8600 gt","8600",1,[[1920,1200,-1]]],["nvidia geforce 8600 gts","8600",1,[[1920,1080,-1]]],["nvidia geforce 910m","910",0,[[1366,768,58],[1600,900,45]]],["nvidia geforce 920m","920",0,[[1366,768,60]]],["nvidia geforce 920mx","920",0,[[1366,768,60],[1920,1080,60]]],["nvidia geforce 9300 / nforce 730i","9300",0,[[1920,1080,6]]],["nvidia geforce 930a","930",0,[[1920,1080,55]]],["nvidia geforce 930m","930",0,[[1366,768,60]]],["nvidia geforce 930mx","930",0,[[1366,768,89],[1920,1080,59]]],["nvidia geforce 9400 gt","9400",1,[[1366,768,-1]]],["nvidia geforce 940a","940",0,[[1920,1080,58]]],["nvidia geforce 940m","940",0,[[1920,1080,54]]],["nvidia geforce 940mx","940",0,[[1920,1080,60]]],["nvidia geforce 945m","945",0,[[1920,1080,59]]],["nvidia geforce 9600 gt","9600",0,[[1920,1200,2]]],["nvidia geforce 9600m gt","9600",1,[[1440,900,-1]]],["nvidia geforce 9800 gt","9800",0,[[1920,1200,52]]],["nvidia geforce 9800 gtx / 9800 gtx+","9800",0,[[1280,1024,59]]],["nvidia geforce gpu","gpu",0,[[3000,2000,36]]],["nvidia geforce gt 1010","1010",0,[[1920,1080,135]]],["nvidia geforce gt 1030","1030",0,[[1920,1080,60]]],["nvidia geforce gt 1030 opengl engine","1030",0,[[6720,3780,15]]],["nvidia geforce gt 120","120",1,[[1920,1080,-1]]],["nvidia geforce gt 240","240",0,[[1366,768,32]]],["nvidia geforce gt 320m","320",0,[[1366,768,26]]],["nvidia geforce gt 415m","415",0,[[1366,768,19]]],["nvidia geforce gt 420","420",0,[[1024,768,33],[1920,1080,20]]],["nvidia geforce gt 420m","420",0,[[1366,768,28]]],["nvidia geforce gt 425m","425",0,[[1366,768,55],[1600,900,28]]],["nvidia geforce gt 430","430",0,[[1600,1200,16],[1920,1080,28]]],["nvidia geforce gt 435m","435",0,[[1366,768,53],[1920,1080,22]]],["nvidia geforce gt 440","440",0,[[1280,1024,51],[1680,1050,38],[1920,1080,45]]],["nvidia geforce gt 445m","445",0,[[1600,900,53]]],["nvidia geforce gt 520","520",0,[[1440,900,19],[1920,1080,17]]],["nvidia geforce gt 520m","520",0,[[1366,768,29]]],["nvidia geforce gt 520mx","520",0,[[1366,768,35]]],["nvidia geforce gt 525m","525",0,[[1366,768,28],[1600,900,22]]],["nvidia geforce gt 530","530",0,[[1920,1080,26]]],["nvidia geforce gt 540m","540",0,[[1366,768,38]]],["nvidia geforce gt 545","545",0,[[1920,1080,54]]],["nvidia geforce gt 550m","550",0,[[1600,900,44],[1920,1080,29]]],["nvidia geforce gt 555m","555",0,[[1920,1080,42]]],["nvidia geforce gt 555m/635m","555",0,[[1920,1080,36]]],["nvidia geforce gt 610","610",0,[[1280,1024,22],[1920,1080,15]]],["nvidia geforce gt 620","620",0,[[1920,1080,19]]],["nvidia geforce gt 620 oem","620",0,[[1920,1080,20],[1920,1200,20]]],["nvidia geforce gt 620m","620",0,[[1366,768,55],[1920,1080,30]]],["nvidia geforce gt 620m/630m/635m/640m le","620",0,[[1368,768,38]]],["nvidia geforce gt 625","625",0,[[1920,1080,18]]],["nvidia geforce gt 625m","625",0,[[1366,768,38]]],["nvidia geforce gt 630","630",0,[[1680,1050,36],[1920,1080,36],[1920,1200,30]]],["nvidia geforce gt 630 oem","630",0,[[1600,900,33]]],["nvidia geforce gt 630 opengl engine","630",0,[[1920,1080,33]]],["nvidia geforce gt 630 rev. 2","630",0,[[1920,1080,26]]],["nvidia geforce gt 630m","630",0,[[1366,768,57]]],["nvidia geforce gt 635","635",0,[[1920,1080,27]]],["nvidia geforce gt 635m","635",0,[[1366,768,47]]],["nvidia geforce gt 640","640",0,[[1920,1080,47]]],["nvidia geforce gt 640 oem","640",0,[[1920,1080,46],[2560,1440,35]]],["nvidia geforce gt 640 opengl engine","640",0,[[1280,1024,43]]],["nvidia geforce gt 640 rev. 2","640",0,[[1280,1024,60],[1920,1080,55]]],["nvidia geforce gt 640m","640",0,[[1366,768,82],[1600,900,59],[1920,1080,34]]],["nvidia geforce gt 640m le","640",0,[[1920,1080,49]]],["nvidia geforce gt 640m mac","640",0,[[1366,768,56],[1920,1080,20]]],["nvidia geforce gt 640m opengl engine","640",0,[[1920,1080,45]]],["nvidia geforce gt 645m","645",0,[[1366,768,60]]],["nvidia geforce gt 650m","650",0,[[1360,768,59],[1920,1080,58],[2560,1440,59]]],["nvidia geforce gt 650m mac","650",0,[[1440,900,56],[1920,1080,15],[2560,1440,19],[2880,1800,31]]],["nvidia geforce gt 650m opengl engine","650",0,[[1920,1080,56],[3840,2160,27]]],["nvidia geforce gt 705","705",0,[[1920,1080,11]]],["nvidia geforce gt 710","710",0,[[1920,1080,28]]],["nvidia geforce gt 710b","710",0,[[1920,1080,26]]],["nvidia geforce gt 710m","710",0,[[1366,768,46]]],["nvidia geforce gt 720","720",0,[[1920,1080,19],[2560,1440,16],[5120,2880,5]]],["nvidia geforce gt 720 opengl engine","720",0,[[2560,1600,20]]],["nvidia geforce gt 720m","720",0,[[1366,768,42]]],["nvidia geforce gt 730","730",0,[[1920,1080,54]]],["nvidia geforce gt 730a","730",0,[[1920,1080,23]]],["nvidia geforce gt 730m","730",0,[[1920,1080,43]]],["nvidia geforce gt 735m","735",0,[[1920,1080,39]]],["nvidia geforce gt 740","740",0,[[1920,1080,55],[3440,1440,23]]],["nvidia geforce gt 740 opengl engine","740",0,[[1920,1200,51]]],["nvidia geforce gt 740m","740",0,[[1366,768,60]]],["nvidia geforce gt 745m","745",0,[[1920,1080,55]]],["nvidia geforce gt 750m","750",0,[[1920,1080,57]]],["nvidia geforce gt 750m mac","750",0,[[1920,1080,58],[2880,1800,28]]],["nvidia geforce gt 755m","755",0,[[1920,1080,57]]],["nvidia geforce gt 755m mac","755",0,[[2560,1440,41]]],["nvidia geforce gt 755m opengl engine","755",0,[[2560,1440,51]]],["nvidia geforce gt 820m","820",0,[[1600,900,47]]],["nvidia geforce gts 250","250",0,[[1680,1050,53]]],["nvidia geforce gts 450","450",0,[[1360,768,60],[1680,1050,57],[1920,1080,55]]],["nvidia geforce gts 450 rev. 2","450",0,[[1920,1080,56]]],["nvidia geforce gtx 1050","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 3gb","1050",0,[[1280,1024,60]]],["nvidia geforce gtx 1050 mobile","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 opengl engine","1050",0,[[1920,1080,116]]],["nvidia geforce gtx 1050 ti","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti mobile","1050",0,[[1920,1080,298]]],["nvidia geforce gtx 1050 ti opengl engine","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti with max-q design","1050",0,[[1920,1080,268],[2560,1440,102],[3840,2160,60]]],["nvidia geforce gtx 1050 with max-q design","1050",0,[[1920,1080,60],[3840,2160,24]]],["nvidia geforce gtx 1060","1060",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1060 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 3gb opengl engine","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 5gb","1060",0,[[1920,1080,55]]],["nvidia geforce gtx 1060 6gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 6gb opengl engine","1060",0,[[1920,1080,75]]],["nvidia geforce gtx 1060 mobile","1060",0,[[1920,1080,422]]],["nvidia geforce gtx 1060 mobile 6gb","1060",0,[[1920,1080,120]]],["nvidia geforce gtx 1060 with max-q design","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060se 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1070","1070",0,[[1920,1080,134]]],["nvidia geforce gtx 1070 a17","1070",0,[[1920,1080,60]]],["nvidia geforce gtx 1070 mobile","1070",0,[[1920,1080,467]]],["nvidia geforce gtx 1070 opengl engine","1070",0,[[1920,1080,143]]],["nvidia geforce gtx 1070 ti","1070",0,[[1920,1080,60],[6016,3384,59]]],["nvidia geforce gtx 1070 ti opengl engine","1070",0,[[1920,1080,75]]],["nvidia geforce gtx 1070 with max-q design","1070",0,[[1920,1080,448]]],["nvidia geforce gtx 1070 with maxq design","1070",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1080","1080",0,[[1920,1080,119],[2560,1440,326],[3840,2160,286]]],["nvidia geforce gtx 1080 mobile","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 opengl engine","1080",0,[[1920,1080,79]]],["nvidia geforce gtx 1080 ti","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 ti opengl engine","1080",0,[[1920,1080,127]]],["nvidia geforce gtx 1080 with max-q design","1080",0,[[1920,1080,144]]],["nvidia geforce gtx 1180","1180",0,[[3440,1440,60]]],["nvidia geforce gtx 1650","1650",0,[[1920,1080,380]]],["nvidia geforce gtx 1650 mobile / max-q","1650",0,[[1920,1080,292]]],["nvidia geforce gtx 1650 super","1650",0,[[1920,1080,433]]],["nvidia geforce gtx 1650 ti","1650",0,[[1920,1080,144],[3840,2400,59]]],["nvidia geforce gtx 1650 ti mobile","1650",0,[[1920,1080,144]]],["nvidia geforce gtx 1650 ti with max-q design","1650",0,[[1920,1080,60],[3839,2160,60]]],["nvidia geforce gtx 1650 with max-q design","1650",0,[[1920,1080,142],[3000,2000,60]]],["nvidia geforce gtx 1660","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 1660 super","1660",0,[[1920,1080,60]]],["nvidia geforce gtx 1660 ti","1660",0,[[1920,1080,546],[3840,2160,60]]],["nvidia geforce gtx 1660 ti mobile","1660",0,[[1920,1080,451]]],["nvidia geforce gtx 1660 ti with max-q design","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 280","280",0,[[1680,1050,56]]],["nvidia geforce gtx 295","295",0,[[1920,1080,56]]],["nvidia geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia geforce gtx 460 oem","460",0,[[1360,768,60],[1920,1080,60]]],["nvidia geforce gtx 460 opengl engine","460",0,[[1920,1080,59]]],["nvidia geforce gtx 460 se","460",0,[[1920,1080,56],[1920,1200,57]]],["nvidia geforce gtx 460 v2","460",0,[[1920,1080,60],[1920,1200,60],[2560,1600,55]]],["nvidia geforce gtx 460m","460",0,[[1920,1080,46]]],["nvidia geforce gtx 465","465",0,[[1920,1080,134],[1920,1200,59]]],["nvidia geforce gtx 470","470",0,[[1680,1050,60],[1920,1080,59]]],["nvidia geforce gtx 470m","470",0,[[1920,1200,55]]],["nvidia geforce gtx 480","480",0,[[1440,900,191],[1920,1080,115],[1920,1200,60]]],["nvidia geforce gtx 480 opengl engine","480",0,[[1600,1200,60]]],["nvidia geforce gtx 550 ti","550",0,[[1280,1024,58],[1920,1080,58]]],["nvidia geforce gtx 550 ti opengl engine","550",0,[[1920,1080,55]]],["nvidia geforce gtx 555","555",0,[[1920,1080,54]]],["nvidia geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 se","560",0,[[1680,1050,52],[1920,1080,111]]],["nvidia geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 ti 448 cores","560",0,[[1920,1080,60],[2560,1440,60]]],["nvidia geforce gtx 560 ti oem","560",0,[[1920,1080,176]]],["nvidia geforce gtx 560 ti opengl engine","560",0,[[1920,1080,48]]],["nvidia geforce gtx 560m","560",0,[[1920,1080,55]]],["nvidia geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 opengl engine","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 rev. 2","570",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 570m","570",0,[[1920,1080,125],[2560,1440,8]]],["nvidia geforce gtx 580","580",0,[[1920,1080,60]]],["nvidia geforce gtx 580 opengl engine","580",0,[[1680,1050,59]]],["nvidia geforce gtx 580m","580",0,[[1920,1080,60]]],["nvidia geforce gtx 590","590",0,[[1920,1080,59]]],["nvidia geforce gtx 645","645",0,[[1920,1080,57],[1920,1200,58]]],["nvidia geforce gtx 645 opengl engine","645",0,[[1920,1200,58]]],["nvidia geforce gtx 650","650",0,[[1920,1080,72]]],["nvidia geforce gtx 650 oem","650",0,[[1366,768,59]]],["nvidia geforce gtx 650 opengl engine","650",0,[[1920,1080,59]]],["nvidia geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia geforce gtx 650 ti boost","650",0,[[1280,1024,60],[1600,1200,187],[1920,1080,60]]],["nvidia geforce gtx 650 ti opengl engine","650",0,[[1920,1080,60]]],["nvidia geforce gtx 660","660",0,[[1920,1080,111]]],["nvidia geforce gtx 660 oem","660",0,[[1920,1080,59]]],["nvidia geforce gtx 660 ti","660",0,[[1920,1080,60]]],["nvidia geforce gtx 660 ti opengl engine","660",0,[[1280,1024,60]]],["nvidia geforce gtx 660m","660",0,[[1680,1050,36],[1920,1080,59]]],["nvidia geforce gtx 660m mac","660",0,[[2560,1440,2]]],["nvidia geforce gtx 660m opengl engine","660",0,[[2560,1440,36]]],["nvidia geforce gtx 670","670",0,[[1920,1080,100]]],["nvidia geforce gtx 670 opengl engine","670",0,[[1920,1080,60]]],["nvidia geforce gtx 670m","670",0,[[1920,1080,66]]],["nvidia geforce gtx 670mx","670",0,[[1920,1080,60]]],["nvidia geforce gtx 675m","675",0,[[1920,1080,60]]],["nvidia geforce gtx 675mx","675",0,[[1680,1050,60],[1920,1080,60],[2560,1440,55]]],["nvidia geforce gtx 675mx mac","675",0,[[2560,1440,36]]],["nvidia geforce gtx 675mx opengl engine","675",0,[[2560,1440,60]]],["nvidia geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680 opengl engine","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680m","680",0,[[1920,1080,39],[1920,1200,60]]],["nvidia geforce gtx 680m opengl engine","680",0,[[1920,1080,36]]],["nvidia geforce gtx 680mx","680",0,[[2560,1440,59]]],["nvidia geforce gtx 680mx opengl engine","680",0,[[2560,1440,59]]],["nvidia geforce gtx 690","690",0,[[1920,1080,60],[3840,2160,30]]],["nvidia geforce gtx 745","745",0,[[1920,1080,60],[2560,1600,29]]],["nvidia geforce gtx 750","750",0,[[1920,1080,60]]],["nvidia geforce gtx 750 opengl engine","750",0,[[1920,1200,58]]],["nvidia geforce gtx 750 ti","750",0,[[1920,1080,97]]],["nvidia geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,116]]],["nvidia geforce gtx 760 oem","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760 opengl engine","760",0,[[1920,1080,52]]],["nvidia geforce gtx 760 ti","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 760 ti oem","760",0,[[1920,1200,60]]],["nvidia geforce gtx 760 ti opengl engine","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760a","760",0,[[2560,1080,15]]],["nvidia geforce gtx 760m","760",0,[[1920,1080,60]]],["nvidia geforce gtx 765m","765",0,[[1920,1080,53],[2560,1440,57]]],["nvidia geforce gtx 765m by nick[d]vb","765",0,[[2560,1440,58]]],["nvidia geforce gtx 765m opengl engine","765",0,[[2560,1440,57]]],["nvidia geforce gtx 770","770",0,[[1920,1080,143],[2560,1440,203]]],["nvidia geforce gtx 770 opengl engine","770",0,[[1920,1080,60]]],["nvidia geforce gtx 770m","770",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 770m by nick[d]vb","770",0,[[2560,1440,34]]],["nvidia geforce gtx 770m opengl engine","770",0,[[2560,1440,59]]],["nvidia geforce gtx 775m by idopt mac","775",0,[[2560,1440,56]]],["nvidia geforce gtx 775m mac","775",0,[[2560,1440,59]]],["nvidia geforce gtx 775m opengl engine","775",0,[[2560,1440,60]]],["nvidia geforce gtx 780","780",0,[[1920,1080,159]]],["nvidia geforce gtx 780 by st3phl3","780",0,[[3840,2160,30]]],["nvidia geforce gtx 780 mac","780",0,[[1680,1050,60],[1920,1080,60]]],["nvidia geforce gtx 780 rev. 2","780",0,[[1920,1080,144],[2560,1440,119],[3840,2160,58],[5120,2880,58]]],["nvidia geforce gtx 780 ti","780",0,[[1280,1024,120],[1920,1080,119]]],["nvidia geforce gtx 780 ti opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m","780",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 780m by nick[d]vb","780",0,[[1920,1080,59],[2560,1440,60]]],["nvidia geforce gtx 780m mac","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 850a","850",0,[[2560,1440,48]]],["nvidia geforce gtx 850m","850",0,[[1920,1080,60]]],["nvidia geforce gtx 860m","860",0,[[1920,1080,59]]],["nvidia geforce gtx 860m opengl engine","860",0,[[2560,1440,58]]],["nvidia geforce gtx 870m","870",0,[[1920,1080,60],[2560,1440,102]]],["nvidia geforce gtx 880m","880",0,[[1920,1080,60],[2560,1440,74]]],["nvidia geforce gtx 880m opengl engine","880",0,[[2560,1440,60]]],["nvidia geforce gtx 950","950",0,[[1920,1080,98]]],["nvidia geforce gtx 950 opengl engine","950",0,[[1920,1200,60]]],["nvidia geforce gtx 950a","950",0,[[1920,1080,60],[3840,2160,38]]],["nvidia geforce gtx 950m","950",0,[[1920,1080,114]]],["nvidia geforce gtx 960","960",0,[[1920,1080,60]]],["nvidia geforce gtx 960a","960",0,[[1920,1440,128]]],["nvidia geforce gtx 960m","960",0,[[1920,1080,119],[3840,2160,37]]],["nvidia geforce gtx 965m","965",0,[[1920,1080,195],[3000,2000,59],[3840,2160,41]]],["nvidia geforce gtx 965m opengl engine","965",0,[[2880,1620,55]]],["nvidia geforce gtx 970","970",0,[[1920,1080,143]]],["nvidia geforce gtx 970 opengl engine","970",0,[[2560,1600,60]]],["nvidia geforce gtx 970m","970",0,[[1920,1080,60]]],["nvidia geforce gtx 980","980",0,[[1920,1080,60],[3440,1440,294]]],["nvidia geforce gtx 980 ti","980",0,[[1920,1080,119],[2560,1440,456]]],["nvidia geforce gtx 980 ti opengl engine","980",0,[[1920,1080,60]]],["nvidia geforce gtx 980m","980",0,[[1920,1080,60],[3840,2160,104]]],["nvidia geforce gtx titan","gtx",0,[[1920,1080,119],[1920,1200,119],[2560,1440,60]]],["nvidia geforce gtx titan black","gtx",0,[[1680,1050,60],[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia geforce gtx titan black opengl engine","gtx",0,[[3840,2160,60]]],["nvidia geforce gtx titan opengl engine","gtx",0,[[2560,1440,60]]],["nvidia geforce gtx titan x","gtxx",0,[[1920,1080,144],[2560,1440,120],[2560,1600,60]]],["nvidia geforce gtx titan xp","gtxxp",0,[[2560,1440,60],[3440,1440,60]]],["nvidia geforce gtx titan z","gtxz",0,[[1440,900,59],[1920,1080,39],[3840,2160,60]]],["nvidia geforce gtx780m by nikey22","780",0,[[2560,1440,60]]],["nvidia geforce gtx870m by nikey22","870",0,[[2560,1440,60]]],["nvidia geforce gtx880m","880",0,[[1920,1080,60]]],["nvidia geforce gtx880m by nikey22","880",0,[[2560,1440,59]]],["nvidia geforce gtx880m opengl engine","880",0,[[2560,1440,59]]],["nvidia geforce mx110","110",0,[[1366,768,61],[1920,1080,57]]],["nvidia geforce mx130","130",0,[[1920,1080,60]]],["nvidia geforce mx150","150",0,[[1920,1080,113]]],["nvidia geforce mx230","230",0,[[1920,1080,60]]],["nvidia geforce mx250","250",0,[[1920,1080,60]]],["nvidia geforce mx330","330",0,[[1920,1080,60],[3840,2160,51]]],["nvidia geforce mx350","350",0,[[1920,1080,60]]],["nvidia geforce mx450","450",0,[[1920,1080,60]]],["nvidia geforce pre-release graphics device","pre",0,[[2560,1440,60]]],["nvidia geforce pre-release tesla c2075 opengl engine","2075",0,[[1600,900,59]]],["nvidia geforce pre-release titan x opengl engine","prex",0,[[1920,1080,60]]],["nvidia geforce pre-release titan xp collectors edition opengl e","prexpe",0,[[1920,1080,59]]],["nvidia geforce pre-release titan xp opengl engine","prexp",0,[[2560,1440,60]]],["nvidia geforce rtx 2060","2060",0,[[1920,1080,512]]],["nvidia geforce rtx 2060 max-q","2060",0,[[2560,1440,301]]],["nvidia geforce rtx 2060 mobile","2060",0,[[1920,1080,518]]],["nvidia geforce rtx 2060 rev. a","2060",0,[[3840,2160,257]]],["nvidia geforce rtx 2060 super","2060",0,[[1920,1080,645],[2560,1440,143]]],["nvidia geforce rtx 2060 with max-q design","2060",0,[[1920,1080,292],[1920,1200,60]]],["nvidia geforce rtx 2070","2070",0,[[1920,1080,60],[3840,2160,60]]],["nvidia geforce rtx 2070 mobile","2070",0,[[1920,1080,477]]],["nvidia geforce rtx 2070 mobile / max-q","2070",0,[[1920,1080,526]]],["nvidia geforce rtx 2070 mobile / max-q refresh","2070",0,[[1920,1080,143]]],["nvidia geforce rtx 2070 rev. a","2070",0,[[2560,1440,144]]],["nvidia geforce rtx 2070 super","2070",0,[[1920,1080,510]]],["nvidia geforce rtx 2070 super with max-q design","2070",0,[[1920,1080,300]]],["nvidia geforce rtx 2070 with max-q design","2070",0,[[1920,1080,240]]],["nvidia geforce rtx 2080","2080",0,[[1920,1080,632],[2560,1440,165]]],["nvidia geforce rtx 2080 mobile","2080",0,[[1920,1080,144]]],["nvidia geforce rtx 2080 rev. a","2080",0,[[2560,1440,143]]],["nvidia geforce rtx 2080 super","2080",0,[[1920,1080,601]]],["nvidia geforce rtx 2080 super mobile / max-q","2080",0,[[3840,2160,59]]],["nvidia geforce rtx 2080 super with max-q design","2080",0,[[1920,1080,300]]],["nvidia geforce rtx 2080 ti","2080",0,[[1920,1080,83]]],["nvidia geforce rtx 2080 ti rev. a","2080",0,[[1920,1080,403]]],["nvidia geforce rtx 2080 with max-q design","2080",0,[[1920,1080,476]]],["nvidia geforce rtx 3050","3050",0,[[1920,1080,60]]],["nvidia geforce rtx 3050 laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3050 ti laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3060","3060",0,[[1920,1080,674]]],["nvidia geforce rtx 3060 laptop gpu","3060",0,[[1920,1080,300]]],["nvidia geforce rtx 3060 lite hash rate","3060",0,[[1920,1080,60]]],["nvidia geforce rtx 3060 mobile / max-q","3060",0,[[1920,1080,435]]],["nvidia geforce rtx 3060 ti","3060",0,[[1920,1080,779]]],["nvidia geforce rtx 3070","3070",0,[[1920,1080,723],[2560,1440,294]]],["nvidia geforce rtx 3070 laptop gpu","3070",0,[[1920,1080,357]]],["nvidia geforce rtx 3070 mobile / max-q","3070",0,[[2560,1440,386]]],["nvidia geforce rtx 3070 ti","3070",0,[[1920,1080,60]]],["nvidia geforce rtx 3080","3080",0,[[1920,1080,726],[2560,1440,60],[3840,2160,60]]],["nvidia geforce rtx 3080 laptop gpu","3080",0,[[1920,1080,294],[2560,1440,244]]],["nvidia geforce rtx 3080 mobile / max-q 8gb/16gb","3080",0,[[1920,1080,293]]],["nvidia geforce rtx 3080 ti","3080",0,[[1920,1080,239],[2560,1440,60]]],["nvidia geforce rtx 3090","3090",0,[[2560,1440,60],[3840,2160,474]]],["nvidia geforce rtx t10-16","10",0,[[2560,1600,3]]],["nvidia geforce rtx t10-8","10",0,[[2560,1600,3]]],["nvidia gigabyte geforce gt 440","440",0,[[1280,1024,34]]],["nvidia gigabyte geforce gt 610","610",0,[[1920,1080,17]]],["nvidia gigabyte geforce gt 630","630",0,[[1920,1080,34]]],["nvidia gigabyte geforce gt 730","730",0,[[1280,1024,38]]],["nvidia gigabyte geforce gts 450","450",0,[[1280,1024,37]]],["nvidia gigabyte geforce gtx 1050 ti","1050",0,[[1920,1080,30]]],["nvidia gigabyte geforce gtx 460","460",0,[[1680,1050,60]]],["nvidia gigabyte geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia gigabyte geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 580","580",0,[[1920,1200,60]]],["nvidia gigabyte geforce gtx 650","650",0,[[1680,1050,55]]],["nvidia gigabyte geforce gtx 650 ti","650",0,[[2560,1440,40]]],["nvidia gigabyte geforce gtx 660","660",0,[[1920,1080,31]]],["nvidia gigabyte geforce gtx 660 ti","660",0,[[5120,2880,29]]],["nvidia gigabyte geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 750","750",0,[[1920,1080,59]]],["nvidia gigabyte geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 760","760",0,[[3440,1440,17]]],["nvidia gigabyte geforce gtx 770","770",0,[[2560,1440,59]]],["nvidia gigabyte geforce gtx 780 ti","780",0,[[1920,1080,240]]],["nvidia gigabyte geforce gtx 960","960",0,[[1920,1080,142],[1920,1200,120]]],["nvidia gigabyte geforce gtx 970","970",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 980","980",0,[[2560,1440,60]]],["nvidia gigabyte geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia hp geforce gt 730","730",0,[[1920,1080,55]]],["nvidia inno3d geforce gtx660","3",0,[[2560,1440,107]]],["nvidia msi geforce gt 610","610",0,[[1920,1080,16]]],["nvidia msi geforce gt 630","630",0,[[1440,900,12]]],["nvidia msi geforce gt 635","635",0,[[1920,1080,30]]],["nvidia msi geforce gt 710","710",0,[[1920,1080,27]]],["nvidia msi geforce gt 730","730",0,[[1920,1080,53]]],["nvidia msi geforce gtx 1050 ti","1050",0,[[1920,1080,59]]],["nvidia msi geforce gtx 1060","1060",0,[[1920,1080,120]]],["nvidia msi geforce gtx 1070","1070",0,[[1920,1200,45]]],["nvidia msi geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia msi geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia msi geforce gtx 570 hd","570",0,[[1920,1200,60]]],["nvidia msi geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia msi geforce gtx 650","650",0,[[2560,1080,52]]],["nvidia msi geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660 ti","660",0,[[1680,1050,49]]],["nvidia msi geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia msi geforce gtx 745","745",0,[[1920,1080,55]]],["nvidia msi geforce gtx 760","760",0,[[1280,1024,30],[1920,1080,58]]],["nvidia msi geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia msi geforce gtx 950","950",0,[[1920,1080,59]]],["nvidia msi geforce gtx 960","960",0,[[1680,1050,120],[2560,1440,59]]],["nvidia msi geforce gtx 970","970",0,[[1680,1050,60]]],["nvidia msi geforce gtx 980","980",0,[[1920,1080,120],[3840,2160,60]]],["nvidia msi geforce gtx 980 ti","980",0,[[5120,2880,56]]],["nvidia null geforce 920a","920",0,[[1920,1080,25]]],["nvidia palit geforce gtx 650","650",0,[[1920,1080,49]]],["nvidia palit geforce gtx 650 ti","650",0,[[1920,1080,59]]],["nvidia palit geforce gtx 660","660",0,[[1920,1080,26]]],["nvidia pegatron geforce gt 420","420",0,[[1400,1050,25]]],["nvidia pny geforce gt 610","610",0,[[1280,1024,19]]],["nvidia pny geforce gtx 1060","1060",0,[[1920,1080,60]]],["nvidia pny geforce gtx 460","460",0,[[1360,768,59]]],["nvidia pny geforce gtx 550 ti","550",0,[[1920,1080,55]]],["nvidia pny geforce gtx 570 hd","570",0,[[1280,1024,72]]],["nvidia pny geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia pny geforce gtx 680","680",0,[[2560,1080,120]]],["nvidia pny geforce gtx 750","750",0,[[1280,1024,60]]],["nvidia pny geforce gtx 970","970",0,[[2560,1440,60]]],["nvidia pny geforce gtx 980","980",0,[[1920,1080,120]]],["nvidia point of view geforce gtx 470","470",0,[[1920,1080,59]]],["nvidia point of view geforce gtx 660 ti","660",0,[[1680,1050,59]]],["nvidia sony geforce 410m","410",0,[[1366,768,24]]],["nvidia toshiba geforce gt 525m","525",0,[[1366,768,33]]],["nvidia zotac geforce gt 430","430",0,[[1600,900,32]]],["nvidia zotac geforce gt 610","610",0,[[1920,1080,15]]],["nvidia zotac geforce gt 630","630",0,[[1360,768,46]]],["nvidia zotac geforce gt 740","740",0,[[1280,1024,118]]],["nvidia zotac geforce gtx 460","460",0,[[1920,1080,59]]],["nvidia zotac geforce gtx 550 ti","550",0,[[1920,1080,42]]],["nvidia zotac geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 580","580",0,[[1920,1080,48]]],["nvidia zotac geforce gtx 650","650",0,[[1920,1080,44]]],["nvidia zotac geforce gtx 650 ti","650",0,[[1920,1080,58]]],["nvidia zotac geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 750","750",0,[[1680,1050,114],[1920,1080,60]]],["nvidia zotac geforce gtx 760","760",0,[[1920,1080,101]]],["nvidia zotac geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 960","960",0,[[2048,1152,60]]]]\')},178:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel","",0,[[4096,2304,12]]],["intel 0x496e74656c2048442047726170686963000732034343","0",0,[[1920,1080,22]]],["intel broxton-p hd","p",0,[[1920,1080,73]]],["intel cherryview hd","hd",0,[[1920,1080,16]]],["intel coffee lake uhd","uhd",0,[[1920,1080,49]]],["intel cometlake uhd graphics 630","630",0,[[2560,1440,40]]],["intel corporation 2nd gen core processor family integrated graphics controller","2",0,[[1366,768,25]]],["intel corporation 2nd generation core processor family integrated graphics controller","2",0,[[1600,900,28]]],["intel corporation 3rd gen core processor graphics controller","3",0,[[1366,768,20]]],["intel corporation 8th gen core processor gaussian mixture model","8",0,[[1366,768,17]]],["intel corporation atom processor z36xxx/z37xxx series graphics & display","36",0,[[1280,799,18],[1366,768,18]]],["intel corporation atom/celeron/pentium processor n4200 series integrated graphics controller","4200",0,[[1280,1024,28]]],["intel corporation atom/celeron/pentium processor x5-e8000 integrated graphics controller","5",0,[[1366,768,34]]],["intel corporation atom/celeron/pentium processor x5-e8000 series pci configuration registers","5",0,[[1920,1080,14]]],["intel corporation broadwell-u integrated","u",0,[[1920,1080,38]]],["intel corporation celeron n3350 n4200/atom e3900 series integrated graphics controller","3350",0,[[1680,1050,33]]],["intel corporation coffeelake-h gt2 [uhd graphics 630]","2",0,[[1920,1080,76]]],["intel corporation cometlake-h gt2 [uhd graphics]","2",0,[[3072,1728,29]]],["intel corporation cometlake-s gt2 [uhd graphics 630]","2",0,[[1920,1080,52]]],["intel corporation cometlake-u gt2 [uhd graphics]","2",0,[[1920,1080,39]]],["intel corporation device","",0,[[1920,1080,31]]],["intel corporation geminilake [uhd graphics 600]","600",0,[[1920,1080,15]]],["intel corporation haswell-ult integrated graphics controller","ult",0,[[1366,768,35]]],["intel corporation hd","hd",0,[[1920,1080,24]]],["intel corporation hd graphics 500","500",0,[[1366,768,19]]],["intel corporation hd graphics 510","510",0,[[1368,768,48]]],["intel corporation hd graphics 515","515",0,[[1920,1080,29]]],["intel corporation hd graphics 520","520",0,[[1366,768,59]]],["intel corporation hd graphics 530","530",0,[[1920,1080,58]]],["intel corporation hd graphics 5300","5300",0,[[1920,1080,35]]],["intel corporation hd graphics 5500","5500",0,[[1920,1080,36]]],["intel corporation hd graphics 610","610",0,[[1920,1080,28]]],["intel corporation hd graphics 620","620",0,[[1920,1080,56],[3200,1800,17]]],["intel corporation hd graphics 630","630",0,[[1920,1080,58]]],["intel corporation iris graphics 540","540",0,[[1920,1080,54]]],["intel corporation iris graphics 6100","6100",0,[[2560,1600,20]]],["intel corporation iris plus graphics 650","650",0,[[1440,900,60]]],["intel corporation iris plus graphics 655","655",0,[[1920,1080,119]]],["intel corporation iris plus graphics g1","1",0,[[1920,1080,57]]],["intel corporation iris plus graphics g7","7",0,[[1920,1080,112]]],["intel corporation iris pro graphics 580","580",0,[[1920,1080,60]]],["intel corporation iris pro graphics 6200","6200",0,[[2560,1080,41]]],["intel corporation iris xe","xe",0,[[1920,1200,60]]],["intel corporation sky lake integrated","sky",0,[[2560,1440,52]]],["intel corporation skylake gt2 [hd graphics 520]","2",0,[[1920,1080,52],[2560,1440,31]]],["intel corporation skylake integrated","",0,[[1920,1080,51]]],["intel corporation tigerlake gt2 [iris xe graphics]","2",0,[[1920,1080,60]]],["intel corporation tigerlake-lp gt2 [iris xe graphics]","2",0,[[1920,1080,60]]],["intel corporation uhd","uhd",0,[[1920,1080,65]]],["intel corporation uhd graphics 605","605",0,[[1920,1080,21]]],["intel corporation uhd graphics 615","615",0,[[1920,1080,30]]],["intel corporation uhd graphics 620","620",0,[[1920,1080,55]]],["intel corporation uhd graphics 630","630",0,[[1920,1080,57]]],["intel corporation whiskeylake-u gt2 [uhd graphics 620]","2",0,[[1920,1080,57]]],["intel corporation xeon e3-1200 v2 gen core processor graphics controller","3",0,[[1920,1080,15]]],["intel corporation xeon e3-1200 v3 gen core processor integrated graphics controller","3",0,[[1360,768,42],[1440,900,34],[1280,1024,23],[1920,1080,22]]],["intel corporation, series chipset iris plus graphics 655","655",0,[[1920,1080,42]]],["intel geforce gtx 960","960",0,[[1920,1080,26]]],["intel gen12 desktop graphics controller","12",0,[[3840,2160,20]]],["intel graphics gfx-driver-user-feature_dg1_poweron-27723 dch releaseinternal","1",0,[[3840,2160,11]]],["intel hd","hd",0,[[1280,800,18],[1366,768,26],[1600,900,12],[1920,1080,13],[1920,1200,16],[1920,1280,18],[3000,2002,6],[4096,2160,4]]],["intel hd 4000","4000",0,[[1366,768,37]]],["intel hd 530","530",0,[[1920,1200,54]]],["intel hd graphics 3000","3000",0,[[1920,1080,21]]],["intel hd graphics 4000","4000",0,[[1280,800,41],[1366,768,33],[1440,900,31],[1680,1050,50],[1920,1080,27],[2560,1600,13],[2880,1800,12]]],["intel hd graphics 4000,,,,,,,","4000",0,[[1920,1080,19]]],["intel hd graphics 4400","4400",0,[[1366,768,28],[1280,1024,48],[1920,1080,18],[2160,1440,20]]],["intel hd graphics 4600","4600",0,[[1366,768,14],[1280,960,65],[1280,1024,60],[1600,900,33],[1680,1050,31],[1600,1200,47],[1920,1080,19],[1920,1200,22],[2880,1620,14]]],["intel hd graphics 500","500",0,[[1920,1080,15]]],["intel hd graphics 5000","5000",0,[[1366,768,45],[1440,900,42],[1920,1032,25],[1920,1080,27],[2160,1439,19],[2160,1440,23],[2560,1440,15]]],["intel hd graphics 505","505",0,[[1366,768,28],[1920,1080,16]]],["intel hd graphics 510","510",0,[[1366,768,29],[1440,900,46],[1680,1050,12],[1920,1080,27]]],["intel hd graphics 515","515",0,[[1920,1080,45],[2720,768,22],[1920,1280,41],[2160,1440,28],[2560,1600,16],[2736,1824,19],[3200,1800,12],[3840,2160,10]]],["intel hd graphics 520","520",0,[[1366,768,90],[1920,1080,30],[2736,1824,26],[3000,2000,21]]],["intel hd graphics 530","530",0,[[1366,768,21],[1280,1024,65],[1920,1080,47],[1920,1200,39],[3840,2160,6]]],["intel hd graphics 5300","5300",0,[[1920,1080,21],[2304,1440,19],[2560,1600,13]]],["intel hd graphics 5500","5500",0,[[1366,768,37],[1920,1080,21]]],["intel hd graphics 5600","5600",0,[[1920,1080,26],[1920,1200,40],[2880,1620,21]]],["intel hd graphics 6000","6000",0,[[1366,768,43],[1440,900,40],[1920,1080,21]]],["intel hd graphics 610","610",0,[[1366,768,33],[1600,900,42],[1920,1080,27],[3840,2160,8]]],["intel hd graphics 615","615",0,[[1600,900,13],[1920,1080,18],[1800,1200,29],[1920,1200,34],[2560,1440,25],[2560,1600,21],[2736,1824,21]]],["intel hd graphics 620","620",0,[[1920,1080,37],[2736,1824,27],[3200,1800,25],[3840,2160,13]]],["intel hd graphics 630","630",0,[[1366,768,69],[1920,1080,40],[2560,1440,27],[2560,1600,23],[3360,2100,56],[3840,2160,12]]],["intel hd graphics 630 gt2","630",0,[[1920,1080,39],[1720,1440,120]]],["intel hd graphics cfl crb","hdcfl",0,[[2560,1440,38]]],["intel hd graphics family","hd",0,[[1366,768,44]]],["intel hd graphics icl rvp","hdicl",0,[[1920,1080,58]]],["intel hd graphics icl rvp bigsur","hdicl",0,[[1920,1080,57]]],["intel hd graphics kbl crb","hdkbl",0,[[1920,1080,57],[3840,2160,13]]],["intel hd graphics p4600","4600",0,[[1280,1024,57],[1920,1080,18],[2560,1600,60]]],["intel hd graphics p530","530",0,[[2560,1440,36],[3840,2160,12]]],["intel hd graphics p630","630",0,[[1440,900,35],[1920,1200,50]]],["intel hd graphics, gen10","10",0,[[3840,2160,4]]],["intel hd5500 broadwell pg7","5500",0,[[1366,768,31]]],["intel hd5500 graphics pg7","5500",0,[[1366,768,56]]],["intel iris","",0,[[1366,768,57],[1600,900,34],[1920,1080,34],[2560,1600,17],[2880,1800,14]]],["intel iris graphics 5100","5100",0,[[1920,1080,35],[2560,1600,18]]],["intel iris graphics 540","540",0,[[1920,1080,20],[2736,1824,28],[2880,1800,23],[3200,1800,17],[3840,2160,17]]],["intel iris graphics 550","550",0,[[1920,1080,81],[2160,1440,45],[2560,1600,28],[2880,1800,26],[3840,2160,24]]],["intel iris graphics 6100","6100",0,[[1920,1080,26],[2560,1600,19],[3840,2160,10]]],["intel iris graphics 6200","6200",0,[[4096,2304,13]]],["intel iris graphics 640","640",0,[[2256,1504,24],[3840,2160,9]]],["intel iris graphics 650","650",0,[[2560,1440,24]]],["intel iris graphics p580","580",0,[[3840,2160,12]]],["intel iris plus","",0,[[1920,1080,60],[2256,1504,95],[2496,1664,93],[2736,1824,60],[2880,1800,60],[3000,2000,56]]],["intel iris plus graphics 640","640",0,[[1920,1080,87],[2256,1504,46],[2560,1600,44],[2735,1823,28],[2736,1824,28],[2880,1800,26],[3072,1728,25],[3200,1800,37],[3840,2160,16]]],["intel iris plus graphics 645","645",0,[[2560,1599,32],[2560,1600,56],[2880,1800,47]]],["intel iris plus graphics 650","650",0,[[1920,1080,60],[2560,1600,49],[2880,1800,27],[3840,2160,16]]],["intel iris plus graphics 655","655",0,[[1920,1080,58],[2560,1440,85],[2880,1800,32],[3840,2160,24]]],["intel iris pro","pro",0,[[1920,1080,56]]],["intel iris pro graphics 5200","5200",0,[[1920,1080,53],[2879,1800,24],[2880,1800,21]]],["intel iris pro graphics 580","580",0,[[1920,1080,58],[2560,1080,91],[2560,1440,58],[3840,1600,27]]],["intel iris pro graphics 6200","6200",0,[[1366,696,38],[1920,1080,58],[1920,1200,60],[3840,2160,19],[4096,2304,14]]],["intel iris pro graphics p580","580",0,[[1024,768,42],[1920,1080,103],[3840,2160,27]]],["intel iris pro graphics p6300","6300",0,[[1366,768,102],[1440,900,128],[1920,1080,30]]],["intel iris xe","xe",0,[[1920,1080,88]]],["intel iris xe graphics releaseinternal","xe",0,[[3840,2160,38]]],["intel iris xe max","xe",0,[[1920,1080,60],[3840,2160,56]]],["intel kabylake hd graphics ult gt2","2",0,[[3840,2160,11]]],["intel kabylake hd graphics ulx gt2","2",0,[[1920,1080,28],[3840,2160,6]]],["intel kbl unknown","kbl",0,[[1920,1080,54]]],["intel mesa dri intel bay trail","dribay",0,[[1366,768,14]]],["intel mesa dri intel haswell mobile","dri",0,[[1920,1080,27]]],["intel mesa dri intel hd","drihd",0,[[1920,1080,10]]],["intel mesa dri intel hd graphics 400","400",0,[[1366,768,30]]],["intel mesa dri intel hd graphics 505","505",0,[[1920,1080,27]]],["intel mesa dri intel hd graphics 520","520",0,[[1920,1080,45],[2560,1440,24]]],["intel mesa dri intel hd graphics 530","530",0,[[3840,2160,12]]],["intel mesa dri intel hd graphics 5500","5500",0,[[1366,768,40]]],["intel mesa dri intel hd graphics 620","620",0,[[1920,1080,53]]],["intel mesa dri intel hd graphics 630","630",0,[[1477,831,58]]],["intel mesa dri intel hd graphics p4000","4000",0,[[1920,1080,36]]],["intel mesa dri intel iris graphics 540","540",0,[[1280,720,40]]],["intel mesa dri intel ivybridge desktop","dri",0,[[2560,1080,16]]],["intel mesa dri intel ivybridge mobile","dri",0,[[1920,1080,25]]],["intel mesa dri intel kabylake gt2","2",0,[[1920,1080,36]]],["intel mesa dri intel sandybridge desktop","dri",0,[[1280,1024,12]]],["intel mesa dri intel sandybridge mobile","dri",0,[[1366,768,33]]],["intel mesa dri intel uhd graphics 620","620",0,[[2736,1824,22]]],["intel mesa dri intel uhd graphics 630","630",0,[[1920,1080,42]]],["intel mesa intel hd graphics 520","520",0,[[1920,1080,47]]],["intel mesa intel hd graphics 530","530",0,[[1920,1080,55]]],["intel phdgd ivy 4","4",0,[[1366,768,45]]],["intel radeon pro vega 16","16",0,[[3360,1890,20]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["intel skl unknown","skl",0,[[1920,1080,43]]],["intel skylake gt2 [hd graphics 520]","2",0,[[1920,1080,39]]],["intel uhd","uhd",0,[[1920,1080,58],[2560,1600,22],[3440,1440,14],[2736,1824,32],[3840,2160,31]]],["intel uhd 630","630",0,[[2560,1440,38]]],["intel uhd graphics 600","600",0,[[1366,768,27],[1920,1080,13],[1920,1200,13],[2560,1440,11],[3840,2160,5]]],["intel uhd graphics 600 universal","600",0,[[1919,1031,15]]],["intel uhd graphics 605","605",0,[[1366,768,29],[1920,1080,37]]],["intel uhd graphics 610","610",0,[[1366,768,58],[1920,1080,32],[1920,1200,37],[2560,1440,17],[3840,2160,11]]],["intel uhd graphics 615","615",0,[[1920,1080,34],[1920,1280,29],[3840,2160,9]]],["intel uhd graphics 617","617",0,[[1920,1080,43],[2560,1599,24],[2560,1600,26],[2880,1800,24]]],["intel uhd graphics 620","620",0,[[1920,1080,50],[2736,1824,33],[3200,1800,16]]],["intel uhd graphics 630","630",0,[[1440,900,112],[1920,1080,44],[1920,1200,65],[2560,1080,68],[2560,1440,26],[3440,1440,25],[3584,2240,137],[3840,2160,12],[6016,3384,8]]],["intel uhd graphics 730","730",0,[[1920,1080,53]]],["intel uhd graphics 750","750",0,[[1920,1080,56],[3840,2160,36]]],["intel uhd graphics 770","770",0,[[3440,1440,78],[5120,1440,31]]],["intel uhd graphics gfx-driver-user-comp_core-23599","23599",0,[[3840,2160,18]]],["intel uhd graphics p630","630",0,[[1920,1080,54],[3840,2160,21]]],["intel uhd graphics releaseinternal","uhd",0,[[3199,1800,22],[3000,2000,47]]],["intel uhd graphics, gen11 lp","11",0,[[3840,2160,10]]],["intel uhd graphics, gen12 lp releaseinternal","12",0,[[3839,2159,4]]],["intel uhd graphics, lkf","uhdlkf",0,[[1927,1439,14]]],["intel unknown","",0,[[1920,1080,37]]],["intel xe","xe",0,[[1920,1080,268],[2560,1440,137]]],["intel xeon e3-1200 v3 gen core processor integrated graphics controller","3",0,[[1600,900,49]]]]\')},217:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["nvidia %nvidia_dev.13d7.0580.1028%","13",0,[[1920,1018,60]]],["nvidia a100-pcie-40gb","100",0,[[1920,1080,449]]],["nvidia a40","40",0,[[1920,1080,504]]],["nvidia a40-8q","40",0,[[2560,1440,58]]],["nvidia ashley","",0,[[1920,1080,60]]],["nvidia asus geforce gt 430","430",0,[[1366,768,35]]],["nvidia asus geforce gt 440","440",0,[[1920,1080,28]]],["nvidia asus geforce gt 520","520",0,[[1680,1050,12]]],["nvidia asus geforce gt 610","610",0,[[1920,1200,15]]],["nvidia asus geforce gt 630","630",0,[[1680,1050,41]]],["nvidia asus geforce gt 640","640",0,[[2560,1440,34]]],["nvidia asus geforce gt 710","710",0,[[1920,1080,31]]],["nvidia asus geforce gt 730","730",0,[[2560,1080,28],[3840,2160,12]]],["nvidia asus geforce gts 450","450",0,[[1920,1080,54]]],["nvidia asus geforce gtx 1060","1060",0,[[3840,2160,38]]],["nvidia asus geforce gtx 1080","1080",0,[[2560,1440,120]]],["nvidia asus geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia asus geforce gtx 480","480",0,[[1920,1080,59]]],["nvidia asus geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia asus geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia asus geforce gtx 560 se","560",0,[[1920,1080,59]]],["nvidia asus geforce gtx 560 ti","560",0,[[1680,1050,58]]],["nvidia asus geforce gtx 570","570",0,[[1280,1024,74]]],["nvidia asus geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia asus geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia asus geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia asus geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia asus geforce gtx 750 ti","750",0,[[1360,768,59],[1920,1080,118]]],["nvidia asus geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia asus geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia asus geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia asus geforce gtx 950","950",0,[[1920,1080,60]]],["nvidia asus geforce gtx 960","960",0,[[1920,1080,60],[2560,1600,117]]],["nvidia asus geforce gtx 970","970",0,[[2560,1600,60]]],["nvidia asus geforce gtx 980 ti","980",0,[[2560,1440,131]]],["nvidia chip model","",0,[[1920,1080,60]]],["nvidia colorful geforce gtx 960","960",0,[[2560,1440,60]]],["nvidia dell nvs 5200m","5200",0,[[1920,1080,27]]],["nvidia dell quadro 2000m","2000",0,[[1920,1080,29]]],["nvidia device","",0,[[1920,1080,746]]],["nvidia elitegroup geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia evga geforce gt 545","545",0,[[1920,1080,37]]],["nvidia evga geforce gt 640","640",0,[[1366,768,60]]],["nvidia evga geforce gt 710","710",0,[[1680,1050,36],[1920,1080,29]]],["nvidia evga geforce gt 730","730",0,[[1600,900,59]]],["nvidia evga geforce gt 740","740",0,[[1280,1024,45]]],["nvidia evga geforce gtx 1050 ti","1050",0,[[2560,1440,60],[4096,2304,58]]],["nvidia evga geforce gtx 1070","1070",0,[[5120,2880,60]]],["nvidia evga geforce gtx 1080 ti","1080",0,[[1920,1200,60]]],["nvidia evga geforce gtx 560 ti","560",0,[[1680,1050,59]]],["nvidia evga geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia evga geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia evga geforce gtx 650","650",0,[[1920,1200,87],[2560,1600,43]]],["nvidia evga geforce gtx 650 ti","650",0,[[1680,1050,116],[2560,1440,55]]],["nvidia evga geforce gtx 650 ti boost","650",0,[[1920,1080,56]]],["nvidia evga geforce gtx 660 ti","660",0,[[1920,1200,60]]],["nvidia evga geforce gtx 680","680",0,[[1600,1200,60]]],["nvidia evga geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia evga geforce gtx 760","760",0,[[1920,1080,119],[1920,1200,60]]],["nvidia evga geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia evga geforce gtx 960","960",0,[[1920,1080,60],[2560,1440,115]]],["nvidia evga geforce gtx 970","970",0,[[1920,1080,120]]],["nvidia evga geforce gtx 980","980",0,[[3440,1440,60]]],["nvidia evga geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia ga104gl [rtx a4000]","104",0,[[3840,2160,60]]],["nvidia gainward geforce gt 630","630",0,[[1920,1080,28]]],["nvidia gainward geforce gts 450","450",0,[[1920,1080,55]]],["nvidia gainward geforce gtx 460","460",0,[[1920,1080,58]]],["nvidia gainward geforce gtx 550 ti","550",0,[[1280,1024,67]]],["nvidia gainward geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia gainward geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia geforce 210","210",0,[[1920,1080,8]]],["nvidia geforce 410m","410",0,[[1366,768,25],[1600,900,19]]],["nvidia geforce 510","510",0,[[1280,960,20]]],["nvidia geforce 605","605",0,[[1768,992,17],[1920,1080,15]]],["nvidia geforce 610m","610",0,[[1366,768,26]]],["nvidia geforce 610m/710m/810m/820m / gt 620m/625m/630m/720m","610",0,[[1366,768,51]]],["nvidia geforce 615","615",0,[[1920,1080,21]]],["nvidia geforce 705m","705",0,[[1920,1080,18]]],["nvidia geforce 710a","710",0,[[1920,1080,32]]],["nvidia geforce 710m","710",0,[[1366,768,55]]],["nvidia geforce 730a","730",0,[[1920,1080,37]]],["nvidia geforce 800m","800",0,[[1920,1080,18]]],["nvidia geforce 810m","810",0,[[1366,768,44],[1920,1080,31]]],["nvidia geforce 820a","820",0,[[1920,1080,28]]],["nvidia geforce 820m","820",0,[[1366,768,57],[1920,1080,23]]],["nvidia geforce 830a","830",0,[[1920,1080,53]]],["nvidia geforce 830m","830",0,[[1366,768,60]]],["nvidia geforce 8400 gs","8400",0,[[1680,1050,4]]],["nvidia geforce 8400 gs rev. 3","8400",0,[[1920,1080,4]]],["nvidia geforce 840a","840",0,[[1920,1080,56]]],["nvidia geforce 840m","840",0,[[1920,1080,56]]],["nvidia geforce 845m","845",0,[[1920,1080,59]]],["nvidia geforce 8600 gt","8600",1,[[1920,1200,-1]]],["nvidia geforce 8600 gts","8600",1,[[1920,1080,-1]]],["nvidia geforce 910m","910",0,[[1366,768,58],[1600,900,45]]],["nvidia geforce 920m","920",0,[[1366,768,60]]],["nvidia geforce 920mx","920",0,[[1366,768,60],[1920,1080,60]]],["nvidia geforce 9300 / nforce 730i","9300",0,[[1920,1080,6]]],["nvidia geforce 930a","930",0,[[1920,1080,55]]],["nvidia geforce 930m","930",0,[[1366,768,60]]],["nvidia geforce 930mx","930",0,[[1366,768,89],[1920,1080,59]]],["nvidia geforce 9400 gt","9400",1,[[1366,768,-1]]],["nvidia geforce 940a","940",0,[[1920,1080,58]]],["nvidia geforce 940m","940",0,[[1920,1080,54]]],["nvidia geforce 940mx","940",0,[[1920,1080,60]]],["nvidia geforce 945m","945",0,[[1920,1080,59]]],["nvidia geforce 9600 gt","9600",0,[[1920,1200,2]]],["nvidia geforce 9600m gt","9600",1,[[1440,900,-1]]],["nvidia geforce 9800 gt","9800",0,[[1920,1200,52]]],["nvidia geforce 9800 gtx / 9800 gtx+","9800",0,[[1280,1024,59]]],["nvidia geforce gpu","gpu",0,[[3000,2000,36]]],["nvidia geforce gt 1010","1010",0,[[1920,1080,135]]],["nvidia geforce gt 1030","1030",0,[[1920,1080,60]]],["nvidia geforce gt 1030 opengl engine","1030",0,[[6720,3780,15]]],["nvidia geforce gt 120","120",1,[[1920,1080,-1]]],["nvidia geforce gt 240","240",0,[[1366,768,32]]],["nvidia geforce gt 320m","320",0,[[1366,768,26]]],["nvidia geforce gt 415m","415",0,[[1366,768,19]]],["nvidia geforce gt 420","420",0,[[1024,768,33],[1920,1080,20]]],["nvidia geforce gt 420m","420",0,[[1366,768,28]]],["nvidia geforce gt 425m","425",0,[[1366,768,55],[1600,900,28]]],["nvidia geforce gt 430","430",0,[[1600,1200,16],[1920,1080,28]]],["nvidia geforce gt 435m","435",0,[[1366,768,53],[1920,1080,22]]],["nvidia geforce gt 440","440",0,[[1280,1024,51],[1680,1050,38],[1920,1080,45]]],["nvidia geforce gt 445m","445",0,[[1600,900,53]]],["nvidia geforce gt 520","520",0,[[1440,900,19],[1920,1080,17]]],["nvidia geforce gt 520m","520",0,[[1366,768,29]]],["nvidia geforce gt 520mx","520",0,[[1366,768,35]]],["nvidia geforce gt 525m","525",0,[[1366,768,28],[1600,900,22]]],["nvidia geforce gt 530","530",0,[[1920,1080,26]]],["nvidia geforce gt 540m","540",0,[[1366,768,38]]],["nvidia geforce gt 545","545",0,[[1920,1080,54]]],["nvidia geforce gt 550m","550",0,[[1600,900,44],[1920,1080,29]]],["nvidia geforce gt 555m","555",0,[[1920,1080,42]]],["nvidia geforce gt 555m/635m","555",0,[[1920,1080,36]]],["nvidia geforce gt 610","610",0,[[1280,1024,22],[1920,1080,15]]],["nvidia geforce gt 620","620",0,[[1920,1080,19]]],["nvidia geforce gt 620 oem","620",0,[[1920,1080,20],[1920,1200,20]]],["nvidia geforce gt 620m","620",0,[[1366,768,55],[1920,1080,30]]],["nvidia geforce gt 620m/630m/635m/640m le","620",0,[[1368,768,38]]],["nvidia geforce gt 625","625",0,[[1920,1080,18]]],["nvidia geforce gt 625m","625",0,[[1366,768,38]]],["nvidia geforce gt 630","630",0,[[1680,1050,36],[1920,1080,36],[1920,1200,30]]],["nvidia geforce gt 630 oem","630",0,[[1600,900,33]]],["nvidia geforce gt 630 opengl engine","630",0,[[1920,1080,33]]],["nvidia geforce gt 630 rev. 2","630",0,[[1920,1080,26]]],["nvidia geforce gt 630m","630",0,[[1366,768,57]]],["nvidia geforce gt 635","635",0,[[1920,1080,27]]],["nvidia geforce gt 635m","635",0,[[1366,768,47]]],["nvidia geforce gt 640","640",0,[[1920,1080,47]]],["nvidia geforce gt 640 oem","640",0,[[1920,1080,46],[2560,1440,35]]],["nvidia geforce gt 640 opengl engine","640",0,[[1280,1024,43]]],["nvidia geforce gt 640 rev. 2","640",0,[[1280,1024,60],[1920,1080,55]]],["nvidia geforce gt 640m","640",0,[[1366,768,82],[1600,900,59],[1920,1080,34]]],["nvidia geforce gt 640m le","640",0,[[1920,1080,49]]],["nvidia geforce gt 640m mac","640",0,[[1366,768,56],[1920,1080,20]]],["nvidia geforce gt 640m opengl engine","640",0,[[1920,1080,45]]],["nvidia geforce gt 645m","645",0,[[1366,768,60]]],["nvidia geforce gt 650m","650",0,[[1360,768,59],[1920,1080,58],[2560,1440,59]]],["nvidia geforce gt 650m mac","650",0,[[1440,900,56],[1920,1080,15],[2560,1440,19],[2880,1800,31]]],["nvidia geforce gt 650m opengl engine","650",0,[[1920,1080,56],[3840,2160,27]]],["nvidia geforce gt 705","705",0,[[1920,1080,11]]],["nvidia geforce gt 710","710",0,[[1920,1080,28]]],["nvidia geforce gt 710b","710",0,[[1920,1080,26]]],["nvidia geforce gt 710m","710",0,[[1366,768,46]]],["nvidia geforce gt 720","720",0,[[1920,1080,19],[2560,1440,16],[5120,2880,5]]],["nvidia geforce gt 720 opengl engine","720",0,[[2560,1600,20]]],["nvidia geforce gt 720m","720",0,[[1366,768,42]]],["nvidia geforce gt 730","730",0,[[1920,1080,54]]],["nvidia geforce gt 730a","730",0,[[1920,1080,23]]],["nvidia geforce gt 730m","730",0,[[1920,1080,43]]],["nvidia geforce gt 735m","735",0,[[1920,1080,39]]],["nvidia geforce gt 740","740",0,[[1920,1080,55],[3440,1440,23]]],["nvidia geforce gt 740 opengl engine","740",0,[[1920,1200,51]]],["nvidia geforce gt 740m","740",0,[[1366,768,60]]],["nvidia geforce gt 745m","745",0,[[1920,1080,55]]],["nvidia geforce gt 750m","750",0,[[1920,1080,57]]],["nvidia geforce gt 750m mac","750",0,[[1920,1080,58],[2880,1800,28]]],["nvidia geforce gt 755m","755",0,[[1920,1080,57]]],["nvidia geforce gt 755m mac","755",0,[[2560,1440,41]]],["nvidia geforce gt 755m opengl engine","755",0,[[2560,1440,51]]],["nvidia geforce gt 820m","820",0,[[1600,900,47]]],["nvidia geforce gts 250","250",0,[[1680,1050,53]]],["nvidia geforce gts 450","450",0,[[1360,768,60],[1680,1050,57],[1920,1080,55]]],["nvidia geforce gts 450 rev. 2","450",0,[[1920,1080,56]]],["nvidia geforce gtx 1050","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 3gb","1050",0,[[1280,1024,60]]],["nvidia geforce gtx 1050 mobile","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 opengl engine","1050",0,[[1920,1080,116]]],["nvidia geforce gtx 1050 ti","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti mobile","1050",0,[[1920,1080,298]]],["nvidia geforce gtx 1050 ti opengl engine","1050",0,[[1920,1080,60]]],["nvidia geforce gtx 1050 ti with max-q design","1050",0,[[1920,1080,268],[2560,1440,102],[3840,2160,60]]],["nvidia geforce gtx 1050 with max-q design","1050",0,[[1920,1080,60],[3840,2160,24]]],["nvidia geforce gtx 1060","1060",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1060 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 3gb opengl engine","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 5gb","1060",0,[[1920,1080,55]]],["nvidia geforce gtx 1060 6gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060 6gb opengl engine","1060",0,[[1920,1080,75]]],["nvidia geforce gtx 1060 mobile","1060",0,[[1920,1080,422]]],["nvidia geforce gtx 1060 mobile 6gb","1060",0,[[1920,1080,120]]],["nvidia geforce gtx 1060 with max-q design","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1060se 3gb","1060",0,[[1920,1080,60]]],["nvidia geforce gtx 1070","1070",0,[[1920,1080,134]]],["nvidia geforce gtx 1070 a17","1070",0,[[1920,1080,60]]],["nvidia geforce gtx 1070 mobile","1070",0,[[1920,1080,467]]],["nvidia geforce gtx 1070 opengl engine","1070",0,[[1920,1080,143]]],["nvidia geforce gtx 1070 ti","1070",0,[[1920,1080,60],[6016,3384,59]]],["nvidia geforce gtx 1070 ti opengl engine","1070",0,[[1920,1080,75]]],["nvidia geforce gtx 1070 with max-q design","1070",0,[[1920,1080,448]]],["nvidia geforce gtx 1070 with maxq design","1070",0,[[1920,1080,60],[3840,2160,59]]],["nvidia geforce gtx 1080","1080",0,[[1920,1080,119],[2560,1440,326],[3840,2160,286]]],["nvidia geforce gtx 1080 mobile","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 opengl engine","1080",0,[[1920,1080,79]]],["nvidia geforce gtx 1080 ti","1080",0,[[1920,1080,120]]],["nvidia geforce gtx 1080 ti opengl engine","1080",0,[[1920,1080,127]]],["nvidia geforce gtx 1080 with max-q design","1080",0,[[1920,1080,144]]],["nvidia geforce gtx 1180","1180",0,[[3440,1440,60]]],["nvidia geforce gtx 1650","1650",0,[[1920,1080,380]]],["nvidia geforce gtx 1650 mobile / max-q","1650",0,[[1920,1080,292]]],["nvidia geforce gtx 1650 super","1650",0,[[1920,1080,433]]],["nvidia geforce gtx 1650 ti","1650",0,[[1920,1080,144],[3840,2400,59]]],["nvidia geforce gtx 1650 ti mobile","1650",0,[[1920,1080,144]]],["nvidia geforce gtx 1650 ti with max-q design","1650",0,[[1920,1080,60],[3839,2160,60]]],["nvidia geforce gtx 1650 with max-q design","1650",0,[[1920,1080,142],[3000,2000,60]]],["nvidia geforce gtx 1660","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 1660 super","1660",0,[[1920,1080,60]]],["nvidia geforce gtx 1660 ti","1660",0,[[1920,1080,546],[3840,2160,60]]],["nvidia geforce gtx 1660 ti mobile","1660",0,[[1920,1080,451]]],["nvidia geforce gtx 1660 ti with max-q design","1660",0,[[1920,1080,144]]],["nvidia geforce gtx 280","280",0,[[1680,1050,56]]],["nvidia geforce gtx 295","295",0,[[1920,1080,56]]],["nvidia geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia geforce gtx 460 oem","460",0,[[1360,768,60],[1920,1080,60]]],["nvidia geforce gtx 460 opengl engine","460",0,[[1920,1080,59]]],["nvidia geforce gtx 460 se","460",0,[[1920,1080,56],[1920,1200,57]]],["nvidia geforce gtx 460 v2","460",0,[[1920,1080,60],[1920,1200,60],[2560,1600,55]]],["nvidia geforce gtx 460m","460",0,[[1920,1080,46]]],["nvidia geforce gtx 465","465",0,[[1920,1080,134],[1920,1200,59]]],["nvidia geforce gtx 470","470",0,[[1680,1050,60],[1920,1080,59]]],["nvidia geforce gtx 470m","470",0,[[1920,1200,55]]],["nvidia geforce gtx 480","480",0,[[1440,900,191],[1920,1080,115],[1920,1200,60]]],["nvidia geforce gtx 480 opengl engine","480",0,[[1600,1200,60]]],["nvidia geforce gtx 550 ti","550",0,[[1280,1024,58],[1920,1080,58]]],["nvidia geforce gtx 550 ti opengl engine","550",0,[[1920,1080,55]]],["nvidia geforce gtx 555","555",0,[[1920,1080,54]]],["nvidia geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 se","560",0,[[1680,1050,52],[1920,1080,111]]],["nvidia geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia geforce gtx 560 ti 448 cores","560",0,[[1920,1080,60],[2560,1440,60]]],["nvidia geforce gtx 560 ti oem","560",0,[[1920,1080,176]]],["nvidia geforce gtx 560 ti opengl engine","560",0,[[1920,1080,48]]],["nvidia geforce gtx 560m","560",0,[[1920,1080,55]]],["nvidia geforce gtx 570","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 opengl engine","570",0,[[1920,1080,60]]],["nvidia geforce gtx 570 rev. 2","570",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 570m","570",0,[[1920,1080,125],[2560,1440,8]]],["nvidia geforce gtx 580","580",0,[[1920,1080,60]]],["nvidia geforce gtx 580 opengl engine","580",0,[[1680,1050,59]]],["nvidia geforce gtx 580m","580",0,[[1920,1080,60]]],["nvidia geforce gtx 590","590",0,[[1920,1080,59]]],["nvidia geforce gtx 645","645",0,[[1920,1080,57],[1920,1200,58]]],["nvidia geforce gtx 645 opengl engine","645",0,[[1920,1200,58]]],["nvidia geforce gtx 650","650",0,[[1920,1080,72]]],["nvidia geforce gtx 650 oem","650",0,[[1366,768,59]]],["nvidia geforce gtx 650 opengl engine","650",0,[[1920,1080,59]]],["nvidia geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia geforce gtx 650 ti boost","650",0,[[1280,1024,60],[1600,1200,187],[1920,1080,60]]],["nvidia geforce gtx 650 ti opengl engine","650",0,[[1920,1080,60]]],["nvidia geforce gtx 660","660",0,[[1920,1080,111]]],["nvidia geforce gtx 660 oem","660",0,[[1920,1080,59]]],["nvidia geforce gtx 660 ti","660",0,[[1920,1080,60]]],["nvidia geforce gtx 660 ti opengl engine","660",0,[[1280,1024,60]]],["nvidia geforce gtx 660m","660",0,[[1680,1050,36],[1920,1080,59]]],["nvidia geforce gtx 660m mac","660",0,[[2560,1440,2]]],["nvidia geforce gtx 660m opengl engine","660",0,[[2560,1440,36]]],["nvidia geforce gtx 670","670",0,[[1920,1080,100]]],["nvidia geforce gtx 670 opengl engine","670",0,[[1920,1080,60]]],["nvidia geforce gtx 670m","670",0,[[1920,1080,66]]],["nvidia geforce gtx 670mx","670",0,[[1920,1080,60]]],["nvidia geforce gtx 675m","675",0,[[1920,1080,60]]],["nvidia geforce gtx 675mx","675",0,[[1680,1050,60],[1920,1080,60],[2560,1440,55]]],["nvidia geforce gtx 675mx mac","675",0,[[2560,1440,36]]],["nvidia geforce gtx 675mx opengl engine","675",0,[[2560,1440,60]]],["nvidia geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680 opengl engine","680",0,[[1920,1080,60]]],["nvidia geforce gtx 680m","680",0,[[1920,1080,39],[1920,1200,60]]],["nvidia geforce gtx 680m opengl engine","680",0,[[1920,1080,36]]],["nvidia geforce gtx 680mx","680",0,[[2560,1440,59]]],["nvidia geforce gtx 680mx opengl engine","680",0,[[2560,1440,59]]],["nvidia geforce gtx 690","690",0,[[1920,1080,60],[3840,2160,30]]],["nvidia geforce gtx 745","745",0,[[1920,1080,60],[2560,1600,29]]],["nvidia geforce gtx 750","750",0,[[1920,1080,60]]],["nvidia geforce gtx 750 opengl engine","750",0,[[1920,1200,58]]],["nvidia geforce gtx 750 ti","750",0,[[1920,1080,97]]],["nvidia geforce gtx 760","760",0,[[1920,1080,60],[1920,1200,116]]],["nvidia geforce gtx 760 oem","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760 opengl engine","760",0,[[1920,1080,52]]],["nvidia geforce gtx 760 ti","760",0,[[1920,1080,60],[1920,1200,60]]],["nvidia geforce gtx 760 ti oem","760",0,[[1920,1200,60]]],["nvidia geforce gtx 760 ti opengl engine","760",0,[[1920,1080,60]]],["nvidia geforce gtx 760a","760",0,[[2560,1080,15]]],["nvidia geforce gtx 760m","760",0,[[1920,1080,60]]],["nvidia geforce gtx 765m","765",0,[[1920,1080,53],[2560,1440,57]]],["nvidia geforce gtx 765m by nick[d]vb","765",0,[[2560,1440,58]]],["nvidia geforce gtx 765m opengl engine","765",0,[[2560,1440,57]]],["nvidia geforce gtx 770","770",0,[[1920,1080,143],[2560,1440,203]]],["nvidia geforce gtx 770 opengl engine","770",0,[[1920,1080,60]]],["nvidia geforce gtx 770m","770",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 770m by nick[d]vb","770",0,[[2560,1440,34]]],["nvidia geforce gtx 770m opengl engine","770",0,[[2560,1440,59]]],["nvidia geforce gtx 775m by idopt mac","775",0,[[2560,1440,56]]],["nvidia geforce gtx 775m mac","775",0,[[2560,1440,59]]],["nvidia geforce gtx 775m opengl engine","775",0,[[2560,1440,60]]],["nvidia geforce gtx 780","780",0,[[1920,1080,159]]],["nvidia geforce gtx 780 by st3phl3","780",0,[[3840,2160,30]]],["nvidia geforce gtx 780 mac","780",0,[[1680,1050,60],[1920,1080,60]]],["nvidia geforce gtx 780 rev. 2","780",0,[[1920,1080,144],[2560,1440,119],[3840,2160,58],[5120,2880,58]]],["nvidia geforce gtx 780 ti","780",0,[[1280,1024,120],[1920,1080,119]]],["nvidia geforce gtx 780 ti opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m","780",0,[[1920,1080,60],[2560,1440,59]]],["nvidia geforce gtx 780m by nick[d]vb","780",0,[[1920,1080,59],[2560,1440,60]]],["nvidia geforce gtx 780m mac","780",0,[[2560,1440,60]]],["nvidia geforce gtx 780m opengl engine","780",0,[[2560,1440,60]]],["nvidia geforce gtx 850a","850",0,[[2560,1440,48]]],["nvidia geforce gtx 850m","850",0,[[1920,1080,60]]],["nvidia geforce gtx 860m","860",0,[[1920,1080,59]]],["nvidia geforce gtx 860m opengl engine","860",0,[[2560,1440,58]]],["nvidia geforce gtx 870m","870",0,[[1920,1080,60],[2560,1440,102]]],["nvidia geforce gtx 880m","880",0,[[1920,1080,60],[2560,1440,74]]],["nvidia geforce gtx 880m opengl engine","880",0,[[2560,1440,60]]],["nvidia geforce gtx 950","950",0,[[1920,1080,98]]],["nvidia geforce gtx 950 opengl engine","950",0,[[1920,1200,60]]],["nvidia geforce gtx 950a","950",0,[[1920,1080,60],[3840,2160,38]]],["nvidia geforce gtx 950m","950",0,[[1920,1080,114]]],["nvidia geforce gtx 960","960",0,[[1920,1080,60]]],["nvidia geforce gtx 960a","960",0,[[1920,1440,128]]],["nvidia geforce gtx 960m","960",0,[[1920,1080,119],[3840,2160,37]]],["nvidia geforce gtx 965m","965",0,[[1920,1080,195],[3000,2000,59],[3840,2160,41]]],["nvidia geforce gtx 965m opengl engine","965",0,[[2880,1620,55]]],["nvidia geforce gtx 970","970",0,[[1920,1080,143]]],["nvidia geforce gtx 970 opengl engine","970",0,[[2560,1600,60]]],["nvidia geforce gtx 970m","970",0,[[1920,1080,60]]],["nvidia geforce gtx 980","980",0,[[1920,1080,60],[3440,1440,294]]],["nvidia geforce gtx 980 ti","980",0,[[1920,1080,119],[2560,1440,456]]],["nvidia geforce gtx 980 ti opengl engine","980",0,[[1920,1080,60]]],["nvidia geforce gtx 980m","980",0,[[1920,1080,60],[3840,2160,104]]],["nvidia geforce gtx titan","gtx",0,[[1920,1080,119],[1920,1200,119],[2560,1440,60]]],["nvidia geforce gtx titan black","gtx",0,[[1680,1050,60],[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia geforce gtx titan black opengl engine","gtx",0,[[3840,2160,60]]],["nvidia geforce gtx titan opengl engine","gtx",0,[[2560,1440,60]]],["nvidia geforce gtx titan x","gtxx",0,[[1920,1080,144],[2560,1440,120],[2560,1600,60]]],["nvidia geforce gtx titan xp","gtxxp",0,[[2560,1440,60],[3440,1440,60]]],["nvidia geforce gtx titan z","gtxz",0,[[1440,900,59],[1920,1080,39],[3840,2160,60]]],["nvidia geforce gtx780m by nikey22","780",0,[[2560,1440,60]]],["nvidia geforce gtx870m by nikey22","870",0,[[2560,1440,60]]],["nvidia geforce gtx880m","880",0,[[1920,1080,60]]],["nvidia geforce gtx880m by nikey22","880",0,[[2560,1440,59]]],["nvidia geforce gtx880m opengl engine","880",0,[[2560,1440,59]]],["nvidia geforce mx110","110",0,[[1366,768,61],[1920,1080,57]]],["nvidia geforce mx130","130",0,[[1920,1080,60]]],["nvidia geforce mx150","150",0,[[1920,1080,113]]],["nvidia geforce mx230","230",0,[[1920,1080,60]]],["nvidia geforce mx250","250",0,[[1920,1080,60]]],["nvidia geforce mx330","330",0,[[1920,1080,60],[3840,2160,51]]],["nvidia geforce mx350","350",0,[[1920,1080,60]]],["nvidia geforce mx450","450",0,[[1920,1080,60]]],["nvidia geforce pre-release graphics device","pre",0,[[2560,1440,60]]],["nvidia geforce pre-release tesla c2075 opengl engine","2075",0,[[1600,900,59]]],["nvidia geforce pre-release titan x opengl engine","prex",0,[[1920,1080,60]]],["nvidia geforce pre-release titan xp collectors edition opengl e","prexpe",0,[[1920,1080,59]]],["nvidia geforce pre-release titan xp opengl engine","prexp",0,[[2560,1440,60]]],["nvidia geforce rtx 2060","2060",0,[[1920,1080,512]]],["nvidia geforce rtx 2060 max-q","2060",0,[[2560,1440,301]]],["nvidia geforce rtx 2060 mobile","2060",0,[[1920,1080,518]]],["nvidia geforce rtx 2060 rev. a","2060",0,[[3840,2160,257]]],["nvidia geforce rtx 2060 super","2060",0,[[1920,1080,645],[2560,1440,143]]],["nvidia geforce rtx 2060 with max-q design","2060",0,[[1920,1080,292],[1920,1200,60]]],["nvidia geforce rtx 2070","2070",0,[[1920,1080,60],[3840,2160,60]]],["nvidia geforce rtx 2070 mobile","2070",0,[[1920,1080,477]]],["nvidia geforce rtx 2070 mobile / max-q","2070",0,[[1920,1080,526]]],["nvidia geforce rtx 2070 mobile / max-q refresh","2070",0,[[1920,1080,143]]],["nvidia geforce rtx 2070 rev. a","2070",0,[[2560,1440,144]]],["nvidia geforce rtx 2070 super","2070",0,[[1920,1080,510]]],["nvidia geforce rtx 2070 super with max-q design","2070",0,[[1920,1080,300]]],["nvidia geforce rtx 2070 with max-q design","2070",0,[[1920,1080,240]]],["nvidia geforce rtx 2080","2080",0,[[1920,1080,632],[2560,1440,165]]],["nvidia geforce rtx 2080 mobile","2080",0,[[1920,1080,144]]],["nvidia geforce rtx 2080 rev. a","2080",0,[[2560,1440,143]]],["nvidia geforce rtx 2080 super","2080",0,[[1920,1080,601]]],["nvidia geforce rtx 2080 super mobile / max-q","2080",0,[[3840,2160,59]]],["nvidia geforce rtx 2080 super with max-q design","2080",0,[[1920,1080,300]]],["nvidia geforce rtx 2080 ti","2080",0,[[1920,1080,83]]],["nvidia geforce rtx 2080 ti rev. a","2080",0,[[1920,1080,403]]],["nvidia geforce rtx 2080 with max-q design","2080",0,[[1920,1080,476]]],["nvidia geforce rtx 3050","3050",0,[[1920,1080,60]]],["nvidia geforce rtx 3050 laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3050 ti laptop gpu","3050",0,[[1920,1080,144]]],["nvidia geforce rtx 3060","3060",0,[[1920,1080,674]]],["nvidia geforce rtx 3060 laptop gpu","3060",0,[[1920,1080,300]]],["nvidia geforce rtx 3060 lite hash rate","3060",0,[[1920,1080,60]]],["nvidia geforce rtx 3060 mobile / max-q","3060",0,[[1920,1080,435]]],["nvidia geforce rtx 3060 ti","3060",0,[[1920,1080,779]]],["nvidia geforce rtx 3070","3070",0,[[1920,1080,723],[2560,1440,294]]],["nvidia geforce rtx 3070 laptop gpu","3070",0,[[1920,1080,357]]],["nvidia geforce rtx 3070 mobile / max-q","3070",0,[[2560,1440,386]]],["nvidia geforce rtx 3070 ti","3070",0,[[1920,1080,60]]],["nvidia geforce rtx 3080","3080",0,[[1920,1080,726],[2560,1440,60],[3840,2160,60]]],["nvidia geforce rtx 3080 laptop gpu","3080",0,[[1920,1080,294],[2560,1440,244]]],["nvidia geforce rtx 3080 mobile / max-q 8gb/16gb","3080",0,[[1920,1080,293]]],["nvidia geforce rtx 3080 ti","3080",0,[[1920,1080,239],[2560,1440,60]]],["nvidia geforce rtx 3090","3090",0,[[2560,1440,60],[3840,2160,474]]],["nvidia geforce rtx t10-16","10",0,[[2560,1600,3]]],["nvidia geforce rtx t10-8","10",0,[[2560,1600,3]]],["nvidia gf100 board - 10220000","100",0,[[1920,1200,60]]],["nvidia gf117","117",0,[[1920,1080,32]]],["nvidia gigabyte geforce gt 440","440",0,[[1280,1024,34]]],["nvidia gigabyte geforce gt 610","610",0,[[1920,1080,17]]],["nvidia gigabyte geforce gt 630","630",0,[[1920,1080,34]]],["nvidia gigabyte geforce gt 730","730",0,[[1280,1024,38]]],["nvidia gigabyte geforce gts 450","450",0,[[1280,1024,37]]],["nvidia gigabyte geforce gtx 1050 ti","1050",0,[[1920,1080,30]]],["nvidia gigabyte geforce gtx 460","460",0,[[1680,1050,60]]],["nvidia gigabyte geforce gtx 550 ti","550",0,[[1920,1080,57]]],["nvidia gigabyte geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 570 hd","570",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 580","580",0,[[1920,1200,60]]],["nvidia gigabyte geforce gtx 650","650",0,[[1680,1050,55]]],["nvidia gigabyte geforce gtx 650 ti","650",0,[[2560,1440,40]]],["nvidia gigabyte geforce gtx 660","660",0,[[1920,1080,31]]],["nvidia gigabyte geforce gtx 660 ti","660",0,[[5120,2880,29]]],["nvidia gigabyte geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 750","750",0,[[1920,1080,59]]],["nvidia gigabyte geforce gtx 750 ti","750",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 760","760",0,[[3440,1440,17]]],["nvidia gigabyte geforce gtx 770","770",0,[[2560,1440,59]]],["nvidia gigabyte geforce gtx 780 ti","780",0,[[1920,1080,240]]],["nvidia gigabyte geforce gtx 960","960",0,[[1920,1080,142],[1920,1200,120]]],["nvidia gigabyte geforce gtx 970","970",0,[[1920,1080,60]]],["nvidia gigabyte geforce gtx 980","980",0,[[2560,1440,60]]],["nvidia gigabyte geforce gtx 980 ti","980",0,[[1920,1080,60]]],["nvidia gk104 board - 2051b502","104",0,[[2560,1440,60]]],["nvidia gk104 board - 20530501","104",0,[[2560,1440,60]]],["nvidia gk104gl [grid k2]","104",0,[[2560,1343,21]]],["nvidia gk104gl [grid k520]","104",0,[[1024,768,120]]],["nvidia gp102 [titan x]","102",0,[[3440,1440,462]]],["nvidia gp102 [titan xp]","102",0,[[1920,1080,126]]],["nvidia gp104","104",0,[[1920,1080,60]]],["nvidia gp104gl","104",0,[[2560,1343,36]]],["nvidia gp108","108",0,[[1920,1080,60]]],["nvidia graphics device","",0,[[1920,1080,60],[1920,1200,60],[3840,2160,60]]],["nvidia grid gtx p40-6","40",0,[[1440,900,153]]],["nvidia grid k1","1",0,[[1245,768,6],[1920,1080,35]]],["nvidia grid k140q vgpu","140",0,[[1920,1080,30]]],["nvidia grid k160q","160",0,[[1920,1080,34]]],["nvidia grid k180q","180",0,[[1920,1080,28]]],["nvidia grid k2","2",0,[[1245,768,6],[1920,1080,59]]],["nvidia grid k220q","220",0,[[1920,1200,34]]],["nvidia grid k240q","240",0,[[1920,1080,64]]],["nvidia grid k260q","260",0,[[2560,1440,31]]],["nvidia grid k280q","280",0,[[1920,1080,64]]],["nvidia grid k520","520",0,[[1280,720,60]]],["nvidia grid m10-1b","10",0,[[1024,768,49]]],["nvidia grid m10-2q","10",0,[[2560,1440,15]]],["nvidia grid m6-0b","6",0,[[1680,1050,33]]],["nvidia grid m60-1b","60",0,[[1680,1050,46],[1920,1080,46]]],["nvidia grid m60-1q","60",0,[[1536,864,60]]],["nvidia grid m60-2q","60",0,[[1920,1080,57]]],["nvidia grid m60-4q","60",0,[[1920,1080,59]]],["nvidia grid m60-8q","60",0,[[1920,1080,60]]],["nvidia grid p100-4q","100",0,[[2560,1440,16]]],["nvidia grid p4-4q","4",0,[[1892,932,247]]],["nvidia grid p40-4q","40",0,[[2741,1495,60]]],["nvidia grid p40-8q","40",0,[[1920,1080,60]]],["nvidia grid rtx6000-2q","6000",0,[[1024,768,60]]],["nvidia grid rtx6000p-6","6000",0,[[1280,1024,161]]],["nvidia grid t4-16q","4",0,[[1920,1080,61]]],["nvidia grid t4-1b","4",0,[[1920,1080,46]]],["nvidia grid t4-1q","4",0,[[1280,1024,48]]],["nvidia grid t4-2b4","4",0,[[1536,864,47]]],["nvidia grid t4-2q","4",0,[[1920,1080,65]]],["nvidia grid t4-8q","4",0,[[2560,1080,60]]],["nvidia grid v100-1q","100",0,[[1646,1154,59]]],["nvidia grid v100-2b","100",0,[[1440,900,45]]],["nvidia grid v100dx-16q","100",0,[[1280,1024,60]]],["nvidia grid v100dx-1q","100",0,[[1280,1024,60]]],["nvidia gtx 1060 hl","1060",0,[[3840,2160,60]]],["nvidia gtx 865m by imacgfx","865",0,[[2560,1440,60]]],["nvidia gtx 980m sli","980",0,[[1366,768,29]]],["nvidia gv-n660oc-2gd","660",0,[[1920,1200,60]]],["nvidia gv100","100",0,[[3840,2160,60]]],["nvidia gv100 [titan v]","100",0,[[2560,1440,60]]],["nvidia gv102","102",0,[[2560,1600,525]]],["nvidia hp geforce gt 730","730",0,[[1920,1080,55]]],["nvidia hp quadro 2000","2000",0,[[2560,1080,38]]],["nvidia hp quadro 4000","4000",0,[[2560,1080,52]]],["nvidia hp quadro 600","600",0,[[1360,768,41]]],["nvidia hp quadro k4000","4000",0,[[1920,1200,26]]],["nvidia hp quadro k620","620",0,[[1600,1200,94]]],["nvidia inno3d geforce gtx660","3",0,[[2560,1440,107]]],["nvidia microsoft virtual render driver","",0,[[1920,1080,59]]],["nvidia msi geforce gt 610","610",0,[[1920,1080,16]]],["nvidia msi geforce gt 630","630",0,[[1440,900,12]]],["nvidia msi geforce gt 635","635",0,[[1920,1080,30]]],["nvidia msi geforce gt 710","710",0,[[1920,1080,27]]],["nvidia msi geforce gt 730","730",0,[[1920,1080,53]]],["nvidia msi geforce gtx 1050 ti","1050",0,[[1920,1080,59]]],["nvidia msi geforce gtx 1060","1060",0,[[1920,1080,120]]],["nvidia msi geforce gtx 1070","1070",0,[[1920,1200,45]]],["nvidia msi geforce gtx 460","460",0,[[1920,1080,60]]],["nvidia msi geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia msi geforce gtx 570 hd","570",0,[[1920,1200,60]]],["nvidia msi geforce gtx 580","580",0,[[2560,1440,60]]],["nvidia msi geforce gtx 650","650",0,[[2560,1080,52]]],["nvidia msi geforce gtx 650 ti","650",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia msi geforce gtx 660 ti","660",0,[[1680,1050,49]]],["nvidia msi geforce gtx 670","670",0,[[1920,1080,60]]],["nvidia msi geforce gtx 745","745",0,[[1920,1080,55]]],["nvidia msi geforce gtx 760","760",0,[[1280,1024,30],[1920,1080,58]]],["nvidia msi geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia msi geforce gtx 950","950",0,[[1920,1080,59]]],["nvidia msi geforce gtx 960","960",0,[[1680,1050,120],[2560,1440,59]]],["nvidia msi geforce gtx 970","970",0,[[1680,1050,60]]],["nvidia msi geforce gtx 980","980",0,[[1920,1080,120],[3840,2160,60]]],["nvidia msi geforce gtx 980 ti","980",0,[[5120,2880,56]]],["nvidia n15e-gt","15",0,[[3840,2160,30]]],["nvidia null geforce 920a","920",0,[[1920,1080,25]]],["nvidia null graphics device","",0,[[1920,1080,24]]],["nvidia nvs 310","310",0,[[1280,1024,24],[1920,1080,15]]],["nvidia nvs 3100m","3100",0,[[1920,1080,10]]],["nvidia nvs 315","315",0,[[1280,1024,25],[1920,1080,15]]],["nvidia nvs 4200m","4200",0,[[1920,1080,11]]],["nvidia nvs 510","510",0,[[1920,1200,27],[2560,1080,24],[3440,1440,16]]],["nvidia nvs 5200m","5200",0,[[1366,768,55],[1600,900,33],[1920,1080,57]]],["nvidia nvs 5400m","5400",0,[[1600,900,46],[1920,1200,27]]],["nvidia p102-100","102",0,[[1600,1200,35]]],["nvidia p106-090","106",0,[[1920,1371,16]]],["nvidia p106-100","106",0,[[1920,1080,60],[3840,2160,30]]],["nvidia p106-100 custom","106",0,[[1680,1050,60]]],["nvidia palit geforce gtx 650","650",0,[[1920,1080,49]]],["nvidia palit geforce gtx 650 ti","650",0,[[1920,1080,59]]],["nvidia palit geforce gtx 660","660",0,[[1920,1080,26]]],["nvidia palit gtx 680 jetstream","680",0,[[1920,1080,60]]],["nvidia pegatron geforce gt 420","420",0,[[1400,1050,25]]],["nvidia pny geforce gt 610","610",0,[[1280,1024,19]]],["nvidia pny geforce gtx 1060","1060",0,[[1920,1080,60]]],["nvidia pny geforce gtx 460","460",0,[[1360,768,59]]],["nvidia pny geforce gtx 550 ti","550",0,[[1920,1080,55]]],["nvidia pny geforce gtx 570 hd","570",0,[[1280,1024,72]]],["nvidia pny geforce gtx 580","580",0,[[1920,1200,59]]],["nvidia pny geforce gtx 680","680",0,[[2560,1080,120]]],["nvidia pny geforce gtx 750","750",0,[[1280,1024,60]]],["nvidia pny geforce gtx 970","970",0,[[2560,1440,60]]],["nvidia pny geforce gtx 980","980",0,[[1920,1080,120]]],["nvidia point of view geforce gtx 470","470",0,[[1920,1080,59]]],["nvidia point of view geforce gtx 660 ti","660",0,[[1680,1050,59]]],["nvidia quadro 1000m","1000",0,[[1920,1080,28]]],["nvidia quadro 1000m,","1000",0,[[1920,1080,27]]],["nvidia quadro 2000","2000",0,[[1920,1080,51],[2560,1440,28]]],["nvidia quadro 2000d","2000",0,[[1280,1024,56]]],["nvidia quadro 2000m","2000",0,[[1920,1080,31]]],["nvidia quadro 3000m","3000",0,[[1920,1080,53],[2560,1440,6]]],["nvidia quadro 3000m opengl engine","3000",0,[[1920,1080,49]]],["nvidia quadro 4000","4000",0,[[1920,1080,56],[1920,1200,58]]],["nvidia quadro 4000m","4000",0,[[1920,1080,51]]],["nvidia quadro 410","410",0,[[1920,1080,23]]],["nvidia quadro 5000","5000",0,[[1920,1080,60],[2560,1080,55],[2560,1440,51]]],["nvidia quadro 5000 opengl engine","5000",0,[[1920,1200,59]]],["nvidia quadro 5000m","5000",0,[[1600,900,110]]],["nvidia quadro 600","600",0,[[1680,1050,28],[1920,1080,28],[1920,1200,26]]],["nvidia quadro 6000","6000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro 7000","7000",0,[[1920,1200,60]]],["nvidia quadro fx 1800m","1800",0,[[1600,900,15]]],["nvidia quadro fx 2800m","2800",0,[[1920,1200,36]]],["nvidia quadro fx grid k1","1",0,[[1920,1080,31]]],["nvidia quadro gp100","100",0,[[1920,1200,366]]],["nvidia quadro gv100","100",0,[[3840,2160,60],[4096,2160,60]]],["nvidia quadro k1000m","1000",0,[[1920,1080,28]]],["nvidia quadro k1000m by nick[d]vb","1000",0,[[1920,1080,36]]],["nvidia quadro k1100m","1100",0,[[1920,1080,56]]],["nvidia quadro k1100m by nick[d]vb","1100",0,[[1920,1080,66]]],["nvidia quadro k1100m opengl engine","1100",0,[[1920,1080,54]]],["nvidia quadro k1200","1200",0,[[1920,1080,60],[2560,1440,57],[3840,2160,28]]],["nvidia quadro k1200 opengl engine","1200",0,[[3840,2160,34]]],["nvidia quadro k2000","2000",0,[[1920,1080,55]]],["nvidia quadro k2000 opengl engine","2000",0,[[2560,1440,44]]],["nvidia quadro k2000d","2000",0,[[1280,1024,57],[1680,1050,57],[1920,1080,59]]],["nvidia quadro k2000m","2000",0,[[1920,1080,36]]],["nvidia quadro k2000m by nick[d]vb","2000",0,[[2560,1440,38]]],["nvidia quadro k2000m opengl engine","2000",0,[[1920,1080,43]]],["nvidia quadro k2100m","2100",0,[[1920,1080,58]]],["nvidia quadro k2100m by nick[d]vb","2100",0,[[2560,1440,54]]],["nvidia quadro k2100m opengl engine","2100",0,[[1920,1080,59]]],["nvidia quadro k2200","2200",0,[[1920,1080,60],[1920,1200,126],[5120,2880,25]]],["nvidia quadro k2200m","2200",0,[[1920,1080,60]]],["nvidia quadro k3000m","3000",0,[[1920,1080,59]]],["nvidia quadro k3000m by st3phl3","3000",0,[[2560,1440,50]]],["nvidia quadro k3100m","3100",0,[[1920,1080,60]]],["nvidia quadro k3100m by nikey22","3100",0,[[2560,1440,59]]],["nvidia quadro k3100m opengl engine","3100",0,[[2560,1440,58]]],["nvidia quadro k4000","4000",0,[[1920,1080,60],[1920,1200,59]]],["nvidia quadro k4000 opengl engine","4000",0,[[1920,1080,59]]],["nvidia quadro k4000m","4000",0,[[1920,1080,80]]],["nvidia quadro k4100m","4100",0,[[1920,1080,32]]],["nvidia quadro k4100m by nikey22","4100",0,[[2560,1440,60]]],["nvidia quadro k420","420",0,[[1366,768,57],[2560,1440,19],[3840,2160,10]]],["nvidia quadro k4200","4200",0,[[1920,1080,60],[2560,1440,59],[3840,2160,57]]],["nvidia quadro k5000","5000",0,[[1920,1080,60],[2560,1440,60]]],["nvidia quadro k5000 opengl engine","5000",0,[[2560,1600,59]]],["nvidia quadro k5000m","5000",0,[[1920,1080,60],[2560,1440,60]]],["nvidia quadro k5000m opengl engine","5000",0,[[2560,1440,60]]],["nvidia quadro k5100m","5100",0,[[1920,1080,60],[2560,1080,171]]],["nvidia quadro k5100m by nikey22","5100",0,[[2560,1440,60]]],["nvidia quadro k510m","510",0,[[1920,1080,33]]],["nvidia quadro k5200","5200",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro k5200 opengl engine","5200",0,[[1920,1200,41]]],["nvidia quadro k600","600",0,[[1920,1080,28]]],["nvidia quadro k600 opengl engine","600",0,[[1920,1200,31]]],["nvidia quadro k6000","6000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia quadro k6000 opengl engine","6000",0,[[1920,1080,59]]],["nvidia quadro k610m","610",0,[[1920,1080,36]]],["nvidia quadro k610m by nick[d]vb","610",0,[[1920,1080,34]]],["nvidia quadro k620","620",0,[[1920,1080,87],[1920,1200,69],[2560,1440,44]]],["nvidia quadro k620 opengl engine","620",0,[[1920,1080,59]]],["nvidia quadro k620m","620",0,[[1920,1080,49],[2880,1620,15]]],["nvidia quadro m1000m","1000",0,[[1920,1080,60]]],["nvidia quadro m1200","1200",0,[[1920,1080,60],[3840,2160,43]]],["nvidia quadro m2000","2000",0,[[1920,1080,73],[2560,1440,59]]],["nvidia quadro m2000m","2000",0,[[1920,1080,60]]],["nvidia quadro m2000m special","2000",0,[[1920,1080,60]]],["nvidia quadro m2200","2200",0,[[1920,1080,60]]],["nvidia quadro m2200 mobile","2200",0,[[3840,2160,13]]],["nvidia quadro m3000m","3000",0,[[1920,1080,60]]],["nvidia quadro m4000","4000",0,[[1920,1080,120],[1920,1200,60],[2560,1440,60]]],["nvidia quadro m4000 opengl engine","4000",0,[[1920,1080,60]]],["nvidia quadro m4000m","4000",0,[[1920,1080,60],[3840,2160,69]]],["nvidia quadro m5000","5000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,59]]],["nvidia quadro m5000m","5000",0,[[1920,1080,212],[3840,2160,60]]],["nvidia quadro m500m","500",0,[[1920,1080,58],[2880,1620,29]]],["nvidia quadro m520","520",0,[[1920,1080,59],[3840,2160,27]]],["nvidia quadro m5500","5500",0,[[3440,1440,60]]],["nvidia quadro m6000","6000",0,[[1920,1080,408],[2560,1440,60]]],["nvidia quadro m6000 24gb","6000",0,[[1680,1050,60],[1920,1200,60]]],["nvidia quadro m600m","600",0,[[1920,1080,59]]],["nvidia quadro m620","620",0,[[1920,1080,60]]],["nvidia quadro nvs 4200m","4200",0,[[1600,900,26],[1920,1080,19]]],["nvidia quadro p1000","1000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro p1000 mobile","1000",0,[[1920,1080,60]]],["nvidia quadro p2000","2000",0,[[1680,1050,60],[1920,1080,242],[2560,1440,60]]],["nvidia quadro p2000 mobile","2000",0,[[1920,1080,60]]],["nvidia quadro p2000 opengl engine","2000",0,[[1920,1080,59]]],["nvidia quadro p2000 with max-q design","2000",0,[[1920,1080,60],[3840,2160,67]]],["nvidia quadro p2200","2200",0,[[1920,1080,60],[3840,2160,340]]],["nvidia quadro p3000","3000",0,[[1920,1080,60]]],["nvidia quadro p3200","3200",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro p3200 mobile","3200",0,[[3840,2160,60]]],["nvidia quadro p3200 with max-q design","3200",0,[[2560,1440,60]]],["nvidia quadro p400","400",0,[[1680,1050,46],[1920,1080,57],[1920,1200,54]]],["nvidia quadro p4000","4000",0,[[1920,1080,60],[3840,2160,167]]],["nvidia quadro p4200","4200",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro p4200 with max-q design","4200",0,[[3839,2159,53]]],["nvidia quadro p500","500",0,[[1920,1080,60]]],["nvidia quadro p5000","5000",0,[[1920,1080,60]]],["nvidia quadro p5000 opengl engine","5000",0,[[3840,2160,58]]],["nvidia quadro p520","520",0,[[1920,1080,60]]],["nvidia quadro p5200","5200",0,[[3840,2160,100]]],["nvidia quadro p600","600",0,[[1920,1080,60]]],["nvidia quadro p6000","6000",0,[[1920,1080,60],[2560,1440,60],[2560,1600,411]]],["nvidia quadro p620","620",0,[[1920,1080,65]]],["nvidia quadro rtx 3000","3000",0,[[1920,1080,60]]],["nvidia quadro rtx 3000 mobile / max-q","3000",0,[[3840,2160,60]]],["nvidia quadro rtx 3000 with max-q design","3000",0,[[3240,2160,60]]],["nvidia quadro rtx 4000","4000",0,[[1920,1080,60]]],["nvidia quadro rtx 4000 mobile / max-q","4000",0,[[1920,1080,60]]],["nvidia quadro rtx 4000 with max-q design","4000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro rtx 5000","5000",0,[[1920,1080,443],[2560,1440,60]]],["nvidia quadro rtx 5000 mobile / max-q","5000",0,[[3840,2160,60]]],["nvidia quadro rtx 5000 with max-q design","5000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia quadro rtx 6000","6000",0,[[1920,1080,438],[2560,1440,60]]],["nvidia quadro rtx 8000","8000",0,[[1920,1080,60],[1920,1200,60]]],["nvidia quadro t1000","1000",0,[[1920,1080,60],[2560,1440,41]]],["nvidia quadro t1000 mobile","1000",0,[[1920,1080,277]]],["nvidia quadro t1000 with max-q design","1000",0,[[1920,1080,60]]],["nvidia quadro t2000","2000",0,[[1920,1080,60]]],["nvidia quadro t2000 mobile / max-q","2000",0,[[1920,1080,302]]],["nvidia quadro t2000 with max-q design","2000",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["nvidia rtx a1000 laptop gpu","1000",0,[[1920,1080,60]]],["nvidia rtx a2000","2000",0,[[3840,2160,60]]],["nvidia rtx a2000 laptop gpu","2000",0,[[2400,1600,120],[3840,2160,60]]],["nvidia rtx a3000 laptop gpu","3000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia rtx a4000","4000",0,[[1920,1080,60],[3840,2160,60]]],["nvidia rtx a4000 laptop gpu","4000",0,[[1920,1080,60]]],["nvidia rtx a5000","5000",0,[[3840,2160,60]]],["nvidia rtx a5000 laptop gpu","5000",0,[[3840,2160,60]]],["nvidia rtx a6000","6000",0,[[1920,1200,60]]],["nvidia sony geforce 410m","410",0,[[1366,768,24]]],["nvidia t1000","1000",0,[[1920,1080,43],[3840,2160,60]]],["nvidia t1200 laptop gpu","1200",0,[[1920,1080,60]]],["nvidia t400","400",0,[[3840,2160,35]]],["nvidia t500","500",0,[[1920,1080,60],[3839,2159,52]]],["nvidia t600","600",0,[[1920,1080,60]]],["nvidia tesla c2050 / c2070","2050",0,[[1920,1080,105]]],["nvidia tesla c2070","2070",0,[[1920,1200,60]]],["nvidia tesla c2075","2075",0,[[1920,1080,60]]],["nvidia tesla k10","10",0,[[1920,1080,60]]],["nvidia tesla k10.g1.8gb","10",0,[[1440,900,59]]],["nvidia tesla k20m","20",0,[[1240,821,118]]],["nvidia tesla k20xm","20",0,[[3840,2400,17]]],["nvidia tesla k80","80",0,[[1664,896,66],[3840,2160,30]]],["nvidia tesla m10","10",0,[[1440,900,60],[1280,1024,60]]],["nvidia tesla m40","40",0,[[1600,1024,190]]],["nvidia tesla m6","6",0,[[1920,1080,59]]],["nvidia tesla m60","60",0,[[1366,768,60],[1920,962,61],[3840,2160,27]]],["nvidia tesla p100 pcie 16gb","100",0,[[1920,1080,60]]],["nvidia tesla p100-pcie-16gb","100",0,[[1920,1080,103]]],["nvidia tesla p4","4",0,[[1680,1050,60]]],["nvidia tesla p40","40",0,[[1546,877,62],[1920,1200,60]]],["nvidia tesla t4","4",0,[[1440,900,33],[1920,1080,60]]],["nvidia tesla v100-pcie-16gb","100",0,[[1920,997,57]]],["nvidia tesla v100-pcie-32gb","100",0,[[1920,1080,57]]],["nvidia tesla v100-sxm2-16gb","100",0,[[1920,1080,60]]],["nvidia tesla v100-sxm2-32gb","100",0,[[1920,1080,1],[2560,1440,60]]],["nvidia titan rtx","rtx",0,[[2560,1440,60],[3840,2160,680]]],["nvidia titan v","v",0,[[2560,1440,622],[3840,2160,60]]],["nvidia titan x","x",0,[[2560,1080,60],[3840,1600,75],[3840,2160,339]]],["nvidia titan xp","xp",0,[[1920,1200,60],[2560,1440,60],[3440,1440,105]]],["nvidia titan xp collectors","xp",0,[[1920,1080,60],[2560,1440,893],[5120,2880,60]]],["nvidia toshiba geforce gt 525m","525",0,[[1366,768,33]]],["nvidia tu102 [titan rtx]","102",0,[[3840,2160,60]]],["nvidia tu107","107",0,[[1920,1080,312]]],["nvidia tu117m","117",0,[[1920,1080,337]]],["nvidia unknown","",0,[[1920,1080,60]]],["nvidia zotac geforce gt 430","430",0,[[1600,900,32]]],["nvidia zotac geforce gt 610","610",0,[[1920,1080,15]]],["nvidia zotac geforce gt 630","630",0,[[1360,768,46]]],["nvidia zotac geforce gt 740","740",0,[[1280,1024,118]]],["nvidia zotac geforce gtx 460","460",0,[[1920,1080,59]]],["nvidia zotac geforce gtx 550 ti","550",0,[[1920,1080,42]]],["nvidia zotac geforce gtx 560","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 560 ti","560",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 580","580",0,[[1920,1080,48]]],["nvidia zotac geforce gtx 650","650",0,[[1920,1080,44]]],["nvidia zotac geforce gtx 650 ti","650",0,[[1920,1080,58]]],["nvidia zotac geforce gtx 660","660",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 680","680",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 750","750",0,[[1680,1050,114],[1920,1080,60]]],["nvidia zotac geforce gtx 760","760",0,[[1920,1080,101]]],["nvidia zotac geforce gtx 770","770",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 780","780",0,[[1920,1080,60]]],["nvidia zotac geforce gtx 960","960",0,[[2048,1152,60]]]]\')},145:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["amd [amd/ati] fiji [radeon r9 fury / nano series]","9",0,[[1920,1200,162]]],["amd asus amd radeon r9-990x","9",0,[[1920,1080,60]]],["amd asus radeon r7 250","7",0,[[800,638,60]]],["amd asus radeon r7 260x","7",0,[[2560,1080,65]]],["amd asus radeon r9 270x","9",0,[[1024,768,85],[1920,1080,60]]],["amd asus radeon r9 280","9",0,[[1920,1080,60]]],["amd asus radeon rx 460","460",0,[[1360,768,104]]],["amd asus radeon rx 470","470",0,[[1920,1080,60]]],["amd asus radeon rx 480","480",0,[[1920,1080,124]]],["amd asus radeon rx 550","550",0,[[1440,900,60],[1920,1080,49]]],["amd asus radeon rx 5500 xt","5500",0,[[1920,1080,325]]],["amd asus radeon rx 560","560",0,[[1360,768,60],[1920,1080,85]]],["amd asus radeon rx 570","570",0,[[1600,900,202],[1920,1080,60]]],["amd asus radeon rx 5700","5700",0,[[1920,1080,327]]],["amd asus radeon rx 5700 xt","5700",0,[[1920,1080,224],[2560,1440,60]]],["amd asus radeon rx 580","580",0,[[1920,1080,177],[2560,1080,60]]],["amd asus radeon rx vega","rx",0,[[2560,1440,117]]],["amd ati mobility radeon hd 5870","5870",0,[[1920,1200,19]]],["amd baffin amd radeon rx 560","560",0,[[1920,1080,60]]],["amd ellesmere radeon rx 570","570",0,[[1920,1080,60]]],["amd embedded radeon e9171","9171",0,[[3840,2160,26]]],["amd embedded radeon e9173","9173",0,[[3840,2160,16]]],["amd gigabyte radeon rx 580","580",0,[[1920,1080,60]]],["amd madison [mobility radeon hd 5650 / 6530m/6550m]","5650",0,[[1366,768,43]]],["amd mobility radeon hd 4250","4250",0,[[963,722,26]]],["amd mobility radeon hd 5000","5000",0,[[1366,768,47]]],["amd mobility radeon hd 5400","5400",0,[[1366,768,24]]],["amd mobility radeon hd 5430","5430",0,[[1600,900,15],[1920,1080,60]]],["amd mobility radeon hd 5470","5470",0,[[1366,768,24]]],["amd mobility radeon hd 5570","5570",0,[[1920,1080,27]]],["amd mobility radeon hd 5730 / 6570m","5730",0,[[1366,768,58]]],["amd mobility radeon hd 5850","5850",0,[[1600,900,55]]],["amd mobility radeon hd 5870","5870",0,[[1600,900,64],[1920,1200,53]]],["amd park [mobility radeon hd 5430","5430",0,[[1280,720,11]]],["amd pitcairn pro radeon hd 7850","7850",0,[[1920,1080,60]]],["amd powercolor radeon r9 280","9",0,[[1920,1080,60]]],["amd radeon","",0,[[1920,1080,299],[3440,1440,60]]],["amd radeon 500","500",0,[[1920,1080,73]]],["amd radeon 520","520",0,[[1920,1080,35],[2560,1440,29]]],["amd radeon 530","530",0,[[1366,768,60],[1920,1080,30]]],["amd radeon 535","535",0,[[1920,1080,35]]],["amd radeon 535dx","535",0,[[1366,768,31],[1920,1080,37]]],["amd radeon 540","540",0,[[1920,1080,38]]],["amd radeon 540 / rx 540x/550/550x","540",0,[[2560,1440,88]]],["amd radeon 540x","540",0,[[1920,1080,59]]],["amd radeon 550","550",0,[[1920,1080,115]]],["amd radeon 550x","550",0,[[1920,1080,28]]],["amd radeon 610","610",0,[[1920,1080,29]]],["amd radeon 620","620",0,[[1920,1080,18]]],["amd radeon 625","625",0,[[1366,768,55],[1920,1080,47]]],["amd radeon 630","630",0,[[1920,1080,29]]],["amd radeon 6600m and 6700m","6600",0,[[1366,768,36],[1440,900,60]]],["amd radeon 6800","6800",0,[[3440,1440,100]]],["amd radeon 7500m/7600m","7500",0,[[1366,768,37]]],["amd radeon 7950 x2","7950",0,[[2560,1440,174]]],["amd radeon d700","700",0,[[2560,1440,120]]],["amd radeon e6460","6460",0,[[1600,1200,13]]],["amd radeon e6760","6760",0,[[1200,900,54],[1920,1080,42]]],["amd radeon e8860","8860",0,[[1920,1200,27],[2560,1374,88]]],["amd radeon e8870","8870",0,[[1920,1080,81]]],["amd radeon e8870mxm","8870",0,[[1920,1080,60]]],["amd radeon e9260","9260",0,[[1680,1050,60],[3840,2160,38]]],["amd radeon e9550","9550",0,[[1680,1050,60],[3840,2160,58]]],["amd radeon embedded e9560","9560",0,[[1920,1200,60]]],["amd radeon fury","",0,[[1920,1080,60]]],["amd radeon fury x","x",0,[[1920,1080,60],[2560,1440,144]]],["amd radeon hd - firepro d300","300",0,[[1920,1080,60]]],["amd radeon hd - firepro d300 opengl engine","300",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d500 opengl engine","500",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd - firepro d700 opengl engine","700",0,[[3840,2160,52]]],["amd radeon hd 2600 xt","2600",1,[[2560,1600,-1]]],["amd radeon hd 5000","5000",0,[[1920,1080,8]]],["amd radeon hd 5400","5400",0,[[1920,1080,12]]],["amd radeon hd 5450","5450",0,[[1920,1080,13]]],["amd radeon hd 5470","5470",0,[[1280,1024,16]]],["amd radeon hd 5500","5500",0,[[1920,1080,27]]],["amd radeon hd 5570","5570",0,[[1920,1080,60],[2048,1152,31]]],["amd radeon hd 5600","5600",0,[[1920,1080,56]]],["amd radeon hd 5650","5650",0,[[1366,768,53]]],["amd radeon hd 5670","5670",1,[[1920,1080,-1],[2560,1440,-1]]],["amd radeon hd 5670 opengl engine","5670",1,[[2560,1440,-1]]],["amd radeon hd 5700","5700",0,[[1920,1080,59]]],["amd radeon hd 5730","5730",0,[[1366,768,46],[1680,1050,40]]],["amd radeon hd 5750","5750",1,[[1920,1080,-1],[1920,1200,-1],[2560,1440,-1]]],["amd radeon hd 5750 opengl engine","5750",1,[[2560,1440,-1]]],["amd radeon hd 5770","5770",0,[[1776,1000,43],[1920,1080,59]]],["amd radeon hd 5800","5800",0,[[1366,768,60],[1920,1200,102]]],["amd radeon hd 5850","5850",0,[[1920,1080,60]]],["amd radeon hd 5870","5870",0,[[1280,960,75],[1920,1080,60],[2048,1280,60]]],["amd radeon hd 5870m","5870",0,[[2560,1080,31]]],["amd radeon hd 5970","5970",0,[[1360,768,60],[1920,1080,60]]],["amd radeon hd 6230","6230",0,[[1366,768,13]]],["amd radeon hd 6250","6250",0,[[1280,800,8],[1366,768,8]]],["amd radeon hd 6290","6290",1,[[1366,768,-1]]],["amd radeon hd 6300m","6300",1,[[1366,768,-1]]],["amd radeon hd 6310","6310",1,[[1366,768,-1]]],["amd radeon hd 6320","6320",1,[[1366,768,-1]]],["amd radeon hd 6350","6350",0,[[1280,1024,18],[1920,1080,14]]],["amd radeon hd 6370d","6370",0,[[1920,1080,14]]],["amd radeon hd 6370m","6370",0,[[1366,768,25]]],["amd radeon hd 6380g","6380",0,[[1366,768,19]]],["amd radeon hd 6400","6400",0,[[1920,1080,13]]],["amd radeon hd 6400m","6400",0,[[1366,768,28]]],["amd radeon hd 6400m/7400m","6400",0,[[1366,768,28]]],["amd radeon hd 6410d","6410",0,[[1920,1080,11]]],["amd radeon hd 6450","6450",0,[[1920,1080,14]]],["amd radeon hd 6450 / r5 230","6450",0,[[1440,900,12]]],["amd radeon hd 6450 230","6450",0,[[1920,1080,15]]],["amd radeon hd 6470m","6470",0,[[1366,768,27],[1600,900,21]]],["amd radeon hd 6470m/7400m","6470",0,[[1366,768,44]]],["amd radeon hd 6480g","6480",0,[[1280,768,19],[1366,768,27],[1600,900,18]]],["amd radeon hd 6490m","6490",1,[[1366,768,-1],[1440,900,-1],[1680,1050,-1]]],["amd radeon hd 6500","6500",0,[[1920,1080,25]]],["amd radeon hd 6500m/5600","6500",0,[[1920,1080,27]]],["amd radeon hd 6510","6510",0,[[1600,900,32]]],["amd radeon hd 6520g","6520",0,[[1366,768,21],[1600,900,20]]],["amd radeon hd 6530d","6530",0,[[1366,768,31],[1440,900,36],[1920,1080,24]]],["amd radeon hd 6540","6540",0,[[1600,1200,13]]],["amd radeon hd 6550d","6550",0,[[1920,1080,28]]],["amd radeon hd 6570","6570",0,[[1920,1080,52],[2560,1440,17]]],["amd radeon hd 6620g","6620",0,[[1360,768,43],[1366,768,28]]],["amd radeon hd 6630m","6630",1,[[1366,768,-1],[1600,900,-1],[1920,1080,-1]]],["amd radeon hd 6630m/6650m/6750m/7670m/7690m","6630",1,[[1366,768,-1],[1920,1080,-1]]],["amd radeon hd 6650m","6650",0,[[1366,768,51],[1600,900,31]]],["amd radeon hd 6670","6670",0,[[1920,1080,55]]],["amd radeon hd 6700","6700",0,[[1920,1080,56]]],["amd radeon hd 6700 green","6700",0,[[1360,768,89]]],["amd radeon hd 6700m/7700m/7900m","6700",0,[[1366,768,59]]],["amd radeon hd 6730m/6770m","6730",0,[[1366,768,58],[1920,1080,46]]],["amd radeon hd 6730m/6770m/7690m xt","6730",0,[[1920,1080,48]]],["amd radeon hd 6750","6750",0,[[1440,900,72],[1920,1080,60]]],["amd radeon hd 6750m","6750",1,[[1440,900,-1],[1920,1080,-1],[1920,1200,-1]]],["amd radeon hd 6770","6770",0,[[1920,1080,60]]],["amd radeon hd 6770m","6770",1,[[1440,900,-1],[2560,1440,-1]]],["amd radeon hd 6770m opengl engine","6770",1,[[2560,1440,-1]]],["amd radeon hd 6790","6790",0,[[1920,1080,59]]],["amd radeon hd 6800","6800",0,[[1280,1024,89],[1920,1080,60]]],["amd radeon hd 6800m","6800",0,[[1600,900,18],[1920,1080,40]]],["amd radeon hd 6850","6850",0,[[1920,1080,59],[2560,1600,54]]],["amd radeon hd 6870","6870",0,[[1920,1080,60],[2560,1440,59]]],["amd radeon hd 6900","6900",0,[[1920,1080,60]]],["amd radeon hd 6900m","6900",0,[[1920,1080,60]]],["amd radeon hd 6950","6950",0,[[1680,1050,60],[1920,1080,41]]],["amd radeon hd 6970","6970",0,[[1920,1080,60]]],["amd radeon hd 6970m","6970",1,[[2560,1440,-1]]],["amd radeon hd 6970m opengl engine","6970",1,[[2560,1440,-1]]],["amd radeon hd 6990","6990",0,[[1920,1080,60]]],["amd radeon hd 7000","7000",0,[[1920,1080,24]]],["amd radeon hd 7290","7290",0,[[1366,768,9]]],["amd radeon hd 7310","7310",0,[[1366,768,14]]],["amd radeon hd 7340","7340",0,[[1366,768,17],[1920,1080,10]]],["amd radeon hd 7340g","7340",0,[[1366,768,15]]],["amd radeon hd 7340m","7340",0,[[1366,768,15]]],["amd radeon hd 7350","7350",0,[[1920,1080,13]]],["amd radeon hd 7400","7400",0,[[1920,1080,18]]],["amd radeon hd 7400g","7400",0,[[963,768,31]]],["amd radeon hd 7400m","7400",0,[[1366,768,44]]],["amd radeon hd 7420g","7420",0,[[1366,768,28],[1600,900,26]]],["amd radeon hd 7450","7450",0,[[1920,1080,15]]],["amd radeon hd 7450a","7450",0,[[1920,1080,15]]],["amd radeon hd 7450m","7450",0,[[1366,768,30]]],["amd radeon hd 7470","7470",0,[[1680,1050,22],[1920,1080,144]]],["amd radeon hd 7470m","7470",0,[[1366,768,31],[1600,900,23]]],["amd radeon hd 7480d","7480",0,[[1280,1024,25],[1920,1080,24],[1920,1200,18]]],["amd radeon hd 7500","7500",0,[[1366,696,49],[1366,768,49]]],["amd radeon hd 7500g","7500",0,[[1366,768,26]]],["amd radeon hd 7500m/7600m","7500",0,[[1366,768,46]]],["amd radeon hd 7520g","7520",0,[[1366,768,33]]],["amd radeon hd 7520g + hd 7400m dual","7520",0,[[1366,768,34]]],["amd radeon hd 7520g + hd 7600m dual","7520",0,[[1366,768,31],[1600,900,41]]],["amd radeon hd 7540d","7540",0,[[1024,768,55],[1280,1024,44],[1920,1080,22]]],["amd radeon hd 7540d + hd 6670 dual","7540",0,[[1280,1024,36]]],["amd radeon hd 7550m/7650m","7550",0,[[1366,768,57]]],["amd radeon hd 7560d","7560",0,[[1920,1080,34]]],["amd radeon hd 7560d + hd 6570 dual","7560",0,[[1680,1050,44]]],["amd radeon hd 7560d + hd 6670 dual","7560",0,[[800,638,60]]],["amd radeon hd 7570","7570",0,[[1024,768,72],[1920,1080,52]]],["amd radeon hd 7570m","7570",0,[[1366,768,35]]],["amd radeon hd 7570m/hd 7670m","7570",0,[[1366,768,50],[1600,900,29]]],["amd radeon hd 7600","7600",0,[[1920,1080,60]]],["amd radeon hd 7600a","7600",0,[[1920,1080,28]]],["amd radeon hd 7600g","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + 7500m/7600m dual","7600",0,[[1366,768,19]]],["amd radeon hd 7600g + hd 8670m dual","7600",0,[[1366,768,29]]],["amd radeon hd 7600g + hd dual","7600",0,[[1366,768,20]]],["amd radeon hd 7600m","7600",0,[[1366,768,56]]],["amd radeon hd 7600m/7700m","7600",0,[[1366,768,31]]],["amd radeon hd 7610m","7610",0,[[1366,768,43]]],["amd radeon hd 7620g","7620",0,[[1366,768,22],[1920,1080,19]]],["amd radeon hd 7640g","7640",0,[[1366,768,38]]],["amd radeon hd 7640g + 7470m dual","7640",0,[[1366,768,32]]],["amd radeon hd 7640g + 7600m dual","7640",0,[[1366,768,23]]],["amd radeon hd 7640g + 7670m dual","7640",0,[[1600,900,15]]],["amd radeon hd 7640g + 8500m dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7400m dual","7640",0,[[1366,768,37]]],["amd radeon hd 7640g + hd 7500 dual","7640",0,[[1366,768,35]]],["amd radeon hd 7640g + hd 7670m dual","7640",0,[[1366,768,34]]],["amd radeon hd 7640g + hd 8500m dual","7640",0,[[1366,768,40]]],["amd radeon hd 7640g + hd 8570m dual","7640",0,[[1366,768,31]]],["amd radeon hd 7650a","7650",0,[[1680,1050,43],[1920,1080,15]]],["amd radeon hd 7650m","7650",0,[[1366,768,41],[1600,900,45]]],["amd radeon hd 7660d","7660",0,[[1680,1050,40],[1920,1008,60],[1920,1080,38]]],["amd radeon hd 7660d + hd 6570 dual","7660",0,[[1200,900,32]]],["amd radeon hd 7660d + hd 6670 dual","7660",0,[[1360,768,57],[1920,1080,53]]],["amd radeon hd 7660g","7660",0,[[1366,768,44],[1600,900,41],[1920,1080,34],[1920,1200,27]]],["amd radeon hd 7660g + 7600m dual","7660",0,[[1366,768,53],[1600,900,45]]],["amd radeon hd 7660g + 7670m dual","7660",0,[[1366,768,52]]],["amd radeon hd 7660g + 8670m dual","7660",0,[[1600,900,46]]],["amd radeon hd 7660g + hd 7600m dual","7660",0,[[1366,768,50]]],["amd radeon hd 7660g + hd 7670m dual","7660",0,[[1366,768,35]]],["amd radeon hd 7660g + hd 8600m dual","7660",0,[[1600,900,29]]],["amd radeon hd 7670","7670",0,[[1920,1080,39]]],["amd radeon hd 7670m","7670",0,[[1366,768,49],[1920,1080,36]]],["amd radeon hd 7700","7700",0,[[1400,1050,45],[1920,1080,60]]],["amd radeon hd 7700m","7700",0,[[1920,1080,54]]],["amd radeon hd 7730m","7730",0,[[1920,1080,57]]],["amd radeon hd 7750","7750",0,[[1280,1024,60],[1600,900,60],[1400,1050,98],[1920,1080,60],[3840,2160,23]]],["amd radeon hd 7750 / r7 250e","7750",0,[[2560,1080,69]]],["amd radeon hd 7750m","7750",0,[[1680,1050,57]]],["amd radeon hd 7770","7770",0,[[1920,1080,60]]],["amd radeon hd 7770 / r7 250x","7770",0,[[1680,1050,78]]],["amd radeon hd 7770 ghz","7770",0,[[1920,1080,78]]],["amd radeon hd 7790","7790",0,[[1920,1080,16]]],["amd radeon hd 7790 / r7 360 / r9 260/360","7790",0,[[1280,1024,131]]],["amd radeon hd 7800","7800",0,[[1920,1080,60]]],["amd radeon hd 7800m","7800",0,[[1920,1080,57]]],["amd radeon hd 7850","7850",0,[[1920,1080,60]]],["amd radeon hd 7850 / r7 265 / r9 270 1024sp","7850",0,[[1280,1024,87]]],["amd radeon hd 7870","7870",0,[[1920,1080,120],[2560,1440,60],[2560,1600,114],[3840,2160,30]]],["amd radeon hd 7870 ghz","7870",0,[[1920,1080,75]]],["amd radeon hd 7870 xt","7870",0,[[1920,1080,57],[3840,2160,53]]],["amd radeon hd 7870m","7870",0,[[1920,1080,22],[2732,1536,40]]],["amd radeon hd 7900","7900",0,[[2560,1600,59]]],["amd radeon hd 7950","7950",0,[[1920,1080,50]]],["amd radeon hd 7950 / r9 280","7950",0,[[1920,1080,59]]],["amd radeon hd 7950 oem / r9 280","7950",0,[[1920,1080,60]]],["amd radeon hd 7970","7970",0,[[1920,1080,60]]],["amd radeon hd 7970 / r9 280x","7970",0,[[1920,1080,193]]],["amd radeon hd 7970m","7970",0,[[1366,768,60],[1920,1080,60]]],["amd radeon hd 7970x/8970 280x","7970",0,[[1920,1080,60]]],["amd radeon hd 7990","7990",0,[[1920,1080,60],[5120,2880,63]]],["amd radeon hd 7xxx","7",0,[[1920,1080,60]]],["amd radeon hd 8180","8180",0,[[1366,768,10]]],["amd radeon hd 8200 / r3","8200",0,[[1366,768,21],[1600,900,13],[1680,1050,13]]],["amd radeon hd 8210","8210",0,[[1366,768,18]]],["amd radeon hd 8240","8240",0,[[1600,900,17]]],["amd radeon hd 8240 / r3","8240",0,[[1366,768,14]]],["amd radeon hd 8250","8250",0,[[1366,768,14],[1920,1200,10]]],["amd radeon hd 8280","8280",0,[[1600,900,60]]],["amd radeon hd 8280 / r3","8280",0,[[1366,768,22]]],["amd radeon hd 8280e","8280",0,[[2880,1620,6]]],["amd radeon hd 8330","8330",0,[[1366,768,24]]],["amd radeon hd 8350","8350",0,[[1920,1080,57]]],["amd radeon hd 8350g","8350",0,[[1366,768,18]]],["amd radeon hd 8370d","8370",0,[[1366,768,60],[1280,1024,26],[1920,1080,22]]],["amd radeon hd 8400","8400",0,[[1366,768,30],[1920,1080,16]]],["amd radeon hd 8400 / r3","8400",0,[[1360,768,19],[1366,768,22],[1920,1080,12]]],["amd radeon hd 8400e","8400",0,[[1680,1050,17],[1920,1080,16],[1920,1200,14]]],["amd radeon hd 8410g","8410",0,[[1366,768,32]]],["amd radeon hd 8450g","8450",0,[[1366,768,23]]],["amd radeon hd 8450g + hd 8750m dual","8450",0,[[1366,768,21]]],["amd radeon hd 8470","8470",0,[[1920,1080,17]]],["amd radeon hd 8470 + 7660d dual","8470",0,[[1920,1080,60]]],["amd radeon hd 8470d","8470",0,[[1280,1024,44],[1920,1080,21]]],["amd radeon hd 8470d + hd 6450 dual","8470",0,[[1600,900,37]]],["amd radeon hd 8490","8490",0,[[1920,1080,18],[1920,1200,20]]],["amd radeon hd 8500m","8500",0,[[1366,768,41],[1920,1080,19]]],["amd radeon hd 8500m/8700m","8500",0,[[1920,1080,30]]],["amd radeon hd 8510g","8510",0,[[1366,768,29],[1920,1080,17]]],["amd radeon hd 8550","8550",0,[[1920,1080,25]]],["amd radeon hd 8550g","8550",0,[[1366,768,34],[1600,900,41],[1920,1080,34]]],["amd radeon hd 8550g + 8500m dual","8550",0,[[1366,768,42]]],["amd radeon hd 8550g + 8600 dual","8550",0,[[1920,1080,27]]],["amd radeon hd 8550g + hd 8570m dual","8550",0,[[1366,768,32]]],["amd radeon hd 8550g + hd 8600 dual","8550",0,[[1366,768,60]]],["amd radeon hd 8550g + hd 8750m dual","8550",0,[[1366,768,37]]],["amd radeon hd 8550g + r5 m230 dual","8550",0,[[1366,768,29]]],["amd radeon hd 8570","8570",0,[[1280,1024,60],[1680,1050,54],[1920,1080,50]]],["amd radeon hd 8570 / r5 430 / r7 240 / radeon 520","8570",0,[[1920,1080,25]]],["amd radeon hd 8570d","8570",0,[[1920,1080,16]]],["amd radeon hd 8570d + r7 240 dual","8570",0,[[1920,1080,45]]],["amd radeon hd 8570m","8570",0,[[1366,768,40]]],["amd radeon hd 8600","8600",0,[[1366,768,41]]],["amd radeon hd 8600m","8600",0,[[1366,768,42],[1920,1080,14]]],["amd radeon hd 8610g","8610",0,[[1366,768,31],[1920,1080,16]]],["amd radeon hd 8610g + 8600m dual","8610",0,[[1366,768,22]]],["amd radeon hd 8610g + hd 8600m dual","8610",0,[[1366,768,41]]],["amd radeon hd 8610g + hd 8670m dual","8610",0,[[1366,768,33]]],["amd radeon hd 8650g","8650",0,[[1360,768,44],[1366,768,44]]],["amd radeon hd 8650g + 8500m dual","8650",0,[[1366,768,35]]],["amd radeon hd 8650g + 8600 dual","8650",0,[[1920,1080,38]]],["amd radeon hd 8650g + 8600m dual","8650",0,[[1366,768,21]]],["amd radeon hd 8650g + 8670m dual","8650",0,[[1366,768,66]]],["amd radeon hd 8650g + 8750m dual","8650",0,[[1920,1080,28]]],["amd radeon hd 8650g + hd 7600m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8500m dual","8650",0,[[1366,768,23]]],["amd radeon hd 8650g + hd 8570m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + hd 8600m dual","8650",0,[[1366,768,46],[1600,900,29]]],["amd radeon hd 8650g + hd 8750m dual","8650",0,[[1366,768,36]]],["amd radeon hd 8650g + r5 m200 dual","8650",0,[[1366,768,35]]],["amd radeon hd 8670 / r7 250","8670",0,[[1024,768,1]]],["amd radeon hd 8670a/8670m/8690m","8670",0,[[1366,768,47]]],["amd radeon hd 8670a/8670m/8750m","8670",0,[[1366,768,60]]],["amd radeon hd 8670d","8670",0,[[1024,768,45],[1280,1024,69],[1920,1080,38]]],["amd radeon hd 8670d + 7700 dual","8670",0,[[1680,1050,58]]],["amd radeon hd 8670d + hd 6670 dual","8670",0,[[1680,1050,33]]],["amd radeon hd 8670d + r5 200 dual","8670",0,[[2560,1080,14]]],["amd radeon hd 8670d + r7 200 dual","8670",0,[[1920,1080,37]]],["amd radeon hd 8670m","8670",0,[[1366,768,41]]],["amd radeon hd 8690a","8690",0,[[1920,1080,31]]],["amd radeon hd 8690m","8690",0,[[1600,900,35]]],["amd radeon hd 8700m","8700",0,[[1366,768,60]]],["amd radeon hd 8730m","8730",0,[[1366,768,59]]],["amd radeon hd 8750m","8750",0,[[1366,768,60]]],["amd radeon hd 8770","8770",0,[[1920,1080,111]]],["amd radeon hd 8790m","8790",0,[[1600,900,78],[1920,1080,60]]],["amd radeon hd 8800m","8800",0,[[1920,1080,60],[2880,1800,45]]],["amd radeon hd 8830m","8830",0,[[1920,1080,82]]],["amd radeon hd 8850m","8850",0,[[1366,768,45]]],["amd radeon hd 8870m","8870",0,[[1280,1024,60],[1600,900,60]]],["amd radeon hd 8950","8950",0,[[1920,1080,60],[1920,1200,59]]],["amd radeon hd 8970","8970",0,[[2560,1600,60]]],["amd radeon hd 8970m","8970",0,[[1920,1080,146],[1920,1200,60]]],["amd radeon hd 8xxx","8",0,[[1920,1080,120],[2560,1440,58]]],["amd radeon hd5450","5450",0,[[1280,720,24]]],["amd radeon hd6870","6870",0,[[1920,1080,60]]],["amd radeon hd7970m","7970",0,[[2560,1440,116]]],["amd radeon hd8530m","8530",0,[[1366,768,40]]],["amd radeon hd8730","8730",0,[[1680,1050,42]]],["amd radeon hd8970m","8970",0,[[1920,1080,74]]],["amd radeon hybrid","",0,[[1366,768,27]]],["amd radeon infoshock rx 460","460",0,[[1360,768,102]]],["amd radeon instinct mi25","25",0,[[1920,1200,26]]],["amd radeon instinct mi25 mxgpu","25",0,[[1920,1080,20],[1920,1200,32]]],["amd radeon m535dx","535",0,[[1366,768,58]]],["amd radeon navi14","14",0,[[3840,2160,60]]],["amd radeon polaris","",0,[[3840,2160,60],[5120,2880,44]]],["amd radeon polaris 10","10",0,[[1920,1200,60]]],["amd radeon pro","pro",0,[[1920,1080,114]]],["amd radeon pro 270x","270",0,[[2560,1440,74]]],["amd radeon pro 450","450",0,[[1920,1080,30],[2880,1800,43],[3360,2100,36],[5120,2880,30]]],["amd radeon pro 450 opengl engine","450",0,[[1920,1200,60]]],["amd radeon pro 455","455",0,[[2879,1800,54],[2880,1800,48],[3360,2100,37]]],["amd radeon pro 455 opengl engine","455",0,[[3360,2100,36]]],["amd radeon pro 460","460",0,[[2880,1800,50],[3360,2100,42]]],["amd radeon pro 460 opengl engine","460",0,[[5760,3240,15]]],["amd radeon pro 470","470",0,[[6016,3384,49]]],["amd radeon pro 480","480",0,[[1920,1080,60]]],["amd radeon pro 5300","5300",0,[[5120,2880,60]]],["amd radeon pro 5300m","5300",0,[[1920,1080,214],[3584,2240,130]]],["amd radeon pro 5500 xt","5500",0,[[5120,2880,51]]],["amd radeon pro 5500m","5500",0,[[3072,1920,60],[3584,2240,139]]],["amd radeon pro 555","555",0,[[2879,1800,54],[2880,1800,36],[3360,2100,40]]],["amd radeon pro 555x","555",0,[[2880,1800,42],[3360,2100,39]]],["amd radeon pro 560","560",0,[[2879,1800,56],[2880,1800,56],[3360,2100,42]]],["amd radeon pro 5600m","5600",0,[[3072,1920,60],[3584,2240,60]]],["amd radeon pro 560x","560",0,[[2879,1800,59],[2880,1800,71],[3360,2100,43]]],["amd radeon pro 570","570",0,[[5120,2880,48]]],["amd radeon pro 570 opengl engine","570",0,[[5120,2880,46]]],["amd radeon pro 5700","5700",0,[[5120,2880,60]]],["amd radeon pro 5700 xt","5700",0,[[5120,2880,60]]],["amd radeon pro 570x","570",0,[[5120,2880,50]]],["amd radeon pro 575","575",0,[[4096,2304,60],[5120,2880,50]]],["amd radeon pro 575 opengl engine","575",0,[[5120,2880,48]]],["amd radeon pro 575x","575",0,[[5120,2880,56]]],["amd radeon pro 580","580",0,[[5120,2880,54]]],["amd radeon pro 580 opengl engine","580",0,[[5120,2880,50]]],["amd radeon pro 580x","580",0,[[5120,2880,52]]],["amd radeon pro duo","pro",0,[[1920,1080,234],[1800,1350,59],[3840,2160,82],[4096,2160,60]]],["amd radeon pro rx 560","560",0,[[2560,1080,60]]],["amd radeon pro ssg","pro",0,[[3440,1440,125]]],["amd radeon pro v340","340",0,[[1920,1080,112]]],["amd radeon pro v520 mxgpu","520",0,[[1920,1080,271]]],["amd radeon pro v7350x2","7350",0,[[1920,1080,60]]],["amd radeon pro vega 16","16",0,[[2879,1800,60],[3360,2100,60]]],["amd radeon pro vega 20","20",0,[[2880,1800,120],[3360,2100,121],[3840,2160,30]]],["amd radeon pro vega 48","48",0,[[5120,2880,86]]],["amd radeon pro vega 56","56",0,[[1920,1080,60],[5120,2880,60]]],["amd radeon pro vega 56 opengl engine","56",0,[[5120,2880,60]]],["amd radeon pro vega 64","64",0,[[5120,2880,60]]],["amd radeon pro vega 64 opengl engine","64",0,[[5120,2880,60]]],["amd radeon pro vega 64x","64",0,[[2560,1440,206],[4096,2304,60],[5120,2880,60]]],["amd radeon pro vega ii","proii",0,[[3840,1600,60],[5120,2880,60]]],["amd radeon pro vega ii duo","proii",0,[[2560,1440,239],[5120,2880,60]]],["amd radeon pro w5500","5500",0,[[1920,1080,195],[3840,2160,59],[7680,3240,56]]],["amd radeon pro w5500m","5500",0,[[1920,1080,60]]],["amd radeon pro w5500x","5500",0,[[1920,1200,60]]],["amd radeon pro w5700","5700",0,[[1680,1050,253],[5120,1440,120],[3840,2160,60]]],["amd radeon pro w5700x","5700",0,[[3840,2160,60]]],["amd radeon pro w6600","6600",0,[[1920,1200,60],[3840,2160,166]]],["amd radeon pro w6600m","6600",0,[[1920,1080,60]]],["amd radeon pro w6800","6800",0,[[1920,1080,60],[3840,2160,237]]],["amd radeon pro w6800x","6800",0,[[6016,3384,60]]],["amd radeon pro w6800x duo","6800",0,[[3840,1600,60],[5120,2880,45]]],["amd radeon pro w6900x","6900",0,[[3840,2160,60]]],["amd radeon pro wx","pro",0,[[2560,1080,69]]],["amd radeon pro wx 2100","2100",0,[[1280,1024,145],[1920,1080,60]]],["amd radeon pro wx 3100","3100",0,[[1919,1080,58],[1920,1080,123],[2560,1440,82]]],["amd radeon pro wx 3200","3200",0,[[2560,1440,92]]],["amd radeon pro wx 4100","4100",0,[[1920,1080,60],[1920,1200,60],[3840,2160,30],[5120,2880,18]]],["amd radeon pro wx 4130","4130",0,[[1920,1080,60],[3840,2160,30]]],["amd radeon pro wx 4150","4150",0,[[1920,1080,56],[3840,2160,37],[4096,2160,34]]],["amd radeon pro wx 5100","5100",0,[[1920,1080,60],[2560,1440,91],[3840,2160,55]]],["amd radeon pro wx 5100 opengl engine","5100",0,[[2560,1440,60]]],["amd radeon pro wx 7100","7100",0,[[1920,1080,122],[2560,1080,58],[3840,2160,60],[5120,2880,60]]],["amd radeon pro wx 7100 mobile","7100",0,[[2560,1440,60]]],["amd radeon pro wx 7100 opengl engine","7100",0,[[3840,2160,60]]],["amd radeon pro wx 8200","8200",0,[[3440,1440,124]]],["amd radeon pro wx 9100","9100",0,[[1920,1080,60],[4096,2160,101]]],["amd radeon pro wx 9100 opengl engine","9100",0,[[1920,1080,60]]],["amd radeon pro wx vega m gl","prom",0,[[3840,2160,14]]],["amd radeon pro wx3200","3200",0,[[1920,1080,55]]],["amd radeon pro wx9100","9100",0,[[2560,1440,60]]],["amd radeon r2","2",0,[[1366,768,13],[1600,900,14]]],["amd radeon r2e","2",0,[[1366,768,16],[1920,1080,45],[3840,2160,4]]],["amd radeon r3","3",0,[[1366,768,17],[1920,1080,15]]],["amd radeon r4","4",0,[[1366,768,19],[1920,1080,13]]],["amd radeon r4e","4",0,[[3840,2160,6]]],["amd radeon r5","5",0,[[1024,768,38],[1360,768,25],[1366,768,21],[1280,1024,33],[1920,1080,14],[3200,1800,7]]],["amd radeon r5 220","5",0,[[1366,768,19],[1920,1080,12]]],["amd radeon r5 230","5",0,[[1920,1080,21]]],["amd radeon r5 235","5",0,[[1920,1080,17]]],["amd radeon r5 240","5",0,[[1280,1024,34],[1920,1080,24]]],["amd radeon r5 340","5",0,[[1920,1080,27]]],["amd radeon r5 340x","5",0,[[1920,1080,31]]],["amd radeon r5 430","5",0,[[1280,1024,31],[1680,1050,54],[1920,1080,54]]],["amd radeon r5 435","5",0,[[1920,1080,30]]],["amd radeon r5 m200","5",0,[[1600,900,45],[1920,1080,20]]],["amd radeon r5 m200 / hd 8500m","5",0,[[1366,768,31],[1920,1080,24]]],["amd radeon r5 m230","5",0,[[1366,768,37]]],["amd radeon r5 m240","5",0,[[1366,768,42],[1920,1080,23]]],["amd radeon r5 m255","5",0,[[1366,768,59],[1600,900,33]]],["amd radeon r5 m315","5",0,[[1366,768,45]]],["amd radeon r5 m320","5",0,[[1920,1080,19]]],["amd radeon r5 m330","5",0,[[1366,768,27],[1920,1080,26]]],["amd radeon r5 m335","5",0,[[1366,768,55],[1920,1080,19]]],["amd radeon r5 m420","5",0,[[1366,768,49]]],["amd radeon r5 m430","5",0,[[1366,768,36],[1920,1080,20]]],["amd radeon r5 m435","5",0,[[1920,1080,41],[2560,1440,67]]],["amd radeon r5 m445","5",0,[[1920,1080,32]]],["amd radeon r5e","5",0,[[1600,768,14],[1920,1080,16]]],["amd radeon r6","6",0,[[1366,768,30],[1280,1024,23],[1920,1080,12]]],["amd radeon r6 m255dx","6",0,[[1366,768,25]]],["amd radeon r6 m340dx","6",0,[[1366,768,31],[1920,1080,15]]],["amd radeon r6e","6",0,[[3840,2160,5]]],["amd radeon r7","7",0,[[1366,768,35],[1280,1024,31],[1680,1050,39],[1920,1080,12],[1920,1200,16],[2560,1080,15],[2560,1440,21],[3840,2160,8]]],["amd radeon r7 200","7",0,[[1280,1024,45],[1920,1080,120]]],["amd radeon r7 200 series","7",0,[[1920,1080,43]]],["amd radeon r7 240","7",0,[[1920,1080,29]]],["amd radeon r7 240 + hd 8570d dual","7",0,[[1920,1080,43]]],["amd radeon r7 250","7",0,[[1920,1080,49]]],["amd radeon r7 250e","7",0,[[1920,1080,60]]],["amd radeon r7 250x","7",0,[[1920,1080,60]]],["amd radeon r7 260x","7",0,[[1920,1080,56]]],["amd radeon r7 260x/360","7",0,[[1920,1200,102]]],["amd radeon r7 350","7",0,[[1024,768,60],[1280,1024,79],[1920,1080,59]]],["amd radeon r7 350x","7",0,[[1920,1080,50]]],["amd radeon r7 360","7",0,[[1920,1048,60],[1920,1080,102]]],["amd radeon r7 360 / r9 360","7",0,[[1920,1080,60]]],["amd radeon r7 370","7",0,[[1600,900,60],[1920,1080,75]]],["amd radeon r7 370 / r9 270","7",0,[[1920,1080,74]]],["amd radeon r7 370 / r9 270x/370","7",0,[[1600,900,115],[1920,1080,60]]],["amd radeon r7 370 / r9 270x/370x","7",0,[[1920,1080,115]]],["amd radeon r7 370 series","7",0,[[1920,1080,212],[3840,2160,60]]],["amd radeon r7 430","7",0,[[1920,1080,55],[3840,2160,10]]],["amd radeon r7 450","7",0,[[1920,1080,60]]],["amd radeon r7 a360","7",0,[[1920,1080,28]]],["amd radeon r7 graphics + hd 7700 dual","7",0,[[1600,1200,72]]],["amd radeon r7 graphics + r5 340 dual","7",0,[[1920,1080,47]]],["amd radeon r7 graphics + r7 200 dual","7",0,[[1920,1080,45],[1920,1200,47]]],["amd radeon r7 graphics + r7 350 dual","7",0,[[1919,1080,60]]],["amd radeon r7 m260","7",0,[[1600,900,44],[1920,1080,13]]],["amd radeon r7 m260dx","7",0,[[1366,768,46],[1920,1080,18]]],["amd radeon r7 m260x","7",0,[[1920,1080,29]]],["amd radeon r7 m265","7",0,[[1366,768,48],[1920,1080,27]]],["amd radeon r7 m270","7",0,[[1920,1080,31],[3840,2160,10]]],["amd radeon r7 m340","7",0,[[1366,768,60],[1920,1080,32]]],["amd radeon r7 m350","7",0,[[3840,2160,12]]],["amd radeon r7 m360","7",0,[[1366,768,40],[1920,1080,22]]],["amd radeon r7 m370","7",0,[[1920,1080,24]]],["amd radeon r7 m440","7",0,[[1920,1080,39]]],["amd radeon r7 m445","7",0,[[1920,1080,36]]],["amd radeon r7 m460","7",0,[[1919,1080,24],[1920,1080,29]]],["amd radeon r7 m520","7",0,[[1919,1080,17]]],["amd radeon r7 series / hd 9000","7",0,[[1920,1080,71],[2560,1080,59]]],["amd radeon r7e","7",0,[[1024,768,41]]],["amd radeon r8 m350dx","8",0,[[1366,768,30]]],["amd radeon r8 m365dx","8",0,[[1920,1080,28]]],["amd radeon r8 m435dx","8",0,[[1920,1080,22]]],["amd radeon r8 m445dx","8",0,[[1366,768,38],[1920,1080,27]]],["amd radeon r8 m535dx","8",0,[[1366,768,55]]],["amd radeon r9","9",0,[[1920,1080,60]]],["amd radeon r9 200","9",0,[[1920,1080,60]]],["amd radeon r9 200 / hd 7900","9",0,[[1920,1080,250]]],["amd radeon r9 255","9",0,[[1600,900,52],[1920,1080,51]]],["amd radeon r9 260","9",0,[[1920,1080,16]]],["amd radeon r9 270","9",0,[[1280,1024,60],[1920,1080,60]]],["amd radeon r9 270 1024sp","9",0,[[1920,1080,135]]],["amd radeon r9 270x","9",0,[[1920,1080,30]]],["amd radeon r9 280","9",0,[[1920,1080,75],[1920,1200,428],[2560,1440,60]]],["amd radeon r9 280,","9",0,[[5120,2880,39]]],["amd radeon r9 280x","9",0,[[1920,1080,137]]],["amd radeon r9 285","9",0,[[1920,1080,60],[1920,1200,129]]],["amd radeon r9 290","9",0,[[1920,1080,60]]],["amd radeon r9 290x","9",0,[[1920,1080,60],[2560,1440,60],[3840,2160,118]]],["amd radeon r9 300","9",0,[[1920,1080,59]]],["amd radeon r9 350","9",0,[[1920,1200,63]]],["amd radeon r9 360","9",0,[[1600,900,83],[1920,1080,60],[2560,1440,59]]],["amd radeon r9 370","9",0,[[1680,1050,205],[1920,1080,60],[3840,2160,49]]],["amd radeon r9 370x","9",0,[[1920,1080,60]]],["amd radeon r9 380","9",0,[[1920,1080,41],[2560,1440,75]]],["amd radeon r9 380x","9",0,[[2560,1600,60]]],["amd radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["amd radeon r9 390x","9",0,[[2560,1440,60],[3840,2160,60]]],["amd radeon r9 a375","9",0,[[1920,1080,28]]],["amd radeon r9 fury","9",0,[[1920,1080,75],[3840,2160,133]]],["amd radeon r9 fury / nano","9",0,[[1920,1200,155]]],["amd radeon r9 m200x","9",0,[[1366,768,104],[1920,1080,60]]],["amd radeon r9 m265x","9",0,[[1920,1080,33]]],["amd radeon r9 m270x","9",0,[[1600,900,60],[1920,1080,68]]],["amd radeon r9 m275","9",0,[[1920,1080,29]]],["amd radeon r9 m275x","9",0,[[1920,1080,20]]],["amd radeon r9 m280x","9",0,[[1920,1080,60],[2560,1440,25]]],["amd radeon r9 m290","9",0,[[5120,2880,33]]],["amd radeon r9 m290x","9",0,[[1920,1080,60],[3840,2160,61],[5120,2880,33]]],["amd radeon r9 m295x","9",0,[[3840,2160,33],[5120,2880,36]]],["amd radeon r9 m295x mac","9",0,[[5120,2880,42]]],["amd radeon r9 m295x mac edition / r9 380x","9",0,[[1920,1080,128]]],["amd radeon r9 m360","9",0,[[1920,1080,60],[3840,2160,26]]],["amd radeon r9 m370x","9",0,[[2560,1440,30],[2880,1800,27]]],["amd radeon r9 m370x opengl engine","9",0,[[5120,2880,14]]],["amd radeon r9 m375","9",0,[[1920,1080,29]]],["amd radeon r9 m375x","9",0,[[1920,1080,60],[3840,2160,22]]],["amd radeon r9 m380","9",0,[[1920,1080,50],[3840,2160,8],[5120,2880,9]]],["amd radeon r9 m380 opengl engine","9",0,[[5120,2880,15]]],["amd radeon r9 m385","9",0,[[1920,1080,58]]],["amd radeon r9 m385x","9",0,[[1920,1080,60]]],["amd radeon r9 m390","9",0,[[5119,2879,29],[5120,2880,21],[5760,3240,32]]],["amd radeon r9 m390 opengl engine","9",0,[[5120,2880,27]]],["amd radeon r9 m390x","9",0,[[1920,1080,140]]],["amd radeon r9 m395","9",0,[[2560,1440,59],[5120,2880,19]]],["amd radeon r9 m395 opengl engine","9",0,[[5120,2880,38]]],["amd radeon r9 m395x","9",0,[[3840,2160,58],[5120,2880,36]]],["amd radeon r9 m395x opengl engine","9",0,[[5120,2880,35]]],["amd radeon r9 m470","9",0,[[3840,2160,29]]],["amd radeon r9 m470x","9",0,[[1920,1080,60]]],["amd radeon r9-290x","9",0,[[1920,1080,60]]],["amd radeon renoir graphics d1","1",0,[[1366,768,60]]],["amd radeon rro 580x","580",0,[[5120,2880,59]]],["amd radeon rx 460","460",0,[[1920,1080,55],[2560,1080,60],[3840,2160,31]]],["amd radeon rx 460 / pro 450/455/460/555/555x/560/560x","460",0,[[3440,1440,93]]],["amd radeon rx 460 / pro 450/455/460/560","460",0,[[1920,1080,72]]],["amd radeon rx 470","470",0,[[1280,1024,73],[1920,1080,58],[1920,1200,147],[3840,2160,51]]],["amd radeon rx 470 opengl engine","470",0,[[2560,1440,60]]],["amd radeon rx 475m","475",0,[[1920,1080,60]]],["amd radeon rx 480","480",0,[[1400,1050,267],[1920,1080,60],[2560,1080,71]]],["amd radeon rx 480 opengl engine","480",0,[[1920,1080,60]]],["amd radeon rx 5300m","5300",0,[[1920,1080,60],[3840,2160,60]]],["amd radeon rx 540","540",0,[[1919,1080,52],[1920,1080,36]]],["amd radeon rx 550","550",0,[[1280,1024,135],[1920,1080,60],[1920,1200,60],[6016,3384,15]]],["amd radeon rx 550 640sp / rx 560","550",0,[[1920,1080,60]]],["amd radeon rx 5500","5500",0,[[1920,1080,139]]],["amd radeon rx 5500 / pro 5500m","5500",0,[[1920,1080,60],[2560,1440,227]]],["amd radeon rx 5500 xt","5500",0,[[1920,1080,239]]],["amd radeon rx 5500m","5500",0,[[1920,1048,144],[1920,1080,144],[3840,2160,60]]],["amd radeon rx 550x","550",0,[[1920,1080,52]]],["amd radeon rx 560","560",0,[[1920,1080,60],[1920,1200,42],[2560,1440,60]]],["amd radeon rx 560 [baffin]","560",0,[[1920,1080,60]]],["amd radeon rx 5600 oem/5600 xt / 5700 xt","5600",0,[[1920,1080,360],[2560,1440,164]]],["amd radeon rx 5600 xt","5600",0,[[1920,1080,75]]],["amd radeon rx 5600m","5600",0,[[1920,1080,144]]],["amd radeon rx 560d","560",0,[[2560,1080,60]]],["amd radeon rx 560x","560",0,[[1920,1080,115],[3840,2160,35]]],["amd radeon rx 570","570",0,[[1920,1080,60],[3072,1728,60]]],["amd radeon rx 570 opengl engine","570",0,[[1920,1080,226]]],["amd radeon rx 5700","5700",0,[[1920,1080,144]]],["amd radeon rx 5700 / 5700 xt","5700",0,[[3840,2160,201]]],["amd radeon rx 5700 xt","5700",0,[[1920,1080,464],[3840,2160,60],[6016,3384,34]]],["amd radeon rx 5700 xt 50th anniversary","5700",0,[[2560,1440,144],[3840,1600,60],[3840,2160,222],[5120,2880,60]]],["amd radeon rx 5700xt","5700",0,[[1920,1080,369]]],["amd radeon rx 580","580",0,[[1920,1080,60],[1920,1200,97],[2560,1440,60],[3840,2160,60]]],["amd radeon rx 580 2048sp","580",0,[[1920,1080,60]]],["amd radeon rx 580 opengl engine","580",0,[[1920,1080,145]]],["amd radeon rx 580 special","580",0,[[2560,1440,60]]],["amd radeon rx 580x","580",0,[[1920,1200,60],[3840,2160,79]]],["amd radeon rx 590","590",0,[[1920,1080,75],[2560,1440,164],[3584,2240,60]]],["amd radeon rx 640","640",0,[[1920,1080,39]]],["amd radeon rx 6500 xt","6500",0,[[1920,1080,60]]],["amd radeon rx 6600","6600",0,[[1920,1080,433],[3840,2160,57]]],["amd radeon rx 6600 xt","6600",0,[[1920,1080,60]]],["amd radeon rx 6600 xt/6600m","6600",0,[[2560,1440,60]]],["amd radeon rx 6600m","6600",0,[[1920,1080,139]]],["amd radeon rx 6700 xt","6700",0,[[1920,1080,451]]],["amd radeon rx 6700 xt / 6800m","6700",0,[[2560,1440,144]]],["amd radeon rx 6700m","6700",0,[[1920,1080,240]]],["amd radeon rx 6800","6800",0,[[2560,1440,564],[3840,2160,60]]],["amd radeon rx 6800 xt","6800",0,[[2560,1440,446],[3440,1440,144],[3840,2160,60]]],["amd radeon rx 6800 xt / 6900 xt","6800",0,[[2560,1440,239]]],["amd radeon rx 6800 xt 16gb","6800",0,[[6400,2666,60]]],["amd radeon rx 6800m","6800",0,[[1920,1080,300]]],["amd radeon rx 6900 xt","6900",0,[[3840,2160,60]]],["amd radeon rx rx 560","560",0,[[1920,1080,60]]],["amd radeon rx vega","rx",0,[[1920,1080,39]]],["amd radeon rx vega 10","10",0,[[1920,1080,38]]],["amd radeon rx vega 11","11",0,[[1920,1080,35]]],["amd radeon rx vega 56","56",0,[[1920,1080,144],[3440,1440,60],[3840,2160,60]]],["amd radeon rx vega 56 8gb","56",0,[[2560,1600,60]]],["amd radeon rx vega 56 opengl engine","56",0,[[2560,1440,60]]],["amd radeon rx vega 64","64",0,[[2560,1440,518]]],["amd radeon rx vega 64 8gb","64",0,[[2560,1440,60]]],["amd radeon rx vega 64 opengl engine","64",0,[[3840,2160,119]]],["amd radeon rx vega 64.1","64",0,[[6016,3384,60]]],["amd radeon rx vega 8","8",0,[[1920,1080,53]]],["amd radeon rx vega m gh","rxm",0,[[1920,1080,60],[2560,1440,60],[3840,2160,51]]],["amd radeon rx vega m gl","rxm",0,[[2560,1440,567],[3840,2160,59]]],["amd radeon rx vega11","11",0,[[2496,1664,30]]],["amd radeon rx460","460",0,[[1920,1080,60]]],["amd radeon rx480","480",0,[[1920,1080,102],[2560,1080,71]]],["amd radeon rx540","540",0,[[2400,1800,37]]],["amd radeon rx550","550",0,[[1920,1080,60]]],["amd radeon rx560","560",0,[[1920,1080,93]]],["amd radeon rx5600","5600",0,[[3840,2160,129]]],["amd radeon rx570","570",0,[[5120,2880,59]]],["amd radeon rx5700","5700",0,[[1920,1080,60]]],["amd radeon rx580","580",0,[[1920,1080,60]]],["amd radeon rx590 gme","590",0,[[1920,1080,112]]],["amd radeon rx6600xt","6600",0,[[3840,2160,60]]],["amd radeon sky 500","500",0,[[4096,2160,34]]],["amd radeon vega","",0,[[5120,2880,32]]],["amd radeon vega 10","10",0,[[1920,1080,44]]],["amd radeon vega 10 mobile","10",0,[[1920,1080,30]]],["amd radeon vega 11","11",0,[[1280,1024,60],[1920,1080,60],[3840,2160,17]]],["amd radeon vega 2","2",0,[[1366,768,30]]],["amd radeon vega 3","3",0,[[1440,900,44],[1920,1080,29],[3840,2160,8]]],["amd radeon vega 3 mobile","3",0,[[1920,1080,30]]],["amd radeon vega 56","56",0,[[2560,1440,144]]],["amd radeon vega 6","6",0,[[1366,768,61],[1920,1080,23]]],["amd radeon vega 64","64",0,[[6016,3384,35]]],["amd radeon vega 64 lc","64",0,[[2560,1080,60]]],["amd radeon vega 8","8",0,[[1920,1080,35],[2560,1440,24],[4096,2160,15]]],["amd radeon vega 8 mobile","8",0,[[1920,1080,36]]],["amd radeon vega 9","9",0,[[2496,1663,32],[2496,1664,39]]],["amd radeon vega fe","fe",0,[[1920,1080,120],[2560,1440,60]]],["amd radeon vega frontier","",0,[[1920,1080,120],[3840,2160,60]]],["amd radeon vega frontier edition opengl engine","",0,[[3440,1440,60]]],["amd radeon vega series / radeon vega mobile","",0,[[1920,1080,67]]],["amd radeon vii","vii",0,[[1920,1080,468],[2560,1440,60],[3840,2160,60]]],["amd radeont 540x","540",0,[[1920,1080,74],[3840,2160,22]]],["amd radeont rx 5300","5300",0,[[1920,1080,60]]],["amd radeont rx 5500m","5500",0,[[1920,1080,303]]],["amd radeont rx 560x","560",0,[[1920,1080,60]]],["amd saphire radeon rx 580","580",0,[[1920,1080,57]]],["amd sapphire radeon hd6870","6870",0,[[1680,1050,60]]],["amd sapphire radeon rx 560","560",0,[[1280,1024,60]]],["amd sapphire radeon rx vega 64 8gb","64",0,[[2560,1440,144]]],["intel radeon pro vega 16","16",0,[[3360,1890,20]]],["intel radeong 0.4 on amd bonaire","0",0,[[1920,1200,92]]],["intel radeong 0.4 on amd cape verde","0",0,[[1920,1200,73]]],["intel radeong 0.4 on amd polaris10","0",0,[[3840,2160,108]]],["intel radeong 0.4 on amd tonga","0",0,[[1920,1080,124]]],["radeon 500","500",0,[[1920,1080,58]]],["radeon 550","550",0,[[1920,1080,60]]],["radeon 550x","550",0,[[1920,1080,68]]],["radeon hd 7700","7700",0,[[1920,1080,60],[1920,1200,90]]],["radeon hd 7800","7800",0,[[1920,1080,60]]],["radeon hd 7900","7900",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60]]],["radeon hd 8500","8500",0,[[1920,1080,42]]],["radeon hd 8790m","8790",0,[[1600,900,60]]],["radeon hd8800","8800",0,[[1920,1080,60]]],["radeon pro wx 5100 graphics (polaris10 / drm 3.27.0 / 4.19.4-1.el7.elrepo.x86_64, llvm 6.0","5100",0,[[1920,1080,60]]],["radeon pro wx3100","3100",0,[[2560,1440,1],[3840,2160,43]]],["radeon r5 340","5",0,[[1536,864,41]]],["radeon r5 m330","5",0,[[1366,768,38]]],["radeon r7 200","7",0,[[1280,1024,60],[2560,1440,52]]],["radeon r7 300","7",0,[[1920,1080,60]]],["radeon r7 m340","7",0,[[1920,1080,32]]],["radeon r7 m360","7",0,[[1920,1080,32]]],["radeon r9 200","9",0,[[1920,1080,60],[1920,1200,60],[2560,1440,1]]],["radeon r9 380","9",0,[[2560,1440,1]]],["radeon r9 390","9",0,[[1920,1080,60],[2560,1440,60]]],["radeon r9 fury","9",0,[[1920,1080,51],[1920,1920,60]]],["radeon rx","rx",0,[[1920,1200,60]]],["radeon rx 460","460",0,[[1920,1080,60],[1920,1200,60]]],["radeon rx 470","470",0,[[1280,768,60],[1680,1050,422],[1920,1080,60],[2560,1440,60]]],["radeon rx 480","480",0,[[1920,1080,60],[1920,1200,185],[2560,1440,1]]],["radeon rx 550","550",0,[[1600,900,60],[1680,1050,60],[1920,1080,1],[1920,1200,60],[2560,1080,60],[3840,2160,30]]],["radeon rx 5500 xt","5500",0,[[1920,1080,60],[1920,1200,60],[2560,1440,60],[3840,2160,19]]],["radeon rx 560","560",0,[[1600,900,60],[1920,1080,29],[1920,1200,47],[2688,1512,60],[3440,1440,60],[3840,2160,58]]],["radeon rx 5600 xt","5600",0,[[1920,1080,60]]],["radeon rx 570","570",0,[[1440,900,60],[1280,1024,60],[1920,1080,51],[1920,1200,60],[2560,1080,60],[2560,1440,37],[3440,1440,60]]],["radeon rx 5700 xt","5700",0,[[1707,960,60],[1920,1080,60],[2560,1440,55],[3840,2160,60]]],["radeon rx 580","580",0,[[1477,831,72],[1440,900,60],[1680,1050,60],[1920,1080,4],[1920,1200,60],[2560,1080,52],[2560,1440,60],[2560,1600,60],[3840,2160,1]]],["radeon rx 580 2048sp","580",0,[[1440,900,75]]],["radeon rx 590","590",0,[[1920,1080,60],[2560,1440,60],[3840,2160,30]]],["radeon rx vega","rx",0,[[1920,1080,60],[1920,1200,60],[2194,1234,60],[2560,1080,60],[2560,1440,60],[3440,1440,75],[3840,2160,60]]],["radeon rx vega 8","8",0,[[3840,2160,23]]],["radeon rx550","550",0,[[1680,1050,60],[1920,1080,60],[3440,1440,58]]],["radeon vega 8","8",0,[[1680,1050,60]]],["radeon vega frontier","",0,[[2560,1440,144]]],["radeon vii","vii",0,[[2560,1440,60],[3440,1440,60],[3840,2160,1]]],["radeong 0.4 on amd polaris10","0",0,[[3840,2160,109]]],["radeong 0.4 on amd tahiti","0",0,[[1920,1080,223]]],["ryzen embedded r1305g with radeon vega gfx","1305",0,[[3840,2160,14]]],["ryzen embedded v1605b with radeon vega gfx","1605",0,[[3840,2160,28]]]]\')},921:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["adreno 506","506",0,[[1512,720,18,"motorola moto g(7) play"]]],["adreno 530","530",0,[[2560,1140,27,"samsung galaxy s7 (sm-930x)"],[2392,1440,28,"google pixel xl"]]],["adreno 615","615",0,[[2088,1080,20,"google pixel 3a"]]],["adreno 618","618",0,[[2210,1080,34,"xiaomi mi 9t"]]],["adreno 620","620",0,[[2340,1080,42,"google pixel 5"]]],["adreno 630","630",0,[[2280,1080,58,"oneplus a6003"]]],["adreno 640","640",0,[[2280,1080,60,"google pixel 4"]]],["qualcomm adreno 205","205",0,[[1280,720,11,"coolpad 8675-w00 (adreno 205)"]]],["qualcomm adreno 304","304",0,[[480,320,16,"zte z353vl cymbal t"],[480,480,6,"lg watch sport"],[758,480,8,"kyocera kyf33 torque x01 s-max"],[782,480,8,"vodafone vfd 510"],[791,480,8,"acer t012"],[792,480,6,"lg k4 2017 (m151, m160, m150 phoenix 3, m153 fortune, m154 risio 2, l58vl rebel 2)"],[800,480,7,"chainway c4050-q4"],[854,480,6,"zte q302c"],[897,540,6,"kyocera c6742 hydro view"],[960,540,6,"cat s40"],[1024,552,6,"tcl 9007 pixi 3 (7)"],[1184,720,4,"micromax q4251 canvas juice a1"],[1187,720,4,"lg phoenix 2 (k37x)"],[1193,720,4,"lg x power (k210, k450)"],[1196,720,4,"obi sj2.5"],[1217,720,4,"fibo la0920"],[1224,720,4,"umax visionbook p70 lte"],[1280,720,4,"k-touch beeline fast +"],[1280,736,4,"alcatel 9022x one touch pixi 3 8.0"],[1280,752,4,"lenovo tab 10 (x103f)"]]],["qualcomm adreno 305","305",0,[[432,320,18,"sonim xp6700"],[480,320,16,"lg t480s wine smart 3g"],[400,400,0,"huawei watch"],[734,480,7,"lg l fino (d290, d295)"],[737,480,7,"acer liquid z220"],[790,480,8,"htc desire 510 (adreno 305)"],[791,480,7,"sony xperia m (c19xx, c20xx)"],[800,480,5,"cherry mobile q510"],[854,480,6,"alcatel a564c one touch pop icon"],[886,540,7,"lg g2 mini (d610, d618, d620)"],[896,540,7,"htc desire 610"],[897,540,5,"motorola xt830c moto e"],[960,540,4,"huawei c8817l"],[1024,528,5,"aurora au701"],[1024,552,4,"asus zenfone go 6.9 (l001 zb690kg)"],[982,600,4,"huawei mediapad 7 youth 2"],[1024,600,7,"samsung galaxy tab 3 7.0 (sm-t215, sm-t217)"],[1024,720,4,"ereneben eben a2"],[1024,722,5,"prestigio pmt5287 multipad ranger 8.0 4g"],[1280,648,5,"tomtom bridge"],[1184,720,5,"htc desire 650 (d650)"],[1188,720,4,"lg aka (h778, h788, f520x)"],[1196,720,3,"zte z787"],[1200,720,4,"lg g vista (d631, vs880, gx2 f430)"],[1216,720,4,"vodafone smart 4 max"],[1217,720,4,"kyocera e6790 duraforce xd"],[1220,720,4,"huawei ascend mate 2 mt2-l03"],[1196,768,4,"infocus m2"],[1280,720,3,"zuum p47"],[1280,732,4,"lg g pad 7.0 (uk410, v410, vk410)"],[1280,736,4,"zte amazing p6"],[1280,737,4,"asus memo pad hd 7 (k00s me175kg)"],[1280,739,4,"lg g pad 8.0 (v480, v49x, p490, t01)"],[1280,740,4,"qualcomm msm8926 (adreno 305, development board)"],[1280,752,4,"asus padfone e (t008 a68m)"],[1216,800,3,"huawei mediapad t1 8.0 (adreno 305)"],[1280,800,3,"samsung tn10gedlte"],[1920,1080,2,"zte s2002 star 1"],[1920,1128,2,"lenovo b8080"]]],["qualcomm adreno 306","306",0,[[734,480,9,"lg f60 (d390, d392)"],[790,480,8,"htc desire 510 (adreno 306)"],[791,480,5,"lg l21g destiny"],[800,480,8,"covia fleaz cp-l42a pop"],[854,480,8,"freetel ft151a priori2 lte"],[897,540,7,"kyocera c6740 hydro wave"],[960,540,5,"blu studio mini lte 2"],[1024,552,6,"tcl 9006w"],[1024,600,5,"samsung sm-t116ir (adreno 306)"],[1024,720,5,"ereneben eben k8s"],[1024,768,5,"samsung sm-p350 galaxy tab a plus"],[1184,720,4,"lg x screen (k500, f650)"],[1188,720,4,"lg band play (f570s)"],[1196,720,4,"fly a5042"],[1199,720,4,"lg stylus 2 (f720, k520, k540, ls775 g stylo 2, l82vl)"],[1200,720,4,"lg g4 stylus (h63x, ms631, f560, ls770 g stylo)"],[1208,720,4,"vizio xr6m10 tablet remote"],[1217,720,4,"lenovo pb1-750x phab"],[1224,720,4,"c spire ft7"],[1280,720,3,"bgh joy smart axs ii"],[1280,736,4,"vodafone smart tab 4g"],[1280,752,4,"huawei mediapad t1 10 (t1-a21)"],[1216,800,4,"huawei mediapad t1 8.0 pro, lte (adreno 306)"],[1280,800,4,"samsung galaxy tab e 8.0 (adreno 306, sm-t377p)"],[1794,1080,2,"bluebird sf550"],[1815,1080,2,"vizio xr6"],[1920,1080,2,"longcheer cc01"]]],["qualcomm adreno 308","308",0,[[800,480,13,"samsung galaxy folder 2 (sm-g160x)"],[854,480,12,"coolpad 3632"],[960,540,10,"samsung sm-j250g"],[1184,720,5,"infocus 00ww"],[1187,720,6,"lg m200"],[1193,720,6,"lg k20 plus (mp260, k20 v vs501)"],[1195,720,6,"lg x charge (x power 2, m322, l63bl fiesta)"],[1199,720,6,"lg stylo 3 (l83bl)"],[1280,720,6,"hisense f23"],[1280,736,6,"lenovo tb-8504"],[1280,752,6,"lenovo tb-x304"],[1344,720,6,"wiko view"],[1223,800,6,"huawei mediapad t3 8.0 (kob-xxx)"],[1368,720,6,"casper via g1"],[1280,800,6,"samsung galaxy tab a2 s (sm-t380, sm-t385)"]]],["qualcomm adreno 320","320",0,[[1196,720,11,"pantech im-a850 vega r3"],[1196,768,10,"google nexus 4 (lg e960)"],[1280,720,8,"blackberry z30"],[1280,752,8,"asus memo pad 10 (k01e me103k)"],[1280,768,10,"lg optimus g (e97x, ls970, e987, f180, kddi lgl21)"],[1920,1008,5,"technicolor px36"],[1794,1080,5,"sony xperia z (c66xx, so-02e, l36x)"],[1848,1080,5,"pantech im-a860 vega n6"],[1920,1080,5,"zte nubia z5 (nx501, nx50x)"],[1920,1104,5,"google nexus 7 (2nd gen, razor)"],[1920,1114,4,"lg g pad 8.3 (vk810 4g)"],[1920,1128,5,"sony xperia tablet z (sgp3xx, so-03e)"]]],["qualcomm adreno 330","330",0,[[800,480,18,"samsung sm-w2014"],[1184,720,27,"sony so-04g xperia a4"],[1196,720,21,"sony xperia j1 compact (d5788)"],[1202,720,21,"lg g flex (d95x, ls995, lgl23, f340)"],[1280,720,20,"amazon fire phone (sd4930ur)"],[1280,768,21,"samsung sm-w2015 galaxy golden 2"],[1280,960,14,"lg f300 optimus vu 3"],[1600,1152,15,"hp pro slate 12"],[1440,1308,10,"blackberry passport"],[1776,1080,11,"google nexus 5"],[1788,1080,11,"lg g3 a f410"],[1794,1080,10,"fujitsu f-01f arrows nx luge (docomo)"],[1803,1080,11,"lg g pro 2 (d838, f350)"],[1836,1080,11,"sony xperia z ultra (c68xx, xl39h, sol24, sgp412)"],[1920,1080,9,"qualcomm quanta is7"],[1920,1104,12,"ntt docomo sh-06f sharp aquos pad"],[1920,1128,12,"sony xperia z2 tablet (sgp5xx, so-05f, sot21)"],[1920,1129,10,"lg g pad ii (v935, v940 prada 3.0, v930 g pad x 10.1, uk932)"],[1920,1200,9,"amazon kindle fire hdx 7 (3rd gen, kfthwa, kfthwi)"],[2048,1440,8,"hp red"],[2392,1440,8,"fujitsu f-02g arrows nx (docomo)"],[2400,1440,6,"iuni u3"],[2560,1440,7,"vivo x520l xplay 3s"],[2560,1504,7,"ntt docomo f-03g (fujitsu arrows tab)"],[2560,1600,5,"samsung sm-t525 galaxy tab pro 10.1"]]],["qualcomm adreno 405","405",0,[[1184,720,13,"lyf ls-5015 water 8"],[1196,720,10,"alcatel 6044 one touch pop up"],[1200,720,12,"oppo a53"],[1280,720,8,"hisense c1"],[1280,736,10,"asus zenpad 8 (adreno 405, p024 z380kl)"],[1776,1080,7,"lyf ls-5505"],[1794,1080,6,"medion life x5020"],[1798,1080,7,"lg h740 g vista 2"],[1800,1080,6,"oppo r7s plus"],[1803,1080,6,"oppo r7 plus (adreno 405)"],[1812,1080,6,"ramos mos1"],[1824,1080,6,"vargo ivargo v210101"],[1836,1080,6,"lenovo pb1-770m everypad3"],[1920,1080,2,"smartisan yq607 jianguo"],[1920,1104,5,"lg vk815 g pad x8.3, p815l g pad ii 8.3"],[1920,1111,6,"lg g pad x 8.0 (v52x)"],[1794,1200,5,"qisda f80"],[1920,1128,5,"huawei mediapad t2 10.0 pro (fdr-xxx)"],[1830,1200,6,"huawei mediapad x3 (ple-xxx)"],[1836,1200,6,"huawei mediapad t2 8.0 pro (jdn-xxx)"]]],["qualcomm adreno 418","418",0,[[1280,768,28,"samsung sm-g9198"],[1776,1080,17,"sharp sh-m03 aquos mini"],[1794,1080,15,"softbank 502sh (sharp aquos xx2)"],[1920,1080,11,"smartisan t2 (sm801)"],[2368,1440,10,"fujitsu f-02h arrows nx (docomo)"],[2392,1440,10,"lg k600"],[2413,1440,10,"motorola moto x style, pure (xt1570, xt1572, xt1575)"],[2560,1440,9,"qiku q terra (8692-a00)"],[2560,1504,9,"ntt docomo f-04h arrows tab"]]],["qualcomm adreno 420","420",0,[[1280,720,32,"odg r7-w"],[1920,1080,20,"samsung galaxy s5 (adreno 420, sm-g901)"],[2392,1440,13,"lg g3 (adreno 420, f460)"],[2560,1352,7,"qualcomm apq8084 (adreno 420, development board)"],[2413,1440,12,"motorola moto x pro"],[2560,1440,8,"qualcomm liquid (adreno 420, windows, development board)"],[2560,1532,12,"samsung galaxy note edge (adreno 420, sm-n915x, scl24, sc-01g)"],[2560,1600,11,"amazon kindle fire hdx 8.9 (4th gen, kfsawa, kfsawi)"]]],["qualcomm adreno 430","430",0,[[1184,720,53,"sony xperia z5 compact (e58xx, so-02h)"],[1280,720,18,"zebra technologies mtp8994"],[1776,1080,29,"sony xperia z5 (e66xx, so-01h, sov32, 501so)"],[1794,1080,19,"vertu signature touch (2015)"],[1920,1080,9,"nokia rm-1106"],[1920,1104,21,"ntt docomo sh-05g sharp aquos pad"],[2392,1440,11,"sony e6508 vzw xperia z4v"],[2413,1440,17,"sirin labs solarin"],[2560,1440,7,"microsoft rm-1105"],[2560,1504,16,"sony xperia z4 tablet (sgp7xx, so-05g, sot31)"]]],["qualcomm adreno 505","505",0,[[728,480,29,"zebra technologies tc25"],[1184,720,15,"ivvi i3-01"],[1196,720,15,"huawei honor 6c (dig-xxx)"],[1199,720,14,"lg stylus 2 plus (ms550, k550)"],[1280,720,14,"xiaomi land"],[1344,720,14,"wiko view prime"],[1368,720,13,"micromax hs3"],[1776,1080,7,"hisense a2"],[1787,1080,7,"lg qua phone px (lgv33)"],[1794,1080,7,"pantech im-100 vega"],[1798,1080,8,"lg stylo 3 plus (tp450, mp450, m470)"],[1802,1080,7,"lg k11 (k530, k535)"],[1812,1080,7,"sugar f11"],[1920,1080,6,"lg x venture (h700, m710)"],[1920,1111,6,"lg g pad x ii 8.0 plus (v530)"],[2004,1080,7,"lg q6 (m700, x600)"],[1920,1128,7,"vodafone vfd 1400"],[1920,1132,7,"huawei mediapad t3 lite 10 (bah-xxx)"],[1839,1200,7,"huawei mediapad m3 lite 8.0 (cpn-xxx)"]]],["qualcomm adreno 506","506",0,[[1184,720,20,"fujitsu f-04j docomo"],[1280,720,20,"samsung galaxy j7 2017 (adreno 506, sm-j727x)"],[1320,720,18,"xiaomi redmi 5"],[1356,720,18,"vivo v7 plus (1716)"],[1620,1080,11,"blackberry bbb100-x (keyone, mercury)"],[1776,1080,10,"condor plume h1"],[1788,1080,10,"huawei nova (caz-xxx)"],[1794,1080,10,"nuans neo reloaded"],[1920,1080,9,"blackberry bbd100"],[1920,1104,9,"nec lavietab pc-ts508fam"],[1980,1080,10,"xiaomi redmi 5 plus"],[1920,1128,9,"zte k92 primetime"],[1920,1132,9,"vestel v tab 1090 lte"],[1920,1200,9,"i.safe is910.1"]]],["qualcomm adreno 508","508",0,[[1776,1080,15,"sonim xp8812"],[1798,1080,15,"sharp fs8010"],[1920,1080,14,"htc u11 life"],[2009,1080,14,"vestel venus z20"]]],["qualcomm adreno 509","509",0,[[2159,1080,15,"asus zenfone 5"]]],["qualcomm adreno 510","510",0,[[1184,720,31,"zebra technologies tc51"],[1208,800,27,"askey turbonet tn800a1 turbotab e1"],[1366,720,29,"sony xperia touch (g1109)"],[1776,1080,13,"agm x2"],[1794,1080,14,"qualcomm msm8952 (adreno 510, development board)"],[1920,1080,14,"coolpad r116 cool1"],[2048,1440,11,"asus zenpad 3 8.0 (p008 z581kl)"],[2160,1440,10,"jide remix pro"],[2048,1536,11,"asus zenpad z10 (p00i zt500kl)"],[2368,1440,10,"vodafone vfd 900"],[2392,1440,10,"sharp aquos z3 (fs8009)"],[2413,1440,9,"infocus m820"],[2560,1440,9,"vivo pd1522a"],[2560,1504,9,"lenovo yoga tab3 plus (yt-x703)"]]],["qualcomm adreno 512","512",0,[[782,480,59,"honeywell cn80"],[1798,1080,23,"sharp fs8016"],[1920,1080,22,"vivo td1608"],[2016,1080,22,"oppo r11s"],[2034,1080,22,"vivo x20a"],[2151,1080,20,"xiaomi redmi note 7"]]],["qualcomm adreno 530","530",0,[[1600,900,56,"keecker keecker"],[1776,1080,43,"softbank 506sh (sharp aquos phone xx3)"],[1794,1080,49,"google pixel"],[1920,1024,47,"contextmedia p-wal-107-elc-03"],[1920,1080,26,"nokia 6071w"],[2048,1536,35,"samsung galaxy tab s3 (sm-t82x)"],[2368,1440,27,"motorola xt1650 (1.8 ghz)"],[2392,1440,21,"lg q8 (h970, x800l)"],[2416,1440,31,"alcatel 6076s"],[2560,1439,17,"hp elite x3"],[2560,1440,4,"hp falcon"],[2672,1440,30,"lg g6 (g600, us997, ls993, vs988, h87x)"],[2880,1440,26,"baofeng ke-01"],[3840,2076,15,"via vt6093"]]],["qualcomm adreno 540","540",0,[[1184,720,61,"sony xperia xz1 compact (g8441)"],[1776,1080,57,"sony xperia xz1 (g834x, sov36, so-01k, 701so)"],[1794,1080,57,"google pixel 2 (walleye)"],[1920,1080,56,"zte nx595j nubia"],[1980,1080,56,"xiaomi mi mix 2"],[2034,1080,55,"oneplus 5t (a5010)"],[2276,1312,43,"essential ph-1"],[2368,1440,39,"sharp aquos r (sh-03j, shv39, 605sh)"],[2392,1440,41,"qualcomm adreno 540 (development board)"],[2416,1440,40,"razer phone"],[2560,1440,36,"htc u11 (u-3x, 2pzc100, 2pzc5, htv33, 601ht)"],[2678,1440,35,"samsung galaxy s8 active (sm-g892)"],[2768,1440,33,"samsung galaxy s8+ (adreno 540, sm-g955x, sc-03j, scv35)"],[2960,1440,33,"samsung galaxy note 8 (adreno 540, sm-n950, sc-01k, scv37)"]]],["qualcomm adreno 615","615",0,[[2560,1492,18,"samsung galaxy tab s5e sm-t720"]]],["qualcomm adreno 616","616",0,[[2047,1080,30,"meizu x8"]]],["qualcomm adreno 618","618",0,[[2183,1080,38,"samsung galaxy a71 (sm-a715f)"],[2274,1080,37,"samsung galaxy a80 sm-a805f"]]],["qualcomm adreno 630","630",0,[[2792,1440,49,"samsung galaxy s9+ (adreno 630, sm-g965)"]]],["qualcomm adreno 640","640",0,[[2020,1080,60,"samsung galaxy s10e (adreno 640, sm-g970x)"],[2064,1080,60,"samsung galaxy note 10 (adreno 640, sm-n970x)"],[2181,1080,60,"samsung galaxy s10 lite"],[2198,1080,60,"samsung galaxy a90 5g"],[2210,1080,79,"xiaomi redmi k20 pro premium edition"],[2048,1410,59,"samsung galaxy fold 5g (adreno 640, sm-f900x)"],[2723,1440,55,"samsung galaxy s10 (adreno 640, sm-g973x)"],[2730,1440,56,"samsung galaxy s10+ (adreno 640, sm-g975x)"],[2759,1440,56,"samsung galaxy note 10+ (adreno 640, sm-n975x)"],[2901,1440,55,"samsung galaxy s10 5g (adreno 640, sm-g977x)"]]],["qualcomm adreno 650","650",0,[[2274,1080,90,"asus zenfone 7"],[3101,1387,50,"samsung galaxy s20 ultra 5g (sm-g988u1)"]]]]\')},535:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a10 gpu","10",0,[[2048,1536,41,"apple ipad (6th gen)"],[2160,1620,36,"apple ipad (10.2-inch) (7th generation)"]]],["apple a10x gpu","10",0,[[2048,1536,59,"apple ipad pro (10.5-inch)"],[2224,1668,69,"apple ipad pro (10.5-inch)"],[2732,2048,46,"apple ipad pro (12.9-inch, 2nd gen)"]]],["apple a12 gpu","12",0,[[2048,1536,60,"apple ipad mini (2019)"]]],["apple a12x gpu","12",0,[[2224,1668,116,"apple ipad pro (11-inch)"],[2388,1668,115,"apple ipad pro (11-inch)"],[2732,2048,60,"apple ipad pro (12.9-inch) (3rd generation)"]]],["apple a12z gpu","12",0,[[2388,1668,115,"apple ipad pro (11-inch) (2nd generation)"],[2732,2048,60,"apple ipad pro (12.9 inch) (4th generation)"]]],["apple a13 gpu","13",0,[[2160,1620,59,"apple ipad 9th gen"]]],["apple a14 gpu","14",0,[[2388,1668,52,"apple ipad air 4th gen (wi-fi only)"]]],["apple a15 gpu","15",0,[[2388,1668,60,"apple ipad mini (6th gen)"]]],["apple a7 gpu","7",0,[[2048,1536,10,"apple ipad mini 3"]]],["apple a8 gpu","8",0,[[2048,1536,16,"apple ipad mini 4"]]],["apple a8x gpu","8",0,[[2048,1536,30,"apple ipad air 2"]]],["apple a9 gpu","9",0,[[2048,1536,29,"apple ipad 9.7 (5th gen)"]]],["apple a9x gpu","9",0,[[2048,1536,40,"apple ipad pro 9.7"],[2732,2048,35,"apple ipad pro"]]],["apple m1 gpu","1",0,[[2732,2048,60,"apple ipad pro (12.9-inch) (5th generation)"]]]]\')},438:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["apple a10 gpu","10",0,[[1334,750,104,"apple iphone 7"],[1920,1080,60,"apple iphone 7 plus"],[2001,1125,59,"apple iphone x"]]],["apple a11 gpu","11",0,[[1334,750,64,"apple iphone 8"],[1920,1080,78,"apple iphone 8 plus"]]],["apple a12 gpu","12",0,[[1792,828,60,"apple iphone xr"],[2436,1125,57,"apple iphone xs"],[2208,1242,60,"apple iphone xs max"]]],["apple a13 gpu","13",0,[[1334,750,60,"apple iphone se (2nd gen)"],[1792,828,61,"apple iphone 11"],[2436,1125,60,"apple iphone 11 pro"],[2688,1242,61,"apple iphone 11 pro max"]]],["apple a14 gpu","14",0,[[2338,1080,60,"apple iphone 12 mini"],[2436,1125,60,"apple iphone 12"],[2778,1284,60,"apple iphone 12 pro max"]]],["apple a15 gpu","15",0,[[2338,1080,60,"apple iphone 13 mini"],[2436,1125,60,"apple iphone 13 pro"],[2688,1242,60,"apple iphone 13 pro max"]]],["apple a7 gpu","7",0,[[1136,640,32,"apple iphone 5s"]]],["apple a8 gpu","8",0,[[1136,640,40,"apple ipod touch 6"],[1334,750,36,"apple iphone 6"],[1920,1080,21,"apple iphone 6 plus"]]],["apple a9 gpu","9",0,[[1136,640,90,"apple iphone se"],[1334,750,72,"apple iphone 6s"],[1920,1080,42,"apple iphone 6s plus"]]]]\')},283:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["intel intel hd graphics for atom x5","5",0,[[1024,600,35,"amazon aeokn"],[1024,720,13,"arbor venus 8"],[1217,720,23,"gole gole1"],[1280,736,27,"medion p850x"],[1360,704,15,"chuwi hibox hero mini pc"],[1280,752,21,"tetratab casebook 3"],[1280,759,28,"lenovo yoga a12 (yb-q501f)"],[1366,720,19,"nextbook nx16a11264 ares 11 (x5-z8300)"],[1920,996,20,"teclast x16 pro"],[1920,1008,12,"teclast tbook 16 pro"],[1920,1016,13,"teclast x16 plus"],[1920,1104,13,"medion p851x"],[1920,1116,13,"teclast x80 pro (x5-z8350)"],[1920,1128,8,"cube technology i12-y"],[1920,1133,9,"cube technology i1-tfp (x5-z8350)"],[1920,1134,11,"microtech e-tab pro lte"],[1920,1136,14,"cube technology iwork 10 ultimate (i15-t)"],[1920,1214,10,"chuwi cw-hi10 plus (x5-z8350)"],[2048,1440,8,"teclast x98 plus"],[2160,1368,10,"chuwi hi12 (x5-z8350)"],[2048,1452,10,"teclast x98 plus ii"],[2048,1536,14,"xiaomi mi pad 2"],[2560,1356,7,"baofeng a1"],[2560,1504,6,"chuwi hibook pro (z8350)"],[2560,1518,11,"lenovo yt3-x90 yoga tablet 3 pro (x5-z8550)"]]],["intel intel hd graphics for baytrail","hdfor",0,[[1024,552,13,"multilaser intel 7qc"],[1024,696,17,"thundersoft dual os tablet"],[1024,720,15,"airis onepad 785i"],[1184,720,18,"trimble tdc500"],[1280,736,12,"acer a1-840"],[1280,752,9,"imuz mupad win 10.1 ii"],[1366,720,13,"nextbook nxa116qc164"],[1366,724,10,"cube technology i10 remix"],[1440,1008,12,"teclast x89 kindow"],[1920,1008,8,"minix neo z64"],[1920,1014,9,"cube technology i7 cx remix"],[1920,1032,11,"hp slate 17"],[1920,1104,5,"jltd d630"],[1920,1128,6,"intel(r) e1008"],[1920,1133,9,"pipo w3f"],[2048,1440,6,"kruger & matz eagle 975 (km0975)"],[2048,1448,6,"jide e-tab 3g"],[2048,1464,6,"reeder a10ix air"],[2560,1344,7,"lenovo yoga tablet 2 pro-1380"],[2560,1504,5,"teclast x10hd 3g"]]],["intel mesa dri intel bay trail","dribay",0,[[1366,768,15,"google chromebook pixel (2015, n2830)"]]],["intel mesa dri intel hd","drihd",0,[[688,412,39,"hp chromebook x360 11 g1 ee"],[960,568,36,"google chromebook pixel (2015, n3450)"],[1024,561,28,"aaeon up-cht01 up board"],[1024,736,33,"google chromebook reef (n3350)"]]],["intel mesa dri intel hd graphics 400","400",0,[[688,412,41,"asus c202sa chromebook"],[768,431,45,"hp chromebook 11 g5"],[960,568,25,"acer chromebook r11 (n3050)"],[1366,768,19,"samsung chromebook 3"],[1536,832,25,"google chromebook r11 (n3160)"],[1920,1080,17,"acer chromebook 14"]]],["intel mesa dri intel hd graphics 510","510",0,[[690,378,53,"hp chromebook chell"],[688,412,60,"acer chromebook 14 for work"]]],["intel mesa dri intel hd graphics 515","515",0,[[1033,617,56,"samsung chromebook pro (m7-6y75, caroline)"],[1536,1088,32,"google chromebook pixel (2015, m3-6y30)"],[1920,980,32,"asus c302 chromebook flip"],[2400,1504,22,"samsung chromebook pro (caroline)"],[3200,1640,12,"google chromebook pixel (2015, 4405y)"]]],["intel mesa dri intel hd graphics 520","520",0,[[700,412,60,"acer chromebook 14 for work (i3-6100u)"]]],["intel mesa dri intel hd graphics 5500","5500",0,[[1080,575,59,"google chromebook pixel (2015, i3-5005u)"],[1920,1000,30,"google chromebook pixel (2015, i5-5300u)"],[2560,1700,14,"google chromebook pixel (2015, i5-5200u)"]]],["intel mesa dri intel hd graphics 615","615",0,[[1034,618,55,"google soraka (4415y)"],[1200,720,34,"google poppy (4410y, kabylake)"],[2400,1504,21,"google chromebook eve (i5-7y54)"]]],["intel mesa dri intel kabylake gt2","2",0,[[960,568,38,"google chromebook pixel (2015, m3-7y30)"]]]]\')},327:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["arm mali-t604 mp4","604",0,[[2560,1504,4,"google nexus 10"]]],["arm mali-t622","622",0,[[1024,564,12,"telechips tcc896x (quad core, development board)"],[1280,720,7,"leadcore l1860 (mali-t622, development board)"]]],["arm mali-t624","624",0,[[1794,1080,7,"huawei grace"],[1812,1080,6,"huawei abc-ul00"],[1830,1080,10,"huawei p8 max (dav-70x)"],[1920,1080,4,"sony amai vp9"],[1920,1104,9,"huawei dtab compact d-02h (docomo)"],[1920,1128,8,"huawei dtab d-01h (docomo)"],[1824,1200,9,"huawei mediapad m2 (m2-80xx)"],[1830,1200,9,"huawei mediapad x2 (gem-701l, gem-702l, gem-703l)"]]],["arm mali-t624 mp2","624",0,[[1280,720,5,"samsung sm-g910f (mali-t624)"]]],["arm mali-t624 mp4","624",0,[[1794,1080,9,"huawei z100"]]],["arm mali-t628","628",0,[[1024,600,30,"thinkware inavi davinci"],[2560,1536,8,"meizu mx4 pro"]]],["arm mali-t628 mp2","628",0,[[1280,720,8,"leadcore l1860 (development board)"]]],["arm mali-t628 mp6","628",0,[[800,480,35,"gen2wave rp1600"],[1280,672,14,"hardkernel odroid-xu3 (development board)"],[1280,720,26,"samsung galaxy alpha (mali-t628, sm-g850)"],[1920,1080,11,"samsung galaxy note iii (mali-t628, sm-n900, sm-n9000q)"],[2560,1600,3,"samsung sm-t520 galaxy tab 10.1"]]],["arm mali-t720","720",0,[[432,240,16,"unihertz jelly pro"],[782,480,8,"mobiistar lai zoro"],[784,480,8,"lg k3 (k100)"],[791,480,6,"i-mobile i-style 812 4g"],[800,480,4,"lava iris 550"],[854,480,3,"verykool sl5009 jet"],[897,540,5,"bluboo xfire"],[960,540,3,"siswoo a5 chocolate"],[1024,552,4,"bb-mobile tq763i techno 7.0 lte"],[1024,714,9,"bluedot bnt-791 (2g)"],[1024,720,3,"zte e8qp"],[1280,624,10,"panasonic p55 novo 4g"],[1280,648,4,"tcl 9025"],[1280,656,7,"acer a1-734 iconia talk s"],[1184,720,4,"lenovo xt1700, xt1706, k10a40"],[1187,720,7,"lg k8 (k350)"],[1189,720,5,"ark impulse p2"],[1193,720,7,"lg x power (k220, f750)"],[1196,720,2,"dtac phone m2"],[1198,720,5,"dtac phone t3"],[1205,720,7,"firefly aurii passion"],[1206,720,4,"archos 50 power"],[1208,720,3,"advan i7 plus"],[1217,720,7,"energy sistem energy phone max 2+"],[1238,720,9,"vnpt technology vivas lotus s3 lte"],[1280,720,2,"archos bush spira c2 5"],[1280,736,2,"digma cs1062ml citi 1903 4g"],[1280,737,3,"waywalkers t805g"],[1280,740,3,"casper via l8"],[1280,746,3,"philips tle821l e line 4g"],[1280,752,3,"4good light at200"],[1280,755,7,"leotec letab1020 supernova qi32"],[1356,720,8,"xiaolajiao la-v11"],[1360,720,7,"tecno in5"],[1368,720,7,"tinno p100"],[1280,800,4,"samsung galaxy tab e 8.0 (sm-t375x, sm-t377x)"],[1920,936,4,"panasonic eluga note"],[1920,996,4,"cube technology u83 iplay10"],[1776,1080,4,"fly fs522 cirrus 14"],[1787,1080,5,"lg x cam (k580, f690)"],[1920,1008,6,"alcatel one touch xess (p17aa)"],[1794,1080,3,"ramos mos 1 max"],[1800,1080,4,"archos sense 55 s"],[1815,1080,4,"archos diamond plus"],[1920,1032,5,"virgin media tellytablet"],[1920,1080,2,"infocus m640"],[1920,1104,4,"vestel v tab 7030"],[1920,1116,4,"jty q101"],[1920,1128,2,"archos 80 oxygen"],[2009,1080,4,"tcl 5099"],[1920,1136,4,"asus zenpad 10 (p028 z301m)"]]],["arm mali-t760","760",0,[[854,480,14,"aux t6200l"],[897,540,13,"sony xperia e4g (e20xx)"],[960,540,12,"gionee v381"],[960,568,24,"asus c100pa chromebook flip"],[1024,552,12,"archos 70 helium"],[1024,720,10,"wiz t-8168"],[1188,720,9,"lg h520 magna, h522 prime plus"],[1196,720,9,"acer s57 liquid jade z"],[1280,720,8,"dunetek vitamin a"],[1280,736,8,"archos 80b helium"],[1280,752,8,"frael m10g 4g"],[1280,768,8,"meizu m1"],[1794,1080,6,"sugar 2 ss136 l8560"],[1920,1032,9,"qbic bxp-300 box pc"],[1920,1080,4,"byxpress mphone xone"],[1920,1104,6,"cube technology t7"],[1920,1128,5,"nec lavietab pc-te510bal"],[2048,1440,3,"teclast p98 4g"],[2560,1440,10,"samsung galaxy note 4 (mali-t760, sm-n910x, sm-n916)"]]],["arm mali-t760 mp6","760",0,[[1920,1080,17,"samsung galaxy a8 (mali-t760, sm-a800x, scv32)"],[2048,1536,12,"samsung galaxy tab s 2 8.0 (sm-t710, sm-t715)"],[2560,1532,10,"samsung galaxy note edge (mali-t760, sm-n915x)"],[2560,1600,10,"samsung galaxy tab s 10.5 (mali-t760, sm-t805s)"]]],["arm mali-t760 mp8","760",0,[[1280,768,42,"samsung sm-w2016"],[1920,1080,25,"meizu niux"],[2160,1200,17,"idealens k2"],[2560,1440,12,"le xiang deepoon m2 vr"],[2560,1504,15,"bungbungame kalos 2"]]],["arm mali-t764","764",0,[[1024,600,19,"gpd q9"],[1280,720,15,"gpd xd"],[1280,752,13,"kruger & matz 1064.1g eagle"],[1280,800,13,"pipo p7"],[1920,1008,6,"rockchip mk809 4k tv stick"],[1920,1010,8,"pipo p7 hd"],[1920,1020,5,"rockchip mk903v mini tv"],[1920,1032,7,"acooo oneboard pro+"],[1872,1080,7,"contextmedia wallboard 32 tablet (p-wal-106-yit-01)"],[1920,1080,7,"rockchip cs4k tv box"],[1920,1128,7,"archos 101 oxygen"],[2048,1437,5,"haier pad 971"],[2048,1440,5,"hisense f5281 vidaa pad"],[2560,1504,4,"teclast p90hd"]]],["arm mali-t820","820",0,[[1344,720,5,"lenovo k320t"],[1776,1080,6,"leagoo t5c"],[1920,1008,7,"probox2 ava tv box"],[1920,1080,4,"skyworth coocaa 5s32 n2"]]],["arm mali-t830","830",0,[[1280,720,9,"samsung galaxy on7 (mali-t830, sm-g600x)"],[1280,800,9,"samsung sm-t536 (mali-t830)"],[1776,1080,9,"huawei p10 lite (was-xxx)"],[1794,1080,9,"huawei honor 6x (bln-xxx)"],[1920,1080,5,"samsung galaxy on7 prime 2018 (sm-g611)"],[2033,1080,8,"huawei p smart (fig-xxx)"],[2040,1080,9,"huawei maimang 6 (rne-xxx)"],[1920,1200,5,"samsung galaxy tab a 10.1 (sm-t580, sm-t585)"]]],["arm mali-t860","860",0,[[1184,720,8,"tcl a626"],[1196,720,8,"green orange go t2"],[1280,720,14,"htc one a9s"],[1920,1024,17,"hardkernel odroid-n1 (development board)"],[1920,1032,16,"contextmedia p-wal-108-elc-02"],[1920,1080,7,"htc u play (u-2u)"],[1920,1116,15,"imuz revolution a8"],[1920,1128,15,"rockchip rk3399 (development board)"],[2400,1440,10,"samsung chromebook plus (kevin)"]]],["arm mali-t860 mp2","860",0,[[598,480,25,"cipherlab 9700a"],[1184,720,11,"vernee m5"],[1193,720,11,"lg x power 2 (u+, x500, m-x320, m320)"],[1196,720,11,"lava z25"],[1199,720,11,"lg stylus 3 (m400)"],[1212,720,11,"meeg 306"],[1280,720,10,"oppo r66"],[1336,720,13,"asus pegasus 4s (x018d zb570tl)"],[1344,720,13,"allview x4 soul infinity n"],[1776,1080,7,"benq f55"],[1794,1080,6,"alcatel 7070"],[1798,1080,7,"energy sistem energy phone pro 3"],[1806,1080,8,"tecno phantom 6"],[1807,1080,7,"covia fleaz cp-j55a g07"],[1810,1080,8,"archos 55 diamond 2 plus"],[1920,1080,4,"advan vandroid i55c"],[2004,1080,7,"asus zenfone max plus m1 (x018d zb570tl)"],[1920,1128,7,"verizon qtaxia1"]]],["arm mali-t880","880",0,[[1184,720,22,"doogee mix"],[1280,720,20,"lenovo k8"],[1344,720,18,"casper via f2"],[1776,1080,11,"alcatel 6060 (mali-t880)"],[1794,1080,20,"huawei mate 8 (nxt-xxx)"],[1824,1080,11,"meiigoo m1"],[1920,1080,10,"letv leeco lex650"],[2016,1080,9,"vernee mix 2"],[2064,1080,10,"umi s2 pro"],[2392,1440,12,"huawei honor v8 (knt-al20)"],[2434,1440,11,"huawei honor note 8 premium edition (edi-al10)"],[2560,1440,24,"meizu pro 6 plus"],[2560,1480,10,"huawei dtab compact d-01j (docomo)"],[2560,1600,10,"huawei mediapad m3 (btv-xxx)"]]],["arm mali-t880 mp12","880",0,[[1920,1080,44,"samsung galaxy s7 (sm-g930f)"],[2560,1440,27,"samsung galaxy note 7 (mali-t880, sm-n930)"]]],["arm mali-t880 mp2","880",0,[[1184,720,19,"sony pikachu"],[1376,720,17,"umi s2"],[1776,1080,10,"coolpad a9s-9"],[1800,1080,11,"infinix x603"],[1920,1080,9,"innjoo pro2"]]],["arm mali-t880 mp4","880",0,[[1280,672,18,"mediatek x20 (development board)"],[1794,1080,13,"infocus tsp"],[1800,1080,16,"infinix x602 zero 4 plus"],[1806,1080,16,"tecno phantom a9"],[1810,1080,8,"mobiistar prime x pro"],[1815,1080,16,"tecno phantom 6 plus"],[1920,1080,7,"elephone r9"],[2048,1440,12,"brown tab 1"],[2392,1440,12,"vernee apollo"],[2416,1440,11,"freetel ftj162b kiwami2"],[2560,1440,10,"ivvi i5"]]],["mali-t830","830",0,[[1480,720,10,"samsung gm-j600fn"]]]]\')},538:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["arm mali-g31","31",0,[[1920,1080,7,"mecool km9 pro"]]],["arm mali-g51","51",0,[[1920,636,10,"telechips tcc803x_lcn"],[1920,1080,5,"skyworth 8n10 g1a"]]],["arm mali-g52 mc1","52",0,[[1280,736,25,"amazon fire hd 8 (kfonwi, 2020)"]]],["arm mali-g52 mc2","52",0,[[2110,1080,23,"xiaomi redmi 10x 4g"],[2264,1080,20,"xiaomi redmi 9 m2004j19c"],[2400,1080,20,"huawei y9a frl-l22"]]],["arm mali-g57 mc3","57",0,[[2158,1080,48,"realme rmx2173"]]],["arm mali-g71","71",0,[[1280,720,14,"samsung sm-j337"],[1812,1080,53,"huawei mate 9 (mha-xxx)"],[1920,1080,12,"sony amai vp9 (mali-g71)"],[2009,1080,11,"tcl 6062"],[2016,1080,11,"gionee s11"],[2038,1080,10,"ulefone power 3"],[2076,1080,15,"samsung galaxy a8 2018 (sm-a530x)"],[2094,1080,15,"samsung sm-a730x"],[2160,1080,9,"oukitel k6"],[2368,1440,35,"huawei honor v9 (duk-xxx)"],[2560,1440,32,"huawei mate 9 pro (lon-xxx)"],[2678,1440,41,"samsung galaxy s8 (mali-g71, sm-g950x)"],[2960,1440,39,"samsung galaxy s8+ (mali-g71, sm-g955x)"]]],["arm mali-g72","72",0,[[2041,1080,55,"huawei mate 10 pro (bla-xxx)"],[2160,1080,56,"huawei honor view 10 (v10, bkl-xxx)"],[2560,1440,43,"huawei mate 10 (alp-xxx)"],[2768,1440,47,"samsung galaxy s9 (mali-g72, sm-g960)"],[2792,1440,47,"samsung galaxy s9+ (mali-g72, sm-g965)"]]],["arm mali-g76","76",0,[[2020,1080,60,"samsung galaxy s10e (mali-g76, sm-g970x)"],[2029,1080,31,"samsung galaxy s10 plus sm-g975n"],[2064,1080,60,"samsung galaxy note 10 5g (mali-g76, sm-n971x)"],[2159,1080,47,"samsung galaxy a51 5g"],[2232,1080,59,"huawei honor 20 pro yal-l41"],[2328,1128,60,"huawei mate 30 pro (lio-lx9, lio-xl00"],[2723,1440,57,"samsung galaxy s10 (mali-g76, sm-g973x)"],[2730,1440,56,"samsung galaxy s10+ (mali-g76, sm-g975x)"],[2733,1440,56,"samsung galaxy s10 5g (mali-g76, sm-g977x)"],[2759,1440,57,"samsung galaxy note 10+ (mali-g76, sm-n975x)"]]],["arm mali-g77","77",0,[[2178,1080,60,"samsung galaxy s20 5g (sm-g981b)"],[2200,1080,67,"samsung galaxy s20 ultra 5g (sm-g988b)"],[2304,1080,55,"oppo pdcm00"]]],["arm mali-g77 mc9","77",0,[[2293,1080,59,"oppo pdsm00"]]],["arm mali-g78","78",0,[[2646,1288,90,"huawei mate 40 pro 5g"]]],["arm mali-t604 mp4","604",0,[[2560,1504,4,"google nexus 10"]]],["arm mali-t622","622",0,[[1024,564,12,"telechips tcc896x (quad core, development board)"],[1280,720,7,"leadcore l1860 (mali-t622, development board)"]]],["arm mali-t624","624",0,[[1794,1080,7,"huawei grace"],[1812,1080,6,"huawei abc-ul00"],[1830,1080,10,"huawei p8 max (dav-70x)"],[1920,1080,4,"sony amai vp9"],[1920,1104,9,"huawei dtab compact d-02h (docomo)"],[1920,1128,8,"huawei dtab d-01h (docomo)"],[1824,1200,9,"huawei mediapad m2 (m2-80xx)"],[1830,1200,9,"huawei mediapad x2 (gem-701l, gem-702l, gem-703l)"]]],["arm mali-t624 mp2","624",0,[[1280,720,5,"samsung sm-g910f (mali-t624)"]]],["arm mali-t624 mp4","624",0,[[1794,1080,9,"huawei z100"]]],["arm mali-t628","628",0,[[1024,600,30,"thinkware inavi davinci"],[2560,1536,8,"meizu mx4 pro"]]],["arm mali-t628 mp2","628",0,[[1280,720,8,"leadcore l1860 (development board)"]]],["arm mali-t628 mp6","628",0,[[800,480,35,"gen2wave rp1600"],[1280,672,14,"hardkernel odroid-xu3 (development board)"],[1280,720,26,"samsung galaxy alpha (mali-t628, sm-g850)"],[1920,1080,11,"samsung galaxy note iii (mali-t628, sm-n900, sm-n9000q)"],[2560,1600,3,"samsung sm-t520 galaxy tab 10.1"]]],["arm mali-t720","720",0,[[432,240,16,"unihertz jelly pro"],[782,480,8,"mobiistar lai zoro"],[784,480,8,"lg k3 (k100)"],[791,480,6,"i-mobile i-style 812 4g"],[800,480,4,"lava iris 550"],[854,480,3,"verykool sl5009 jet"],[897,540,5,"bluboo xfire"],[960,540,3,"siswoo a5 chocolate"],[1024,552,4,"bb-mobile tq763i techno 7.0 lte"],[1024,714,9,"bluedot bnt-791 (2g)"],[1024,720,3,"zte e8qp"],[1280,624,10,"panasonic p55 novo 4g"],[1280,648,4,"tcl 9025"],[1280,656,7,"acer a1-734 iconia talk s"],[1184,720,4,"lenovo xt1700, xt1706, k10a40"],[1187,720,7,"lg k8 (k350)"],[1189,720,5,"ark impulse p2"],[1193,720,7,"lg x power (k220, f750)"],[1196,720,2,"dtac phone m2"],[1198,720,5,"dtac phone t3"],[1205,720,7,"firefly aurii passion"],[1206,720,4,"archos 50 power"],[1208,720,3,"advan i7 plus"],[1217,720,7,"energy sistem energy phone max 2+"],[1238,720,9,"vnpt technology vivas lotus s3 lte"],[1280,720,2,"archos bush spira c2 5"],[1280,736,2,"digma cs1062ml citi 1903 4g"],[1280,737,3,"waywalkers t805g"],[1280,740,3,"casper via l8"],[1280,746,3,"philips tle821l e line 4g"],[1280,752,3,"4good light at200"],[1280,755,7,"leotec letab1020 supernova qi32"],[1356,720,8,"xiaolajiao la-v11"],[1360,720,7,"tecno in5"],[1368,720,7,"tinno p100"],[1280,800,4,"samsung galaxy tab e 8.0 (sm-t375x, sm-t377x)"],[1920,936,4,"panasonic eluga note"],[1920,996,4,"cube technology u83 iplay10"],[1776,1080,4,"fly fs522 cirrus 14"],[1787,1080,5,"lg x cam (k580, f690)"],[1920,1008,6,"alcatel one touch xess (p17aa)"],[1794,1080,3,"ramos mos 1 max"],[1800,1080,4,"archos sense 55 s"],[1815,1080,4,"archos diamond plus"],[1920,1032,5,"virgin media tellytablet"],[1920,1080,2,"infocus m640"],[1920,1104,4,"vestel v tab 7030"],[1920,1116,4,"jty q101"],[1920,1128,2,"archos 80 oxygen"],[2009,1080,4,"tcl 5099"],[1920,1136,4,"asus zenpad 10 (p028 z301m)"]]],["arm mali-t760","760",0,[[854,480,14,"aux t6200l"],[897,540,13,"sony xperia e4g (e20xx)"],[960,540,12,"gionee v381"],[960,568,24,"asus c100pa chromebook flip"],[1024,552,12,"archos 70 helium"],[1024,720,10,"wiz t-8168"],[1188,720,9,"lg h520 magna, h522 prime plus"],[1196,720,9,"acer s57 liquid jade z"],[1280,720,8,"dunetek vitamin a"],[1280,736,8,"archos 80b helium"],[1280,752,8,"frael m10g 4g"],[1280,768,8,"meizu m1"],[1794,1080,6,"sugar 2 ss136 l8560"],[1920,1032,9,"qbic bxp-300 box pc"],[1920,1080,4,"byxpress mphone xone"],[1920,1104,6,"cube technology t7"],[1920,1128,5,"nec lavietab pc-te510bal"],[2048,1440,3,"teclast p98 4g"],[2560,1440,10,"samsung galaxy note 4 (mali-t760, sm-n910x, sm-n916)"]]],["arm mali-t760 mp6","760",0,[[1920,1080,17,"samsung galaxy a8 (mali-t760, sm-a800x, scv32)"],[2048,1536,12,"samsung galaxy tab s 2 8.0 (sm-t710, sm-t715)"],[2560,1532,10,"samsung galaxy note edge (mali-t760, sm-n915x)"],[2560,1600,10,"samsung galaxy tab s 10.5 (mali-t760, sm-t805s)"]]],["arm mali-t760 mp8","760",0,[[1280,768,42,"samsung sm-w2016"],[1920,1080,25,"meizu niux"],[2160,1200,17,"idealens k2"],[2560,1440,12,"le xiang deepoon m2 vr"],[2560,1504,15,"bungbungame kalos 2"]]],["arm mali-t764","764",0,[[1024,600,19,"gpd q9"],[1280,720,15,"gpd xd"],[1280,752,13,"kruger & matz 1064.1g eagle"],[1280,800,13,"pipo p7"],[1920,1008,6,"rockchip mk809 4k tv stick"],[1920,1010,8,"pipo p7 hd"],[1920,1020,5,"rockchip mk903v mini tv"],[1920,1032,7,"acooo oneboard pro+"],[1872,1080,7,"contextmedia wallboard 32 tablet (p-wal-106-yit-01)"],[1920,1080,7,"rockchip cs4k tv box"],[1920,1128,7,"archos 101 oxygen"],[2048,1437,5,"haier pad 971"],[2048,1440,5,"hisense f5281 vidaa pad"],[2560,1504,4,"teclast p90hd"]]],["arm mali-t820","820",0,[[1344,720,5,"lenovo k320t"],[1776,1080,6,"leagoo t5c"],[1920,1008,7,"probox2 ava tv box"],[1920,1080,4,"skyworth coocaa 5s32 n2"]]],["arm mali-t830","830",0,[[1280,720,9,"samsung galaxy on7 (mali-t830, sm-g600x)"],[1280,800,9,"samsung sm-t536 (mali-t830)"],[1776,1080,9,"huawei p10 lite (was-xxx)"],[1794,1080,9,"huawei honor 6x (bln-xxx)"],[1920,1080,5,"samsung galaxy on7 prime 2018 (sm-g611)"],[2033,1080,8,"huawei p smart (fig-xxx)"],[2040,1080,9,"huawei maimang 6 (rne-xxx)"],[1920,1200,5,"samsung galaxy tab a 10.1 (sm-t580, sm-t585)"]]],["arm mali-t860","860",0,[[1184,720,8,"tcl a626"],[1196,720,8,"green orange go t2"],[1280,720,14,"htc one a9s"],[1920,1024,17,"hardkernel odroid-n1 (development board)"],[1920,1032,16,"contextmedia p-wal-108-elc-02"],[1920,1080,7,"htc u play (u-2u)"],[1920,1116,15,"imuz revolution a8"],[1920,1128,15,"rockchip rk3399 (development board)"],[2400,1440,10,"samsung chromebook plus (kevin)"]]],["arm mali-t860 mp2","860",0,[[598,480,25,"cipherlab 9700a"],[1184,720,11,"vernee m5"],[1193,720,11,"lg x power 2 (u+, x500, m-x320, m320)"],[1196,720,11,"lava z25"],[1199,720,11,"lg stylus 3 (m400)"],[1212,720,11,"meeg 306"],[1280,720,10,"oppo r66"],[1336,720,13,"asus pegasus 4s (x018d zb570tl)"],[1344,720,13,"allview x4 soul infinity n"],[1776,1080,7,"benq f55"],[1794,1080,6,"alcatel 7070"],[1798,1080,7,"energy sistem energy phone pro 3"],[1806,1080,8,"tecno phantom 6"],[1807,1080,7,"covia fleaz cp-j55a g07"],[1810,1080,8,"archos 55 diamond 2 plus"],[1920,1080,4,"advan vandroid i55c"],[2004,1080,7,"asus zenfone max plus m1 (x018d zb570tl)"],[1920,1128,7,"verizon qtaxia1"]]],["arm mali-t880","880",0,[[1184,720,22,"doogee mix"],[1280,720,20,"lenovo k8"],[1344,720,18,"casper via f2"],[1776,1080,11,"alcatel 6060 (mali-t880)"],[1794,1080,20,"huawei mate 8 (nxt-xxx)"],[1824,1080,11,"meiigoo m1"],[1920,1080,10,"letv leeco lex650"],[2016,1080,9,"vernee mix 2"],[2064,1080,10,"umi s2 pro"],[2392,1440,12,"huawei honor v8 (knt-al20)"],[2434,1440,11,"huawei honor note 8 premium edition (edi-al10)"],[2560,1440,24,"meizu pro 6 plus"],[2560,1480,10,"huawei dtab compact d-01j (docomo)"],[2560,1600,10,"huawei mediapad m3 (btv-xxx)"]]],["arm mali-t880 mp12","880",0,[[1920,1080,44,"samsung galaxy s7 (sm-g930f)"],[2560,1440,27,"samsung galaxy note 7 (mali-t880, sm-n930)"]]],["arm mali-t880 mp2","880",0,[[1184,720,19,"sony pikachu"],[1376,720,17,"umi s2"],[1776,1080,10,"coolpad a9s-9"],[1800,1080,11,"infinix x603"],[1920,1080,9,"innjoo pro2"]]],["arm mali-t880 mp4","880",0,[[1280,672,18,"mediatek x20 (development board)"],[1794,1080,13,"infocus tsp"],[1800,1080,16,"infinix x602 zero 4 plus"],[1806,1080,16,"tecno phantom a9"],[1810,1080,8,"mobiistar prime x pro"],[1815,1080,16,"tecno phantom 6 plus"],[1920,1080,7,"elephone r9"],[2048,1440,12,"brown tab 1"],[2392,1440,12,"vernee apollo"],[2416,1440,11,"freetel ftj162b kiwami2"],[2560,1440,10,"ivvi i5"]]],["mali-g71","71",0,[[2220,1080,54,"samsung s8+ sm-g955f"]]],["mali-g72","72",0,[[2220,1080,56,"samsung s9+ sm-g965f"]]],["mali-t830","830",0,[[1480,720,10,"samsung gm-j600fn"]]]]\')},884:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["nvidia tegra","",0,[[2048,1440,23,"google nexus 9"]]],["nvidia tegra k1","1",0,[[1920,1008,32,"nvidia jetson tk1 (pm375, development board)"],[1920,1032,12,"lenovo k1 hd (2014)"],[1920,1080,28,"nvidia tegra gk20a (ardbeg, development board)"],[1920,1104,29,"google project tango"],[2048,1536,21,"xiaomi mi pad"],[3840,2088,8,"lenovo thinkvision 28"]]],["nvidia tegra x1","1",0,[[1920,1080,60,"nvidia shield android tv"],[2560,1688,33,"google pixel c"]]]]\')},214:e=>{"use strict";e.exports=JSON.parse(\'["4.0.8",["powervr rogue g6110","6110",0,[[1024,600,11,"dasaita mtcd px5 head unit"],[1280,752,8,"visual land prestige prime 10se"],[1366,720,7,"ditecma m1092r"],[1920,1008,6,"vensmile t051 tv box"],[1920,1016,5,"geekbuying geekbox tv box"],[1920,1032,4,"hannspree hsg1351"],[1920,1080,5,"10moons tv box (rogue g6110)"],[1920,1128,5,"teclast p10"]]],["powervr rogue g6200","6200",0,[[1280,720,15,"infocus m530"],[1280,736,12,"amazon kindle fire hd 8 (5th gen, kfmewi)"],[1280,752,12,"amazon kindle fire hd 10 (5th gen, kftbwi)"],[1280,800,9,"amazon kindle fire hd 7 (4th gen, kfaswi)"],[1794,1080,5,"ubik uno"],[1920,1080,6,"cherry mobile x220 cosmos one plus"],[1920,1152,8,"meizu mx4 (m460, m460a, m461)"],[2392,1440,6,"hasee hl9916004"],[2560,1440,6,"condor allure a100 pgn-607"]]],["powervr rogue g6230","6230",0,[[1920,1008,8,"rikomagic mk80 tv box (tronsmart draco aw80, fantasy a80)"],[1920,1016,7,"cubietech cubieboard 4 (cc-a80, hansen-a80, development board)"],[2048,1440,5,"teclast p98air"],[2048,1464,7,"actions gs900a (development board)"]]],["powervr rogue g6400","6400",0,[[1794,1080,8,"lg f490 liger (g6400)"],[1920,1032,8,"renesas lager"]]],["powervr rogue g6430","6430",0,[[1024,552,26,"asus fonepad 7 (k01f fe171mg)"],[1280,720,27,"asus zenfone 2 (z008 ze550ml)"],[1280,736,20,"asus fonepad 7 (k019 fe375cg)"],[1280,752,27,"asus zenpad 10 (p01t z300cl)"],[1788,1080,8,"lg f490 liger (g6430)"],[1920,1080,15,"asus zenfone zoom (intel z3560, z00xsb zx551ml)"],[1920,1104,11,"asus memo pad 8 ast21 (intel z3580, k015 me581cl)"],[2048,1440,11,"asus zenpad s 8.0 (p01m z580c)"],[2560,1504,9,"dell venue 10 7040"]]],["powervr rogue ge8100","8100",0,[[906,480,8,"tinno k600"],[1184,720,5,"mediatek mt6739 (development board, rogue ge8100)"],[1339,720,5,"vodafone vfd 720"],[1344,720,6,"gionee f205"]]],["powervr rogue ge8300","8300",0,[[1280,752,9,"acer b3-a40 iconia one 10"],[1208,800,8,"verizon qtaki1"],[1920,1128,5,"acer b3-a40 fhd iconia one 10"]]],["powervr rogue gx6250","6250",0,[[688,412,16,"lenovo n23 yoga / flex 11 chromebook"],[1280,672,25,"renesas salvator-x-r8a7796"],[1280,736,25,"mediatek mt8173 (development board)"],[1920,980,10,"google chromebook pixel (2015, rogue gx6250)"],[1920,1016,14,"peloton ruby"],[1920,1020,8,"acer chromebook r13"],[1920,1032,13,"renesas salvator-x-m3"],[1920,1080,12,"xiaomi mibox 3 pro tv box"],[1920,1128,10,"amazon kindle fire hd 10 (2017, kfsuwi)"],[2048,1536,7,"alps jdtab j01"],[2560,1504,7,"onda f109"]]],["powervr rogue gx6650","6650",0,[[1280,672,52,"renesas salvator-x"],[1920,1032,24,"renesas salvator-x (octa core)"]]],["powervr rogue han","han",0,[[1794,1080,6,"ireadygo w3d"],[1920,1080,6,"changhong x6"],[2392,1440,5,"alcatel one touch d820"],[2560,1440,4,"alcatel 6071y phantom"]]],["powervr rogue hood","",0,[[1280,736,16,"dell venue 7 3740"],[1920,1080,12,"lenovo p90"],[1920,1104,9,"dell venue 8 3840"]]],["powervr rogue lando","",0,[[1920,1080,13,"spreadtrum sp9861e (development board, rogue lando)"]]],["powervr rogue marlowe","",0,[[1920,1080,39,"meitu v6 mp1605"],[2560,1440,25,"meizu pro 7 plus"]]]]\')},804:(e,t,n)=>{var i={"./d-adreno.json":622,"./d-amd.json":183,"./d-apple.json":732,"./d-geforce.json":405,"./d-intel.json":178,"./d-nvidia.json":217,"./d-radeon.json":145,"./m-adreno.json":921,"./m-apple-ipad.json":535,"./m-apple.json":438,"./m-intel.json":283,"./m-mali-t.json":327,"./m-mali.json":538,"./m-nvidia.json":884,"./m-powervr.json":214};function r(e){var t=o(e);return n(t)}function o(e){if(!n.o(i,e)){var t=new Error("Cannot find module \'"+e+"\'");throw t.code="MODULE_NOT_FOUND",t}return i[e]}r.keys=function(){return Object.keys(i)},r.resolve=o,e.exports=r,r.id=804},354:(e,t,n)=>{var i,r=function(){function e(e,t){if(!r[e]){r[e]={};for(var n=0;n<e.length;n++)r[e][e.charAt(n)]=n}return r[e][t]}var t=String.fromCharCode,n="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",i="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$",r={},o={compressToBase64:function(e){if(null==e)return"";var t=o._compress(e,6,(function(e){return n.charAt(e)}));switch(t.length%4){default:case 0:return t;case 1:return t+"===";case 2:return t+"==";case 3:return t+"="}},decompressFromBase64:function(t){return null==t?"":""==t?null:o._decompress(t.length,32,(function(i){return e(n,t.charAt(i))}))},compressToUTF16:function(e){return null==e?"":o._compress(e,15,(function(e){return t(e+32)}))+" "},decompressFromUTF16:function(e){return null==e?"":""==e?null:o._decompress(e.length,16384,(function(t){return e.charCodeAt(t)-32}))},compressToUint8Array:function(e){for(var t=o.compress(e),n=new Uint8Array(2*t.length),i=0,r=t.length;r>i;i++){var s=t.charCodeAt(i);n[2*i]=s>>>8,n[2*i+1]=s%256}return n},decompressFromUint8Array:function(e){if(null==e)return o.decompress(e);for(var n=new Array(e.length/2),i=0,r=n.length;r>i;i++)n[i]=256*e[2*i]+e[2*i+1];var s=[];return n.forEach((function(e){s.push(t(e))})),o.decompress(s.join(""))},compressToEncodedURIComponent:function(e){return null==e?"":o._compress(e,6,(function(e){return i.charAt(e)}))},decompressFromEncodedURIComponent:function(t){return null==t?"":""==t?null:(t=t.replace(/ /g,"+"),o._decompress(t.length,32,(function(n){return e(i,t.charAt(n))})))},compress:function(e){return o._compress(e,16,(function(e){return t(e)}))},_compress:function(e,t,n){if(null==e)return"";var i,r,o,s={},a={},d="",c="",l="",h=2,u=3,p=2,m=[],g=0,f=0;for(o=0;o<e.length;o+=1)if(d=e.charAt(o),Object.prototype.hasOwnProperty.call(s,d)||(s[d]=u++,a[d]=!0),c=l+d,Object.prototype.hasOwnProperty.call(s,c))l=c;else{if(Object.prototype.hasOwnProperty.call(a,l)){if(l.charCodeAt(0)<256){for(i=0;p>i;i++)g<<=1,f==t-1?(f=0,m.push(n(g)),g=0):f++;for(r=l.charCodeAt(0),i=0;8>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}else{for(r=1,i=0;p>i;i++)g=g<<1|r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r=0;for(r=l.charCodeAt(0),i=0;16>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}0==--h&&(h=Math.pow(2,p),p++),delete a[l]}else for(r=s[l],i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;0==--h&&(h=Math.pow(2,p),p++),s[c]=u++,l=String(d)}if(""!==l){if(Object.prototype.hasOwnProperty.call(a,l)){if(l.charCodeAt(0)<256){for(i=0;p>i;i++)g<<=1,f==t-1?(f=0,m.push(n(g)),g=0):f++;for(r=l.charCodeAt(0),i=0;8>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}else{for(r=1,i=0;p>i;i++)g=g<<1|r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r=0;for(r=l.charCodeAt(0),i=0;16>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1}0==--h&&(h=Math.pow(2,p),p++),delete a[l]}else for(r=s[l],i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;0==--h&&(h=Math.pow(2,p),p++)}for(r=2,i=0;p>i;i++)g=g<<1|1&r,f==t-1?(f=0,m.push(n(g)),g=0):f++,r>>=1;for(;;){if(g<<=1,f==t-1){m.push(n(g));break}f++}return m.join("")},decompress:function(e){return null==e?"":""==e?null:o._decompress(e.length,32768,(function(t){return e.charCodeAt(t)}))},_decompress:function(e,n,i){var r,o,s,a,d,c,l,h=[],u=4,p=4,m=3,g="",f=[],v={val:i(0),position:n,index:1};for(r=0;3>r;r+=1)h[r]=r;for(s=0,d=Math.pow(2,2),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;switch(s){case 0:for(s=0,d=Math.pow(2,8),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;l=t(s);break;case 1:for(s=0,d=Math.pow(2,16),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;l=t(s);break;case 2:return""}for(h[3]=l,o=l,f.push(l);;){if(v.index>e)return"";for(s=0,d=Math.pow(2,m),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;switch(l=s){case 0:for(s=0,d=Math.pow(2,8),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;h[p++]=t(s),l=p-1,u--;break;case 1:for(s=0,d=Math.pow(2,16),c=1;c!=d;)a=v.val&v.position,v.position>>=1,0==v.position&&(v.position=n,v.val=i(v.index++)),s|=(a>0?1:0)*c,c<<=1;h[p++]=t(s),l=p-1,u--;break;case 2:return f.join("")}if(0==u&&(u=Math.pow(2,m),m++),h[l])g=h[l];else{if(l!==p)return null;g=o+o.charAt(0)}f.push(g),h[p++]=o+g.charAt(0),o=g,0==--u&&(u=Math.pow(2,m),m++)}}};return o}();void 0===(i=function(){return r}.call(t,n,t,e))||(e.exports=i)}},t={};function n(i){if(t[i])return t[i].exports;var r=t[i]={exports:{}};return e[i].call(r.exports,r,r.exports,n),r.exports}return n.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n(607)})().default},577:(e,t)=>{"use strict";t.byteLength=function(e){var t=d(e),n=t[0],i=t[1];return 3*(n+i)/4-i},t.toByteArray=function(e){var t,n,o=d(e),s=o[0],a=o[1],c=new r(function(e,t,n){return 3*(t+n)/4-n}(0,s,a)),l=0,h=a>0?s-4:s;for(n=0;n<h;n+=4)t=i[e.charCodeAt(n)]<<18|i[e.charCodeAt(n+1)]<<12|i[e.charCodeAt(n+2)]<<6|i[e.charCodeAt(n+3)],c[l++]=t>>16&255,c[l++]=t>>8&255,c[l++]=255&t;return 2===a&&(t=i[e.charCodeAt(n)]<<2|i[e.charCodeAt(n+1)]>>4,c[l++]=255&t),1===a&&(t=i[e.charCodeAt(n)]<<10|i[e.charCodeAt(n+1)]<<4|i[e.charCodeAt(n+2)]>>2,c[l++]=t>>8&255,c[l++]=255&t),c},t.fromByteArray=function(e){for(var t,i=e.length,r=i%3,o=[],s=16383,a=0,d=i-r;a<d;a+=s)o.push(c(e,a,a+s>d?d:a+s));return 1===r?(t=e[i-1],o.push(n[t>>2]+n[t<<4&63]+"==")):2===r&&(t=(e[i-2]<<8)+e[i-1],o.push(n[t>>10]+n[t>>4&63]+n[t<<2&63]+"=")),o.join("")};for(var n=[],i=[],r="undefined"!=typeof Uint8Array?Uint8Array:Array,o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",s=0,a=o.length;s<a;++s)n[s]=o[s],i[o.charCodeAt(s)]=s;function d(e){var t=e.length;if(t%4>0)throw new Error("Invalid string. Length must be a multiple of 4");var n=e.indexOf("=");return-1===n&&(n=t),[n,n===t?0:4-n%4]}function c(e,t,i){for(var r,o,s=[],a=t;a<i;a+=3)r=(e[a]<<16&16711680)+(e[a+1]<<8&65280)+(255&e[a+2]),s.push(n[(o=r)>>18&63]+n[o>>12&63]+n[o>>6&63]+n[63&o]);return s.join("")}i["-".charCodeAt(0)]=62,i["_".charCodeAt(0)]=63},799:function(e,t){var n,i;this||window,void 0===(i="function"==typeof(n=function(){var e=/^(interactive|loaded|complete)$/,t=window.location?window.location.href:null,n=t&&t.replace(/#.*$/,"").replace(/\\?.*$/,"")||null,i=document.getElementsByTagName("script"),r="readyState"in(i[0]||document.createElement("script")),o=!window.opera||"[object Opera]"!==window.opera.toString(),s="currentScript"in document;"stackTraceLimit"in Error&&Error.stackTraceLimit!==1/0&&(Error.stackTraceLimit,Error.stackTraceLimit=1/0);var a=!1,d=!1;function c(e,t){var n,i=null,r="number"==typeof t;return t=r?Math.round(t):0,"string"==typeof e&&e&&(r?n=e.match(/(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/):(n=e.match(/^(?:|[^:@]*@|.+\\)@(?=data:text\\/javascript|blob|http[s]?|file)|.+?\\s+(?: at |@)(?:[^:\\(]+ )*[\\(]?)(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/))&&n[1]||(n=e.match(/\\)@(data:text\\/javascript(?:;[^,]+)?,.+?|(?:|blob:)(?:http[s]?|file):\\/\\/[\\/]?.+?\\/[^:\\)]*?)(?::\\d+)(?::\\d+)?/)),n&&n[1]&&(i=t>0?c(e.slice(e.indexOf(n[0])+n[0].length),t-1):n[1])),i}function l(){if(0===i.length)return null;var t,h,u,p,m,g=[],f=l.skipStackDepth||1;for(t=0;t<i.length;t++)o&&r?e.test(i[t].readyState)&&g.push(i[t]):g.push(i[t]);if(h=new Error,a&&(u=h.stack),!u&&d)try{throw h}catch(e){u=e.stack}if(u&&!(m=function(e,t){var n,r=null;if(t=t||i,"string"==typeof e&&e)for(n=t.length;n--;)if(t[n].src===e){r=t[n];break}return r}(p=c(u,f),g))&&n&&p===n&&(m=function(e){var t,n,r=null;for(t=0,n=(e=e||i).length;t<n;t++)if(!e[t].hasAttribute("src")){if(r){r=null;break}r=e[t]}return r}(g)),m||1===g.length&&(m=g[0]),m||s&&(m=document.currentScript),!m&&o&&r)for(t=g.length;t--;)if("interactive"===g[t].readyState){m=g[t];break}return m||(m=g[g.length-1]||null),m}(function(){try{var e=new Error;throw a="string"==typeof e.stack&&!!e.stack,e}catch(e){d="string"==typeof e.stack&&!!e.stack}})(),l.skipStackDepth=1;var h=l;return h.near=l,h.far=function(){return null},h.origin=function(){return null},h})?n.apply(t,[]):n)||(e.exports=i)},857:e=>{"use strict";var t,n="object"==typeof Reflect?Reflect:null,i=n&&"function"==typeof n.apply?n.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};t=n&&"function"==typeof n.ownKeys?n.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var r=Number.isNaN||function(e){return e!=e};function o(){o.init.call(this)}e.exports=o,e.exports.once=function(e,t){return new Promise((function(n,i){function r(n){e.removeListener(t,o),i(n)}function o(){"function"==typeof e.removeListener&&e.removeListener("error",r),n([].slice.call(arguments))}g(e,t,o,{once:!0}),"error"!==t&&function(e,t,n){"function"==typeof e.on&&g(e,"error",t,{once:!0})}(e,r)}))},o.EventEmitter=o,o.prototype._events=void 0,o.prototype._eventsCount=0,o.prototype._maxListeners=void 0;var s=10;function a(e){if("function"!=typeof e)throw new TypeError(\'The "listener" argument must be of type Function. Received type \'+typeof e)}function d(e){return void 0===e._maxListeners?o.defaultMaxListeners:e._maxListeners}function c(e,t,n,i){var r,o,s,c;if(a(n),void 0===(o=e._events)?(o=e._events=Object.create(null),e._eventsCount=0):(void 0!==o.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),o=e._events),s=o[t]),void 0===s)s=o[t]=n,++e._eventsCount;else if("function"==typeof s?s=o[t]=i?[n,s]:[s,n]:i?s.unshift(n):s.push(n),(r=d(e))>0&&s.length>r&&!s.warned){s.warned=!0;var l=new Error("Possible EventEmitter memory leak detected. "+s.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");l.name="MaxListenersExceededWarning",l.emitter=e,l.type=t,l.count=s.length,c=l,console&&console.warn&&console.warn(c)}return e}function l(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=!0,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function h(e,t,n){var i={fired:!1,wrapFn:void 0,target:e,type:t,listener:n},r=l.bind(i);return r.listener=n,i.wrapFn=r,r}function u(e,t,n){var i=e._events;if(void 0===i)return[];var r=i[t];return void 0===r?[]:"function"==typeof r?n?[r.listener||r]:[r]:n?function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(r):m(r,r.length)}function p(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function m(e,t){for(var n=new Array(t),i=0;i<t;++i)n[i]=e[i];return n}function g(e,t,n,i){if("function"==typeof e.on)i.once?e.once(t,n):e.on(t,n);else{if("function"!=typeof e.addEventListener)throw new TypeError(\'The "emitter" argument must be of type EventEmitter. Received type \'+typeof e);e.addEventListener(t,(function r(o){i.once&&e.removeEventListener(t,r),n(o)}))}}Object.defineProperty(o,"defaultMaxListeners",{enumerable:!0,get:function(){return s},set:function(e){if("number"!=typeof e||e<0||r(e))throw new RangeError(\'The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received \'+e+".");s=e}}),o.init=function(){void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0},o.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||r(e))throw new RangeError(\'The value of "n" is out of range. It must be a non-negative number. Received \'+e+".");return this._maxListeners=e,this},o.prototype.getMaxListeners=function(){return d(this)},o.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var r="error"===e,o=this._events;if(void 0!==o)r=r&&void 0===o.error;else if(!r)return!1;if(r){var s;if(t.length>0&&(s=t[0]),s instanceof Error)throw s;var a=new Error("Unhandled error."+(s?" ("+s.message+")":""));throw a.context=s,a}var d=o[e];if(void 0===d)return!1;if("function"==typeof d)i(d,this,t);else{var c=d.length,l=m(d,c);for(n=0;n<c;++n)i(l[n],this,t)}return!0},o.prototype.addListener=function(e,t){return c(this,e,t,!1)},o.prototype.on=o.prototype.addListener,o.prototype.prependListener=function(e,t){return c(this,e,t,!0)},o.prototype.once=function(e,t){return a(t),this.on(e,h(this,e,t)),this},o.prototype.prependOnceListener=function(e,t){return a(t),this.prependListener(e,h(this,e,t)),this},o.prototype.removeListener=function(e,t){var n,i,r,o,s;if(a(t),void 0===(i=this._events))return this;if(void 0===(n=i[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete i[e],i.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(r=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){s=n[o].listener,r=o;break}if(r<0)return this;0===r?n.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop()}(n,r),1===n.length&&(i[e]=n[0]),void 0!==i.removeListener&&this.emit("removeListener",e,s||t)}return this},o.prototype.off=o.prototype.removeListener,o.prototype.removeAllListeners=function(e){var t,n,i;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var r,o=Object.keys(n);for(i=0;i<o.length;++i)"removeListener"!==(r=o[i])&&this.removeAllListeners(r);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(i=t.length-1;i>=0;i--)this.removeListener(e,t[i]);return this},o.prototype.listeners=function(e){return u(this,e,!0)},o.prototype.rawListeners=function(e){return u(this,e,!1)},o.listenerCount=function(e,t){return"function"==typeof e.listenerCount?e.listenerCount(t):p.call(e,t)},o.prototype.listenerCount=p,o.prototype.eventNames=function(){return this._eventsCount>0?t(this._events):[]}},387:function(e,t){var n;!function(t,n){"use strict";"object"==typeof e.exports?e.exports=t.document?n(t,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return n(e)}:n(t)}("undefined"!=typeof window?window:this,(function(i,r){"use strict";var o=[],s=Object.getPrototypeOf,a=o.slice,d=o.flat?function(e){return o.flat.call(e)}:function(e){return o.concat.apply([],e)},c=o.push,l=o.indexOf,h={},u=h.toString,p=h.hasOwnProperty,m=p.toString,g=m.call(Object),f={},v=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},_=function(e){return null!=e&&e===e.window},E=i.document,y={type:!0,src:!0,nonce:!0,noModule:!0};function S(e,t,n){var i,r,o=(n=n||E).createElement("script");if(o.text=e,t)for(i in y)(r=t[i]||t.getAttribute&&t.getAttribute(i))&&o.setAttribute(i,r);n.head.appendChild(o).parentNode.removeChild(o)}function b(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?h[u.call(e)]||"object":typeof e}var T="3.6.1 -ajax,-ajax/jsonp,-ajax/load,-ajax/script,-ajax/var/location,-ajax/var/nonce,-ajax/var/rquery,-ajax/xhr,-manipulation/_evalUrl,-deprecated/ajax-event-alias,-effects,-effects/Tween,-effects/animatedSelector",C=function(e,t){return new C.fn.init(e,t)};function x(e){var t=!!e&&"length"in e&&e.length,n=b(e);return!v(e)&&!_(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}C.fn=C.prototype={jquery:T,constructor:C,length:0,toArray:function(){return a.call(this)},get:function(e){return null==e?a.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=C.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return C.each(this,e)},map:function(e){return this.pushStack(C.map(this,(function(t,n){return e.call(t,n,t)})))},slice:function(){return this.pushStack(a.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(C.grep(this,(function(e,t){return(t+1)%2})))},odd:function(){return this.pushStack(C.grep(this,(function(e,t){return t%2})))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:c,sort:o.sort,splice:o.splice},C.extend=C.fn.extend=function(){var e,t,n,i,r,o,s=arguments[0]||{},a=1,d=arguments.length,c=!1;for("boolean"==typeof s&&(c=s,s=arguments[a]||{},a++),"object"==typeof s||v(s)||(s={}),a===d&&(s=this,a--);a<d;a++)if(null!=(e=arguments[a]))for(t in e)i=e[t],"__proto__"!==t&&s!==i&&(c&&i&&(C.isPlainObject(i)||(r=Array.isArray(i)))?(n=s[t],o=r&&!Array.isArray(n)?[]:r||C.isPlainObject(n)?n:{},r=!1,s[t]=C.extend(c,o,i)):void 0!==i&&(s[t]=i));return s},C.extend({expando:"jQuery"+(T+Math.random()).replace(/\\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==u.call(e)||(t=s(e))&&("function"!=typeof(n=p.call(t,"constructor")&&t.constructor)||m.call(n)!==g))},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){S(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,i=0;if(x(e))for(n=e.length;i<n&&!1!==t.call(e[i],i,e[i]);i++);else for(i in e)if(!1===t.call(e[i],i,e[i]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(x(Object(e))?C.merge(n,"string"==typeof e?[e]:e):c.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:l.call(t,e,n)},merge:function(e,t){for(var n=+t.length,i=0,r=e.length;i<n;i++)e[r++]=t[i];return e.length=r,e},grep:function(e,t,n){for(var i=[],r=0,o=e.length,s=!n;r<o;r++)!t(e[r],r)!==s&&i.push(e[r]);return i},map:function(e,t,n){var i,r,o=0,s=[];if(x(e))for(i=e.length;o<i;o++)null!=(r=t(e[o],o,n))&&s.push(r);else for(o in e)null!=(r=t(e[o],o,n))&&s.push(r);return d(s)},guid:1,support:f}),"function"==typeof Symbol&&(C.fn[Symbol.iterator]=o[Symbol.iterator]),C.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),(function(e,t){h["[object "+t+"]"]=t.toLowerCase()}));var R=function(e){var t,n,i,r,o,s,a,d,c,l,h,u,p,m,g,f,v,_,E,y="sizzle"+1*new Date,S=e.document,b=0,T=0,C=de(),x=de(),R=de(),A=de(),w=function(e,t){return e===t&&(h=!0),0},I={}.hasOwnProperty,P=[],D=P.pop,O=P.push,k=P.push,N=P.slice,M=function(e,t){for(var n=0,i=e.length;n<i;n++)if(e[n]===t)return n;return-1},L="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",F="[\\\\x20\\\\t\\\\r\\\\n\\\\f]",j="(?:\\\\\\\\[\\\\da-fA-F]{1,6}"+F+"?|\\\\\\\\[^\\\\r\\\\n\\\\f]|[\\\\w-]|[^\\0-\\\\x7f])+",V="\\\\["+F+"*("+j+")(?:"+F+"*([*^$|!~]?=)"+F+"*(?:\'((?:\\\\\\\\.|[^\\\\\\\\\'])*)\'|\\"((?:\\\\\\\\.|[^\\\\\\\\\\"])*)\\"|("+j+"))|)"+F+"*\\\\]",U=":("+j+")(?:\\\\(((\'((?:\\\\\\\\.|[^\\\\\\\\\'])*)\'|\\"((?:\\\\\\\\.|[^\\\\\\\\\\"])*)\\")|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|"+V+")*)|.*)\\\\)|)",H=new RegExp(F+"+","g"),$=new RegExp("^"+F+"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)"+F+"+$","g"),J=new RegExp("^"+F+"*,"+F+"*"),B=new RegExp("^"+F+"*([>+~]|"+F+")"+F+"*"),q=new RegExp(F+"|>"),G=new RegExp(U),z=new RegExp("^"+j+"$"),K={ID:new RegExp("^#("+j+")"),CLASS:new RegExp("^\\\\.("+j+")"),TAG:new RegExp("^("+j+"|[*])"),ATTR:new RegExp("^"+V),PSEUDO:new RegExp("^"+U),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\("+F+"*(even|odd|(([+-]|)(\\\\d*)n|)"+F+"*(?:([+-]|)"+F+"*(\\\\d+)|))"+F+"*\\\\)|)","i"),bool:new RegExp("^(?:"+L+")$","i"),needsContext:new RegExp("^"+F+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\("+F+"*((?:-\\\\d)?\\\\d*)"+F+"*\\\\)|)(?=[^-]|$)","i")},W=/HTML$/i,X=/^(?:input|select|textarea|button)$/i,Y=/^h\\d$/i,Q=/^[^{]+\\{\\s*\\[native \\w/,Z=/^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\\\\\[\\\\da-fA-F]{1,6}"+F+"?|\\\\\\\\([^\\\\r\\\\n\\\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},ie=/([\\0-\\x1f\\x7f]|^-?\\d)|^-$|[^\\0-\\x1f\\x7f-\\uFFFF\\w-]/g,re=function(e,t){return t?"\\0"===e?"�":e.slice(0,-1)+"\\\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\\\"+e},oe=function(){u()},se=ye((function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()}),{dir:"parentNode",next:"legend"});try{k.apply(P=N.call(S.childNodes),S.childNodes),P[S.childNodes.length].nodeType}catch(t){k={apply:P.length?function(e,t){O.apply(e,N.call(t))}:function(e,t){for(var n=e.length,i=0;e[n++]=t[i++];);e.length=n-1}}}function ae(e,t,i,r){var o,a,c,l,h,m,v,_=t&&t.ownerDocument,S=t?t.nodeType:9;if(i=i||[],"string"!=typeof e||!e||1!==S&&9!==S&&11!==S)return i;if(!r&&(u(t),t=t||p,g)){if(11!==S&&(h=Z.exec(e)))if(o=h[1]){if(9===S){if(!(c=t.getElementById(o)))return i;if(c.id===o)return i.push(c),i}else if(_&&(c=_.getElementById(o))&&E(t,c)&&c.id===o)return i.push(c),i}else{if(h[2])return k.apply(i,t.getElementsByTagName(e)),i;if((o=h[3])&&n.getElementsByClassName&&t.getElementsByClassName)return k.apply(i,t.getElementsByClassName(o)),i}if(n.qsa&&!A[e+" "]&&(!f||!f.test(e))&&(1!==S||"object"!==t.nodeName.toLowerCase())){if(v=e,_=t,1===S&&(q.test(e)||B.test(e))){for((_=ee.test(e)&&ve(t.parentNode)||t)===t&&n.scope||((l=t.getAttribute("id"))?l=l.replace(ie,re):t.setAttribute("id",l=y)),a=(m=s(e)).length;a--;)m[a]=(l?"#"+l:":scope")+" "+Ee(m[a]);v=m.join(",")}try{return k.apply(i,_.querySelectorAll(v)),i}catch(t){A(e,!0)}finally{l===y&&t.removeAttribute("id")}}}return d(e.replace($,"$1"),t,i,r)}function de(){var e=[];return function t(n,r){return e.push(n+" ")>i.cacheLength&&delete t[e.shift()],t[n+" "]=r}}function ce(e){return e[y]=!0,e}function le(e){var t=p.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function he(e,t){for(var n=e.split("|"),r=n.length;r--;)i.attrHandle[n[r]]=t}function ue(e,t){var n=t&&e,i=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(i)return i;if(n)for(;n=n.nextSibling;)if(n===t)return-1;return e?1:-1}function pe(e){return function(t){return"input"===t.nodeName.toLowerCase()&&t.type===e}}function me(e){return function(t){var n=t.nodeName.toLowerCase();return("input"===n||"button"===n)&&t.type===e}}function ge(e){return function(t){return"form"in t?t.parentNode&&!1===t.disabled?"label"in t?"label"in t.parentNode?t.parentNode.disabled===e:t.disabled===e:t.isDisabled===e||t.isDisabled!==!e&&se(t)===e:t.disabled===e:"label"in t&&t.disabled===e}}function fe(e){return ce((function(t){return t=+t,ce((function(n,i){for(var r,o=e([],n.length,t),s=o.length;s--;)n[r=o[s]]&&(n[r]=!(i[r]=n[r]))}))}))}function ve(e){return e&&void 0!==e.getElementsByTagName&&e}for(t in n=ae.support={},o=ae.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!W.test(t||n&&n.nodeName||"HTML")},u=ae.setDocument=function(e){var t,r,s=e?e.ownerDocument||e:S;return s!=p&&9===s.nodeType&&s.documentElement&&(m=(p=s).documentElement,g=!o(p),S!=p&&(r=p.defaultView)&&r.top!==r&&(r.addEventListener?r.addEventListener("unload",oe,!1):r.attachEvent&&r.attachEvent("onunload",oe)),n.scope=le((function(e){return m.appendChild(e).appendChild(p.createElement("div")),void 0!==e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length})),n.attributes=le((function(e){return e.className="i",!e.getAttribute("className")})),n.getElementsByTagName=le((function(e){return e.appendChild(p.createComment("")),!e.getElementsByTagName("*").length})),n.getElementsByClassName=Q.test(p.getElementsByClassName),n.getById=le((function(e){return m.appendChild(e).id=y,!p.getElementsByName||!p.getElementsByName(y).length})),n.getById?(i.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},i.find.ID=function(e,t){if(void 0!==t.getElementById&&g){var n=t.getElementById(e);return n?[n]:[]}}):(i.filter.ID=function(e){var t=e.replace(te,ne);return function(e){var n=void 0!==e.getAttributeNode&&e.getAttributeNode("id");return n&&n.value===t}},i.find.ID=function(e,t){if(void 0!==t.getElementById&&g){var n,i,r,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];for(r=t.getElementsByName(e),i=0;o=r[i++];)if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),i.find.TAG=n.getElementsByTagName?function(e,t){return void 0!==t.getElementsByTagName?t.getElementsByTagName(e):n.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,i=[],r=0,o=t.getElementsByTagName(e);if("*"===e){for(;n=o[r++];)1===n.nodeType&&i.push(n);return i}return o},i.find.CLASS=n.getElementsByClassName&&function(e,t){if(void 0!==t.getElementsByClassName&&g)return t.getElementsByClassName(e)},v=[],f=[],(n.qsa=Q.test(p.querySelectorAll))&&(le((function(e){var t;m.appendChild(e).innerHTML="<a id=\'"+y+"\'></a><select id=\'"+y+"-\\r\\\\\' msallowcapture=\'\'><option selected=\'\'></option></select>",e.querySelectorAll("[msallowcapture^=\'\']").length&&f.push("[*^$]="+F+"*(?:\'\'|\\"\\")"),e.querySelectorAll("[selected]").length||f.push("\\\\["+F+"*(?:value|"+L+")"),e.querySelectorAll("[id~="+y+"-]").length||f.push("~="),(t=p.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name=\'\']").length||f.push("\\\\["+F+"*name"+F+"*="+F+"*(?:\'\'|\\"\\")"),e.querySelectorAll(":checked").length||f.push(":checked"),e.querySelectorAll("a#"+y+"+*").length||f.push(".#.+[+~]"),e.querySelectorAll("\\\\\\f"),f.push("[\\\\r\\\\n\\\\f]")})),le((function(e){e.innerHTML="<a href=\'\' disabled=\'disabled\'></a><select disabled=\'disabled\'><option/></select>";var t=p.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&f.push("name"+F+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&f.push(":enabled",":disabled"),m.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&f.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),f.push(",.*:")}))),(n.matchesSelector=Q.test(_=m.matches||m.webkitMatchesSelector||m.mozMatchesSelector||m.oMatchesSelector||m.msMatchesSelector))&&le((function(e){n.disconnectedMatch=_.call(e,"*"),_.call(e,"[s!=\'\']:x"),v.push("!=",U)})),f=f.length&&new RegExp(f.join("|")),v=v.length&&new RegExp(v.join("|")),t=Q.test(m.compareDocumentPosition),E=t||Q.test(m.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,i=t&&t.parentNode;return e===i||!(!i||1!==i.nodeType||!(n.contains?n.contains(i):e.compareDocumentPosition&&16&e.compareDocumentPosition(i)))}:function(e,t){if(t)for(;t=t.parentNode;)if(t===e)return!0;return!1},w=t?function(e,t){if(e===t)return h=!0,0;var i=!e.compareDocumentPosition-!t.compareDocumentPosition;return i||(1&(i=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!n.sortDetached&&t.compareDocumentPosition(e)===i?e==p||e.ownerDocument==S&&E(S,e)?-1:t==p||t.ownerDocument==S&&E(S,t)?1:l?M(l,e)-M(l,t):0:4&i?-1:1)}:function(e,t){if(e===t)return h=!0,0;var n,i=0,r=e.parentNode,o=t.parentNode,s=[e],a=[t];if(!r||!o)return e==p?-1:t==p?1:r?-1:o?1:l?M(l,e)-M(l,t):0;if(r===o)return ue(e,t);for(n=e;n=n.parentNode;)s.unshift(n);for(n=t;n=n.parentNode;)a.unshift(n);for(;s[i]===a[i];)i++;return i?ue(s[i],a[i]):s[i]==S?-1:a[i]==S?1:0}),p},ae.matches=function(e,t){return ae(e,null,null,t)},ae.matchesSelector=function(e,t){if(u(e),n.matchesSelector&&g&&!A[t+" "]&&(!v||!v.test(t))&&(!f||!f.test(t)))try{var i=_.call(e,t);if(i||n.disconnectedMatch||e.document&&11!==e.document.nodeType)return i}catch(e){A(t,!0)}return 0<ae(t,p,null,[e]).length},ae.contains=function(e,t){return(e.ownerDocument||e)!=p&&u(e),E(e,t)},ae.attr=function(e,t){(e.ownerDocument||e)!=p&&u(e);var r=i.attrHandle[t.toLowerCase()],o=r&&I.call(i.attrHandle,t.toLowerCase())?r(e,t,!g):void 0;return void 0!==o?o:n.attributes||!g?e.getAttribute(t):(o=e.getAttributeNode(t))&&o.specified?o.value:null},ae.escape=function(e){return(e+"").replace(ie,re)},ae.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},ae.uniqueSort=function(e){var t,i=[],r=0,o=0;if(h=!n.detectDuplicates,l=!n.sortStable&&e.slice(0),e.sort(w),h){for(;t=e[o++];)t===e[o]&&(r=i.push(o));for(;r--;)e.splice(i[r],1)}return l=null,e},r=ae.getText=function(e){var t,n="",i=0,o=e.nodeType;if(o){if(1===o||9===o||11===o){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=r(e)}else if(3===o||4===o)return e.nodeValue}else for(;t=e[i++];)n+=r(t);return n},(i=ae.selectors={cacheLength:50,createPseudo:ce,match:K,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||ae.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&ae.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return K.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&G.test(n)&&(t=s(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=C[e+" "];return t||(t=new RegExp("(^|"+F+")"+e+"("+F+"|$)"))&&C(e,(function(e){return t.test("string"==typeof e.className&&e.className||void 0!==e.getAttribute&&e.getAttribute("class")||"")}))},ATTR:function(e,t,n){return function(i){var r=ae.attr(i,e);return null==r?"!="===t:!t||(r+="","="===t?r===n:"!="===t?r!==n:"^="===t?n&&0===r.indexOf(n):"*="===t?n&&-1<r.indexOf(n):"$="===t?n&&r.slice(-n.length)===n:"~="===t?-1<(" "+r.replace(H," ")+" ").indexOf(n):"|="===t&&(r===n||r.slice(0,n.length+1)===n+"-"))}},CHILD:function(e,t,n,i,r){var o="nth"!==e.slice(0,3),s="last"!==e.slice(-4),a="of-type"===t;return 1===i&&0===r?function(e){return!!e.parentNode}:function(t,n,d){var c,l,h,u,p,m,g=o!==s?"nextSibling":"previousSibling",f=t.parentNode,v=a&&t.nodeName.toLowerCase(),_=!d&&!a,E=!1;if(f){if(o){for(;g;){for(u=t;u=u[g];)if(a?u.nodeName.toLowerCase()===v:1===u.nodeType)return!1;m=g="only"===e&&!m&&"nextSibling"}return!0}if(m=[s?f.firstChild:f.lastChild],s&&_){for(E=(p=(c=(l=(h=(u=f)[y]||(u[y]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]||[])[0]===b&&c[1])&&c[2],u=p&&f.childNodes[p];u=++p&&u&&u[g]||(E=p=0)||m.pop();)if(1===u.nodeType&&++E&&u===t){l[e]=[b,p,E];break}}else if(_&&(E=p=(c=(l=(h=(u=t)[y]||(u[y]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]||[])[0]===b&&c[1]),!1===E)for(;(u=++p&&u&&u[g]||(E=p=0)||m.pop())&&((a?u.nodeName.toLowerCase()!==v:1!==u.nodeType)||!++E||(_&&((l=(h=u[y]||(u[y]={}))[u.uniqueID]||(h[u.uniqueID]={}))[e]=[b,E]),u!==t)););return(E-=r)===i||E%i==0&&0<=E/i}}},PSEUDO:function(e,t){var n,r=i.pseudos[e]||i.setFilters[e.toLowerCase()]||ae.error("unsupported pseudo: "+e);return r[y]?r(t):1<r.length?(n=[e,e,"",t],i.setFilters.hasOwnProperty(e.toLowerCase())?ce((function(e,n){for(var i,o=r(e,t),s=o.length;s--;)e[i=M(e,o[s])]=!(n[i]=o[s])})):function(e){return r(e,0,n)}):r}},pseudos:{not:ce((function(e){var t=[],n=[],i=a(e.replace($,"$1"));return i[y]?ce((function(e,t,n,r){for(var o,s=i(e,null,r,[]),a=e.length;a--;)(o=s[a])&&(e[a]=!(t[a]=o))})):function(e,r,o){return t[0]=e,i(t,null,o,n),t[0]=null,!n.pop()}})),has:ce((function(e){return function(t){return 0<ae(e,t).length}})),contains:ce((function(e){return e=e.replace(te,ne),function(t){return-1<(t.textContent||r(t)).indexOf(e)}})),lang:ce((function(e){return z.test(e||"")||ae.error("unsupported lang: "+e),e=e.replace(te,ne).toLowerCase(),function(t){var n;do{if(n=g?t.lang:t.getAttribute("xml:lang")||t.getAttribute("lang"))return(n=n.toLowerCase())===e||0===n.indexOf(e+"-")}while((t=t.parentNode)&&1===t.nodeType);return!1}})),target:function(t){var n=e.location&&e.location.hash;return n&&n.slice(1)===t.id},root:function(e){return e===m},focus:function(e){return e===p.activeElement&&(!p.hasFocus||p.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!i.pseudos.empty(e)},header:function(e){return Y.test(e.nodeName)},input:function(e){return X.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:fe((function(){return[0]})),last:fe((function(e,t){return[t-1]})),eq:fe((function(e,t,n){return[n<0?n+t:n]})),even:fe((function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e})),odd:fe((function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e})),lt:fe((function(e,t,n){for(var i=n<0?n+t:t<n?t:n;0<=--i;)e.push(i);return e})),gt:fe((function(e,t,n){for(var i=n<0?n+t:n;++i<t;)e.push(i);return e}))}}).pseudos.nth=i.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})i.pseudos[t]=pe(t);for(t in{submit:!0,reset:!0})i.pseudos[t]=me(t);function _e(){}function Ee(e){for(var t=0,n=e.length,i="";t<n;t++)i+=e[t].value;return i}function ye(e,t,n){var i=t.dir,r=t.next,o=r||i,s=n&&"parentNode"===o,a=T++;return t.first?function(t,n,r){for(;t=t[i];)if(1===t.nodeType||s)return e(t,n,r);return!1}:function(t,n,d){var c,l,h,u=[b,a];if(d){for(;t=t[i];)if((1===t.nodeType||s)&&e(t,n,d))return!0}else for(;t=t[i];)if(1===t.nodeType||s)if(l=(h=t[y]||(t[y]={}))[t.uniqueID]||(h[t.uniqueID]={}),r&&r===t.nodeName.toLowerCase())t=t[i]||t;else{if((c=l[o])&&c[0]===b&&c[1]===a)return u[2]=c[2];if((l[o]=u)[2]=e(t,n,d))return!0}return!1}}function Se(e){return 1<e.length?function(t,n,i){for(var r=e.length;r--;)if(!e[r](t,n,i))return!1;return!0}:e[0]}function be(e,t,n,i,r){for(var o,s=[],a=0,d=e.length,c=null!=t;a<d;a++)(o=e[a])&&(n&&!n(o,i,r)||(s.push(o),c&&t.push(a)));return s}function Te(e,t,n,i,r,o){return i&&!i[y]&&(i=Te(i)),r&&!r[y]&&(r=Te(r,o)),ce((function(o,s,a,d){var c,l,h,u=[],p=[],m=s.length,g=o||function(e,t,n){for(var i=0,r=t.length;i<r;i++)ae(e,t[i],n);return n}(t||"*",a.nodeType?[a]:a,[]),f=!e||!o&&t?g:be(g,u,e,a,d),v=n?r||(o?e:m||i)?[]:s:f;if(n&&n(f,v,a,d),i)for(c=be(v,p),i(c,[],a,d),l=c.length;l--;)(h=c[l])&&(v[p[l]]=!(f[p[l]]=h));if(o){if(r||e){if(r){for(c=[],l=v.length;l--;)(h=v[l])&&c.push(f[l]=h);r(null,v=[],c,d)}for(l=v.length;l--;)(h=v[l])&&-1<(c=r?M(o,h):u[l])&&(o[c]=!(s[c]=h))}}else v=be(v===s?v.splice(m,v.length):v),r?r(null,s,v,d):k.apply(s,v)}))}function Ce(e){for(var t,n,r,o=e.length,s=i.relative[e[0].type],a=s||i.relative[" "],d=s?1:0,l=ye((function(e){return e===t}),a,!0),h=ye((function(e){return-1<M(t,e)}),a,!0),u=[function(e,n,i){var r=!s&&(i||n!==c)||((t=n).nodeType?l(e,n,i):h(e,n,i));return t=null,r}];d<o;d++)if(n=i.relative[e[d].type])u=[ye(Se(u),n)];else{if((n=i.filter[e[d].type].apply(null,e[d].matches))[y]){for(r=++d;r<o&&!i.relative[e[r].type];r++);return Te(1<d&&Se(u),1<d&&Ee(e.slice(0,d-1).concat({value:" "===e[d-2].type?"*":""})).replace($,"$1"),n,d<r&&Ce(e.slice(d,r)),r<o&&Ce(e=e.slice(r)),r<o&&Ee(e))}u.push(n)}return Se(u)}return _e.prototype=i.filters=i.pseudos,i.setFilters=new _e,s=ae.tokenize=function(e,t){var n,r,o,s,a,d,c,l=x[e+" "];if(l)return t?0:l.slice(0);for(a=e,d=[],c=i.preFilter;a;){for(s in n&&!(r=J.exec(a))||(r&&(a=a.slice(r[0].length)||a),d.push(o=[])),n=!1,(r=B.exec(a))&&(n=r.shift(),o.push({value:n,type:r[0].replace($," ")}),a=a.slice(n.length)),i.filter)!(r=K[s].exec(a))||c[s]&&!(r=c[s](r))||(n=r.shift(),o.push({value:n,type:s,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?ae.error(e):x(e,d).slice(0)},a=ae.compile=function(e,t){var n,r,o,a,d,l,h=[],m=[],f=R[e+" "];if(!f){for(t||(t=s(e)),n=t.length;n--;)(f=Ce(t[n]))[y]?h.push(f):m.push(f);(f=R(e,(r=m,a=0<(o=h).length,d=0<r.length,l=function(e,t,n,s,l){var h,m,f,v=0,_="0",E=e&&[],y=[],S=c,T=e||d&&i.find.TAG("*",l),C=b+=null==S?1:Math.random()||.1,x=T.length;for(l&&(c=t==p||t||l);_!==x&&null!=(h=T[_]);_++){if(d&&h){for(m=0,t||h.ownerDocument==p||(u(h),n=!g);f=r[m++];)if(f(h,t||p,n)){s.push(h);break}l&&(b=C)}a&&((h=!f&&h)&&v--,e&&E.push(h))}if(v+=_,a&&_!==v){for(m=0;f=o[m++];)f(E,y,t,n);if(e){if(0<v)for(;_--;)E[_]||y[_]||(y[_]=D.call(s));y=be(y)}k.apply(s,y),l&&!e&&0<y.length&&1<v+o.length&&ae.uniqueSort(s)}return l&&(b=C,c=S),E},a?ce(l):l))).selector=e}return f},d=ae.select=function(e,t,n,r){var o,d,c,l,h,u="function"==typeof e&&e,p=!r&&s(e=u.selector||e);if(n=n||[],1===p.length){if(2<(d=p[0]=p[0].slice(0)).length&&"ID"===(c=d[0]).type&&9===t.nodeType&&g&&i.relative[d[1].type]){if(!(t=(i.find.ID(c.matches[0].replace(te,ne),t)||[])[0]))return n;u&&(t=t.parentNode),e=e.slice(d.shift().value.length)}for(o=K.needsContext.test(e)?0:d.length;o--&&(c=d[o],!i.relative[l=c.type]);)if((h=i.find[l])&&(r=h(c.matches[0].replace(te,ne),ee.test(d[0].type)&&ve(t.parentNode)||t))){if(d.splice(o,1),!(e=r.length&&Ee(d)))return k.apply(n,r),n;break}}return(u||a(e,p))(r,t,!g,n,!t||ee.test(e)&&ve(t.parentNode)||t),n},n.sortStable=y.split("").sort(w).join("")===y,n.detectDuplicates=!!h,u(),n.sortDetached=le((function(e){return 1&e.compareDocumentPosition(p.createElement("fieldset"))})),le((function(e){return e.innerHTML="<a href=\'#\'></a>","#"===e.firstChild.getAttribute("href")}))||he("type|href|height|width",(function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)})),n.attributes&&le((function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")}))||he("value",(function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue})),le((function(e){return null==e.getAttribute("disabled")}))||he(L,(function(e,t,n){var i;if(!n)return!0===e[t]?t.toLowerCase():(i=e.getAttributeNode(t))&&i.specified?i.value:null})),ae}(i);C.find=R,C.expr=R.selectors,C.expr[":"]=C.expr.pseudos,C.uniqueSort=C.unique=R.uniqueSort,C.text=R.getText,C.isXMLDoc=R.isXML,C.contains=R.contains,C.escapeSelector=R.escape;var A=function(e,t,n){for(var i=[],r=void 0!==n;(e=e[t])&&9!==e.nodeType;)if(1===e.nodeType){if(r&&C(e).is(n))break;i.push(e)}return i},w=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},I=C.expr.match.needsContext;function P(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var D=/^<([a-z][^\\/\\0>:\\x20\\t\\r\\n\\f]*)[\\x20\\t\\r\\n\\f]*\\/?>(?:<\\/\\1>|)$/i;function O(e,t,n){return v(t)?C.grep(e,(function(e,i){return!!t.call(e,i,e)!==n})):t.nodeType?C.grep(e,(function(e){return e===t!==n})):"string"!=typeof t?C.grep(e,(function(e){return-1<l.call(t,e)!==n})):C.filter(t,e,n)}C.filter=function(e,t,n){var i=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===i.nodeType?C.find.matchesSelector(i,e)?[i]:[]:C.find.matches(e,C.grep(t,(function(e){return 1===e.nodeType})))},C.fn.extend({find:function(e){var t,n,i=this.length,r=this;if("string"!=typeof e)return this.pushStack(C(e).filter((function(){for(t=0;t<i;t++)if(C.contains(r[t],this))return!0})));for(n=this.pushStack([]),t=0;t<i;t++)C.find(e,r[t],n);return 1<i?C.uniqueSort(n):n},filter:function(e){return this.pushStack(O(this,e||[],!1))},not:function(e){return this.pushStack(O(this,e||[],!0))},is:function(e){return!!O(this,"string"==typeof e&&I.test(e)?C(e):e||[],!1).length}});var k,N=/^(?:\\s*(<[\\w\\W]+>)[^>]*|#([\\w-]+))$/;(C.fn.init=function(e,t,n){var i,r;if(!e)return this;if(n=n||k,"string"==typeof e){if(!(i="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:N.exec(e))||!i[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(i[1]){if(t=t instanceof C?t[0]:t,C.merge(this,C.parseHTML(i[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),D.test(i[1])&&C.isPlainObject(t))for(i in t)v(this[i])?this[i](t[i]):this.attr(i,t[i]);return this}return(r=E.getElementById(i[2]))&&(this[0]=r,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):v(e)?void 0!==n.ready?n.ready(e):e(C):C.makeArray(e,this)}).prototype=C.fn,k=C(E);var M=/^(?:parents|prev(?:Until|All))/,L={children:!0,contents:!0,next:!0,prev:!0};function F(e,t){for(;(e=e[t])&&1!==e.nodeType;);return e}C.fn.extend({has:function(e){var t=C(e,this),n=t.length;return this.filter((function(){for(var e=0;e<n;e++)if(C.contains(this,t[e]))return!0}))},closest:function(e,t){var n,i=0,r=this.length,o=[],s="string"!=typeof e&&C(e);if(!I.test(e))for(;i<r;i++)for(n=this[i];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(s?-1<s.index(n):1===n.nodeType&&C.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?C.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?l.call(C(e),this[0]):l.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(C.uniqueSort(C.merge(this.get(),C(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),C.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return A(e,"parentNode")},parentsUntil:function(e,t,n){return A(e,"parentNode",n)},next:function(e){return F(e,"nextSibling")},prev:function(e){return F(e,"previousSibling")},nextAll:function(e){return A(e,"nextSibling")},prevAll:function(e){return A(e,"previousSibling")},nextUntil:function(e,t,n){return A(e,"nextSibling",n)},prevUntil:function(e,t,n){return A(e,"previousSibling",n)},siblings:function(e){return w((e.parentNode||{}).firstChild,e)},children:function(e){return w(e.firstChild)},contents:function(e){return null!=e.contentDocument&&s(e.contentDocument)?e.contentDocument:(P(e,"template")&&(e=e.content||e),C.merge([],e.childNodes))}},(function(e,t){C.fn[e]=function(n,i){var r=C.map(this,t,n);return"Until"!==e.slice(-5)&&(i=n),i&&"string"==typeof i&&(r=C.filter(i,r)),1<this.length&&(L[e]||C.uniqueSort(r),M.test(e)&&r.reverse()),this.pushStack(r)}}));var j=/[^\\x20\\t\\r\\n\\f]+/g;function V(e){return e}function U(e){throw e}function H(e,t,n,i){var r;try{e&&v(r=e.promise)?r.call(e).done(t).fail(n):e&&v(r=e.then)?r.call(e,t,n):t.apply(void 0,[e].slice(i))}catch(e){n.apply(void 0,[e])}}C.Callbacks=function(e){var t,n;e="string"==typeof e?(t=e,n={},C.each(t.match(j)||[],(function(e,t){n[t]=!0})),n):C.extend({},e);var i,r,o,s,a=[],d=[],c=-1,l=function(){for(s=s||e.once,o=i=!0;d.length;c=-1)for(r=d.shift();++c<a.length;)!1===a[c].apply(r[0],r[1])&&e.stopOnFalse&&(c=a.length,r=!1);e.memory||(r=!1),i=!1,s&&(a=r?[]:"")},h={add:function(){return a&&(r&&!i&&(c=a.length-1,d.push(r)),function t(n){C.each(n,(function(n,i){v(i)?e.unique&&h.has(i)||a.push(i):i&&i.length&&"string"!==b(i)&&t(i)}))}(arguments),r&&!i&&l()),this},remove:function(){return C.each(arguments,(function(e,t){for(var n;-1<(n=C.inArray(t,a,n));)a.splice(n,1),n<=c&&c--})),this},has:function(e){return e?-1<C.inArray(e,a):0<a.length},empty:function(){return a&&(a=[]),this},disable:function(){return s=d=[],a=r="",this},disabled:function(){return!a},lock:function(){return s=d=[],r||i||(a=r=""),this},locked:function(){return!!s},fireWith:function(e,t){return s||(t=[e,(t=t||[]).slice?t.slice():t],d.push(t),i||l()),this},fire:function(){return h.fireWith(this,arguments),this},fired:function(){return!!o}};return h},C.extend({Deferred:function(e){var t=[["notify","progress",C.Callbacks("memory"),C.Callbacks("memory"),2],["resolve","done",C.Callbacks("once memory"),C.Callbacks("once memory"),0,"resolved"],["reject","fail",C.Callbacks("once memory"),C.Callbacks("once memory"),1,"rejected"]],n="pending",r={state:function(){return n},always:function(){return o.done(arguments).fail(arguments),this},catch:function(e){return r.then(null,e)},pipe:function(){var e=arguments;return C.Deferred((function(n){C.each(t,(function(t,i){var r=v(e[i[4]])&&e[i[4]];o[i[1]]((function(){var e=r&&r.apply(this,arguments);e&&v(e.promise)?e.promise().progress(n.notify).done(n.resolve).fail(n.reject):n[i[0]+"With"](this,r?[e]:arguments)}))})),e=null})).promise()},then:function(e,n,r){var o=0;function s(e,t,n,r){return function(){var a=this,d=arguments,c=function(){var i,c;if(!(e<o)){if((i=n.apply(a,d))===t.promise())throw new TypeError("Thenable self-resolution");c=i&&("object"==typeof i||"function"==typeof i)&&i.then,v(c)?r?c.call(i,s(o,t,V,r),s(o,t,U,r)):(o++,c.call(i,s(o,t,V,r),s(o,t,U,r),s(o,t,V,t.notifyWith))):(n!==V&&(a=void 0,d=[i]),(r||t.resolveWith)(a,d))}},l=r?c:function(){try{c()}catch(i){C.Deferred.exceptionHook&&C.Deferred.exceptionHook(i,l.stackTrace),o<=e+1&&(n!==U&&(a=void 0,d=[i]),t.rejectWith(a,d))}};e?l():(C.Deferred.getStackHook&&(l.stackTrace=C.Deferred.getStackHook()),i.setTimeout(l))}}return C.Deferred((function(i){t[0][3].add(s(0,i,v(r)?r:V,i.notifyWith)),t[1][3].add(s(0,i,v(e)?e:V)),t[2][3].add(s(0,i,v(n)?n:U))})).promise()},promise:function(e){return null!=e?C.extend(e,r):r}},o={};return C.each(t,(function(e,i){var s=i[2],a=i[5];r[i[1]]=s.add,a&&s.add((function(){n=a}),t[3-e][2].disable,t[3-e][3].disable,t[0][2].lock,t[0][3].lock),s.add(i[3].fire),o[i[0]]=function(){return o[i[0]+"With"](this===o?void 0:this,arguments),this},o[i[0]+"With"]=s.fireWith})),r.promise(o),e&&e.call(o,o),o},when:function(e){var t=arguments.length,n=t,i=Array(n),r=a.call(arguments),o=C.Deferred(),s=function(e){return function(n){i[e]=this,r[e]=1<arguments.length?a.call(arguments):n,--t||o.resolveWith(i,r)}};if(t<=1&&(H(e,o.done(s(n)).resolve,o.reject,!t),"pending"===o.state()||v(r[n]&&r[n].then)))return o.then();for(;n--;)H(r[n],s(n),o.reject);return o.promise()}});var $=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;C.Deferred.exceptionHook=function(e,t){i.console&&i.console.warn&&e&&$.test(e.name)&&i.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},C.readyException=function(e){i.setTimeout((function(){throw e}))};var J=C.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),i.removeEventListener("load",B),C.ready()}C.fn.ready=function(e){return J.then(e).catch((function(e){C.readyException(e)})),this},C.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--C.readyWait:C.isReady)||(C.isReady=!0)!==e&&0<--C.readyWait||J.resolveWith(E,[C])}}),C.ready.then=J.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?i.setTimeout(C.ready):(E.addEventListener("DOMContentLoaded",B),i.addEventListener("load",B));var q=function(e,t,n,i,r,o,s){var a=0,d=e.length,c=null==n;if("object"===b(n))for(a in r=!0,n)q(e,t,a,n[a],!0,o,s);else if(void 0!==i&&(r=!0,v(i)||(s=!0),c&&(s?(t.call(e,i),t=null):(c=t,t=function(e,t,n){return c.call(C(e),n)})),t))for(;a<d;a++)t(e[a],n,s?i:i.call(e[a],a,t(e[a],n)));return r?e:c?t.call(e):d?t(e[0],n):o},G=/^-ms-/,z=/-([a-z])/g;function K(e,t){return t.toUpperCase()}function W(e){return e.replace(G,"ms-").replace(z,K)}var X=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Y(){this.expando=C.expando+Y.uid++}Y.uid=1,Y.prototype={cache:function(e){var t=e[this.expando];return t||(t={},X(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var i,r=this.cache(e);if("string"==typeof t)r[W(t)]=n;else for(i in t)r[W(i)]=t[i];return r},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][W(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,i=e[this.expando];if(void 0!==i){if(void 0!==t){n=(t=Array.isArray(t)?t.map(W):(t=W(t))in i?[t]:t.match(j)||[]).length;for(;n--;)delete i[t[n]]}(void 0===t||C.isEmptyObject(i))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!C.isEmptyObject(t)}};var Q=new Y,Z=new Y,ee=/^(?:\\{[\\w\\W]*\\}|\\[[\\w\\W]*\\])$/,te=/[A-Z]/g;function ne(e,t,n){var i,r;if(void 0===n&&1===e.nodeType)if(i="data-"+t.replace(te,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(i))){try{n="true"===(r=n)||"false"!==r&&("null"===r?null:r===+r+""?+r:ee.test(r)?JSON.parse(r):r)}catch(e){}Z.set(e,t,n)}else n=void 0;return n}C.extend({hasData:function(e){return Z.hasData(e)||Q.hasData(e)},data:function(e,t,n){return Z.access(e,t,n)},removeData:function(e,t){Z.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),C.fn.extend({data:function(e,t){var n,i,r,o=this[0],s=o&&o.attributes;if(void 0===e){if(this.length&&(r=Z.get(o),1===o.nodeType&&!Q.get(o,"hasDataAttrs"))){for(n=s.length;n--;)s[n]&&0===(i=s[n].name).indexOf("data-")&&(i=W(i.slice(5)),ne(o,i,r[i]));Q.set(o,"hasDataAttrs",!0)}return r}return"object"==typeof e?this.each((function(){Z.set(this,e)})):q(this,(function(t){var n;if(o&&void 0===t)return void 0!==(n=Z.get(o,e))||void 0!==(n=ne(o,e))?n:void 0;this.each((function(){Z.set(this,e,t)}))}),null,t,1<arguments.length,null,!0)},removeData:function(e){return this.each((function(){Z.remove(this,e)}))}}),C.extend({queue:function(e,t,n){var i;if(e)return t=(t||"fx")+"queue",i=Q.get(e,t),n&&(!i||Array.isArray(n)?i=Q.access(e,t,C.makeArray(n)):i.push(n)),i||[]},dequeue:function(e,t){t=t||"fx";var n=C.queue(e,t),i=n.length,r=n.shift(),o=C._queueHooks(e,t);"inprogress"===r&&(r=n.shift(),i--),r&&("fx"===t&&n.unshift("inprogress"),delete o.stop,r.call(e,(function(){C.dequeue(e,t)}),o)),!i&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:C.Callbacks("once memory").add((function(){Q.remove(e,[t+"queue",n])}))})}}),C.fn.extend({queue:function(e,t){var n=2;return"string"!=typeof e&&(t=e,e="fx",n--),arguments.length<n?C.queue(this[0],e):void 0===t?this:this.each((function(){var n=C.queue(this,e,t);C._queueHooks(this,e),"fx"===e&&"inprogress"!==n[0]&&C.dequeue(this,e)}))},dequeue:function(e){return this.each((function(){C.dequeue(this,e)}))},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,i=1,r=C.Deferred(),o=this,s=this.length,a=function(){--i||r.resolveWith(o,[o])};for("string"!=typeof e&&(t=e,e=void 0),e=e||"fx";s--;)(n=Q.get(o[s],e+"queueHooks"))&&n.empty&&(i++,n.empty.add(a));return a(),r.promise(t)}});var ie=/[+-]?(?:\\d*\\.|)\\d+(?:[eE][+-]?\\d+|)/.source,re=new RegExp("^(?:([+-])=|)("+ie+")([a-z%]*)$","i"),oe=["Top","Right","Bottom","Left"],se=E.documentElement,ae=function(e){return C.contains(e.ownerDocument,e)},de={composed:!0};se.getRootNode&&(ae=function(e){return C.contains(e.ownerDocument,e)||e.getRootNode(de)===e.ownerDocument});var ce=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ae(e)&&"none"===C.css(e,"display")},le={};function he(e,t){for(var n,i,r,o,s,a,d,c=[],l=0,h=e.length;l<h;l++)(i=e[l]).style&&(n=i.style.display,t?("none"===n&&(c[l]=Q.get(i,"display")||null,c[l]||(i.style.display="")),""===i.style.display&&ce(i)&&(c[l]=(d=s=o=void 0,s=(r=i).ownerDocument,a=r.nodeName,(d=le[a])||(o=s.body.appendChild(s.createElement(a)),d=C.css(o,"display"),o.parentNode.removeChild(o),"none"===d&&(d="block"),le[a]=d)))):"none"!==n&&(c[l]="none",Q.set(i,"display",n)));for(l=0;l<h;l++)null!=c[l]&&(e[l].style.display=c[l]);return e}C.fn.extend({show:function(){return he(this,!0)},hide:function(){return he(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each((function(){ce(this)?C(this).show():C(this).hide()}))}});var ue,pe,me=/^(?:checkbox|radio)$/i,ge=/<([a-z][^\\/\\0>\\x20\\t\\r\\n\\f]*)/i,fe=/^$|^module$|\\/(?:java|ecma)script/i;ue=E.createDocumentFragment().appendChild(E.createElement("div")),(pe=E.createElement("input")).setAttribute("type","radio"),pe.setAttribute("checked","checked"),pe.setAttribute("name","t"),ue.appendChild(pe),f.checkClone=ue.cloneNode(!0).cloneNode(!0).lastChild.checked,ue.innerHTML="<textarea>x</textarea>",f.noCloneChecked=!!ue.cloneNode(!0).lastChild.defaultValue,ue.innerHTML="<option></option>",f.option=!!ue.lastChild;var ve={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function _e(e,t){var n;return n=void 0!==e.getElementsByTagName?e.getElementsByTagName(t||"*"):void 0!==e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&P(e,t)?C.merge([e],n):n}function Ee(e,t){for(var n=0,i=e.length;n<i;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}ve.tbody=ve.tfoot=ve.colgroup=ve.caption=ve.thead,ve.th=ve.td,f.option||(ve.optgroup=ve.option=[1,"<select multiple=\'multiple\'>","</select>"]);var ye=/<|&#?\\w+;/;function Se(e,t,n,i,r){for(var o,s,a,d,c,l,h=t.createDocumentFragment(),u=[],p=0,m=e.length;p<m;p++)if((o=e[p])||0===o)if("object"===b(o))C.merge(u,o.nodeType?[o]:o);else if(ye.test(o)){for(s=s||h.appendChild(t.createElement("div")),a=(ge.exec(o)||["",""])[1].toLowerCase(),d=ve[a]||ve._default,s.innerHTML=d[1]+C.htmlPrefilter(o)+d[2],l=d[0];l--;)s=s.lastChild;C.merge(u,s.childNodes),(s=h.firstChild).textContent=""}else u.push(t.createTextNode(o));for(h.textContent="",p=0;o=u[p++];)if(i&&-1<C.inArray(o,i))r&&r.push(o);else if(c=ae(o),s=_e(h.appendChild(o),"script"),c&&Ee(s),n)for(l=0;o=s[l++];)fe.test(o.type||"")&&n.push(o);return h}var be=/^([^.]*)(?:\\.(.+)|)/;function Te(){return!0}function Ce(){return!1}function xe(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Re(e,t,n,i,r,o){var s,a;if("object"==typeof t){for(a in"string"!=typeof n&&(i=i||n,n=void 0),t)Re(e,a,n,i,t[a],o);return e}if(null==i&&null==r?(r=n,i=n=void 0):null==r&&("string"==typeof n?(r=i,i=void 0):(r=i,i=n,n=void 0)),!1===r)r=Ce;else if(!r)return e;return 1===o&&(s=r,(r=function(e){return C().off(e),s.apply(this,arguments)}).guid=s.guid||(s.guid=C.guid++)),e.each((function(){C.event.add(this,t,r,i,n)}))}function Ae(e,t,n){n?(Q.set(e,t,!1),C.event.add(e,t,{namespace:!1,handler:function(e){var i,r,o=Q.get(this,t);if(1&e.isTrigger&&this[t]){if(o.length)(C.event.special[t]||{}).delegateType&&e.stopPropagation();else if(o=a.call(arguments),Q.set(this,t,o),i=n(this,t),this[t](),o!==(r=Q.get(this,t))||i?Q.set(this,t,!1):r={},o!==r)return e.stopImmediatePropagation(),e.preventDefault(),r&&r.value}else o.length&&(Q.set(this,t,{value:C.event.trigger(C.extend(o[0],C.Event.prototype),o.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Q.get(e,t)&&C.event.add(e,t,Te)}C.event={global:{},add:function(e,t,n,i,r){var o,s,a,d,c,l,h,u,p,m,g,f=Q.get(e);if(X(e))for(n.handler&&(n=(o=n).handler,r=o.selector),r&&C.find.matchesSelector(se,r),n.guid||(n.guid=C.guid++),(d=f.events)||(d=f.events=Object.create(null)),(s=f.handle)||(s=f.handle=function(t){return void 0!==C&&C.event.triggered!==t.type?C.event.dispatch.apply(e,arguments):void 0}),c=(t=(t||"").match(j)||[""]).length;c--;)p=g=(a=be.exec(t[c])||[])[1],m=(a[2]||"").split(".").sort(),p&&(h=C.event.special[p]||{},p=(r?h.delegateType:h.bindType)||p,h=C.event.special[p]||{},l=C.extend({type:p,origType:g,data:i,handler:n,guid:n.guid,selector:r,needsContext:r&&C.expr.match.needsContext.test(r),namespace:m.join(".")},o),(u=d[p])||((u=d[p]=[]).delegateCount=0,h.setup&&!1!==h.setup.call(e,i,m,s)||e.addEventListener&&e.addEventListener(p,s)),h.add&&(h.add.call(e,l),l.handler.guid||(l.handler.guid=n.guid)),r?u.splice(u.delegateCount++,0,l):u.push(l),C.event.global[p]=!0)},remove:function(e,t,n,i,r){var o,s,a,d,c,l,h,u,p,m,g,f=Q.hasData(e)&&Q.get(e);if(f&&(d=f.events)){for(c=(t=(t||"").match(j)||[""]).length;c--;)if(p=g=(a=be.exec(t[c])||[])[1],m=(a[2]||"").split(".").sort(),p){for(h=C.event.special[p]||{},u=d[p=(i?h.delegateType:h.bindType)||p]||[],a=a[2]&&new RegExp("(^|\\\\.)"+m.join("\\\\.(?:.*\\\\.|)")+"(\\\\.|$)"),s=o=u.length;o--;)l=u[o],!r&&g!==l.origType||n&&n.guid!==l.guid||a&&!a.test(l.namespace)||i&&i!==l.selector&&("**"!==i||!l.selector)||(u.splice(o,1),l.selector&&u.delegateCount--,h.remove&&h.remove.call(e,l));s&&!u.length&&(h.teardown&&!1!==h.teardown.call(e,m,f.handle)||C.removeEvent(e,p,f.handle),delete d[p])}else for(p in d)C.event.remove(e,p+t[c],n,i,!0);C.isEmptyObject(d)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,i,r,o,s,a=new Array(arguments.length),d=C.event.fix(e),c=(Q.get(this,"events")||Object.create(null))[d.type]||[],l=C.event.special[d.type]||{};for(a[0]=d,t=1;t<arguments.length;t++)a[t]=arguments[t];if(d.delegateTarget=this,!l.preDispatch||!1!==l.preDispatch.call(this,d)){for(s=C.event.handlers.call(this,d,c),t=0;(r=s[t++])&&!d.isPropagationStopped();)for(d.currentTarget=r.elem,n=0;(o=r.handlers[n++])&&!d.isImmediatePropagationStopped();)d.rnamespace&&!1!==o.namespace&&!d.rnamespace.test(o.namespace)||(d.handleObj=o,d.data=o.data,void 0!==(i=((C.event.special[o.origType]||{}).handle||o.handler).apply(r.elem,a))&&!1===(d.result=i)&&(d.preventDefault(),d.stopPropagation()));return l.postDispatch&&l.postDispatch.call(this,d),d.result}},handlers:function(e,t){var n,i,r,o,s,a=[],d=t.delegateCount,c=e.target;if(d&&c.nodeType&&!("click"===e.type&&1<=e.button))for(;c!==this;c=c.parentNode||this)if(1===c.nodeType&&("click"!==e.type||!0!==c.disabled)){for(o=[],s={},n=0;n<d;n++)void 0===s[r=(i=t[n]).selector+" "]&&(s[r]=i.needsContext?-1<C(r,this).index(c):C.find(r,this,null,[c]).length),s[r]&&o.push(i);o.length&&a.push({elem:c,handlers:o})}return c=this,d<t.length&&a.push({elem:c,handlers:t.slice(d)}),a},addProp:function(e,t){Object.defineProperty(C.Event.prototype,e,{enumerable:!0,configurable:!0,get:v(t)?function(){if(this.originalEvent)return t(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[e]},set:function(t){Object.defineProperty(this,e,{enumerable:!0,configurable:!0,writable:!0,value:t})}})},fix:function(e){return e[C.expando]?e:new C.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return me.test(t.type)&&t.click&&P(t,"input")&&Ae(t,"click",Te),!1},trigger:function(e){var t=this||e;return me.test(t.type)&&t.click&&P(t,"input")&&Ae(t,"click"),!0},_default:function(e){var t=e.target;return me.test(t.type)&&t.click&&P(t,"input")&&Q.get(t,"click")||P(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},C.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},C.Event=function(e,t){if(!(this instanceof C.Event))return new C.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?Te:Ce,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&C.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[C.expando]=!0},C.Event.prototype={constructor:C.Event,isDefaultPrevented:Ce,isPropagationStopped:Ce,isImmediatePropagationStopped:Ce,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=Te,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=Te,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=Te,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},C.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,char:!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},C.event.addProp),C.each({focus:"focusin",blur:"focusout"},(function(e,t){C.event.special[e]={setup:function(){return Ae(this,e,xe),!1},trigger:function(){return Ae(this,e),!0},_default:function(t){return Q.get(t.target,e)},delegateType:t}})),C.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},(function(e,t){C.event.special[e]={delegateType:t,bindType:t,handle:function(e){var n,i=e.relatedTarget,r=e.handleObj;return i&&(i===this||C.contains(this,i))||(e.type=r.origType,n=r.handler.apply(this,arguments),e.type=t),n}}})),C.fn.extend({on:function(e,t,n,i){return Re(this,e,t,n,i)},one:function(e,t,n,i){return Re(this,e,t,n,i,1)},off:function(e,t,n){var i,r;if(e&&e.preventDefault&&e.handleObj)return i=e.handleObj,C(e.delegateTarget).off(i.namespace?i.origType+"."+i.namespace:i.origType,i.selector,i.handler),this;if("object"==typeof e){for(r in e)this.off(r,t,e[r]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Ce),this.each((function(){C.event.remove(this,e,n,t)}))}});var we=/<script|<style|<link/i,Ie=/checked\\s*(?:[^=]|=\\s*.checked.)/i,Pe=/^\\s*<!\\[CDATA\\[|\\]\\]>\\s*$/g;function De(e,t){return P(e,"table")&&P(11!==t.nodeType?t:t.firstChild,"tr")&&C(e).children("tbody")[0]||e}function Oe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function ke(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Ne(e,t){var n,i,r,o,s,a;if(1===t.nodeType){if(Q.hasData(e)&&(a=Q.get(e).events))for(r in Q.remove(t,"handle events"),a)for(n=0,i=a[r].length;n<i;n++)C.event.add(t,r,a[r][n]);Z.hasData(e)&&(o=Z.access(e),s=C.extend({},o),Z.set(t,s))}}function Me(e,t,n,i){t=d(t);var r,o,s,a,c,l,h=0,u=e.length,p=u-1,m=t[0],g=v(m);if(g||1<u&&"string"==typeof m&&!f.checkClone&&Ie.test(m))return e.each((function(r){var o=e.eq(r);g&&(t[0]=m.call(this,r,o.html())),Me(o,t,n,i)}));if(u&&(o=(r=Se(t,e[0].ownerDocument,!1,e,i)).firstChild,1===r.childNodes.length&&(r=o),o||i)){for(a=(s=C.map(_e(r,"script"),Oe)).length;h<u;h++)c=r,h!==p&&(c=C.clone(c,!0,!0),a&&C.merge(s,_e(c,"script"))),n.call(e[h],c,h);if(a)for(l=s[s.length-1].ownerDocument,C.map(s,ke),h=0;h<a;h++)c=s[h],fe.test(c.type||"")&&!Q.access(c,"globalEval")&&C.contains(l,c)&&(c.src&&"module"!==(c.type||"").toLowerCase()?C._evalUrl&&!c.noModule&&C._evalUrl(c.src,{nonce:c.nonce||c.getAttribute("nonce")},l):S(c.textContent.replace(Pe,""),c,l))}return e}function Le(e,t,n){for(var i,r=t?C.filter(t,e):e,o=0;null!=(i=r[o]);o++)n||1!==i.nodeType||C.cleanData(_e(i)),i.parentNode&&(n&&ae(i)&&Ee(_e(i,"script")),i.parentNode.removeChild(i));return e}C.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var i,r,o,s,a,d,c,l=e.cloneNode(!0),h=ae(e);if(!(f.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||C.isXMLDoc(e)))for(s=_e(l),i=0,r=(o=_e(e)).length;i<r;i++)a=o[i],"input"===(c=(d=s[i]).nodeName.toLowerCase())&&me.test(a.type)?d.checked=a.checked:"input"!==c&&"textarea"!==c||(d.defaultValue=a.defaultValue);if(t)if(n)for(o=o||_e(e),s=s||_e(l),i=0,r=o.length;i<r;i++)Ne(o[i],s[i]);else Ne(e,l);return 0<(s=_e(l,"script")).length&&Ee(s,!h&&_e(e,"script")),l},cleanData:function(e){for(var t,n,i,r=C.event.special,o=0;void 0!==(n=e[o]);o++)if(X(n)){if(t=n[Q.expando]){if(t.events)for(i in t.events)r[i]?C.event.remove(n,i):C.removeEvent(n,i,t.handle);n[Q.expando]=void 0}n[Z.expando]&&(n[Z.expando]=void 0)}}}),C.fn.extend({detach:function(e){return Le(this,e,!0)},remove:function(e){return Le(this,e)},text:function(e){return q(this,(function(e){return void 0===e?C.text(this):this.empty().each((function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)}))}),null,e,arguments.length)},append:function(){return Me(this,arguments,(function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||De(this,e).appendChild(e)}))},prepend:function(){return Me(this,arguments,(function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=De(this,e);t.insertBefore(e,t.firstChild)}}))},before:function(){return Me(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this)}))},after:function(){return Me(this,arguments,(function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)}))},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(C.cleanData(_e(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map((function(){return C.clone(this,e,t)}))},html:function(e){return q(this,(function(e){var t=this[0]||{},n=0,i=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!we.test(e)&&!ve[(ge.exec(e)||["",""])[1].toLowerCase()]){e=C.htmlPrefilter(e);try{for(;n<i;n++)1===(t=this[n]||{}).nodeType&&(C.cleanData(_e(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)}),null,e,arguments.length)},replaceWith:function(){var e=[];return Me(this,arguments,(function(t){var n=this.parentNode;C.inArray(this,e)<0&&(C.cleanData(_e(this)),n&&n.replaceChild(t,this))}),e)}}),C.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},(function(e,t){C.fn[e]=function(e){for(var n,i=[],r=C(e),o=r.length-1,s=0;s<=o;s++)n=s===o?this:this.clone(!0),C(r[s])[t](n),c.apply(i,n.get());return this.pushStack(i)}}));var Fe=new RegExp("^("+ie+")(?!px)[a-z%]+$","i"),je=/^--/,Ve=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=i),t.getComputedStyle(e)},Ue=function(e,t,n){var i,r,o={};for(r in t)o[r]=e.style[r],e.style[r]=t[r];for(r in i=n.call(e),t)e.style[r]=o[r];return i},He=new RegExp(oe.join("|"),"i"),$e="[\\\\x20\\\\t\\\\r\\\\n\\\\f]",Je=new RegExp("^"+$e+"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)"+$e+"+$","g");function Be(e,t,n){var i,r,o,s,a=je.test(t),d=e.style;return(n=n||Ve(e))&&(s=n.getPropertyValue(t)||n[t],a&&(s=s.replace(Je,"$1")),""!==s||ae(e)||(s=C.style(e,t)),!f.pixelBoxStyles()&&Fe.test(s)&&He.test(t)&&(i=d.width,r=d.minWidth,o=d.maxWidth,d.minWidth=d.maxWidth=d.width=s,s=n.width,d.width=i,d.minWidth=r,d.maxWidth=o)),void 0!==s?s+"":s}function qe(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){c.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",se.appendChild(c).appendChild(l);var e=i.getComputedStyle(l);n="1%"!==e.top,d=12===t(e.marginLeft),l.style.right="60%",s=36===t(e.right),r=36===t(e.width),l.style.position="absolute",o=12===t(l.offsetWidth/3),se.removeChild(c),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,o,s,a,d,c=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",f.clearCloneStyle="content-box"===l.style.backgroundClip,C.extend(f,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),s},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),d},scrollboxSize:function(){return e(),o},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",se.appendChild(e).appendChild(t).appendChild(n),r=i.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,se.removeChild(e)),a}}))}();var Ge=["Webkit","Moz","ms"],ze=E.createElement("div").style,Ke={};function We(e){return C.cssProps[e]||Ke[e]||(e in ze?e:Ke[e]=function(e){for(var t=e[0].toUpperCase()+e.slice(1),n=Ge.length;n--;)if((e=Ge[n]+t)in ze)return e}(e)||e)}var Xe,Ye,Qe=/^(none|table(?!-c[ea]).+)/,Ze={position:"absolute",visibility:"hidden",display:"block"},et={letterSpacing:"0",fontWeight:"400"};function tt(e,t,n){var i=re.exec(t);return i?Math.max(0,i[2]-(n||0))+(i[3]||"px"):t}function nt(e,t,n,i,r,o){var s="width"===t?1:0,a=0,d=0;if(n===(i?"border":"content"))return 0;for(;s<4;s+=2)"margin"===n&&(d+=C.css(e,n+oe[s],!0,r)),i?("content"===n&&(d-=C.css(e,"padding"+oe[s],!0,r)),"margin"!==n&&(d-=C.css(e,"border"+oe[s]+"Width",!0,r))):(d+=C.css(e,"padding"+oe[s],!0,r),"padding"!==n?d+=C.css(e,"border"+oe[s]+"Width",!0,r):a+=C.css(e,"border"+oe[s]+"Width",!0,r));return!i&&0<=o&&(d+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-d-a-.5))||0),d}function it(e,t,n){var i=Ve(e),r=(!f.boxSizingReliable()||n)&&"border-box"===C.css(e,"boxSizing",!1,i),o=r,s=Be(e,t,i),a="offset"+t[0].toUpperCase()+t.slice(1);if(Fe.test(s)){if(!n)return s;s="auto"}return(!f.boxSizingReliable()&&r||!f.reliableTrDimensions()&&P(e,"tr")||"auto"===s||!parseFloat(s)&&"inline"===C.css(e,"display",!1,i))&&e.getClientRects().length&&(r="border-box"===C.css(e,"boxSizing",!1,i),(o=a in e)&&(s=e[a])),(s=parseFloat(s)||0)+nt(e,t,n||(r?"border":"content"),o,i,s)+"px"}C.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=Be(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,i){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var r,o,s,a=W(t),d=je.test(t),c=e.style;if(d||(t=We(a)),s=C.cssHooks[t]||C.cssHooks[a],void 0===n)return s&&"get"in s&&void 0!==(r=s.get(e,!1,i))?r:c[t];"string"==(o=typeof n)&&(r=re.exec(n))&&r[1]&&(n=function(e,t,n,i){var r,o,s=20,a=function(){return C.css(e,t,"")},d=a(),c=n&&n[3]||(C.cssNumber[t]?"":"px"),l=e.nodeType&&(C.cssNumber[t]||"px"!==c&&+d)&&re.exec(C.css(e,t));if(l&&l[3]!==c){for(d/=2,c=c||l[3],l=+d||1;s--;)C.style(e,t,l+c),(1-o)*(1-(o=a()/d||.5))<=0&&(s=0),l/=o;l*=2,C.style(e,t,l+c),n=n||[]}return n&&(l=+l||+d||0,r=n[1]?l+(n[1]+1)*n[2]:+n[2]),r}(e,t,r),o="number"),null!=n&&n==n&&("number"!==o||d||(n+=r&&r[3]||(C.cssNumber[a]?"":"px")),f.clearCloneStyle||""!==n||0!==t.indexOf("background")||(c[t]="inherit"),s&&"set"in s&&void 0===(n=s.set(e,n,i))||(d?c.setProperty(t,n):c[t]=n))}},css:function(e,t,n,i){var r,o,s,a=W(t);return je.test(t)||(t=We(a)),(s=C.cssHooks[t]||C.cssHooks[a])&&"get"in s&&(r=s.get(e,!0,n)),void 0===r&&(r=Be(e,t,i)),"normal"===r&&t in et&&(r=et[t]),""===n||n?(o=parseFloat(r),!0===n||isFinite(o)?o||0:r):r}}),C.each(["height","width"],(function(e,t){C.cssHooks[t]={get:function(e,n,i){if(n)return!Qe.test(C.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?it(e,t,i):Ue(e,Ze,(function(){return it(e,t,i)}))},set:function(e,n,i){var r,o=Ve(e),s=!f.scrollboxSize()&&"absolute"===o.position,a=(s||i)&&"border-box"===C.css(e,"boxSizing",!1,o),d=i?nt(e,t,i,a,o):0;return a&&s&&(d-=Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-parseFloat(o[t])-nt(e,t,"border",!1,o)-.5)),d&&(r=re.exec(n))&&"px"!==(r[3]||"px")&&(e.style[t]=n,n=C.css(e,t)),tt(0,n,d)}}})),C.cssHooks.marginLeft=qe(f.reliableMarginLeft,(function(e,t){if(t)return(parseFloat(Be(e,"marginLeft"))||e.getBoundingClientRect().left-Ue(e,{marginLeft:0},(function(){return e.getBoundingClientRect().left})))+"px"})),C.each({margin:"",padding:"",border:"Width"},(function(e,t){C.cssHooks[e+t]={expand:function(n){for(var i=0,r={},o="string"==typeof n?n.split(" "):[n];i<4;i++)r[e+oe[i]+t]=o[i]||o[i-2]||o[0];return r}},"margin"!==e&&(C.cssHooks[e+t].set=tt)})),C.fn.extend({css:function(e,t){return q(this,(function(e,t,n){var i,r,o={},s=0;if(Array.isArray(t)){for(i=Ve(e),r=t.length;s<r;s++)o[t[s]]=C.css(e,t[s],!1,i);return o}return void 0!==n?C.style(e,t,n):C.css(e,t)}),e,t,1<arguments.length)}}),C.fn.delay=function(e,t){return e=C.fx&&C.fx.speeds[e]||e,t=t||"fx",this.queue(t,(function(t,n){var r=i.setTimeout(t,e);n.stop=function(){i.clearTimeout(r)}}))},Xe=E.createElement("input"),Ye=E.createElement("select").appendChild(E.createElement("option")),Xe.type="checkbox",f.checkOn=""!==Xe.value,f.optSelected=Ye.selected,(Xe=E.createElement("input")).value="t",Xe.type="radio",f.radioValue="t"===Xe.value;var rt,ot=C.expr.attrHandle;C.fn.extend({attr:function(e,t){return q(this,C.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each((function(){C.removeAttr(this,e)}))}}),C.extend({attr:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return void 0===e.getAttribute?C.prop(e,t,n):(1===o&&C.isXMLDoc(e)||(r=C.attrHooks[t.toLowerCase()]||(C.expr.match.bool.test(t)?rt:void 0)),void 0!==n?null===n?void C.removeAttr(e,t):r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:(e.setAttribute(t,n+""),n):r&&"get"in r&&null!==(i=r.get(e,t))?i:null==(i=C.find.attr(e,t))?void 0:i)},attrHooks:{type:{set:function(e,t){if(!f.radioValue&&"radio"===t&&P(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,i=0,r=t&&t.match(j);if(r&&1===e.nodeType)for(;n=r[i++];)e.removeAttribute(n)}}),rt={set:function(e,t,n){return!1===t?C.removeAttr(e,n):e.setAttribute(n,n),n}},C.each(C.expr.match.bool.source.match(/\\w+/g),(function(e,t){var n=ot[t]||C.find.attr;ot[t]=function(e,t,i){var r,o,s=t.toLowerCase();return i||(o=ot[s],ot[s]=r,r=null!=n(e,t,i)?s:null,ot[s]=o),r}}));var st=/^(?:input|select|textarea|button)$/i,at=/^(?:a|area)$/i;function dt(e){return(e.match(j)||[]).join(" ")}function ct(e){return e.getAttribute&&e.getAttribute("class")||""}function lt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(j)||[]}C.fn.extend({prop:function(e,t){return q(this,C.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each((function(){delete this[C.propFix[e]||e]}))}}),C.extend({prop:function(e,t,n){var i,r,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&C.isXMLDoc(e)||(t=C.propFix[t]||t,r=C.propHooks[t]),void 0!==n?r&&"set"in r&&void 0!==(i=r.set(e,n,t))?i:e[t]=n:r&&"get"in r&&null!==(i=r.get(e,t))?i:e[t]},propHooks:{tabIndex:{get:function(e){var t=C.find.attr(e,"tabindex");return t?parseInt(t,10):st.test(e.nodeName)||at.test(e.nodeName)&&e.href?0:-1}}},propFix:{for:"htmlFor",class:"className"}}),f.optSelected||(C.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),C.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],(function(){C.propFix[this.toLowerCase()]=this})),C.fn.extend({addClass:function(e){var t,n,i,r,o,s;return v(e)?this.each((function(t){C(this).addClass(e.call(this,t,ct(this)))})):(t=lt(e)).length?this.each((function(){if(i=ct(this),n=1===this.nodeType&&" "+dt(i)+" "){for(o=0;o<t.length;o++)r=t[o],n.indexOf(" "+r+" ")<0&&(n+=r+" ");s=dt(n),i!==s&&this.setAttribute("class",s)}})):this},removeClass:function(e){var t,n,i,r,o,s;return v(e)?this.each((function(t){C(this).removeClass(e.call(this,t,ct(this)))})):arguments.length?(t=lt(e)).length?this.each((function(){if(i=ct(this),n=1===this.nodeType&&" "+dt(i)+" "){for(o=0;o<t.length;o++)for(r=t[o];-1<n.indexOf(" "+r+" ");)n=n.replace(" "+r+" "," ");s=dt(n),i!==s&&this.setAttribute("class",s)}})):this:this.attr("class","")},toggleClass:function(e,t){var n,i,r,o,s=typeof e,a="string"===s||Array.isArray(e);return v(e)?this.each((function(n){C(this).toggleClass(e.call(this,n,ct(this),t),t)})):"boolean"==typeof t&&a?t?this.addClass(e):this.removeClass(e):(n=lt(e),this.each((function(){if(a)for(o=C(this),r=0;r<n.length;r++)i=n[r],o.hasClass(i)?o.removeClass(i):o.addClass(i);else void 0!==e&&"boolean"!==s||((i=ct(this))&&Q.set(this,"__className__",i),this.setAttribute&&this.setAttribute("class",i||!1===e?"":Q.get(this,"__className__")||""))})))},hasClass:function(e){var t,n,i=0;for(t=" "+e+" ";n=this[i++];)if(1===n.nodeType&&-1<(" "+dt(ct(n))+" ").indexOf(t))return!0;return!1}});var ht=/\\r/g;C.fn.extend({val:function(e){var t,n,i,r=this[0];return arguments.length?(i=v(e),this.each((function(n){var r;1===this.nodeType&&(null==(r=i?e.call(this,n,C(this).val()):e)?r="":"number"==typeof r?r+="":Array.isArray(r)&&(r=C.map(r,(function(e){return null==e?"":e+""}))),(t=C.valHooks[this.type]||C.valHooks[this.nodeName.toLowerCase()])&&"set"in t&&void 0!==t.set(this,r,"value")||(this.value=r))}))):r?(t=C.valHooks[r.type]||C.valHooks[r.nodeName.toLowerCase()])&&"get"in t&&void 0!==(n=t.get(r,"value"))?n:"string"==typeof(n=r.value)?n.replace(ht,""):null==n?"":n:void 0}}),C.extend({valHooks:{option:{get:function(e){var t=C.find.attr(e,"value");return null!=t?t:dt(C.text(e))}},select:{get:function(e){var t,n,i,r=e.options,o=e.selectedIndex,s="select-one"===e.type,a=s?null:[],d=s?o+1:r.length;for(i=o<0?d:s?o:0;i<d;i++)if(((n=r[i]).selected||i===o)&&!n.disabled&&(!n.parentNode.disabled||!P(n.parentNode,"optgroup"))){if(t=C(n).val(),s)return t;a.push(t)}return a},set:function(e,t){for(var n,i,r=e.options,o=C.makeArray(t),s=r.length;s--;)((i=r[s]).selected=-1<C.inArray(C.valHooks.option.get(i),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),C.each(["radio","checkbox"],(function(){C.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<C.inArray(C(e).val(),t)}},f.checkOn||(C.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})})),f.focusin="onfocusin"in i;var ut=/^(?:focusinfocus|focusoutblur)$/,pt=function(e){e.stopPropagation()};C.extend(C.event,{trigger:function(e,t,n,r){var o,s,a,d,c,l,h,u,m=[n||E],g=p.call(e,"type")?e.type:e,f=p.call(e,"namespace")?e.namespace.split("."):[];if(s=u=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!ut.test(g+C.event.triggered)&&(-1<g.indexOf(".")&&(g=(f=g.split(".")).shift(),f.sort()),c=g.indexOf(":")<0&&"on"+g,(e=e[C.expando]?e:new C.Event(g,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=f.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\\\.)"+f.join("\\\\.(?:.*\\\\.|)")+"(\\\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:C.makeArray(t,[e]),h=C.event.special[g]||{},r||!h.trigger||!1!==h.trigger.apply(n,t))){if(!r&&!h.noBubble&&!_(n)){for(d=h.delegateType||g,ut.test(d+g)||(s=s.parentNode);s;s=s.parentNode)m.push(s),a=s;a===(n.ownerDocument||E)&&m.push(a.defaultView||a.parentWindow||i)}for(o=0;(s=m[o++])&&!e.isPropagationStopped();)u=s,e.type=1<o?d:h.bindType||g,(l=(Q.get(s,"events")||Object.create(null))[e.type]&&Q.get(s,"handle"))&&l.apply(s,t),(l=c&&s[c])&&l.apply&&X(s)&&(e.result=l.apply(s,t),!1===e.result&&e.preventDefault());return e.type=g,r||e.isDefaultPrevented()||h._default&&!1!==h._default.apply(m.pop(),t)||!X(n)||c&&v(n[g])&&!_(n)&&((a=n[c])&&(n[c]=null),C.event.triggered=g,e.isPropagationStopped()&&u.addEventListener(g,pt),n[g](),e.isPropagationStopped()&&u.removeEventListener(g,pt),C.event.triggered=void 0,a&&(n[c]=a)),e.result}},simulate:function(e,t,n){var i=C.extend(new C.Event,n,{type:e,isSimulated:!0});C.event.trigger(i,null,t)}}),C.fn.extend({trigger:function(e,t){return this.each((function(){C.event.trigger(e,t,this)}))},triggerHandler:function(e,t){var n=this[0];if(n)return C.event.trigger(e,t,n,!0)}}),f.focusin||C.each({focus:"focusin",blur:"focusout"},(function(e,t){var n=function(e){C.event.simulate(t,e.target,C.event.fix(e))};C.event.special[t]={setup:function(){var i=this.ownerDocument||this.document||this,r=Q.access(i,t);r||i.addEventListener(e,n,!0),Q.access(i,t,(r||0)+1)},teardown:function(){var i=this.ownerDocument||this.document||this,r=Q.access(i,t)-1;r?Q.access(i,t,r):(i.removeEventListener(e,n,!0),Q.remove(i,t))}}})),C.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new i.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||C.error("Invalid XML: "+(n?C.map(n.childNodes,(function(e){return e.textContent})).join("\\n"):e)),t};var mt,gt=/\\[\\]$/,ft=/\\r?\\n/g,vt=/^(?:submit|button|image|reset|file)$/i,_t=/^(?:input|select|textarea|keygen)/i;function Et(e,t,n,i){var r;if(Array.isArray(t))C.each(t,(function(t,r){n||gt.test(e)?i(e,r):Et(e+"["+("object"==typeof r&&null!=r?t:"")+"]",r,n,i)}));else if(n||"object"!==b(t))i(e,t);else for(r in t)Et(e+"["+r+"]",t[r],n,i)}C.param=function(e,t){var n,i=[],r=function(e,t){var n=v(t)?t():t;i[i.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!C.isPlainObject(e))C.each(e,(function(){r(this.name,this.value)}));else for(n in e)Et(n,e[n],t,r);return i.join("&")},C.fn.extend({serialize:function(){return C.param(this.serializeArray())},serializeArray:function(){return this.map((function(){var e=C.prop(this,"elements");return e?C.makeArray(e):this})).filter((function(){var e=this.type;return this.name&&!C(this).is(":disabled")&&_t.test(this.nodeName)&&!vt.test(e)&&(this.checked||!me.test(e))})).map((function(e,t){var n=C(this).val();return null==n?null:Array.isArray(n)?C.map(n,(function(e){return{name:t.name,value:e.replace(ft,"\\r\\n")}})):{name:t.name,value:n.replace(ft,"\\r\\n")}})).get()}}),C.fn.extend({wrapAll:function(e){var t;return this[0]&&(v(e)&&(e=e.call(this[0])),t=C(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map((function(){for(var e=this;e.firstElementChild;)e=e.firstElementChild;return e})).append(this)),this},wrapInner:function(e){return v(e)?this.each((function(t){C(this).wrapInner(e.call(this,t))})):this.each((function(){var t=C(this),n=t.contents();n.length?n.wrapAll(e):t.append(e)}))},wrap:function(e){var t=v(e);return this.each((function(n){C(this).wrapAll(t?e.call(this,n):e)}))},unwrap:function(e){return this.parent(e).not("body").each((function(){C(this).replaceWith(this.childNodes)})),this}}),C.expr.pseudos.hidden=function(e){return!C.expr.pseudos.visible(e)},C.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},f.createHTMLDocument=((mt=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===mt.childNodes.length),C.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(f.createHTMLDocument?((i=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(i)):t=E),o=!n&&[],(r=D.exec(e))?[t.createElement(r[1])]:(r=Se([e],t,o),o&&o.length&&C(o).remove(),C.merge([],r.childNodes)));var i,r,o},C.offset={setOffset:function(e,t,n){var i,r,o,s,a,d,c=C.css(e,"position"),l=C(e),h={};"static"===c&&(e.style.position="relative"),a=l.offset(),o=C.css(e,"top"),d=C.css(e,"left"),("absolute"===c||"fixed"===c)&&-1<(o+d).indexOf("auto")?(s=(i=l.position()).top,r=i.left):(s=parseFloat(o)||0,r=parseFloat(d)||0),v(t)&&(t=t.call(e,n,C.extend({},a))),null!=t.top&&(h.top=t.top-a.top+s),null!=t.left&&(h.left=t.left-a.left+r),"using"in t?t.using.call(e,h):l.css(h)}},C.fn.extend({offset:function(e){if(arguments.length)return void 0===e?this:this.each((function(t){C.offset.setOffset(this,e,t)}));var t,n,i=this[0];return i?i.getClientRects().length?(t=i.getBoundingClientRect(),n=i.ownerDocument.defaultView,{top:t.top+n.pageYOffset,left:t.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,i=this[0],r={top:0,left:0};if("fixed"===C.css(i,"position"))t=i.getBoundingClientRect();else{for(t=this.offset(),n=i.ownerDocument,e=i.offsetParent||n.documentElement;e&&(e===n.body||e===n.documentElement)&&"static"===C.css(e,"position");)e=e.parentNode;e&&e!==i&&1===e.nodeType&&((r=C(e).offset()).top+=C.css(e,"borderTopWidth",!0),r.left+=C.css(e,"borderLeftWidth",!0))}return{top:t.top-r.top-C.css(i,"marginTop",!0),left:t.left-r.left-C.css(i,"marginLeft",!0)}}},offsetParent:function(){return this.map((function(){for(var e=this.offsetParent;e&&"static"===C.css(e,"position");)e=e.offsetParent;return e||se}))}}),C.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},(function(e,t){var n="pageYOffset"===t;C.fn[e]=function(i){return q(this,(function(e,i,r){var o;if(_(e)?o=e:9===e.nodeType&&(o=e.defaultView),void 0===r)return o?o[t]:e[i];o?o.scrollTo(n?o.pageXOffset:r,n?r:o.pageYOffset):e[i]=r}),e,i,arguments.length)}})),C.each(["top","left"],(function(e,t){C.cssHooks[t]=qe(f.pixelPosition,(function(e,n){if(n)return n=Be(e,t),Fe.test(n)?C(e).position()[t]+"px":n}))})),C.each({Height:"height",Width:"width"},(function(e,t){C.each({padding:"inner"+e,content:t,"":"outer"+e},(function(n,i){C.fn[i]=function(r,o){var s=arguments.length&&(n||"boolean"!=typeof r),a=n||(!0===r||!0===o?"margin":"border");return q(this,(function(t,n,r){var o;return _(t)?0===i.indexOf("outer")?t["inner"+e]:t.document.documentElement["client"+e]:9===t.nodeType?(o=t.documentElement,Math.max(t.body["scroll"+e],o["scroll"+e],t.body["offset"+e],o["offset"+e],o["client"+e])):void 0===r?C.css(t,n,a):C.style(t,n,r,a)}),t,s?r:void 0,s)}}))})),C.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,i){return this.on(t,e,n,i)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),C.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),(function(e,t){C.fn[t]=function(e,n){return 0<arguments.length?this.on(t,null,e,n):this.trigger(t)}}));var yt=/^[\\s\\uFEFF\\xA0]+|([^\\s\\uFEFF\\xA0])[\\s\\uFEFF\\xA0]+$/g;C.proxy=function(e,t){var n,i,r;if("string"==typeof t&&(n=e[t],t=e,e=n),v(e))return i=a.call(arguments,2),(r=function(){return e.apply(t||this,i.concat(a.call(arguments)))}).guid=e.guid=e.guid||C.guid++,r},C.holdReady=function(e){e?C.readyWait++:C.ready(!0)},C.isArray=Array.isArray,C.parseJSON=JSON.parse,C.nodeName=P,C.isFunction=v,C.isWindow=_,C.camelCase=W,C.type=b,C.now=Date.now,C.isNumeric=function(e){var t=C.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},C.trim=function(e){return null==e?"":(e+"").replace(yt,"$1")},void 0===(n=function(){return C}.apply(t,[]))||(e.exports=n);var St=i.jQuery,bt=i.$;return C.noConflict=function(e){return i.$===C&&(i.$=bt),e&&i.jQuery===C&&(i.jQuery=St),C},void 0===r&&(i.jQuery=i.$=C),C}))},478:(module,exports,__webpack_require__)=>{var __WEBPACK_AMD_DEFINE_RESULT__;(function(){"use strict";var ERROR="input is invalid type",WINDOW="object"==typeof window,root=WINDOW?window:{};root.JS_MD5_NO_WINDOW&&(WINDOW=!1);var WEB_WORKER=!WINDOW&&"object"==typeof self,NODE_JS=!root.JS_MD5_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node;NODE_JS?root=__webpack_require__.g:WEB_WORKER&&(root=self);var COMMON_JS=!root.JS_MD5_NO_COMMON_JS&&module.exports,AMD=__webpack_require__.amdO,ARRAY_BUFFER=!root.JS_MD5_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,HEX_CHARS="0123456789abcdef".split(""),EXTRA=[128,32768,8388608,-2147483648],SHIFT=[0,8,16,24],OUTPUT_TYPES=["hex","array","digest","buffer","arrayBuffer","base64"],BASE64_ENCODE_CHAR="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split(""),blocks=[],buffer8;if(ARRAY_BUFFER){var buffer=new ArrayBuffer(68);buffer8=new Uint8Array(buffer),blocks=new Uint32Array(buffer)}!root.JS_MD5_NO_NODE_JS&&Array.isArray||(Array.isArray=function(e){return"[object Array]"===Object.prototype.toString.call(e)}),!ARRAY_BUFFER||!root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(e){return"object"==typeof e&&e.buffer&&e.buffer.constructor===ArrayBuffer});var createOutputMethod=function(e){return function(t){return new Md5(!0).update(t)[e]()}},createMethod=function(){var e=createOutputMethod("hex");NODE_JS&&(e=nodeWrap(e)),e.create=function(){return new Md5},e.update=function(t){return e.create().update(t)};for(var t=0;t<OUTPUT_TYPES.length;++t){var n=OUTPUT_TYPES[t];e[n]=createOutputMethod(n)}return e},nodeWrap=function(method){var crypto=eval("require(\'crypto\')"),Buffer=eval("require(\'buffer\').Buffer"),nodeMethod=function(e){if("string"==typeof e)return crypto.createHash("md5").update(e,"utf8").digest("hex");if(null==e)throw ERROR;return e.constructor===ArrayBuffer&&(e=new Uint8Array(e)),Array.isArray(e)||ArrayBuffer.isView(e)||e.constructor===Buffer?crypto.createHash("md5").update(new Buffer(e)).digest("hex"):method(e)};return nodeMethod};function Md5(e){if(e)blocks[0]=blocks[16]=blocks[1]=blocks[2]=blocks[3]=blocks[4]=blocks[5]=blocks[6]=blocks[7]=blocks[8]=blocks[9]=blocks[10]=blocks[11]=blocks[12]=blocks[13]=blocks[14]=blocks[15]=0,this.blocks=blocks,this.buffer8=buffer8;else if(ARRAY_BUFFER){var t=new ArrayBuffer(68);this.buffer8=new Uint8Array(t),this.blocks=new Uint32Array(t)}else this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];this.h0=this.h1=this.h2=this.h3=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1,this.first=!0}Md5.prototype.update=function(e){if(!this.finalized){var t,n=typeof e;if("string"!==n){if("object"!==n)throw ERROR;if(null===e)throw ERROR;if(ARRAY_BUFFER&&e.constructor===ArrayBuffer)e=new Uint8Array(e);else if(!(Array.isArray(e)||ARRAY_BUFFER&&ArrayBuffer.isView(e)))throw ERROR;t=!0}for(var i,r,o=0,s=e.length,a=this.blocks,d=this.buffer8;o<s;){if(this.hashed&&(this.hashed=!1,a[0]=a[16],a[16]=a[1]=a[2]=a[3]=a[4]=a[5]=a[6]=a[7]=a[8]=a[9]=a[10]=a[11]=a[12]=a[13]=a[14]=a[15]=0),t)if(ARRAY_BUFFER)for(r=this.start;o<s&&r<64;++o)d[r++]=e[o];else for(r=this.start;o<s&&r<64;++o)a[r>>2]|=e[o]<<SHIFT[3&r++];else if(ARRAY_BUFFER)for(r=this.start;o<s&&r<64;++o)(i=e.charCodeAt(o))<128?d[r++]=i:i<2048?(d[r++]=192|i>>6,d[r++]=128|63&i):i<55296||i>=57344?(d[r++]=224|i>>12,d[r++]=128|i>>6&63,d[r++]=128|63&i):(i=65536+((1023&i)<<10|1023&e.charCodeAt(++o)),d[r++]=240|i>>18,d[r++]=128|i>>12&63,d[r++]=128|i>>6&63,d[r++]=128|63&i);else for(r=this.start;o<s&&r<64;++o)(i=e.charCodeAt(o))<128?a[r>>2]|=i<<SHIFT[3&r++]:i<2048?(a[r>>2]|=(192|i>>6)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]):i<55296||i>=57344?(a[r>>2]|=(224|i>>12)<<SHIFT[3&r++],a[r>>2]|=(128|i>>6&63)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]):(i=65536+((1023&i)<<10|1023&e.charCodeAt(++o)),a[r>>2]|=(240|i>>18)<<SHIFT[3&r++],a[r>>2]|=(128|i>>12&63)<<SHIFT[3&r++],a[r>>2]|=(128|i>>6&63)<<SHIFT[3&r++],a[r>>2]|=(128|63&i)<<SHIFT[3&r++]);this.lastByteIndex=r,this.bytes+=r-this.start,r>=64?(this.start=r-64,this.hash(),this.hashed=!0):this.start=r}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this}},Md5.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var e=this.blocks,t=this.lastByteIndex;e[t>>2]|=EXTRA[3&t],t>=56&&(this.hashed||this.hash(),e[0]=e[16],e[16]=e[1]=e[2]=e[3]=e[4]=e[5]=e[6]=e[7]=e[8]=e[9]=e[10]=e[11]=e[12]=e[13]=e[14]=e[15]=0),e[14]=this.bytes<<3,e[15]=this.hBytes<<3|this.bytes>>>29,this.hash()}},Md5.prototype.hash=function(){var e,t,n,i,r,o,s=this.blocks;this.first?t=((t=((e=((e=s[0]-680876937)<<7|e>>>25)-271733879<<0)^(n=((n=(-271733879^(i=((i=(-1732584194^2004318071&e)+s[1]-117830708)<<12|i>>>20)+e<<0)&(-271733879^e))+s[2]-1126478375)<<17|n>>>15)+i<<0)&(i^e))+s[3]-1316259209)<<22|t>>>10)+n<<0:(e=this.h0,t=this.h1,n=this.h2,t=((t+=((e=((e+=((i=this.h3)^t&(n^i))+s[0]-680876936)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[1]-389564586)<<12|i>>>20)+e<<0)&(e^t))+s[2]+606105819)<<17|n>>>15)+i<<0)&(i^e))+s[3]-1044525330)<<22|t>>>10)+n<<0),t=((t+=((e=((e+=(i^t&(n^i))+s[4]-176418897)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[5]+1200080426)<<12|i>>>20)+e<<0)&(e^t))+s[6]-1473231341)<<17|n>>>15)+i<<0)&(i^e))+s[7]-45705983)<<22|t>>>10)+n<<0,t=((t+=((e=((e+=(i^t&(n^i))+s[8]+1770035416)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[9]-1958414417)<<12|i>>>20)+e<<0)&(e^t))+s[10]-42063)<<17|n>>>15)+i<<0)&(i^e))+s[11]-1990404162)<<22|t>>>10)+n<<0,t=((t+=((e=((e+=(i^t&(n^i))+s[12]+1804603682)<<7|e>>>25)+t<<0)^(n=((n+=(t^(i=((i+=(n^e&(t^n))+s[13]-40341101)<<12|i>>>20)+e<<0)&(e^t))+s[14]-1502002290)<<17|n>>>15)+i<<0)&(i^e))+s[15]+1236535329)<<22|t>>>10)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[1]-165796510)<<5|e>>>27)+t<<0)^t))+s[6]-1069501632)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[11]+643717713)<<14|n>>>18)+i<<0)^i))+s[0]-373897302)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[5]-701558691)<<5|e>>>27)+t<<0)^t))+s[10]+38016083)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[15]-660478335)<<14|n>>>18)+i<<0)^i))+s[4]-405537848)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[9]+568446438)<<5|e>>>27)+t<<0)^t))+s[14]-1019803690)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[3]-187363961)<<14|n>>>18)+i<<0)^i))+s[8]+1163531501)<<20|t>>>12)+n<<0,t=((t+=((i=((i+=(t^n&((e=((e+=(n^i&(t^n))+s[13]-1444681467)<<5|e>>>27)+t<<0)^t))+s[2]-51403784)<<9|i>>>23)+e<<0)^e&((n=((n+=(e^t&(i^e))+s[7]+1735328473)<<14|n>>>18)+i<<0)^i))+s[12]-1926607734)<<20|t>>>12)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[5]-378558)<<4|e>>>28)+t<<0))+s[8]-2022574463)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[11]+1839030562)<<16|n>>>16)+i<<0))+s[14]-35309556)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[1]-1530992060)<<4|e>>>28)+t<<0))+s[4]+1272893353)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[7]-155497632)<<16|n>>>16)+i<<0))+s[10]-1094730640)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[13]+681279174)<<4|e>>>28)+t<<0))+s[0]-358537222)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[3]-722521979)<<16|n>>>16)+i<<0))+s[6]+76029189)<<23|t>>>9)+n<<0,t=((t+=((o=(i=((i+=((r=t^n)^(e=((e+=(r^i)+s[9]-640364487)<<4|e>>>28)+t<<0))+s[12]-421815835)<<11|i>>>21)+e<<0)^e)^(n=((n+=(o^t)+s[15]+530742520)<<16|n>>>16)+i<<0))+s[2]-995338651)<<23|t>>>9)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[0]-198630844)<<6|e>>>26)+t<<0)|~n))+s[7]+1126891415)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[14]-1416354905)<<15|n>>>17)+i<<0)|~e))+s[5]-57434055)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[12]+1700485571)<<6|e>>>26)+t<<0)|~n))+s[3]-1894986606)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[10]-1051523)<<15|n>>>17)+i<<0)|~e))+s[1]-2054922799)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[8]+1873313359)<<6|e>>>26)+t<<0)|~n))+s[15]-30611744)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[6]-1560198380)<<15|n>>>17)+i<<0)|~e))+s[13]+1309151649)<<21|t>>>11)+n<<0,t=((t+=((i=((i+=(t^((e=((e+=(n^(t|~i))+s[4]-145523070)<<6|e>>>26)+t<<0)|~n))+s[11]-1120210379)<<10|i>>>22)+e<<0)^((n=((n+=(e^(i|~t))+s[2]+718787259)<<15|n>>>17)+i<<0)|~e))+s[9]-343485551)<<21|t>>>11)+n<<0,this.first?(this.h0=e+1732584193<<0,this.h1=t-271733879<<0,this.h2=n-1732584194<<0,this.h3=i+271733878<<0,this.first=!1):(this.h0=this.h0+e<<0,this.h1=this.h1+t<<0,this.h2=this.h2+n<<0,this.h3=this.h3+i<<0)},Md5.prototype.hex=function(){this.finalize();var e=this.h0,t=this.h1,n=this.h2,i=this.h3;return HEX_CHARS[e>>4&15]+HEX_CHARS[15&e]+HEX_CHARS[e>>12&15]+HEX_CHARS[e>>8&15]+HEX_CHARS[e>>20&15]+HEX_CHARS[e>>16&15]+HEX_CHARS[e>>28&15]+HEX_CHARS[e>>24&15]+HEX_CHARS[t>>4&15]+HEX_CHARS[15&t]+HEX_CHARS[t>>12&15]+HEX_CHARS[t>>8&15]+HEX_CHARS[t>>20&15]+HEX_CHARS[t>>16&15]+HEX_CHARS[t>>28&15]+HEX_CHARS[t>>24&15]+HEX_CHARS[n>>4&15]+HEX_CHARS[15&n]+HEX_CHARS[n>>12&15]+HEX_CHARS[n>>8&15]+HEX_CHARS[n>>20&15]+HEX_CHARS[n>>16&15]+HEX_CHARS[n>>28&15]+HEX_CHARS[n>>24&15]+HEX_CHARS[i>>4&15]+HEX_CHARS[15&i]+HEX_CHARS[i>>12&15]+HEX_CHARS[i>>8&15]+HEX_CHARS[i>>20&15]+HEX_CHARS[i>>16&15]+HEX_CHARS[i>>28&15]+HEX_CHARS[i>>24&15]},Md5.prototype.toString=Md5.prototype.hex,Md5.prototype.digest=function(){this.finalize();var e=this.h0,t=this.h1,n=this.h2,i=this.h3;return[255&e,e>>8&255,e>>16&255,e>>24&255,255&t,t>>8&255,t>>16&255,t>>24&255,255&n,n>>8&255,n>>16&255,n>>24&255,255&i,i>>8&255,i>>16&255,i>>24&255]},Md5.prototype.array=Md5.prototype.digest,Md5.prototype.arrayBuffer=function(){this.finalize();var e=new ArrayBuffer(16),t=new Uint32Array(e);return t[0]=this.h0,t[1]=this.h1,t[2]=this.h2,t[3]=this.h3,e},Md5.prototype.buffer=Md5.prototype.arrayBuffer,Md5.prototype.base64=function(){for(var e,t,n,i="",r=this.array(),o=0;o<15;)e=r[o++],t=r[o++],n=r[o++],i+=BASE64_ENCODE_CHAR[e>>>2]+BASE64_ENCODE_CHAR[63&(e<<4|t>>>4)]+BASE64_ENCODE_CHAR[63&(t<<2|n>>>6)]+BASE64_ENCODE_CHAR[63&n];return e=r[o],i+(BASE64_ENCODE_CHAR[e>>>2]+BASE64_ENCODE_CHAR[e<<4&63]+"==")};var exports=createMethod();COMMON_JS?module.exports=exports:(root.md5=exports,AMD&&(__WEBPACK_AMD_DEFINE_RESULT__=function(){return exports}.call(exports,__webpack_require__,exports,module),void 0===__WEBPACK_AMD_DEFINE_RESULT__||(module.exports=__WEBPACK_AMD_DEFINE_RESULT__)))})()},138:(e,t,n)=>{e=n.nmd(e);var i="__lodash_hash_undefined__",r=9007199254740991,o="[object Arguments]",s="[object Boolean]",a="[object Date]",d="[object Function]",c="[object GeneratorFunction]",l="[object Map]",h="[object Number]",u="[object Object]",p="[object Promise]",m="[object RegExp]",g="[object Set]",f="[object String]",v="[object Symbol]",_="[object WeakMap]",E="[object ArrayBuffer]",y="[object DataView]",S="[object Float32Array]",b="[object Float64Array]",T="[object Int8Array]",C="[object Int16Array]",x="[object Int32Array]",R="[object Uint8Array]",A="[object Uint8ClampedArray]",w="[object Uint16Array]",I="[object Uint32Array]",P=/\\w*$/,D=/^\\[object .+?Constructor\\]$/,O=/^(?:0|[1-9]\\d*)$/,k={};k[o]=k["[object Array]"]=k[E]=k[y]=k[s]=k[a]=k[S]=k[b]=k[T]=k[C]=k[x]=k[l]=k[h]=k[u]=k[m]=k[g]=k[f]=k[v]=k[R]=k[A]=k[w]=k[I]=!0,k["[object Error]"]=k[d]=k[_]=!1;var N="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,M="object"==typeof self&&self&&self.Object===Object&&self,L=N||M||Function("return this")(),F=t&&!t.nodeType&&t,j=F&&e&&!e.nodeType&&e,V=j&&j.exports===F;function U(e,t){return e.set(t[0],t[1]),e}function H(e,t){return e.add(t),e}function $(e,t,n,i){var r=-1,o=e?e.length:0;for(i&&o&&(n=e[++r]);++r<o;)n=t(n,e[r],r,e);return n}function J(e){var t=!1;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"")}catch(e){}return t}function B(e){var t=-1,n=Array(e.size);return e.forEach((function(e,i){n[++t]=[i,e]})),n}function q(e,t){return function(n){return e(t(n))}}function G(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}var z,K=Array.prototype,W=Function.prototype,X=Object.prototype,Y=L["__core-js_shared__"],Q=(z=/[^.]+$/.exec(Y&&Y.keys&&Y.keys.IE_PROTO||""))?"Symbol(src)_1."+z:"",Z=W.toString,ee=X.hasOwnProperty,te=X.toString,ne=RegExp("^"+Z.call(ee).replace(/[\\\\^$.*+?()[\\]{}|]/g,"\\\\$&").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,"$1.*?")+"$"),ie=V?L.Buffer:void 0,re=L.Symbol,oe=L.Uint8Array,se=q(Object.getPrototypeOf,Object),ae=Object.create,de=X.propertyIsEnumerable,ce=K.splice,le=Object.getOwnPropertySymbols,he=ie?ie.isBuffer:void 0,ue=q(Object.keys,Object),pe=Le(L,"DataView"),me=Le(L,"Map"),ge=Le(L,"Promise"),fe=Le(L,"Set"),ve=Le(L,"WeakMap"),_e=Le(Object,"create"),Ee=He(pe),ye=He(me),Se=He(ge),be=He(fe),Te=He(ve),Ce=re?re.prototype:void 0,xe=Ce?Ce.valueOf:void 0;function Re(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ae(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function we(e){var t=-1,n=e?e.length:0;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ie(e){this.__data__=new Ae(e)}function Pe(e,t,n){var i=e[t];ee.call(e,t)&&$e(i,n)&&(void 0!==n||t in e)||(e[t]=n)}function De(e,t){for(var n=e.length;n--;)if($e(e[n][0],t))return n;return-1}function Oe(e,t,n,i,r,p,_){var D;if(i&&(D=p?i(e,r,p,_):i(e)),void 0!==D)return D;if(!ze(e))return e;var O=Je(e);if(O){if(D=function(e){var t=e.length,n=e.constructor(t);return t&&"string"==typeof e[0]&&ee.call(e,"index")&&(n.index=e.index,n.input=e.input),n}(e),!t)return function(e,t){var n=-1,i=e.length;for(t||(t=Array(i));++n<i;)t[n]=e[n];return t}(e,D)}else{var N=je(e),M=N==d||N==c;if(qe(e))return function(e,t){if(t)return e.slice();var n=new e.constructor(e.length);return e.copy(n),n}(e,t);if(N==u||N==o||M&&!p){if(J(e))return p?e:{};if(D=function(e){return"function"!=typeof e.constructor||Ue(e)?{}:ze(t=se(e))?ae(t):{};var t}(M?{}:e),!t)return function(e,t){return Ne(e,Fe(e),t)}(e,function(e,t){return e&&Ne(t,Ke(t),e)}(D,e))}else{if(!k[N])return p?e:{};D=function(e,t,n,i){var r,o=e.constructor;switch(t){case E:return ke(e);case s:case a:return new o(+e);case y:return function(e,t){var n=t?ke(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.byteLength)}(e,i);case S:case b:case T:case C:case x:case R:case A:case w:case I:return function(e,t){var n=t?ke(e.buffer):e.buffer;return new e.constructor(n,e.byteOffset,e.length)}(e,i);case l:return function(e,t,n){return $(t?n(B(e),!0):B(e),U,new e.constructor)}(e,i,n);case h:case f:return new o(e);case m:return function(e){var t=new e.constructor(e.source,P.exec(e));return t.lastIndex=e.lastIndex,t}(e);case g:return function(e,t,n){return $(t?n(G(e),!0):G(e),H,new e.constructor)}(e,i,n);case v:return r=e,xe?Object(xe.call(r)):{}}}(e,N,Oe,t)}}_||(_=new Ie);var L=_.get(e);if(L)return L;if(_.set(e,D),!O)var F=n?function(e){return function(e,t,n){var i=t(e);return Je(e)?i:function(e,t){for(var n=-1,i=t.length,r=e.length;++n<i;)e[r+n]=t[n];return e}(i,n(e))}(e,Ke,Fe)}(e):Ke(e);return function(e,t){for(var n=-1,i=e?e.length:0;++n<i&&!1!==t(e[n],n););}(F||e,(function(r,o){F&&(r=e[o=r]),Pe(D,o,Oe(r,t,n,i,o,e,_))})),D}function ke(e){var t=new e.constructor(e.byteLength);return new oe(t).set(new oe(e)),t}function Ne(e,t,n,i){n||(n={});for(var r=-1,o=t.length;++r<o;){var s=t[r],a=i?i(n[s],e[s],s,n,e):void 0;Pe(n,s,void 0===a?e[s]:a)}return n}function Me(e,t){var n,i,r=e.__data__;return("string"==(i=typeof(n=t))||"number"==i||"symbol"==i||"boolean"==i?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Le(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return function(e){return!(!ze(e)||(t=e,Q&&Q in t))&&(Ge(e)||J(e)?ne:D).test(He(e));var t}(n)?n:void 0}Re.prototype.clear=function(){this.__data__=_e?_e(null):{}},Re.prototype.delete=function(e){return this.has(e)&&delete this.__data__[e]},Re.prototype.get=function(e){var t=this.__data__;if(_e){var n=t[e];return n===i?void 0:n}return ee.call(t,e)?t[e]:void 0},Re.prototype.has=function(e){var t=this.__data__;return _e?void 0!==t[e]:ee.call(t,e)},Re.prototype.set=function(e,t){return this.__data__[e]=_e&&void 0===t?i:t,this},Ae.prototype.clear=function(){this.__data__=[]},Ae.prototype.delete=function(e){var t=this.__data__,n=De(t,e);return!(n<0||(n==t.length-1?t.pop():ce.call(t,n,1),0))},Ae.prototype.get=function(e){var t=this.__data__,n=De(t,e);return n<0?void 0:t[n][1]},Ae.prototype.has=function(e){return De(this.__data__,e)>-1},Ae.prototype.set=function(e,t){var n=this.__data__,i=De(n,e);return i<0?n.push([e,t]):n[i][1]=t,this},we.prototype.clear=function(){this.__data__={hash:new Re,map:new(me||Ae),string:new Re}},we.prototype.delete=function(e){return Me(this,e).delete(e)},we.prototype.get=function(e){return Me(this,e).get(e)},we.prototype.has=function(e){return Me(this,e).has(e)},we.prototype.set=function(e,t){return Me(this,e).set(e,t),this},Ie.prototype.clear=function(){this.__data__=new Ae},Ie.prototype.delete=function(e){return this.__data__.delete(e)},Ie.prototype.get=function(e){return this.__data__.get(e)},Ie.prototype.has=function(e){return this.__data__.has(e)},Ie.prototype.set=function(e,t){var n=this.__data__;if(n instanceof Ae){var i=n.__data__;if(!me||i.length<199)return i.push([e,t]),this;n=this.__data__=new we(i)}return n.set(e,t),this};var Fe=le?q(le,Object):function(){return[]},je=function(e){return te.call(e)};function Ve(e,t){return!!(t=null==t?r:t)&&("number"==typeof e||O.test(e))&&e>-1&&e%1==0&&e<t}function Ue(e){var t=e&&e.constructor;return e===("function"==typeof t&&t.prototype||X)}function He(e){if(null!=e){try{return Z.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function $e(e,t){return e===t||e!=e&&t!=t}(pe&&je(new pe(new ArrayBuffer(1)))!=y||me&&je(new me)!=l||ge&&je(ge.resolve())!=p||fe&&je(new fe)!=g||ve&&je(new ve)!=_)&&(je=function(e){var t=te.call(e),n=t==u?e.constructor:void 0,i=n?He(n):void 0;if(i)switch(i){case Ee:return y;case ye:return l;case Se:return p;case be:return g;case Te:return _}return t});var Je=Array.isArray;function Be(e){return null!=e&&function(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=r}(e.length)&&!Ge(e)}var qe=he||function(){return!1};function Ge(e){var t=ze(e)?te.call(e):"";return t==d||t==c}function ze(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function Ke(e){return Be(e)?function(e,t){var n=Je(e)||function(e){return function(e){return function(e){return!!e&&"object"==typeof e}(e)&&Be(e)}(e)&&ee.call(e,"callee")&&(!de.call(e,"callee")||te.call(e)==o)}(e)?function(e,t){for(var n=-1,i=Array(e);++n<e;)i[n]=t(n);return i}(e.length,String):[],i=n.length,r=!!i;for(var s in e)!t&&!ee.call(e,s)||r&&("length"==s||Ve(s,i))||n.push(s);return n}(e):function(e){if(!Ue(e))return ue(e);var t=[];for(var n in Object(e))ee.call(e,n)&&"constructor"!=n&&t.push(n);return t}(e)}e.exports=function(e){return Oe(e,!0,!0)}},509:(e,t,n)=>{var i=NaN,r="[object Symbol]",o=/^\\s+|\\s+$/g,s=/^[-+]0x[0-9a-f]+$/i,a=/^0b[01]+$/i,d=/^0o[0-7]+$/i,c=parseInt,l="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,h="object"==typeof self&&self&&self.Object===Object&&self,u=l||h||Function("return this")(),p=Object.prototype.toString,m=Math.max,g=Math.min,f=function(){return u.Date.now()};function v(e){var t=typeof e;return!!e&&("object"==t||"function"==t)}function _(e){if("number"==typeof e)return e;if(function(e){return"symbol"==typeof e||function(e){return!!e&&"object"==typeof e}(e)&&p.call(e)==r}(e))return i;if(v(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=v(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var n=a.test(e);return n||d.test(e)?c(e.slice(2),n?2:8):s.test(e)?i:+e}e.exports=function(e,t,n){var i,r,o,s,a,d,c=0,l=!1,h=!1,u=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function p(t){var n=i,o=r;return i=r=void 0,c=t,s=e.apply(o,n)}function E(e){var n=e-d;return void 0===d||n>=t||n<0||h&&e-c>=o}function y(){var e=f();if(E(e))return S(e);a=setTimeout(y,function(e){var n=t-(e-d);return h?g(n,o-(e-c)):n}(e))}function S(e){return a=void 0,u&&i?p(e):(i=r=void 0,s)}function b(){var e=f(),n=E(e);if(i=arguments,r=this,d=e,n){if(void 0===a)return function(e){return c=e,a=setTimeout(y,t),l?p(e):s}(d);if(h)return a=setTimeout(y,t),p(d)}return void 0===a&&(a=setTimeout(y,t)),s}return t=_(t)||0,v(n)&&(l=!!n.leading,o=(h="maxWait"in n)?m(_(n.maxWait)||0,t):o,u="trailing"in n?!!n.trailing:u),b.cancel=function(){void 0!==a&&clearTimeout(a),c=0,i=d=r=a=void 0},b.flush=function(){return void 0===a?s:S(f())},b}},47:(e,t,n)=>{e=n.nmd(e);var i="__lodash_hash_undefined__",r=1,o=2,s=9007199254740991,a="[object Arguments]",d="[object Array]",c="[object AsyncFunction]",l="[object Boolean]",h="[object Date]",u="[object Error]",p="[object Function]",m="[object GeneratorFunction]",g="[object Map]",f="[object Number]",v="[object Null]",_="[object Object]",E="[object Promise]",y="[object Proxy]",S="[object RegExp]",b="[object Set]",T="[object String]",C="[object Symbol]",x="[object Undefined]",R="[object WeakMap]",A="[object ArrayBuffer]",w="[object DataView]",I=/^\\[object .+?Constructor\\]$/,P=/^(?:0|[1-9]\\d*)$/,D={};D["[object Float32Array]"]=D["[object Float64Array]"]=D["[object Int8Array]"]=D["[object Int16Array]"]=D["[object Int32Array]"]=D["[object Uint8Array]"]=D["[object Uint8ClampedArray]"]=D["[object Uint16Array]"]=D["[object Uint32Array]"]=!0,D[a]=D[d]=D[A]=D[l]=D[w]=D[h]=D[u]=D[p]=D[g]=D[f]=D[_]=D[S]=D[b]=D[T]=D[R]=!1;var O="object"==typeof n.g&&n.g&&n.g.Object===Object&&n.g,k="object"==typeof self&&self&&self.Object===Object&&self,N=O||k||Function("return this")(),M=t&&!t.nodeType&&t,L=M&&e&&!e.nodeType&&e,F=L&&L.exports===M,j=F&&O.process,V=function(){try{return j&&j.binding&&j.binding("util")}catch(e){}}(),U=V&&V.isTypedArray;function H(e,t){for(var n=-1,i=null==e?0:e.length;++n<i;)if(t(e[n],n,e))return!0;return!1}function $(e){var t=-1,n=Array(e.size);return e.forEach((function(e,i){n[++t]=[i,e]})),n}function J(e){var t=-1,n=Array(e.size);return e.forEach((function(e){n[++t]=e})),n}var B,q,G,z=Array.prototype,K=Function.prototype,W=Object.prototype,X=N["__core-js_shared__"],Y=K.toString,Q=W.hasOwnProperty,Z=(B=/[^.]+$/.exec(X&&X.keys&&X.keys.IE_PROTO||""))?"Symbol(src)_1."+B:"",ee=W.toString,te=RegExp("^"+Y.call(Q).replace(/[\\\\^$.*+?()[\\]{}|]/g,"\\\\$&").replace(/hasOwnProperty|(function).*?(?=\\\\\\()| for .+?(?=\\\\\\])/g,"$1.*?")+"$"),ne=F?N.Buffer:void 0,ie=N.Symbol,re=N.Uint8Array,oe=W.propertyIsEnumerable,se=z.splice,ae=ie?ie.toStringTag:void 0,de=Object.getOwnPropertySymbols,ce=ne?ne.isBuffer:void 0,le=(q=Object.keys,G=Object,function(e){return q(G(e))}),he=Le(N,"DataView"),ue=Le(N,"Map"),pe=Le(N,"Promise"),me=Le(N,"Set"),ge=Le(N,"WeakMap"),fe=Le(Object,"create"),ve=Ue(he),_e=Ue(ue),Ee=Ue(pe),ye=Ue(me),Se=Ue(ge),be=ie?ie.prototype:void 0,Te=be?be.valueOf:void 0;function Ce(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function xe(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Re(e){var t=-1,n=null==e?0:e.length;for(this.clear();++t<n;){var i=e[t];this.set(i[0],i[1])}}function Ae(e){var t=-1,n=null==e?0:e.length;for(this.__data__=new Re;++t<n;)this.add(e[t])}function we(e){var t=this.__data__=new xe(e);this.size=t.size}function Ie(e,t){for(var n=e.length;n--;)if(He(e[n][0],t))return n;return-1}function Pe(e){return null==e?void 0===e?x:v:ae&&ae in Object(e)?function(e){var t=Q.call(e,ae),n=e[ae];try{e[ae]=void 0;var i=!0}catch(e){}var r=ee.call(e);return i&&(t?e[ae]=n:delete e[ae]),r}(e):function(e){return ee.call(e)}(e)}function De(e){return Ke(e)&&Pe(e)==a}function Oe(e,t,n,i,s){return e===t||(null==e||null==t||!Ke(e)&&!Ke(t)?e!=e&&t!=t:function(e,t,n,i,s,c){var p=Je(e),m=Je(t),v=p?d:je(e),E=m?d:je(t),y=(v=v==a?_:v)==_,x=(E=E==a?_:E)==_,R=v==E;if(R&&Be(e)){if(!Be(t))return!1;p=!0,y=!1}if(R&&!y)return c||(c=new we),p||We(e)?ke(e,t,n,i,s,c):function(e,t,n,i,s,a,d){switch(n){case w:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return!1;e=e.buffer,t=t.buffer;case A:return!(e.byteLength!=t.byteLength||!a(new re(e),new re(t)));case l:case h:case f:return He(+e,+t);case u:return e.name==t.name&&e.message==t.message;case S:case T:return e==t+"";case g:var c=$;case b:var p=i&r;if(c||(c=J),e.size!=t.size&&!p)return!1;var m=d.get(e);if(m)return m==t;i|=o,d.set(e,t);var v=ke(c(e),c(t),i,s,a,d);return d.delete(e),v;case C:if(Te)return Te.call(e)==Te.call(t)}return!1}(e,t,v,n,i,s,c);if(!(n&r)){var I=y&&Q.call(e,"__wrapped__"),P=x&&Q.call(t,"__wrapped__");if(I||P){var D=I?e.value():e,O=P?t.value():t;return c||(c=new we),s(D,O,n,i,c)}}return!!R&&(c||(c=new we),function(e,t,n,i,o,s){var a=n&r,d=Ne(e),c=d.length;if(c!=Ne(t).length&&!a)return!1;for(var l=c;l--;){var h=d[l];if(!(a?h in t:Q.call(t,h)))return!1}var u=s.get(e);if(u&&s.get(t))return u==t;var p=!0;s.set(e,t),s.set(t,e);for(var m=a;++l<c;){var g=e[h=d[l]],f=t[h];if(i)var v=a?i(f,g,h,t,e,s):i(g,f,h,e,t,s);if(!(void 0===v?g===f||o(g,f,n,i,s):v)){p=!1;break}m||(m="constructor"==h)}if(p&&!m){var _=e.constructor,E=t.constructor;_==E||!("constructor"in e)||!("constructor"in t)||"function"==typeof _&&_ instanceof _&&"function"==typeof E&&E instanceof E||(p=!1)}return s.delete(e),s.delete(t),p}(e,t,n,i,s,c))}(e,t,n,i,Oe,s))}function ke(e,t,n,i,s,a){var d=n&r,c=e.length,l=t.length;if(c!=l&&!(d&&l>c))return!1;var h=a.get(e);if(h&&a.get(t))return h==t;var u=-1,p=!0,m=n&o?new Ae:void 0;for(a.set(e,t),a.set(t,e);++u<c;){var g=e[u],f=t[u];if(i)var v=d?i(f,g,u,t,e,a):i(g,f,u,e,t,a);if(void 0!==v){if(v)continue;p=!1;break}if(m){if(!H(t,(function(e,t){if(r=t,!m.has(r)&&(g===e||s(g,e,n,i,a)))return m.push(t);var r}))){p=!1;break}}else if(g!==f&&!s(g,f,n,i,a)){p=!1;break}}return a.delete(e),a.delete(t),p}function Ne(e){return function(e,t,n){var i=t(e);return Je(e)?i:function(e,t){for(var n=-1,i=t.length,r=e.length;++n<i;)e[r+n]=t[n];return e}(i,n(e))}(e,Xe,Fe)}function Me(e,t){var n,i,r=e.__data__;return("string"==(i=typeof(n=t))||"number"==i||"symbol"==i||"boolean"==i?"__proto__"!==n:null===n)?r["string"==typeof t?"string":"hash"]:r.map}function Le(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return function(e){return!(!ze(e)||function(e){return!!Z&&Z in e}(e))&&(qe(e)?te:I).test(Ue(e))}(n)?n:void 0}Ce.prototype.clear=function(){this.__data__=fe?fe(null):{},this.size=0},Ce.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},Ce.prototype.get=function(e){var t=this.__data__;if(fe){var n=t[e];return n===i?void 0:n}return Q.call(t,e)?t[e]:void 0},Ce.prototype.has=function(e){var t=this.__data__;return fe?void 0!==t[e]:Q.call(t,e)},Ce.prototype.set=function(e,t){var n=this.__data__;return this.size+=this.has(e)?0:1,n[e]=fe&&void 0===t?i:t,this},xe.prototype.clear=function(){this.__data__=[],this.size=0},xe.prototype.delete=function(e){var t=this.__data__,n=Ie(t,e);return!(n<0||(n==t.length-1?t.pop():se.call(t,n,1),--this.size,0))},xe.prototype.get=function(e){var t=this.__data__,n=Ie(t,e);return n<0?void 0:t[n][1]},xe.prototype.has=function(e){return Ie(this.__data__,e)>-1},xe.prototype.set=function(e,t){var n=this.__data__,i=Ie(n,e);return i<0?(++this.size,n.push([e,t])):n[i][1]=t,this},Re.prototype.clear=function(){this.size=0,this.__data__={hash:new Ce,map:new(ue||xe),string:new Ce}},Re.prototype.delete=function(e){var t=Me(this,e).delete(e);return this.size-=t?1:0,t},Re.prototype.get=function(e){return Me(this,e).get(e)},Re.prototype.has=function(e){return Me(this,e).has(e)},Re.prototype.set=function(e,t){var n=Me(this,e),i=n.size;return n.set(e,t),this.size+=n.size==i?0:1,this},Ae.prototype.add=Ae.prototype.push=function(e){return this.__data__.set(e,i),this},Ae.prototype.has=function(e){return this.__data__.has(e)},we.prototype.clear=function(){this.__data__=new xe,this.size=0},we.prototype.delete=function(e){var t=this.__data__,n=t.delete(e);return this.size=t.size,n},we.prototype.get=function(e){return this.__data__.get(e)},we.prototype.has=function(e){return this.__data__.has(e)},we.prototype.set=function(e,t){var n=this.__data__;if(n instanceof xe){var i=n.__data__;if(!ue||i.length<199)return i.push([e,t]),this.size=++n.size,this;n=this.__data__=new Re(i)}return n.set(e,t),this.size=n.size,this};var Fe=de?function(e){return null==e?[]:(e=Object(e),function(t,n){for(var i=-1,r=null==t?0:t.length,o=0,s=[];++i<r;){var a=t[i];d=a,oe.call(e,d)&&(s[o++]=a)}var d;return s}(de(e)))}:function(){return[]},je=Pe;function Ve(e,t){return!!(t=null==t?s:t)&&("number"==typeof e||P.test(e))&&e>-1&&e%1==0&&e<t}function Ue(e){if(null!=e){try{return Y.call(e)}catch(e){}try{return e+""}catch(e){}}return""}function He(e,t){return e===t||e!=e&&t!=t}(he&&je(new he(new ArrayBuffer(1)))!=w||ue&&je(new ue)!=g||pe&&je(pe.resolve())!=E||me&&je(new me)!=b||ge&&je(new ge)!=R)&&(je=function(e){var t=Pe(e),n=t==_?e.constructor:void 0,i=n?Ue(n):"";if(i)switch(i){case ve:return w;case _e:return g;case Ee:return E;case ye:return b;case Se:return R}return t});var $e=De(function(){return arguments}())?De:function(e){return Ke(e)&&Q.call(e,"callee")&&!oe.call(e,"callee")},Je=Array.isArray,Be=ce||function(){return!1};function qe(e){if(!ze(e))return!1;var t=Pe(e);return t==p||t==m||t==c||t==y}function Ge(e){return"number"==typeof e&&e>-1&&e%1==0&&e<=s}function ze(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function Ke(e){return null!=e&&"object"==typeof e}var We=U?function(e){return function(t){return e(t)}}(U):function(e){return Ke(e)&&Ge(e.length)&&!!D[Pe(e)]};function Xe(e){return null!=(t=e)&&Ge(t.length)&&!qe(t)?function(e,t){var n=Je(e),i=!n&&$e(e),r=!n&&!i&&Be(e),o=!n&&!i&&!r&&We(e),s=n||i||r||o,a=s?function(e,t){for(var n=-1,i=Array(e);++n<e;)i[n]=t(n);return i}(e.length,String):[],d=a.length;for(var c in e)!t&&!Q.call(e,c)||s&&("length"==c||r&&("offset"==c||"parent"==c)||o&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||Ve(c,d))||a.push(c);return a}(e):function(e){if(n=(t=e)&&t.constructor,t!==("function"==typeof n&&n.prototype||W))return le(e);var t,n,i=[];for(var r in Object(e))Q.call(e,r)&&"constructor"!=r&&i.push(r);return i}(e);var t}e.exports=function(e,t){return Oe(e,t)}},296:e=>{var t=e.exports={v:[{name:"version",reg:/^(\\d*)$/}],o:[{name:"origin",reg:/^(\\S*) (\\d*) (\\d*) (\\S*) IP(\\d) (\\S*)/,names:["username","sessionId","sessionVersion","netType","ipVer","address"],format:"%s %s %d %s IP%d %s"}],s:[{name:"name"}],i:[{name:"description"}],u:[{name:"uri"}],e:[{name:"email"}],p:[{name:"phone"}],z:[{name:"timezones"}],r:[{name:"repeats"}],t:[{name:"timing",reg:/^(\\d*) (\\d*)/,names:["start","stop"],format:"%d %d"}],c:[{name:"connection",reg:/^IN IP(\\d) (\\S*)/,names:["version","ip"],format:"IN IP%d %s"}],b:[{push:"bandwidth",reg:/^(TIAS|AS|CT|RR|RS):(\\d*)/,names:["type","limit"],format:"%s:%s"}],m:[{reg:/^(\\w*) (\\d*) ([\\w\\/]*)(?: (.*))?/,names:["type","port","protocol","payloads"],format:"%s %d %s %s"}],a:[{push:"rtp",reg:/^rtpmap:(\\d*) ([\\w\\-\\.]*)(?:\\s*\\/(\\d*)(?:\\s*\\/(\\S*))?)?/,names:["payload","codec","rate","encoding"],format:function(e){return e.encoding?"rtpmap:%d %s/%s/%s":e.rate?"rtpmap:%d %s/%s":"rtpmap:%d %s"}},{push:"fmtp",reg:/^fmtp:(\\d*) ([\\S| ]*)/,names:["payload","config"],format:"fmtp:%d %s"},{name:"control",reg:/^control:(.*)/,format:"control:%s"},{name:"rtcp",reg:/^rtcp:(\\d*)(?: (\\S*) IP(\\d) (\\S*))?/,names:["port","netType","ipVer","address"],format:function(e){return null!=e.address?"rtcp:%d %s IP%d %s":"rtcp:%d"}},{push:"rtcpFbTrrInt",reg:/^rtcp-fb:(\\*|\\d*) trr-int (\\d*)/,names:["payload","value"],format:"rtcp-fb:%d trr-int %d"},{push:"rtcpFb",reg:/^rtcp-fb:(\\*|\\d*) ([\\w-_]*)(?: ([\\w-_]*))?/,names:["payload","type","subtype"],format:function(e){return null!=e.subtype?"rtcp-fb:%s %s %s":"rtcp-fb:%s %s"}},{push:"ext",reg:/^extmap:(\\d+)(?:\\/(\\w+))? (\\S*)(?: (\\S*))?/,names:["value","direction","uri","config"],format:function(e){return"extmap:%d"+(e.direction?"/%s":"%v")+" %s"+(e.config?" %s":"")}},{push:"crypto",reg:/^crypto:(\\d*) ([\\w_]*) (\\S*)(?: (\\S*))?/,names:["id","suite","config","sessionConfig"],format:function(e){return null!=e.sessionConfig?"crypto:%d %s %s %s":"crypto:%d %s %s"}},{name:"setup",reg:/^setup:(\\w*)/,format:"setup:%s"},{name:"mid",reg:/^mid:([^\\s]*)/,format:"mid:%s"},{name:"msid",reg:/^msid:(.*)/,format:"msid:%s"},{name:"ptime",reg:/^ptime:(\\d*)/,format:"ptime:%d"},{name:"maxptime",reg:/^maxptime:(\\d*)/,format:"maxptime:%d"},{name:"direction",reg:/^(sendrecv|recvonly|sendonly|inactive)/},{name:"icelite",reg:/^(ice-lite)/},{name:"iceUfrag",reg:/^ice-ufrag:(\\S*)/,format:"ice-ufrag:%s"},{name:"icePwd",reg:/^ice-pwd:(\\S*)/,format:"ice-pwd:%s"},{name:"fingerprint",reg:/^fingerprint:(\\S*) (\\S*)/,names:["type","hash"],format:"fingerprint:%s %s"},{push:"candidates",reg:/^candidate:(\\S*) (\\d*) (\\S*) (\\d*) (\\S*) (\\d*) typ (\\S*)(?: raddr (\\S*) rport (\\d*))?(?: tcptype (\\S*))?(?: generation (\\d*))?(?: network-id (\\d*))?(?: network-cost (\\d*))?/,names:["foundation","component","transport","priority","ip","port","type","raddr","rport","tcptype","generation","network-id","network-cost"],format:function(e){var t="candidate:%s %d %s %d %s %d typ %s";return t+=null!=e.raddr?" raddr %s rport %d":"%v%v",t+=null!=e.tcptype?" tcptype %s":"%v",null!=e.generation&&(t+=" generation %d"),(t+=null!=e["network-id"]?" network-id %d":"%v")+(null!=e["network-cost"]?" network-cost %d":"%v")}},{name:"endOfCandidates",reg:/^(end-of-candidates)/},{name:"remoteCandidates",reg:/^remote-candidates:(.*)/,format:"remote-candidates:%s"},{name:"iceOptions",reg:/^ice-options:(\\S*)/,format:"ice-options:%s"},{push:"ssrcs",reg:/^ssrc:(\\d*) ([\\w_]*)(?::(.*))?/,names:["id","attribute","value"],format:function(e){var t="ssrc:%d";return null!=e.attribute&&(t+=" %s",null!=e.value&&(t+=":%s")),t}},{push:"ssrcGroups",reg:/^ssrc-group:([\\x21\\x23\\x24\\x25\\x26\\x27\\x2A\\x2B\\x2D\\x2E\\w]*) (.*)/,names:["semantics","ssrcs"],format:"ssrc-group:%s %s"},{name:"msidSemantic",reg:/^msid-semantic:\\s?(\\w*) (\\S*)/,names:["semantic","token"],format:"msid-semantic: %s %s"},{push:"groups",reg:/^group:(\\w*) (.*)/,names:["type","mids"],format:"group:%s %s"},{name:"rtcpMux",reg:/^(rtcp-mux)/},{name:"rtcpRsize",reg:/^(rtcp-rsize)/},{name:"sctpmap",reg:/^sctpmap:([\\w_\\/]*) (\\S*)(?: (\\S*))?/,names:["sctpmapNumber","app","maxMessageSize"],format:function(e){return null!=e.maxMessageSize?"sctpmap:%s %s %s":"sctpmap:%s %s"}},{name:"xGoogleFlag",reg:/^x-google-flag:([^\\s]*)/,format:"x-google-flag:%s"},{push:"rids",reg:/^rid:([\\d\\w]+) (\\w+)(?: ([\\S| ]*))?/,names:["id","direction","params"],format:function(e){return e.params?"rid:%s %s %s":"rid:%s %s"}},{push:"imageattrs",reg:new RegExp("^imageattr:(\\\\d+|\\\\*)[\\\\s\\\\t]+(send|recv)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*)(?:[\\\\s\\\\t]+(recv|send)[\\\\s\\\\t]+(\\\\*|\\\\[\\\\S+\\\\](?:[\\\\s\\\\t]+\\\\[\\\\S+\\\\])*))?"),names:["pt","dir1","attrs1","dir2","attrs2"],format:function(e){return"imageattr:%s %s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast",reg:new RegExp("^simulcast:(send|recv) ([a-zA-Z0-9\\\\-_~;,]+)(?:\\\\s?(send|recv) ([a-zA-Z0-9\\\\-_~;,]+))?$"),names:["dir1","list1","dir2","list2"],format:function(e){return"simulcast:%s %s"+(e.dir2?" %s %s":"")}},{name:"simulcast_03",reg:/^simulcast:[\\s\\t]+([\\S+\\s\\t]+)$/,names:["value"],format:"simulcast: %s"},{name:"framerate",reg:/^framerate:(\\d+(?:$|\\.\\d+))/,format:"framerate:%s"},{push:"invalid",names:["value"]}]};Object.keys(t).forEach((function(e){t[e].forEach((function(e){e.reg||(e.reg=/(.*)/),e.format||(e.format="%s")}))}))},310:(e,t,n)=>{var i=n(415),r=n(159);t.write=r,t.parse=i.parse,t.parseFmtpConfig=i.parseFmtpConfig,t.parseParams=i.parseParams,t.parsePayloads=i.parsePayloads,t.parseRemoteCandidates=i.parseRemoteCandidates,t.parseImageAttributes=i.parseImageAttributes,t.parseSimulcastStreamList=i.parseSimulcastStreamList},415:(e,t,n)=>{var i=function(e){return String(Number(e))===e?Number(e):e},r=function(e,t,n){var r=e.name&&e.names;e.push&&!t[e.push]?t[e.push]=[]:r&&!t[e.name]&&(t[e.name]={});var o=e.push?{}:r?t[e.name]:t;!function(e,t,n,r){if(r&&!n)t[r]=i(e[1]);else for(var o=0;o<n.length;o+=1)null!=e[o+1]&&(t[n[o]]=i(e[o+1]))}(n.match(e.reg),o,e.names,e.name),e.push&&t[e.push].push(o)},o=n(296),s=RegExp.prototype.test.bind(/^([a-z])=(.*)/);t.parse=function(e){var t={},n=[],i=t;return e.split(/(\\r\\n|\\r|\\n)/).filter(s).forEach((function(e){var t=e[0],s=e.slice(2);"m"===t&&(n.push({rtp:[],fmtp:[]}),i=n[n.length-1]);for(var a=0;a<(o[t]||[]).length;a+=1){var d=o[t][a];if(d.reg.test(s))return r(d,i,s)}})),t.media=n,t};var a=function(e,t){var n=t.split(/=(.+)/,2);return 2===n.length&&(e[n[0]]=i(n[1])),e};t.parseParams=function(e){return e.split(/\\;\\s?/).reduce(a,{})},t.parseFmtpConfig=t.parseParams,t.parsePayloads=function(e){return e.split(" ").map(Number)},t.parseRemoteCandidates=function(e){for(var t=[],n=e.split(" ").map(i),r=0;r<n.length;r+=3)t.push({component:n[r],ip:n[r+1],port:n[r+2]});return t},t.parseImageAttributes=function(e){return e.split(" ").map((function(e){return e.substring(1,e.length-1).split(",").reduce(a,{})}))},t.parseSimulcastStreamList=function(e){return e.split(";").map((function(e){return e.split(",").map((function(e){var t,n=!1;return"~"!==e[0]?t=i(e):(t=i(e.substring(1,e.length)),n=!0),{scid:t,paused:n}}))}))}},159:(e,t,n)=>{var i=n(296),r=/%[sdv%]/g,o=function(e){var t=1,n=arguments,i=n.length;return e.replace(r,(function(e){if(t>=i)return e;var r=n[t];switch(t+=1,e){case"%%":return"%";case"%s":return String(r);case"%d":return Number(r);case"%v":return""}}))},s=function(e,t,n){var i=[e+"="+(t.format instanceof Function?t.format(t.push?n:n[t.name]):t.format)];if(t.names)for(var r=0;r<t.names.length;r+=1){var s=t.names[r];t.name?i.push(n[t.name][s]):i.push(n[t.names[r]])}else i.push(n[t.name]);return o.apply(null,i)},a=["v","o","s","i","u","e","p","c","b","t","r","z","a"],d=["i","c","b","a"];e.exports=function(e,t){t=t||{},null==e.version&&(e.version=0),null==e.name&&(e.name=" "),e.media.forEach((function(e){null==e.payloads&&(e.payloads="")}));var n=t.outerOrder||a,r=t.innerOrder||d,o=[];return n.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))})),e.media.forEach((function(e){o.push(s("m",i.m[0],e)),r.forEach((function(t){i[t].forEach((function(n){n.name in e&&null!=e[n.name]?o.push(s(t,n,e)):n.push in e&&null!=e[n.push]&&e[n.push].forEach((function(e){o.push(s(t,n,e))}))}))}))})),o.join("\\r\\n")+"\\r\\n"}},483:e=>{"use strict";const t={generateIdentifier:function(){return Math.random().toString(36).substr(2,10)}};t.localCName=t.generateIdentifier(),t.splitLines=function(e){return e.trim().split("\\n").map((e=>e.trim()))},t.splitSections=function(e){return e.split("\\nm=").map(((e,t)=>(t>0?"m="+e:e).trim()+"\\r\\n"))},t.getDescription=function(e){const n=t.splitSections(e);return n&&n[0]},t.getMediaSections=function(e){const n=t.splitSections(e);return n.shift(),n},t.matchPrefix=function(e,n){return t.splitLines(e).filter((e=>0===e.indexOf(n)))},t.parseCandidate=function(e){let t;t=0===e.indexOf("a=candidate:")?e.substring(12).split(" "):e.substring(10).split(" ");const n={foundation:t[0],component:{1:"rtp",2:"rtcp"}[t[1]]||t[1],protocol:t[2].toLowerCase(),priority:parseInt(t[3],10),ip:t[4],address:t[4],port:parseInt(t[5],10),type:t[7]};for(let e=8;e<t.length;e+=2)switch(t[e]){case"raddr":n.relatedAddress=t[e+1];break;case"rport":n.relatedPort=parseInt(t[e+1],10);break;case"tcptype":n.tcpType=t[e+1];break;case"ufrag":n.ufrag=t[e+1],n.usernameFragment=t[e+1];break;default:void 0===n[t[e]]&&(n[t[e]]=t[e+1])}return n},t.writeCandidate=function(e){const t=[];t.push(e.foundation);const n=e.component;"rtp"===n?t.push(1):"rtcp"===n?t.push(2):t.push(n),t.push(e.protocol.toUpperCase()),t.push(e.priority),t.push(e.address||e.ip),t.push(e.port);const i=e.type;return t.push("typ"),t.push(i),"host"!==i&&e.relatedAddress&&e.relatedPort&&(t.push("raddr"),t.push(e.relatedAddress),t.push("rport"),t.push(e.relatedPort)),e.tcpType&&"tcp"===e.protocol.toLowerCase()&&(t.push("tcptype"),t.push(e.tcpType)),(e.usernameFragment||e.ufrag)&&(t.push("ufrag"),t.push(e.usernameFragment||e.ufrag)),"candidate:"+t.join(" ")},t.parseIceOptions=function(e){return e.substr(14).split(" ")},t.parseRtpMap=function(e){let t=e.substr(9).split(" ");const n={payloadType:parseInt(t.shift(),10)};return t=t[0].split("/"),n.name=t[0],n.clockRate=parseInt(t[1],10),n.channels=3===t.length?parseInt(t[2],10):1,n.numChannels=n.channels,n},t.writeRtpMap=function(e){let t=e.payloadType;void 0!==e.preferredPayloadType&&(t=e.preferredPayloadType);const n=e.channels||e.numChannels||1;return"a=rtpmap:"+t+" "+e.name+"/"+e.clockRate+(1!==n?"/"+n:"")+"\\r\\n"},t.parseExtmap=function(e){const t=e.substr(9).split(" ");return{id:parseInt(t[0],10),direction:t[0].indexOf("/")>0?t[0].split("/")[1]:"sendrecv",uri:t[1]}},t.writeExtmap=function(e){return"a=extmap:"+(e.id||e.preferredId)+(e.direction&&"sendrecv"!==e.direction?"/"+e.direction:"")+" "+e.uri+"\\r\\n"},t.parseFmtp=function(e){const t={};let n;const i=e.substr(e.indexOf(" ")+1).split(";");for(let e=0;e<i.length;e++)n=i[e].trim().split("="),t[n[0].trim()]=n[1];return t},t.writeFmtp=function(e){let t="",n=e.payloadType;if(void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.parameters&&Object.keys(e.parameters).length){const i=[];Object.keys(e.parameters).forEach((t=>{void 0!==e.parameters[t]?i.push(t+"="+e.parameters[t]):i.push(t)})),t+="a=fmtp:"+n+" "+i.join(";")+"\\r\\n"}return t},t.parseRtcpFb=function(e){const t=e.substr(e.indexOf(" ")+1).split(" ");return{type:t.shift(),parameter:t.join(" ")}},t.writeRtcpFb=function(e){let t="",n=e.payloadType;return void 0!==e.preferredPayloadType&&(n=e.preferredPayloadType),e.rtcpFeedback&&e.rtcpFeedback.length&&e.rtcpFeedback.forEach((e=>{t+="a=rtcp-fb:"+n+" "+e.type+(e.parameter&&e.parameter.length?" "+e.parameter:"")+"\\r\\n"})),t},t.parseSsrcMedia=function(e){const t=e.indexOf(" "),n={ssrc:parseInt(e.substr(7,t-7),10)},i=e.indexOf(":",t);return i>-1?(n.attribute=e.substr(t+1,i-t-1),n.value=e.substr(i+1)):n.attribute=e.substr(t+1),n},t.parseSsrcGroup=function(e){const t=e.substr(13).split(" ");return{semantics:t.shift(),ssrcs:t.map((e=>parseInt(e,10)))}},t.getMid=function(e){const n=t.matchPrefix(e,"a=mid:")[0];if(n)return n.substr(6)},t.parseFingerprint=function(e){const t=e.substr(14).split(" ");return{algorithm:t[0].toLowerCase(),value:t[1].toUpperCase()}},t.getDtlsParameters=function(e,n){return{role:"auto",fingerprints:t.matchPrefix(e+n,"a=fingerprint:").map(t.parseFingerprint)}},t.writeDtlsParameters=function(e,t){let n="a=setup:"+t+"\\r\\n";return e.fingerprints.forEach((e=>{n+="a=fingerprint:"+e.algorithm+" "+e.value+"\\r\\n"})),n},t.parseCryptoLine=function(e){const t=e.substr(9).split(" ");return{tag:parseInt(t[0],10),cryptoSuite:t[1],keyParams:t[2],sessionParams:t.slice(3)}},t.writeCryptoLine=function(e){return"a=crypto:"+e.tag+" "+e.cryptoSuite+" "+("object"==typeof e.keyParams?t.writeCryptoKeyParams(e.keyParams):e.keyParams)+(e.sessionParams?" "+e.sessionParams.join(" "):"")+"\\r\\n"},t.parseCryptoKeyParams=function(e){if(0!==e.indexOf("inline:"))return null;const t=e.substr(7).split("|");return{keyMethod:"inline",keySalt:t[0],lifeTime:t[1],mkiValue:t[2]?t[2].split(":")[0]:void 0,mkiLength:t[2]?t[2].split(":")[1]:void 0}},t.writeCryptoKeyParams=function(e){return e.keyMethod+":"+e.keySalt+(e.lifeTime?"|"+e.lifeTime:"")+(e.mkiValue&&e.mkiLength?"|"+e.mkiValue+":"+e.mkiLength:"")},t.getCryptoParameters=function(e,n){return t.matchPrefix(e+n,"a=crypto:").map(t.parseCryptoLine)},t.getIceParameters=function(e,n){const i=t.matchPrefix(e+n,"a=ice-ufrag:")[0],r=t.matchPrefix(e+n,"a=ice-pwd:")[0];return i&&r?{usernameFragment:i.substr(12),password:r.substr(10)}:null},t.writeIceParameters=function(e){let t="a=ice-ufrag:"+e.usernameFragment+"\\r\\na=ice-pwd:"+e.password+"\\r\\n";return e.iceLite&&(t+="a=ice-lite\\r\\n"),t},t.parseRtpParameters=function(e){const n={codecs:[],headerExtensions:[],fecMechanisms:[],rtcp:[]},i=t.splitLines(e)[0].split(" ");for(let r=3;r<i.length;r++){const o=i[r],s=t.matchPrefix(e,"a=rtpmap:"+o+" ")[0];if(s){const i=t.parseRtpMap(s),r=t.matchPrefix(e,"a=fmtp:"+o+" ");switch(i.parameters=r.length?t.parseFmtp(r[0]):{},i.rtcpFeedback=t.matchPrefix(e,"a=rtcp-fb:"+o+" ").map(t.parseRtcpFb),n.codecs.push(i),i.name.toUpperCase()){case"RED":case"ULPFEC":n.fecMechanisms.push(i.name.toUpperCase())}}}return t.matchPrefix(e,"a=extmap:").forEach((e=>{n.headerExtensions.push(t.parseExtmap(e))})),n},t.writeRtpDescription=function(e,n){let i="";i+="m="+e+" ",i+=n.codecs.length>0?"9":"0",i+=" UDP/TLS/RTP/SAVPF ",i+=n.codecs.map((e=>void 0!==e.preferredPayloadType?e.preferredPayloadType:e.payloadType)).join(" ")+"\\r\\n",i+="c=IN IP4 0.0.0.0\\r\\n",i+="a=rtcp:9 IN IP4 0.0.0.0\\r\\n",n.codecs.forEach((e=>{i+=t.writeRtpMap(e),i+=t.writeFmtp(e),i+=t.writeRtcpFb(e)}));let r=0;return n.codecs.forEach((e=>{e.maxptime>r&&(r=e.maxptime)})),r>0&&(i+="a=maxptime:"+r+"\\r\\n"),n.headerExtensions&&n.headerExtensions.forEach((e=>{i+=t.writeExtmap(e)})),i},t.parseRtpEncodingParameters=function(e){const n=[],i=t.parseRtpParameters(e),r=-1!==i.fecMechanisms.indexOf("RED"),o=-1!==i.fecMechanisms.indexOf("ULPFEC"),s=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"cname"===e.attribute)),a=s.length>0&&s[0].ssrc;let d;const c=t.matchPrefix(e,"a=ssrc-group:FID").map((e=>e.substr(17).split(" ").map((e=>parseInt(e,10)))));c.length>0&&c[0].length>1&&c[0][0]===a&&(d=c[0][1]),i.codecs.forEach((e=>{if("RTX"===e.name.toUpperCase()&&e.parameters.apt){let t={ssrc:a,codecPayloadType:parseInt(e.parameters.apt,10)};a&&d&&(t.rtx={ssrc:d}),n.push(t),r&&(t=JSON.parse(JSON.stringify(t)),t.fec={ssrc:a,mechanism:o?"red+ulpfec":"red"},n.push(t))}})),0===n.length&&a&&n.push({ssrc:a});let l=t.matchPrefix(e,"b=");return l.length&&(l=0===l[0].indexOf("b=TIAS:")?parseInt(l[0].substr(7),10):0===l[0].indexOf("b=AS:")?1e3*parseInt(l[0].substr(5),10)*.95-16e3:void 0,n.forEach((e=>{e.maxBitrate=l}))),n},t.parseRtcpParameters=function(e){const n={},i=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"cname"===e.attribute))[0];i&&(n.cname=i.value,n.ssrc=i.ssrc);const r=t.matchPrefix(e,"a=rtcp-rsize");n.reducedSize=r.length>0,n.compound=0===r.length;const o=t.matchPrefix(e,"a=rtcp-mux");return n.mux=o.length>0,n},t.writeRtcpParameters=function(e){let t="";return e.reducedSize&&(t+="a=rtcp-rsize\\r\\n"),e.mux&&(t+="a=rtcp-mux\\r\\n"),void 0!==e.ssrc&&e.cname&&(t+="a=ssrc:"+e.ssrc+" cname:"+e.cname+"\\r\\n"),t},t.parseMsid=function(e){let n;const i=t.matchPrefix(e,"a=msid:");if(1===i.length)return n=i[0].substr(7).split(" "),{stream:n[0],track:n[1]};const r=t.matchPrefix(e,"a=ssrc:").map((e=>t.parseSsrcMedia(e))).filter((e=>"msid"===e.attribute));return r.length>0?(n=r[0].value.split(" "),{stream:n[0],track:n[1]}):void 0},t.parseSctpDescription=function(e){const n=t.parseMLine(e),i=t.matchPrefix(e,"a=max-message-size:");let r;i.length>0&&(r=parseInt(i[0].substr(19),10)),isNaN(r)&&(r=65536);const o=t.matchPrefix(e,"a=sctp-port:");if(o.length>0)return{port:parseInt(o[0].substr(12),10),protocol:n.fmt,maxMessageSize:r};const s=t.matchPrefix(e,"a=sctpmap:");if(s.length>0){const e=s[0].substr(10).split(" ");return{port:parseInt(e[0],10),protocol:e[1],maxMessageSize:r}}},t.writeSctpDescription=function(e,t){let n=[];return n="DTLS/SCTP"!==e.protocol?["m="+e.kind+" 9 "+e.protocol+" "+t.protocol+"\\r\\n","c=IN IP4 0.0.0.0\\r\\n","a=sctp-port:"+t.port+"\\r\\n"]:["m="+e.kind+" 9 "+e.protocol+" "+t.port+"\\r\\n","c=IN IP4 0.0.0.0\\r\\n","a=sctpmap:"+t.port+" "+t.protocol+" 65535\\r\\n"],void 0!==t.maxMessageSize&&n.push("a=max-message-size:"+t.maxMessageSize+"\\r\\n"),n.join("")},t.generateSessionId=function(){return Math.random().toString().substr(2,21)},t.writeSessionBoilerplate=function(e,n,i){let r;const o=void 0!==n?n:2;return r=e||t.generateSessionId(),"v=0\\r\\no="+(i||"thisisadapterortc")+" "+r+" "+o+" IN IP4 127.0.0.1\\r\\ns=-\\r\\nt=0 0\\r\\n"},t.getDirection=function(e,n){const i=t.splitLines(e);for(let e=0;e<i.length;e++)switch(i[e]){case"a=sendrecv":case"a=sendonly":case"a=recvonly":case"a=inactive":return i[e].substr(2)}return n?t.getDirection(n):"sendrecv"},t.getKind=function(e){return t.splitLines(e)[0].split(" ")[0].substr(2)},t.isRejected=function(e){return"0"===e.split(" ",2)[1]},t.parseMLine=function(e){const n=t.splitLines(e)[0].substr(2).split(" ");return{kind:n[0],port:parseInt(n[1],10),protocol:n[2],fmt:n.slice(3).join(" ")}},t.parseOLine=function(e){const n=t.matchPrefix(e,"o=")[0].substr(2).split(" ");return{username:n[0],sessionId:n[1],sessionVersion:parseInt(n[2],10),netType:n[3],addressType:n[4],address:n[5]}},t.isValidSDP=function(e){if("string"!=typeof e||0===e.length)return!1;const n=t.splitLines(e);for(let e=0;e<n.length;e++)if(n[e].length<2||"="!==n[e].charAt(1))return!1;return!0},e.exports=t},33:function(e,t,n){!function(e){"use strict";var t=void 0!==n.g?n.g:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};const i=function(){let e=t.WebSocket;if(void 0===e)try{e=n(Object(function(){var e=new Error("Cannot find module \'ws\'");throw e.code="MODULE_NOT_FOUND",e}()))}catch(e){throw new Error(\'You must install the "ws" package to use Strophe in nodejs.\')}return e}();const r=function(){let e=t.DOMParser;if(void 0===e)try{e=Object(function(){var e=new Error("Cannot find module \'@xmldom/xmldom\'");throw e.code="MODULE_NOT_FOUND",e}())}catch(e){throw new Error(\'You must install the "@xmldom/xmldom" package to use Strophe in nodejs.\')}return e}();function o(){if("undefined"==typeof document)try{return(new(Object(function(){var e=new Error("Cannot find module \'@xmldom/xmldom\'");throw e.code="MODULE_NOT_FOUND",e}()))).createDocument("jabber:client","strophe",null)}catch(e){throw new Error(\'You must install the "@xmldom/xmldom" package to use Strophe in nodejs.\')}if(void 0===document.implementation.createDocument||document.implementation.createDocument&&document.documentMode&&document.documentMode<10){const e=function(){const e=["Msxml2.DOMDocument.6.0","Msxml2.DOMDocument.5.0","Msxml2.DOMDocument.4.0","MSXML2.DOMDocument.3.0","MSXML2.DOMDocument","MSXML.DOMDocument","Microsoft.XMLDOM"];for(let t=0;t<e.length;t++)try{return new ActiveXObject(e[t])}catch(e){}}();return e.appendChild(e.createElement("strophe")),e}return document.implementation.createDocument("jabber:client","strophe",null)}const s=function(e,t){const n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n},a=function(e){if("string"!=typeof e)throw new Error("str2binl was passed a non-string");const t=[];for(let n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<n%32;return t},d=function(e,t,n,i,r,o){return s((a=s(s(t,e),s(i,o)))<<(d=r)|a>>>32-d,n);var a,d},c=function(e,t,n,i,r,o,s){return d(t&n|~t&i,e,t,r,o,s)},l=function(e,t,n,i,r,o,s){return d(t&i|n&~i,e,t,r,o,s)},h=function(e,t,n,i,r,o,s){return d(t^n^i,e,t,r,o,s)},u=function(e,t,n,i,r,o,s){return d(n^(t|~i),e,t,r,o,s)},p=function(e,t){e[t>>5]|=128<<t%32,e[14+(t+64>>>9<<4)]=t;let n,i,r,o,a=1732584193,d=-271733879,p=-1732584194,m=271733878;for(let t=0;t<e.length;t+=16)n=a,i=d,r=p,o=m,a=c(a,d,p,m,e[t+0],7,-680876936),m=c(m,a,d,p,e[t+1],12,-389564586),p=c(p,m,a,d,e[t+2],17,606105819),d=c(d,p,m,a,e[t+3],22,-1044525330),a=c(a,d,p,m,e[t+4],7,-176418897),m=c(m,a,d,p,e[t+5],12,1200080426),p=c(p,m,a,d,e[t+6],17,-1473231341),d=c(d,p,m,a,e[t+7],22,-45705983),a=c(a,d,p,m,e[t+8],7,1770035416),m=c(m,a,d,p,e[t+9],12,-1958414417),p=c(p,m,a,d,e[t+10],17,-42063),d=c(d,p,m,a,e[t+11],22,-1990404162),a=c(a,d,p,m,e[t+12],7,1804603682),m=c(m,a,d,p,e[t+13],12,-40341101),p=c(p,m,a,d,e[t+14],17,-1502002290),d=c(d,p,m,a,e[t+15],22,1236535329),a=l(a,d,p,m,e[t+1],5,-165796510),m=l(m,a,d,p,e[t+6],9,-1069501632),p=l(p,m,a,d,e[t+11],14,643717713),d=l(d,p,m,a,e[t+0],20,-373897302),a=l(a,d,p,m,e[t+5],5,-701558691),m=l(m,a,d,p,e[t+10],9,38016083),p=l(p,m,a,d,e[t+15],14,-660478335),d=l(d,p,m,a,e[t+4],20,-405537848),a=l(a,d,p,m,e[t+9],5,568446438),m=l(m,a,d,p,e[t+14],9,-1019803690),p=l(p,m,a,d,e[t+3],14,-187363961),d=l(d,p,m,a,e[t+8],20,1163531501),a=l(a,d,p,m,e[t+13],5,-1444681467),m=l(m,a,d,p,e[t+2],9,-51403784),p=l(p,m,a,d,e[t+7],14,1735328473),d=l(d,p,m,a,e[t+12],20,-1926607734),a=h(a,d,p,m,e[t+5],4,-378558),m=h(m,a,d,p,e[t+8],11,-2022574463),p=h(p,m,a,d,e[t+11],16,1839030562),d=h(d,p,m,a,e[t+14],23,-35309556),a=h(a,d,p,m,e[t+1],4,-1530992060),m=h(m,a,d,p,e[t+4],11,1272893353),p=h(p,m,a,d,e[t+7],16,-155497632),d=h(d,p,m,a,e[t+10],23,-1094730640),a=h(a,d,p,m,e[t+13],4,681279174),m=h(m,a,d,p,e[t+0],11,-358537222),p=h(p,m,a,d,e[t+3],16,-722521979),d=h(d,p,m,a,e[t+6],23,76029189),a=h(a,d,p,m,e[t+9],4,-640364487),m=h(m,a,d,p,e[t+12],11,-421815835),p=h(p,m,a,d,e[t+15],16,530742520),d=h(d,p,m,a,e[t+2],23,-995338651),a=u(a,d,p,m,e[t+0],6,-198630844),m=u(m,a,d,p,e[t+7],10,1126891415),p=u(p,m,a,d,e[t+14],15,-1416354905),d=u(d,p,m,a,e[t+5],21,-57434055),a=u(a,d,p,m,e[t+12],6,1700485571),m=u(m,a,d,p,e[t+3],10,-1894986606),p=u(p,m,a,d,e[t+10],15,-1051523),d=u(d,p,m,a,e[t+1],21,-2054922799),a=u(a,d,p,m,e[t+8],6,1873313359),m=u(m,a,d,p,e[t+15],10,-30611744),p=u(p,m,a,d,e[t+6],15,-1560198380),d=u(d,p,m,a,e[t+13],21,1309151649),a=u(a,d,p,m,e[t+4],6,-145523070),m=u(m,a,d,p,e[t+11],10,-1120210379),p=u(p,m,a,d,e[t+2],15,718787259),d=u(d,p,m,a,e[t+9],21,-343485551),a=s(a,n),d=s(d,i),p=s(p,r),m=s(m,o);return[a,d,p,m]},m={hexdigest:function(e){return function(e){const t="0123456789abcdef";let n="";for(let i=0;i<4*e.length;i++)n+=t.charAt(e[i>>2]>>i%4*8+4&15)+t.charAt(e[i>>2]>>i%4*8&15);return n}(p(a(e),8*e.length))},hash:function(e){return function(e){let t="";for(let n=0;n<32*e.length;n+=8)t+=String.fromCharCode(e[n>>5]>>>n%32&255);return t}(p(a(e),8*e.length))}};class g{constructor(e,t,n){this.mechname=e,this.isClientFirst=t,this.priority=n}test(){return!0}onStart(e){this._connection=e}onChallenge(e,t){throw new Error("You should implement challenge handling!")}clientChallenge(e){if(!this.isClientFirst)throw new Error("clientChallenge should not be called if isClientFirst is false!");return this.onChallenge(e)}onFailure(){this._connection=null}onSuccess(){this._connection=null}}const f=function(e){var t,n,i="",r=e.length;for(t=0;t<r;t++)(n=e.charCodeAt(t))>=0&&n<=127?i+=e.charAt(t):n>2047?(i+=String.fromCharCode(224|n>>12&15),i+=String.fromCharCode(128|n>>6&63),i+=String.fromCharCode(128|n>>0&63)):(i+=String.fromCharCode(192|n>>6&31),i+=String.fromCharCode(128|n>>0&63));return i},v=function(e){e=e||{};for(const t in e)if(Object.prototype.hasOwnProperty.call(e,t)){let n="",i="",r="";const o=e[t],s="object"==typeof o,a=escape(unescape(s?o.value:o));s&&(n=o.expires?";expires="+o.expires:"",i=o.domain?";domain="+o.domain:"",r=o.path?";path="+o.path:""),document.cookie=t+"="+a+n+i+r}};function _(e,t){e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;var n,i,r,o,s,a,d,c,l=new Array(80),h=1732584193,u=-271733879,p=-1732584194,m=271733878,g=-1009589776;for(n=0;n<e.length;n+=16){for(o=h,s=u,a=p,d=m,c=g,i=0;i<80;i++)l[i]=i<16?e[n+i]:T(l[i-3]^l[i-8]^l[i-14]^l[i-16],1),r=b(b(T(h,5),E(i,u,p,m)),b(b(g,l[i]),y(i))),g=m,m=p,p=T(u,30),u=h,h=r;h=b(h,o),u=b(u,s),p=b(p,a),m=b(m,d),g=b(g,c)}return[h,u,p,m,g]}function E(e,t,n,i){return e<20?t&n|~t&i:e<40?t^n^i:e<60?t&n|t&i|n&i:t^n^i}function y(e){return e<20?1518500249:e<40?1859775393:e<60?-1894007588:-899497514}function S(e,t){var n=C(e);n.length>16&&(n=_(n,8*e.length));for(var i=new Array(16),r=new Array(16),o=0;o<16;o++)i[o]=909522486^n[o],r[o]=1549556828^n[o];var s=_(i.concat(C(t)),512+8*t.length);return _(r.concat(s),672)}function b(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function T(e,t){return e<<t|e>>>32-t}function C(e){for(var t=[],n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<24-n%32;return t}function x(e){for(var t,n,i="",r=0;r<4*e.length;r+=3)for(t=(e[r>>2]>>8*(3-r%4)&255)<<16|(e[r+1>>2]>>8*(3-(r+1)%4)&255)<<8|e[r+2>>2]>>8*(3-(r+2)%4)&255,n=0;n<4;n++)8*r+6*n>32*e.length?i+="=":i+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(t>>6*(3-n)&63);return i}function R(e){for(var t="",n=0;n<32*e.length;n+=8)t+=String.fromCharCode(e[n>>5]>>>24-n%32&255);return t}const A={b64_hmac_sha1:function(e,t){return x(S(e,t))},b64_sha1:function(e){return x(_(C(e),8*e.length))},binb2str:R,core_hmac_sha1:S,str_hmac_sha1:function(e,t){return R(S(e,t))},str_sha1:function(e){return R(_(C(e),8*e.length))}};const w="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function I(e){const t=w.indexOf(e);return t<0?void 0:t}const P="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";function D(e){if(e>=0&&e<64)return P[e]}var O={atob:function(e){if(0===arguments.length)throw new TypeError("1 argument required, but only 0 present.");if((e=(e=`${e}`).replace(/[ \\t\\n\\f\\r]/g,"")).length%4==0&&(e=e.replace(/==?$/,"")),e.length%4==1||/[^+/0-9A-Za-z]/.test(e))return null;let t="",n=0,i=0;for(let r=0;r<e.length;r++)n<<=6,n|=I(e[r]),i+=6,24===i&&(t+=String.fromCharCode((16711680&n)>>16),t+=String.fromCharCode((65280&n)>>8),t+=String.fromCharCode(255&n),n=i=0);return 12===i?(n>>=4,t+=String.fromCharCode(n)):18===i&&(n>>=2,t+=String.fromCharCode((65280&n)>>8),t+=String.fromCharCode(255&n)),t},btoa:function(e){if(0===arguments.length)throw new TypeError("1 argument required, but only 0 present.");let t;for(e=`${e}`,t=0;t<e.length;t++)if(e.charCodeAt(t)>255)return null;let n="";for(t=0;t<e.length;t+=3){const i=[void 0,void 0,void 0,void 0];i[0]=e.charCodeAt(t)>>2,i[1]=(3&e.charCodeAt(t))<<4,e.length>t+1&&(i[1]|=e.charCodeAt(t+1)>>4,i[2]=(15&e.charCodeAt(t+1))<<2),e.length>t+2&&(i[2]|=e.charCodeAt(t+2)>>6,i[3]=63&e.charCodeAt(t+2));for(let e=0;e<i.length;e++)void 0===i[e]?n+="=":n+=D(i[e])}return n}};function k(e,t){return new F.Builder(e,t)}function N(e){return new F.Builder("message",e)}function M(e){return new F.Builder("iq",e)}function L(e){return new F.Builder("presence",e)}const F={VERSION:"1.5.0",NS:{HTTPBIND:"http://jabber.org/protocol/httpbind",BOSH:"urn:xmpp:xbosh",CLIENT:"jabber:client",AUTH:"jabber:iq:auth",ROSTER:"jabber:iq:roster",PROFILE:"jabber:iq:profile",DISCO_INFO:"http://jabber.org/protocol/disco#info",DISCO_ITEMS:"http://jabber.org/protocol/disco#items",MUC:"http://jabber.org/protocol/muc",SASL:"urn:ietf:params:xml:ns:xmpp-sasl",STREAM:"http://etherx.jabber.org/streams",FRAMING:"urn:ietf:params:xml:ns:xmpp-framing",BIND:"urn:ietf:params:xml:ns:xmpp-bind",SESSION:"urn:ietf:params:xml:ns:xmpp-session",VERSION:"jabber:iq:version",STANZAS:"urn:ietf:params:xml:ns:xmpp-stanzas",XHTML_IM:"http://jabber.org/protocol/xhtml-im",XHTML:"http://www.w3.org/1999/xhtml"},XHTML:{tags:["a","blockquote","br","cite","em","img","li","ol","p","span","strong","ul","body"],attributes:{a:["href"],blockquote:["style"],br:[],cite:["style"],em:[],img:["src","alt","style","height","width"],li:["style"],ol:["style"],p:["style"],span:["style"],strong:[],ul:["style"],body:[]},css:["background-color","color","font-family","font-size","font-style","font-weight","margin-left","margin-right","text-align","text-decoration"],validTag(e){for(let t=0;t<F.XHTML.tags.length;t++)if(e===F.XHTML.tags[t])return!0;return!1},validAttribute(e,t){if(void 0!==F.XHTML.attributes[e]&&F.XHTML.attributes[e].length>0)for(let n=0;n<F.XHTML.attributes[e].length;n++)if(t===F.XHTML.attributes[e][n])return!0;return!1},validCSS(e){for(let t=0;t<F.XHTML.css.length;t++)if(e===F.XHTML.css[t])return!0;return!1}},Status:{ERROR:0,CONNECTING:1,CONNFAIL:2,AUTHENTICATING:3,AUTHFAIL:4,CONNECTED:5,DISCONNECTED:6,DISCONNECTING:7,ATTACHED:8,REDIRECT:9,CONNTIMEOUT:10,BINDREQUIRED:11,ATTACHFAIL:12},ErrorCondition:{BAD_FORMAT:"bad-format",CONFLICT:"conflict",MISSING_JID_NODE:"x-strophe-bad-non-anon-jid",NO_AUTH_MECH:"no-auth-mech",UNKNOWN_REASON:"unknown"},LogLevel:{DEBUG:0,INFO:1,WARN:2,ERROR:3,FATAL:4},ElementType:{NORMAL:1,TEXT:3,CDATA:4,FRAGMENT:11},TIMEOUT:1.1,SECONDARY_TIMEOUT:.1,addNamespace(e,t){F.NS[e]=t},forEachChild(e,t,n){for(let i=0;i<e.childNodes.length;i++){const r=e.childNodes[i];r.nodeType!==F.ElementType.NORMAL||t&&!this.isTagEqual(r,t)||n(r)}},isTagEqual:(e,t)=>e.tagName===t,_xmlGenerator:null,xmlGenerator:()=>(F._xmlGenerator||(F._xmlGenerator=o()),F._xmlGenerator),xmlElement(e){if(!e)return null;const t=F.xmlGenerator().createElement(e);for(let e=1;e<arguments.length;e++){const n=arguments[e];if(n)if("string"==typeof n||"number"==typeof n)t.appendChild(F.xmlTextNode(n));else if("object"==typeof n&&"function"==typeof n.sort)for(let e=0;e<n.length;e++){const i=n[e];"object"==typeof i&&"function"==typeof i.sort&&void 0!==i[1]&&null!==i[1]&&t.setAttribute(i[0],i[1])}else if("object"==typeof n)for(const e in n)Object.prototype.hasOwnProperty.call(n,e)&&void 0!==n[e]&&null!==n[e]&&t.setAttribute(e,n[e])}return t},xmlescape:e=>(e=(e=(e=(e=e.replace(/\\&/g,"&amp;")).replace(/</g,"&lt;")).replace(/>/g,"&gt;")).replace(/\'/g,"&apos;")).replace(/"/g,"&quot;"),xmlunescape:e=>(e=(e=(e=(e=e.replace(/\\&amp;/g,"&")).replace(/&lt;/g,"<")).replace(/&gt;/g,">")).replace(/&apos;/g,"\'")).replace(/&quot;/g,\'"\'),xmlTextNode:e=>F.xmlGenerator().createTextNode(e),xmlHtmlNode(e){let t;return r?t=(new r).parseFromString(e,"text/xml"):(t=new ActiveXObject("Microsoft.XMLDOM"),t.async="false",t.loadXML(e)),t},getText(e){if(!e)return null;let t="";0===e.childNodes.length&&e.nodeType===F.ElementType.TEXT&&(t+=e.nodeValue);for(let n=0;n<e.childNodes.length;n++)e.childNodes[n].nodeType===F.ElementType.TEXT&&(t+=e.childNodes[n].nodeValue);return F.xmlescape(t)},copyElement(e){let t;if(e.nodeType===F.ElementType.NORMAL){t=F.xmlElement(e.tagName);for(let n=0;n<e.attributes.length;n++)t.setAttribute(e.attributes[n].nodeName,e.attributes[n].value);for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.copyElement(e.childNodes[n]))}else e.nodeType===F.ElementType.TEXT&&(t=F.xmlGenerator().createTextNode(e.nodeValue));return t},createHtml(e){let t;if(e.nodeType===F.ElementType.NORMAL){const n=e.nodeName.toLowerCase();if(F.XHTML.validTag(n))try{t=F.xmlElement(n);for(let i=0;i<F.XHTML.attributes[n].length;i++){const r=F.XHTML.attributes[n][i];let o=e.getAttribute(r);if(null!=o&&""!==o&&!1!==o&&0!==o)if("style"===r&&"object"==typeof o&&void 0!==o.cssText&&(o=o.cssText),"style"===r){const e=[],n=o.split(";");for(let t=0;t<n.length;t++){const i=n[t].split(":"),r=i[0].replace(/^\\s*/,"").replace(/\\s*$/,"").toLowerCase();if(F.XHTML.validCSS(r)){const t=i[1].replace(/^\\s*/,"").replace(/\\s*$/,"");e.push(r+": "+t)}}e.length>0&&(o=e.join("; "),t.setAttribute(r,o))}else t.setAttribute(r,o)}for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}catch(e){t=F.xmlTextNode("")}else{t=F.xmlGenerator().createDocumentFragment();for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}}else if(e.nodeType===F.ElementType.FRAGMENT){t=F.xmlGenerator().createDocumentFragment();for(let n=0;n<e.childNodes.length;n++)t.appendChild(F.createHtml(e.childNodes[n]))}else e.nodeType===F.ElementType.TEXT&&(t=F.xmlTextNode(e.nodeValue));return t},escapeNode:e=>"string"!=typeof e?e:e.replace(/^\\s+|\\s+$/g,"").replace(/\\\\/g,"\\\\5c").replace(/ /g,"\\\\20").replace(/\\"/g,"\\\\22").replace(/\\&/g,"\\\\26").replace(/\\\'/g,"\\\\27").replace(/\\//g,"\\\\2f").replace(/:/g,"\\\\3a").replace(/</g,"\\\\3c").replace(/>/g,"\\\\3e").replace(/@/g,"\\\\40"),unescapeNode:e=>"string"!=typeof e?e:e.replace(/\\\\20/g," ").replace(/\\\\22/g,\'"\').replace(/\\\\26/g,"&").replace(/\\\\27/g,"\'").replace(/\\\\2f/g,"/").replace(/\\\\3a/g,":").replace(/\\\\3c/g,"<").replace(/\\\\3e/g,">").replace(/\\\\40/g,"@").replace(/\\\\5c/g,"\\\\"),getNodeFromJid:e=>e.indexOf("@")<0?null:e.split("@")[0],getDomainFromJid(e){const t=F.getBareJidFromJid(e);if(t.indexOf("@")<0)return t;{const e=t.split("@");return e.splice(0,1),e.join("@")}},getResourceFromJid(e){if(!e)return null;const t=e.split("/");return t.length<2?null:(t.splice(0,1),t.join("/"))},getBareJidFromJid:e=>e?e.split("/")[0]:null,_handleError(e){void 0!==e.stack&&F.fatal(e.stack),e.sourceURL?F.fatal("error: "+this.handler+" "+e.sourceURL+":"+e.line+" - "+e.name+": "+e.message):e.fileName?F.fatal("error: "+this.handler+" "+e.fileName+":"+e.lineNumber+" - "+e.name+": "+e.message):F.fatal("error: "+e.message)},log(e,t){var n;e===this.LogLevel.FATAL&&(null===(n=console)||void 0===n||n.error(t))},debug(e){this.log(this.LogLevel.DEBUG,e)},info(e){this.log(this.LogLevel.INFO,e)},warn(e){this.log(this.LogLevel.WARN,e)},error(e){this.log(this.LogLevel.ERROR,e)},fatal(e){this.log(this.LogLevel.FATAL,e)},serialize(e){if(!e)return null;"function"==typeof e.tree&&(e=e.tree());const t=[...Array(e.attributes.length).keys()].map((t=>e.attributes[t].nodeName));t.sort();let n=t.reduce(((t,n)=>`${t} ${n}="${F.xmlescape(e.attributes.getNamedItem(n).value)}"`),`<${e.nodeName}`);if(e.childNodes.length>0){n+=">";for(let t=0;t<e.childNodes.length;t++){const i=e.childNodes[t];switch(i.nodeType){case F.ElementType.NORMAL:n+=F.serialize(i);break;case F.ElementType.TEXT:n+=F.xmlescape(i.nodeValue);break;case F.ElementType.CDATA:n+="<![CDATA["+i.nodeValue+"]]>"}}n+="</"+e.nodeName+">"}else n+="/>";return n},_requestId:0,_connectionPlugins:{},addConnectionPlugin(e,t){F._connectionPlugins[e]=t},Builder:class{constructor(e,t){"presence"!==e&&"message"!==e&&"iq"!==e||(t&&!t.xmlns?t.xmlns=F.NS.CLIENT:t||(t={xmlns:F.NS.CLIENT})),this.nodeTree=F.xmlElement(e,t),this.node=this.nodeTree}tree(){return this.nodeTree}toString(){return F.serialize(this.nodeTree)}up(){return this.node=this.node.parentNode,this}root(){return this.node=this.nodeTree,this}attrs(e){for(const t in e)Object.prototype.hasOwnProperty.call(e,t)&&(void 0===e[t]?this.node.removeAttribute(t):this.node.setAttribute(t,e[t]));return this}c(e,t,n){const i=F.xmlElement(e,t,n);return this.node.appendChild(i),"string"!=typeof n&&"number"!=typeof n&&(this.node=i),this}cnode(e){let t;const n=F.xmlGenerator();try{t=void 0!==n.importNode}catch(e){t=!1}const i=t?n.importNode(e,!0):F.copyElement(e);return this.node.appendChild(i),this.node=i,this}t(e){const t=F.xmlTextNode(e);return this.node.appendChild(t),this}h(e){const t=F.xmlGenerator().createElement("body");t.innerHTML=e;const n=F.createHtml(t);for(;n.childNodes.length>0;)this.node.appendChild(n.childNodes[0]);return this}},Handler:function(e,t,n,i,r,o,s){this.handler=e,this.ns=t,this.name=n,this.type=i,this.id=r,this.options=s||{matchBareFromJid:!1,ignoreNamespaceFragment:!1},this.options.matchBare&&(F.warn(\'The "matchBare" option is deprecated, use "matchBareFromJid" instead.\'),this.options.matchBareFromJid=this.options.matchBare,delete this.options.matchBare),this.options.matchBareFromJid?this.from=o?F.getBareJidFromJid(o):null:this.from=o,this.user=!0}};F.Handler.prototype={getNamespace(e){let t=e.getAttribute("xmlns");return t&&this.options.ignoreNamespaceFragment&&(t=t.split("#")[0]),t},namespaceMatch(e){let t=!1;return!this.ns||(F.forEachChild(e,null,(e=>{this.getNamespace(e)===this.ns&&(t=!0)})),t||this.getNamespace(e)===this.ns)},isMatch(e){let t=e.getAttribute("from");this.options.matchBareFromJid&&(t=F.getBareJidFromJid(t));const n=e.getAttribute("type");return!(!this.namespaceMatch(e)||this.name&&!F.isTagEqual(e,this.name)||this.type&&(Array.isArray(this.type)?-1===this.type.indexOf(n):n!==this.type)||this.id&&e.getAttribute("id")!==this.id||this.from&&t!==this.from)},run(e){let t=null;try{t=this.handler(e)}catch(e){throw F._handleError(e),e}return t},toString(){return"{Handler: "+this.handler+"("+this.name+","+this.id+","+this.ns+")}"}},F.TimedHandler=class{constructor(e,t){this.period=e,this.handler=t,this.lastCalled=(new Date).getTime(),this.user=!0}run(){return this.lastCalled=(new Date).getTime(),this.handler()}reset(){this.lastCalled=(new Date).getTime()}toString(){return"{TimedHandler: "+this.handler+"("+this.period+")}"}},F.Connection=class{constructor(e,t){this.service=e,this.options=t||{},this.setProtocol(),this.jid="",this.domain=null,this.features=null,this._sasl_data={},this.do_bind=!1,this.do_session=!1,this.mechanisms={},this.timedHandlers=[],this.handlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this.protocolErrorHandlers={HTTP:{},websocket:{}},this._idleTimeout=null,this._disconnectTimeout=null,this.authenticated=!1,this.connected=!1,this.disconnecting=!1,this.do_authentication=!0,this.paused=!1,this.restored=!1,this._data=[],this._uniqueId=0,this._sasl_success_handler=null,this._sasl_failure_handler=null,this._sasl_challenge_handler=null,this.maxRetries=5,this._idleTimeout=setTimeout((()=>this._onIdle()),100),v(this.options.cookies),this.registerSASLMechanisms(this.options.mechanisms),this.iqFallbackHandler=new F.Handler((e=>this.send(M({type:"error",id:e.getAttribute("id")}).c("error",{type:"cancel"}).c("service-unavailable",{xmlns:F.NS.STANZAS}))),null,"iq",["get","set"]);for(const e in F._connectionPlugins)if(Object.prototype.hasOwnProperty.call(F._connectionPlugins,e)){const t=function(){};t.prototype=F._connectionPlugins[e],this[e]=new t,this[e].init(this)}}setProtocol(){const e=this.options.protocol||"";this.options.worker?this._proto=new F.WorkerWebsocket(this):0===this.service.indexOf("ws:")||0===this.service.indexOf("wss:")||0===e.indexOf("ws")?this._proto=new F.Websocket(this):this._proto=new F.Bosh(this)}reset(){this._proto._reset(),this.do_session=!1,this.do_bind=!1,this.timedHandlers=[],this.handlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this.authenticated=!1,this.connected=!1,this.disconnecting=!1,this.restored=!1,this._data=[],this._requests=[],this._uniqueId=0}pause(){this.paused=!0}resume(){this.paused=!1}getUniqueId(e){const t="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){const t=16*Math.random()|0;return("x"===e?t:3&t|8).toString(16)}));return"string"==typeof e||"number"==typeof e?t+":"+e:t+""}addProtocolErrorHandler(e,t,n){this.protocolErrorHandlers[e][t]=n}connect(e,t,n,i,r,o,s){let a=arguments.length>7&&void 0!==arguments[7]?arguments[7]:3e3;this.jid=e,this.authzid=F.getBareJidFromJid(this.jid),this.authcid=s||F.getNodeFromJid(this.jid),this.pass=t,this.connect_callback=n,this.disconnecting=!1,this.connected=!1,this.authenticated=!1,this.restored=!1,this.disconnection_timeout=a,this.domain=F.getDomainFromJid(this.jid),this._changeConnectStatus(F.Status.CONNECTING,null),this._proto._connect(i,r,o)}attach(e,t,n,i,r,o,s){if(this._proto._attach)return this._proto._attach(e,t,n,i,r,o,s);{const e=new Error(\'The "attach" method is not available for your connection protocol\');throw e.name="StropheSessionError",e}}restore(e,t,n,i,r){if(!this._sessionCachingSupported()){const e=new Error(\'The "restore" method can only be used with a BOSH connection.\');throw e.name="StropheSessionError",e}this._proto._restore(e,t,n,i,r)}_sessionCachingSupported(){if(this._proto instanceof F.Bosh){if(!JSON)return!1;try{sessionStorage.setItem("_strophe_","_strophe_"),sessionStorage.removeItem("_strophe_")}catch(e){return!1}return!0}return!1}xmlInput(e){}xmlOutput(e){}rawInput(e){}rawOutput(e){}nextValidRid(e){}send(e){if(null!==e){if("function"==typeof e.sort)for(let t=0;t<e.length;t++)this._queueData(e[t]);else"function"==typeof e.tree?this._queueData(e.tree()):this._queueData(e);this._proto._send()}}flush(){clearTimeout(this._idleTimeout),this._onIdle()}sendPresence(e,t,n,i){let r=null;"function"==typeof e.tree&&(e=e.tree());let o=e.getAttribute("id");if(o||(o=this.getUniqueId("sendPresence"),e.setAttribute("id",o)),"function"==typeof t||"function"==typeof n){const e=this.addHandler((e=>{r&&this.deleteTimedHandler(r),"error"===e.getAttribute("type")?n&&n(e):t&&t(e)}),null,"presence",null,o);i&&(r=this.addTimedHandler(i,(()=>(this.deleteHandler(e),n&&n(null),!1))))}return this.send(e),o}sendIQ(e,t,n,i){let r=null;"function"==typeof e.tree&&(e=e.tree());let o=e.getAttribute("id");if(o||(o=this.getUniqueId("sendIQ"),e.setAttribute("id",o)),"function"==typeof t||"function"==typeof n){const e=this.addHandler((e=>{r&&this.deleteTimedHandler(r);const i=e.getAttribute("type");if("result"===i)t&&t(e);else{if("error"!==i){const e=new Error(`Got bad IQ type of ${i}`);throw e.name="StropheError",e}n&&n(e)}}),null,"iq",["error","result"],o);i&&(r=this.addTimedHandler(i,(()=>(this.deleteHandler(e),n&&n(null),!1))))}return this.send(e),o}_queueData(e){if(null===e||!e.tagName||!e.childNodes){const e=new Error("Cannot queue non-DOMElement.");throw e.name="StropheError",e}this._data.push(e)}_sendRestart(){this._data.push("restart"),this._proto._sendRestart(),this._idleTimeout=setTimeout((()=>this._onIdle()),100)}addTimedHandler(e,t){const n=new F.TimedHandler(e,t);return this.addTimeds.push(n),n}deleteTimedHandler(e){this.removeTimeds.push(e)}addHandler(e,t,n,i,r,o,s){const a=new F.Handler(e,t,n,i,r,o,s);return this.addHandlers.push(a),a}deleteHandler(e){this.removeHandlers.push(e);const t=this.addHandlers.indexOf(e);t>=0&&this.addHandlers.splice(t,1)}registerSASLMechanisms(e){this.mechanisms={},(e=e||[F.SASLAnonymous,F.SASLExternal,F.SASLOAuthBearer,F.SASLXOAuth2,F.SASLPlain,F.SASLSHA1]).forEach((e=>this.registerSASLMechanism(e)))}registerSASLMechanism(e){const t=new e;this.mechanisms[t.mechname]=t}disconnect(e){if(this._changeConnectStatus(F.Status.DISCONNECTING,e),e?F.warn("Disconnect was called because: "+e):F.info("Disconnect was called"),this.connected){let e=!1;this.disconnecting=!0,this.authenticated&&(e=L({xmlns:F.NS.CLIENT,type:"unavailable"})),this._disconnectTimeout=this._addSysTimedHandler(this.disconnection_timeout,this._onDisconnectTimeout.bind(this)),this._proto._disconnect(e)}else F.warn("Disconnect was called before Strophe connected to the server"),this._proto._abortAllRequests(),this._doDisconnect()}_changeConnectStatus(e,t,n){for(const n in F._connectionPlugins)if(Object.prototype.hasOwnProperty.call(F._connectionPlugins,n)){const i=this[n];if(i.statusChanged)try{i.statusChanged(e,t)}catch(e){F.error(`${n} plugin caused an exception changing status: ${e}`)}}if(this.connect_callback)try{this.connect_callback(e,t,n)}catch(e){F._handleError(e),F.error(`User connection callback caused an exception: ${e}`)}}_doDisconnect(e){"number"==typeof this._idleTimeout&&clearTimeout(this._idleTimeout),null!==this._disconnectTimeout&&(this.deleteTimedHandler(this._disconnectTimeout),this._disconnectTimeout=null),F.debug("_doDisconnect was called"),this._proto._doDisconnect(),this.authenticated=!1,this.disconnecting=!1,this.restored=!1,this.handlers=[],this.timedHandlers=[],this.removeTimeds=[],this.removeHandlers=[],this.addTimeds=[],this.addHandlers=[],this._changeConnectStatus(F.Status.DISCONNECTED,e),this.connected=!1}_dataRecv(e,t){const n=this._proto._reqToData(e);if(null===n)return;for(this.xmlInput!==F.Connection.prototype.xmlInput&&(n.nodeName===this._proto.strip&&n.childNodes.length?this.xmlInput(n.childNodes[0]):this.xmlInput(n)),this.rawInput!==F.Connection.prototype.rawInput&&(t?this.rawInput(t):this.rawInput(F.serialize(n)));this.removeHandlers.length>0;){const e=this.removeHandlers.pop(),t=this.handlers.indexOf(e);t>=0&&this.handlers.splice(t,1)}for(;this.addHandlers.length>0;)this.handlers.push(this.addHandlers.pop());if(this.disconnecting&&this._proto._emptyQueue())return void this._doDisconnect();const i=n.getAttribute("type");if(null!==i&&"terminate"===i){if(this.disconnecting)return;let e=n.getAttribute("condition");const t=n.getElementsByTagName("conflict");return null!==e?("remote-stream-error"===e&&t.length>0&&(e="conflict"),this._changeConnectStatus(F.Status.CONNFAIL,e)):this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.UNKOWN_REASON),void this._doDisconnect(e)}F.forEachChild(n,null,(e=>{const t=[];this.handlers=this.handlers.reduce(((n,i)=>{try{!i.isMatch(e)||!this.authenticated&&i.user?n.push(i):(i.run(e)&&n.push(i),t.push(i))}catch(e){F.warn("Removing Strophe handlers due to uncaught exception: "+e.message)}return n}),[]),!t.length&&this.iqFallbackHandler.isMatch(e)&&this.iqFallbackHandler.run(e)}))}_connect_cb(e,t,n){let i,r;F.debug("_connect_cb was called"),this.connected=!0;try{i=this._proto._reqToData(e)}catch(e){if(e.name!==F.ErrorCondition.BAD_FORMAT)throw e;this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.BAD_FORMAT),this._doDisconnect(F.ErrorCondition.BAD_FORMAT)}if(!i)return;if(this.xmlInput!==F.Connection.prototype.xmlInput&&(i.nodeName===this._proto.strip&&i.childNodes.length?this.xmlInput(i.childNodes[0]):this.xmlInput(i)),this.rawInput!==F.Connection.prototype.rawInput&&(n?this.rawInput(n):this.rawInput(F.serialize(i))),this._proto._connect_cb(i)===F.Status.CONNFAIL)return;if(r=i.getElementsByTagNameNS?i.getElementsByTagNameNS(F.NS.STREAM,"features").length>0:i.getElementsByTagName("stream:features").length>0||i.getElementsByTagName("features").length>0,!r)return void this._proto._no_auth_received(t);const o=Array.from(i.getElementsByTagName("mechanism")).map((e=>this.mechanisms[e.textContent])).filter((e=>e));0!==o.length||0!==i.getElementsByTagName("auth").length?!1!==this.do_authentication&&this.authenticate(o):this._proto._no_auth_received(t)}sortMechanismsByPriority(e){for(let t=0;t<e.length-1;++t){let n=t;for(let i=t+1;i<e.length;++i)e[i].priority>e[n].priority&&(n=i);if(n!==t){const i=e[t];e[t]=e[n],e[n]=i}}return e}authenticate(e){this._attemptSASLAuth(e)||this._attemptLegacyAuth()}_attemptSASLAuth(e){e=this.sortMechanismsByPriority(e||[]);let t=!1;for(let n=0;n<e.length;++n){if(!e[n].test(this))continue;this._sasl_success_handler=this._addSysHandler(this._sasl_success_cb.bind(this),null,"success",null,null),this._sasl_failure_handler=this._addSysHandler(this._sasl_failure_cb.bind(this),null,"failure",null,null),this._sasl_challenge_handler=this._addSysHandler(this._sasl_challenge_cb.bind(this),null,"challenge",null,null),this._sasl_mechanism=e[n],this._sasl_mechanism.onStart(this);const i=k("auth",{xmlns:F.NS.SASL,mechanism:this._sasl_mechanism.mechname});if(this._sasl_mechanism.isClientFirst){const e=this._sasl_mechanism.clientChallenge(this);i.t(O.btoa(e))}this.send(i.tree()),t=!0;break}return t}_sasl_challenge_cb(e){const t=O.atob(F.getText(e)),n=this._sasl_mechanism.onChallenge(this,t),i=k("response",{xmlns:F.NS.SASL});return""!==n&&i.t(O.btoa(n)),this.send(i.tree()),!0}_attemptLegacyAuth(){null===F.getNodeFromJid(this.jid)?(this._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.MISSING_JID_NODE),this.disconnect(F.ErrorCondition.MISSING_JID_NODE)):(this._changeConnectStatus(F.Status.AUTHENTICATING,null),this._addSysHandler(this._onLegacyAuthIQResult.bind(this),null,null,null,"_auth_1"),this.send(M({type:"get",to:this.domain,id:"_auth_1"}).c("query",{xmlns:F.NS.AUTH}).c("username",{}).t(F.getNodeFromJid(this.jid)).tree()))}_onLegacyAuthIQResult(e){const t=M({type:"set",id:"_auth_2"}).c("query",{xmlns:F.NS.AUTH}).c("username",{}).t(F.getNodeFromJid(this.jid)).up().c("password").t(this.pass);return F.getResourceFromJid(this.jid)||(this.jid=F.getBareJidFromJid(this.jid)+"/strophe"),t.up().c("resource",{}).t(F.getResourceFromJid(this.jid)),this._addSysHandler(this._auth2_cb.bind(this),null,null,null,"_auth_2"),this.send(t.tree()),!1}_sasl_success_cb(e){if(this._sasl_data["server-signature"]){let t;const n=/([a-z]+)=([^,]+)(,|$)/,i=O.atob(F.getText(e)).match(n);if("v"===i[1]&&(t=i[2]),t!==this._sasl_data["server-signature"])return this.deleteHandler(this._sasl_failure_handler),this._sasl_failure_handler=null,this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null),this._sasl_data={},this._sasl_failure_cb(null)}F.info("SASL authentication succeeded."),this._sasl_mechanism&&this._sasl_mechanism.onSuccess(),this.deleteHandler(this._sasl_failure_handler),this._sasl_failure_handler=null,this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null);const t=[],n=(e,t)=>{for(;e.length;)this.deleteHandler(e.pop());return this._onStreamFeaturesAfterSASL(t),!1};return t.push(this._addSysHandler((e=>n(t,e)),null,"stream:features",null,null)),t.push(this._addSysHandler((e=>n(t,e)),F.NS.STREAM,"features",null,null)),this._sendRestart(),!1}_onStreamFeaturesAfterSASL(e){this.features=e;for(let t=0;t<e.childNodes.length;t++){const n=e.childNodes[t];"bind"===n.nodeName&&(this.do_bind=!0),"session"===n.nodeName&&(this.do_session=!0)}return this.do_bind?(this.options.explicitResourceBinding?this._changeConnectStatus(F.Status.BINDREQUIRED,null):this.bind(),!1):(this._changeConnectStatus(F.Status.AUTHFAIL,null),!1)}bind(){if(!this.do_bind)return void F.log(F.LogLevel.INFO,\'Strophe.Connection.prototype.bind called but "do_bind" is false\');this._addSysHandler(this._onResourceBindResultIQ.bind(this),null,null,null,"_bind_auth_2");const e=F.getResourceFromJid(this.jid);e?this.send(M({type:"set",id:"_bind_auth_2"}).c("bind",{xmlns:F.NS.BIND}).c("resource",{}).t(e).tree()):this.send(M({type:"set",id:"_bind_auth_2"}).c("bind",{xmlns:F.NS.BIND}).tree())}_onResourceBindResultIQ(e){if("error"===e.getAttribute("type")){let t;return F.warn("Resource binding failed."),e.getElementsByTagName("conflict").length>0&&(t=F.ErrorCondition.CONFLICT),this._changeConnectStatus(F.Status.AUTHFAIL,t,e),!1}const t=e.getElementsByTagName("bind");if(!(t.length>0))return F.warn("Resource binding failed."),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1;{const e=t[0].getElementsByTagName("jid");e.length>0&&(this.authenticated=!0,this.jid=F.getText(e[0]),this.do_session?this._establishSession():this._changeConnectStatus(F.Status.CONNECTED,null))}}_establishSession(){if(!this.do_session)throw new Error(`Strophe.Connection.prototype._establishSession called but apparently ${F.NS.SESSION} wasn\'t advertised by the server`);this._addSysHandler(this._onSessionResultIQ.bind(this),null,null,null,"_session_auth_2"),this.send(M({type:"set",id:"_session_auth_2"}).c("session",{xmlns:F.NS.SESSION}).tree())}_onSessionResultIQ(e){if("result"===e.getAttribute("type"))this.authenticated=!0,this._changeConnectStatus(F.Status.CONNECTED,null);else if("error"===e.getAttribute("type"))return this.authenticated=!1,F.warn("Session creation failed."),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1;return!1}_sasl_failure_cb(e){return this._sasl_success_handler&&(this.deleteHandler(this._sasl_success_handler),this._sasl_success_handler=null),this._sasl_challenge_handler&&(this.deleteHandler(this._sasl_challenge_handler),this._sasl_challenge_handler=null),this._sasl_mechanism&&this._sasl_mechanism.onFailure(),this._changeConnectStatus(F.Status.AUTHFAIL,null,e),!1}_auth2_cb(e){return"result"===e.getAttribute("type")?(this.authenticated=!0,this._changeConnectStatus(F.Status.CONNECTED,null)):"error"===e.getAttribute("type")&&(this._changeConnectStatus(F.Status.AUTHFAIL,null,e),this.disconnect("authentication failed")),!1}_addSysTimedHandler(e,t){const n=new F.TimedHandler(e,t);return n.user=!1,this.addTimeds.push(n),n}_addSysHandler(e,t,n,i,r){const o=new F.Handler(e,t,n,i,r);return o.user=!1,this.addHandlers.push(o),o}_onDisconnectTimeout(){return F.debug("_onDisconnectTimeout was called"),this._changeConnectStatus(F.Status.CONNTIMEOUT,null),this._proto._onDisconnectTimeout(),this._doDisconnect(),!1}_onIdle(){for(;this.addTimeds.length>0;)this.timedHandlers.push(this.addTimeds.pop());for(;this.removeTimeds.length>0;){const e=this.removeTimeds.pop(),t=this.timedHandlers.indexOf(e);t>=0&&this.timedHandlers.splice(t,1)}const e=(new Date).getTime(),t=[];for(let n=0;n<this.timedHandlers.length;n++){const i=this.timedHandlers[n];!this.authenticated&&i.user||(i.lastCalled+i.period-e<=0?i.run()&&t.push(i):t.push(i))}this.timedHandlers=t,clearTimeout(this._idleTimeout),this._proto._onIdle(),this.connected&&(this._idleTimeout=setTimeout((()=>this._onIdle()),100))}},F.SASLMechanism=g,F.SASLAnonymous=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"ANONYMOUS",arguments.length>1&&void 0!==arguments[1]&&arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:20)}test(e){return null===e.authcid}},F.SASLPlain=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"PLAIN",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:50)}test(e){return null!==e.authcid}onChallenge(e){const{authcid:t,authzid:n,domain:i,pass:r}=e;if(!i)throw new Error("SASLPlain onChallenge: domain is not defined!");let o=n!==`${t}@${i}`?n:"";return o+="\\0",o+=t,o+="\\0",o+=r,f(o)}},F.SASLSHA1=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"SCRAM-SHA-1",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:60)}test(e){return null!==e.authcid}onChallenge(e,t){let n,i,r,o,s,a,d,c,l="c=biws,",h=`${e._sasl_data["client-first-message-bare"]},${t},`;const u=e._sasl_data.cnonce,p=/([a-z]+)=([^,]+)(,|$)/;for(;t.match(p);){const e=t.match(p);switch(t=t.replace(e[0],""),e[1]){case"r":n=e[2];break;case"s":i=e[2];break;case"i":r=e[2]}}if(n.slice(0,u.length)!==u)return e._sasl_data={},e._sasl_failure_cb();l+="r="+n,h+=l,i=atob(i),i+="\\0\\0\\0";const m=f(e.pass);for(o=a=A.core_hmac_sha1(m,i),d=1;d<r;d++){for(s=A.core_hmac_sha1(m,A.binb2str(a)),c=0;c<5;c++)o[c]^=s[c];a=s}o=A.binb2str(o);const g=A.core_hmac_sha1(o,"Client Key"),v=A.str_hmac_sha1(o,"Server Key"),_=A.core_hmac_sha1(A.str_sha1(A.binb2str(g)),h);for(e._sasl_data["server-signature"]=A.b64_hmac_sha1(v,h),c=0;c<5;c++)g[c]^=_[c];return l+=",p="+btoa(A.binb2str(g)),l}clientChallenge(e,t){const n=t||m.hexdigest(""+1234567890*Math.random());let i="n="+f(e.authcid);return i+=",r=",i+=n,e._sasl_data.cnonce=n,e._sasl_data["client-first-message-bare"]=i,i="n,,"+i,i}},F.SASLOAuthBearer=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"OAUTHBEARER",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:40)}test(e){return null!==e.pass}onChallenge(e){let t="n,";return null!==e.authcid&&(t=t+"a="+e.authzid),t+=",",t+="",t+="auth=Bearer ",t+=e.pass,t+="",t+="",f(t)}},F.SASLExternal=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"EXTERNAL",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:10)}onChallenge(e){return e.authcid===e.authzid?"":e.authzid}},F.SASLXOAuth2=class extends g{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:"X-OAUTH2",!(arguments.length>1&&void 0!==arguments[1])||arguments[1],arguments.length>2&&void 0!==arguments[2]?arguments[2]:30)}test(e){return null!==e.pass}onChallenge(e){let t="\\0";return null!==e.authcid&&(t+=e.authzid),t+="\\0",t+=e.pass,f(t)}};var j={Strophe:F,$build:k,$iq:M,$msg:N,$pres:L,SHA1:A,MD5:m,b64_hmac_sha1:A.b64_hmac_sha1,b64_sha1:A.b64_sha1,str_hmac_sha1:A.str_hmac_sha1,str_sha1:A.str_sha1};F.Request=class{constructor(e,t,n,i){this.id=++F._requestId,this.xmlData=e,this.data=F.serialize(e),this.origFunc=t,this.func=t,this.rid=n,this.date=NaN,this.sends=i||0,this.abort=!1,this.dead=null,this.age=function(){return this.date?(new Date-this.date)/1e3:0},this.timeDead=function(){return this.dead?(new Date-this.dead)/1e3:0},this.xhr=this._newXHR()}getResponse(){let e=null;if(this.xhr.responseXML&&this.xhr.responseXML.documentElement){if(e=this.xhr.responseXML.documentElement,"parsererror"===e.tagName)throw F.error("invalid response received"),F.error("responseText: "+this.xhr.responseText),F.error("responseXML: "+F.serialize(this.xhr.responseXML)),new Error("parsererror")}else if(this.xhr.responseText){if(F.debug("Got responseText but no responseXML; attempting to parse it with DOMParser..."),e=(new r).parseFromString(this.xhr.responseText,"application/xml").documentElement,!e)throw new Error("Parsing produced null node");if(e.querySelector("parsererror")){F.error("invalid response received: "+e.querySelector("parsererror").textContent),F.error("responseText: "+this.xhr.responseText);const t=new Error;throw t.name=F.ErrorCondition.BAD_FORMAT,t}}return e}_newXHR(){let e=null;return window.XMLHttpRequest?(e=new XMLHttpRequest,e.overrideMimeType&&e.overrideMimeType("text/xml; charset=utf-8")):window.ActiveXObject&&(e=new ActiveXObject("Microsoft.XMLHTTP")),e.onreadystatechange=this.func.bind(null,this),e}},F.Bosh=class e{constructor(e){this._conn=e,this.rid=Math.floor(4294967295*Math.random()),this.sid=null,this.hold=1,this.wait=60,this.window=5,this.errors=0,this.inactivity=null,this.lastResponseHeaders=null,this._requests=[]}_buildBody(){const e=k("body",{rid:this.rid++,xmlns:F.NS.HTTPBIND});return null!==this.sid&&e.attrs({sid:this.sid}),this._conn.options.keepalive&&this._conn._sessionCachingSupported()&&this._cacheSession(),e}_reset(){this.rid=Math.floor(4294967295*Math.random()),this.sid=null,this.errors=0,this._conn._sessionCachingSupported()&&window.sessionStorage.removeItem("strophe-bosh-session"),this._conn.nextValidRid(this.rid)}_connect(e,t,n){this.wait=e||this.wait,this.hold=t||this.hold,this.errors=0;const i=this._buildBody().attrs({to:this._conn.domain,"xml:lang":"en",wait:this.wait,hold:this.hold,content:"text/xml; charset=utf-8",ver:"1.6","xmpp:version":"1.0","xmlns:xmpp":F.NS.BOSH});n&&i.attrs({route:n});const r=this._conn._connect_cb;this._requests.push(new F.Request(i.tree(),this._onRequestStateChange.bind(this,r.bind(this._conn)),i.tree().getAttribute("rid"))),this._throttledRequestHandler()}_attach(e,t,n,i,r,o,s){this._conn.jid=e,this.sid=t,this.rid=n,this._conn.connect_callback=i,this._conn.domain=F.getDomainFromJid(this._conn.jid),this._conn.authenticated=!0,this._conn.connected=!0,this.wait=r||this.wait,this.hold=o||this.hold,this.window=s||this.window,this._conn._changeConnectStatus(F.Status.ATTACHED,null)}_restore(e,t,n,i,r){const o=JSON.parse(window.sessionStorage.getItem("strophe-bosh-session"));if(!(null!=o&&o.rid&&o.sid&&o.jid&&(null==e||F.getBareJidFromJid(o.jid)===F.getBareJidFromJid(e)||null===F.getNodeFromJid(e)&&F.getDomainFromJid(o.jid)===e))){const e=new Error("_restore: no restoreable session.");throw e.name="StropheSessionError",e}this._conn.restored=!0,this._attach(o.jid,o.sid,o.rid,t,n,i,r)}_cacheSession(){this._conn.authenticated?this._conn.jid&&this.rid&&this.sid&&window.sessionStorage.setItem("strophe-bosh-session",JSON.stringify({jid:this._conn.jid,rid:this.rid,sid:this.sid})):window.sessionStorage.removeItem("strophe-bosh-session")}_connect_cb(e){const t=e.getAttribute("type");if(null!==t&&"terminate"===t){let t=e.getAttribute("condition");F.error("BOSH-Connection failed: "+t);const n=e.getElementsByTagName("conflict");return null!==t?("remote-stream-error"===t&&n.length>0&&(t="conflict"),this._conn._changeConnectStatus(F.Status.CONNFAIL,t)):this._conn._changeConnectStatus(F.Status.CONNFAIL,"unknown"),this._conn._doDisconnect(t),F.Status.CONNFAIL}this.sid||(this.sid=e.getAttribute("sid"));const n=e.getAttribute("requests");n&&(this.window=parseInt(n,10));const i=e.getAttribute("hold");i&&(this.hold=parseInt(i,10));const r=e.getAttribute("wait");r&&(this.wait=parseInt(r,10));const o=e.getAttribute("inactivity");o&&(this.inactivity=parseInt(o,10))}_disconnect(e){this._sendTerminate(e)}_doDisconnect(){this.sid=null,this.rid=Math.floor(4294967295*Math.random()),this._conn._sessionCachingSupported()&&window.sessionStorage.removeItem("strophe-bosh-session"),this._conn.nextValidRid(this.rid)}_emptyQueue(){return 0===this._requests.length}_callProtocolErrorHandlers(t){const n=e._getRequestStatus(t),i=this._conn.protocolErrorHandlers.HTTP[n];i&&i.call(this,n)}_hitError(e){this.errors++,F.warn("request errored, status: "+e+", number of errors: "+this.errors),this.errors>4&&this._conn._onDisconnectTimeout()}_no_auth_received(e){F.warn("Server did not yet offer a supported authentication mechanism. Sending a blank poll request."),e=e?e.bind(this._conn):this._conn._connect_cb.bind(this._conn);const t=this._buildBody();this._requests.push(new F.Request(t.tree(),this._onRequestStateChange.bind(this,e),t.tree().getAttribute("rid"))),this._throttledRequestHandler()}_onDisconnectTimeout(){this._abortAllRequests()}_abortAllRequests(){for(;this._requests.length>0;){const e=this._requests.pop();e.abort=!0,e.xhr.abort(),e.xhr.onreadystatechange=function(){}}}_onIdle(){const e=this._conn._data;if(this._conn.authenticated&&0===this._requests.length&&0===e.length&&!this._conn.disconnecting&&(F.debug("no requests during idle cycle, sending blank request"),e.push(null)),!this._conn.paused){if(this._requests.length<2&&e.length>0){const t=this._buildBody();for(let n=0;n<e.length;n++)null!==e[n]&&("restart"===e[n]?t.attrs({to:this._conn.domain,"xml:lang":"en","xmpp:restart":"true","xmlns:xmpp":F.NS.BOSH}):t.cnode(e[n]).up());delete this._conn._data,this._conn._data=[],this._requests.push(new F.Request(t.tree(),this._onRequestStateChange.bind(this,this._conn._dataRecv.bind(this._conn)),t.tree().getAttribute("rid"))),this._throttledRequestHandler()}if(this._requests.length>0){const e=this._requests[0].age();null!==this._requests[0].dead&&this._requests[0].timeDead()>Math.floor(F.SECONDARY_TIMEOUT*this.wait)&&this._throttledRequestHandler(),e>Math.floor(F.TIMEOUT*this.wait)&&(F.warn("Request "+this._requests[0].id+" timed out, over "+Math.floor(F.TIMEOUT*this.wait)+" seconds since last activity"),this._throttledRequestHandler())}}}static _getRequestStatus(e,t){let n;if(4===e.xhr.readyState)try{n=e.xhr.status}catch(e){F.error("Caught an error while retrieving a request\'s status, reqStatus: "+n)}return void 0===n&&(n="number"==typeof t?t:0),n}_onRequestStateChange(t,n){if(F.debug("request id "+n.id+"."+n.sends+" state changed to "+n.xhr.readyState),n.abort)return void(n.abort=!1);if(4!==n.xhr.readyState)return;const i=e._getRequestStatus(n);if(this.lastResponseHeaders=n.xhr.getAllResponseHeaders(),this._conn.disconnecting&&i>=400)return this._hitError(i),void this._callProtocolErrorHandlers(n);const r=this._requests[0]===n,o=this._requests[1]===n,s=i>0&&i<500,a=n.sends>this._conn.maxRetries;(s||a)&&(this._removeRequest(n),F.debug("request id "+n.id+" should now be removed")),200===i?((o||r&&this._requests.length>0&&this._requests[0].age()>Math.floor(F.SECONDARY_TIMEOUT*this.wait))&&this._restartRequest(0),this._conn.nextValidRid(Number(n.rid)+1),F.debug("request id "+n.id+"."+n.sends+" got 200"),t(n),this.errors=0):0===i||i>=400&&i<600||i>=12e3?(F.error("request id "+n.id+"."+n.sends+" error "+i+" happened"),this._hitError(i),this._callProtocolErrorHandlers(n),i>=400&&i<500&&(this._conn._changeConnectStatus(F.Status.DISCONNECTING,null),this._conn._doDisconnect())):F.error("request id "+n.id+"."+n.sends+" error "+i+" happened"),s||a?a&&!this._conn.connected&&this._conn._changeConnectStatus(F.Status.CONNFAIL,"giving-up"):this._throttledRequestHandler()}_processRequest(t){let n=this._requests[t];const i=e._getRequestStatus(n,-1);if(n.sends>this._conn.maxRetries)return void this._conn._onDisconnectTimeout();const r=n.age(),o=!isNaN(r)&&r>Math.floor(F.TIMEOUT*this.wait),s=null!==n.dead&&n.timeDead()>Math.floor(F.SECONDARY_TIMEOUT*this.wait),a=4===n.xhr.readyState&&(i<1||i>=500);if((o||s||a)&&(s&&F.error(`Request ${this._requests[t].id} timed out (secondary), restarting`),n.abort=!0,n.xhr.abort(),n.xhr.onreadystatechange=function(){},this._requests[t]=new F.Request(n.xmlData,n.origFunc,n.rid,n.sends),n=this._requests[t]),0===n.xhr.readyState){F.debug("request id "+n.id+"."+n.sends+" posting");try{const e=this._conn.options.contentType||"text/xml; charset=utf-8";n.xhr.open("POST",this._conn.service,!this._conn.options.sync),void 0!==n.xhr.setRequestHeader&&n.xhr.setRequestHeader("Content-Type",e),this._conn.options.withCredentials&&(n.xhr.withCredentials=!0)}catch(e){return F.error("XHR open failed: "+e.toString()),this._conn.connected||this._conn._changeConnectStatus(F.Status.CONNFAIL,"bad-service"),void this._conn.disconnect()}const e=()=>{if(n.date=new Date,this._conn.options.customHeaders){const e=this._conn.options.customHeaders;for(const t in e)Object.prototype.hasOwnProperty.call(e,t)&&n.xhr.setRequestHeader(t,e[t])}n.xhr.send(n.data)};if(n.sends>1){const t=1e3*Math.min(Math.floor(F.TIMEOUT*this.wait),Math.pow(n.sends,3));setTimeout((function(){e()}),t)}else e();n.sends++,this._conn.xmlOutput!==F.Connection.prototype.xmlOutput&&(n.xmlData.nodeName===this.strip&&n.xmlData.childNodes.length?this._conn.xmlOutput(n.xmlData.childNodes[0]):this._conn.xmlOutput(n.xmlData)),this._conn.rawOutput!==F.Connection.prototype.rawOutput&&this._conn.rawOutput(n.data)}else F.debug("_processRequest: "+(0===t?"first":"second")+" request has readyState of "+n.xhr.readyState)}_removeRequest(e){F.debug("removing request");for(let t=this._requests.length-1;t>=0;t--)e===this._requests[t]&&this._requests.splice(t,1);e.xhr.onreadystatechange=function(){},this._throttledRequestHandler()}_restartRequest(e){const t=this._requests[e];null===t.dead&&(t.dead=new Date),this._processRequest(e)}_reqToData(e){try{return e.getResponse()}catch(e){if("parsererror"!==e.message)throw e;this._conn.disconnect("strophe-parsererror")}}_sendTerminate(e){F.debug("_sendTerminate was called");const t=this._buildBody().attrs({type:"terminate"});e&&t.cnode(e.tree());const n=new F.Request(t.tree(),this._onRequestStateChange.bind(this,this._conn._dataRecv.bind(this._conn)),t.tree().getAttribute("rid"));this._requests.push(n),this._throttledRequestHandler()}_send(){clearTimeout(this._conn._idleTimeout),this._throttledRequestHandler(),this._conn._idleTimeout=setTimeout((()=>this._conn._onIdle()),100)}_sendRestart(){this._throttledRequestHandler(),clearTimeout(this._conn._idleTimeout)}_throttledRequestHandler(){this._requests?F.debug("_throttledRequestHandler called with "+this._requests.length+" requests"):F.debug("_throttledRequestHandler called with undefined requests"),this._requests&&0!==this._requests.length&&(this._requests.length>0&&this._processRequest(0),this._requests.length>1&&Math.abs(this._requests[0].rid-this._requests[1].rid)<this.window&&this._processRequest(1))}},F.Bosh.prototype.strip=null,F.Websocket=class{constructor(e){this._conn=e,this.strip="wrapper";const t=e.service;if(0!==t.indexOf("ws:")&&0!==t.indexOf("wss:")){let n="";"ws"===e.options.protocol&&"https:"!==window.location.protocol?n+="ws":n+="wss",n+="://"+window.location.host,0!==t.indexOf("/")?n+=window.location.pathname+t:n+=t,e.service=n}}_buildStream(){return k("open",{xmlns:F.NS.FRAMING,to:this._conn.domain,version:"1.0"})}_checkStreamError(e,t){let n;if(n=e.getElementsByTagNameNS?e.getElementsByTagNameNS(F.NS.STREAM,"error"):e.getElementsByTagName("stream:error"),0===n.length)return!1;const i=n[0];let r="",o="";for(let e=0;e<i.childNodes.length;e++){const t=i.childNodes[e];if("urn:ietf:params:xml:ns:xmpp-streams"!==t.getAttribute("xmlns"))break;"text"===t.nodeName?o=t.textContent:r=t.nodeName}let s="WebSocket stream error: ";return s+=r||"unknown",o&&(s+=" - "+o),F.error(s),this._conn._changeConnectStatus(t,r),this._conn._doDisconnect(),!0}_reset(){}_connect(){this._closeSocket(),this.socket=new i(this._conn.service,"xmpp"),this.socket.onopen=()=>this._onOpen(),this.socket.onerror=e=>this._onError(e),this.socket.onclose=e=>this._onClose(e),this.socket.onmessage=e=>this._onInitialMessage(e)}_connect_cb(e){if(this._checkStreamError(e,F.Status.CONNFAIL))return F.Status.CONNFAIL}_handleStreamStart(e){let t=!1;const n=e.getAttribute("xmlns");"string"!=typeof n?t="Missing xmlns in <open />":n!==F.NS.FRAMING&&(t="Wrong xmlns in <open />: "+n);const i=e.getAttribute("version");return"string"!=typeof i?t="Missing version in <open />":"1.0"!==i&&(t="Wrong version in <open />: "+i),!t||(this._conn._changeConnectStatus(F.Status.CONNFAIL,t),this._conn._doDisconnect(),!1)}_onInitialMessage(e){if(0===e.data.indexOf("<open ")||0===e.data.indexOf("<?xml")){const t=e.data.replace(/^(<\\?.*?\\?>\\s*)*/,"");if(""===t)return;const n=(new r).parseFromString(t,"text/xml").documentElement;this._conn.xmlInput(n),this._conn.rawInput(e.data),this._handleStreamStart(n)&&this._connect_cb(n)}else if(0===e.data.indexOf("<close ")){const t=(new r).parseFromString(e.data,"text/xml").documentElement;this._conn.xmlInput(t),this._conn.rawInput(e.data);const n=t.getAttribute("see-other-uri");if(n){const e=this._conn.service;(e.indexOf("wss:")>=0&&n.indexOf("wss:")>=0||e.indexOf("ws:")>=0)&&(this._conn._changeConnectStatus(F.Status.REDIRECT,"Received see-other-uri, resetting connection"),this._conn.reset(),this._conn.service=n,this._connect())}else this._conn._changeConnectStatus(F.Status.CONNFAIL,"Received closing stream"),this._conn._doDisconnect()}else{this._replaceMessageHandler();const t=this._streamWrap(e.data),n=(new r).parseFromString(t,"text/xml").documentElement;this._conn._connect_cb(n,null,e.data)}}_replaceMessageHandler(){this.socket.onmessage=e=>this._onMessage(e)}_disconnect(e){if(this.socket&&this.socket.readyState!==i.CLOSED){e&&this._conn.send(e);const t=k("close",{xmlns:F.NS.FRAMING});this._conn.xmlOutput(t.tree());const n=F.serialize(t);this._conn.rawOutput(n);try{this.socket.send(n)}catch(e){F.warn("Couldn\'t send <close /> tag.")}}setTimeout((()=>this._conn._doDisconnect()),0)}_doDisconnect(){F.debug("WebSockets _doDisconnect was called"),this._closeSocket()}_streamWrap(e){return"<wrapper>"+e+"</wrapper>"}_closeSocket(){if(this.socket)try{this.socket.onclose=null,this.socket.onerror=null,this.socket.onmessage=null,this.socket.close()}catch(e){F.debug(e.message)}this.socket=null}_emptyQueue(){return!0}_onClose(e){this._conn.connected&&!this._conn.disconnecting?(F.error("Websocket closed unexpectedly"),this._conn._doDisconnect()):e&&1006===e.code&&!this._conn.connected&&this.socket?(F.error("Websocket closed unexcectedly"),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._conn._doDisconnect()):F.debug("Websocket closed")}_no_auth_received(e){F.error("Server did not offer a supported authentication mechanism"),this._conn._changeConnectStatus(F.Status.CONNFAIL,F.ErrorCondition.NO_AUTH_MECH),e&&e.call(this._conn),this._conn._doDisconnect()}_onDisconnectTimeout(){}_abortAllRequests(){}_onError(e){F.error("Websocket error "+JSON.stringify(e)),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._disconnect()}_onIdle(){const e=this._conn._data;if(e.length>0&&!this._conn.paused){for(let t=0;t<e.length;t++)if(null!==e[t]){let n;n="restart"===e[t]?this._buildStream().tree():e[t];const i=F.serialize(n);this._conn.xmlOutput(n),this._conn.rawOutput(i),this.socket.send(i)}this._conn._data=[]}}_onMessage(e){let t;const n=\'<close xmlns="urn:ietf:params:xml:ns:xmpp-framing" />\';if(e.data===n)return this._conn.rawInput(n),this._conn.xmlInput(e),void(this._conn.disconnecting||this._conn._doDisconnect());if(0===e.data.search("<open ")){if(t=(new r).parseFromString(e.data,"text/xml").documentElement,!this._handleStreamStart(t))return}else{const n=this._streamWrap(e.data);t=(new r).parseFromString(n,"text/xml").documentElement}return this._checkStreamError(t,F.Status.ERROR)?void 0:this._conn.disconnecting&&"presence"===t.firstChild.nodeName&&"unavailable"===t.firstChild.getAttribute("type")?(this._conn.xmlInput(t),void this._conn.rawInput(F.serialize(t))):void this._conn._dataRecv(t,e.data)}_onOpen(){F.debug("Websocket open");const e=this._buildStream();this._conn.xmlOutput(e.tree());const t=F.serialize(e);this._conn.rawOutput(t),this.socket.send(t)}_reqToData(e){return e}_send(){this._conn.flush()}_sendRestart(){clearTimeout(this._conn._idleTimeout),this._conn._onIdle.bind(this._conn)()}};const V={};V.debug=F.LogLevel.DEBUG,V.info=F.LogLevel.INFO,V.warn=F.LogLevel.WARN,V.error=F.LogLevel.ERROR,V.fatal=F.LogLevel.FATAL,F.WorkerWebsocket=class extends F.Websocket{constructor(e){super(e),this._conn=e,this.worker=new SharedWorker(this._conn.options.worker,"Strophe XMPP Connection"),this.worker.onerror=e=>{var t;null===(t=console)||void 0===t||t.error(e),F.log(F.LogLevel.ERROR,`Shared Worker Error: ${e}`)}}get socket(){return{send:e=>this.worker.port.postMessage(["send",e])}}_connect(){this._messageHandler=e=>this._onInitialMessage(e),this.worker.port.start(),this.worker.port.onmessage=e=>this._onWorkerMessage(e),this.worker.port.postMessage(["_connect",this._conn.service,this._conn.jid])}_attach(e){this._messageHandler=e=>this._onMessage(e),this._conn.connect_callback=e,this.worker.port.start(),this.worker.port.onmessage=e=>this._onWorkerMessage(e),this.worker.port.postMessage(["_attach",this._conn.service])}_attachCallback(e,t){e===F.Status.ATTACHED?(this._conn.jid=t,this._conn.authenticated=!0,this._conn.connected=!0,this._conn.restored=!0,this._conn._changeConnectStatus(F.Status.ATTACHED)):e===F.Status.ATTACHFAIL&&(this._conn.authenticated=!1,this._conn.connected=!1,this._conn.restored=!1,this._conn._changeConnectStatus(F.Status.ATTACHFAIL))}_disconnect(e,t){t&&this._conn.send(t);const n=k("close",{xmlns:F.NS.FRAMING});this._conn.xmlOutput(n.tree());const i=F.serialize(n);this._conn.rawOutput(i),this.worker.port.postMessage(["send",i]),this._conn._doDisconnect()}_onClose(e){this._conn.connected&&!this._conn.disconnecting?(F.error("Websocket closed unexpectedly"),this._conn._doDisconnect()):e&&1006===e.code&&!this._conn.connected?(F.error("Websocket closed unexcectedly"),this._conn._changeConnectStatus(F.Status.CONNFAIL,"The WebSocket connection could not be established or was disconnected."),this._conn._doDisconnect()):F.debug("Websocket closed")}_closeSocket(){this.worker.port.postMessage(["_closeSocket"])}_replaceMessageHandler(){this._messageHandler=e=>this._onMessage(e)}_onWorkerMessage(e){const{data:t}=e,n=t[0];if("_onMessage"===n)this._messageHandler(t[1]);else if(n in this)try{this[n].apply(this,e.data.slice(1))}catch(e){F.log(F.LogLevel.ERROR,e)}else if("log"===n){const e=t[1],n=t[2];F.log(V[e],n)}else F.log(F.LogLevel.ERROR,`Found unhandled service worker message: ${t}`)}},t.$build=j.$build,t.$iq=j.$iq,t.$msg=j.$msg,t.$pres=j.$pres,t.Strophe=j.Strophe;const{b64_sha1:U}=A;e.$build=k,e.$iq=M,e.$msg=N,e.$pres=L,e.Strophe=F,e.b64_sha1=U,Object.defineProperty(e,"__esModule",{value:!0})}(t)},352:function(e,t,n){!function(e){"use strict";e.Strophe.addConnectionPlugin("disco",{_connection:null,_identities:[],_features:[],_items:[],init:function(t){this._connection=t,this._identities=[],this._features=[],this._items=[],t.addHandler(this._onDiscoInfo.bind(this),e.Strophe.NS.DISCO_INFO,"iq","get",null,null),t.addHandler(this._onDiscoItems.bind(this),e.Strophe.NS.DISCO_ITEMS,"iq","get",null,null)},addIdentity:function(e,t,n,i){for(var r=0;r<this._identities.length;r++)if(this._identities[r].category==e&&this._identities[r].type==t&&this._identities[r].name==n&&this._identities[r].lang==i)return!1;return this._identities.push({category:e,type:t,name:n,lang:i}),!0},addFeature:function(e){for(var t=0;t<this._features.length;t++)if(this._features[t]==e)return!1;return this._features.push(e),!0},removeFeature:function(e){for(var t=0;t<this._features.length;t++)if(this._features[t]===e)return this._features.splice(t,1),!0;return!1},addItem:function(e,t,n,i){return!(n&&!i||(this._items.push({jid:e,name:t,node:n,call_back:i}),0))},info:function(t,n,i,r,o){var s={xmlns:e.Strophe.NS.DISCO_INFO};n&&(s.node=n);var a=e.$iq({from:this._connection.jid,to:t,type:"get"}).c("query",s);this._connection.sendIQ(a,i,r,o)},items:function(t,n,i,r,o){var s={xmlns:e.Strophe.NS.DISCO_ITEMS};n&&(s.node=n);var a=e.$iq({from:this._connection.jid,to:t,type:"get"}).c("query",s);this._connection.sendIQ(a,i,r,o)},_buildIQResult:function(t,n){var i=t.getAttribute("id"),r=t.getAttribute("from"),o=e.$iq({type:"result",id:i});return null!==r&&o.attrs({to:r}),o.c("query",n)},_onDiscoInfo:function(t){var n,i=t.getElementsByTagName("query")[0].getAttribute("node"),r={xmlns:e.Strophe.NS.DISCO_INFO};i&&(r.node=i);var o=this._buildIQResult(t,r);for(n=0;n<this._identities.length;n++)r={category:this._identities[n].category,type:this._identities[n].type},this._identities[n].name&&(r.name=this._identities[n].name),this._identities[n].lang&&(r["xml:lang"]=this._identities[n].lang),o.c("identity",r).up();for(n=0;n<this._features.length;n++)o.c("feature",{var:this._features[n]}).up();return this._connection.send(o.tree()),!0},_onDiscoItems:function(t){var n,i,r={xmlns:e.Strophe.NS.DISCO_ITEMS},o=t.getElementsByTagName("query")[0].getAttribute("node");if(o){for(r.node=o,n=[],i=0;i<this._items.length;i++)if(this._items[i].node==o){n=this._items[i].call_back(t);break}}else n=this._items;var s=this._buildIQResult(t,r);for(i=0;i<n.length;i++){var a={jid:n[i].jid};n[i].name&&(a.name=n[i].name),n[i].node&&(a.node=n[i].node),s.c("item",a).up()}return this._connection.send(s.tree()),!0}})}(n(33))},617:function(e,t,n){!function(e){"use strict";e.Strophe.addConnectionPlugin("streamManagement",{logging:!1,autoSendCountOnEveryIncomingStanza:!1,requestResponseInterval:5,_c:null,_NS:"urn:xmpp:sm:3",_isStreamManagementEnabled:!1,_serverProcesssedStanzasCounter:null,_clientProcessedStanzasCounter:null,_clientSentStanzasCounter:null,_originalXMLOutput:null,_requestHandler:null,_incomingHandler:null,_requestResponseIntervalCount:0,_isSupported:!1,_unacknowledgedStanzas:[],_acknowledgedStanzaListeners:[],addAcknowledgedStanzaListener:function(e){this._acknowledgedStanzaListeners.push(e)},enable:function(t){if(!this._isSupported)throw new Error("The server doesn\'t support urn:xmpp:sm:3 namespace");if(this._connectionStatus!==e.Strophe.Status.CONNECTED)throw new Error("enable() can only be called in the CONNECTED state");this._c.send(e.$build("enable",{xmlns:this._NS,resume:t})),this._c.flush(),this._c.pause()},getResumeToken:function(){return this._resumeToken},isSupported(){return this._isSupported},resume:function(){if(!this.getResumeToken())throw new Error("No resume token");if(this._connectionStatus!==e.Strophe.Status.DISCONNECTED)throw new Error("resume() can only be called in the DISCONNECTED state");this._c.options.explicitResourceBinding=!0,this._resuming=!0,this._originalConnect.apply(this._c,this._connectArgs)},requestAcknowledgement:function(){if(this._connectionStatus!==e.Strophe.Status.CONNECTED)throw new Error("requestAcknowledgement() can only be called in the CONNECTED state");this._requestResponseIntervalCount=0,this._c.send(e.$build("r",{xmlns:this._NS}))},getOutgoingCounter:function(){return this._clientSentStanzasCounter},getIncomingCounter:function(){return this._clientProcessedStanzasCounter},init:function(t){this._c=t,e.Strophe.addNamespace("SM",this._NS),this._originalXMLOutput=this._c.xmlOutput,this._c.xmlOutput=this.xmlOutput.bind(this),this._originalConnect=this._c.connect,this._c.connect=this._interceptConnectArgs.bind(this),this._originalOnStreamFeaturesAfterSASL=this._c._onStreamFeaturesAfterSASL,this._c._onStreamFeaturesAfterSASL=this._onStreamFeaturesAfterSASL.bind(this),this._originalDoDisconnect=this._c._doDisconnect,this._c._doDisconnect=this._interceptDoDisconnect.bind(this),this._originalDisconnect=this._c.disconnect,this._c.disconnect=this._interceptDisconnect.bind(this)},_interceptDisconnect:function(){this._resumeToken=void 0,this._originalDisconnect.apply(this._c,arguments)},_interceptDoDisconnect:function(){this.getResumeToken()&&!this._resuming&&this._c.connected&&!this._c.disconnecting&&(this._resumeState={handlers:this._c.handlers,timedHandlers:this._c.timedHandlers,removeTimeds:this._c.removeTimeds,removeHandlers:this._c.removeHandlers,addTimeds:this._c.addTimeds,addHandlers:this._c.addHandlers},this._storedJid=this._c.jid,this.logging&&e.Strophe.debug("SM stored resume state, handler count: "+this._resumeState.handlers.length)),this._c._data=[],this._originalDoDisconnect.apply(this._c,arguments)},_interceptConnectArgs:function(){this._connectArgs=arguments,this._originalConnect.apply(this._c,arguments)},_onStreamFeaturesAfterSASL:function(e){return this._isSupported=e.getElementsByTagNameNS(this._NS,"sm").length>0,this._originalOnStreamFeaturesAfterSASL.apply(this._c,arguments)},statusChanged:function(t){if(this._connectionStatus=t,this.getResumeToken()||t!==e.Strophe.Status.CONNECTED&&t!==e.Strophe.Status.DISCONNECTED)if(t===e.Strophe.Status.BINDREQUIRED){this._c.jid=this._storedJid;for(const e of(this._resumeState.handlers||[]).concat(this._resumeState.addHandlers||[]))this._c._addSysHandler(e.handler,e.ns,e.name,e.type,e.id);for(const e of(this._resumeState.timedHandlers||[]).concat(this._resumeState.addTimeds))this._c.addTimedHandler(e.period,e.handler);for(const e of(this._resumeState.removeTimeds||[]).concat(this._resumeState.removeHandlers||[]))this._c.deleteTimedHandler(e);this._c.send(e.$build("resume",{xmlns:this._NS,h:this._clientProcessedStanzasCounter,previd:this._resumeToken})),this._c.flush()}else t===e.Strophe.Status.ERROR&&(this.logging&&e.Strophe.debug("SM cleared resume token on error"),this._resumeToken=void 0);else this.logging&&e.Strophe.debug("SM reset state"),this._serverProcesssedStanzasCounter=0,this._clientProcessedStanzasCounter=0,this._clientSentStanzasCounter=0,this._isStreamManagementEnabled=!1,this._requestResponseIntervalCount=0,this._resuming=!1,t===e.Strophe.Status.DISCONNECTED&&(this._isSupported=!1),this._unacknowledgedStanzas=[],this._requestHandler&&this._c.deleteHandler(this._requestHandler),this._incomingHandler&&this._c.deleteHandler(this._incomingHandler),this._requestHandler=this._c.addHandler(this._handleServerRequestHandler.bind(this),this._NS,"r"),this._ackHandler=this._c.addHandler(this._handleServerAck.bind(this),this._NS,"a"),this._incomingHandler=this._c.addHandler(this._incomingStanzaHandler.bind(this)),this._enabledHandler=this._c._addSysHandler(this._handleEnabled.bind(this),this._NS,"enabled"),this._resumeFailedHandler=this._c._addSysHandler(this._handleResumeFailed.bind(this),this._NS,"failed"),this._resumedHandler=this._c._addSysHandler(this._handleResumed.bind(this),this._NS,"resumed")},xmlOutput:function(t){return(e.Strophe.isTagEqual(t,"iq")||e.Strophe.isTagEqual(t,"presence")||e.Strophe.isTagEqual(t,"message"))&&this._increaseSentStanzasCounter(t),this._originalXMLOutput.call(this._c,t)},_handleEnabled:function(e){return this._isStreamManagementEnabled=!0,this._resumeToken="true"===e.getAttribute("resume")&&e.getAttribute("id"),this._c.resume(),!0},_handleResumeFailed:function(t){const n=t&&(t.firstElementChild&&t.firstElementChild.tagName||t.firstChild&&t.firstChild.tagName);return this._c._changeConnectStatus(e.Strophe.Status.ERROR,n,t),this._c._doDisconnect(),!0},_handleResumed:function(t){var n=parseInt(t.getAttribute("h"));if(this._handleAcknowledgedStanzas(n,this._serverProcesssedStanzasCounter),this._resuming=!1,this._c.do_bind=!1,this._c.authenticated=!0,this._c.restored=!0,this._unacknowledgedStanzas.length>0){this.logging&&e.Strophe.debug("SM Sending unacknowledged stanzas",this._unacknowledgedStanzas);for(const e of this._unacknowledgedStanzas)this._c.send(e)}else this.logging&&e.Strophe.debug("SM No unacknowledged stanzas",this._unacknowledgedStanzas);return this._c._changeConnectStatus(e.Strophe.Status.CONNECTED,null),!0},_incomingStanzaHandler:function(t){return(e.Strophe.isTagEqual(t,"iq")||e.Strophe.isTagEqual(t,"presence")||e.Strophe.isTagEqual(t,"message"))&&(this._increaseReceivedStanzasCounter(),this.autoSendCountOnEveryIncomingStanza&&this._answerProcessedStanzas()),!0},_handleAcknowledgedStanzas:function(t,n){var i=t-n;i<0&&this._throwError("New reported stanza count lower than previous. New: "+t+" - Previous: "+n),i>this._unacknowledgedStanzas.length&&this._throwError("Higher reported acknowledge count than unacknowledged stanzas. Reported Acknowledge Count: "+i+" - Unacknowledge Stanza Count: "+this._unacknowledgedStanzas.length+" - New: "+t+" - Previous: "+n);for(var r=0;r<i;r++)for(var o=this._unacknowledgedStanzas.shift(),s=0;s<this._acknowledgedStanzaListeners.length;s++)this._acknowledgedStanzaListeners[s](o);this.logging&&this._unacknowledgedStanzas.length>0&&e.Strophe.warn("SM Unacknowledged stanzas",this._unacknowledgedStanzas),this._serverProcesssedStanzasCounter=t,this.requestResponseInterval>0&&(this._requestResponseIntervalCount=0)},_handleServerRequestHandler:function(){return this._answerProcessedStanzas(),!0},_handleServerAck:function(e){var t=parseInt(e.getAttribute("h"));return this._handleAcknowledgedStanzas(t,this._serverProcesssedStanzasCounter),!0},_answerProcessedStanzas:function(){this._isStreamManagementEnabled&&this._c.send(e.$build("a",{xmlns:this._NS,h:this._clientProcessedStanzasCounter}))},_increaseSentStanzasCounter:function(t){if(this._isStreamManagementEnabled){if(-1!==this._unacknowledgedStanzas.indexOf(t))return;this._unacknowledgedStanzas.push(t),this._clientSentStanzasCounter++,this.requestResponseInterval>0&&(this._requestResponseIntervalCount++,this._requestResponseIntervalCount===this.requestResponseInterval&&setTimeout((()=>{this._connectionStatus===e.Strophe.Status.CONNECTED&&this.requestAcknowledgement()}),1))}},_increaseReceivedStanzasCounter:function(){this._isStreamManagementEnabled&&this._clientProcessedStanzasCounter++},_throwError:function(t){throw e.Strophe.error(t),new Error(t)}})}(n(33))},144:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;const n=[];for(let e=0;e<256;++e)n.push((e+256).toString(16).substr(1));t.default=function(e,t){const i=t||0,r=n;return(r[e[i+0]]+r[e[i+1]]+r[e[i+2]]+r[e[i+3]]+"-"+r[e[i+4]]+r[e[i+5]]+"-"+r[e[i+6]]+r[e[i+7]]+"-"+r[e[i+8]]+r[e[i+9]]+"-"+r[e[i+10]]+r[e[i+11]]+r[e[i+12]]+r[e[i+13]]+r[e[i+14]]+r[e[i+15]]).toLowerCase()}},433:(e,t,n)=>{"use strict";Object.defineProperty(t,"v1",{enumerable:!0,get:function(){return i.default}}),Object.defineProperty(t,"v3",{enumerable:!0,get:function(){return r.default}}),Object.defineProperty(t,"v4",{enumerable:!0,get:function(){return o.default}}),Object.defineProperty(t,"v5",{enumerable:!0,get:function(){return s.default}});var i=a(n(423)),r=a(n(89)),o=a(n(600)),s=a(n(400));function a(e){return e&&e.__esModule?e:{default:e}}},862:(e,t)=>{"use strict";function n(e){return 14+(e+64>>>9<<4)+1}function i(e,t){const n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function r(e,t,n,r,o,s){return i((a=i(i(t,e),i(r,s)))<<(d=o)|a>>>32-d,n);var a,d}function o(e,t,n,i,o,s,a){return r(t&n|~t&i,e,t,o,s,a)}function s(e,t,n,i,o,s,a){return r(t&i|n&~i,e,t,o,s,a)}function a(e,t,n,i,o,s,a){return r(t^n^i,e,t,o,s,a)}function d(e,t,n,i,o,s,a){return r(n^(t|~i),e,t,o,s,a)}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(e){if("string"==typeof e){const t=unescape(encodeURIComponent(e));e=new Uint8Array(t.length);for(let n=0;n<t.length;++n)e[n]=t.charCodeAt(n)}return function(e){const t=[],n=32*e.length,i="0123456789abcdef";for(let r=0;r<n;r+=8){const n=e[r>>5]>>>r%32&255,o=parseInt(i.charAt(n>>>4&15)+i.charAt(15&n),16);t.push(o)}return t}(function(e,t){e[t>>5]|=128<<t%32,e[n(t)-1]=t;let r=1732584193,c=-271733879,l=-1732584194,h=271733878;for(let t=0;t<e.length;t+=16){const n=r,u=c,p=l,m=h;r=o(r,c,l,h,e[t],7,-680876936),h=o(h,r,c,l,e[t+1],12,-389564586),l=o(l,h,r,c,e[t+2],17,606105819),c=o(c,l,h,r,e[t+3],22,-1044525330),r=o(r,c,l,h,e[t+4],7,-176418897),h=o(h,r,c,l,e[t+5],12,1200080426),l=o(l,h,r,c,e[t+6],17,-1473231341),c=o(c,l,h,r,e[t+7],22,-45705983),r=o(r,c,l,h,e[t+8],7,1770035416),h=o(h,r,c,l,e[t+9],12,-1958414417),l=o(l,h,r,c,e[t+10],17,-42063),c=o(c,l,h,r,e[t+11],22,-1990404162),r=o(r,c,l,h,e[t+12],7,1804603682),h=o(h,r,c,l,e[t+13],12,-40341101),l=o(l,h,r,c,e[t+14],17,-1502002290),c=o(c,l,h,r,e[t+15],22,1236535329),r=s(r,c,l,h,e[t+1],5,-165796510),h=s(h,r,c,l,e[t+6],9,-1069501632),l=s(l,h,r,c,e[t+11],14,643717713),c=s(c,l,h,r,e[t],20,-373897302),r=s(r,c,l,h,e[t+5],5,-701558691),h=s(h,r,c,l,e[t+10],9,38016083),l=s(l,h,r,c,e[t+15],14,-660478335),c=s(c,l,h,r,e[t+4],20,-405537848),r=s(r,c,l,h,e[t+9],5,568446438),h=s(h,r,c,l,e[t+14],9,-1019803690),l=s(l,h,r,c,e[t+3],14,-187363961),c=s(c,l,h,r,e[t+8],20,1163531501),r=s(r,c,l,h,e[t+13],5,-1444681467),h=s(h,r,c,l,e[t+2],9,-51403784),l=s(l,h,r,c,e[t+7],14,1735328473),c=s(c,l,h,r,e[t+12],20,-1926607734),r=a(r,c,l,h,e[t+5],4,-378558),h=a(h,r,c,l,e[t+8],11,-2022574463),l=a(l,h,r,c,e[t+11],16,1839030562),c=a(c,l,h,r,e[t+14],23,-35309556),r=a(r,c,l,h,e[t+1],4,-1530992060),h=a(h,r,c,l,e[t+4],11,1272893353),l=a(l,h,r,c,e[t+7],16,-155497632),c=a(c,l,h,r,e[t+10],23,-1094730640),r=a(r,c,l,h,e[t+13],4,681279174),h=a(h,r,c,l,e[t],11,-358537222),l=a(l,h,r,c,e[t+3],16,-722521979),c=a(c,l,h,r,e[t+6],23,76029189),r=a(r,c,l,h,e[t+9],4,-640364487),h=a(h,r,c,l,e[t+12],11,-421815835),l=a(l,h,r,c,e[t+15],16,530742520),c=a(c,l,h,r,e[t+2],23,-995338651),r=d(r,c,l,h,e[t],6,-198630844),h=d(h,r,c,l,e[t+7],10,1126891415),l=d(l,h,r,c,e[t+14],15,-1416354905),c=d(c,l,h,r,e[t+5],21,-57434055),r=d(r,c,l,h,e[t+12],6,1700485571),h=d(h,r,c,l,e[t+3],10,-1894986606),l=d(l,h,r,c,e[t+10],15,-1051523),c=d(c,l,h,r,e[t+1],21,-2054922799),r=d(r,c,l,h,e[t+8],6,1873313359),h=d(h,r,c,l,e[t+15],10,-30611744),l=d(l,h,r,c,e[t+6],15,-1560198380),c=d(c,l,h,r,e[t+13],21,1309151649),r=d(r,c,l,h,e[t+4],6,-145523070),h=d(h,r,c,l,e[t+11],10,-1120210379),l=d(l,h,r,c,e[t+2],15,718787259),c=d(c,l,h,r,e[t+9],21,-343485551),r=i(r,n),c=i(c,u),l=i(l,p),h=i(h,m)}return[r,c,l,h]}(function(e){if(0===e.length)return[];const t=8*e.length,i=new Uint32Array(n(t));for(let n=0;n<t;n+=8)i[n>>5]|=(255&e[n/8])<<n%32;return i}(e),8*e.length))}},294:(e,t)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(){if(!n)throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return n(i)};const n="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto),i=new Uint8Array(16)},585:(e,t)=>{"use strict";function n(e,t,n,i){switch(e){case 0:return t&n^~t&i;case 1:case 3:return t^n^i;case 2:return t&n^t&i^n&i}}function i(e,t){return e<<t|e>>>32-t}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;t.default=function(e){const t=[1518500249,1859775393,2400959708,3395469782],r=[1732584193,4023233417,2562383102,271733878,3285377520];if("string"==typeof e){const t=unescape(encodeURIComponent(e));e=[];for(let n=0;n<t.length;++n)e.push(t.charCodeAt(n))}e.push(128);const o=e.length/4+2,s=Math.ceil(o/16),a=new Array(s);for(let t=0;t<s;++t){const n=new Uint32Array(16);for(let i=0;i<16;++i)n[i]=e[64*t+4*i]<<24|e[64*t+4*i+1]<<16|e[64*t+4*i+2]<<8|e[64*t+4*i+3];a[t]=n}a[s-1][14]=8*(e.length-1)/Math.pow(2,32),a[s-1][14]=Math.floor(a[s-1][14]),a[s-1][15]=8*(e.length-1)&4294967295;for(let e=0;e<s;++e){const o=new Uint32Array(80);for(let t=0;t<16;++t)o[t]=a[e][t];for(let e=16;e<80;++e)o[e]=i(o[e-3]^o[e-8]^o[e-14]^o[e-16],1);let s=r[0],d=r[1],c=r[2],l=r[3],h=r[4];for(let e=0;e<80;++e){const r=Math.floor(e/20),a=i(s,5)+n(r,d,c,l)+h+t[r]+o[e]>>>0;h=l,l=c,c=i(d,30)>>>0,d=s,s=a}r[0]=r[0]+s>>>0,r[1]=r[1]+d>>>0,r[2]=r[2]+c>>>0,r[3]=r[3]+l>>>0,r[4]=r[4]+h>>>0}return[r[0]>>24&255,r[0]>>16&255,r[0]>>8&255,255&r[0],r[1]>>24&255,r[1]>>16&255,r[1]>>8&255,255&r[1],r[2]>>24&255,r[2]>>16&255,r[2]>>8&255,255&r[2],r[3]>>24&255,r[3]>>16&255,r[3]>>8&255,255&r[3],r[4]>>24&255,r[4]>>16&255,r[4]>>8&255,255&r[4]]}},423:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(294)),r=o(n(144));function o(e){return e&&e.__esModule?e:{default:e}}let s,a,d=0,c=0;t.default=function(e,t,n){let o=t&&n||0;const l=t||[];let h=(e=e||{}).node||s,u=void 0!==e.clockseq?e.clockseq:a;if(null==h||null==u){const t=e.random||(e.rng||i.default)();null==h&&(h=s=[1|t[0],t[1],t[2],t[3],t[4],t[5]]),null==u&&(u=a=16383&(t[6]<<8|t[7]))}let p=void 0!==e.msecs?e.msecs:Date.now(),m=void 0!==e.nsecs?e.nsecs:c+1;const g=p-d+(m-c)/1e4;if(g<0&&void 0===e.clockseq&&(u=u+1&16383),(g<0||p>d)&&void 0===e.nsecs&&(m=0),m>=1e4)throw new Error("uuid.v1(): Can\'t create more than 10M uuids/sec");d=p,c=m,a=u,p+=122192928e5;const f=(1e4*(268435455&p)+m)%4294967296;l[o++]=f>>>24&255,l[o++]=f>>>16&255,l[o++]=f>>>8&255,l[o++]=255&f;const v=p/4294967296*1e4&268435455;l[o++]=v>>>8&255,l[o++]=255&v,l[o++]=v>>>24&15|16,l[o++]=v>>>16&255,l[o++]=u>>>8|128,l[o++]=255&u;for(let e=0;e<6;++e)l[o+e]=h[e];return t||(0,r.default)(l)}},89:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(929)),r=o(n(862));function o(e){return e&&e.__esModule?e:{default:e}}var s=(0,i.default)("v3",48,r.default);t.default=s},929:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=function(e,t,n){function i(e,i,o,s){const a=o&&s||0;if("string"==typeof e&&(e=function(e){e=unescape(encodeURIComponent(e));const t=[];for(let n=0;n<e.length;++n)t.push(e.charCodeAt(n));return t}(e)),"string"==typeof i&&(i=function(e){const t=[];return e.replace(/[a-fA-F0-9]{2}/g,(function(e){t.push(parseInt(e,16))})),t}(i)),!Array.isArray(e))throw TypeError("value must be an array of bytes");if(!Array.isArray(i)||16!==i.length)throw TypeError("namespace must be uuid string or an Array of 16 byte values");const d=n(i.concat(e));if(d[6]=15&d[6]|t,d[8]=63&d[8]|128,o)for(let e=0;e<16;++e)o[a+e]=d[e];return o||(0,r.default)(d)}try{i.name=e}catch(e){}return i.DNS=o,i.URL=s,i},t.URL=t.DNS=void 0;var i,r=(i=n(144))&&i.__esModule?i:{default:i};const o="6ba7b810-9dad-11d1-80b4-00c04fd430c8";t.DNS=o;const s="6ba7b811-9dad-11d1-80b4-00c04fd430c8";t.URL=s},600:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(294)),r=o(n(144));function o(e){return e&&e.__esModule?e:{default:e}}t.default=function(e,t,n){"string"==typeof e&&(t="binary"===e?new Uint8Array(16):null,e=null);const o=(e=e||{}).random||(e.rng||i.default)();if(o[6]=15&o[6]|64,o[8]=63&o[8]|128,t){const e=n||0;for(let n=0;n<16;++n)t[e+n]=o[n];return t}return(0,r.default)(o)}},400:(e,t,n)=>{"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=o(n(929)),r=o(n(585));function o(e){return e&&e.__esModule?e:{default:e}}var s=(0,i.default)("v5",80,r.default);t.default=s},987:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{AUDIO_OUTPUT_DEVICE_CHANGED:()=>T,AUDIO_SSRCS_REMAPPED:()=>O,CREATE_ANSWER_FAILED:()=>r,CREATE_OFFER_FAILED:()=>o,DATA_CHANNEL_CLOSED:()=>a,DATA_CHANNEL_OPEN:()=>s,DEVICE_LIST_AVAILABLE:()=>R,DEVICE_LIST_CHANGED:()=>C,DEVICE_LIST_WILL_CHANGE:()=>x,DOMINANT_SPEAKER_CHANGED:()=>c,ENDPOINT_CONN_STATUS_CHANGED:()=>d,ENDPOINT_MESSAGE_RECEIVED:()=>A,ENDPOINT_STATS_RECEIVED:()=>w,FORWARDED_SOURCES_CHANGED:()=>l,LASTN_VALUE_CHANGED:()=>p,LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED:()=>g,LOCAL_TRACK_SSRC_UPDATED:()=>m,LOCAL_UFRAG_CHANGED:()=>I,PERMISSIONS_CHANGED:()=>h,REMOTE_TRACK_ADDED:()=>v,REMOTE_TRACK_MUTE:()=>_,REMOTE_TRACK_REMOVED:()=>E,REMOTE_TRACK_UNMUTE:()=>y,REMOTE_UFRAG_CHANGED:()=>P,RTCEvents:()=>i,SENDER_VIDEO_CONSTRAINTS_CHANGED:()=>u,SET_LOCAL_DESCRIPTION_FAILED:()=>S,SET_REMOTE_DESCRIPTION_FAILED:()=>b,TRACK_ATTACHED:()=>f,VIDEO_SSRCS_REMAPPED:()=>D,default:()=>k}),function(e){e.CREATE_ANSWER_FAILED="rtc.create_answer_failed",e.CREATE_OFFER_FAILED="rtc.create_offer_failed",e.DATA_CHANNEL_OPEN="rtc.data_channel_open",e.DATA_CHANNEL_CLOSED="rtc.data_channel_closed",e.ENDPOINT_CONN_STATUS_CHANGED="rtc.endpoint_conn_status_changed",e.DOMINANT_SPEAKER_CHANGED="rtc.dominant_speaker_changed",e.FORWARDED_SOURCES_CHANGED="rtc.forwarded_sources_changed",e.PERMISSIONS_CHANGED="rtc.permissions_changed",e.SENDER_VIDEO_CONSTRAINTS_CHANGED="rtc.sender_video_constraints_changed",e.LASTN_VALUE_CHANGED="rtc.lastn_value_changed",e.LOCAL_TRACK_SSRC_UPDATED="rtc.local_track_ssrc_updated",e.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED="rtc.local_track_max_enabled_resolution_changed",e.TRACK_ATTACHED="rtc.track_attached",e.REMOTE_TRACK_ADDED="rtc.remote_track_added",e.REMOTE_TRACK_MUTE="rtc.remote_track_mute",e.REMOTE_TRACK_REMOVED="rtc.remote_track_removed",e.REMOTE_TRACK_UNMUTE="rtc.remote_track_unmute",e.SET_LOCAL_DESCRIPTION_FAILED="rtc.set_local_description_failed",e.SET_REMOTE_DESCRIPTION_FAILED="rtc.set_remote_description_failed",e.AUDIO_OUTPUT_DEVICE_CHANGED="rtc.audio_output_device_changed",e.DEVICE_LIST_CHANGED="rtc.device_list_changed",e.DEVICE_LIST_WILL_CHANGE="rtc.device_list_will_change",e.DEVICE_LIST_AVAILABLE="rtc.device_list_available",e.ENDPOINT_MESSAGE_RECEIVED="rtc.endpoint_message_received",e.ENDPOINT_STATS_RECEIVED="rtc.endpoint_stats_received",e.LOCAL_UFRAG_CHANGED="rtc.local_ufrag_changed",e.REMOTE_UFRAG_CHANGED="rtc.remote_ufrag_changed",e.VIDEO_SSRCS_REMAPPED="rtc.video_ssrcs_remapped",e.AUDIO_SSRCS_REMAPPED="rtc.audio_ssrcs_remapped"}(i||(i={}));const r=i.CREATE_ANSWER_FAILED,o=i.CREATE_OFFER_FAILED,s=i.DATA_CHANNEL_OPEN,a=i.DATA_CHANNEL_CLOSED,d=i.ENDPOINT_CONN_STATUS_CHANGED,c=i.DOMINANT_SPEAKER_CHANGED,l=i.FORWARDED_SOURCES_CHANGED,h=i.PERMISSIONS_CHANGED,u=i.SENDER_VIDEO_CONSTRAINTS_CHANGED,p=i.LASTN_VALUE_CHANGED,m=i.LOCAL_TRACK_SSRC_UPDATED,g=i.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,f=i.TRACK_ATTACHED,v=i.REMOTE_TRACK_ADDED,_=i.REMOTE_TRACK_MUTE,E=i.REMOTE_TRACK_REMOVED,y=i.REMOTE_TRACK_UNMUTE,S=i.SET_LOCAL_DESCRIPTION_FAILED,b=i.SET_REMOTE_DESCRIPTION_FAILED,T=i.AUDIO_OUTPUT_DEVICE_CHANGED,C=i.DEVICE_LIST_CHANGED,x=i.DEVICE_LIST_WILL_CHANGE,R=i.DEVICE_LIST_AVAILABLE,A=i.ENDPOINT_MESSAGE_RECEIVED,w=i.ENDPOINT_STATS_RECEIVED,I=i.LOCAL_UFRAG_CHANGED,P=i.REMOTE_UFRAG_CHANGED,D=i.VIDEO_SSRCS_REMAPPED,O=i.AUDIO_SSRCS_REMAPPED,k=i},125:e=>{e.exports={2160:{width:3840,height:2160},"4k":{width:3840,height:2160},1080:{width:1920,height:1080},fullhd:{width:1920,height:1080},720:{width:1280,height:720},hd:{width:1280,height:720},540:{width:960,height:540},qhd:{width:960,height:540},480:{width:640,height:480},vga:{width:640,height:480},360:{width:640,height:360},240:{width:320,height:240},180:{width:320,height:180}}},408:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{VideoType:()=>i}),function(e){e.CAMERA="camera",e.DESKTOP="desktop"}(i||(i={}))},514:e=>{e.exports={IDENTITY_UPDATED:"authentication.identity_updated"}},680:(e,t,n)=>{"use strict";n.d(t,{D:()=>i});const i="local"},609:(e,t,n)=>{"use strict";let i;n.r(t),n.d(t,{XMPPEvents:()=>i}),function(e){e.ADD_ICE_CANDIDATE_FAILED="xmpp.add_ice_candidate_failed",e.AUDIO_MUTED_BY_FOCUS="xmpp.audio_muted_by_focus",e.VIDEO_MUTED_BY_FOCUS="xmpp.video_muted_by_focus",e.AUTHENTICATION_REQUIRED="xmpp.authentication_required",e.BRIDGE_DOWN="xmpp.bridge_down",e.CALL_ACCEPTED="xmpp.callaccepted.jingle",e.CALL_INCOMING="xmpp.callincoming.jingle",e.CALL_ENDED="xmpp.callended.jingle",e.CHAT_ERROR_RECEIVED="xmpp.chat_error_received",e.SETTINGS_ERROR_RECEIVED="xmpp.settings_error_received",e.CONFERENCE_PROPERTIES_CHANGED="xmpp.conference_properties_changed",e.CONNECTION_ESTABLISHED="xmpp.connection.connected",e.CONNECTION_FAILED="xmpp.connection.failed",e.CONNECTION_INTERRUPTED="xmpp.connection.interrupted",e.CONNECTION_RESTORED="xmpp.connection.restored",e.CONNECTION_ICE_FAILED="xmpp.connection.ice.failed",e.CONNECTION_RESTARTED="xmpp.connection.restart",e.CONNECTION_STATUS_CHANGED="xmpp.connection.status.changed",e.DISPLAY_NAME_CHANGED="xmpp.display_name_changed",e.DISPLAY_NAME_REQUIRED="xmpp.display_name_required",e.EMUC_ROOM_ADDED="xmpp.emuc_room_added",e.EMUC_ROOM_REMOVED="xmpp.emuc_room_removed",e.ETHERPAD="xmpp.etherpad",e.FOCUS_DISCONNECTED="xmpp.focus_disconnected",e.FOCUS_LEFT="xmpp.focus_left",e.GRACEFUL_SHUTDOWN="xmpp.graceful_shutdown",e.ICE_RESTARTING="rtc.ice_restarting",e.ICE_RESTART_SUCCESS="rtc.ice_restart_success",e.KICKED="xmpp.kicked",e.LOCAL_ROLE_CHANGED="xmpp.localrole_changed",e.MEETING_ID_SET="xmpp.meeting_id_set",e.MESSAGE_RECEIVED="xmpp.message_received",e.INVITE_MESSAGE_RECEIVED="xmpp.invite_message_received",e.PRIVATE_MESSAGE_RECEIVED="xmpp.private_message_received",e.MUC_MEMBER_BOT_TYPE_CHANGED="xmpp.muc_member_bot_type_changed",e.MUC_DESTROYED="xmpp.muc_destroyed",e.MUC_JOIN_IN_PROGRESS="xmpp.muc_join_in_progress",e.MUC_JOINED="xmpp.muc_joined",e.MUC_MEMBER_JOINED="xmpp.muc_member_joined",e.MUC_MEMBER_LEFT="xmpp.muc_member_left",e.MUC_LOBBY_MEMBER_JOINED="xmpp.muc_lobby_member_joined",e.MUC_LOBBY_MEMBER_UPDATED="xmpp.muc_lobby_member_updated",e.MUC_LOBBY_MEMBER_LEFT="xmpp.muc_lobby_member_left",e.MUC_DENIED_ACCESS="xmpp.muc_denied access",e.MUC_LEFT="xmpp.muc_left",e.MUC_ROLE_CHANGED="xmpp.muc_role_changed",e.MUC_LOCK_CHANGED="xmpp.muc_lock_changed",e.MUC_MEMBERS_ONLY_CHANGED="xmpp.muc_members_only_changed",e.MUC_VISITORS_SUPPORTED_CHANGED="xmpp.muc_visitors_supported_changed",e.PARTICIPANT_AUDIO_MUTED="xmpp.audio_muted",e.PARTICIPANT_VIDEO_MUTED="xmpp.video_muted",e.PARTICIPANT_VIDEO_TYPE_CHANGED="xmpp.video_type",e.PARTICIPANT_FEATURES_CHANGED="xmpp.participant_features_changed",e.PASSWORD_REQUIRED="xmpp.password_required",e.PHONE_NUMBER_CHANGED="conference.phoneNumberChanged",e.PRESENCE_RECEIVED="xmpp.presence_received",e.PRESENCE_STATUS="xmpp.presence_status",e.PROMPT_FOR_LOGIN="xmpp.prompt_for_login",e.READY_TO_JOIN="xmpp.ready_to_join",e.RECORDER_STATE_CHANGED="xmpp.recorderStateChanged",e.REMOTE_STATS="xmpp.remote_stats",e.RENEGOTIATION_FAILED="xmpp.renegotiation_failed",e.RESERVATION_ERROR="xmpp.room_reservation_error",e.ROOM_CONNECT_ERROR="xmpp.room_connect_error",e.ROOM_CONNECT_NOT_ALLOWED_ERROR="xmpp.room_connect_error.not_allowed",e.ROOM_JOIN_ERROR="xmpp.room_join_error",e.ROOM_CONNECT_MEMBERS_ONLY_ERROR="xmpp.room_connect_error.members_only",e.ROOM_DISCO_INFO_UPDATED="xmpp.room_disco_info_updated",e.ROOM_DISCO_INFO_FAILED="xmpp.room_disco_info_failed",e.ROOM_MAX_USERS_ERROR="xmpp.room_max_users_error",e.SENDING_CHAT_MESSAGE="xmpp.sending_chat_message",e.SENDING_PRIVATE_CHAT_MESSAGE="xmpp.sending_private_chat_message",e.SESSION_ACCEPT="xmpp.session_accept",e.SESSION_ACCEPT_ERROR="xmpp.session_accept_error",e.SESSION_ACCEPT_TIMEOUT="xmpp.session_accept_timeout",e.SOURCE_ADD="xmpp.source_add",e.SOURCE_ADD_ERROR="xmpp.source_add_error",e.SOURCE_REMOVE="xmpp.source_remove",e.SOURCE_REMOVE_ERROR="xmpp.source_remove_error",e.SPEAKER_STATS_RECEIVED="xmpp.speaker_stats_received",e.CONFERENCE_TIMESTAMP_RECEIVED="xmpp.conference_timestamp_received",e.AV_MODERATION_APPROVED="xmpp.av_moderation.approved",e.AV_MODERATION_REJECTED="xmpp.av_moderation.rejected",e.AV_MODERATION_RECEIVED="xmpp.av_moderation.received",e.AV_MODERATION_CHANGED="xmpp.av_moderation.changed",e.AV_MODERATION_PARTICIPANT_APPROVED="xmpp.av_moderation.participant.approved",e.AV_MODERATION_PARTICIPANT_REJECTED="xmpp.av_moderation.participant.rejected",e.BREAKOUT_ROOMS_MOVE_TO_ROOM="xmpp.breakout-rooms.move-to-room",e.BREAKOUT_ROOMS_EVENT="xmpp.breakout-rooms.event",e.BREAKOUT_ROOMS_UPDATED="xmpp.breakout-rooms.updated",e.ROOM_METADATA_EVENT="xmpp.room-metadata.event",e.ROOM_METADATA_UPDATED="xmpp.room-metadata.updated",e.START_MUTED_FROM_FOCUS="xmpp.start_muted_from_focus",e.SUBJECT_CHANGED="xmpp.subject_changed",e.SUSPEND_DETECTED="xmpp.suspend_detected",e.TRANSCRIPTION_STATUS_CHANGED="xmpp.transcription_status_changed",e.TRANSPORT_INFO="xmpp.transportinfo.jingle",e.VIDEO_SIP_GW_AVAILABILITY_CHANGED="xmpp.videoSIPGWAvailabilityChanged",e.VIDEO_SIP_GW_SESSION_STATE_CHANGED="xmpp.videoSIPGWSessionStateChanged",e.VISITORS_MESSAGE="xmpp.visitors_message",e.VISITORS_REJECTION="xmpp.visitors_rejection",e.ICE_CONNECTION_STATE_CHANGED="xmpp.ice_connection_state_changed",e.JSON_MESSAGE_RECEIVED="xmmp.json_message_received"}(i||(i={}))},526:(e,t,n)=>{"use strict";n.d(t,{Z:()=>mu});var i={};n.r(i),n.d(i,{AUTHENTICATION_REQUIRED:()=>T,CHAT_ERROR:()=>C,CONFERENCE_ACCESS_DENIED:()=>O,CONFERENCE_DESTROYED:()=>R,CONFERENCE_MAX_USERS:()=>A,CONFERENCE_RESTARTED:()=>I,CONNECTION_ERROR:()=>w,DISPLAY_NAME_REQUIRED:()=>k,FOCUS_DISCONNECTED:()=>N,FOCUS_LEFT:()=>M,GRACEFUL_SHUTDOWN:()=>L,ICE_FAILED:()=>F,INCOMPATIBLE_SERVER_VERSIONS:()=>j,JitsiConferenceErrors:()=>b,MEMBERS_ONLY_ERROR:()=>D,NOT_ALLOWED_ERROR:()=>P,OFFER_ANSWER_FAILED:()=>V,PASSWORD_NOT_SUPPORTED:()=>U,PASSWORD_REQUIRED:()=>H,RESERVATION_ERROR:()=>$,SETTINGS_ERROR:()=>x,VIDEOBRIDGE_NOT_AVAILABLE:()=>J});var r={};n.r(r),n.d(r,{AUDIO_INPUT_STATE_CHANGE:()=>z,AUDIO_UNMUTE_PERMISSIONS_CHANGED:()=>K,AUTH_STATUS_CHANGED:()=>W,AV_MODERATION_APPROVED:()=>X,AV_MODERATION_CHANGED:()=>Y,AV_MODERATION_PARTICIPANT_APPROVED:()=>Q,AV_MODERATION_PARTICIPANT_REJECTED:()=>Z,AV_MODERATION_REJECTED:()=>ee,BEFORE_STATISTICS_DISPOSED:()=>te,BOT_TYPE_CHANGED:()=>ne,BREAKOUT_ROOMS_MOVE_TO_ROOM:()=>ie,BREAKOUT_ROOMS_UPDATED:()=>re,CONFERENCE_CREATED_TIMESTAMP:()=>oe,CONFERENCE_ERROR:()=>se,CONFERENCE_FAILED:()=>ae,CONFERENCE_JOINED:()=>ce,CONFERENCE_JOIN_IN_PROGRESS:()=>de,CONFERENCE_LEFT:()=>le,CONFERENCE_UNIQUE_ID_SET:()=>he,CONFERENCE_VISITOR_CODECS_CHANGED:()=>ue,CONNECTION_ESTABLISHED:()=>pe,CONNECTION_INTERRUPTED:()=>me,CONNECTION_RESTORED:()=>ge,DATA_CHANNEL_CLOSED:()=>fe,DATA_CHANNEL_OPENED:()=>ve,DISPLAY_NAME_CHANGED:()=>_e,DOMINANT_SPEAKER_CHANGED:()=>Ee,DTMF_SUPPORT_CHANGED:()=>ye,E2EE_VERIFICATION_AVAILABLE:()=>Se,E2EE_VERIFICATION_COMPLETED:()=>be,E2EE_VERIFICATION_READY:()=>Te,ENDPOINT_MESSAGE_RECEIVED:()=>Ce,ENDPOINT_STATS_RECEIVED:()=>xe,FORWARDED_SOURCES_CHANGED:()=>Re,JVB121_STATUS:()=>Ae,JitsiConferenceEvents:()=>B,KICKED:()=>we,LAST_N_ENDPOINTS_CHANGED:()=>Ie,LOBBY_USER_JOINED:()=>Pe,LOBBY_USER_LEFT:()=>De,LOBBY_USER_UPDATED:()=>Oe,LOCK_STATE_CHANGED:()=>ke,MEMBERS_ONLY_CHANGED:()=>Ne,MESSAGE_RECEIVED:()=>Me,METADATA_UPDATED:()=>Le,NOISY_MIC:()=>je,NON_PARTICIPANT_MESSAGE_RECEIVED:()=>Ve,NO_AUDIO_INPUT:()=>Fe,P2P_STATUS:()=>Ue,PARTCIPANT_FEATURES_CHANGED:()=>Be,PARTICIPANT_KICKED:()=>He,PARTICIPANT_PROPERTY_CHANGED:()=>qe,PARTICIPANT_SOURCE_UPDATED:()=>$e,PHONE_NUMBER_CHANGED:()=>Ge,PRIVATE_MESSAGE_RECEIVED:()=>Je,PROPERTIES_CHANGED:()=>ze,RECORDER_STATE_CHANGED:()=>Ke,SERVER_REGION_CHANGED:()=>We,STARTED_MUTED:()=>Ye,START_MUTED_POLICY_CHANGED:()=>Xe,SUBJECT_CHANGED:()=>Qe,SUSPEND_DETECTED:()=>Ze,TALK_WHILE_MUTED:()=>et,TRACK_ADDED:()=>tt,TRACK_AUDIO_LEVEL_CHANGED:()=>nt,TRACK_MUTE_CHANGED:()=>it,TRACK_REMOVED:()=>rt,TRACK_UNMUTE_REJECTED:()=>ot,TRANSCRIPTION_STATUS_CHANGED:()=>st,USER_JOINED:()=>at,USER_LEFT:()=>dt,USER_ROLE_CHANGED:()=>ct,USER_STATUS_CHANGED:()=>lt,VIDEO_SIP_GW_AVAILABILITY_CHANGED:()=>ht,VIDEO_SIP_GW_SESSION_STATE_CHANGED:()=>ut,VIDEO_UNMUTE_PERMISSIONS_CHANGED:()=>pt,VISITORS_MESSAGE:()=>gt,VISITORS_REJECTION:()=>ft,VISITORS_SUPPORTED_CHANGED:()=>mt,_MEDIA_SESSION_ACTIVE_CHANGED:()=>G,_MEDIA_SESSION_STARTED:()=>q});var o={};n.r(o),n.d(o,{JitsiTrackEvents:()=>bt,LOCAL_TRACK_STOPPED:()=>Tt,NO_AUDIO_INPUT:()=>It,NO_DATA_FROM_SOURCE:()=>wt,TRACK_AUDIO_LEVEL_CHANGED:()=>Ct,TRACK_AUDIO_OUTPUT_CHANGED:()=>xt,TRACK_MUTE_CHANGED:()=>Rt,TRACK_OWNER_CHANGED:()=>Dt,TRACK_REMOVED:()=>Ot,TRACK_STREAMING_STATUS_CHANGED:()=>Pt,TRACK_VIDEOTYPE_CHANGED:()=>At});var s={};n.r(s),n.d(s,{RTCStatsEvents:()=>Zn,RTC_STATS_PC_EVENT:()=>ti,RTC_STATS_WC_DISCONNECTED:()=>ei});var a={};n.r(a),n.d(a,{CONSTRAINT_FAILED:()=>Gi,ELECTRON_DESKTOP_PICKER_ERROR:()=>zi,ELECTRON_DESKTOP_PICKER_NOT_FOUND:()=>Ki,GENERAL:()=>Wi,JitsiTrackErrors:()=>qi,NOT_FOUND:()=>Xi,PERMISSION_DENIED:()=>Yi,SCREENSHARING_GENERIC_ERROR:()=>Qi,SCREENSHARING_USER_CANCELED:()=>Zi,TIMEOUT:()=>er,TRACK_IS_DISPOSED:()=>tr,TRACK_NO_STREAM_FOUND:()=>nr,TRACK_NO_STREAM_TRACKS_FOUND:()=>or,TRACK_TOO_MANY_TRACKS_IN_STREAM:()=>rr,UNSUPPORTED_RESOLUTION:()=>ir});var d={};n.r(d),n.d(d,{CONNECTION_DISCONNECTED:()=>lr,CONNECTION_ESTABLISHED:()=>hr,CONNECTION_FAILED:()=>ur,CONNECTION_REDIRECTED:()=>pr,DISPLAY_NAME_REQUIRED:()=>gr,JitsiConnectionEvents:()=>cr,PROPERTIES_UPDATED:()=>fr,WRONG_STATE:()=>mr});var c={};n.r(c),n.d(c,{CONNECTION_DROPPED_ERROR:()=>yr,JitsiConnectionErrors:()=>Er,OTHER_ERROR:()=>Sr,PASSWORD_REQUIRED:()=>br,SERVER_ERROR:()=>Tr});var l={};n.r(l),n.d(l,{JitsiTranscriptionStatus:()=>Wo,OFF:()=>Yo,ON:()=>Xo});var h={};n.r(h),n.d(h,{fixNegotiationNeeded:()=>cd,shimAddTrackRemoveTrack:()=>ad,shimAddTrackRemoveTrackWithNative:()=>sd,shimGetDisplayMedia:()=>ed,shimGetSendersWithDtmf:()=>id,shimGetStats:()=>rd,shimGetUserMedia:()=>Za,shimMediaStream:()=>td,shimOnTrack:()=>nd,shimPeerConnection:()=>dd,shimSenderReceiverGetStats:()=>od});var u={};n.r(u),n.d(u,{shimAddTransceiver:()=>_d,shimCreateAnswer:()=>Sd,shimCreateOffer:()=>yd,shimGetDisplayMedia:()=>hd,shimGetParameters:()=>Ed,shimGetUserMedia:()=>ld,shimOnTrack:()=>ud,shimPeerConnection:()=>pd,shimRTCDataChannel:()=>vd,shimReceiverGetStats:()=>gd,shimRemoveStream:()=>fd,shimSenderGetStats:()=>md});var p={};n.r(p),n.d(p,{shimAudioContext:()=>Pd,shimCallbacksAPI:()=>Cd,shimConstraints:()=>Rd,shimCreateOfferLegacy:()=>Id,shimGetUserMedia:()=>xd,shimLocalStreamsAPI:()=>bd,shimRTCIceServerUrls:()=>Ad,shimRemoteStreamsAPI:()=>Td,shimTrackEventTransceiver:()=>wd});var m={};n.r(m),n.d(m,{removeExtmapAllowMixed:()=>Md,shimAddIceCandidateNullOrEmpty:()=>Ld,shimConnectionState:()=>Nd,shimMaxMessageSize:()=>Od,shimParameterlessSetLocalDescription:()=>Fd,shimRTCIceCandidate:()=>Dd,shimSendThrowTypeError:()=>kd});var g={};n.r(g),n.d(g,{ConnectionQualityEvents:()=>cl,LOCAL_STATS_UPDATED:()=>ml,REMOTE_STATS_UPDATED:()=>gl});var f={};n.r(f),n.d(f,{AUDIO_INPUT_STATE_CHANGE:()=>Rl,DETECTOR_STATE_CHANGE:()=>xl,DetectionEvents:()=>Cl,NO_AUDIO_INPUT:()=>Al,VAD_NOISY_DEVICE:()=>wl,VAD_REPORT_PUBLISHED:()=>Il,VAD_SCORE_PUBLISHED:()=>Pl,VAD_TALK_WHILE_MUTED:()=>Dl});var v={};n.r(v),n.d(v,{E2E_RTT_CHANGED:()=>Hl,E2ePingEvents:()=>Ul});var _={};n.r(_),n.d(_,{ERROR_NO_CONNECTION:()=>Ph,ERROR_SESSION_EXISTS:()=>Dh,STATE_FAILED:()=>Ih,STATE_OFF:()=>Rh,STATE_ON:()=>xh,STATE_PENDING:()=>Ah,STATE_RETRYING:()=>wh,STATUS_AVAILABLE:()=>bh,STATUS_BUSY:()=>Ch,STATUS_UNDEFINED:()=>Th,VideoSIPGWErrorConstants:()=>Sh,VideoSIPGWStateConstants:()=>yh,VideoSIPGWStatusConstants:()=>Eh});var E={};n.r(E),n.d(E,{DEVICE_LIST_CHANGED:()=>Gh,JitsiMediaDevicesEvents:()=>qh,PERMISSIONS_CHANGED:()=>zh,PERMISSION_PROMPT_IS_SHOWN:()=>Kh,SLOW_GET_USER_MEDIA:()=>Wh});var y=n(810),S=n.n(y);let b;!function(e){e.AUTHENTICATION_REQUIRED="conference.authenticationRequired",e.CHAT_ERROR="conference.chatError",e.SETTINGS_ERROR="conference.settingsError",e.CONFERENCE_DESTROYED="conference.destroyed",e.CONFERENCE_MAX_USERS="conference.max_users",e.CONNECTION_ERROR="conference.connectionError",e.CONFERENCE_RESTARTED="conference.restarted",e.NOT_ALLOWED_ERROR="conference.connectionError.notAllowed",e.MEMBERS_ONLY_ERROR="conference.connectionError.membersOnly",e.CONFERENCE_ACCESS_DENIED="conference.connectionError.accessDenied",e.DISPLAY_NAME_REQUIRED="conference.display_name_required",e.FOCUS_DISCONNECTED="conference.focusDisconnected",e.FOCUS_LEFT="conference.focusLeft",e.GRACEFUL_SHUTDOWN="conference.gracefulShutdown",e.ICE_FAILED="conference.iceFailed",e.INCOMPATIBLE_SERVER_VERSIONS="conference.incompatible_server_versions",e.OFFER_ANSWER_FAILED="conference.offerAnswerFailed",e.PASSWORD_NOT_SUPPORTED="conference.passwordNotSupported",e.PASSWORD_REQUIRED="conference.passwordRequired",e.RESERVATION_ERROR="conference.reservationError",e.VIDEOBRIDGE_NOT_AVAILABLE="conference.videobridgeNotAvailable"}(b||(b={}));const T=b.AUTHENTICATION_REQUIRED,C=b.CHAT_ERROR,x=b.SETTINGS_ERROR,R=b.CONFERENCE_DESTROYED,A=b.CONFERENCE_MAX_USERS,w=b.CONNECTION_ERROR,I=b.CONFERENCE_RESTARTED,P=b.NOT_ALLOWED_ERROR,D=b.MEMBERS_ONLY_ERROR,O=b.CONFERENCE_ACCESS_DENIED,k=b.DISPLAY_NAME_REQUIRED,N=b.FOCUS_DISCONNECTED,M=b.FOCUS_LEFT,L=b.GRACEFUL_SHUTDOWN,F=b.ICE_FAILED,j=b.INCOMPATIBLE_SERVER_VERSIONS,V=b.OFFER_ANSWER_FAILED,U=b.PASSWORD_NOT_SUPPORTED,H=b.PASSWORD_REQUIRED,$=b.RESERVATION_ERROR,J=b.VIDEOBRIDGE_NOT_AVAILABLE;let B;!function(e){e._MEDIA_SESSION_ACTIVE_CHANGED="conference.media_session.active_changed",e._MEDIA_SESSION_STARTED="conference.media_session.started",e.AUDIO_INPUT_STATE_CHANGE="conference.audio_input_state_changed",e.AUDIO_UNMUTE_PERMISSIONS_CHANGED="conference.audio_unmute_permissions_changed",e.AUTH_STATUS_CHANGED="conference.auth_status_changed",e.AV_MODERATION_APPROVED="conference.av_moderation.approved",e.AV_MODERATION_CHANGED="conference.av_moderation.changed",e.AV_MODERATION_PARTICIPANT_APPROVED="conference.av_moderation.participant.approved",e.AV_MODERATION_PARTICIPANT_REJECTED="conference.av_moderation.participant.rejected",e.AV_MODERATION_REJECTED="conference.av_moderation.rejected",e.BEFORE_STATISTICS_DISPOSED="conference.beforeStatisticsDisposed",e.BOT_TYPE_CHANGED="conference.bot_type_changed",e.BREAKOUT_ROOMS_MOVE_TO_ROOM="conference.breakout-rooms.move-to-room",e.BREAKOUT_ROOMS_UPDATED="conference.breakout-rooms.updated",e.CONFERENCE_CREATED_TIMESTAMP="conference.createdTimestamp",e.CONFERENCE_ERROR="conference.error",e.CONFERENCE_FAILED="conference.failed",e.CONFERENCE_JOIN_IN_PROGRESS="conference.join_in_progress",e.CONFERENCE_JOINED="conference.joined",e.CONFERENCE_LEFT="conference.left",e.CONFERENCE_UNIQUE_ID_SET="conference.unique_id_set",e.CONFERENCE_VISITOR_CODECS_CHANGED="conference.visitor_codecs_changed",e.CONNECTION_ESTABLISHED="conference.connectionEstablished",e.CONNECTION_INTERRUPTED="conference.connectionInterrupted",e.CONNECTION_RESTORED="conference.connectionRestored",e.DATA_CHANNEL_CLOSED="conference.dataChannelClosed",e.DATA_CHANNEL_OPENED="conference.dataChannelOpened",e.DISPLAY_NAME_CHANGED="conference.displayNameChanged",e.DOMINANT_SPEAKER_CHANGED="conference.dominantSpeaker",e.DTMF_SUPPORT_CHANGED="conference.dtmfSupportChanged",e.E2EE_VERIFICATION_AVAILABLE="conference.e2ee.verification.available",e.E2EE_VERIFICATION_COMPLETED="conference.e2ee.verification.completed",e.E2EE_VERIFICATION_READY="conference.e2ee.verification.ready",e.ENDPOINT_MESSAGE_RECEIVED="conference.endpoint_message_received",e.ENDPOINT_STATS_RECEIVED="conference.endpoint_stats_received",e.FORWARDED_SOURCES_CHANGED="conference.forwardedSourcesChanged",e.JVB121_STATUS="conference.jvb121Status",e.KICKED="conference.kicked",e.LAST_N_ENDPOINTS_CHANGED="conference.lastNEndpointsChanged",e.LOBBY_USER_JOINED="conference.lobby.userJoined",e.LOBBY_USER_LEFT="conference.lobby.userLeft",e.LOBBY_USER_UPDATED="conference.lobby.userUpdated",e.LOCK_STATE_CHANGED="conference.lock_state_changed",e.MEMBERS_ONLY_CHANGED="conference.membersOnlyChanged",e.MESSAGE_RECEIVED="conference.messageReceived",e.METADATA_UPDATED="conference.metadata.updated",e.NO_AUDIO_INPUT="conference.no_audio_input",e.NOISY_MIC="conference.noisy_mic",e.NON_PARTICIPANT_MESSAGE_RECEIVED="conference.non_participant_message_received",e.P2P_STATUS="conference.p2pStatus",e.PARTCIPANT_FEATURES_CHANGED="conference.partcipant_features_changed",e.PARTICIPANT_KICKED="conference.participant_kicked",e.PARTICIPANT_PROPERTY_CHANGED="conference.participant_property_changed",e.PARTICIPANT_SOURCE_UPDATED="conference.participant_source_updated",e.PHONE_NUMBER_CHANGED="conference.phoneNumberChanged",e.PRIVATE_MESSAGE_RECEIVED="conference.privateMessageReceived",e.PROPERTIES_CHANGED="conference.propertiesChanged",e.RECORDER_STATE_CHANGED="conference.recorderStateChanged",e.SERVER_REGION_CHANGED="conference.server_region_changed",e.START_MUTED_POLICY_CHANGED="conference.start_muted_policy_changed",e.STARTED_MUTED="conference.started_muted",e.SUBJECT_CHANGED="conference.subjectChanged",e.SUSPEND_DETECTED="conference.suspendDetected",e.TALK_WHILE_MUTED="conference.talk_while_muted",e.TRACK_ADDED="conference.trackAdded",e.TRACK_AUDIO_LEVEL_CHANGED="conference.audioLevelsChanged",e.TRACK_MUTE_CHANGED="conference.trackMuteChanged",e.TRACK_REMOVED="conference.trackRemoved",e.TRACK_UNMUTE_REJECTED="conference.trackUnmuteRejected",e.TRANSCRIPTION_STATUS_CHANGED="conference.transcriptionStatusChanged",e.USER_JOINED="conference.userJoined",e.USER_LEFT="conference.userLeft",e.USER_ROLE_CHANGED="conference.roleChanged",e.USER_STATUS_CHANGED="conference.statusChanged",e.VIDEO_SIP_GW_AVAILABILITY_CHANGED="conference.videoSIPGWAvailabilityChanged",e.VIDEO_SIP_GW_SESSION_STATE_CHANGED="conference.videoSIPGWSessionStateChanged",e.VIDEO_UNMUTE_PERMISSIONS_CHANGED="conference.video_unmute_permissions_changed",e.VISITORS_SUPPORTED_CHANGED="conference.visitorsSupported",e.VISITORS_MESSAGE="conference.visitors_message",e.VISITORS_REJECTION="conference.visitors_rejection"}(B||(B={}));const q=B._MEDIA_SESSION_STARTED,G=B._MEDIA_SESSION_ACTIVE_CHANGED,z=B.AUDIO_INPUT_STATE_CHANGE,K=B.AUDIO_UNMUTE_PERMISSIONS_CHANGED,W=B.AUTH_STATUS_CHANGED,X=B.AV_MODERATION_APPROVED,Y=B.AV_MODERATION_CHANGED,Q=B.AV_MODERATION_PARTICIPANT_APPROVED,Z=B.AV_MODERATION_PARTICIPANT_REJECTED,ee=B.AV_MODERATION_REJECTED,te=B.BEFORE_STATISTICS_DISPOSED,ne=B.BOT_TYPE_CHANGED,ie=B.BREAKOUT_ROOMS_MOVE_TO_ROOM,re=B.BREAKOUT_ROOMS_UPDATED,oe=B.CONFERENCE_CREATED_TIMESTAMP,se=B.CONFERENCE_ERROR,ae=B.CONFERENCE_FAILED,de=B.CONFERENCE_JOIN_IN_PROGRESS,ce=B.CONFERENCE_JOINED,le=B.CONFERENCE_LEFT,he=B.CONFERENCE_UNIQUE_ID_SET,ue=B.CONFERENCE_VISITOR_CODECS_CHANGED,pe=B.CONNECTION_ESTABLISHED,me=B.CONNECTION_INTERRUPTED,ge=B.CONNECTION_RESTORED,fe=B.DATA_CHANNEL_CLOSED,ve=B.DATA_CHANNEL_OPENED,_e=B.DISPLAY_NAME_CHANGED,Ee=B.DOMINANT_SPEAKER_CHANGED,ye=B.DTMF_SUPPORT_CHANGED,Se=B.E2EE_VERIFICATION_AVAILABLE,be=B.E2EE_VERIFICATION_COMPLETED,Te=B.E2EE_VERIFICATION_READY,Ce=B.ENDPOINT_MESSAGE_RECEIVED,xe=B.ENDPOINT_STATS_RECEIVED,Re=B.FORWARDED_SOURCES_CHANGED,Ae=B.JVB121_STATUS,we=B.KICKED,Ie=B.LAST_N_ENDPOINTS_CHANGED,Pe=B.LOBBY_USER_JOINED,De=B.LOBBY_USER_LEFT,Oe=B.LOBBY_USER_UPDATED,ke=B.LOCK_STATE_CHANGED,Ne=B.MEMBERS_ONLY_CHANGED,Me=B.MESSAGE_RECEIVED,Le=B.METADATA_UPDATED,Fe=B.NO_AUDIO_INPUT,je=B.NOISY_MIC,Ve=B.NON_PARTICIPANT_MESSAGE_RECEIVED,Ue=B.P2P_STATUS,He=B.PARTICIPANT_KICKED,$e=B.PARTICIPANT_SOURCE_UPDATED,Je=B.PRIVATE_MESSAGE_RECEIVED,Be=B.PARTCIPANT_FEATURES_CHANGED,qe=B.PARTICIPANT_PROPERTY_CHANGED,Ge=B.PHONE_NUMBER_CHANGED,ze=B.PROPERTIES_CHANGED,Ke=B.RECORDER_STATE_CHANGED,We=B.SERVER_REGION_CHANGED,Xe=B.START_MUTED_POLICY_CHANGED,Ye=B.STARTED_MUTED,Qe=B.SUBJECT_CHANGED,Ze=B.SUSPEND_DETECTED,et=B.TALK_WHILE_MUTED,tt=B.TRACK_ADDED,nt=B.TRACK_AUDIO_LEVEL_CHANGED,it=B.TRACK_MUTE_CHANGED,rt=B.TRACK_REMOVED,ot=B.TRACK_UNMUTE_REJECTED,st=B.TRANSCRIPTION_STATUS_CHANGED,at=B.USER_JOINED,dt=B.USER_LEFT,ct=B.USER_ROLE_CHANGED,lt=B.USER_STATUS_CHANGED,ht=B.VIDEO_SIP_GW_AVAILABILITY_CHANGED,ut=B.VIDEO_SIP_GW_SESSION_STATE_CHANGED,pt=B.VIDEO_UNMUTE_PERMISSIONS_CHANGED,mt=B.VISITORS_SUPPORTED_CHANGED,gt=B.VISITORS_MESSAGE,ft=B.VISITORS_REJECTION;var vt=n(387),_t=n.n(vt),Et=n(47),yt=n.n(Et),St=n(33);let bt;!function(e){e.LOCAL_TRACK_STOPPED="track.stopped",e.TRACK_AUDIO_LEVEL_CHANGED="track.audioLevelsChanged",e.TRACK_AUDIO_OUTPUT_CHANGED="track.audioOutputChanged",e.TRACK_MUTE_CHANGED="track.trackMuteChanged",e.TRACK_VIDEOTYPE_CHANGED="track.videoTypeChanged",e.NO_DATA_FROM_SOURCE="track.no_data_from_source",e.NO_AUDIO_INPUT="track.no_audio_input",e.TRACK_STREAMING_STATUS_CHANGED="track.streaming_status_changed",e.TRACK_OWNER_CHANGED="track.owner_changed",e.TRACK_REMOVED="track.removed"}(bt||(bt={}));const Tt=bt.LOCAL_TRACK_STOPPED,Ct=bt.TRACK_AUDIO_LEVEL_CHANGED,xt=bt.TRACK_AUDIO_OUTPUT_CHANGED,Rt=bt.TRACK_MUTE_CHANGED,At=bt.TRACK_VIDEOTYPE_CHANGED,wt=bt.NO_DATA_FROM_SOURCE,It=bt.NO_AUDIO_INPUT,Pt=bt.TRACK_STREAMING_STATUS_CHANGED,Dt=bt.TRACK_OWNER_CHANGED,Ot=bt.TRACK_REMOVED;let kt;!function(e){e.TYPE_OPERATIONAL="operational",e.TYPE_PAGE="page",e.TYPE_TRACK="track",e.TYPE_UI="ui",e.ACTION_JINGLE_RESTART="restart",e.ACTION_JINGLE_SA_TIMEOUT="session-accept.timeout",e.ACTION_JINGLE_SI_RECEIVED="session-initiate.received",e.ACTION_JINGLE_SI_TIMEOUT="session-initiate.timeout",e.ACTION_JINGLE_TERMINATE="terminate",e.ACTION_JINGLE_TR_RECEIVED="transport-replace.received",e.ACTION_JINGLE_TR_SUCCESS="transport-replace.success",e.ACTION_P2P_DECLINED="decline",e.ACTION_P2P_ESTABLISHED="established",e.ACTION_P2P_FAILED="failed",e.ACTION_P2P_SWITCH_TO_JVB="switch.to.jvb",e.AVAILABLE_DEVICE="available.device",e.CONNECTION_DISCONNECTED="connection.disconnected",e.FEEDBACK="feedback",e.ICE_DURATION="ice.duration",e.ICE_ESTABLISHMENT_DURATION_DIFF="ice.establishment.duration.diff",e.ICE_STATE_CHANGED="ice.state.changed",e.NO_BYTES_SENT="track.no-bytes-sent",e.TRACK_UNMUTED="track.unmuted"}(kt||(kt={}));const Nt=kt.TYPE_OPERATIONAL,Mt=kt.TYPE_PAGE,Lt=kt.TYPE_TRACK,Ft=kt.TYPE_UI,jt=kt.ACTION_JINGLE_RESTART,Vt=kt.ACTION_JINGLE_SA_TIMEOUT,Ut=kt.ACTION_JINGLE_SI_RECEIVED,Ht=kt.ACTION_JINGLE_SI_TIMEOUT,$t=kt.ACTION_JINGLE_TERMINATE,Jt=kt.ACTION_JINGLE_TR_RECEIVED,Bt=kt.ACTION_JINGLE_TR_SUCCESS,qt=kt.ACTION_P2P_DECLINED,Gt=kt.ACTION_P2P_ESTABLISHED,zt=kt.ACTION_P2P_FAILED,Kt=kt.ACTION_P2P_SWITCH_TO_JVB,Wt=kt.AVAILABLE_DEVICE,Xt=kt.CONNECTION_DISCONNECTED,Yt=kt.FEEDBACK,Qt=kt.ICE_DURATION,Zt=kt.ICE_ESTABLISHMENT_DURATION_DIFF,en=kt.ICE_STATE_CHANGED,tn=kt.NO_BYTES_SENT,nn=kt.TRACK_UNMUTED,rn=(e,t,n)=>({type:kt.TYPE_OPERATIONAL,action:"connection.failed",attributes:{error_type:e,error_message:t,...n}}),on=(e,t)=>({action:e,attributes:t,source:"conference",type:kt.TYPE_OPERATIONAL}),sn=(e,t)=>({action:"connection.stage.reached",actionSubject:e,attributes:t,source:"connection.stage.reached",type:kt.TYPE_OPERATIONAL}),an=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,source:"get.user.media",action:e,attributes:t}},dn=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,action:e,source:"jingle",attributes:t}},cn=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return{type:kt.TYPE_OPERATIONAL,action:e,source:"p2p",attributes:t}},ln=e=>({type:kt.TYPE_OPERATIONAL,action:"remotely.muted",mediaType:e}),hn=e=>({type:kt.TYPE_OPERATIONAL,action:"rtp.stats",attributes:e});let un;!function(e){e.AUDIO_LEVEL="statistics.audioLevel",e.BEFORE_DISPOSED="statistics.before_disposed",e.BYTE_SENT_STATS="statistics.byte_sent_stats",e.CONNECTION_STATS="statistics.connectionstats",e.LONG_TASKS_STATS="statistics.long_tasks_stats"}(un||(un={}));const pn=un.AUDIO_LEVEL,mn=un.BEFORE_DISPOSED,gn=un.BYTE_SENT_STATS,fn=un.CONNECTION_STATS,vn=un.LONG_TASKS_STATS;var _n=n(122);const En="chrome",yn="safari",Sn="electron",bn="react-native",Tn={Chrome:En,Firefox:"firefox",Safari:yn,Electron:Sn},Cn="blink",xn="webkit",Rn="gecko",An={Blink:Cn,WebKit:xn,Gecko:Rn};function wn(e){return{name:Tn[e.name],version:e.version,engine:An[e.engine],engineVersion:e.engineVersion}}class In{constructor(e){this._parser=new _n.UAParser(navigator.userAgent);const{name:t,version:n,engine:i,engineVersion:r}=e?wn(e):function(e){const t=function(){const e=navigator.userAgent.match(/\\b(react[ \\t_-]*native)(?:\\/(\\S+))?/i);let t;if(e||"ReactNative"===navigator.product){let n;return e&&e.length>2&&(n=e[1],t=e[2]),n||(n="react-native"),t||(t="unknown"),{name:bn,version:t}}}();if(t)return t;const{name:n,version:i}=e.getBrowser(),{name:r,version:o}=e.getEngine();return wn({name:n,version:i,engine:r,engineVersion:o})}(this._parser);this._name=t,this._version=n,this._engine=i,this._engineVersion=r}isChrome(){return this._name===En||this._engine===Cn}isFirefox(){return this._engine===Rn}isSafari(){return this._name===yn}isElectron(){return this._name===Sn}isReactNative(){return this._name===bn}isChromiumBased(){return this._engine===Cn}isWebKitBased(){return this._engine===xn}getName(){return this._name?this._name:this._parser.getBrowser().name}getVersion(){return this._version?this._version:this._parser.getBrowser().version}getEngine(){return this._engine}getEngineVersion(){return this._engineVersion}getOS(){return this._parser.getOS().name}getOSVersion(){return this._parser.getOS().version}isVersionGreaterThan(e){if(this._version)return parseInt(this._version,10)>parseInt(e,10)}isVersionLessThan(e){if(this._version)return parseInt(this._version,10)<parseInt(e,10)}isVersionEqualTo(e){if(this._version)return parseInt(this._version,10)===parseInt(e,10)}isEngineVersionGreaterThan(e){if(this._engineVersion)return parseInt(this._engineVersion,10)>parseInt(e,10)}isEngineVersionLessThan(e){if(this._engineVersion)return parseInt(this._engineVersion,10)<parseInt(e,10)}isEngineVersionEqualTo(e){if(this._engineVersion)return parseInt(this._engineVersion,10)===parseInt(e,10)}}const Pn=(0,y.getLogger)("rtctstats");function Dn(e,t){const n=JSON.parse(JSON.stringify(t));Object.keys(n).forEach((t=>{const i=n[t];delete i.id,e[t]&&Object.keys(i).forEach((r=>{i[r]===e[t][r]&&delete n[t][r]}))}));let i=-1/0;return Object.keys(n).forEach((e=>{const t=n[e];t.timestamp>i&&(i=t.timestamp)})),Object.keys(n).forEach((e=>{const t=n[e];t.timestamp===i&&(t.timestamp=0)})),n.timestamp=i,n}function On(e){return{id:e.id,tracks:e.getTracks().map((e=>({id:e.id,kind:e.kind,label:e.label,enabled:e.enabled,muted:e.muted,readyState:e.readyState})))}}var kn,Nn=new Uint8Array(16);function Mn(){if(!kn&&!(kn="undefined"!=typeof crypto&&crypto.getRandomValues&&crypto.getRandomValues.bind(crypto)||"undefined"!=typeof msCrypto&&"function"==typeof msCrypto.getRandomValues&&msCrypto.getRandomValues.bind(msCrypto)))throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");return kn(Nn)}const Ln=/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;for(var Fn=[],jn=0;jn<256;++jn)Fn.push((jn+256).toString(16).substr(1));const Vn=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=(Fn[e[t+0]]+Fn[e[t+1]]+Fn[e[t+2]]+Fn[e[t+3]]+"-"+Fn[e[t+4]]+Fn[e[t+5]]+"-"+Fn[e[t+6]]+Fn[e[t+7]]+"-"+Fn[e[t+8]]+Fn[e[t+9]]+"-"+Fn[e[t+10]]+Fn[e[t+11]]+Fn[e[t+12]]+Fn[e[t+13]]+Fn[e[t+14]]+Fn[e[t+15]]).toLowerCase();if(!function(e){return"string"==typeof e&&Ln.test(e)}(n))throw TypeError("Stringified UUID is invalid");return n},Un=function(e,t,n){var i=(e=e||{}).random||(e.rng||Mn)();if(i[6]=15&i[6]|64,i[8]=63&i[8]|128,t){n=n||0;for(var r=0;r<16;++r)t[n+r]=i[r];return t}return Vn(i)},Hn="3.1",$n=6e5,Jn={SequenceNumber:"sn"},Bn=3001,qn=3002,Gn=[Bn,qn],zn=1e3;var Kn=n(483),Wn=n.n(Kn);function Xn(e){return 0===e.indexOf("[")||-1!==e.indexOf(":")?"x:x:x:x:x:x:x:x":"x.x.x.x"}function Yn(e){const t=Wn().parseCandidate(e);return"relay"!==t.type&&"ssltcp"!==t.protocol&&(t.ip=Xn(t.ip),t.address=Xn(t.address)),t.relatedAddress&&(t.relatedAddress=Xn(t.relatedAddress)),Wn().writeCandidate(t)}function Qn(e){let t,n,i,r,{endpoint:o,meetingFqn:s,onCloseCallback:a,useLegacy:d,obfuscate:c=!0,pingInterval:l=3e4}=e,h=[],u=Un(),p=0,m=!1,g=1;const f=d?`${Hn}_LEGACY`:`${Hn}_STANDARD`,v=e=>{e.push((new Date).getTime()),e.push(g++)},_=e=>{const t=Object.assign({},e);"identity"!==t.type&&t.data&&(t.data=JSON.stringify(t.data)),n&&n.readyState===WebSocket.OPEN&&m&&n.send(JSON.stringify(t))},E=function(e){_(e),h.length<zn&&e.data&&h.push(e)};return E.isConnected=function(){if(!n)return!1;const{readyState:e}=n;return e===WebSocket.OPEN},E.isClosed=function(){if(!n)return!0;const{readyState:e}=n;return e===WebSocket.CLOSED},E.identity=function(){for(var e=arguments.length,n=new Array(e),i=0;i<e;i++)n[i]=arguments[i];v(n),t&&(n[2].parentStatsSessionId=t),E({statsSessionId:u,type:"identity",data:n})},E.statsEntry=function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];let i=t;if(c){switch(t[0]){case"addIceCandidate":case"onicecandidate":case"setLocalDescription":case"setRemoteDescription":i=JSON.parse(JSON.stringify(i))}!function(e){switch(e[0]){case"addIceCandidate":case"onicecandidate":if(e[2]&&e[2].candidate){const t=e[2];t.candidate=Yn(t.candidate),e[2]=t}break;case"setLocalDescription":case"setRemoteDescription":case"createOfferOnSuccess":case"createAnswerOnSuccess":e[2]&&e[2].sdp&&(e[2].sdp=(n=e[2].sdp,`${Wn().splitLines(n).map((e=>0===e.indexOf("a=candidate:")?`a=${Yn(e)}`:0===e.indexOf("c=")?"c=IN IP4 0.0.0.0":0===e.indexOf("a=rtcp:")?"a=rtcp:9 IN IP4 0.0.0.0":e)).join("\\r\\n").trim()}\\r\\n`));break;case"getStats":case"getstats":e[2]&&(t=e[2],Object.keys(t).forEach((e=>{const n=t[e];n&&(["ipAddress","ip","address"].forEach((e=>{n[e]&&"relay"!==n.candidateType&&(n[e]=Xn(n[e]))})),["googLocalAddress","googRemoteAddress"].forEach((e=>{let t,i,r;n[e]&&(r="["===n[e][0]?"]:":":",[i,t]=n[e].split(r),n[e]=`${Xn(i)}:${t}`)})))})))}var t,n}(i)}v(i),E({statsSessionId:u,type:"stats-entry",data:i})},E.keepAlive=function(){E({statsSessionId:u,type:"keepalive"})},E.close=function(){n&&n.close(Bn)},E.connect=function(e){let d=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e&&!t&&(t=u),t&&(u=Un(),h.forEach((e=>{e.statsSessionId=u}))),n&&n.close(),n=new WebSocket(`${o}/${s}?statsSessionId=${u}&isReconnect=${d}`,f,{headers:{"User-Agent":navigator.userAgent}}),n.onclose=function(t){if(i&&clearInterval(i),m&&(m=!1),a({code:t.code,reason:t.reason}),!Gn.includes(t.code)&&p<$n){const t=2**p*1e3+Math.floor(1e4*Math.random()),n=p+t<$n?t:$n-p;p+=n,r=setTimeout((()=>E.connect(e,!0)),n)}},n.onopen=function(){i=setInterval(E.keepAlive,l)},n.onmessage=async function(e){const{type:t,body:i}=JSON.parse(e.data);if(t===Jn.SequenceNumber){const{value:e,state:t}=i;if(h.length){const t=h[0].data[4],i=h[h.length-1].data[4];if(e<t-1&&e>i)return void(n&&n.close(qn));const r=h.findIndex((t=>t.data[4]===e));h=h.slice(r+1)}if("initial"===t){r&&clearTimeout(r),p=0,m=!0;for(let e=0;e<h.length;e++)_(h[e])}}}},E}let Zn;!function(e){e.RTC_STATS_WC_DISCONNECTED="rtcstats_ws_disconnected",e.RTC_STATS_PC_EVENT="rtstats_pc_event"}(Zn||(Zn={}));const ei=Zn.RTC_STATS_WC_DISCONNECTED,ti=Zn.RTC_STATS_PC_EVENT;var ni=n(857);class ii extends ni.EventEmitter{constructor(){super(),this.addEventListener=this.addListener,this.removeEventListener=this.removeListener}}function ri(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}const oi=(0,y.getLogger)("modules/RTCStats/RTCStats.ts"),si=new class{constructor(){ri(this,"_initialized",!1),ri(this,"_trace",null),ri(this,"events",new ii)}init(e){const{analytics:{rtcstatsUseLegacy:t=!1,rtcstatsPollInterval:n=1e4,rtcstatsSendSdp:i=!1,rtcstatsEnabled:r=!1}={}}=e;r&&!this._initialized&&(function(e,t){let{statsEntry:n}=e,{connectionFilter:i,pollInterval:r,useLegacy:o,sendSdp:s=!1,prefixesToWrap:a=[""],eventCallback:d}=t,c=0;const l=new In,h=l.isFirefox(),u=l.isChromiumBased(),p=l.isWebKitBased(),m=l.isReactNative();if(h||u||p||m){if(a.forEach((e=>{if(!window[`${e}RTCPeerConnection`])return;const t=window[`${e}RTCPeerConnection`],a=function(e){let s=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const a={...e},{optional:l=[]}=s;let g=!1;try{l.some((e=>!0===e.rtcStatsSFUP2P))&&(g=!0);const a=new t(e,s);if(i&&i(e))return a;const f="PC_"+c++;a.__rtcStatsId=f,e||(e={nullConfig:!0}),((e=JSON.parse(JSON.stringify(e)))&&e.iceServers||[]).forEach((e=>{delete e.credential})),e.browserType=h?"moz":"webkit",n("create",f,e),a.__dtlsTransport=null,n("constraints",f,s),a.addEventListener("icecandidate",(e=>{n("onicecandidate",f,e.candidate)})),a.addEventListener("addstream",(e=>{n("onaddstream",f,`${e.stream.id} ${e.stream.getTracks().map((e=>`${e.kind}:${e.id}`))}`)})),a.addEventListener("track",(e=>{n("ontrack",f,`${e.track.kind}:${e.track.id} ${e.streams.map((e=>`stream:${e.id}`))}`)})),a.addEventListener("removestream",(e=>{n("onremovestream",f,`${e.stream.id} ${e.stream.getTracks().map((e=>`${e.kind}:${e.id}`))}`)})),a.addEventListener("signalingstatechange",(()=>{n("onsignalingstatechange",f,a.signalingState)})),a.addEventListener("iceconnectionstatechange",(()=>{const{iceConnectionState:e}=a;n("oniceconnectionstatechange",f,e),null==d||d({type:"iceconnectionstatechange",body:{pcId:f,isP2P:g,state:e}})})),a.addEventListener("icegatheringstatechange",(()=>{n("onicegatheringstatechange",f,a.iceGatheringState)})),a.addEventListener("connectionstatechange",(()=>{const{connectionState:e}=a;n("onconnectionstatechange",f,a.connectionState),null==d||d({type:"connectionstatechange",body:{pcId:f,isP2P:g,state:e}})})),a.addEventListener("negotiationneeded",(()=>{n("onnegotiationneeded",f,void 0)})),a.addEventListener("datachannel",(e=>{n("ondatachannel",f,[e.channel.id,e.channel.label])}));let v={};const _=function(){h||p||m||u&&!o?a.getStats(null).then((e=>{const t=function(e){if(!e.entries)return e;const t={};return e.forEach(((e,n)=>{t[n]=e})),t}(e),i=JSON.parse(JSON.stringify(t));n("getstats",f,Dn(v,t)),v=i})):u&&a.getStats((e=>{const t=function(e,t){const n={};return t.result().forEach((e=>{const t={id:e.id,timestamp:e.timestamp.getTime(),type:e.type};e.names().forEach((n=>{t[n]=e.stat(n)})),n[t.id]=t})),n}(0,e),i=JSON.parse(JSON.stringify(t));n("getstats",f,Dn(v,t)),v=i}))};if(r){const e=window.setInterval((()=>{"closed"!==a.signalingState&&"closed"!==a.iceConnectionState?_():window.clearInterval(e)}),r)}return a.addEventListener("connectionstatechange",(()=>{["connected","failed"].includes(a.connectionState)&&_()})),a}catch(e){return console.error("RTCStats PeerConnection bind failed: ",e),new t(a,s)}};["createDataChannel","close"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{n(e,this.__rtcStatsId,arguments)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addStream","removeStream"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0],i=t.getTracks().map((e=>`${e.kind}:${e.id}`)).join(",");n(e,this.__rtcStatsId,`${t.id} ${i}`)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addTrack"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0],i=[].slice.call(arguments,1);n(e,this.__rtcStatsId,`${t.kind}:${t.id} ${i.map((e=>`stream:${e.id}`)).join(";")||"-"}`)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["removeTrack"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0].track;n(e,this.__rtcStatsId,t?`${t.kind}:${t.id}`:"null")}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["addTransceiver"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){try{const t=arguments[0];let i;i="string"==typeof t?t:`${t.kind}:${t.id}`,2===arguments.length&&"object"==typeof arguments[1]&&(i+=` ${JSON.stringify(arguments[1])}`),n(e,this.__rtcStatsId,i)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,arguments)})})),["createOffer","createAnswer"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){const t=this.__rtcStatsId,r=arguments;let o;1===arguments.length&&"object"==typeof arguments[0]?o=arguments[0]:3===arguments.length&&"object"==typeof arguments[2]&&(o=arguments[2]);try{n(e,this.__rtcStatsId,o)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,o?[o]:void 0).then((i=>{try{n(`${e}OnSuccess`,t,s?i:"")}catch(t){console.error(`RTCStats ${e} promise success bind failed: `,t)}if(!(r.length>0&&"function"==typeof r[0]))return i;r[0].apply(null,[i])}),(i=>{try{n(`${e}OnFailure`,t,i.toString())}catch(t){console.error(`RTCStats ${e} promise failure bind failed: `,t)}if(!(r.length>1&&"function"==typeof r[1]))throw i;r[1].apply(null,[i])}))})})),["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((e=>{const i=t.prototype[e];i&&(t.prototype[e]=function(){const t=this.__rtcStatsId,r=arguments;try{const t=s?r[0]:"";n(e,this.__rtcStatsId,t)}catch(t){console.error(`RTCStats ${e} bind failed: `,t)}return i.apply(this,[r[0]]).then((()=>{try{n(`${e}OnSuccess`,t,void 0)}catch(t){console.error(`RTCStats ${e} promise success bind failed: `,t)}this.__dtlsTransport||!e.endsWith("Description")||m||this.getSenders().forEach((e=>{!this.__dtlsTransport&&e.transport&&(this.__dtlsTransport=e.transport,e.transport.addEventListener("error",(e=>{n("ondtlserror",t,e)})),e.transport.addEventListener("statechange",(()=>{const i=e.transport.state;n("ondtlsstatechange",t,i)})))})),r.length>=2&&"function"==typeof r[1]&&r[1].apply(null,[])}),(i=>{try{n(`${e}OnFailure`,t,i.toString())}catch(t){console.error(`RTCStats ${e} promise failure bind failed: `,t)}if(!(r.length>=3&&"function"==typeof r[2]))throw i;r[2].apply(null,[i])}))})})),t.generateCertificate&&Object.defineProperty(a,"generateCertificate",{get(){return arguments.length?t.generateCertificate.apply(null,arguments):t.generateCertificate}}),window[`${e}RTCPeerConnection`]=a,window[`${e}RTCPeerConnection`].prototype=t.prototype})),a.forEach((e=>{const t=e+(e.length?"GetUserMedia":"getUserMedia");if(!navigator[t])return;const i=navigator[t].bind(navigator);navigator[t]=function(){try{n("getUserMedia",null,arguments[0])}catch(e){console.error("RTCStats getUserMedia bind failed: ",e)}const e=arguments[1],t=arguments[2];i(arguments[0],(t=>{try{n("getUserMediaOnSuccess",null,On(t))}catch(e){console.error("RTCStats getUserMediaOnSuccess bind failed: ",e)}e&&e(t)}),(e=>{try{n("getUserMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats getUserMediaOnFailure bind failed: ",e)}t&&t(e)}))}.bind(navigator)})),navigator.mediaDevices&&navigator.mediaDevices.getUserMedia){const e=navigator.mediaDevices.getUserMedia.bind(navigator.mediaDevices),t=function(){try{n("navigator.mediaDevices.getUserMedia",null,arguments[0])}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMedia bind failed: ",e)}return e.apply(navigator.mediaDevices,arguments).then((e=>{try{n("navigator.mediaDevices.getUserMediaOnSuccess",null,On(e))}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMediaOnSuccess bind failed: ",e)}return e}),(e=>{try{n("navigator.mediaDevices.getUserMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats navigator.mediaDevices.getUserMediaOnFailure bind failed: ",e)}return Promise.reject(e)}))};navigator.mediaDevices.getUserMedia=t.bind(navigator.mediaDevices)}if(navigator.mediaDevices&&navigator.mediaDevices.getDisplayMedia){const e=navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices),t=function(){try{n("navigator.mediaDevices.getDisplayMedia",null,arguments[0])}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMedia bind failed: ",e)}return e.apply(navigator.mediaDevices,arguments).then((e=>{try{n("navigator.mediaDevices.getDisplayMediaOnSuccess",null,On(e))}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMediaOnSuccess bind failed: ",e)}return e}),(e=>{try{n("navigator.mediaDevices.getDisplayMediaOnFailure",null,e.name)}catch(e){console.error("RTCStats navigator.mediaDevices.getDisplayMediaOnFailure bind failed: ",e)}return Promise.reject(e)}))};navigator.mediaDevices.getDisplayMedia=t.bind(navigator.mediaDevices)}}else Pn.warn("RTCStats unsupported browser.")}({statsEntry:this.sendStatsEntry.bind(this)},{pollInterval:n,useLegacy:t,sendSdp:i,eventCallback:e=>this.events.emit(ti,e)}),this._initialized=!0)}start(e){const{options:{config:t={},name:n=""}={},_statsCurrentId:i=""}=e,{analytics:{rtcstatsEnabled:r=!1,rtcstatsEndpoint:o="",rtcstatsUseLegacy:s=!1}={}}=t;this.reset(),r&&(this._initialized?(e.once(ce,(()=>{var r;const a={endpoint:o,meetingFqn:n,onCloseCallback:e=>this.events.emit(ei,e),useLegacy:s},d=Boolean(null===(r=e.getBreakoutRooms())||void 0===r?void 0:r.isBreakoutRoom()),c=e.myUserId(),l=e.getMeetingUniqueId();this._trace=Qn(a),this._trace.connect(d);const h={...t,endpointId:c,confName:n,displayName:i,meetingUniqueId:l,isBreakoutRoom:d};this.sendIdentity(h)})),e.once(he,(e=>{this.sendIdentity({meetingUniqueId:e})})),e.once(le,(()=>{this.reset()}))):oi.error("Calling start before RTCStats proxy module is initialized."))}sendIdentity(e){var t;null===(t=this._trace)||void 0===t||t.identity("identity",null,e)}reset(){var e;null===(e=this._trace)||void 0===e||e.close(),this._trace=null}sendStatsEntry(e,t,n){var i;null===(i=this._trace)||void 0===i||i.statsEntry(e,t,n)}};n(478);class ai extends ni{constructor(){var e,t;super(...arguments),t={},(e="_storage")in this?Object.defineProperty(this,e,{value:t,enumerable:!0,configurable:!0,writable:!0}):this[e]=t}clear(){this._storage={}}get length(){return Object.keys(this._storage).length}getItem(e){return this._storage[e]}setItem(e,t){this._storage[e]=t}removeItem(e){delete this._storage[e]}key(e){const t=Object.keys(this._storage);if(!(t.length<=e))return t[e]}serialize(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(0===e.length)return JSON.stringify(this._storage);const t={...this._storage};return e.forEach((e=>{delete t[e]})),JSON.stringify(t)}}const di=new class extends ni{constructor(){super();try{this._storage=window.localStorage,this._localStorageDisabled=!1}catch(e){}this._storage||(console.warn("Local storage is disabled."),this._storage=new ai,this._localStorageDisabled=!0)}isLocalStorageDisabled(){return this._localStorageDisabled}setLocalStorageDisabled(e){this._localStorageDisabled=e;try{this._storage=e?new ai:window.localStorage}catch(e){}this._storage||(this._storage=new ai)}clear(){this._storage.clear(),this.emit("changed")}get length(){return this._storage.length}getItem(e){return this._storage.getItem(e)}setItem(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this._storage.setItem(e,t),n||this.emit("changed")}removeItem(e){this._storage.removeItem(e),this.emit("changed")}key(e){return this._storage.key(e)}serialize(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(this.isLocalStorageDisabled())return this._storage.serialize(e);const t=this._storage.length,n={};for(let i=0;i<t;i++){const t=this._storage.key(i);e.includes(t)||(n[t]=this._storage.getItem(t))}return JSON.stringify(n)}},ci=new class extends In{doesVideoMuteByStreamRemove(){return this.isChromiumBased()||this.isWebKitBased()||this.isFirefox()}isAndroidBrowser(){return!this.isReactNative()&&"Android"===this.getOS()}isIosBrowser(){return!this.isReactNative()&&"iOS"===this.getOS()}isMobileDevice(){return this.isAndroidBrowser()||this.isIosBrowser()||this.isReactNative()}isTwa(){return"matchMedia"in window&&window.matchMedia("(display-mode:standalone)").matches}isSupported(){return!(this.isSafari()&&this._getSafariVersion()<14)&&(this.isChromiumBased()&&this.isEngineVersionGreaterThan(71)||this.isFirefox()&&this.isVersionGreaterThan(90)||this.isReactNative()||this.isWebKitBased())}isSupportedAndroidBrowser(){return this.isChromiumBased()||this.isFirefox()}isSupportedIOSBrowser(){return this._getSafariVersion()>=14||this._getIOSVersion()>=14}isUserInteractionRequiredForUnmute(){return this.isFirefox()&&this.isVersionLessThan("68")}supportsVideoMuteOnConnInterrupted(){return this.isChromiumBased()||this.isReactNative()}supportsBandwidthStatistics(){return!this.isFirefox()&&!this.isWebKitBased()}supportsCodecPreferences(){return Boolean(window.RTCRtpTransceiver&&"setCodecPreferences"in window.RTCRtpTransceiver.prototype&&window.RTCRtpReceiver&&void 0!==window.RTCRtpReceiver.getCapabilities)&&!this.isWebKitBased()}supportsDDExtHeaders(){return!this.isFirefox()}supportsDeviceChangeEvent(){return navigator.mediaDevices&&void 0!==navigator.mediaDevices.ondevicechange&&void 0!==navigator.mediaDevices.addEventListener}supportsPerformanceObserver(){return void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf("longtask")>-1}supportsReceiverStats(){return void 0!==window.RTCRtpReceiver&&Object.keys(RTCRtpReceiver.prototype).indexOf("getSynchronizationSources")>-1}supportsRTTStatistics(){return!this.isFirefox()}supportsScalabilityModeAPI(){return this.isChromiumBased()&&this.isEngineVersionGreaterThan(112)}supportsTrackBasedStats(){return this.isChromiumBased()&&this.isEngineVersionLessThan(112)}supportsVP9(){return this.isChromiumBased()||this.isReactNative()}usesSdpMungingForSimulcast(){return this.isChromiumBased()||this.isReactNative()||this.isWebKitBased()}usesRidsForSimulcast(){return!1}supportsGetDisplayMedia(){return void 0!==navigator.getDisplayMedia||void 0!==navigator.mediaDevices&&void 0!==navigator.mediaDevices.getDisplayMedia}supportsEncodedTransform(){return Boolean(window.RTCRtpScriptTransform)}supportsInsertableStreams(){if(void 0===window.RTCRtpSender||!window.RTCRtpSender.prototype.createEncodedStreams)return!1;const e=new ReadableStream;try{return window.postMessage(e,"*",[e]),!0}catch{return!1}}supportsAudioRed(){return Boolean(window.RTCRtpSender&&window.RTCRtpSender.getCapabilities&&window.RTCRtpSender.getCapabilities("audio").codecs.some((e=>"audio/red"===e.mimeType))&&window.RTCRtpReceiver&&window.RTCRtpReceiver.getCapabilities&&window.RTCRtpReceiver.getCapabilities("audio").codecs.some((e=>"audio/red"===e.mimeType)))}supportsVADDetection(){return this.isChromiumBased()}supportsRTX(){return!(this.isFirefox()&&this.isVersionLessThan("96"))}_getSafariVersion(){return this.isSafari()?Number.parseInt(this.getVersion(),10):-1}_getIOSVersion(){return this.isWebKitBased()?Number.parseInt(this.getOSVersion(),10):-1}};var li=n(803),hi=n.n(li);const ui=S().getLogger("modules/watchRTC/WatchRTC.ts"),pi=new class{init(e){if(function(e){var t;const{analytics:n}=e;return null!==(t=null==n?void 0:n.watchRTCEnabled)&&void 0!==t&&t}(e)){if(ci.isReactNative())return void ui.warn("Cannot initialize WatchRTC in a react native environment!");if(!function(e){const{analytics:t,disableThirdPartyRequests:n}=e;return!(null!=t&&t.disabled||n)}(e))return void ui.error("Cannot initialize WatchRTC when analytics or third party requests are disabled.");try{var t;null!=e&&null!==(t=e.watchRTCConfigParams)&&void 0!==t&&t.rtcApiKey?(hi().init({rtcApiKey:e.watchRTCConfigParams.rtcApiKey}),this.options=e.watchRTCConfigParams,ui.info("WatchRTC initialized.")):ui.error("WatchRTC is enabled but missing API key.")}catch(e){ui.error("Failed to initialize WatchRTC: ",e)}}}start(e,t){try{this.options&&(this.options.rtcRoomId=this.options.rtcRoomId?this.options.rtcRoomId:e,this.options.rtcPeerId=this.options.rtcPeerId?this.options.rtcPeerId:t,hi().setConfig(this.options),ui.info("WatchRTC setConfig."))}catch(e){ui.error("Failed to start WatchRTC session: ",e)}}},mi=(0,y.getLogger)("modules/statistics/AnalyticsAdapter.js"),gi=new class{constructor(){this.reset()}reset(){this.disposed=!1,this.analyticsHandlers=new Set,this.cache=[],this.permanentProperties={},this.conferenceName="",this.addPermanentProperties({user_agent:navigator.userAgent,browser_name:ci.getName()})}dispose(){mi.debug("Disposing of analytics adapter."),this.analyticsHandlers&&this.analyticsHandlers.size>0&&this.analyticsHandlers.forEach((e=>{"function"==typeof e.dispose&&e.dispose()})),this.setAnalyticsHandlers([]),this.disposed=!0}setAnalyticsHandlers(e){if(this.disposed)return;this.analyticsHandlers=new Set(e),this._setUserProperties();const t=this.cache;this.cache=null,t&&t.forEach((e=>this._sendEvent(e)))}_setUserProperties(){this.analyticsHandlers.forEach((e=>{try{e.setUserProperties(this.permanentProperties)}catch(e){mi.warn(`Error in setUserProperties method of one of the analytics handlers: ${e}`)}}))}addPermanentProperties(e){this.permanentProperties={...this.permanentProperties,...e},this._setUserProperties()}setConferenceName(e){this.conferenceName=e,this.addPermanentProperties({conference_name:e})}sendEvent(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(this.disposed)return;let n=null;"string"==typeof e?n={type:Nt,action:e,actionSubject:e,source:e,attributes:t}:"object"==typeof e&&(n=e),this._verifyRequiredFields(n)?this._sendEvent(n):mi.error(`Dropping a mis-formatted event: ${JSON.stringify(n)}`)}_verifyRequiredFields(e){if(!e)return!1;e.type||(e.type=Nt);const t=e.type;return t!==Nt&&t!==Mt&&t!==Ft&&t!==Lt?(mi.error(`Unknown event type: ${t}`),!1):t===Mt?Boolean(e.name):(e.action=e.action||e.name||e.actionSubject,e.actionSubject=e.actionSubject||e.name||e.action,e.source=e.source||e.name||e.action||e.actionSubject,e.action&&e.actionSubject&&e.source?!!(t!==Lt||(e.objectType=e.objectType||"generic-object-type",e.containerType=e.containerType||"conference","conference"!==e.containerType||e.containerId||(e.containerId=this.conferenceName),e.objectType&&e.objectId&&e.containerType&&e.containerId))||(mi.error("Required field missing (containerId, containerType, objectId or objectType)"),!1):(mi.error("Required field missing (action, actionSubject or source)"),!1))}_maybeCacheEvent(e){return!!this.cache&&(this.cache.push(e),this.cache.length>100&&this.cache.splice(0,1),!0)}_sendEvent(e){this._maybeCacheEvent(e)||this.analyticsHandlers.forEach((t=>{try{t.sendEvent(e)}catch(e){mi.warn(`Error sending analytics event: ${e}`)}}))}},fi=n(810).getLogger("modules/statistics/LocalStatsCollector.js");window.AudioContext=window.AudioContext||window.webkitAudioContext;let vi=null;function _i(e,t,n){this.stream=e,this.intervalId=null,this.intervalMilis=t,this.audioLevel=0,this.callback=n,this.source=null,this.analyser=null}function Ei(e){let t=e;return e>=Number.MAX_SAFE_INTEGER&&(t=0),t+1}function yi(e){return e.length>0?e.reduce(((e,t)=>e+t))/e.length:0}function Si(e){return e.filter((e=>e>=0))}_i.prototype.start=function(){_i.isLocalStatsSupported()&&(vi.resume(),this.analyser=vi.createAnalyser(),this.analyser.smoothingTimeConstant=.8,this.analyser.fftSize=2048,this.source=vi.createMediaStreamSource(this.stream),this.source.connect(this.analyser),this.intervalId=setInterval((()=>{const e=new Uint8Array(this.analyser.frequencyBinCount);this.analyser.getByteTimeDomainData(e);const t=function(e){let t=0;const n=e.length;for(let i=0;i<n;i++)t<e[i]&&(t=e[i]);return parseFloat(((t-127)/128).toFixed(3))}(e);this.audioLevel=function(e,t){let n=0;const i=t-e;return n=i>.2?t-.2:i<-.4?t+.4:e,parseFloat(n.toFixed(3))}(t,this.audioLevel),this.callback(this.audioLevel)}),this.intervalMilis))},_i.prototype.stop=function(){var e,t;this.intervalId&&(clearInterval(this.intervalId),this.intervalId=null),null===(e=this.analyser)||void 0===e||e.disconnect(),this.analyser=null,null===(t=this.source)||void 0===t||t.disconnect(),this.source=null},_i.init=function(){_i.connectAudioContext()},_i.isLocalStatsSupported=function(){var e;return Boolean(null===(e=window)||void 0===e?void 0:e.AudioContext)},_i.disconnectAudioContext=async function(){vi&&(fi.info("Disconnecting audio context"),await vi.close(),vi=null)},_i.connectAudioContext=function(){_i.isLocalStatsSupported()&&(fi.info("Connecting audio context"),vi=new AudioContext,vi.suspend())};class bi{constructor(){this.average=0,this.n=0}addNext(e){"number"==typeof e&&(this.n+=1,this.average=this.average+(e-this.average)/this.n)}getAverage(){return this.average}}function Ti(e,t){return isNaN(e)||isNaN(t)?0:e-t}const Ci=(0,y.getLogger)("modules/statistics/PerformanceObserverStats.js");class xi{constructor(e,t){this.eventEmitter=e,this.longTasks=0,this.maxDuration=0,this.performanceStatsInterval=t,this.stats=new bi}getLongTasksStats(){return{avgRatePerMinute:(60*this.stats.getAverage()).toFixed(2),maxDurationMs:this.maxDuration}}startObserver(){this.longTaskEventHandler=e=>{const t=e.getEntries();for(const e of t)this.longTasks++,this.maxDuration=Math.max(this.maxDuration,e.duration).toFixed(3)},Ci.info("Creating a Performance Observer for monitoring Long Tasks"),this.observer=new PerformanceObserver(this.longTaskEventHandler),this.observer.observe({type:"longtask",buffered:!0});const e=Date.now();this.longTasksIntervalId=setInterval((()=>{const t=Date.now(),n=this._lastTimeStamp?(t-this._lastTimeStamp)/1e3:(t-e)/1e3,i=this.longTasks/n;this.stats.addNext(i),this.eventEmitter.emit(vn,this.getLongTasksStats()),this.longTasks=0,this._lastTimeStamp=Date.now()}),this.performanceStatsInterval)}stopObserver(){this.observer&&this.observer.disconnect(),this.longTaskEventHandler=null,this.longTasksIntervalId&&(clearInterval(this.longTasksIntervalId),this.longTasksIntervalId=null)}}let Ri;!function(e){e.AUDIO="audio",e.VIDEO="video"}(Ri||(Ri={}));const Ai=new class{init(e){this._runInLiteMode=Boolean(e.runInLiteMode),this._ssrcRewriting=Boolean(e.ssrcRewritingEnabled)}isRunInLiteModeEnabled(){return this._runInLiteMode&&ci.supportsInsertableStreams()}isSsrcRewritingSupported(){return this._ssrcRewriting}},wi=(0,y.getLogger)("modules/statistics/RTPStatsCollector.js");function Ii(e,t){return e>0&&t>0?Math.round(e/t*100):0}function Pi(){this.loss={},this.bitrate={download:0,upload:0},this.resolution={},this.framerate=0,this.codec=""}function Di(){this.bandwidth={},this.bitrate={},this.packetLoss=null,this.transport=[]}function Oi(e,t,n,i){this.peerconnection=e,this.currentStatsReport=null,this.previousStatsReport=null,this.audioLevelReportHistory={},this.audioLevelsIntervalId=null,this.eventEmitter=i,this.conferenceStats=new Di,this.audioLevelsIntervalMilis=t,this.speakerList=[],this.statsIntervalId=null,this.statsIntervalMilis=n,this.ssrc2stats=new Map}Pi.prototype.setLoss=function(e){this.loss=e||{}},Pi.prototype.setResolution=function(e){this.resolution=e||{}},Pi.prototype.addBitrate=function(e){this.bitrate.download+=e.download,this.bitrate.upload+=e.upload},Pi.prototype.resetBitrate=function(){this.bitrate.download=0,this.bitrate.upload=0},Pi.prototype.setFramerate=function(e){this.framerate=e||0},Pi.prototype.setCodec=function(e){this.codec=e||""},Oi.prototype.setSpeakerList=function(e){this.speakerList=e},Oi.prototype.stop=function(){this.audioLevelsIntervalId&&(clearInterval(this.audioLevelsIntervalId),this.audioLevelsIntervalId=null),this.statsIntervalId&&(clearInterval(this.statsIntervalId),this.statsIntervalId=null)},Oi.prototype.errorCallback=function(e){wi.error("Get stats error",e),this.stop()},Oi.prototype.start=function(e){e&&ci.supportsReceiverStats()&&(this.audioLevelsIntervalId=setInterval((()=>{const e=this.peerconnection.getAudioLevels(this.speakerList);for(const t in e)if(e.hasOwnProperty(t)){const n=2.5*e[t];this.eventEmitter.emit(pn,this.peerconnection,Number.parseInt(t,10),n,!1)}}),this.audioLevelsIntervalMilis));const t=()=>{this.peerconnection.getStats().then((e=>{this.currentStatsReport="function"==typeof(null==e?void 0:e.result)?e.result():e;try{this.processStatsReport()}catch(e){wi.error("Processing of RTP stats failed:",e)}this.previousStatsReport=this.currentStatsReport})).catch((e=>this.errorCallback(e)))};t(),this.statsIntervalId=setInterval(t,this.statsIntervalMilis)},Oi.prototype._processAndEmitReport=function(){const e={download:0,upload:0},t={download:0,upload:0};let n=0,i=0;const r={},o={},s={};let a=0,d=0,c=0,l=0;for(const[p,m]of this.ssrc2stats){var h;const g=m.loss,f=g.isDownloadStream?"download":"upload";e[f]+=g.packetsTotal,t[f]+=g.packetsLost;const v=m.bitrate.download,_=m.bitrate.upload;n+=v,i+=_,m.resetBitrate();const E=this.peerconnection.getTrackBySSRC(p);if(!E)continue;let y,S;E.isAudioTrack()?(a+=v,d+=_,y=m.codec):(c+=v,l+=_,S=m.codec);const b=E.getParticipantId();if(!b){Ai.isSsrcRewritingSupported()||wi.error(`No participant ID returned by ${E}`);continue}const T=null!==(h=s[b])&&void 0!==h?h:{};T[p]={audio:y,video:S},s[b]=T;const{resolution:C}=m;if(!E.isVideoTrack()||isNaN(null==C?void 0:C.height)||isNaN(null==C?void 0:C.width)||-1===C.height||-1===C.width)continue;const x=r[b]||{};if(E.isLocal()&&!ci.supportsTrackBasedStats()&&this.peerconnection.doesTrueSimulcast()){const e=this.peerconnection.getLocalVideoSSRCs(E);for(const t of e){var u;const e=null===(u=this.ssrc2stats.get(t))||void 0===u?void 0:u.resolution;null!=e&&e.height&&null!=e&&e.width&&(C.height=Math.max(C.height,e.height),C.width=Math.max(C.width,e.width))}}if(x[p]=C,r[b]=x,m.framerate>0){const e=o[b]||{};e[p]=m.framerate,o[b]=e}}this.conferenceStats.bitrate={upload:i,download:n},this.conferenceStats.bitrate.audio={upload:d,download:a},this.conferenceStats.bitrate.video={upload:l,download:c},this.conferenceStats.packetLoss={total:Ii(t.download+t.upload,e.download+e.upload),download:Ii(t.download,e.download),upload:Ii(t.upload,e.upload)};const p={};let m;Object.keys(this.audioLevelReportHistory).forEach((e=>{const{data:t,isLocal:n}=this.audioLevelReportHistory[e],i=t.reduce(((e,t)=>e+t))/t.length;if(n)m=i;else{const t=this.peerconnection.getTrackBySSRC(Number(e));if(t){const e=t.getParticipantId();e&&(p[e]=i)}}})),this.audioLevelReportHistory={},this.eventEmitter.emit(fn,this.peerconnection,{bandwidth:this.conferenceStats.bandwidth,bitrate:this.conferenceStats.bitrate,packetLoss:this.conferenceStats.packetLoss,resolution:r,framerate:o,codec:s,transport:this.conferenceStats.transport,localAvgAudioLevels:m,avgAudioLevels:p}),this.conferenceStats.transport=[]},Oi.prototype.getNonNegativeValue=function(e){let t=e;return"number"!=typeof t&&(t=Number(t)),isNaN(t)?0:Math.max(0,t)},Oi.prototype._calculateBitrate=function(e,t,n){const i=this.getNonNegativeValue(e[n]),r=this.getNonNegativeValue(t[n]),o=Math.max(0,i-r),s=e.timestamp-t.timestamp;let a=0;return s>0&&(a=Math.round(8*o/s)),a},Oi.prototype._calculateFps=function(e,t,n){const i=e.timestamp-t.timestamp;let r=0;return i>0&&e[n]&&(r=(e[n]-t[n])/i*1e3),r},Oi.prototype.processStatsReport=function(){const e={};this.currentStatsReport.forEach((t=>{const n=this.previousStatsReport?this.previousStatsReport.get(t.id):null;if("candidate-pair"===t.type&&t.nominated&&"succeeded"===t.state){const e=t.availableIncomingBitrate,n=t.availableOutgoingBitrate;(e||n)&&(this.conferenceStats.bandwidth={download:Math.round(e/1e3),upload:Math.round(n/1e3)});const i=this.currentStatsReport.get(t.remoteCandidateId),r=this.currentStatsReport.get(t.localCandidateId);if(i&&r){const e=`${ci.isChromiumBased()?i.ip:i.address}:${i.port}`,n=`${ci.isChromiumBased()?r.ip:r.address}:${r.port}`,o=i.protocol,s=this.conferenceStats.transport;s.some((t=>t.ip===e&&t.type===o&&t.localip===n))||s.push({ip:e,type:o,localip:n,p2p:this.peerconnection.isP2P,localCandidateType:r.candidateType,remoteCandidateType:i.candidateType,networkType:r.networkType,rtt:1e3*t.currentRoundTripTime})}}else if("inbound-rtp"===t.type||"outbound-rtp"===t.type){const r=this.getNonNegativeValue(t.ssrc);if(!r)return;let o=this.ssrc2stats.get(r);o||(o=new Pi,this.ssrc2stats.set(r,o));let s=!0,a="packetsReceived";"outbound-rtp"===t.type&&(s=!1,a="packetsSent");let d,c=t[a];if((!c||c<0)&&(c=0),n){const e=this.getNonNegativeValue(n[a]),i=Math.max(0,c-e),r=this.getNonNegativeValue(t.packetsLost),d=this.getNonNegativeValue(n.packetsLost),l=Math.max(0,r-d);o.setLoss({packetsTotal:i+l,packetsLost:l,isDownloadStream:s})}if(void 0!==t.frameHeight&&void 0!==t.frameWidth){var i;const e=null===(i=t.active)||void 0===i||i;("inbound-rtp"===t.type||!ci.supportsTrackBasedStats()&&e)&&(d={height:t.frameHeight,width:t.frameWidth})}o.setResolution(d);let l=t.framesPerSecond;!l&&n&&(l=this._calculateFps(t,n,"framesSent")),o.setFramerate(Math.round(l||0)),"inbound-rtp"===t.type&&n?o.addBitrate({download:this._calculateBitrate(t,n,"bytesReceived"),upload:0}):n&&(e[r]=this.getNonNegativeValue(t.bytesSent),o.addBitrate({download:0,upload:this._calculateBitrate(t,n,"bytesSent")}));const h=this.currentStatsReport.get(t.codecId);if(h){const e=h.mimeType.split("/")[1];e&&o.setCodec(e)}}else if(ci.supportsTrackBasedStats()&&"track"===t.type&&t.kind===Ri.VIDEO&&!t.remoteSource){const e={height:t.frameHeight,width:t.frameWidth},i=this.peerconnection.getLocalTracks(Ri.VIDEO);if(null==i||!i.length)return;const r=this.peerconnection.getSsrcByTrackId(t.trackIdentifier);if(!r)return;let o=this.ssrc2stats.get(r);o||(o=new Pi,this.ssrc2stats.set(r,o)),e.height&&e.width&&o.setResolution(e);let s=t.framesPerSecond;!s&&n&&(s=this._calculateFps(t,n,"framesSent")),o.setFramerate(s)}})),Object.keys(e).length&&this.eventEmitter.emit(gn,this.peerconnection,e),this._processAndEmitReport()};const ki=n(810).getLogger("modules/statistics/statistics.js");let Ni;function Mi(e,t){this.rtpStatsMap=new Map,this.eventEmitter=new ii,this.conference=e,this.xmpp=null==e?void 0:e.xmpp,this.options=t||{},Mi.instances.add(this),si.start(this.conference),ci.isReactNative()||pi.start(this.options.roomName,this.options.userName)}Mi.init=function(e){Mi.audioLevelsEnabled=!e.disableAudioLevels,"number"==typeof e.pcStatsInterval&&(Mi.pcStatsInterval=e.pcStatsInterval),"number"==typeof e.audioLevelsInterval&&(Mi.audioLevelsInterval=e.audioLevelsInterval),"number"==typeof e.longTasksStatsInterval&&(Mi.longTasksStatsInterval=e.longTasksStatsInterval),Mi.disableThirdPartyRequests=e.disableThirdPartyRequests,_i.init(),pi.init(e),si.init(e)},Mi.audioLevelsEnabled=!1,Mi.audioLevelsInterval=200,Mi.pcStatsInterval=1e4,Mi.disableThirdPartyRequests=!1,Mi.analytics=gi,Object.defineProperty(Mi,"instances",{get:()=>(Ni||(Ni=new Set),Ni)}),Mi.prototype.startRemoteStats=function(e){this.stopRemoteStats(e);try{const t=new Oi(e,Mi.audioLevelsInterval,Mi.pcStatsInterval,this.eventEmitter);t.start(Mi.audioLevelsEnabled),this.rtpStatsMap.set(e.id,t)}catch(e){ki.error(`Failed to start collecting remote statistics: ${e}`)}},Mi.localStats=[],Mi.startLocalStats=function(e,t){if(ci.isIosBrowser()&&e.addEventListener(bt.NO_DATA_FROM_SOURCE,(async e=>{if(e){for(const e of Mi.localStats)e.stop();await _i.disconnectAudioContext()}else{_i.connectAudioContext();for(const e of Mi.localStats)e.start()}})),!Mi.audioLevelsEnabled)return;e.addEventListener(bt.LOCAL_TRACK_STOPPED,(()=>{Mi.stopLocalStats(e)}));const n=new _i(e.getOriginalStream(),Mi.audioLevelsInterval,t);this.localStats.push(n),n.start()},Mi.prototype.addAudioLevelListener=function(e){Mi.audioLevelsEnabled&&this.eventEmitter.on(pn,e)},Mi.prototype.removeAudioLevelListener=function(e){Mi.audioLevelsEnabled&&this.eventEmitter.removeListener(pn,e)},Mi.prototype.addBeforeDisposedListener=function(e){this.eventEmitter.on(mn,e)},Mi.prototype.removeBeforeDisposedListener=function(e){this.eventEmitter.removeListener(mn,e)},Mi.prototype.addConnectionStatsListener=function(e){this.eventEmitter.on(fn,e)},Mi.prototype.removeConnectionStatsListener=function(e){this.eventEmitter.removeListener(fn,e)},Mi.prototype.addByteSentStatsListener=function(e){this.eventEmitter.on(gn,e)},Mi.prototype.removeByteSentStatsListener=function(e){this.eventEmitter.removeListener(gn,e)},Mi.prototype.addLongTasksStatsListener=function(e){this.eventEmitter.on(vn,e)},Mi.prototype.attachLongTasksStats=function(){ci.supportsPerformanceObserver()?(this.performanceObserverStats=new xi(this.eventEmitter,Mi.longTasksStatsInterval),this.conference.on(ce,(()=>this.performanceObserverStats.startObserver())),this.conference.on(le,(()=>this.performanceObserverStats.stopObserver()))):ki.warn("Performance observer for long tasks not supported by browser!")},Mi.prototype.getLongTasksStats=function(){return this.performanceObserverStats?this.performanceObserverStats.getLongTasksStats():null},Mi.prototype.removeLongTasksStatsListener=function(e){this.eventEmitter.removeListener(vn,e)},Mi.prototype.setSpeakerList=function(e){for(const t of Array.from(this.rtpStatsMap.values()))t.peerconnection.isP2P||t.setSpeakerList(e)},Mi.prototype.dispose=function(){try{this.eventEmitter.emit(mn);for(const e of this.rtpStatsMap.keys())this._stopRemoteStats(e);this.eventEmitter&&this.eventEmitter.removeAllListeners()}finally{Mi.instances.delete(this)}},Mi.stopLocalStats=function(e){if(!Mi.audioLevelsEnabled)return;const t=e.getOriginalStream();for(let e=0;e<Mi.localStats.length;e++)if(Mi.localStats[e].stream===t){Mi.localStats.splice(e,1)[0].stop();break}},Mi.prototype._stopRemoteStats=function(e){const t=this.rtpStatsMap.get(e);t&&(t.stop(),this.rtpStatsMap.delete(e))},Mi.prototype.stopRemoteStats=function(e){this._stopRemoteStats(e.id)},Mi.prototype.sendFeedback=function(e,t){return Mi.analytics.sendEvent(Yt,{rating:e,comment:t}),Promise.resolve()},Mi.LOCAL_JID=n(680).D,Mi.sendAnalyticsAndLog=function(e){let t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};e?(t="object"==typeof e?e:{name:e,properties:n},ki.log(JSON.stringify(t)),this.analytics.sendEvent(e,n)):ki.warn("No event or event name given.")},Mi.sendAnalytics=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};this.analytics.sendEvent(e,t)};var Li=n(832),Fi=n.n(Li),ji=n(987),Vi=n(514),Ui=n.n(Vi),Hi=n(609);const $i=(0,y.getLogger)("JitsiConferenceEventManager.js");function Ji(e){this.conference=e,this.xmppListeners={}}Ji.prototype.setupChatRoomListeners=function(){const e=this.conference,t=e.room;this.chatRoomForwarder=new(Fi())(t,this.conference.eventEmitter),t.addListener(Hi.XMPPEvents.ICE_RESTARTING,(t=>{t.isP2P||e.rtc.closeBridgeChannel()})),t.addListener(Hi.XMPPEvents.PARTICIPANT_FEATURES_CHANGED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(t));i&&(i.setFeatures(n),e.eventEmitter.emit(Be,i))})),t.addListener(Hi.XMPPEvents.ICE_RESTART_SUCCESS,((t,n)=>{!t.isP2P&&e._setBridgeChannel(n,t.peerconnection)})),t.addListener(Hi.XMPPEvents.AUDIO_MUTED_BY_FOCUS,(t=>{Mi.sendAnalytics(ln(Ri.AUDIO)),e.mutedByFocusActor=t,e.rtc.setAudioMute(!0).then((()=>{e.isMutedByFocus=!0,e.mutedByFocusActor=null})).catch((t=>{e.mutedByFocusActor=null,$i.warn("Error while audio muting due to focus request",t)}))})),t.addListener(Hi.XMPPEvents.VIDEO_MUTED_BY_FOCUS,(t=>{Mi.sendAnalytics(ln(Ri.VIDEO)),e.mutedVideoByFocusActor=t,e.rtc.setVideoMute(!0).then((()=>{e.isVideoMutedByFocus=!0,e.mutedVideoByFocusActor=null})).catch((t=>{e.mutedVideoByFocusActor=null,$i.warn("Error while video muting due to focus request",t)}))})),this.chatRoomForwarder.forward(Hi.XMPPEvents.SUBJECT_CHANGED,Qe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_JOINED,ce),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_JOIN_IN_PROGRESS,de),this.chatRoomForwarder.forward(Hi.XMPPEvents.MEETING_ID_SET,he),this.chatRoomForwarder.forward(Hi.XMPPEvents.CONFERENCE_TIMESTAMP_RECEIVED,oe),t.addListener(Hi.XMPPEvents.MUC_JOINED,(()=>{this.conference._onMucJoined(),this.conference.isJvbConnectionInterrupted=!1,Object.keys(t.connectionTimes).forEach((e=>{const n=sn(`conference_${e}`,{value:t.connectionTimes[e]});Mi.sendAnalytics(n)})),Object.keys(t.xmpp.connectionTimes).forEach((e=>{const n=sn(`xmpp_${e}`,{value:t.xmpp.connectionTimes[e]});Mi.sendAnalytics(n)}))})),t.addListener(Hi.XMPPEvents.RENEGOTIATION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(Ot,(t=>{e.eventEmitter.emit(rt,t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_JOIN_ERROR,ae,w),this.chatRoomForwarder.forward(Hi.XMPPEvents.DISPLAY_NAME_REQUIRED,ae,k),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_ERROR,ae,w),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,ae,P),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,ae,D),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_MAX_USERS_ERROR,ae,A),this.chatRoomForwarder.forward(Hi.XMPPEvents.PASSWORD_REQUIRED,ae,H),this.chatRoomForwarder.forward(Hi.XMPPEvents.AUTHENTICATION_REQUIRED,ae,T),this.chatRoomForwarder.forward(Hi.XMPPEvents.BRIDGE_DOWN,ae,J),t.addListener(Hi.XMPPEvents.BRIDGE_DOWN,(()=>Mi.sendAnalytics({action:"bridge.down",actionSubject:"bridge.down",type:Nt}))),t.addListener(Hi.XMPPEvents.CONNECTION_RESTARTED,(t=>{e._onConferenceRestarted(t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.RESERVATION_ERROR,ae,$),this.chatRoomForwarder.forward(Hi.XMPPEvents.GRACEFUL_SHUTDOWN,ae,L),t.addListener(Hi.XMPPEvents.CONNECTION_ICE_FAILED,(t=>{e._onIceConnectionFailed(t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_DESTROYED,ae,R),this.chatRoomForwarder.forward(Hi.XMPPEvents.CHAT_ERROR_RECEIVED,se,C),this.chatRoomForwarder.forward(Hi.XMPPEvents.SETTINGS_ERROR_RECEIVED,se,x),this.chatRoomForwarder.forward(Hi.XMPPEvents.FOCUS_DISCONNECTED,ae,N),t.addListener(Hi.XMPPEvents.FOCUS_LEFT,(()=>{Mi.sendAnalytics({action:"focus.left",actionSubject:"focus.left",type:kt.TYPE_OPERATIONAL}),e.eventEmitter.emit(ae,M)})),t.addListener(Hi.XMPPEvents.SESSION_ACCEPT_TIMEOUT,(e=>{Mi.sendAnalyticsAndLog(dn(Vt,{p2p:e.isP2P}))})),t.addListener(Hi.XMPPEvents.RECORDER_STATE_CHANGED,((t,n)=>{if(n){const i=St.Strophe.getResourceFromJid(n),r=e.getParticipantById(i)||i;"off"===t.getStatus()?t.setTerminator(r):"on"===t.getStatus()&&t.setInitiator(r)}e.eventEmitter.emit(Ke,t)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.TRANSCRIPTION_STATUS_CHANGED,st),this.chatRoomForwarder.forward(Hi.XMPPEvents.VIDEO_SIP_GW_AVAILABILITY_CHANGED,ht),this.chatRoomForwarder.forward(Hi.XMPPEvents.VIDEO_SIP_GW_SESSION_STATE_CHANGED,ut),this.chatRoomForwarder.forward(Hi.XMPPEvents.PHONE_NUMBER_CHANGED,Ge),t.setParticipantPropertyListener(((t,n)=>{const i=e.getParticipantById(n);i&&i.setProperty(t.tagName.substring("jitsi_participant_".length),t.value)})),t.addListener(Hi.XMPPEvents.KICKED,e.onMemberKicked.bind(e)),t.addListener(Hi.XMPPEvents.SUSPEND_DETECTED,e.onSuspendDetected.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOCK_CHANGED,ke),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,Ne),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_VISITORS_SUPPORTED_CHANGED,mt),t.addListener(Hi.XMPPEvents.MUC_MEMBER_JOINED,e.onMemberJoined.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_JOINED,Pe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_UPDATED,Oe),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,De),t.addListener(Hi.XMPPEvents.MUC_MEMBER_BOT_TYPE_CHANGED,e._onMemberBotTypeChanged.bind(e)),t.addListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,e.onMemberLeft.bind(e)),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_LEFT,le),this.chatRoomForwarder.forward(Hi.XMPPEvents.MUC_DENIED_ACCESS,ae,O),t.addListener(Hi.XMPPEvents.DISPLAY_NAME_CHANGED,e.onDisplayNameChanged.bind(e)),t.addListener(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,(t=>{e.onLocalRoleChanged(t)})),t.addListener(Hi.XMPPEvents.MUC_ROLE_CHANGED,e.onUserRoleChanged.bind(e)),t.addListener(Ui().IDENTITY_UPDATED,((t,n)=>{e.authEnabled=t,e.authIdentity=n,e.eventEmitter.emit(W,t,n)})),t.addListener(Hi.XMPPEvents.MESSAGE_RECEIVED,((t,n,i,r,o,s)=>{const a=St.Strophe.getResourceFromJid(t);e.eventEmitter.emit(Me,a,n,r,o,s)})),t.addListener(Hi.XMPPEvents.PRIVATE_MESSAGE_RECEIVED,((t,n,i,r)=>{const o=St.Strophe.getResourceFromJid(t);e.eventEmitter.emit(Je,o,n,r)})),t.addListener(Hi.XMPPEvents.PRESENCE_STATUS,((t,n)=>{const i=St.Strophe.getResourceFromJid(t),r=e.getParticipantById(i);r&&r._status!==n&&(r._status=n,e.eventEmitter.emit(lt,i,n))})),t.addListener(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,((t,n)=>{const i=St.Strophe.getResourceFromJid(t),r=e.getParticipantById(i);r?e.eventEmitter.emit(Ce,r,n):e.eventEmitter.emit(Ve,i,n)})),t.addPresenceListener("startmuted",((t,n)=>{if(e.myUserId()===n)return;const i=e.getParticipantById(n);if(!i||!i.isModerator())return;const r="true"===t.attributes.audio,o="true"===t.attributes.video;let s=!1;r!==e.startMutedPolicy.audio&&(e.startMutedPolicy.audio=r,s=!0),o!==e.startMutedPolicy.video&&(e.startMutedPolicy.video=o,s=!0),s&&e.eventEmitter.emit(Xe,e.startMutedPolicy)})),this.chatRoomForwarder.forward(Hi.XMPPEvents.BREAKOUT_ROOMS_MOVE_TO_ROOM,ie),this.chatRoomForwarder.forward(Hi.XMPPEvents.BREAKOUT_ROOMS_UPDATED,re),this.chatRoomForwarder.forward(Hi.XMPPEvents.ROOM_METADATA_UPDATED,Le)},Ji.prototype.setupRTCListeners=function(){const e=this.conference,t=e.rtc;t.addListener(ji.default.REMOTE_TRACK_ADDED,e.onRemoteTrackAdded.bind(e)),t.addListener(ji.default.REMOTE_TRACK_REMOVED,e.onRemoteTrackRemoved.bind(e)),t.addListener(ji.default.DOMINANT_SPEAKER_CHANGED,((t,n,i)=>{if((e.lastDominantSpeaker!==t||e.dominantSpeakerIsSilent!==i)&&e.room&&(e.lastDominantSpeaker=t,e.dominantSpeakerIsSilent=i,e.eventEmitter.emit(Ee,t,n,i),e.statistics&&e.myUserId()===t&&e.xmpp.sendDominantSpeakerEvent(e.room.roomjid,i),e.lastDominantSpeaker!==t&&n&&n.length)){const i=n.slice(0);e.myUserId!==t&&i.splice(0,0,t),i.length>5&&i.splice(5,i.length-5),e.statistics&&e.statistics.setSpeakerList(i)}})),t.addListener(ji.default.DATA_CHANNEL_OPEN,(()=>{const t=window.performance.now(),n="data.channel.opened";$i.log(`(TIME) ${n}:\\t`,t),e.room.connectionTimes[n]=t,Mi.sendAnalytics(sn(n,{value:t})),e.eventEmitter.emit(ve)})),t.addListener(ji.default.DATA_CHANNEL_CLOSED,(t=>{e.eventEmitter.emit(fe,t)})),t.addListener(ji.default.VIDEO_SSRCS_REMAPPED,(e=>{for(const t of this.conference.getMediaSessions())t.processSourceMap(e,Ri.VIDEO)})),t.addListener(ji.default.AUDIO_SSRCS_REMAPPED,(e=>{for(const t of this.conference.getMediaSessions())t.processSourceMap(e,Ri.AUDIO)})),t.addListener(ji.default.ENDPOINT_MESSAGE_RECEIVED,((t,n)=>{const i=e.getParticipantById(t);i?e.eventEmitter.emit(Ce,i,n):$i.warn(`Ignored ENDPOINT_MESSAGE_RECEIVED for not existing participant: ${t}`,n)})),t.addListener(ji.default.ENDPOINT_STATS_RECEIVED,((t,n)=>{const i=e.getParticipantById(t);i?e.eventEmitter.emit(xe,i,n):$i.warn(`Ignoring ENDPOINT_STATS_RECEIVED for a non-existant participant: ${t}`)})),t.addListener(ji.default.CREATE_ANSWER_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.CREATE_OFFER_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.SET_LOCAL_DESCRIPTION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)})),t.addListener(ji.default.SET_REMOTE_DESCRIPTION_FAILED,((t,n)=>{n.isP2P||e.eventEmitter.emit(ae,V,t)}))},Ji.prototype.removeXMPPListeners=function(){const e=this.conference;Object.keys(this.xmppListeners).forEach((t=>{e.xmpp.removeListener(t,this.xmppListeners[t])})),this.xmppListeners={}},Ji.prototype.setupXMPPListeners=function(){const e=this.conference;this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_INCOMING,e.onIncomingCall.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_ACCEPTED,e.onCallAccepted.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.TRANSPORT_INFO,e.onTransportInfo.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.CALL_ENDED,e.onCallEnded.bind(e)),this._addConferenceXMPPListener(Hi.XMPPEvents.START_MUTED_FROM_FOCUS,((t,n)=>{e.options.config.ignoreStartMuted||(e.startAudioMuted=t,e.startVideoMuted=n,t&&(e.isMutedByFocus=!0),n&&(e.isVideoMutedByFocus=!0),e.getLocalTracks().forEach((t=>{switch(t.getType()){case Ri.AUDIO:e.startAudioMuted&&t.mute();break;case Ri.VIDEO:e.startVideoMuted&&t.mute()}})),e.eventEmitter.emit(Ye))})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_CHANGED,((t,n,i)=>{const r=e.getParticipants().find((e=>e.getJid()===i));e.eventEmitter.emit(Y,{enabled:t,mediaType:n,actor:r})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_APPROVED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(n));i&&e.eventEmitter.emit(Q,{participant:i,mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_REJECTED,((t,n)=>{const i=e.getParticipantById(St.Strophe.getResourceFromJid(n));i&&e.eventEmitter.emit(Z,{participant:i,mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_APPROVED,(t=>e.eventEmitter.emit(X,{mediaType:t}))),this._addConferenceXMPPListener(Hi.XMPPEvents.AV_MODERATION_REJECTED,(t=>{e.eventEmitter.emit(ee,{mediaType:t})})),this._addConferenceXMPPListener(Hi.XMPPEvents.VISITORS_MESSAGE,(t=>e.eventEmitter.emit(gt,t))),this._addConferenceXMPPListener(Hi.XMPPEvents.VISITORS_REJECTION,(()=>e.eventEmitter.emit(ft)))},Ji.prototype._addConferenceXMPPListener=function(e,t){this.xmppListeners[e]=t,this.conference.xmpp.addListener(e,t)},Ji.prototype.setupStatisticsListeners=function(){const e=this.conference;e.statistics&&(e.statistics.addAudioLevelListener(((t,n,i,r)=>{e.rtc.setAudioLevel(t,n,i,r)})),e.statistics.addBeforeDisposedListener((()=>{e.eventEmitter.emit(te)})),e.options.config.startSilent||e.statistics.addByteSentStatsListener(((t,n)=>{e.getLocalTracks(Ri.AUDIO).forEach((e=>{const i=t.getLocalSSRC(e);i&&n.hasOwnProperty(i)&&e.onByteSentStatsReceived(t,n[i])}))})))};class Bi{constructor(e,t,n,i,r,o,s,a,d){this._jid=e,this._id=St.Strophe.getResourceFromJid(e),this._conference=t,this._displayName=n,this._supportsDTMF=!1,this._tracks=[],this._role="none",this._status=o,this._hidden=i,this._statsID=r,this._properties={},this._identity=s,this._isReplacing=a,this._isReplaced=d,this._features=new Set,this._sources=new Map}_isMediaTypeMuted(e){return this.getTracks().reduce(((t,n)=>t&&(n.getType()!==e||n.isMuted())),!0)}_setSources(e,t,n,i){var r;let o=this._sources.get(e);const s={muted:t,videoType:i};null!==(r=o)&&void 0!==r&&r.size?o.set(n,s):(o=new Map,o.set(n,s),this._sources.set(e,o))}getBotType(){return this._botType}getConference(){return this._conference}getConnectionJid(){return this._connectionJid}getDisplayName(){return this._displayName}getFeatures(){return Promise.resolve(this._features)}getId(){return this._id}getIdentity(){return this._identity}getJid(){return this._jid}getProperty(e){return this._properties[e]}getRole(){return this._role}getSources(){return this._sources}getStatsID(){return this._statsID}getStatus(){return this._status}getTracks(){return this._tracks.slice()}getTracksByMediaType(e){return this.getTracks().filter((t=>t.getType()===e))}hasFeature(e){return this._features.has(e)}isAudioMuted(){return this._isMediaTypeMuted(Ri.AUDIO)}isHidden(){return this._hidden}isHiddenFromRecorder(){var e,t;return"true"===(null===(e=this._identity)||void 0===e||null===(t=e.user)||void 0===t?void 0:t["hidden-from-recorder"])}isModerator(){return"moderator"===this._role}isReplaced(){return this._isReplaced}isReplacing(){return this._isReplacing}isVideoMuted(){return this._isMediaTypeMuted(Ri.VIDEO)}setBotType(e){this._botType=e}setConnectionJid(e){this._connectionJid=e}setFeatures(e){this._features=e||new Set}setIsReplaced(e){this._isReplaced=e}setIsReplacing(e){this._isReplacing=e}setProperty(e,t){const n=this._properties[e];t!==n&&(this._properties[e]=t,this._conference.eventEmitter.emit(qe,this,e,n,t))}setRole(e){this._role=e}supportsDTMF(){return this._supportsDTMF}}let qi;!function(e){e.CONSTRAINT_FAILED="gum.constraint_failed",e.ELECTRON_DESKTOP_PICKER_ERROR="gum.electron_desktop_picker_error",e.ELECTRON_DESKTOP_PICKER_NOT_FOUND="gum.electron_desktop_picker_not_found",e.GENERAL="gum.general",e.NOT_FOUND="gum.not_found",e.PERMISSION_DENIED="gum.permission_denied",e.SCREENSHARING_GENERIC_ERROR="gum.screensharing_generic_error",e.SCREENSHARING_USER_CANCELED="gum.screensharing_user_canceled",e.TIMEOUT="gum.timeout",e.TRACK_IS_DISPOSED="track.track_is_disposed",e.TRACK_NO_STREAM_FOUND="track.no_stream_found",e.UNSUPPORTED_RESOLUTION="gum.unsupported_resolution",e.TRACK_TOO_MANY_TRACKS_IN_STREAM="track.too_many_tracks_in_stream",e.TRACK_NO_STREAM_TRACKS_FOUND="track.no_stream_tracks_found"}(qi||(qi={}));const Gi=qi.CONSTRAINT_FAILED,zi=qi.ELECTRON_DESKTOP_PICKER_ERROR,Ki=qi.ELECTRON_DESKTOP_PICKER_NOT_FOUND,Wi=qi.GENERAL,Xi=qi.NOT_FOUND,Yi=qi.PERMISSION_DENIED,Qi=qi.SCREENSHARING_GENERIC_ERROR,Zi=qi.SCREENSHARING_USER_CANCELED,er=qi.TIMEOUT,tr=qi.TRACK_IS_DISPOSED,nr=qi.TRACK_NO_STREAM_FOUND,ir=qi.UNSUPPORTED_RESOLUTION,rr=qi.TRACK_TOO_MANY_TRACKS_IN_STREAM,or=qi.TRACK_NO_STREAM_TRACKS_FOUND,sr={};function ar(e,t,n){if("object"==typeof e&&void 0!==e.name)switch(this.gum={error:e,constraints:t,devices:n&&Array.isArray(n)?n.slice(0):void 0},e.name){case"NotAllowedError":case"PermissionDeniedError":case"SecurityError":this.name=Yi,this.message=sr[this.name]+(this.gum.devices||[]).join(", ");break;case"DevicesNotFoundError":case"NotFoundError":this.name=Xi,this.message=sr[this.name]+(this.gum.devices||[]).join(", ");break;case"ConstraintNotSatisfiedError":case"OverconstrainedError":{const i=e.constraintName||e.constraint;t&&t.video&&(!n||n.indexOf("video")>-1)&&("minWidth"===i||"maxWidth"===i||"minHeight"===i||"maxHeight"===i||"width"===i||"height"===i||"deviceId"===i)?(this.name=ir,this.message=sr[this.name]+function(e,t){if(t&&t.video&&t.video.mandatory)switch(e){case"width":return t.video.mandatory.minWidth;case"height":return t.video.mandatory.minHeight;default:return t.video.mandatory[e]||""}return""}(i,t)):(this.name=Gi,this.message=sr[this.name]+e.constraintName);break}default:this.name=Wi,this.message=e.message||sr[this.name]}else{if("string"!=typeof e)throw new Error("Invalid arguments");sr[e]?(this.name=e,this.message=t||sr[e]):this.message=e}this.stack=e.stack||(new Error).stack}sr[ir]="Video resolution is not supported: ",sr[Zi]="User canceled screen sharing prompt",sr[Qi]="Unknown error from screensharing",sr[zi]="Unkown error from desktop picker",sr[Ki]="Failed to detect desktop picker",sr[Wi]="Generic getUserMedia error",sr[Yi]="User denied permission to use device(s): ",sr[Xi]="Requested device(s) was/were not found: ",sr[Gi]="Constraint could not be satisfied: ",sr[er]="Could not start media source. Timeout occured!",sr[tr]="Track has been already disposed",sr[nr]="Track does not have an associated Media Stream",ar.prototype=Object.create(Error.prototype),ar.prototype.constructor=ar;const dr=ar;let cr;!function(e){e.CONNECTION_DISCONNECTED="connection.connectionDisconnected",e.CONNECTION_ESTABLISHED="connection.connectionEstablished",e.CONNECTION_FAILED="connection.connectionFailed",e.CONNECTION_REDIRECTED="connection.redirected",e.WRONG_STATE="connection.wrongState",e.DISPLAY_NAME_REQUIRED="connection.display_name_required",e.PROPERTIES_UPDATED="connection.propertiesUpdated"}(cr||(cr={}));const lr=cr.CONNECTION_DISCONNECTED,hr=cr.CONNECTION_ESTABLISHED,ur=cr.CONNECTION_FAILED,pr=cr.CONNECTION_REDIRECTED,mr=cr.WRONG_STATE,gr=cr.DISPLAY_NAME_REQUIRED,fr=cr.PROPERTIES_UPDATED;var vr=n(32);function _r(e){return vr.parse(e)}let Er;n(352),function(e){e.CONNECTION_DROPPED_ERROR="connection.droppedError",e.OTHER_ERROR="connection.otherError",e.PASSWORD_REQUIRED="connection.passwordRequired",e.SERVER_ERROR="connection.serverError"}(Er||(Er={}));const yr=Er.CONNECTION_DROPPED_ERROR,Sr=Er.OTHER_ERROR,br=Er.PASSWORD_REQUIRED,Tr=Er.SERVER_ERROR;class Cr{constructor(){var e=this;this.promise=new Promise(((t,n)=>{this.resolve=function(){e.clearRejectTimeout(),t(...arguments)},this.reject=function(){e.clearRejectTimeout(),n(...arguments)}})),this.then=this.promise.then.bind(this.promise),this.catch=this.promise.catch.bind(this.promise)}clearRejectTimeout(){clearTimeout(this._timeout)}setRejectTimeout(e){this._timeout=setTimeout((()=>{this.reject(new Error("timeout"))}),e)}}class xr{constructor(){this.eventEmitter=new ii,this.addEventListener=this.on=this.addListener,this.removeEventListener=this.off=this.removeListener}addCancellableListener(e,t){return this.addListener(e,t),()=>this.removeListener(e,t)}addListener(e,t){return this.eventEmitter.addListener(e,t)}removeListener(e,t){return this.eventEmitter.removeListener(e,t)}emit(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];this.eventEmitter.emit(e,...n)}}const Rr=(0,y.getLogger)("modules/e2ee/E2EEContext.js"),Ar=Symbol("kJitsiE2EE");class wr{constructor(){let{sharedKey:e}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t="";const n=document.querySelector(\'script[src*="lib-jitsi-meet"]\');if(n){const e=n.src.lastIndexOf("/");t=`${n.src.substring(0,e)}/`}let i=`${t}lib-jitsi-meet.e2ee-worker.js`;if(t&&"/"!==t){const e=new Blob([`importScripts("${i}");`],{type:"application/javascript"});i=window.URL.createObjectURL(e)}this._worker=new Worker(i,{name:"E2EE Worker"}),this._worker.onerror=e=>Rr.error(e),this._worker.postMessage({operation:"initialize",sharedKey:e})}cleanup(e){this._worker.postMessage({operation:"cleanup",participantId:e})}cleanupAll(){this._worker.postMessage({operation:"cleanupAll"})}handleReceiver(e,t,n){if(!e[Ar])if(e[Ar]=!0,window.RTCRtpScriptTransform){const t={operation:"decode",participantId:n};e.transform=new RTCRtpScriptTransform(this._worker,t)}else{const t=e.createEncodedStreams();this._worker.postMessage({operation:"decode",readableStream:t.readable,writableStream:t.writable,participantId:n},[t.readable,t.writable])}}handleSender(e,t,n){if(!e[Ar])if(e[Ar]=!0,window.RTCRtpScriptTransform){const t={operation:"encode",participantId:n};e.transform=new RTCRtpScriptTransform(this._worker,t)}else{const t=e.createEncodedStreams();this._worker.postMessage({operation:"encode",readableStream:t.readable,writableStream:t.writable,participantId:n},[t.readable,t.writable])}}setKey(e,t,n){this._worker.postMessage({operation:"setKey",key:t,keyIndex:n,participantId:e})}}const Ir=(0,y.getLogger)("modules/e2ee/KeyHandler.js");class Pr extends xr{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(),this.conference=e,this.e2eeCtx=new wr(t),this.enabled=!1,this._enabling=void 0,this.conference.on(q,this._onMediaSessionStarted.bind(this)),this.conference.on(tt,(e=>e.isLocal()&&this._onLocalTrackAdded(e))),this.conference.rtc.on(ji.default.REMOTE_TRACK_ADDED,((e,t)=>this._setupReceiverE2EEForTrack(t,e))),this.conference.on(it,this._trackMuteChanged.bind(this))}isEnabled(){return this.enabled}async setEnabled(e){this._enabling&&await this._enabling,e!==this.enabled&&(this._enabling=new Cr,this.enabled=e,e||this.e2eeCtx.cleanupAll(),this._setEnabled&&await this._setEnabled(e),this.conference.setLocalParticipantProperty("e2ee.enabled",e),this.conference._restartMediaSessions(),this._enabling.resolve())}setEncryptionKey(){throw new Error("Not implemented by subclass")}_onLocalTrackAdded(e){for(const t of this.conference.getMediaSessions())this._setupSenderE2EEForTrack(t,e)}_onMediaSessionStarted(e){const t=this.conference.getLocalTracks();for(const n of t)this._setupSenderE2EEForTrack(e,n)}_setupReceiverE2EEForTrack(e,t){if(!this.enabled)return;const n=e.findReceiverForTrack(t.track);n?this.e2eeCtx.handleReceiver(n,t.getType(),t.getParticipantId()):Ir.warn(`Could not handle E2EE for ${t}: receiver not found in: ${e}`)}_setupSenderE2EEForTrack(e,t){if(!this.enabled)return;const n=e.peerconnection,i=n&&n.findSenderForTrack(t.track);i?this.e2eeCtx.handleSender(i,t.getType(),t.getParticipantId()):Ir.warn(`Could not handle E2EE for ${t}: sender not found in ${n}`)}_trackMuteChanged(e){if(ci.doesVideoMuteByStreamRemove()&&e.isLocal()&&e.isVideoTrack()&&!e.isMuted())for(const t of this.conference.getMediaSessions())this._setupSenderE2EEForTrack(t,e)}}class Dr extends Pr{constructor(e){super(e,{sharedKey:!0})}setKey(e){this.e2eeCtx.setKey(void 0,{encryptionKey:e.encryptionKey},e.index)}}var Or=n(509),kr=n.n(Or),Nr=n(577),Mr=n(433);Mr.v1,Mr.v3;const Lr=Mr.v4;let Fr;Mr.v5,function(e){e.E2EE_SAS_KEYS_MAC_MISMATCH="e2ee.sas.keys-mac-mismatch",e.E2EE_SAS_MAC_MISMATCH="e2ee.sas.mac-mismatch",e.E2EE_SAS_MISSING_KEY="e2ee.sas.missing-key",e.E2EE_SAS_COMMITMENT_MISMATCHED="e2ee.sas.commitment-mismatched",e.E2EE_SAS_CHANNEL_VERIFICATION_FAILED="e2ee.sas.channel-verification-failed",e.E2EE_SAS_INVALID_SAS_VERIFICATION="e2ee.sas.invalid-sas-verification"}(Fr||(Fr={}));const jr=[["🐶","dog"],["🐱","cat"],["🦁","lion"],["🐎","horse"],["🦄","unicorn"],["🐷","pig"],["🐘","elephant"],["🐰","rabbit"],["🐼","panda"],["🐓","rooster"],["🐧","penguin"],["🐢","turtle"],["🐟","fish"],["🐙","octopus"],["🦋","butterfly"],["🌷","flower"],["🌳","tree"],["🌵","cactus"],["🍄","mushroom"],["🌏","globe"],["🌙","moon"],["☁️","cloud"],["🔥","fire"],["🍌","banana"],["🍎","apple"],["🍓","strawberry"],["🌽","corn"],["🍕","pizza"],["🎂","cake"],["❤️","heart"],["🙂","smiley"],["🤖","robot"],["🎩","hat"],["👓","glasses"],["🔧","spanner"],["🎅","santa"],["👍","thumbs up"],["☂️","umbrella"],["⌛","hourglass"],["⏰","clock"],["🎁","gift"],["💡","light bulb"],["📕","book"],["✏️","pencil"],["📎","paperclip"],["✂️","scissors"],["🔒","lock"],["🔑","key"],["🔨","hammer"],["☎️","telephone"],["🏁","flag"],["🚂","train"],["🚲","bicycle"],["✈️","aeroplane"],["🚀","rocket"],["🏆","trophy"],["⚽","ball"],["🎸","guitar"],["🎺","trumpet"],["🔔","bell"],["⚓️","anchor"],["🎧","headphones"],["📁","folder"],["📌","pin"]],Vr={decimal:function(e){return[1e3+(e[0]<<5|e[1]>>3),1e3+((7&e[1])<<10|e[2]<<2|e[3]>>6),1e3+((63&e[3])<<7|e[4]>>1)]},emoji:function(e){return[e[0]>>2,(3&e[0])<<4|e[1]>>4,(15&e[1])<<2|e[2]>>6,63&e[2],e[3]>>2,(3&e[3])<<4|e[4]>>4,(15&e[4])<<2|e[5]>>6].map((e=>jr[e]))}},Ur=(0,y.getLogger)("modules/e2ee/OlmAdapter.js"),Hr=5e3,$r="olm",Jr="error",Br="key-info",qr="key-info-ack",Gr="session-ack",zr="session-init",Kr="sas-start",Wr="sas-accept",Xr="sas-key",Yr="sas-mac",Qr="Jitsi-KEY_VERIFICATION_MAC",Zr="Jitsi-KEY_IDS",eo=Symbol("OlmData"),to={PARTICIPANT_E2EE_CHANNEL_READY:"olm.participant_e2ee_channel_ready",PARTICIPANT_SAS_AVAILABLE:"olm.participant_sas_available",PARTICIPANT_SAS_READY:"olm.participant_sas_ready",PARTICIPANT_KEY_UPDATED:"olm.partitipant_key_updated",PARTICIPANT_VERIFICATION_COMPLETED:"olm.participant_verification_completed"};class no extends xr{constructor(e){super(),this._conf=e,this._init=new Cr,this._mediaKey=void 0,this._mediaKeyIndex=-1,this._reqs=new Map,this._sessionInitialization=void 0,no.isSupported()?(this._bootstrapOlm(),this._conf.on(Ce,this._onEndpointMessageReceived.bind(this)),this._conf.on(le,this._onConferenceLeft.bind(this)),this._conf.on(dt,this._onParticipantLeft.bind(this)),this._conf.on(qe,this._onParticipantPropertyChanged.bind(this))):this._init.reject(new Error("Olm not supported"))}get myId(){return this._conf.myUserId()}async initSessions(){if(this._sessionInitialization)throw new Error("OlmAdapter initSessions called multiple times");{this._sessionInitialization=new Cr,await this._init;const e=[],t=this._conf.myUserId();for(const n of this._conf.getParticipants())n.hasFeature(Ia)&&t<n.getId()&&e.push(this._sendSessionInit(n));await Promise.allSettled(e),this._sessionInitialization.resolve(),this._sessionInitialization=void 0}}static isSupported(){return void 0!==window.Olm}async updateKey(e){this._mediaKey=e,this._mediaKeyIndex++;const t=[];for(const e of this._conf.getParticipants()){const n=e.getId(),i=this._getParticipantOlmData(e);if(!i.session){Ur.warn(`Tried to send key to participant ${n} but we have no session`);continue}const r=Lr(),o={[Aa]:$r,olm:{type:Br,data:{ciphertext:this._encryptKeyInfo(i.session),uuid:r}}},s=new Cr;s.setRejectTimeout(Hr),s.catch((()=>{this._reqs.delete(r)})),this._reqs.set(r,s),t.push(s),this._sendMessage(o,n)}return await Promise.allSettled(t),this._mediaKeyIndex}updateCurrentMediaKey(e){return this._mediaKey=e,this._mediaKeyIndex}clearParticipantSession(e){const t=this._getParticipantOlmData(e);t.session&&(t.session.free(),t.session=void 0)}clearAllParticipantsSessions(){for(const e of this._conf.getParticipants())this.clearParticipantSession(e)}markParticipantVerified(e,t){const n=this._getParticipantOlmData(e),i=e.getId();if(!t)return n.sasVerification=void 0,Ur.warn(`Verification failed for participant ${i}`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_CHANNEL_VERIFICATION_FAILED);if(!n.sasVerification)return Ur.warn(`Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{sas:r,sasMacSent:o}=n.sasVerification;r&&r.is_their_key_set()&&!o&&(this._sendSasMac(e),n.sasVerification.sasMacSent=!0)}async _bootstrapOlm(){Ur.debug("Initializing Olm...");try{await Olm.init(),this._olmAccount=new Olm.Account,this._olmAccount.create(),this._idKeys=_r(this._olmAccount.identity_keys()),Ur.debug(`Olm ${Olm.get_library_version().join(".")} initialized`),this._init.resolve(),this._onIdKeysReady(this._idKeys)}catch(e){Ur.error("Failed to initialize Olm",e),this._init.reject(e)}}startVerification(e){const t=e.getId(),n=this._getParticipantOlmData(e);if(!n.session)return void Ur.warn(`Tried to start verification with participant ${t} but we have no session`);if(n.sasVerification)return void Ur.warn(`There is already a verification in progress with participant ${t}`);n.sasVerification={sas:new Olm.SAS,transactionId:Lr()};const i={transactionId:n.sasVerification.transactionId};n.sasVerification.startContent=i,n.sasVerification.isInitiator=!0;const r={[Aa]:$r,olm:{type:Kr,data:i}};this._sendMessage(r,t)}_onIdKeysReady(e){Ur.debug(`Olm id key ready: ${e}`);for(const t in e)if(e.hasOwnProperty(t)){const n=e[t];this._conf.setLocalParticipantProperty(`e2ee.idKey.${t}`,n)}}_onParticipantE2EEChannelReady(e){Ur.debug(`E2EE channel with participant ${e} is ready`)}_encryptKeyInfo(e){const t={};return void 0!==this._mediaKey&&(t.key=!!this._mediaKey&&Nr.fromByteArray(this._mediaKey),t.keyIndex=this._mediaKeyIndex),e.encrypt(JSON.stringify(t))}_getParticipantOlmData(e){return e[eo]=e[eo]||{},e[eo]}async _onConferenceLeft(){Ur.debug("Conference left"),await this._init;for(const e of this._conf.getParticipants())this._onParticipantLeft(e.getId(),e);this._olmAccount&&(this._olmAccount.free(),this._olmAccount=void 0)}async _onEndpointMessageReceived(e,t){if(t[Aa]!==$r)return;if(!t.olm)return void Ur.warn("Incorrectly formatted message");await this._init;const n=t.olm,i=e.getId(),r=this._getParticipantOlmData(e);switch(n.type){case zr:if(r.session)Ur.warn(`Participant ${i} already has a session`),this._sendError(e,"Session already established");else{const e=new Olm.Session;e.create_outbound(this._olmAccount,n.data.idKey,n.data.otKey),r.session=e;const t={[Aa]:$r,olm:{type:Gr,data:{ciphertext:this._encryptKeyInfo(e),uuid:n.data.uuid}}};this._sendMessage(t,i),this._onParticipantE2EEChannelReady(i)}break;case Gr:if(r.session)Ur.warn(`Participant ${i} already has a session`),this._sendError(e,"No session found");else if(n.data.uuid===r.pendingSessionUuid){const{ciphertext:e}=n.data,t=this._reqs.get(n.data.uuid),o=new Olm.Session;o.create_inbound(this._olmAccount,e.body),this._olmAccount.remove_one_time_keys(o);const s=o.decrypt(e.type,e.body);r.session=o,r.pendingSessionUuid=void 0,this._onParticipantE2EEChannelReady(i),this._reqs.delete(n.data.uuid),t.resolve();const a=io(s);if(a.key){const e=Nr.toByteArray(a.key),t=a.keyIndex;r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,t)}}else Ur.warn("Received ACK with the wrong UUID"),this._sendError(e,"Invalid UUID");break;case Jr:Ur.error(n.data.error);break;case Br:if(r.session){const{ciphertext:e}=n.data,t=io(r.session.decrypt(e.type,e.body));if(void 0!==t.key&&void 0!==t.keyIndex){const e=!!t.key&&Nr.toByteArray(t.key),o=t.keyIndex;yt()(r.lastKey,e)||(r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,o));const s={[Aa]:$r,olm:{type:qr,data:{ciphertext:this._encryptKeyInfo(r.session),uuid:n.data.uuid}}};this._sendMessage(s,i)}}else Ur.debug(`Received key info message from ${i} but we have no session for them!`),this._sendError(e,"No session found while processing key-info");break;case qr:if(r.session){const{ciphertext:e}=n.data,t=io(r.session.decrypt(e.type,e.body));if(void 0!==t.key&&void 0!==t.keyIndex){const e=!!t.key&&Nr.toByteArray(t.key),n=t.keyIndex;yt()(r.lastKey,e)||(r.lastKey=e,this.eventEmitter.emit(to.PARTICIPANT_KEY_UPDATED,i,e,n))}const o=this._reqs.get(n.data.uuid);this._reqs.delete(n.data.uuid),o.resolve()}else Ur.debug(`Received key info ack message from ${i} but we have no session for them!`),this._sendError(e,"No session found while processing key-info-ack");break;case Kr:{var o;if(!r.session)return Ur.debug(`Received sas init message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-init");if(null!==(o=r.sasVerification)&&void 0!==o&&o.sas)return Ur.warn(`SAS already created for participant ${i}`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{transactionId:t}=n.data,s=new Olm.SAS;r.sasVerification={sas:s,transactionId:t,isInitiator:!1};const a=r.sasVerification.sas.get_pubkey(),d=this._computeCommitment(a,n.data),c={[Aa]:$r,olm:{type:Wr,data:{transactionId:t,commitment:d}}};this._sendMessage(c,i);break}case Wr:{if(!r.session)return Ur.debug(`Received sas accept message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-accept");const{commitment:t,transactionId:o}=n.data;if(!r.sasVerification)return Ur.warn(`SAS_ACCEPT Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);if(r.sasVerification.sasCommitment)return Ur.debug(`Already received sas commitment message from ${i}!`),void this._sendError(e,"Already received sas commitment message from ${pId}!");r.sasVerification.sasCommitment=t;const s=r.sasVerification.sas.get_pubkey(),a={[Aa]:$r,olm:{type:Xr,data:{key:s,transactionId:o}}};this._sendMessage(a,i),r.sasVerification.keySent=!0;break}case Xr:{if(!r.session)return Ur.debug(`Received sas key message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-key");if(!r.sasVerification)return Ur.warn(`SAS_KEY Participant ${i} does not have valid sasVerification`),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_INVALID_SAS_VERIFICATION);const{isInitiator:t,sas:o,sasCommitment:s,startContent:a,keySent:d}=r.sasVerification;if(o.is_their_key_set())return void Ur.warn("SAS already has their key!");const{key:c,transactionId:l}=n.data;if(s&&s!==this._computeCommitment(c,a))return this._sendError(e,"OlmAdapter commitments mismatched"),this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_COMMITMENT_MISMATCHED),void r.sasVerification.free();o.set_their_key(c);const h=o.get_pubkey(),u=`${this.myId}|${h}`,p=`${i}|${c}`,m=t?`${u}|${p}`:`${p}|${u}`,g=function(e){const t={};for(const n in Vr)Vr.hasOwnProperty(n)&&(t[n]=Vr[n](e));return t}(o.generate_bytes(m,6));if(this.eventEmitter.emit(to.PARTICIPANT_SAS_READY,i,g),d)return;const f={[Aa]:$r,olm:{type:Xr,data:{key:h,transactionId:l}}};this._sendMessage(f,i),r.sasVerification.keySent=!0;break}case Yr:{if(!r.session)return Ur.debug(`Received sas mac message from ${i} but we have no session for them!`),void this._sendError(e,"No session found while processing sas-mac");const{keys:t,mac:o,transactionId:s}=n.data;if(!o||!t)return void Ur.warn("Invalid SAS MAC message");if(!r.sasVerification)return void Ur.warn(`SAS_MAC Participant ${i} does not have valid sasVerification`);const a=r.sasVerification.sas,d=`${Qr}${i}${this.myId}${s}`;if(a.calculate_mac(Object.keys(o).sort().join(","),d+Zr)!==t)return Ur.error("SAS verification error: keys MAC mismatch"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_KEYS_MAC_MISMATCH);if(!r.ed25519)return Ur.warn("SAS verification error: Missing ed25519 key"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_MISSING_KEY);for(const[e,t]of Object.entries(o))if(t!==a.calculate_mac(r.ed25519,d+e))return Ur.error("SAS verification error: MAC mismatch"),void this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!1,Fr.E2EE_SAS_MAC_MISMATCH);Ur.info(`SAS MAC verified for participant ${i}`),this.eventEmitter.emit(to.PARTICIPANT_VERIFICATION_COMPLETED,i,!0);break}}}_onParticipantLeft(e,t){Ur.debug(`Participant ${e} left`),this.clearParticipantSession(t)}async _onParticipantPropertyChanged(e,t,n,i){const r=e.getId(),o=this._getParticipantOlmData(e);switch(t){case"e2ee.enabled":if(i&&this._conf.isE2EEEnabled()){const t=this._conf.myUserId();if((await e.getFeatures()).has(Ia)&&t<r){this._sessionInitialization&&await this._sessionInitialization,await this._sendSessionInit(e);const t=Lr(),n=new Cr;n.setRejectTimeout(Hr),n.catch((()=>{this._reqs.delete(t),o.pendingSessionUuid=void 0})),this._reqs.set(t,n);const i={[Aa]:$r,olm:{type:Br,data:{ciphertext:this._encryptKeyInfo(o.session),uuid:t}}};this._sendMessage(i,r)}}break;case"e2ee.idKey.ed25519":o.ed25519=i,this.eventEmitter.emit(to.PARTICIPANT_SAS_AVAILABLE,r)}}_sendError(e,t){const n=e.getId(),i={[Aa]:$r,olm:{type:Jr,data:{error:t}}};this._sendMessage(i,n)}_sendMessage(e,t){this._conf.sendMessage(e,t)}_sendSessionInit(e){const t=e.getId(),n=this._getParticipantOlmData(e);if(n.session)return Ur.warn(`Tried to send session-init to ${t} but we already have a session`),Promise.reject();if(void 0!==n.pendingSessionUuid)return Ur.warn(`Tried to send session-init to ${t} but we already have a pending session`),Promise.reject();this._olmAccount.generate_one_time_keys(1);const i=_r(this._olmAccount.one_time_keys()),r=Object.values(i.curve25519)[0];if(!r)return Promise.reject(new Error("No one-time-keys generated"));this._olmAccount.mark_keys_as_published();const o=Lr(),s={[Aa]:$r,olm:{type:zr,data:{idKey:this._idKeys.curve25519,otKey:r,uuid:o}}},a=new Cr;return a.setRejectTimeout(Hr),a.catch((()=>{this._reqs.delete(o),n.pendingSessionUuid=void 0})),this._reqs.set(o,a),this._sendMessage(s,t),n.pendingSessionUuid=o,a}_sendSasMac(e){const t=e.getId(),n=this._getParticipantOlmData(e),{sas:i,transactionId:r}=n.sasVerification,o={},s=[],a=`${Qr}${this.myId}${t}${r}`,d=`ed25519:${t}`;o[d]=i.calculate_mac(this._idKeys.ed25519,a+d),s.push(d);const c=i.calculate_mac(s.sort().join(","),a+Zr),l={[Aa]:$r,olm:{type:Yr,data:{keys:c,mac:o,transactionId:r}}};this._sendMessage(l,t)}_computeCommitment(e,t){const n=new Olm.Utility,i=n.sha256(e+JSON.stringify(t));return n.free(),i}}function io(e){try{return _r(e)}catch(e){return{}}}no.events=to;const ro=(0,y.getLogger)("modules/e2ee/ManagedKeyHandler.js");class oo extends Pr{constructor(e){super(e),this._key=void 0,this._conferenceJoined=!1,this._olmAdapter=new no(e),this._rotateKey=kr()(this._rotateKeyImpl,5e3),this._ratchetKey=kr()(this._ratchetKeyImpl,5e3),this._olmAdapter.on(no.events.PARTICIPANT_KEY_UPDATED,this._onParticipantKeyUpdated.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_SAS_READY,this._onParticipantSasReady.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_SAS_AVAILABLE,this._onParticipantSasAvailable.bind(this)),this._olmAdapter.on(no.events.PARTICIPANT_VERIFICATION_COMPLETED,this._onParticipantVerificationCompleted.bind(this)),this.conference.on(qe,this._onParticipantPropertyChanged.bind(this)),this.conference.on(at,this._onParticipantJoined.bind(this)),this.conference.on(dt,this._onParticipantLeft.bind(this)),this.conference.on(ce,(()=>{this._conferenceJoined=!0}))}get sasVerification(){return this._olmAdapter}async _setEnabled(e){e?await this._olmAdapter.initSessions():this._olmAdapter.clearAllParticipantsSessions(),this._key=!!e&&this._generateKey();const t=await this._olmAdapter.updateKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,t)}async _onParticipantPropertyChanged(e,t,n,i){switch(t){case"e2ee.idKey":ro.debug(`Participant ${e.getId()} updated their id key: ${i}`);break;case"e2ee.enabled":!i&&this.enabled&&this._olmAdapter.clearParticipantSession(e)}}_onParticipantJoined(){this._conferenceJoined&&this.enabled&&this._ratchetKey()}_onParticipantLeft(e){this.e2eeCtx.cleanup(e),this.enabled&&this._rotateKey()}async _rotateKeyImpl(){ro.debug("Rotating key"),this._key=this._generateKey();const e=await this._olmAdapter.updateKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,e)}async _ratchetKeyImpl(){ro.debug("Ratchetting key");const e=await async function(e){return crypto.subtle.importKey("raw",e,"HKDF",!1,["deriveBits","deriveKey"])}(this._key),t=await async function(e){const t=new TextEncoder;return crypto.subtle.deriveBits({name:"HKDF",salt:t.encode("JFrameRatchetKey"),hash:"SHA-256",info:new ArrayBuffer},e,256)}(e);this._key=new Uint8Array(t);const n=this._olmAdapter.updateCurrentMediaKey(this._key);this.e2eeCtx.setKey(this.conference.myUserId(),this._key,n)}_onParticipantKeyUpdated(e,t,n){ro.debug(`Participant ${e} updated their key`),this.e2eeCtx.setKey(e,t,n)}_onParticipantSasReady(e,t){this.conference.eventEmitter.emit(Te,e,t)}_onParticipantSasAvailable(e){this.conference.eventEmitter.emit(Se,e)}_onParticipantVerificationCompleted(e,t,n){this.conference.eventEmitter.emit(be,e,t,n)}_generateKey(){return window.crypto.getRandomValues(new Uint8Array(32))}}class so{constructor(e){const{e2ee:t={}}=e.options.config;this._externallyManaged=t.externallyManagedKey,this._externallyManaged?this._keyHandler=new Dr(e):this._keyHandler=new oo(e)}static isSupported(e){const{e2ee:t={}}=e;return!(!t.externallyManagedKey&&!no.isSupported())&&!(e.testing&&e.testing.disableE2EE)&&(ci.supportsInsertableStreams()||e.enableEncodedTransformSupport&&ci.supportsEncodedTransform())}isEnabled(){return this._keyHandler.isEnabled()}async setEnabled(e){await this._keyHandler.setEnabled(e)}setEncryptionKey(e){this._keyHandler.setKey(e)}startVerification(e){var t;null===(t=this._keyHandler.sasVerification)||void 0===t||t.startVerification(e)}markParticipantVerified(e,t){var n;null===(n=this._keyHandler.sasVerification)||void 0===n||n.markParticipantVerified(e,t)}}var ao=n(399),co=n.n(ao);function lo(e,t){e[t>>5]|=128<<24-t%32,e[15+(t+64>>9<<4)]=t;var n,i,r,o,s,a,d,c,l=new Array(80),h=1732584193,u=-271733879,p=-1732584194,m=271733878,g=-1009589776;for(n=0;n<e.length;n+=16){for(o=h,s=u,a=p,d=m,c=g,i=0;i<80;i++)l[i]=i<16?e[n+i]:mo(l[i-3]^l[i-8]^l[i-14]^l[i-16],1),r=po(po(mo(h,5),ho(i,u,p,m)),po(po(g,l[i]),uo(i))),g=m,m=p,p=mo(u,30),u=h,h=r;h=po(h,o),u=po(u,s),p=po(p,a),m=po(m,d),g=po(g,c)}return[h,u,p,m,g]}function ho(e,t,n,i){return e<20?t&n|~t&i:e<40?t^n^i:e<60?t&n|t&i|n&i:t^n^i}function uo(e){return e<20?1518500249:e<40?1859775393:e<60?-1894007588:-899497514}function po(e,t){var n=(65535&e)+(65535&t);return(e>>16)+(t>>16)+(n>>16)<<16|65535&n}function mo(e,t){return e<<t|e>>>32-t}function go(e){for(var t=[],n=0;n<8*e.length;n+=8)t[n>>5]|=(255&e.charCodeAt(n/8))<<24-n%32;return t}function fo(e){for(var t,n,i="",r=0;r<4*e.length;r+=3)for(t=(e[r>>2]>>8*(3-r%4)&255)<<16|(e[r+1>>2]>>8*(3-(r+1)%4)&255)<<8|e[r+2>>2]>>8*(3-(r+2)%4)&255,n=0;n<4;n++)8*r+6*n>32*e.length?i+="=":i+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(t>>6*(3-n)&63);return i}const vo=function(e){return fo(lo(go(e),8*e.length))},_o=["category","type","lang","name"],Eo=["category","type","lang"];function yo(e,t){let n=0;return Eo.some((i=>0!==(n=e[i]>t[i]?1:e[i]<t[i]&&-1))),n}function So(e){const t=new Set,n=new Set;return _t()(e).find(">query>feature").each(((e,n)=>t.add(n.getAttribute("var")))),_t()(e).find(">query>identity").each(((e,t)=>n.add({type:t.getAttribute("type"),name:t.getAttribute("name"),category:t.getAttribute("category")}))),{features:t,identities:n}}class bo extends xr{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"http://jitsi.org/jitsimeet";if(super(),this.node=t,this.disco=e.disco,!this.disco)throw new Error("Missing strophe-plugins (disco plugin is required)!");this.version="",this.rooms=new Set,this.externalFeatures=new Set;const n=e.emuc;n.addListener(Hi.XMPPEvents.EMUC_ROOM_ADDED,(e=>this._addChatRoom(e))),n.addListener(Hi.XMPPEvents.EMUC_ROOM_REMOVED,(e=>this._removeChatRoom(e))),Object.keys(n.rooms).forEach((e=>{this._addChatRoom(n.rooms[e])})),St.Strophe.addNamespace("CAPS","http://jabber.org/protocol/caps"),this.disco.addFeature(St.Strophe.NS.CAPS)}addFeature(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this.disco.addFeature(e),this._generateVersion(),n&&!this.externalFeatures.has(e)&&(this.externalFeatures.add(e),this.rooms.forEach((e=>this._updateRoomWithExternalFeatures(e)))),t&&this.submit()}removeFeature(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];this.disco.removeFeature(e),this._generateVersion(),n&&this.externalFeatures.has(e)&&(this.externalFeatures.delete(e),this.rooms.forEach((e=>this._updateRoomWithExternalFeatures(e)))),t&&this.submit()}submit(){this.rooms.forEach((e=>e.sendPresence()))}_updateRoomWithExternalFeatures(e){if(0===this.externalFeatures.size)e.removeFromPresence("features");else{const t=[];this.externalFeatures.forEach((e=>{t.push({tagName:"feature",attributes:{var:e}})})),e.addOrReplaceInPresence("features",{children:t})}}getFeaturesAndIdentities(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:5e3;return this._getDiscoInfo(e,t,n)}_getDiscoInfo(e,t,n){return new Promise(((i,r)=>this.disco.info(e,t,(e=>{i(So(e))}),r,n)))}_addChatRoom(e){this.rooms.add(e),this._fixChatRoomPresenceMap(e),this._updateRoomWithExternalFeatures(e)}_removeChatRoom(e){this.rooms.delete(e)}_fixChatRoomPresenceMap(e){e.addOrReplaceInPresence("c",{attributes:{xmlns:St.Strophe.NS.CAPS,hash:"sha-1",node:this.node,ver:this.version}})}_notifyVersionChanged(){this.rooms.forEach((e=>this._fixChatRoomPresenceMap(e)))}_generateVersion(){this.version=function(e,t){const n=e.sort(yo).reduce(((e,t)=>`${_o.reduce(((e,n,i)=>e+(0===i?"":"/")+(t[n]?t[n]:"")),"")}<`),""),i=t.sort().reduce(((e,t)=>`${e+t}<`),"");return vo(n+i)}(this.disco._identities,this.disco._features),this._notifyVersionChanged()}}n(617);const To="NETWORK_INFO_CHANGED",Co=(0,y.getLogger)("modules/connectivity/NetworkInfo.js"),xo=new class extends xr{constructor(){super(),this._current={isOnline:!0}}updateNetworkInfo(e){let{isOnline:t}=e;Co.debug("updateNetworkInfo",{isOnline:t}),this._current={isOnline:!0===t},this.eventEmitter.emit(To,this._current)}isOnline(){return!0===this._current.isOnline}};function Ro(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:500,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:2;return Math.floor(Math.random()*(1e3*Math.pow(n,e)-t)+t)}const Ao=(0,y.getLogger)("modules/xmpp/ResumeTask.js");class wo{constructor(e){this._stropheConn=e,this._resumeRetryN=0,this._retryDelay=void 0}get retryDelay(){return this._retryDelay}schedule(){this._cancelResume(),this._resumeRetryN+=1,this._networkOnlineListener=xo.addCancellableListener(To,(e=>{let{isOnline:t}=e;t?this._scheduleResume():this._cancelResume()})),xo.isOnline()&&this._scheduleResume()}_scheduleResume(){this._resumeTimeout||(this._resumeRetryN=Math.min(3,this._resumeRetryN),this._retryDelay=Ro(this._resumeRetryN,1500*this._resumeRetryN,3),Ao.info(`Will try to resume the XMPP connection in ${this.retryDelay}ms`),this._resumeTimeout=setTimeout((()=>this._resumeConnection()),this.retryDelay))}_cancelResume(){this._resumeTimeout&&(Ao.info("Canceling connection resume task"),clearTimeout(this._resumeTimeout),this._resumeTimeout=void 0,this._retryDelay=void 0)}_resumeConnection(){const{streamManagement:e}=this._stropheConn,t=e.getResumeToken();if(!t)return;Ao.info("Trying to resume the XMPP connection");const n=new URL(this._stropheConn.service);let{search:i}=n;const r=/(previd=)([\\w-]+)/,o=i.match(r);o&&-1===o.indexOf(t)?i=i.replace(r,`$1${t}`):o||(i+=-1===i.indexOf("?")?`?previd=${t}`:`&previd=${t}`),n.search=i,this._stropheConn.service=n.toString(),e.resume()}cancel(){this._cancelResume(),this._resumeRetryN=0,this._networkOnlineListener&&(this._networkOnlineListener(),this._networkOnlineListener=null)}}class Io{constructor(){this._lastSuccess=null,this._lastFailedMessage=null}startTracking(e,t){var n=this;const i=t.rawInput;t.rawInput=function(){for(var r=arguments.length,o=new Array(r),s=0;s<r;s++)o[s]=arguments[s];const a=o[0];a.includes("failure")&&(n._lastFailedMessage=a),e.connected&&(n._lastSuccess=Date.now()),i.apply(t,o)}}getLastFailedMessage(){return this._lastFailedMessage}getTimeSinceLastSuccess(){return this._lastSuccess?Date.now()-this._lastSuccess:null}}function Po(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:class{};return class extends e{constructor(){super(...arguments),this.connection=null}init(e){this.connection=e}}}const Do=Po(),Oo=Po(xr),ko=(0,y.getLogger)("modules/xmpp/strophe.ping.js");class No extends Do{constructor(e){let{getTimeSinceLastServerResponse:t,onPingThresholdExceeded:n,pingOptions:i={}}=e;super(),this.failedPings=0,this._onPingThresholdExceeded=n,this._getTimeSinceLastServerResponse=t,this.pingInterval="number"==typeof i.interval?i.interval:1e4,this.pingTimeout="number"==typeof i.timeout?i.timeout:5e3,this.pingThreshold="number"==typeof i.threshold?i.threshold:2,this.pingTimestampsToKeep=Math.round(12e4/this.pingInterval),this.pingExecIntervals=new Array(this.pingTimestampsToKeep)}init(e){super.init(e),St.Strophe.addNamespace("PING","urn:xmpp:ping")}ping(e,t,n,i){this._addPingExecutionTimestamp();const r=(0,St.$iq)({type:"get",to:e});r.c("ping",{xmlns:St.Strophe.NS.PING}),this.connection.sendIQ2(r,{timeout:i}).then(t,n)}startInterval(e){clearInterval(this.intervalId),this.intervalId=window.setInterval((()=>{const t=Date.now();if(this._getTimeSinceLastServerResponse()<t-this._lastServerCheck)return this._addPingExecutionTimestamp(),this._lastServerCheck=t,void(this.failedPings=0);this.ping(e,(()=>{this._lastServerCheck=this._getTimeSinceLastServerResponse()+Date.now(),this.failedPings=0}),(e=>{this.failedPings+=1;const t="Ping "+(e?"error":"timeout");this.failedPings>=this.pingThreshold?(ko.error(t,e),this._onPingThresholdExceeded&&this._onPingThresholdExceeded()):ko.warn(t,e)}),this.pingTimeout)}),this.pingInterval),ko.info(`XMPP pings will be sent every ${this.pingInterval} ms`)}stopInterval(){this.intervalId&&(window.clearInterval(this.intervalId),this.intervalId=null,this.failedPings=0,ko.info("Ping interval cleared"))}_addPingExecutionTimestamp(){this.pingExecIntervals.push((new Date).getTime()),this.pingExecIntervals.length>this.pingTimestampsToKeep&&this.pingExecIntervals.shift()}getPingSuspendTime(){const e=this.pingExecIntervals.slice();e.push((new Date).getTime());let t=0,n=e[0];return e.forEach((e=>{const i=e-n;i>t&&(t=i),n=e})),t-=this.pingInterval,Math.max(t,0)}}const Mo=(0,y.getLogger)("modules/xmpp/XmppConnection.js");class Lo extends xr{static get Events(){return{CONN_STATUS_CHANGED:"CONN_STATUS_CHANGED",CONN_SHARD_CHANGED:"CONN_SHARD_CHANGED"}}static get Status(){return St.Strophe.Status}constructor(e){let{enableWebsocketResume:t,websocketKeepAlive:n,websocketKeepAliveUrl:i,serviceUrl:r,shard:o,xmppPing:s}=e;super(),this._options={enableWebsocketResume:void 0===t||t,pingOptions:s,shard:o,websocketKeepAlive:void 0===n?6e4:Number(n),websocketKeepAliveUrl:i},this._stropheConn=new St.Strophe.Connection(r),this._usesWebsocket=r.startsWith("ws:")||r.startsWith("wss:"),this._stropheConn.maxRetries=3,this._rawInputTracker=new Io,this._rawInputTracker.startTracking(this,this._stropheConn),this._resumeTask=new wo(this._stropheConn),this._deferredIQs=[],this.addConnectionPlugin("ping",new No({getTimeSinceLastServerResponse:()=>this.getTimeSinceLastSuccess(),onPingThresholdExceeded:()=>this._onPingErrorThresholdExceeded(),pingOptions:s})),this._oneSuccessfulConnect=!1}get connected(){const e=this._stropheConn&&this._stropheConn._proto&&this._stropheConn._proto.socket;return(this._status===St.Strophe.Status.CONNECTED||this._status===St.Strophe.Status.ATTACHED)&&(!this.isUsingWebSocket||e&&e.readyState===WebSocket.OPEN)}get disco(){return this._stropheConn.disco}get disconnecting(){return!0===this._stropheConn.disconnecting}get domain(){return this._stropheConn.domain}get isUsingWebSocket(){return this._usesWebsocket}get jid(){return this._stropheConn.jid}get lastResponseHeaders(){return this._stropheConn._proto&&this._stropheConn._proto.lastResponseHeaders}get logger(){return this._stropheConn.logger}get options(){return this._stropheConn.options}get pingDomain(){var e;return(null===(e=this._options.pingOptions)||void 0===e?void 0:e.domain)||this.domain}get service(){return this._stropheConn.service}set shard(e){this._options.shard=e,this._oneSuccessfulConnect&&this._maybeStartWSKeepAlive()}get status(){return this._status}addConnectionPlugin(e,t){this[e]=t,t.init(this)}addHandler(){return this._stropheConn.addHandler(...arguments)}deleteHandler(){this._stropheConn.deleteHandler(...arguments)}attach(e,t,n,i){for(var r=arguments.length,o=new Array(r>4?r-4:0),s=4;s<r;s++)o[s-4]=arguments[s];this._stropheConn.attach(e,t,n,this._stropheConnectionCb.bind(this,i),...o)}connect(e,t,n){for(var i=arguments.length,r=new Array(i>3?i-3:0),o=3;o<i;o++)r[o-3]=arguments[o];this._stropheConn.connect(e,t,this._stropheConnectionCb.bind(this,n),...r)}_stropheConnectionCb(e,t){this._status=t;let n=!1;var i;if(t===St.Strophe.Status.CONNECTED||t===St.Strophe.Status.ATTACHED?(this._maybeEnableStreamResume(),this._usesWebsocket&&this._oneSuccessfulConnect&&this._keepAliveAndCheckShard(),this._oneSuccessfulConnect=!0,this._maybeStartWSKeepAlive(),this._processDeferredIQs(),this._resumeTask.cancel(),this.ping.startInterval((null===(i=this._options.pingOptions)||void 0===i?void 0:i.domain)||this.domain)):t===St.Strophe.Status.DISCONNECTED&&(this.ping.stopInterval(),n=this._tryResumingConnection(),n||clearTimeout(this._wsKeepAlive)),!n){for(var r=arguments.length,o=new Array(r>2?r-2:0),s=2;s<r;s++)o[s-2]=arguments[s];e(t,...o),this.eventEmitter.emit(Lo.Events.CONN_STATUS_CHANGED,t)}}_clearDeferredIQs(){for(const e of this._deferredIQs)e.reject(new Error("disconnect"));this._deferredIQs=[]}closeWebsocket(){this._stropheConn&&this._stropheConn._proto&&(this._stropheConn._proto._closeSocket(),this._stropheConn._proto._onClose(null))}disconnect(){this._resumeTask.cancel(),clearTimeout(this._wsKeepAlive),this._clearDeferredIQs(),this._stropheConn.disconnect(...arguments)}flush(){this._stropheConn.flush(...arguments)}getTimeSinceLastSuccess(){return this._rawInputTracker.getTimeSinceLastSuccess()}getLastFailedMessage(){return this._rawInputTracker.getLastFailedMessage()}_maybeEnableStreamResume(){if(!this._options.enableWebsocketResume)return;const{streamManagement:e}=this._stropheConn;this.isUsingWebSocket?e?e.isSupported()?e.getResumeToken()||(Mo.info("Enabling XEP-0198 stream management"),e.enable(!0)):Mo.warn("Stream resume enabled, but XEP-0198 is not supported by the server"):Mo.warn("Stream resume enabled, but Strophe streamManagement plugin is not installed"):Mo.warn("Stream resume enabled, but WebSockets are not enabled")}_maybeStartWSKeepAlive(){const{websocketKeepAlive:e}=this._options;if(this._usesWebsocket&&e>0){this._wsKeepAlive||Mo.info(`WebSocket keep alive interval: ${e}ms`),clearTimeout(this._wsKeepAlive);const t=e+60*Math.random()*1e3;Mo.debug(`Scheduling next WebSocket keep-alive in ${t}ms`),this._wsKeepAlive=setTimeout((()=>this._keepAliveAndCheckShard().then((()=>this._maybeStartWSKeepAlive()))),t)}}_keepAliveAndCheckShard(){const{shard:e,websocketKeepAliveUrl:t}=this._options,n=t||this.service.replace("wss://","https://").replace("ws://","http://");return fetch(n).then((t=>{if(!e)return;const n=t.headers.get("x-jitsi-shard");n!==e&&(Mo.error(`Detected that shard changed from ${e} to ${n}`),this.eventEmitter.emit(Lo.Events.CONN_SHARD_CHANGED))})).catch((e=>{Mo.error(`Websocket Keep alive failed for url: ${n}`,{error:e})}))}_processDeferredIQs(){for(const e of this._deferredIQs)if(e.iq){clearTimeout(e.timeout);const t=Date.now()-e.start;this.sendIQ(e.iq,(t=>e.resolve(t)),(t=>e.reject(t)),t)}this._deferredIQs=[]}send(e){var t,n,i;if(!this.connected)throw Mo.error(`Trying to send stanza while not connected. Status:${this._status} Proto:${this.isUsingWebSocket?null===(t=this._stropheConn)||void 0===t||null===(n=t._proto)||void 0===n||null===(i=n.socket)||void 0===i?void 0:i.readyState:"bosh"}`),new Error("Not connected");this._stropheConn.send(e)}sendIQ(e,t,n,i){if(this.connected)return this._stropheConn.sendIQ(e,t,n,i);n("Not connected")}sendIQ2(e,t){let{timeout:n}=t;return new Promise(((t,i)=>{if(this.connected)this.sendIQ(e,(e=>t(e)),(e=>i(e)),n);else{const r={iq:e,resolve:t,reject:i,start:Date.now(),timeout:setTimeout((()=>{r.iq=void 0,i(void 0)}),n)};this._deferredIQs.push(r)}}))}_onPingErrorThresholdExceeded(){this.isUsingWebSocket&&(Mo.warn("Ping error threshold exceeded - killing the WebSocket"),this.closeWebsocket())}sendPresence(e,t,n,i){this.connected?this._stropheConn.sendPresence(e,t,n,i):n("Not connected")}sendUnavailableBeacon(){if(!navigator.sendBeacon||this._stropheConn.disconnecting||!this._stropheConn.connected)return!1;this._stropheConn._changeConnectStatus(St.Strophe.Status.DISCONNECTING),this._stropheConn.disconnecting=!0;const e=this._stropheConn._proto._buildBody().attrs({type:"terminate"}),t=(0,St.$pres)({xmlns:St.Strophe.NS.CLIENT,type:"unavailable"});e.cnode(t.tree());const n=navigator.sendBeacon(-1===this.service.indexOf("https://")?`https:${this.service}`:this.service,St.Strophe.serialize(e.tree()));return Mo.info(`Successfully send unavailable beacon ${n}`),this._stropheConn._proto._abortAllRequests(),this._stropheConn._doDisconnect(),!0}_tryResumingConnection(){const{streamManagement:e}=this._stropheConn;return!(!e||!e.getResumeToken()||(this._resumeTask.schedule(),0))}}var Fo=n(667),jo=n.n(Fo);const Vo=(0,y.getLogger)("modules/settings/Settings.js");let Uo,Ho;const $o={_storage:di,init(e){this._storage=e||di},get callStatsUserName(){return Uo||(Uo=this._storage.getItem("callStatsUserName"),Uo||(Uo=function(){const e=jo().generateUsername();return Vo.log("generated stats id",e),e}(),this._storage.setItem("callStatsUserName",Uo))),Uo},get machineId(){if(!Ho){const e=this._storage.getItem("billingId");Ho=e||this._storage.getItem("jitsiMeetId"),e?this._storage.setItem("jitsiMeetId",e):Ho||(Ho=function(){const e=Jo()+Jo()+Jo()+Jo();return Vo.log("generated id",e),e}(),this._storage.setItem("jitsiMeetId",Ho))}return Ho},get sessionId(){return this._storage.getItem("sessionId")},set sessionId(e){e?this._storage.setItem("sessionId",e):this._storage.removeItem("sessionId")}};function Jo(){return`${Math.random().toString(16)}000000000`.substr(2,8)}const Bo=n(514),{XMPPEvents:qo}=n(609),Go=(0,y.getLogger)("modules/xmpp/moderator.js");function zo(e){let t=1;return function(n){if(n)return void(t=1);const i=Math.pow(2,t-1);return t+=1,Math.min(i*e,12e4)}}class Ko extends xr{constructor(e){var t,n;function i(e){if(e.data&&e.data.sessionId){if(e.origin!==window.location.origin)return void Go.warn(`Ignoring sessionId from different origin: ${e.origin}`);$o.sessionId=e.data.sessionId}}super(),this.getNextTimeout=zo(1e3),this.getNextErrorTimeout=zo(1e3),this.options=e.options,this.sipGatewayEnabled=!1,this.xmpp=e,this.connection=e.connection,this.targetJid=null===(t=this.options.hosts)||void 0===t?void 0:t.focus,this.targetJid||(this.targetJid=`focus.${null===(n=this.options.hosts)||void 0===n?void 0:n.domain}`),this.targetUrl=this.options.conferenceRequestUrl,this.mode=this.targetUrl?"http":"xmpp",Go.info(`Using ${this.mode} for conference requests.`),this.focusUserJids=new Set,this.options.focusUserJid&&this.focusUserJids.add(this.options.focusUserJid),window.addEventListener?window.addEventListener("message",i,!1):window.attachEvent("onmessage",i)}isFocusJid(e){if(!e)return!1;for(const t of this.focusUserJids)if(0===e.indexOf(`${t}/`))return!0;return!1}isSipGatewayEnabled(){return this.sipGatewayEnabled}_createConferenceRequest(e){var t,n;const{sessionId:i}=$o,r=this.options,o={};void 0!==r.startAudioMuted&&(o.startAudioMuted=r.startAudioMuted),void 0!==r.startVideoMuted&&(o.startVideoMuted=r.startVideoMuted),null!==(t=null==r||null===(n=r.analytics)||void 0===n?void 0:n.rtcstatsEnabled)&&void 0!==t&&t||(o.rtcstatsEnabled=!1);const s={properties:o,machineUid:$o.machineId,room:e};return i&&(s.sessionId=i),r.iAmRecorder||r.iAmSipGateway||(s.properties["visitors-version"]=1,this.options.preferVisitor&&(s.properties.visitor=!0)),s}_createConferenceIq(e){const t=this._createConferenceRequest(e),n=(0,St.$iq)({to:this.targetJid,type:"set"});n.c("conference",{xmlns:"http://jitsi.org/protocol/focus",room:e,"machine-uid":t.machineUid}),t.sessionId&&n.attrs({"session-id":t.sessionId});for(const e in t.properties)t.properties.hasOwnProperty(e)&&n.c("property",{name:e,value:t.properties[e]}).up();return n}_parseConferenceIq(e){const t={properties:{}};return t.focusJid=_t()(e).find("conference").attr("focusjid"),t.sessionId=_t()(e).find("conference").attr("session-id"),t.identity=_t()(e).find(">conference").attr("identity"),t.ready="true"===_t()(e).find("conference").attr("ready"),t.vnode=_t()(e).find("conference").attr("vnode"),_t()(e).find(">conference>property[name=\'authentication\'][value=\'true\']").length>0&&(t.properties.authentication="true"),_t()(e).find(">conference>property[name=\'externalAuth\'][value=\'true\']").length>0&&(t.properties.externalAuth="true"),_t()(e).find(">conference>property[name=\'sipGatewayEnabled\'][value=\'true\']").length>0&&(t.properties.sipGatewayEnabled="true"),t}sendConferenceRequest(e){return new Promise((t=>{"xmpp"===this.mode?(Go.info(`Sending conference request over XMPP to ${this.targetJid}`),this.connection.sendIQ(this._createConferenceIq(e),(n=>this._handleIqSuccess(e,n,t)),(n=>this._handleIqError(e,n,t))),this.connection.flush()):(Go.info(`Sending conference request over HTTP to ${this.targetUrl}`),fetch(this.targetUrl,{method:"POST",body:JSON.stringify(this._createConferenceRequest(e)),headers:{"Content-Type":"application/json"}}).then((n=>{n.ok?n.json().then((n=>{this._handleSuccess(e,n,t)})):n.text().then((i=>{Go.warn(`Received HTTP ${n.status} ${n.statusText}. Body: ${i}`);const r=400===n.status&&i.indexOf("400 invalid-session")>0,o=403===n.status;this._handleError(e,r,o,t)})).catch((t=>{Go.warn(`Error: ${t}`),this._handleError(e)}))})).catch((t=>{Go.warn(`Error: ${t}`),this._handleError(e)})))}))}_handleSuccess(e,t,n){this.getNextErrorTimeout(!0),t.focusJid?(Go.info(`Adding focus JID: ${t.focusJid}`),this.focusUserJids.add(t.focusJid)):Go.warn("Conference request response contained no focusJid.");const i="true"===t.properties.authentication;if(Go.info(`Authentication enabled: ${i}`),t.sessionId&&(Go.info(`Received sessionId: ${t.sessionId}`),$o.sessionId=t.sessionId),this.eventEmitter.emit(Bo.IDENTITY_UPDATED,i,t.identity),this.sipGatewayEnabled=t.properties.sipGatewayEnabled,Go.info(`Sip gateway enabled: ${this.sipGatewayEnabled}`),t.ready){if(this.getNextTimeout(!0),t.vnode&&!this.options.iAmRecorder&&!this.options.iAmSipGateway)return Go.warn(`Redirected to: ${t.vnode} with focusJid ${t.focusJid}`),void this.xmpp.eventEmitter.emit(pr,t.vnode,t.focusJid);Go.info("Conference-request successful, ready to join the MUC."),n()}else{const t=this.getNextTimeout();Go.info(`Not ready yet, will retry in ${t} ms.`),window.setTimeout((()=>this.sendConferenceRequest(e).then(n)),t)}}_handleError(e,t,n,i){if(t&&(Go.info("Session expired! - removing"),$o.sessionId=void 0),n)return Go.warn("Unauthorized to start the conference"),void this.eventEmitter.emit(qo.AUTHENTICATION_REQUIRED);const r=this.getNextErrorTimeout();t&&r<6e4?(Go.info(`Invalid session, will retry after ${r} ms.`),this.getNextTimeout(!0),window.setTimeout((()=>this.sendConferenceRequest(e).then(i)),r)):(Go.error("Failed to get a successful response, giving up."),this.eventEmitter.emit(qo.FOCUS_DISCONNECTED))}_handleIqError(e,t,n){const i=_t()(t).find(">error>reservation-error");if(i.length){const e=i.attr("error-code"),n=_t()(t).find(">error>text");let r;return n&&(r=n.text()),void this.eventEmitter.emit(qo.RESERVATION_ERROR,e,r)}const r=Boolean(_t()(t).find(">error>session-invalid").length||_t()(t).find(">error>not-acceptable").length),o=_t()(t).find(">error>not-authorized").length>0;this._handleError(e,r,o,n)}_handleIqSuccess(e,t,n){const i=this._parseConferenceIq(t);this._handleSuccess(e,i,n)}authenticate(e){return new Promise(((t,n)=>{this.connection.sendIQ(this._createConferenceIq(e),(e=>{const n=_t()(e).find("conference").attr("session-id");n?(Go.info(`Received sessionId:  ${n}`),$o.sessionId=n):Go.warn("Response did not contain a session-id"),t()}),(e=>n({error:_t()(e).find("iq>error :first").prop("tagName"),message:_t()(e).find("iq>error>text").text()})))}))}logout(e){const t=(0,St.$iq)({to:this.targetJid,type:"set"}),{sessionId:n}=$o;n?(t.c("logout",{xmlns:"http://jitsi.org/protocol/focus","session-id":n}),this.connection.sendIQ(t,(t=>{Go.info("Log out OK",t),$o.sessionId=void 0,e()}),(e=>{Go.error("Logout error",e)}))):e()}}let Wo;!function(e){e.ON="on",e.OFF="off"}(Wo||(Wo={}));const Xo=Wo.ON,Yo=Wo.OFF;var Qo=n(408);const Zo=(0,y.getLogger)("modules/xmpp/AVModeration.js");class es{constructor(e){this._xmpp=e.xmpp,this._mainRoom=e,this._moderationEnabledByType={[Ri.AUDIO]:!1,[Ri.VIDEO]:!1},this._whitelistAudio=[],this._whitelistVideo=[],this._onMessage=this._onMessage.bind(this),this._xmpp.addListener(Hi.XMPPEvents.AV_MODERATION_RECEIVED,this._onMessage)}dispose(){this._xmpp.removeListener(Hi.XMPPEvents.AV_MODERATION_RECEIVED,this._onMessage)}isSupported(){return Boolean(this._xmpp.avModerationComponentAddress)}enable(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot enable:${e} AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);if(e===this._moderationEnabledByType[t])return void Zo.warn(`Moderation already in state:${e} for mediaType:${t}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{enable:e,mediaType:t}).up(),this._xmpp.connection.send(n)}approve(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot approve in AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{mediaType:e,jidToWhitelist:t}).up(),this._xmpp.connection.send(n)}reject(e,t){if(!this.isSupported()||!this._mainRoom.isModerator())return void Zo.error(`Cannot reject in AV moderation supported:${this.isSupported()},\\n                moderator:${this._mainRoom.isModerator()}`);const n=(0,St.$msg)({to:this._xmpp.avModerationComponentAddress});n.c("av_moderation",{mediaType:e,jidToBlacklist:t}).up(),this._xmpp.connection.send(n)}_onMessage(e){const{removed:t,mediaType:n,enabled:i,approved:r,actor:o,whitelists:s}=e;if(s){const e=n===Ri.AUDIO?this._whitelistAudio:this._whitelistVideo,i=Array.isArray(s[n])?s[n]:[];t?e.filter((e=>!i.includes(e))).forEach((e=>this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_REJECTED,n,e))):i.filter((t=>!e.includes(t))).forEach((e=>this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_PARTICIPANT_APPROVED,n,e))),n===Ri.AUDIO?this._whitelistAudio=i:this._whitelistVideo=i}else void 0!==i&&this._moderationEnabledByType[n]!==i?(this._moderationEnabledByType[n]=i,this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_CHANGED,i,n,o)):t?this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_REJECTED,n):r&&this._xmpp.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_APPROVED,n)}}const ts="features/breakout-rooms",ns={ADD:`${ts}/add`,MOVE_TO_ROOM:`${ts}/move-to-room`,REMOVE:`${ts}/remove`,RENAME:`${ts}/rename`},is=`${ts}/move-to-room`,rs=`${ts}/update`,os=(0,y.getLogger)("modules/xmpp/BreakoutRooms.js");class ss{constructor(e){this.room=e,this._handleMessages=this._handleMessages.bind(this),this.room.xmpp.addListener(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,this._handleMessages),this._rooms={}}dispose(){this.room.xmpp.removeListener(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,this._handleMessages)}createBreakoutRoom(e){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot create breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const t={type:ns.ADD,subject:e};this._sendMessage(t)}removeBreakoutRoom(e){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot remove breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const t={type:ns.REMOVE,breakoutRoomJid:e};this._sendMessage(t)}renameBreakoutRoom(e,t){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot rename breakout room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={type:ns.RENAME,breakoutRoomJid:e,subject:t};this._sendMessage(n)}sendParticipantToRoom(e,t){if(!this.isSupported()||!this.room.isModerator())return void os.error(`Cannot send participant to room - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={type:ns.MOVE_TO_ROOM,participantJid:e,roomJid:t};this._sendMessage(n)}isFeatureSupported(e){return Boolean((this.room.xmpp.breakoutRoomsFeatures||{})[e])}isSupported(){return Boolean(this.getComponentAddress())}getComponentAddress(){return this.room.xmpp.breakoutRoomsComponentAddress}_setIsBreakoutRoom(e){this._isBreakoutRoom=e}isBreakoutRoom(){return void 0!==this._isBreakoutRoom?this._isBreakoutRoom:St.Strophe.getDomainFromJid(this.room.myroomjid)===this.getComponentAddress()}_setMainRoomJid(e){this._mainRoomJid=e}getMainRoomJid(){return this._mainRoomJid}_handleMessages(e){switch(e.event){case is:this.room.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_MOVE_TO_ROOM,e.roomJid);break;case rs:{const t=this._filterUpdatePayload(e);this._rooms=t.rooms,this.room.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_UPDATED,t);break}}}_filterUpdatePayload(e){const t=this.room.options.hiddenDomain,{rooms:n}=e,i={};return Object.entries(n).forEach((e=>{let[n,r]=e;const{participants:o={}}=r,s={};Object.entries(o).forEach((e=>{let[n,i]=e;St.Strophe.getDomainFromJid(i.jid)!==t&&(s[n]=i)})),i[n]={...r,participants:s}})),{...e,rooms:i}}_sendMessage(e){const t=(0,St.$msg)({to:this.getComponentAddress()});t.c("breakout_rooms",e).up(),this.room.xmpp.connection.send(t)}}const as=(0,y.getLogger)("modules/xmpp/Lobby.js"),ds="email";class cs{constructor(e){this.xmpp=e.xmpp,this.mainRoom=e;const t=this._maybeJoinLobbyRoom.bind(this);this.mainRoom.addEventListener(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,t),this.mainRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,t),this.mainRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,(e=>{this.lobbyRoomJid=e}))}isSupported(){return this.xmpp.lobbySupported}enable(){return this.isSupported()?this.mainRoom.initialDiscoRoomInfoReceived?this.mainRoom.membersOnlyEnabled?Promise.resolve():new Promise(((e,t)=>{this.mainRoom.setMembersOnly(!0,e,t)})):new Promise(((e,t)=>{let n=[];const i=()=>{n.forEach((e=>e())),n=[]};n.push(this.mainRoom.addCancellableListener(Hi.XMPPEvents.ROOM_DISCO_INFO_UPDATED,(()=>{i(),this.mainRoom.membersOnlyEnabled?e():this.mainRoom.setMembersOnly(!0,e,t)}))),n.push(this.mainRoom.addCancellableListener(Hi.XMPPEvents.ROOM_DISCO_INFO_FAILED,(e=>{i(),t(e)})))})):Promise.reject(new Error("Lobby not supported!"))}disable(){this.isSupported()&&this.mainRoom.isModerator()&&this.lobbyRoom&&this.mainRoom.membersOnlyEnabled&&this.mainRoom.setMembersOnly(!1)}sendMessage(e){this.lobbyRoom&&this.lobbyRoom.sendMessage(JSON.stringify(e),"json-message")}sendPrivateMessage(e,t){this.lobbyRoom&&this.lobbyRoom.sendPrivateMessage(e,JSON.stringify(t),"json-message")}getLocalId(){if(this.lobbyRoom)return St.Strophe.getResourceFromJid(this.lobbyRoom.myroomjid)}addMessageListener(e){if(this.lobbyRoom){const t=(t,n)=>{e(n,St.Strophe.getResourceFromJid(t))};return this.lobbyRoom.on(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,t),t}}removeMessageHandler(e){this.lobbyRoom&&this.lobbyRoom.off(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,e)}leave(){return this.lobbyRoom?this.lobbyRoom.leave().then((()=>{this.lobbyRoom=void 0,as.info("Lobby room left!")})).catch((()=>{})):Promise.reject(new Error("The lobby has already been left"))}setLobbyRoomJid(e){this.lobbyRoomJid=e}_maybeJoinLobbyRoom(){this.isSupported()&&this.mainRoom.joined&&this.mainRoom.isModerator()&&this.mainRoom.membersOnlyEnabled&&!this.lobbyRoom&&this.join().then((()=>as.info("Joined lobby room"))).catch((e=>as.error("Failed joining lobby",e)))}join(e,t){const n=this.mainRoom.joined&&this.mainRoom.isModerator();if(!this.lobbyRoomJid)return Promise.reject(new Error("Missing lobbyRoomJid, cannot join lobby room."));const i=St.Strophe.getNodeFromJid(this.lobbyRoomJid),r=St.Strophe.getDomainFromJid(this.lobbyRoomJid);return this.lobbyRoom=this.xmpp.createRoom(i,{customDomain:r,disableDiscoInfo:!0,disableFocus:!0,enableLobby:!1}),e&&this.lobbyRoom.addOrReplaceInPresence("nick",{attributes:{xmlns:"http://jabber.org/protocol/nick"},value:e}),n?(this.lobbyRoom.addPresenceListener(ds,((e,t)=>{this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_UPDATED,t,{email:e.value})})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBER_JOINED,((e,t,n,i,r,o,s,a,d)=>{if(!Object.values(this.mainRoom.members).find((e=>e.jid===d))){for(const e of Object.values(this.mainRoom.getBreakoutRooms()._rooms))if(Object.values(e.participants).find((e=>e.jid===d)))return;this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_JOINED,St.Strophe.getResourceFromJid(e),t,s?s.avatar:void 0)}})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,(e=>{this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,St.Strophe.getResourceFromJid(e))})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_DESTROYED,(()=>{Object.keys(this.lobbyRoom.members).forEach((e=>this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_LOBBY_MEMBER_LEFT,St.Strophe.getResourceFromJid(e)))),this.lobbyRoom.clean(),this.lobbyRoom=void 0,as.info("Lobby room left(destroyed)!")}))):(this.lobbyRoom.addEventListener(Hi.XMPPEvents.KICKED,(e=>{if(e)return this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_DENIED_ACCESS),void this.lobbyRoom.clean()})),this.mainRoom.addEventListener(Hi.XMPPEvents.INVITE_MESSAGE_RECEIVED,((e,t,n,i)=>{as.debug(`Received approval to join ${e} ${t} ${n}`),e===this.mainRoom.roomjid&&this.mainRoom.join(i)})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_DESTROYED,((e,t)=>{var n;null===(n=this.lobbyRoom)||void 0===n||n.clean(),this.lobbyRoom=void 0,as.info("Lobby room left(destroyed)!"),t?this.mainRoom.join():this.mainRoom.eventEmitter.emit(Hi.XMPPEvents.MUC_DESTROYED,e)})),this.mainRoom.addEventListener(Hi.XMPPEvents.MUC_JOINED,(()=>{this.leave().catch((()=>{}))}))),new Promise(((e,i)=>{this.lobbyRoom.addEventListener(Hi.XMPPEvents.MUC_JOINED,(()=>{e(),t&&!n&&this.lobbyRoom.addOrReplaceInPresence(ds,{value:t})&&this.lobbyRoom.sendPresence()})),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_JOIN_ERROR,i),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,i),this.lobbyRoom.addEventListener(Hi.XMPPEvents.ROOM_CONNECT_ERROR,i),this.lobbyRoom.join()}))}denyAccess(e){if(!this.isSupported()||!this.mainRoom.isModerator())return;const t=Object.keys(this.lobbyRoom.members).find((t=>St.Strophe.getResourceFromJid(t)===e));t?this.lobbyRoom.kick(t):as.error(`Not found member for ${e} in lobby room.`)}approveAccess(e){if(!this.isSupported()||!this.mainRoom.isModerator())return;let t=this.mainRoom.roomjid;this.mainRoom.getBreakoutRooms().isBreakoutRoom()&&(t=this.mainRoom.getBreakoutRooms().getMainRoomJid());const n=[];let i=e;if(Array.isArray(e)||(i=[e]),i.forEach((e=>{const t=Object.keys(this.lobbyRoom.members).find((t=>St.Strophe.getResourceFromJid(t)===e));t?n.push(this.lobbyRoom.members[t].jid):as.error(`Not found member for ${t} in lobby room.`)})),n.length>0){const e=(0,St.$msg)({to:t}).c("x",{xmlns:"http://jabber.org/protocol/muc#user"});n.forEach((t=>{e.c("invite",{to:t}).up()})),this.xmpp.connection.sendIQ(e,(()=>{}),(e=>{as.error(`Error sending invite for ${n}`,e)}))}}}const ls=(0,y.getLogger)("modules/xmpp/RoomMetadata.ts");class hs{constructor(e){this.room=e,this._handleMessages=this._handleMessages.bind(this),this.room.xmpp.addListener(Hi.XMPPEvents.ROOM_METADATA_EVENT,this._handleMessages),this._metadata={}}dispose(){this.room.xmpp.removeListener(Hi.XMPPEvents.ROOM_METADATA_EVENT,this._handleMessages)}setMetadata(e,t){if(!this.isSupported()||!this.room.isModerator())return void ls.error(`Cannot set room metadata - supported:${this.isSupported()},\\n                moderator:${this.room.isModerator()}`);const n={key:e,data:t};this._sendMessage(n)}getMetadata(){return this._metadata}isSupported(){return Boolean(this.getComponentAddress())}getComponentAddress(){return this.room.xmpp.roomMetadataComponentAddress}_handleMessages(e){const{metadata:t}=e;t&&!yt()(this._metadata,t)&&(this._metadata=t,this.room.eventEmitter.emit(Hi.XMPPEvents.ROOM_METADATA_UPDATED,t))}_sendMessage(e){e[Aa]="room_metadata";const t=(0,St.$msg)({to:this.getComponentAddress()});t.c("room_metadata",{room:this.room.roomjid,xmlns:"http://jitsi.org/jitmeet"},JSON.stringify(e)).up(),this.room.xmpp.connection.send(t)}}const us=(0,y.getLogger)("modules/xmpp/ChatRoom.js"),ps={packet2JSON(e,t){for(const n of Array.from(e.children)){const e={attributes:{},children:[],tagName:n.tagName};for(const t of Array.from(n.attributes))e.attributes[t.name]=t.value;const i=St.Strophe.getText(n);i&&(e.value=St.Strophe.xmlunescape(i)),t.push(e),this.packet2JSON(n,e.children)}},json2packet(e,t){for(let n=0;n<e.length;n++){const i=e[n];i&&(t.c(i.tagName,i.attributes),i.value&&t.t(i.value),i.children&&this.json2packet(i.children,t),t.up())}}};function ms(e,t){const n=[];for(let i=0;i<e.length;i++)e[i].tagName===t&&n.push(e[i]);return n}const gs=["owner","admin","member"];function fs(e,t){const n={},i=e.children.find((e=>"user"===e.tagName));if(i){n.user={};const e=["id","name","avatar"];t&&e.push("hidden-from-recorder");for(const t of e){const e=i.children.find((e=>e.tagName===t));e&&(n.user[t]=e.value)}}const r=e.children.find((e=>"group"===e.tagName));return r&&(n.group=r.value),n}class vs extends xr{constructor(e,t,n,i,r){super(),this.xmpp=i,this.connection=e,this.roomjid=St.Strophe.getBareJidFromJid(t),this.myroomjid=t,this.password=n,this.replaceParticipant=!1,us.info(`Joining MUC as ${this.myroomjid}`),this.members={},this.presMap={},this.presHandlers={},this._removeConnListeners=[],this.joined=!1,this.inProgressEmitted=!1,this.role=null,this.focusMucJid=null,this.noBridgeAvailable=!1,this.options=r||{},this.eventsForwarder=new(Fi())(this.xmpp.moderator,this.eventEmitter),this.eventsForwarder.forward(Ui().IDENTITY_UPDATED,Ui().IDENTITY_UPDATED),this.eventsForwarder.forward(Hi.XMPPEvents.AUTHENTICATION_REQUIRED,Hi.XMPPEvents.AUTHENTICATION_REQUIRED),this.eventsForwarder.forward(Hi.XMPPEvents.FOCUS_DISCONNECTED,Hi.XMPPEvents.FOCUS_DISCONNECTED),this.eventsForwarder.forward(Hi.XMPPEvents.RESERVATION_ERROR,Hi.XMPPEvents.RESERVATION_ERROR),(void 0===this.options.enableLobby||this.options.enableLobby)&&(this.lobby=new cs(this)),this.avModeration=new es(this),this.breakoutRooms=new ss(this),this.roomMetadata=new hs(this),this.initPresenceMap(r),this.lastPresences={},this.phoneNumber=null,this.phonePin=null,this.connectionTimes={},this.participantPropertyListener=null,this.locked=!1,this.transcriptionStatus=Yo,this.initialDiscoRoomInfoReceived=!1}initPresenceMap(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.presMap.to=this.myroomjid,this.presMap.xns="http://jabber.org/protocol/muc",this.presMap.nodes=[],e.statsId&&this.presMap.nodes.push({tagName:"stats-id",value:e.statsId}),this.presenceUpdateTime=Date.now()}join(e,t){return this.password=e,this.replaceParticipant=t,new Promise((e=>{this.options.disableFocus&&us.info(`Conference focus disabled for ${this.roomjid}`),(this.options.disableFocus?Promise.resolve():this.xmpp.moderator.sendConferenceRequest(this.roomjid)).then((()=>{this.sendPresence(!0),this._removeConnListeners.push(this.connection.addCancellableListener(Lo.Events.CONN_STATUS_CHANGED,this.onConnStatusChanged.bind(this))),e()}))}))}sendPresence(e){const t=this.presMap.to;if(!this.connection||!this.connection.connected||!t||!this.joined&&!e)return;const n=(0,St.$pres)({to:t});e&&(this.replaceParticipant&&n.c("flip_device").up(),n.c("x",{xmlns:this.presMap.xns}),this.password&&n.c("password").t(this.password).up(),this.xmpp.moderator.targetUrl&&n.c("billingid").t($o.machineId).up(),n.up()),ps.json2packet(this.presMap.nodes,n),this.presenceSyncTime=Date.now(),this.connection.send(n),e&&this.connection.flush()}doLeave(e){us.log("do leave",this.myroomjid);const t=(0,St.$pres)({to:this.myroomjid,type:"unavailable"});e&&t.c("status").t(e).up(),this.presMap.length=0,!this.connection.isUsingWebSocket&&this.connection.flush(),this.connection.send(t),this.connection.flush()}discoRoomInfo(){const e=(0,St.$iq)({type:"get",to:this.roomjid}).c("query",{xmlns:St.Strophe.NS.DISCO_INFO});this.connection.sendIQ(e,(e=>{const t=1===_t()(e).find(\'>query>feature[var="muc_passwordprotected"]\').length;t!==this.locked&&(this.eventEmitter.emit(Hi.XMPPEvents.MUC_LOCK_CHANGED,t),this.locked=t);const n=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_meetingId"]>value\');n.length?this.setMeetingId(n.text()):us.warn("No meeting ID from backend");const i=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_created_timestamp"]>value\');i.length?this.eventEmitter.emit(Hi.XMPPEvents.CONFERENCE_TIMESTAMP_RECEIVED,i.text()):us.warn("No conference duration from backend");const r=1===_t()(e).find(\'>query>feature[var="muc_membersonly"]\').length,o=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_lobbyroom"]>value\');this.lobby&&this.lobby.setLobbyRoomJid(o&&o.length?o.text():void 0);const s=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_isbreakout"]>value\'),a=Boolean(null==s?void 0:s.text());this.breakoutRooms._setIsBreakoutRoom(a);const d=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_breakout_main_room"]>value\');null!=d&&d.length&&this.breakoutRooms._setMainRoomJid(d.text()),r!==this.membersOnlyEnabled&&(this.membersOnlyEnabled=r,this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBERS_ONLY_CHANGED,r));const c="1"===_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_visitorsEnabled"]>value\').text();c!==this.visitorsSupported&&(this.visitorsSupported=c,this.eventEmitter.emit(Hi.XMPPEvents.MUC_VISITORS_SUPPORTED_CHANGED,c));const l=_t()(e).find(\'>query>x[type="result"]>field[var="muc#roominfo_jitsimetadata"]>value\'),h=null==l?void 0:l.text();if(h)try{this.roomMetadata._handleMessages(_r(h))}catch(e){us.warn("Failed to set room metadata",e)}this.initialDiscoRoomInfoReceived=!0,this.eventEmitter.emit(Hi.XMPPEvents.ROOM_DISCO_INFO_UPDATED)}),(e=>{us.error("Error getting room info: ",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_DISCO_INFO_FAILED,e)}),1e4)}setMeetingId(e){this.meetingId!==e&&(this.meetingId&&us.warn(`Meeting Id changed from:${this.meetingId} to:${e}`),this.meetingId=e,this.eventEmitter.emit(Hi.XMPPEvents.MEETING_ID_SET,e))}createNonAnonymousRoom(){if(this.options.disableDiscoInfo)return;const e=(0,St.$iq)({type:"get",to:this.roomjid}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}).c("x",{xmlns:"jabber:x:data",type:"submit"});this.connection.sendIQ(e,(e=>{if(!_t()(e).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_whois"]\').length)return void us.error("non-anonymous rooms not supported");const t=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});t.c("x",{xmlns:"jabber:x:data",type:"submit"}),t.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),t.c("field",{var:"muc#roomconfig_whois"}).c("value").t("anyone").up().up(),this.connection.sendIQ(t)}),(e=>{us.error("Error getting room configuration form: ",e)}))}onConnStatusChanged(e){e===Lo.Status.CONNECTED&&this.presenceUpdateTime>this.presenceSyncTime&&this.sendPresence()}onPresence(e){const t=e.getAttribute("from"),n={},i=e.getElementsByTagName("status")[0];i&&(n.status=i.textContent||"");let r=!1,o=!1;const s=e.getElementsByTagNameNS("http://jabber.org/protocol/muc#user","x")[0],a=s&&s.getElementsByTagName("item")[0];n.isReplaceParticipant=e.getElementsByTagName("flip_device").length,n.affiliation=a&&a.getAttribute("affiliation"),n.role=a&&a.getAttribute("role");const d=a&&a.getAttribute("jid");n.jid=d,n.isFocus=this.xmpp.moderator.isFocusJid(d),n.isHiddenDomain=d&&d.indexOf("@")>0&&this.options.hiddenDomain===d.substring(d.indexOf("@")+1,d.indexOf("/")),this.eventEmitter.emit(Hi.XMPPEvents.PRESENCE_RECEIVED,{fromHiddenDomain:n.isHiddenDomain,presence:e});const c=e.querySelector("x");c&&c.remove();const l=[];ps.packet2JSON(e,l),this.lastPresences[t]=l;for(let e=0;e<l.length;e++){const t=l[e];switch(t.tagName){case"bot":{const{attributes:e}=t;if(!e)break;const{type:i}=e;n.botType=i;break}case"nick":n.nick=t.value;break;case"userId":n.id=t.value;break;case"stats-id":n.statsID=t.value;break;case"identity":n.identity=fs(t,this.options.hiddenFromRecorderFeatureEnabled);break;case"features":n.features=this._extractFeatures(t);break;case"stat":{const{attributes:e}=t;if(!e)break;const{name:i}=e;"version"===i&&(n.version=e.value);break}}}if(!this.joined&&!this.inProgressEmitted){const e=this.connectionTimes["muc.join.started"]=window.performance.now();us.log("(TIME) MUC join started:\\t",e),this.eventEmitter.emit(Hi.XMPPEvents.MUC_JOIN_IN_PROGRESS),this.inProgressEmitted=!0}if(t===this.myroomjid){const e="owner"===n.affiliation?n.role:"none";if(this.role!==e&&(this.role=e,this.eventEmitter.emit(Hi.XMPPEvents.LOCAL_ROLE_CHANGED,this.role)),!this.joined){this.joined=!0;const e=this.connectionTimes["muc.joined"]=window.performance.now();us.log("(TIME) MUC joined:\\t",e),this.password&&(this.locked=!0),this.presenceUpdateTime>=this.presenceSyncTime&&this.sendPresence(),this.eventEmitter.emit(Hi.XMPPEvents.MUC_JOINED),!this.options.disableDiscoInfo&&this.discoRoomInfo()}}else if(void 0===d)us.info("Ignoring member with undefined JID");else if(void 0===this.members[t])this.members[t]=n,us.log("entered",t,n),r=void 0!==n.status,o=void 0!==n.version,n.isFocus?this._initFocus(t,n.features):(this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_JOINED,t,n.nick,n.role,n.isHiddenDomain,n.statsID,n.status,n.identity,n.botType,n.jid,n.features,n.isReplaceParticipant),r=!1);else{const e=this.members[t];e.role!==n.role&&(e.role=n.role,this.eventEmitter.emit(Hi.XMPPEvents.MUC_ROLE_CHANGED,t,n.role)),e.affiliation!==n.affiliation&&(e.affiliation=n.affiliation),e.botType!==n.botType&&(e.botType=n.botType,this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_BOT_TYPE_CHANGED,t,n.botType)),n.isFocus&&(e.isFocus=!0,this._initFocus(t,n.features)),n.displayName&&(e.displayName=n.displayName),e.status!==n.status&&(r=!0,e.status=n.status),e.version!==n.version&&(o=!0,e.version=n.version),yt()(e.features,n.features)||(e.features=n.features,this.eventEmitter.emit(Hi.XMPPEvents.PARTICIPANT_FEATURES_CHANGED,t,n.features))}for(let e=0;e<l.length;e++){const i=l[e];switch(i.tagName){case"nick":if(!n.isFocus){const e=this.xmpp.options.displayJids?St.Strophe.getResourceFromJid(t):n.nick;this.eventEmitter.emit(Hi.XMPPEvents.DISPLAY_NAME_CHANGED,t,e)}break;case"bridgeNotAvailable":n.isFocus&&!this.noBridgeAvailable&&(this.noBridgeAvailable=!0,this.eventEmitter.emit(Hi.XMPPEvents.BRIDGE_DOWN));break;case"conference-properties":if(n.isFocus){const e={};for(let t=0;t<i.children.length;t++){const{attributes:n}=i.children[t];n&&n.key&&(e[n.key]=n.value)}this.eventEmitter.emit(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,e),void 0===this.restartByTerminateSupported&&(this.restartByTerminateSupported="true"===e["support-terminate-restart"],us.info(`Jicofo supports restart by terminate: ${this.supportsRestartByTerminate()}`))}break;case"transcription-status":{const{attributes:e}=i;if(!e)break;const{status:t}=e;t&&t!==this.transcriptionStatus&&(this.transcriptionStatus=t,this.eventEmitter.emit(Hi.XMPPEvents.TRANSCRIPTION_STATUS_CHANGED,t));break}case"call-control":{const e=i.attributes;if(!e)break;this.phoneNumber=e.phone||null,this.phonePin=e.pin||null,this.eventEmitter.emit(Hi.XMPPEvents.PHONE_NUMBER_CHANGED);break}default:this.processNode(i,t)}}r&&this.eventEmitter.emit(Hi.XMPPEvents.PRESENCE_STATUS,t,n.status),o&&us.info(`Received version for ${d}: ${n.version}`)}_extractFeatures(e){const t=new Set;for(let n=0;n<e.children.length;n++){const{attributes:i}=e.children[n];i&&i.var&&t.add(i.var)}return t}_initFocus(e,t){this.focusMucJid=e,this.focusFeatures=t}setParticipantPropertyListener(e){this.participantPropertyListener=e}supportsRestartByTerminate(){return this.restartByTerminateSupported}processNode(e,t){try{let n=this.presHandlers[e.tagName];e.tagName.startsWith("jitsi_participant_")&&(n=[this.participantPropertyListener]),n&&n.forEach((n=>{n(e,St.Strophe.getResourceFromJid(t),t)}))}catch(t){us.error(`Error processing:${e.tagName} node.`,t)}}sendMessage(e,t){const n=(0,St.$msg)({to:this.roomjid,type:"groupchat"});"body"===t?n.c(t,{},e):n.c(t,{xmlns:"http://jitsi.org/jitmeet"},e),this.connection.send(n),this.eventEmitter.emit(Hi.XMPPEvents.SENDING_CHAT_MESSAGE,e)}sendPrivateMessage(e,t,n){const i=(0,St.$msg)({to:`${this.roomjid}/${e}`,type:"chat"});"body"===n?i.c(n,t).up():i.c(n,{xmlns:"http://jitsi.org/jitmeet"},t).up(),this.connection.send(i),this.eventEmitter.emit(Hi.XMPPEvents.SENDING_PRIVATE_CHAT_MESSAGE,t)}setSubject(e){const t=(0,St.$msg)({to:this.roomjid,type:"groupchat"});t.c("subject",e),this.connection.send(t)}onPresenceUnavailable(e,t){if(_t()(e).find(\'>ignore[xmlns="http://jitsi.org/jitmeet/"]\').length)return!0;const n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>destroy\');if(n.length){let t;const i=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>destroy>reason\');return i.length&&(t=i.text()),this.eventEmitter.emit(Hi.XMPPEvents.MUC_DESTROYED,t,n.attr("jid")),this.connection.emuc.doLeave(this.roomjid),!0}const i=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="110"]\').length,r=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="307"]\').length,o=Object.keys(this.members),s=_t()(e).find("flip_device").length;if(r){const n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>item>actor\');let r,o;n.length&&(r=n.attr("nick"));const a=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>item>reason\');a.length&&(o=a.text()),this.eventEmitter.emit(Hi.XMPPEvents.KICKED,i,r,St.Strophe.getResourceFromJid(t),o,s)}if(i)o.forEach((e=>{const t=this.members[e];delete this.members[e],delete this.lastPresences[e],t.isFocus||this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_LEFT,e)})),this.connection.emuc.doLeave(this.roomjid),r||this.eventEmitter.emit(Hi.XMPPEvents.MUC_LEFT);else{const n=_t()(e).find(">status"),i=this.members[t];let r;n.length&&(r=n.text()),delete this.members[t],delete this.lastPresences[t],this.eventEmitter.emit(Hi.XMPPEvents.MUC_MEMBER_LEFT,t,r),null!=i&&i.isFocus&&(us.info("Focus has left the room - leaving conference"),this.eventEmitter.emit(Hi.XMPPEvents.FOCUS_LEFT))}}onMessage(e,t){const n=e.getAttribute("type");if("error"===n){const t=_t()(e).find(">settings-error>text").text();if(t.length)return this.eventEmitter.emit(Hi.XMPPEvents.SETTINGS_ERROR_RECEIVED,t),!0;const n=_t()(e).find(">error>text").text();return this.eventEmitter.emit(Hi.XMPPEvents.CHAT_ERROR_RECEIVED,n),!0}const i=_t()(e).find(">body").text(),r=_t()(e).find(">subject");if(r.length){const e=r.text();(e||""===e)&&(this.eventEmitter.emit(Hi.XMPPEvents.SUBJECT_CHANGED,e),us.log(`Subject is changed to ${e}`))}let o=_t()(e).find(">delay").attr("stamp");if(!o&&(o=_t()(e).find(\'>[xmlns="jabber:x:delay"]\').attr("stamp"),o)){const e=o.match(/(\\d{4})(\\d{2})(\\d{2}T\\d{2}:\\d{2}:\\d{2})/);o=`${e[1]}-${e[2]}-${e[3]}Z`}if(t===this.roomjid){let n;if(_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="104"]\').length)this.discoRoomInfo();else if((n=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>invite\'))&&n.length){const r=_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>password\');let o;r&&r.length&&(o=r.text()),this.eventEmitter.emit(Hi.XMPPEvents.INVITE_MESSAGE_RECEIVED,t,n.attr("from"),i,o)}}const s=_t()(e).find(">json-message").text();if(s){const e=this.xmpp.tryParseJSONAndVerify(s);if(e&&void 0===o)return void this.eventEmitter.emit(Hi.XMPPEvents.JSON_MESSAGE_RECEIVED,t,e)}if(i)if("chat"===n)this.eventEmitter.emit(Hi.XMPPEvents.PRIVATE_MESSAGE_RECEIVED,t,i,this.myroomjid,o);else if("groupchat"===n){const n=_t()(e).find(">nick");let r;n.length>0&&(r=n.text()),this.eventEmitter.emit(Hi.XMPPEvents.MESSAGE_RECEIVED,t,i,this.myroomjid,o,r,Boolean(r))}}onPresenceError(e,t){let n;if(_t()(e).find(\'>error[type="auth"]>not-authorized[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length)us.log("on password required",t),this.eventEmitter.emit(Hi.XMPPEvents.PASSWORD_REQUIRED);else if(_t()(e).find(\'>error[type="cancel"]>not-allowed[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length)if(St.Strophe.getDomainFromJid(e.getAttribute("to"))===this.xmpp.options.hosts.anonymousdomain)this.eventEmitter.emit(Hi.XMPPEvents.ROOM_JOIN_ERROR);else{us.warn("onPresError ",e);const t=_t()(e).find(\'>error[type="cancel"]>text[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\'),n=t.length&&t.text();if("Room creation is restricted"===n&&(this._roomCreationRetries||(this._roomCreationRetries=0),this._roomCreationRetries++,this._roomCreationRetries<=3)){const e=Ro(this._roomCreationRetries,500,1.5);return void setTimeout((()=>this.join(this.password,this.replaceParticipant)),e)}this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_NOT_ALLOWED_ERROR,n)}else if(_t()(e).find(">error>service-unavailable").length)us.warn("Maximum users limit for the room has been reached",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_MAX_USERS_ERROR);else if(_t()(e).find(\'>error[type="auth"]>registration-required[xmlns="urn:ietf:params:xml:ns:xmpp-stanzas"]\').length){const t=_t()(e).find(\'>error[type="auth"]>lobbyroom\');let n;t.length&&(n=t.text());const i=_t()(e).find(\'>error[type="auth"]>waiting-for-host\').length>0;this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_MEMBERS_ONLY_ERROR,n,i)}else if((n=_t()(e).find(\'>error[type="modify"]>displayname-required[xmlns="http://jitsi.org/jitmeet"]\')).length){var i;us.warn("display name required ",e),this.eventEmitter.emit(Hi.XMPPEvents.DISPLAY_NAME_REQUIRED,null===(i=n[0].attributes.lobby)||void 0===i?void 0:i.value)}else us.warn("onPresError ",e),this.eventEmitter.emit(Hi.XMPPEvents.ROOM_CONNECT_ERROR)}setAffiliation(e,t){const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"}).c("item",{affiliation:t,jid:St.Strophe.getBareJidFromJid(e)}).c("reason").t(`Your affiliation has been changed to \'${t}\'.`).up().up().up();this.connection.sendIQ(n,(n=>us.log("Set affiliation of participant with jid: ",e,"to",t,n)),(e=>us.log("Set affiliation of participant error: ",e)))}kick(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"You have been kicked.";const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"}).c("item",{nick:St.Strophe.getResourceFromJid(e),role:"none"}).c("reason").t(t).up().up().up();this.connection.sendIQ(n,(t=>us.log("Kick participant with jid: ",e,t)),(e=>us.log("Kick participant error: ",e)))}lockRoom(e,t,n,i){this.connection.sendIQ((0,St.$iq)({to:this.roomjid,type:"get"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}),(r=>{if(_t()(r).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_roomsecret"]\').length){const i=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});i.c("x",{xmlns:"jabber:x:data",type:"submit"}),i.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),i.c("field",{var:"muc#roomconfig_roomsecret"}).c("value").t(e).up().up(),i.c("field",{var:"muc#roomconfig_passwordprotectedroom"}).c("value").t(null===e||0===e.length?"0":"1").up().up(),this.membersOnlyEnabled&&i.c("field",{var:"muc#roomconfig_membersonly"}).c("value").t("true").up().up(),i.c("field",{var:"muc#roomconfig_whois"}).c("value").t("anyone").up().up(),this.connection.sendIQ(i,(()=>{this.password=e,t()}),n)}else i()}),n)}setMembersOnly(e,t,n){if(e&&Object.values(this.members).filter((e=>!e.isFocus)).length){const e=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#admin"});Object.values(this.members).forEach((t=>{t.jid&&!gs.includes(t.affiliation)&&e.c("item",{affiliation:"member",jid:St.Strophe.getBareJidFromJid(t.jid)}).up()})),this.xmpp.connection.sendIQ(e.up())}const i=n||(()=>{});this.xmpp.connection.sendIQ((0,St.$iq)({to:this.roomjid,type:"get"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"}),(n=>{if(_t()(n).find(\'>query>x[xmlns="jabber:x:data"]>field[var="muc#roomconfig_membersonly"]\').length){const n=(0,St.$iq)({to:this.roomjid,type:"set"}).c("query",{xmlns:"http://jabber.org/protocol/muc#owner"});n.c("x",{xmlns:"jabber:x:data",type:"submit"}),n.c("field",{var:"FORM_TYPE"}).c("value").t("http://jabber.org/protocol/muc#roomconfig").up().up(),n.c("field",{var:"muc#roomconfig_membersonly"}).c("value").t(e?"true":"false").up().up(),this.locked&&n.c("field",{var:"muc#roomconfig_passwordprotectedroom"}).c("value").t("1").up().up(),this.xmpp.connection.sendIQ(n,t,i)}else i(new Error("Setting members only room not supported!"))}),i)}addToPresence(e,t){return this.addOrReplaceInPresence(e,t)}addOrReplaceInPresence(e,t){t.tagName=e;const n=this.presMap.nodes.filter((t=>e===t.tagName));return!(1===n.length&&yt()(n[0],t)||(this.removeFromPresence(e),this.presMap.nodes.push(t),this.presenceUpdateTime=Date.now(),0))}getFromPresence(e){return this.presMap.nodes.find((t=>e===t.tagName))}removeFromPresence(e){const t=this.presMap.nodes.filter((t=>e!==t.tagName));this.presMap.nodes=t,this.presenceUpdateTime=Date.now()}addPresenceListener(e,t){if("function"!=typeof t)throw new Error(\'"handler" is not a function\');let n=this.presHandlers[e];n||(this.presHandlers[e]=n=[]),-1===n.indexOf(t)?n.push(t):us.warn(`Trying to add the same handler more than once for: ${e}`)}removePresenceListener(e,t){const n=this.presHandlers[e],i=n?n.indexOf(t):-1;-1!==i?n.splice(i,1):us.warn(`Handler for: ${e} was not registered`)}isFocus(e){const t=this.members[e];return t?t.isFocus:null}isModerator(){return"moderator"===this.role}getMediaPresenceInfo(e,t){const n=this.lastPresences[`${this.roomjid}/${e}`];if(!n)return null;const i={muted:!0,videoType:t===Ri.VIDEO?Qo.VideoType.CAMERA:void 0};let r=null;if(t===Ri.AUDIO)r=ms(n,"audiomuted");else{if(t!==Ri.VIDEO)return us.error(`Unsupported media type: ${t}`),null;{r=ms(n,"videomuted");const e=ms(n,"jitsi_participant_codecType"),t=ms(n,"videoType");t.length>0&&(i.videoType=t[0].value),e.length>0&&(i.codecType=e[0].value)}}return r.length>0&&(i.muted="true"===r[0].value),i}getMemberRole(e){return this.members[e]?this.members[e].role:null}getLastPresence(e){return this.lastPresences[`${this.roomjid}/${e}`]}dial(e){return this.connection.rayo.dial(e,"fromnumber",St.Strophe.getBareJidFromJid(this.myroomjid),this.password,this.focusMucJid)}hangup(){return this.connection.rayo.hangup()}getLobby(){return this.lobby}getAVModeration(){return this.avModeration}getBreakoutRooms(){return this.breakoutRooms}getMetadataHandler(){return this.roomMetadata}getPhoneNumber(){return this.phoneNumber}getPhonePin(){return this.phonePin}getMeetingId(){return this.meetingId}muteParticipant(e,t,n){us.info("set mute",t,e);const i=(0,St.$iq)({to:this.focusMucJid,type:"set"}).c("mute",{xmlns:`http://jitsi.org/jitmeet/${n}`,jid:e}).t(t.toString()).up();this.connection.sendIQ(i,(e=>us.log("set mute",e)),(e=>us.log("set mute error",e)))}onMute(e){if(e.getAttribute("from")!==this.focusMucJid)return void us.warn("Ignored mute from non focus peer");const t=_t()(e).find("mute");t.length&&"true"===t.text()?this.eventEmitter.emit(Hi.XMPPEvents.AUDIO_MUTED_BY_FOCUS,t.attr("actor")):us.warn("Ignoring a mute request which does not explicitly specify a positive mute command.")}onMuteVideo(e){if(e.getAttribute("from")!==this.focusMucJid)return void us.warn("Ignored mute from non focus peer");const t=_t()(e).find("mute");t.length&&"true"===t.text()?this.eventEmitter.emit(Hi.XMPPEvents.VIDEO_MUTED_BY_FOCUS,t.attr("actor")):us.warn("Ignoring a mute request which does not explicitly specify a positive mute command.")}clean(){this._removeConnListeners.forEach((e=>e())),this._removeConnListeners=[],this.eventsForwarder.removeListeners(Ui().IDENTITY_UPDATED,Hi.XMPPEvents.AUTHENTICATION_REQUIRED,Hi.XMPPEvents.FOCUS_DISCONNECTED,Hi.XMPPEvents.RESERVATION_ERROR),this.joined=!1,this.inProgressEmitted=!1}leave(e){var t,n=this;this.avModeration.dispose(),this.breakoutRooms.dispose(),this.roomMetadata.dispose();const i=[];return(null===(t=this.lobby)||void 0===t?void 0:t.lobbyRoom)&&i.push(this.lobby.leave()),i.push(new Promise(((t,i)=>{let r=-1;const o=function(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];n.eventEmitter.removeListener(Hi.XMPPEvents.MUC_LEFT,o),clearTimeout(r),n.clean(),e?(n.connection.emuc.doLeave(n.roomjid),i(new Error("The timeout for the confirmation about leaving the room expired."))):t()};this.joined?(r=setTimeout((()=>o(!0)),5e3),this.eventEmitter.on(Hi.XMPPEvents.MUC_LEFT,o),this.doLeave(e)):(this.connection.emuc.doLeave(this.roomjid),this.clean(),t())}))),Promise.allSettled(i)}end(){if(this.breakoutRooms.isBreakoutRoom())return void us.warn("Cannot end conference: this is a breakout room.");const e=(0,St.$msg)({to:this.xmpp.endConferenceComponentAddress});e.c("end_conference").up(),this.xmpp.connection.send(e)}}const _s=(0,y.getLogger)("modules/xmpp/strophe.emuc.js");class Es extends Oo{constructor(e){super(),this.xmpp=e,this.rooms={}}init(e){super.init(e),this.connection.addHandler(this.onPresence.bind(this),null,"presence",null,null,null,null),this.connection.addHandler(this.onPresenceUnavailable.bind(this),null,"presence","unavailable",null),this.connection.addHandler(this.onPresenceError.bind(this),null,"presence","error",null),this.connection.addHandler(this.onMessage.bind(this),null,"message",null,null),this.connection.addHandler(this.onMute.bind(this),"http://jitsi.org/jitmeet/audio","iq","set",null,null),this.connection.addHandler(this.onMuteVideo.bind(this),"http://jitsi.org/jitmeet/video","iq","set",null,null),this.connection.addHandler(this.onVisitors.bind(this),"jitsi:visitors","iq","set",null,null)}createRoom(e,t,n){const i=St.Strophe.getBareJidFromJid(e);if(this.isRoomCreated(i)){const e="You are already in the room!";throw _s.error(e),new Error(e)}return this.rooms[i]=new vs(this.connection,e,t,this.xmpp,n),this.eventEmitter.emit(Hi.XMPPEvents.EMUC_ROOM_ADDED,this.rooms[i]),this.rooms[i]}isRoomCreated(e){return e in this.rooms}doLeave(e){this.eventEmitter.emit(Hi.XMPPEvents.EMUC_ROOM_REMOVED,this.rooms[e]),delete this.rooms[e]}onPresence(e){const t=e.getAttribute("from");if(e.getAttribute("type"))return!0;const n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(_t()(e).find(\'>x[xmlns="http://jabber.org/protocol/muc#user"]>status[code="201"]\').length&&n.createNonAnonymousRoom(),n.onPresence(e),!0)}onPresenceUnavailable(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onPresenceUnavailable(e,t),!0)}onPresenceError(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onPresenceError(e,t),!0)}onMessage(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMessage(e,t),!0)}onMute(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMute(e),!0)}onMuteVideo(e){const t=e.getAttribute("from"),n=this.rooms[St.Strophe.getBareJidFromJid(t)];return!n||(n.onMuteVideo(e),!0)}onVisitors(e){const t=e.getAttribute("from");if(!this.rooms[St.Strophe.getBareJidFromJid(t)])return!0;const n=_t()(e).find(\'>visitors[xmlns="jitsi:visitors"]\'),i=_t()(e).find("promotion-response");return n.length&&i.length&&("true"===String(i.attr("allow")).toLowerCase()?(_s.info("Promotion request accepted. Redirected to main room."),this.xmpp.eventEmitter.emit(pr,void 0,n.attr("focusjid"),i.attr("username"))):(_s.info("Promotion request rejected."),this.xmpp.eventEmitter.emit(Hi.XMPPEvents.VISITORS_REJECTION))),!0}}var ys=n(138),Ss=n.n(ys);const bs=(0,y.getLogger)("modules/xmpp/JingleHelperFunctions.js");function Ts(e,t){const n=(0,St.$build)("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:t.s,name:t.n});return t.m&&n.c("parameter",{name:"msid",value:t.m}).up(),n.c("ssrc-info",{xmlns:"http://jitsi.org/jitmeet",owner:e}).up(),n.node}function Cs(e){const t=(0,St.$build)("ssrc-group",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",semantics:(n=e[0],"f"===n?"FID":"s"===n?"SIM":null)});var n;for(let n=1;n<e.length;n++)t.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:e[n]}).up();return t.node}function xs(e,t){const n=_t()(e).find("jingle")[0];let i,r=_t()(n).find(`content[name="${t}"]`);return r.length?r=r[0]:(r=(0,St.$build)("content",{name:t}).node,n.appendChild(r)),i=_t()(r).find("description"),i.length?i=i[0]:(i=(0,St.$build)("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:t}).node,r.appendChild(i)),i}function Rs(e,t){var n;let i;try{i=_r(t.textContent)}catch(e){return bs.error(`json-message XML contained invalid JSON, ignoring: ${t.textContent}`),null}if(null===(n=i)||void 0===n||!n.sources)return null;const r=xs(e,Ri.AUDIO),o=xs(e,Ri.VIDEO),s=new Map;for(const e in i.sources)if(i.sources.hasOwnProperty(e)){const t=[],n=i.sources[e],c=(null==n?void 0:n.length)&&n[0],l=(null==n?void 0:n.length)>1&&n[1],h=(null==n?void 0:n.length)>2&&n[2],u=(null==n?void 0:n.length)>3&&n[3];if(null!=c&&c.length)for(let n=0;n<c.length;n++){var a;o.appendChild(Ts(e,c[n])),t.push(null===(a=c[n])||void 0===a?void 0:a.s)}if(null!=l&&l.length)for(let e=0;e<l.length;e++)o.appendChild(Cs(l[e]));if(null!=h&&h.length)for(let n=0;n<h.length;n++){var d;r.appendChild(Ts(e,h[n])),t.push(null===(d=h[n])||void 0===d?void 0:d.s)}if(null!=u&&u.length)for(let e=0;e<u.length;e++)r.appendChild(Cs(u[e]));s.set(e,t)}return s}let As;!function(e){e.INACTIVE="inactive",e.RECVONLY="recvonly",e.SENDONLY="sendonly",e.SENDRECV="sendrecv"}(As||(As={}));const ws=n(810).getLogger("modules/RTC/ScreenObtainer.js"),Is={obtainStream:null,init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.options=e,this.obtainStream=this._createObtainStreamMethod(),this.obtainStream||ws.info("Desktop sharing disabled")},_createObtainStreamMethod(){return ci.isElectron()?this.obtainScreenOnElectron:ci.isReactNative()&&ci.supportsGetDisplayMedia()?this.obtainScreenFromGetDisplayMediaRN:ci.supportsGetDisplayMedia()?this.obtainScreenFromGetDisplayMedia:(ws.log("Screen sharing not supported on ",ci.getName()),null)},_getAudioConstraints(){const{audioQuality:e}=this.options;return null==e||!e.stereo||{autoGainControl:!1,channelCount:2,echoCancellation:!1,noiseSuppression:!1}},isSupported(){return null!==this.obtainStream},obtainScreenOnElectron(e,t){var n=this;let i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(window.JitsiMeetScreenObtainer&&window.JitsiMeetScreenObtainer.openDesktopPicker){const{desktopSharingFrameRate:r,desktopSharingResolution:o,desktopSharingSources:s}=this.options;window.JitsiMeetScreenObtainer.openDesktopPicker({desktopSharingSources:i.desktopSharingSources||s||["screen","window"]},(function(i,s){if(i){var a,d,c,l,h,u,p,m;let g=!1;if(arguments.length>2&&void 0!==arguments[2]&&arguments[2]){g={};const e=n._getAudioConstraints();"boolean"!=typeof e&&(g={optional:e}),"screen"===s&&(g.mandatory={chromeMediaSource:"desktop"})}const f={audio:g,video:{mandatory:{chromeMediaSource:"desktop",chromeMediaSourceId:i,minFrameRate:null!==(a=null==r?void 0:r.min)&&void 0!==a?a:5,maxFrameRate:null!==(d=null==r?void 0:r.max)&&void 0!==d?d:5,minWidth:null==o||null===(c=o.width)||void 0===c?void 0:c.min,minHeight:null==o||null===(l=o.height)||void 0===l?void 0:l.min,maxWidth:null!==(h=null==o||null===(u=o.width)||void 0===u?void 0:u.max)&&void 0!==h?h:window.screen.width,maxHeight:null!==(p=null==o||null===(m=o.height)||void 0===m?void 0:m.max)&&void 0!==p?p:window.screen.height}}};navigator.mediaDevices.getUserMedia(f).then((t=>{n.setContentHint(t),e({stream:t,sourceId:i,sourceType:s})})).catch((e=>t(e)))}else t(new dr(Zi))}),(e=>t(new dr(zi,e))))}else t(new dr(Ki))},obtainScreenFromGetDisplayMedia(e,t){let n;n=navigator.getDisplayMedia?navigator.getDisplayMedia.bind(navigator):navigator.mediaDevices.getDisplayMedia.bind(navigator.mediaDevices);const i=this._getAudioConstraints();let r={};const o={},{desktopSharingFrameRate:s,screenShareSettings:a}=this.options;"object"==typeof s&&(r.frameRate=s),r.frameRate&&delete r.frameRate.min,ci.isChromiumBased()&&(ci.isEngineVersionGreaterThan(93)&&(o.preferCurrentTab=(null==a?void 0:a.desktopPreferCurrentTab)||!1),ci.isEngineVersionGreaterThan(104)&&(o.systemAudio=(null==a?void 0:a.desktopSystemAudio)||"include"),ci.isEngineVersionGreaterThan(106)&&(o.surfaceSwitching=(null==a?void 0:a.desktopSurfaceSwitching)||"include"),ci.isEngineVersionGreaterThan(106)&&(null==a?void 0:a.desktopDisplaySurface)&&(r.displaySurface=null==a?void 0:a.desktopDisplaySurface),ci.isEngineVersionGreaterThan(111)&&(o.selfBrowserSurface=(null==a?void 0:a.desktopSelfBrowserSurface)||"exclude"),(null==s?void 0:s.max)>5||(r.height=99999,r.width=99999)),ci.isSafari()&&null!=a&&a.desktopDisplaySurface&&(r.displaySurface=null==a?void 0:a.desktopDisplaySurface),0===Object.keys(r).length&&(r=!0);const d={video:r,audio:i,...o,cursor:"always"};ws.info("Using getDisplayMedia for screen sharing",d),n(d).then((t=>{if(this.setContentHint(t),ci.isChromiumBased()){const e=t.getVideoTracks()[0];let n=5;"number"==typeof(null==s?void 0:s.min)&&s.min>0&&(n=s.min);const i={frameRate:{min:n}};try{e.applyConstraints(i)}catch(e){ws.warn(`Min fps=${n} constraint could not be applied on the desktop track,${e.message}`)}}e({stream:t,sourceId:t.id})})).catch((e=>{const n={errorName:e&&e.name,errorMsg:e&&e.message,errorStack:e&&e.stack};ws.error("getDisplayMedia error",JSON.stringify(d),JSON.stringify(n)),n.errorMsg&&-1!==n.errorMsg.indexOf("denied by system")?t(new dr(Yi)):t(new dr(Zi))}))},obtainScreenFromGetDisplayMediaRN(e,t){ws.info("Using getDisplayMedia for screen sharing"),navigator.mediaDevices.getDisplayMedia({video:!0}).then((t=>{this.setContentHint(t),e({stream:t,sourceId:t.id})})).catch((()=>{t(new dr(Zi))}))},setContentHint(e){const{desktopSharingFrameRate:t}=this.options,n=e.getVideoTracks()[0];"contentHint"in n?n.contentHint=(null==t?void 0:t.max)>5?"motion":"detail":ws.warn("MediaStreamTrack contentHint attribute not supported")},setDesktopSharingFrameRate(e){ws.info(`Setting the desktop capture rate to ${e}`),this.options.desktopSharingFrameRate={min:5,max:e}}};var Ps=n(310);let Ds;!function(e){e.AV1="av1",e.H264="h264",e.OPUS="opus",e.RED="red",e.ULPFEC="ulpfec",e.VP8="vp8",e.VP9="vp9"}(Ds||(Ds={}));const Os=(0,y.getLogger)("modules/sdp/SDPUtil.js"),ks={filterSpecialChars:e=>e?e.replace(/[\\\\\\/\\{,\\}\\+]/g,""):e,iceparams(e,t){let n,i,r=null;return(i=ks.findLine(e,"a=ice-ufrag:",t))&&(n=ks.findLine(e,"a=ice-pwd:",t))&&(r={ufrag:ks.parseICEUfrag(i),pwd:ks.parseICEPwd(n)}),r},parseICEUfrag:e=>e.substring(12),buildICEUfrag:e=>`a=ice-ufrag:${e}`,parseICEPwd:e=>e.substring(10),buildICEPwd:e=>`a=ice-pwd:${e}`,parseMID:e=>e.substring(6),parseMSIDAttribute(e){const t=e.find((e=>e.indexOf(" msid:")>0));if(!t)return;const n=t.substring(t.indexOf(" msid:")+6);return ks.filterSpecialChars(n)},parseMLine(e){const t={},n=e.substring(2).split(" ");return t.media=n.shift(),t.port=n.shift(),t.proto=n.shift(),""===n[n.length-1]&&n.pop(),t.fmt=n,t},buildMLine:e=>`m=${e.media} ${e.port} ${e.proto} ${e.fmt.join(" ")}`,parseRTPMap(e){const t={};let n=e.substring(9).split(" ");return t.id=n.shift(),n=n[0].split("/"),t.name=n.shift(),t.clockrate=n.shift(),t.channels=n.length?n.shift():"1",t},parseSCTPMap(e){const t=e.substring(10).split(" ");return[t[0],t[1],t.length>2?t[2]:null]},parseSCTPPort:e=>e.substring(12),buildRTPMap(e){let t=`a=rtpmap:${e.getAttribute("id")} ${e.getAttribute("name")}/${e.getAttribute("clockrate")}`;return e.getAttribute("channels")&&"1"!==e.getAttribute("channels")&&(t+=`/${e.getAttribute("channels")}`),t},parseCrypto(e){const t={},n=e.substring(9).split(" ");return t.tag=n.shift(),t["crypto-suite"]=n.shift(),t["key-params"]=n.shift(),n.length&&(t["session-params"]=n.join(" ")),t},parseFingerprint(e){const t={},n=e.substring(14).split(" ");return t.hash=n.shift(),t.fingerprint=n.shift(),t},parseFmtp(e){const t=[];let n=e.split(" ");n.shift(),n=n.join(" ").split(";");for(let e=0;e<n.length;e++){let i=n[e].split("=")[0];for(;i.length&&" "===i[0];)i=i.substring(1);const r=n[e].split("=")[1];i&&r?t.push({name:i,value:r}):i&&t.push({name:"",value:i})}return t},parseICECandidate(e){const t={},n=e.split(" ");t.foundation=n[0].substring(12),t.component=n[1],t.protocol=n[2].toLowerCase(),t.priority=n[3],t.ip=n[4],t.port=n[5],t.type=n[7],t.generation=0;for(let e=8;e<n.length;e+=2)switch(n[e]){case"raddr":t["rel-addr"]=n[e+1];break;case"rport":t["rel-port"]=n[e+1];break;case"generation":t.generation=n[e+1];break;case"tcptype":t.tcptype=n[e+1];break;default:Os.debug(`parseICECandidate not translating "${n[e]}" = "${n[e+1]}"`)}return t.network="1",t.id=Math.random().toString(36).substr(2,10),t},buildICECandidate(e){let t=[`a=candidate:${e.foundation}`,e.component,e.protocol,e.priority,e.ip,e.port,"typ",e.type].join(" ");switch(t+=" ",e.type){case"srflx":case"prflx":case"relay":e.hasOwnAttribute("rel-addr")&&e.hasOwnAttribute("rel-port")&&(t+="raddr",t+=" ",t+=e["rel-addr"],t+=" ",t+="rport",t+=" ",t+=e["rel-port"],t+=" ")}return e.hasOwnAttribute("tcptype")&&(t+="tcptype",t+=" ",t+=e.tcptype,t+=" "),t+="generation",t+=" ",t+=e.hasOwnAttribute("generation")?e.generation:"0",t},parseSSRC(e){const t=new Map,n=e.split("\\r\\n");for(let e=0;e<n.length;e++)if("a=ssrc:"===n[e].substring(0,7)){const i=n[e].split("a=ssrc:")[1].split(" ")[0];t.get(i)||t.set(i,[]),t.get(i).push(n[e])}return t},parseSourceNameLine(e){const t=e.find((e=>e.indexOf(" name:")>0));return null==t?void 0:t.substring(t.indexOf(" name:")+6)},parseVideoTypeLine(e){const t=" videoType:",n=e.find((e=>e.indexOf(t)>0));return null==n?void 0:n.substring(n.indexOf(t)+t.length)},parseRTCPFB(e){const t=e.substr(10).split(" "),n={};return n.pt=t.shift(),n.type=t.shift(),n.params=t,n},parseExtmap(e){const t=e.substr(9).split(" "),n={};return n.value=t.shift(),-1===n.value.indexOf("/")?n.direction="both":(n.direction=n.value.substr(n.value.indexOf("/")+1),n.value=n.value.substr(0,n.value.indexOf("/"))),n.uri=t.shift(),n.params=t,n},findLine(e,t,n){let i=e.split("\\r\\n");for(let e=0;e<i.length;e++)if(i[e].substring(0,t.length)===t)return i[e];if(!n)return!1;i=n.split("\\r\\n");for(let e=0;e<i.length;e++)if(i[e].substring(0,t.length)===t)return i[e];return!1},findLines(e,t,n){let i=e.split("\\r\\n");const r=[];for(let e=0;e<i.length;e++)i[e].substring(0,t.length)===t&&r.push(i[e]);if(r.length||!n)return r;i=n.split("\\r\\n");for(let e=0;e<i.length;e++)i[e].substring(0,t.length)===t&&r.push(i[e]);return r},candidateToJingle(e){if(0===e.indexOf("candidate:"))e=`a=${e}`;else if("a=candidate:"!==e.substring(0,12))return Os.warn("parseCandidate called with a line that is not a candidate line"),Os.warn(e),null;"\\r\\n"===e.substring(e.length-2)&&(e=e.substring(0,e.length-2));const t={},n=e.split(" ");if("typ"!==n[6])return Os.warn("did not find typ in the right place"),Os.warn(e),null;t.foundation=n[0].substring(12),t.component=n[1],t.protocol=n[2].toLowerCase(),t.priority=n[3],t.ip=n[4],t.port=n[5],t.type=n[7],t.generation="0";for(let e=8;e<n.length;e+=2)switch(n[e]){case"raddr":t["rel-addr"]=n[e+1];break;case"rport":t["rel-port"]=n[e+1];break;case"generation":t.generation=n[e+1];break;case"tcptype":t.tcptype=n[e+1];break;default:Os.debug(`not translating "${n[e]}" = "${n[e+1]}"`)}return t.network="1",t.id=Math.random().toString(36).substr(2,10),t},candidateFromJingle(e){let t="a=candidate:";t+=e.getAttribute("foundation"),t+=" ",t+=e.getAttribute("component"),t+=" ";let n=e.getAttribute("protocol");switch(ci.isFirefox()&&"ssltcp"===n.toLowerCase()&&(n="tcp"),t+=n,t+=" ",t+=e.getAttribute("priority"),t+=" ",t+=e.getAttribute("ip"),t+=" ",t+=e.getAttribute("port"),t+=" ",t+="typ",t+=` ${e.getAttribute("type")}`,t+=" ",e.getAttribute("type")){case"srflx":case"prflx":case"relay":e.getAttribute("rel-addr")&&e.getAttribute("rel-port")&&(t+="raddr",t+=" ",t+=e.getAttribute("rel-addr"),t+=" ",t+="rport",t+=" ",t+=e.getAttribute("rel-port"),t+=" ")}return"tcp"===n.toLowerCase()&&(t+="tcptype",t+=" ",t+=e.getAttribute("tcptype"),t+=" "),t+="generation",t+=" ",t+=e.getAttribute("generation")||"0",`${t}\\r\\n`},parsePrimaryVideoSsrc(e){const t=e.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t)).length,n=e.ssrcGroups&&e.ssrcGroups.length||0;if(t>1&&0===n)return;let i=null;if(1===t)i=e.ssrcs[0].id;else if(2===t){const t=e.ssrcGroups.find((e=>"FID"===e.semantics));t&&(i=t.ssrcs.split(" ")[0])}else if(t>=3){const t=e.ssrcGroups.find((e=>"SIM"===e.semantics));t&&(i=t.ssrcs.split(" ")[0])}return i},generateSsrc:()=>co().randomInt(1,4294967295),getSsrcAttribute(e,t,n){for(let i=0;i<e.ssrcs.length;++i){const r=e.ssrcs[i];if(r.id===t&&r.attribute===n)return r.value}},parseGroupSsrcs:e=>e.ssrcs.split(" ").map((e=>parseInt(e,10))),getMedia:(e,t)=>e.media.find((e=>e.type===t)),getUfrag(e){const t=e.split("\\n").filter((e=>e.startsWith("a=ice-ufrag:")));if(t.length>0)return t[0].substr("a=ice-ufrag:".length)},preferCodec(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||!t)return;const i=e.rtp.filter((e=>e.codec&&e.codec.toLowerCase()===t.toLowerCase())).map((e=>e.payload));if(i){if(n&&t===Ds.H264){const t=i.filter((t=>{const n=e.fmtp.find((e=>e.payload===t));return!!n&&n.config.includes("packetization-mode=0")}));for(const e of t.reverse()){const t=i.findIndex((t=>t===e));t>=0&&(i.splice(t,1),i.unshift(e))}}const r=e.payloads.toString().split(" ").map((e=>parseInt(e,10)));for(const e of i.reverse()){const t=r.indexOf(e);r.splice(t,1),r.unshift(e)}e.payloads=r.join(" ")}else Os.error(`No matching RTP payload type found for ${t}, failed to set preferred codecs`)},stripCodec(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(!e||!t)return;const i=new Map;let r=[];for(const o of e.rtp)o.codec&&o.codec.toLowerCase()===t.toLowerCase()&&(n?i.set(o.payload,o.codec):r.push(o.payload));if(n&&(r=e.fmtp.filter((e=>{const t=i.get(e.payload);return!!t&&(t.toLowerCase()===Ds.VP9?!e.config.includes("profile-id=0"):!e.config.includes("profile-level-id=42"))})).map((e=>e.payload))),r.length>0){const t=r.map((e=>`apt=${e}`)),n=e.fmtp.filter((e=>-1!==t.indexOf(e.config)));r.push(...n.map((e=>e.payload)));const i=e.payloads.toString().split(" ").map(Number).filter((e=>-1===r.indexOf(e)));0===i.length?(e.port=0,e.direction=As.INACTIVE,e.payloads="*"):e.payloads=i.join(" "),e.rtp=e.rtp.filter((e=>-1!==i.indexOf(e.payload))),e.fmtp=e.fmtp.filter((e=>-1!==i.indexOf(e.payload))),e.rtcpFb&&(e.rtcpFb=e.rtcpFb.filter((e=>-1!==i.indexOf(e.payload))))}}},Ns=ks;function Ms(e){const t=e.split("\\r\\nm=");for(let e=1,n=t.length;e<n;e++){let i=`m=${t[e]}`;e!==n-1&&(i+="\\r\\n"),t[e]=i}const n=`${t.shift()}\\r\\n`;this.media=t,this.raw=n+t.join(""),this.session=n}function Ls(e,t){if(!t)return!1;if(e.length!==t.length)return!1;for(let n=0,i=e.length;n<i;n++)if(e[n]instanceof Array&&t[n]instanceof Array){if(!e[n].equals(t[n]))return!1}else if(e[n]!==t[n])return!1;return!0}function Fs(e,t){if(this.mySDP=e,this.otherSDP=t,!e)throw new Error(\'"mySDP" is undefined!\');if(!t)throw new Error(\'"otherSDP" is undefined!\')}function js(e){return function(){if(null===e)throw new Error("Callback was already called.");var t=e;e=null;for(var n=arguments.length,i=new Array(n),r=0;r<n;r++)i[r]=arguments[r];t.apply(this,i)}}Ms.prototype.failICE=!1,Ms.prototype.removeTcpCandidates=!1,Ms.prototype.removeUdpCandidates=!1,Ms.prototype.addMlineForNewLocalSource=function(e){const t=this.media.length,n=Ps.parse(this.raw),i=Ss()(n.media.find((t=>t.type===e)));i.mid=t,i.direction=As.RECVONLY,i.msid=void 0,i.ssrcs=void 0,i.ssrcGroups=void 0,n.media=n.media.concat(i),n.groups.forEach((e=>{if("BUNDLE"===e.type){const n=e.mids.split(" ");n.push(t),e.mids=n.join(" ")}})),this.raw=Ps.write(n)},Ms.prototype.getMediaSsrcMap=function(){const e={};for(let t=0;t<this.media.length;t++){const n={mediaindex:t,mid:Ns.parseMID(Ns.findLine(this.media[t],"a=mid:")),ssrcs:{},ssrcGroups:[]};e[t]=n,Ns.findLines(this.media[t],"a=ssrc:").forEach((e=>{const t=e.substring(7).split(" ")[0];n.ssrcs[t]||(n.ssrcs[t]={ssrc:t,lines:[]}),n.ssrcs[t].lines.push(e)})),Ns.findLines(this.media[t],"a=ssrc-group:").forEach((e=>{const t=e.indexOf(" "),i=e.substr(0,t).substr(13),r=e.substr(14+i.length).split(" ");r.length&&n.ssrcGroups.push({semantics:i,ssrcs:r})}))}return e},Ms.prototype.containsSSRC=function(e){const t=this.getMediaSsrcMap();let n=!1;return Object.keys(t).forEach((i=>{n||t[i].ssrcs[e]&&(n=!0)})),n},Ms.prototype.toJingle=function(e,t){Ns.findLines(this.session,"a=group:").forEach((t=>{const n=t.split(" "),i=n.shift().substr(8);e.c("group",{xmlns:"urn:xmpp:jingle:apps:grouping:0",semantics:i});for(let t=0;t<n.length;t++)e.c("content",{name:n[t]}).up();e.up()}));for(let n=0;n<this.media.length;n++){const i=Ns.parseMLine(this.media[n].split("\\r\\n")[0]);if("audio"!==i.media&&"video"!==i.media&&"application"!==i.media)continue;let r;const o=Ns.findLine(this.media[n],"a=ssrc:");r=!!o&&o.substring(7).split(" ")[0],e.c("content",{creator:t,name:i.media});const s=Ns.findLine(this.media[n],"a=mid:");if(s){const t=Ns.parseMID(s);e.attrs({name:t})}if("video"===i.media&&"number"==typeof this.initialLastN&&e.c("initial-last-n",{xmlns:"jitsi:colibri2",value:this.initialLastN}).up(),"audio"===i.media||"video"===i.media){e.c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:i.media}),r&&e.attrs({ssrc:r});for(let t=0;t<i.fmt.length;t++){const r=Ns.findLine(this.media[n],`a=rtpmap:${i.fmt[t]}`);e.c("payload-type",Ns.parseRTPMap(r));const o=Ns.findLine(this.media[n],`a=fmtp:${i.fmt[t]}`);if(o){const t=Ns.parseFmtp(o);for(let n=0;n<t.length;n++)e.c("parameter",t[n]).up()}this.rtcpFbToJingle(n,e,i.fmt[t]),e.up()}if(r){const t=Ns.parseSSRC(this.media[n]);for(const[n,i]of t){const t=Ns.parseSourceNameLine(i),r=Ns.parseVideoTypeLine(i);e.c("source",{ssrc:n,name:t,videoType:r,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"});const o=Ns.parseMSIDAttribute(i);o&&(e.c("parameter"),e.attrs({name:"msid"}),e.attrs({value:o}),e.up()),e.up()}Ns.findLines(this.media[n],"a=ssrc-group:").forEach((t=>{const n=t.indexOf(" "),i=t.substr(0,n).substr(13),r=t.substr(14+i.length).split(" ");r.length&&(e.c("ssrc-group",{semantics:i,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),r.forEach((t=>e.c("source",{ssrc:t}).up())),e.up())}))}const t=Ns.findLines(this.media[n],"a=rid:");if(t.length&&ci.usesRidsForSimulcast()){const i=t.map((e=>e.split(":")[1])).map((e=>e.split(" ")[0]));i.forEach((t=>{e.c("source",{rid:t,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),e.up()})),Ns.findLine(this.media[n],"a=simulcast:")&&(e.c("rid-group",{semantics:"SIM",xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),i.forEach((t=>{e.c("source",{rid:t}).up()})),e.up())}Ns.findLine(this.media[n],"a=rtcp-mux")&&e.c("rtcp-mux").up(),this.rtcpFbToJingle(n,e,"*");const o=Ns.findLines(this.media[n],"a=extmap:",this.session);for(let t=0;t<o.length;t++){const n=Ns.parseExtmap(o[t]);if(e.c("rtp-hdrext",{xmlns:"urn:xmpp:jingle:apps:rtp:rtp-hdrext:0",uri:n.uri,id:n.value}),n.hasOwnProperty("direction"))switch(n.direction){case As.SENDONLY:e.attrs({senders:"responder"});break;case As.RECVONLY:e.attrs({senders:"initiator"});break;case As.SENDRECV:e.attrs({senders:"both"});break;case As.INACTIVE:e.attrs({senders:"none"})}e.up()}Ns.findLine(this.media[n],"a=extmap-allow-mixed",this.session)&&(e.c("extmap-allow-mixed",{xmlns:"urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"}),e.up()),e.up()}this.transportToJingle(n,e);const a=this.media[n];Ns.findLine(a,`a=${As.SENDRECV}`)?e.attrs({senders:"both"}):Ns.findLine(a,`a=${As.SENDONLY}`)?e.attrs({senders:"initiator"}):Ns.findLine(a,`a=${As.RECVONLY}`)?e.attrs({senders:"responder"}):Ns.findLine(a,`a=${As.INACTIVE}`)&&e.attrs({senders:"none"}),"0"!==i.port||Ns.findLine(a,"a=bundle-only",this.session)||e.attrs({senders:"rejected"}),e.up()}return e.up(),e},Ms.prototype.transportToJingle=function(e,t){t.c("transport");const n=Ns.findLine(this.media[e],"a=sctp-port:",this.session),i=Ns.findLine(this.media[e],"a=sctpmap:",this.session);if(n){const e=Ns.parseSCTPPort(n);t.c("sctpmap",{xmlns:"urn:xmpp:jingle:transports:dtls-sctp:1",number:e,protocol:"webrtc-datachannel"}),t.attrs({streams:0}),t.up()}else if(i){const e=Ns.parseSCTPMap(i);t.c("sctpmap",{xmlns:"urn:xmpp:jingle:transports:dtls-sctp:1",number:e[0],protocol:e[1]}),e.length>2?t.attrs({streams:e[2]}):t.attrs({streams:0}),t.up()}Ns.findLines(this.media[e],"a=fingerprint:",this.session).forEach((n=>{const i=Ns.parseFingerprint(n);i.xmlns="urn:xmpp:jingle:apps:dtls:0",t.c("fingerprint").t(i.fingerprint),delete i.fingerprint;const r=Ns.findLine(this.media[e],"a=setup:",this.session);r&&(i.setup=r.substr(8)),t.attrs(i),t.up()}));const r=Ns.iceparams(this.media[e],this.session);r&&(r.xmlns="urn:xmpp:jingle:transports:ice-udp:1",t.attrs(r),Ns.findLines(this.media[e],"a=candidate:",this.session).forEach((e=>{const n=Ns.candidateToJingle(e);this.failICE&&(n.ip="1.1.1.1");const i=n&&"string"==typeof n.protocol?n.protocol.toLowerCase():"";this.removeTcpCandidates&&("tcp"===i||"ssltcp"===i)||this.removeUdpCandidates&&"udp"===i||t.c("candidate",n).up()}))),t.up()},Ms.prototype.rtcpFbToJingle=function(e,t,n){Ns.findLines(this.media[e],`a=rtcp-fb:${n}`).forEach((e=>{const n=Ns.parseRTCPFB(e);"trr-int"===n.type?(t.c("rtcp-fb-trr-int",{xmlns:"urn:xmpp:jingle:apps:rtp:rtcp-fb:0",value:n.params[0]}),t.up()):(t.c("rtcp-fb",{xmlns:"urn:xmpp:jingle:apps:rtp:rtcp-fb:0",type:n.type}),n.params.length>0&&t.attrs({subtype:n.params[0]}),t.up())}))},Ms.prototype.rtcpFbFromJingle=function(e,t){let n="";const i=e.find(\'>rtcp-fb-trr-int[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]\');return i.length&&(n+="a=rtcp-fb:* trr-int ",i.attr("value")?n+=i.attr("value"):n+="0",n+="\\r\\n"),e.find(\'>rtcp-fb[xmlns="urn:xmpp:jingle:apps:rtp:rtcp-fb:0"]\').each(((e,i)=>{n+=`a=rtcp-fb:${t} ${i.getAttribute("type")}`,i.hasAttribute("subtype")&&(n+=` ${i.getAttribute("subtype")}`),n+="\\r\\n"})),n},Ms.prototype.fromJingle=function(e){const t=Date.now();this.raw=`v=0\\r\\no=- ${t} 2 IN IP4 0.0.0.0\\r\\ns=-\\r\\nt=0 0\\r\\n`;const n=_t()(e).find(\'>group[xmlns="urn:xmpp:jingle:apps:grouping:0"]\');n.length&&n.each(((e,t)=>{const n=_t()(t).find(">content").map(((e,t)=>t.getAttribute("name"))).get();n.length>0&&(this.raw+=`a=group:${t.getAttribute("semantics")||t.getAttribute("type")} ${n.join(" ")}\\r\\n`)})),this.session=this.raw,e.find(">content").each(((e,t)=>{const n=this.jingle2media(_t()(t));this.media.push(n)})),this.raw=this.session+this.media.join("")},Ms.prototype.jingle2media=function(e){const t=e.find(">description"),n=e.find(\'>transport[xmlns="urn:xmpp:jingle:transports:ice-udp:1"]\');let i="";const r=n.find(\'>sctpmap[xmlns="urn:xmpp:jingle:transports:dtls-sctp:1"]\'),o={media:t.attr("media"),port:"9"};switch("rejected"===e.attr("senders")&&(o.port="0"),n.find(\'>fingerprint[xmlns="urn:xmpp:jingle:apps:dtls:0"]\').length?o.proto=r.length?"UDP/DTLS/SCTP":"UDP/TLS/RTP/SAVPF":o.proto="UDP/TLS/RTP/SAVPF",r.length?(i+=`m=application ${o.port} UDP/DTLS/SCTP webrtc-datachannel\\r\\n`,i+=`a=sctp-port:${r.attr("number")}\\r\\n`,i+="a=max-message-size:262144\\r\\n"):(o.fmt=t.find(">payload-type").map(((e,t)=>t.getAttribute("id"))).get(),i+=`${Ns.buildMLine(o)}\\r\\n`),i+="c=IN IP4 0.0.0.0\\r\\n",r.length||(i+="a=rtcp:1 IN IP4 0.0.0.0\\r\\n"),n.length&&(n.attr("ufrag")&&(i+=`${Ns.buildICEUfrag(n.attr("ufrag"))}\\r\\n`),n.attr("pwd")&&(i+=`${Ns.buildICEPwd(n.attr("pwd"))}\\r\\n`),n.find(\'>fingerprint[xmlns="urn:xmpp:jingle:apps:dtls:0"]\').each(((e,t)=>{i+=`a=fingerprint:${t.getAttribute("hash")}`,i+=` ${_t()(t).text()}`,i+="\\r\\n",t.hasAttribute("setup")&&(i+=`a=setup:${t.getAttribute("setup")}\\r\\n`)}))),n.find(">candidate").each(((e,t)=>{let n=t.getAttribute("protocol");n="string"==typeof n?n.toLowerCase():"",this.removeTcpCandidates&&("tcp"===n||"ssltcp"===n)||this.removeUdpCandidates&&"udp"===n||(this.failICE&&t.setAttribute("ip","1.1.1.1"),i+=Ns.candidateFromJingle(t))})),e.attr("senders")){case"initiator":i+=`a=${As.SENDONLY}\\r\\n`;break;case"responder":i+=`a=${As.RECVONLY}\\r\\n`;break;case"none":i+=`a=${As.INACTIVE}\\r\\n`;break;case"both":i+=`a=${As.SENDRECV}\\r\\n`}i+=`a=mid:${e.attr("name")}\\r\\n`,t.find(">rtcp-mux").length&&(i+="a=rtcp-mux\\r\\n"),t.find(">payload-type").each(((e,t)=>{i+=`${Ns.buildRTPMap(t)}\\r\\n`,_t()(t).find(">parameter").length&&(i+=`a=fmtp:${t.getAttribute("id")} `,i+=_t()(t).find(">parameter").map(((e,t)=>{const n=t.getAttribute("name");return(n?`${n}=`:"")+t.getAttribute("value")})).get().join(";"),i+="\\r\\n"),i+=this.rtcpFbFromJingle(_t()(t),t.getAttribute("id"))})),i+=this.rtcpFbFromJingle(t,"*"),t.find(\'>rtp-hdrext[xmlns="urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"]\').each(((e,t)=>{i+=`a=extmap:${t.getAttribute("id")} ${t.getAttribute("uri")}\\r\\n`})),t.find(\'>extmap-allow-mixed[xmlns="urn:xmpp:jingle:apps:rtp:rtp-hdrext:0"]\').length>0&&(i+="a=extmap-allow-mixed\\r\\n"),t.find(\'>ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=t.getAttribute("semantics"),r=_t()(t).find(">source").map(((e,t)=>t.getAttribute("ssrc"))).get();r.length&&(i+=`a=ssrc-group:${n} ${r.join(" ")}\\r\\n`)}));let s="",a="";return t.find(\'>source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=t.getAttribute("ssrc");let i=!0,r="";_t()(t).find(">parameter").each(((e,t)=>{var o;const s=t.getAttribute("name");let a=t.getAttribute("value");a=Ns.filterSpecialChars(a),r+=`a=ssrc:${n} ${s}`,a&&a.length&&(r+=`:${a}`),r+="\\r\\n",null!==(o=a)&&void 0!==o&&o.includes("mixedmslabel")&&(i=!1)})),i?s+=r:a+=r})),i+=a+s,i},Fs.prototype.getNewMedia=function(){const e=this.mySDP.getMediaSsrcMap(),t=this.otherSDP.getMediaSsrcMap(),n={};return Object.keys(t).forEach((i=>{const r=e[i],o=t[i];r||!o?(Object.keys(o.ssrcs).forEach((e=>{(-1===Object.keys(r.ssrcs).indexOf(e)||o.ssrcs[e].lines&&r.ssrcs[e].lines&&void 0!==r.ssrcs[e].lines.find((e=>-1!==e.indexOf("msid")))!=(void 0!==o.ssrcs[e].lines.find((e=>-1!==e.indexOf("msid")))))&&(n[i]||(n[i]={mediaindex:o.mediaindex,mid:o.mid,ssrcs:{},ssrcGroups:[]}),n[i].ssrcs[e]=o.ssrcs[e])})),o.ssrcGroups.forEach((e=>{let t=!1;for(let n=0;n<r.ssrcGroups.length;n++){const i=r.ssrcGroups[n];if(e.semantics===i.semantics&&Ls(e.ssrcs,i.ssrcs)){t=!0;break}}t||(n[i]||(n[i]={mediaindex:o.mediaindex,mid:o.mid,ssrcs:{},ssrcGroups:[]}),n[i].ssrcGroups.push(e))}))):n[i]=o})),n},Fs.prototype.toJingle=function(e){const t=this.getNewMedia();let n=!1;return Object.keys(t).forEach((i=>{n=!0;const r=t[i];e.c("content",{name:r.mid}),e.c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:r.mid}),Object.keys(r.ssrcs).forEach((t=>{const n=r.ssrcs[t],i=n.lines,o=Ns.parseSourceNameLine(i),s=Ns.parseVideoTypeLine(i);e.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),e.attrs({name:o,videoType:s,ssrc:n.ssrc});const a=Ns.parseMSIDAttribute(i);a&&(e.c("parameter"),e.attrs({name:"msid"}),e.attrs({value:a}),e.up()),e.up()})),r.ssrcGroups.forEach((t=>{t.ssrcs.length&&(e.c("ssrc-group",{semantics:t.semantics,xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0"}),t.ssrcs.forEach((t=>{e.c("source",{ssrc:t}).up()})),e.up())})),e.up(),e.up()})),n};var Vs,Us="function"==typeof queueMicrotask&&queueMicrotask,Hs="function"==typeof setImmediate&&setImmediate,$s="object"==typeof process&&"function"==typeof process.nextTick;Vs=Us?queueMicrotask:Hs?setImmediate:$s?process.nextTick:function(e){setTimeout(e,0)};const Js=(Bs=Vs,function(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];return Bs((()=>e(...n)))});var Bs;class qs{constructor(){this.head=this.tail=null,this.length=0}removeLink(e){return e.prev?e.prev.next=e.next:this.head=e.next,e.next?e.next.prev=e.prev:this.tail=e.prev,e.prev=e.next=null,this.length-=1,e}empty(){for(;this.head;)this.shift();return this}insertAfter(e,t){t.prev=e,t.next=e.next,e.next?e.next.prev=t:this.tail=t,e.next=t,this.length+=1}insertBefore(e,t){t.prev=e.prev,t.next=e,e.prev?e.prev.next=t:this.head=t,e.prev=t,this.length+=1}unshift(e){this.head?this.insertBefore(this.head,e):Gs(this,e)}push(e){this.tail?this.insertAfter(this.tail,e):Gs(this,e)}shift(){return this.head&&this.removeLink(this.head)}pop(){return this.tail&&this.removeLink(this.tail)}toArray(){return[...this]}*[Symbol.iterator](){for(var e=this.head;e;)yield e.data,e=e.next}remove(e){for(var t=this.head;t;){var{next:n}=t;e(t)&&this.removeLink(t),t=n}return this}}function Gs(e,t){e.length=1,e.head=e.tail=t}function zs(e,t){return e.then((e=>{Ks(t,null,e)}),(e=>{Ks(t,e&&e.message?e:new Error(e))}))}function Ks(e,t,n){try{e(t,n)}catch(e){Js((e=>{throw e}),e)}}function Ws(e){return"AsyncFunction"===e[Symbol.toStringTag]}const Xs=function(e){if("function"!=typeof e)throw new Error("expected a function");return Ws(e)?Ws(t=e)?function(){for(var e=arguments.length,n=new Array(e),i=0;i<e;i++)n[i]=arguments[i];const r=n.pop();return zs(t.apply(this,n),r)}:(n=function(e,n){var i;try{i=t.apply(this,e)}catch(e){return n(e)}if(i&&"function"==typeof i.then)return zs(i,n);n(null,i)},function(){for(var e=arguments.length,t=new Array(e),i=0;i<e;i++)t[i]=arguments[i];var r=t.pop();return n.call(this,t,r)}):e;var t,n};function Ys(e,t,n){if(null==t)t=1;else if(0===t)throw new RangeError("Concurrency must not be zero");var i=Xs(e),r=0,o=[];const s={error:[],drain:[],saturated:[],unsaturated:[],empty:[]};function a(e,t){return e?t?void(s[e]=s[e].filter((e=>e!==t))):s[e]=[]:Object.keys(s).forEach((e=>s[e]=[]))}function d(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),i=1;i<t;i++)n[i-1]=arguments[i];s[e].forEach((e=>e(...n)))}var c=!1;function l(e,t,n,i){if(null!=i&&"function"!=typeof i)throw new Error("task callback must be a function");var r,o;function s(e){if(e)return n?o(e):r();for(var t=arguments.length,i=new Array(t>1?t-1:0),s=1;s<t;s++)i[s-1]=arguments[s];if(i.length<=1)return r(i[0]);r(i)}g.started=!0;var a=g._createTaskItem(e,n?s:i||s);if(t?g._tasks.unshift(a):g._tasks.push(a),c||(c=!0,Js((()=>{c=!1,g.process()}))),n||!i)return new Promise(((e,t)=>{r=e,o=t}))}function h(e){return function(t){r-=1;for(var n=arguments.length,i=new Array(n>1?n-1:0),s=1;s<n;s++)i[s-1]=arguments[s];for(var a=0,c=e.length;a<c;a++){var l=e[a],h=o.indexOf(l);0===h?o.shift():h>0&&o.splice(h,1),l.callback(t,...i),null!=t&&d("error",t,l.data)}r<=g.concurrency-g.buffer&&d("unsaturated"),g.idle()&&d("drain"),g.process()}}function u(e){return!(0!==e.length||!g.idle()||(Js((()=>d("drain"))),0))}const p=e=>t=>{if(!t)return new Promise(((t,n)=>{!function(e,i){const r=function(){a(e,r),((e,i)=>{if(e)return n(e);t(i)})(...arguments)};s[e].push(r)}(e)}));a(e),function(e,t){s[e].push(t)}(e,t)};var m=!1,g={_tasks:new qs,_createTaskItem:(e,t)=>({data:e,callback:t}),*[Symbol.iterator](){yield*g._tasks[Symbol.iterator]()},concurrency:t,payload:n,buffer:t/4,started:!1,paused:!1,push(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!1,!1,t)))}return l(e,!1,!1,t)},pushAsync(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!1,!0,t)))}return l(e,!1,!0,t)},kill(){a(),g._tasks.empty()},unshift(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!0,!1,t)))}return l(e,!0,!1,t)},unshiftAsync(e,t){if(Array.isArray(e)){if(u(e))return;return e.map((e=>l(e,!0,!0,t)))}return l(e,!0,!0,t)},remove(e){g._tasks.remove(e)},process(){if(!m){for(m=!0;!g.paused&&r<g.concurrency&&g._tasks.length;){var e=[],t=[],n=g._tasks.length;g.payload&&(n=Math.min(n,g.payload));for(var s=0;s<n;s++){var a=g._tasks.shift();e.push(a),o.push(a),t.push(a.data)}r+=1,0===g._tasks.length&&d("empty"),r===g.concurrency&&d("saturated");var c=js(h(e));i(t,c)}m=!1}},length:()=>g._tasks.length,running:()=>r,workersList:()=>o,idle:()=>g._tasks.length+r===0,pause(){g.paused=!0},resume(){!1!==g.paused&&(g.paused=!1,Js(g.process))}};return Object.defineProperties(g,{saturated:{writable:!1,value:p("saturated")},unsaturated:{writable:!1,value:p("unsaturated")},empty:{writable:!1,value:p("empty")},drain:{writable:!1,value:p("drain")},error:{writable:!1,value:p("error")}}),g}const Qs=(0,y.getLogger)("modules/util/AsyncQueue.js");class Zs extends Error{constructor(e){super(e),this.name="ClearedQueueError"}}class ea{constructor(){var e,t;this._queue=(e=this._processQueueTasks.bind(this),1,t=Xs(e),Ys(((e,n)=>{t(e[0],n)}),1,1)),this._stopped=!1,this._taskCallbacks=new Map}clear(){for(const e of this._taskCallbacks.values())try{null==e||e(new Zs("The queue has been cleared"))}catch(e){Qs.error("Error in callback while clearing the queue:",e)}this._queue.kill()}_processQueueTasks(e,t){try{e(t)}catch(e){Qs.error(`Task failed: ${null==e?void 0:e.stack}`),t(e)}finally{this._taskCallbacks.delete(e)}}pause(){this._queue.pause()}push(e,t){this._stopped?t&&t(new Error("The queue has been stopped")):(this._taskCallbacks.set(e,t),this._queue.push(e,t))}resume(){this._queue.resume()}shutdown(){this._stopped=!0}}let ta;!function(e){e.PENDING="pending",e.ACTIVE="active",e.ENDED="ended"}(ta||(ta={}));const na=ta.PENDING,ia=ta.ACTIVE,ra=ta.ENDED,oa=(0,y.getLogger)("modules/xmpp/JingleSession.js");class sa extends xr{constructor(e,t,n,i,r,o,s){super(),this.sid=e,this.localJid=t,this.remoteJid=n,this.connection=i,this.mediaConstraints=r,this.pcConfig=o,this.isInitiator=s,this.usedrip=!0,this.dripContainer=[],this.room=null,this._signalingLayer=null,this.state=null,this.rtc=null}get initiatorJid(){return this.isInitiator?this.localJid:this.remoteJid}get responderJid(){return this.isInitiator?this.remoteJid:this.localJid}initialize(e,t,n,i){if(null!==this.state){const e=`attempt to initiate on session ${this.sid}\\n                   in state ${this.state}`;throw oa.error(e),new Error(e)}this.room=e,this.rtc=t,this._signalingLayer=n,this.state=na,this.doInitialize(i)}doInitialize(e){}addIceCandidates(e){}getState(){return this.state}addSources(e){}removeSources(e){}terminate(e,t,n){}acceptOffer(e,t,n){}}var aa;!function(e){e.REMOTE_SOURCE_CONSTRAINTS_CHANGED="media_session.REMOTE_SOURCE_CONSTRAINTS_CHANGED"}(aa||(aa={}));const da=aa,ca=(0,y.getLogger)("modules/xmpp/JingleSessionPC.js"),la=1e4;function ha(e,t,n,i){e.c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:n,name:t.source}).c("parameter",{name:"msid",value:i}).up().c("ssrc-info",{xmlns:"http://jitsi.org/jitmeet",owner:t.owner}).up().up()}class ua extends sa{static parseVideoSenders(e){const t=e.find(\'>content[name="video"]\');if(t.length){const e=t[0].getAttribute("senders");if("both"===e||"initiator"===e||"responder"===e||"none"===e)return e}return null}static parseSourceMaxFrameHeight(e){const t=[],n=e.find(\'>content[name="video"]>source-frame-height\');let i,r;return n.length?(n.each(((e,n)=>{r=n.getAttribute("sourceName"),i=n.getAttribute("maxHeight"),t.push({maxHeight:i,sourceName:r})})),t):null}constructor(e,t,n,i,r,o,s,a){super(e,t,n,i,r,o,a),this._bridgeSessionId=null,this._cachedOldLocalSdp=void 0,this._cachedNewLocalSdp=void 0,this._iceCheckingStartedTimestamp=null,this._gatheringStartedTimestamp=null,this._sourceReceiverConstraints=void 0,this._localSendReceiveVideoActive=!0,this._remoteSendReceiveVideoActive=!0,this._gatheringReported=!1,this.lasticecandidate=!1,this.closed=!1,this.isP2P=s,this.remoteRecvMaxFrameHeight=void 0,this.numRemoteVideoSources=0,this.numRemoteAudioSources=0,this.remoteSourceMaxFrameHeights=void 0,this.modificationQueue=new ea,this.modificationQueue.pause(),this.wasConnected=!1,this.establishmentDuration=void 0,this._xmppListeners=[],this._xmppListeners.push(i.addCancellableListener(Lo.Events.CONN_STATUS_CHANGED,this.onXmppStatusChanged.bind(this))),this._removeSenderVideoConstraintsChangeListener=void 0}_assertNotEnded(){return this.state!==ra}doInitialize(e){this.failICE=Boolean(e.failICE),this.lasticecandidate=!1,this.options=e,this.isReconnect=!1,this.wasstable=!1,this.webrtcIceUdpDisable=Boolean(e.webrtcIceUdpDisable),this.webrtcIceTcpDisable=Boolean(e.webrtcIceTcpDisable);const t={disableRtx:e.disableRtx};if(e.gatherStats&&(t.maxstats=300),t.capScreenshareBitrate=!1,t.codecSettings=e.codecSettings,t.enableInsertableStreams=e.enableInsertableStreams,e.videoQuality){const n=Object.entries(e.videoQuality).map((e=>(e[0]=e[0].toLowerCase(),e)));t.videoQuality=Object.fromEntries(n)}var n;t.forceTurnRelay=e.forceTurnRelay,t.audioQuality=e.audioQuality,t.disableSimulcast=!!this.isP2P||e.disableSimulcast,this.isP2P||(t.capScreenshareBitrate=!((null===(n=e.desktopSharingFrameRate)||void 0===n?void 0:n.max)>5)),e.startSilent&&(t.startSilent=!0),this.peerconnection=this.rtc.createPeerConnection(this._signalingLayer,this.pcConfig,this.isP2P,t),this.peerconnection.onicecandidate=e=>{if(!e)return;const t=e.candidate,n=window.performance.now();if(t){null===this._gatheringStartedTimestamp&&(this._gatheringStartedTimestamp=n);let e=t.protocol;if("string"==typeof e)if(e=e.toLowerCase(),"tcp"===e||"ssltcp"===e){if(this.webrtcIceTcpDisable)return}else if("udp"===e&&this.webrtcIceUdpDisable)return}else this._gatheringReported||(Mi.sendAnalytics(Qt,{phase:"gathering",value:n-this._gatheringStartedTimestamp,p2p:this.isP2P,initiator:this.isInitiator}),this._gatheringReported=!0);this.isP2P&&this.sendIceCandidate(t)},this.peerconnection.onsignalingstatechange=()=>{"stable"===this.peerconnection.signalingState?this.wasstable=!0:"closed"!==this.peerconnection.signalingState&&"closed"!==this.peerconnection.connectionState||this.room.eventEmitter.emit(Hi.XMPPEvents.SUSPEND_DETECTED,this)},this.peerconnection.oniceconnectionstatechange=()=>{const e=window.performance.now();let t=!1;switch(this.isP2P||(this.room.connectionTimes[`ice.state.${this.peerconnection.iceConnectionState}`]=e),ca.log(`(TIME) ICE ${this.peerconnection.iceConnectionState} ${this.isP2P?"P2P":"JVB"}:\\t`,e),Mi.sendAnalytics(en,{p2p:this.isP2P,state:this.peerconnection.iceConnectionState,signaling_state:this.peerconnection.signalingState,reconnect:this.isReconnect,value:e}),this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_CONNECTION_STATE_CHANGED,this,this.peerconnection.iceConnectionState),this.peerconnection.iceConnectionState){case"checking":this._iceCheckingStartedTimestamp=e;break;case"connected":if("stable"===this.peerconnection.signalingState){t=!0;const e=!this.options.enableIceRestart&&this.room.supportsRestartByTerminate();(this.isReconnect||e)&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_RESTORED,this)}if(!this.wasConnected&&(this.wasstable||t||this.isInitiator&&(ci.isChromiumBased()||ci.isReactNative()))){Mi.sendAnalytics(Qt,{phase:"checking",value:e-this._iceCheckingStartedTimestamp,p2p:this.isP2P,initiator:this.isInitiator});const t=Math.min(this._iceCheckingStartedTimestamp,this._gatheringStartedTimestamp);this.establishmentDuration=e-t,Mi.sendAnalytics(Qt,{phase:"establishment",value:this.establishmentDuration,p2p:this.isP2P,initiator:this.isInitiator}),this.wasConnected=!0,this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this)}this.isReconnect=!1;break;case"disconnected":this.isReconnect=!0,this.wasstable&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this);break;case"failed":this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ICE_FAILED,this)}},this.peerconnection.onconnectionstatechange=()=>{const e=this.peerconnection.iceConnectionState;"failed"===this.peerconnection.connectionState&&"disconnected"===e&&this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_ICE_FAILED,this)},this.peerconnection.onnegotiationneeded=()=>{const e=this.peerconnection.signalingState,t=this.peerconnection.remoteDescription;if(!this.isP2P&&"stable"===e&&t&&"string"==typeof t.sdp){ca.info(`${this} onnegotiationneeded fired on ${this.peerconnection}`);const e=e=>{this._renegotiate().then((()=>this.peerconnection.configureAudioSenderEncodings())).then((()=>e()),(t=>e(t)))};this.modificationQueue.push(e,(e=>{e?ca.error(`${this} onnegotiationneeded error`,e):ca.debug(`${this} onnegotiationneeded executed - OK`)}))}}}getRemoteRecvMaxFrameHeight(){if(this.isP2P)return this.remoteRecvMaxFrameHeight}getRemoteSourcesRecvMaxFrameHeight(){if(this.isP2P)return this.remoteSourceMaxFrameHeights}sendIceCandidate(e){const t=new Ms(this.peerconnection.localDescription.sdp);if(e&&e.candidate.length&&!this.lasticecandidate){const n=Ns.iceparams(t.media[e.sdpMLineIndex],t.session),i=Ns.candidateToJingle(e.candidate);if(!n||!i)return void ca.error("failed to get ice && jcand");n.xmlns="urn:xmpp:jingle:transports:ice-udp:1",this.usedrip?(0===this.dripContainer.length&&setTimeout((()=>{0!==this.dripContainer.length&&(this.sendIceCandidates(this.dripContainer),this.dripContainer=[])}),150),this.dripContainer.push(e)):this.sendIceCandidates([e])}else ca.log(`${this} sendIceCandidate: last candidate`),this.lasticecandidate=!0}sendIceCandidates(e){if(!this._assertNotEnded("sendIceCandidates"))return;ca.log(`${this} sendIceCandidates ${JSON.stringify(e)}`);const t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-info",initiator:this.initiatorJid,sid:this.sid}),n=new Ms(this.peerconnection.localDescription.sdp);for(let i=0;i<n.media.length;i++){const r=e.filter((e=>e.sdpMLineIndex===i)),o=Ns.parseMLine(n.media[i].split("\\r\\n")[0]);if(r.length>0){const e=Ns.iceparams(n.media[i],n.session);e.xmlns="urn:xmpp:jingle:transports:ice-udp:1",t.c("content",{creator:this.initiatorJid===this.localJid?"initiator":"responder",name:r[0].sdpMid?r[0].sdpMid:o.media}).c("transport",e);for(let e=0;e<r.length;e++){const n=Ns.candidateToJingle(r[e].candidate);this.failICE&&(n.ip="1.1.1.1"),t.c("candidate",n).up()}const s=Ns.findLine(n.media[i],"a=fingerprint:",n.session);if(s){const e=Ns.parseFingerprint(s);e.required=!0,t.c("fingerprint",{xmlns:"urn:xmpp:jingle:apps:dtls:0"}).t(e.fingerprint),delete e.fingerprint,t.attrs(e),t.up()}t.up(),t.up()}}this.connection.sendIQ(t,null,this.newJingleErrorHandler(t),la)}sendIceFailedNotification(){const e=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-info",initiator:this.initiatorJid,sid:this.sid}).c("ice-state",{xmlns:"http://jitsi.org/protocol/focus"}).t("failed").up();this._bridgeSessionId&&e.c("bridge-session",{xmlns:"http://jitsi.org/protocol/focus",id:this._bridgeSessionId}),this.connection.sendIQ2(e,{timeout:65}).catch(this.newJingleErrorHandler(e))}addIceCandidates(e){if("closed"===this.peerconnection.signalingState)return void ca.warn(`${this} Ignored add ICE candidate when in closed state`);const t=[];e.find(">content>transport>candidate").each(((e,n)=>{let i=Ns.candidateFromJingle(n);i=i.replace("\\r\\n","").replace("a=","");const r=new RTCIceCandidate({sdpMLineIndex:0,sdpMid:"",candidate:i});t.push(r)})),t.length?(ca.debug(`${this} Queued add (${t.length}) ICE candidates task`),this.modificationQueue.push((e=>{for(const e of t)this.peerconnection.addIceCandidate(e).then((()=>ca.debug(`${this} addIceCandidate ok!`)),(e=>ca.error(`${this} addIceCandidate failed!`,e)));e(),ca.debug(`${this} ICE candidates task finished`)}))):ca.error(`${this} No ICE candidates to add ?`,e[0]&&e[0].outerHTML)}readSsrcInfo(e){_t()(e).find(\'>description>source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each(((e,t)=>{const n=Number(t.getAttribute("ssrc"));let i;t.hasAttribute("name")&&(i=t.getAttribute("name")),this.isP2P?this._signalingLayer.setSSRCOwner(n,St.Strophe.getResourceFromJid(this.remoteJid),i):_t()(t).find(\'>ssrc-info[xmlns="http://jitsi.org/jitmeet"]\').each(((e,t)=>{const r=t.getAttribute("owner");var o;null!=r&&r.length&&(isNaN(n)||n<0?ca.warn(`${this} Invalid SSRC ${n} value received for ${r}`):this._signalingLayer.setSSRCOwner(n,(o=r,St.Strophe.getResourceFromJid(o)||o),i))}))}))}acceptOffer(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];this.setOfferAnswerCycle(e,(()=>{this.sendSessionAccept((()=>{ca.debug(`${this} Resuming the modification queue after session is established!`),this.modificationQueue.resume(),t(),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT,this);const e=i.filter((e=>e.getType()===Ri.VIDEO));e.length&&e.splice(0,1),e.length&&this.addTracks(e)}),(e=>{n(e),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT_ERROR,this,e)}))}),n,i)}invite(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];if(!this.isInitiator)throw new Error("Trying to invite from the responder session");ca.debug(`${this} Executing invite task`);const t=[];for(const n of e)t.push(this.peerconnection.addTrack(n,this.isInitiator));Promise.all(t).then((()=>this.peerconnection.createOffer(this.mediaConstraints))).then((e=>this.peerconnection.setLocalDescription(e))).then((()=>{this.peerconnection.processLocalSdpForTransceiverInfo(e),this.sendSessionInitiate(this.peerconnection.localDescription.sdp)})).then((()=>{ca.debug(`${this} invite executed - OK`)})).catch((e=>{ca.error(`${this} invite error`,e)}))}sendSessionInitiate(e){let t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-initiate",initiator:this.initiatorJid,sid:this.sid});new Ms(e).toJingle(t,this.isInitiator?"initiator":"responder"),t=t.tree(),ca.debug(`${this} Session-initiate: `,t),this.connection.sendIQ(t,(()=>{ca.info(`${this} Got RESULT for "session-initiate"`)}),(e=>{ca.error(`${this} "session-initiate" error`,e)}),la)}setAnswer(e){if(!this.isInitiator)throw new Error("Trying to set an answer on the responder session");ca.debug(`${this} Executing setAnswer task`);const t=this._processNewJingleOfferIq(e),n=new Ms(this.peerconnection.localDescription.sdp),i=new RTCSessionDescription({type:"answer",sdp:t.raw});this.peerconnection.setRemoteDescription(i).then((()=>{if(this.state===na){this.state=ia,ca.debug(`${this} Resuming the modification queue after session is established!`),this.modificationQueue.resume();const e=new Ms(this.peerconnection.localDescription.sdp);this.sendContentModify(),this.notifyMySSRCUpdate(n,e)}})).then((()=>{ca.debug(`${this} setAnswer task done`)})).catch((e=>{ca.error(`${this} setAnswer task failed: ${e}`)}))}setOfferAnswerCycle(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:[];ca.debug(`${this} Executing setOfferAnswerCycle task`);const r=[],o=i.filter((e=>e.getType()===Ri.AUDIO)),s=i.filter((e=>e.getType()===Ri.VIDEO));let a=i;s.length>1&&(a=[...o,s[0]]);for(const e of a)r.push(this.peerconnection.addTrack(e,this.isInitiator));const d=this._processNewJingleOfferIq(e),c=_t()(e).find(\'>bridge-session[xmlns="http://jitsi.org/protocol/focus"]\').attr("id");c!==this._bridgeSessionId&&(this._bridgeSessionId=c),Promise.all(r).then((()=>this._renegotiate(d.raw))).then((()=>{this.peerconnection.processLocalSdpForTransceiverInfo(a),this.state===na&&(this.state=ia,!this.isP2P||this._localSendReceiveVideoActive&&!this._sourceReceiverConstraints||this.sendContentModify())})).then((()=>{ca.debug(`${this} setOfferAnswerCycle task done`),t()})).catch((e=>{ca.error(`${this} setOfferAnswerCycle task failed: ${e}`),n(e)}))}setVideoCodecs(e){if(this._assertNotEnded()){ca.info(`${this} setVideoCodecs: ${e}`),this.peerconnection.setVideoCodecs(e);const t=e=>{this._renegotiate().then((()=>this.peerconnection.configureVideoSenderEncodings())).then((()=>(ca.debug(`${this} setVideoCodecs task is done`),e())),(t=>(ca.error(`${this} setVideoCodecs task failed: ${t}`),e(t))))};ca.debug(`${this} Queued setVideoCodecs task`),this.modificationQueue.push(t)}}replaceTransport(e,t,n){if(this.options.enableForcedReload){const e=new Ms(this.peerconnection.localDescription.sdp);return this.sendTransportAccept(e,t,n),void this.room.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_RESTARTED,this)}this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_RESTARTING,this);const i=e.clone();e.find(">content[name=\'data\']").attr("senders","rejected"),e.find(">content>description>source").remove(),e.find(">content>description>ssrc-group").remove();const r=e.find(">content>transport>fingerprint");r.attr("hash","sha-1"),r.text("00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00"),ca.debug(`${this} Queued ICE restart task`),this.modificationQueue.push((r=>{this.setOfferAnswerCycle(e,(()=>{this.setOfferAnswerCycle(i,(()=>{const e=new Ms(this.peerconnection.localDescription.sdp);"number"==typeof this.options.channelLastN&&this.options.channelLastN>=0&&(e.initialLastN=this.options.channelLastN),this.sendTransportAccept(e,t,n),this.room.eventEmitter.emit(Hi.XMPPEvents.ICE_RESTART_SUCCESS,this,i),r()}),(e=>r(e)))}),(e=>r(e)))}),(e=>{if(e){if(e instanceof Zs)return ca.debug(`${this} ICE restart task aborted: session terminated`),void t();ca.error(`${this} ICE restart task failed: ${e}`),n(e)}else ca.debug(`${this} ICE restart task done`),t()}))}sendSessionAccept(e,t){const n=new Ms(this.peerconnection.localDescription.sdp),i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-accept",initiator:this.initiatorJid,responder:this.responderJid,sid:this.sid});this.webrtcIceTcpDisable&&(n.removeTcpCandidates=!0),this.webrtcIceUdpDisable&&(n.removeUdpCandidates=!0),this.failICE&&(n.failICE=!0),"number"==typeof this.options.channelLastN&&this.options.channelLastN>=0&&(n.initialLastN=this.options.channelLastN),n.toJingle(i,this.initiatorJid===this.localJid?"initiator":"responder"),ca.info(`${this} Sending session-accept`),ca.debug(i.tree()),this.connection.sendIQ(i,e,this.newJingleErrorHandler(i,(e=>{t(e),this.room.eventEmitter.emit(Hi.XMPPEvents.SESSION_ACCEPT_TIMEOUT,this)})),la)}sendContentModify(){const e=this._localSendReceiveVideoActive?"both":"none",t=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"content-modify",initiator:this.initiatorJid,sid:this.sid}).c("content",{name:Ri.VIDEO,senders:e});void 0!==this._sourceReceiverConstraints&&this._sourceReceiverConstraints.forEach(((e,n)=>{t.c("source-frame-height",{xmlns:"http://jitsi.org/jitmeet/video"}).attrs({sourceName:n,maxHeight:e}),t.up(),ca.info(`${this} sending content-modify for source-name: ${n}, maxHeight: ${e}`)})),ca.debug(t.tree()),this.connection.sendIQ(t,null,this.newJingleErrorHandler(t),la)}setReceiverVideoConstraint(e){ca.info(`${this} setReceiverVideoConstraint - constraints: ${JSON.stringify(e)}`),this._sourceReceiverConstraints=e,this.isP2P&&this.state===ia&&this.sendContentModify()}sendTransportAccept(e,t,n){const i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-accept",initiator:this.initiatorJid,sid:this.sid});e.media.forEach(((t,n)=>{const r=Ns.parseMLine(t.split("\\r\\n")[0]);i.c("content",{creator:this.initiatorJid===this.localJid?"initiator":"responder",name:r.media}),e.transportToJingle(n,i),i.up()})),ca.info(`${this} Sending transport-accept`),ca.debug(i.tree()),this.connection.sendIQ(i,t,this.newJingleErrorHandler(i,n),la)}sendTransportReject(e,t){const n=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"transport-reject",initiator:this.initiatorJid,sid:this.sid});ca.info(`${this} Sending \'transport-reject\'`),ca.debug(n.tree()),this.connection.sendIQ(n,e,this.newJingleErrorHandler(n,t),la)}setSenderVideoConstraint(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(this._assertNotEnded()){ca.info(`${this} setSenderVideoConstraint: ${e}, sourceName: ${t}`);const n=t?this.rtc.getLocalVideoTracks().find((e=>e.getSourceName()===t)):this.rtc.getLocalVideoTrack();return this.peerconnection.setSenderVideoConstraints(e,n)}return Promise.resolve()}terminate(e,t,n){if(this.state!==ra){if(!n||Boolean(n.sendSessionTerminate)){const i=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"session-terminate",initiator:this.initiatorJid,sid:this.sid}).c("reason").c(n&&n.reason||"success").up();n&&n.reasonDescription?i.c("text").t(n.reasonDescription).up().up():i.up(),this._bridgeSessionId&&i.c("bridge-session",{xmlns:"http://jitsi.org/protocol/focus",id:this._bridgeSessionId,restart:n&&!0===n.requestRestart}).up(),ca.info(`${this} Sending session-terminate`),ca.debug(i.tree()),this.connection.sendIQ(i,e,this.newJingleErrorHandler(i,t),la)}else ca.info(`${this} Skipped sending session-terminate`);this.connection.jingle.terminate(this.sid)}}onTerminated(e,t){ca.info(`${this} Session terminated`,e,t),this._xmppListeners.forEach((e=>e())),this._xmppListeners=[],this._removeSenderVideoConstraintsChangeListener&&this._removeSenderVideoConstraintsChangeListener(),Ai.isSsrcRewritingSupported()&&this.peerconnection&&this.peerconnection.getRemoteTracks().forEach((e=>{this.room.eventEmitter.emit(bt.TRACK_REMOVED,e)})),this.close()}onXmppStatusChanged(e){e===Lo.Status.CONNECTED&&this._cachedOldLocalSdp&&(ca.info(`${this} Sending SSRC update on reconnect`),this.notifyMySSRCUpdate(this._cachedOldLocalSdp,this._cachedNewLocalSdp))}_parseSsrcInfoFromSourceAdd(e,t){const n=[],i=this;return _t()(e).each(((e,r)=>{const o=_t()(r).attr("name");let s="";_t()(r).find(\'ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=this.getAttribute("semantics"),t=_t()(this).find(">source").map((function(){return this.getAttribute("ssrc")})).get();t.length&&(s+=`a=ssrc-group:${e} ${t.join(" ")}\\r\\n`)})),_t()(r).find(\'source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=_t()(this).attr("ssrc");t.containsSSRC(e)?!i.isP2P&&ca.warn(`${i} Source-add request for existing SSRC: ${e}`):_t()(this).find(">parameter").each((function(){s+=`a=ssrc:${e} ${_t()(this).attr("name")}`,_t()(this).attr("value")&&_t()(this).attr("value").length&&(s+=`:${_t()(this).attr("value")}`),s+="\\r\\n"}))}));let a=!1;t.media.forEach(((e,t)=>{Ns.findLine(e,`a=mid:${o}`)&&(n[t]||(n[t]=""),n[t]+=s,a=!0)})),!a&&this.isP2P&&(n[o]=s)})),n}addRemoteStream(e){this._addOrRemoveRemoteStream(!0,e)}removeRemoteStream(e){this._addOrRemoveRemoteStream(!1,e)}processSourceMap(e,t){if(!Ai.isSsrcRewritingSupported())return;const n=[];for(const i of e.mappedSources){const{owner:e,source:r,ssrc:o}=i;if(this.peerconnection.addRemoteSsrc(o,r)){n.push(i),ca.debug(`New SSRC signaled ${o}: owner=${e}, source-name=${r}`);const t=this.peerconnection.remoteSources.get(r);if(t){this._signalingLayer.removeSSRCOwners([t]);const e=this.peerconnection.getTrackBySSRC(t);e&&(e.setSourceName(void 0),e.setOwner(void 0),e._setVideoType(void 0))}}else{ca.debug(`Existing SSRC re-mapped ${o}: new owner=${e}, source-name=${r}`);const n=this.peerconnection.getTrackBySSRC(o);this._signalingLayer.setSSRCOwner(o,e,r),n.setSourceName(r),n.setOwner(e);const i=this._signalingLayer.getPeerMediaInfo(e,t,r);i&&(n._setVideoType(i.videoType),this.peerconnection._sourceMutedChanged(r,i.muted))}}if(n.length){let e=(0,St.$build)("content",{xmlns:"urn:xmpp:jingle:1",name:t}).c("description",{xmlns:"urn:xmpp:jingle:apps:rtp:1",media:t});for(const i of n){const{rtx:n,ssrc:r,source:o}=i;let s;if(t===Ri.VIDEO){const t=++this.numRemoteVideoSources;s=`remote-video-${t} remote-video-${t}`,"-1"!==n&&(ha(e,i,n,s),e.c("ssrc-group",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",semantics:"FID"}).c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:r}).up().c("source",{xmlns:"urn:xmpp:jingle:apps:rtp:ssma:0",ssrc:n}).up().up())}else{const e=++this.numRemoteAudioSources;s=`remote-audio-${e} remote-audio-${e}`}ha(e,i,r,s),this.peerconnection.remoteSources.set(o,r)}e=e.up(),this._addOrRemoveRemoteStream(!0,e.node)}}removeRemoteStreamsOnLeave(e){ca.debug(`${this} Queued removeRemoteStreamsOnLeave task for participant ${e}`),this.modificationQueue.push((t=>{const n=this.peerconnection.getRemoteSourceInfoByParticipant(e);if(n.length){const e=this._processRemoteRemoveSource(n);this._renegotiate(e.raw).then((()=>t()),(e=>t(e)))}else t()}),(e=>{e?ca.error(`${this} removeRemoteStreamsOnLeave error:`,e):ca.info(`${this} removeRemoteStreamsOnLeave done!`)}))}_addOrRemoveRemoteStream(e,t){const n=e?"addRemoteStream":"removeRemoteStream";e&&this.readSsrcInfo(t),ca.debug(`${this} Queued ${n} task`),this.modificationQueue.push((i=>{if(!this.peerconnection.localDescription||!this.peerconnection.localDescription.sdp){const e=`${n} - localDescription not ready yet`;return ca.error(e),void i(e)}ca.log(`${this} Processing ${n}`);const r=new Ms(this.peerconnection.remoteDescription.sdp),o=e?this._parseSsrcInfoFromSourceAdd(t,r):this._parseSsrcInfoFromSourceRemove(t,r),s=e?this._processRemoteAddSource(o):this._processRemoteRemoveSource(o);this._renegotiate(s.raw).then((()=>{ca.log(`${this} ${n} - OK`),i()}),(e=>{ca.error(`${this} ${n} failed:`,e),i(e)}))}))}_processNewJingleOfferIq(e){const t=new Ms("");return this.webrtcIceTcpDisable&&(t.removeTcpCandidates=!0),this.webrtcIceUdpDisable&&(t.removeUdpCandidates=!0),this.failICE&&(t.failICE=!0),t.fromJingle(e),this.readSsrcInfo(_t()(e).find(">content")),t}_processRemoteRemoveSource(e){var t;const n=new Ms(this.peerconnection.peerconnection.remoteDescription.sdp);let i;return e.forEach((e=>{let t;(e=e.split("\\r\\n")).pop(),i=e.map((e=>{var t;return Number(null===(t=e.split("a=ssrc:")[1])||void 0===t?void 0:t.split(" ")[0])})),e.forEach((e=>{if(t=n.media.findIndex((t=>t.includes(e))),t>-1)if(n.media[t]=n.media[t].replace(`${e}\\r\\n`,""),this.isP2P){var i;const e=null===(i=Ns.parseMLine(n.media[t].split("\\r\\n")[0]))||void 0===i?void 0:i.media,r=this.peerconnection.getDesiredMediaDirection(e,!1);[As.SENDRECV,As.SENDONLY].forEach((e=>{n.media[t]=n.media[t].replace(`a=${e}`,`a=${r}`)}))}else{n.media[t]=n.media[t].replace(`a=${As.SENDONLY}`,`a=${As.INACTIVE}`);const{media:e,port:i}=Ns.parseMLine(n.media[t].split("\\r\\n")[0]);n.media[t]=n.media[t].replace(`m=${e} ${i}`,`m=${e} 0`)}}))})),(null===(t=i)||void 0===t?void 0:t.length)&&this._signalingLayer.removeSSRCOwners(i),n.raw=n.session+n.media.join(""),n}_processRemoteAddSource(e){let t=new Ms(this.peerconnection.remoteDescription.sdp);return e.length>t.media.length&&this.isP2P&&(t.addMlineForNewLocalSource(Ri.VIDEO),t=new Ms(t.raw)),e.forEach(((e,n)=>{if(t.media[n]+=e,this.isP2P){var i;const e=null===(i=Ns.parseMLine(t.media[n].split("\\r\\n")[0]))||void 0===i?void 0:i.media,r=this.peerconnection.getDesiredMediaDirection(e,!0);[As.RECVONLY,As.INACTIVE].forEach((e=>{t.media[n]=t.media[n].replace(`a=${e}`,`a=${r}`)}))}})),t.raw=t.session+t.media.join(""),t}_renegotiate(e){if("closed"===this.peerconnection.signalingState){const e=new Error("Attempted to renegotiate in state closed");return this.room.eventEmitter.emit(Hi.XMPPEvents.RENEGOTIATION_FAILED,e,this),Promise.reject(e)}const t=e||this.peerconnection.remoteDescription.sdp;if(!t){const e=new Error(`Can not renegotiate without remote description, current state: ${this.state}`);return this.room.eventEmitter.emit(Hi.XMPPEvents.RENEGOTIATION_FAILED,e,this),Promise.reject(e)}const n=new RTCSessionDescription({type:"offer",sdp:t}),i=this.peerconnection.localDescription.sdp;return ca.debug(`${this} Renegotiate: setting remote description`),this.peerconnection.setRemoteDescription(n).then((()=>(ca.debug(`${this} Renegotiate: creating answer`),this.peerconnection.createAnswer(this.mediaConstraints)))).then((e=>(ca.debug(`${this} Renegotiate: setting local description`),this.peerconnection.setLocalDescription(e)))).then((()=>{i&&this.notifyMySSRCUpdate(new Ms(i),new Ms(this.peerconnection.localDescription.sdp))}))}addTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(null!=e&&e.length||Promise.reject(new Error("No tracks passed")),e.find((e=>e.getType()!==Ri.VIDEO)))return Promise.reject(new Error("Multiple tracks of the given media type are not supported"));const t=[],n=n=>{const i=new Ms(this.peerconnection.peerconnection.remoteDescription.sdp),r=this.peerconnection.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===Ri.VIDEO&&e.direction===As.RECVONLY&&e.currentDirection===As.RECVONLY));for(const t of e)this.isP2P&&r||i.addMlineForNewLocalSource(t.getType());this._renegotiate(i.raw).then((()=>{for(const n of e)t.push(this.peerconnection.replaceTrack(null,n));return Promise.all(t)})).then((()=>this._renegotiate())).then((()=>n()),(e=>n(e)))};return new Promise(((e,t)=>{ca.debug(`${this} Queued renegotiation after addTrack`),this.modificationQueue.push(n,(n=>{if(n){if(n instanceof Zs)return ca.debug(`${this} renegotiation after addTrack aborted: session terminated`),void e();ca.error(`${this} renegotiation after addTrack error`,n),t(n)}else ca.debug(`${this} renegotiation after addTrack executed - OK`),e()}))}))}setMediaTransferActive(e){return this.peerconnection.audioTransferActive!==e||this.peerconnection.videoTransferActive!==e?this.peerconnection.tpcUtils.setMediaTransferActive(e).then((()=>{this.peerconnection.audioTransferActive=e,this.peerconnection.videoTransferActive=e;const t=[];return t.push(this.peerconnection.configureVideoSenderEncodings()),t.push(this.peerconnection.configureAudioSenderEncodings()),Promise.allSettled(t)})):Promise.resolve()}replaceTrack(e,t){const n=n=>{ca.debug(`${this} replaceTrack worker started. oldTrack = ${e}, newTrack = ${t}`),this.peerconnection.replaceTrack(e,t).then((n=>{let i=Promise.resolve();return ca.debug(`${this} TPC.replaceTrack finished. shouldRenegotiate = ${n}, JingleSessionState = ${this.state}`),n&&(e||t)&&this.state===ia&&(i=this._renegotiate()),i.then((()=>{e&&t&&e.isVideoTrack()&&t.setSourceName(e.getSourceName())}))})).then((()=>n()),(e=>n(e)))};return new Promise(((i,r)=>{ca.debug(`${this} Queued replaceTrack task. Old track = ${e}, new track = ${t}`),this.modificationQueue.push(n,(e=>{if(e){if(e instanceof Zs)return ca.debug("Replace track aborted: session terminated"),void i();ca.error(`${this} Replace track error:`,e),r(e)}else ca.info(`${this}  Replace track done!`),i()}))}))}_parseSsrcInfoFromSourceRemove(e,t){const n=[];return _t()(e).each(((e,i)=>{const r=_t()(i).attr("name");let o="";_t()(i).find(\'ssrc-group[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=this.getAttribute("semantics"),t=_t()(this).find(">source").map((function(){return this.getAttribute("ssrc")})).get();t.length&&(o+=`a=ssrc-group:${e} ${t.join(" ")}\\r\\n`)}));const s=[];_t()(i).find(\'source[xmlns="urn:xmpp:jingle:apps:rtp:ssma:0"]\').each((function(){const e=_t()(this).attr("ssrc");s.push(e)})),t.media.forEach(((e,t)=>{Ns.findLine(e,`a=mid:${r}`)&&(n[t]||(n[t]=""),s.forEach((i=>{const r=Ns.findLines(e,`a=ssrc:${i}`);r.length&&(n[t]+=`${r.join("\\r\\n")}\\r\\n`)})),n[t]+=o)}))})),n}addTrackToPc(e){return this._addRemoveTrack(!1,e).then((()=>{if(e.isVideoTrack())return this.peerconnection.configureVideoSenderEncodings(e)}))}removeTrackFromPc(e){return this._addRemoveTrack(!0,e)}_addRemoveTrack(e,t){if(!t)return Promise.reject(\'invalid "track" argument value\');const n=e?"removeTrack":"addTrack",i=i=>{const r=this.peerconnection;r?(e?r.removeTrackFromPc(t):r.addTrackToPc(t)).then((e=>{e?this._renegotiate().then(i):i()}),i):i(`Error:  tried ${n} track with no active peer connection`)};return ca.debug(`${this} Queued ${n} task`),new Promise(((e,t)=>{this.modificationQueue.push(i,(i=>{if(i){if(i instanceof Zs)return ca.debug(`${this} ${n} aborted: session terminated`),void e();ca.error(`${this} ${n} failed`),t(i)}else ca.debug(`${this} ${n} done`),e()}))}))}setP2pVideoTransferActive(e){return this.peerconnection?this._localSendReceiveVideoActive!==e?(this._localSendReceiveVideoActive=e,this.isP2P&&this.state===ia&&this.sendContentModify(),this.peerconnection.setVideoTransferActive(this._localSendReceiveVideoActive&&this._remoteSendReceiveVideoActive)):Promise.resolve():Promise.reject(\'Can not modify video transfer active state, before "initialize" is called\')}modifyContents(e){const t=ua.parseVideoSenders(e),n=ua.parseSourceMaxFrameHeight(e);if(n&&(this.remoteSourceMaxFrameHeights=n,this.eventEmitter.emit(da.REMOTE_SOURCE_CONSTRAINTS_CHANGED,this,n)),null===t)return void ca.error(`${this} - failed to parse video "senders" attribute in "content-modify" action`);if(!this._assertNotEnded())return;const i="both"===t||"initiator"===t&&this.isInitiator||"responder"===t&&!this.isInitiator;i!==this._remoteSendReceiveVideoActive&&(ca.debug(`${this} new remote video active: ${i}`),this._remoteSendReceiveVideoActive=i,this.peerconnection.setVideoTransferActive(this._localSendReceiveVideoActive&&this._remoteSendReceiveVideoActive))}notifyMySSRCUpdate(e,t){if(this.state!==ia)return void ca.warn(`${this} Skipping SSRC update in \'${this.state} \' state.`);if(!this.connection.connected)return this._cachedOldLocalSdp||(this._cachedOldLocalSdp=e),this._cachedNewLocalSdp=t,void ca.warn(`${this} Not sending SSRC update while the signaling is disconnected`);this._cachedOldLocalSdp=void 0,this._cachedNewLocalSdp=void 0;const n=e=>{const t=e.getNewMedia();let n=[],i=null;return Object.keys(t).forEach((e=>{const r=Object.keys(t[e].ssrcs);i=t[e].mid,null!=r&&r.length&&(n=n.concat(r))})),{mediaType:i,ssrcs:n}};let i=new Fs(t,e);const r=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"source-remove",initiator:this.initiatorJid,sid:this.sid});i.toJingle(r);const o={},s=n(i);s.ssrcs.length&&(ca.info(`${this} Sending source-remove for ${s.mediaType} ssrcs=${s.ssrcs}`),this.connection.sendIQ(r,(()=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_REMOVE,this,o)}),this.newJingleErrorHandler(r,(e=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_REMOVE_ERROR,this,e,o)})),la)),i=new Fs(e,t);const a=(0,St.$iq)({to:this.remoteJid,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:"source-add",initiator:this.initiatorJid,sid:this.sid});i.toJingle(a);const d=n(i);d.ssrcs.length&&(ca.info(`${this} Sending source-add for ${d.mediaType} ssrcs=${d.ssrcs}`),this.connection.sendIQ(a,(()=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_ADD,this,o)}),this.newJingleErrorHandler(a,(e=>{this.room.eventEmitter.emit(Hi.XMPPEvents.SOURCE_ADD_ERROR,this,e,d.mediaType,o)})),la))}newJingleErrorHandler(e,t){return e=>{const n={},i=_t()(e).find("error");if(i.length){n.code=i.attr("code");const t=_t()(e).find("error :first");t.length&&(n.reason=t[0].tagName);const r=i.find(">text");r.length&&(n.msg=r.text())}e||(n.reason="timeout"),n.session=this.toString(),t?t(n):this.state===ra&&"item-not-found"===n.reason?ca.debug(`${this} Jingle error: ${JSON.stringify(n)}`):ca.error(`Jingle error: ${JSON.stringify(n)}`)}}getIceConnectionState(){return this.peerconnection.getConnectionState()}close(){this.state=ra,this.establishmentDuration=void 0,this.peerconnection&&(this.peerconnection.onicecandidate=null,this.peerconnection.oniceconnectionstatechange=null,this.peerconnection.onnegotiationneeded=null,this.peerconnection.onsignalingstatechange=null),ca.debug(`${this} Clearing modificationQueue`),this.modificationQueue.clear(),ca.debug(`${this} Queued PC close task`),this.modificationQueue.push((e=>{this.peerconnection&&this.peerconnection.close(),e(),ca.debug(`${this} PC close task done!`)})),ca.debug(`${this} Shutdown modificationQueue!`),this.modificationQueue.shutdown()}toString(){return`JingleSessionPC[session=${this.isP2P?"P2P":"JVB"},initiator=${this.isInitiator},sid=${this.sid}]`}}const pa=(0,y.getLogger)("modules/xmpp/strophe.jingle.js");function ma(e){const t=_t()(e).find(">candidate"),n=[];return t.each(((e,t)=>{const i=t.attributes,r=[];for(let e=0;e<i.length;e++){const t=i[e];r.push(`${t.name}: ${t.value}`)}n.push(r.join(" "))})),n}class ga extends Do{constructor(e,t,n){super(),this.xmpp=e,this.eventEmitter=t,this.sessions={},this.jvbIceConfig=n.jvb,this.p2pIceConfig=n.p2p,this.mediaConstraints={offerToReceiveAudio:!0,offerToReceiveVideo:!0}}init(e){super.init(e),this.connection.addHandler(this.onJingle.bind(this),"urn:xmpp:jingle:1","iq","set",null,null)}onJingle(e){const t=_t()(e).find("jingle").attr("sid"),n=_t()(e).find("jingle").attr("action"),i=e.getAttribute("from"),r=(0,St.$iq)({type:"result",to:i,id:e.getAttribute("id")});let o=this.sessions[t];if("session-initiate"!==n){if(!o)return r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("item-not-found",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up().c("unknown-session",{xmlns:"urn:xmpp:jingle:errors:1"}),pa.warn(`invalid session id: ${t}`),pa.debug(e),this.connection.send(r),!0;if(i!==o.remoteJid)return pa.warn("jid mismatch for session id",t,o.remoteJid,e),r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("item-not-found",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up().c("unknown-session",{xmlns:"urn:xmpp:jingle:errors:1"}),this.connection.send(r),!0}else if(void 0!==o)return r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("service-unavailable",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up(),pa.warn("duplicate session id",t,e),this.connection.send(r),!0;const s=window.performance.now(),a="focus"!==St.Strophe.getResourceFromJid(i),d=_t()(e).find("jingle>json-message");if(null!=d&&d.length){var c;let t;pa.info(`Found a JSON-encoded element in ${n}, translating to standard Jingle.`);for(let n=0;n<d.length;n++)t=Rs(e,d[n]);if(null!==(c=t)&&void 0!==c&&c.size){const e=[];for(const n of t.keys())e.push(`${n}:[${t.get(n)}]`);pa.debug(`Received ${n} from ${i} with sources=${e.join(", ")}`)}}switch(n){case"session-initiate":{pa.log("(TIME) received session-initiate:\\t",s);const t=_t()(e).find("jingle>startmuted");if(a&&pa.debug(`Received ${n} from ${i}`),null!=t&&t.length){const e=t.attr(Ri.AUDIO),n=t.attr(Ri.VIDEO);this.eventEmitter.emit(Hi.XMPPEvents.START_MUTED_FROM_FOCUS,"true"===e,"true"===n)}const r=a?this.p2pIceConfig:this.jvbIceConfig;o=new ua(_t()(e).find("jingle").attr("sid"),_t()(e).attr("to"),i,this.connection,this.mediaConstraints,Ss()(r),a,!1),this.sessions[o.sid]=o,this.eventEmitter.emit(Hi.XMPPEvents.CALL_INCOMING,o,_t()(e).find(">jingle"),s);break}case"session-accept":{const t=[],r=_t()(e).find("jingle>content");for(const e of r){const n=_t()(e).find("description").attr("ssrc");n&&t.push(n)}pa.debug(`Received ${n} from ${i} with ssrcs=${t}`),this.eventEmitter.emit(Hi.XMPPEvents.CALL_ACCEPTED,o,_t()(e).find(">jingle"));break}case"content-modify":pa.debug(`Received ${n} from ${i}`),o.modifyContents(_t()(e).find(">jingle"));break;case"transport-info":{const t=ma(_t()(e).find("jingle>content>transport"));pa.debug(`Received ${n} from ${i} for candidates=${t.join(", ")}`),this.eventEmitter.emit(Hi.XMPPEvents.TRANSPORT_INFO,o,_t()(e).find(">jingle"));break}case"session-terminate":{pa.log("terminating...",o.sid);let t=null,r=null;_t()(e).find(">jingle>reason").length&&(t=_t()(e).find(">jingle>reason>:first")[0].tagName,r=_t()(e).find(">jingle>reason>text").text()),pa.debug(`Received ${n} from ${i} disconnect reason=${r}`),this.terminate(o.sid,t,r),this.eventEmitter.emit(Hi.XMPPEvents.CALL_ENDED,o,t,r);break}case"transport-replace":{var l;pa.info("(TIME) Start transport replace:\\t",s);const t=_t()(e).find("jingle>content>transport"),r=ma(t),d=_t()(t).attr("ufrag"),c=_t()(t).attr("pwd"),h=null===(l=_t()(t).find(">fingerprint"))||void 0===l?void 0:l.text();pa.debug(`Received ${n} from ${i} with iceUfrag=${d}, icePwd=${c}, DTLS fingerprint=${h}, candidates=${r.join(", ")}`),Mi.sendAnalytics(dn(Jt,{p2p:a,value:s})),o.replaceTransport(_t()(e).find(">jingle"),(()=>{const e=window.performance.now();pa.info("(TIME) Transport replace success:\\t",e),Mi.sendAnalytics(dn(Bt,{p2p:a,value:e}))}),(e=>{pa.error("Transport replace failed",e),o.sendTransportReject()}));break}case"source-add":o.addRemoteStream(_t()(e).find(">jingle>content"));break;case"source-remove":o.removeRemoteStream(_t()(e).find(">jingle>content"));break;default:pa.warn("jingle action not implemented",n),r.attrs({type:"error"}),r.c("error",{type:"cancel"}).c("bad-request",{xmlns:"urn:ietf:params:xml:ns:xmpp-stanzas"}).up()}return this.connection.send(r),!0}newP2PJingleSession(e,t){const n=new ua(co().randomHexString(12),e,t,this.connection,this.mediaConstraints,this.p2pIceConfig,!0,!0);return this.sessions[n.sid]=n,n}terminate(e,t,n){this.sessions.hasOwnProperty(e)&&("ended"!==this.sessions[e].state&&this.sessions[e].onTerminated(t,n),delete this.sessions[e])}getStunAndTurnCredentials(){this.connection.sendIQ((0,St.$iq)({type:"get",to:this.xmpp.options.hosts.domain}).c("services",{xmlns:"urn:xmpp:extdisco:2"}),(e=>this.onReceiveStunAndTurnCredentials(e)),(()=>{pa.warn("getting turn credentials with extdisco:2 failed, trying extdisco:1"),this.connection.sendIQ((0,St.$iq)({type:"get",to:this.xmpp.options.hosts.domain}).c("services",{xmlns:"urn:xmpp:extdisco:1"}),(e=>this.onReceiveStunAndTurnCredentials(e)),(()=>{pa.warn("getting turn credentials failed"),pa.warn("is mod_turncredentials or similar installed and configured?")}))}))}onReceiveStunAndTurnCredentials(e){let t=[];_t()(e).find(">services>service").each(((e,n)=>{const i={},r=(n=_t()(n)).attr("type");switch(r){case"stun":i.urls=`stun:${n.attr("host")}`,n.attr("port")&&(i.urls+=`:${n.attr("port")}`),t.push(i);break;case"turn":case"turns":{i.urls=`${r}:`,i.username=n.attr("username"),i.urls+=n.attr("host");const e=n.attr("port");e&&(i.urls+=`:${e}`);const o=n.attr("transport");o&&"udp"!==o&&(i.urls+=`?transport=${o}`),i.credential=n.attr("password")||i.credential,t.push(i);break}}}));const n=this.xmpp.options,{iceServersOverride:i=[]}=n;i.forEach((e=>{let{targetType:n,urls:i,username:r,credential:o}=e;if(!["turn","turns","stun"].includes(n))return;const s=`${n}:`;void 0===i&&void 0===r&&void 0===o||(null===i&&(t=t.filter((e=>!e.urls.startsWith(s)))),t.forEach((e=>{e.urls.startsWith(s)&&(e.urls=null!=i?i:e.urls,null===r?delete e.username:e.username=null!=r?r:e.username,null===o?delete e.credential:e.credential=null!=o?o:e.credential)})))}));for(let e=t.length-1;e>0;e--){const n=Math.floor(Math.random()*(e+1)),i=t[e];t[e]=t[n],t[n]=i}let r;return r=n.useTurnUdp?e=>e.urls.startsWith("turn"):e=>e.urls.startsWith("turn")&&e.urls.indexOf("transport=tcp")>=0,this.jvbIceConfig.iceServers=t.filter(r),this.p2pIceConfig.iceServers=t,t.length>0}getLog(){const e={};return Object.keys(this.sessions).forEach((t=>{const n=this.sessions[t].peerconnection;n&&n.updateLog&&(e[`jingle_${t}`]={updateLog:n.updateLog,stats:n.stats,url:window.location.href})})),e}}class fa extends Do{constructor(){super(),this.log=[]}init(e){super.init(e),this.connection.rawInput=this.logIncoming.bind(this),this.connection.rawOutput=this.logOutgoing.bind(this)}logIncoming(e){this.log.push([(new Date).getTime(),"incoming",e])}logOutgoing(e){this.log.push([(new Date).getTime(),"outgoing",e])}}const va=(0,y.getLogger)("modules/xmpp/strophe.rayo.js"),_a="urn:xmpp:rayo:1";class Ea extends Do{init(e){super.init(e),this.connection.addHandler(this.onRayo.bind(this),_a,"iq","set",null,null)}onRayo(e){va.info("Rayo IQ",e)}dial(e,t,n,i,r){return new Promise(((o,s)=>{if(!r)return void s(new Error("Internal error!"));const a=(0,St.$iq)({type:"set",to:r});a.c("dial",{xmlns:_a,to:e,from:t}),a.c("header",{name:"JvbRoomName",value:n}).up(),i&&i.length&&a.c("header",{name:"JvbRoomPassword",value:i}).up(),this.connection.sendIQ(a,(e=>{va.info("Dial result ",e);const t=_t()(e).find("ref").attr("uri");this.callResource=t.substr("xmpp:".length),va.info(`Received call resource: ${this.callResource}`),o()}),(e=>{va.info("Dial error ",e),s(e)}))}))}hangup(){return new Promise(((e,t)=>{if(!this.callResource)return t(new Error("No call in progress")),void va.warn("No call in progress");const n=(0,St.$iq)({type:"set",to:this.callResource});n.c("hangup",{xmlns:_a}),this.connection.sendIQ(n,(t=>{va.info("Hangup result ",t),this.callResource=null,e()}),(e=>{va.info("Hangup error ",e),this.callResource=null,t(new Error("Hangup error "))}))}))}}const ya=(0,y.getLogger)("modules/xmpp/strophe.util.js");let Sa=-1;const ba=/request id \\d+.\\d+ got 200/,Ta=/request errored, status: (\\d+), number of errors: \\d+/,Ca=(0,y.getLogger)("modules/xmpp/xmpp.js"),xa=/<failure.*><not-allowed\\/><text>(.*)<\\/text><\\/failure>/gi;const Ra=[{urls:"stun:meet-jit-si-turnrelay.jitsi.net:443"}],Aa="type",wa="http://jitsi.org/protocol/jigasi",Ia="https://jitsi.org/meet/e2ee";class Pa extends xr{constructor(e,t){if(super(),e.bosh&&!e.serviceUrl)throw new Error(\'The "bosh" option is no longer supported, please use "serviceUrl" instead\');this.connection=null,this.disconnectInProgress=!1,this.connectionTimes={},this.options=e,this.token=t,this.authenticatedUser=!1,this.options.deploymentInfo||(this.options.deploymentInfo={}),this._components=[],St.Strophe.log=function(e,t){switch(ya.trace("Strophe",e,t),"string"==typeof t&&-1!==t.indexOf("Request ")&&-1!==t.indexOf("timed out (secondary), restarting")&&(e=St.Strophe.LogLevel.WARN),e){case St.Strophe.LogLevel.DEBUG:-1!==Sa&&ba.test(t)&&(ya.debug("Reset lastErrorStatus"),Sa=-1);break;case St.Strophe.LogLevel.WARN:ya.warn(`Strophe: ${t}`);const e=Ta.exec(t);e&&2===e.length&&(Sa=parseInt(e[1],10),ya.debug(`lastErrorStatus set to: ${Sa}`));break;case St.Strophe.LogLevel.ERROR:case St.Strophe.LogLevel.FATAL:ya.error(`Strophe: ${t}`,t)}},St.Strophe.getLastErrorStatus=function(){return Sa},St.Strophe.getStatusString=function(e){switch(e){case St.Strophe.Status.BINDREQUIRED:return"BINDREQUIRED";case St.Strophe.Status.ERROR:return"ERROR";case St.Strophe.Status.CONNECTING:return"CONNECTING";case St.Strophe.Status.CONNFAIL:return"CONNFAIL";case St.Strophe.Status.AUTHENTICATING:return"AUTHENTICATING";case St.Strophe.Status.AUTHFAIL:return"AUTHFAIL";case St.Strophe.Status.CONNECTED:return"CONNECTED";case St.Strophe.Status.DISCONNECTED:return"DISCONNECTED";case St.Strophe.Status.DISCONNECTING:return"DISCONNECTING";case St.Strophe.Status.ATTACHED:return"ATTACHED";default:return"unknown"}},St.Strophe.addConnectionPlugin("logger",new fa);const n=e.xmppPing||{};n.domain=e.hosts.domain,this.connection=function(e){let{enableWebsocketResume:t,serviceUrl:n="/http-bind",shard:i,token:r,websocketKeepAlive:o,websocketKeepAliveUrl:s,xmppPing:a}=e;return r&&(n+=`${-1===n.indexOf("?")?"?":"&"}token=${r}`),new Lo({enableWebsocketResume:t,serviceUrl:n,websocketKeepAlive:o,websocketKeepAliveUrl:s,xmppPing:a,shard:i})}({enableWebsocketResume:e.enableWebsocketResume,serviceUrl:e.serviceUrl,token:t,websocketKeepAlive:e.websocketKeepAlive,websocketKeepAliveUrl:e.websocketKeepAliveUrl,xmppPing:n,shard:e.deploymentInfo.shard}),this.moderator=new Ko(this),this.connection.on(Lo.Events.CONN_SHARD_CHANGED,(()=>{const e={shard_changed:!0,suspend_time:this.connection.ping.getPingSuspendTime(),time_since_last_success:this.connection.getTimeSinceLastSuccess()};this.eventEmitter.emit(ur,Sr,void 0,void 0,e)})),this._initStrophePlugins(),this.caps=new bo(this.connection,"https://jitsi.org/jitsi-meet"),this.initFeaturesList(),_t()(window).on((this.options.disableBeforeUnloadHandlers?"":"beforeunload ")+"unload",(e=>{this.disconnect(e).catch((()=>{}))}))}initFeaturesList(){this.caps.addFeature("urn:xmpp:jingle:1"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:1"),this.caps.addFeature("urn:xmpp:jingle:transports:ice-udp:1"),this.caps.addFeature("urn:xmpp:jingle:apps:dtls:0"),this.caps.addFeature("urn:xmpp:jingle:transports:dtls-sctp:1"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:audio"),this.caps.addFeature("urn:xmpp:jingle:apps:rtp:video"),this.caps.addFeature("http://jitsi.org/json-encoded-sources"),!this.options.disableRtx&&ci.supportsRTX()&&this.caps.addFeature("urn:ietf:rfc:4588"),!0===this.options.enableOpusRed&&ci.supportsAudioRed()&&this.caps.addFeature("http://jitsi.org/opus-red"),(void 0===this.options.enableRemb||this.options.enableRemb)&&this.caps.addFeature("http://jitsi.org/remb"),ci.isFirefox()&&ci.isVersionLessThan(115)||void 0!==this.options.enableTcc&&!this.options.enableTcc||this.caps.addFeature("http://jitsi.org/tcc"),this.connection.rayo&&this.caps.addFeature("urn:xmpp:rayo:client:1"),so.isSupported(this.options)&&this.caps.addFeature(Ia,!1,!0),Ca.debug("Source-name signaling is enabled"),this.caps.addFeature("http://jitsi.org/source-name"),Ca.debug("Receiving multiple video streams is enabled"),this.caps.addFeature("http://jitsi.org/receive-multiple-video-streams"),Ai.isSsrcRewritingSupported()&&this.caps.addFeature("http://jitsi.org/ssrc-rewriting-1"),this.caps.addFeature("http://jitsi.org/visitors-1")}getConnection(){return this.connection}connectionHandler(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1?arguments[1]:void 0,n=arguments.length>2?arguments[2]:void 0;const i=window.performance.now(),r=St.Strophe.getStatusString(t).toLowerCase();if(this.connectionTimes[r]=i,Ca.log(`(TIME) Strophe ${r}${n?`[${n}]`:""}:\\t`,i),this.eventEmitter.emit(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,e,t,n),this._maybeSendDeploymentInfoStat(),t===St.Strophe.Status.CONNECTED||t===St.Strophe.Status.ATTACHED)this._sysMessageHandler&&(this.connection._stropheConn.deleteHandler(this._sysMessageHandler),this._sysMessageHandler=null),this.sendDiscoInfo&&this.connection.jingle.getStunAndTurnCredentials(),Ca.info(`My Jabber ID: ${this.connection.jid}`),this._resetState(),this.sendDeploymentInfo=!1,this.sendDiscoInfo&&this.caps.getFeaturesAndIdentities(this.options.hosts.domain).then((e=>{let{features:t,identities:n}=e;t.has(St.Strophe.NS.PING)||Ca.error(`Ping NOT supported by ${this.options.hosts.domain} - please enable ping in your XMPP server config`),this._processDiscoInfoIdentities(n,void 0)})).catch((e=>{Ca.error("Feature discovery error",e),this._maybeSendDeploymentInfoStat(!0)})),this.sendDiscoInfo=!1,e.password&&(this.authenticatedUser=!0),this.connection&&this.connection.connected&&St.Strophe.getResourceFromJid(this.connection.jid)&&this.eventEmitter.emit(hr,St.Strophe.getResourceFromJid(this.connection.jid));else if(t===St.Strophe.Status.CONNFAIL)"x-strophe-bad-non-anon-jid"===n?this.anonymousConnectionFailed=!0:this.connectionFailed=!0,this.lastErrorMsg=n,"giving-up"===n&&this.eventEmitter.emit(ur,Sr,n);else if(t===St.Strophe.Status.ERROR)this.lastErrorMsg=n;else if(t===St.Strophe.Status.DISCONNECTED){this.connection.ping.stopInterval();const e=Boolean(this.disconnectInProgress),t=n||this.lastErrorMsg;if(this.anonymousConnectionFailed)this.eventEmitter.emit(ur,br);else if(this.connectionFailed)this.eventEmitter.emit(ur,Sr,t,void 0,this._getConnectionFailedReasonDetails());else if(e)this.eventEmitter.emit(lr,t);else{Ca.error("XMPP connection dropped!");const e=St.Strophe.getLastErrorStatus();e>=500&&e<600?this.eventEmitter.emit(ur,Tr,t||"server-error",void 0,this._getConnectionFailedReasonDetails()):this.eventEmitter.emit(ur,yr,t||"connection-dropped-error",void 0,this._getConnectionFailedReasonDetails())}}else if(t===St.Strophe.Status.AUTHFAIL){const t=this.getConnection().getLastFailedMessage();this.eventEmitter.emit(ur,br,n||this._parseConnectionFailedMessage(t),e)}}_processDiscoInfoIdentities(e,t){e.forEach((e=>{if("av_moderation"===e.type&&(this.avModerationComponentAddress=e.name,this._components.push(this.avModerationComponentAddress)),"end_conference"===e.type&&(this.endConferenceComponentAddress=e.name,this._components.push(this.endConferenceComponentAddress)),"speakerstats"===e.type&&(this.speakerStatsComponentAddress=e.name,this._components.push(this.speakerStatsComponentAddress)),"lobbyrooms"===e.type){this.lobbySupported=!0;const n=e=>{e.forEach((e=>{e.endsWith("#displayname_required")&&this.eventEmitter.emit(gr)}))};t?n(t):e.name&&this.caps.getFeaturesAndIdentities(e.name,e.type).then((e=>{let{features:t}=e;return n(t)})).catch((e=>Ca.warn("Error getting features from lobby.",e&&e.message)))}if("shard"===e.type&&(this.options.deploymentInfo.shard=this.connection.shard=e.name),"region"===e.type&&(this.options.deploymentInfo.region=this.connection.region=e.name),"release"===e.type&&(this.options.deploymentInfo.backendRelease=e.name),"breakout_rooms"===e.type){this.breakoutRoomsComponentAddress=e.name,this._components.push(this.breakoutRoomsComponentAddress);const n=e=>{this.breakoutRoomsFeatures={},e.forEach((e=>{e.endsWith("#rename")&&(this.breakoutRoomsFeatures.rename=!0)}))};t?n(t):e.name&&this.caps.getFeaturesAndIdentities(e.name,e.type).then((e=>{let{features:t}=e;return n(t)})).catch((e=>Ca.warn("Error getting features for breakout rooms.",e&&e.message)))}"room_metadata"===e.type&&(this.roomMetadataComponentAddress=e.name,this._components.push(this.roomMetadataComponentAddress)),"visitors"===e.type&&this._components.push(e.name)})),this._maybeSendDeploymentInfoStat(!0),this._components.length>0&&this.connection.addHandler(this._onPrivateMessage.bind(this),null,"message",null,null)}_parseConnectionFailedMessage(e){if(!e)return null;xa.lastIndex=0;const t=xa.exec(e);return t?t[1]:null}_connect(e,t){this._resetState(),this.sendDiscoInfo=!0,this.sendDeploymentInfo=!0,this.connection._stropheConn&&this.connection._stropheConn._addSysHandler?this._sysMessageHandler=this.connection._stropheConn._addSysHandler(this._onSystemMessage.bind(this),null,"message"):Ca.warn("Cannot attach strophe system handler, jiconop cannot operate"),this.connection.connect(e,t,this.connectionHandler.bind(this,{jid:e,password:t}))}_onSystemMessage(e){if(0===_t()(e).find(">services").length&&0===_t()(e).find(">query").length)return;this.sendDiscoInfo=!1;const t=this.connection.jingle.onReceiveStunAndTurnCredentials(e),{features:n,identities:i}=So(e);this._processDiscoInfoIdentities(i,n),(t||i.size>0||n.size>0)&&(this.connection._stropheConn.deleteHandler(this._sysMessageHandler),this._sysMessageHandler=null)}attach(e){this._resetState(),this.sendDiscoInfo=!0;const t=this.connectionTimes.attaching=window.performance.now();Ca.log("(TIME) Strophe Attaching:\\t",t),this.connection.attach(e.jid,e.sid,parseInt(e.rid,10)+1,this.connectionHandler.bind(this,{jid:e.jid,password:e.password}))}_resetState(){this.anonymousConnectionFailed=!1,this.connectionFailed=!1,this.lastErrorMsg=void 0,this.disconnectInProgress=void 0}connect(e,t){if(!e){const{anonymousdomain:t,domain:n}=this.options.hosts;let i=t||n;const{location:r}=window;if(t){const e=r&&r.search;(e&&-1!==e.indexOf("login=true")||this.token)&&(i=n)}e=i||r&&r.hostname}return this._startConnecting=!0,this._connect(e,t)}createRoom(e,t,n){const i=e.domain||t.customDomain;let r=`${this.getRoomJid(e,i)}/`;const o=n?n(this.connection.jid,this.authenticatedUser):co().randomHexString(8).toLowerCase();return Ca.info(`JID ${this.connection.jid} using MUC nickname ${o}`),r+=o,this.connection.emuc.createRoom(r,null,t)}getRoomJid(e,t){return`${e}@${t||this.options.hosts.muc.toLowerCase()}`}isRoomCreated(e,t){return this.connection.emuc.isRoomCreated(this.getRoomJid(e,t))}getJid(){return this.connection.jid}getJingleLog(){const e=this.connection.jingle;return e?e.getLog():{}}getXmppLog(){return(this.connection.logger||{}).log||null}dial(){this.connection.rayo.dial(...arguments)}ping(e){return new Promise(((t,n)=>{this.connection.ping.ping(this.connection.pingDomain,t,n,e)}))}getSessions(){return this.connection.jingle.sessions}disconnect(e){return this.disconnectInProgress?this.disconnectInProgress:this.connection&&this._startConnecting?(this.disconnectInProgress=new Promise((e=>{const t=(n,i)=>{i===St.Strophe.Status.DISCONNECTED&&(this.eventEmitter.removeListener(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,t),e())};this.eventEmitter.on(Hi.XMPPEvents.CONNECTION_STATUS_CHANGED,t)})),this._cleanupXmppConnection(e),this.disconnectInProgress):Promise.resolve()}_cleanupXmppConnection(e){if(!this.connection.isUsingWebSocket&&this.connection.flush(),!this.connection.isUsingWebSocket&&null!=e){const t=e.type;if(("beforeunload"===t||"unload"===t)&&(this.connection.options.sync=!0,this.connection.sendUnavailableBeacon()))return}this.connection.disconnect(),this._startConnecting=!1,!0!==this.connection.options.sync&&this.connection.flush()}_initStrophePlugins(){const e={jvb:{iceServers:[]},p2p:{iceServers:[]}},t=this.options.p2p&&this.options.p2p.stunServers||Ra;Array.isArray(t)&&(Ca.info("P2P STUN servers: ",t),e.p2p.iceServers=t),this.options.p2p&&this.options.p2p.iceTransportPolicy&&(Ca.info("P2P ICE transport policy: ",this.options.p2p.iceTransportPolicy),e.p2p.iceTransportPolicy=this.options.p2p.iceTransportPolicy),this.connection.addConnectionPlugin("emuc",new Es(this)),this.connection.addConnectionPlugin("jingle",new ga(this,this.eventEmitter,e)),this.connection.addConnectionPlugin("rayo",new Ea)}_getConnectionFailedReasonDetails(){const e={};if(this.options.deploymentInfo&&this.options.deploymentInfo.shard&&this.connection.lastResponseHeaders){const t=this.connection.lastResponseHeaders.trim().split(/[\\r\\n]+/),n={};t.forEach((e=>{const t=e.split(": "),i=t.shift(),r=t.join(": ");n[i]=r})),e.shard_changed=this.options.deploymentInfo.shard!==n["x-jitsi-shard"]}return e.suspend_time=this.connection.ping.getPingSuspendTime(),e.time_since_last_success=this.connection.getTimeSinceLastSuccess(),e}sendDominantSpeakerEvent(e,t){if(!this.speakerStatsComponentAddress||!e)return;const n=(0,St.$msg)({to:this.speakerStatsComponentAddress});n.c("speakerstats",{xmlns:"http://jitsi.org/jitmeet",room:e,silence:t}).up(),this.connection.send(n)}sendFaceLandmarksEvent(e,t){if(!this.speakerStatsComponentAddress||!e)return;const n=(0,St.$msg)({to:this.speakerStatsComponentAddress});n.c("faceLandmarks",{xmlns:"http://jitsi.org/jitmeet",room:e,faceExpression:t.faceExpression,timestamp:t.timestamp,duration:t.duration}).up(),this.connection.send(n)}tryParseJSONAndVerify(e){if(!e)return!1;try{const t=_r(e);if(t&&"object"==typeof t){const e=t[Aa];if(void 0!==e)return t;Ca.debug("parsing valid json but does not have correct structure","topic: ",e)}}catch(t){return Ca.error(`Error parsing json ${e}`,t),!1}return!1}_onPrivateMessage(e){const t=e.getAttribute("from");if(!this._components.includes(t))return!0;const n=_t()(e).find(">json-message").text(),i=this.tryParseJSONAndVerify(n);return!i||("speakerstats"===i[Aa]&&i.users?this.eventEmitter.emit(Hi.XMPPEvents.SPEAKER_STATS_RECEIVED,i.users):"av_moderation"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.AV_MODERATION_RECEIVED,i):"breakout_rooms"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.BREAKOUT_ROOMS_EVENT,i):"room_metadata"===i[Aa]?this.eventEmitter.emit(Hi.XMPPEvents.ROOM_METADATA_EVENT,i):"visitors"===i[Aa]&&this.eventEmitter.emit(Hi.XMPPEvents.VISITORS_MESSAGE,i),!0)}_maybeSendDeploymentInfoStat(e){const t=[St.Strophe.Status.ERROR,St.Strophe.Status.CONNFAIL,St.Strophe.Status.AUTHFAIL,St.Strophe.Status.DISCONNECTED,St.Strophe.Status.CONNTIMEOUT];if(!(e||t.includes(this.connection.status)&&this.sendDeploymentInfo))return;const n=this.options.deploymentInfo;if(n&&Object.keys(n).length>0){const e={};for(const t in n)n.hasOwnProperty(t)&&(e[t]=n[t]);Mi.analytics.addPermanentProperties({...e}),e.id="deployment_info";const t=JSON.stringify(e);Ca.info(t)}this.sendDeploymentInfo=!1;const{region:i,shard:r}=n;(i||r)&&this.eventEmitter.emit(fr,JSON.parse(JSON.stringify({region:i,shard:r})))}}function Da(e){let t,{id:n,password:i,onCreateResource:r,onLoginSuccessful:o}=e,s=!1,a=new Pa(this.connection.options);const d=new Promise(((e,d)=>{t=d,a.addListener(lr,(()=>{a=void 0})),a.addListener(hr,(()=>{if(s)return;o&&o();const t=a.createRoom(this.options.name,this.options.config,r);t.xmpp.moderator.authenticate(t.roomjid).then((()=>{a&&a.disconnect(),s||this.room.xmpp.moderator.sendConferenceRequest(this.room.roomjid).finally(e)})).catch((e=>{let{error:t,message:n}=e;a.disconnect(),d({authenticationError:t,message:n})}))})),a.addListener(ur,((e,t,n)=>{d({connectionError:e,credentials:n,message:t}),a=void 0})),s||a.connect(n,i)}));return d.cancel=()=>{s=!0,t({}),a&&a.disconnect()},d}const Oa=(0,y.getLogger)("modules/RTC/CodecSelection.js"),ka=[Ds.VP9,Ds.VP8,Ds.H264,Ds.AV1],Na=[Ds.H264,Ds.VP8,Ds.VP9,Ds.AV1],Ma=[Ds.VP8,Ds.VP9,Ds.H264,Ds.AV1];class La{constructor(e,t){this.conference=e,this.options=t,this.codecPreferenceOrder={},this.visitorCodecs=[];for(const e of Object.keys(t)){let{disabledCodec:r,preferredCodec:o,preferenceOrder:s}=t[e];const a=new Set(this._getSupportedVideoCodecs(e));let d=Array.from(a);if(s)s=s.map((e=>e.toLowerCase())),d=s.filter((e=>a.has(e)));else if(o||r){var n,i;r=null===(n=r)||void 0===n?void 0:n.toLowerCase(),o=null===(i=o)||void 0===i?void 0:i.toLowerCase(),r&&r!==Ds.VP8&&(d=d.filter((e=>e!==r)));const e=d.findIndex((e=>e===o));o&&-1!==e&&(d.splice(e,1),d.unshift(o))}if(!(ci.supportsVP9()||ci.isWebKitBased()&&"p2p"===e)||this.conference.isE2EEEnabled()){const e=d.findIndex((e=>e===Ds.VP9));-1!==e&&(d.splice(e,1),this.conference.isE2EEEnabled()||d.push(Ds.VP9))}Oa.info(`Codec preference order for ${e} connection is ${d}`),this.codecPreferenceOrder[e]=d}this.conference.on(q,(e=>this._selectPreferredCodec(e))),this.conference.on(ue,(e=>this._updateVisitorCodecs(e))),this.conference.on(at,(()=>this._selectPreferredCodec())),this.conference.on(dt,(()=>this._selectPreferredCodec()))}_getSupportedVideoCodecs(e){const t=(ci.isMobileDevice()&&"p2p"===e?Na:ci.isMobileDevice()?Ma:ka).filter((e=>{var t,n,i,r;return(null!==(t=null===(n=window.RTCRtpReceiver)||void 0===n||null===(i=n.getCapabilities)||void 0===i||null===(r=i.call(n,Ri.VIDEO))||void 0===r?void 0:r.codecs)&&void 0!==t?t:[]).some((t=>t.mimeType.toLowerCase()===`${Ri.VIDEO}/${e}`))}));return!t.length&&t.push(Ds.VP8),t}_selectPreferredCodec(e){const t=e||this.conference.jvbJingleSession;if(!t)return;const n=t.peerconnection.getConfiguredVideoCodecs(),i=t===this.conference.jvbJingleSession;let r=i?this.codecPreferenceOrder.jvb:this.codecPreferenceOrder.p2p;this.conference.isE2EEEnabled()&&i&&(r=[Ds.VP8]);const o=this.conference.getParticipants().map((e=>e.getId())),s=null==o?void 0:o.map((e=>{const n=t._signalingLayer.getPeerMediaInfo(e,Ri.VIDEO);return null!=n&&n.codecList?n.codecList:null!=n&&n.codecType?[n.codecType]:[]}));this.visitorCodecs.length&&s.push(this.visitorCodecs);const a=r.reduce(((e,n)=>{let i=!1;if(!t.isP2P)for(const e of s)e.length&&(i=i||!e.find((e=>e===n)));return i||e.push(n),e}),[]);a.length?a.every(((e,t)=>e===n[t]))||t.setVideoCodecs(a):Oa.warn("Invalid codec list generated because of a user joining/leaving the call")}_updateVisitorCodecs(e){this.visitorCodecs!==e&&(this.visitorCodecs=e,this._selectPreferredCodec())}getCodecPreferenceList(e){return this.codecPreferenceOrder[e]}}const Fa=(0,y.getLogger)("modules/RTC/BridgeChannel.js");class ja{constructor(e,t,n,i){if(!e&&!t)throw new TypeError("At least peerconnection or wsUrl must be given");if(e&&t)throw new TypeError("Just one of peerconnection or wsUrl must be given");if(e?Fa.debug("constructor() with peerconnection"):Fa.debug(`constructor() with wsUrl:"${t}"`),this._channel=null,this._conference=i,this._connected=void 0,this._eventEmitter=n,this._mode=null,this._areRetriesEnabled=!1,this._closedFromClient=!1,e){const t=e.createDataChannel("JVB data channel",{protocol:"http://jitsi.org/protocols/colibri"});this._handleChannel(t),this._mode="datachannel"}else t&&(this._areRetriesEnabled=!0,this._wsUrl=t,this._initWebSocket())}_initWebSocket(){const e=new WebSocket(this._wsUrl);this._handleChannel(e),this._mode="websocket"}_startConnectionRetries(){let e=1;const t=()=>{!this._channel||"connecting"!==this._channel.readyState&&this._channel.readyState!==WebSocket.CONNECTING?this.isOpen()||(this._initWebSocket(this._wsUrl),e=Math.min(2*e,60),this._retryTimeout=setTimeout(t,1e3*e)):this._retryTimeout=setTimeout(t,1e3*e)};this._retryTimeout=setTimeout(t,1e3*e)}_stopConnectionRetries(){this._retryTimeout&&(clearTimeout(this._retryTimeout),this._retryTimeout=void 0)}_retryWebSocketConnection(e){if(!this._areRetriesEnabled)return;const{code:t,reason:n}=e;Mi.sendAnalytics(((e,t)=>({type:kt.TYPE_OPERATIONAL,action:"bridge-channel.error",attributes:{code:e,reason:t}}))(t,n)),this._areRetriesEnabled=!1,this._eventEmitter.once(ji.default.DATA_CHANNEL_OPEN,(()=>{this._stopConnectionRetries(),this._areRetriesEnabled=!0})),this._startConnectionRetries()}get mode(){return this._mode}close(){if(this._closedFromClient=!0,this._stopConnectionRetries(),this._areRetriesEnabled=!1,this._channel){try{this._channel.close()}catch(e){}this._channel=null}}isOpen(){return this._channel&&("open"===this._channel.readyState||this._channel.readyState===WebSocket.OPEN)}sendEndpointStatsMessage(e){this._send({colibriClass:"EndpointStats",...e})}sendMessage(e,t){this._send({colibriClass:"EndpointMessage",msgPayload:t,to:e})}sendSetLastNMessage(e){Fa.log(`Sending lastN=${e}.`),this._send({colibriClass:"LastNChangedEvent",lastN:e})}sendReceiverVideoConstraintsMessage(e){Fa.log(`Sending ReceiverVideoConstraints with ${JSON.stringify(e)}`),this._send({colibriClass:"ReceiverVideoConstraints",...e})}sendSourceVideoTypeMessage(e,t){Fa.info(`Sending SourceVideoTypeMessage with video type ${e}: ${t}`),this._send({colibriClass:"SourceVideoTypeMessage",sourceName:e,videoType:t})}_handleChannel(e){const t=this._eventEmitter;e.onopen=()=>{Fa.info(`${this._mode} channel opened`),this._connected=!0,t.emit(ji.default.DATA_CHANNEL_OPEN)},e.onerror=e=>{"websocket"!==this._mode&&Fa.error(`Channel error: ${e.message}`)},e.onmessage=e=>{let n,{data:i}=e;try{n=_r(i)}catch(e){return void Fa.error("Failed to parse channel message as JSON: ",i,e)}const r=n.colibriClass;switch(r){case"DominantSpeakerEndpointChangeEvent":{const{dominantSpeakerEndpoint:e,previousSpeakers:i=[],silence:r}=n;Fa.debug(`Dominant speaker: ${e}, previous speakers: ${i}`),t.emit(ji.default.DOMINANT_SPEAKER_CHANGED,e,i,r);break}case"EndpointConnectivityStatusChangeEvent":{const e=n.endpoint,i="true"===n.active;Fa.info(`Endpoint connection status changed: ${e} active=${i}`),t.emit(ji.default.ENDPOINT_CONN_STATUS_CHANGED,e,i);break}case"EndpointMessage":t.emit(ji.default.ENDPOINT_MESSAGE_RECEIVED,n.from,n.msgPayload);break;case"EndpointStats":t.emit(ji.default.ENDPOINT_STATS_RECEIVED,n.from,n);break;case"ForwardedSources":{const e=n.forwardedSources;Fa.info(`New forwarded sources: ${e}`),t.emit(ji.default.FORWARDED_SOURCES_CHANGED,e);break}case"SenderSourceConstraints":"string"==typeof n.sourceName&&"number"==typeof n.maxHeight?(Fa.info(`SenderSourceConstraints: ${n.sourceName} - ${n.maxHeight}`),t.emit(ji.default.SENDER_VIDEO_CONSTRAINTS_CHANGED,n)):Fa.error(`Invalid SenderSourceConstraints: ${n.sourceName} - ${n.maxHeight}`);break;case"ServerHello":Fa.info(`Received ServerHello, version=${n.version}.`);break;case"VideoSourcesMap":Fa.info(`Received VideoSourcesMap: ${JSON.stringify(n.mappedSources)}`),t.emit(ji.default.VIDEO_SSRCS_REMAPPED,n);break;case"AudioSourcesMap":Fa.info(`Received AudioSourcesMap: ${JSON.stringify(n.mappedSources)}`),t.emit(ji.default.AUDIO_SSRCS_REMAPPED,n);break;default:Fa.debug("Channel JSON-formatted message: ",n),t.emit(`rtc.datachannel.${r}`,n)}},e.onclose=n=>{if(Fa.debug("Channel closed by "+(this._closedFromClient?"client":"server")),e===this._channel){if(!(this._closedFromClient||1001===n.code&&1===this._conference.getParticipantCount())){const{code:e,reason:i}=n;Fa.error(`Channel closed: ${e} ${i}`),"websocket"===this._mode&&(this._retryWebSocketConnection(n),!1!==this._connected&&t.emit(ji.default.DATA_CHANNEL_CLOSED,{code:e,reason:i}))}this._connected=!1,this._channel=null}else Fa.debug("Skip close handler, channel instance is not equal to stored one")},this._channel=e}_send(e){const t=this._channel;if(!this.isOpen())throw Fa.error("Bridge Channel send: no opened channel."),new Error("No opened channel");t.send(JSON.stringify(e))}}let Va;!function(e){e.ENVIRONMENT="environment",e.USER="user"}(Va||(Va={}));let Ua=!0,Ha=!0;function $a(e,t,n){const i=e.match(t);return i&&i.length>=n&&parseInt(i[n],10)}function Ja(e,t,n){if(!e.RTCPeerConnection)return;const i=e.RTCPeerConnection.prototype,r=i.addEventListener;i.addEventListener=function(e,i){if(e!==t)return r.apply(this,arguments);const o=e=>{const t=n(e);t&&(i.handleEvent?i.handleEvent(t):i(t))};return this._eventMap=this._eventMap||{},this._eventMap[t]||(this._eventMap[t]=new Map),this._eventMap[t].set(i,o),r.apply(this,[e,o])};const o=i.removeEventListener;i.removeEventListener=function(e,n){if(e!==t||!this._eventMap||!this._eventMap[t])return o.apply(this,arguments);if(!this._eventMap[t].has(n))return o.apply(this,arguments);const i=this._eventMap[t].get(n);return this._eventMap[t].delete(n),0===this._eventMap[t].size&&delete this._eventMap[t],0===Object.keys(this._eventMap).length&&delete this._eventMap,o.apply(this,[e,i])},Object.defineProperty(i,"on"+t,{get(){return this["_on"+t]},set(e){this["_on"+t]&&(this.removeEventListener(t,this["_on"+t]),delete this["_on"+t]),e&&this.addEventListener(t,this["_on"+t]=e)},enumerable:!0,configurable:!0})}function Ba(e){return"boolean"!=typeof e?new Error("Argument type: "+typeof e+". Please use a boolean."):(Ua=e,e?"adapter.js logging disabled":"adapter.js logging enabled")}function qa(e){return"boolean"!=typeof e?new Error("Argument type: "+typeof e+". Please use a boolean."):(Ha=!e,"adapter.js deprecation warnings "+(e?"disabled":"enabled"))}function Ga(){if("object"==typeof window){if(Ua)return;"undefined"!=typeof console&&"function"==typeof console.log&&console.log.apply(console,arguments)}}function za(e,t){Ha&&console.warn(e+" is deprecated, please use "+t+" instead.")}function Ka(e){return"[object Object]"===Object.prototype.toString.call(e)}function Wa(e){return Ka(e)?Object.keys(e).reduce((function(t,n){const i=Ka(e[n]),r=i?Wa(e[n]):e[n],o=i&&!Object.keys(r).length;return void 0===r||o?t:Object.assign(t,{[n]:r})}),{}):e}function Xa(e,t,n){t&&!n.has(t.id)&&(n.set(t.id,t),Object.keys(t).forEach((i=>{i.endsWith("Id")?Xa(e,e.get(t[i]),n):i.endsWith("Ids")&&t[i].forEach((t=>{Xa(e,e.get(t),n)}))})))}function Ya(e,t,n){const i=n?"outbound-rtp":"inbound-rtp",r=new Map;if(null===t)return r;const o=[];return e.forEach((e=>{"track"===e.type&&e.trackIdentifier===t.id&&o.push(e)})),o.forEach((t=>{e.forEach((n=>{n.type===i&&n.trackId===t.id&&Xa(e,n,r)}))})),r}const Qa=Ga;function Za(e,t){const n=e&&e.navigator;if(!n.mediaDevices)return;const i=function(e){if("object"!=typeof e||e.mandatory||e.optional)return e;const t={};return Object.keys(e).forEach((n=>{if("require"===n||"advanced"===n||"mediaSource"===n)return;const i="object"==typeof e[n]?e[n]:{ideal:e[n]};void 0!==i.exact&&"number"==typeof i.exact&&(i.min=i.max=i.exact);const r=function(e,t){return e?e+t.charAt(0).toUpperCase()+t.slice(1):"deviceId"===t?"sourceId":t};if(void 0!==i.ideal){t.optional=t.optional||[];let e={};"number"==typeof i.ideal?(e[r("min",n)]=i.ideal,t.optional.push(e),e={},e[r("max",n)]=i.ideal,t.optional.push(e)):(e[r("",n)]=i.ideal,t.optional.push(e))}void 0!==i.exact&&"number"!=typeof i.exact?(t.mandatory=t.mandatory||{},t.mandatory[r("",n)]=i.exact):["min","max"].forEach((e=>{void 0!==i[e]&&(t.mandatory=t.mandatory||{},t.mandatory[r(e,n)]=i[e])}))})),e.advanced&&(t.optional=(t.optional||[]).concat(e.advanced)),t},r=function(e,r){if(t.version>=61)return r(e);if((e=JSON.parse(JSON.stringify(e)))&&"object"==typeof e.audio){const t=function(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t])};t((e=JSON.parse(JSON.stringify(e))).audio,"autoGainControl","googAutoGainControl"),t(e.audio,"noiseSuppression","googNoiseSuppression"),e.audio=i(e.audio)}if(e&&"object"==typeof e.video){let o=e.video.facingMode;o=o&&("object"==typeof o?o:{ideal:o});const s=t.version<66;if(o&&("user"===o.exact||"environment"===o.exact||"user"===o.ideal||"environment"===o.ideal)&&(!n.mediaDevices.getSupportedConstraints||!n.mediaDevices.getSupportedConstraints().facingMode||s)){let t;if(delete e.video.facingMode,"environment"===o.exact||"environment"===o.ideal?t=["back","rear"]:"user"!==o.exact&&"user"!==o.ideal||(t=["front"]),t)return n.mediaDevices.enumerateDevices().then((n=>{let s=(n=n.filter((e=>"videoinput"===e.kind))).find((e=>t.some((t=>e.label.toLowerCase().includes(t)))));return!s&&n.length&&t.includes("back")&&(s=n[n.length-1]),s&&(e.video.deviceId=o.exact?{exact:s.deviceId}:{ideal:s.deviceId}),e.video=i(e.video),Qa("chrome: "+JSON.stringify(e)),r(e)}))}e.video=i(e.video)}return Qa("chrome: "+JSON.stringify(e)),r(e)},o=function(e){return t.version>=64?e:{name:{PermissionDeniedError:"NotAllowedError",PermissionDismissedError:"NotAllowedError",InvalidStateError:"NotAllowedError",DevicesNotFoundError:"NotFoundError",ConstraintNotSatisfiedError:"OverconstrainedError",TrackStartError:"NotReadableError",MediaDeviceFailedDueToShutdown:"NotAllowedError",MediaDeviceKillSwitchOn:"NotAllowedError",TabCaptureError:"AbortError",ScreenCaptureError:"AbortError",DeviceCaptureError:"AbortError"}[e.name]||e.name,message:e.message,constraint:e.constraint||e.constraintName,toString(){return this.name+(this.message&&": ")+this.message}}};if(n.getUserMedia=function(e,t,i){r(e,(e=>{n.webkitGetUserMedia(e,t,(e=>{i&&i(o(e))}))}))}.bind(n),n.mediaDevices.getUserMedia){const e=n.mediaDevices.getUserMedia.bind(n.mediaDevices);n.mediaDevices.getUserMedia=function(t){return r(t,(t=>e(t).then((e=>{if(t.audio&&!e.getAudioTracks().length||t.video&&!e.getVideoTracks().length)throw e.getTracks().forEach((e=>{e.stop()})),new DOMException("","NotFoundError");return e}),(e=>Promise.reject(o(e))))))}}}function ed(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&("function"==typeof t?e.navigator.mediaDevices.getDisplayMedia=function(n){return t(n).then((t=>{const i=n.video&&n.video.width,r=n.video&&n.video.height,o=n.video&&n.video.frameRate;return n.video={mandatory:{chromeMediaSource:"desktop",chromeMediaSourceId:t,maxFrameRate:o||3}},i&&(n.video.mandatory.maxWidth=i),r&&(n.video.mandatory.maxHeight=r),e.navigator.mediaDevices.getUserMedia(n)}))}:console.error("shimGetDisplayMedia: getSourceId argument is not a function"))}function td(e){e.MediaStream=e.MediaStream||e.webkitMediaStream}function nd(e){if("object"==typeof e&&e.RTCPeerConnection&&!("ontrack"in e.RTCPeerConnection.prototype)){Object.defineProperty(e.RTCPeerConnection.prototype,"ontrack",{get(){return this._ontrack},set(e){this._ontrack&&this.removeEventListener("track",this._ontrack),this.addEventListener("track",this._ontrack=e)},enumerable:!0,configurable:!0});const t=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){return this._ontrackpoly||(this._ontrackpoly=t=>{t.stream.addEventListener("addtrack",(n=>{let i;i=e.RTCPeerConnection.prototype.getReceivers?this.getReceivers().find((e=>e.track&&e.track.id===n.track.id)):{track:n.track};const r=new Event("track");r.track=n.track,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],this.dispatchEvent(r)})),t.stream.getTracks().forEach((n=>{let i;i=e.RTCPeerConnection.prototype.getReceivers?this.getReceivers().find((e=>e.track&&e.track.id===n.id)):{track:n};const r=new Event("track");r.track=n,r.receiver=i,r.transceiver={receiver:i},r.streams=[t.stream],this.dispatchEvent(r)}))},this.addEventListener("addstream",this._ontrackpoly)),t.apply(this,arguments)}}else Ja(e,"track",(e=>(e.transceiver||Object.defineProperty(e,"transceiver",{value:{receiver:e.receiver}}),e)))}function id(e){if("object"==typeof e&&e.RTCPeerConnection&&!("getSenders"in e.RTCPeerConnection.prototype)&&"createDTMFSender"in e.RTCPeerConnection.prototype){const t=function(e,t){return{track:t,get dtmf(){return void 0===this._dtmf&&("audio"===t.kind?this._dtmf=e.createDTMFSender(t):this._dtmf=null),this._dtmf},_pc:e}};if(!e.RTCPeerConnection.prototype.getSenders){e.RTCPeerConnection.prototype.getSenders=function(){return this._senders=this._senders||[],this._senders.slice()};const n=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,i){let r=n.apply(this,arguments);return r||(r=t(this,e),this._senders.push(r)),r};const i=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){i.apply(this,arguments);const t=this._senders.indexOf(e);-1!==t&&this._senders.splice(t,1)}}const n=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){this._senders=this._senders||[],n.apply(this,[e]),e.getTracks().forEach((e=>{this._senders.push(t(this,e))}))};const i=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){this._senders=this._senders||[],i.apply(this,[e]),e.getTracks().forEach((e=>{const t=this._senders.find((t=>t.track===e));t&&this._senders.splice(this._senders.indexOf(t),1)}))}}else if("object"==typeof e&&e.RTCPeerConnection&&"getSenders"in e.RTCPeerConnection.prototype&&"createDTMFSender"in e.RTCPeerConnection.prototype&&e.RTCRtpSender&&!("dtmf"in e.RTCRtpSender.prototype)){const t=e.RTCPeerConnection.prototype.getSenders;e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e},Object.defineProperty(e.RTCRtpSender.prototype,"dtmf",{get(){return void 0===this._dtmf&&("audio"===this.track.kind?this._dtmf=this._pc.createDTMFSender(this.track):this._dtmf=null),this._dtmf}})}}function rd(e){if(!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){const[e,n,i]=arguments;if(arguments.length>0&&"function"==typeof e)return t.apply(this,arguments);if(0===t.length&&(0===arguments.length||"function"!=typeof e))return t.apply(this,[]);const r=function(e){const t={};return e.result().forEach((e=>{const n={id:e.id,timestamp:e.timestamp,type:{localcandidate:"local-candidate",remotecandidate:"remote-candidate"}[e.type]||e.type};e.names().forEach((t=>{n[t]=e.stat(t)})),t[n.id]=n})),t},o=function(e){return new Map(Object.keys(e).map((t=>[t,e[t]])))};if(arguments.length>=2){const i=function(e){n(o(r(e)))};return t.apply(this,[i,e])}return new Promise(((e,n)=>{t.apply(this,[function(t){e(o(r(t)))},n])})).then(n,i)}}function od(e){if(!("object"==typeof e&&e.RTCPeerConnection&&e.RTCRtpSender&&e.RTCRtpReceiver))return;if(!("getStats"in e.RTCRtpSender.prototype)){const t=e.RTCPeerConnection.prototype.getSenders;t&&(e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e});const n=e.RTCPeerConnection.prototype.addTrack;n&&(e.RTCPeerConnection.prototype.addTrack=function(){const e=n.apply(this,arguments);return e._pc=this,e}),e.RTCRtpSender.prototype.getStats=function(){const e=this;return this._pc.getStats().then((t=>Ya(t,e.track,!0)))}}if(!("getStats"in e.RTCRtpReceiver.prototype)){const t=e.RTCPeerConnection.prototype.getReceivers;t&&(e.RTCPeerConnection.prototype.getReceivers=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e}),Ja(e,"track",(e=>(e.receiver._pc=e.srcElement,e))),e.RTCRtpReceiver.prototype.getStats=function(){const e=this;return this._pc.getStats().then((t=>Ya(t,e.track,!1)))}}if(!("getStats"in e.RTCRtpSender.prototype)||!("getStats"in e.RTCRtpReceiver.prototype))return;const t=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){if(arguments.length>0&&arguments[0]instanceof e.MediaStreamTrack){const e=arguments[0];let t,n,i;return this.getSenders().forEach((n=>{n.track===e&&(t?i=!0:t=n)})),this.getReceivers().forEach((t=>(t.track===e&&(n?i=!0:n=t),t.track===e))),i||t&&n?Promise.reject(new DOMException("There are more than one sender or receiver for the track.","InvalidAccessError")):t?t.getStats():n?n.getStats():Promise.reject(new DOMException("There is no sender or receiver for the track.","InvalidAccessError"))}return t.apply(this,arguments)}}function sd(e){e.RTCPeerConnection.prototype.getLocalStreams=function(){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},Object.keys(this._shimmedLocalStreams).map((e=>this._shimmedLocalStreams[e][0]))};const t=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addTrack=function(e,n){if(!n)return t.apply(this,arguments);this._shimmedLocalStreams=this._shimmedLocalStreams||{};const i=t.apply(this,arguments);return this._shimmedLocalStreams[n.id]?-1===this._shimmedLocalStreams[n.id].indexOf(i)&&this._shimmedLocalStreams[n.id].push(i):this._shimmedLocalStreams[n.id]=[n,i],i};const n=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(e){this._shimmedLocalStreams=this._shimmedLocalStreams||{},e.getTracks().forEach((e=>{if(this.getSenders().find((t=>t.track===e)))throw new DOMException("Track already exists.","InvalidAccessError")}));const t=this.getSenders();n.apply(this,arguments);const i=this.getSenders().filter((e=>-1===t.indexOf(e)));this._shimmedLocalStreams[e.id]=[e].concat(i)};const i=e.RTCPeerConnection.prototype.removeStream;e.RTCPeerConnection.prototype.removeStream=function(e){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},delete this._shimmedLocalStreams[e.id],i.apply(this,arguments)};const r=e.RTCPeerConnection.prototype.removeTrack;e.RTCPeerConnection.prototype.removeTrack=function(e){return this._shimmedLocalStreams=this._shimmedLocalStreams||{},e&&Object.keys(this._shimmedLocalStreams).forEach((t=>{const n=this._shimmedLocalStreams[t].indexOf(e);-1!==n&&this._shimmedLocalStreams[t].splice(n,1),1===this._shimmedLocalStreams[t].length&&delete this._shimmedLocalStreams[t]})),r.apply(this,arguments)}}function ad(e,t){if(!e.RTCPeerConnection)return;if(e.RTCPeerConnection.prototype.addTrack&&t.version>=65)return sd(e);const n=e.RTCPeerConnection.prototype.getLocalStreams;e.RTCPeerConnection.prototype.getLocalStreams=function(){const e=n.apply(this);return this._reverseStreams=this._reverseStreams||{},e.map((e=>this._reverseStreams[e.id]))};const i=e.RTCPeerConnection.prototype.addStream;e.RTCPeerConnection.prototype.addStream=function(t){if(this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},t.getTracks().forEach((e=>{if(this.getSenders().find((t=>t.track===e)))throw new DOMException("Track already exists.","InvalidAccessError")})),!this._reverseStreams[t.id]){const n=new e.MediaStream(t.getTracks());this._streams[t.id]=n,this._reverseStreams[n.id]=t,t=n}i.apply(this,[t])};const r=e.RTCPeerConnection.prototype.removeStream;function o(e,t){let n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach((t=>{const i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(r.id,"g"),i.id)})),new RTCSessionDescription({type:t.type,sdp:n})}e.RTCPeerConnection.prototype.removeStream=function(e){this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{},r.apply(this,[this._streams[e.id]||e]),delete this._reverseStreams[this._streams[e.id]?this._streams[e.id].id:e.id],delete this._streams[e.id]},e.RTCPeerConnection.prototype.addTrack=function(t,n){if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection\'s signalingState is \'closed\'.","InvalidStateError");const i=[].slice.call(arguments,1);if(1!==i.length||!i[0].getTracks().find((e=>e===t)))throw new DOMException("The adapter.js addTrack polyfill only supports a single  stream which is associated with the specified track.","NotSupportedError");if(this.getSenders().find((e=>e.track===t)))throw new DOMException("Track already exists.","InvalidAccessError");this._streams=this._streams||{},this._reverseStreams=this._reverseStreams||{};const r=this._streams[n.id];if(r)r.addTrack(t),Promise.resolve().then((()=>{this.dispatchEvent(new Event("negotiationneeded"))}));else{const i=new e.MediaStream([t]);this._streams[n.id]=i,this._reverseStreams[i.id]=n,this.addStream(i)}return this.getSenders().find((e=>e.track===t))},["createOffer","createAnswer"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){const e=arguments;return arguments.length&&"function"==typeof arguments[0]?n.apply(this,[t=>{const n=o(this,t);e[0].apply(null,[n])},t=>{e[1]&&e[1].apply(null,t)},arguments[2]]):n.apply(this,arguments).then((e=>o(this,e)))}};e.RTCPeerConnection.prototype[t]=i[t]}));const s=e.RTCPeerConnection.prototype.setLocalDescription;e.RTCPeerConnection.prototype.setLocalDescription=function(){return arguments.length&&arguments[0].type?(arguments[0]=function(e,t){let n=t.sdp;return Object.keys(e._reverseStreams||[]).forEach((t=>{const i=e._reverseStreams[t],r=e._streams[i.id];n=n.replace(new RegExp(i.id,"g"),r.id)})),new RTCSessionDescription({type:t.type,sdp:n})}(this,arguments[0]),s.apply(this,arguments)):s.apply(this,arguments)};const a=Object.getOwnPropertyDescriptor(e.RTCPeerConnection.prototype,"localDescription");Object.defineProperty(e.RTCPeerConnection.prototype,"localDescription",{get(){const e=a.get.apply(this);return""===e.type?e:o(this,e)}}),e.RTCPeerConnection.prototype.removeTrack=function(e){if("closed"===this.signalingState)throw new DOMException("The RTCPeerConnection\'s signalingState is \'closed\'.","InvalidStateError");if(!e._pc)throw new DOMException("Argument 1 of RTCPeerConnection.removeTrack does not implement interface RTCRtpSender.","TypeError");if(e._pc!==this)throw new DOMException("Sender was not created by this connection.","InvalidAccessError");let t;this._streams=this._streams||{},Object.keys(this._streams).forEach((n=>{this._streams[n].getTracks().find((t=>e.track===t))&&(t=this._streams[n])})),t&&(1===t.getTracks().length?this.removeStream(this._reverseStreams[t.id]):t.removeTrack(e.track),this.dispatchEvent(new Event("negotiationneeded")))}}function dd(e,t){!e.RTCPeerConnection&&e.webkitRTCPeerConnection&&(e.RTCPeerConnection=e.webkitRTCPeerConnection),e.RTCPeerConnection&&t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments)}};e.RTCPeerConnection.prototype[t]=i[t]}))}function cd(e,t){Ja(e,"negotiationneeded",(e=>{const n=e.target;if(!(t.version<72||n.getConfiguration&&"plan-b"===n.getConfiguration().sdpSemantics)||"stable"===n.signalingState)return e}))}function ld(e,t){const n=e&&e.navigator,i=e&&e.MediaStreamTrack;if(n.getUserMedia=function(e,t,i){za("navigator.getUserMedia","navigator.mediaDevices.getUserMedia"),n.mediaDevices.getUserMedia(e).then(t,i)},!(t.version>55&&"autoGainControl"in n.mediaDevices.getSupportedConstraints())){const e=function(e,t,n){t in e&&!(n in e)&&(e[n]=e[t],delete e[t])},t=n.mediaDevices.getUserMedia.bind(n.mediaDevices);if(n.mediaDevices.getUserMedia=function(n){return"object"==typeof n&&"object"==typeof n.audio&&(n=JSON.parse(JSON.stringify(n)),e(n.audio,"autoGainControl","mozAutoGainControl"),e(n.audio,"noiseSuppression","mozNoiseSuppression")),t(n)},i&&i.prototype.getSettings){const t=i.prototype.getSettings;i.prototype.getSettings=function(){const n=t.apply(this,arguments);return e(n,"mozAutoGainControl","autoGainControl"),e(n,"mozNoiseSuppression","noiseSuppression"),n}}if(i&&i.prototype.applyConstraints){const t=i.prototype.applyConstraints;i.prototype.applyConstraints=function(n){return"audio"===this.kind&&"object"==typeof n&&(n=JSON.parse(JSON.stringify(n)),e(n,"autoGainControl","mozAutoGainControl"),e(n,"noiseSuppression","mozNoiseSuppression")),t.apply(this,[n])}}}}function hd(e,t){e.navigator.mediaDevices&&"getDisplayMedia"in e.navigator.mediaDevices||e.navigator.mediaDevices&&(e.navigator.mediaDevices.getDisplayMedia=function(n){if(!n||!n.video){const e=new DOMException("getDisplayMedia without video constraints is undefined");return e.name="NotFoundError",e.code=8,Promise.reject(e)}return!0===n.video?n.video={mediaSource:t}:n.video.mediaSource=t,e.navigator.mediaDevices.getUserMedia(n)})}function ud(e){"object"==typeof e&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get(){return{receiver:this.receiver}}})}function pd(e,t){if("object"!=typeof e||!e.RTCPeerConnection&&!e.mozRTCPeerConnection)return;!e.RTCPeerConnection&&e.mozRTCPeerConnection&&(e.RTCPeerConnection=e.mozRTCPeerConnection),t.version<53&&["setLocalDescription","setRemoteDescription","addIceCandidate"].forEach((function(t){const n=e.RTCPeerConnection.prototype[t],i={[t](){return arguments[0]=new("addIceCandidate"===t?e.RTCIceCandidate:e.RTCSessionDescription)(arguments[0]),n.apply(this,arguments)}};e.RTCPeerConnection.prototype[t]=i[t]}));const n={inboundrtp:"inbound-rtp",outboundrtp:"outbound-rtp",candidatepair:"candidate-pair",localcandidate:"local-candidate",remotecandidate:"remote-candidate"},i=e.RTCPeerConnection.prototype.getStats;e.RTCPeerConnection.prototype.getStats=function(){const[e,r,o]=arguments;return i.apply(this,[e||null]).then((e=>{if(t.version<53&&!r)try{e.forEach((e=>{e.type=n[e.type]||e.type}))}catch(t){if("TypeError"!==t.name)throw t;e.forEach(((t,i)=>{e.set(i,Object.assign({},t,{type:n[t.type]||t.type}))}))}return e})).then(r,o)}}function md(e){if("object"!=typeof e||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpSender.prototype)return;const t=e.RTCPeerConnection.prototype.getSenders;t&&(e.RTCPeerConnection.prototype.getSenders=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e});const n=e.RTCPeerConnection.prototype.addTrack;n&&(e.RTCPeerConnection.prototype.addTrack=function(){const e=n.apply(this,arguments);return e._pc=this,e}),e.RTCRtpSender.prototype.getStats=function(){return this.track?this._pc.getStats(this.track):Promise.resolve(new Map)}}function gd(e){if("object"!=typeof e||!e.RTCPeerConnection||!e.RTCRtpSender)return;if(e.RTCRtpSender&&"getStats"in e.RTCRtpReceiver.prototype)return;const t=e.RTCPeerConnection.prototype.getReceivers;t&&(e.RTCPeerConnection.prototype.getReceivers=function(){const e=t.apply(this,[]);return e.forEach((e=>e._pc=this)),e}),Ja(e,"track",(e=>(e.receiver._pc=e.srcElement,e))),e.RTCRtpReceiver.prototype.getStats=function(){return this._pc.getStats(this.track)}}function fd(e){e.RTCPeerConnection&&!("removeStream"in e.RTCPeerConnection.prototype)&&(e.RTCPeerConnection.prototype.removeStream=function(e){za("removeStream","removeTrack"),this.getSenders().forEach((t=>{t.track&&e.getTracks().includes(t.track)&&this.removeTrack(t)}))})}function vd(e){e.DataChannel&&!e.RTCDataChannel&&(e.RTCDataChannel=e.DataChannel)}function _d(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.addTransceiver;t&&(e.RTCPeerConnection.prototype.addTransceiver=function(){this.setParametersPromises=[];const e=arguments[1],n=e&&"sendEncodings"in e;n&&e.sendEncodings.forEach((e=>{if("rid"in e&&!/^[a-z0-9]{0,16}$/i.test(e.rid))throw new TypeError("Invalid RID value provided.");if("scaleResolutionDownBy"in e&&!(parseFloat(e.scaleResolutionDownBy)>=1))throw new RangeError("scale_resolution_down_by must be >= 1.0");if("maxFramerate"in e&&!(parseFloat(e.maxFramerate)>=0))throw new RangeError("max_framerate must be >= 0.0")}));const i=t.apply(this,arguments);if(n){const{sender:t}=i,n=t.getParameters();(!("encodings"in n)||1===n.encodings.length&&0===Object.keys(n.encodings[0]).length)&&(n.encodings=e.sendEncodings,t.sendEncodings=e.sendEncodings,this.setParametersPromises.push(t.setParameters(n).then((()=>{delete t.sendEncodings})).catch((()=>{delete t.sendEncodings}))))}return i})}function Ed(e){if("object"!=typeof e||!e.RTCRtpSender)return;const t=e.RTCRtpSender.prototype.getParameters;t&&(e.RTCRtpSender.prototype.getParameters=function(){const e=t.apply(this,arguments);return"encodings"in e||(e.encodings=[].concat(this.sendEncodings||[{}])),e})}function yd(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(){return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then((()=>t.apply(this,arguments))).finally((()=>{this.setParametersPromises=[]})):t.apply(this,arguments)}}function Sd(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype.createAnswer;e.RTCPeerConnection.prototype.createAnswer=function(){return this.setParametersPromises&&this.setParametersPromises.length?Promise.all(this.setParametersPromises).then((()=>t.apply(this,arguments))).finally((()=>{this.setParametersPromises=[]})):t.apply(this,arguments)}}function bd(e){if("object"==typeof e&&e.RTCPeerConnection){if("getLocalStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getLocalStreams=function(){return this._localStreams||(this._localStreams=[]),this._localStreams}),!("addStream"in e.RTCPeerConnection.prototype)){const t=e.RTCPeerConnection.prototype.addTrack;e.RTCPeerConnection.prototype.addStream=function(e){this._localStreams||(this._localStreams=[]),this._localStreams.includes(e)||this._localStreams.push(e),e.getAudioTracks().forEach((n=>t.call(this,n,e))),e.getVideoTracks().forEach((n=>t.call(this,n,e)))},e.RTCPeerConnection.prototype.addTrack=function(e){for(var n=arguments.length,i=new Array(n>1?n-1:0),r=1;r<n;r++)i[r-1]=arguments[r];return i&&i.forEach((e=>{this._localStreams?this._localStreams.includes(e)||this._localStreams.push(e):this._localStreams=[e]})),t.apply(this,arguments)}}"removeStream"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.removeStream=function(e){this._localStreams||(this._localStreams=[]);const t=this._localStreams.indexOf(e);if(-1===t)return;this._localStreams.splice(t,1);const n=e.getTracks();this.getSenders().forEach((e=>{n.includes(e.track)&&this.removeTrack(e)}))})}}function Td(e){if("object"==typeof e&&e.RTCPeerConnection&&("getRemoteStreams"in e.RTCPeerConnection.prototype||(e.RTCPeerConnection.prototype.getRemoteStreams=function(){return this._remoteStreams?this._remoteStreams:[]}),!("onaddstream"in e.RTCPeerConnection.prototype))){Object.defineProperty(e.RTCPeerConnection.prototype,"onaddstream",{get(){return this._onaddstream},set(e){this._onaddstream&&(this.removeEventListener("addstream",this._onaddstream),this.removeEventListener("track",this._onaddstreampoly)),this.addEventListener("addstream",this._onaddstream=e),this.addEventListener("track",this._onaddstreampoly=e=>{e.streams.forEach((e=>{if(this._remoteStreams||(this._remoteStreams=[]),this._remoteStreams.includes(e))return;this._remoteStreams.push(e);const t=new Event("addstream");t.stream=e,this.dispatchEvent(t)}))})}});const t=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){const e=this;return this._onaddstreampoly||this.addEventListener("track",this._onaddstreampoly=function(t){t.streams.forEach((t=>{if(e._remoteStreams||(e._remoteStreams=[]),e._remoteStreams.indexOf(t)>=0)return;e._remoteStreams.push(t);const n=new Event("addstream");n.stream=t,e.dispatchEvent(n)}))}),t.apply(e,arguments)}}}function Cd(e){if("object"!=typeof e||!e.RTCPeerConnection)return;const t=e.RTCPeerConnection.prototype,n=t.createOffer,i=t.createAnswer,r=t.setLocalDescription,o=t.setRemoteDescription,s=t.addIceCandidate;t.createOffer=function(e,t){const i=arguments.length>=2?arguments[2]:arguments[0],r=n.apply(this,[i]);return t?(r.then(e,t),Promise.resolve()):r},t.createAnswer=function(e,t){const n=arguments.length>=2?arguments[2]:arguments[0],r=i.apply(this,[n]);return t?(r.then(e,t),Promise.resolve()):r};let a=function(e,t,n){const i=r.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i};t.setLocalDescription=a,a=function(e,t,n){const i=o.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i},t.setRemoteDescription=a,a=function(e,t,n){const i=s.apply(this,[e]);return n?(i.then(t,n),Promise.resolve()):i},t.addIceCandidate=a}function xd(e){const t=e&&e.navigator;if(t.mediaDevices&&t.mediaDevices.getUserMedia){const e=t.mediaDevices,n=e.getUserMedia.bind(e);t.mediaDevices.getUserMedia=e=>n(Rd(e))}!t.getUserMedia&&t.mediaDevices&&t.mediaDevices.getUserMedia&&(t.getUserMedia=function(e,n,i){t.mediaDevices.getUserMedia(e).then(n,i)}.bind(t))}function Rd(e){return e&&void 0!==e.video?Object.assign({},e,{video:Wa(e.video)}):e}function Ad(e){if(!e.RTCPeerConnection)return;const t=e.RTCPeerConnection;e.RTCPeerConnection=function(e,n){if(e&&e.iceServers){const t=[];for(let n=0;n<e.iceServers.length;n++){let i=e.iceServers[n];!i.hasOwnProperty("urls")&&i.hasOwnProperty("url")?(za("RTCIceServer.url","RTCIceServer.urls"),i=JSON.parse(JSON.stringify(i)),i.urls=i.url,delete i.url,t.push(i)):t.push(e.iceServers[n])}e.iceServers=t}return new t(e,n)},e.RTCPeerConnection.prototype=t.prototype,"generateCertificate"in t&&Object.defineProperty(e.RTCPeerConnection,"generateCertificate",{get:()=>t.generateCertificate})}function wd(e){"object"==typeof e&&e.RTCTrackEvent&&"receiver"in e.RTCTrackEvent.prototype&&!("transceiver"in e.RTCTrackEvent.prototype)&&Object.defineProperty(e.RTCTrackEvent.prototype,"transceiver",{get(){return{receiver:this.receiver}}})}function Id(e){const t=e.RTCPeerConnection.prototype.createOffer;e.RTCPeerConnection.prototype.createOffer=function(e){if(e){void 0!==e.offerToReceiveAudio&&(e.offerToReceiveAudio=!!e.offerToReceiveAudio);const t=this.getTransceivers().find((e=>"audio"===e.receiver.track.kind));!1===e.offerToReceiveAudio&&t?"sendrecv"===t.direction?t.setDirection?t.setDirection("sendonly"):t.direction="sendonly":"recvonly"===t.direction&&(t.setDirection?t.setDirection("inactive"):t.direction="inactive"):!0!==e.offerToReceiveAudio||t||this.addTransceiver("audio",{direction:"recvonly"}),void 0!==e.offerToReceiveVideo&&(e.offerToReceiveVideo=!!e.offerToReceiveVideo);const n=this.getTransceivers().find((e=>"video"===e.receiver.track.kind));!1===e.offerToReceiveVideo&&n?"sendrecv"===n.direction?n.setDirection?n.setDirection("sendonly"):n.direction="sendonly":"recvonly"===n.direction&&(n.setDirection?n.setDirection("inactive"):n.direction="inactive"):!0!==e.offerToReceiveVideo||n||this.addTransceiver("video",{direction:"recvonly"})}return t.apply(this,arguments)}}function Pd(e){"object"!=typeof e||e.AudioContext||(e.AudioContext=e.webkitAudioContext)}function Dd(e){if(!e.RTCIceCandidate||e.RTCIceCandidate&&"foundation"in e.RTCIceCandidate.prototype)return;const t=e.RTCIceCandidate;e.RTCIceCandidate=function(e){if("object"==typeof e&&e.candidate&&0===e.candidate.indexOf("a=")&&((e=JSON.parse(JSON.stringify(e))).candidate=e.candidate.substr(2)),e.candidate&&e.candidate.length){const n=new t(e),i=Wn().parseCandidate(e.candidate),r=Object.assign(n,i);return r.toJSON=function(){return{candidate:r.candidate,sdpMid:r.sdpMid,sdpMLineIndex:r.sdpMLineIndex,usernameFragment:r.usernameFragment}},r}return new t(e)},e.RTCIceCandidate.prototype=t.prototype,Ja(e,"icecandidate",(t=>(t.candidate&&Object.defineProperty(t,"candidate",{value:new e.RTCIceCandidate(t.candidate),writable:"false"}),t)))}function Od(e,t){if(!e.RTCPeerConnection)return;"sctp"in e.RTCPeerConnection.prototype||Object.defineProperty(e.RTCPeerConnection.prototype,"sctp",{get(){return void 0===this._sctp?null:this._sctp}});const n=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(){if(this._sctp=null,"chrome"===t.browser&&t.version>=76){const{sdpSemantics:e}=this.getConfiguration();"plan-b"===e&&Object.defineProperty(this,"sctp",{get(){return void 0===this._sctp?null:this._sctp},enumerable:!0,configurable:!0})}if(function(e){if(!e||!e.sdp)return!1;const t=Wn().splitSections(e.sdp);return t.shift(),t.some((e=>{const t=Wn().parseMLine(e);return t&&"application"===t.kind&&-1!==t.protocol.indexOf("SCTP")}))}(arguments[0])){const e=function(e){const t=e.sdp.match(/mozilla...THIS_IS_SDPARTA-(\\d+)/);if(null===t||t.length<2)return-1;const n=parseInt(t[1],10);return n!=n?-1:n}(arguments[0]),n=function(e){let n=65536;return"firefox"===t.browser&&(n=t.version<57?-1===e?16384:2147483637:t.version<60?57===t.version?65535:65536:2147483637),n}(e),i=function(e,n){let i=65536;"firefox"===t.browser&&57===t.version&&(i=65535);const r=Wn().matchPrefix(e.sdp,"a=max-message-size:");return r.length>0?i=parseInt(r[0].substr(19),10):"firefox"===t.browser&&-1!==n&&(i=2147483637),i}(arguments[0],e);let r;r=0===n&&0===i?Number.POSITIVE_INFINITY:0===n||0===i?Math.max(n,i):Math.min(n,i);const o={};Object.defineProperty(o,"maxMessageSize",{get:()=>r}),this._sctp=o}return n.apply(this,arguments)}}function kd(e){if(!e.RTCPeerConnection||!("createDataChannel"in e.RTCPeerConnection.prototype))return;function t(e,t){const n=e.send;e.send=function(){const i=arguments[0],r=i.length||i.size||i.byteLength;if("open"===e.readyState&&t.sctp&&r>t.sctp.maxMessageSize)throw new TypeError("Message too large (can send a maximum of "+t.sctp.maxMessageSize+" bytes)");return n.apply(e,arguments)}}const n=e.RTCPeerConnection.prototype.createDataChannel;e.RTCPeerConnection.prototype.createDataChannel=function(){const e=n.apply(this,arguments);return t(e,this),e},Ja(e,"datachannel",(e=>(t(e.channel,e.target),e)))}function Nd(e){if(!e.RTCPeerConnection||"connectionState"in e.RTCPeerConnection.prototype)return;const t=e.RTCPeerConnection.prototype;Object.defineProperty(t,"connectionState",{get(){return{completed:"connected",checking:"connecting"}[this.iceConnectionState]||this.iceConnectionState},enumerable:!0,configurable:!0}),Object.defineProperty(t,"onconnectionstatechange",{get(){return this._onconnectionstatechange||null},set(e){this._onconnectionstatechange&&(this.removeEventListener("connectionstatechange",this._onconnectionstatechange),delete this._onconnectionstatechange),e&&this.addEventListener("connectionstatechange",this._onconnectionstatechange=e)},enumerable:!0,configurable:!0}),["setLocalDescription","setRemoteDescription"].forEach((e=>{const n=t[e];t[e]=function(){return this._connectionstatechangepoly||(this._connectionstatechangepoly=e=>{const t=e.target;if(t._lastConnectionState!==t.connectionState){t._lastConnectionState=t.connectionState;const n=new Event("connectionstatechange",e);t.dispatchEvent(n)}return e},this.addEventListener("iceconnectionstatechange",this._connectionstatechangepoly)),n.apply(this,arguments)}}))}function Md(e,t){if(!e.RTCPeerConnection)return;if("chrome"===t.browser&&t.version>=71)return;if("safari"===t.browser&&t.version>=605)return;const n=e.RTCPeerConnection.prototype.setRemoteDescription;e.RTCPeerConnection.prototype.setRemoteDescription=function(t){if(t&&t.sdp&&-1!==t.sdp.indexOf("\\na=extmap-allow-mixed")){const n=t.sdp.split("\\n").filter((e=>"a=extmap-allow-mixed"!==e.trim())).join("\\n");e.RTCSessionDescription&&t instanceof e.RTCSessionDescription?arguments[0]=new e.RTCSessionDescription({type:t.type,sdp:n}):t.sdp=n}return n.apply(this,arguments)}}function Ld(e,t){if(!e.RTCPeerConnection||!e.RTCPeerConnection.prototype)return;const n=e.RTCPeerConnection.prototype.addIceCandidate;n&&0!==n.length&&(e.RTCPeerConnection.prototype.addIceCandidate=function(){return arguments[0]?("chrome"===t.browser&&t.version<78||"firefox"===t.browser&&t.version<68||"safari"===t.browser)&&arguments[0]&&""===arguments[0].candidate?Promise.resolve():n.apply(this,arguments):(arguments[1]&&arguments[1].apply(null),Promise.resolve())})}function Fd(e,t){if(!e.RTCPeerConnection||!e.RTCPeerConnection.prototype)return;const n=e.RTCPeerConnection.prototype.setLocalDescription;n&&0!==n.length&&(e.RTCPeerConnection.prototype.setLocalDescription=function(){let e=arguments[0]||{};if("object"!=typeof e||e.type&&e.sdp)return n.apply(this,arguments);if(e={type:e.type,sdp:e.sdp},!e.type)switch(this.signalingState){case"stable":case"have-local-offer":case"have-remote-pranswer":e.type="offer";break;default:e.type="answer"}return e.sdp||"offer"!==e.type&&"answer"!==e.type?n.apply(this,[e]):("offer"===e.type?this.createOffer:this.createAnswer).apply(this).then((e=>n.apply(this,[e])))})}!function(){let{window:e}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{shimChrome:!0,shimFirefox:!0,shimSafari:!0};const n=Ga,i=function(e){const t={browser:null,version:null};if(void 0===e||!e.navigator)return t.browser="Not a browser.",t;const{navigator:n}=e;if(n.mozGetUserMedia)t.browser="firefox",t.version=$a(n.userAgent,/Firefox\\/(\\d+)\\./,1);else if(n.webkitGetUserMedia||!1===e.isSecureContext&&e.webkitRTCPeerConnection&&!e.RTCIceGatherer)t.browser="chrome",t.version=$a(n.userAgent,/Chrom(e|ium)\\/(\\d+)\\./,2);else{if(!e.RTCPeerConnection||!n.userAgent.match(/AppleWebKit\\/(\\d+)\\./))return t.browser="Not a supported browser.",t;t.browser="safari",t.version=$a(n.userAgent,/AppleWebKit\\/(\\d+)\\./,1),t.supportsUnifiedPlan=e.RTCRtpTransceiver&&"currentDirection"in e.RTCRtpTransceiver.prototype}return t}(e),r={browserDetails:i,commonShim:m,extractVersion:$a,disableLog:Ba,disableWarnings:qa,sdp:Kn};switch(i.browser){case"chrome":if(!h||!dd||!t.shimChrome)return n("Chrome shim is not included in this adapter release."),r;if(null===i.version)return n("Chrome shim can not determine version, not shimming."),r;n("adapter.js shimming chrome."),r.browserShim=h,Ld(e,i),Fd(e),Za(e,i),td(e),dd(e,i),nd(e),ad(e,i),id(e),rd(e),od(e),cd(e,i),Dd(e),Nd(e),Od(e,i),kd(e),Md(e,i);break;case"firefox":if(!u||!pd||!t.shimFirefox)return n("Firefox shim is not included in this adapter release."),r;n("adapter.js shimming firefox."),r.browserShim=u,Ld(e,i),Fd(e),ld(e,i),pd(e,i),ud(e),fd(e),md(e),gd(e),vd(e),_d(e),Ed(e),yd(e),Sd(e),Dd(e),Nd(e),Od(e,i),kd(e);break;case"safari":if(!p||!t.shimSafari)return n("Safari shim is not included in this adapter release."),r;n("adapter.js shimming safari."),r.browserShim=p,Ld(e,i),Fd(e),Ad(e),Id(e),Cd(e),bd(e),Td(e),wd(e),xd(e),Pd(e),Dd(e),Od(e,i),kd(e),Md(e,i);break;default:n("Unsupported browser!")}}({window:"undefined"==typeof window?void 0:window});var jd=n(125),Vd=n.n(jd);const Ud=(0,y.getLogger)("modules/RTC/RTCUtils.js"),Hd={video:{height:{ideal:720,max:720,min:180},width:{ideal:1280,max:1280,min:320}}};let $d="default",Jd=!1,Bd=!1,qd=!1,Gd=!1,zd=!1,Kd=null;const Wd=document.createElement("audio"),Xd=void 0!==Wd.setSinkId;let Yd,Qd=[];function Zd(){}function ec(e){const t=e.filter((e=>"audioinput"===e.kind)).length,n=e.filter((e=>"audiooutput"===e.kind)).length,i=e.filter((e=>"videoinput"===e.kind)).length,r=e.filter((e=>"videooutput"===e.kind)).length;e.forEach((e=>{const o={audio_input_device_count:t,audio_output_device_count:n,video_input_device_count:i,video_output_device_count:r,device_id:e.deviceId,device_group_id:e.groupId,device_kind:e.kind,device_label:e.label};Mi.sendAnalytics(Wt,o)}))}const tc=new class extends xr{init(){var e;let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};var n;"boolean"==typeof t.disableAEC&&(qd=t.disableAEC,Ud.info(`Disable AEC: ${qd}`)),"boolean"==typeof t.disableNS&&(Gd=t.disableNS,Ud.info(`Disable NS: ${Gd}`)),"boolean"==typeof t.disableAP&&(Bd=t.disableAP,Ud.info(`Disable AP: ${Bd}`)),"boolean"==typeof t.disableAGC&&(zd=t.disableAGC,Ud.info(`Disable AGC: ${zd}`)),"boolean"==typeof(null===(e=t.audioQuality)||void 0===e?void 0:e.stereo)&&(Kd=t.audioQuality.stereo,Ud.info(`Stereo: ${Kd}`)),window.clearInterval(Yd),Yd=void 0,ci.isReactNative()||(this.attachMediaStream=(n=(e,t)=>{e&&(e.srcObject=t)},function(e,t){return n.apply(tc,arguments),t&&tc.isDeviceChangeAvailable("output")&&t.getAudioTracks&&t.getAudioTracks().length&&Jd?e.setSinkId(tc.getAudioOutputDevice()).catch((t=>{const n=new dr(t,null,["audiooutput"]);throw Ud.warn("Failed to set audio output device for the element. Default audio output device will be used instead",null==e?void 0:e.id,n),n})):Promise.resolve()})),this.pcConstraints={},Is.init(t),this.isDeviceListAvailable()&&this.enumerateDevices((e=>{Qd=e.slice(0),Ud.debug("Available devices: ",Qd),ec(Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_AVAILABLE,Qd),ci.supportsDeviceChangeEvent()?navigator.mediaDevices.addEventListener("devicechange",(()=>this.enumerateDevices(Zd))):Yd=window.setInterval((()=>this.enumerateDevices(Zd)),3e3)}))}enumerateDevices(e){navigator.mediaDevices.enumerateDevices().then((t=>{this._updateKnownDevices(t),e(t)})).catch((t=>{Ud.warn(`Failed to  enumerate devices. ${t}`),this._updateKnownDevices([]),e([])}))}_getUserMedia(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return new Promise(((i,r)=>{let o,s=!1;"number"==typeof n&&!isNaN(n)&&n>0&&(o=setTimeout((()=>{s=!0,o=void 0,r(new dr(er))}),n)),navigator.mediaDevices.getUserMedia(t).then((t=>{Ud.log("onUserMediaSuccess"),this._updateGrantedPermissions(e,t),s||(void 0!==o&&clearTimeout(o),i(t))})).catch((n=>{Ud.warn(`Failed to get access to local media. ${n} ${JSON.stringify(t)}`);const i=new dr(n,t,e);s||(void 0!==o&&clearTimeout(o),r(i)),i.name===Yi&&this._updateGrantedPermissions(e,void 0)}))}))}_getDesktopMedia(e){return Is.isSupported()?new Promise(((t,n)=>{Is.obtainStream((e=>{t(e)}),(e=>{n(e)}),e)})):Promise.reject(new Error("Desktop sharing is not supported!"))}_getMissingTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0;const n=[],i=e.includes("audio"),r=t&&t.getAudioTracks().length>0;i&&!r&&n.push("audio");const o=e.includes("video"),s=t&&t.getVideoTracks().length>0;return o&&!s&&n.push("video"),n}_onMediaDevicesListChanged(e){Qd=e.slice(0),Ud.info("list of media devices has changed:",Qd),ec(Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_WILL_CHANGE,Qd),this.eventEmitter.emit(ji.default.DEVICE_LIST_CHANGED,Qd)}_updateKnownDevices(e){(function(e){return e.length!==Qd.length||e.map(t).sort().join("")!==Qd.map(t).sort().join("");function t(e){return JSON.stringify({kind:e.kind,deviceId:e.deviceId,groupId:e.groupId,label:e.label,facing:e.facing})}})(e)&&this._onMediaDevicesListChanged(e)}_updateGrantedPermissions(e,t){const n=Boolean(t)&&t.getAudioTracks().length>0,i=Boolean(t)&&t.getVideoTracks().length>0,r={};-1!==e.indexOf("video")&&(r.video=i),-1!==e.indexOf("audio")&&(r.audio=n),this.eventEmitter.emit(ji.default.PERMISSIONS_CHANGED,r)}obtainAudioAndVideoPermissions(e){const{timeout:t,...n}=e,i=[];let r={};const o=function(){if(-1===(n.devices||[]).indexOf("desktop"))return Promise.resolve();const{desktopSharingSourceDevice:e,desktopSharingSources:i}=n;if(e){const n=Qd&&Qd.find((t=>"videoinput"===t.kind&&(t.deviceId===e||t.label===e)));if(!n)return Promise.reject(new dr({name:"ConstraintNotSatisfiedError"},{},[e]));const i=["video"],r={video:{deviceId:n.deviceId}};return this._getUserMedia(i,r,t).then((e=>({sourceType:"device",stream:e})))}return this._getDesktopMedia({desktopSharingSources:i})}.bind(this),s=function(){const e=(n.devices||["audio","video"]).filter((e=>"audio"===e||"video"===e));return e.length?(r=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};const n=Ss()(t.constraints||Hd);if(e.indexOf("video")>=0){if(Vd()[t.resolution]){const e=Vd()[t.resolution];n.video.height={ideal:e.height},n.video.width={ideal:e.width}}if(n.video||(n.video={}),ci.isWebKitBased()&&(n.video.height&&n.video.height.ideal?n.video.height={ideal:n.video.height.ideal}:Ud.warn("Ideal camera height missing, camera may not start properly"),n.video.width&&n.video.width.ideal?n.video.width={ideal:n.video.width.ideal}:Ud.warn("Ideal camera width missing, camera may not start properly")),t.cameraDeviceId)n.video.deviceId={exact:t.cameraDeviceId};else{const e=t.facingMode||Va.USER;n.video.facingMode=e}}else n.video=!1;return e.indexOf("audio")>=0?(n.audio&&"boolean"!=typeof n.audio||(n.audio={}),n.audio={autoGainControl:!zd&&!Bd,echoCancellation:!qd&&!Bd,noiseSuppression:!Gd&&!Bd},t.micDeviceId&&(n.audio.deviceId={exact:t.micDeviceId}),Kd&&Object.assign(n.audio,{channelCount:2})):n.audio=!1,n}(e,n),Ud.info("Got media constraints: ",JSON.stringify(r)),this._getUserMedia(e,r,t)):Promise.resolve()}.bind(this);return o().then((function(e){if(!e)return;const{stream:t,sourceId:n,sourceType:r}=e,o=t.getAudioTracks();if(o.length){const e=new MediaStream(o);i.push({stream:e,sourceId:n,sourceType:r,track:e.getAudioTracks()[0]})}const s=t.getVideoTracks();if(s.length){const e=new MediaStream(s);i.push({stream:e,sourceId:n,sourceType:r,track:e.getVideoTracks()[0],videoType:Qo.VideoType.DESKTOP})}})).then(s).then((function(e){if(!e)return;const t=e.getAudioTracks();if(t.length){const e=new MediaStream(t);i.push({constraints:r.audio,stream:e,track:e.getAudioTracks()[0],effects:n.effects})}const o=e.getVideoTracks();if(o.length){const e=new MediaStream(o);i.push({constraints:r.video,stream:e,track:e.getVideoTracks()[0],videoType:Qo.VideoType.CAMERA,effects:n.effects})}})).then((()=>i)).catch((e=>(i.forEach((e=>{let{stream:t}=e;this.stopMediaStream(t)})),Promise.reject(e))))}isDeviceListAvailable(){return Boolean(navigator.mediaDevices&&navigator.mediaDevices.enumerateDevices)}isDeviceChangeAvailable(e){return"output"!==e&&"audiooutput"!==e||Xd}stopMediaStream(e){e&&(e.getTracks().forEach((e=>{e.stop&&e.stop()})),e.stop&&e.stop(),e.release&&e.release())}isDesktopSharingEnabled(){return Is.isSupported()}setAudioOutputDevice(e){return this.isDeviceChangeAvailable("output")?Wd.setSinkId(e).then((()=>{$d=e,Jd=!0,Ud.log(`Audio output device set to ${e}`),this.eventEmitter.emit(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,e)})):Promise.reject(new Error("Audio output device change is not supported"))}setDesktopSharingFrameRate(e){Is.setDesktopSharingFrameRate(e)}getAudioOutputDevice(){return $d}getCurrentlyAvailableMediaDevices(){return Qd}arePermissionsGrantedForAvailableDevices(){return Qd.some((e=>Boolean(e.label)))}getEventDataForActiveDevice(e){const t=[],n={deviceId:e.deviceId,kind:e.kind,label:e.label,groupId:e.groupId};return t.push(n),{deviceList:t}}isUserStreamById(e){return e&&"mixedmslabel"!==e&&"default"!==e}},nc=tc,ic=(0,y.getLogger)("modules/RTC/JitsiTrack.js"),rc={track_mute:"onmute",track_unmute:"onunmute",track_ended:"onended"};class oc extends ii{constructor(e,t,n,i,r,o){super(),this.containers=[],this.conference=e,this.audioLevel=-1,this.type=r,this.track=n,this.videoType=o,this.handlers=new Map,this.disposed=!1,this._streamInactiveHandler=i,this._setStream(t)}_addMediaStreamInactiveHandler(e){ci.isFirefox()||ci.isWebKitBased()?this.track.onended=e:this.stream.oninactive=e}_attachTTFMTracker(e){}_onTrackAttach(e){}_onTrackDetach(e){}_setHandler(e,t){if(rc.hasOwnProperty(e)){if(t?this.handlers.set(e,t):this.handlers.delete(e),this.stream)for(const n of this.stream.getTracks())n[rc[e]]=t}else ic.error(`Invalid handler type ${e}`)}_setStream(e){if(this.stream!==e&&(this.stream=e,this.stream)){for(const e of this.handlers.keys())this._setHandler(e,this.handlers.get(e));this._streamInactiveHandler&&this._addMediaStreamInactiveHandler(this._streamInactiveHandler)}}_unregisterHandlers(){if(this.stream){for(const e of this.handlers.keys())for(const t of this.stream.getVideoTracks())t[rc[e]]=void 0;this._streamInactiveHandler&&this._addMediaStreamInactiveHandler(void 0)}else ic.warn(`${this}: unable to unregister handlers - no stream object`)}attach(e){let t=Promise.resolve();return this.stream&&(this._onTrackAttach(e),t=nc.attachMediaStream(e,this.stream)),this.containers.push(e),this._attachTTFMTracker(e),t}detach(e){for(let t=this.containers,n=t.length-1;n>=0;--n){const i=t[n];e||(this._onTrackDetach(i),nc.attachMediaStream(i,null).catch((()=>{ic.error(`Detach for ${this} failed!`)}))),e&&i!==e||t.splice(n,1)}e&&(this._onTrackDetach(e),nc.attachMediaStream(e,null).catch((()=>{ic.error(`Detach for ${this} failed!`)})))}dispose(){return this.removeAllListeners(),this.disposed=!0,Promise.resolve()}getId(){return this.getStreamId()}getOriginalStream(){return this.stream}getSourceName(){}getStreamId(){return this.stream?this.stream.id:null}getTrack(){return this.track}getTrackLabel(){return this.track.label}getTrackId(){return this.track?this.track.id:null}getType(){return this.type}getUsageLabel(){return this.isAudioTrack()?"mic":this.videoType?this.videoType:"default"}getVideoType(){return this.videoType}getHeight(){return Math.min(this.track.getSettings().height,this.track.getSettings().width)}getWidth(){return Math.max(this.track.getSettings().height,this.track.getSettings().width)}isActive(){return void 0===this.stream.active||this.stream.active}isAudioTrack(){return this.getType()===Ri.AUDIO}isLocal(){throw new Error("Not implemented by subclass")}isLocalAudioTrack(){return this.isAudioTrack()&&this.isLocal()}isVideoTrack(){return this.getType()===Ri.VIDEO}isWebRTCTrackMuted(){return this.track&&this.track.muted}setAudioLevel(e,t){let n=e;ci.supportsReceiverStats()&&void 0!==t&&this.isMuted()&&(n=0),this.audioLevel!==n?(this.audioLevel=n,this.emit(Ct,n,t)):0===this.audioLevel&&0===n&&this.isLocal()&&!this.isWebRTCTrackMuted()&&this.emit(It,n)}setAudioOutput(e){return nc.isDeviceChangeAvailable("output")?this.isVideoTrack()?Promise.resolve():Promise.all(this.containers.map((t=>t.setSinkId(e).catch((e=>{throw ic.warn("Failed to change audio output device on element. Default or previously set audio output device will be used.",t,e),e}))))).then((()=>{this.emit(xt,e)})):Promise.reject(new Error("Audio output device change is not supported"))}setSourceName(e){}}const sc=(0,y.getLogger)("modules/RTC/JitsiLocalTrack.js");class ac extends oc{constructor(e){let{constraints:t,deviceId:n,facingMode:i,mediaType:r,rtcId:o,sourceId:s,sourceType:a,stream:d,track:c,videoType:l,effects:h=[]}=e;super(null,d,c,(()=>this.emit(Tt,this)),r,l),this._setEffectInProgress=!1;const u=h.find((e=>e.isEnabled(this)));u&&this._startStreamEffect(u);const p=l===Qo.VideoType.DESKTOP?c.getSettings().displaySurface:null;var m;this.metadata={timestamp:Date.now(),...p?{displaySurface:p}:{}},this.rtcId=o,this.sourceId=s,this.sourceType=null!=a?a:p,this._constraints=c.getConstraints(),r===Ri.VIDEO&&(l===Qo.VideoType.CAMERA&&(Object.keys(this._constraints).length||(this._constraints={height:{ideal:this.getHeight()},width:{ideal:this.getWidth()}}),isNaN(this._constraints.height.ideal)&&isNaN(this._constraints.width.ideal)&&(this._constraints.height={ideal:t.height.ideal},this._constraints.width={ideal:t.width.ideal})),this.resolution=this.getHeight(),isNaN(this.resolution)&&null!==(m=this._constraints.height)&&void 0!==m&&m.ideal&&(this.resolution=this._constraints.height.ideal),this.maxEnabledResolution=this.resolution),this.deviceId=n,this._prevSetMuted=Promise.resolve(),this._facingMode=i,this._trackEnded=!1,this._hasSentData=!1,this._testDataSent=!0,this._realDeviceId=""===this.deviceId?void 0:this.deviceId,this._sourceName=null,this._trackMutedTS=0,this._onDeviceListWillChange=e=>{const t=this._realDeviceId;this._setRealDeviceIdFromDeviceList(e),(void 0===this.getTrack().readyState&&void 0!==this._realDeviceId&&!e.find((e=>e.deviceId===this._realDeviceId))||void 0!==t&&void 0===this._realDeviceId)&&(this._trackEnded=!0)},this.isAudioTrack()&&nc.isDeviceChangeAvailable("output")&&(this._onAudioOutputDeviceChanged=this.setAudioOutput.bind(this),nc.addListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._onAudioOutputDeviceChanged)),nc.addListener(ji.default.DEVICE_LIST_WILL_CHANGE,this._onDeviceListWillChange),this._initNoDataFromSourceHandlers()}_addStreamToConferenceAsUnmute(){return this.conference?new Promise(((e,t)=>{this.conference._addLocalTrackToPc(this).then(e,(e=>t(new Error(e))))})):Promise.resolve()}_fireNoDataFromSourceEvent(){const e=!this.isReceivingData();this.emit(wt,e),sc.debug(`NO_DATA_FROM_SOURCE event with value ${e} detected for track: ${this}`),Mi.sendAnalytics(((e,t)=>({attributes:{media_type:e,value:t},action:"track.no.data.from.source",type:kt.TYPE_OPERATIONAL}))(this.getType(),e))}_initNoDataFromSourceHandlers(){this._isNoDataFromSourceEventsEnabled()&&(this._setHandler("track_mute",(()=>{this._trackMutedTS=window.performance.now(),this._fireNoDataFromSourceEvent()})),this._setHandler("track_unmute",(()=>{this._fireNoDataFromSourceEvent(),Mi.sendAnalyticsAndLog(nn,{media_type:this.getType(),track_type:"local",value:window.performance.now()-this._trackMutedTS})})),this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA&&this._setHandler("track_ended",(()=>{this.isReceivingData()||this._fireNoDataFromSourceEvent()})))}_isNoDataFromSourceEventsEnabled(){return!this.isVideoTrack()||this.videoType!==Qo.VideoType.DESKTOP}_queueSetMuted(e){const t=this._setMuted.bind(this,e);return this._prevSetMuted=this._prevSetMuted.then(t,t),this._prevSetMuted}_removeStreamFromConferenceAsMute(e,t){this.conference?this.conference._removeLocalTrackFromPc(this).then(e,(e=>t(new Error(e)))):e()}_sendMuteStatus(e){this.conference&&this.conference._setTrackMuteStatus(this.getType(),this,e)&&this.conference.room.sendPresence()}_setMuted(e){if(this.isMuted()===e&&this.videoType!==Qo.VideoType.DESKTOP)return Promise.resolve();if(this.disposed)return Promise.reject(new dr(tr));let t=Promise.resolve();const n=()=>sc.info(`Mute ${this}: ${e}`),i=ci.isReactNative()?this.videoType===Qo.VideoType.DESKTOP:ci.doesVideoMuteByStreamRemove();if(this.isAudioTrack()||!i)n(),this._streamEffect&&this._streamEffect.setMuted?this._streamEffect.setMuted(e):this.track&&(this.track.enabled=!e);else if(e)t=new Promise(((e,t)=>{n(),this._removeStreamFromConferenceAsMute((()=>{this._streamEffect&&this._stopStreamEffect(),this._unregisterHandlers(),this.stopStream(),this._setStream(null),e()}),t)}));else{n();const e={cameraDeviceId:this.getDeviceId(),devices:[Ri.VIDEO],effects:this._streamEffect?[this._streamEffect]:[],facingMode:this.getCameraFacingMode()};t=nc.obtainAudioAndVideoPermissions(Object.assign({},e,{constraints:{video:this._constraints}})),t=t.then((e=>{const t=e.find((e=>e.track.kind===this.getType()));if(!t)throw new dr(nr);return this._setStream(t.stream),this.track=t.track,this.videoType!==t.videoType&&(sc.warn(`${this}: video type has changed after unmute!`,this.videoType,t.videoType),this.videoType=t.videoType),this._streamEffect&&this._startStreamEffect(this._streamEffect),this.containers.map((e=>nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} on video unmute!`)})))),this._addStreamToConferenceAsUnmute()}))}return t.then((()=>{this._sendMuteStatus(e),this.isVideoTrack()&&this.conference&&this.conference._sendBridgeVideoTypeMessage(this),this.emit(Rt,this)}))}_setRealDeviceIdFromDeviceList(e){const t=this.getTrack(),n=`${t.kind}input`;let i=e.find((e=>e.kind===n&&e.label===t.label&&e.deviceId===this.deviceId));if(!i&&"default"===this._realDeviceId){const r=(t.label||"").replace("Default - ","");i=e.find((e=>e.kind===n&&e.label===r))}this._realDeviceId=i?i.deviceId:void 0}_setStream(e){super._setStream(e)}_startStreamEffect(e){this._streamEffect=e,this._originalStream=this.stream,this._setStream(this._streamEffect.startEffect(this._originalStream)),this.track=this.stream.getTracks()[0]}_stopStreamEffect(){this._streamEffect&&(this._streamEffect.stopEffect(),this._setStream(this._originalStream),this._originalStream=null,this.track=this.stream?this.stream.getTracks()[0]:null)}_switchCamera(){this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA&&"function"==typeof this.track._switchCamera&&(this.track._switchCamera(),this._facingMode=this._facingMode===Va.ENVIRONMENT?Va.USER:Va.ENVIRONMENT)}_switchStreamEffect(e){this._streamEffect&&(this._stopStreamEffect(),this._streamEffect=void 0),e&&this._startStreamEffect(e)}async dispose(){return this._streamEffect&&await this.setEffect(),this.conference&&await this.conference.removeTrack(this),this.stream&&(this.stopStream(),this.detach()),nc.removeListener(ji.default.DEVICE_LIST_WILL_CHANGE,this._onDeviceListWillChange),this._onAudioOutputDeviceChanged&&nc.removeListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._onAudioOutputDeviceChanged),super.dispose()}getCameraFacingMode(){if(this.isVideoTrack()&&this.videoType===Qo.VideoType.CAMERA){var e,t;const n=null===(e=(t=this.track).getSettings)||void 0===e?void 0:e.call(t);return n&&"facingMode"in n?n.facingMode:void 0!==this._facingMode?this._facingMode:Va.USER}}getCaptureResolution(){return this.videoType!==Qo.VideoType.CAMERA&&ci.isWebKitBased()?this.getHeight():this.resolution}getDeviceId(){return this._realDeviceId||this.deviceId}getDuration(){return Date.now()/1e3-this.metadata.timestamp/1e3}getParticipantId(){return this.conference&&this.conference.myUserId()}getSourceName(){return this._sourceName}isEnded(){return this.isVideoTrack()&&this.isMuted()?this._trackEnded:"ended"===this.getTrack().readyState||this._trackEnded}isLocal(){return!0}isMuted(){return!this.stream||!(!this.isVideoTrack()||this.isActive())||(this._streamEffect&&this._streamEffect.isMuted?this._streamEffect.isMuted():!this.track||!this.track.enabled)}isReceivingData(){return!(!this.isVideoTrack()||!this.isMuted()&&!this._stopStreamInProgress&&this.videoType!==Qo.VideoType.DESKTOP)||!!this.stream&&(this._effectEnabled?this._originalStream:this.stream).getTracks().some((e=>!("readyState"in e&&"live"!==e.readyState||"muted"in e&&!0===e.muted)))}mute(){return this._queueSetMuted(!0)}onByteSentStatsReceived(e,t){t>0&&(this._hasSentData=!0);const n=e.getConnectionState();this._testDataSent&&"connected"===n&&(setTimeout((()=>{this._hasSentData||(sc.warn(`${this} \'bytes sent\' <= 0:                         ${t}`),Mi.analytics.sendEvent(tn,{media_type:this.getType()}))}),3e3),this._testDataSent=!1)}setConference(e){this.conference=e}setEffect(e){if(void 0===this._streamEffect&&void 0===e)return Promise.resolve();if(void 0!==e&&!e.isEnabled(this))return Promise.reject(new Error("Incompatible effect instance!"));if(!0===this._setEffectInProgress)return Promise.reject(new Error("setEffect already in progress!"));if(this.isMuted()&&!this.isAudioTrack())return this._streamEffect=e,Promise.resolve();const t=this.conference;return t?(this._setEffectInProgress=!0,t._removeLocalTrackFromPc(this).then((()=>(this._switchStreamEffect(e),this.isVideoTrack()&&this.containers.forEach((e=>{nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} when trying to set effect.`)}))})),t._addLocalTrackToPc(this)))).then((()=>{this._setEffectInProgress=!1})).catch((e=>{throw this._setEffectInProgress=!1,this._switchStreamEffect(),sc.error("Failed to switch to the new stream!",e),e}))):(this._switchStreamEffect(e),this.isVideoTrack()&&this.containers.forEach((e=>{nc.attachMediaStream(e,this.stream).catch((()=>{sc.error(`Attach media failed for ${this} when trying to set effect.`)}))})),Promise.resolve())}setSourceName(e){this._sourceName=e}stopStream(){this._stopStreamInProgress=!0;try{nc.stopMediaStream(this.stream)}finally{this._stopStreamInProgress=!1}}toString(){return`LocalTrack[${this.rtcId},${this.getType()}]`}unmute(){return this._queueSetMuted(!1)}}var dc=n(561);const cc=function(e,t){return void 0!==e&&void 0!==e.media&&Array.isArray(e.media)&&e.media.forEach((e=>{e.sources&&e.sources.length&&(e.ssrcs=[],e.sources.forEach((t=>{Object.keys(t).forEach((n=>{"id"!==n&&e.ssrcs.push({id:t.id,attribute:n,value:t[n]})}))})),delete e.sources),e.ssrcGroups&&e.ssrcGroups.length&&e.ssrcGroups.forEach((e=>{void 0!==e.ssrcs&&Array.isArray(e.ssrcs)&&(e.ssrcs=e.ssrcs.join(" "))}))})),dc.write(e,t)},lc=function(e){const t=dc.parse(e);return void 0!==t&&void 0!==t.media&&Array.isArray(t.media)&&t.media.forEach((e=>{void 0!==e.ssrcs&&Array.isArray(e.ssrcs)&&(e.sources=[],e.ssrcs.forEach((t=>{const n=e.sources.findIndex((e=>e.id===t.id));if(n>-1)e.sources[n][t.attribute]=t.value;else{const n={id:t.id};n[t.attribute]=t.value,e.sources.push(n)}})),delete e.ssrcs),void 0!==e.ssrcGroups&&Array.isArray(e.ssrcGroups)&&e.ssrcGroups.forEach((e=>{"string"==typeof e.ssrcs&&(e.ssrcs=e.ssrcs.split(" "))}))})),t},hc=["audio","video","data"],uc=e=>e.find((e=>"SIM"===e.semantics)),pc=e=>e.find((e=>"FID"===e.semantics));function mc(e,t,n,i){if(!e||!t)return;const r=e=>i.find((t=>t.id.toString()===e));t.ssrcs.forEach((t=>{e.sources.push(r(t));const i=n[parseInt(t,10)].find((e=>"FID"===e.semantics));if(i){const n=i.ssrcs.find((e=>e!==t));e.sources.push(r(n)),e.ssrcGroups.push(i)}})),e.ssrcGroups.push(t)}function gc(e,t,n,i){if(!e||!t)return;if(e.sources=[],e.ssrcGroups=[],!n[t.id])return e.sources.push(t),void(e.msid=t.msid);const r=uc(n[t.id]),o=pc(n[t.id]);if(r)mc(e,r,n,i);else if(o){const r=o.ssrcs.find((e=>e!==t)),s=uc(n[r]);s?mc(e,s,n,i):(o.ssrcs.forEach((t=>{e.sources.push((e=>i.find((t=>t.id.toString()===e)))(t))})),e.ssrcGroups.push(o))}e.msid=e.sources[0].msid}function fc(e,t,n){if(!n.find((t=>!!t.sources&&t.sources.some((t=>t.id===e.id))))){if(!t[e.id])return!1;const i=uc(t[e.id]),r=pc(t[e.id]);return i?n.some((e=>e.sources&&e.sources.some((e=>e.id.toString()===i.ssrcs[0])))):!(!r||e.id.toString()===r.ssrcs[0])&&fc({id:r.ssrcs[0]},t,n)}return!0}class vc{toPlanB(e){if(!e||"string"!=typeof e.sdp)return console.warn("An empty description was passed as an argument."),e;const t=lc(e.sdp);if(!t.media||!t.media.length)return console.warn("The description has no media."),e;if(t.media.every((e=>-1!==hc.indexOf(e.mid))))return console.warn("The description does not look like unified plan sdp"),e;const n={},i=t.media;t.media=[],i.forEach((e=>{const t=e.type;if("application"===t)return e.mid="data",void(n[e.mid]=e);if(void 0===n[t]){const i=ys(e);i.sources&&Array.isArray(i.sources)&&i.sources.forEach((t=>{e.msid?t.msid=e.msid:delete t.msid})),i.ssrcGroups&&e.msid||(i.ssrcGroups=[]),delete i.msid,i.mid=t,n[t]=i}else if(e.msid){const i=ys(e);i.sources&&Array.isArray(i.sources)&&(i.sources.forEach((t=>{t.msid=e.msid})),n[t].sources=(n[t].sources||[]).concat(i.sources)),void 0!==i.ssrcGroups&&Array.isArray(i.ssrcGroups)&&(n[t].ssrcGroups=(n[t].ssrcGroups||[]).concat(i.ssrcGroups))}})),t.media=Object.values(n);const r=[];Object.values(n).forEach((e=>{"inactive"!==e.direction&&r.push(e.mid)})),t.groups.forEach((e=>{"BUNDLE"===e.type&&(e.mids=r.join(" "))})),t.msidSemantic={semantic:"WMS",token:"*"};const o=cc(t);return new RTCSessionDescription({type:e.type,sdp:o})}toUnifiedPlan(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;if(!e||"string"!=typeof e.sdp)return console.warn("An empty description was passed as an argument."),e;const n=lc(e.sdp);if(!n.media||!n.media.length)return console.warn("The description has no media."),e;if(n.media.length>3||n.media.every((e=>-1===hc.indexOf(e.mid))))return console.warn("The description does not look like plan-b"),e;const i=t?lc(t.sdp):null,r=function(e,t){if(!e||!t||0===e.media.length||0===t.media.length)return!1;const n=e.media[0],i=t.media[0];return n.iceUfrag!==i.iceUfrag||n.icePwd!==i.icePwd}(n,i),o=n.media[0].iceUfrag,s=n.media[0].icePwd,a=n.media[0].fingerprint,d={};n.media.forEach((e=>{const t=e.type;if("application"===t){if(!i||!i.media){const t=ys(e);return t.mid=Object.keys(d).length.toString(),void(d[e.mid]=t)}const n=i.media.findIndex((e=>e.type===t));return void(n&&(i.media[n]=e,i.media[n].mid=n))}const n=function(e){const t={};return e&&Array.isArray(e)?(e.forEach((e=>{e.ssrcs&&Array.isArray(e.ssrcs)&&e.ssrcs.forEach((n=>{void 0===t[n]&&(t[n]=[]),t[n].push(e)}))})),t):t}(e.ssrcGroups);if(e.sources)e.sources.forEach(((t,r)=>{if(!t.msid)return;if(!i||!i.media){if(fc(t,n,Object.values(d)))return;const i=ys(e);return i.mid=Object.keys(d).length.toString(),i.direction=r||"sendonly"===e.direction?"sendonly":"sendrecv",i.bundleOnly=void 0,gc(i,t,n,e.sources),void(d[i.mid]=i)}if(fc(t,n,i.media))return;const o=ys(e);o.mid=i.media.length.toString(),o.direction="sendonly",gc(o,t,n,e.sources),i.media.push(o)}));else if(!i){const t=ys(e);t.mid=Object.keys(d).length.toString(),d[e.mid]=t}})),n.media=i?i.media:Object.values(d);const c=[];n.media.forEach((e=>{c.push(e.mid),r&&(e.iceUfrag=o,e.icePwd=s,e.fingerprint=a)})),n.groups.forEach((e=>{"BUNDLE"===e.type&&(e.mids=c.join(" "))})),n.msidSemantic={semantic:"WMS",token:"*"},n.origin.sessionVersion++;const l=cc(n);return new RTCSessionDescription({type:e.type,sdp:l})}}let _c;!function(e){e.PEER_MUTED_CHANGED="signaling.peerMuted",e.PEER_VIDEO_TYPE_CHANGED="signaling.peerVideoType",e.SOURCE_MUTED_CHANGED="signaling.sourceMuted",e.SOURCE_UPDATED="signaling.sourceUpdated",e.SOURCE_VIDEO_TYPE_CHANGED="signaling.sourceVideoType"}(_c||(_c={}));const Ec=_c.PEER_MUTED_CHANGED,yc=_c.PEER_VIDEO_TYPE_CHANGED,Sc=_c.SOURCE_MUTED_CHANGED,bc=_c.SOURCE_UPDATED,Tc=_c.SOURCE_VIDEO_TYPE_CHANGED;function Cc(e,t,n){return`${e}-${t.substring(0,1)}${n}`}function xc(e){const t=e.lastIndexOf("-")+1;if(t<=0)throw new Error(`Invalid source name: ${e}`);const n=e.substr(t,1);for(const e of Object.values(Ri))if(e.substr(0,1)===n)return e;throw new Error(`Invalid source name: ${e}`)}function Rc(e){const t=e.split("-"),n=Number(t[t.length-1].substring(1));if(Number.isNaN(n))throw new Error(`Failed to parse track idx for source name: ${e}`);return n}class Ac extends xr{getPeerMediaInfo(e,t,n){throw new Error("not implemented")}getPeerSourceInfo(e,t){throw new Error("not implemented")}getSSRCOwner(e){throw new Error("not implemented")}getTrackSourceName(e){throw new Error("not implemented")}removeSSRCOwners(e){}setSSRCOwner(e,t,n){}setTrackMuteStatus(e,t){}setTrackVideoType(e,t){}updateSsrcOwnersOnLeave(e){}}const wc=[{rid:"1",scaleFactor:4},{rid:"2",scaleFactor:2},{rid:"3",scaleFactor:1}],Ic={av1:{maxBitratesVideo:{low:1e5,standard:3e5,high:1e6,fullHd:2e6,ultraHd:4e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI(),useSimulcast:!1,useKSVC:!0},h264:{maxBitratesVideo:{low:2e5,standard:5e5,high:15e5,fullHd:3e6,ultraHd:6e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI()},vp8:{maxBitratesVideo:{low:2e5,standard:5e5,high:15e5,fullHd:3e6,ultraHd:6e6,ssHigh:25e5,none:0},scalabilityModeEnabled:!1},vp9:{maxBitratesVideo:{low:1e5,standard:3e5,high:12e5,fullHd:25e5,ultraHd:5e6,ssHigh:25e5,none:0},scalabilityModeEnabled:ci.supportsScalabilityModeAPI(),useSimulcast:!1,useKSVC:!0}},Pc=[{height:2160,level:"ultraHd"},{height:1080,level:"fullHd"},{height:720,level:"high"},{height:540,level:"standard"},{height:480,level:"standard"},{height:360,level:"standard"},{height:270,level:"low"},{height:180,level:"low"},{height:90,level:"low"},{height:0,level:"none"}];let Dc;function Oc(e){return parseInt(e.ssrcs.split(" ")[0],10)}function kc(e){return parseInt(e.ssrcs.split(" ")[1],10)}function Nc(e){return e.ssrcs?e.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t)).length:0}!function(e){e.ULTRA="ultraHd",e.FULL="fullHd",e.HIGH="high",e.STANDARD="standard",e.LOW="low",e.NONE="none"}(Dc||(Dc={}));class Mc{constructor(e){if(!e)throw new Error("mLine is undefined");this.mLine=e}get ssrcs(){return this.mLine.ssrcs||(this.mLine.ssrcs=[]),this.mLine.ssrcs}set ssrcs(e){this.mLine.ssrcs=e}get direction(){return this.mLine.direction}set direction(e){this.mLine.direction=e}get ssrcGroups(){return this.mLine.ssrcGroups||(this.mLine.ssrcGroups=[]),this.mLine.ssrcGroups}set ssrcGroups(e){this.mLine.ssrcGroups=e}getSSRCAttrValue(e,t){const n=this.ssrcs.find((n=>n.id===e&&n.attribute===t));return n&&n.value}removeSSRC(e){this.mLine.ssrcs&&this.mLine.ssrcs.length&&(this.mLine.ssrcs=this.mLine.ssrcs.filter((t=>t.id!==e)))}addSSRCAttribute(e){this.ssrcs.push(e)}findGroup(e,t){return this.ssrcGroups.find((n=>n.semantics===e&&(!t||t===n.ssrcs)))}findGroups(e){return this.ssrcGroups.filter((t=>t.semantics===e))}findGroupByPrimarySSRC(e,t){return this.ssrcGroups.find((n=>n.semantics===e&&Oc(n)===t))}findSSRCByMSID(e){return this.ssrcs.find((t=>"msid"===t.attribute&&(null===e||t.value===e)))}getSSRCCount(){return Nc(this.mLine)}containsAnySSRCGroups(){return void 0!==this.mLine.ssrcGroups}getPrimaryVideoSsrc(){const e=this.mLine.type;if("video"!==e)throw new Error(`getPrimarySsrc doesn\'t work with \'${e}\'`);if(1===Nc(this.mLine))return this.mLine.ssrcs[0].id;if(this.mLine.ssrcGroups){const e=this.findGroup("SIM");if(e)return Oc(e);const t=this.findGroup("FID");if(t)return Oc(t);const n=this.findGroup("FEC-FR");if(n)return Oc(n)}}getRtxSSRC(e){const t=this.findGroupByPrimarySSRC("FID",e);return t&&kc(t)}getSSRCs(){return this.ssrcs.map((e=>e.id)).filter(((e,t,n)=>n.indexOf(e)===t))}getPrimaryVideoSSRCs(){const e=this.mLine.type;if("video"!==e)throw new Error(`getPrimaryVideoSSRCs doesn\'t work with ${e}`);const t=this.getSSRCs();for(const e of this.ssrcGroups)if("FID"===e.semantics||"FEC-FR"===e.semantics){const n=kc(e);t.splice(t.indexOf(n),1)}return t}dumpSSRCGroups(){return JSON.stringify(this.mLine.ssrcGroups)}removeGroupsWithSSRC(e){this.mLine.ssrcGroups&&(this.mLine.ssrcGroups=this.mLine.ssrcGroups.filter((t=>-1===t.ssrcs.indexOf(`${e}`))))}removeGroupsBySemantics(e){this.mLine.ssrcGroups&&(this.mLine.ssrcGroups=this.mLine.ssrcGroups.filter((t=>t.semantics!==e)))}replaceSSRC(e,t){this.mLine.ssrcs&&this.mLine.ssrcs.forEach((n=>{n.id===e&&(n.id=t)}))}addSSRCGroup(e){this.ssrcGroups.push(e)}}class Lc{constructor(e){this.parsedSDP=Ps.parse(e)}selectMedia(e){const t=this.parsedSDP.media.filter((t=>t.type===e)).map((e=>new Mc(e)));return null!=t?t:null}toRawSDP(){return Ps.write(this.parsedSDP)}}const Fc=(0,y.getLogger)("modules/sdp/LocalSdpMunger.js");class jc{constructor(e,t){this.tpc=e,this.localEndpointId=t,this.audioSourcesToMsidMap=new Map,this.videoSourcesToMsidMap=new Map}_generateMsidAttribute(e,t,n){if(!e||!t)return Fc.error(`Unable to munge local MSID - track id=${t} or media type=${e} is missing`),null;const i=this.tpc.id;return`${n}-${i} ${t}-${i}`}_transformMediaIdentifiers(e){var t,n,i,r,o;const s=null===(t=e.mLine)||void 0===t?void 0:t.type,a=null===(n=e.mLine)||void 0===n?void 0:n.direction,d=null===(i=e.mLine)||void 0===i?void 0:i.msid,c=[...new Set(null===(r=e.mLine)||void 0===r||null===(o=r.ssrcs)||void 0===o?void 0:o.map((e=>e.id)))],l=`${this.localEndpointId}-${s}`;let h=d?d.split(" ")[1]:`${this.localEndpointId}-${e.mLine.mid}`;for(const t of c){const n=e.ssrcs.find((e=>e.id===t&&"msid"===e.attribute));n&&(h=n.value.split(" ")[1]),this._updateSourcesToMsidMap(s,l,h);const i=s===Ri.VIDEO?this.videoSourcesToMsidMap.get(h):this.audioSourcesToMsidMap.get(h),r=this._generateMsidAttribute(s,h,i);n?n.value=r:a!==As.SENDONLY&&a!==As.SENDRECV||e.ssrcs.push({id:t,attribute:"msid",value:r})}e.ssrcs=e.ssrcs.filter((e=>"msid"===e.attribute)),!ci.isFirefox()||a!==As.RECVONLY&&a!==As.INACTIVE||(s!==Ri.VIDEO||this.tpc._hasHadVideoTrack)&&(s!==Ri.AUDIO||this.tpc._hasHadAudioTrack)||(e.ssrcs=void 0,e.ssrcGroups=void 0)}_updateSourcesToMsidMap(e,t,n){if(e===Ri.VIDEO){if(!this.videoSourcesToMsidMap.has(n)){const e=`${t}-${this.videoSourcesToMsidMap.size}`;this.videoSourcesToMsidMap.set(n,e)}}else if(!this.audioSourcesToMsidMap.has(n)){const e=`${t}-${this.audioSourcesToMsidMap.size}`;this.audioSourcesToMsidMap.set(n,e)}}transformStreamIdentifiers(e){var t;if(!e||!e.sdp||!e.type)return e;const n=new Lc(e.sdp),i=null===(t=n.selectMedia(Ri.AUDIO))||void 0===t?void 0:t[0];i&&(this._transformMediaIdentifiers(i),this._injectSourceNames(i));const r=n.selectMedia(Ri.VIDEO);for(const e of r)this._transformMediaIdentifiers(e),this._injectSourceNames(e);return this.audioSourcesToMsidMap.clear(),this.videoSourcesToMsidMap.clear(),new RTCSessionDescription({type:e.type,sdp:n.toRawSDP()})}_injectSourceNames(e){var t,n,i;const r=[...new Set(null===(t=e.mLine)||void 0===t||null===(n=t.ssrcs)||void 0===n?void 0:n.map((e=>e.id)))],o=null===(i=e.mLine)||void 0===i?void 0:i.type;if(!o)throw new Error("_transformMediaIdentifiers - no media type in mediaSection");for(const t of r){const n=e.ssrcs.find((e=>e.id===t&&"name"===e.attribute)),i=e.ssrcs.find((e=>e.id===t&&"msid"===e.attribute)).value.split(" ")[0].split("-"),r=i[i.length-2],a=Cc(this.localEndpointId,o,r);if(n||e.ssrcs.push({id:t,attribute:"name",value:a}),o===Ri.VIDEO){var s;const n=null===(s=this.tpc.getLocalVideoTracks().find((e=>e.getSourceName()===a)))||void 0===s?void 0:s.getVideoType();n&&e.ssrcs.push({id:t,attribute:"videoType",value:n})}}}}const Vc=(0,y.getLogger)("modules/sdp/RtxModifier.js");function Uc(e,t,n){const i=t.id,r=t.msid,o=t.cname,s=e.getRtxSSRC(i);s!==n&&(s&&(e.removeSSRC(s),e.removeGroupsWithSSRC(s)),e.addSSRCAttribute({id:n,attribute:"cname",value:o}),r&&e.addSSRCAttribute({id:n,attribute:"msid",value:r}),e.addSSRCGroup({semantics:"FID",ssrcs:`${i} ${n}`}))}class Hc{constructor(){this.correspondingRtxSsrcs=new Map}clearSsrcCache(){this.correspondingRtxSsrcs.clear()}setSsrcCache(e){Vc.debug("Setting ssrc cache to ",e),this.correspondingRtxSsrcs=e}modifyRtxSsrcs(e){let t=!1;const n=new Lc(e),i=n.selectMedia(Ri.VIDEO);if(null==i||!i.length)return Vc.debug(`No \'video\' media found in the sdp: ${e}`),e;for(const e of i)this.modifyRtxSsrcs2(e)&&(t=!0);return t?n.toRawSDP():e}modifyRtxSsrcs2(e){if(e.direction===As.RECVONLY)return!1;if(e.getSSRCCount()<1)return!1;const t=e.getPrimaryVideoSSRCs();for(const n of t){const t=e.getSSRCAttrValue(n,"msid"),i=e.getSSRCAttrValue(n,"cname");let r=this.correspondingRtxSsrcs.get(n);if(!r){r=e.getRtxSSRC(n)||Ns.generateSsrc(),this.correspondingRtxSsrcs.set(n,r)}Uc(e,{id:n,cname:i,msid:t},r)}return!0}stripRtx(e){const t=new Lc(e),n=t.selectMedia(Ri.VIDEO);if(null==n||!n.length)return Vc.debug(`No \'video\' media found in the sdp: ${e}`),e;for(const e of n)if(e.direction!==As.RECVONLY&&e.getSSRCCount()&&e.containsAnySSRCGroups()){const t=e.findGroups("FID");e.removeGroupsBySemantics("FID");for(const n of t){const t=kc(n);e.removeSSRC(t)}}return t.toRawSDP()}}class $c{constructor(){this._ssrcCache=new Map,this._numOfLayers=wc.length}_fillSsrcsFromCache(e){const t=e.mid,n=this._ssrcCache.get(t),i=this._parseSimLayers(e),r=this._getSsrcAttribute(e,i[0],"msid"),o=this._getSsrcAttribute(e,i[0],"cname");e.ssrcs=[],e.ssrcGroups=[];for(const t of n)e.ssrcs.push({id:t,attribute:"msid",value:r}),e.ssrcs.push({id:t,attribute:"cname",value:o});return e.ssrcGroups.push({semantics:"SIM",ssrcs:n.join(" ")}),e}_generateNewSsrcsForSimulcast(e,t){const n=this._getSsrcAttribute(e,t,"cname");let i=this._getSsrcAttribute(e,t,"msid");const r=(e,t)=>{e.ssrcs.push({id:t,attribute:"cname",value:n}),e.ssrcs.push({id:t,attribute:"msid",value:i})};i||(i=e.msid,e.ssrcs.forEach((t=>{e.ssrcs.push({id:t.id,attribute:"msid",value:i})})));const o=[];for(let t=0;t<this._numOfLayers-1;++t){const t=this._generateSsrc();r(e,t),o.push(t)}return e.ssrcGroups=e.ssrcGroups||[],e.ssrcGroups.push({semantics:"SIM",ssrcs:t+" "+o.join(" ")}),e}_generateSsrc(){return Math.floor(4294967295*Math.random())}_getSsrcAttribute(e,t,n){var i,r;return null===(i=e.ssrcs)||void 0===i||null===(r=i.find((e=>Number(e.id)===t&&e.attribute===n)))||void 0===r?void 0:r.value}_parseSimLayers(e){var t,n;const i=null===(t=e.ssrcGroups)||void 0===t?void 0:t.find((e=>"SIM"===e.semantics));return i?i.ssrcs.split(" ").map((e=>Number(e))):null!==(n=e.ssrcs)&&void 0!==n&&n.length?[Number(e.ssrcs[0].id)]:null}mungeLocalDescription(e){if(!e||!e.sdp)return e;const t=Ps.parse(e.sdp);for(let e of t.media){var n,i,r;if(e.direction===As.RECVONLY||e.direction===As.INACTIVE)continue;if(e.type!==Ri.VIDEO)continue;const t=e.mid,s=new Set(null===(n=e.ssrcs)||void 0===n?void 0:n.map((e=>e.id))),a=null!==(i=null===(r=e.ssrcGroups)||void 0===r?void 0:r.length)&&void 0!==i?i:0;let d;if(!(0===s.size||s.size>2||2===s.size&&0===a)){if(1===s.size){var o;d=Number(null===(o=e.ssrcs[0])||void 0===o?void 0:o.id)}else{const t=e.ssrcGroups.find((e=>"FID"===e.semantics));t&&(d=Number(t.ssrcs.split(" ")[0]))}if(this._ssrcCache.has(t))e=this._fillSsrcsFromCache(e);else{e=this._generateNewSsrcsForSimulcast(e,d);const n=this._parseSimLayers(e);this._ssrcCache.set(t,n)}}}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})}}let Jc;!function(e){e.ACTIVE="active",e.INACTIVE="inactive",e.INTERRUPTED="interrupted",e.RESTORING="restoring"}(Jc||(Jc={}));const Bc=(0,y.getLogger)("modules/connectivity/TrackStreamingStatus.ts");class qc{static _getNewStateForJvbMode(e,t,n,i){return n?Jc.ACTIVE:ci.supportsVideoMuteOnConnInterrupted()?i?e?t?Jc.INTERRUPTED:Jc.RESTORING:Jc.INACTIVE:Jc.ACTIVE:e?Jc.ACTIVE:Jc.INACTIVE}static _getNewStateForP2PMode(e,t){return ci.supportsVideoMuteOnConnInterrupted()?e||!t?Jc.ACTIVE:Jc.INTERRUPTED:Jc.ACTIVE}constructor(e,t,n,i){this.rtc=e,this.conference=t,this.track=n,this.restoringTimer=null,this.rtcMutedTimestamp=null,this.streamingStatusMap={},this.trackTimer=null,this.outOfForwardedSourcesTimeout="number"==typeof i.outOfForwardedSourcesTimeout?i.outOfForwardedSourcesTimeout:500,this.p2pRtcMuteTimeout="number"==typeof i.p2pRtcMuteTimeout?i.p2pRtcMuteTimeout:2500,this.rtcMuteTimeout="number"==typeof i.rtcMuteTimeout?i.rtcMuteTimeout:1e4,Bc.info(`RtcMuteTimeout set to: ${this.rtcMuteTimeout}`)}_getVideoFrozenTimeout(){const e=this.track.getSourceName();return this.rtc.isInForwardedSources(e)?this.rtcMuteTimeout:this.conference.isP2PActive()?this.p2pRtcMuteTimeout:this.outOfForwardedSourcesTimeout}init(){this._onP2PStatus=this.figureOutStreamingStatus.bind(this),this.conference.on(B.P2P_STATUS,this._onP2PStatus),this._onUserLeft=this.onUserLeft.bind(this),this.conference.on(B.USER_LEFT,this._onUserLeft),ci.supportsVideoMuteOnConnInterrupted()&&(this._onTrackRtcMuted=this.onTrackRtcMuted.bind(this),this.rtc.addListener(ji.default.REMOTE_TRACK_MUTE,this._onTrackRtcMuted),this._onTrackRtcUnmuted=this.onTrackRtcUnmuted.bind(this),this.rtc.addListener(ji.default.REMOTE_TRACK_UNMUTE,this._onTrackRtcUnmuted),this._onSignallingMuteChanged=this.onSignallingMuteChanged.bind(this),this.track.on(Rt,this._onSignallingMuteChanged),this._onTrackVideoTypeChanged=this.onTrackVideoTypeChanged.bind(this),this.track.on(At,this._onTrackVideoTypeChanged)),this._onForwardedSourcesChanged=this.onForwardedSourcesChanged.bind(this),this.conference.on(B.FORWARDED_SOURCES_CHANGED,this._onForwardedSourcesChanged),this._onLastNValueChanged=this.figureOutStreamingStatus.bind(this),this.rtc.on(ji.default.LASTN_VALUE_CHANGED,this._onLastNValueChanged)}dispose(){ci.supportsVideoMuteOnConnInterrupted()&&(this.rtc.removeListener(ji.default.REMOTE_TRACK_MUTE,this._onTrackRtcMuted),this.rtc.removeListener(ji.default.REMOTE_TRACK_UNMUTE,this._onTrackRtcUnmuted),this.track.off(Rt,this._onSignallingMuteChanged),this.track.off(At,this._onTrackVideoTypeChanged)),this.conference.off(B.FORWARDED_SOURCES_CHANGED,this._onForwardedSourcesChanged),this.conference.off(B.P2P_STATUS,this._onP2PStatus),this.conference.off(B.USER_LEFT,this._onUserLeft),this.rtc.removeListener(ji.default.LASTN_VALUE_CHANGED,this._onLastNValueChanged),this.clearTimeout(),this.clearRtcMutedTimestamp(),this.maybeSendTrackStreamingStatusEvent(Date.now()),this.figureOutStreamingStatus()}_changeStreamingStatus(e){if(this.track.getTrackStreamingStatus()!==e){const t=this.track.getSourceName();this.track._setTrackStreamingStatus(e),Bc.debug(`Emit track streaming status(${Date.now()}) ${t}: ${e}`),this.track.emit(Pt,this.track,e)}}clearTimeout(){this.trackTimer&&(window.clearTimeout(this.trackTimer),this.trackTimer=null)}clearRtcMutedTimestamp(){this.rtcMutedTimestamp=null}isVideoTrackFrozen(){if(!ci.supportsVideoMuteOnConnInterrupted())return!1;const e=this.track.isWebRTCTrackMuted(),t=this.rtcMutedTimestamp,n=this._getVideoFrozenTimeout();return e&&"number"==typeof t&&Date.now()-t>=n}figureOutStreamingStatus(){const e=this.track.getSourceName(),t=this.conference.isP2PActive(),n=this._isRestoringTimedout(),i=0===this.conference.getLastN(),r=this.track.isMuted()||i,o=this.isVideoTrackFrozen(),s=this.rtc.isInForwardedSources(e),a=t?qc._getNewStateForP2PMode(r,o):qc._getNewStateForJvbMode(s,n,r,o);a!==Jc.RESTORING&&this._clearRestoringTimer(),Bc.debug(`Figure out conn status for ${e}, is video muted: ${r} video track frozen: ${o} p2p mode: ${t} is in forwarded sources: ${s} currentStatus => newStatus: ${this.track.getTrackStreamingStatus()} => ${a}`);const d=this.streamingStatusMap||{};if(!("p2p"in d)||!("streamingStatus"in d)||d.p2p!==t||d.streamingStatus!==a){const e=Date.now();this.maybeSendTrackStreamingStatusEvent(e),this.streamingStatusMap={...d,streamingStatus:a,p2p:t,startedMs:e},"videoType"in this.streamingStatusMap||(this.streamingStatusMap.videoType=this.track.getVideoType())}this._changeStreamingStatus(a)}maybeSendTrackStreamingStatusEvent(e){const t=this.streamingStatusMap;t&&"startedMs"in t&&"videoType"in t&&"streamingStatus"in t&&"p2p"in t&&(t.value=e-t.startedMs,Mi.sendAnalytics(function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return{type:kt.TYPE_OPERATIONAL,source:"track.streaming.status",action:"duration",attributes:e}}(t)))}onForwardedSourcesChanged(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],n=arguments.length>2?arguments[2]:void 0;const i=this.track.getSourceName();ci.supportsVideoMuteOnConnInterrupted()||this.figureOutStreamingStatus(),e.includes(i)&&(this.track._clearEnteredForwardedSourcesTimestamp(),this._clearRestoringTimer(),ci.supportsVideoMuteOnConnInterrupted()&&this.figureOutStreamingStatus()),t.includes(i)&&(this.track._setEnteredForwardedSourcesTimestamp(n),ci.supportsVideoMuteOnConnInterrupted()&&this.figureOutStreamingStatus())}_clearRestoringTimer(){const e=this.restoringTimer;e&&(clearTimeout(e),this.restoringTimer=null)}_isRestoringTimedout(){const e=this.track._getEnteredForwardedSourcesTimestamp();return!!(e&&Date.now()-e>=1e4)||(this.restoringTimer||(this.restoringTimer=setTimeout((()=>this.figureOutStreamingStatus()),1e4)),!1)}_isCurrentTrack(e){return e.getSourceName()===this.track.getSourceName()}onUserLeft(e){this.track.getParticipantId()===e&&(this.maybeSendTrackStreamingStatusEvent(Date.now()),this.streamingStatusMap={})}onTrackRtcMuted(e){if(!this._isCurrentTrack(e))return;const t=e.getSourceName();if(Bc.debug(`Detector track RTC muted: ${t}`,Date.now()),this.rtcMutedTimestamp=Date.now(),!e.isMuted()){this.clearTimeout();const e=this._getVideoFrozenTimeout();this.trackTimer=window.setTimeout((()=>{Bc.debug(`Set track RTC muted for: ${t} after the timeout of ${e} ms`),this.clearTimeout(),this.figureOutStreamingStatus()}),e)}}onTrackRtcUnmuted(e){if(!this._isCurrentTrack(e))return;const t=this.track.getSourceName();Bc.debug(`Detector track RTC unmuted: ${t}`,Date.now()),this.clearTimeout(),this.clearRtcMutedTimestamp(),this.figureOutStreamingStatus()}onSignallingMuteChanged(e){this._isCurrentTrack(e)&&(this.track.getSourceName(),this.figureOutStreamingStatus())}onTrackVideoTypeChanged(e){const t=Date.now();this.maybeSendTrackStreamingStatusEvent(t),this.streamingStatusMap={...this.streamingStatusMap||{},videoType:e,startedMs:t}}}const Gc=qc,zc=n(810).getLogger("modules/RTC/JitsiRemoteTrack.js"),Kc=n(987);let Wc=!1,Xc=!1;const Yc=["abort","canplaythrough","ended","error","stalled","suspend","waiting"];class Qc extends oc{constructor(e,t,n,i,r,o,s,a,d,c,l){if(super(t,i,r,(()=>{}),o,s),this.rtc=e,"number"!=typeof a)throw new TypeError(`SSRC ${a} is not a number`);this.ssrc=a,this.ownerEndpointId=n,this.muted=d,this.isP2P=c,this._sourceName=l,this._trackStreamingStatus=null,this._trackStreamingStatusImpl=null,this._enteredForwardedSourcesTimestamp=null,this.addEventListener=this.on=this._addEventListener.bind(this),this.removeEventListener=this.off=this._removeEventListener.bind(this),zc.debug(`New remote track created: ${this}`),this.hasBeenMuted=d,this.rtc&&this.track&&this._bindTrackHandlers(),this._containerHandlers={},Yc.forEach((e=>{this._containerHandlers[e]=this._containerEventHandler.bind(this,e)}))}_bindTrackHandlers(){this.track.addEventListener("mute",(()=>this._onTrackMute())),this.track.addEventListener("unmute",(()=>this._onTrackUnmute())),this.track.addEventListener("ended",(()=>{zc.debug(`"onended" event(${Date.now()}): ${this}`)}))}_addEventListener(e,t){super.addListener(e,t),e===Pt&&this.listenerCount(Pt)&&!this._trackStreamingStatusImpl&&(this._initTrackStreamingStatus(),zc.debug(`Initializing track streaming status: ${this._sourceName}`))}_removeEventListener(e,t){super.removeListener(e,t),e!==Pt||this.listenerCount(Pt)||(this._disposeTrackStreamingStatus(),zc.debug(`Disposing track streaming status: ${this._sourceName}`))}_onTrackMute(){zc.debug(`"onmute" event(${Date.now()}): ${this}`),this.videoType!==Qo.VideoType.DESKTOP?this.rtc.eventEmitter.emit(Kc.REMOTE_TRACK_MUTE,this):zc.debug("Ignoring mute event on desktop tracks.")}_onTrackUnmute(){zc.debug(`"onunmute" event(${Date.now()}): ${this}`),this.rtc.eventEmitter.emit(Kc.REMOTE_TRACK_UNMUTE,this)}dispose(){return this._disposeTrackStreamingStatus(),super.dispose()}setMute(e){this.muted!==e&&(e&&(this.hasBeenMuted=!0),this.stream&&(this.stream.muted=e),this.muted=e,zc.info(`Mute ${this}: ${e}`),this.emit(Rt,this))}isMuted(){return this.muted}getParticipantId(){return this.ownerEndpointId}isLocal(){return!1}getSSRC(){return this.ssrc}getSourceName(){return this._sourceName}setOwner(e){this.ownerEndpointId=e,this.emit(Dt,e)}setSourceName(e){this._sourceName=e}_setVideoType(e){this.videoType!==e&&(this.videoType=e,this.emit(At,e))}_playCallback(){if(!this.conference.room)return;const e=this.isVideoTrack()?"video":"audio",t=window.performance.now();zc.info(`(TIME) Render ${e}:\\t`,t),this.conference.getConnectionTimes()[`${e}.render`]=t;const n=window.connectionTimes["obtainPermissions.start"],i=window.connectionTimes["obtainPermissions.end"],r=isNaN(i)||isNaN(n)?0:i-n,o=t-(this.conference.getConnectionTimes()["session.initiate"]-this.conference.getConnectionTimes()["muc.joined"])-r;var s;this.conference.getConnectionTimes()[`${e}.ttfm`]=o,zc.info(`(TIME) TTFM ${e}:\\t`,o),Mi.sendAnalytics((s={media_type:e,muted:this.hasBeenMuted,value:o},sn("ttfm",s)))}_attachTTFMTracker(e){Wc&&this.isAudioTrack()||Xc&&this.isVideoTrack()||(this.isAudioTrack()&&(Wc=!0),this.isVideoTrack()&&(Xc=!0),e.addEventListener("canplay",this._playCallback.bind(this)))}_onTrackAttach(e){Yc.forEach((t=>{e.addEventListener(t,this._containerHandlers[t])}))}_onTrackDetach(e){Yc.forEach((t=>{e.removeEventListener(t,this._containerHandlers[t])}))}_containerEventHandler(e){zc.debug(`${e} handler was called for a container with attached ${this}`)}_getStatus(){const{enabled:e,muted:t,readyState:n}=this.track;return`readyState: ${n}, muted: ${t}, enabled: ${e}`}_initTrackStreamingStatus(){const e=this.conference.options.config;this._trackStreamingStatus=Jc.ACTIVE,this._trackStreamingStatusImpl=new Gc(this.rtc,this.conference,this,{p2pRtcMuteTimeout:e._p2pConnStatusRtcMuteTimeout,rtcMuteTimeout:e._peerConnStatusRtcMuteTimeout,outOfForwardedSourcesTimeout:e._peerConnStatusOutOfLastNTimeout}),this._trackStreamingStatusImpl.init(),!this._trackStreamingStatusImpl.isVideoTrackFrozen()&&this.rtc.eventEmitter.emit(Pt,this,this._trackStreamingStatus)}_disposeTrackStreamingStatus(){this._trackStreamingStatusImpl&&(this._trackStreamingStatusImpl.dispose(),this._trackStreamingStatusImpl=null,this._trackStreamingStatus=null)}_setTrackStreamingStatus(e){this._trackStreamingStatus=e}getTrackStreamingStatus(){return this._trackStreamingStatus}_clearEnteredForwardedSourcesTimestamp(){this._enteredForwardedSourcesTimestamp=null}_setEnteredForwardedSourcesTimestamp(e){this._enteredForwardedSourcesTimestamp=e}_getEnteredForwardedSourcesTimestamp(){return this._enteredForwardedSourcesTimestamp}toString(){return`RemoteTrack[userID: ${this.getParticipantId()}, type: ${this.getType()}, ssrc: ${this.getSSRC()}, p2p: ${this.isP2P}, sourceName: ${this._sourceName}, status: {${this._getStatus()}}]`}}let Zc;!function(e){e.L1T3="L1T3",e.L2T3="L2T3",e.L2T3_KEY="L2T3_KEY",e.L3T3="L3T3",e.L3T3_KEY="L3T3_KEY"}(Zc||(Zc={}));const el=(0,y.getLogger)("modules/RTC/TPCUtils.js"),tl=[Ds.AV1,Ds.H264,Ds.VP8,Ds.VP9];class nl{constructor(e){var t;this.pc=e,this.codecSettings=Ss()(Ic);const n=null===(t=this.pc.options)||void 0===t?void 0:t.videoQuality;if(n)for(const e of tl){var i;const t=n[e],r=null!==(i=null==t?void 0:t.maxBitratesVideo)&&void 0!==i?i:n.maxbitratesvideo&&n.maxbitratesvideo[e.toUpperCase()];r&&[...Object.values(Dc),"ssHigh"].forEach((t=>{r[t]&&(this.codecSettings[e].maxBitratesVideo[t]=r[t])})),t&&(this.codecSettings[e].scalabilityModeEnabled&&(void 0===t.scalabilityModeEnabled||t.scalabilityModeEnabled)?(void 0!==t.useSimulcast&&(this.codecSettings[e].useSimulcast=t.useSimulcast),void 0!==t.useKSVC&&(this.codecSettings[e].useKSVC=t.useKSVC)):this.codecSettings[e].scalabilityModeEnabled=!1)}}_calculateActiveEncodingParams(e,t,n){var i,r;const o=this.codecSettings[t].maxBitratesVideo,s=e.getCaptureResolution(),a=n>s?s:n,d=(null===(i=this.pc.options)||void 0===i||null===(r=i.videoQuality)||void 0===r?void 0:r.desktopbitrate)||o.ssHigh,c=e.getVideoType()===Qo.VideoType.DESKTOP;let l=this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3;const{height:h,level:u}=Pc.find((e=>e.height<=a));let p,m=wc[2].scaleFactor;this._isScreenshareBitrateCapped(e)?(l=Zc.L1T3,p=d):c?p=o.ssHigh:(p=o[u],a&&(m=s/a),h!==a&&el.debug(`Quality level with height=${h} was picked when requested height=${n} fortrack with capture height=${s}`));const g={active:a>0,maxBitrate:p,scalabilityMode:l,scaleResolutionDownBy:m};if(!g.active||c)return g;switch(u){case Dc.ULTRA:case Dc.FULL:case Dc.HIGH:g.scalabilityMode=this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3;break;case Dc.STANDARD:g.scalabilityMode=this.codecSettings[t].useKSVC?Zc.L2T3_KEY:Zc.L2T3;break;default:g.scalabilityMode=Zc.L1T3}return g}_configureSenderEncodings(e){var t,n;const i=e.getType(),r=null!=e&&e.track&&e.getOriginalStream()?this.pc.peerconnection.getTransceivers().find((t=>{var n,i;return(null===(n=t.sender)||void 0===n||null===(i=n.track)||void 0===i?void 0:i.id)===e.getTrackId()})):this.pc.peerconnection.getTransceivers().find((e=>{var t,n;return(null===(t=e.receiver)||void 0===t||null===(n=t.track)||void 0===n?void 0:n.kind)===i})),o=null==r||null===(t=r.sender)||void 0===t?void 0:t.getParameters();return null!=o&&null!==(n=o.encodings)&&void 0!==n&&n.length?(o.encodings=this._getStreamEncodings(e),r.sender.setParameters(o)):Promise.resolve()}_enableSenderEncodings(e,t){var n;const i=e.getParameters();if(null!=i&&null!==(n=i.encodings)&&void 0!==n&&n.length)for(const e of i.encodings)e.active=t;return e.setParameters(i)}_getStreamEncodings(e){if(e.isAudioTrack())return[{active:this.pc.audioTransferActive}];const t=this.pc.getConfiguredVideoCodec();return this.pc.isSpatialScalabilityOn()?this._getVideoStreamEncodings(e,t):[{active:this.pc.videoTransferActive,maxBitrate:this.codecSettings[t].maxBitratesVideo.high}]}_getVideoStreamEncodings(e,t){const n=e.getCaptureResolution(),i=this.codecSettings[t].maxBitratesVideo,r=e.getVideoType();let o,s=wc.map((e=>e.scaleFactor));if(r===Qo.VideoType.CAMERA){const{level:e}=Pc.find((e=>e.height<=n));o=i[e],e===Dc.ULTRA?(s[1]=6,s[0]=12):e===Dc.FULL&&(s[1]=3,s[0]=6)}const a=r===Qo.VideoType.DESKTOP?i.ssHigh:o;let d=[i.low,i.standard,a];ci.isFirefox()&&(r===Qo.VideoType.DESKTOP||ci.isVersionLessThan(117))&&(d=d.reverse(),s=s.reverse());const c=[{active:this.pc.videoTransferActive,maxBitrate:d[0],rid:wc[0].rid,scaleResolutionDownBy:s[0]},{active:this.pc.videoTransferActive,maxBitrate:d[1],rid:wc[1].rid,scaleResolutionDownBy:s[1]},{active:this.pc.videoTransferActive,maxBitrate:d[2],rid:wc[2].rid,scaleResolutionDownBy:s[2]}];if(this.codecSettings[t].scalabilityModeEnabled){if(this.codecSettings[t].useSimulcast||t===Ds.H264){for(const e of c)e.scalabilityMode=Zc.L1T3;return c}return[{active:this.pc.videoTransferActive,maxBitrate:d[2],rid:wc[0].rid,scaleResolutionDownBy:s[2],scalabilityMode:this.codecSettings[t].useKSVC?Zc.L3T3_KEY:Zc.L3T3},{active:!1,maxBitrate:0},{active:!1,maxBitrate:0}]}return c}_isRunningInFullSvcMode(e){return(e===Ds.VP9||e===Ds.AV1)&&this.codecSettings[e].scalabilityModeEnabled&&!this.codecSettings[e].useSimulcast}_isScreenshareBitrateCapped(e){return e.getVideoType()===Qo.VideoType.DESKTOP&&this.pc._capScreenshareBitrate&&!ci.isWebKitBased()}_updateSenderEncodings(e,t){var n;const i=e.getParameters();if(null!=i&&null!==(n=i.encodings)&&void 0!==n&&n.length)for(const e of i.encodings)e.active=t;return e.setParameters(i)}addTrack(e,t){const n=e.getTrack();if(t){const t=[];e.getOriginalStream()&&t.push(e.getOriginalStream());const i={direction:As.SENDRECV,streams:t,sendEncodings:[]};ci.isFirefox()||(i.sendEncodings=this._getStreamEncodings(e)),this.pc.peerconnection.addTransceiver(n,i)}else this.pc.peerconnection.addTrack(n)}calculateEncodingsActiveState(e,t,n){const i=e.getCaptureResolution(),r=this._getVideoStreamEncodings(e,t);return r.map((e=>i/e.scaleResolutionDownBy)).map(((i,o)=>{let s=!1;if(!this.pc.videoTransferActive)return s;if(!this.pc.isSpatialScalabilityOn()||this._isRunningInFullSvcMode(t)){const{active:i}=this._calculateActiveEncodingParams(e,t,n);return 0===o?i:s}var a;return n>0&&(s=e.getVideoType()===Qo.VideoType.CAMERA?i<=n||(null===(a=r[o])||void 0===a?void 0:a.scaleResolutionDownBy)===wc[0].scaleFactor:r[o].scaleResolutionDownBy===wc[2].scaleFactor||!this._isScreenshareBitrateCapped(e)),s}))}calculateEncodingsBitrates(e,t,n){var i,r;const o=this.codecSettings[t].maxBitratesVideo,s=(null===(i=this.pc.options)||void 0===i||null===(r=i.videoQuality)||void 0===r?void 0:r.desktopbitrate)||o.ssHigh;return this._getVideoStreamEncodings(e,t).map(((i,r)=>{let o=i.maxBitrate;if(!this.pc.isSpatialScalabilityOn()||this._isRunningInFullSvcMode(t)){const{maxBitrate:i}=this._calculateActiveEncodingParams(e,t,n);return 0===r?i:0}return this._isScreenshareBitrateCapped(e)&&(o=s),o}))}calculateEncodingsScalabilityMode(e,t,n){if(!this.pc.isSpatialScalabilityOn()||!this.codecSettings[t].scalabilityModeEnabled)return;const i=[Zc.L1T3,Zc.L1T3,Zc.L1T3];if(this._isRunningInFullSvcMode(t)){const{scalabilityMode:r}=this._calculateActiveEncodingParams(e,t,n);return i[0]=r,i[1]=void 0,i[2]=void 0,i}return i}calculateEncodingsScaleFactor(e,t,n){if(this.pc.isSpatialScalabilityOn()&&this.isRunningInSimulcastMode(t))return this._getVideoStreamEncodings(e,t).map((e=>e.scaleResolutionDownBy));const{scaleResolutionDownBy:i}=this._calculateActiveEncodingParams(e,t,n);return[i,void 0,void 0]}ensureCorrectOrderOfSsrcs(e){const t=Ps.parse(e.sdp);return t.media.forEach((e=>{if(e.type===Ri.AUDIO)return;if(!e.ssrcGroups||!e.ssrcGroups.length)return;let t=[];const n=new Set;e.ssrcGroups.map((e=>e.ssrcs.split(" ").filter(Boolean).forEach((e=>n.add(e))))),n.forEach((n=>{const i=e.ssrcs.filter((e=>e.id.toString()===n));t=t.concat(i)})),e.ssrcs=t})),new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})}insertUnifiedPlanSimulcastReceive(e){if(ci.usesSdpMungingForSimulcast())return e;const t=[{id:wc[0].rid,direction:"recv"},{id:wc[1].rid,direction:"recv"},{id:wc[2].rid,direction:"recv"}],n=`recv ${t.map((e=>e.id)).join(";")}`,i=Ps.parse(e.sdp),r=i.media.filter((e=>e.type===Ri.VIDEO)),o=Array.from(this.pc._localTrackTransceiverMids.values());return r.forEach(((e,i)=>{o.find((t=>e.mid.toString()===t.toString()))||0===i?e.simulcast_03&&e.simulcast||(e.rids=t,e.simulcast_03={value:n}):(e.rids=void 0,e.simulcast=void 0,e.simulcast_03=void 0)})),new RTCSessionDescription({type:e.type,sdp:Ps.write(i)})}isRunningInSimulcastMode(e){return e===Ds.VP8||!this.codecSettings[e].scalabilityModeEnabled&&e===Ds.VP9||this.codecSettings[e].scalabilityModeEnabled&&(e===Ds.H264||this.codecSettings[e].useSimulcast)}replaceTrack(e,t){var n,i;const r=null!==(n=null==t?void 0:t.getType())&&void 0!==n?n:null==e?void 0:e.getType(),o=this.pc.getLocalTracks(r),s=null!==(i=null==t?void 0:t.getTrack())&&void 0!==i?i:null,a=(null==o?void 0:o.length)&&!e&&t&&!o.find((e=>e===t));let d;if(e&&!e.isMuted())d=this.pc.peerconnection.getTransceivers().find((t=>t.sender.track===e.getTrack()));else if(a)d=this.pc.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===r&&e.direction===As.RECVONLY&&(this.pc.isP2P&&e.currentDirection===As.RECVONLY||e.currentDirection===As.INACTIVE&&!e.stopped)));else{var c;d=this.pc.peerconnection.getTransceivers().find((e=>e.receiver.track.kind===r));const n=null!==(c=null==t?void 0:t.getSourceName())&&void 0!==c?c:null==e?void 0:e.getSourceName();if(n){const t=Rc(n);if(this.pc.isP2P)d=this.pc.peerconnection.getTransceivers().filter((e=>e.receiver.track.kind===r))[t];else if(e){const t=this.pc._localTrackTransceiverMids.get(e.rtcId);d=this.pc.peerconnection.getTransceivers().find((e=>e.mid===t))}else t&&(d=this.pc.peerconnection.getTransceivers().filter((e=>e.receiver.track.kind===r&&e.direction!==As.RECVONLY))[t])}}return d?(el.debug(`${this.pc} Replacing ${e} with ${t}`),d.sender.replaceTrack(s).then((()=>Promise.resolve(d)))):Promise.reject(new Error(`Replace track failed - no transceiver for old: ${e}, new: ${t}`))}setEncodings(e){return e.getType()===Ri.VIDEO?this.pc._updateVideoSenderParameters((()=>this._configureSenderEncodings(e))):this._configureSenderEncodings(e)}setMediaTransferActive(e,t){el.info(`${this.pc} ${e?"Resuming":"Suspending"} media transfer.`);const n=this.pc.peerconnection.getSenders().filter((e=>Boolean(e.track)&&(!t||e.track.kind===t))),i=[];for(const t of n)t.track.kind===Ri.VIDEO?i.push(this.pc._updateVideoSenderParameters((()=>this._enableSenderEncodings(t,e)))):i.push(this._enableSenderEncodings(t,e));return Promise.allSettled(i).then((e=>{const t=e.filter((e=>"rejected"===e.status)).map((e=>e.reason));return t.length?Promise.reject(new Error(`Failed to change encodings on the RTCRtpSenders${t.join(" ")}`)):Promise.resolve()}))}}const il=(0,y.getLogger)("modules/RTC/TraceablePeerConnection.js"),rl="https://aomediacodec.github.io/av1-rtp-spec/#dependency-descriptor-rtp-header-extension";function ol(e,t,n,i,r,o,s){this.audioTransferActive=!(!0===s.startSilent),this._dtmfSender=void 0,this._dtmfTonesQueue=[],this.videoTransferActive=!0,this.rtc=e,this.id=t,this.isP2P=o,this.remoteTracks=new Map,this.localTracks=new Map,this.localSSRCs=new Map,this.remoteSSRCs=new Set,this.remoteSources=new Map,this.localUfrag=null,this.remoteUfrag=null,this._dtlsTransport=null,this.signalingLayer=n,this._peerVideoTypeChanged=this._peerVideoTypeChanged.bind(this),this.signalingLayer.on(yc,this._peerVideoTypeChanged),this._peerMutedChanged=this._peerMutedChanged.bind(this),this.signalingLayer.on(Ec,this._peerMutedChanged),this.options=s,this.signalingLayer.on(Sc,((e,t)=>this._sourceMutedChanged(e,t))),this.signalingLayer.on(Tc,((e,t)=>this._sourceVideoTypeChanged(e,t)));const a=r||{};a.optional=a.optional||[],Array.isArray(a.optional)?a.optional.push({rtcStatsSFUP2P:this.isP2P}):il.warn("Optional param is not an array, rtcstats p2p data is omitted."),this.peerconnection=new RTCPeerConnection(i,a),this.tpcUtils=new nl(this),this.updateLog=[],this.stats={},this.statsinterval=null,this._capScreenshareBitrate=this.options.capScreenshareBitrate,this.codecSettings=this.options.codecSettings,ci.supportsCodecPreferences()&&il.info("Using RTCRtpTransceiver#setCodecPreferences for codec selection"),this._hasHadAudioTrack=!1,this._hasHadVideoTrack=!1,this.maxstats=s.maxstats,this.interop=new vc,this.simulcast=new $c,this.localSdpMunger=new jc(this,this.rtc.getLocalEndpointId()),this.eventEmitter=e.eventEmitter,this.rtxModifier=new Hc,this._senderMaxHeights=new Map,this._supportsDDHeaderExt=!1,this._localTrackTransceiverMids=new Map,this.trace=(e,t)=>{il.trace(e,t),this.updateLog.push({time:new Date,type:e,value:t||""})},this.onicecandidate=null,this.peerconnection.onicecandidate=e=>{this.trace("onicecandidate",JSON.stringify(e.candidate,null," ")),null!==this.onicecandidate&&this.onicecandidate(e)},this.onTrack=e=>{const t=e.streams[0];this._remoteTrackAdded(t,e.track,e.transceiver),t.addEventListener("removetrack",(e=>{this._remoteTrackRemoved(t,e.track)}))},this.peerconnection.addEventListener("track",this.onTrack),this.onsignalingstatechange=null,this.peerconnection.onsignalingstatechange=e=>{this.trace("onsignalingstatechange",this.signalingState),null!==this.onsignalingstatechange&&this.onsignalingstatechange(e)},this.oniceconnectionstatechange=null,this.peerconnection.oniceconnectionstatechange=e=>{this.trace("oniceconnectionstatechange",this.iceConnectionState),null!==this.oniceconnectionstatechange&&this.oniceconnectionstatechange(e)},this.onnegotiationneeded=null,this.peerconnection.onnegotiationneeded=e=>{this.trace("onnegotiationneeded"),null!==this.onnegotiationneeded&&this.onnegotiationneeded(e)},this.onconnectionstatechange=null,this.peerconnection.onconnectionstatechange=e=>{this.trace("onconnectionstatechange",this.connectionState),null!==this.onconnectionstatechange&&this.onconnectionstatechange(e)},this.ondatachannel=null,this.peerconnection.ondatachannel=e=>{this.trace("ondatachannel"),null!==this.ondatachannel&&this.ondatachannel(e)},this.maxstats&&(this.statsinterval=window.setInterval((()=>{this.getStats().then((e=>{if("function"==typeof(null==e?void 0:e.result)){const t=e.result();for(let e=0;e<t.length;++e){const n=t[e];n.names().forEach((e=>{this._processStat(n,e,n.stat(e))}))}}else e.forEach((e=>this._processStat(e,"",e)))}))}),1e3)),this._lastVideoSenderUpdatePromise=Promise.resolve(),il.info(`Create new ${this}`)}ol.prototype._processStat=function(e,t,n){const i=`${e.id}-${t}`;let r=this.stats[i];const o=new Date;r||(this.stats[i]=r={startTime:o,endTime:o,values:[],times:[]}),r.values.push(n),r.times.push(o.getTime()),r.values.length>this.maxstats&&(r.values.shift(),r.times.shift()),r.endTime=o};const sl=function(e){return null==e?"":`type: ${e.type}\\r\\n${e.sdp}`};ol.prototype.getConnectionState=function(){const e=this.peerconnection.iceConnectionState;return"completed"===e?"connected":e},ol.prototype.getDesiredMediaDirection=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=this.hasAnyTracksOfType(e);return t?n?As.SENDRECV:As.SENDONLY:n?As.RECVONLY:As.INACTIVE},ol.prototype._getReceiversByEndpointIds=function(e,t){let n=[],i=[];for(const i of e)n=n.concat(this.getRemoteTracks(i,t));const r=n.map((e=>{var t;return null===(t=e.track)||void 0===t?void 0:t.id}));return i=this.peerconnection.getReceivers().filter((e=>e.track&&e.track.kind===t&&r.find((t=>t===e.track.id)))),i},ol.prototype.isSpatialScalabilityOn=function(){const e=this.tpcUtils.codecSettings[Ds.H264].scalabilityModeEnabled&&this._supportsDDHeaderExt;return!this.options.disableSimulcast&&(this.codecSettings.codecList[0]!==Ds.H264||e)},ol.prototype._peerVideoTypeChanged=function(e,t){if(!e)return void il.error(`${this} No endpointID on peerVideoTypeChanged`);const n=this.getRemoteTracks(e,Ri.VIDEO);n.length&&n[0]._setVideoType(t)},ol.prototype._peerMutedChanged=function(e,t,n){if(!e)return void il.error(`${this} On peerMuteChanged - no endpoint ID`);const i=this.getRemoteTracks(e,t);i.length&&i[0].setMute(n)},ol.prototype._sourceMutedChanged=function(e,t){const n=this.getRemoteTracks().find((t=>t.getSourceName()===e));n?n.setMute(t):Ai.isSsrcRewritingSupported()&&il.debug(`Remote track not found for source=${e}, mute update failed!`)},ol.prototype._sourceVideoTypeChanged=function(e,t){const n=this.getRemoteTracks().find((t=>t.getSourceName()===e));n&&n._setVideoType(t)},ol.prototype.getAudioLevels=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];const t={};return(e.length?this._getReceiversByEndpointIds(e,Ri.AUDIO):this.peerconnection.getReceivers().filter((e=>e.track&&e.track.kind===Ri.AUDIO&&e.track.enabled))).forEach((e=>{const n=e.getSynchronizationSources();n&&n.length&&(t[n[0].source]=n[0].audioLevel)})),t},ol.prototype.doesTrueSimulcast=function(){const e=this.getConfiguredVideoCodec();return this.isSpatialScalabilityOn()&&this.tpcUtils.isRunningInSimulcastMode(e)},ol.prototype.getLocalVideoSSRCs=function(e){var t,n,i;const r=[];if(!e||!e.isVideoTrack())return r;const o=this.isSpatialScalabilityOn()?"SIM":"FID";return(null===(t=this.localSSRCs.get(e.rtcId))||void 0===t||null===(n=t.groups)||void 0===n||null===(i=n.find((e=>e.semantics===o)))||void 0===i?void 0:i.ssrcs)||r},ol.prototype.getLocalTracks=function(e){let t=Array.from(this.localTracks.values());return void 0!==e&&(t=t.filter((t=>t.getType()===e))),t},ol.prototype.getLocalVideoTracks=function(){return this.getLocalTracks(Ri.VIDEO)},ol.prototype.hasAnyTracksOfType=function(e){if(!e)throw new Error(\'"mediaType" is required\');return this.getLocalTracks(e).length>0},ol.prototype.getRemoteTracks=function(e,t){let n=[];const i=e?[e]:this.remoteTracks.keys();for(const e of i){const i=this.remoteTracks.get(e);if(i)for(const e of i.keys())t&&t!==e||(n=n.concat(Array.from(i.get(e))))}return n},ol.prototype.getRemoteSourceInfoByParticipant=function(e){const t=[],n=this.getRemoteTracks(e);if(null==n||!n.length)return t;const i=n.map((e=>e.getSSRC())),r=new Ms(this.remoteDescription.sdp);return i.forEach(((e,n)=>{for(const i of r.media){let r="",o=Ns.findLines(i,`a=ssrc:${e}`);if(o.length){t[n]||(t[n]="");const s=Ns.findLines(i,`a=ssrc-group:FID ${e}`);if(s.length){const e=s[0].split(" ")[2];r+=`${s[0]}\\r\\n`,o=o.concat(Ns.findLines(i,`a=ssrc:${e}`))}t[n]+=`${o.join("\\r\\n")}\\r\\n`,t[n]+=r}}})),t},ol.prototype.getTargetVideoBitrates=function(){const e=this.getConfiguredVideoCodec();return this.tpcUtils.codecSettings[e].maxBitratesVideo},ol.prototype.getTrackBySSRC=function(e){if("number"!=typeof e)throw new Error(`SSRC ${e} is not a number`);for(const t of this.localTracks.values())if(this.getLocalSSRC(t)===e)return t;for(const t of this.getRemoteTracks())if(t.getSSRC()===e)return t;return null},ol.prototype.getSsrcByTrackId=function(e){const t=t=>t.getTrack().id===e,n=this.getLocalTracks().find(t);if(n)return this.getLocalSSRC(n);const i=this.getRemoteTracks().find(t);return i?i.getSSRC():null},ol.prototype._remoteTrackAdded=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;const i=e.id,r=t.kind;if(!this.isP2P&&!nc.isUserStreamById(i))return;if(il.info(`${this} Received track event for remote stream[id=${i},type=${r}]`),!r)return void il.error(`MediaType undefined for remote track, stream id: ${i}, track creation failed!`);const o=new Ms(this.peerconnection.remoteDescription.sdp);let s;if(null!=n&&n.mid){const e=n.mid;s=o.media.find((t=>Ns.findLine(t,`a=mid:${e}`)))}else s=o.media.find((e=>{const t=Ns.findLine(e,"a=msid:");return"string"==typeof t&&i===t.substring(7).split(" ")[0]}));if(!s)return void il.error(`Matching media line not found in remote SDP for remote stream[id=${i},type=${r}],track creation failed!`);let a=Ns.findLines(s,"a=ssrc:");if(a=a.filter((e=>-1!==e.indexOf(`msid:${i}`))),!a.length)return void il.error(`No SSRC lines found in remote SDP for remote stream[msid=${i},type=${r}]track creation failed!`);const d=a[0].substring(7).split(" ")[0],c=Number(d),l=this.signalingLayer.getSSRCOwner(c);if(isNaN(c)||c<0)return void il.error(`Invalid SSRC for remote stream[ssrc=${c},id=${i},type=${r}]track creation failed!`);if(!l)return void il.error(`No SSRC owner known for remote stream[ssrc=${c},id=${i},type=${r}]track creation failed!`);const h=this.signalingLayer.getTrackSourceName(c),u=this.signalingLayer.getPeerMediaInfo(l,r,h);let p=!0,m=r===Ri.VIDEO?Qo.VideoType.CAMERA:void 0;u?(p=u.muted,m=u.videoType):il.info(`${this}: no source-info available for ${l}:${h}, assuming default state`),this._createRemoteTrack(l,e,t,r,m,c,p,h)},ol.prototype._createRemoteTrack=function(e,t,n,i,r,o,s,a){il.info(`${this} creating remote track[endpoint=${e},ssrc=${o},type=${i},sourceName=${a}]`);let d=this.remoteTracks.get(e);d||(d=new Map,d.set(Ri.AUDIO,new Set),d.set(Ri.VIDEO,new Set),this.remoteTracks.set(e,d));const c=d.get(i);if(null!=c&&c.size&&Array.from(c).find((e=>e.getTrack()===n)))return void il.info(`${this} ignored duplicated track event for track[endpoint=${e},type=${i}]`);const l=new Qc(this.rtc,this.rtc.conference,e,t,n,i,r,o,s,this.isP2P,a);c.add(l),this.eventEmitter.emit(ji.default.REMOTE_TRACK_ADDED,l,this)},ol.prototype._remoteTrackRemoved=function(e,t){const n=e.id,i=null==t?void 0:t.id;if(!nc.isUserStreamById(n))return;if(!n)return void il.error(`${this} remote track removal failed - no stream ID`);if(!i)return void il.error(`${this} remote track removal failed - no track ID`);const r=this.getRemoteTracks().find((e=>e.getStreamId()===n&&e.getTrackId()===i));r?this._removeRemoteTrack(r):il.error(`${this} remote track removal failed - track not found`)},ol.prototype.removeRemoteTracks=function(e){let t=[];const n=this.remoteTracks.get(e);return n&&(t=t.concat(Array.from(n.get(Ri.AUDIO))),t=t.concat(Array.from(n.get(Ri.VIDEO))),this.remoteTracks.delete(e)),il.debug(`${this} removed remote tracks[endpoint=${e},count=${t.length}`),t},ol.prototype._removeRemoteTrack=function(e){var t;il.info(`${this} Removing remote track stream[id=${e.getStreamId()},trackId=${e.getTrackId()}]`),e.dispose();const n=e.getParticipantId();if(!n&&Ai.isSsrcRewritingSupported())return;const i=this.remoteTracks.get(n);i?null!==(t=i.get(e.getType()))&&void 0!==t&&t.delete(e)||il.error(`${this} Failed to remove ${e} - type mapping messed up ?`):il.error(`${this} removeRemoteTrack: no remote tracks map for endpoint=${n}`),this.eventEmitter.emit(ji.default.REMOTE_TRACK_REMOVED,e)},ol.prototype._extractSSRCMap=function(e){const t=new Map,n=new Map;if("object"!=typeof e||null===e||"string"!=typeof e.sdp)return il.warn("An empty description was passed as an argument"),t;const i=Ps.parse(e.sdp);if(!Array.isArray(i.media))return t;let r=i.media;r=r.filter((e=>e.direction===As.SENDONLY||e.direction===As.SENDRECV));let o=0;for(const e of r){if(!Array.isArray(e.ssrcs))continue;if(Array.isArray(e.ssrcGroups)){for(const t of e.ssrcGroups)if(void 0!==t.semantics&&void 0!==t.ssrcs){const e=t.ssrcs.split(" ").map((e=>parseInt(e,10))),i=e[0];t.ssrcs=e,n.has(i)||n.set(i,[]),n.get(i).push(t)}if(!e.ssrcGroups.find((e=>"SIM"===e.semantics))){const t=e.ssrcGroups.map((e=>e.ssrcs[0]));n.get(t[0]).push({semantics:"SIM",ssrcs:t})}}let i=e.ssrcs;i=i.filter((e=>"cname"===e.attribute));for(const r of i){const i=`${e.type}-${o}`,s=r.id;let a=t.get(i);if(a||(a={ssrcs:[],groups:[],msid:i},t.set(i,a)),a.ssrcs.push(s),n.has(s)){const e=n.get(s);for(const t of e)a.groups.push(t)}}e.type===Ri.VIDEO&&o++}return t},ol.prototype.getLocalSSRC=function(e){const t=this._getSSRC(e.rtcId);return t&&t.ssrcs[0]},ol.prototype._injectSsrcGroupForUnifiedSimulcast=function(e){const t=Ps.parse(e.sdp),n=t.media.find((e=>"video"===e.type));n.ssrcGroups=n.ssrcGroups||[];const i=n.ssrcGroups.filter((e=>"FID"===e.semantics));if(n.simulcast||n.simulcast_03){const t=[];if(i&&i.length?i.forEach((e=>{t.push(e.ssrcs.split(" ")[0])})):n.ssrcs.forEach((e=>{"msid"===e.attribute&&t.push(e.id)})),n.ssrcGroups.find((e=>"SIM"===e.semantics)))return e;for(let e=0;e<t.length;e+=3){const i=t.slice(e,e+3);n.ssrcGroups.push({semantics:"SIM",ssrcs:i.join(" ")})}}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})};const al={signalingState(){return this.peerconnection.signalingState},iceConnectionState(){return this.peerconnection.iceConnectionState},connectionState(){return this.peerconnection.connectionState},localDescription(){let e=this.peerconnection.localDescription;return e?(this.trace("getLocalDescription::preTransform",sl(e)),this.isP2P||(e=this.interop.toPlanB(e),this.trace("getLocalDescription::postTransform (Plan B)",sl(e)),e=this._injectSsrcGroupForUnifiedSimulcast(e),this.trace("getLocalDescription::postTransform (inject ssrc group)",sl(e))),e=this.localSdpMunger.transformStreamIdentifiers(e),e):(il.debug(`${this} getLocalDescription no localDescription found`),{})},remoteDescription(){let e=this.peerconnection.remoteDescription;return e?(this.trace("getRemoteDescription::preTransform",sl(e)),this.isP2P?e=this._adjustRemoteMediaDirection(e):(e=this.interop.toPlanB(e),this.trace("getRemoteDescription::postTransform (Plan B)",sl(e))),e):(il.debug(`${this} getRemoteDescription no remoteDescription found`),{})}};Object.keys(al).forEach((e=>{Object.defineProperty(ol.prototype,e,{get:al[e]})})),ol.prototype._getSSRC=function(e){return this.localSSRCs.get(e)},ol.prototype.isSharingLowFpsScreen=function(){return this._isSharingScreen()&&this._capScreenshareBitrate},ol.prototype._isSharingScreen=function(){const e=this.getLocalVideoTracks();return Boolean(e.find((e=>e.videoType===Qo.VideoType.DESKTOP)))},ol.prototype._mungeCodecOrder=function(e){if(!this.codecSettings)return e;const t=Ps.parse(e.sdp),n=t.media.filter((e=>e.type===this.codecSettings.mediaType));if(!n.length)return e;for(const t of n){const n=this.getConfiguredVideoCodecs(e);for(const e of n)this.isP2P&&(e!==Ds.H264&&e!==Ds.VP9||Ns.stripCodec(t,e,!0),e!==Ds.ULPFEC&&e!==Ds.RED||Ns.stripCodec(t,e,!1));for(const e of this.codecSettings.codecList.slice().reverse())Ns.preferCodec(t,e,this.isP2P)}return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})},ol.prototype._updateAv1DdHeaders=function(e){const t=Ps.parse(e.sdp),n=t.media.filter((e=>e.type===Ri.VIDEO));return n.length&&ci.supportsDDExtHeaders()?(n.forEach(((e,t)=>{var n;const i=Array.from(this._localTrackTransceiverMids.values()),r=i.length?i.find((t=>e.mid.toString()===t.toString())):0===t,o=e.payloads.split(" ")[0];let{codec:s}=e.rtp.find((e=>e.payload===Number(o)));if(s=s.toLowerCase(),r&&null!==(n=e.ext)&&void 0!==n&&n.length){const t=e.ext.findIndex((e=>e.uri===rl)),n=s===Ds.AV1||s===Ds.H264;!this._supportsDDHeaderExt&&t>=0&&(this._supportsDDHeaderExt=!0),this._supportsDDHeaderExt&&n&&t<0?e.ext.push({value:11,uri:rl}):!n&&t>=0&&e.ext.splice(t,1)}})),new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})):e},ol.prototype.addTrack=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];const n=e.rtcId;if(il.info(`${this} adding ${e}`),this.localTracks.has(n))return Promise.reject(new Error(`${e} is already in ${this}`));this.localTracks.set(n,e);const i=e.getOriginalStream();try{this.tpcUtils.addTrack(e,t),e&&(e.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0)}catch(t){return il.error(`${this} Adding track=${e} failed: ${null==t?void 0:t.message}`),Promise.reject(t)}let r=Promise.resolve();return ci.isFirefox()&&(r=r.then((()=>i&&this.tpcUtils.setEncodings(e)))),r},ol.prototype.addTrackToPc=function(e){return il.info(`${this} Adding track=${e} to PC`),this._assertTrackBelongs("addTrackToPc",e)?e.getOriginalStream()?this.tpcUtils.replaceTrack(null,e).then((()=>(e&&(e.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0),!1))):(il.error(`${this} Unable to add track=${e} to PC - no WebRTC stream`),Promise.reject("Stream not found")):Promise.reject("Track not found on the peerconnection")},ol.prototype._assertTrackBelongs=function(e,t){const n=this.localTracks.has(null==t?void 0:t.rtcId);return n||il.error(`${this} ${e}: track=${t} does not belong to pc`),n},ol.prototype.getConfiguredVideoCodec=function(){var e;const t=null===(e=this.peerconnection.remoteDescription)||void 0===e?void 0:e.sdp,n=Ds.VP8;if(!t)return n;const i=Ps.parse(t).media.find((e=>e.type===Ri.VIDEO)),r=i.payloads.split(" ")[0],{codec:o}=i.rtp.find((e=>e.payload===Number(r)));return o?Object.values(Ds).find((e=>e===o.toLowerCase())):n},ol.prototype.getConfiguredVideoCodecs=function(e){var t,n;const i=null!==(t=null==e?void 0:e.sdp)&&void 0!==t?t:null===(n=this.peerconnection.localDescription)||void 0===n?void 0:n.sdp;if(!i)return[];const r=Ps.parse(i).media.find((e=>e.type===Ri.VIDEO)),o=new Set(r.rtp.filter((e=>"rtx"!==e.codec.toLowerCase())).map((e=>e.codec.toLowerCase())));return Array.from(o)},ol.prototype.isVideoCodecDisabled=function(e){var t;const n=null===(t=this.peerconnection.localDescription)||void 0===t?void 0:t.sdp;return!!n&&!Ps.parse(n).media.find((e=>e.type===Ri.VIDEO)).rtp.find((t=>t.codec===e))},ol.prototype.setDesktopSharingFrameRate=function(e){const t=e<=5;this._capScreenshareBitrate=this.isSpatialScalabilityOn()&&t},ol.prototype.setVideoCodecs=function(e){this.codecSettings&&null!=e&&e.length&&(this.codecSettings.codecList=e)},ol.prototype.removeTrack=function(e){const t=e.getOriginalStream();this.trace("removeStream",e.rtcId,t?t.id:void 0),this._assertTrackBelongs("removeStream",e)&&(this.localTracks.delete(e.rtcId),this.localSSRCs.delete(e.rtcId),t&&this.peerconnection.removeStream(t))},ol.prototype.findSenderByKind=function(e){if(this.peerconnection.getSenders)return this.peerconnection.getSenders().find((t=>t.track&&t.track.kind===e))},ol.prototype.findReceiverForTrack=function(e){return this.peerconnection.getReceivers().find((t=>t.track===e))},ol.prototype.findSenderForTrack=function(e){if(this.peerconnection.getSenders)return this.peerconnection.getSenders().find((t=>t.track===e))},ol.prototype.processLocalSdpForTransceiverInfo=function(e){var t;const n=null===(t=this.peerconnection.localDescription)||void 0===t?void 0:t.sdp;n&&[Ri.AUDIO,Ri.VIDEO].forEach((t=>{const i=e.filter((e=>e.getType()===t)),r=Ps.parse(n).media.filter((e=>e.type===t));i.forEach(((e,t)=>{this._localTrackTransceiverMids.has(e.rtcId)||this._localTrackTransceiverMids.set(e.rtcId,r[t].mid.toString())}))}))},ol.prototype.replaceTrack=function(e,t){return e||t?(il.info(`${this} TPC.replaceTrack old=${e}, new=${t}`),this.tpcUtils.replaceTrack(e,t).then((n=>{var i;if(e&&(this.localTracks.delete(e.rtcId),this._localTrackTransceiverMids.delete(e.rtcId)),t&&(t.isAudioTrack()?this._hasHadAudioTrack=!0:this._hasHadVideoTrack=!0,this._localTrackTransceiverMids.set(t.rtcId,null==n||null===(i=n.mid)||void 0===i?void 0:i.toString()),this.localTracks.set(t.rtcId,t)),e&&t){const n=this.localSSRCs.get(e.rtcId);n&&(this.localSSRCs.delete(e.rtcId),this.localSSRCs.set(t.rtcId,n))}return n&&(n.direction=t||ci.isFirefox()?As.SENDRECV:As.RECVONLY),(!t||t.getType()===Ri.VIDEO&&ci.usesSdpMungingForSimulcast()?Promise.resolve():this.tpcUtils.setEncodings(t)).then((()=>this.isP2P))}))):(il.info(`${this} replaceTrack called with no new track and no old track`),Promise.resolve())},ol.prototype.removeTrackFromPc=function(e){const t=e.getOriginalStream();return this.trace("removeTrack",e.rtcId,t?t.id:null),this._assertTrackBelongs("removeTrack",e)?this.tpcUtils.replaceTrack(e,null).then((()=>!1)):Promise.reject("Track not found in the peerconnection")},ol.prototype.createDataChannel=function(e,t){return this.trace("createDataChannel",e,t),this.peerconnection.createDataChannel(e,t)},ol.prototype._adjustRemoteMediaDirection=function(e){const t=new Lc(e.sdp);return[Ri.AUDIO,Ri.VIDEO].forEach((e=>{const n=t.selectMedia(e),i=this.getLocalTracks(e).length,r=this.getRemoteTracks(null,e).length;n.forEach(((e,t)=>{e.direction=i&&i===r?As.SENDRECV:i||r?i?r?i>r?t?As.RECVONLY:As.SENDRECV:t?As.SENDONLY:As.SENDRECV:As.RECVONLY:As.SENDONLY:As.INACTIVE}))})),new RTCSessionDescription({type:e.type,sdp:t.toRawSDP()})},ol.prototype._mungeOpus=function(e){const{audioQuality:t}=this.options;if(!(null!=t&&t.enableOpusDtx||null!=t&&t.stereo||null!=t&&t.opusMaxAverageBitrate))return e;const n=Ps.parse(e.sdp),i=n.media;for(const e of i)if("audio"===e.type){const{payload:n}=e.rtp.find((e=>e.codec===Ds.OPUS));if(!n)continue;let i=e.fmtp.find((e=>e.payload===n));i||(i={payload:n,config:""});const r=Ps.parseParams(i.config);let o=!1;if(null!=t&&t.stereo&&(r.stereo=1,o=!0),null!=t&&t.opusMaxAverageBitrate&&(r.maxaveragebitrate=t.opusMaxAverageBitrate,o=!0),!ci.isFirefox()&&null!=t&&t.enableOpusDtx&&(r.usedtx=1,o=!0),!o)continue;let s="";for(const e of Object.keys(r))s+=`${e}=${r[e]}; `;i.config=s.trim()}return new RTCSessionDescription({type:e.type,sdp:Ps.write(n)})},ol.prototype._mungeInactive=function(e){const t=Ps.parse(e.sdp),n=t.media;for(const e of n)e.direction=As.INACTIVE,e.ssrcs=void 0,e.ssrcGroups=void 0;return new RTCSessionDescription({type:e.type,sdp:Ps.write(t)})},ol.prototype._initializeDtlsTransport=function(){if(!this.peerconnection.getSenders||this._dtlsTransport)return;const e=this.peerconnection.getSenders();0!==e.length&&e[0].transport&&(this._dtlsTransport=e[0].transport,this._dtlsTransport.onerror=e=>{il.error(`${this} DtlsTransport error: ${e}`)},this._dtlsTransport.onstatechange=()=>{this.trace("dtlsTransport.onstatechange",this._dtlsTransport.state)})},ol.prototype._setMaxBitrates=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];if(!this.codecSettings)return e;const n=Ps.parse(e.sdp),i=t?As.RECVONLY:As.SENDONLY,r=n.media.filter((e=>e.type===Ri.VIDEO&&e.direction!==i)),o=this.codecSettings.codecList[0],s=this.tpcUtils.codecSettings[o];for(const e of r){const t=o===Ds.VP9&&!s.scalabilityModeEnabled,n=this.getLocalVideoTracks().find((t=>this._localTrackTransceiverMids.get(t.rtcId)===e.mid.toString()));if((t||this.tpcUtils._isRunningInFullSvcMode(o))&&n){let t;if(n.getVideoType()===Qo.VideoType.DESKTOP)t=s.maxBitratesVideo.ssHigh;else{const{level:e}=Pc.find((e=>e.height<=n.getCaptureResolution()));t=s.maxBitratesVideo[e]}const i=Math.floor(t/1e3);e.bandwidth=[{type:"AS",limit:i}]}else e.bandwidth=void 0}return new RTCSessionDescription({type:e.type,sdp:Ps.write(n)})},ol.prototype.configureAudioSenderEncodings=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(e)return this.tpcUtils.setEncodings(e);const t=[];for(const e of this.getLocalTracks(Ri.AUDIO))t.push(this.tpcUtils.setEncodings(e));return Promise.allSettled(t)},ol.prototype.configureVideoSenderEncodings=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;if(e)return this.setSenderVideoConstraints(this._senderMaxHeights.get(e.getSourceName()),e);const t=[];for(const e of this.getLocalVideoTracks()){var n;const i=null!==(n=this._senderMaxHeights.get(e.getSourceName()))&&void 0!==n?n:Pc[0].height;t.push(this.setSenderVideoConstraints(i,e))}return Promise.allSettled(t)},ol.prototype.setLocalDescription=function(e){let t=e;return this.trace("setLocalDescription::preTransform",sl(t)),t=this._mungeOpus(t),t=this._mungeCodecOrder(t),t=this._setMaxBitrates(t,!0),t=this._updateAv1DdHeaders(t),this.trace("setLocalDescription::postTransform",sl(t)),new Promise(((e,n)=>{this.peerconnection.setLocalDescription(t).then((()=>{this.trace("setLocalDescriptionOnSuccess");const n=Ns.getUfrag(t.sdp);n!==this.localUfrag&&(this.localUfrag=n,this.eventEmitter.emit(ji.default.LOCAL_UFRAG_CHANGED,this,n)),this._initializeDtlsTransport(),e()}),(e=>{this.trace("setLocalDescriptionOnFailure",e),this.eventEmitter.emit(ji.default.SET_LOCAL_DESCRIPTION_FAILED,e,this),n(e)}))}))},ol.prototype.setRemoteDescription=function(e){let t=e;if(this.trace("setRemoteDescription::preTransform",sl(e)),t=this._mungeOpus(t),!this.isP2P){const e=this.peerconnection.remoteDescription;t=this.interop.toUnifiedPlan(t,e),this.trace("setRemoteDescription::postTransform (Unified)",sl(t))}return this.isSpatialScalabilityOn()&&(t=this.tpcUtils.insertUnifiedPlanSimulcastReceive(t),this.trace("setRemoteDescription::postTransform (sim receive)",sl(t))),t=this.tpcUtils.ensureCorrectOrderOfSsrcs(t),this.trace("setRemoteDescription::postTransform (correct ssrc order)",sl(t)),t=this._mungeCodecOrder(t),t=this._setMaxBitrates(t),t=this._updateAv1DdHeaders(t),this.trace("setRemoteDescription::postTransform (munge codec order)",sl(t)),new Promise(((e,n)=>{this.peerconnection.setRemoteDescription(t).then((()=>{this.trace("setRemoteDescriptionOnSuccess");const n=Ns.getUfrag(t.sdp);n!==this.remoteUfrag&&(this.remoteUfrag=n,this.eventEmitter.emit(ji.default.REMOTE_UFRAG_CHANGED,this,n)),this._initializeDtlsTransport(),e()}),(e=>{this.trace("setRemoteDescriptionOnFailure",e),this.eventEmitter.emit(ji.default.SET_REMOTE_DESCRIPTION_FAILED,e,this),n(e)}))}))},ol.prototype.setSenderVideoConstraints=function(e,t){if(e<0||isNaN(e))throw new Error(`Invalid frameHeight: ${e}`);if(!t)throw new Error("Local video track is missing");const n=t.getSourceName();return t.isMuted()?(this._senderMaxHeights.set(n,e),Promise.resolve()):this._updateVideoSenderParameters((()=>this._updateVideoSenderEncodings(e,t)))},ol.prototype._updateVideoSenderParameters=function(e){const t=this._lastVideoSenderUpdatePromise.finally(e);return this._lastVideoSenderUpdatePromise=t,t},ol.prototype._updateVideoSenderEncodings=function(e,t){var n;const i=this.findSenderForTrack(t.getTrack());if(!i)return Promise.resolve();const r=i.getParameters();if(null==r||null===(n=r.encodings)||void 0===n||!n.length)return Promise.resolve();const o=t.getVideoType()===Qo.VideoType.DESKTOP&&this._capScreenshareBitrate?"maintain-resolution":"maintain-framerate";r.degradationPreference=o;const s=this.getConfiguredVideoCodec(),a=this.tpcUtils.calculateEncodingsBitrates(t,s,e),d=this.tpcUtils.calculateEncodingsActiveState(t,s,e),c=this.tpcUtils.calculateEncodingsScaleFactor(t,s,e),l=this.tpcUtils.calculateEncodingsScalabilityMode(t,s,e),h=t.getSourceName();let u=!1;for(const e in r.encodings)if(r.encodings.hasOwnProperty(e)){const{active:t,maxBitrate:n,scalabilityMode:i,scaleResolutionDownBy:h}=r.encodings[e];t!==d[e]&&(r.encodings[e].active=d[e],u=!0),ci.isFirefox()&&(r.encodings[e].degradationPreference=o),(s!==Ds.VP9||!this.isSpatialScalabilityOn()||ci.supportsScalabilityModeAPI()&&this.tpcUtils.codecSettings[s].scalabilityModeEnabled)&&(h!==c[e]&&(r.encodings[e].scaleResolutionDownBy=c[e],u=!0),n!==a[e]&&(r.encodings[e].maxBitrate=a[e],u=!0)),l?i!==l[e]&&(r.encodings[e].scalabilityMode=l[e],u=!0):r.encodings[e].scalabilityMode=void 0}return u?(il.info(`${this} setting max height=${e},encodings=${JSON.stringify(r.encodings)}`),i.setParameters(r).then((()=>{this._senderMaxHeights.set(h,e),t.maxEnabledResolution=e,this.eventEmitter.emit(ji.default.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,t)}))):(this._senderMaxHeights.set(h,e),Promise.resolve())},ol.prototype.setVideoTransferActive=function(e){il.debug(`${this} video transfer active: ${e}`);const t=this.videoTransferActive!==e;return this.videoTransferActive=e,t?this.tpcUtils.setMediaTransferActive(e,Ri.VIDEO):Promise.resolve()},ol.prototype.sendTones=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:200,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:200;if(!this._dtmfSender){if(this.peerconnection.getSenders){const e=this.peerconnection.getSenders().find((e=>e.dtmf));this._dtmfSender=e&&e.dtmf,this._dtmfSender&&il.info(`${this} initialized DTMFSender using getSenders`)}if(!this._dtmfSender){const e=Array.from(this.localTracks.values()).find((e=>e.isAudioTrack()));this.peerconnection.createDTMFSender&&e&&(this._dtmfSender=this.peerconnection.createDTMFSender(e.getTrack())),this._dtmfSender&&il.info(`${this} initialized DTMFSender using deprecated createDTMFSender`)}this._dtmfSender&&(this._dtmfSender.ontonechange=this._onToneChange.bind(this))}if(this._dtmfSender){if(this._dtmfSender.toneBuffer)return void this._dtmfTonesQueue.push({tones:e,duration:t,interToneGap:n});this._dtmfSender.insertDTMF(e,t,n)}else il.warn(`${this} sendTones - failed to select DTMFSender`)},ol.prototype._onToneChange=function(e){if(this._dtmfSender&&""===e.tone&&this._dtmfTonesQueue.length){const{tones:e,duration:t,interToneGap:n}=this._dtmfTonesQueue.shift();this._dtmfSender.insertDTMF(e,t,n)}},ol.prototype.close=function(){this.trace("stop"),this.signalingLayer.off(Ec,this._peerMutedChanged),this.signalingLayer.off(yc,this._peerVideoTypeChanged),this.peerconnection.removeEventListener("track",this.onTrack);for(const e of this.remoteTracks.values())for(const t of e.values())for(const e of t)this._removeRemoteTrack(e);this.remoteTracks.clear(),this._dtmfSender=null,this._dtmfTonesQueue=[],this.rtc._removePeerConnection(this)||il.error(`${this} rtc._removePeerConnection returned false`),null!==this.statsinterval&&(window.clearInterval(this.statsinterval),this.statsinterval=null),il.info(`${this} Closing peerconnection`),this.peerconnection.close()},ol.prototype.createAnswer=function(e){return this._createOfferOrAnswer(!1,e)},ol.prototype.createOffer=function(e){return this._createOfferOrAnswer(!0,e)},ol.prototype._createOfferOrAnswer=function(e,t){const n=e?"Offer":"Answer";this.trace(`create${n}`,JSON.stringify(t,null," "));const i=(e,t,i)=>{try{this.trace(`create${n}OnSuccess::preTransform`,sl(e)),this.isSpatialScalabilityOn()&&ci.usesSdpMungingForSimulcast()&&(e=this.simulcast.mungeLocalDescription(e),this.trace(`create${n} OnSuccess::postTransform (simulcast)`,sl(e))),!this.options.disableRtx&&ci.usesSdpMungingForSimulcast()&&(e=new RTCSessionDescription({type:e.type,sdp:this.rtxModifier.modifyRtxSsrcs(e.sdp)}),this.trace(`create${n}OnSuccess::postTransform (rtx modifier)`,sl(e)));const i=this._extractSSRCMap(e);this._processLocalSSRCsMap(i),t(e)}catch(t){this.trace(`create${n}OnError`,t),this.trace(`create${n}OnError`,sl(e)),il.error(`${this} create${n}OnError`,t,sl(e)),i(t)}},r=(t,i)=>{this.trace(`create${n}OnFailure`,t);const r=e?ji.default.CREATE_OFFER_FAILED:ji.default.CREATE_ANSWER_FAILED;this.eventEmitter.emit(r,t,this),i(t)};if(ci.supportsCodecPreferences()&&this.codecSettings){var o;const{codecList:e,mediaType:t}=this.codecSettings,n=this.peerconnection.getTransceivers().filter((e=>{var n,i;return e.receiver&&(null===(n=e.receiver)||void 0===n||null===(i=n.track)||void 0===i?void 0:i.kind)===t}));let i=null===(o=RTCRtpReceiver.getCapabilities(t))||void 0===o?void 0:o.codecs;if(n.length&&i){for(const n of e.slice().reverse())i.sort((e=>e.mimeType.toLowerCase()===`${t}/${n}`?-1:1));this.isP2P&&t===Ri.VIDEO&&(i=i.filter((e=>e.mimeType.toLowerCase()!==`${Ri.VIDEO}/${Ds.ULPFEC}`&&e.mimeType.toLowerCase()!==`${Ri.VIDEO}/${Ds.RED}`)));for(const e of n)e.setCodecPreferences(i)}}return new Promise(((n,o)=>{let s;s=e?this.peerconnection.createOffer(t):this.peerconnection.createAnswer(t),s.then((e=>i(e,n,o)),(e=>r(e,o)))}))},ol.prototype._extractPrimarySSRC=function(e){return e&&e.groups&&e.groups.length?e.groups[0].ssrcs[0]:e&&e.ssrcs&&e.ssrcs.length?e.ssrcs[0]:null},ol.prototype._processLocalSSRCsMap=function(e){for(const t of this.localTracks.values()){const n=Rc(t.getSourceName()),i=`${t.getType()}-${n}`;if(e.has(i)){const n=e.get(i);if(!n)return void il.error(`${this} No SSRC found for stream=${i}`);const r=this.localSSRCs.get(t.rtcId),o=this._extractPrimarySSRC(n),s=this._extractPrimarySSRC(r);o!==s&&(s&&il.error(`${this} Overwriting SSRC for track=${t}] with ssrc=${n}`),this.localSSRCs.set(t.rtcId,n),this.eventEmitter.emit(ji.default.LOCAL_TRACK_SSRC_UPDATED,t,o))}else t.isVideoTrack()||t.isMuted()||il.warn(`${this} No SSRCs found in the local SDP for track=${t}, stream=${i}`)}},ol.prototype.addRemoteSsrc=function(e){const t=this.remoteSSRCs.has(e);return t||this.remoteSSRCs.add(e),!t},ol.prototype.addIceCandidate=function(e){return this.trace("addIceCandidate",JSON.stringify({candidate:e.candidate,sdpMid:e.sdpMid,sdpMLineIndex:e.sdpMLineIndex,usernameFragment:e.usernameFragment},null," ")),this.peerconnection.addIceCandidate(e)},ol.prototype.getStats=function(){return this.peerconnection.getStats()},ol.prototype.toString=function(){return`TPC[id=${this.id},type=${this.isP2P?"P2P":"JVB"}]`};const dl=(0,y.getLogger)("modules/RTC/RTC.js");let cl,ll=0,hl=0;function ul(){return(arguments.length>0&&void 0!==arguments[0]?arguments[0]:[]).map((e=>{const{constraints:t,sourceId:n,sourceType:i,stream:r,track:o,videoType:s,effects:a}=e,{deviceId:d,facingMode:c}=o.getSettings();return hl=Ei(hl),new ac({constraints:t,deviceId:d,facingMode:c,mediaType:o.kind,rtcId:hl,sourceId:n,sourceType:i,stream:r,track:o,videoType:s||null,effects:a})}))}class pl extends xr{constructor(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(),this.conference=e,this.peerConnections=new Map,this.localTracks=[],this.options=t,this._channel=null,this._lastN=void 0,this._forwardedSources=null,this._forwardedSourcesChangeListener=this._onForwardedSourcesChanged.bind(this),this._onDeviceListChanged=this._onDeviceListChanged.bind(this),this._updateAudioOutputForAudioTracks=this._updateAudioOutputForAudioTracks.bind(this),nc.isDeviceChangeAvailable("output")&&(nc.addListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._updateAudioOutputForAudioTracks),nc.addListener(ji.default.DEVICE_LIST_CHANGED,this._onDeviceListChanged))}destroy(){nc.removeListener(ji.default.AUDIO_OUTPUT_DEVICE_CHANGED,this._updateAudioOutputForAudioTracks),nc.removeListener(ji.default.DEVICE_LIST_CHANGED,this._onDeviceListChanged),this._channelOpenListener&&this.removeListener(ji.default.DATA_CHANNEL_OPEN,this._channelOpenListener)}static createLocalTracks(e){return ul(e)}static obtainAudioAndVideoPermissions(e){return nc.obtainAudioAndVideoPermissions(e).then((e=>ul(e)))}initializeBridgeChannel(e,t){this._channel=new ja(e,t,this.eventEmitter,this.conference),this._channelOpenListener=()=>{const e=(e,t,n)=>{dl.error(`Cannot send ${t}(${JSON.stringify(n)}) endpoint message`,e)};if(this._receiverVideoConstraints)try{this._channel.sendReceiverVideoConstraintsMessage(this._receiverVideoConstraints)}catch(t){e(t,"ReceiverVideoConstraints",this._receiverVideoConstraints)}if(void 0!==this._lastN&&-1!==this._lastN)try{this._channel.sendSetLastNMessage(this._lastN)}catch(t){e(t,"LastNChangedEvent",this._lastN)}},this.addListener(ji.default.DATA_CHANNEL_OPEN,this._channelOpenListener),this.addListener(ji.default.FORWARDED_SOURCES_CHANGED,this._forwardedSourcesChangeListener)}_onDeviceListChanged(){this._updateAudioOutputForAudioTracks(nc.getAudioOutputDevice())}_onForwardedSourcesChanged(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];const t=this._forwardedSources||[];let n=[],i=[];const r=Date.now();this._forwardedSources=e,n=t.filter((e=>!this.isInForwardedSources(e))),i=e.filter((e=>-1===t.indexOf(e))),dl.debug(`Fowarded sources changed leaving=${n}, entering=${i} at ${r}`),this.conference.eventEmitter.emit(Re,n,i,r)}onCallEnded(){this._channel&&(this._channel&&"websocket"===this._channel.mode&&this._channel.close(),this._channel=null)}setDesktopSharingFrameRate(e){nc.setDesktopSharingFrameRate(e)}setReceiverVideoConstraints(e){this._receiverVideoConstraints=e,this._channel&&this._channel.isOpen()&&this._channel.sendReceiverVideoConstraintsMessage(e)}sendSourceVideoType(e,t){this._channel&&this._channel.isOpen()&&this._channel.sendSourceVideoTypeMessage(e,t)}static addListener(e,t){nc.addListener(e,t)}static removeListener(e,t){nc.removeListener(e,t)}static init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.options=e,nc.init(this.options)}createPeerConnection(e,t,n,i){const r=Ss()(nc.pcConstraints);i.enableInsertableStreams&&(dl.debug("E2EE - setting insertable streams constraints"),t.encodedInsertableStreams=!0),i.forceTurnRelay&&(t.iceTransportPolicy="relay"),t.bundlePolicy="max-bundle",ll=Ei(ll);const o=new ol(this,ll,e,t,r,n,i);return this.peerConnections.set(o.id,o),o}_removePeerConnection(e){const t=e.id;return!!this.peerConnections.has(t)&&(this.peerConnections.delete(t),!0)}addLocalTrack(e){if(!e)throw new Error("track must not be null nor undefined");this.localTracks.push(e),e.conference=this.conference}getForwardedSources(){return this._forwardedSources}getLocalVideoTrack(){const e=this.getLocalTracks(Ri.VIDEO);return e.length?e[0]:void 0}getLocalVideoTracks(){return this.getLocalTracks(Ri.VIDEO)}getLocalAudioTrack(){const e=this.getLocalTracks(Ri.AUDIO);return e.length?e[0]:void 0}getLocalEndpointId(){return this.conference.myUserId()}getLocalTracks(e){let t=this.localTracks.slice();return void 0!==e&&(t=t.filter((t=>t.getType()===e))),t}getRemoteTracks(e){let t=[];for(const n of this.peerConnections.values()){const i=n.getRemoteTracks(void 0,e);i&&(t=t.concat(i))}return t}setAudioMute(e){const t=[];return this.getLocalTracks(Ri.AUDIO).forEach((n=>{t.push(e?n.mute():n.unmute())})),Promise.all(t)}setVideoMute(e){const t=[];return this.getLocalTracks(Ri.VIDEO).forEach((n=>{t.push(e?n.mute():n.unmute())})),Promise.all(t)}removeLocalTrack(e){const t=this.localTracks.indexOf(e);-1!==t&&this.localTracks.splice(t,1)}static attachMediaStream(e,t){return nc.attachMediaStream(e,t)}static isDeviceListAvailable(){return nc.isDeviceListAvailable()}static isDeviceChangeAvailable(e){return nc.isDeviceChangeAvailable(e)}static isWebRtcSupported(){return ci.isSupported()}static getAudioOutputDevice(){return nc.getAudioOutputDevice()}static getCurrentlyAvailableMediaDevices(){return nc.getCurrentlyAvailableMediaDevices()}static arePermissionsGrantedForAvailableDevices(){return nc.arePermissionsGrantedForAvailableDevices()}static getEventDataForActiveDevice(e){return nc.getEventDataForActiveDevice(e)}static setAudioOutputDevice(e){return nc.setAudioOutputDevice(e)}static enumerateDevices(e){nc.enumerateDevices(e)}static stopMediaStream(e){nc.stopMediaStream(e)}static isDesktopSharingEnabled(){return nc.isDesktopSharingEnabled()}closeBridgeChannel(){this._channel&&(this._channel.close(),this._channel=null)}setAudioLevel(e,t,n,i){const r=e.getTrackBySSRC(t);r&&(r.isAudioTrack()?(r.isLocal()!==i&&dl.error(`${r} was expected to ${i?"be":"not be"} local`),r.setAudioLevel(n,e)):dl.warn(`Received audio level for non-audio track: ${t}`))}sendChannelMessage(e,t){if(!this._channel)throw new Error("Channel support is disabled!");this._channel.sendMessage(e,t)}sendEndpointStatsMessage(e){this._channel&&this._channel.isOpen()&&this._channel.sendEndpointStatsMessage(e)}setLastN(e){this._lastN!==e&&(this._lastN=e,this._channel&&this._channel.isOpen()&&this._channel.sendSetLastNMessage(e),this.eventEmitter.emit(ji.default.LASTN_VALUE_CHANGED,e))}isInForwardedSources(e){return!this._forwardedSources||this._forwardedSources.indexOf(e)>-1}_updateAudioOutputForAudioTracks(e){const t=this.getRemoteTracks(Ri.AUDIO);for(const n of t)n.setAudioOutput(e)}}!function(e){e.LOCAL_STATS_UPDATED="cq.local_stats_updated",e.REMOTE_STATS_UPDATED="cq.remote_stats_updated"}(cl||(cl={}));const ml=cl.LOCAL_STATS_UPDATED,gl=cl.REMOTE_STATS_UPDATED,fl=n(125),{VideoType:vl}=n(408),{XMPPEvents:_l}=n(609),El=(0,y.getLogger)("modules/connectivity/ConnectionQuality.js");let yl=800;class Sl{constructor(e,t,n){var i;this.eventEmitter=t,this._conference=e,this._localStats={connectionQuality:100,jvbRTT:void 0},this._lastConnectionQualityUpdate=-1,this._options=n,this._remoteStats={},this._timeIceConnected=-1,this._timeVideoUnmuted=-1,(null===(i=this._options.config)||void 0===i?void 0:i.startBitrate)>0&&(yl=this._options.config.startBitrate),e.on(me,(()=>{this._updateLocalConnectionQuality(0),this.eventEmitter.emit(ml,this._localStats),this._broadcastLocalStats()})),e.room.addListener(_l.ICE_CONNECTION_STATE_CHANGED,((e,t)=>{e.isP2P||"connected"!==t||(this._timeIceConnected=window.performance.now())})),e.on(Ce,((e,t)=>{"stats"===t.type&&this._updateRemoteStats(e.getId(),t.values)})),e.on(xe,((e,t)=>{this._updateRemoteStats(e.getId(),t)})),this._options.config.disableLocalStats||e.statistics.addConnectionStatsListener(this._updateLocalStats.bind(this)),e.on(it,(e=>{e.isVideoTrack()&&(e.isMuted()?this._timeVideoUnmuted=-1:this._maybeUpdateUnmuteTime())})),e.on(tt,(e=>{e.isVideoTrack()&&!e.isMuted()&&this._maybeUpdateUnmuteTime()})),e.rtc.on(ji.LOCAL_TRACK_MAX_ENABLED_RESOLUTION_CHANGED,(e=>{this._localStats.maxEnabledResolution=e.maxEnabledResolution})),e.on(We,(e=>{this._localStats.serverRegion=e})),e.on(ze,(e=>{this._localStats.bridgeCount=Number((e||{})["bridge-count"])}))}_maybeUpdateUnmuteTime(){this._timeVideoUnmuted<0&&(this._timeVideoUnmuted=window.performance.now())}_calculateConnectionQuality(e,t,n){const i=fl[n];let r,o=100;if(this._localStats.packetLoss&&(r=this._localStats.packetLoss.upload,t&&(r*=.5)),t||!i||e===vl.DESKTOP||this._timeIceConnected<0||this._timeVideoUnmuted<0)void 0===r?(El.error("Cannot calculate connection quality, unknown packet loss."),o=100):o=r<=2?100:r<=4?70:r<=6?50:r<=8?30:r<=12?10:0;else{const e=this._conference.getActivePeerConnection();if(e){var s,a;const t=window.performance.now()-Math.max(this._timeVideoUnmuted,this._timeIceConnected),n=null!==(s=null===(a=this._options.config)||void 0===a?void 0:a.pcStatsInterval)&&void 0!==s?s:1e4;let r=function(e,t,n,i){let r=0,o=Math.min(t.height,t.width),s=Pc.find((e=>e.height<=o));if(s&&e)for(o=s.height;o>=180;o/=2){const e=o;if(s=Pc.find((t=>t.height===e)),!s)break;r+=i[s.level]}else s&&(r=i[s.level]);return Math.min(r/1e3,function(e){return e>6e4?Number.MAX_SAFE_INTEGER:yl*Math.pow(1.08,e/1e3)}(Math.max(0,n-1e3)))}(e.doesTrueSimulcast(),i,t,e.getTargetVideoBitrates());r=Math.min(r,2500),t>n&&(o=100*this._localStats.bitrate.upload/r)}r&&r>=10&&(o=Math.min(o,30))}if(this._lastConnectionQualityUpdate>0){const e=2,t=this._localStats.connectionQuality,n=(window.performance.now()-this._lastConnectionQualityUpdate)/1e3;o=Math.min(o,t+n*e)}return Math.min(100,o)}_updateLocalConnectionQuality(e){this._localStats.connectionQuality=e,this._lastConnectionQualityUpdate=window.performance.now()}_broadcastLocalStats(){const e={bitrate:this._localStats.bitrate,packetLoss:this._localStats.packetLoss,connectionQuality:this._localStats.connectionQuality,jvbRTT:this._localStats.jvbRTT,serverRegion:this._localStats.serverRegion,maxEnabledResolution:this._localStats.maxEnabledResolution,avgAudioLevels:this._localStats.localAvgAudioLevels};try{this._conference.sendEndpointStatsMessage(e)}catch(e){}}_updateLocalStats(e,t){if(!e.isP2P){const e=t.transport&&t.transport.length&&t.transport[0].rtt;this._localStats.jvbRTT=e||void 0}if(e!==this._conference.getActivePeerConnection())return;let n;const i=!this._conference.isConnectionInterrupted(),r=this._conference.getLocalVideoTrack(),o=r?r.videoType:void 0,s=!r||r.isMuted(),a=r?Math.min(r.resolution,r.maxEnabledResolution):null;for(n in s||this._maybeUpdateUnmuteTime(),t)t.hasOwnProperty(n)&&(this._localStats[n]=t[n]);i&&this._updateLocalConnectionQuality(this._calculateConnectionQuality(o,s,a)),this.eventEmitter.emit(ml,this._localStats),this._broadcastLocalStats()}_updateRemoteStats(e,t){this._remoteStats[e]={bitrate:t.bitrate,packetLoss:t.packetLoss,connectionQuality:t.connectionQuality,jvbRTT:t.jvbRTT,serverRegion:t.serverRegion,maxEnabledResolution:t.maxEnabledResolution,avgAudioLevels:t.avgAudioLevels},this.eventEmitter.emit(gl,e,this._remoteStats[e])}getStats(){return this._localStats}}const bl=(0,y.getLogger)("modules/connectivity/IceFailedHandling.js");class Tl{constructor(e){this._conference=e}_actOnIceFailed(){if(!this._conference.room)return;const{enableForcedReload:e,enableIceRestart:t}=this._conference.options.config,n=void 0!==t&&!t,i=this._conference.room.supportsRestartByTerminate(),r=i&&!t;if(bl.info(`ICE failed, enableForcedReload: ${e}, enableIceRestart: ${t}, supports restart by terminate: ${i}`),n||!t&&!i||e){bl.info("ICE failed, but ICE restarts are disabled");const t=e?I:F;return void this._conference.eventEmitter.emit(ae,t)}const o=this._conference.jvbJingleSession,s=o&&o.getIceConnectionState();o?"connected"===s?bl.info("ICE connection restored - not sending ICE failed"):(bl.info(`Sending ICE failed - the connection did not recover, ICE state: ${s}, use \'session-terminate\': ${r}`),r?this._conference._stopJvbSession({reason:"connectivity-error",reasonDescription:"ICE FAILED",requestRestart:!0,sendSessionTerminate:!0}):this._conference.jvbJingleSession.sendIceFailedNotification()):bl.warn("Not sending ICE failed - no JVB connection")}start(){this._conference.xmpp.ping(65e3).then((()=>{this._canceled||(this._iceFailedTimeout=window.setTimeout((()=>{this._iceFailedTimeout=void 0,this._actOnIceFailed()}),2e3))}),(e=>{bl.error("PING error/timeout - not sending ICE failed",e)}))}cancel(){this._canceled=!0,window.clearTimeout(this._iceFailedTimeout)}}let Cl;!function(e){e.DETECTOR_STATE_CHANGE="detector_state_change",e.AUDIO_INPUT_STATE_CHANGE="audio_input_state_changed",e.NO_AUDIO_INPUT="no_audio_input_detected",e.VAD_NOISY_DEVICE="detection.vad_noise_device",e.VAD_REPORT_PUBLISHED="vad-report-published",e.VAD_SCORE_PUBLISHED="detection.vad_score_published",e.VAD_TALK_WHILE_MUTED="detection.vad_talk_while_muted"}(Cl||(Cl={}));const xl=Cl.DETECTOR_STATE_CHANGE,Rl=Cl.AUDIO_INPUT_STATE_CHANGE,Al=Cl.NO_AUDIO_INPUT,wl=Cl.VAD_NOISY_DEVICE,Il=Cl.VAD_REPORT_PUBLISHED,Pl=Cl.VAD_SCORE_PUBLISHED,Dl=Cl.VAD_TALK_WHILE_MUTED;class Ol extends ii{constructor(e){super(),this._conference=e,this._timeoutTrigger=null,this._hasAudioInput=null,e.on(tt,this._trackAdded.bind(this))}_clearTriggerTimeout(){clearTimeout(this._timeoutTrigger),this._timeoutTrigger=null}_handleAudioInputStateChange(e){const t=0!==e;null!==this._hasAudioInput&&this._hasAudioInput===t||(this._hasAudioInput=t,this.emit(Rl,this._hasAudioInput))}_handleNoAudioInputDetection(e){this._eventFired||(0!==e||this._timeoutTrigger?0!==e&&this._timeoutTrigger&&this._clearTriggerTimeout():this._timeoutTrigger=setTimeout((()=>{this._eventFired=!0,this.emit(Al)}),4e3))}_audioLevel(e,t,n,i){if(!i||!this._audioTrack)return;const r=e.localSSRCs.get(this._audioTrack.rtcId);r&&r.ssrcs.includes(t)&&(this._handleAudioInputStateChange(n),this._handleNoAudioInputDetection(n))}_trackAdded(e){e.isLocalAudioTrack()&&(this._audioTrack=e,this._eventFired=!1,this._clearTriggerTimeout(),e.on(It,(e=>{this._handleNoAudioInputDetection(e)})),e.on(Ct,(e=>{this._handleNoAudioInputDetection(e),this._handleAudioInputStateChange(e)})))}}class kl{constructor(e){this.conference=e,e.addEventListener(nt,this._audioLevel.bind(this)),this.myUserID=this.conference.myUserId()}_audioLevel(e,t){!this.conference.isP2PActive()||t<=.6||e===this.myUserID&&this.conference.getLocalAudioTrack().isMuted()||this.conference.rtc.eventEmitter.emit(ji.default.DOMINANT_SPEAKER_CHANGED,e)}}function Nl(e){const t=window.AudioContext||window.webkitAudioContext;if(t)return new t(e)}class Ml extends ii{constructor(e,t,n){super(),this._procNodeSampleRate=e,this._vadProcessor=t,this._localTrack=n,this._bufferResidue=new Float32Array([]),this._audioContext=Nl({sampleRate:t.getRequiredPCMFrequency()}),this._vadSampleSize=t.getSampleLength(),this._onAudioProcess=this._onAudioProcess.bind(this),this._initializeAudioContext()}static create(e,t,n){return pl.obtainAudioAndVideoPermissions({devices:["audio"],micDeviceId:e}).then((i=>{if(!i[0])throw new Error(`Failed to create jitsi local track for device id: ${e}`);return new Ml(t,n,i[0])}))}_initializeAudioContext(){this._audioSource=this._audioContext.createMediaStreamSource(this._localTrack.stream),this._audioProcessingNode=this._audioContext.createScriptProcessor(this._procNodeSampleRate,1,1)}_onAudioProcess(e){const t=e.inputBuffer.getChannelData(0),n=[...this._bufferResidue,...t],i=Date.now();let r=0;for(;r+this._vadSampleSize<n.length;r+=this._vadSampleSize){const e=n.slice(r,r+this._vadSampleSize),t=this._vadProcessor.calculateAudioFrameVAD(e.slice());this.emit(Pl,{timestamp:i,score:t,pcmData:e,deviceId:this._localTrack.getDeviceId()})}this._bufferResidue=n.slice(r,n.length)}_connectAudioGraph(){this._audioProcessingNode.onaudioprocess=this._onAudioProcess,this._audioSource.connect(this._audioProcessingNode),this._audioProcessingNode.connect(this._audioContext.destination)}_disconnectAudioGraph(){this._audioProcessingNode.onaudioprocess=()=>{},this._audioProcessingNode.disconnect(),this._audioSource.disconnect()}_cleanupResources(){this._disconnectAudioGraph(),this._localTrack.stopStream()}getDeviceId(){return this._localTrack.getDeviceId()}getTrackLabel(){return this._localTrack.getDeviceLabel()}start(){this._connectAudioGraph()}stop(){this._disconnectAudioGraph(),this._bufferResidue=[]}destroy(){this._destroyed||(this._cleanupResources(),this._destroyed=!0)}}const Ll=(0,y.getLogger)("modules/detection/VADAudioAnalyser.js");class Fl extends ii{constructor(e,t){super(),this._createVADProcessor=t,this._vadEmitter=null,this._isVADEmitterRunning=!1,this._detectionServices=[],this._vadInitTracker=Promise.resolve(),this._processVADScore=this._processVADScore.bind(this),e.on(tt,this._trackAdded.bind(this)),e.on(rt,this._trackRemoved.bind(this)),e.on(it,this._trackMuteChanged.bind(this))}addVADDetectionService(e){this._detectionServices.push(e),e.on(xl,(()=>{!this._detectionServices.filter((e=>!0===e.isActive())).length&&this._isVADEmitterRunning?this._stopVADEmitter():this._isVADEmitterRunning||this._startVADEmitter()}))}_startVADEmitter(){this._vadEmitter&&(this._vadEmitter.on(Pl,this._processVADScore),this._vadEmitter.start(),this._isVADEmitterRunning=!0)}_stopVADEmitter(){this._vadEmitter&&(this._vadEmitter.removeListener(Pl,this._processVADScore),this._vadEmitter.stop()),this._isVADEmitterRunning=!1}_processVADScore(e){for(const t of this._detectionServices)t.processVADScore(e)}_changeDetectorsMuteState(e){for(const t of this._detectionServices)t.changeMuteState(e)}_trackAdded(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>this._createVADProcessor())).then((t=>Ml.create(e.getDeviceId(),4096,t))).then((t=>{Ll.debug("Created VAD emitter for track: ",e.getTrackLabel()),this._vadEmitter=t,this._changeDetectorsMuteState(e.isMuted())})).catch((e=>{Ll.warn("Failed to start VADAudioAnalyser",e)})))}_trackMuteChanged(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>{this._changeDetectorsMuteState(e.isMuted())})))}_trackRemoved(e){e.isLocalAudioTrack()&&(this._vadInitTracker=this._vadInitTracker.then((()=>{Ll.debug("Removing track from VAD detection - ",e.getTrackLabel()),this._vadEmitter&&(this._stopVADEmitter(),this._vadEmitter.destroy(),this._vadEmitter=null);for(const e of this._detectionServices)e.reset()})))}}class jl extends ii{constructor(){super(),this._processing=!1,this._scoreArray=[],this._audioLvlArray=[],this._active=!1,this._calculateNoisyScore=this._calculateNoisyScore.bind(this)}_calculateNoisyScore(){const e=yi(this._scoreArray),t=yi(this._audioLvlArray);e<.2&&t>.04&&(this.emit(wl),this._setActiveState(!1)),this.reset()}_recordValues(e,t){this._scoreArray.push(e),this._audioLvlArray.push(t)}_setActiveState(e){this._active=e,this.emit(xl,this._active)}changeMuteState(e){this._setActiveState(!e),this.reset()}isActive(){return this._active}reset(){this._processing=!1,this._scoreArray=[],this._audioLvlArray=[],clearTimeout(this._processTimeout)}processVADScore(e){if(this._active)if(this._processing){const t=Si(e.pcmData);this._recordValues(e.score,yi(t))}else if(e.score<.2){const t=yi(Si(e.pcmData));t>.02&&(this._processing=!0,this._recordValues(e.score,t),this._processTimeout=setTimeout(this._calculateNoisyScore,1500))}}}class Vl extends ii{constructor(){super(),this._processing=!1,this._scoreArray=[],this._active=!1,this._calculateVADScore=this._calculateVADScore.bind(this)}_calculateVADScore(){yi(this._scoreArray)>.6&&(this.emit(Dl),this._setActiveState(!1)),this.reset()}_setActiveState(e){this._active=e,this.emit(xl,this._active)}changeMuteState(e){this._setActiveState(e),this.reset()}isActive(){return this._active}processVADScore(e){this._active&&(this._processing?this._scoreArray.push(e.score):e.score>.9&&(this._processing=!0,this._scoreArray.push(e.score),this._processTimeout=setTimeout(this._calculateVADScore,700)))}reset(){this._processing=!1,this._scoreArray=[],clearTimeout(this._processTimeout)}}let Ul;!function(e){e.E2E_RTT_CHANGED="e2eping.e2e_rtt_changed"}(Ul||(Ul={}));const Hl=Ul.E2E_RTT_CHANGED,$l=(0,y.getLogger)("modules/e2eping/e2eping.js"),Jl="e2e-ping-request",Bl="e2e-ping-response";class ql{constructor(e,t){this.participant=e,this.e2eping=t,this.id=e.getId(),this.requests={},this.lastRequestId=1,this.sendRequest=this.sendRequest.bind(this),this.handleResponse=this.handleResponse.bind(this),this.maybeLogRttAndStop=this.maybeLogRttAndStop.bind(this),this.scheduleNext=this.scheduleNext.bind(this),this.stop=this.stop.bind(this),this.getDelay=this.getDelay.bind(this),this.timeout=this.scheduleNext()}scheduleNext(){return window.setTimeout(this.sendRequest,this.getDelay())}stop(){this.timeout&&window.clearTimeout(this.timeout),this.e2eping.removeParticipant(this.id)}getDelay(){const e=this.e2eping.conference.getParticipants().length,t=e*(e-1)/2*this.e2eping.numRequests/this.e2eping.maxMessagesPerSecond;return(1.5-Math.random())*Math.max(t/this.e2eping.numRequests*1e3,1e3)}sendRequest(){const e=this.lastRequestId++,t={type:Jl,id:e};this.e2eping.sendMessage(t,this.id),this.requests[e]={id:e,timeSent:window.performance.now()}}handleResponse(e){const t=this.requests[e.id];t&&(t.rtt=window.performance.now()-t.timeSent),this.maybeLogRttAndStop()}maybeLogRttAndStop(){let e,t,n=1/0,i=0,r=0;for(t in this.requests)this.requests.hasOwnProperty(t)&&(e=this.requests[t],r++,e.rtt&&(i++,n=Math.min(n,e.rtt)));return i>=this.e2eping.numRequests?($l.info(`Measured RTT=${n} ms to ${this.id} (in ${this.participant.getProperty("region")})`),this.stop(),void this.e2eping.conference.eventEmitter.emit(Hl,this.participant,n)):r>2*this.e2eping.numRequests?($l.info(`Stopping e2eping for ${this.id} because we sent ${r} with only ${i} responses.`),void this.stop()):void(this.timeout=this.scheduleNext())}}class Gl{constructor(e,t,n){this.conference=e,this.eventEmitter=e.eventEmitter,this.sendMessage=n,this.participants={},this.numRequests=5,this.maxConferenceSize=200,this.maxMessagesPerSecond=250,t&&t.e2eping&&("number"==typeof t.e2eping.numRequests&&(this.numRequests=t.e2eping.numRequests),"number"==typeof t.e2eping.maxConferenceSize&&(this.maxConferenceSize=t.e2eping.maxConferenceSize),"number"==typeof t.e2eping.maxMessagesPerSecond&&(this.maxMessagesPerSecond=t.e2eping.maxMessagesPerSecond)),$l.info(`Initializing e2e ping with numRequests=${this.numRequests}, maxConferenceSize=${this.maxConferenceSize}, maxMessagesPerSecond=${this.maxMessagesPerSecond}.`),this.participantJoined=this.participantJoined.bind(this),this.participantLeft=this.participantLeft.bind(this),e.on(dt,this.participantLeft),this.messageReceived=this.messageReceived.bind(this),e.on(Ce,this.messageReceived),this.conferenceJoined=this.conferenceJoined.bind(this),e.on(ce,this.conferenceJoined)}conferenceJoined(){this.conference.getParticipants().forEach((e=>this.participantJoined(e.getId(),e))),this.conference.on(at,this.participantJoined)}messageReceived(e,t){t.type===Jl?this.handleRequest(e.getId(),t):t.type===Bl&&this.handleResponse(e.getId(),t)}participantJoined(e,t){this.participants[e]&&($l.info(`Participant wrapper already exists for ${e}. Clearing.`),this.participants[e].stop()),this.conference.getParticipants().length>this.maxConferenceSize||this.conference.myUserId()>e&&($l.info(`Starting e2eping for participant ${e}`),this.participants[e]=new ql(t,this))}removeParticipant(e){this.participants[e]&&delete this.participants[e]}participantLeft(e){this.participants[e]&&(this.participants[e].stop(),delete this.participants[e])}handleRequest(e,t){if(t&&t.id){const n={type:Bl,id:t.id};this.sendMessage(n,e)}else $l.info(`Received an invalid e2e ping request from ${e}.`)}handleResponse(e,t){const n=this.participants[e];n&&n.handleResponse(t)}stop(){$l.info("Stopping e2eping"),this.conference.off(at,this.participantJoined),this.conference.off(dt,this.participantLeft),this.conference.off(Ce,this.messageReceived);for(const e in this.participants)this.participants.hasOwnProperty(e)&&this.participants[e].stop();this.participants={}}}const zl=(0,y.getLogger)("modules/event/Jvb121EventGenerator.js");class Kl{constructor(e){this._conference=e,this._jvb121=!0,this._conference.addEventListener(at,(()=>this.evaluateStatus())),this._conference.addEventListener(dt,(()=>this.evaluateStatus())),this._conference.addEventListener(Ue,(()=>this.evaluateStatus()))}evaluateStatus(){const e=this._jvb121,t=!this._conference.isP2PActive()&&this._conference.getParticipantCount()<=2;e!==t&&(this._jvb121=t,zl.debug(`JVB121 status ${e} => ${t}`),this._conference.eventEmitter.emit(Ae,e,t))}}const Wl=Symbol("kJitsiLiteMode"),Xl=(0,y.getLogger)("modules/litemode/LiteModeContext.js");class Yl{constructor(e){this.enabled=Ai.isRunInLiteModeEnabled(),this.enabled&&e.rtc.on(ji.default.REMOTE_TRACK_ADDED,((e,t)=>this._setupLiteModeForTrack(t,e)))}_setupLiteModeForTrack(e,t){if(!this.enabled)return;const n=e.findReceiverForTrack(t.track);if(!n)return void Xl.warn(`Could not set up lite mode for ${t}: receiver not found in: ${e}`);if(n[Wl])return;n[Wl]=!0;const i=n.createEncodedStreams(),r=new TransformStream({transform:()=>{}});i.readable.pipeThrough(r).pipeTo(i.writable)}}const Ql=(0,y.getLogger)("modules/qualitycontrol/ReceiveVideoController.js"),Zl=2160;class eh{constructor(e){const{lastN:t,assumedBandwidthBps:n}=e;this._lastN=null!=t?t:-1,this._maxFrameHeight=Zl,this._assumedBandwidthBps=null!=n?n:-1,this._receiverVideoConstraints={assumedBandwidthBps:this._assumedBandwidthBps,constraints:{},defaultConstraints:{maxHeight:this._maxFrameHeight},lastN:this._lastN}}get constraints(){this._receiverVideoConstraints.assumedBandwidthBps=this._assumedBandwidthBps,this._receiverVideoConstraints.lastN=this._lastN;const e=this._receiverVideoConstraints.constraints;if(e&&Object.keys(e).length)for(const[t,n]of Object.entries(e))n.maxHeight=this._maxFrameHeight;else this._receiverVideoConstraints.defaultConstraints={maxHeight:this._maxFrameHeight};return this._receiverVideoConstraints}updateAssumedBandwidthBps(e){const t=this._assumedBandwidthBps!==e;return t&&(this._assumedBandwidthBps=e,Ql.debug(`Updating receive assumedBandwidthBps: ${e}`)),t}updateLastN(e){const t=this._lastN!==e;return t&&(this._lastN=e,Ql.debug(`Updating ReceiverVideoConstraints lastN(${e})`)),t}updateReceiveResolution(e){const t=this._maxFrameHeight!==e;return t&&(this._maxFrameHeight=e,Ql.debug(`Updating receive maxFrameHeight: ${e}`)),t}updateReceiverVideoConstraints(e){const t=!yt()(this._receiverVideoConstraints,e);var n;return t&&(this._receiverVideoConstraints=e,null!==(n=e.defaultConstraints)&&void 0!==n&&n.maxHeight&&this.updateReceiveResolution(e.defaultConstraints.maxHeight),Ql.debug(`Updating ReceiverVideoConstraints ${JSON.stringify(e)}`)),t}}class th{constructor(e,t){var n;this._conference=e,this._rtc=t;const{config:i}=e.options;this._lastN=null!==(n=null==i?void 0:i.startLastN)&&void 0!==n?n:(null==i?void 0:i.channelLastN)||-1,this._maxFrameHeight=Zl,this._sourceReceiverConstraints=new Map,this._assumedBandwidthBps=-1,this._receiverVideoConstraints=new eh({lastN:this._lastN,assumedBandwidthBps:this._assumedBandwidthBps}),this._conference.on(q,(e=>this._onMediaSessionStarted(e)))}_getDefaultSourceReceiverConstraints(e,t){var n;const i=null!=t?t:Zl,r=(null===(n=e.peerconnection)||void 0===n?void 0:n.getRemoteTracks(null,Ri.VIDEO))||[],o=new Map;for(const e of r)o.set(e.getSourceName(),i);return o}_onMediaSessionStarted(e){e.isP2P?e.setReceiverVideoConstraint(this._getDefaultSourceReceiverConstraints(e)):this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}getLastN(){return this._lastN}setAssumedBandwidthBps(e){this._receiverVideoConstraints.updateAssumedBandwidthBps(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}setLastN(e){this._lastN!==e&&(this._lastN=e,this._receiverVideoConstraints.updateLastN(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints))}setPreferredReceiveMaxFrameHeight(e){this._maxFrameHeight=e;for(const t of this._conference.getMediaSessions())t.isP2P?t.setReceiverVideoConstraint(this._getDefaultSourceReceiverConstraints(t,e)):this._receiverVideoConstraints.updateReceiveResolution(e)&&this._rtc.setReceiverVideoConstraints(this._receiverVideoConstraints.constraints)}setReceiverConstraints(e){if(e){if(Object.keys(e).includes("onStageEndpoints","selectedEndpoints"))throw new Error(\'"onStageEndpoints" and "selectedEndpoints" are not supported when sourceNameSignaling is enabled.\');if(this._receiverVideoConstraints.updateReceiverVideoConstraints(e)){var t,n;this._assumedBandwidthBps=null!==(t=e.assumedBandwidthBps)&&void 0!==t?t:this._assumedBandwidthBps,this._lastN=null!==(n=e.lastN)&&void 0!==n?n:this._lastN,this._rtc.setReceiverVideoConstraints(e);const i=this._conference.getMediaSessions().find((e=>e.isP2P));if(!i||!e.constraints)return;const r=Array.from(Object.entries(e.constraints)).map((e=>(e[1]=e[1].maxHeight,e)));this._sourceReceiverConstraints=new Map(r),i.setReceiverVideoConstraint(this._sourceReceiverConstraints)}}}}const nh=(0,y.getLogger)("modules/qualitycontrol/SendVideoController.js");class ih{constructor(e,t){this._conference=e,this._preferredSendMaxFrameHeight=2160,this._rtc=t,this._sourceSenderConstraints=new Map,this._conference.on(q,(e=>this._onMediaSessionStarted(e))),this._conference.on(G,(()=>this._configureConstraintsForLocalSources())),this._rtc.on(ji.default.SENDER_VIDEO_CONSTRAINTS_CHANGED,(e=>this._onSenderConstraintsReceived(e)))}_configureConstraintsForLocalSources(){for(const e of this._rtc.getLocalVideoTracks()){const t=e.getSourceName();t&&this._propagateSendMaxFrameHeight(t)}}_onMediaSessionStarted(e){e.addListener(da.REMOTE_SOURCE_CONSTRAINTS_CHANGED,((e,t)=>{e===this._conference.getActiveMediaSession()&&t.forEach((e=>this._onSenderConstraintsReceived(e)))}))}_onSenderConstraintsReceived(e){var t;const{maxHeight:n,sourceName:i}=e,r=null!==(t=this._conference.getLocalVideoTracks())&&void 0!==t?t:[];for(const e of r)e.getSourceName()===i&&this._sourceSenderConstraints.get(i)!==n&&(this._sourceSenderConstraints.set(i,-1===n?Math.min(2160,this._preferredSendMaxFrameHeight):n),nh.debug(`Sender constraints for source:${i} changed to maxHeight:${n}`),this._propagateSendMaxFrameHeight(i))}_propagateSendMaxFrameHeight(e){if(!e)throw new Error("sourceName missing for calculating the sendMaxHeight for video tracks");const t=this._selectSendMaxFrameHeight(e),n=[];if(t>=0)for(const i of this._conference.getMediaSessions())n.push(i.setSenderVideoConstraint(t,e));return Promise.all(n)}_selectSendMaxFrameHeight(e){if(!e)throw new Error("sourceName missing for calculating the sendMaxHeight for video tracks");const t=this._conference.getActiveMediaSession()?this._sourceSenderConstraints.get(e):void 0;return this._preferredSendMaxFrameHeight>=0&&t>=0?Math.min(this._preferredSendMaxFrameHeight,t):t>=0?t:this._preferredSendMaxFrameHeight}setPreferredSendMaxFrameHeight(e){this._preferredSendMaxFrameHeight=e;const t=[];for(const e of this._sourceSenderConstraints.keys())t.push(this._propagateSendMaxFrameHeight(e));return Promise.allSettled(t)}}const rh={getFocusRecordingUpdate(e){const t=e&&e.getElementsByTagName("jibri-recording-status")[0];if(t)return{error:t.getAttribute("failure_reason"),initiator:t.getAttribute("initiator"),recordingMode:t.getAttribute("recording_mode"),sessionID:t.getAttribute("session_id"),status:t.getAttribute("status")}},getHiddenDomainUpdate(e){const t=e.getElementsByTagName("live-stream-view-url")[0],n=t&&t.textContent,i=e.getElementsByTagName("mode")[0],r=i&&i.textContent&&i.textContent.toLowerCase(),o=e.getElementsByTagName("session_id")[0];return{liveStreamViewURL:n,mode:r,sessionID:o&&o.textContent}},getSessionIdFromIq(e){const t=e&&e.getElementsByTagName("jibri")[0];return t&&t.getAttribute("session_id")},getSessionId(e){const t=e.getElementsByTagName("session_id")[0];return t&&t.textContent},isFromFocus:e=>e.getAttribute("from").includes("focus")};class oh{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._connection=e.connection,this._mode=e.mode,this._jibriJid=null,this._statusFromJicofo="",this._setSessionID(e.sessionID),this.setStatus(e.status)}getError(){return this._error}getID(){return this._sessionID}getInitiator(){return this._initiator}getLiveStreamViewURL(){return this._liveStreamViewURL}getStatus(){return this._status?this._status:this._statusFromJicofo}getJibriJid(){return this._jibriJid}getTerminator(){return this._terminator}getMode(){return this._mode}setError(e){this._error=e}setLiveStreamViewURL(e){this._liveStreamViewURL=e}setStatus(e){this._status=e}setStatusFromJicofo(e){this._statusFromJicofo=e}setJibriJid(e){this._jibriJid=e}setInitiator(e){this._initiator=e}setTerminator(e){this._terminator=e}start(e){let{appData:t,broadcastId:n,focusMucJid:i,streamId:r}=e;return new Promise(((e,o)=>{this._connection.sendIQ(this._createIQ({action:"start",appData:t,focusMucJid:i,broadcastId:n,streamId:r}),(t=>{this.setStatus("pending"),this._setSessionID(rh.getSessionIdFromIq(t)),e()}),(e=>{this._setErrorFromIq(e),o(e)}))}))}stop(e){let{focusMucJid:t}=e;return new Promise(((e,n)=>{this._connection.sendIQ(this._createIQ({action:"stop",focusMucJid:t}),e,n)}))}_createIQ(e){let{action:t,appData:n,broadcastId:i,focusMucJid:r,streamId:o}=e;return(0,St.$iq)({to:r,type:"set"}).c("jibri",{xmlns:"http://jitsi.org/protocol/jibri",action:t,app_data:n,recording_mode:this._mode,streamid:o,you_tube_broadcast_id:i}).up()}_setErrorFromIq(e){const t=e.getElementsByTagName("error")[0];this.setError(t.children[0].tagName)}_setSessionID(e){this._sessionID=e}}const sh=(0,y.getLogger)("modules/recording/RecordingManager.js"),ah=class{constructor(e){this._sessions={},this._chatRoom=e,this.onPresence=this.onPresence.bind(this),this.onMemberLeft=this.onMemberLeft.bind(this),this._chatRoom.eventEmitter.addListener(Hi.XMPPEvents.PRESENCE_RECEIVED,this.onPresence),this._chatRoom.eventEmitter.addListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this.onMemberLeft)}getSession(e){return this._sessions[e]}getSessionByJibriJid(e){let t;return Object.values(this._sessions).forEach((n=>{n.getJibriJid()===e&&(t=n)})),t}onPresence(e){let{fromHiddenDomain:t,presence:n}=e;rh.isFromFocus(n)?this._handleFocusPresence(n):t&&this._handleJibriPresence(n)}onMemberLeft(e){const t=this.getSessionByJibriJid(e);if(t){const e=t.getStatus();t.setStatus(""),t.setJibriJid(null),t.getStatus()!==e&&this._emitSessionUpdate(t)}}startRecording(e){const t=new oh({...e,connection:this._chatRoom.connection});return t.start({appData:e.appData,broadcastId:e.broadcastId,focusMucJid:this._chatRoom.focusMucJid,streamId:e.streamId}).then((()=>(this.getSession(t.getID())||(this._addSession(t),this._emitSessionUpdate(t)),t))).catch((e=>(this._emitSessionUpdate(t),Promise.reject(e))))}stopRecording(e){const t=this.getSession(e);return t?t.stop({focusMucJid:this._chatRoom.focusMucJid}):Promise.reject(new Error("Could not find session"))}_addSession(e){this._sessions[e.getID()]=e}_createSession(e,t,n){const i=new oh({connection:this._chatRoom.connection,focusMucJid:this._chatRoom.focusMucJid,mode:n,sessionID:e,status:t});return this._addSession(i),i}_emitSessionUpdate(e,t){this._chatRoom.eventEmitter.emit(Hi.XMPPEvents.RECORDER_STATE_CHANGED,e,t)}_handleFocusPresence(e){const t=rh.getFocusRecordingUpdate(e);if(!t)return;const{error:n,initiator:i,recordingMode:r,sessionID:o,status:s}=t;let a=this.getSession(o);a||"off"!==s?a&&a.getStatus()===s&&a.getError()===n?sh.warn("Ignoring duplicate presence update: ",JSON.stringify(t)):(a||(a=this._createSession(o,s,r)),a.setStatusFromJicofo(s),n&&a.setError(n),this._emitSessionUpdate(a,i)):sh.warn("Ignoring recording presence update","Received a new session with status off.")}_handleJibriPresence(e){const{liveStreamViewURL:t,mode:n,sessionID:i}=rh.getHiddenDomainUpdate(e);if(!i)return void sh.warn("Ignoring potential jibri presence due to no session id.");let r=this.getSession(i);r||(r=this._createSession(i,"on",n)),r.setStatus("on"),r.setJibriJid(e.getAttribute("from")),r.setLiveStreamViewURL(t),this._emitSessionUpdate(r)}},dh=(0,y.getLogger)("modules/statistics/AudioOutputProblemDetector.js");class ch{constructor(e){this._conference=e,this._localAudioLevelCache={},this._reportedParticipants=[],this._audioProblemCandidates={},this._numberOfRemoteAudioLevelsReceived={},this._onLocalAudioLevelsReport=this._onLocalAudioLevelsReport.bind(this),this._onRemoteAudioLevelReceived=this._onRemoteAudioLevelReceived.bind(this),this._clearUserData=this._clearUserData.bind(this),this._conference.on(gl,this._onRemoteAudioLevelReceived),this._conference.statistics.addConnectionStatsListener(this._onLocalAudioLevelsReport),this._conference.on(dt,this._clearUserData)}_onRemoteAudioLevelReceived(e,t){let{avgAudioLevels:n}=t;const i=this._numberOfRemoteAudioLevelsReceived[e]+1||0;if(this._numberOfRemoteAudioLevelsReceived[e]=i,-1!==this._reportedParticipants.indexOf(e)||e in this._audioProblemCandidates||n<=0||i<3)return;const r=this._conference.getParticipantById(e);if(r&&r.getTracksByMediaType(Ri.AUDIO).length>0&&r.isAudioMuted())return;const o=this._localAudioLevelCache[e];Array.isArray(o)&&!o.every((e=>0===e))||(this._audioProblemCandidates[e]={remoteAudioLevels:n,localAudioLevels:[]})}_onLocalAudioLevelsReport(e,t){let{avgAudioLevels:n}=t;e===this._conference.getActivePeerConnection()&&(Object.keys(n).forEach((e=>{if(-1!==this._reportedParticipants.indexOf(e))return;const t=this._localAudioLevelCache[e];Array.isArray(t)?t.length>=2&&t.shift():this._localAudioLevelCache[e]=[],this._localAudioLevelCache[e].push(n[e])})),Object.keys(this._audioProblemCandidates).forEach((e=>{const{localAudioLevels:t,remoteAudioLevels:i}=this._audioProblemCandidates[e];if(t.push(n[e]),2===t.length){if(t.every((e=>void 0===e||0===e))){const n=JSON.stringify(t);Mi.sendAnalytics(((e,t,n)=>({type:kt.TYPE_OPERATIONAL,action:"audio.output.problem",attributes:{userID:e,localAudioLevels:t,remoteAudioLevels:n}}))(e,n,i)),dh.warn(`A potential problem is detected with the audio output for participant ${e}, local audio levels: ${n}, remote audio levels: ${i}`),this._reportedParticipants.push(e),this._clearUserData(e)}delete this._audioProblemCandidates[e]}})))}_clearUserData(e){delete this._localAudioLevelCache[e]}dispose(){this._conference.off(gl,this._onRemoteAudioLevelReceived),this._conference.off(dt,this._clearUserData),this._conference.statistics.removeConnectionStatsListener(this._onLocalAudioLevelsReport),this._localAudioLevelCache=void 0,this._audioProblemCandidates=void 0,this._reportedParticipants=void 0,this._numberOfRemoteAudioLevelsReceived=void 0,this._conference=void 0}}const lh=(0,y.getLogger)("modules/statistics/AvgRTPStatsReporter.js");class hh{constructor(e){this.name=e,this.count=0,this.sum=0,this.samples=[]}addNext(e){void 0!==e&&("number"!=typeof e?lh.error(`${this.name} - invalid value for idx: ${this.count}`,e):isNaN(e)||(this.sum+=e,this.samples.push(e),this.count+=1))}calculate(){return this.sum/this.count}appendReport(e){e[`${this.name}_avg`]=this.calculate(),e[`${this.name}_samples`]=JSON.stringify(this.samples)}reset(){this.samples=[],this.sum=0,this.count=0}}class uh{constructor(e,t,n){this.isP2P=t,this._n=n,this._sampleIdx=0,this._avgRTT=new hh("rtt"),this._avgRemoteRTTMap=new Map,this._avgRtpStatsReporter=e,this._avgEnd2EndRTT=void 0,this._onConnectionStats=(e,t)=>{this.isP2P===e.isP2P&&this._calculateAvgStats(t)};const i=e._conference;i.statistics.addConnectionStatsListener(this._onConnectionStats),this.isP2P||(this._onUserLeft=e=>this._avgRemoteRTTMap.delete(e),i.on(dt,this._onUserLeft),this._onRemoteStatsUpdated=(e,t)=>this._processRemoteStats(e,t),i.on(gl,this._onRemoteStatsUpdated))}_calculateAvgStats(e){if(e){if(ci.supportsRTTStatistics()&&e.transport&&e.transport.length&&this._avgRTT.addNext(e.transport[0].rtt),this._sampleIdx+=1,this._sampleIdx>=this._n){if(ci.supportsRTTStatistics()){const t=this._avgRtpStatsReporter._conference,n={p2p:this.isP2P,conference_size:t.getParticipantCount()};if(e.transport&&e.transport.length&&Object.assign(n,{local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type}),this._avgRTT.appendReport(n),this.isP2P){const e=this._avgRtpStatsReporter.jvbStatsMonitor._avgEnd2EndRTT;isNaN(e)||(n.rtt_diff=this._avgRTT.calculate()-e)}else{const e=this._calculateAvgRemoteRTT(),t=this._avgRTT.calculate();this._avgEnd2EndRTT=t+e,isNaN(t)||isNaN(e)||(n.end2end_rtt_avg=this._avgEnd2EndRTT)}Mi.sendAnalytics(hn(n))}this._resetAvgStats()}}else lh.error("No stats")}_calculateAvgRemoteRTT(){let e=0,t=0;for(const n of this._avgRemoteRTTMap.values()){const i=n.calculate();isNaN(i)||(t+=i,e+=1,n.reset())}return t/e}_processRemoteStats(e,t){const n="number"==typeof t.jvbRTT;let i=this._avgRemoteRTTMap.get(e);!i&&n&&(i=new hh(`${e}_stat_rtt`),this._avgRemoteRTTMap.set(e,i)),n?i.addNext(t.jvbRTT):i&&this._avgRemoteRTTMap.delete(e)}_resetAvgStats(){this._avgRTT.reset(),this._avgRemoteRTTMap&&this._avgRemoteRTTMap.clear(),this._sampleIdx=0}dispose(){const e=this._avgRtpStatsReporter._conference;e.statistics.removeConnectionStatsListener(this._onConnectionStats),this.isP2P||(e.off(gl,this._onRemoteStatsUpdated),e.off(dt,this._onUserLeft))}}class ph{constructor(e,t){this._n=t,t>0?(lh.info(`Avg RTP stats will be calculated every ${t} samples`),this._sampleIdx=0,this._conference=e,this._avgAudioBitrateUp=new hh("bitrate_audio_upload"),this._avgAudioBitrateDown=new hh("bitrate_audio_download"),this._avgVideoBitrateUp=new hh("bitrate_video_upload"),this._avgVideoBitrateDown=new hh("bitrate_video_download"),this._avgBandwidthUp=new hh("bandwidth_upload"),this._avgBandwidthDown=new hh("bandwidth_download"),this._avgPacketLossTotal=new hh("packet_loss_total"),this._avgPacketLossUp=new hh("packet_loss_upload"),this._avgPacketLossDown=new hh("packet_loss_download"),this._avgRemoteFPS=new hh("framerate_remote"),this._avgRemoteScreenFPS=new hh("framerate_screen_remote"),this._avgLocalFPS=new hh("framerate_local"),this._avgLocalScreenFPS=new hh("framerate_screen_local"),this._avgRemoteCameraPixels=new hh("pixels_remote"),this._avgRemoteScreenPixels=new hh("pixels_screen_remote"),this._avgLocalCameraPixels=new hh("pixels_local"),this._avgLocalScreenPixels=new hh("pixels_screen_local"),this._avgCQ=new hh("connection_quality"),this._cachedTransportStats=void 0,this._onLocalStatsUpdated=e=>{this._calculateAvgStats(e),this._maybeSendTransportAnalyticsEvent(e)},e.on(ml,this._onLocalStatsUpdated),this._onP2PStatusChanged=()=>{lh.debug("Resetting average stats calculation"),this._resetAvgStats(),this.jvbStatsMonitor._resetAvgStats(),this.p2pStatsMonitor._resetAvgStats()},e.on(Ue,this._onP2PStatusChanged),this._onJvb121StatusChanged=(e,t)=>{!0===t&&(lh.info("Resetting JVB avg RTP stats"),this._resetAvgJvbStats())},e.on(Ae,this._onJvb121StatusChanged),this.jvbStatsMonitor=new uh(this,!1,t),this.p2pStatsMonitor=new uh(this,!0,t)):lh.info("Avg RTP stats reports are disabled.")}_calculateAvgStats(e){if(!e)return void lh.error("No stats");const t=this._conference.isP2PActive(),n=this._conference.getParticipantCount();if(!t&&n<2)return;const i=e.bitrate,r=e.bandwidth,o=e.packetLoss,s=e.framerate,a=e.resolution;if(i)if(r)if(o)if(s)if(a){if(this._avgAudioBitrateUp.addNext(i.audio.upload),this._avgAudioBitrateDown.addNext(i.audio.download),this._avgVideoBitrateUp.addNext(i.video.upload),this._avgVideoBitrateDown.addNext(i.video.download),ci.supportsBandwidthStatistics()&&(this._avgBandwidthUp.addNext(r.upload),this._avgBandwidthDown.addNext(r.download)),this._avgPacketLossUp.addNext(o.upload),this._avgPacketLossDown.addNext(o.download),this._avgPacketLossTotal.addNext(o.total),this._avgCQ.addNext(e.connectionQuality),s&&(this._avgRemoteFPS.addNext(this._calculateAvgVideoFps(s,!1,Qo.VideoType.CAMERA)),this._avgRemoteScreenFPS.addNext(this._calculateAvgVideoFps(s,!1,Qo.VideoType.DESKTOP)),this._avgLocalFPS.addNext(this._calculateAvgVideoFps(s,!0,Qo.VideoType.CAMERA)),this._avgLocalScreenFPS.addNext(this._calculateAvgVideoFps(s,!0,Qo.VideoType.DESKTOP))),a&&(this._avgRemoteCameraPixels.addNext(this._calculateAvgVideoPixels(a,!1,Qo.VideoType.CAMERA)),this._avgRemoteScreenPixels.addNext(this._calculateAvgVideoPixels(a,!1,Qo.VideoType.DESKTOP)),this._avgLocalCameraPixels.addNext(this._calculateAvgVideoPixels(a,!0,Qo.VideoType.CAMERA)),this._avgLocalScreenPixels.addNext(this._calculateAvgVideoPixels(a,!0,Qo.VideoType.DESKTOP))),this._sampleIdx+=1,this._sampleIdx>=this._n){const i={p2p:t,conference_size:n};e.transport&&e.transport.length&&Object.assign(i,{local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type}),this._avgAudioBitrateUp.appendReport(i),this._avgAudioBitrateDown.appendReport(i),this._avgVideoBitrateUp.appendReport(i),this._avgVideoBitrateDown.appendReport(i),ci.supportsBandwidthStatistics()&&(this._avgBandwidthUp.appendReport(i),this._avgBandwidthDown.appendReport(i)),this._avgPacketLossUp.appendReport(i),this._avgPacketLossDown.appendReport(i),this._avgPacketLossTotal.appendReport(i),this._avgRemoteFPS.appendReport(i),isNaN(this._avgRemoteScreenFPS.calculate())||this._avgRemoteScreenFPS.appendReport(i),this._avgLocalFPS.appendReport(i),isNaN(this._avgLocalScreenFPS.calculate())||this._avgLocalScreenFPS.appendReport(i),this._avgRemoteCameraPixels.appendReport(i),isNaN(this._avgRemoteScreenPixels.calculate())||this._avgRemoteScreenPixels.appendReport(i),this._avgLocalCameraPixels.appendReport(i),isNaN(this._avgLocalScreenPixels.calculate())||this._avgLocalScreenPixels.appendReport(i),this._avgCQ.appendReport(i),Mi.sendAnalytics(hn(i)),this._resetAvgStats()}}else lh.error("No resolution");else lh.error(\'No "framerate"\');else lh.error(\'No "packetloss"\');else lh.error(\'No "bandwidth"\');else lh.error(\'No "bitrate"\')}_calculateAvgVideoPixels(e,t,n){let i=0,r=0;const o=this._conference.myUserId();for(const s of Object.keys(e))if(t?s===o:s!==o){const o=t?null:this._conference.getParticipantById(s),a=e[s];if((t||o)&&a){const e=this._calculatePeerAvgVideoPixels(a,o,n);isNaN(e)||(i+=e,r+=1)}}return i/r}_calculatePeerAvgVideoPixels(e,t,n){let i=Object.keys(e).map((e=>Number(e))),r=null;const o=this._conference.getActivePeerConnection();t?(r=t.getTracksByMediaType(Ri.VIDEO),r&&(i=i.filter((e=>r.find((t=>!t.isMuted()&&t.getSSRC()===e&&t.videoType===n)))))):(r=this._conference.getLocalTracks(Ri.VIDEO),i=i.filter((e=>r.find((t=>!t.isMuted()&&o.getLocalSSRC(t)===e&&t.videoType===n)))));let s=0,a=0;for(const t of i){const n=Number(e[t].height)*Number(e[t].width);!isNaN(n)&&n>0&&(s+=n,a+=1)}return s/a}_calculateAvgVideoFps(e,t,n){let i=0,r=0;const o=this._conference.myUserId();for(const s of Object.keys(e))if(t?s===o:s!==o){const o=t?null:this._conference.getParticipantById(s),a=e[s];if((t||o)&&a){const e=this._calculatePeerAvgVideoFps(a,o,n);isNaN(e)||(i+=e,r+=1)}}return i/r}_calculatePeerAvgVideoFps(e,t,n){let i=Object.keys(e).map((e=>Number(e))),r=null;const o=this._conference.getActivePeerConnection();t?(r=t.getTracksByMediaType(Ri.VIDEO),r&&(i=i.filter((e=>r.find((t=>!t.isMuted()&&t.getSSRC()===e&&t.videoType===n)))))):(r=this._conference.getLocalTracks(Ri.VIDEO),i=i.filter((e=>r.find((t=>!t.isMuted()&&o.getLocalSSRC(t)===e&&t.videoType===n)))));let s=0,a=0;for(const t of i){const n=Number(e[t]);!isNaN(n)&&n>0&&(s+=n,a+=1)}return s/a}_maybeSendTransportAnalyticsEvent(e){if(!e||!e.transport||!e.transport.length)return;const t={p2p:e.transport[0].p2p,local_candidate_type:e.transport[0].localCandidateType,remote_candidate_type:e.transport[0].remoteCandidateType,transport_type:e.transport[0].type};var n;this._cachedTransportStats&&yt()(t,this._cachedTransportStats)||(this._cachedTransportStats=t,Mi.sendAnalytics((n=t,{type:kt.TYPE_OPERATIONAL,action:"transport.stats",attributes:n})))}_resetAvgJvbStats(){this._resetAvgStats(),this.jvbStatsMonitor._resetAvgStats()}_resetAvgStats(){this._avgAudioBitrateUp.reset(),this._avgAudioBitrateDown.reset(),this._avgVideoBitrateUp.reset(),this._avgVideoBitrateDown.reset(),this._avgBandwidthUp.reset(),this._avgBandwidthDown.reset(),this._avgPacketLossUp.reset(),this._avgPacketLossDown.reset(),this._avgPacketLossTotal.reset(),this._avgRemoteFPS.reset(),this._avgRemoteScreenFPS.reset(),this._avgLocalFPS.reset(),this._avgLocalScreenFPS.reset(),this._avgRemoteCameraPixels.reset(),this._avgRemoteScreenPixels.reset(),this._avgLocalCameraPixels.reset(),this._avgLocalScreenPixels.reset(),this._avgCQ.reset(),this._sampleIdx=0}dispose(){this._conference.off(Ue,this._onP2PStatusChanged),this._conference.off(ml,this._onLocalStatsUpdated),this._conference.off(Ae,this._onJvb121StatusChanged),this.jvbStatsMonitor.dispose(),this.p2pStatsMonitor.dispose()}}var mh=n(444),gh=n.n(mh);class fh{constructor(e){this.stats={users:{},dominantSpeakerId:null};const t=e.myUserId();this.stats.users[t]=new(gh())(t,null,!0),this.conference=e,e.addEventListener(Ee,this._onDominantSpeaker.bind(this)),e.addEventListener(at,this._onUserJoin.bind(this)),e.addEventListener(dt,this._onUserLeave.bind(this)),e.addEventListener(_e,this._onDisplayNameChange.bind(this)),e.on(Ce,((e,t)=>{let{type:n,faceLandmarks:i}=t;"face-landmarks"===n&&this._onFaceLandmarkAdd(e.getId(),i)})),e.xmpp&&e.xmpp.addListener(Hi.XMPPEvents.SPEAKER_STATS_RECEIVED,this._updateStats.bind(this))}_onDominantSpeaker(e,t,n){const i=this.stats.users[this.stats.dominantSpeakerId],r=this.stats.users[e];i&&i.setDominantSpeaker(!1),r&&r.setDominantSpeaker(!0,n),this.stats.dominantSpeakerId=e}_onUserJoin(e,t){t.isHidden()||this.stats.users[e]||(this.stats.users[e]=new(gh())(e,t.getDisplayName()))}_onUserLeave(e){const t=this.stats.users[e];t&&t.markAsHasLeft()}_onDisplayNameChange(e,t){const n=this.stats.users[e];n&&n.setDisplayName(t)}_onFaceLandmarkAdd(e,t){const n=this.stats.users[e];n&&t&&n.addFaceLandmarks(t)}getStats(){return this.stats.users}_updateStats(e){for(const t in e){let n;const i=this.conference.getParticipantById(t);i&&i.isHidden()||(this.stats.users[t]?(n=this.stats.users[t],n.getDisplayName()||n.setDisplayName(e[t].displayName)):(n=new(gh())(t,e[t].displayName),this.stats.users[t]=n,n.markAsHasLeft()),n.totalDominantSpeakerTime=e[t].totalDominantSpeakerTime,Array.isArray(e[t].faceLandmarks)&&n.setFaceLandmarks(e[t].faceLandmarks))}}}const vh=n(810).getLogger("modules/version/ComponentsVersions.js");function _h(e){this.versions={},this.conference=e,this.conference.addCommandListener("versions",this.processVersions.bind(this))}let Eh,yh,Sh;_h.prototype.processVersions=function(e,t,n){this.conference.isFocus(n)?e.children.forEach((e=>{const t=e.attributes.name,n=e.value;this.versions[t]!==n&&(this.versions[t]=n,vh.info(`Got ${t} version: ${n}`))})):vh.warn(`Received versions not from the focus user: ${e}`,n)},_h.prototype.getComponentVersion=function(e){return this.versions[e]},function(e){e.STATUS_AVAILABLE="available",e.STATUS_UNDEFINED="undefined",e.STATUS_BUSY="busy"}(Eh||(Eh={})),function(e){e.STATE_ON="on",e.STATE_OFF="off",e.STATE_PENDING="pending",e.STATE_RETRYING="retrying",e.STATE_FAILED="failed"}(yh||(yh={})),function(e){e.ERROR_NO_CONNECTION="error_no_connection",e.ERROR_SESSION_EXISTS="error_session_already_exists"}(Sh||(Sh={}));const bh=Eh.STATUS_AVAILABLE,Th=Eh.STATUS_UNDEFINED,Ch=Eh.STATUS_BUSY,xh=yh.STATE_ON,Rh=yh.STATE_OFF,Ah=yh.STATE_PENDING,wh=yh.STATE_RETRYING,Ih=yh.STATE_FAILED,Ph=Sh.ERROR_NO_CONNECTION,Dh=Sh.ERROR_SESSION_EXISTS,Oh=(0,y.getLogger)("modules/videosipgw/JitsiVideoSIPGWSession.js"),kh="STATE_CHANGED";class Nh extends xr{constructor(e,t,n){super(),this.sipAddress=e,this.displayName=t,this.chatRoom=n,this.state=void 0}stop(){this.state!==Rh&&this.state!==Ih?this._sendJibriIQ("stop"):Oh.warn("Video SIP GW session already stopped or failed!")}start(){this.state!==xh&&this.state!==Rh&&this.state!==Ah&&this.state!==wh?this._sendJibriIQ("start"):Oh.warn("Video SIP GW session already started!")}setState(e,t){if(e===this.state)return;const n=this.state;this.state=e,this.eventEmitter.emit(kh,{address:this.sipAddress,failureReason:t,oldState:n,newState:this.state,displayName:this.displayName})}addStateListener(e){this.addListener(kh,e)}removeStateListener(e){this.removeListener(kh,e)}_sendJibriIQ(e){const t={xmlns:"http://jitsi.org/protocol/jibri",action:e,sipaddress:this.sipAddress};t.displayname=this.displayName;const n=(0,St.$iq)({to:this.chatRoom.focusMucJid,type:"set"}).c("jibri",t).up();Oh.debug(`${e} video SIP GW session`,n.nodeTree),this.chatRoom.connection.sendIQ(n,(()=>{}),(t=>{Oh.error(`Failed to ${e} video SIP GW session, error: `,t),this.setState(Ih)}))}}const Mh=(0,y.getLogger)("modules/videosipgw/VideoSIPGW.js");class Lh{constructor(e){this.chatRoom=e,this.eventEmitter=e.eventEmitter,Mh.debug("creating VideoSIPGW"),this.sessions={},this.sessionStateChangeListener=this.sessionStateChanged.bind(this),e.addPresenceListener("jibri-sip-call-state",this.handleJibriSIPState.bind(this))}handleJibriSIPState(e){const t=e.attributes;if(!t)return;Mh.debug("Handle video sip gw state : ",t);const n=t.state;if(n!==this.state)switch(n){case xh:case Rh:case Ah:case wh:case Ih:{const e=t.sipaddress;if(!e)return;const i=this.sessions[e];i?i.setState(n,t.failure_reason):Mh.warn("Video SIP GW session not found:",e)}}}createVideoSIPGWSession(e,t){if(this.sessions[e])return Mh.warn("There was already a Video SIP GW session for address",e),new Error(Dh);const n=new Nh(e,t,this.chatRoom);return n.addStateListener(this.sessionStateChangeListener),this.sessions[e]=n,n}sessionStateChanged(e){const t=e.address;if(e.newState===Rh||e.newState===Ih){const e=this.sessions[t];if(!e)return void Mh.error("Missing Video SIP GW session with address:",t);e.removeStateListener(this.sessionStateChangeListener),delete this.sessions[t]}this.eventEmitter.emit(Hi.XMPPEvents.VIDEO_SIP_GW_SESSION_STATE_CHANGED,e)}}const Fh=(0,y.getLogger)("modules/xmpp/SignalingLayerImpl.js"),jh="SourceInfo";class Vh extends Ac{constructor(){super(),this.ssrcOwners=new Map,this.chatRoom=null,this._localSourceState={},this._remoteSourceState={}}_addLocalSourceInfoToPresence(){return!!this.chatRoom&&this.chatRoom.addOrReplaceInPresence(jh,{value:JSON.stringify(this._localSourceState)})}_bindChatRoomEventHandlers(e){const t=(e,t)=>{this.eventEmitter.emit(Ec,e,Ri.AUDIO,t)};this._audioMuteHandler=(e,n)=>{this._doesEndpointSendNewSourceInfo(n)||t(n,"true"===e.value)},e.addPresenceListener("audiomuted",this._audioMuteHandler);const n=(e,t)=>{this.eventEmitter.emit(Ec,e,Ri.VIDEO,t)};this._videoMuteHandler=(e,t)=>{this._doesEndpointSendNewSourceInfo(t)||n(t,"true"===e.value)},e.addPresenceListener("videomuted",this._videoMuteHandler);const i=(e,t)=>{this.eventEmitter.emit(yc,e,t)};this._videoTypeHandler=(e,t)=>{this._doesEndpointSendNewSourceInfo(t)||i(t,e.value)},e.addPresenceListener("videoType",this._videoTypeHandler),this._sourceInfoHandler=(e,t)=>{const n=t,{value:i}=e,r=_r(i),o=this._doesEndpointSendNewSourceInfo(n),s=this._remoteSourceState[n]||(this._remoteSourceState[n]={});for(const e of Object.keys(r)){var a;let n=!1;const i=xc(e),d=Boolean(r[e].muted),c=s[e]||(s[e]={sourceName:e});c.muted!==d&&(n=!0,c.muted=d,o&&!this._localSourceState[e]&&this.eventEmitter.emit(Sc,e,d));const l=i===Ri.VIDEO?null!==(a=r[e].videoType)&&void 0!==a?a:Qo.VideoType.CAMERA:void 0;c.videoType!==l&&(c.videoType=l,n=!0,o&&!this._localSourceState[e]&&this.eventEmitter.emit(Tc,e,l)),n&&Ai.isSsrcRewritingSupported()&&this.eventEmitter.emit(bc,e,t,d,l)}const d=Object.keys(r);for(const e of Object.keys(s))-1===d.indexOf(e)&&delete s[e]},e.addPresenceListener("SourceInfo",this._sourceInfoHandler),this._memberLeftHandler=e=>{const t=St.Strophe.getResourceFromJid(e);delete this._remoteSourceState[t]},e.addEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this._memberLeftHandler)}_doesEndpointSendNewSourceInfo(e){var t;const n=null===(t=this.chatRoom)||void 0===t?void 0:t.getLastPresence(e);return Boolean(n&&n.find((e=>e.tagName===jh)))}_logOwnerChangedMessage(e){Ai.isSsrcRewritingSupported()?Fh.debug(e):Fh.error(e)}getPeerMediaInfo(e,t,n){var i;const r=null===(i=this.chatRoom)||void 0===i?void 0:i.getLastPresence(e);if(!r)return void Fh.warn(`getPeerMediaInfo - no presence stored for: ${e}`);if(!this._doesEndpointSendNewSourceInfo(e))return(()=>{if(this.chatRoom)return this.chatRoom.getMediaPresenceInfo(e,t);Fh.warn("Requested peer media info, before room was set")})();if(n)return this.getPeerSourceInfo(e,n);const o={muted:!0};if(t===Ri.VIDEO){o.videoType=void 0;const e=ms(r,"jitsi_participant_codecList"),t=ms(r,"jitsi_participant_codecType");var s,a;e.length?o.codecList=null!==(s=null===(a=e[0].value)||void 0===a?void 0:a.split(","))&&void 0!==s?s:[]:t.length>0&&(o.codecType=t[0].value)}return o}getPeerSourceInfo(e,t){var n;const i={muted:!0,videoType:xc(t)===Ri.VIDEO?Qo.VideoType.CAMERA:void 0};return this._remoteSourceState[e]?null!==(n=this._remoteSourceState[e][t])&&void 0!==n?n:i:void 0}getSSRCOwner(e){var t;return null===(t=this.ssrcOwners.get(e))||void 0===t?void 0:t.endpointId}getTrackSourceName(e){var t;return null===(t=this.ssrcOwners.get(e))||void 0===t?void 0:t.sourceName}removeSSRCOwners(e){if(null!=e&&e.length)for(const t of e)this.ssrcOwners.delete(t)}setChatRoom(e){const t=this.chatRoom;this.chatRoom=e,t&&(t.removePresenceListener("audiomuted",this._audioMuteHandler),t.removePresenceListener("videomuted",this._videoMuteHandler),t.removePresenceListener("videoType",this._videoTypeHandler),this._sourceInfoHandler&&t.removePresenceListener(jh,this._sourceInfoHandler),this._memberLeftHandler&&t.removeEventListener(Hi.XMPPEvents.MUC_MEMBER_LEFT,this._memberLeftHandler)),e&&(this._bindChatRoomEventHandlers(e),this._addLocalSourceInfoToPresence())}setSSRCOwner(e,t,n){if("number"!=typeof e)throw new TypeError(`SSRC(${e}) must be a number`);const i=this.ssrcOwners.get(e);if(i){const{endpointId:e,sourceName:r}=i;e===t&&r===n||this._logOwnerChangedMessage(`SSRC owner re-assigned from ${i}(source-name=${r}) to ${t}(source-name=${n})`)}this.ssrcOwners.set(e,{endpointId:t,sourceName:n})}setTrackMuteStatus(e,t){return this._localSourceState[e]||(this._localSourceState[e]={}),this._localSourceState[e].muted=t,Fh.debug(`Mute state of ${e} changed to muted=${t}`),!!this.chatRoom&&this._addLocalSourceInfoToPresence()}setTrackVideoType(e,t){return this._localSourceState[e]||(this._localSourceState[e]={}),this._localSourceState[e].videoType!==t&&(this._localSourceState[e].videoType=t===Qo.VideoType.CAMERA?void 0:t,this._addLocalSourceInfoToPresence())}updateSsrcOwnersOnLeave(e){const t=[];this.ssrcOwners.forEach(((n,i)=>{let{endpointId:r}=n;r===e&&t.push(i)})),null!=t&&t.length&&this.removeSSRCOwners(t)}}let Uh;!function(e){e.CAMERA="camera",e.DESKTOP="desktop",e.DESKTOP_HIGH_FPS="desktop_high_fps",e.NONE="none"}(Uh||(Uh={}));const Hh=(0,y.getLogger)("JitsiConference.js");function $h(e){return"string"==typeof e?Object.values(Ds).find((t=>t===e.toLowerCase())):null}function Jh(e){var t,n,i;if(!e.name||e.name.toLowerCase()!==e.name.toString()){const t="Invalid conference name (no conference name passed or it contains invalid characters like capital letters)!",n=e.name?`roomName=${e.name}; condition - ${e.name.toLowerCase()}!==${e.name.toString()}`:"No room name passed!";throw Hh.error(`${t} ${n}`),new Error(t)}if(this.connection=e.connection,this.xmpp=null===(t=this.connection)||void 0===t?void 0:t.xmpp,this.xmpp.isRoomCreated(e.name,e.customDomain)){const e="A conference with the same name has already been created!";throw delete this.connection,delete this.xmpp,Hh.error(e),new Error(e)}this.eventEmitter=new ii,this.options=e,this.eventManager=new Ji(this),this.participants=new Map,this._signalingLayer=new Vh,this._init(e),this.componentsVersions=new _h(this),this.jvbJingleSession=null,this.lastDominantSpeaker=null,this.dtmfManager=null,this.somebodySupportsDTMF=!1,this.authEnabled=!1,this.startAudioMuted=!1,this.startVideoMuted=!1,this.startMutedPolicy={audio:!1,video:!1},this.isMutedByFocus=!1,this.mutedByFocusActor=null,this.isVideoMutedByFocus=!1,this.mutedVideoByFocusActor=null,this.wasStopped=!1,this.properties={},this.connectionQuality=new Sl(this,this.eventEmitter,e),this.avgRtpStatsReporter=new ph(this,e.config.avgRtpStatsN||15),e.config.disableAudioLevels||(this._audioOutputProblemDetector=new ch(this)),this.isJvbConnectionInterrupted=!1,this.speakerStatsCollector=new fh(this),this.deferredStartP2PTask=null;const r=parseInt(e.config.p2p&&e.config.p2p.backToP2PDelay,10);this.backToP2PDelay=isNaN(r)?5:r,Hh.info(`backToP2PDelay: ${this.backToP2PDelay}`),this.isP2PConnectionInterrupted=!1,this.p2p=!1,this.p2pJingleSession=null,this.videoSIPGWHandler=new Lh(this.room),this.recordingManager=new ah(this.room),this._conferenceJoinAnalyticsEventSent=void 0,this.isE2EESupported()&&(Hh.info("End-to-End Encryption is supported"),this._e2eEncryption=new so(this)),Ai.isRunInLiteModeEnabled()&&(Hh.info("Lite mode enabled"),this._liteModeContext=new Yl(this)),this._audioSenderLimitReached=void 0,this._videoSenderLimitReached=void 0,this._firefoxP2pEnabled=ci.isVersionGreaterThan(109)&&(null===(n=null===(i=this.options.config.testing)||void 0===i?void 0:i.enableFirefoxP2p)||void 0===n||n)}function Bh(e,t,n){this.appID=e,this.token=t,this.options=n,Ai.init(n.flags||{}),this.xmpp=new Pa(n,t),this.addEventListener(ur,((e,t,n,i)=>{Mi.sendAnalyticsAndLog(rn(e,t,i))})),this.addEventListener(lr,(e=>{e&&Mi.sendAnalytics(Xt,{message:e})}))}let qh;Jh.prototype.constructor=Jh,Jh.resourceCreator=function(e,t){let n;var i;t?n=co().randomHexString(8).toLowerCase():(n=null===(i=St.Strophe.getNodeFromJid(e))||void 0===i?void 0:i.substr(0,8).toLowerCase(),n&&/[0-9a-f]{8}/g.test(n)||(n=co().randomHexString(8).toLowerCase()));return n},Jh.prototype._init=function(){var e,t,n,i,r,o,s,a,d;let c=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.eventManager.setupXMPPListeners();const{config:l}=this.options,h={jvb:{preferenceOrder:ci.isMobileDevice()&&null!==(e=l.videoQuality)&&void 0!==e&&e.mobileCodecPreferenceOrder?l.videoQuality.mobileCodecPreferenceOrder:null===(t=l.videoQuality)||void 0===t?void 0:t.codecPreferenceOrder,disabledCodec:$h(null===(n=l.videoQuality)||void 0===n?void 0:n.disabledCodec),preferredCodec:$h(null===(i=l.videoQuality)||void 0===i?void 0:i.preferredCodec)},p2p:{preferenceOrder:ci.isMobileDevice()&&null!==(r=l.p2p)&&void 0!==r&&r.mobileCodecPreferenceOrder?l.p2p.mobileCodecPreferenceOrder:null===(o=l.p2p)||void 0===o?void 0:o.codecPreferenceOrder,disabledCodec:$h(null===(s=l.p2p)||void 0===s?void 0:s.disabledCodec),preferredCodec:$h(null===(a=l.p2p)||void 0===a?void 0:a.preferredCodec)}};if(this.codecSelection=new La(this,h),this._statsCurrentId=l.statisticsId?l.statisticsId:$o.callStatsUserName,this.room=this.xmpp.createRoom(this.options.name,{...l,statsId:this._statsCurrentId},Jh.resourceCreator),this._signalingLayer.setChatRoom(this.room),this._signalingLayer.on(_c.SOURCE_UPDATED,((e,t,n,i)=>{const r=this.participants.get(t),o=xc(e);r&&(r._setSources(o,n,e,i),this.eventEmitter.emit($e,r))})),this._onIceConnectionInterrupted=this._onIceConnectionInterrupted.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this._onIceConnectionInterrupted),this._onIceConnectionRestored=this._onIceConnectionRestored.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_RESTORED,this._onIceConnectionRestored),this._onIceConnectionEstablished=this._onIceConnectionEstablished.bind(this),this.room.addListener(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this._onIceConnectionEstablished),this._updateProperties=this._updateProperties.bind(this),this.room.addListener(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,this._updateProperties),this._sendConferenceJoinAnalyticsEvent=this._sendConferenceJoinAnalyticsEvent.bind(this),this.room.addListener(Hi.XMPPEvents.MEETING_ID_SET,this._sendConferenceJoinAnalyticsEvent),this._removeLocalSourceOnReject=this._removeLocalSourceOnReject.bind(this),this._updateRoomPresence=this._updateRoomPresence.bind(this),this.room.addListener(Hi.XMPPEvents.SESSION_ACCEPT,this._updateRoomPresence),this.room.addListener(Hi.XMPPEvents.SOURCE_ADD,this._updateRoomPresence),this.room.addListener(Hi.XMPPEvents.SOURCE_ADD_ERROR,this._removeLocalSourceOnReject),this.room.addListener(Hi.XMPPEvents.SOURCE_REMOVE,this._updateRoomPresence),null!==(d=l.e2eping)&&void 0!==d&&d.enabled&&(this.e2eping=new Gl(this,l,((e,t)=>{try{this.sendMessage(e,t,!0)}catch(e){Hh.warn("Failed to send E2E ping request or response.",e&&e.msg)}}))),this.rtc||(this.rtc=new pl(this,c),this.eventManager.setupRTCListeners(),this._registerRtcListeners(this.rtc)),this.receiveVideoController=new th(this,this.rtc),this.sendVideoController=new ih(this,this.rtc),this.statistics||(this.statistics=new Mi(this,{aliasName:this._statsCurrentId,userName:l.statisticsDisplayName?l.statisticsDisplayName:this.myUserId(),confID:l.confID||`${this.connection.options.hosts.domain}/${this.options.name}`,roomName:this.options.name,applicationName:l.applicationName}),Mi.analytics.addPermanentProperties({callstats_name:this._statsCurrentId}),l.longTasksStatsInterval&&this.statistics.attachLongTasksStats()),this.eventManager.setupChatRoomListeners(),this.eventManager.setupStatisticsListeners(),l.enableTalkWhileMuted&&ci.supportsVADDetection())if(l.createVADProcessor){Hh.info("Using VAD detection for generating talk while muted events"),this._audioAnalyser||(this._audioAnalyser=new Fl(this,l.createVADProcessor));const e=new Vl;e.on(Dl,(()=>this.eventEmitter.emit(et))),this._audioAnalyser.addVADDetectionService(e)}else Hh.warn("No VAD Processor was provided. Talk while muted detection service was not initialized!");if(l.enableNoisyMicDetection&&ci.supportsVADDetection())if(l.createVADProcessor){this._audioAnalyser||(this._audioAnalyser=new Fl(this,l.createVADProcessor));const e=new jl;e.on(wl,(()=>this.eventEmitter.emit(je))),this._audioAnalyser.addVADDetectionService(e)}else Hh.warn("No VAD Processor was provided. Noisy microphone detection service was not initialized!");l.enableNoAudioDetection&&!l.disableAudioLevels&&_i.isLocalStatsSupported()&&(this._noAudioSignalDetection=new Ol(this),this._noAudioSignalDetection.on(Al,(()=>{this.eventEmitter.emit(Fe)})),this._noAudioSignalDetection.on(Rl,(e=>{this.eventEmitter.emit(z,e)}))),"channelLastN"in l&&this.setLastN(l.channelLastN),this.jvb121Status=new Kl(this),this.p2pDominantSpeakerDetection=new kl(this),l&&l.deploymentInfo&&l.deploymentInfo.userRegion&&this.setLocalParticipantProperty("region",l.deploymentInfo.userRegion),this.setLocalParticipantProperty("codecList",this.codecSelection.getCodecPreferenceList("jvb")),l&&l.transcriptionLanguage&&"en-US"!==l.transcriptionLanguage&&this.setLocalParticipantProperty("transcription_language",l.transcriptionLanguage)},Jh.prototype.join=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.room&&this.room.join(e,t).then((()=>this._maybeSetSITimeout()))},Jh.prototype.authenticateAndUpgradeRole=function(e){return Da.call(this,{...e,onCreateResource:Jh.resourceCreator})},Jh.prototype.isJoined=function(){return this.room&&this.room.joined},Jh.prototype.isP2PEnabled=function(){return Boolean(this.options.config.p2p&&this.options.config.p2p.enabled)||void 0===this.options.config.p2p},Jh.prototype.isP2PTestModeEnabled=function(){return Boolean(this.options.config.testing&&this.options.config.testing.p2pTestMode)},Jh.prototype.leave=async function(e){if(this.avgRtpStatsReporter&&(this.avgRtpStatsReporter.dispose(),this.avgRtpStatsReporter=null),this._audioOutputProblemDetector&&(this._audioOutputProblemDetector.dispose(),this._audioOutputProblemDetector=null),this.e2eping&&(this.e2eping.stop(),this.e2eping=null),this.getLocalTracks().forEach((e=>this.onLocalTrackRemoved(e))),this.rtc.closeBridgeChannel(),this._sendConferenceLeftAnalyticsEvent(),this.statistics&&this.statistics.dispose(),this._delayedIceFailed&&this._delayedIceFailed.cancel(),this._maybeClearSITimeout(),this.jvbJingleSession&&(this.jvbJingleSession.close(),this.jvbJingleSession=null),this.p2pJingleSession&&(this.p2pJingleSession.close(),this.p2pJingleSession=null),!this.room)throw new Error("You have already left the conference");const t=this.room;let n;t.removeListener(Hi.XMPPEvents.CONNECTION_INTERRUPTED,this._onIceConnectionInterrupted),t.removeListener(Hi.XMPPEvents.CONNECTION_RESTORED,this._onIceConnectionRestored),t.removeListener(Hi.XMPPEvents.CONNECTION_ESTABLISHED,this._onIceConnectionEstablished),t.removeListener(Hi.XMPPEvents.CONFERENCE_PROPERTIES_CHANGED,this._updateProperties),t.removeListener(Hi.XMPPEvents.MEETING_ID_SET,this._sendConferenceJoinAnalyticsEvent),t.removeListener(Hi.XMPPEvents.SESSION_ACCEPT,this._updateRoomPresence),t.removeListener(Hi.XMPPEvents.SOURCE_ADD,this._updateRoomPresence),t.removeListener(Hi.XMPPEvents.SOURCE_ADD_ERROR,this._removeLocalSourceOnReject),t.removeListener(Hi.XMPPEvents.SOURCE_REMOVE,this._updateRoomPresence),this.eventManager.removeXMPPListeners(),this._signalingLayer.setChatRoom(null),this.room=null;try{await t.leave(e)}catch(e){n=e,this.getParticipants().forEach((e=>this.onMemberLeft(e.getJid())))}if(this.rtc&&this.rtc.destroy(),n)throw n},Jh.prototype.isEndConferenceSupported=function(){return Boolean(this.room&&this.room.xmpp.endConferenceComponentAddress)},Jh.prototype.end=function(){if(this.isEndConferenceSupported()){if(!this.room)throw new Error("You have already left the conference");this.room.end()}else Hh.warn("Cannot end conference: is not supported.")},Jh.prototype.getActiveMediaSession=function(){return this.isP2PActive()?this.p2pJingleSession:this.jvbJingleSession},Jh.prototype.getMediaSessions=function(){const e=[];return this.jvbJingleSession&&e.push(this.jvbJingleSession),this.p2pJingleSession&&e.push(this.p2pJingleSession),e},Jh.prototype._registerRtcListeners=function(e){e.addListener(ji.default.DATA_CHANNEL_OPEN,(()=>{for(const e of this.rtc.localTracks)e.isVideoTrack()&&this._sendBridgeVideoTypeMessage(e)}))},Jh.prototype._sendBridgeVideoTypeMessage=function(e){let t=!e||e.isMuted()?Uh.NONE:e.getVideoType();t===Uh.DESKTOP&&this._desktopSharingFrameRate>5&&(t=Uh.DESKTOP_HIGH_FPS),e&&this.rtc.sendSourceVideoType(e.getSourceName(),t)},Jh.prototype.getName=function(){return this.options.name.toString()},Jh.prototype.getConnection=function(){return this.connection},Jh.prototype.isAuthEnabled=function(){return this.authEnabled},Jh.prototype.isLoggedIn=function(){return Boolean(this.authIdentity)},Jh.prototype.getAuthLogin=function(){return this.authIdentity},Jh.prototype.getLocalTracks=function(e){let t=[];return this.rtc&&(t=this.rtc.getLocalTracks(e)),t},Jh.prototype.getLocalAudioTrack=function(){return this.rtc?this.rtc.getLocalAudioTrack():null},Jh.prototype.getLocalVideoTrack=function(){return this.rtc?this.rtc.getLocalVideoTrack():null},Jh.prototype.getLocalVideoTracks=function(){return this.rtc?this.rtc.getLocalVideoTracks():null},Jh.prototype.getPerformanceStats=function(){return{longTasksStats:this.statistics.getLongTasksStats()}},Jh.prototype.on=function(e,t){this.eventEmitter&&this.eventEmitter.on(e,t)},Jh.prototype.once=function(e,t){this.eventEmitter&&this.eventEmitter.once(e,t)},Jh.prototype.off=function(e,t){this.eventEmitter&&this.eventEmitter.removeListener(e,t)},Jh.prototype.addEventListener=Jh.prototype.on,Jh.prototype.removeEventListener=Jh.prototype.off,Jh.prototype.addCommandListener=function(e,t){this.room&&this.room.addPresenceListener(e,t)},Jh.prototype.removeCommandListener=function(e,t){this.room&&this.room.removePresenceListener(e,t)},Jh.prototype.sendTextMessage=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"body";this.room&&this.room.sendMessage(e,t)},Jh.prototype.sendPrivateTextMessage=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"body";this.room&&this.room.sendPrivateMessage(e,t,n)},Jh.prototype.sendCommand=function(e,t){this.room?this.room.addOrReplaceInPresence(e,t)&&this.room.sendPresence():Hh.warn("Not sending a command, room not initialized.")},Jh.prototype.sendCommandOnce=function(e,t){this.sendCommand(e,t),this.removeCommand(e)},Jh.prototype.removeCommand=function(e){this.room&&this.room.removeFromPresence(e)},Jh.prototype.setDisplayName=function(e){if(this.room){const t="nick";e?this.room.addOrReplaceInPresence(t,{attributes:{xmlns:"http://jabber.org/protocol/nick"},value:e})&&this.room.sendPresence():this.room.getFromPresence(t)&&(this.room.removeFromPresence(t),this.room.sendPresence())}},Jh.prototype.setSubject=function(e){this.room&&this.isModerator()?this.room.setSubject(e):Hh.warn(`Failed to set subject, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.getTranscriptionStatus=function(){return this.room.transcriptionStatus},Jh.prototype.addTrack=function(e){if(!e)throw new Error("addTrack - a track is required");const t=e.getType(),n=this.rtc.getLocalTracks(t);if(n.length>0){if(e===n[0])return Promise.resolve(e);if(t===Ri.VIDEO&&!n.find((t=>t.getVideoType()===e.getVideoType()))){var i;const n=Cc(this.myUserId(),t,null===(i=this.getLocalTracks(t))||void 0===i?void 0:i.length);e.setSourceName(n);const r=[];return this.p2pJingleSession&&r.push(this.p2pJingleSession.addTracks([e])),this.jvbJingleSession&&r.push(this.jvbJingleSession.addTracks([e])),Promise.all(r).then((()=>{this._setupNewTrack(e),this._sendBridgeVideoTypeMessage(e),this._updateRoomPresence(this.getActiveMediaSession()),(this.isMutedByFocus||this.isVideoMutedByFocus)&&this._fireMuteChangeEvent(e)}))}return Promise.reject(new Error(`Cannot add second ${t} track to the conference`))}return this.replaceTrack(null,e).then((()=>{e.getVideoType()===Qo.VideoType.DESKTOP&&this._updateRoomPresence(this.getActiveMediaSession())}))},Jh.prototype._fireAudioLevelChangeEvent=function(e,t){const n=this.getActivePeerConnection();t&&n!==t||this.eventEmitter.emit(nt,this.myUserId(),e)},Jh.prototype._fireMuteChangeEvent=function(e){let t;if(this.isMutedByFocus&&e.isAudioTrack()&&!e.isMuted()?(this.isMutedByFocus=!1,this.room.muteParticipant(this.room.myroomjid,!1,Ri.AUDIO)):this.isVideoMutedByFocus&&e.isVideoTrack()&&!e.isMuted()&&(this.isVideoMutedByFocus=!1,this.room.muteParticipant(this.room.myroomjid,!1,Ri.VIDEO)),this.mutedByFocusActor&&e.isAudioTrack()){const e=St.Strophe.getResourceFromJid(this.mutedByFocusActor);t=this.participants.get(e)}else if(this.mutedVideoByFocusActor&&e.isVideoTrack()){const e=St.Strophe.getResourceFromJid(this.mutedVideoByFocusActor);t=this.participants.get(e)}const n=ci.isReactNative()?e.videoType===Qo.VideoType.DESKTOP:ci.doesVideoMuteByStreamRemove();e.isVideoTrack()&&!n&&this._sendBridgeVideoTypeMessage(e),this.eventEmitter.emit(it,e,t)},Jh.prototype._getInitialLocalTracks=function(){return this.getLocalTracks().filter((e=>{const t=e.getType();return!(t!==Ri.AUDIO||(this.isStartAudioMuted()||this.startMutedPolicy.audio)&&!ci.isWebKitBased()&&!ci.isReactNative())||t===Ri.VIDEO&&!this.isStartVideoMuted()&&!this.startMutedPolicy.video||(this.onLocalTrackRemoved(e),!1)}))},Jh.prototype.onLocalTrackRemoved=function(e){e.setConference(null),this.rtc.removeLocalTrack(e),e.removeEventListener(Rt,e.muteHandler),e.isAudioTrack()&&e.removeEventListener(Ct,e.audioLevelHandler),this.eventEmitter.emit(rt,e)},Jh.prototype.removeTrack=function(e){return this.replaceTrack(e,null)},Jh.prototype.replaceTrack=function(e,t){const n=null==e?void 0:e.getVideoType(),i=(null==e?void 0:e.getType())||(null==t?void 0:t.getType()),r=null==t?void 0:t.getVideoType();if(e&&t&&n!==r)throw new Error(`Replacing a track of videoType=${n} with a track of videoType=${r} is not supported in this mode.`);if(t){var o;const n=e?e.getSourceName():Cc(this.myUserId(),i,null===(o=this.getLocalTracks(i))||void 0===o?void 0:o.length);t.setSourceName(n)}const s=this===(null==e?void 0:e.conference);return s&&e.disposed||null!=t&&t.disposed?Promise.reject(new dr(tr)):(e&&!s&&Hh.warn(`JitsiConference.replaceTrack oldTrack (${e} does not belong to this conference`),this._doReplaceTrack(s?e:null,t).then((()=>(!s||e.isMuted()||t||e._sendMuteStatus(!0),s&&this.onLocalTrackRemoved(e),t&&this._setupNewTrack(t),(s&&null!=e&&e.isVideoTrack()||null!=t&&t.isVideoTrack())&&this._sendBridgeVideoTypeMessage(t),this._updateRoomPresence(this.getActiveMediaSession()),null!==t&&(this.isMutedByFocus||this.isVideoMutedByFocus)&&this._fireMuteChangeEvent(t),Promise.resolve()))).catch((e=>(Hh.error(`replaceTrack failed: ${null==e?void 0:e.stack}`),Promise.reject(e)))))},Jh.prototype._doReplaceTrack=function(e,t){const n=[];return this.jvbJingleSession?n.push(this.jvbJingleSession.replaceTrack(e,t)):Hh.info("_doReplaceTrack - no JVB JingleSession"),this.p2pJingleSession?n.push(this.p2pJingleSession.replaceTrack(e,t)):Hh.info("_doReplaceTrack - no P2P JingleSession"),Promise.all(n)},Jh.prototype._removeLocalSourceOnReject=function(e,t,n){if(!e)return;Hh.warn(`Source-add rejected on ${e}, reason="${null==t?void 0:t.reason}", message="${null==t?void 0:t.msg}"`);const i=this.getLocalTracks(n)[0];this.eventEmitter.emit(ot,i)},Jh.prototype._setupNewTrack=function(e){const t=e.getType();if(!e.getSourceName()){var n;const i=Cc(this.myUserId(),t,null===(n=this.getLocalTracks(t))||void 0===n?void 0:n.length);e.setSourceName(i)}this.rtc.addLocalTrack(e),e.setConference(this),e.muteHandler=this._fireMuteChangeEvent.bind(this,e),e.addEventListener(Rt,e.muteHandler),e.isAudioTrack()&&(e.audioLevelHandler=this._fireAudioLevelChangeEvent.bind(this),e.addEventListener(Ct,e.audioLevelHandler)),this.eventEmitter.emit(tt,e)},Jh.prototype._setNewVideoType=function(e){let t=!1;return e&&(t=this._signalingLayer.setTrackVideoType(e.getSourceName(),e.videoType)),t},Jh.prototype._setTrackMuteStatus=function(e,t,n){let i=!1;return t&&(i=this._signalingLayer.setTrackMuteStatus(t.getSourceName(),n),i&&Hh.debug(`Mute state of ${t} changed to muted=${n}`)),i},Jh.prototype._addLocalTrackToPc=function(e){const t=[];return e.conference===this?(this.jvbJingleSession?t.push(this.jvbJingleSession.addTrackToPc(e)):Hh.debug("Add local MediaStream - no JVB Jingle session started yet"),this.p2pJingleSession?t.push(this.p2pJingleSession.addTrackToPc(e)):Hh.debug("Add local MediaStream - no P2P Jingle session started yet")):t.push(this.addTrack(e)),Promise.allSettled(t)},Jh.prototype._removeLocalTrackFromPc=function(e){const t=[];return e.conference===this&&(this.jvbJingleSession?t.push(this.jvbJingleSession.removeTrackFromPc(e)):Hh.debug("Remove local MediaStream - no JVB JingleSession started yet"),this.p2pJingleSession?t.push(this.p2pJingleSession.removeTrackFromPc(e)):Hh.debug("Remove local MediaStream - no P2P JingleSession started yet")),Promise.allSettled(t)},Jh.prototype.getRole=function(){return this.room.role},Jh.prototype.isHidden=function(){return this.connection?St.Strophe.getDomainFromJid(this.connection.getJid())===this.options.config.hiddenDomain:null},Jh.prototype.isModerator=function(){return this.room?this.room.isModerator():null},Jh.prototype.lock=function(e){return this.isModerator()?new Promise(((t,n)=>{this.room.lockRoom(e||"",(()=>t()),(e=>n(e)),(()=>n(U)))})):Promise.reject(new Error("You are not moderator."))},Jh.prototype.unlock=function(){return this.lock()},Jh.prototype.getLastN=function(){return this.receiveVideoController.getLastN()},Jh.prototype.getForwardedSources=function(){return this.rtc.getForwardedSources()},Jh.prototype.setLastN=function(e){if(!Number.isInteger(e)&&!Number.parseInt(e,10))throw new Error(`Invalid value for lastN: ${e}`);const t=Number(e);if(t<-1)throw new RangeError("lastN cannot be smaller than -1");if(this.receiveVideoController.setLastN(t),this.p2pJingleSession){const e=0!==t;this.p2pJingleSession.setP2pVideoTransferActive(e).catch((t=>{Hh.error(`Failed to adjust video transfer status (${e})`,t)}))}},Jh.prototype.getParticipants=function(){return Array.from(this.participants.values())},Jh.prototype.getParticipantCount=function(){let e=arguments.length>0&&void 0!==arguments[0]&&arguments[0],t=this.getParticipants();return e||(t=t.filter((e=>!e.isHidden()))),t.length+1},Jh.prototype.getParticipantById=function(e){return this.participants.get(e)},Jh.prototype.grantOwner=function(e){const t=this.getParticipantById(e);t&&this.room.setAffiliation(t.getConnectionJid(),"owner")},Jh.prototype.revokeOwner=function(e){const t=this.getParticipantById(e),n=this.myUserId()===e,i=this.isMembersOnly()?"member":"none";n?this.room.setAffiliation(this.connection.getJid(),i):t&&this.room.setAffiliation(t.getConnectionJid(),i)},Jh.prototype.kickParticipant=function(e,t){const n=this.getParticipantById(e);n&&this.room.kick(n.getJid(),t)},Jh.prototype._maybeClearSITimeout=function(){this._sessionInitiateTimeout&&(this.jvbJingleSession||this.getParticipantCount()<2)&&(window.clearTimeout(this._sessionInitiateTimeout),this._sessionInitiateTimeout=null)},Jh.prototype._maybeSetSITimeout=function(){!this.jvbJingleSession&&this.getParticipantCount()>=2&&!this._sessionInitiateTimeout&&(this._sessionInitiateTimeout=window.setTimeout((()=>{this._sessionInitiateTimeout=null,Mi.sendAnalytics(dn(Ht,{p2p:!1,value:5e3}))}),5e3))},Jh.prototype.muteParticipant=function(e,t){const n=t||Ri.AUDIO;if(n!==Ri.AUDIO&&n!==Ri.VIDEO)return void Hh.error(`Unsupported media type: ${n}`);const i=this.getParticipantById(e);i&&this.room.muteParticipant(i.getJid(),!0,n)},Jh.prototype.onMemberJoined=function(e,t,n,i,r,o,s,a,d,c,l){var h,u,p,m;const g=St.Strophe.getResourceFromJid(e);if("focus"===g||this.myUserId()===g)return;const f=new Bi(e,this,t,i,r,o,s);f.setConnectionJid(d),f.setRole(n),f.setBotType(a),f.setFeatures(c),f.setIsReplacing(l);const v=this.isP2PActive()?null!==(h=null===(u=this.p2pJingleSession)||void 0===u?void 0:u.peerconnection.getRemoteTracks(g))&&void 0!==h?h:[]:null!==(p=null===(m=this.jvbJingleSession)||void 0===m?void 0:m.peerconnection.getRemoteTracks(g))&&void 0!==p?p:[];for(const e of v)f._tracks.push(e);this.participants.set(g,f),this.eventEmitter.emit(at,g,f),this._updateFeatures(f),this.isJoined()&&this._maybeStartOrStopP2P(),this._maybeSetSITimeout()},Jh.prototype._onMucJoined=function(){this._numberOfParticipantsOnJoin=this.getParticipantCount(),this._maybeStartOrStopP2P()},Jh.prototype._updateFeatures=function(e){e.getFeatures().then((t=>{e._supportsDTMF=t.has("urn:xmpp:jingle:dtmf:0"),this.updateDTMFSupport(),t.has(wa)&&e.setProperty("features_jigasi",!0),t.has(Ia)&&e.setProperty("features_e2ee",!0)})).catch((()=>!1))},Jh.prototype._onMemberBotTypeChanged=function(e,t){const n=this.getParticipants().find((t=>t.getJid()===e));if(n){n.setBotType(t);const i=St.Strophe.getResourceFromJid(e);this.eventEmitter.emit(ne,i,t)}n.getBotType()||this._maybeStartOrStopP2P()},Jh.prototype.onMemberLeft=function(e,t){const n=St.Strophe.getResourceFromJid(e);if("focus"===n||this.myUserId()===n)return;const i=this.getMediaSessions();let r=[];for(const e of i){const t=e.peerconnection.getRemoteTracks(n);t&&(r=[...r,...t]),e._signalingLayer.updateSsrcOwnersOnLeave(n),Ai.isSsrcRewritingSupported()||e.removeRemoteStreamsOnLeave(n)}r.forEach((e=>{Ai.isSsrcRewritingSupported()?(e.setSourceName(null),e.setOwner(null)):this.eventEmitter.emit(rt,e)}));const o=this.participants.get(n);o&&(this.participants.delete(n),this.eventEmitter.emit(dt,n,o,t)),null!==this.room&&(this._maybeStartOrStopP2P(!0),this._maybeClearSITimeout())},Jh.prototype.onMemberKicked=function(e,t,n,i,r){if(t===this.myUserId())return;const o=this.participants.get(t);if(e)return this.leave().finally((()=>this.xmpp.disconnect())),void this.eventEmitter.emit(we,o,i,r);const s=this.participants.get(n);s.setIsReplaced(r),this.eventEmitter.emit(He,o,s,i)},Jh.prototype.onLocalRoleChanged=function(e){this.eventEmitter.emit(ct,this.myUserId(),e)},Jh.prototype.onUserRoleChanged=function(e,t){const n=St.Strophe.getResourceFromJid(e),i=this.getParticipantById(n);i&&(i.setRole(t),this.eventEmitter.emit(ct,n,t))},Jh.prototype.onDisplayNameChanged=function(e,t){const n=St.Strophe.getResourceFromJid(e),i=this.getParticipantById(n);i&&i._displayName!==t&&(i._displayName=t,this.eventEmitter.emit(_e,n,t))},Jh.prototype.onRemoteTrackAdded=function(e){if(e.isP2P&&!this.isP2PActive())return void Hh.info("Trying to add remote P2P track, when not in P2P - IGNORED");if(!e.isP2P&&this.isP2PActive())return void Hh.info("Trying to add remote JVB track, when in P2P - IGNORED");const t=e.getParticipantId(),n=this.getParticipantById(t);n?n._tracks.push(e):Hh.info(`Source signaling received before presence for ${t}`);const i=this.eventEmitter;e.addEventListener(Rt,(()=>i.emit(it,e))),e.isAudioTrack()&&e.addEventListener(Ct,((e,n)=>{this.getActivePeerConnection()===n&&i.emit(nt,t,e)})),i.emit(tt,e)},Jh.prototype.onCallAccepted=function(e,t){this.p2pJingleSession===e&&(Hh.info("P2P setAnswer"),this.p2pJingleSession.setAnswer(t),this.eventEmitter.emit(q,this.p2pJingleSession))},Jh.prototype.onTransportInfo=function(e,t){this.p2pJingleSession===e&&(Hh.info("P2P addIceCandidates"),this.p2pJingleSession.addIceCandidates(t))},Jh.prototype.onRemoteTrackRemoved=function(e){this.getParticipants().forEach((t=>{const n=t.getTracks();for(let i=0;i<n.length;i++)if(n[i]===e){t._tracks.splice(i,1),this.eventEmitter.emit(rt,e);break}}),this)},Jh.prototype._onIncomingCallP2P=function(e,t){let n;const i=t.find(">content").attr("name");"0"===i||"1"===i?!this.isP2PEnabled()&&!this.isP2PTestModeEnabled()||ci.isFirefox()&&!this._firefoxP2pEnabled?n={reason:"decline",reasonDescription:"P2P disabled",errorMsg:"P2P mode disabled in the configuration or browser unsupported"}:this.p2pJingleSession?n={reason:"busy",reasonDescription:"P2P already in progress",errorMsg:\'Duplicated P2P "session-initiate"\'}:this._shouldBeInP2PMode()||(n={reason:"decline",reasonDescription:"P2P requirements not met",errorMsg:\'Received P2P "session-initiate" when should not be in P2P mode\'},Mi.sendAnalytics(dn(qt))):n={reason:"decline",reasonDescription:"P2P disabled",errorMsg:"P2P across two endpoints in different SDP modes is disabled"},n?this._rejectIncomingCall(e,n):this._acceptP2PIncomingCall(e,t)},Jh.prototype.onIncomingCall=function(e,t,n){if(e.isP2P)this._onIncomingCallP2P(e,t);else{if(!this.isFocus(e.remoteJid)){const t="Rejecting session-initiate from non-focus.";return void this._rejectIncomingCall(e,{reason:"security-error",reasonDescription:t,errorMsg:t})}this._acceptJvbIncomingCall(e,t,n)}},Jh.prototype._acceptJvbIncomingCall=function(e,t,n){this.jvbJingleSession=e,this.room.connectionTimes["session.initiate"]=n,this._sendConferenceJoinAnalyticsEvent(),this.wasStopped&&Mi.sendAnalyticsAndLog(dn(jt,{p2p:!1}));const i=_t()(t).find(\'>bridge-session[xmlns="http://jitsi.org/protocol/focus"]\').attr("region");this.eventEmitter.emit(We,i),this._maybeClearSITimeout(),Mi.sendAnalytics(dn(Ut,{p2p:!1,value:n}));try{e.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("jvb")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()})}catch(e){return void Hh.error(e)}this._setBridgeChannel(t,e.peerconnection);const r=this._getInitialLocalTracks();try{e.acceptOffer(t,(()=>{this.isP2PActive()&&this.jvbJingleSession&&this._suspendMediaTransferForJvbConnection(),this.eventEmitter.emit(q,e),this.isP2PActive()||this.eventEmitter.emit(G,e)}),(e=>{Hh.error("Failed to accept incoming Jingle session",e)}),r),this._desktopSharingFrameRate&&e.peerconnection.setDesktopSharingFrameRate(this._desktopSharingFrameRate),this.statistics.startRemoteStats(this.jvbJingleSession.peerconnection)}catch(e){Hh.error(e)}},Jh.prototype._setBridgeChannel=function(e,t){var n,i,r,o,s,a,d;const c=null===(n=this.connection)||void 0===n||null===(i=n.options)||void 0===i||null===(r=i.bridgeChannel)||void 0===r?void 0:r.ignoreDomain,l=null!==(o=null===(s=this.connection)||void 0===s||null===(a=s.options)||void 0===a||null===(d=a.bridgeChannel)||void 0===d?void 0:d.preferSctp)&&void 0!==o&&o,h=1===_t()(e).find(\'>content[name="data"]\').first().length;let u=null;if(Hh.info(`SCTP: offered=${h}, prefered=${l}`),!(h&&l||(_t()(e).find(">content>transport>web-socket").toArray().map((e=>e.getAttribute("url"))).forEach((e=>{u||c&&c===new URL(e).hostname?u||Hh.info(`Ignoring colibri-ws url with domain ${c}`):(u=e,Hh.info(`Using colibri-ws url ${e}`))})),u))){const t=_t()(e).find(">content>transport>web-socket").first();1===t.length&&(u=t[0].getAttribute("url"),Hh.info(`Falling back to ${u}`))}!u||h&&l?h?this.rtc.initializeBridgeChannel(t,null):Hh.warn("Neither SCTP nor a websocket is available. Will not initialize bridge channel."):this.rtc.initializeBridgeChannel(null,u)},Jh.prototype._rejectIncomingCall=function(e,t){null!=t&&t.errorMsg&&Hh.warn(t.errorMsg),e.terminate(null,(e=>{Hh.warn("An error occurred while trying to terminate invalid Jingle session",e)}),{reason:t&&t.reason,reasonDescription:t&&t.reasonDescription,sendSessionTerminate:!0})},Jh.prototype.onCallEnded=function(e,t,n){if(Hh.info(`Call ended: ${t} - ${n} P2P ?${e.isP2P}`),e===this.jvbJingleSession)this.wasStopped=!0,Mi.sendAnalytics(dn($t,{p2p:!1})),this.statistics&&this.statistics.stopRemoteStats(this.jvbJingleSession.peerconnection),this.jvbJingleSession=null,this.rtc.onCallEnded();else if(e===this.p2pJingleSession){const e={};"connectivity-error"===t&&"ICE FAILED"===n?Mi.analytics.addPermanentProperties({p2pFailed:!0}):"success"===t&&"restart"===n&&(e.requestRestart=!0),this._stopP2PSession(e)}else Hh.error("Received onCallEnded for invalid session",e.sid,e.remoteJid,t,n)},Jh.prototype.onSuspendDetected=function(e){e.isP2P||(this.leave(),this.eventEmitter.emit(Ze))},Jh.prototype.updateDTMFSupport=function(){let e=!1;const t=this.getParticipants();for(let n=0;n<t.length;n+=1)if(t[n].supportsDTMF()){e=!0;break}e!==this.somebodySupportsDTMF&&(this.somebodySupportsDTMF=e,this.eventEmitter.emit(ye,e))},Jh.prototype.isDTMFSupported=function(){return this.somebodySupportsDTMF},Jh.prototype.myUserId=function(){return this.room&&this.room.myroomjid?St.Strophe.getResourceFromJid(this.room.myroomjid):null},Jh.prototype.sendTones=function(e,t,n){const i=this.getActivePeerConnection();i?i.sendTones(e,t,n):Hh.warn("cannot sendTones: no peer connection")},Jh.prototype.startRecording=function(e){return this.room?this.recordingManager.startRecording(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.stopRecording=function(e){return this.room?this.recordingManager.stopRecording(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.isSIPCallingSupported=function(){var e,t,n,i;return null!==(e=null===(t=this.room)||void 0===t||null===(n=t.xmpp)||void 0===n||null===(i=n.moderator)||void 0===i?void 0:i.isSipGatewayEnabled())&&void 0!==e&&e},Jh.prototype.dial=function(e){return this.room?this.room.dial(e):Promise.reject(new Error("The conference is not created yet!"))},Jh.prototype.hangup=function(){return this.room?this.room.hangup():Promise.resolve()},Jh.prototype.getPhoneNumber=function(){return this.room?this.room.getPhoneNumber():null},Jh.prototype.getPhonePin=function(){return this.room?this.room.getPhonePin():null},Jh.prototype.getMeetingUniqueId=function(){if(this.room)return this.room.getMeetingId()},Jh.prototype.getActivePeerConnection=function(){const e=this.isP2PActive()?this.p2pJingleSession:this.jvbJingleSession;return e?e.peerconnection:null},Jh.prototype.getConnectionState=function(){const e=this.getActivePeerConnection();return e?e.getConnectionState():null},Jh.prototype.setStartMutedPolicy=function(e){this.isModerator()?this.room.addOrReplaceInPresence("startmuted",{attributes:{audio:e.audio,video:e.video,xmlns:"http://jitsi.org/jitmeet/start-muted"}})&&this.room.sendPresence():Hh.warn(`Failed to set start muted policy, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.getStartMutedPolicy=function(){return this.startMutedPolicy},Jh.prototype.isStartAudioMuted=function(){return this.startAudioMuted},Jh.prototype.isStartVideoMuted=function(){return this.startVideoMuted},Jh.prototype.getConnectionTimes=function(){return this.room.connectionTimes},Jh.prototype.setLocalParticipantProperty=function(e,t){this.sendCommand(`jitsi_participant_${e}`,{value:t})},Jh.prototype.removeLocalParticipantProperty=function(e){this.removeCommand(`jitsi_participant_${e}`),this.room.sendPresence()},Jh.prototype.getLocalParticipantProperty=function(e){const t=this.room.presMap.nodes.find((t=>t.tagName===`jitsi_participant_${e}`));return t?t.value:void 0},Jh.prototype.sendFeedback=function(e,t){return this.statistics.sendFeedback(e,t)},Jh.prototype.isCallstatsEnabled=function(){return Hh.warn("Callstats is no longer supported"),!1},Jh.prototype.getSsrcByTrack=function(e){var t;return e.isLocal()?null===(t=this.getActivePeerConnection())||void 0===t?void 0:t.getLocalSSRC(e):e.getSSRC()},Jh.prototype.sendApplicationLog=function(){},Jh.prototype.isFocus=function(e){return this.room?this.room.isFocus(e):null},Jh.prototype._fireIncompatibleVersionsEvent=function(){this.eventEmitter.emit(ae,j)},Jh.prototype.sendEndpointMessage=function(e,t){this.rtc.sendChannelMessage(e,t)},Jh.prototype.sendEndpointStatsMessage=function(e){this.rtc.sendEndpointStatsMessage(e)},Jh.prototype.broadcastEndpointMessage=function(e){this.sendEndpointMessage("",e)},Jh.prototype.sendMessage=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"",n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];const i=typeof e;if("object"===i||!n&&"string"===i)if(n)this.sendEndpointMessage(t,e);else{let n=e,r="body";if("object"===i){r="json-message",n.hasOwnProperty(Aa)||(n[Aa]="");try{n=JSON.stringify(n)}catch(e){return void Hh.error("Can not send a message, stringify failed: ",e)}}t?this.sendPrivateTextMessage(t,n,r):this.sendTextMessage(n,r)}else Hh.error(`Can not send a message of type ${i}`)},Jh.prototype.isConnectionInterrupted=function(){return this.isP2PActive()?this.isP2PConnectionInterrupted:this.isJvbConnectionInterrupted},Jh.prototype._onConferenceRestarted=function(e){!e.isP2P&&this.options.config.enableForcedReload&&this.eventEmitter.emit(ae,I)},Jh.prototype._onIceConnectionInterrupted=function(e){e.isP2P?this.isP2PConnectionInterrupted=!0:this.isJvbConnectionInterrupted=!0,e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(me)},Jh.prototype._onIceConnectionFailed=function(e){e.isP2P?(Mi.analytics.addPermanentProperties({p2pFailed:!0}),this.p2pJingleSession&&Mi.sendAnalyticsAndLog(cn(zt,{initiator:this.p2pJingleSession.isInitiator})),this._stopP2PSession({reason:"connectivity-error",reasonDescription:"ICE FAILED"})):e&&this.jvbJingleSession===e&&(this._delayedIceFailed=new Tl(this),this._delayedIceFailed.start(e))},Jh.prototype._onIceConnectionRestored=function(e){e.isP2P?this.isP2PConnectionInterrupted=!1:(this.isJvbConnectionInterrupted=!1,this._delayedIceFailed&&this._delayedIceFailed.cancel()),e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(ge)},Jh.prototype._acceptP2PIncomingCall=function(e,t){this.isP2PConnectionInterrupted=!1,this.p2pJingleSession=e,this._sendConferenceJoinAnalyticsEvent(),this.p2pJingleSession.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("p2p")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()});const n=this.getLocalTracks();this.p2pJingleSession.acceptOffer(t,(()=>{Hh.debug(\'Got RESULT for P2P "session-accept"\'),this.eventEmitter.emit(q,e)}),(e=>{Hh.error("Failed to accept incoming P2P Jingle session",e)}),n)},Jh.prototype._addRemoteJVBTracks=function(){this._addRemoteTracks("JVB",this.jvbJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._addRemoteP2PTracks=function(){this._addRemoteTracks("P2P",this.p2pJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._addRemoteTracks=function(e,t){for(const n of t)(Ai.isSsrcRewritingSupported()||this.participants.has(n.ownerEndpointId))&&(Hh.info(`Adding remote ${e} track: ${n}`),this.onRemoteTrackAdded(n))},Jh.prototype._onIceConnectionEstablished=function(e){null!==this.p2pJingleSession&&(this.p2pEstablishmentDuration=this.p2pJingleSession.establishmentDuration),null!==this.jvbJingleSession&&(this.jvbEstablishmentDuration=this.jvbJingleSession.establishmentDuration);let t=!1;if(e.isP2P?this.p2pJingleSession!==e&&(Hh.error("CONNECTION_ESTABLISHED - wrong P2P session instance ?!"),t=!0):t=!0,!isNaN(this.p2pEstablishmentDuration)&&!isNaN(this.jvbEstablishmentDuration)){const e=this.p2pEstablishmentDuration-this.jvbEstablishmentDuration;Mi.sendAnalytics(Zt,{value:e})}e.isP2P===this.isP2PActive()&&this.eventEmitter.emit(pe),t||(this._setP2PStatus(!0),this.jvbJingleSession?this._removeRemoteJVBTracks():Hh.info("Not removing remote JVB tracks - no session yet"),this._addRemoteP2PTracks(),this.jvbJingleSession&&this._suspendMediaTransferForJvbConnection(),Hh.info("Starting remote stats with p2p connection"),this.statistics.startRemoteStats(this.p2pJingleSession.peerconnection),Mi.sendAnalyticsAndLog(cn(Gt,{initiator:this.p2pJingleSession.isInitiator})))},Jh.prototype._updateProperties=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const t=!yt()(e,this.properties);if(this.properties=e,t){var n,i;this.eventEmitter.emit(ze,this.properties);const t="true"===this.properties["audio-limit-reached"],r="true"===this.properties["video-limit-reached"];this._audioSenderLimitReached!==t&&(this._audioSenderLimitReached=t,this.eventEmitter.emit(K,t),Hh.info(`Audio unmute permissions set by Jicofo to ${t}`)),this._videoSenderLimitReached!==r&&(this._videoSenderLimitReached=r,this.eventEmitter.emit(pt,r),Hh.info(`Video unmute permissions set by Jicofo to ${r}`)),["bridge-count"].forEach((t=>{void 0!==e[t]&&Mi.analytics.addPermanentProperties({[t.replace("-","_")]:e[t]})}));let o=null===(n=this.properties["visitor-codecs"])||void 0===n?void 0:n.split(",");null!==(i=o)&&void 0!==i&&i.length&&(o=o.filter((e=>"string"==typeof e&&e.trim().length&&Object.values(Ds).find((t=>t===e))))),this._visitorCodecs!==o&&(this._visitorCodecs=o,this.eventEmitter.emit(ue,this._visitorCodecs));const s=this._hasVisitors;this._hasVisitors=this.properties["visitor-count"]>0,s!==this._hasVisitors&&this._maybeStartOrStopP2P(!0)}},Jh.prototype.getProperty=function(e){return this.properties[e]},Jh.prototype._maybeClearDeferredStartP2P=function(){this.deferredStartP2PTask&&(Hh.info("Cleared deferred start P2P task"),clearTimeout(this.deferredStartP2PTask),this.deferredStartP2PTask=null)},Jh.prototype._removeRemoteJVBTracks=function(){this._removeRemoteTracks("JVB",this.jvbJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._removeRemoteP2PTracks=function(){this._removeRemoteTracks("P2P",this.p2pJingleSession.peerconnection.getRemoteTracks())},Jh.prototype._removeRemoteTracks=function(e,t){for(const n of t)Hh.info(`Removing remote ${e} track: ${n}`),this.onRemoteTrackRemoved(n)},Jh.prototype._resumeMediaTransferForJvbConnection=function(){Hh.info("Resuming media transfer over the JVB connection..."),this.jvbJingleSession.setMediaTransferActive(!0).then((()=>{Hh.info("Resumed media transfer over the JVB connection!")})).catch((e=>{Hh.error("Failed to resume media transfer over the JVB connection:",e)}))},Jh.prototype._setP2PStatus=function(e){if(this.p2p!==e){if(this.p2p=e,e){Hh.info("Peer to peer connection established!"),Mi.analytics.addPermanentProperties({p2pFailed:!1});const e=0!==this.getLastN();this.p2pJingleSession.setP2pVideoTransferActive(e).catch((t=>{Hh.error(`Failed to sync up P2P video transfer status (${e}), ${t}`)}))}else Hh.info("Peer to peer connection closed!");this.dtmfManager=null,this.eventEmitter.emit(Ue,this,this.p2p),this.eventEmitter.emit(G,this.getActiveMediaSession()),this.eventEmitter.emit(this.isConnectionInterrupted()?me:ge)}else Hh.debug(`Called _setP2PStatus with the same status: ${e}`)},Jh.prototype._startP2PSession=function(e){if(this._maybeClearDeferredStartP2P(),this.p2pJingleSession)return void Hh.error("P2P session already started!");this.isP2PConnectionInterrupted=!1,this.p2pJingleSession=this.xmpp.connection.jingle.newP2PJingleSession(this.room.myroomjid,e),Hh.info("Created new P2P JingleSession",this.room.myroomjid,e),this._sendConferenceJoinAnalyticsEvent(),this.p2pJingleSession.initialize(this.room,this.rtc,this._signalingLayer,{...this.options.config,codecSettings:{mediaType:Ri.VIDEO,codecList:this.codecSelection.getCodecPreferenceList("p2p")},enableInsertableStreams:this.isE2EEEnabled()||Ai.isRunInLiteModeEnabled()});const t=this.getLocalTracks();this.p2pJingleSession.invite(t)},Jh.prototype._suspendMediaTransferForJvbConnection=function(){Hh.info("Suspending media transfer over the JVB connection..."),this.jvbJingleSession.setMediaTransferActive(!1).then((()=>{Hh.info("Suspended media transfer over the JVB connection !")})).catch((e=>{Hh.error("Failed to suspend media transfer over the JVB connection:",e)}))},Jh.prototype._maybeStartOrStopP2P=function(e){if(!this.isP2PEnabled()||this.isP2PTestModeEnabled()||ci.isFirefox()&&!this._firefoxP2pEnabled||this.isE2EEEnabled())return void Hh.info("Auto P2P disabled");const t=this.getParticipants(),n=t.length,i=this._shouldBeInP2PMode();if(!i&&this.deferredStartP2PTask&&this._maybeClearDeferredStartP2P(),!this.p2pJingleSession&&i){const i=n&&t[0],r=this.myUserId(),o=i.getId();if(r>o)return void Hh.debug("I\'m the bigger peersId - the other peer should start P2P",r,o);if(r===o)return void Hh.error("The same IDs ? ",r,o);const s=i.getJid();if(e){if(this.deferredStartP2PTask)return void Hh.error("Deferred start P2P task\'s been set already!");Hh.info(`Will start P2P with: ${s} after ${this.backToP2PDelay} seconds...`),this.deferredStartP2PTask=setTimeout(this._startP2PSession.bind(this,s),1e3*this.backToP2PDelay)}else Hh.info(`Will start P2P with: ${s}`),this._startP2PSession(s)}else this.p2pJingleSession&&!i&&(Hh.info(`Will stop P2P with: ${this.p2pJingleSession.remoteJid}`),this.p2pJingleSession.isInitiator&&n>1&&Mi.sendAnalyticsAndLog(cn(Kt)),this._stopP2PSession())},Jh.prototype._shouldBeInP2PMode=function(){const e=this.getParticipants(),t=e.length,n=void 0!==e.find((e=>"poltergeist"===e.getBotType()||e.hasFeature(wa))),i=1===t&&!n&&!this._hasVisitors;return Hh.debug(`P2P? peerCount: ${t}, hasBotPeer: ${n} => ${i}`),i},Jh.prototype._stopJvbSession=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{requestRestart:t=!1,sendSessionTerminate:n=!1}=e;this.jvbJingleSession?(!this.isP2PActive()&&this._removeRemoteJVBTracks(),Hh.info("Stopping stats for jvb connection"),this.statistics.stopRemoteStats(this.jvbJingleSession.peerconnection),this.jvbJingleSession.terminate((()=>{t&&n&&Hh.info("session-terminate for ice restart - done"),this.jvbJingleSession=null}),(e=>{t&&n&&(Hh.error("session-terminate for ice restart failed: reloading the client"),this.eventEmitter.emit(ae,F)),Hh.error(`An error occurred while trying to terminate the JVB session\', reason=${e.reason},msg=${e.msg}`)}),e)):Hh.error("No JVB session to be stopped")},Jh.prototype._stopP2PSession=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{reason:t="success",reasonDescription:n="Turning off P2P session",requestRestart:i=!1}=e;if(!this.p2pJingleSession)return void Hh.error("No P2P session to be stopped!");const r=this.isP2PActive();r&&(this.jvbJingleSession&&!i&&this._resumeMediaTransferForJvbConnection(),this._removeRemoteP2PTracks()),Hh.info("Stopping remote stats for P2P connection"),this.statistics.stopRemoteStats(this.p2pJingleSession.peerconnection),this.p2pJingleSession.terminate((()=>{Hh.info("P2P session terminate RESULT"),this.p2pJingleSession=null}),(e=>{"success"!==t&&Hh.error("An error occurred while trying to terminate P2P Jingle session",e)}),{reason:t,reasonDescription:n,sendSessionTerminate:this.room&&this.getParticipantById(St.Strophe.getResourceFromJid(this.p2pJingleSession.remoteJid))}),this.p2pJingleSession=null,this._setP2PStatus(!1),r&&(this.jvbJingleSession&&!i?this._addRemoteJVBTracks():Hh.info("Not adding remote JVB tracks - no session yet"))},Jh.prototype._updateRoomPresence=function(e,t){if(!e)return;if(t){if(t.skip)return;t.skip=!0}let n,i,r=!1;const o=e.peerconnection.getLocalTracks();for(const e of o){const t=e.isMuted();n=this._setTrackMuteStatus(e.getType(),e,t),n&&Hh.debug(`Updating mute state of ${e} in presence to muted=${t}`),e.getType()===Ri.VIDEO&&(i=this._setNewVideoType(e),i&&Hh.debug(`Updating videoType in presence to ${e.getVideoType()}`)),r=r||n||i}r&&this.room.sendPresence()},Jh.prototype.isP2PActive=function(){return this.p2p},Jh.prototype.getP2PConnectionState=function(){return this.isP2PActive()?this.p2pJingleSession.peerconnection.getConnectionState():null},Jh.prototype.setDesktopSharingFrameRate=function(e){return"number"!=typeof e||isNaN(e)?(Hh.error(`Invalid value ${e} specified for desktop capture frame rate`),!1):(this._desktopSharingFrameRate=e,this.jvbJingleSession&&this.jvbJingleSession.peerconnection.setDesktopSharingFrameRate(e),this.rtc.setDesktopSharingFrameRate(e),!0)},Jh.prototype.startP2PSession=function(){const e=this.getParticipants();if(1!==e.length)throw new Error("There must be exactly 1 participant to start the P2P session !");{const t=e[0].getJid();this._startP2PSession(t)}},Jh.prototype.stopP2PSession=function(e){this._stopP2PSession(e)},Jh.prototype.getSpeakerStats=function(){return this.speakerStatsCollector.getStats()},Jh.prototype.sendFaceLandmarks=function(e){e.faceExpression&&this.xmpp.sendFaceLandmarksEvent(this.room.roomjid,e)},Jh.prototype.setReceiverConstraints=function(e){this.receiveVideoController.setReceiverConstraints(e)},Jh.prototype.setAssumedBandwidthBps=function(e){this.receiveVideoController.setAssumedBandwidthBps(e)},Jh.prototype.setReceiverVideoConstraint=function(e){this.receiveVideoController.setPreferredReceiveMaxFrameHeight(e)},Jh.prototype.setSenderVideoConstraint=function(e){return this.sendVideoController.setPreferredSendMaxFrameHeight(e)},Jh.prototype.createVideoSIPGWSession=function(e,t){return this.room?this.videoSIPGWHandler.createVideoSIPGWSession(e,t):new Error(Ph)},Jh.prototype._sendConferenceJoinAnalyticsEvent=function(){var e,t,n;const i=this.getMeetingUniqueId();if(this._conferenceJoinAnalyticsEventSent||!i||null===this.getActivePeerConnection())return;const r=this.getConnectionTimes(),o=this.connection.getConnectionTimes(),s=window.connectionTimes["firstObtainPermissions.start"],a=window.connectionTimes["firstObtainPermissions.end"],d=null!==(e=null===(t=window.JitsiMeetJS)||void 0===t||null===(n=t.app)||void 0===n?void 0:n.connectionTimes)&&void 0!==e?e:{},c={...r,...o,...d,gumDuration:Ti(a,s),xmppConnectingTime:Ti(o.connected,o.connecting),connectedToMUCJoinedTime:Ti(r["muc.joined"],o.connected),connectingToMUCJoinedTime:Ti(r["muc.joined"],o.connecting),numberOfParticipantsOnJoin:this._numberOfParticipantsOnJoin};Mi.sendAnalytics(on("joined",{...c,meetingId:i,participantId:`${i}.${this._statsCurrentId}`})),this._conferenceJoinAnalyticsEventSent=Date.now()},Jh.prototype._sendConferenceLeftAnalyticsEvent=function(){const e=this.getMeetingUniqueId();e&&this._conferenceJoinAnalyticsEventSent&&Mi.sendAnalytics(on("left",{meetingId:e,participantId:`${e}.${this._statsCurrentId}`,stats:{duration:Math.floor((Date.now()-this._conferenceJoinAnalyticsEventSent)/1e3),perf:this.getPerformanceStats()}}))},Jh.prototype._restartMediaSessions=function(){this.p2pJingleSession&&this._stopP2PSession({reasonDescription:"restart",requestRestart:!0}),this.jvbJingleSession&&this._stopJvbSession({reason:"success",reasonDescription:"restart required",requestRestart:!0,sendSessionTerminate:!0}),this._maybeStartOrStopP2P(!1)},Jh.prototype.isE2EEEnabled=function(){return Boolean(this._e2eEncryption&&this._e2eEncryption.isEnabled())},Jh.prototype.isE2EESupported=function(){return so.isSupported(this.options.config)},Jh.prototype.toggleE2EE=function(e){this.isE2EESupported()?this._e2eEncryption.setEnabled(e):Hh.warn("Cannot enable / disable E2EE: platform is not supported.")},Jh.prototype.setMediaEncryptionKey=function(e){this._e2eEncryption.setEncryptionKey(e)},Jh.prototype.startVerification=function(e){const t=this.getParticipantById(e);t&&this._e2eEncryption.startVerification(t)},Jh.prototype.markParticipantVerified=function(e,t){const n=this.getParticipantById(e);n&&this._e2eEncryption.markParticipantVerified(n,t)},Jh.prototype.isLobbySupported=function(){return Boolean(this.room&&this.room.getLobby().isSupported())},Jh.prototype.isMembersOnly=function(){return Boolean(this.room&&this.room.membersOnlyEnabled)},Jh.prototype.isVisitorsSupported=function(){return Boolean(this.room&&this.room.visitorsSupported)},Jh.prototype.enableLobby=function(){return this.room&&this.isModerator()?this.room.getLobby().enable():Promise.reject(new Error("The conference not started or user is not moderator"))},Jh.prototype.disableLobby=function(){this.room&&this.isModerator()?this.room.getLobby().disable():Hh.warn(`Failed to disable lobby, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator"}`)},Jh.prototype.joinLobby=function(e,t){return this.room?this.room.getLobby().join(e,t):Promise.reject(new Error("The conference not started"))},Jh.prototype.myLobbyUserId=function(){if(this.room)return this.room.getLobby().getLocalId()},Jh.prototype.sendLobbyMessage=function(e,t){if(this.room)return t?this.room.getLobby().sendPrivateMessage(t,e):this.room.getLobby().sendMessage(e)},Jh.prototype.addLobbyMessageListener=function(e){if(this.room)return this.room.getLobby().addMessageListener(e)},Jh.prototype.removeLobbyMessageHandler=function(e){if(this.room)return this.room.getLobby().removeMessageHandler(e)},Jh.prototype.lobbyDenyAccess=function(e){this.room&&this.room.getLobby().denyAccess(e)},Jh.prototype.lobbyApproveAccess=function(e){this.room&&this.room.getLobby().approveAccess(e)},Jh.prototype.isAVModerationSupported=function(){return Boolean(this.room&&this.room.getAVModeration().isSupported())},Jh.prototype.enableAVModeration=function(e){this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)?this.room.getAVModeration().enable(!0,e):Hh.warn(`Failed to enable AV moderation, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.disableAVModeration=function(e){this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)?this.room.getAVModeration().enable(!1,e):Hh.warn(`Failed to disable AV moderation, ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.avModerationApprove=function(e,t){if(this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)){const n=this.getParticipantById(t);if(!n)return;this.room.getAVModeration().approve(e,n.getJid())}else Hh.warn(`AV moderation approve skipped , ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.avModerationReject=function(e,t){if(this.room&&this.isModerator()&&(e===Ri.AUDIO||e===Ri.VIDEO)){const n=this.getParticipantById(t);if(!n)return;this.room.getAVModeration().reject(e,n.getJid())}else Hh.warn(`AV moderation reject skipped , ${this.room?"":"not in a room, "}${this.isModerator()?"":"participant is not a moderator, "}${this.room&&this.isModerator()?"wrong media type passed":""}`)},Jh.prototype.getBreakoutRooms=function(){var e;return null===(e=this.room)||void 0===e?void 0:e.getBreakoutRooms()},Jh.prototype.getMetadataHandler=function(){var e;return null===(e=this.room)||void 0===e?void 0:e.getMetadataHandler()},Bh.prototype.connect=function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this.xmpp.moderator.targetUrl&&!this.options.disableFocus&&e.name?this.xmpp.moderator.sendConferenceRequest(this.xmpp.getRoomJid(e.name)).then((()=>{this.xmpp.connect(e.id,e.password)})):this.xmpp.connect(e.id,e.password)},Bh.prototype.attach=function(e){this.xmpp.attach(e)},Bh.prototype.disconnect=function(){return this.xmpp.disconnect(...arguments)},Bh.prototype.getJid=function(){return this.xmpp.getJid()},Bh.prototype.setToken=function(e){this.token=e},Bh.prototype.initJitsiConference=function(e,t){return new Jh({name:e,config:t,connection:this})},Bh.prototype.addEventListener=function(e,t){this.xmpp.addListener(e,t)},Bh.prototype.removeEventListener=function(e,t){this.xmpp.removeListener(e,t)},Bh.prototype.getConnectionTimes=function(){return this.xmpp.connectionTimes},Bh.prototype.addFeature=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.xmpp.caps.addFeature(e,t,!0)},Bh.prototype.removeFeature=function(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];this.xmpp.caps.removeFeature(e,t,!0)},Bh.prototype.getLogs=function(){const e=this.xmpp.getJingleLog(),t={};t.time=new Date,t.url=window.location.href,t.ua=navigator.userAgent;const n=this.xmpp.getXmppLog();return n&&(t.xmpp=n),e.metadata=t,e},function(e){e.DEVICE_LIST_CHANGED="mediaDevices.devicechange",e.PERMISSIONS_CHANGED="rtc.permissions_changed",e.PERMISSION_PROMPT_IS_SHOWN="mediaDevices.permissionPromptIsShown",e.SLOW_GET_USER_MEDIA="mediaDevices.slowGetUserMedia"}(qh||(qh={}));const Gh=qh.DEVICE_LIST_CHANGED,zh=qh.PERMISSIONS_CHANGED,Kh=qh.PERMISSION_PROMPT_IS_SHOWN,Wh=qh.SLOW_GET_USER_MEDIA,Xh="microphone",Yh="camera",Qh=new class extends xr{constructor(){super(),this._permissions={},pl.addListener(ji.default.DEVICE_LIST_CHANGED,(e=>this.eventEmitter.emit(Gh,e))),pl.addListener(ji.default.PERMISSIONS_CHANGED,(e=>this._handlePermissionsChange(e))),this._permissionsApiSupported=new Promise((e=>{if(!navigator.permissions)return void e(!1);const t=this,n=[];n.push(navigator.permissions.query({name:Yh}).then((e=>(this._handlePermissionsChange({[Ri.VIDEO]:this._parsePermissionState(e)}),e.onchange=function(){try{t._handlePermissionsChange({[Ri.VIDEO]:t._parsePermissionState(this)})}catch(e){}},!0))).catch((()=>!1))),n.push(navigator.permissions.query({name:Xh}).then((e=>(this._handlePermissionsChange({[Ri.AUDIO]:this._parsePermissionState(e)}),e.onchange=function(){try{t._handlePermissionsChange({[Ri.AUDIO]:t._parsePermissionState(this)})}catch(e){}},!0))).catch((()=>!1))),Promise.all(n).then((t=>e(t.every((e=>e)))))}))}_parsePermissionState(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const t=e.state||e.status;if("string"!=typeof t)throw new TypeError;return"granted"===t}_handlePermissionsChange(e){[Ri.AUDIO,Ri.VIDEO].some((t=>t in e&&e[t]!==this._permissions[t]))&&(this._permissions={...this._permissions,...e},this.eventEmitter.emit(zh,this._permissions),(this._permissions[Ri.AUDIO]||this._permissions[Ri.VIDEO])&&this.enumerateDevices((()=>{})))}enumerateDevices(e){pl.enumerateDevices(e)}isDeviceListAvailable(){return pl.isDeviceListAvailable()}isDeviceChangeAvailable(e){return pl.isDeviceChangeAvailable(e)}isDevicePermissionGranted(e){return new Promise((t=>{e in this._permissions?t(this._permissions[e]):this._permissionsApiSupported.then((n=>{if(!n)return void t(!1);const i=[];switch(e){case Ri.VIDEO:i.push(navigator.permissions.query({name:Yh}));break;case Ri.AUDIO:i.push(navigator.permissions.query({name:Xh}));break;default:i.push(navigator.permissions.query({name:Yh})),i.push(navigator.permissions.query({name:Xh}))}Promise.all(i).then((e=>t(e.every((e=>{try{return this._parsePermissionState(e)}catch{return!1}})))),(()=>t(!1)))}))}))}isMultipleAudioInputSupported(){return!(ci.isFirefox()&&ci.isVersionLessThan("101")||ci.isIosBrowser())}getAudioOutputDevice(){return pl.getAudioOutputDevice()}setAudioOutputDevice(e){return pl.setAudioOutputDevice(e)}},Zh=(0,y.getLogger)("modules/detection/ActiveDeviceDetector.js");function eu(e){for(const t of e)t.stopStream()}const tu=(0,y.getLogger)("modules/proxyconnection/CustomSignalingLayer.js");class nu extends Ac{constructor(){super(),this.ssrcOwners=new Map,this.chatRoom=null}getPeerMediaInfo(e,t,n){return{}}getPeerSourceInfo(e,t){}getSSRCOwner(e){return this.ssrcOwners.get(e)}getTrackSourceName(e){}removeSSRCOwners(e){if(null!=e&&e.length)for(const t of e)this.ssrcOwners.delete(t)}setChatRoom(e){this.chatRoom=e}setSSRCOwner(e,t){if("number"!=typeof e)throw new TypeError(`SSRC(${e}) must be a number`);const n=this.ssrcOwners.get(e);n&&n!==t&&tu.error(`SSRC owner re-assigned from ${n} to ${t}`),this.ssrcOwners.set(e,t)}setTrackMuteStatus(e,t){return!1}setTrackVideoType(e,t){return!1}updateSsrcOwnersOnLeave(e){const t=Array.from(this.ssrcOwners).filter((t=>t[1]===e)).map((e=>e[0]));null!=t&&t.length&&this.removeSSRCOwners(t)}}let iu;!function(e){e.ACCEPT="session-accept",e.CONNECTION_ERROR="connection-error-encountered",e.INITIATE="session-initiate",e.TERMINATE="session-terminate",e.TRANSPORT_INFO="transport-info",e.UNAVAILABLE="unavailable"}(iu||(iu={}));const ru=(0,y.getLogger)("modules/proxyconnection/ProxyConnectionPC.js");class ou{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};this._options={pcConfig:{},isInitiator:!1,receiveAudio:!1,receiveVideo:!1,...e},this._tracks=[],this._peerConnection=null,this._onError=this._onError.bind(this),this._onRemoteStream=this._onRemoteStream.bind(this),this._onSendMessage=this._onSendMessage.bind(this)}getPeerJid(){return this._options.peerJid}processMessage(e){switch(e.attr("action")){case iu.ACCEPT:this._onSessionAccept(e);break;case iu.INITIATE:this._onSessionInitiate(e);break;case iu.TERMINATE:this._onSessionTerminate(e);break;case iu.TRANSPORT_INFO:this._onTransportInfo(e)}}start(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];this._peerConnection||(this._tracks=this._tracks.concat(e),this._peerConnection=this._createPeerConnection(),this._peerConnection.invite(e))}stop(){this._peerConnection&&this._peerConnection.terminate(),this._onSessionTerminate()}_createPeerConnection(){const e={connected:!0,jingle:{terminate:()=>{}},sendIQ:this._onSendMessage,addEventListener:()=>()=>{},addCancellableListener:()=>()=>{}},t={iceServers:Ra,...this._options.pcConfig},n={addEventListener:()=>{},addPresenceListener:()=>{},connectionTimes:[],eventEmitter:{emit:e=>{switch(e){case Hi.XMPPEvents.CONNECTION_ICE_FAILED:case Hi.XMPPEvents.CONNECTION_FAILED:this._onError(iu.CONNECTION_ERROR,e)}}},removeEventListener:()=>{},removePresenceListener:()=>{},supportsRestartByTerminate:()=>!1};this._rtc=new pl({myUserId:()=>""},{}),this._rtc.addListener(ji.default.REMOTE_TRACK_ADDED,this._onRemoteStream);const i=new ua(void 0,void 0,this._options.peerJid,e,{offerToReceiveAudio:this._options.receiveAudio,offerToReceiveVideo:this._options.receiveVideo},t,!0,this._options.isInitiator),r=new nu;return r.setChatRoom(n),i.initialize(n,this._rtc,r,{}),i}_onError(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";this._options.onError(this._options.peerJid,e,t)}_onRemoteStream(e){this._tracks.push(e),this._options.onRemoteStream(e)}_onSendMessage(e,t){this._options.onSendMessage(this._options.peerJid,e),t&&setTimeout(t,250)}_onSessionAccept(e){this._peerConnection?this._peerConnection.setAnswer(e):ru.error("Received an answer when no peer connection exists.")}_onSessionInitiate(e){this._peerConnection?ru.error("Received an offer when an offer was already sent."):(this._peerConnection=this._createPeerConnection(),this._peerConnection.acceptOffer(e,(()=>{}),(()=>this._onError(this._options.peerJid,iu.CONNECTION_ERROR,"session initiate error")),[]))}_onSessionTerminate(){this._tracks.forEach((e=>e.dispose())),this._tracks=[],this._peerConnection&&this._peerConnection.onTerminated(),this._rtc&&(this._rtc.removeListener(ji.default.REMOTE_TRACK_ADDED,this._onRemoteStream),this._rtc.destroy())}_onTransportInfo(e){this._peerConnection.addIceCandidates(e)}}const su=(0,y.getLogger)("modules/proxyconnection/ProxyConnectionService.js");var au=n(549),du=n.n(au);const cu=(0,y.getLogger)("modules/webaudio/AudioMixer.js");class lu{constructor(){this._started=!1,this._streamsToMix=[],this._streamMSSArray=[]}addMediaStream(e){e.getAudioTracks()||cu.warn("Added MediaStream doesn\'t contain audio tracks."),this._streamsToMix.push(e)}start(){if(this._started)return this._mixedMSD.stream;if(this._audioContext=Nl(),!this._streamsToMix.length)return cu.warn("No MediaStream\'s added to AudioMixer, nothing will happen."),null;this._started=!0,this._mixedMSD=this._audioContext.createMediaStreamDestination();for(const e of this._streamsToMix){const t=this._audioContext.createMediaStreamSource(e);t.connect(this._mixedMSD),this._streamMSSArray.push(t)}return this._mixedMSD.stream}reset(){this._started=!1,this._streamsToMix=[];for(const e of this._streamMSSArray)e.disconnect();this._streamMSSArray=[],this._audioContext&&(this._audioContext=void 0)}}const hu=S().getLogger("JitsiMeetJS.ts");let uu=!1;function pu(e){const t={};return t.audio_requested=e.devices.includes("audio"),t.video_requested=e.devices.includes("video"),t.screen_sharing_requested=e.devices.includes("desktop"),t.video_requested&&(t.resolution=e.resolution),t}const mu={version:"09993fc8",JitsiConnection:Bh,ProxyConnectionService:class{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{jitsiConnection:t,...n}=e;this._options={pcConfig:t&&t.xmpp.connection.jingle.p2pIceConfig,...n},this._peerConnection=null,this._onFatalError=this._onFatalError.bind(this),this._onSendMessage=this._onSendMessage.bind(this),this._onRemoteStream=this._onRemoteStream.bind(this)}processMessage(e){const t=e.from;if(!t)return;if(this._peerConnection&&this._peerConnection.getPeerJid()!==t)return void this._onFatalError(t,iu.CONNECTION_ERROR,"rejected");const n=this._convertStringToXML(e.data.iq),i=n&&n.find("jingle"),r=i&&i.attr("action");r===iu.INITIATE&&(this._peerConnection=this._createPeerConnection(t,{isInitiator:!1,receiveVideo:!0})),this._peerConnection&&this._peerConnection.processMessage(i),r!==iu.CONNECTION_ERROR&&r!==iu.UNAVAILABLE&&r!==iu.TERMINATE||this._selfCloseConnection()}start(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[];this._peerConnection=this._createPeerConnection(e,{isInitiator:!0,receiveVideo:!1}),t.forEach(((e,t)=>{const n=Cc("peer",e.getType(),t);e.setSourceName(n)})),this._peerConnection.start(t)}stop(){this._peerConnection&&this._peerConnection.stop(),this._peerConnection=null}_convertStringToXML(e){try{const t=(new DOMParser).parseFromString(e,"text/xml");return _t()(t)}catch(e){return su.error("Attempted to convert incorrectly formatted xml"),null}}_createPeerConnection(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};if(!e)throw new Error("Cannot create ProxyConnectionPC without a peer.");const n={pcConfig:this._options.pcConfig,onError:this._onFatalError,onRemoteStream:this._onRemoteStream,onSendMessage:this._onSendMessage,peerJid:e,...t};return new ou(n)}_onFatalError(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:"";su.error("Received a proxy connection error",e,t,n);const i=(0,St.$iq)({to:e,type:"set"}).c("jingle",{xmlns:"urn:xmpp:jingle:1",action:t}).c("details").t(n).up();this._onSendMessage(e,i),this._peerConnection&&this._peerConnection.getPeerJid()===e&&this._selfCloseConnection()}_onRemoteStream(e){if(!this._options.onRemoteStream)return su.error("Remote track received without callback."),void e.dispose();const t=e.isVideoTrack();let n;t&&(n=this._options.convertVideoToDesktop?Qo.VideoType.DESKTOP:Qo.VideoType.CAMERA);const i=e.getOriginalStream(),r=pl.createLocalTracks([{deviceId:`proxy:${this._peerConnection.getPeerJid()}`,mediaType:t?Ri.VIDEO:Ri.AUDIO,sourceType:"proxy",stream:i,track:i.getVideoTracks()[0],videoType:n}]);this._options.onRemoteStream(r[0])}_onSendMessage(e,t){if(this._options.onSendMessage)try{const n=(new XMLSerializer).serializeToString(t.nodeTree||t);this._options.onSendMessage(e,{iq:n})}catch(e){su.error("Attempted to send an incorrectly formatted iq.")}}_selfCloseConnection(){this.stop(),this._options.onConnectionClosed&&this._options.onConnectionClosed()}},constants:{recording:{error:{BUSY:"busy",ERROR:"error",RESOURCE_CONSTRAINT:"resource-constraint",UNEXPECTED_REQUEST:"unexpected-request",SERVICE_UNAVAILABLE:"service-unavailable"},mode:{FILE:"file",STREAM:"stream"},status:{OFF:"off",ON:"on",PENDING:"pending"}},sipVideoGW:_,transcriptionStatus:l,trackStreamingStatus:Jc},events:{conference:r,connection:d,detection:f,track:o,mediaDevices:E,connectionQuality:g,e2eping:v,rtcstats:s},errors:{conference:i,connection:c,track:a},errorTypes:{JitsiTrackError:dr},logLevels:S().levels,mediaDevices:Qh,analytics:Mi.analytics,init(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return S().setLogLevel(S().levels.INFO),hu.info(`This appears to be ${ci.getName()}, ver: ${ci.getVersion()}`),$o.init(e.externalStorage),Mi.init(e),window.connectionTimes||(window.connectionTimes={}),!0!==e.enableAnalyticsLogging&&(hu.warn("Analytics disabled, disposing."),this.analytics.dispose()),pl.init(e)},isDesktopSharingEnabled:()=>pl.isDesktopSharingEnabled(),isWebRtcSupported:()=>pl.isWebRtcSupported(),setLogLevel(e){S().setLogLevel(e)},rtcstats:{sendIdentityEntry(e){si.sendIdentity(e)},sendStatsEntry(e,t){si.sendStatsEntry(e,null,t)},on(e,t){si.events.on(e,t)}},setLogLevelById(e,t){S().setLogLevelById(e,t)},addGlobalLogTransport(e){S().addGlobalTransport(e)},removeGlobalLogTransport(e){S().removeGlobalTransport(e)},setGlobalLogOptions(e){S().setGlobalOptions(e)},createLocalTracks(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=!1;const{firePermissionPromptIsShownEvent:n,fireSlowPromiseEvent:i,...r}=e;n&&!pl.arePermissionsGrantedForAvailableDevices()?Qh.emit(Kh,ci.getName()):i&&window.setTimeout((()=>{t||Qh.emit(Wh)}),1e3);let o=!1,s=window.performance.now();return window.connectionTimes||(window.connectionTimes={}),uu||(uu=!0,o=!0,window.connectionTimes["firstObtainPermissions.start"]=s),window.connectionTimes["obtainPermissions.start"]=s,pl.obtainAudioAndVideoPermissions(r).then((e=>{t=!0;let n=window.performance.now();if(window.connectionTimes["obtainPermissions.end"]=n,o&&(window.connectionTimes["firstObtainPermissions.end"]=n),Mi.sendAnalytics(an("success",pu(r))),this.isCollectingLocalStats())for(let t=0;t<e.length;t++){const n=e[t];n.getType()===Ri.AUDIO&&Mi.startLocalStats(n,n.setAudioLevel.bind(n))}const i=pl.getCurrentlyAvailableMediaDevices();if(i)for(let t=0;t<e.length;t++)e[t]._setRealDeviceIdFromDeviceList(i);return e})).catch((n=>{if(t=!0,n.name===Zi)Mi.sendAnalytics(an("warning",{reason:"extension install user canceled"}));else if(n.name===Xi){const t=pu(e);t.reason="device not found",t.devices=n.gum.devices.join("."),Mi.sendAnalytics(an("error",t))}else{const t=pu(e);t.reason=n.name,Mi.sendAnalytics(an("error",t))}let i=window.performance.now();return window.connectionTimes["obtainPermissions.end"]=i,o&&(window.connectionTimes["firstObtainPermissions.end"]=i),Promise.reject(n)}))},createLocalTracksFromMediaStreams:e=>pl.createLocalTracks(e.map((e=>{const t=e.stream.getTracks().filter((t=>t.kind===e.mediaType));if(!t||0===t.length)throw new dr(or,null,null);if(t.length>1)throw new dr(rr,null,null);return e.track=t[0],e}))),createTrackVADEmitter:(e,t,n)=>Ml.create(e,t,n),createAudioMixer:()=>new lu,getActiveAudioDevice:()=>new Promise((e=>{pl.enumerateDevices((t=>{const n=t.filter((e=>"audioinput"===e.kind)),i=[];for(const e of n){const t=pl.obtainAudioAndVideoPermissions({devices:["audio"],micDeviceId:e.deviceId}).then((e=>{const t=e[0];return Mi.startLocalStats(t,t.setAudioLevel.bind(t)),t}));i.push(t)}Promise.allSettled(i).then((t=>{const n=t.filter((e=>"fulfilled"===e.status)),i=t.filter((e=>"rejected"===e.status)),r=n.map((e=>e.value)),o=i.map((e=>e.value));for(const e of o)Zh.error("Failed to acquire audio device with error: ",e);for(const t of r)t.on(Ct,(n=>{n>.008&&(eu(r),e({deviceId:t.deviceId,deviceLabel:t.track.label}))}));setTimeout((()=>{eu(r),e({deviceId:"",deviceLabel:""})}),3e3)}))}))})),isDeviceListAvailable(){return hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.isDeviceListAvailable instead"),this.mediaDevices.isDeviceListAvailable()},isDeviceChangeAvailable(e){return hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.isDeviceChangeAvailable instead"),this.mediaDevices.isDeviceChangeAvailable(e)},isMultipleAudioInputSupported(){return this.mediaDevices.isMultipleAudioInputSupported()},isCollectingLocalStats:()=>Mi.audioLevelsEnabled&&_i.isLocalStatsSupported(),enumerateDevices(e){hu.warn("This method is deprecated, use JitsiMeetJS.mediaDevices.enumerateDevices instead"),this.mediaDevices.enumerateDevices(e)},setNetworkInfo(e){let{isOnline:t}=e;xo.updateNetworkInfo({isOnline:t})},util:{ScriptUtil:du(),browser:ci}}}},__webpack_module_cache__={};function __webpack_require__(e){var t=__webpack_module_cache__[e];if(void 0!==t)return t.exports;var n=__webpack_module_cache__[e]={id:e,loaded:!1,exports:{}};return __webpack_modules__[e].call(n.exports,n,n.exports,__webpack_require__),n.loaded=!0,n.exports}__webpack_require__.amdO={},__webpack_require__.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return __webpack_require__.d(t,{a:t}),t},__webpack_require__.d=(e,t)=>{for(var n in t)__webpack_require__.o(t,n)&&!__webpack_require__.o(e,n)&&Object.defineProperty(e,n,{enumerable:!0,get:t[n]})},__webpack_require__.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),__webpack_require__.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),__webpack_require__.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},__webpack_require__.nmd=e=>(e.paths=[],e.children||(e.children=[]),e);var __webpack_exports__=__webpack_require__(449);return __webpack_exports__})()));\n//# sourceMappingURL=lib-jitsi-meet.min.map';
if (!window.JitsiMeetJS) {
  const d = document.createElement("script");
  d.text = ZU, document.head.appendChild(d);
}
process.env.NODE_ENV === "production" && JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
window.APP = {
  conference: {
    getConnectionState: () => {
      var d;
      return (d = window.APP.conference._room) == null ? void 0 : d.getConnectionState();
    },
    getStats: () => {
      var d, l;
      return (l = (d = window.APP.conference._room) == null ? void 0 : d.connectionQuality) == null ? void 0 : l.getStats();
    }
  }
};
JitsiMeetJS.setLogLevel(JitsiMeetJS.logLevels.ERROR);
const tt = JitsiMeetJS;
function OU(d, l) {
  if (d !== "default")
    return d;
  const u = l === "audio" ? ne.getState().audioInputDevices : ne.getState().videoInputDevices, p = u.find((R) => R.deviceId === "default");
  if (!p)
    return d;
  const g = u.find(
    (R) => R.deviceId !== "default" && R.groupId === p.groupId
  );
  return (g == null ? void 0 : g.deviceId) ?? d;
}
async function YS(d, l = null, u = null, p = {}) {
  if (Rt.getState().iAmRecorder)
    return;
  const { data: R, error: y } = await Is(
    tt.createLocalTracks({
      devices: [d],
      cameraDeviceId: l,
      micDeviceId: l,
      timeout: u,
      ...p
    })
  );
  if (y)
    throw y;
  return R[0];
}
async function Xl(d, l = null, u = hd.USER) {
  const g = ne.getState().isMobile() ? null : l, R = OU(g, d), { data: y, error: Q } = await Is(
    YS(d, R, null, {
      facingMode: u
    })
  );
  y ? (g === "default" && (y._realDeviceId = y.deviceId = "default"), nR(y)) : (d === "video" ? Gg() : d === "audio" && jg(), Q instanceof Error && Q.name === "gum.permission_denied" && Ye.publish({
    type: An.notification,
    payload: {
      type: "error",
      message: `Permission denied for ${d} track. Please allow access to your device.`
    }
  }));
}
function BU() {
  var u, p;
  if (!Rt.getState().enableCompanionMode) {
    const g = Rt.getState().audioInputDeviceId ?? ((u = ne.getState().audioInputDevice) == null ? void 0 : u.deviceId);
    Xl("audio", g);
  }
  if (Rt.getState().sessionType === jS.VIDEO) {
    const g = Rt.getState().videoInputDeviceId, R = (p = ne.getState().videoInputDevice) == null ? void 0 : p.deviceId, y = Rt.getState().initialCameraFacing, Q = ne.getState().cameraFacing;
    g ? Xl("video", g) : y ? Xl("video", null, Q) : Xl("video", R, Q);
  }
}
function wU(d) {
  ne.getState().audioInputDevices.filter((u) => u.deviceId !== "").length > 0 && Xl("audio", d);
}
function Mh(d, l = !1) {
  ne.getState().isMobileSDK() || d && ne.setState({
    audioInputDevice: d ? { ...d.toJSON(), skipSubscribe: l } : void 0
  });
}
async function v5(d, l) {
  var p;
  if (ne.getState().videoInputDevices.filter((g) => g.deviceId !== "").length > 0)
    Xl("video", d, l);
  else if (d === null) {
    const g = (p = yn(We.VIDEO)) == null ? void 0 : p.originalTrack;
    if (g) {
      await g.dispose();
      const R = rt.getState().conference;
      R && R.replaceTrack(g, null);
    }
    Xl("video", d, l);
  }
}
function kh(d, l = !1) {
  if (!ne.getState().isMobileSDK() && d) {
    const p = d.toJSON ? d.toJSON() : d;
    ne.setState({
      videoInputDevice: { ...p, skipSubscribe: l }
    });
  }
}
function XS(d) {
  tt.mediaDevices.isDeviceChangeAvailable("output") && tt.mediaDevices.setAudioOutputDevice(d).then(() => {
    const u = ne.getState().audioOutputDevices.find((p) => p.deviceId === d);
    u && ne.setState({
      audioOutputDevice: u
    });
  });
}
const AU = /* @__PURE__ */ hi({
  low: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
  standard: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
  high: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
  fullHd: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
  ultraHd: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
  ssHigh: /* @__PURE__ */ Xe(/* @__PURE__ */ _a())
}), Fg = /* @__PURE__ */ hi({
  maxBitratesVideo: /* @__PURE__ */ Xe(AU),
  scalabilityModeEnabled: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
  useSimulcast: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
  useKSVC: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa())
}), JU = /* @__PURE__ */ hi({
  codecPreferenceOrder: /* @__PURE__ */ Xe(/* @__PURE__ */ Qf(/* @__PURE__ */ Kt())),
  screenshareCodec: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  mobileScreenshareCodec: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  enableAdaptiveMode: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
  av1: /* @__PURE__ */ Xe(Fg),
  h264: /* @__PURE__ */ Xe(Fg),
  vp8: /* @__PURE__ */ Xe(Fg),
  vp9: /* @__PURE__ */ Xe(Fg),
  minHeightForQualityLvl: /* @__PURE__ */ Xe(/* @__PURE__ */ c5(/* @__PURE__ */ Kt(), /* @__PURE__ */ Kt())),
  mobileCodecPreferenceOrder: /* @__PURE__ */ Xe(/* @__PURE__ */ Qf(/* @__PURE__ */ Kt()))
}), LU = /* @__PURE__ */ hi({
  uid: /* @__PURE__ */ Kt(),
  name: /* @__PURE__ */ Kt(),
  avatar: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  status: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  role: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  lastActiveAt: /* @__PURE__ */ Xe(/* @__PURE__ */ _a())
}), IU = /* @__PURE__ */ hi({
  WEBRTC_HOST: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  ANALYTICS_HOST: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  ANALYTICS_VERSION: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  PRESENTER_MODE_ENABLED: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
  connectionConfig: /* @__PURE__ */ hi({
    audioQuality: /* @__PURE__ */ Xe(
      /* @__PURE__ */ hi({
        stereo: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa())
      })
    ),
    bridgeChannel: /* @__PURE__ */ Xe(
      /* @__PURE__ */ hi({
        preferSctp: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa())
      })
    ),
    constraints: /* @__PURE__ */ Xe(
      /* @__PURE__ */ hi({
        video: /* @__PURE__ */ Xe(
          /* @__PURE__ */ hi({
            height: /* @__PURE__ */ Xe(
              /* @__PURE__ */ hi({
                ideal: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
                max: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
                min: /* @__PURE__ */ Xe(/* @__PURE__ */ _a())
              })
            ),
            width: /* @__PURE__ */ Xe(
              /* @__PURE__ */ hi({
                ideal: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
                max: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
                min: /* @__PURE__ */ Xe(/* @__PURE__ */ _a())
              })
            )
          })
        )
      })
    ),
    e2ee: /* @__PURE__ */ Xe(/* @__PURE__ */ Qf(/* @__PURE__ */ u5())),
    e2eping: /* @__PURE__ */ Xe(
      /* @__PURE__ */ hi({
        enabled: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa())
      })
    ),
    flags: /* @__PURE__ */ Xe(
      /* @__PURE__ */ hi({
        receiveMultipleVideoStreams: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
        sendMultipleVideoStreams: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
        sourceNameSignaling: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa()),
        ssrcRewritingEnabled: /* @__PURE__ */ Xe(/* @__PURE__ */ Fa())
      })
    ),
    hosts: /* @__PURE__ */ hi({
      domain: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
      muc: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt())
    }),
    hiddenDomain: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
    bosh: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
    websocket: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
    serviceUrl: /* @__PURE__ */ Kt(),
    p2p: /* @__PURE__ */ hi({
      enabled: /* @__PURE__ */ Fa()
    }),
    resolution: /* @__PURE__ */ Xe(/* @__PURE__ */ _a()),
    videoQuality: /* @__PURE__ */ Xe(JU)
  })
}), S5 = /* @__PURE__ */ hi({
  callToken: /* @__PURE__ */ Kt(),
  settings: IU,
  sessionId: /* @__PURE__ */ Kt(),
  user: LU
}), R5 = /* @__PURE__ */ hi({
  pid: /* @__PURE__ */ Kt(),
  name: /* @__PURE__ */ Kt(),
  uid: /* @__PURE__ */ Kt(),
  // audioMuted: v.boolean(),
  // videoPaused: v.boolean(),
  avatar: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt())
});
function Ko(d, l) {
  const u = Pe.getState().getParticipantById(l);
  if (u) {
    const p = /* @__PURE__ */ zg(R5, u);
    p.success && Ye.publish({
      type: d,
      payload: p.output
    });
  }
}
function WU() {
  const d = Pe.getState().participants, l = /* @__PURE__ */ zg(
    /* @__PURE__ */ Qf(R5),
    d
  );
  l.success && Ye.publish({
    type: Vt.ParticipantEventsListner.onParticipantListChanged,
    payload: l.output
  });
}
const v3 = {
  sessionType: "VIDEO",
  autoStartRecording: !1,
  layout: ha.TILE,
  hideRecordingButton: !0,
  hideVirtualBackgroundButton: !1,
  hideAudioModeButton: !1,
  hideSwitchCameraButton: !1,
  devSessionId: "dev-session",
  iAmRecorder: !1,
  hideControlPanel: !1,
  hideHeaderPanel: !1,
  hideRaiseHandButton: !1,
  hideShareInviteButton: !0,
  hideChangeLayoutButton: !1,
  hideLeaveSessionButton: !1,
  hideToggleAudioButton: !1,
  hideParticipantListButton: !1,
  hideChatButton: !0,
  hideToggleVideoButton: !1,
  hideScreenSharingButton: !1,
  hideSessionTimer: !1,
  hideNetworkIndicator: !0,
  hideRecordingStatusIndicator: !1,
  enableParticipantContextMenu: !0,
  // lowBandwidthMode: false,
  displayName: "",
  startAudioMuted: !1,
  startVideoPaused: !1,
  title: "",
  enableNoiseReduction: !1,
  idleTimeoutPeriodBeforePrompt: 6e4,
  idleTimeoutPeriodAfterPrompt: 18e4,
  enableSpotlightDrag: !0,
  enableSpotlightSwap: !0,
  showFrameRate: !1,
  enableCompanionMode: !1
}, Rt = nu()(
  iu(
    au(v3, (d) => ({
      reset: () => d(v3)
    }))
  )
), HU = (d) => {
  Rt.setState(d);
}, zU = {
  avatar: void 0,
  isLocal: !0,
  name: "",
  pid: "local",
  ruid: "local-human",
  role: "none",
  sources: /* @__PURE__ */ new Map(),
  type: "human",
  uid: "unknown"
}, S3 = {
  dominantSpeakers: [],
  localParticipant: zU,
  participants: [],
  virtualParticipants: []
}, Pe = nu()(
  iu(
    au(S3, (d, l) => ({
      addParticipant: (u) => {
        d((p) => ({
          participants: [...p.participants, u]
        }));
      },
      addVirtualParticipant: (u) => {
        d((p) => ({
          virtualParticipants: [...p.virtualParticipants, u]
        }));
      },
      clearParticipants: () => d({ participants: [], virtualParticipants: [] }),
      removeParticipant: (u) => {
        const g = Pe.getState().participants.find((R) => R.pid === u);
        if (g) {
          Ko(
            Vt.ParticipantEventsListner.onParticipantLeft,
            g.pid
          );
          const R = Pe.getState().pinnedParticipant;
          (R == null ? void 0 : R.pid) === g.pid && Pe.getState().unpinParticipant();
        }
        d((R) => ({
          participants: R.participants.filter((y) => y.pid !== u)
        }));
      },
      removeVirtualParticipant: (u, p = "screen-share") => {
        const g = Pe.getState().pinnedParticipant;
        (g == null ? void 0 : g.pid) === u && g.type === p && Pe.getState().unpinParticipant(), d((R) => ({
          virtualParticipants: R.virtualParticipants.filter(
            (y) => !(y.pid === u && y.type === p)
          )
        }));
      },
      updateLocalParticipant: (u) => {
        d((p) => ({
          localParticipant: {
            ...p.localParticipant,
            ...u
          }
        }));
      },
      updateParticipant: (u, p) => {
        d((g) => u === g.localParticipant.pid ? {
          localParticipant: {
            ...g.localParticipant,
            ...p
          }
        } : {
          participants: g.participants.map(
            (R) => R.pid === u ? { ...R, ...p } : R
          )
        });
      },
      updateParticipantRole: (u, p) => {
        d((g) => ({
          participants: g.participants.map(
            (R) => R.pid === u ? { ...R, role: p } : R
          )
        }));
      },
      pinParticipant: (u, p) => {
        const R = E5().find(
          (y) => y.pid === u && y.type === p
        );
        R && d({ pinnedParticipant: R });
      },
      unpinParticipant: () => {
        d({ pinnedParticipant: void 0 });
      },
      getParticipantById: (u) => {
        const p = l().localParticipant;
        return u === p.pid ? p : l().participants.find((g) => g.pid === u);
      },
      reset: () => d(S3)
    }))
  )
);
function ru() {
  const d = Pe((g) => g.localParticipant), l = Pe((g) => g.participants), u = Pe(
    (g) => g.virtualParticipants
  ), p = Rt.getState().iAmRecorder;
  return re.useMemo(() => p ? [...u, ...l] : [d, ...u, ...l], [p, d, l, u]);
}
function E5() {
  const d = Pe.getState().localParticipant, l = Pe.getState().participants, u = Pe.getState().virtualParticipants;
  return [d, ...u, ...l];
}
const jU = () => {
  const d = Pe.getState().dominantSpeakers, l = Pe.getState().participants;
  Pe.setState({
    dominantSpeakers: d.filter(
      (u) => l.some((p) => p.pid === u)
    )
  });
}, U5 = (d, l) => {
  Pe.getState().pinParticipant(d, l);
}, T5 = () => {
  Pe.getState().unpinParticipant();
};
Pe.subscribe(
  (d) => d.virtualParticipants,
  (d) => {
    d && d.length > 0 ? eu(ha.SIDEBAR, !0) : ne.getState().sidebarLayoutSetProgrammatically && eu(ha.TILE);
  }
);
Pe.subscribe(
  (d) => d.participants.length,
  () => {
    jU();
  }
);
Pe.subscribe(
  (d) => d.participants.map(({ pid: l, name: u, avatar: p, uid: g }) => ({
    pid: l,
    name: u,
    avatar: p,
    uid: g
  })),
  () => {
    WU();
  },
  {
    equalityFn: PS
  }
);
Pe.subscribe(
  (d) => d.localParticipant.pid,
  (d) => {
    ft.getState().updateLocalTrack(We.AUDIO, {
      pid: d
    }), ft.getState().updateLocalTrack(We.VIDEO, {
      pid: d
    });
  }
);
Pe.subscribe(
  (d) => !!d.pinnedParticipant,
  (d) => {
    d ? ne.getState().layout === ha.TILE && eu(ha.SIDEBAR, !0) : ne.getState().sidebarLayoutSetProgrammatically && eu(ha.TILE);
  }
);
Pe.subscribe(
  (d) => d.participants.length,
  (d) => {
    d === 0 ? ne.getState().restartIdealTimeoutTimer() : ne.getState().clearIdealTimeoutTimer();
  }
);
Ye.subscribe(
  Vt.SessionStatusListener.onSessionJoined,
  () => {
    Pe.getState().participants.length === 0 && ne.getState().restartIdealTimeoutTimer();
  }
);
const KS = (d) => {
  const {
    pinnedParticipant: l,
    participants: u,
    virtualParticipants: p,
    dominantSpeakers: g,
    localParticipant: R
  } = d;
  if (l)
    return l;
  if (p.length > 0)
    return p[0];
  for (const y of g) {
    const Q = u.find((T) => T.pid === y);
    if (Q)
      return Q;
  }
  return u.length > 0 ? u[0] : R;
};
Pe.subscribe(
  (d) => d.participants.filter((l) => l.uid),
  (d, l) => {
    d.length > l.length && OS(
      d,
      l,
      (p) => p.uid
    ).forEach((p) => {
      Ko(
        Vt.ParticipantEventsListner.onParticipantJoined,
        p.pid
      );
    });
  }
);
const R3 = {
  conference: null,
  conferenceJoined: !1,
  conferenceJoinedAt: null,
  conferenceStartedAt: null,
  conferenceStatus: "initial",
  p2p: !1,
  connectionQuality: /* @__PURE__ */ new Map(),
  raiseHandMap: /* @__PURE__ */ new Map(),
  recording: {
    status: tt.constants.recording.status.OFF,
    mode: tt.constants.recording.mode.FILE
  },
  isRecording: !1
}, rt = nu()(
  iu(
    au(R3, (d) => ({
      conferenceWillJoin: (l) => {
        typeof (window == null ? void 0 : window.APP) < "u" && (window.APP.conference._room = l), d({ conference: l, conferenceStatus: "joining" });
      },
      reset: () => {
        d(R3);
      },
      raiseHand: (l, u) => {
        d((p) => ({
          raiseHandMap: new Map(p.raiseHandMap).set(
            l,
            u
          )
        })), Ko(
          Vt.ParticipantEventsListner.onParticipantHandRaised,
          l
        );
      },
      lowerHand: (l) => {
        d((u) => {
          const p = new Map(u.raiseHandMap);
          return p.delete(l), { raiseHandMap: p };
        }), Ko(
          Vt.ParticipantEventsListner.onParticipantHandLowered,
          l
        );
      },
      leaveConference: async () => {
        const l = rt.getState().conference;
        if (l) {
          const { error: u } = await Is(l.leave());
          u && Ye.publish({
            type: Vt.SessionStatusListener.onSessionLeft
          });
        }
      },
      stopRecording: async () => {
        const l = rt.getState().conference;
        if (l) {
          const u = rt.getState().recording;
          if (u.sessionId) {
            const { error: p } = await Is(
              l.stopRecording(u.sessionId)
            );
          }
        }
      }
    }))
  )
), GU = () => {
  const [d, l] = re.useState(0), u = rt(
    (p) => p.conferenceStartedAt
  );
  return re.useEffect(() => {
    const p = setInterval(() => {
      if (!u) {
        l(0);
        return;
      }
      l(Math.max(Date.now() - u, 0));
    }, 1e3);
    return () => clearInterval(p);
  }, [u]), d;
};
function y5() {
  const d = rt.getState().conference;
  if (d) {
    const l = Date.now(), u = Pe.getState().localParticipant.pid;
    d == null || d.setLocalParticipantProperty("raisedHand", l), rt.getState().raiseHand(u, l);
  }
}
function Ig() {
  const d = rt.getState().conference;
  if (d) {
    const l = Pe.getState().localParticipant.pid;
    d.setLocalParticipantProperty("raisedHand", 0), rt.getState().lowerHand(l);
  }
}
function N5() {
  const d = rt.getState().conference;
  (d == null ? void 0 : d.getLocalParticipantProperty("raisedHand")) ? Ig() : y5();
}
const b5 = () => {
  const d = rt((u) => u.isRecording);
  return !Rt((u) => u.iAmRecorder) && d;
};
rt.subscribe(
  (d) => d.recording,
  (d) => {
    const l = d.status, u = d.mode, p = d.error, g = d.initiator;
    !p && g && u === tt.constants.recording.mode.FILE && (l === tt.constants.recording.status.ON || l === tt.constants.recording.status.PENDING) ? rt.setState({ isRecording: !0 }) : rt.setState({ isRecording: !1 });
  }
);
rt.subscribe(
  (d) => d.isRecording,
  (d) => {
    var p, g;
    const l = (g = (p = rt.getState().recording.initiator) == null ? void 0 : p.getId) == null ? void 0 : g.call(p), u = Pe.getState().localParticipant.pid;
    d ? (l && l !== u ? Ko(
      Vt.ParticipantEventsListner.onParticipantStartedRecording,
      l
    ) : Ye.publish({
      type: Vt.MediaEventsListener.onRecordingStarted
    }), Ye.publish({
      type: An.notification,
      payload: {
        type: "info",
        // TODO: Localize this message
        message: "The session is being recorded"
      }
    })) : (l && l !== u ? Ko(
      Vt.ParticipantEventsListner.onParticipantStoppedRecording,
      l
    ) : Ye.publish({
      type: Vt.MediaEventsListener.onRecordingStopped
    }), Ye.publish({
      type: An.notification,
      payload: {
        type: "info",
        // TODO: Localize this message
        message: "Recording has been stopped"
      }
    }));
  }
);
async function V5() {
  const d = rt.getState().conference;
  if (d) {
    const { data: l, error: u } = await Is(
      d.startRecording({
        mode: tt.constants.recording.mode.FILE,
        appData: JSON.stringify({
          startedAt: Date.now()
        })
      })
    );
  }
}
async function PU() {
  rt.getState().stopRecording();
}
async function YU() {
  rt.getState().isRecording ? await PU() : await V5();
}
const XU = () => {
  const d = rt.getState().conferenceStatus;
  return d === "joined" || d === "restored";
};
rt.subscribe(
  (d) => d.conference,
  (d) => {
    if (d) {
      const l = Pe.getState().localParticipant;
      d == null || d.sendCommand(h5.userInfo, {
        value: JSON.stringify(l)
      });
    }
  }
);
const E3 = {
  tracks: [],
  permissions: {
    audio: !1,
    video: !1,
    initialized: !1
  }
}, ft = nu()(
  iu(
    au(E3, (d, l) => ({
      reset: () => d({
        ...E3,
        // Preserve permissions across resets - they're queried once at SDK init
        // and shouldn't be lost when joining/leaving sessions
        permissions: l().permissions
      }),
      addTrack: (u) => d((p) => {
        const g = u.isLocal(), R = (() => {
          var Q;
          return u.getParticipantId() ? u.getParticipantId() : g ? (Q = Pe.getState().localParticipant) == null ? void 0 : Q.pid : u.getId();
        })(), y = {
          local: g,
          mediaType: ZS(u),
          pid: R,
          videoType: u.getVideoType(),
          muted: u.isMuted() ? 1 : 0,
          originalTrack: u
        };
        return {
          tracks: [...p.tracks, y]
        };
      }),
      removeTrack: (u) => d((p) => ({
        tracks: p.tracks.filter(
          (g) => g.originalTrack !== u
        )
      })),
      updateTrack: (u, p) => d((g) => ({
        tracks: g.tracks.map(
          (R) => R.originalTrack === u ? {
            ...R,
            mediaType: R.mediaType ?? ZS(u),
            videoType: R.videoType ?? u.getVideoType(),
            ...p
          } : R
        )
      })),
      updateLocalTrack: (u, p) => d((g) => {
        const R = g.tracks.find(
          (y) => y.local && y.mediaType === u
        );
        if (!R) {
          const y = Pe.getState().localParticipant;
          return {
            tracks: [
              ...g.tracks,
              {
                local: !0,
                mediaType: u,
                pid: y.pid,
                videoType: u === We.SCREENSHARE ? "desktop" : u === We.VIDEO ? "camera" : null,
                muted: p.muted ?? 0,
                ...p
              }
            ]
          };
        }
        return {
          tracks: g.tracks.map(
            (y) => y === R ? {
              ...y,
              ...p,
              mediaType: u,
              videoType: u === We.SCREENSHARE ? "desktop" : u === We.VIDEO ? "camera" : null
            } : y
          )
        };
      })
    }))
  )
), qS = (d, l = We.VIDEO) => {
  const u = ft((g) => g.tracks);
  return re.useMemo(
    () => u.find((g) => g.pid === d && g.mediaType === l),
    [u, d, l]
  );
}, KU = (d = We.VIDEO) => {
  const l = ft((u) => u.tracks);
  return re.useMemo(
    () => l.find((u) => u.local && u.mediaType === d),
    [l, d]
  );
}, yn = (d = We.VIDEO) => ft.getState().tracks.find((u) => u.local && u.mediaType === d), qU = async () => {
  const d = ft.getState().tracks.filter((p) => p.local), l = [];
  for (const { originalTrack: p } of d)
    p && p.disposed !== !0 && l.push(Is(p.dispose()));
  const u = await Promise.all(l);
  for (const { error: p } of u)
    p && console.error("Error disposing track:", p);
}, jg = () => {
  ft.getState().updateLocalTrack(We.AUDIO, {
    muted: 1
  });
}, C5 = async () => {
  let d = yn(We.AUDIO);
  const l = ft.getState().permissions, u = ne.getState().isMobileSDK();
  if (!l.audio && l.initialized && !u) {
    Ye.publish({
      type: An.notification,
      payload: {
        type: "error",
        message: "Permission denied for audio track. Please allow access to your device."
      }
    }), Ye.publish({
      type: An.queryPermission
    });
    return;
  }
  d != null && d.originalTrack || (await Xl("audio"), d = yn(We.AUDIO)), d != null && d.originalTrack && ft.getState().updateLocalTrack(We.AUDIO, {
    muted: 0
  });
}, $U = () => {
  var l;
  ((l = yn(We.AUDIO)) == null ? void 0 : l.muted) ? C5() : jg();
}, Gg = (d = GS.USER) => {
  var u;
  const l = (((u = yn(We.VIDEO)) == null ? void 0 : u.muted) || 0) | d;
  ft.getState().updateLocalTrack(We.VIDEO, {
    muted: l
  });
}, F5 = async (d = GS.USER) => {
  let l = yn(We.VIDEO);
  const u = ft.getState().permissions, p = ne.getState().isMobileSDK();
  if (!u.video && u.initialized && !p) {
    Ye.publish({
      type: An.notification,
      payload: {
        type: "error",
        message: "Permission denied for video track. Please allow access to your device."
      }
    }), Ye.publish({
      type: An.queryPermission
    });
    return;
  }
  if (l != null && l.originalTrack || (await Xl(We.VIDEO), l = yn(We.VIDEO)), !(l != null && l.originalTrack))
    return;
  const g = l.muted & ~d;
  ft.getState().updateLocalTrack(We.VIDEO, {
    muted: g
  });
}, eT = () => {
  var l;
  ((l = yn(We.VIDEO)) == null ? void 0 : l.muted) ? F5() : Gg();
};
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.AUDIO && u.local)) == null ? void 0 : l.muted;
  },
  (d, l) => {
    var p;
    const u = (p = yn(We.AUDIO)) == null ? void 0 : p.originalTrack;
    d && u ? u.mute() : u && u.unmute(), typeof d == "number" && typeof l == "number" && Ye.publish({
      type: d ? Vt.MediaEventsListener.onAudioMuted : Vt.MediaEventsListener.onAudioUnMuted
    });
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.VIDEO && u.local)) == null ? void 0 : l.muted;
  },
  (d, l) => {
    var p;
    const u = (p = yn(We.VIDEO)) == null ? void 0 : p.originalTrack;
    d && u ? u.mute() : u && u.unmute(), typeof d == "number" && typeof l == "number" && Ye.publish({
      type: d ? Vt.MediaEventsListener.onVideoPaused : Vt.MediaEventsListener.onVideoResumed
    });
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.SCREENSHARE && u.local)) == null ? void 0 : l.muted;
  },
  (d) => {
    var u;
    const l = (u = yn(We.SCREENSHARE)) == null ? void 0 : u.originalTrack;
    d && l && l.mute();
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.AUDIO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d) => {
    var l;
    d && (((l = yn(We.AUDIO)) == null ? void 0 : l.muted) ? d.mute() : d.unmute());
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.VIDEO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d) => {
    var l;
    d && (((l = yn(We.VIDEO)) == null ? void 0 : l.muted) ? d.mute() : d.unmute());
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.AUDIO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d, l) => {
    const u = rt.getState().conference;
    if (u && (l && d ? u.replaceTrack(l, d) : d && u.addTrack(d)), d) {
      const p = d.getDeviceId(), g = ne.getState().audioInputDevices.find((R) => R.deviceId === p);
      Mh(g, !0);
    }
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.VIDEO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d, l) => {
    const u = rt.getState().conference;
    if (u && (l && d ? u.replaceTrack(l, d) : d && u.addTrack(d)), d) {
      const p = d.getDeviceId(), g = ne.getState().videoInputDevices.find((R) => R.deviceId === p);
      kh(g, !0);
    }
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.SCREENSHARE && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d, l) => {
    const u = rt.getState().conference;
    u && (l && d ? u.replaceTrack(l, d).then(() => {
      l.removeAllListeners(), l.dispose();
    }) : d && u.addTrack(d));
  }
);
ft.subscribe(
  (d) => d.tracks.filter((l) => l.mediaType === We.SCREENSHARE && !l.muted).length,
  () => {
    const d = ft.getState().tracks.filter((g) => g.mediaType === We.SCREENSHARE && !g.muted), l = Pe.getState().virtualParticipants.filter((g) => g.type === "screen-share"), u = OS(
      d,
      l,
      (g) => g.pid
    );
    OS(
      l,
      d,
      (g) => g.pid
    ).forEach((g) => {
      AT(g.pid);
    }), u.forEach((g) => wT(g.originalTrack));
  }
);
ft.subscribe(
  (d) => d.permissions,
  (d, l) => {
    const u = rt.getState().conferenceStatus;
    u !== "joined" && u !== "restored" || (d.audio === !1 && l.audio === !0 && (Ye.publish({
      type: An.notification,
      payload: {
        type: "error",
        message: "Permission denied for audio track. Please allow access to your device."
      }
    }), jg()), d.video === !1 && l.video === !0 && (Ye.publish({
      type: An.notification,
      payload: {
        type: "error",
        message: "Permission denied for video track. Please allow access to your device."
      }
    }), Gg()));
  }
);
ft.subscribe(
  (d) => d.permissions.audio || d.permissions.video,
  (d) => {
    d && O5();
  }
);
ft.subscribe(
  (d) => d.tracks.filter((l) => l.mediaType === We.AUDIO && !l.local).map((l) => ({
    muted: l.muted,
    pid: l.pid
  })),
  (d, l) => {
    l.forEach((u) => {
      const p = d.find((g) => g.pid === u.pid);
      p && p.muted !== u.muted && Ko(
        p.muted ? Vt.ParticipantEventsListner.onParticipantAudioMuted : Vt.ParticipantEventsListner.onParticipantAudioUnmuted,
        p.pid
      );
    });
  },
  {
    equalityFn: PS
  }
);
ft.subscribe(
  (d) => d.tracks.filter((l) => l.mediaType === We.VIDEO && !l.local).map((l) => ({
    muted: l.muted,
    pid: l.pid
  })),
  (d, l) => {
    l.forEach((u) => {
      const p = d.find((g) => g.pid === u.pid);
      p && p.muted !== u.muted && Ko(
        p.muted ? Vt.ParticipantEventsListner.onParticipantVideoPaused : Vt.ParticipantEventsListner.onParticipantVideoResumed,
        p.pid
      );
    });
  },
  {
    equalityFn: PS
  }
);
function U3(d) {
  if (HU(d), d.layout && eu(d.layout), d.internalSettings, typeof d.internalSettings == "string") {
    const l = m5(
      d.internalSettings
    );
    if (!(l != null && l.data))
      return;
    const u = /* @__PURE__ */ zg(
      S5,
      l.data
    );
    u.success ? (Pe.getState().updateLocalParticipant({
      name: u.output.user.name,
      avatar: u.output.user.avatar,
      uid: u.output.user.uid
    }), Rt.setState({
      sessionId: u.output.sessionId
    }), ua.setState({
      jwt: u.output.callToken
    }), ua.setState({
      connectionConfig: u.output.settings.connectionConfig
    })) : console.error("Invalid internal setting data:", u.issues);
  }
  d.devSessionId && Rt.setState({
    sessionId: d.devSessionId
  }), d.initialCameraFacing && ne.setState({
    cameraFacing: d.initialCameraFacing === Lg.REAR ? hd.ENVIRONMENT : hd.USER
  }), d.displayName && Pe.getState().updateLocalParticipant({
    name: d.displayName,
    avatar: void 0
  }), typeof d.startAudioMuted == "boolean" && ft.getState().updateLocalTrack(We.AUDIO, {
    muted: d.startAudioMuted ? 1 : 0
  }), typeof d.startVideoPaused == "boolean" && ft.getState().updateLocalTrack(We.VIDEO, {
    muted: d.startVideoPaused ? GS.USER : 0
  }), typeof d.enableNoiseReduction == "boolean" && ne.setState({
    enableNoiseReduction: d.enableNoiseReduction
  });
}
const T3 = {
  audioModeMenuVisible: !1,
  audioModes: [],
  audioInputDevices: [],
  audioOutputDevices: [],
  videoInputDevices: [],
  cameraFacing: hd.USER,
  isPIPLayoutEnabled: !1,
  layout: ha.TILE,
  sidebarLayoutSetProgrammatically: !1,
  mainAreaDimension: {
    height: 0,
    width: 0
  },
  tileDimensions: {
    tileHeight: 0,
    tileWidth: 0
  },
  callContainerDimension: {
    height: 0,
    width: 0
  },
  moreMenuVisible: !1,
  participantListVisible: !1,
  subscriptions: [],
  connectionRetryCount: 0,
  settingsDialogVisible: !1,
  virtualBackgroundDialogVisible: !1,
  idleTimeoutModalVisible: !1,
  mirrorLocalVideo: !0,
  isDesktopSharingEnabled: !1,
  isBlurSupported: !1,
  desktopSharingFrameRate: 5,
  chatButtonUnreadCount: 0,
  enableNoiseReduction: !0,
  sdkPlatform: FU.WEB,
  webOSName: "unknown",
  isMobileBrowser: !1,
  visibleParticipants: {
    startIndex: 0,
    endIndex: 0
  }
}, ne = nu()(
  iu(
    CU(
      au(T3, (d, l) => ({
        addSubscriptions: (u) => {
          ne.setState((p) => ({
            subscriptions: [...p.subscriptions, ...u]
          }));
        },
        reset: () => d((u) => ({
          ...T3,
          // Preserve persisted properties
          audioInputDevice: u.audioInputDevice,
          audioOutputDevice: u.audioOutputDevice,
          videoInputDevice: u.videoInputDevice,
          enableNoiseReduction: u.enableNoiseReduction,
          isMobileBrowser: u.isMobileBrowser
        })),
        toggleMoreMenuVisible: () => d((u) => ({
          moreMenuVisible: !u.moreMenuVisible
        })),
        toggleParticipantListVisible: () => d((u) => ({
          participantListVisible: !u.participantListVisible
        })),
        incrementConnectionRetryCount: () => d((u) => ({
          connectionRetryCount: u.connectionRetryCount + 1
        })),
        isMobileSDK: () => l().sdkPlatform === "android" || l().sdkPlatform === "ios",
        isMobile: () => {
          const u = l().sdkPlatform === "android" || l().sdkPlatform === "ios", p = l().isMobileBrowser;
          return u || p;
        },
        clearIdealTimeoutTimer: () => {
          const u = l().idealTimeoutTimer;
          u && (clearTimeout(u), d({
            idealTimeoutTimer: void 0,
            idleTimeoutModalVisible: !1
          }));
        },
        restartIdealTimeoutTimer: () => {
          if (ne.getState().clearIdealTimeoutTimer(), Rt.getState().iAmRecorder || Pe.getState().participants.length > 0 || !XU())
            return;
          const R = Rt.getState().idleTimeoutPeriodBeforePrompt, y = setTimeout(() => {
            d({
              idleTimeoutModalVisible: !0
            });
          }, R);
          d({ idealTimeoutTimer: y });
        }
      })),
      {
        name: "base-store",
        partialize: (d) => ({
          audioInputDevice: d.audioInputDevice,
          audioOutputDevice: d.audioOutputDevice,
          videoInputDevice: d.videoInputDevice,
          enableNoiseReduction: d.enableNoiseReduction
        })
      }
    )
  )
), $S = ne.getState().toggleParticipantListVisible, tT = () => ne.setState({ participantListVisible: !1 });
ne.getState().toggleMoreMenuVisible;
const eu = (d, l = !1) => {
  d !== ha.SIDEBAR && Pe.setState({ pinnedParticipant: void 0 }), ne.setState({ layout: d, sidebarLayoutSetProgrammatically: l });
}, nT = () => ne.setState({ isPIPLayoutEnabled: !0 }), iT = () => ne.setState({ isPIPLayoutEnabled: !1 }), aT = () => {
  ne.setState({ settingsDialogVisible: !0 });
}, rT = () => {
  ne.setState({ settingsDialogVisible: !1 });
}, y3 = () => {
  ne.setState((d) => ({
    settingsDialogVisible: !d.settingsDialogVisible
  }));
}, _5 = () => {
  ne.setState({
    virtualBackgroundDialogVisible: !0,
    participantListVisible: !1
  });
}, Mf = () => {
  ne.setState({ virtualBackgroundDialogVisible: !1 });
}, oT = () => {
  ne.setState((d) => ({
    mirrorLocalVideo: !d.mirrorLocalVideo
  }));
}, sT = () => {
  ne.setState((d) => ({
    enableNoiseReduction: !d.enableNoiseReduction
  }));
}, lT = (d) => {
  ne.setState({ chatButtonUnreadCount: d });
}, cT = () => ne.getState().layout;
function dT() {
  const d = [], l = ne.subscribe(
    (V) => V.audioModes,
    (V) => {
      if (V.length > 0) {
        const N = V.find((b) => b.selected) ?? V[0];
        ne.setState({
          selectedAudioModeType: N.type
        });
      }
    }
  );
  d.push(l);
  const u = ne.subscribe(
    (V) => V.selectedAudioModeType,
    (V) => {
      V && Ye.publish({
        payload: V,
        type: Vh.MediaEventsListener.onAudioModeChanged
      });
    }
  );
  d.push(u);
  const p = ne.subscribe(
    (V) => V.layout,
    (V) => {
      Ye.publish({
        payload: V,
        type: Vt.CallLayoutListener.onCallLayoutChanged
      });
    }
  );
  d.push(p);
  const g = ne.subscribe(
    (V) => V.participantListVisible,
    (V) => {
      V ? Ye.publish({
        type: Vh.CallLayoutListener.onParticipantListVisible
      }) : Ye.publish({
        type: Vh.CallLayoutListener.onParticipantListHidden
      });
    }
  );
  d.push(g);
  const R = ne.subscribe(
    (V) => V.isPIPLayoutEnabled,
    (V) => {
      V ? Ye.publish({
        type: Vh.CallLayoutListener.onPictureInPictureLayoutEnabled
      }) : Ye.publish({
        type: Vh.CallLayoutListener.onPictureInPictureLayoutDisabled
      });
    }
  );
  d.push(R);
  const y = ne.subscribe(
    (V) => V.cameraFacing,
    (V) => {
      var b;
      Ye.publish({
        payload: V === hd.USER ? Lg.FRONT : Lg.REAR,
        type: Vh.MediaEventsListener.onCameraFacingChanged
      });
      const N = (b = yn(We.VIDEO)) == null ? void 0 : b.originalTrack;
      N && N.getCameraFacingMode() !== V && (ne.getState().isMobileBrowser ? v5(null, V) : N._switchCamera());
    }
  );
  d.push(y);
  const Q = ne.subscribe(
    (V) => V.audioInputDevices,
    (V) => {
      if (V.length > 0) {
        const N = ne.getState().audioInputDevice;
        N ? V.some(
          (A) => A.deviceId === N.deviceId && A.label === N.label
        ) || Mh(Ch(V)) : Mh(
          Ch(V),
          !0
        );
      }
    }
  );
  d.push(Q);
  const T = ne.subscribe(
    (V) => V.audioOutputDevices,
    (V) => {
      if (V.length > 0) {
        const N = ne.getState().audioOutputDevice;
        N ? V.some(
          (A) => A.deviceId === N.deviceId && A.label === N.label
        ) || ne.setState({
          audioOutputDevice: Ch(V)
        }) : ne.setState({
          audioOutputDevice: Ch(V)
        });
      }
    }
  );
  d.push(T);
  const k = ne.subscribe(
    (V) => V.videoInputDevices,
    (V) => {
      if (V.length > 0) {
        const N = ne.getState().videoInputDevice;
        N ? V.some(
          (A) => A.deviceId === N.deviceId && A.label === N.label
        ) || kh(Ch(V)) : kh(
          Ch(V),
          !0
        );
      }
    }
  );
  d.push(k), ne.subscribe(
    (V) => V.previewVideoTrack,
    (V, N) => {
      N && N.disposed !== !0 && N.dispose();
    }
  ), ne.getState().addSubscriptions(d);
}
dT();
const TS = {
  connection: void 0,
  connectionStatus: "initial",
  error: void 0,
  timeEstablished: void 0
}, ua = nu()(
  iu(
    au(TS, (d) => ({
      connectionEstablished: (l) => d({
        connection: l,
        connectionStatus: "connected",
        error: void 0,
        timeEstablished: Date.now()
      }),
      connectionFailed: (l) => d({
        connectionStatus: "error",
        error: l,
        timeEstablished: void 0
      }),
      connectionWillConnect: (l) => {
        typeof (window == null ? void 0 : window.APP) < "u" && (window.APP.connection = l), l.addFeature("http://jitsi.org/protocol/jibri"), d({
          connection: l,
          connectionStatus: "connecting",
          error: void 0,
          timeEstablished: void 0
        });
      },
      disconnect: async () => {
        const l = ua.getState().connection, u = ua.getState().connectionStatus;
        l && u !== "disconnecting" && (d({
          connectionStatus: "disconnecting"
        }), Ye.publish({
          type: An.connectionWillClose
        }), Ye.stopEmitting(), await Is(l.disconnect()), Ye.publish(
          {
            type: Vt.SessionStatusListener.onConnectionClosed
          },
          !0
        ), d(TS));
      },
      reset: () => d(TS)
    }))
  )
), uT = () => {
  const d = Rt(
    (u) => u.hideToggleAudioButton
  ), l = Rt(
    (u) => u.enableCompanionMode
  );
  return d || l;
}, hT = () => {
  const d = Rt(
    (u) => u.hideToggleVideoButton
  ), l = Rt((u) => u.sessionType);
  return d || l !== jS.VIDEO;
}, M5 = () => {
  const d = rt((l) => l.conferenceStatus);
  return d === "joined" || d === "restored";
}, k5 = () => {
  const d = Rt(
    (R) => R.hideScreenSharingButton
  ), l = ne((R) => R.sdkPlatform === "android"), u = ne(
    (R) => R.isDesktopSharingEnabled
  ), p = M5(), g = ne.getState().isMobileSDK();
  return d || g || !p || (l ? !1 : !u);
}, mT = () => Rt((l) => l.hideChatButton), Of = (d) => Pe(
  (l) => l.localParticipant
), pT = () => {
  const d = KU(We.SCREENSHARE);
  return (d == null ? void 0 : d.originalTrack) && !d.muted;
}, ou = (d, l) => {
  const u = Of(), p = qS(
    l ?? u.pid,
    d
  );
  return p ? !!p.muted : !0;
}, Q5 = () => {
  const d = Pe(
    (R) => R.pinnedParticipant
  ), l = Pe((R) => R.participants), u = Pe(
    (R) => R.virtualParticipants
  ), p = Pe((R) => R.dominantSpeakers), g = Of();
  return KS({
    pinnedParticipant: d,
    participants: l,
    virtualParticipants: u,
    dominantSpeakers: p,
    localParticipant: g
  });
}, N3 = () => {
  const d = Pe.getState();
  return KS({
    pinnedParticipant: d.pinnedParticipant,
    participants: d.participants,
    virtualParticipants: d.virtualParticipants,
    dominantSpeakers: d.dominantSpeakers,
    localParticipant: d.localParticipant
  });
}, fT = () => {
  const d = ua((p) => p.connectionStatus), l = rt((p) => p.conferenceStatus);
  return d === "connected" && l === "interrupted";
}, gT = () => {
  const d = Rt(
    (p) => p.hideRecordingButton
  ), l = M5(), u = Of();
  return d || !l || u.role !== "moderator";
}, vT = () => {
  const d = Rt(
    (p) => p.hideVirtualBackgroundButton
  ), l = yn(We.VIDEO), u = ne((p) => p.isBlurSupported);
  return d || !(l != null && l.originalTrack) || !u;
}, Pg = () => ne((l) => l.layout), ST = () => {
  const d = Rt(
    (g) => g.enableParticipantContextMenu
  ), l = ne((g) => g.isPIPLayoutEnabled);
  return Pg() === ha.SPOTLIGHT || l ? !1 : d;
}, Yg = (d, l = "human") => {
  const u = Of(), p = rt(
    (g) => g.raiseHandMap.get(d ?? u.pid)
  );
  return l === "human" ? p : void 0;
}, D5 = (d, l) => {
  const u = Pe(
    (p) => p.pinnedParticipant
  );
  return !!(u && u.pid === d && u.type === l);
}, RT = () => {
  const d = ru(), l = rt((p) => p.raiseHandMap);
  return d.sort((p, g) => {
    const R = l.get(p.pid), y = l.get(g.pid);
    return R && !y ? -1 : !R && y ? 1 : p.name.localeCompare(g.name);
  });
}, ET = () => {
  const d = rt((u) => u.conferenceError), l = ua((u) => u.error);
  return d || l;
}, UT = () => {
  const d = ne((u) => u.isMobileBrowser), l = yn(We.VIDEO);
  return d && (l == null ? void 0 : l.originalTrack);
}, TT = () => {
  const d = ft((p) => p.permissions.audio), l = ne((p) => p.audioInputDevices);
  return d && l.length > 0;
}, yT = () => {
  const d = ft((p) => p.permissions.video), l = ne((p) => p.videoInputDevices);
  return d && l.length > 0;
}, x5 = () => {
  ne.setState((d) => ({
    cameraFacing: d.cameraFacing === hd.USER ? hd.ENVIRONMENT : hd.USER
  }));
};
function NT(d) {
  return d <= _h.LOW ? _h.LOW : d <= _h.STANDARD ? _h.STANDARD : _h.HIGH;
}
function bT() {
  var p, g;
  const d = {
    constraints: {},
    defaultConstraints: { maxHeight: _h.NONE },
    lastN: -1,
    onStageSources: [],
    selectedSources: []
  }, l = cT();
  if (l === "SPOTLIGHT") {
    const R = (p = N3().sources) == null ? void 0 : p.get("video");
    R && Array.from(R.keys()).forEach((y) => {
      d.constraints[y] = {
        maxHeight: 720
      }, d.onStageSources.push(y);
    });
  } else if (l === "TILE") {
    const R = NT(
      ne.getState().tileDimensions.tileHeight
    ), y = ne.getState().visibleParticipants;
    E5().slice(
      y.startIndex,
      y.endIndex + 1
    ).forEach((T) => {
      var N;
      const k = T.isLocal, V = (N = T.sources) == null ? void 0 : N.get("video");
      !k && V && Array.from(V.keys()).forEach((b) => {
        d.constraints[b] = {
          maxHeight: R
        };
      });
    });
  } else if (l === "SIDEBAR") {
    Pe.getState().participants.forEach((T) => {
      var V;
      const k = (V = T.sources) == null ? void 0 : V.get("video");
      k && Array.from(k.keys()).forEach((N) => {
        d.constraints[N] = {
          maxHeight: 180
        };
      });
    });
    const Q = (g = N3().sources) == null ? void 0 : g.get("video");
    Q && Array.from(Q.keys()).forEach((T) => {
      d.constraints[T] = {
        maxHeight: 720
      }, d.onStageSources.push(T);
    });
  }
  const u = rt.getState().conference;
  u && Object.keys(d.constraints).length > 0 && u.setReceiverConstraints(d);
}
const Xg = g5(
  bT,
  200
);
ne.subscribe(
  (d) => d.visibleParticipants,
  () => {
    Xg();
  }
);
ne.subscribe(
  (d) => d.layout,
  () => {
    Xg();
  }
);
Pe.subscribe(
  (d) => KS(d).pid,
  () => {
    const d = ne.getState().layout;
    (d === "SPOTLIGHT" || d === "SIDEBAR") && Xg();
  }
);
const VT = 0.2;
class CT {
  onConferenceJoined() {
    rt.setState({
      conferenceJoined: !0,
      conferenceStatus: "joined",
      conferenceJoinedAt: Date.now()
    }), Ye.publish({
      type: Vt.SessionStatusListener.onSessionJoined
    }), Ye.publish({
      type: An.onSessionJoined
    }), Rt.getState().autoStartRecording && setTimeout(() => {
      V5();
    }, 500);
  }
  async onConferenceLeft() {
    rt.setState({
      conferenceJoined: !1,
      conferenceStatus: "left"
    }), Ye.publish({
      type: Vt.SessionStatusListener.onSessionLeft
    }), await ua.getState().disconnect();
  }
  onTrackAdded(l) {
    l.isLocal() || nR(l);
  }
  onUserJoined(l, u) {
    const p = u.getId(), g = u.getDisplayName(), R = u.getRole();
    u.isHidden() || (Ye.publish({
      type: An.notification,
      payload: {
        type: "info",
        message: `${g} has joined the conference`
      }
    }), Pe.getState().addParticipant({
      name: g ?? "Unknown",
      pid: p,
      ruid: `${p}-human`,
      role: R,
      isLocal: !1,
      sources: u.getSources(),
      type: "human"
    }));
  }
  onUserLeft(l, u) {
    if (u.isHidden())
      return;
    const p = u.getId();
    Ye.publish({
      type: An.notification,
      payload: {
        type: "info",
        message: `${u.getDisplayName()} has left the conference`
      }
    }), Pe.getState().removeParticipant(p);
  }
  onTrackRemoved(l) {
    if (l.isLocal()) {
      const u = yn(l.getType());
      (u == null ? void 0 : u.originalTrack) === l && ft.getState().updateLocalTrack(l.getType(), {
        originalTrack: void 0
      });
    } else
      ft.getState().removeTrack(l);
    l.removeAllListeners(tt.events.track.TRACK_MUTE_CHANGED), l.removeAllListeners(tt.events.track.TRACK_VIDEOTYPE_CHANGED), l.removeAllListeners(tt.events.track.NO_DATA_FROM_SOURCE);
  }
  onConferenceJoinInProgress() {
  }
  onConferenceFailed(l, u, p) {
    console.error("Conference failed:", u, p), rt.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: (p == null ? void 0 : p.toString()) || "Unknown error"
    });
  }
  onRecorderStateChanged(l) {
    if (l.getStatus(), l) {
      const u = l.getID();
      if (u) {
        const p = l.getStatus(), g = l.getMode(), R = l.getError(), y = l.getInitiator();
        rt.setState({
          recording: {
            status: p,
            mode: g,
            error: R,
            sessionId: u,
            initiator: y
          }
        });
        const Q = rt.getState().conference, T = Pe.getState().localParticipant;
        Q.sendCommandOnce("START_SCREEN_RECORDING", {
          attributes: {
            recordId: u,
            ...T,
            id: T.pid
          }
        });
      }
    }
  }
  onConnectionEstablished() {
    rt.setState({
      conferenceStatus: "joined"
    });
  }
  onConnectionInterrupted() {
    rt.setState({
      conferenceStatus: "interrupted"
    });
  }
  onConnectionRestored() {
    rt.setState({
      conferenceStatus: "restored"
    });
  }
  onP2PStatus(l, u) {
    rt.setState({
      p2p: u
    });
  }
  onTrackMuteChanged(l, u) {
    if (u) {
      ft.getState().updateTrack(l, {
        muted: l.isMuted() ? 1 : 0
      });
      const p = u.getDisplayName();
      p && Ye.publish({
        type: An.notification,
        payload: {
          type: "info",
          message: `${p} has muted you.`
        }
      });
    }
  }
  onParticipantSourceUpdated(l) {
    Xg();
  }
  onConferenceCreatedTimestamp(l) {
    rt.setState({
      conferenceStartedAt: l
    });
  }
  onDominantSpeakerChanged(l, u, p) {
    Pe.setState({
      dominantSpeakers: [l, ...u ?? []]
    }), Ko(
      Vt.ParticipantEventsListner.onDominantSpeakerChanged,
      l
    );
    const g = Pe.getState().localParticipant;
    l === g.pid && Ig();
  }
  onLocalStatsUpdated(l) {
    const u = Pe.getState().localParticipant;
    l.connectionQuality && rt.setState((p) => {
      const g = new Map(p.connectionQuality);
      return g.set(u.pid, l.connectionQuality), { connectionQuality: g };
    });
  }
  onRemoteStatsUpdated(l, u) {
    u.connectionQuality && rt.setState((p) => {
      const g = new Map(p.connectionQuality);
      return g.set(l, u.connectionQuality), { connectionQuality: g };
    });
  }
  onParticipantPropertyChanged(l, u, p, g) {
    const R = l.getId();
    R && u === "raisedHand" && (g ? rt.getState().raiseHand(R, parseInt(g, 10)) : rt.getState().lowerHand(R));
  }
  onUserRoleChanged(l, u) {
    typeof l == "string" && (u === xS.MODERATOR || u === xS.NONE) && Pe.getState().updateParticipant(l, {
      role: u
    });
  }
  onTalkWhileMuted() {
  }
  onConferenceError(l) {
    console.error("Conference error:", l), l instanceof Error ? rt.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: l.message
    }) : rt.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: l.toString()
    });
  }
  onTrackAudioLevelChanged(l, u) {
    const p = Pe.getState().localParticipant;
    if (l !== p.pid)
      return;
    const g = yn(We.AUDIO);
    if (g != null && g.muted)
      return;
    rt.getState().raiseHandMap.has(p.pid) && u > VT && Ig();
  }
}
const Hn = new CT(), FT = /* @__PURE__ */ hi({
  name: /* @__PURE__ */ Kt(),
  pid: /* @__PURE__ */ Kt(),
  ruid: /* @__PURE__ */ Kt(),
  role: /* @__PURE__ */ l5(Object.values(xS)),
  uid: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  avatar: /* @__PURE__ */ Xe(/* @__PURE__ */ Kt()),
  isLocal: /* @__PURE__ */ Fa(),
  sources: /* @__PURE__ */ Xe(
    /* @__PURE__ */ QS(
      /* @__PURE__ */ d5([/* @__PURE__ */ Zg("video"), /* @__PURE__ */ Zg("audio")]),
      /* @__PURE__ */ QS(/* @__PURE__ */ Kt(), /* @__PURE__ */ s5())
    )
  ),
  type: /* @__PURE__ */ Zg("human")
}), _T = /* @__PURE__ */ gU(FT, [
  "avatar",
  "uid"
]);
function MT(d) {
  d.on(
    tt.events.conference.USER_JOINED,
    Hn.onUserJoined
  ), d.on(
    tt.events.conference.USER_LEFT,
    Hn.onUserLeft
  ), d.on(
    tt.events.conference.TRACK_ADDED,
    Hn.onTrackAdded
  ), d.on(
    tt.events.conference.TRACK_REMOVED,
    Hn.onTrackRemoved
  ), d.on(
    tt.events.conference.CONFERENCE_JOIN_IN_PROGRESS,
    Hn.onConferenceJoinInProgress
  ), d.on(
    tt.events.conference.CONFERENCE_FAILED,
    Hn.onConferenceFailed
  ), d.on(
    tt.events.conference.RECORDER_STATE_CHANGED,
    Hn.onRecorderStateChanged
  ), d.on(
    tt.events.conference.CONNECTION_ESTABLISHED,
    Hn.onConnectionEstablished
  ), d.on(
    tt.events.conference.CONNECTION_INTERRUPTED,
    Hn.onConnectionInterrupted
  ), d.on(
    tt.events.conference.CONNECTION_RESTORED,
    Hn.onConnectionRestored
  ), d.on(
    tt.events.conference.P2P_STATUS,
    Hn.onP2PStatus
  ), d.on(
    tt.events.conference.TRACK_MUTE_CHANGED,
    Hn.onTrackMuteChanged
  ), d.on(
    tt.events.conference.CONFERENCE_JOINED,
    Hn.onConferenceJoined
  ), d.on(
    tt.events.conference.CONFERENCE_LEFT,
    Hn.onConferenceLeft
  ), d.on(
    tt.events.conference.PARTICIPANT_SOURCE_UPDATED,
    Hn.onParticipantSourceUpdated
  ), d.on(
    tt.events.conference.CONFERENCE_CREATED_TIMESTAMP,
    Hn.onConferenceCreatedTimestamp
  ), d.on(
    tt.events.conference.DOMINANT_SPEAKER_CHANGED,
    Hn.onDominantSpeakerChanged
  ), d.on(
    tt.events.connectionQuality.LOCAL_STATS_UPDATED,
    Hn.onLocalStatsUpdated
  ), d.on(
    tt.events.connectionQuality.REMOTE_STATS_UPDATED,
    Hn.onRemoteStatsUpdated
  ), d.on(
    tt.events.conference.PARTICIPANT_PROPERTY_CHANGED,
    Hn.onParticipantPropertyChanged
  ), d.on(
    tt.events.conference.USER_ROLE_CHANGED,
    Hn.onUserRoleChanged
  ), d.on(
    tt.events.conference.TALK_WHILE_MUTED,
    Hn.onTalkWhileMuted
  ), d.on(
    tt.events.conference.TRACK_AUDIO_LEVEL_CHANGED,
    Hn.onTrackAudioLevelChanged
  ), d.addCommandListener(
    h5.userInfo,
    (l, u) => {
      const p = /* @__PURE__ */ zg(
        _T,
        m5(l.value)
      );
      p.success && Pe.getState().updateParticipant(u, {
        avatar: p.output.avatar,
        uid: p.output.uid
      });
    }
  );
}
async function kT(d, l) {
  var Q, T;
  if (!d)
    throw new Error("No connection available");
  if (rt.getState().conference)
    return;
  const p = ua.getState().connectionConfig, g = d.initJitsiConference(l, p), R = (Q = yn(We.AUDIO)) == null ? void 0 : Q.originalTrack, y = (T = yn(We.VIDEO)) == null ? void 0 : T.originalTrack;
  R && g.addTrack(R), y && g.addTrack(y), Pe.getState().updateLocalParticipant({
    pid: g.myUserId()
  }), MT(g), rt.getState().conferenceWillJoin(g), g.setDisplayName(
    Pe.getState().localParticipant.name
  ), g.join();
}
function Z5(d) {
  const l = rt.getState().conference;
  l == null || l.muteParticipant(d, "audio");
}
function QT(d) {
  const l = rt.getState().conference;
  l == null || l.muteParticipant(d, "video");
}
function DT(d) {
  const l = ua.getState().connectionConfig, u = ua.getState().jwt, p = Rt.getState().iAmRecorder;
  l && p && (l.p2p = {
    enabled: !1
  });
  const g = new tt.JitsiConnection(null, u, l);
  ua.getState().connectionWillConnect(g), g.addEventListener(
    tt.events.connection.CONNECTION_ESTABLISHED,
    R
  ), g.addEventListener(
    tt.events.connection.CONNECTION_FAILED,
    y
  ), g.addEventListener(
    tt.events.connection.CONNECTION_DISCONNECTED,
    Q
  ), g.addEventListener(
    tt.events.connection.PROPERTIES_UPDATED,
    T
  );
  async function R() {
    ua.getState().connectionEstablished(g), Ye.publish({
      type: An.onConnectionEstablished
    });
    const b = await Is(kT(g, d));
    b.error && (console.error("Error creating conference", b.error), rt.setState({
      conferenceStatus: "error",
      conferenceJoined: !1,
      conferenceError: b.error.message
    }));
  }
  function y(b, A, ...Ne) {
    k(), console.error("Connection failed", b, A, Ne), ua.getState().connectionFailed(A);
  }
  function Q() {
  }
  function T(b) {
  }
  function k() {
    g.removeEventListener(
      tt.events.connection.PROPERTIES_UPDATED,
      T
    ), g.removeEventListener(
      tt.events.connection.CONNECTION_FAILED,
      y
    ), g.removeEventListener(
      tt.events.connection.CONNECTION_DISCONNECTED,
      Q
    );
  }
  const V = localStorage.getItem("xmpp_username_override"), N = localStorage.getItem("xmpp_password_override");
  V && N ? (g.addFeature("http://jitsi.org/protocol/jibri"), g.connect({
    id: V,
    password: N
  })) : g.connect();
}
function xT(d) {
  let l = !1, u;
  return function(...p) {
    return l || (l = !0, u = d.apply(this, p)), u;
  };
}
function ZT(d = [], l = []) {
  if (d.length !== l.length)
    return !0;
  for (let u of d)
    if (!l.find(
      ({ deviceId: g, groupId: R, kind: y, label: Q }) => u.deviceId === g && u.groupId === R && u.kind === y && u.label === Q
    ))
      return !0;
  return !1;
}
function OT() {
  const d = ne.getState().audioInputDevices, l = ne.getState().videoInputDevices, u = [...d, ...l], p = Rt.getState().sessionType;
  return !!u.filter((g) => g.kind === "audioinput" || p === "VIDEO").some((g) => g.label === "");
}
function BS(d = !1) {
  if (d && OT())
    return;
  const { mediaDevices: l } = tt;
  l.isDeviceChangeAvailable() && l.enumerateDevices((u) => {
    const p = u.filter(
      (y) => y.kind === "audioinput" && y.deviceId !== ""
    ), g = u.filter(
      (y) => y.kind === "audiooutput" && y.deviceId !== ""
    ), R = u.filter(
      (y) => y.kind === "videoinput" && y.deviceId !== ""
    );
    ne.setState({
      audioInputDevices: p,
      audioOutputDevices: g,
      videoInputDevices: R
    });
  });
}
function BT() {
  const { mediaDevices: d } = tt;
  d.addEventListener(
    tt.events.mediaDevices.DEVICE_LIST_CHANGED,
    (l) => {
      const u = ne.getState().audioInputDevices, p = ne.getState().audioOutputDevices, g = ne.getState().videoInputDevices, R = u.concat(
        p,
        g
      );
      setTimeout(() => {
        ZT(R, l) && BS();
      }, 0);
    }
  ), BS();
}
const O5 = xT(BT);
function eR() {
  const d = ne.getState().desktopSharingFrameRate;
  tt.createLocalTracks({
    devices: ["desktop"],
    desktopSharingFrameRate: d
  }).then((l) => {
    const u = l.find(
      (g) => g.getType() === "video"
    ), p = l.find(
      (g) => g.getType() === "audio"
    );
    p && p.dispose(), u && nR(u);
  }).catch((l) => {
    console.error("Error starting screen share:", l);
  });
}
function tR() {
  ft.getState().updateLocalTrack(We.SCREENSHARE, {
    muted: 1
  });
}
function wT(d) {
  if (!d || d.isMuted())
    return;
  const l = Pe.getState().participants, u = Pe.getState().localParticipant, p = d.isLocal() ? u : l.find((g) => g.pid === d.getParticipantId());
  if (!p) {
    console.error("Participant not found:", d.getParticipantId());
    return;
  }
  Pe.getState().addVirtualParticipant({
    ...p,
    type: "screen-share",
    name: p.name,
    ruid: `${p.pid}-screen-share`
  }), Pe.getState().pinParticipant(p.pid, "screen-share"), d.isLocal() ? Ye.publish({
    type: Vt.MediaEventsListener.onScreenShareStarted
  }) : Ko(
    Vt.ParticipantEventsListner.onParticipantStartedScreenShare,
    p.pid
  );
}
function AT(d) {
  Pe.getState().removeVirtualParticipant(d, "screen-share"), Pe.getState().localParticipant.pid === d ? Ye.publish({
    type: Vt.MediaEventsListener.onScreenShareStopped
  }) : Ko(
    Vt.ParticipantEventsListner.onParticipantStoppedScreenShare,
    d
  );
}
function B5() {
  ne.getState().reset(), rt.getState().reset(), Rt.getState().reset(), ua.getState().reset(), Pe.getState().reset(), ft.getState().reset();
}
class JT {
  constructor() {
    P(this, "lock", Promise.resolve());
  }
  /**
   * Runs the provided function exclusively, ensuring
   * only one runs at a time in order of requests.
   */
  async run(l) {
    let u;
    const p = new Promise((R) => {
      u = R;
    }), g = this.lock;
    this.lock = g.then(() => p), await g;
    try {
      return await l();
    } finally {
      u();
    }
  }
}
function LT() {
  tt.init();
}
let Wg = !1;
function IT() {
  var p;
  const d = Rt.getState().sessionId;
  if (!d) {
    console.error("Session ID is required to start a session");
    return;
  }
  if (Wg)
    return;
  Wg = !0, LT(), BU();
  const l = Rt.getState().audioOutputDeviceId ?? ((p = ne.getState().audioOutputDevice) == null ? void 0 : p.deviceId);
  l && XS(l), Ye.startEmitting();
  const u = f5(() => DT(d));
  if (u.error) {
    console.error("Error connecting to session:", u.error), ua.getState().connectionFailed(u.error.message);
    return;
  }
  O5();
}
async function WT() {
  Wg !== !1 && (Wg = !1, await Promise.all([
    qU(),
    rt.getState().leaveConference()
  ]), await ua.getState().disconnect());
}
const HT = new JT();
function Kg() {
  return HT.run(async () => {
    ne.getState().clearIdealTimeoutTimer(), await WT(), B5();
  });
}
async function zT() {
  Ye.publish({
    type: "onSessionTimedOut"
  }), await Kg();
}
function nR(d) {
  var l;
  if (d.isLocal()) {
    BS(!0);
    const u = (l = yn(d.getType())) == null ? void 0 : l.muted;
    ft.getState().updateLocalTrack(ZS(d), {
      originalTrack: d,
      ...d.getVideoType() === "desktop" ? {
        muted: 0
      } : typeof u == "boolean" ? { muted: u } : {}
    }), d.on(tt.events.track.LOCAL_TRACK_STOPPED, (p) => {
      p.getVideoType() === "desktop" && tR();
    });
  } else
    ft.getState().addTrack(d);
  d.removeAllListeners(tt.events.track.TRACK_MUTE_CHANGED), d.removeAllListeners(tt.events.track.TRACK_VIDEOTYPE_CHANGED), d.on(tt.events.track.TRACK_MUTE_CHANGED, (u) => {
    u.isLocal() || ft.getState().updateTrack(u, {
      muted: u.isMuted() ? 1 : 0
    });
  }), d.on(
    tt.events.track.TRACK_VIDEOTYPE_CHANGED,
    (u) => {
      ft.getState().updateTrack(d, {
        videoType: u,
        mediaType: u === "desktop" ? "screenshare" : "video"
      });
    }
  );
}
const jT = { layouts: { tileView: "Tile View", sideLayout: "Side Layout", spotlight: "Spotlight" } }, GT = { audioControl: { muteMicrophone: "Mute microphone", unmuteMicrophone: "Unmute microphone", audioDeviceOptions: "Audio device options", audioSettings: "Audio settings" }, videoControl: { turnOffCamera: "Turn off camera", turnOnCamera: "Turn on camera", videoDeviceOptions: "Video device options", videoSettings: "Video settings" }, settingsDialog: { todo: "// TODO: Revisit this section", title: "Settings", tabs: { audio: "Audio", video: "Video" }, deviceLabels: { microphone: "Microphone", speaker: "Speaker", camera: "Camera", frameRate: "Desktop sharing frame rate" }, deviceStates: { noMicrophoneSelected: "No microphone selected", noSpeakerSelected: "No speaker selected", noCameraSelected: "No camera selected" }, audioSettings: { enableNoiseReduction: "Enable noise reduction" }, videoSettings: { mirrorMyVideo: "Mirror my video", selectCameraToSeePreview: "Select a camera to see preview", loadingCameraPreview: "Loading camera preview...", frameRateUnit: "frames per second", frameRateNotice: "You need to restart the screen share for the new settings to take effect." }, permissions: { errorTitle: "Some permissions are missing", microphoneBlocked: "Access to your microphone is blocked. Please check your browser settings.", cameraBlocked: "Access to your camera is blocked. Please check your browser settings.", microphoneAndCameraBlocked: "Access to your microphone and camera is blocked. Please check your browser settings." }, buttons: { cancel: "Cancel", done: "Done" } }, recording: { startRecording: "Start recording", stopRecording: "Stop recording", startRecordingConfirmation: "Recording will capture video, audio, and screen sharing from this call.", stopRecordingConfirmation: "Stopping will end the recording of video, audio, and screen sharing from this call.", cancel: "Cancel" }, raiseHand: "Raise hand", lowerHand: "Lower hand", startScreenSharing: "Start screen sharing", stopScreenSharing: "Stop screen sharing", moreOptions: "More options", leaveSession: "Leave session", reactions: "Reactions" }, PT = { title: "Are you still there?", subtitle: "You are the only one here, so this call will end in less than {minutes} minute{plural}. Do you want to stay in this call?", buttons: { stayInCall: "Stay in the call", leaveNow: "Leave now" } }, YT = { header: { title: "Participants", closeButton: "Close participants list" }, search: { placeholder: "Search Participant" }, emptyState: { title: "No participants found", subtitle: "No participants match your search" } }, XT = { title: "Virtual Background", addBackground: "Add Background", noCameraFeed: "No camera feed detected", buttons: { cancel: "Cancel", done: "Done" } }, KT = { error: "Something went wrong, please try again." }, qT = {}, $T = {
  header: jT,
  controlPanel: GT,
  idealTimeout: PT,
  participantList: YT,
  virtualBackground: XT,
  general: KT,
  other: qT
}, b3 = {
  translations: {
    "en-US": $T
  },
  currentLocale: "en-US"
}, ey = nu(
  iu(
    au(b3, (d) => ({
      reset: () => d(b3),
      setLocale: (l) => d(() => ({
        currentLocale: l
      }))
    }))
  )
);
function ty(d, l) {
  const u = l.split(".");
  let p = d;
  for (const g of u) {
    if (p == null || typeof p != "object")
      return "";
    p = p[g];
  }
  return p;
}
const fo = () => {
  const { translations: d, currentLocale: l } = ey();
  return {
    t: (p) => ty(d, `${l}.${p}`),
    currentLocale: l,
    translations: d
  };
};
var Yl;
// @__NO_SIDE_EFFECTS__
function w5(d) {
  return {
    lang: (d == null ? void 0 : d.lang) ?? (Yl == null ? void 0 : Yl.lang),
    message: d == null ? void 0 : d.message,
    abortEarly: (d == null ? void 0 : d.abortEarly) ?? (Yl == null ? void 0 : Yl.abortEarly),
    abortPipeEarly: (d == null ? void 0 : d.abortPipeEarly) ?? (Yl == null ? void 0 : Yl.abortPipeEarly)
  };
}
var yS;
// @__NO_SIDE_EFFECTS__
function ny(d) {
  return yS == null ? void 0 : yS.get(d);
}
var NS;
// @__NO_SIDE_EFFECTS__
function iy(d) {
  return NS == null ? void 0 : NS.get(d);
}
var bS;
// @__NO_SIDE_EFFECTS__
function ay(d, l) {
  var u;
  return (u = bS == null ? void 0 : bS.get(d)) == null ? void 0 : u.get(l);
}
// @__NO_SIDE_EFFECTS__
function A5(d) {
  var u, p;
  const l = typeof d;
  return l === "string" ? `"${d}"` : l === "number" || l === "bigint" || l === "boolean" ? `${d}` : l === "object" || l === "function" ? (d && ((p = (u = Object.getPrototypeOf(d)) == null ? void 0 : u.constructor) == null ? void 0 : p.name)) ?? "null" : l;
}
function tu(d, l, u, p, g) {
  const R = g && "input" in g ? g.input : u.value, y = (g == null ? void 0 : g.expected) ?? d.expects ?? null, Q = (g == null ? void 0 : g.received) ?? /* @__PURE__ */ A5(R), T = {
    kind: d.kind,
    type: d.type,
    input: R,
    expected: y,
    received: Q,
    message: `Invalid ${l}: ${y ? `Expected ${y} but r` : "R"}eceived ${Q}`,
    requirement: d.requirement,
    path: g == null ? void 0 : g.path,
    issues: g == null ? void 0 : g.issues,
    lang: p.lang,
    abortEarly: p.abortEarly,
    abortPipeEarly: p.abortPipeEarly
  }, k = d.kind === "schema", V = (g == null ? void 0 : g.message) ?? d.message ?? /* @__PURE__ */ ay(d.reference, T.lang) ?? (k ? /* @__PURE__ */ iy(T.lang) : null) ?? p.message ?? /* @__PURE__ */ ny(T.lang);
  V !== void 0 && (T.message = typeof V == "function" ? (
    // @ts-expect-error
    V(T)
  ) : V), k && (u.typed = !1), u.issues ? u.issues.push(T) : u.issues = [T];
}
// @__NO_SIDE_EFFECTS__
function pd(d) {
  return {
    version: 1,
    vendor: "valibot",
    validate(l) {
      return d["~run"]({ value: l }, /* @__PURE__ */ w5());
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ry(d, l) {
  return Object.hasOwn(d, l) && l !== "__proto__" && l !== "prototype" && l !== "constructor";
}
// @__NO_SIDE_EFFECTS__
function oy(d, l) {
  const u = [...new Set(d)];
  return u.length > 1 ? `(${u.join(` ${l} `)})` : u[0] ?? "never";
}
// @__NO_SIDE_EFFECTS__
function J5(d) {
  return {
    kind: "transformation",
    type: "transform",
    reference: J5,
    async: !1,
    operation: d,
    "~run"(l) {
      return l.value = this.operation(l.value), l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function sy(d, l, u) {
  return typeof d.fallback == "function" ? (
    // @ts-expect-error
    d.fallback(l, u)
  ) : (
    // @ts-expect-error
    d.fallback
  );
}
// @__NO_SIDE_EFFECTS__
function L5(d, l, u) {
  return typeof d.default == "function" ? (
    // @ts-expect-error
    d.default(l, u)
  ) : (
    // @ts-expect-error
    d.default
  );
}
// @__NO_SIDE_EFFECTS__
function Xo(d, l) {
  return {
    kind: "schema",
    type: "literal",
    reference: Xo,
    expects: /* @__PURE__ */ A5(d),
    async: !1,
    literal: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(u, p) {
      return u.value === this.literal ? u.typed = !0 : tu(this, "type", u, p), u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Bf(d, l) {
  return {
    kind: "schema",
    type: "object",
    reference: Bf,
    expects: "Object",
    async: !1,
    entries: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(u, p) {
      var R;
      const g = u.value;
      if (g && typeof g == "object") {
        u.typed = !0, u.value = {};
        for (const y in this.entries) {
          const Q = this.entries[y];
          if (y in g || (Q.type === "exact_optional" || Q.type === "optional" || Q.type === "nullish") && // @ts-expect-error
          Q.default !== void 0) {
            const T = y in g ? (
              // @ts-expect-error
              g[y]
            ) : /* @__PURE__ */ L5(Q), k = Q["~run"]({ value: T }, p);
            if (k.issues) {
              const V = {
                type: "object",
                origin: "value",
                input: g,
                key: y,
                value: T
              };
              for (const N of k.issues)
                N.path ? N.path.unshift(V) : N.path = [V], (R = u.issues) == null || R.push(N);
              if (u.issues || (u.issues = k.issues), p.abortEarly) {
                u.typed = !1;
                break;
              }
            }
            k.typed || (u.typed = !1), u.value[y] = k.value;
          } else if (Q.fallback !== void 0)
            u.value[y] = /* @__PURE__ */ sy(Q);
          else if (Q.type !== "exact_optional" && Q.type !== "optional" && Q.type !== "nullish" && (tu(this, "key", u, p, {
            input: void 0,
            expected: `"${y}"`,
            path: [
              {
                type: "object",
                origin: "key",
                input: g,
                key: y,
                // @ts-expect-error
                value: g[y]
              }
            ]
          }), p.abortEarly))
            break;
        }
      } else
        tu(this, "type", u, p);
      return u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function K0(d, l) {
  return {
    kind: "schema",
    type: "optional",
    reference: K0,
    expects: `(${d.expects} | undefined)`,
    async: !1,
    wrapped: d,
    default: l,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(u, p) {
      return u.value === void 0 && (this.default !== void 0 && (u.value = /* @__PURE__ */ L5(this, u, p)), u.value === void 0) ? (u.typed = !0, u) : this.wrapped["~run"](u, p);
    }
  };
}
// @__NO_SIDE_EFFECTS__
function I5(d, l, u) {
  return {
    kind: "schema",
    type: "record",
    reference: I5,
    expects: "Object",
    async: !1,
    key: d,
    value: l,
    message: u,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(p, g) {
      var y, Q;
      const R = p.value;
      if (R && typeof R == "object") {
        p.typed = !0, p.value = {};
        for (const T in R)
          if (/* @__PURE__ */ ry(R, T)) {
            const k = R[T], V = this.key["~run"]({ value: T }, g);
            if (V.issues) {
              const b = {
                type: "object",
                origin: "key",
                input: R,
                key: T,
                value: k
              };
              for (const A of V.issues)
                A.path = [b], (y = p.issues) == null || y.push(A);
              if (p.issues || (p.issues = V.issues), g.abortEarly) {
                p.typed = !1;
                break;
              }
            }
            const N = this.value["~run"](
              { value: k },
              g
            );
            if (N.issues) {
              const b = {
                type: "object",
                origin: "value",
                input: R,
                key: T,
                value: k
              };
              for (const A of N.issues)
                A.path ? A.path.unshift(b) : A.path = [b], (Q = p.issues) == null || Q.push(A);
              if (p.issues || (p.issues = N.issues), g.abortEarly) {
                p.typed = !1;
                break;
              }
            }
            (!V.typed || !N.typed) && (p.typed = !1), V.typed && (p.value[V.value] = N.value);
          }
      } else
        tu(this, "type", p, g);
      return p;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ni(d) {
  return {
    kind: "schema",
    type: "string",
    reference: Ni,
    expects: "string",
    async: !1,
    message: d,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(l, u) {
      return typeof l.value == "string" ? l.typed = !0 : tu(this, "type", l, u), l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function V3(d) {
  let l;
  if (d)
    for (const u of d)
      l ? l.push(...u.issues) : l = u.issues;
  return l;
}
// @__NO_SIDE_EFFECTS__
function iR(d, l) {
  return {
    kind: "schema",
    type: "union",
    reference: iR,
    expects: /* @__PURE__ */ oy(
      d.map((u) => u.expects),
      "|"
    ),
    async: !1,
    options: d,
    message: l,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(u, p) {
      let g, R, y;
      for (const Q of this.options) {
        const T = Q["~run"]({ value: u.value }, p);
        if (T.typed)
          if (T.issues)
            R ? R.push(T) : R = [T];
          else {
            g = T;
            break;
          }
        else
          y ? y.push(T) : y = [T];
      }
      if (g)
        return g;
      if (R) {
        if (R.length === 1)
          return R[0];
        tu(this, "type", u, p, {
          issues: /* @__PURE__ */ V3(R)
        }), u.typed = !0;
      } else {
        if ((y == null ? void 0 : y.length) === 1)
          return y[0];
        tu(this, "type", u, p, {
          issues: /* @__PURE__ */ V3(y)
        });
      }
      return u;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function W5() {
  return {
    kind: "schema",
    type: "unknown",
    reference: W5,
    expects: "unknown",
    async: !1,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(d) {
      return d.typed = !0, d;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ly(...d) {
  return {
    ...d[0],
    pipe: d,
    get "~standard"() {
      return /* @__PURE__ */ pd(this);
    },
    "~run"(l, u) {
      for (const p of d)
        if (p.kind !== "metadata") {
          if (l.issues && (p.kind === "schema" || p.kind === "transformation")) {
            l.typed = !1;
            break;
          }
          (!l.issues || !u.abortEarly && !u.abortPipeEarly) && (l = p["~run"](l, u));
        }
      return l;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Df(d, l, u) {
  const p = d["~run"]({ value: l }, /* @__PURE__ */ w5(u));
  return {
    typed: p.typed,
    success: !p.issues,
    output: p.value,
    issues: p.issues
  };
}
var _g = { exports: {} }, Nf = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C3;
function cy() {
  if (C3) return Nf;
  C3 = 1;
  var d = Symbol.for("react.transitional.element"), l = Symbol.for("react.fragment");
  function u(p, g, R) {
    var y = null;
    if (R !== void 0 && (y = "" + R), g.key !== void 0 && (y = "" + g.key), "key" in g) {
      R = {};
      for (var Q in g)
        Q !== "key" && (R[Q] = g[Q]);
    } else R = g;
    return g = R.ref, {
      $$typeof: d,
      type: p,
      key: y,
      ref: g !== void 0 ? g : null,
      props: R
    };
  }
  return Nf.Fragment = l, Nf.jsx = u, Nf.jsxs = u, Nf;
}
var bf = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var F3;
function dy() {
  return F3 || (F3 = 1, process.env.NODE_ENV !== "production" && function() {
    function d(F) {
      if (F == null) return null;
      if (typeof F == "function")
        return F.$$typeof === xe ? null : F.displayName || F.name || null;
      if (typeof F == "string") return F;
      switch (F) {
        case Ee:
          return "Fragment";
        case he:
          return "Profiler";
        case Fe:
          return "StrictMode";
        case z:
          return "Suspense";
        case Ce:
          return "SuspenseList";
        case Se:
          return "Activity";
      }
      if (typeof F == "object")
        switch (typeof F.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), F.$$typeof) {
          case Ne:
            return "Portal";
          case Ve:
            return (F.displayName || "Context") + ".Provider";
          case ie:
            return (F._context.displayName || "Context") + ".Consumer";
          case _e:
            var H = F.render;
            return F = F.displayName, F || (F = H.displayName || H.name || "", F = F !== "" ? "ForwardRef(" + F + ")" : "ForwardRef"), F;
          case Re:
            return H = F.displayName || null, H !== null ? H : d(F.type) || "Memo";
          case Ue:
            H = F._payload, F = F._init;
            try {
              return d(F(H));
            } catch {
            }
        }
      return null;
    }
    function l(F) {
      return "" + F;
    }
    function u(F) {
      try {
        l(F);
        var H = !1;
      } catch {
        H = !0;
      }
      if (H) {
        H = console;
        var L = H.error, de = typeof Symbol == "function" && Symbol.toStringTag && F[Symbol.toStringTag] || F.constructor.name || "Object";
        return L.call(
          H,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          de
        ), l(F);
      }
    }
    function p(F) {
      if (F === Ee) return "<>";
      if (typeof F == "object" && F !== null && F.$$typeof === Ue)
        return "<...>";
      try {
        var H = d(F);
        return H ? "<" + H + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function g() {
      var F = Qe.A;
      return F === null ? null : F.getOwner();
    }
    function R() {
      return Error("react-stack-top-frame");
    }
    function y(F) {
      if (fe.call(F, "key")) {
        var H = Object.getOwnPropertyDescriptor(F, "key").get;
        if (H && H.isReactWarning) return !1;
      }
      return F.key !== void 0;
    }
    function Q(F, H) {
      function L() {
        De || (De = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          H
        ));
      }
      L.isReactWarning = !0, Object.defineProperty(F, "key", {
        get: L,
        configurable: !0
      });
    }
    function T() {
      var F = d(this.type);
      return Z[F] || (Z[F] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), F = this.props.ref, F !== void 0 ? F : null;
    }
    function k(F, H, L, de, ye, Ae, Ze, Bt) {
      return L = Ae.ref, F = {
        $$typeof: A,
        type: F,
        key: H,
        props: Ae,
        _owner: ye
      }, (L !== void 0 ? L : null) !== null ? Object.defineProperty(F, "ref", {
        enumerable: !1,
        get: T
      }) : Object.defineProperty(F, "ref", { enumerable: !1, value: null }), F._store = {}, Object.defineProperty(F._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(F, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(F, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ze
      }), Object.defineProperty(F, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Bt
      }), Object.freeze && (Object.freeze(F.props), Object.freeze(F)), F;
    }
    function V(F, H, L, de, ye, Ae, Ze, Bt) {
      var $e = H.children;
      if ($e !== void 0)
        if (de)
          if (be($e)) {
            for (de = 0; de < $e.length; de++)
              N($e[de]);
            Object.freeze && Object.freeze($e);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else N($e);
      if (fe.call(H, "key")) {
        $e = d(F);
        var Ht = Object.keys(H).filter(function(rn) {
          return rn !== "key";
        });
        de = 0 < Ht.length ? "{key: someKey, " + Ht.join(": ..., ") + ": ...}" : "{key: someKey}", Te[$e + de] || (Ht = 0 < Ht.length ? "{" + Ht.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          de,
          $e,
          Ht,
          $e
        ), Te[$e + de] = !0);
      }
      if ($e = null, L !== void 0 && (u(L), $e = "" + L), y(H) && (u(H.key), $e = "" + H.key), "key" in H) {
        L = {};
        for (var Nn in H)
          Nn !== "key" && (L[Nn] = H[Nn]);
      } else L = H;
      return $e && Q(
        L,
        typeof F == "function" ? F.displayName || F.name || "Unknown" : F
      ), k(
        F,
        $e,
        Ae,
        ye,
        g(),
        L,
        Ze,
        Bt
      );
    }
    function N(F) {
      typeof F == "object" && F !== null && F.$$typeof === A && F._store && (F._store.validated = 1);
    }
    var b = Qh(), A = Symbol.for("react.transitional.element"), Ne = Symbol.for("react.portal"), Ee = Symbol.for("react.fragment"), Fe = Symbol.for("react.strict_mode"), he = Symbol.for("react.profiler"), ie = Symbol.for("react.consumer"), Ve = Symbol.for("react.context"), _e = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), Ce = Symbol.for("react.suspense_list"), Re = Symbol.for("react.memo"), Ue = Symbol.for("react.lazy"), Se = Symbol.for("react.activity"), xe = Symbol.for("react.client.reference"), Qe = b.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fe = Object.prototype.hasOwnProperty, be = Array.isArray, Be = console.createTask ? console.createTask : function() {
      return null;
    };
    b = {
      "react-stack-bottom-frame": function(F) {
        return F();
      }
    };
    var De, Z = {}, X = b["react-stack-bottom-frame"].bind(
      b,
      R
    )(), ae = Be(p(R)), Te = {};
    bf.Fragment = Ee, bf.jsx = function(F, H, L, de, ye) {
      var Ae = 1e4 > Qe.recentlyCreatedOwnerStacks++;
      return V(
        F,
        H,
        L,
        !1,
        de,
        ye,
        Ae ? Error("react-stack-top-frame") : X,
        Ae ? Be(p(F)) : ae
      );
    }, bf.jsxs = function(F, H, L, de, ye) {
      var Ae = 1e4 > Qe.recentlyCreatedOwnerStacks++;
      return V(
        F,
        H,
        L,
        !0,
        de,
        ye,
        Ae ? Error("react-stack-top-frame") : X,
        Ae ? Be(p(F)) : ae
      );
    };
  }()), bf;
}
var _3;
function uy() {
  return _3 || (_3 = 1, process.env.NODE_ENV === "production" ? _g.exports = cy() : _g.exports = dy()), _g.exports;
}
var U = uy(), Mg = { exports: {} }, Vf = {}, kg = { exports: {} }, VS = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M3;
function hy() {
  return M3 || (M3 = 1, function(d) {
    function l(Z, X) {
      var ae = Z.length;
      Z.push(X);
      e: for (; 0 < ae; ) {
        var Te = ae - 1 >>> 1, F = Z[Te];
        if (0 < g(F, X))
          Z[Te] = X, Z[ae] = F, ae = Te;
        else break e;
      }
    }
    function u(Z) {
      return Z.length === 0 ? null : Z[0];
    }
    function p(Z) {
      if (Z.length === 0) return null;
      var X = Z[0], ae = Z.pop();
      if (ae !== X) {
        Z[0] = ae;
        e: for (var Te = 0, F = Z.length, H = F >>> 1; Te < H; ) {
          var L = 2 * (Te + 1) - 1, de = Z[L], ye = L + 1, Ae = Z[ye];
          if (0 > g(de, ae))
            ye < F && 0 > g(Ae, de) ? (Z[Te] = Ae, Z[ye] = ae, Te = ye) : (Z[Te] = de, Z[L] = ae, Te = L);
          else if (ye < F && 0 > g(Ae, ae))
            Z[Te] = Ae, Z[ye] = ae, Te = ye;
          else break e;
        }
      }
      return X;
    }
    function g(Z, X) {
      var ae = Z.sortIndex - X.sortIndex;
      return ae !== 0 ? ae : Z.id - X.id;
    }
    if (d.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var R = performance;
      d.unstable_now = function() {
        return R.now();
      };
    } else {
      var y = Date, Q = y.now();
      d.unstable_now = function() {
        return y.now() - Q;
      };
    }
    var T = [], k = [], V = 1, N = null, b = 3, A = !1, Ne = !1, Ee = !1, Fe = !1, he = typeof setTimeout == "function" ? setTimeout : null, ie = typeof clearTimeout == "function" ? clearTimeout : null, Ve = typeof setImmediate < "u" ? setImmediate : null;
    function _e(Z) {
      for (var X = u(k); X !== null; ) {
        if (X.callback === null) p(k);
        else if (X.startTime <= Z)
          p(k), X.sortIndex = X.expirationTime, l(T, X);
        else break;
        X = u(k);
      }
    }
    function z(Z) {
      if (Ee = !1, _e(Z), !Ne)
        if (u(T) !== null)
          Ne = !0, Ce || (Ce = !0, fe());
        else {
          var X = u(k);
          X !== null && De(z, X.startTime - Z);
        }
    }
    var Ce = !1, Re = -1, Ue = 5, Se = -1;
    function xe() {
      return Fe ? !0 : !(d.unstable_now() - Se < Ue);
    }
    function Qe() {
      if (Fe = !1, Ce) {
        var Z = d.unstable_now();
        Se = Z;
        var X = !0;
        try {
          e: {
            Ne = !1, Ee && (Ee = !1, ie(Re), Re = -1), A = !0;
            var ae = b;
            try {
              t: {
                for (_e(Z), N = u(T); N !== null && !(N.expirationTime > Z && xe()); ) {
                  var Te = N.callback;
                  if (typeof Te == "function") {
                    N.callback = null, b = N.priorityLevel;
                    var F = Te(
                      N.expirationTime <= Z
                    );
                    if (Z = d.unstable_now(), typeof F == "function") {
                      N.callback = F, _e(Z), X = !0;
                      break t;
                    }
                    N === u(T) && p(T), _e(Z);
                  } else p(T);
                  N = u(T);
                }
                if (N !== null) X = !0;
                else {
                  var H = u(k);
                  H !== null && De(
                    z,
                    H.startTime - Z
                  ), X = !1;
                }
              }
              break e;
            } finally {
              N = null, b = ae, A = !1;
            }
            X = void 0;
          }
        } finally {
          X ? fe() : Ce = !1;
        }
      }
    }
    var fe;
    if (typeof Ve == "function")
      fe = function() {
        Ve(Qe);
      };
    else if (typeof MessageChannel < "u") {
      var be = new MessageChannel(), Be = be.port2;
      be.port1.onmessage = Qe, fe = function() {
        Be.postMessage(null);
      };
    } else
      fe = function() {
        he(Qe, 0);
      };
    function De(Z, X) {
      Re = he(function() {
        Z(d.unstable_now());
      }, X);
    }
    d.unstable_IdlePriority = 5, d.unstable_ImmediatePriority = 1, d.unstable_LowPriority = 4, d.unstable_NormalPriority = 3, d.unstable_Profiling = null, d.unstable_UserBlockingPriority = 2, d.unstable_cancelCallback = function(Z) {
      Z.callback = null;
    }, d.unstable_forceFrameRate = function(Z) {
      0 > Z || 125 < Z ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Ue = 0 < Z ? Math.floor(1e3 / Z) : 5;
    }, d.unstable_getCurrentPriorityLevel = function() {
      return b;
    }, d.unstable_next = function(Z) {
      switch (b) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = b;
      }
      var ae = b;
      b = X;
      try {
        return Z();
      } finally {
        b = ae;
      }
    }, d.unstable_requestPaint = function() {
      Fe = !0;
    }, d.unstable_runWithPriority = function(Z, X) {
      switch (Z) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          Z = 3;
      }
      var ae = b;
      b = Z;
      try {
        return X();
      } finally {
        b = ae;
      }
    }, d.unstable_scheduleCallback = function(Z, X, ae) {
      var Te = d.unstable_now();
      switch (typeof ae == "object" && ae !== null ? (ae = ae.delay, ae = typeof ae == "number" && 0 < ae ? Te + ae : Te) : ae = Te, Z) {
        case 1:
          var F = -1;
          break;
        case 2:
          F = 250;
          break;
        case 5:
          F = 1073741823;
          break;
        case 4:
          F = 1e4;
          break;
        default:
          F = 5e3;
      }
      return F = ae + F, Z = {
        id: V++,
        callback: X,
        priorityLevel: Z,
        startTime: ae,
        expirationTime: F,
        sortIndex: -1
      }, ae > Te ? (Z.sortIndex = ae, l(k, Z), u(T) === null && Z === u(k) && (Ee ? (ie(Re), Re = -1) : Ee = !0, De(z, ae - Te))) : (Z.sortIndex = F, l(T, Z), Ne || A || (Ne = !0, Ce || (Ce = !0, fe()))), Z;
    }, d.unstable_shouldYield = xe, d.unstable_wrapCallback = function(Z) {
      var X = b;
      return function() {
        var ae = b;
        b = X;
        try {
          return Z.apply(this, arguments);
        } finally {
          b = ae;
        }
      };
    };
  }(VS)), VS;
}
var CS = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var k3;
function my() {
  return k3 || (k3 = 1, function(d) {
    process.env.NODE_ENV !== "production" && function() {
      function l() {
        if (z = !1, Se) {
          var Z = d.unstable_now();
          fe = Z;
          var X = !0;
          try {
            e: {
              Ve = !1, _e && (_e = !1, Re(xe), xe = -1), ie = !0;
              var ae = he;
              try {
                t: {
                  for (y(Z), Fe = p(A); Fe !== null && !(Fe.expirationTime > Z && T()); ) {
                    var Te = Fe.callback;
                    if (typeof Te == "function") {
                      Fe.callback = null, he = Fe.priorityLevel;
                      var F = Te(
                        Fe.expirationTime <= Z
                      );
                      if (Z = d.unstable_now(), typeof F == "function") {
                        Fe.callback = F, y(Z), X = !0;
                        break t;
                      }
                      Fe === p(A) && g(A), y(Z);
                    } else g(A);
                    Fe = p(A);
                  }
                  if (Fe !== null) X = !0;
                  else {
                    var H = p(Ne);
                    H !== null && k(
                      Q,
                      H.startTime - Z
                    ), X = !1;
                  }
                }
                break e;
              } finally {
                Fe = null, he = ae, ie = !1;
              }
              X = void 0;
            }
          } finally {
            X ? be() : Se = !1;
          }
        }
      }
      function u(Z, X) {
        var ae = Z.length;
        Z.push(X);
        e: for (; 0 < ae; ) {
          var Te = ae - 1 >>> 1, F = Z[Te];
          if (0 < R(F, X))
            Z[Te] = X, Z[ae] = F, ae = Te;
          else break e;
        }
      }
      function p(Z) {
        return Z.length === 0 ? null : Z[0];
      }
      function g(Z) {
        if (Z.length === 0) return null;
        var X = Z[0], ae = Z.pop();
        if (ae !== X) {
          Z[0] = ae;
          e: for (var Te = 0, F = Z.length, H = F >>> 1; Te < H; ) {
            var L = 2 * (Te + 1) - 1, de = Z[L], ye = L + 1, Ae = Z[ye];
            if (0 > R(de, ae))
              ye < F && 0 > R(Ae, de) ? (Z[Te] = Ae, Z[ye] = ae, Te = ye) : (Z[Te] = de, Z[L] = ae, Te = L);
            else if (ye < F && 0 > R(Ae, ae))
              Z[Te] = Ae, Z[ye] = ae, Te = ye;
            else break e;
          }
        }
        return X;
      }
      function R(Z, X) {
        var ae = Z.sortIndex - X.sortIndex;
        return ae !== 0 ? ae : Z.id - X.id;
      }
      function y(Z) {
        for (var X = p(Ne); X !== null; ) {
          if (X.callback === null) g(Ne);
          else if (X.startTime <= Z)
            g(Ne), X.sortIndex = X.expirationTime, u(A, X);
          else break;
          X = p(Ne);
        }
      }
      function Q(Z) {
        if (_e = !1, y(Z), !Ve)
          if (p(A) !== null)
            Ve = !0, Se || (Se = !0, be());
          else {
            var X = p(Ne);
            X !== null && k(
              Q,
              X.startTime - Z
            );
          }
      }
      function T() {
        return z ? !0 : !(d.unstable_now() - fe < Qe);
      }
      function k(Z, X) {
        xe = Ce(function() {
          Z(d.unstable_now());
        }, X);
      }
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error()), d.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
        var V = performance;
        d.unstable_now = function() {
          return V.now();
        };
      } else {
        var N = Date, b = N.now();
        d.unstable_now = function() {
          return N.now() - b;
        };
      }
      var A = [], Ne = [], Ee = 1, Fe = null, he = 3, ie = !1, Ve = !1, _e = !1, z = !1, Ce = typeof setTimeout == "function" ? setTimeout : null, Re = typeof clearTimeout == "function" ? clearTimeout : null, Ue = typeof setImmediate < "u" ? setImmediate : null, Se = !1, xe = -1, Qe = 5, fe = -1;
      if (typeof Ue == "function")
        var be = function() {
          Ue(l);
        };
      else if (typeof MessageChannel < "u") {
        var Be = new MessageChannel(), De = Be.port2;
        Be.port1.onmessage = l, be = function() {
          De.postMessage(null);
        };
      } else
        be = function() {
          Ce(l, 0);
        };
      d.unstable_IdlePriority = 5, d.unstable_ImmediatePriority = 1, d.unstable_LowPriority = 4, d.unstable_NormalPriority = 3, d.unstable_Profiling = null, d.unstable_UserBlockingPriority = 2, d.unstable_cancelCallback = function(Z) {
        Z.callback = null;
      }, d.unstable_forceFrameRate = function(Z) {
        0 > Z || 125 < Z ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : Qe = 0 < Z ? Math.floor(1e3 / Z) : 5;
      }, d.unstable_getCurrentPriorityLevel = function() {
        return he;
      }, d.unstable_next = function(Z) {
        switch (he) {
          case 1:
          case 2:
          case 3:
            var X = 3;
            break;
          default:
            X = he;
        }
        var ae = he;
        he = X;
        try {
          return Z();
        } finally {
          he = ae;
        }
      }, d.unstable_requestPaint = function() {
        z = !0;
      }, d.unstable_runWithPriority = function(Z, X) {
        switch (Z) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            Z = 3;
        }
        var ae = he;
        he = Z;
        try {
          return X();
        } finally {
          he = ae;
        }
      }, d.unstable_scheduleCallback = function(Z, X, ae) {
        var Te = d.unstable_now();
        switch (typeof ae == "object" && ae !== null ? (ae = ae.delay, ae = typeof ae == "number" && 0 < ae ? Te + ae : Te) : ae = Te, Z) {
          case 1:
            var F = -1;
            break;
          case 2:
            F = 250;
            break;
          case 5:
            F = 1073741823;
            break;
          case 4:
            F = 1e4;
            break;
          default:
            F = 5e3;
        }
        return F = ae + F, Z = {
          id: Ee++,
          callback: X,
          priorityLevel: Z,
          startTime: ae,
          expirationTime: F,
          sortIndex: -1
        }, ae > Te ? (Z.sortIndex = ae, u(Ne, Z), p(A) === null && Z === p(Ne) && (_e ? (Re(xe), xe = -1) : _e = !0, k(Q, ae - Te))) : (Z.sortIndex = F, u(A, Z), Ve || ie || (Ve = !0, Se || (Se = !0, be()))), Z;
      }, d.unstable_shouldYield = T, d.unstable_wrapCallback = function(Z) {
        var X = he;
        return function() {
          var ae = he;
          he = X;
          try {
            return Z.apply(this, arguments);
          } finally {
            he = ae;
          }
        };
      }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    }();
  }(CS)), CS;
}
var Q3;
function H5() {
  return Q3 || (Q3 = 1, process.env.NODE_ENV === "production" ? kg.exports = hy() : kg.exports = my()), kg.exports;
}
var Qg = { exports: {} }, ca = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D3;
function py() {
  if (D3) return ca;
  D3 = 1;
  var d = Qh();
  function l(T) {
    var k = "https://react.dev/errors/" + T;
    if (1 < arguments.length) {
      k += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var V = 2; V < arguments.length; V++)
        k += "&args[]=" + encodeURIComponent(arguments[V]);
    }
    return "Minified React error #" + T + "; visit " + k + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function u() {
  }
  var p = {
    d: {
      f: u,
      r: function() {
        throw Error(l(522));
      },
      D: u,
      C: u,
      L: u,
      m: u,
      X: u,
      S: u,
      M: u
    },
    p: 0,
    findDOMNode: null
  }, g = Symbol.for("react.portal");
  function R(T, k, V) {
    var N = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: g,
      key: N == null ? null : "" + N,
      children: T,
      containerInfo: k,
      implementation: V
    };
  }
  var y = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function Q(T, k) {
    if (T === "font") return "";
    if (typeof k == "string")
      return k === "use-credentials" ? k : "";
  }
  return ca.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = p, ca.createPortal = function(T, k) {
    var V = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!k || k.nodeType !== 1 && k.nodeType !== 9 && k.nodeType !== 11)
      throw Error(l(299));
    return R(T, k, null, V);
  }, ca.flushSync = function(T) {
    var k = y.T, V = p.p;
    try {
      if (y.T = null, p.p = 2, T) return T();
    } finally {
      y.T = k, p.p = V, p.d.f();
    }
  }, ca.preconnect = function(T, k) {
    typeof T == "string" && (k ? (k = k.crossOrigin, k = typeof k == "string" ? k === "use-credentials" ? k : "" : void 0) : k = null, p.d.C(T, k));
  }, ca.prefetchDNS = function(T) {
    typeof T == "string" && p.d.D(T);
  }, ca.preinit = function(T, k) {
    if (typeof T == "string" && k && typeof k.as == "string") {
      var V = k.as, N = Q(V, k.crossOrigin), b = typeof k.integrity == "string" ? k.integrity : void 0, A = typeof k.fetchPriority == "string" ? k.fetchPriority : void 0;
      V === "style" ? p.d.S(
        T,
        typeof k.precedence == "string" ? k.precedence : void 0,
        {
          crossOrigin: N,
          integrity: b,
          fetchPriority: A
        }
      ) : V === "script" && p.d.X(T, {
        crossOrigin: N,
        integrity: b,
        fetchPriority: A,
        nonce: typeof k.nonce == "string" ? k.nonce : void 0
      });
    }
  }, ca.preinitModule = function(T, k) {
    if (typeof T == "string")
      if (typeof k == "object" && k !== null) {
        if (k.as == null || k.as === "script") {
          var V = Q(
            k.as,
            k.crossOrigin
          );
          p.d.M(T, {
            crossOrigin: V,
            integrity: typeof k.integrity == "string" ? k.integrity : void 0,
            nonce: typeof k.nonce == "string" ? k.nonce : void 0
          });
        }
      } else k == null && p.d.M(T);
  }, ca.preload = function(T, k) {
    if (typeof T == "string" && typeof k == "object" && k !== null && typeof k.as == "string") {
      var V = k.as, N = Q(V, k.crossOrigin);
      p.d.L(T, V, {
        crossOrigin: N,
        integrity: typeof k.integrity == "string" ? k.integrity : void 0,
        nonce: typeof k.nonce == "string" ? k.nonce : void 0,
        type: typeof k.type == "string" ? k.type : void 0,
        fetchPriority: typeof k.fetchPriority == "string" ? k.fetchPriority : void 0,
        referrerPolicy: typeof k.referrerPolicy == "string" ? k.referrerPolicy : void 0,
        imageSrcSet: typeof k.imageSrcSet == "string" ? k.imageSrcSet : void 0,
        imageSizes: typeof k.imageSizes == "string" ? k.imageSizes : void 0,
        media: typeof k.media == "string" ? k.media : void 0
      });
    }
  }, ca.preloadModule = function(T, k) {
    if (typeof T == "string")
      if (k) {
        var V = Q(k.as, k.crossOrigin);
        p.d.m(T, {
          as: typeof k.as == "string" && k.as !== "script" ? k.as : void 0,
          crossOrigin: V,
          integrity: typeof k.integrity == "string" ? k.integrity : void 0
        });
      } else p.d.m(T);
  }, ca.requestFormReset = function(T) {
    p.d.r(T);
  }, ca.unstable_batchedUpdates = function(T, k) {
    return T(k);
  }, ca.useFormState = function(T, k, V) {
    return y.H.useFormState(T, k, V);
  }, ca.useFormStatus = function() {
    return y.H.useHostTransitionStatus();
  }, ca.version = "19.1.0", ca;
}
var da = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var x3;
function fy() {
  return x3 || (x3 = 1, process.env.NODE_ENV !== "production" && function() {
    function d() {
    }
    function l(N) {
      return "" + N;
    }
    function u(N, b, A) {
      var Ne = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      try {
        l(Ne);
        var Ee = !1;
      } catch {
        Ee = !0;
      }
      return Ee && (console.error(
        "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
        typeof Symbol == "function" && Symbol.toStringTag && Ne[Symbol.toStringTag] || Ne.constructor.name || "Object"
      ), l(Ne)), {
        $$typeof: k,
        key: Ne == null ? null : "" + Ne,
        children: N,
        containerInfo: b,
        implementation: A
      };
    }
    function p(N, b) {
      if (N === "font") return "";
      if (typeof b == "string")
        return b === "use-credentials" ? b : "";
    }
    function g(N) {
      return N === null ? "`null`" : N === void 0 ? "`undefined`" : N === "" ? "an empty string" : 'something with type "' + typeof N + '"';
    }
    function R(N) {
      return N === null ? "`null`" : N === void 0 ? "`undefined`" : N === "" ? "an empty string" : typeof N == "string" ? JSON.stringify(N) : typeof N == "number" ? "`" + N + "`" : 'something with type "' + typeof N + '"';
    }
    function y() {
      var N = V.H;
      return N === null && console.error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      ), N;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Q = Qh(), T = {
      d: {
        f: d,
        r: function() {
          throw Error(
            "Invalid form element. requestFormReset must be passed a form that was rendered by React."
          );
        },
        D: d,
        C: d,
        L: d,
        m: d,
        X: d,
        S: d,
        M: d
      },
      p: 0,
      findDOMNode: null
    }, k = Symbol.for("react.portal"), V = Q.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
    typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"
    ), da.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = T, da.createPortal = function(N, b) {
      var A = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!b || b.nodeType !== 1 && b.nodeType !== 9 && b.nodeType !== 11)
        throw Error("Target container is not a DOM element.");
      return u(N, b, null, A);
    }, da.flushSync = function(N) {
      var b = V.T, A = T.p;
      try {
        if (V.T = null, T.p = 2, N)
          return N();
      } finally {
        V.T = b, T.p = A, T.d.f() && console.error(
          "flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."
        );
      }
    }, da.preconnect = function(N, b) {
      typeof N == "string" && N ? b != null && typeof b != "object" ? console.error(
        "ReactDOM.preconnect(): Expected the `options` argument (second) to be an object but encountered %s instead. The only supported option at this time is `crossOrigin` which accepts a string.",
        R(b)
      ) : b != null && typeof b.crossOrigin != "string" && console.error(
        "ReactDOM.preconnect(): Expected the `crossOrigin` option (second argument) to be a string but encountered %s instead. Try removing this option or passing a string value instead.",
        g(b.crossOrigin)
      ) : console.error(
        "ReactDOM.preconnect(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        g(N)
      ), typeof N == "string" && (b ? (b = b.crossOrigin, b = typeof b == "string" ? b === "use-credentials" ? b : "" : void 0) : b = null, T.d.C(N, b));
    }, da.prefetchDNS = function(N) {
      if (typeof N != "string" || !N)
        console.error(
          "ReactDOM.prefetchDNS(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
          g(N)
        );
      else if (1 < arguments.length) {
        var b = arguments[1];
        typeof b == "object" && b.hasOwnProperty("crossOrigin") ? console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. It looks like the you are attempting to set a crossOrigin property for this DNS lookup hint. Browsers do not perform DNS queries using CORS and setting this attribute on the resource hint has no effect. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          R(b)
        ) : console.error(
          "ReactDOM.prefetchDNS(): Expected only one argument, `href`, but encountered %s as a second argument instead. This argument is reserved for future options and is currently disallowed. Try calling ReactDOM.prefetchDNS() with just a single string argument, `href`.",
          R(b)
        );
      }
      typeof N == "string" && T.d.D(N);
    }, da.preinit = function(N, b) {
      if (typeof N == "string" && N ? b == null || typeof b != "object" ? console.error(
        "ReactDOM.preinit(): Expected the `options` argument (second) to be an object with an `as` property describing the type of resource to be preinitialized but encountered %s instead.",
        R(b)
      ) : b.as !== "style" && b.as !== "script" && console.error(
        'ReactDOM.preinit(): Expected the `as` property in the `options` argument (second) to contain a valid value describing the type of resource to be preinitialized but encountered %s instead. Valid values for `as` are "style" and "script".',
        R(b.as)
      ) : console.error(
        "ReactDOM.preinit(): Expected the `href` argument (first) to be a non-empty string but encountered %s instead.",
        g(N)
      ), typeof N == "string" && b && typeof b.as == "string") {
        var A = b.as, Ne = p(A, b.crossOrigin), Ee = typeof b.integrity == "string" ? b.integrity : void 0, Fe = typeof b.fetchPriority == "string" ? b.fetchPriority : void 0;
        A === "style" ? T.d.S(
          N,
          typeof b.precedence == "string" ? b.precedence : void 0,
          {
            crossOrigin: Ne,
            integrity: Ee,
            fetchPriority: Fe
          }
        ) : A === "script" && T.d.X(N, {
          crossOrigin: Ne,
          integrity: Ee,
          fetchPriority: Fe,
          nonce: typeof b.nonce == "string" ? b.nonce : void 0
        });
      }
    }, da.preinitModule = function(N, b) {
      var A = "";
      if (typeof N == "string" && N || (A += " The `href` argument encountered was " + g(N) + "."), b !== void 0 && typeof b != "object" ? A += " The `options` argument encountered was " + g(b) + "." : b && "as" in b && b.as !== "script" && (A += " The `as` option encountered was " + R(b.as) + "."), A)
        console.error(
          "ReactDOM.preinitModule(): Expected up to two arguments, a non-empty `href` string and, optionally, an `options` object with a valid `as` property.%s",
          A
        );
      else
        switch (A = b && typeof b.as == "string" ? b.as : "script", A) {
          case "script":
            break;
          default:
            A = R(A), console.error(
              'ReactDOM.preinitModule(): Currently the only supported "as" type for this function is "script" but received "%s" instead. This warning was generated for `href` "%s". In the future other module types will be supported, aligning with the import-attributes proposal. Learn more here: (https://github.com/tc39/proposal-import-attributes)',
              A,
              N
            );
        }
      typeof N == "string" && (typeof b == "object" && b !== null ? (b.as == null || b.as === "script") && (A = p(
        b.as,
        b.crossOrigin
      ), T.d.M(N, {
        crossOrigin: A,
        integrity: typeof b.integrity == "string" ? b.integrity : void 0,
        nonce: typeof b.nonce == "string" ? b.nonce : void 0
      })) : b == null && T.d.M(N));
    }, da.preload = function(N, b) {
      var A = "";
      if (typeof N == "string" && N || (A += " The `href` argument encountered was " + g(N) + "."), b == null || typeof b != "object" ? A += " The `options` argument encountered was " + g(b) + "." : typeof b.as == "string" && b.as || (A += " The `as` option encountered was " + g(b.as) + "."), A && console.error(
        'ReactDOM.preload(): Expected two arguments, a non-empty `href` string and an `options` object with an `as` property valid for a `<link rel="preload" as="..." />` tag.%s',
        A
      ), typeof N == "string" && typeof b == "object" && b !== null && typeof b.as == "string") {
        A = b.as;
        var Ne = p(
          A,
          b.crossOrigin
        );
        T.d.L(N, A, {
          crossOrigin: Ne,
          integrity: typeof b.integrity == "string" ? b.integrity : void 0,
          nonce: typeof b.nonce == "string" ? b.nonce : void 0,
          type: typeof b.type == "string" ? b.type : void 0,
          fetchPriority: typeof b.fetchPriority == "string" ? b.fetchPriority : void 0,
          referrerPolicy: typeof b.referrerPolicy == "string" ? b.referrerPolicy : void 0,
          imageSrcSet: typeof b.imageSrcSet == "string" ? b.imageSrcSet : void 0,
          imageSizes: typeof b.imageSizes == "string" ? b.imageSizes : void 0,
          media: typeof b.media == "string" ? b.media : void 0
        });
      }
    }, da.preloadModule = function(N, b) {
      var A = "";
      typeof N == "string" && N || (A += " The `href` argument encountered was " + g(N) + "."), b !== void 0 && typeof b != "object" ? A += " The `options` argument encountered was " + g(b) + "." : b && "as" in b && typeof b.as != "string" && (A += " The `as` option encountered was " + g(b.as) + "."), A && console.error(
        'ReactDOM.preloadModule(): Expected two arguments, a non-empty `href` string and, optionally, an `options` object with an `as` property valid for a `<link rel="modulepreload" as="..." />` tag.%s',
        A
      ), typeof N == "string" && (b ? (A = p(
        b.as,
        b.crossOrigin
      ), T.d.m(N, {
        as: typeof b.as == "string" && b.as !== "script" ? b.as : void 0,
        crossOrigin: A,
        integrity: typeof b.integrity == "string" ? b.integrity : void 0
      })) : T.d.m(N));
    }, da.requestFormReset = function(N) {
      T.d.r(N);
    }, da.unstable_batchedUpdates = function(N, b) {
      return N(b);
    }, da.useFormState = function(N, b, A) {
      return y().useFormState(N, b, A);
    }, da.useFormStatus = function() {
      return y().useHostTransitionStatus();
    }, da.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), da;
}
var Z3;
function z5() {
  if (Z3) return Qg.exports;
  Z3 = 1;
  function d() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(d);
      } catch (l) {
        console.error(l);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (d(), Qg.exports = py()) : Qg.exports = fy(), Qg.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var O3;
function gy() {
  if (O3) return Vf;
  O3 = 1;
  var d = H5(), l = Qh(), u = z5();
  function p(n) {
    var a = "https://react.dev/errors/" + n;
    if (1 < arguments.length) {
      a += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var r = 2; r < arguments.length; r++)
        a += "&args[]=" + encodeURIComponent(arguments[r]);
    }
    return "Minified React error #" + n + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function g(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function R(n) {
    var a = n, r = n;
    if (n.alternate) for (; a.return; ) a = a.return;
    else {
      n = a;
      do
        a = n, (a.flags & 4098) !== 0 && (r = a.return), n = a.return;
      while (n);
    }
    return a.tag === 3 ? r : null;
  }
  function y(n) {
    if (n.tag === 13) {
      var a = n.memoizedState;
      if (a === null && (n = n.alternate, n !== null && (a = n.memoizedState)), a !== null) return a.dehydrated;
    }
    return null;
  }
  function Q(n) {
    if (R(n) !== n)
      throw Error(p(188));
  }
  function T(n) {
    var a = n.alternate;
    if (!a) {
      if (a = R(n), a === null) throw Error(p(188));
      return a !== n ? null : n;
    }
    for (var r = n, s = a; ; ) {
      var m = r.return;
      if (m === null) break;
      var f = m.alternate;
      if (f === null) {
        if (s = m.return, s !== null) {
          r = s;
          continue;
        }
        break;
      }
      if (m.child === f.child) {
        for (f = m.child; f; ) {
          if (f === r) return Q(m), n;
          if (f === s) return Q(m), a;
          f = f.sibling;
        }
        throw Error(p(188));
      }
      if (r.return !== s.return) r = m, s = f;
      else {
        for (var E = !1, _ = m.child; _; ) {
          if (_ === r) {
            E = !0, r = m, s = f;
            break;
          }
          if (_ === s) {
            E = !0, s = m, r = f;
            break;
          }
          _ = _.sibling;
        }
        if (!E) {
          for (_ = f.child; _; ) {
            if (_ === r) {
              E = !0, r = f, s = m;
              break;
            }
            if (_ === s) {
              E = !0, s = f, r = m;
              break;
            }
            _ = _.sibling;
          }
          if (!E) throw Error(p(189));
        }
      }
      if (r.alternate !== s) throw Error(p(190));
    }
    if (r.tag !== 3) throw Error(p(188));
    return r.stateNode.current === r ? n : a;
  }
  function k(n) {
    var a = n.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return n;
    for (n = n.child; n !== null; ) {
      if (a = k(n), a !== null) return a;
      n = n.sibling;
    }
    return null;
  }
  var V = Object.assign, N = Symbol.for("react.element"), b = Symbol.for("react.transitional.element"), A = Symbol.for("react.portal"), Ne = Symbol.for("react.fragment"), Ee = Symbol.for("react.strict_mode"), Fe = Symbol.for("react.profiler"), he = Symbol.for("react.provider"), ie = Symbol.for("react.consumer"), Ve = Symbol.for("react.context"), _e = Symbol.for("react.forward_ref"), z = Symbol.for("react.suspense"), Ce = Symbol.for("react.suspense_list"), Re = Symbol.for("react.memo"), Ue = Symbol.for("react.lazy"), Se = Symbol.for("react.activity"), xe = Symbol.for("react.memo_cache_sentinel"), Qe = Symbol.iterator;
  function fe(n) {
    return n === null || typeof n != "object" ? null : (n = Qe && n[Qe] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var be = Symbol.for("react.client.reference");
  function Be(n) {
    if (n == null) return null;
    if (typeof n == "function")
      return n.$$typeof === be ? null : n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case Ne:
        return "Fragment";
      case Fe:
        return "Profiler";
      case Ee:
        return "StrictMode";
      case z:
        return "Suspense";
      case Ce:
        return "SuspenseList";
      case Se:
        return "Activity";
    }
    if (typeof n == "object")
      switch (n.$$typeof) {
        case A:
          return "Portal";
        case Ve:
          return (n.displayName || "Context") + ".Provider";
        case ie:
          return (n._context.displayName || "Context") + ".Consumer";
        case _e:
          var a = n.render;
          return n = n.displayName, n || (n = a.displayName || a.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
        case Re:
          return a = n.displayName || null, a !== null ? a : Be(n.type) || "Memo";
        case Ue:
          a = n._payload, n = n._init;
          try {
            return Be(n(a));
          } catch {
          }
      }
    return null;
  }
  var De = Array.isArray, Z = l.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, X = u.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ae = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, Te = [], F = -1;
  function H(n) {
    return { current: n };
  }
  function L(n) {
    0 > F || (n.current = Te[F], Te[F] = null, F--);
  }
  function de(n, a) {
    F++, Te[F] = n.current, n.current = a;
  }
  var ye = H(null), Ae = H(null), Ze = H(null), Bt = H(null);
  function $e(n, a) {
    switch (de(Ze, a), de(Ae, n), de(ye, null), a.nodeType) {
      case 9:
      case 11:
        n = (n = a.documentElement) && (n = n.namespaceURI) ? Ao(n) : 0;
        break;
      default:
        if (n = a.tagName, a = a.namespaceURI)
          a = Ao(a), n = Lc(a, n);
        else
          switch (n) {
            case "svg":
              n = 1;
              break;
            case "math":
              n = 2;
              break;
            default:
              n = 0;
          }
    }
    L(ye), de(ye, n);
  }
  function Ht() {
    L(ye), L(Ae), L(Ze);
  }
  function Nn(n) {
    n.memoizedState !== null && de(Bt, n);
    var a = ye.current, r = Lc(a, n.type);
    a !== r && (de(Ae, n), de(ye, r));
  }
  function rn(n) {
    Ae.current === n && (L(ye), L(Ae)), Bt.current === n && (L(Bt), sa._currentValue = ae);
  }
  var tn = Object.prototype.hasOwnProperty, gn = d.unstable_scheduleCallback, Ma = d.unstable_cancelCallback, go = d.unstable_shouldYield, Qt = d.unstable_requestPaint, vn = d.unstable_now, ka = d.unstable_getCurrentPriorityLevel, Rr = d.unstable_ImmediatePriority, gt = d.unstable_UserBlockingPriority, bi = d.unstable_NormalPriority, Lt = d.unstable_LowPriority, xi = d.unstable_IdlePriority, qo = d.log, vo = d.unstable_setDisableYieldValue, ni = null, Jn = null;
  function un(n) {
    if (typeof qo == "function" && vo(n), Jn && typeof Jn.setStrictMode == "function")
      try {
        Jn.setStrictMode(ni, n);
      } catch {
      }
  }
  var Ln = Math.clz32 ? Math.clz32 : Er, Qa = Math.log, So = Math.LN2;
  function Er(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (Qa(n) / So | 0) | 0;
  }
  var Zi = 256, ii = 4194304;
  function In(n) {
    var a = n & 42;
    if (a !== 0) return a;
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194048;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return n & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return n;
    }
  }
  function Oi(n, a, r) {
    var s = n.pendingLanes;
    if (s === 0) return 0;
    var m = 0, f = n.suspendedLanes, E = n.pingedLanes;
    n = n.warmLanes;
    var _ = s & 134217727;
    return _ !== 0 ? (s = _ & ~f, s !== 0 ? m = In(s) : (E &= _, E !== 0 ? m = In(E) : r || (r = _ & ~n, r !== 0 && (m = In(r))))) : (_ = s & ~f, _ !== 0 ? m = In(_) : E !== 0 ? m = In(E) : r || (r = s & ~n, r !== 0 && (m = In(r)))), m === 0 ? 0 : a !== 0 && a !== m && (a & f) === 0 && (f = m & -m, r = a & -a, f >= r || f === 32 && (r & 4194048) !== 0) ? a : m;
  }
  function C(n, a) {
    return (n.pendingLanes & ~(n.suspendedLanes & ~n.pingedLanes) & a) === 0;
  }
  function j(n, a) {
    switch (n) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return a + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function ke() {
    var n = Zi;
    return Zi <<= 1, (Zi & 4194048) === 0 && (Zi = 256), n;
  }
  function Oe() {
    var n = ii;
    return ii <<= 1, (ii & 62914560) === 0 && (ii = 4194304), n;
  }
  function Je(n) {
    for (var a = [], r = 0; 31 > r; r++) a.push(n);
    return a;
  }
  function nt(n, a) {
    n.pendingLanes |= a, a !== 268435456 && (n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0);
  }
  function mt(n, a, r, s, m, f) {
    var E = n.pendingLanes;
    n.pendingLanes = r, n.suspendedLanes = 0, n.pingedLanes = 0, n.warmLanes = 0, n.expiredLanes &= r, n.entangledLanes &= r, n.errorRecoveryDisabledLanes &= r, n.shellSuspendCounter = 0;
    var _ = n.entanglements, O = n.expirationTimes, K = n.hiddenUpdates;
    for (r = E & ~r; 0 < r; ) {
      var me = 31 - Ln(r), ve = 1 << me;
      _[me] = 0, O[me] = -1;
      var $ = K[me];
      if ($ !== null)
        for (K[me] = null, me = 0; me < $.length; me++) {
          var te = $[me];
          te !== null && (te.lane &= -536870913);
        }
      r &= ~ve;
    }
    s !== 0 && Ct(n, s, 0), f !== 0 && m === 0 && n.tag !== 0 && (n.suspendedLanes |= f & ~(E & ~a));
  }
  function Ct(n, a, r) {
    n.pendingLanes |= a, n.suspendedLanes &= ~a;
    var s = 31 - Ln(a);
    n.entangledLanes |= a, n.entanglements[s] = n.entanglements[s] | 1073741824 | r & 4194090;
  }
  function ct(n, a) {
    var r = n.entangledLanes |= a;
    for (n = n.entanglements; r; ) {
      var s = 31 - Ln(r), m = 1 << s;
      m & a | n[s] & a && (n[s] |= a), r &= ~m;
    }
  }
  function Sn(n) {
    switch (n) {
      case 2:
        n = 1;
        break;
      case 8:
        n = 4;
        break;
      case 32:
        n = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        n = 128;
        break;
      case 268435456:
        n = 134217728;
        break;
      default:
        n = 0;
    }
    return n;
  }
  function Bi(n) {
    return n &= -n, 2 < n ? 8 < n ? (n & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function $o() {
    var n = X.p;
    return n !== 0 ? n : (n = window.event, n === void 0 ? 32 : Bp(n.type));
  }
  function Ws(n, a) {
    var r = X.p;
    try {
      return X.p = n, a();
    } finally {
      X.p = r;
    }
  }
  var bn = Math.random().toString(36).slice(2), _n = "__reactFiber$" + bn, Yn = "__reactProps$" + bn, Da = "__reactContainer$" + bn, Ur = "__reactEvents$" + bn, xa = "__reactListeners$" + bn, Tr = "__reactHandles$" + bn, yr = "__reactResources$" + bn, He = "__reactMarker$" + bn;
  function D(n) {
    delete n[_n], delete n[Yn], delete n[Ur], delete n[xa], delete n[Tr];
  }
  function B(n) {
    var a = n[_n];
    if (a) return a;
    for (var r = n.parentNode; r; ) {
      if (a = r[Da] || r[_n]) {
        if (r = a.alternate, a.child !== null || r !== null && r.child !== null)
          for (n = Ri(n); n !== null; ) {
            if (r = n[_n]) return r;
            n = Ri(n);
          }
        return a;
      }
      n = r, r = n.parentNode;
    }
    return null;
  }
  function pe(n) {
    if (n = n[_n] || n[Da]) {
      var a = n.tag;
      if (a === 5 || a === 6 || a === 13 || a === 26 || a === 27 || a === 3)
        return n;
    }
    return null;
  }
  function Ie(n) {
    var a = n.tag;
    if (a === 5 || a === 26 || a === 27 || a === 6) return n.stateNode;
    throw Error(p(33));
  }
  function ot(n) {
    var a = n[yr];
    return a || (a = n[yr] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), a;
  }
  function Ke(n) {
    n[He] = !0;
  }
  var qe = /* @__PURE__ */ new Set(), dt = {};
  function qt(n, a) {
    Gi(n, a), Gi(n + "Capture", a);
  }
  function Gi(n, a) {
    for (dt[n] = a, n = 0; n < a.length; n++)
      qe.add(a[n]);
  }
  var wf = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), su = {}, xh = {};
  function Af(n) {
    return tn.call(xh, n) ? !0 : tn.call(su, n) ? !1 : wf.test(n) ? xh[n] = !0 : (su[n] = !0, !1);
  }
  function Ro(n, a, r) {
    if (Af(a))
      if (r === null) n.removeAttribute(a);
      else {
        switch (typeof r) {
          case "undefined":
          case "function":
          case "symbol":
            n.removeAttribute(a);
            return;
          case "boolean":
            var s = a.toLowerCase().slice(0, 5);
            if (s !== "data-" && s !== "aria-") {
              n.removeAttribute(a);
              return;
            }
        }
        n.setAttribute(a, "" + r);
      }
  }
  function fd(n, a, r) {
    if (r === null) n.removeAttribute(a);
    else {
      switch (typeof r) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(a);
          return;
      }
      n.setAttribute(a, "" + r);
    }
  }
  function Nr(n, a, r, s) {
    if (s === null) n.removeAttribute(r);
    else {
      switch (typeof s) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          n.removeAttribute(r);
          return;
      }
      n.setAttributeNS(a, r, "" + s);
    }
  }
  var lu, Zh;
  function Hs(n) {
    if (lu === void 0)
      try {
        throw Error();
      } catch (r) {
        var a = r.stack.trim().match(/\n( *(at )?)/);
        lu = a && a[1] || "", Zh = -1 < r.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < r.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + lu + n + Zh;
  }
  var wi = !1;
  function es(n, a) {
    if (!n || wi) return "";
    wi = !0;
    var r = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var s = {
        DetermineComponentFrameRoot: function() {
          try {
            if (a) {
              var ve = function() {
                throw Error();
              };
              if (Object.defineProperty(ve.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(ve, []);
                } catch (te) {
                  var $ = te;
                }
                Reflect.construct(n, [], ve);
              } else {
                try {
                  ve.call();
                } catch (te) {
                  $ = te;
                }
                n.call(ve.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (te) {
                $ = te;
              }
              (ve = n()) && typeof ve.catch == "function" && ve.catch(function() {
              });
            }
          } catch (te) {
            if (te && $ && typeof te.stack == "string")
              return [te.stack, $.stack];
          }
          return [null, null];
        }
      };
      s.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var m = Object.getOwnPropertyDescriptor(
        s.DetermineComponentFrameRoot,
        "name"
      );
      m && m.configurable && Object.defineProperty(
        s.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var f = s.DetermineComponentFrameRoot(), E = f[0], _ = f[1];
      if (E && _) {
        var O = E.split(`
`), K = _.split(`
`);
        for (m = s = 0; s < O.length && !O[s].includes("DetermineComponentFrameRoot"); )
          s++;
        for (; m < K.length && !K[m].includes(
          "DetermineComponentFrameRoot"
        ); )
          m++;
        if (s === O.length || m === K.length)
          for (s = O.length - 1, m = K.length - 1; 1 <= s && 0 <= m && O[s] !== K[m]; )
            m--;
        for (; 1 <= s && 0 <= m; s--, m--)
          if (O[s] !== K[m]) {
            if (s !== 1 || m !== 1)
              do
                if (s--, m--, 0 > m || O[s] !== K[m]) {
                  var me = `
` + O[s].replace(" at new ", " at ");
                  return n.displayName && me.includes("<anonymous>") && (me = me.replace("<anonymous>", n.displayName)), me;
                }
              while (1 <= s && 0 <= m);
            break;
          }
      }
    } finally {
      wi = !1, Error.prepareStackTrace = r;
    }
    return (r = n ? n.displayName || n.name : "") ? Hs(r) : "";
  }
  function zs(n) {
    switch (n.tag) {
      case 26:
      case 27:
      case 5:
        return Hs(n.type);
      case 16:
        return Hs("Lazy");
      case 13:
        return Hs("Suspense");
      case 19:
        return Hs("SuspenseList");
      case 0:
      case 15:
        return es(n.type, !1);
      case 11:
        return es(n.type.render, !1);
      case 1:
        return es(n.type, !0);
      case 31:
        return Hs("Activity");
      default:
        return "";
    }
  }
  function Oh(n) {
    try {
      var a = "";
      do
        a += zs(n), n = n.return;
      while (n);
      return a;
    } catch (r) {
      return `
Error generating stack: ` + r.message + `
` + r.stack;
    }
  }
  function Vi(n) {
    switch (typeof n) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function gd(n) {
    var a = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
  }
  function Bh(n) {
    var a = gd(n) ? "checked" : "value", r = Object.getOwnPropertyDescriptor(
      n.constructor.prototype,
      a
    ), s = "" + n[a];
    if (!n.hasOwnProperty(a) && typeof r < "u" && typeof r.get == "function" && typeof r.set == "function") {
      var m = r.get, f = r.set;
      return Object.defineProperty(n, a, {
        configurable: !0,
        get: function() {
          return m.call(this);
        },
        set: function(E) {
          s = "" + E, f.call(this, E);
        }
      }), Object.defineProperty(n, a, {
        enumerable: r.enumerable
      }), {
        getValue: function() {
          return s;
        },
        setValue: function(E) {
          s = "" + E;
        },
        stopTracking: function() {
          n._valueTracker = null, delete n[a];
        }
      };
    }
  }
  function ts(n) {
    n._valueTracker || (n._valueTracker = Bh(n));
  }
  function js(n) {
    if (!n) return !1;
    var a = n._valueTracker;
    if (!a) return !0;
    var r = a.getValue(), s = "";
    return n && (s = gd(n) ? n.checked ? "true" : "false" : n.value), n = s, n !== r ? (a.setValue(n), !0) : !1;
  }
  function ql(n) {
    if (n = n || (typeof document < "u" ? document : void 0), typeof n > "u") return null;
    try {
      return n.activeElement || n.body;
    } catch {
      return n.body;
    }
  }
  var ev = /[\n"\\]/g;
  function Za(n) {
    return n.replace(
      ev,
      function(a) {
        return "\\" + a.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function cu(n, a, r, s, m, f, E, _) {
    n.name = "", E != null && typeof E != "function" && typeof E != "symbol" && typeof E != "boolean" ? n.type = E : n.removeAttribute("type"), a != null ? E === "number" ? (a === 0 && n.value === "" || n.value != a) && (n.value = "" + Vi(a)) : n.value !== "" + Vi(a) && (n.value = "" + Vi(a)) : E !== "submit" && E !== "reset" || n.removeAttribute("value"), a != null ? vd(n, E, Vi(a)) : r != null ? vd(n, E, Vi(r)) : s != null && n.removeAttribute("value"), m == null && f != null && (n.defaultChecked = !!f), m != null && (n.checked = m && typeof m != "function" && typeof m != "symbol"), _ != null && typeof _ != "function" && typeof _ != "symbol" && typeof _ != "boolean" ? n.name = "" + Vi(_) : n.removeAttribute("name");
  }
  function du(n, a, r, s, m, f, E, _) {
    if (f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" && (n.type = f), a != null || r != null) {
      if (!(f !== "submit" && f !== "reset" || a != null))
        return;
      r = r != null ? "" + Vi(r) : "", a = a != null ? "" + Vi(a) : r, _ || a === n.value || (n.value = a), n.defaultValue = a;
    }
    s = s ?? m, s = typeof s != "function" && typeof s != "symbol" && !!s, n.checked = _ ? n.checked : !!s, n.defaultChecked = !!s, E != null && typeof E != "function" && typeof E != "symbol" && typeof E != "boolean" && (n.name = E);
  }
  function vd(n, a, r) {
    a === "number" && ql(n.ownerDocument) === n || n.defaultValue === "" + r || (n.defaultValue = "" + r);
  }
  function Gs(n, a, r, s) {
    if (n = n.options, a) {
      a = {};
      for (var m = 0; m < r.length; m++)
        a["$" + r[m]] = !0;
      for (r = 0; r < n.length; r++)
        m = a.hasOwnProperty("$" + n[r].value), n[r].selected !== m && (n[r].selected = m), m && s && (n[r].defaultSelected = !0);
    } else {
      for (r = "" + Vi(r), a = null, m = 0; m < n.length; m++) {
        if (n[m].value === r) {
          n[m].selected = !0, s && (n[m].defaultSelected = !0);
          return;
        }
        a !== null || n[m].disabled || (a = n[m]);
      }
      a !== null && (a.selected = !0);
    }
  }
  function wh(n, a, r) {
    if (a != null && (a = "" + Vi(a), a !== n.value && (n.value = a), r == null)) {
      n.defaultValue !== a && (n.defaultValue = a);
      return;
    }
    n.defaultValue = r != null ? "" + Vi(r) : "";
  }
  function Ah(n, a, r, s) {
    if (a == null) {
      if (s != null) {
        if (r != null) throw Error(p(92));
        if (De(s)) {
          if (1 < s.length) throw Error(p(93));
          s = s[0];
        }
        r = s;
      }
      r == null && (r = ""), a = r;
    }
    r = Vi(a), n.defaultValue = r, s = n.textContent, s === r && s !== "" && s !== null && (n.value = s);
  }
  function $l(n, a) {
    if (a) {
      var r = n.firstChild;
      if (r && r === n.lastChild && r.nodeType === 3) {
        r.nodeValue = a;
        return;
      }
    }
    n.textContent = a;
  }
  var Jf = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function uu(n, a, r) {
    var s = a.indexOf("--") === 0;
    r == null || typeof r == "boolean" || r === "" ? s ? n.setProperty(a, "") : a === "float" ? n.cssFloat = "" : n[a] = "" : s ? n.setProperty(a, r) : typeof r != "number" || r === 0 || Jf.has(a) ? a === "float" ? n.cssFloat = r : n[a] = ("" + r).trim() : n[a] = r + "px";
  }
  function Sd(n, a, r) {
    if (a != null && typeof a != "object")
      throw Error(p(62));
    if (n = n.style, r != null) {
      for (var s in r)
        !r.hasOwnProperty(s) || a != null && a.hasOwnProperty(s) || (s.indexOf("--") === 0 ? n.setProperty(s, "") : s === "float" ? n.cssFloat = "" : n[s] = "");
      for (var m in a)
        s = a[m], a.hasOwnProperty(m) && r[m] !== s && uu(n, m, s);
    } else
      for (var f in a)
        a.hasOwnProperty(f) && uu(n, f, a[f]);
  }
  function Ps(n) {
    if (n.indexOf("-") === -1) return !1;
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var tv = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Lf = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Rd(n) {
    return Lf.test("" + n) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : n;
  }
  var Ys = null;
  function hu(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var ec = null, tc = null;
  function If(n) {
    var a = pe(n);
    if (a && (n = a.stateNode)) {
      var r = n[Yn] || null;
      e: switch (n = a.stateNode, a.type) {
        case "input":
          if (cu(
            n,
            r.value,
            r.defaultValue,
            r.defaultValue,
            r.checked,
            r.defaultChecked,
            r.type,
            r.name
          ), a = r.name, r.type === "radio" && a != null) {
            for (r = n; r.parentNode; ) r = r.parentNode;
            for (r = r.querySelectorAll(
              'input[name="' + Za(
                "" + a
              ) + '"][type="radio"]'
            ), a = 0; a < r.length; a++) {
              var s = r[a];
              if (s !== n && s.form === n.form) {
                var m = s[Yn] || null;
                if (!m) throw Error(p(90));
                cu(
                  s,
                  m.value,
                  m.defaultValue,
                  m.defaultValue,
                  m.checked,
                  m.defaultChecked,
                  m.type,
                  m.name
                );
              }
            }
            for (a = 0; a < r.length; a++)
              s = r[a], s.form === n.form && js(s);
          }
          break e;
        case "textarea":
          wh(n, r.value, r.defaultValue);
          break e;
        case "select":
          a = r.value, a != null && Gs(n, !!r.multiple, a, !1);
      }
    }
  }
  var Jh = !1;
  function nc(n, a, r) {
    if (Jh) return n(a, r);
    Jh = !0;
    try {
      var s = n(a);
      return s;
    } finally {
      if (Jh = !1, (ec !== null || tc !== null) && (Cl(), ec && (a = ec, n = tc, tc = ec = null, If(a), n)))
        for (a = 0; a < n.length; a++) If(n[a]);
    }
  }
  function Xs(n, a) {
    var r = n.stateNode;
    if (r === null) return null;
    var s = r[Yn] || null;
    if (s === null) return null;
    r = s[a];
    e: switch (a) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (s = !s.disabled) || (n = n.type, s = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !s;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (r && typeof r != "function")
      throw Error(
        p(231, a, typeof r)
      );
    return r;
  }
  var br = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), mu = !1;
  if (br)
    try {
      var Eo = {};
      Object.defineProperty(Eo, "passive", {
        get: function() {
          mu = !0;
        }
      }), window.addEventListener("test", Eo, Eo), window.removeEventListener("test", Eo, Eo);
    } catch {
      mu = !1;
    }
  var Uo = null, ic = null, Ks = null;
  function Lh() {
    if (Ks) return Ks;
    var n, a = ic, r = a.length, s, m = "value" in Uo ? Uo.value : Uo.textContent, f = m.length;
    for (n = 0; n < r && a[n] === m[n]; n++) ;
    var E = r - n;
    for (s = 1; s <= E && a[r - s] === m[f - s]; s++) ;
    return Ks = m.slice(n, 1 < s ? 1 - s : void 0);
  }
  function mi(n) {
    var a = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && a === 13 && (n = 13)) : n = a, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function pu() {
    return !0;
  }
  function fu() {
    return !1;
  }
  function Ai(n) {
    function a(r, s, m, f, E) {
      this._reactName = r, this._targetInst = m, this.type = s, this.nativeEvent = f, this.target = E, this.currentTarget = null;
      for (var _ in n)
        n.hasOwnProperty(_) && (r = n[_], this[_] = r ? r(f) : f[_]);
      return this.isDefaultPrevented = (f.defaultPrevented != null ? f.defaultPrevented : f.returnValue === !1) ? pu : fu, this.isPropagationStopped = fu, this;
    }
    return V(a.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var r = this.nativeEvent;
        r && (r.preventDefault ? r.preventDefault() : typeof r.returnValue != "unknown" && (r.returnValue = !1), this.isDefaultPrevented = pu);
      },
      stopPropagation: function() {
        var r = this.nativeEvent;
        r && (r.stopPropagation ? r.stopPropagation() : typeof r.cancelBubble != "unknown" && (r.cancelBubble = !0), this.isPropagationStopped = pu);
      },
      persist: function() {
      },
      isPersistent: pu
    }), a;
  }
  var ns = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(n) {
      return n.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, gu = Ai(ns), Ed = V({}, ns, { view: 0, detail: 0 }), Wf = Ai(Ed), Ih, vu, Ud, qs = V({}, Ed, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: To,
    button: 0,
    buttons: 0,
    relatedTarget: function(n) {
      return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
    },
    movementX: function(n) {
      return "movementX" in n ? n.movementX : (n !== Ud && (Ud && n.type === "mousemove" ? (Ih = n.screenX - Ud.screenX, vu = n.screenY - Ud.screenY) : vu = Ih = 0, Ud = n), Ih);
    },
    movementY: function(n) {
      return "movementY" in n ? n.movementY : vu;
    }
  }), Wh = Ai(qs), Hf = V({}, qs, { dataTransfer: 0 }), zf = Ai(Hf), nv = V({}, Ed, { relatedTarget: 0 }), Hh = Ai(nv), iv = V({}, ns, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), av = Ai(iv), rv = V({}, ns, {
    clipboardData: function(n) {
      return "clipboardData" in n ? n.clipboardData : window.clipboardData;
    }
  }), Td = Ai(rv), jf = V({}, ns, { data: 0 }), zh = Ai(jf), Gf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Pf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, jh = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Yf(n) {
    var a = this.nativeEvent;
    return a.getModifierState ? a.getModifierState(n) : (n = jh[n]) ? !!a[n] : !1;
  }
  function To() {
    return Yf;
  }
  var $s = V({}, Ed, {
    key: function(n) {
      if (n.key) {
        var a = Gf[n.key] || n.key;
        if (a !== "Unidentified") return a;
      }
      return n.type === "keypress" ? (n = mi(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? Pf[n.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: To,
    charCode: function(n) {
      return n.type === "keypress" ? mi(n) : 0;
    },
    keyCode: function(n) {
      return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    },
    which: function(n) {
      return n.type === "keypress" ? mi(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
    }
  }), tr = Ai($s), ma = V({}, qs, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), yd = Ai(ma), Su = V({}, Ed, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: To
  }), Gh = Ai(Su), Pi = V({}, ns, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Xf = Ai(Pi), Ru = V({}, qs, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), el = Ai(Ru), Ph = V({}, ns, {
    newState: 0,
    oldState: 0
  }), Kf = Ai(Ph), qf = [9, 13, 27, 32], Nd = br && "CompositionEvent" in window, bd = null;
  br && "documentMode" in document && (bd = document.documentMode);
  var Yh = br && "TextEvent" in window && !bd, Vr = br && (!Nd || bd && 8 < bd && 11 >= bd), Xh = " ", Eu = !1;
  function Vd(n, a) {
    switch (n) {
      case "keyup":
        return qf.indexOf(a.keyCode) !== -1;
      case "keydown":
        return a.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function is(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var as = !1;
  function Kh(n, a) {
    switch (n) {
      case "compositionend":
        return is(a);
      case "keypress":
        return a.which !== 32 ? null : (Eu = !0, Xh);
      case "textInput":
        return n = a.data, n === Xh && Eu ? null : n;
      default:
        return null;
    }
  }
  function tl(n, a) {
    if (as)
      return n === "compositionend" || !Nd && Vd(n, a) ? (n = Lh(), Ks = ic = Uo = null, as = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(a.ctrlKey || a.altKey || a.metaKey) || a.ctrlKey && a.altKey) {
          if (a.char && 1 < a.char.length)
            return a.char;
          if (a.which) return String.fromCharCode(a.which);
        }
        return null;
      case "compositionend":
        return Vr && a.locale !== "ko" ? null : a.data;
      default:
        return null;
    }
  }
  var $f = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Uu(n) {
    var a = n && n.nodeName && n.nodeName.toLowerCase();
    return a === "input" ? !!$f[n.type] : a === "textarea";
  }
  function Tu(n, a, r, s) {
    ec ? tc ? tc.push(s) : tc = [s] : ec = s, a = Jc(a, "onChange"), 0 < a.length && (r = new gu(
      "onChange",
      "change",
      null,
      r,
      s
    ), n.push({ event: r, listeners: a }));
  }
  var nr = null, ir = null;
  function qh(n) {
    kl(n, 0);
  }
  function Cr(n) {
    var a = Ie(n);
    if (js(a)) return n;
  }
  function $h(n, a) {
    if (n === "change") return a;
  }
  var em = !1;
  if (br) {
    var nl;
    if (br) {
      var il = "oninput" in document;
      if (!il) {
        var tm = document.createElement("div");
        tm.setAttribute("oninput", "return;"), il = typeof tm.oninput == "function";
      }
      nl = il;
    } else nl = !1;
    em = nl && (!document.documentMode || 9 < document.documentMode);
  }
  function ac() {
    nr && (nr.detachEvent("onpropertychange", nm), ir = nr = null);
  }
  function nm(n) {
    if (n.propertyName === "value" && Cr(ir)) {
      var a = [];
      Tu(
        a,
        ir,
        n,
        hu(n)
      ), nc(qh, a);
    }
  }
  function yu(n, a, r) {
    n === "focusin" ? (ac(), nr = a, ir = r, nr.attachEvent("onpropertychange", nm)) : n === "focusout" && ac();
  }
  function rs(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown")
      return Cr(ir);
  }
  function yo(n, a) {
    if (n === "click") return Cr(a);
  }
  function im(n, a) {
    if (n === "input" || n === "change")
      return Cr(a);
  }
  function am(n, a) {
    return n === a && (n !== 0 || 1 / n === 1 / a) || n !== n && a !== a;
  }
  var pi = typeof Object.is == "function" ? Object.is : am;
  function os(n, a) {
    if (pi(n, a)) return !0;
    if (typeof n != "object" || n === null || typeof a != "object" || a === null)
      return !1;
    var r = Object.keys(n), s = Object.keys(a);
    if (r.length !== s.length) return !1;
    for (s = 0; s < r.length; s++) {
      var m = r[s];
      if (!tn.call(a, m) || !pi(n[m], a[m]))
        return !1;
    }
    return !0;
  }
  function ss(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function mn(n, a) {
    var r = ss(n);
    n = 0;
    for (var s; r; ) {
      if (r.nodeType === 3) {
        if (s = n + r.textContent.length, n <= a && s >= a)
          return { node: r, offset: a - n };
        n = s;
      }
      e: {
        for (; r; ) {
          if (r.nextSibling) {
            r = r.nextSibling;
            break e;
          }
          r = r.parentNode;
        }
        r = void 0;
      }
      r = ss(r);
    }
  }
  function Cd(n, a) {
    return n && a ? n === a ? !0 : n && n.nodeType === 3 ? !1 : a && a.nodeType === 3 ? Cd(n, a.parentNode) : "contains" in n ? n.contains(a) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(a) & 16) : !1 : !1;
  }
  function rm(n) {
    n = n != null && n.ownerDocument != null && n.ownerDocument.defaultView != null ? n.ownerDocument.defaultView : window;
    for (var a = ql(n.document); a instanceof n.HTMLIFrameElement; ) {
      try {
        var r = typeof a.contentWindow.location.href == "string";
      } catch {
        r = !1;
      }
      if (r) n = a.contentWindow;
      else break;
      a = ql(n.document);
    }
    return a;
  }
  function Fd(n) {
    var a = n && n.nodeName && n.nodeName.toLowerCase();
    return a && (a === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || a === "textarea" || n.contentEditable === "true");
  }
  var al = br && "documentMode" in document && 11 >= document.documentMode, Fr = null, ar = null, ls = null, rl = !1;
  function Nu(n, a, r) {
    var s = r.window === r ? r.document : r.nodeType === 9 ? r : r.ownerDocument;
    rl || Fr == null || Fr !== ql(s) || (s = Fr, "selectionStart" in s && Fd(s) ? s = { start: s.selectionStart, end: s.selectionEnd } : (s = (s.ownerDocument && s.ownerDocument.defaultView || window).getSelection(), s = {
      anchorNode: s.anchorNode,
      anchorOffset: s.anchorOffset,
      focusNode: s.focusNode,
      focusOffset: s.focusOffset
    }), ls && os(ls, s) || (ls = s, s = Jc(ar, "onSelect"), 0 < s.length && (a = new gu(
      "onSelect",
      "select",
      null,
      a,
      r
    ), n.push({ event: a, listeners: s }), a.target = Fr)));
  }
  function No(n, a) {
    var r = {};
    return r[n.toLowerCase()] = a.toLowerCase(), r["Webkit" + n] = "webkit" + a, r["Moz" + n] = "moz" + a, r;
  }
  var ol = {
    animationend: No("Animation", "AnimationEnd"),
    animationiteration: No("Animation", "AnimationIteration"),
    animationstart: No("Animation", "AnimationStart"),
    transitionrun: No("Transition", "TransitionRun"),
    transitionstart: No("Transition", "TransitionStart"),
    transitioncancel: No("Transition", "TransitionCancel"),
    transitionend: No("Transition", "TransitionEnd")
  }, Oa = {}, rr = {};
  br && (rr = document.createElement("div").style, "AnimationEvent" in window || (delete ol.animationend.animation, delete ol.animationiteration.animation, delete ol.animationstart.animation), "TransitionEvent" in window || delete ol.transitionend.transition);
  function _r(n) {
    if (Oa[n]) return Oa[n];
    if (!ol[n]) return n;
    var a = ol[n], r;
    for (r in a)
      if (a.hasOwnProperty(r) && r in rr)
        return Oa[n] = a[r];
    return n;
  }
  var e2 = _r("animationend"), om = _r("animationiteration"), t2 = _r("animationstart"), sm = _r("transitionrun"), bu = _r("transitionstart"), n2 = _r("transitioncancel"), lm = _r("transitionend"), cm = /* @__PURE__ */ new Map(), rc = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  rc.push("scrollEnd");
  function Ba(n, a) {
    cm.set(n, a), qt(a, [n]);
  }
  var dm = /* @__PURE__ */ new WeakMap();
  function pa(n, a) {
    if (typeof n == "object" && n !== null) {
      var r = dm.get(n);
      return r !== void 0 ? r : (a = {
        value: n,
        source: a,
        stack: Oh(a)
      }, dm.set(n, a), a);
    }
    return {
      value: n,
      source: a,
      stack: Oh(a)
    };
  }
  var Yi = [], cs = 0, Mr = 0;
  function or() {
    for (var n = cs, a = Mr = cs = 0; a < n; ) {
      var r = Yi[a];
      Yi[a++] = null;
      var s = Yi[a];
      Yi[a++] = null;
      var m = Yi[a];
      Yi[a++] = null;
      var f = Yi[a];
      if (Yi[a++] = null, s !== null && m !== null) {
        var E = s.pending;
        E === null ? m.next = m : (m.next = E.next, E.next = m), s.pending = m;
      }
      f !== 0 && sc(r, m, f);
    }
  }
  function ds(n, a, r, s) {
    Yi[cs++] = n, Yi[cs++] = a, Yi[cs++] = r, Yi[cs++] = s, Mr |= s, n.lanes |= s, n = n.alternate, n !== null && (n.lanes |= s);
  }
  function oc(n, a, r, s) {
    return ds(n, a, r, s), _d(n);
  }
  function kr(n, a) {
    return ds(n, null, null, a), _d(n);
  }
  function sc(n, a, r) {
    n.lanes |= r;
    var s = n.alternate;
    s !== null && (s.lanes |= r);
    for (var m = !1, f = n.return; f !== null; )
      f.childLanes |= r, s = f.alternate, s !== null && (s.childLanes |= r), f.tag === 22 && (n = f.stateNode, n === null || n._visibility & 1 || (m = !0)), n = f, f = f.return;
    return n.tag === 3 ? (f = n.stateNode, m && a !== null && (m = 31 - Ln(r), n = f.hiddenUpdates, s = n[m], s === null ? n[m] = [a] : s.push(a), a.lane = r | 536870912), f) : null;
  }
  function _d(n) {
    if (50 < xc)
      throw xc = 0, dp = null, Error(p(185));
    for (var a = n.return; a !== null; )
      n = a, a = n.return;
    return n.tag === 3 ? n.stateNode : null;
  }
  var lc = {};
  function i2(n, a, r, s) {
    this.tag = n, this.key = r, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = a, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = s, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Xi(n, a, r, s) {
    return new i2(n, a, r, s);
  }
  function Md(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function sr(n, a) {
    var r = n.alternate;
    return r === null ? (r = Xi(
      n.tag,
      a,
      n.key,
      n.mode
    ), r.elementType = n.elementType, r.type = n.type, r.stateNode = n.stateNode, r.alternate = n, n.alternate = r) : (r.pendingProps = a, r.type = n.type, r.flags = 0, r.subtreeFlags = 0, r.deletions = null), r.flags = n.flags & 65011712, r.childLanes = n.childLanes, r.lanes = n.lanes, r.child = n.child, r.memoizedProps = n.memoizedProps, r.memoizedState = n.memoizedState, r.updateQueue = n.updateQueue, a = n.dependencies, r.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }, r.sibling = n.sibling, r.index = n.index, r.ref = n.ref, r.refCleanup = n.refCleanup, r;
  }
  function Ft(n, a) {
    n.flags &= 65011714;
    var r = n.alternate;
    return r === null ? (n.childLanes = 0, n.lanes = a, n.child = null, n.subtreeFlags = 0, n.memoizedProps = null, n.memoizedState = null, n.updateQueue = null, n.dependencies = null, n.stateNode = null) : (n.childLanes = r.childLanes, n.lanes = r.lanes, n.child = r.child, n.subtreeFlags = 0, n.deletions = null, n.memoizedProps = r.memoizedProps, n.memoizedState = r.memoizedState, n.updateQueue = r.updateQueue, n.type = r.type, a = r.dependencies, n.dependencies = a === null ? null : {
      lanes: a.lanes,
      firstContext: a.firstContext
    }), n;
  }
  function Me(n, a, r, s, m, f) {
    var E = 0;
    if (s = n, typeof n == "function") Md(n) && (E = 1);
    else if (typeof n == "string")
      E = B2(
        n,
        r,
        ye.current
      ) ? 26 : n === "html" || n === "head" || n === "body" ? 27 : 5;
    else
      e: switch (n) {
        case Se:
          return n = Xi(31, r, a, m), n.elementType = Se, n.lanes = f, n;
        case Ne:
          return wa(r.children, m, f, a);
        case Ee:
          E = 8, m |= 24;
          break;
        case Fe:
          return n = Xi(12, r, a, m | 2), n.elementType = Fe, n.lanes = f, n;
        case z:
          return n = Xi(13, r, a, m), n.elementType = z, n.lanes = f, n;
        case Ce:
          return n = Xi(19, r, a, m), n.elementType = Ce, n.lanes = f, n;
        default:
          if (typeof n == "object" && n !== null)
            switch (n.$$typeof) {
              case he:
              case Ve:
                E = 10;
                break e;
              case ie:
                E = 9;
                break e;
              case _e:
                E = 11;
                break e;
              case Re:
                E = 14;
                break e;
              case Ue:
                E = 16, s = null;
                break e;
            }
          E = 29, r = Error(
            p(130, n === null ? "null" : typeof n, "")
          ), s = null;
      }
    return a = Xi(E, r, a, m), a.elementType = n, a.type = s, a.lanes = f, a;
  }
  function wa(n, a, r, s) {
    return n = Xi(7, n, s, a), n.lanes = r, n;
  }
  function cc(n, a, r) {
    return n = Xi(6, n, null, a), n.lanes = r, n;
  }
  function Vn(n, a, r) {
    return a = Xi(
      4,
      n.children !== null ? n.children : [],
      n.key,
      a
    ), a.lanes = r, a.stateNode = {
      containerInfo: n.containerInfo,
      pendingChildren: null,
      implementation: n.implementation
    }, a;
  }
  var us = [], hs = 0, kd = null, dc = 0, Aa = [], Ki = 0, bo = null, lr = 1, Mn = "";
  function At(n, a) {
    us[hs++] = dc, us[hs++] = kd, kd = n, dc = a;
  }
  function Vu(n, a, r) {
    Aa[Ki++] = lr, Aa[Ki++] = Mn, Aa[Ki++] = bo, bo = n;
    var s = lr;
    n = Mn;
    var m = 32 - Ln(s) - 1;
    s &= ~(1 << m), r += 1;
    var f = 32 - Ln(a) + m;
    if (30 < f) {
      var E = m - m % 5;
      f = (s & (1 << E) - 1).toString(32), s >>= E, m -= E, lr = 1 << 32 - Ln(a) + m | r << m | s, Mn = f + n;
    } else
      lr = 1 << f | r << m | s, Mn = n;
  }
  function sl(n) {
    n.return !== null && (At(n, 1), Vu(n, 1, 0));
  }
  function Qr(n) {
    for (; n === kd; )
      kd = us[--hs], us[hs] = null, dc = us[--hs], us[hs] = null;
    for (; n === bo; )
      bo = Aa[--Ki], Aa[Ki] = null, Mn = Aa[--Ki], Aa[Ki] = null, lr = Aa[--Ki], Aa[Ki] = null;
  }
  var Wn = null, zt = null, Wt = !1, Ja = null, La = !1, ll = Error(p(519));
  function Vo(n) {
    var a = Error(p(418, ""));
    throw mc(pa(a, n)), ll;
  }
  function Qd(n) {
    var a = n.stateNode, r = n.type, s = n.memoizedProps;
    switch (a[_n] = n, a[Yn] = s, r) {
      case "dialog":
        Ut("cancel", a), Ut("close", a);
        break;
      case "iframe":
      case "object":
      case "embed":
        Ut("load", a);
        break;
      case "video":
      case "audio":
        for (r = 0; r < v0.length; r++)
          Ut(v0[r], a);
        break;
      case "source":
        Ut("error", a);
        break;
      case "img":
      case "image":
      case "link":
        Ut("error", a), Ut("load", a);
        break;
      case "details":
        Ut("toggle", a);
        break;
      case "input":
        Ut("invalid", a), du(
          a,
          s.value,
          s.defaultValue,
          s.checked,
          s.defaultChecked,
          s.type,
          s.name,
          !0
        ), ts(a);
        break;
      case "select":
        Ut("invalid", a);
        break;
      case "textarea":
        Ut("invalid", a), Ah(a, s.value, s.defaultValue, s.children), ts(a);
    }
    r = s.children, typeof r != "string" && typeof r != "number" && typeof r != "bigint" || a.textContent === "" + r || s.suppressHydrationWarning === !0 || Np(a.textContent, r) ? (s.popover != null && (Ut("beforetoggle", a), Ut("toggle", a)), s.onScroll != null && Ut("scroll", a), s.onScrollEnd != null && Ut("scrollend", a), s.onClick != null && (a.onclick = O1), a = !0) : a = !1, a || Vo(n);
  }
  function um(n) {
    for (Wn = n.return; Wn; )
      switch (Wn.tag) {
        case 5:
        case 13:
          La = !1;
          return;
        case 27:
        case 3:
          La = !0;
          return;
        default:
          Wn = Wn.return;
      }
  }
  function uc(n) {
    if (n !== Wn) return !1;
    if (!Wt) return um(n), Wt = !0, !1;
    var a = n.tag, r;
    if ((r = a !== 3 && a !== 27) && ((r = a === 5) && (r = n.type, r = !(r !== "form" && r !== "button") || qr(n.type, n.memoizedProps)), r = !r), r && zt && Vo(n), um(n), a === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(p(317));
      e: {
        for (n = n.nextSibling, a = 0; n; ) {
          if (n.nodeType === 8)
            if (r = n.data, r === "/$") {
              if (a === 0) {
                zt = pr(n.nextSibling);
                break e;
              }
              a--;
            } else
              r !== "$" && r !== "$!" && r !== "$?" || a++;
          n = n.nextSibling;
        }
        zt = null;
      }
    } else
      a === 27 ? (a = zt, Ms(n.type) ? (n = ks, ks = null, zt = n) : zt = a) : zt = Wn ? pr(n.stateNode.nextSibling) : null;
    return !0;
  }
  function hc() {
    zt = Wn = null, Wt = !1;
  }
  function hm() {
    var n = Ja;
    return n !== null && (ia === null ? ia = n : ia.push.apply(
      ia,
      n
    ), Ja = null), n;
  }
  function mc(n) {
    Ja === null ? Ja = [n] : Ja.push(n);
  }
  var Dd = H(null), Co = null, cr = null;
  function Fo(n, a, r) {
    de(Dd, a._currentValue), a._currentValue = r;
  }
  function Dr(n) {
    n._currentValue = Dd.current, L(Dd);
  }
  function Cu(n, a, r) {
    for (; n !== null; ) {
      var s = n.alternate;
      if ((n.childLanes & a) !== a ? (n.childLanes |= a, s !== null && (s.childLanes |= a)) : s !== null && (s.childLanes & a) !== a && (s.childLanes |= a), n === r) break;
      n = n.return;
    }
  }
  function mm(n, a, r, s) {
    var m = n.child;
    for (m !== null && (m.return = n); m !== null; ) {
      var f = m.dependencies;
      if (f !== null) {
        var E = m.child;
        f = f.firstContext;
        e: for (; f !== null; ) {
          var _ = f;
          f = m;
          for (var O = 0; O < a.length; O++)
            if (_.context === a[O]) {
              f.lanes |= r, _ = f.alternate, _ !== null && (_.lanes |= r), Cu(
                f.return,
                r,
                n
              ), s || (E = null);
              break e;
            }
          f = _.next;
        }
      } else if (m.tag === 18) {
        if (E = m.return, E === null) throw Error(p(341));
        E.lanes |= r, f = E.alternate, f !== null && (f.lanes |= r), Cu(E, r, n), E = null;
      } else E = m.child;
      if (E !== null) E.return = m;
      else
        for (E = m; E !== null; ) {
          if (E === n) {
            E = null;
            break;
          }
          if (m = E.sibling, m !== null) {
            m.return = E.return, E = m;
            break;
          }
          E = E.return;
        }
      m = E;
    }
  }
  function pc(n, a, r, s) {
    n = null;
    for (var m = a, f = !1; m !== null; ) {
      if (!f) {
        if ((m.flags & 524288) !== 0) f = !0;
        else if ((m.flags & 262144) !== 0) break;
      }
      if (m.tag === 10) {
        var E = m.alternate;
        if (E === null) throw Error(p(387));
        if (E = E.memoizedProps, E !== null) {
          var _ = m.type;
          pi(m.pendingProps.value, E.value) || (n !== null ? n.push(_) : n = [_]);
        }
      } else if (m === Bt.current) {
        if (E = m.alternate, E === null) throw Error(p(387));
        E.memoizedState.memoizedState !== m.memoizedState.memoizedState && (n !== null ? n.push(sa) : n = [sa]);
      }
      m = m.return;
    }
    n !== null && mm(
      a,
      n,
      r,
      s
    ), a.flags |= 262144;
  }
  function xd(n) {
    for (n = n.firstContext; n !== null; ) {
      if (!pi(
        n.context._currentValue,
        n.memoizedValue
      ))
        return !0;
      n = n.next;
    }
    return !1;
  }
  function ms(n) {
    Co = n, cr = null, n = n.dependencies, n !== null && (n.firstContext = null);
  }
  function ai(n) {
    return pm(Co, n);
  }
  function Zd(n, a) {
    return Co === null && ms(n), pm(n, a);
  }
  function pm(n, a) {
    var r = a._currentValue;
    if (a = { context: a, memoizedValue: r, next: null }, cr === null) {
      if (n === null) throw Error(p(308));
      cr = a, n.dependencies = { lanes: 0, firstContext: a }, n.flags |= 524288;
    } else cr = cr.next = a;
    return r;
  }
  var fc = typeof AbortController < "u" ? AbortController : function() {
    var n = [], a = this.signal = {
      aborted: !1,
      addEventListener: function(r, s) {
        n.push(s);
      }
    };
    this.abort = function() {
      a.aborted = !0, n.forEach(function(r) {
        return r();
      });
    };
  }, Fu = d.unstable_scheduleCallback, a2 = d.unstable_NormalPriority, Xn = {
    $$typeof: Ve,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function gc() {
    return {
      controller: new fc(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function xr(n) {
    n.refCount--, n.refCount === 0 && Fu(a2, function() {
      n.controller.abort();
    });
  }
  var ps = null, Od = 0, Ia = 0, Kn = null;
  function _u(n, a) {
    if (ps === null) {
      var r = ps = [];
      Od = 0, Ia = Ml(), Kn = {
        status: "pending",
        value: void 0,
        then: function(s) {
          r.push(s);
        }
      };
    }
    return Od++, a.then(Mu, Mu), a;
  }
  function Mu() {
    if (--Od === 0 && ps !== null) {
      Kn !== null && (Kn.status = "fulfilled");
      var n = ps;
      ps = null, Ia = 0, Kn = null;
      for (var a = 0; a < n.length; a++) (0, n[a])();
    }
  }
  function r2(n, a) {
    var r = [], s = {
      status: "pending",
      value: null,
      reason: null,
      then: function(m) {
        r.push(m);
      }
    };
    return n.then(
      function() {
        s.status = "fulfilled", s.value = a;
        for (var m = 0; m < r.length; m++) (0, r[m])(a);
      },
      function(m) {
        for (s.status = "rejected", s.reason = m, m = 0; m < r.length; m++)
          (0, r[m])(void 0);
      }
    ), s;
  }
  var ku = Z.S;
  Z.S = function(n, a) {
    typeof a == "object" && a !== null && typeof a.then == "function" && _u(n, a), ku !== null && ku(n, a);
  };
  var Zr = H(null);
  function Bd() {
    var n = Zr.current;
    return n !== null ? n : dn.pooledCache;
  }
  function cl(n, a) {
    a === null ? de(Zr, Zr.current) : de(Zr, a.pool);
  }
  function Qu() {
    var n = Bd();
    return n === null ? null : { parent: Xn._currentValue, pool: n };
  }
  var fs = Error(p(460)), Du = Error(p(474)), wd = Error(p(542)), xu = { then: function() {
  } };
  function Zu(n) {
    return n = n.status, n === "fulfilled" || n === "rejected";
  }
  function Ad() {
  }
  function fm(n, a, r) {
    switch (r = n[r], r === void 0 ? n.push(a) : r !== a && (a.then(Ad, Ad), a = r), a.status) {
      case "fulfilled":
        return a.value;
      case "rejected":
        throw n = a.reason, vm(n), n;
      default:
        if (typeof a.status == "string") a.then(Ad, Ad);
        else {
          if (n = dn, n !== null && 100 < n.shellSuspendCounter)
            throw Error(p(482));
          n = a, n.status = "pending", n.then(
            function(s) {
              if (a.status === "pending") {
                var m = a;
                m.status = "fulfilled", m.value = s;
              }
            },
            function(s) {
              if (a.status === "pending") {
                var m = a;
                m.status = "rejected", m.reason = s;
              }
            }
          );
        }
        switch (a.status) {
          case "fulfilled":
            return a.value;
          case "rejected":
            throw n = a.reason, vm(n), n;
        }
        throw dl = a, fs;
    }
  }
  var dl = null;
  function gm() {
    if (dl === null) throw Error(p(459));
    var n = dl;
    return dl = null, n;
  }
  function vm(n) {
    if (n === fs || n === wd)
      throw Error(p(483));
  }
  var Or = !1;
  function Ou(n) {
    n.updateQueue = {
      baseState: n.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Bu(n, a) {
    n = n.updateQueue, a.updateQueue === n && (a.updateQueue = {
      baseState: n.baseState,
      firstBaseUpdate: n.firstBaseUpdate,
      lastBaseUpdate: n.lastBaseUpdate,
      shared: n.shared,
      callbacks: null
    });
  }
  function qi(n) {
    return { lane: n, tag: 0, payload: null, callback: null, next: null };
  }
  function Br(n, a, r) {
    var s = n.updateQueue;
    if (s === null) return null;
    if (s = s.shared, (Xt & 2) !== 0) {
      var m = s.pending;
      return m === null ? a.next = a : (a.next = m.next, m.next = a), s.pending = a, a = _d(n), sc(n, null, r), a;
    }
    return ds(n, s, a, r), _d(n);
  }
  function ul(n, a, r) {
    if (a = a.updateQueue, a !== null && (a = a.shared, (r & 4194048) !== 0)) {
      var s = a.lanes;
      s &= n.pendingLanes, r |= s, a.lanes = r, ct(n, r);
    }
  }
  function Sm(n, a) {
    var r = n.updateQueue, s = n.alternate;
    if (s !== null && (s = s.updateQueue, r === s)) {
      var m = null, f = null;
      if (r = r.firstBaseUpdate, r !== null) {
        do {
          var E = {
            lane: r.lane,
            tag: r.tag,
            payload: r.payload,
            callback: null,
            next: null
          };
          f === null ? m = f = E : f = f.next = E, r = r.next;
        } while (r !== null);
        f === null ? m = f = a : f = f.next = a;
      } else m = f = a;
      r = {
        baseState: s.baseState,
        firstBaseUpdate: m,
        lastBaseUpdate: f,
        shared: s.shared,
        callbacks: s.callbacks
      }, n.updateQueue = r;
      return;
    }
    n = r.lastBaseUpdate, n === null ? r.firstBaseUpdate = a : n.next = a, r.lastBaseUpdate = a;
  }
  var Rm = !1;
  function vc() {
    if (Rm) {
      var n = Kn;
      if (n !== null) throw n;
    }
  }
  function _o(n, a, r, s) {
    Rm = !1;
    var m = n.updateQueue;
    Or = !1;
    var f = m.firstBaseUpdate, E = m.lastBaseUpdate, _ = m.shared.pending;
    if (_ !== null) {
      m.shared.pending = null;
      var O = _, K = O.next;
      O.next = null, E === null ? f = K : E.next = K, E = O;
      var me = n.alternate;
      me !== null && (me = me.updateQueue, _ = me.lastBaseUpdate, _ !== E && (_ === null ? me.firstBaseUpdate = K : _.next = K, me.lastBaseUpdate = O));
    }
    if (f !== null) {
      var ve = m.baseState;
      E = 0, me = K = O = null, _ = f;
      do {
        var $ = _.lane & -536870913, te = $ !== _.lane;
        if (te ? (Zt & $) === $ : (s & $) === $) {
          $ !== 0 && $ === Ia && (Rm = !0), me !== null && (me = me.next = {
            lane: 0,
            tag: _.tag,
            payload: _.payload,
            callback: null,
            next: null
          });
          e: {
            var it = n, at = _;
            $ = a;
            var Gt = r;
            switch (at.tag) {
              case 1:
                if (it = at.payload, typeof it == "function") {
                  ve = it.call(Gt, ve, $);
                  break e;
                }
                ve = it;
                break e;
              case 3:
                it.flags = it.flags & -65537 | 128;
              case 0:
                if (it = at.payload, $ = typeof it == "function" ? it.call(Gt, ve, $) : it, $ == null) break e;
                ve = V({}, ve, $);
                break e;
              case 2:
                Or = !0;
            }
          }
          $ = _.callback, $ !== null && (n.flags |= 64, te && (n.flags |= 8192), te = m.callbacks, te === null ? m.callbacks = [$] : te.push($));
        } else
          te = {
            lane: $,
            tag: _.tag,
            payload: _.payload,
            callback: _.callback,
            next: null
          }, me === null ? (K = me = te, O = ve) : me = me.next = te, E |= $;
        if (_ = _.next, _ === null) {
          if (_ = m.shared.pending, _ === null)
            break;
          te = _, _ = te.next, te.next = null, m.lastBaseUpdate = te, m.shared.pending = null;
        }
      } while (!0);
      me === null && (O = ve), m.baseState = O, m.firstBaseUpdate = K, m.lastBaseUpdate = me, f === null && (m.shared.lanes = 0), Oo |= E, n.lanes = E, n.memoizedState = ve;
    }
  }
  function wu(n, a) {
    if (typeof n != "function")
      throw Error(p(191, n));
    n.call(a);
  }
  function Jd(n, a) {
    var r = n.callbacks;
    if (r !== null)
      for (n.callbacks = null, n = 0; n < r.length; n++)
        wu(r[n], a);
  }
  var hl = H(null), Ld = H(0);
  function ri(n, a) {
    n = Zo, de(Ld, n), de(hl, a), Zo = n | a.baseLanes;
  }
  function Sc() {
    de(Ld, Zo), de(hl, hl.current);
  }
  function Rc() {
    Zo = Ld.current, L(hl), L(Ld);
  }
  var Wa = 0, Et = null, Yt = null, Cn = null, Id = !1, fa = !1, gs = !1, dr = 0, ga = 0, Mo = null, Em = 0;
  function Fn() {
    throw Error(p(321));
  }
  function Au(n, a) {
    if (a === null) return !1;
    for (var r = 0; r < a.length && r < n.length; r++)
      if (!pi(n[r], a[r])) return !1;
    return !0;
  }
  function Ju(n, a, r, s, m, f) {
    return Wa = f, Et = a, a.memoizedState = null, a.updateQueue = null, a.lanes = 0, Z.H = n === null || n.memoizedState === null ? Zm : Om, gs = !1, f = r(s, m), gs = !1, fa && (f = Um(
      a,
      r,
      s,
      m
    )), vs(n), f;
  }
  function vs(n) {
    Z.H = i1;
    var a = Yt !== null && Yt.next !== null;
    if (Wa = 0, Cn = Yt = Et = null, Id = !1, ga = 0, Mo = null, a) throw Error(p(300));
    n === null || qn || (n = n.dependencies, n !== null && xd(n) && (qn = !0));
  }
  function Um(n, a, r, s) {
    Et = n;
    var m = 0;
    do {
      if (fa && (Mo = null), ga = 0, fa = !1, 25 <= m) throw Error(p(301));
      if (m += 1, Cn = Yt = null, n.updateQueue != null) {
        var f = n.updateQueue;
        f.lastEffect = null, f.events = null, f.stores = null, f.memoCache != null && (f.memoCache.index = 0);
      }
      Z.H = ko, f = a(r, s);
    } while (fa);
    return f;
  }
  function o2() {
    var n = Z.H, a = n.useState()[0];
    return a = typeof a.then == "function" ? Hd(a) : a, n = n.useState()[0], (Yt !== null ? Yt.memoizedState : null) !== n && (Et.flags |= 1024), a;
  }
  function Lu() {
    var n = dr !== 0;
    return dr = 0, n;
  }
  function Ec(n, a, r) {
    a.updateQueue = n.updateQueue, a.flags &= -2053, n.lanes &= ~r;
  }
  function Iu(n) {
    if (Id) {
      for (n = n.memoizedState; n !== null; ) {
        var a = n.queue;
        a !== null && (a.pending = null), n = n.next;
      }
      Id = !1;
    }
    Wa = 0, Cn = Yt = Et = null, fa = !1, ga = dr = 0, Mo = null;
  }
  function Ci() {
    var n = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Cn === null ? Et.memoizedState = Cn = n : Cn = Cn.next = n, Cn;
  }
  function kn() {
    if (Yt === null) {
      var n = Et.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = Yt.next;
    var a = Cn === null ? Et.memoizedState : Cn.next;
    if (a !== null)
      Cn = a, Yt = n;
    else {
      if (n === null)
        throw Et.alternate === null ? Error(p(467)) : Error(p(310));
      Yt = n, n = {
        memoizedState: Yt.memoizedState,
        baseState: Yt.baseState,
        baseQueue: Yt.baseQueue,
        queue: Yt.queue,
        next: null
      }, Cn === null ? Et.memoizedState = Cn = n : Cn = Cn.next = n;
    }
    return Cn;
  }
  function Wd() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Hd(n) {
    var a = ga;
    return ga += 1, Mo === null && (Mo = []), n = fm(Mo, n, a), a = Et, (Cn === null ? a.memoizedState : Cn.next) === null && (a = a.alternate, Z.H = a === null || a.memoizedState === null ? Zm : Om), n;
  }
  function jn(n) {
    if (n !== null && typeof n == "object") {
      if (typeof n.then == "function") return Hd(n);
      if (n.$$typeof === Ve) return ai(n);
    }
    throw Error(p(438, String(n)));
  }
  function Wu(n) {
    var a = null, r = Et.updateQueue;
    if (r !== null && (a = r.memoCache), a == null) {
      var s = Et.alternate;
      s !== null && (s = s.updateQueue, s !== null && (s = s.memoCache, s != null && (a = {
        data: s.data.map(function(m) {
          return m.slice();
        }),
        index: 0
      })));
    }
    if (a == null && (a = { data: [], index: 0 }), r === null && (r = Wd(), Et.updateQueue = r), r.memoCache = a, r = a.data[a.index], r === void 0)
      for (r = a.data[a.index] = Array(n), s = 0; s < n; s++)
        r[s] = xe;
    return a.index++, r;
  }
  function wr(n, a) {
    return typeof a == "function" ? a(n) : a;
  }
  function zd(n) {
    var a = kn();
    return Hu(a, Yt, n);
  }
  function Hu(n, a, r) {
    var s = n.queue;
    if (s === null) throw Error(p(311));
    s.lastRenderedReducer = r;
    var m = n.baseQueue, f = s.pending;
    if (f !== null) {
      if (m !== null) {
        var E = m.next;
        m.next = f.next, f.next = E;
      }
      a.baseQueue = m = f, s.pending = null;
    }
    if (f = n.baseState, m === null) n.memoizedState = f;
    else {
      a = m.next;
      var _ = E = null, O = null, K = a, me = !1;
      do {
        var ve = K.lane & -536870913;
        if (ve !== K.lane ? (Zt & ve) === ve : (Wa & ve) === ve) {
          var $ = K.revertLane;
          if ($ === 0)
            O !== null && (O = O.next = {
              lane: 0,
              revertLane: 0,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }), ve === Ia && (me = !0);
          else if ((Wa & $) === $) {
            K = K.next, $ === Ia && (me = !0);
            continue;
          } else
            ve = {
              lane: 0,
              revertLane: K.revertLane,
              action: K.action,
              hasEagerState: K.hasEagerState,
              eagerState: K.eagerState,
              next: null
            }, O === null ? (_ = O = ve, E = f) : O = O.next = ve, Et.lanes |= $, Oo |= $;
          ve = K.action, gs && r(f, ve), f = K.hasEagerState ? K.eagerState : r(f, ve);
        } else
          $ = {
            lane: ve,
            revertLane: K.revertLane,
            action: K.action,
            hasEagerState: K.hasEagerState,
            eagerState: K.eagerState,
            next: null
          }, O === null ? (_ = O = $, E = f) : O = O.next = $, Et.lanes |= ve, Oo |= ve;
        K = K.next;
      } while (K !== null && K !== a);
      if (O === null ? E = f : O.next = _, !pi(f, n.memoizedState) && (qn = !0, me && (r = Kn, r !== null)))
        throw r;
      n.memoizedState = f, n.baseState = E, n.baseQueue = O, s.lastRenderedState = f;
    }
    return m === null && (s.lanes = 0), [n.memoizedState, s.dispatch];
  }
  function zu(n) {
    var a = kn(), r = a.queue;
    if (r === null) throw Error(p(311));
    r.lastRenderedReducer = n;
    var s = r.dispatch, m = r.pending, f = a.memoizedState;
    if (m !== null) {
      r.pending = null;
      var E = m = m.next;
      do
        f = n(f, E.action), E = E.next;
      while (E !== m);
      pi(f, a.memoizedState) || (qn = !0), a.memoizedState = f, a.baseQueue === null && (a.baseState = f), r.lastRenderedState = f;
    }
    return [f, s];
  }
  function jd(n, a, r) {
    var s = Et, m = kn(), f = Wt;
    if (f) {
      if (r === void 0) throw Error(p(407));
      r = r();
    } else r = a();
    var E = !pi(
      (Yt || m).memoizedState,
      r
    );
    E && (m.memoizedState = r, qn = !0), m = m.queue;
    var _ = ym.bind(null, s, m, n);
    if (on(2048, 8, _, [n]), m.getSnapshot !== a || E || Cn !== null && Cn.memoizedState.tag & 1) {
      if (s.flags |= 2048, $i(
        9,
        Yd(),
        Tm.bind(
          null,
          s,
          m,
          r,
          a
        ),
        null
      ), dn === null) throw Error(p(349));
      f || (Wa & 124) !== 0 || ju(s, a, r);
    }
    return r;
  }
  function ju(n, a, r) {
    n.flags |= 16384, n = { getSnapshot: a, value: r }, a = Et.updateQueue, a === null ? (a = Wd(), Et.updateQueue = a, a.stores = [n]) : (r = a.stores, r === null ? a.stores = [n] : r.push(n));
  }
  function Tm(n, a, r, s) {
    a.value = r, a.getSnapshot = s, Nm(a) && Gu(n);
  }
  function ym(n, a, r) {
    return r(function() {
      Nm(a) && Gu(n);
    });
  }
  function Nm(n) {
    var a = n.getSnapshot;
    n = n.value;
    try {
      var r = a();
      return !pi(n, r);
    } catch {
      return !0;
    }
  }
  function Gu(n) {
    var a = kr(n, 2);
    a !== null && Ra(a, n, 2);
  }
  function Gd(n) {
    var a = Ci();
    if (typeof n == "function") {
      var r = n;
      if (n = r(), gs) {
        un(!0);
        try {
          r();
        } finally {
          un(!1);
        }
      }
    }
    return a.memoizedState = a.baseState = n, a.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: wr,
      lastRenderedState: n
    }, a;
  }
  function Pu(n, a, r, s) {
    return n.baseState = r, Hu(
      n,
      Yt,
      typeof s == "function" ? s : wr
    );
  }
  function s2(n, a, r, s, m) {
    if (gl(n)) throw Error(p(485));
    if (n = a.action, n !== null) {
      var f = {
        payload: m,
        action: n,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(E) {
          f.listeners.push(E);
        }
      };
      Z.T !== null ? r(!0) : f.isTransition = !1, s(f), r = a.pending, r === null ? (f.next = a.pending = f, Yu(a, f)) : (f.next = r.next, a.pending = r.next = f);
    }
  }
  function Yu(n, a) {
    var r = a.action, s = a.payload, m = n.state;
    if (a.isTransition) {
      var f = Z.T, E = {};
      Z.T = E;
      try {
        var _ = r(m, s), O = Z.S;
        O !== null && O(E, _), Pd(n, a, _);
      } catch (K) {
        Ku(n, a, K);
      } finally {
        Z.T = f;
      }
    } else
      try {
        f = r(m, s), Pd(n, a, f);
      } catch (K) {
        Ku(n, a, K);
      }
  }
  function Pd(n, a, r) {
    r !== null && typeof r == "object" && typeof r.then == "function" ? r.then(
      function(s) {
        Xu(n, a, s);
      },
      function(s) {
        return Ku(n, a, s);
      }
    ) : Xu(n, a, r);
  }
  function Xu(n, a, r) {
    a.status = "fulfilled", a.value = r, bm(a), n.state = r, a = n.pending, a !== null && (r = a.next, r === a ? n.pending = null : (r = r.next, a.next = r, Yu(n, r)));
  }
  function Ku(n, a, r) {
    var s = n.pending;
    if (n.pending = null, s !== null) {
      s = s.next;
      do
        a.status = "rejected", a.reason = r, bm(a), a = a.next;
      while (a !== s);
    }
    n.action = null;
  }
  function bm(n) {
    n = n.listeners;
    for (var a = 0; a < n.length; a++) (0, n[a])();
  }
  function qu(n, a) {
    return a;
  }
  function Vm(n, a) {
    if (Wt) {
      var r = dn.formState;
      if (r !== null) {
        e: {
          var s = Et;
          if (Wt) {
            if (zt) {
              t: {
                for (var m = zt, f = La; m.nodeType !== 8; ) {
                  if (!f) {
                    m = null;
                    break t;
                  }
                  if (m = pr(
                    m.nextSibling
                  ), m === null) {
                    m = null;
                    break t;
                  }
                }
                f = m.data, m = f === "F!" || f === "F" ? m : null;
              }
              if (m) {
                zt = pr(
                  m.nextSibling
                ), s = m.data === "F!";
                break e;
              }
            }
            Vo(s);
          }
          s = !1;
        }
        s && (a = r[0]);
      }
    }
    return r = Ci(), r.memoizedState = r.baseState = a, s = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: qu,
      lastRenderedState: a
    }, r.queue = s, r = Dm.bind(
      null,
      Et,
      s
    ), s.dispatch = r, s = Gd(!1), f = qd.bind(
      null,
      Et,
      !1,
      s.queue
    ), s = Ci(), m = {
      state: a,
      dispatch: null,
      action: n,
      pending: null
    }, s.queue = m, r = s2.bind(
      null,
      Et,
      m,
      f,
      r
    ), m.dispatch = r, s.memoizedState = n, [a, r, !1];
  }
  function Ar(n) {
    var a = kn();
    return $u(a, Yt, n);
  }
  function $u(n, a, r) {
    if (a = Hu(
      n,
      a,
      qu
    )[0], n = zd(wr)[0], typeof a == "object" && a !== null && typeof a.then == "function")
      try {
        var s = Hd(a);
      } catch (E) {
        throw E === fs ? wd : E;
      }
    else s = a;
    a = kn();
    var m = a.queue, f = m.dispatch;
    return r !== a.memoizedState && (Et.flags |= 2048, $i(
      9,
      Yd(),
      ov.bind(null, m, r),
      null
    )), [s, f, n];
  }
  function ov(n, a) {
    n.action = a;
  }
  function e1(n) {
    var a = kn(), r = Yt;
    if (r !== null)
      return $u(a, r, n);
    kn(), a = a.memoizedState, r = kn();
    var s = r.queue.dispatch;
    return r.memoizedState = n, [a, s, !1];
  }
  function $i(n, a, r, s) {
    return n = { tag: n, create: r, deps: s, inst: a, next: null }, a = Et.updateQueue, a === null && (a = Wd(), Et.updateQueue = a), r = a.lastEffect, r === null ? a.lastEffect = n.next = n : (s = r.next, r.next = n, n.next = s, a.lastEffect = n), n;
  }
  function Yd() {
    return { destroy: void 0, resource: void 0 };
  }
  function Xd() {
    return kn().memoizedState;
  }
  function Ss(n, a, r, s) {
    var m = Ci();
    s = s === void 0 ? null : s, Et.flags |= n, m.memoizedState = $i(
      1 | a,
      Yd(),
      r,
      s
    );
  }
  function on(n, a, r, s) {
    var m = kn();
    s = s === void 0 ? null : s;
    var f = m.memoizedState.inst;
    Yt !== null && s !== null && Au(s, Yt.memoizedState.deps) ? m.memoizedState = $i(a, f, r, s) : (Et.flags |= n, m.memoizedState = $i(
      1 | a,
      f,
      r,
      s
    ));
  }
  function l2(n, a) {
    Ss(8390656, 8, n, a);
  }
  function c2(n, a) {
    on(2048, 8, n, a);
  }
  function Cm(n, a) {
    return on(4, 2, n, a);
  }
  function ur(n, a) {
    return on(4, 4, n, a);
  }
  function Fm(n, a) {
    if (typeof a == "function") {
      n = n();
      var r = a(n);
      return function() {
        typeof r == "function" ? r() : a(null);
      };
    }
    if (a != null)
      return n = n(), a.current = n, function() {
        a.current = null;
      };
  }
  function t1(n, a, r) {
    r = r != null ? r.concat([n]) : null, on(4, 4, Fm.bind(null, a, n), r);
  }
  function ml() {
  }
  function pl(n, a) {
    var r = kn();
    a = a === void 0 ? null : a;
    var s = r.memoizedState;
    return a !== null && Au(a, s[1]) ? s[0] : (r.memoizedState = [n, a], n);
  }
  function _m(n, a) {
    var r = kn();
    a = a === void 0 ? null : a;
    var s = r.memoizedState;
    if (a !== null && Au(a, s[1]))
      return s[0];
    if (s = n(), gs) {
      un(!0);
      try {
        n();
      } finally {
        un(!1);
      }
    }
    return r.memoizedState = [s, a], s;
  }
  function Kd(n, a, r) {
    return r === void 0 || (Wa & 1073741824) !== 0 ? n.memoizedState = a : (n.memoizedState = r, n = up(), Et.lanes |= n, Oo |= n, r);
  }
  function Mm(n, a, r, s) {
    return pi(r, a) ? r : hl.current !== null ? (n = Kd(n, r, s), pi(n, a) || (qn = !0), n) : (Wa & 42) === 0 ? (qn = !0, n.memoizedState = r) : (n = up(), Et.lanes |= n, Oo |= n, a);
  }
  function d2(n, a, r, s, m) {
    var f = X.p;
    X.p = f !== 0 && 8 > f ? f : 8;
    var E = Z.T, _ = {};
    Z.T = _, qd(n, !1, a, r);
    try {
      var O = m(), K = Z.S;
      if (K !== null && K(_, O), O !== null && typeof O == "object" && typeof O.then == "function") {
        var me = r2(
          O,
          s
        );
        fl(
          n,
          a,
          me,
          Sa(n)
        );
      } else
        fl(
          n,
          a,
          s,
          Sa(n)
        );
    } catch (ve) {
      fl(
        n,
        a,
        { then: function() {
        }, status: "rejected", reason: ve },
        Sa()
      );
    } finally {
      X.p = f, Z.T = E;
    }
  }
  function sv() {
  }
  function n1(n, a, r, s) {
    if (n.tag !== 5) throw Error(p(476));
    var m = u2(n).queue;
    d2(
      n,
      m,
      a,
      ae,
      r === null ? sv : function() {
        return Uc(n), r(s);
      }
    );
  }
  function u2(n) {
    var a = n.memoizedState;
    if (a !== null) return a;
    a = {
      memoizedState: ae,
      baseState: ae,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wr,
        lastRenderedState: ae
      },
      next: null
    };
    var r = {};
    return a.next = {
      memoizedState: r,
      baseState: r,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wr,
        lastRenderedState: r
      },
      next: null
    }, n.memoizedState = a, n = n.alternate, n !== null && (n.memoizedState = a), a;
  }
  function Uc(n) {
    var a = u2(n).next.queue;
    fl(n, a, {}, Sa());
  }
  function Ha() {
    return ai(sa);
  }
  function km() {
    return kn().memoizedState;
  }
  function h2() {
    return kn().memoizedState;
  }
  function m2(n) {
    for (var a = n.return; a !== null; ) {
      switch (a.tag) {
        case 24:
        case 3:
          var r = Sa();
          n = qi(r);
          var s = Br(a, n, r);
          s !== null && (Ra(s, a, r), ul(s, a, r)), a = { cache: gc() }, n.payload = a;
          return;
      }
      a = a.return;
    }
  }
  function Qm(n, a, r) {
    var s = Sa();
    r = {
      lane: s,
      revertLane: 0,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, gl(n) ? p2(a, r) : (r = oc(n, a, r, s), r !== null && (Ra(r, n, s), xm(r, a, s)));
  }
  function Dm(n, a, r) {
    var s = Sa();
    fl(n, a, r, s);
  }
  function fl(n, a, r, s) {
    var m = {
      lane: s,
      revertLane: 0,
      action: r,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (gl(n)) p2(a, m);
    else {
      var f = n.alternate;
      if (n.lanes === 0 && (f === null || f.lanes === 0) && (f = a.lastRenderedReducer, f !== null))
        try {
          var E = a.lastRenderedState, _ = f(E, r);
          if (m.hasEagerState = !0, m.eagerState = _, pi(_, E))
            return ds(n, a, m, 0), dn === null && or(), !1;
        } catch {
        } finally {
        }
      if (r = oc(n, a, m, s), r !== null)
        return Ra(r, n, s), xm(r, a, s), !0;
    }
    return !1;
  }
  function qd(n, a, r, s) {
    if (s = {
      lane: 2,
      revertLane: Ml(),
      action: s,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, gl(n)) {
      if (a) throw Error(p(479));
    } else
      a = oc(
        n,
        r,
        s,
        2
      ), a !== null && Ra(a, n, 2);
  }
  function gl(n) {
    var a = n.alternate;
    return n === Et || a !== null && a === Et;
  }
  function p2(n, a) {
    fa = Id = !0;
    var r = n.pending;
    r === null ? a.next = a : (a.next = r.next, r.next = a), n.pending = a;
  }
  function xm(n, a, r) {
    if ((r & 4194048) !== 0) {
      var s = a.lanes;
      s &= n.pendingLanes, r |= s, a.lanes = r, ct(n, r);
    }
  }
  var i1 = {
    readContext: ai,
    use: jn,
    useCallback: Fn,
    useContext: Fn,
    useEffect: Fn,
    useImperativeHandle: Fn,
    useLayoutEffect: Fn,
    useInsertionEffect: Fn,
    useMemo: Fn,
    useReducer: Fn,
    useRef: Fn,
    useState: Fn,
    useDebugValue: Fn,
    useDeferredValue: Fn,
    useTransition: Fn,
    useSyncExternalStore: Fn,
    useId: Fn,
    useHostTransitionStatus: Fn,
    useFormState: Fn,
    useActionState: Fn,
    useOptimistic: Fn,
    useMemoCache: Fn,
    useCacheRefresh: Fn
  }, Zm = {
    readContext: ai,
    use: jn,
    useCallback: function(n, a) {
      return Ci().memoizedState = [
        n,
        a === void 0 ? null : a
      ], n;
    },
    useContext: ai,
    useEffect: l2,
    useImperativeHandle: function(n, a, r) {
      r = r != null ? r.concat([n]) : null, Ss(
        4194308,
        4,
        Fm.bind(null, a, n),
        r
      );
    },
    useLayoutEffect: function(n, a) {
      return Ss(4194308, 4, n, a);
    },
    useInsertionEffect: function(n, a) {
      Ss(4, 2, n, a);
    },
    useMemo: function(n, a) {
      var r = Ci();
      a = a === void 0 ? null : a;
      var s = n();
      if (gs) {
        un(!0);
        try {
          n();
        } finally {
          un(!1);
        }
      }
      return r.memoizedState = [s, a], s;
    },
    useReducer: function(n, a, r) {
      var s = Ci();
      if (r !== void 0) {
        var m = r(a);
        if (gs) {
          un(!0);
          try {
            r(a);
          } finally {
            un(!1);
          }
        }
      } else m = a;
      return s.memoizedState = s.baseState = m, n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: n,
        lastRenderedState: m
      }, s.queue = n, n = n.dispatch = Qm.bind(
        null,
        Et,
        n
      ), [s.memoizedState, n];
    },
    useRef: function(n) {
      var a = Ci();
      return n = { current: n }, a.memoizedState = n;
    },
    useState: function(n) {
      n = Gd(n);
      var a = n.queue, r = Dm.bind(null, Et, a);
      return a.dispatch = r, [n.memoizedState, r];
    },
    useDebugValue: ml,
    useDeferredValue: function(n, a) {
      var r = Ci();
      return Kd(r, n, a);
    },
    useTransition: function() {
      var n = Gd(!1);
      return n = d2.bind(
        null,
        Et,
        n.queue,
        !0,
        !1
      ), Ci().memoizedState = n, [!1, n];
    },
    useSyncExternalStore: function(n, a, r) {
      var s = Et, m = Ci();
      if (Wt) {
        if (r === void 0)
          throw Error(p(407));
        r = r();
      } else {
        if (r = a(), dn === null)
          throw Error(p(349));
        (Zt & 124) !== 0 || ju(s, a, r);
      }
      m.memoizedState = r;
      var f = { value: r, getSnapshot: a };
      return m.queue = f, l2(ym.bind(null, s, f, n), [
        n
      ]), s.flags |= 2048, $i(
        9,
        Yd(),
        Tm.bind(
          null,
          s,
          f,
          r,
          a
        ),
        null
      ), r;
    },
    useId: function() {
      var n = Ci(), a = dn.identifierPrefix;
      if (Wt) {
        var r = Mn, s = lr;
        r = (s & ~(1 << 32 - Ln(s) - 1)).toString(32) + r, a = "«" + a + "R" + r, r = dr++, 0 < r && (a += "H" + r.toString(32)), a += "»";
      } else
        r = Em++, a = "«" + a + "r" + r.toString(32) + "»";
      return n.memoizedState = a;
    },
    useHostTransitionStatus: Ha,
    useFormState: Vm,
    useActionState: Vm,
    useOptimistic: function(n) {
      var a = Ci();
      a.memoizedState = a.baseState = n;
      var r = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return a.queue = r, a = qd.bind(
        null,
        Et,
        !0,
        r
      ), r.dispatch = a, [n, a];
    },
    useMemoCache: Wu,
    useCacheRefresh: function() {
      return Ci().memoizedState = m2.bind(
        null,
        Et
      );
    }
  }, Om = {
    readContext: ai,
    use: jn,
    useCallback: pl,
    useContext: ai,
    useEffect: c2,
    useImperativeHandle: t1,
    useInsertionEffect: Cm,
    useLayoutEffect: ur,
    useMemo: _m,
    useReducer: zd,
    useRef: Xd,
    useState: function() {
      return zd(wr);
    },
    useDebugValue: ml,
    useDeferredValue: function(n, a) {
      var r = kn();
      return Mm(
        r,
        Yt.memoizedState,
        n,
        a
      );
    },
    useTransition: function() {
      var n = zd(wr)[0], a = kn().memoizedState;
      return [
        typeof n == "boolean" ? n : Hd(n),
        a
      ];
    },
    useSyncExternalStore: jd,
    useId: km,
    useHostTransitionStatus: Ha,
    useFormState: Ar,
    useActionState: Ar,
    useOptimistic: function(n, a) {
      var r = kn();
      return Pu(r, Yt, n, a);
    },
    useMemoCache: Wu,
    useCacheRefresh: h2
  }, ko = {
    readContext: ai,
    use: jn,
    useCallback: pl,
    useContext: ai,
    useEffect: c2,
    useImperativeHandle: t1,
    useInsertionEffect: Cm,
    useLayoutEffect: ur,
    useMemo: _m,
    useReducer: zu,
    useRef: Xd,
    useState: function() {
      return zu(wr);
    },
    useDebugValue: ml,
    useDeferredValue: function(n, a) {
      var r = kn();
      return Yt === null ? Kd(r, n, a) : Mm(
        r,
        Yt.memoizedState,
        n,
        a
      );
    },
    useTransition: function() {
      var n = zu(wr)[0], a = kn().memoizedState;
      return [
        typeof n == "boolean" ? n : Hd(n),
        a
      ];
    },
    useSyncExternalStore: jd,
    useId: km,
    useHostTransitionStatus: Ha,
    useFormState: e1,
    useActionState: e1,
    useOptimistic: function(n, a) {
      var r = kn();
      return Yt !== null ? Pu(r, Yt, n, a) : (r.baseState = n, [n, r.queue.dispatch]);
    },
    useMemoCache: Wu,
    useCacheRefresh: h2
  }, vl = null, Tc = 0;
  function a1(n) {
    var a = Tc;
    return Tc += 1, vl === null && (vl = []), fm(vl, n, a);
  }
  function Sl(n, a) {
    a = a.props.ref, n.ref = a !== void 0 ? a : null;
  }
  function Fi(n, a) {
    throw a.$$typeof === N ? Error(p(525)) : (n = Object.prototype.toString.call(a), Error(
      p(
        31,
        n === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : n
      )
    ));
  }
  function Bm(n) {
    var a = n._init;
    return a(n._payload);
  }
  function ea(n) {
    function a(G, W) {
      if (n) {
        var Y = G.deletions;
        Y === null ? (G.deletions = [W], G.flags |= 16) : Y.push(W);
      }
    }
    function r(G, W) {
      if (!n) return null;
      for (; W !== null; )
        a(G, W), W = W.sibling;
      return null;
    }
    function s(G) {
      for (var W = /* @__PURE__ */ new Map(); G !== null; )
        G.key !== null ? W.set(G.key, G) : W.set(G.index, G), G = G.sibling;
      return W;
    }
    function m(G, W) {
      return G = sr(G, W), G.index = 0, G.sibling = null, G;
    }
    function f(G, W, Y) {
      return G.index = Y, n ? (Y = G.alternate, Y !== null ? (Y = Y.index, Y < W ? (G.flags |= 67108866, W) : Y) : (G.flags |= 67108866, W)) : (G.flags |= 1048576, W);
    }
    function E(G) {
      return n && G.alternate === null && (G.flags |= 67108866), G;
    }
    function _(G, W, Y, ge) {
      return W === null || W.tag !== 6 ? (W = cc(Y, G.mode, ge), W.return = G, W) : (W = m(W, Y), W.return = G, W);
    }
    function O(G, W, Y, ge) {
      var ze = Y.type;
      return ze === Ne ? me(
        G,
        W,
        Y.props.children,
        ge,
        Y.key
      ) : W !== null && (W.elementType === ze || typeof ze == "object" && ze !== null && ze.$$typeof === Ue && Bm(ze) === W.type) ? (W = m(W, Y.props), Sl(W, Y), W.return = G, W) : (W = Me(
        Y.type,
        Y.key,
        Y.props,
        null,
        G.mode,
        ge
      ), Sl(W, Y), W.return = G, W);
    }
    function K(G, W, Y, ge) {
      return W === null || W.tag !== 4 || W.stateNode.containerInfo !== Y.containerInfo || W.stateNode.implementation !== Y.implementation ? (W = Vn(Y, G.mode, ge), W.return = G, W) : (W = m(W, Y.children || []), W.return = G, W);
    }
    function me(G, W, Y, ge, ze) {
      return W === null || W.tag !== 7 ? (W = wa(
        Y,
        G.mode,
        ge,
        ze
      ), W.return = G, W) : (W = m(W, Y), W.return = G, W);
    }
    function ve(G, W, Y) {
      if (typeof W == "string" && W !== "" || typeof W == "number" || typeof W == "bigint")
        return W = cc(
          "" + W,
          G.mode,
          Y
        ), W.return = G, W;
      if (typeof W == "object" && W !== null) {
        switch (W.$$typeof) {
          case b:
            return Y = Me(
              W.type,
              W.key,
              W.props,
              null,
              G.mode,
              Y
            ), Sl(Y, W), Y.return = G, Y;
          case A:
            return W = Vn(
              W,
              G.mode,
              Y
            ), W.return = G, W;
          case Ue:
            var ge = W._init;
            return W = ge(W._payload), ve(G, W, Y);
        }
        if (De(W) || fe(W))
          return W = wa(
            W,
            G.mode,
            Y,
            null
          ), W.return = G, W;
        if (typeof W.then == "function")
          return ve(G, a1(W), Y);
        if (W.$$typeof === Ve)
          return ve(
            G,
            Zd(G, W),
            Y
          );
        Fi(G, W);
      }
      return null;
    }
    function $(G, W, Y, ge) {
      var ze = W !== null ? W.key : null;
      if (typeof Y == "string" && Y !== "" || typeof Y == "number" || typeof Y == "bigint")
        return ze !== null ? null : _(G, W, "" + Y, ge);
      if (typeof Y == "object" && Y !== null) {
        switch (Y.$$typeof) {
          case b:
            return Y.key === ze ? O(G, W, Y, ge) : null;
          case A:
            return Y.key === ze ? K(G, W, Y, ge) : null;
          case Ue:
            return ze = Y._init, Y = ze(Y._payload), $(G, W, Y, ge);
        }
        if (De(Y) || fe(Y))
          return ze !== null ? null : me(G, W, Y, ge, null);
        if (typeof Y.then == "function")
          return $(
            G,
            W,
            a1(Y),
            ge
          );
        if (Y.$$typeof === Ve)
          return $(
            G,
            W,
            Zd(G, Y),
            ge
          );
        Fi(G, Y);
      }
      return null;
    }
    function te(G, W, Y, ge, ze) {
      if (typeof ge == "string" && ge !== "" || typeof ge == "number" || typeof ge == "bigint")
        return G = G.get(Y) || null, _(W, G, "" + ge, ze);
      if (typeof ge == "object" && ge !== null) {
        switch (ge.$$typeof) {
          case b:
            return G = G.get(
              ge.key === null ? Y : ge.key
            ) || null, O(W, G, ge, ze);
          case A:
            return G = G.get(
              ge.key === null ? Y : ge.key
            ) || null, K(W, G, ge, ze);
          case Ue:
            var _t = ge._init;
            return ge = _t(ge._payload), te(
              G,
              W,
              Y,
              ge,
              ze
            );
        }
        if (De(ge) || fe(ge))
          return G = G.get(Y) || null, me(W, G, ge, ze, null);
        if (typeof ge.then == "function")
          return te(
            G,
            W,
            Y,
            a1(ge),
            ze
          );
        if (ge.$$typeof === Ve)
          return te(
            G,
            W,
            Y,
            Zd(W, ge),
            ze
          );
        Fi(W, ge);
      }
      return null;
    }
    function it(G, W, Y, ge) {
      for (var ze = null, _t = null, et = W, lt = W = 0, li = null; et !== null && lt < Y.length; lt++) {
        et.index > lt ? (li = et, et = null) : li = et.sibling;
        var It = $(
          G,
          et,
          Y[lt],
          ge
        );
        if (It === null) {
          et === null && (et = li);
          break;
        }
        n && et && It.alternate === null && a(G, et), W = f(It, W, lt), _t === null ? ze = It : _t.sibling = It, _t = It, et = li;
      }
      if (lt === Y.length)
        return r(G, et), Wt && At(G, lt), ze;
      if (et === null) {
        for (; lt < Y.length; lt++)
          et = ve(G, Y[lt], ge), et !== null && (W = f(
            et,
            W,
            lt
          ), _t === null ? ze = et : _t.sibling = et, _t = et);
        return Wt && At(G, lt), ze;
      }
      for (et = s(et); lt < Y.length; lt++)
        li = te(
          et,
          G,
          lt,
          Y[lt],
          ge
        ), li !== null && (n && li.alternate !== null && et.delete(
          li.key === null ? lt : li.key
        ), W = f(
          li,
          W,
          lt
        ), _t === null ? ze = li : _t.sibling = li, _t = li);
      return n && et.forEach(function(Os) {
        return a(G, Os);
      }), Wt && At(G, lt), ze;
    }
    function at(G, W, Y, ge) {
      if (Y == null) throw Error(p(151));
      for (var ze = null, _t = null, et = W, lt = W = 0, li = null, It = Y.next(); et !== null && !It.done; lt++, It = Y.next()) {
        et.index > lt ? (li = et, et = null) : li = et.sibling;
        var Os = $(G, et, It.value, ge);
        if (Os === null) {
          et === null && (et = li);
          break;
        }
        n && et && Os.alternate === null && a(G, et), W = f(Os, W, lt), _t === null ? ze = Os : _t.sibling = Os, _t = Os, et = li;
      }
      if (It.done)
        return r(G, et), Wt && At(G, lt), ze;
      if (et === null) {
        for (; !It.done; lt++, It = Y.next())
          It = ve(G, It.value, ge), It !== null && (W = f(It, W, lt), _t === null ? ze = It : _t.sibling = It, _t = It);
        return Wt && At(G, lt), ze;
      }
      for (et = s(et); !It.done; lt++, It = Y.next())
        It = te(et, G, lt, It.value, ge), It !== null && (n && It.alternate !== null && et.delete(It.key === null ? lt : It.key), W = f(It, W, lt), _t === null ? ze = It : _t.sibling = It, _t = It);
      return n && et.forEach(function(Rv) {
        return a(G, Rv);
      }), Wt && At(G, lt), ze;
    }
    function Gt(G, W, Y, ge) {
      if (typeof Y == "object" && Y !== null && Y.type === Ne && Y.key === null && (Y = Y.props.children), typeof Y == "object" && Y !== null) {
        switch (Y.$$typeof) {
          case b:
            e: {
              for (var ze = Y.key; W !== null; ) {
                if (W.key === ze) {
                  if (ze = Y.type, ze === Ne) {
                    if (W.tag === 7) {
                      r(
                        G,
                        W.sibling
                      ), ge = m(
                        W,
                        Y.props.children
                      ), ge.return = G, G = ge;
                      break e;
                    }
                  } else if (W.elementType === ze || typeof ze == "object" && ze !== null && ze.$$typeof === Ue && Bm(ze) === W.type) {
                    r(
                      G,
                      W.sibling
                    ), ge = m(W, Y.props), Sl(ge, Y), ge.return = G, G = ge;
                    break e;
                  }
                  r(G, W);
                  break;
                } else a(G, W);
                W = W.sibling;
              }
              Y.type === Ne ? (ge = wa(
                Y.props.children,
                G.mode,
                ge,
                Y.key
              ), ge.return = G, G = ge) : (ge = Me(
                Y.type,
                Y.key,
                Y.props,
                null,
                G.mode,
                ge
              ), Sl(ge, Y), ge.return = G, G = ge);
            }
            return E(G);
          case A:
            e: {
              for (ze = Y.key; W !== null; ) {
                if (W.key === ze)
                  if (W.tag === 4 && W.stateNode.containerInfo === Y.containerInfo && W.stateNode.implementation === Y.implementation) {
                    r(
                      G,
                      W.sibling
                    ), ge = m(W, Y.children || []), ge.return = G, G = ge;
                    break e;
                  } else {
                    r(G, W);
                    break;
                  }
                else a(G, W);
                W = W.sibling;
              }
              ge = Vn(Y, G.mode, ge), ge.return = G, G = ge;
            }
            return E(G);
          case Ue:
            return ze = Y._init, Y = ze(Y._payload), Gt(
              G,
              W,
              Y,
              ge
            );
        }
        if (De(Y))
          return it(
            G,
            W,
            Y,
            ge
          );
        if (fe(Y)) {
          if (ze = fe(Y), typeof ze != "function") throw Error(p(150));
          return Y = ze.call(Y), at(
            G,
            W,
            Y,
            ge
          );
        }
        if (typeof Y.then == "function")
          return Gt(
            G,
            W,
            a1(Y),
            ge
          );
        if (Y.$$typeof === Ve)
          return Gt(
            G,
            W,
            Zd(G, Y),
            ge
          );
        Fi(G, Y);
      }
      return typeof Y == "string" && Y !== "" || typeof Y == "number" || typeof Y == "bigint" ? (Y = "" + Y, W !== null && W.tag === 6 ? (r(G, W.sibling), ge = m(W, Y), ge.return = G, G = ge) : (r(G, W), ge = cc(Y, G.mode, ge), ge.return = G, G = ge), E(G)) : r(G, W);
    }
    return function(G, W, Y, ge) {
      try {
        Tc = 0;
        var ze = Gt(
          G,
          W,
          Y,
          ge
        );
        return vl = null, ze;
      } catch (et) {
        if (et === fs || et === wd) throw et;
        var _t = Xi(29, et, null, G.mode);
        return _t.lanes = ge, _t.return = G, _t;
      } finally {
      }
    };
  }
  var Rl = ea(!0), Jr = ea(!1), va = H(null), _i = null;
  function Qo(n) {
    var a = n.alternate;
    de(sn, sn.current & 1), de(va, n), _i === null && (a === null || hl.current !== null || a.memoizedState !== null) && (_i = n);
  }
  function Lr(n) {
    if (n.tag === 22) {
      if (de(sn, sn.current), de(va, n), _i === null) {
        var a = n.alternate;
        a !== null && a.memoizedState !== null && (_i = n);
      }
    } else Ir();
  }
  function Ir() {
    de(sn, sn.current), de(va, va.current);
  }
  function hr(n) {
    L(va), _i === n && (_i = null), L(sn);
  }
  var sn = H(0);
  function $d(n) {
    for (var a = n; a !== null; ) {
      if (a.tag === 13) {
        var r = a.memoizedState;
        if (r !== null && (r = r.dehydrated, r === null || r.data === "$?" || T0(r)))
          return a;
      } else if (a.tag === 19 && a.memoizedProps.revealOrder !== void 0) {
        if ((a.flags & 128) !== 0) return a;
      } else if (a.child !== null) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === n) break;
      for (; a.sibling === null; ) {
        if (a.return === null || a.return === n) return null;
        a = a.return;
      }
      a.sibling.return = a.return, a = a.sibling;
    }
    return null;
  }
  function Rs(n, a, r, s) {
    a = n.memoizedState, r = r(s, a), r = r == null ? a : V({}, a, r), n.memoizedState = r, n.lanes === 0 && (n.updateQueue.baseState = r);
  }
  var r1 = {
    enqueueSetState: function(n, a, r) {
      n = n._reactInternals;
      var s = Sa(), m = qi(s);
      m.payload = a, r != null && (m.callback = r), a = Br(n, m, s), a !== null && (Ra(a, n, s), ul(a, n, s));
    },
    enqueueReplaceState: function(n, a, r) {
      n = n._reactInternals;
      var s = Sa(), m = qi(s);
      m.tag = 1, m.payload = a, r != null && (m.callback = r), a = Br(n, m, s), a !== null && (Ra(a, n, s), ul(a, n, s));
    },
    enqueueForceUpdate: function(n, a) {
      n = n._reactInternals;
      var r = Sa(), s = qi(r);
      s.tag = 2, a != null && (s.callback = a), a = Br(n, s, r), a !== null && (Ra(a, n, r), ul(a, n, r));
    }
  };
  function yc(n, a, r, s, m, f, E) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(s, f, E) : a.prototype && a.prototype.isPureReactComponent ? !os(r, s) || !os(m, f) : !0;
  }
  function El(n, a, r, s) {
    n = a.state, typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(r, s), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(r, s), a.state !== n && r1.enqueueReplaceState(a, a.state, null);
  }
  function Es(n, a) {
    var r = a;
    if ("ref" in a) {
      r = {};
      for (var s in a)
        s !== "ref" && (r[s] = a[s]);
    }
    if (n = n.defaultProps) {
      r === a && (r = V({}, r));
      for (var m in n)
        r[m] === void 0 && (r[m] = n[m]);
    }
    return r;
  }
  var e0 = typeof reportError == "function" ? reportError : function(n) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var a = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof n == "object" && n !== null && typeof n.message == "string" ? String(n.message) : String(n),
        error: n
      });
      if (!window.dispatchEvent(a)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", n);
      return;
    }
    console.error(n);
  };
  function Nc(n) {
    e0(n);
  }
  function wm(n) {
    console.error(n);
  }
  function t0(n) {
    e0(n);
  }
  function n0(n, a) {
    try {
      var r = n.onUncaughtError;
      r(a.value, { componentStack: a.stack });
    } catch (s) {
      setTimeout(function() {
        throw s;
      });
    }
  }
  function Am(n, a, r) {
    try {
      var s = n.onCaughtError;
      s(r.value, {
        componentStack: r.stack,
        errorBoundary: a.tag === 1 ? a.stateNode : null
      });
    } catch (m) {
      setTimeout(function() {
        throw m;
      });
    }
  }
  function Jm(n, a, r) {
    return r = qi(r), r.tag = 3, r.payload = { element: null }, r.callback = function() {
      n0(n, a);
    }, r;
  }
  function Lm(n) {
    return n = qi(n), n.tag = 3, n;
  }
  function ta(n, a, r, s) {
    var m = r.type.getDerivedStateFromError;
    if (typeof m == "function") {
      var f = s.value;
      n.payload = function() {
        return m(f);
      }, n.callback = function() {
        Am(a, r, s);
      };
    }
    var E = r.stateNode;
    E !== null && typeof E.componentDidCatch == "function" && (n.callback = function() {
      Am(a, r, s), typeof m != "function" && (Ns === null ? Ns = /* @__PURE__ */ new Set([this]) : Ns.add(this));
      var _ = s.stack;
      this.componentDidCatch(s.value, {
        componentStack: _ !== null ? _ : ""
      });
    });
  }
  function f2(n, a, r, s, m) {
    if (r.flags |= 32768, s !== null && typeof s == "object" && typeof s.then == "function") {
      if (a = r.alternate, a !== null && pc(
        a,
        r,
        m,
        !0
      ), r = va.current, r !== null) {
        switch (r.tag) {
          case 13:
            return _i === null ? _l() : r.alternate === null && Zn === 0 && (Zn = 3), r.flags &= -257, r.flags |= 65536, r.lanes = m, s === xu ? r.flags |= 16384 : (a = r.updateQueue, a === null ? r.updateQueue = /* @__PURE__ */ new Set([s]) : a.add(s), k1(n, s, m)), !1;
          case 22:
            return r.flags |= 65536, s === xu ? r.flags |= 16384 : (a = r.updateQueue, a === null ? (a = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([s])
            }, r.updateQueue = a) : (r = a.retryQueue, r === null ? a.retryQueue = /* @__PURE__ */ new Set([s]) : r.add(s)), k1(n, s, m)), !1;
        }
        throw Error(p(435, r.tag));
      }
      return k1(n, s, m), _l(), !1;
    }
    if (Wt)
      return a = va.current, a !== null ? ((a.flags & 65536) === 0 && (a.flags |= 256), a.flags |= 65536, a.lanes = m, s !== ll && (n = Error(p(422), { cause: s }), mc(pa(n, r)))) : (s !== ll && (a = Error(p(423), {
        cause: s
      }), mc(
        pa(a, r)
      )), n = n.current.alternate, n.flags |= 65536, m &= -m, n.lanes |= m, s = pa(s, r), m = Jm(
        n.stateNode,
        s,
        m
      ), Sm(n, m), Zn !== 4 && (Zn = 2)), !1;
    var f = Error(p(520), { cause: s });
    if (f = pa(f, r), kc === null ? kc = [f] : kc.push(f), Zn !== 4 && (Zn = 2), a === null) return !0;
    s = pa(s, r), r = a;
    do {
      switch (r.tag) {
        case 3:
          return r.flags |= 65536, n = m & -m, r.lanes |= n, n = Jm(r.stateNode, s, n), Sm(r, n), !1;
        case 1:
          if (a = r.type, f = r.stateNode, (r.flags & 128) === 0 && (typeof a.getDerivedStateFromError == "function" || f !== null && typeof f.componentDidCatch == "function" && (Ns === null || !Ns.has(f))))
            return r.flags |= 65536, m &= -m, r.lanes |= m, m = Lm(m), ta(
              m,
              n,
              r,
              s
            ), Sm(r, m), !1;
      }
      r = r.return;
    } while (r !== null);
    return !1;
  }
  var Qn = Error(p(461)), qn = !1;
  function oi(n, a, r, s) {
    a.child = n === null ? Jr(a, null, r, s) : Rl(
      a,
      n.child,
      r,
      s
    );
  }
  function g2(n, a, r, s, m) {
    r = r.render;
    var f = a.ref;
    if ("ref" in s) {
      var E = {};
      for (var _ in s)
        _ !== "ref" && (E[_] = s[_]);
    } else E = s;
    return ms(a), s = Ju(
      n,
      a,
      r,
      E,
      f,
      m
    ), _ = Lu(), n !== null && !qn ? (Ec(n, a, m), Wr(n, a, m)) : (Wt && _ && sl(a), a.flags |= 1, oi(n, a, s, m), a.child);
  }
  function Do(n, a, r, s, m) {
    if (n === null) {
      var f = r.type;
      return typeof f == "function" && !Md(f) && f.defaultProps === void 0 && r.compare === null ? (a.tag = 15, a.type = f, Ul(
        n,
        a,
        f,
        s,
        m
      )) : (n = Me(
        r.type,
        null,
        s,
        a,
        a.mode,
        m
      ), n.ref = a.ref, n.return = a, a.child = n);
    }
    if (f = n.child, !f1(n, m)) {
      var E = f.memoizedProps;
      if (r = r.compare, r = r !== null ? r : os, r(E, s) && n.ref === a.ref)
        return Wr(n, a, m);
    }
    return a.flags |= 1, n = sr(f, s), n.ref = a.ref, n.return = a, a.child = n;
  }
  function Ul(n, a, r, s, m) {
    if (n !== null) {
      var f = n.memoizedProps;
      if (os(f, s) && n.ref === a.ref)
        if (qn = !1, a.pendingProps = s = f, f1(n, m))
          (n.flags & 131072) !== 0 && (qn = !0);
        else
          return a.lanes = n.lanes, Wr(n, a, m);
    }
    return s1(
      n,
      a,
      r,
      s,
      m
    );
  }
  function o1(n, a, r) {
    var s = a.pendingProps, m = s.children, f = n !== null ? n.memoizedState : null;
    if (s.mode === "hidden") {
      if ((a.flags & 128) !== 0) {
        if (s = f !== null ? f.baseLanes | r : r, n !== null) {
          for (m = a.child = n.child, f = 0; m !== null; )
            f = f | m.lanes | m.childLanes, m = m.sibling;
          a.childLanes = f & ~s;
        } else a.childLanes = 0, a.child = null;
        return Tl(
          n,
          a,
          s,
          r
        );
      }
      if ((r & 536870912) !== 0)
        a.memoizedState = { baseLanes: 0, cachePool: null }, n !== null && cl(
          a,
          f !== null ? f.cachePool : null
        ), f !== null ? ri(a, f) : Sc(), Lr(a);
      else
        return a.lanes = a.childLanes = 536870912, Tl(
          n,
          a,
          f !== null ? f.baseLanes | r : r,
          r
        );
    } else
      f !== null ? (cl(a, f.cachePool), ri(a, f), Ir(), a.memoizedState = null) : (n !== null && cl(a, null), Sc(), Ir());
    return oi(n, a, m, r), a.child;
  }
  function Tl(n, a, r, s) {
    var m = Bd();
    return m = m === null ? null : { parent: Xn._currentValue, pool: m }, a.memoizedState = {
      baseLanes: r,
      cachePool: m
    }, n !== null && cl(a, null), Sc(), Lr(a), n !== null && pc(n, a, s, !0), null;
  }
  function i0(n, a) {
    var r = a.ref;
    if (r === null)
      n !== null && n.ref !== null && (a.flags |= 4194816);
    else {
      if (typeof r != "function" && typeof r != "object")
        throw Error(p(284));
      (n === null || n.ref !== r) && (a.flags |= 4194816);
    }
  }
  function s1(n, a, r, s, m) {
    return ms(a), r = Ju(
      n,
      a,
      r,
      s,
      void 0,
      m
    ), s = Lu(), n !== null && !qn ? (Ec(n, a, m), Wr(n, a, m)) : (Wt && s && sl(a), a.flags |= 1, oi(n, a, r, m), a.child);
  }
  function Im(n, a, r, s, m, f) {
    return ms(a), a.updateQueue = null, r = Um(
      a,
      s,
      r,
      m
    ), vs(n), s = Lu(), n !== null && !qn ? (Ec(n, a, f), Wr(n, a, f)) : (Wt && s && sl(a), a.flags |= 1, oi(n, a, r, f), a.child);
  }
  function l1(n, a, r, s, m) {
    if (ms(a), a.stateNode === null) {
      var f = lc, E = r.contextType;
      typeof E == "object" && E !== null && (f = ai(E)), f = new r(s, f), a.memoizedState = f.state !== null && f.state !== void 0 ? f.state : null, f.updater = r1, a.stateNode = f, f._reactInternals = a, f = a.stateNode, f.props = s, f.state = a.memoizedState, f.refs = {}, Ou(a), E = r.contextType, f.context = typeof E == "object" && E !== null ? ai(E) : lc, f.state = a.memoizedState, E = r.getDerivedStateFromProps, typeof E == "function" && (Rs(
        a,
        r,
        E,
        s
      ), f.state = a.memoizedState), typeof r.getDerivedStateFromProps == "function" || typeof f.getSnapshotBeforeUpdate == "function" || typeof f.UNSAFE_componentWillMount != "function" && typeof f.componentWillMount != "function" || (E = f.state, typeof f.componentWillMount == "function" && f.componentWillMount(), typeof f.UNSAFE_componentWillMount == "function" && f.UNSAFE_componentWillMount(), E !== f.state && r1.enqueueReplaceState(f, f.state, null), _o(a, s, f, m), vc(), f.state = a.memoizedState), typeof f.componentDidMount == "function" && (a.flags |= 4194308), s = !0;
    } else if (n === null) {
      f = a.stateNode;
      var _ = a.memoizedProps, O = Es(r, _);
      f.props = O;
      var K = f.context, me = r.contextType;
      E = lc, typeof me == "object" && me !== null && (E = ai(me));
      var ve = r.getDerivedStateFromProps;
      me = typeof ve == "function" || typeof f.getSnapshotBeforeUpdate == "function", _ = a.pendingProps !== _, me || typeof f.UNSAFE_componentWillReceiveProps != "function" && typeof f.componentWillReceiveProps != "function" || (_ || K !== E) && El(
        a,
        f,
        s,
        E
      ), Or = !1;
      var $ = a.memoizedState;
      f.state = $, _o(a, s, f, m), vc(), K = a.memoizedState, _ || $ !== K || Or ? (typeof ve == "function" && (Rs(
        a,
        r,
        ve,
        s
      ), K = a.memoizedState), (O = Or || yc(
        a,
        r,
        O,
        s,
        $,
        K,
        E
      )) ? (me || typeof f.UNSAFE_componentWillMount != "function" && typeof f.componentWillMount != "function" || (typeof f.componentWillMount == "function" && f.componentWillMount(), typeof f.UNSAFE_componentWillMount == "function" && f.UNSAFE_componentWillMount()), typeof f.componentDidMount == "function" && (a.flags |= 4194308)) : (typeof f.componentDidMount == "function" && (a.flags |= 4194308), a.memoizedProps = s, a.memoizedState = K), f.props = s, f.state = K, f.context = E, s = O) : (typeof f.componentDidMount == "function" && (a.flags |= 4194308), s = !1);
    } else {
      f = a.stateNode, Bu(n, a), E = a.memoizedProps, me = Es(r, E), f.props = me, ve = a.pendingProps, $ = f.context, K = r.contextType, O = lc, typeof K == "object" && K !== null && (O = ai(K)), _ = r.getDerivedStateFromProps, (K = typeof _ == "function" || typeof f.getSnapshotBeforeUpdate == "function") || typeof f.UNSAFE_componentWillReceiveProps != "function" && typeof f.componentWillReceiveProps != "function" || (E !== ve || $ !== O) && El(
        a,
        f,
        s,
        O
      ), Or = !1, $ = a.memoizedState, f.state = $, _o(a, s, f, m), vc();
      var te = a.memoizedState;
      E !== ve || $ !== te || Or || n !== null && n.dependencies !== null && xd(n.dependencies) ? (typeof _ == "function" && (Rs(
        a,
        r,
        _,
        s
      ), te = a.memoizedState), (me = Or || yc(
        a,
        r,
        me,
        s,
        $,
        te,
        O
      ) || n !== null && n.dependencies !== null && xd(n.dependencies)) ? (K || typeof f.UNSAFE_componentWillUpdate != "function" && typeof f.componentWillUpdate != "function" || (typeof f.componentWillUpdate == "function" && f.componentWillUpdate(s, te, O), typeof f.UNSAFE_componentWillUpdate == "function" && f.UNSAFE_componentWillUpdate(
        s,
        te,
        O
      )), typeof f.componentDidUpdate == "function" && (a.flags |= 4), typeof f.getSnapshotBeforeUpdate == "function" && (a.flags |= 1024)) : (typeof f.componentDidUpdate != "function" || E === n.memoizedProps && $ === n.memoizedState || (a.flags |= 4), typeof f.getSnapshotBeforeUpdate != "function" || E === n.memoizedProps && $ === n.memoizedState || (a.flags |= 1024), a.memoizedProps = s, a.memoizedState = te), f.props = s, f.state = te, f.context = O, s = me) : (typeof f.componentDidUpdate != "function" || E === n.memoizedProps && $ === n.memoizedState || (a.flags |= 4), typeof f.getSnapshotBeforeUpdate != "function" || E === n.memoizedProps && $ === n.memoizedState || (a.flags |= 1024), s = !1);
    }
    return f = s, i0(n, a), s = (a.flags & 128) !== 0, f || s ? (f = a.stateNode, r = s && typeof r.getDerivedStateFromError != "function" ? null : f.render(), a.flags |= 1, n !== null && s ? (a.child = Rl(
      a,
      n.child,
      null,
      m
    ), a.child = Rl(
      a,
      null,
      r,
      m
    )) : oi(n, a, r, m), a.memoizedState = f.state, n = a.child) : n = Wr(
      n,
      a,
      m
    ), n;
  }
  function c1(n, a, r, s) {
    return hc(), a.flags |= 256, oi(n, a, r, s), a.child;
  }
  var d1 = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Wm(n) {
    return { baseLanes: n, cachePool: Qu() };
  }
  function Hm(n, a, r) {
    return n = n !== null ? n.childLanes & ~r : 0, a && (n |= Ga), n;
  }
  function zm(n, a, r) {
    var s = a.pendingProps, m = !1, f = (a.flags & 128) !== 0, E;
    if ((E = f) || (E = n !== null && n.memoizedState === null ? !1 : (sn.current & 2) !== 0), E && (m = !0, a.flags &= -129), E = (a.flags & 32) !== 0, a.flags &= -33, n === null) {
      if (Wt) {
        if (m ? Qo(a) : Ir(), Wt) {
          var _ = zt, O;
          if (O = _) {
            e: {
              for (O = _, _ = La; O.nodeType !== 8; ) {
                if (!_) {
                  _ = null;
                  break e;
                }
                if (O = pr(
                  O.nextSibling
                ), O === null) {
                  _ = null;
                  break e;
                }
              }
              _ = O;
            }
            _ !== null ? (a.memoizedState = {
              dehydrated: _,
              treeContext: bo !== null ? { id: lr, overflow: Mn } : null,
              retryLane: 536870912,
              hydrationErrors: null
            }, O = Xi(
              18,
              null,
              null,
              0
            ), O.stateNode = _, O.return = a, a.child = O, Wn = a, zt = null, O = !0) : O = !1;
          }
          O || Vo(a);
        }
        if (_ = a.memoizedState, _ !== null && (_ = _.dehydrated, _ !== null))
          return T0(_) ? a.lanes = 32 : a.lanes = 536870912, null;
        hr(a);
      }
      return _ = s.children, s = s.fallback, m ? (Ir(), m = a.mode, _ = h1(
        { mode: "hidden", children: _ },
        m
      ), s = wa(
        s,
        m,
        r,
        null
      ), _.return = a, s.return = a, _.sibling = s, a.child = _, m = a.child, m.memoizedState = Wm(r), m.childLanes = Hm(
        n,
        E,
        r
      ), a.memoizedState = d1, s) : (Qo(a), u1(a, _));
    }
    if (O = n.memoizedState, O !== null && (_ = O.dehydrated, _ !== null)) {
      if (f)
        a.flags & 256 ? (Qo(a), a.flags &= -257, a = Us(
          n,
          a,
          r
        )) : a.memoizedState !== null ? (Ir(), a.child = n.child, a.flags |= 128, a = null) : (Ir(), m = s.fallback, _ = a.mode, s = h1(
          { mode: "visible", children: s.children },
          _
        ), m = wa(
          m,
          _,
          r,
          null
        ), m.flags |= 2, s.return = a, m.return = a, s.sibling = m, a.child = s, Rl(
          a,
          n.child,
          null,
          r
        ), s = a.child, s.memoizedState = Wm(r), s.childLanes = Hm(
          n,
          E,
          r
        ), a.memoizedState = d1, a = m);
      else if (Qo(a), T0(_)) {
        if (E = _.nextSibling && _.nextSibling.dataset, E) var K = E.dgst;
        E = K, s = Error(p(419)), s.stack = "", s.digest = E, mc({ value: s, source: null, stack: null }), a = Us(
          n,
          a,
          r
        );
      } else if (qn || pc(n, a, r, !1), E = (r & n.childLanes) !== 0, qn || E) {
        if (E = dn, E !== null && (s = r & -r, s = (s & 42) !== 0 ? 1 : Sn(s), s = (s & (E.suspendedLanes | r)) !== 0 ? 0 : s, s !== 0 && s !== O.retryLane))
          throw O.retryLane = s, kr(n, s), Ra(E, n, s), Qn;
        _.data === "$?" || _l(), a = Us(
          n,
          a,
          r
        );
      } else
        _.data === "$?" ? (a.flags |= 192, a.child = n.child, a = null) : (n = O.treeContext, zt = pr(
          _.nextSibling
        ), Wn = a, Wt = !0, Ja = null, La = !1, n !== null && (Aa[Ki++] = lr, Aa[Ki++] = Mn, Aa[Ki++] = bo, lr = n.id, Mn = n.overflow, bo = a), a = u1(
          a,
          s.children
        ), a.flags |= 4096);
      return a;
    }
    return m ? (Ir(), m = s.fallback, _ = a.mode, O = n.child, K = O.sibling, s = sr(O, {
      mode: "hidden",
      children: s.children
    }), s.subtreeFlags = O.subtreeFlags & 65011712, K !== null ? m = sr(K, m) : (m = wa(
      m,
      _,
      r,
      null
    ), m.flags |= 2), m.return = a, s.return = a, s.sibling = m, a.child = s, s = m, m = a.child, _ = n.child.memoizedState, _ === null ? _ = Wm(r) : (O = _.cachePool, O !== null ? (K = Xn._currentValue, O = O.parent !== K ? { parent: K, pool: K } : O) : O = Qu(), _ = {
      baseLanes: _.baseLanes | r,
      cachePool: O
    }), m.memoizedState = _, m.childLanes = Hm(
      n,
      E,
      r
    ), a.memoizedState = d1, s) : (Qo(a), r = n.child, n = r.sibling, r = sr(r, {
      mode: "visible",
      children: s.children
    }), r.return = a, r.sibling = null, n !== null && (E = a.deletions, E === null ? (a.deletions = [n], a.flags |= 16) : E.push(n)), a.child = r, a.memoizedState = null, r);
  }
  function u1(n, a) {
    return a = h1(
      { mode: "visible", children: a },
      n.mode
    ), a.return = n, n.child = a;
  }
  function h1(n, a) {
    return n = Xi(22, n, null, a), n.lanes = 0, n.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }, n;
  }
  function Us(n, a, r) {
    return Rl(a, n.child, null, r), n = u1(
      a,
      a.pendingProps.children
    ), n.flags |= 2, a.memoizedState = null, n;
  }
  function a0(n, a, r) {
    n.lanes |= a;
    var s = n.alternate;
    s !== null && (s.lanes |= a), Cu(n.return, a, r);
  }
  function m1(n, a, r, s, m) {
    var f = n.memoizedState;
    f === null ? n.memoizedState = {
      isBackwards: a,
      rendering: null,
      renderingStartTime: 0,
      last: s,
      tail: r,
      tailMode: m
    } : (f.isBackwards = a, f.rendering = null, f.renderingStartTime = 0, f.last = s, f.tail = r, f.tailMode = m);
  }
  function p1(n, a, r) {
    var s = a.pendingProps, m = s.revealOrder, f = s.tail;
    if (oi(n, a, s.children, r), s = sn.current, (s & 2) !== 0)
      s = s & 1 | 2, a.flags |= 128;
    else {
      if (n !== null && (n.flags & 128) !== 0)
        e: for (n = a.child; n !== null; ) {
          if (n.tag === 13)
            n.memoizedState !== null && a0(n, r, a);
          else if (n.tag === 19)
            a0(n, r, a);
          else if (n.child !== null) {
            n.child.return = n, n = n.child;
            continue;
          }
          if (n === a) break e;
          for (; n.sibling === null; ) {
            if (n.return === null || n.return === a)
              break e;
            n = n.return;
          }
          n.sibling.return = n.return, n = n.sibling;
        }
      s &= 1;
    }
    switch (de(sn, s), m) {
      case "forwards":
        for (r = a.child, m = null; r !== null; )
          n = r.alternate, n !== null && $d(n) === null && (m = r), r = r.sibling;
        r = m, r === null ? (m = a.child, a.child = null) : (m = r.sibling, r.sibling = null), m1(
          a,
          !1,
          m,
          r,
          f
        );
        break;
      case "backwards":
        for (r = null, m = a.child, a.child = null; m !== null; ) {
          if (n = m.alternate, n !== null && $d(n) === null) {
            a.child = m;
            break;
          }
          n = m.sibling, m.sibling = r, r = m, m = n;
        }
        m1(
          a,
          !0,
          r,
          null,
          f
        );
        break;
      case "together":
        m1(a, !1, null, null, void 0);
        break;
      default:
        a.memoizedState = null;
    }
    return a.child;
  }
  function Wr(n, a, r) {
    if (n !== null && (a.dependencies = n.dependencies), Oo |= a.lanes, (r & a.childLanes) === 0)
      if (n !== null) {
        if (pc(
          n,
          a,
          r,
          !1
        ), (r & a.childLanes) === 0)
          return null;
      } else return null;
    if (n !== null && a.child !== n.child)
      throw Error(p(153));
    if (a.child !== null) {
      for (n = a.child, r = sr(n, n.pendingProps), a.child = r, r.return = a; n.sibling !== null; )
        n = n.sibling, r = r.sibling = sr(n, n.pendingProps), r.return = a;
      r.sibling = null;
    }
    return a.child;
  }
  function f1(n, a) {
    return (n.lanes & a) !== 0 ? !0 : (n = n.dependencies, !!(n !== null && xd(n)));
  }
  function v2(n, a, r) {
    switch (a.tag) {
      case 3:
        $e(a, a.stateNode.containerInfo), Fo(a, Xn, n.memoizedState.cache), hc();
        break;
      case 27:
      case 5:
        Nn(a);
        break;
      case 4:
        $e(a, a.stateNode.containerInfo);
        break;
      case 10:
        Fo(
          a,
          a.type,
          a.memoizedProps.value
        );
        break;
      case 13:
        var s = a.memoizedState;
        if (s !== null)
          return s.dehydrated !== null ? (Qo(a), a.flags |= 128, null) : (r & a.child.childLanes) !== 0 ? zm(n, a, r) : (Qo(a), n = Wr(
            n,
            a,
            r
          ), n !== null ? n.sibling : null);
        Qo(a);
        break;
      case 19:
        var m = (n.flags & 128) !== 0;
        if (s = (r & a.childLanes) !== 0, s || (pc(
          n,
          a,
          r,
          !1
        ), s = (r & a.childLanes) !== 0), m) {
          if (s)
            return p1(
              n,
              a,
              r
            );
          a.flags |= 128;
        }
        if (m = a.memoizedState, m !== null && (m.rendering = null, m.tail = null, m.lastEffect = null), de(sn, sn.current), s) break;
        return null;
      case 22:
      case 23:
        return a.lanes = 0, o1(n, a, r);
      case 24:
        Fo(a, Xn, n.memoizedState.cache);
    }
    return Wr(n, a, r);
  }
  function S2(n, a, r) {
    if (n !== null)
      if (n.memoizedProps !== a.pendingProps)
        qn = !0;
      else {
        if (!f1(n, r) && (a.flags & 128) === 0)
          return qn = !1, v2(
            n,
            a,
            r
          );
        qn = (n.flags & 131072) !== 0;
      }
    else
      qn = !1, Wt && (a.flags & 1048576) !== 0 && Vu(a, dc, a.index);
    switch (a.lanes = 0, a.tag) {
      case 16:
        e: {
          n = a.pendingProps;
          var s = a.elementType, m = s._init;
          if (s = m(s._payload), a.type = s, typeof s == "function")
            Md(s) ? (n = Es(s, n), a.tag = 1, a = l1(
              null,
              a,
              s,
              n,
              r
            )) : (a.tag = 0, a = s1(
              null,
              a,
              s,
              n,
              r
            ));
          else {
            if (s != null) {
              if (m = s.$$typeof, m === _e) {
                a.tag = 11, a = g2(
                  null,
                  a,
                  s,
                  n,
                  r
                );
                break e;
              } else if (m === Re) {
                a.tag = 14, a = Do(
                  null,
                  a,
                  s,
                  n,
                  r
                );
                break e;
              }
            }
            throw a = Be(s) || s, Error(p(306, a, ""));
          }
        }
        return a;
      case 0:
        return s1(
          n,
          a,
          a.type,
          a.pendingProps,
          r
        );
      case 1:
        return s = a.type, m = Es(
          s,
          a.pendingProps
        ), l1(
          n,
          a,
          s,
          m,
          r
        );
      case 3:
        e: {
          if ($e(
            a,
            a.stateNode.containerInfo
          ), n === null) throw Error(p(387));
          s = a.pendingProps;
          var f = a.memoizedState;
          m = f.element, Bu(n, a), _o(a, s, null, r);
          var E = a.memoizedState;
          if (s = E.cache, Fo(a, Xn, s), s !== f.cache && mm(
            a,
            [Xn],
            r,
            !0
          ), vc(), s = E.element, f.isDehydrated)
            if (f = {
              element: s,
              isDehydrated: !1,
              cache: E.cache
            }, a.updateQueue.baseState = f, a.memoizedState = f, a.flags & 256) {
              a = c1(
                n,
                a,
                s,
                r
              );
              break e;
            } else if (s !== m) {
              m = pa(
                Error(p(424)),
                a
              ), mc(m), a = c1(
                n,
                a,
                s,
                r
              );
              break e;
            } else {
              switch (n = a.stateNode.containerInfo, n.nodeType) {
                case 9:
                  n = n.body;
                  break;
                default:
                  n = n.nodeName === "HTML" ? n.ownerDocument.body : n;
              }
              for (zt = pr(n.firstChild), Wn = a, Wt = !0, Ja = null, La = !0, r = Jr(
                a,
                null,
                s,
                r
              ), a.child = r; r; )
                r.flags = r.flags & -3 | 4096, r = r.sibling;
            }
          else {
            if (hc(), s === m) {
              a = Wr(
                n,
                a,
                r
              );
              break e;
            }
            oi(
              n,
              a,
              s,
              r
            );
          }
          a = a.child;
        }
        return a;
      case 26:
        return i0(n, a), n === null ? (r = x2(
          a.type,
          null,
          a.pendingProps,
          null
        )) ? a.memoizedState = r : Wt || (r = a.type, n = a.pendingProps, s = Ya(
          Ze.current
        ).createElement(r), s[_n] = a, s[Yn] = n, ut(s, r, n), Ke(s), a.stateNode = s) : a.memoizedState = x2(
          a.type,
          n.memoizedProps,
          a.pendingProps,
          n.memoizedState
        ), null;
      case 27:
        return Nn(a), n === null && Wt && (s = a.stateNode = Le(
          a.type,
          a.pendingProps,
          Ze.current
        ), Wn = a, La = !0, m = zt, Ms(a.type) ? (ks = m, zt = pr(
          s.firstChild
        )) : zt = m), oi(
          n,
          a,
          a.pendingProps.children,
          r
        ), i0(n, a), n === null && (a.flags |= 4194304), a.child;
      case 5:
        return n === null && Wt && ((m = s = zt) && (s = Wc(
          s,
          a.type,
          a.pendingProps,
          La
        ), s !== null ? (a.stateNode = s, Wn = a, zt = pr(
          s.firstChild
        ), La = !1, m = !0) : m = !1), m || Vo(a)), Nn(a), m = a.type, f = a.pendingProps, E = n !== null ? n.memoizedProps : null, s = f.children, qr(m, f) ? s = null : E !== null && qr(m, E) && (a.flags |= 32), a.memoizedState !== null && (m = Ju(
          n,
          a,
          o2,
          null,
          null,
          r
        ), sa._currentValue = m), i0(n, a), oi(n, a, s, r), a.child;
      case 6:
        return n === null && Wt && ((n = r = zt) && (r = gv(
          r,
          a.pendingProps,
          La
        ), r !== null ? (a.stateNode = r, Wn = a, zt = null, n = !0) : n = !1), n || Vo(a)), null;
      case 13:
        return zm(n, a, r);
      case 4:
        return $e(
          a,
          a.stateNode.containerInfo
        ), s = a.pendingProps, n === null ? a.child = Rl(
          a,
          null,
          s,
          r
        ) : oi(
          n,
          a,
          s,
          r
        ), a.child;
      case 11:
        return g2(
          n,
          a,
          a.type,
          a.pendingProps,
          r
        );
      case 7:
        return oi(
          n,
          a,
          a.pendingProps,
          r
        ), a.child;
      case 8:
        return oi(
          n,
          a,
          a.pendingProps.children,
          r
        ), a.child;
      case 12:
        return oi(
          n,
          a,
          a.pendingProps.children,
          r
        ), a.child;
      case 10:
        return s = a.pendingProps, Fo(a, a.type, s.value), oi(
          n,
          a,
          s.children,
          r
        ), a.child;
      case 9:
        return m = a.type._context, s = a.pendingProps.children, ms(a), m = ai(m), s = s(m), a.flags |= 1, oi(n, a, s, r), a.child;
      case 14:
        return Do(
          n,
          a,
          a.type,
          a.pendingProps,
          r
        );
      case 15:
        return Ul(
          n,
          a,
          a.type,
          a.pendingProps,
          r
        );
      case 19:
        return p1(n, a, r);
      case 31:
        return s = a.pendingProps, r = a.mode, s = {
          mode: s.mode,
          children: s.children
        }, n === null ? (r = h1(
          s,
          r
        ), r.ref = a.ref, a.child = r, r.return = a, a = r) : (r = sr(n.child, s), r.ref = a.ref, a.child = r, r.return = a, a = r), a;
      case 22:
        return o1(n, a, r);
      case 24:
        return ms(a), s = ai(Xn), n === null ? (m = Bd(), m === null && (m = dn, f = gc(), m.pooledCache = f, f.refCount++, f !== null && (m.pooledCacheLanes |= r), m = f), a.memoizedState = {
          parent: s,
          cache: m
        }, Ou(a), Fo(a, Xn, m)) : ((n.lanes & r) !== 0 && (Bu(n, a), _o(a, null, null, r), vc()), m = n.memoizedState, f = a.memoizedState, m.parent !== s ? (m = { parent: s, cache: s }, a.memoizedState = m, a.lanes === 0 && (a.memoizedState = a.updateQueue.baseState = m), Fo(a, Xn, s)) : (s = f.cache, Fo(a, Xn, s), s !== m.cache && mm(
          a,
          [Xn],
          r,
          !0
        ))), oi(
          n,
          a,
          a.pendingProps.children,
          r
        ), a.child;
      case 29:
        throw a.pendingProps;
    }
    throw Error(p(156, a.tag));
  }
  function Hr(n) {
    n.flags |= 4;
  }
  function bc(n, a) {
    if (a.type !== "stylesheet" || (a.state.loading & 4) !== 0)
      n.flags &= -16777217;
    else if (n.flags |= 16777216, !Fp(a)) {
      if (a = va.current, a !== null && ((Zt & 4194048) === Zt ? _i !== null : (Zt & 62914560) !== Zt && (Zt & 536870912) === 0 || a !== _i))
        throw dl = xu, Du;
      n.flags |= 8192;
    }
  }
  function r0(n, a) {
    a !== null && (n.flags |= 4), n.flags & 16384 && (a = n.tag !== 22 ? Oe() : 536870912, n.lanes |= a, Mc |= a);
  }
  function Vc(n, a) {
    if (!Wt)
      switch (n.tailMode) {
        case "hidden":
          a = n.tail;
          for (var r = null; a !== null; )
            a.alternate !== null && (r = a), a = a.sibling;
          r === null ? n.tail = null : r.sibling = null;
          break;
        case "collapsed":
          r = n.tail;
          for (var s = null; r !== null; )
            r.alternate !== null && (s = r), r = r.sibling;
          s === null ? a || n.tail === null ? n.tail = null : n.tail.sibling = null : s.sibling = null;
      }
  }
  function st(n) {
    var a = n.alternate !== null && n.alternate.child === n.child, r = 0, s = 0;
    if (a)
      for (var m = n.child; m !== null; )
        r |= m.lanes | m.childLanes, s |= m.subtreeFlags & 65011712, s |= m.flags & 65011712, m.return = n, m = m.sibling;
    else
      for (m = n.child; m !== null; )
        r |= m.lanes | m.childLanes, s |= m.subtreeFlags, s |= m.flags, m.return = n, m = m.sibling;
    return n.subtreeFlags |= s, n.childLanes = r, a;
  }
  function jm(n, a, r) {
    var s = a.pendingProps;
    switch (Qr(a), a.tag) {
      case 31:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return st(a), null;
      case 1:
        return st(a), null;
      case 3:
        return r = a.stateNode, s = null, n !== null && (s = n.memoizedState.cache), a.memoizedState.cache !== s && (a.flags |= 2048), Dr(Xn), Ht(), r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null), (n === null || n.child === null) && (uc(a) ? Hr(a) : n === null || n.memoizedState.isDehydrated && (a.flags & 256) === 0 || (a.flags |= 1024, hm())), st(a), null;
      case 26:
        return r = a.memoizedState, n === null ? (Hr(a), r !== null ? (st(a), bc(a, r)) : (st(a), a.flags &= -16777217)) : r ? r !== n.memoizedState ? (Hr(a), st(a), bc(a, r)) : (st(a), a.flags &= -16777217) : (n.memoizedProps !== s && Hr(a), st(a), a.flags &= -16777217), null;
      case 27:
        rn(a), r = Ze.current;
        var m = a.type;
        if (n !== null && a.stateNode != null)
          n.memoizedProps !== s && Hr(a);
        else {
          if (!s) {
            if (a.stateNode === null)
              throw Error(p(166));
            return st(a), null;
          }
          n = ye.current, uc(a) ? Qd(a) : (n = Le(m, s, r), a.stateNode = n, Hr(a));
        }
        return st(a), null;
      case 5:
        if (rn(a), r = a.type, n !== null && a.stateNode != null)
          n.memoizedProps !== s && Hr(a);
        else {
          if (!s) {
            if (a.stateNode === null)
              throw Error(p(166));
            return st(a), null;
          }
          if (n = ye.current, uc(a))
            Qd(a);
          else {
            switch (m = Ya(
              Ze.current
            ), n) {
              case 1:
                n = m.createElementNS(
                  "http://www.w3.org/2000/svg",
                  r
                );
                break;
              case 2:
                n = m.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  r
                );
                break;
              default:
                switch (r) {
                  case "svg":
                    n = m.createElementNS(
                      "http://www.w3.org/2000/svg",
                      r
                    );
                    break;
                  case "math":
                    n = m.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      r
                    );
                    break;
                  case "script":
                    n = m.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild);
                    break;
                  case "select":
                    n = typeof s.is == "string" ? m.createElement("select", { is: s.is }) : m.createElement("select"), s.multiple ? n.multiple = !0 : s.size && (n.size = s.size);
                    break;
                  default:
                    n = typeof s.is == "string" ? m.createElement(r, { is: s.is }) : m.createElement(r);
                }
            }
            n[_n] = a, n[Yn] = s;
            e: for (m = a.child; m !== null; ) {
              if (m.tag === 5 || m.tag === 6)
                n.appendChild(m.stateNode);
              else if (m.tag !== 4 && m.tag !== 27 && m.child !== null) {
                m.child.return = m, m = m.child;
                continue;
              }
              if (m === a) break e;
              for (; m.sibling === null; ) {
                if (m.return === null || m.return === a)
                  break e;
                m = m.return;
              }
              m.sibling.return = m.return, m = m.sibling;
            }
            a.stateNode = n;
            e: switch (ut(n, r, s), r) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                n = !!s.autoFocus;
                break e;
              case "img":
                n = !0;
                break e;
              default:
                n = !1;
            }
            n && Hr(a);
          }
        }
        return st(a), a.flags &= -16777217, null;
      case 6:
        if (n && a.stateNode != null)
          n.memoizedProps !== s && Hr(a);
        else {
          if (typeof s != "string" && a.stateNode === null)
            throw Error(p(166));
          if (n = Ze.current, uc(a)) {
            if (n = a.stateNode, r = a.memoizedProps, s = null, m = Wn, m !== null)
              switch (m.tag) {
                case 27:
                case 5:
                  s = m.memoizedProps;
              }
            n[_n] = a, n = !!(n.nodeValue === r || s !== null && s.suppressHydrationWarning === !0 || Np(n.nodeValue, r)), n || Vo(a);
          } else
            n = Ya(n).createTextNode(
              s
            ), n[_n] = a, a.stateNode = n;
        }
        return st(a), null;
      case 13:
        if (s = a.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (m = uc(a), s !== null && s.dehydrated !== null) {
            if (n === null) {
              if (!m) throw Error(p(318));
              if (m = a.memoizedState, m = m !== null ? m.dehydrated : null, !m) throw Error(p(317));
              m[_n] = a;
            } else
              hc(), (a.flags & 128) === 0 && (a.memoizedState = null), a.flags |= 4;
            st(a), m = !1;
          } else
            m = hm(), n !== null && n.memoizedState !== null && (n.memoizedState.hydrationErrors = m), m = !0;
          if (!m)
            return a.flags & 256 ? (hr(a), a) : (hr(a), null);
        }
        if (hr(a), (a.flags & 128) !== 0)
          return a.lanes = r, a;
        if (r = s !== null, n = n !== null && n.memoizedState !== null, r) {
          s = a.child, m = null, s.alternate !== null && s.alternate.memoizedState !== null && s.alternate.memoizedState.cachePool !== null && (m = s.alternate.memoizedState.cachePool.pool);
          var f = null;
          s.memoizedState !== null && s.memoizedState.cachePool !== null && (f = s.memoizedState.cachePool.pool), f !== m && (s.flags |= 2048);
        }
        return r !== n && r && (a.child.flags |= 8192), r0(a, a.updateQueue), st(a), null;
      case 4:
        return Ht(), n === null && Tp(a.stateNode.containerInfo), st(a), null;
      case 10:
        return Dr(a.type), st(a), null;
      case 19:
        if (L(sn), m = a.memoizedState, m === null) return st(a), null;
        if (s = (a.flags & 128) !== 0, f = m.rendering, f === null)
          if (s) Vc(m, !1);
          else {
            if (Zn !== 0 || n !== null && (n.flags & 128) !== 0)
              for (n = a.child; n !== null; ) {
                if (f = $d(n), f !== null) {
                  for (a.flags |= 128, Vc(m, !1), n = f.updateQueue, a.updateQueue = n, r0(a, n), a.subtreeFlags = 0, n = r, r = a.child; r !== null; )
                    Ft(r, n), r = r.sibling;
                  return de(
                    sn,
                    sn.current & 1 | 2
                  ), a.child;
                }
                n = n.sibling;
              }
            m.tail !== null && vn() > N1 && (a.flags |= 128, s = !0, Vc(m, !1), a.lanes = 4194304);
          }
        else {
          if (!s)
            if (n = $d(f), n !== null) {
              if (a.flags |= 128, s = !0, n = n.updateQueue, a.updateQueue = n, r0(a, n), Vc(m, !0), m.tail === null && m.tailMode === "hidden" && !f.alternate && !Wt)
                return st(a), null;
            } else
              2 * vn() - m.renderingStartTime > N1 && r !== 536870912 && (a.flags |= 128, s = !0, Vc(m, !1), a.lanes = 4194304);
          m.isBackwards ? (f.sibling = a.child, a.child = f) : (n = m.last, n !== null ? n.sibling = f : a.child = f, m.last = f);
        }
        return m.tail !== null ? (a = m.tail, m.rendering = a, m.tail = a.sibling, m.renderingStartTime = vn(), a.sibling = null, n = sn.current, de(sn, s ? n & 1 | 2 : n & 1), a) : (st(a), null);
      case 22:
      case 23:
        return hr(a), Rc(), s = a.memoizedState !== null, n !== null ? n.memoizedState !== null !== s && (a.flags |= 8192) : s && (a.flags |= 8192), s ? (r & 536870912) !== 0 && (a.flags & 128) === 0 && (st(a), a.subtreeFlags & 6 && (a.flags |= 8192)) : st(a), r = a.updateQueue, r !== null && r0(a, r.retryQueue), r = null, n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (r = n.memoizedState.cachePool.pool), s = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (s = a.memoizedState.cachePool.pool), s !== r && (a.flags |= 2048), n !== null && L(Zr), null;
      case 24:
        return r = null, n !== null && (r = n.memoizedState.cache), a.memoizedState.cache !== r && (a.flags |= 2048), Dr(Xn), st(a), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(p(156, a.tag));
  }
  function lv(n, a) {
    switch (Qr(a), a.tag) {
      case 1:
        return n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 3:
        return Dr(Xn), Ht(), n = a.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (a.flags = n & -65537 | 128, a) : null;
      case 26:
      case 27:
      case 5:
        return rn(a), null;
      case 13:
        if (hr(a), n = a.memoizedState, n !== null && n.dehydrated !== null) {
          if (a.alternate === null)
            throw Error(p(340));
          hc();
        }
        return n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 19:
        return L(sn), null;
      case 4:
        return Ht(), null;
      case 10:
        return Dr(a.type), null;
      case 22:
      case 23:
        return hr(a), Rc(), n !== null && L(Zr), n = a.flags, n & 65536 ? (a.flags = n & -65537 | 128, a) : null;
      case 24:
        return Dr(Xn), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Gm(n, a) {
    switch (Qr(a), a.tag) {
      case 3:
        Dr(Xn), Ht();
        break;
      case 26:
      case 27:
      case 5:
        rn(a);
        break;
      case 4:
        Ht();
        break;
      case 13:
        hr(a);
        break;
      case 19:
        L(sn);
        break;
      case 10:
        Dr(a.type);
        break;
      case 22:
      case 23:
        hr(a), Rc(), n !== null && L(Zr);
        break;
      case 24:
        Dr(Xn);
    }
  }
  function o0(n, a) {
    try {
      var r = a.updateQueue, s = r !== null ? r.lastEffect : null;
      if (s !== null) {
        var m = s.next;
        r = m;
        do {
          if ((r.tag & n) === n) {
            s = void 0;
            var f = r.create, E = r.inst;
            s = f(), E.destroy = s;
          }
          r = r.next;
        } while (r !== m);
      }
    } catch (_) {
      nn(a, a.return, _);
    }
  }
  function Ts(n, a, r) {
    try {
      var s = a.updateQueue, m = s !== null ? s.lastEffect : null;
      if (m !== null) {
        var f = m.next;
        s = f;
        do {
          if ((s.tag & n) === n) {
            var E = s.inst, _ = E.destroy;
            if (_ !== void 0) {
              E.destroy = void 0, m = a;
              var O = r, K = _;
              try {
                K();
              } catch (me) {
                nn(
                  m,
                  O,
                  me
                );
              }
            }
          }
          s = s.next;
        } while (s !== f);
      }
    } catch (me) {
      nn(a, a.return, me);
    }
  }
  function g1(n) {
    var a = n.updateQueue;
    if (a !== null) {
      var r = n.stateNode;
      try {
        Jd(a, r);
      } catch (s) {
        nn(n, n.return, s);
      }
    }
  }
  function Pm(n, a, r) {
    r.props = Es(
      n.type,
      n.memoizedProps
    ), r.state = n.memoizedState;
    try {
      r.componentWillUnmount();
    } catch (s) {
      nn(n, a, s);
    }
  }
  function Cc(n, a) {
    try {
      var r = n.ref;
      if (r !== null) {
        switch (n.tag) {
          case 26:
          case 27:
          case 5:
            var s = n.stateNode;
            break;
          case 30:
            s = n.stateNode;
            break;
          default:
            s = n.stateNode;
        }
        typeof r == "function" ? n.refCleanup = r(s) : r.current = s;
      }
    } catch (m) {
      nn(n, a, m);
    }
  }
  function mr(n, a) {
    var r = n.ref, s = n.refCleanup;
    if (r !== null)
      if (typeof s == "function")
        try {
          s();
        } catch (m) {
          nn(n, a, m);
        } finally {
          n.refCleanup = null, n = n.alternate, n != null && (n.refCleanup = null);
        }
      else if (typeof r == "function")
        try {
          r(null);
        } catch (m) {
          nn(n, a, m);
        }
      else r.current = null;
  }
  function Fc(n) {
    var a = n.type, r = n.memoizedProps, s = n.stateNode;
    try {
      e: switch (a) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          r.autoFocus && s.focus();
          break e;
        case "img":
          r.src ? s.src = r.src : r.srcSet && (s.srcset = r.srcSet);
      }
    } catch (m) {
      nn(n, n.return, m);
    }
  }
  function Ym(n, a, r) {
    try {
      var s = n.stateNode;
      mv(s, n.type, r, a), s[Yn] = a;
    } catch (m) {
      nn(n, n.return, m);
    }
  }
  function R2(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 26 || n.tag === 27 && Ms(n.type) || n.tag === 4;
  }
  function za(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || R2(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.tag === 27 && Ms(n.type) || n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function yl(n, a, r) {
    var s = n.tag;
    if (s === 5 || s === 6)
      n = n.stateNode, a ? (r.nodeType === 9 ? r.body : r.nodeName === "HTML" ? r.ownerDocument.body : r).insertBefore(n, a) : (a = r.nodeType === 9 ? r.body : r.nodeName === "HTML" ? r.ownerDocument.body : r, a.appendChild(n), r = r._reactRootContainer, r != null || a.onclick !== null || (a.onclick = O1));
    else if (s !== 4 && (s === 27 && Ms(n.type) && (r = n.stateNode, a = null), n = n.child, n !== null))
      for (yl(n, a, r), n = n.sibling; n !== null; )
        yl(n, a, r), n = n.sibling;
  }
  function v1(n, a, r) {
    var s = n.tag;
    if (s === 5 || s === 6)
      n = n.stateNode, a ? r.insertBefore(n, a) : r.appendChild(n);
    else if (s !== 4 && (s === 27 && Ms(n.type) && (r = n.stateNode), n = n.child, n !== null))
      for (v1(n, a, r), n = n.sibling; n !== null; )
        v1(n, a, r), n = n.sibling;
  }
  function S1(n) {
    var a = n.stateNode, r = n.memoizedProps;
    try {
      for (var s = n.type, m = a.attributes; m.length; )
        a.removeAttributeNode(m[0]);
      ut(a, s, r), a[_n] = n, a[Yn] = r;
    } catch (f) {
      nn(n, n.return, f);
    }
  }
  var zr = !1, Dn = !1, R1 = !1, E1 = typeof WeakSet == "function" ? WeakSet : Set, $n = null;
  function Xm(n, a) {
    if (n = n.containerInfo, R0 = b0, n = rm(n), Fd(n)) {
      if ("selectionStart" in n)
        var r = {
          start: n.selectionStart,
          end: n.selectionEnd
        };
      else
        e: {
          r = (r = n.ownerDocument) && r.defaultView || window;
          var s = r.getSelection && r.getSelection();
          if (s && s.rangeCount !== 0) {
            r = s.anchorNode;
            var m = s.anchorOffset, f = s.focusNode;
            s = s.focusOffset;
            try {
              r.nodeType, f.nodeType;
            } catch {
              r = null;
              break e;
            }
            var E = 0, _ = -1, O = -1, K = 0, me = 0, ve = n, $ = null;
            t: for (; ; ) {
              for (var te; ve !== r || m !== 0 && ve.nodeType !== 3 || (_ = E + m), ve !== f || s !== 0 && ve.nodeType !== 3 || (O = E + s), ve.nodeType === 3 && (E += ve.nodeValue.length), (te = ve.firstChild) !== null; )
                $ = ve, ve = te;
              for (; ; ) {
                if (ve === n) break t;
                if ($ === r && ++K === m && (_ = E), $ === f && ++me === s && (O = E), (te = ve.nextSibling) !== null) break;
                ve = $, $ = ve.parentNode;
              }
              ve = te;
            }
            r = _ === -1 || O === -1 ? null : { start: _, end: O };
          } else r = null;
        }
      r = r || { start: 0, end: 0 };
    } else r = null;
    for (E0 = { focusedElem: n, selectionRange: r }, b0 = !1, $n = a; $n !== null; )
      if (a = $n, n = a.child, (a.subtreeFlags & 1024) !== 0 && n !== null)
        n.return = a, $n = n;
      else
        for (; $n !== null; ) {
          switch (a = $n, f = a.alternate, n = a.flags, a.tag) {
            case 0:
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((n & 1024) !== 0 && f !== null) {
                n = void 0, r = a, m = f.memoizedProps, f = f.memoizedState, s = r.stateNode;
                try {
                  var it = Es(
                    r.type,
                    m,
                    r.elementType === r.type
                  );
                  n = s.getSnapshotBeforeUpdate(
                    it,
                    f
                  ), s.__reactInternalSnapshotBeforeUpdate = n;
                } catch (at) {
                  nn(
                    r,
                    r.return,
                    at
                  );
                }
              }
              break;
            case 3:
              if ((n & 1024) !== 0) {
                if (n = a.stateNode.containerInfo, r = n.nodeType, r === 9)
                  U0(n);
                else if (r === 1)
                  switch (n.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      U0(n);
                      break;
                    default:
                      n.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((n & 1024) !== 0) throw Error(p(163));
          }
          if (n = a.sibling, n !== null) {
            n.return = a.return, $n = n;
            break;
          }
          $n = a.return;
        }
  }
  function Km(n, a, r) {
    var s = r.flags;
    switch (r.tag) {
      case 0:
      case 11:
      case 15:
        Gr(n, r), s & 4 && o0(5, r);
        break;
      case 1:
        if (Gr(n, r), s & 4)
          if (n = r.stateNode, a === null)
            try {
              n.componentDidMount();
            } catch (E) {
              nn(r, r.return, E);
            }
          else {
            var m = Es(
              r.type,
              a.memoizedProps
            );
            a = a.memoizedState;
            try {
              n.componentDidUpdate(
                m,
                a,
                n.__reactInternalSnapshotBeforeUpdate
              );
            } catch (E) {
              nn(
                r,
                r.return,
                E
              );
            }
          }
        s & 64 && g1(r), s & 512 && Cc(r, r.return);
        break;
      case 3:
        if (Gr(n, r), s & 64 && (n = r.updateQueue, n !== null)) {
          if (a = null, r.child !== null)
            switch (r.child.tag) {
              case 27:
              case 5:
                a = r.child.stateNode;
                break;
              case 1:
                a = r.child.stateNode;
            }
          try {
            Jd(n, a);
          } catch (E) {
            nn(r, r.return, E);
          }
        }
        break;
      case 27:
        a === null && s & 4 && S1(r);
      case 26:
      case 5:
        Gr(n, r), a === null && s & 4 && Fc(r), s & 512 && Cc(r, r.return);
        break;
      case 12:
        Gr(n, r);
        break;
      case 13:
        Gr(n, r), s & 4 && U1(n, r), s & 64 && (n = r.memoizedState, n !== null && (n = n.dehydrated, n !== null && (r = cv.bind(
          null,
          r
        ), vv(n, r))));
        break;
      case 22:
        if (s = r.memoizedState !== null || zr, !s) {
          a = a !== null && a.memoizedState !== null || Dn, m = zr;
          var f = Dn;
          zr = s, (Dn = a) && !f ? ys(
            n,
            r,
            (r.subtreeFlags & 8772) !== 0
          ) : Gr(n, r), zr = m, Dn = f;
        }
        break;
      case 30:
        break;
      default:
        Gr(n, r);
    }
  }
  function qm(n) {
    var a = n.alternate;
    a !== null && (n.alternate = null, qm(a)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (a = n.stateNode, a !== null && D(a)), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  var Rn = null, fi = !1;
  function jr(n, a, r) {
    for (r = r.child; r !== null; )
      Dt(n, a, r), r = r.sibling;
  }
  function Dt(n, a, r) {
    if (Jn && typeof Jn.onCommitFiberUnmount == "function")
      try {
        Jn.onCommitFiberUnmount(ni, r);
      } catch {
      }
    switch (r.tag) {
      case 26:
        Dn || mr(r, a), jr(
          n,
          a,
          r
        ), r.memoizedState ? r.memoizedState.count-- : r.stateNode && (r = r.stateNode, r.parentNode.removeChild(r));
        break;
      case 27:
        Dn || mr(r, a);
        var s = Rn, m = fi;
        Ms(r.type) && (Rn = r.stateNode, fi = !1), jr(
          n,
          a,
          r
        ), ra(r.stateNode), Rn = s, fi = m;
        break;
      case 5:
        Dn || mr(r, a);
      case 6:
        if (s = Rn, m = fi, Rn = null, jr(
          n,
          a,
          r
        ), Rn = s, fi = m, Rn !== null)
          if (fi)
            try {
              (Rn.nodeType === 9 ? Rn.body : Rn.nodeName === "HTML" ? Rn.ownerDocument.body : Rn).removeChild(r.stateNode);
            } catch (f) {
              nn(
                r,
                a,
                f
              );
            }
          else
            try {
              Rn.removeChild(r.stateNode);
            } catch (f) {
              nn(
                r,
                a,
                f
              );
            }
        break;
      case 18:
        Rn !== null && (fi ? (n = Rn, w1(
          n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n,
          r.stateNode
        ), to(n)) : w1(Rn, r.stateNode));
        break;
      case 4:
        s = Rn, m = fi, Rn = r.stateNode.containerInfo, fi = !0, jr(
          n,
          a,
          r
        ), Rn = s, fi = m;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Dn || Ts(2, r, a), Dn || Ts(4, r, a), jr(
          n,
          a,
          r
        );
        break;
      case 1:
        Dn || (mr(r, a), s = r.stateNode, typeof s.componentWillUnmount == "function" && Pm(
          r,
          a,
          s
        )), jr(
          n,
          a,
          r
        );
        break;
      case 21:
        jr(
          n,
          a,
          r
        );
        break;
      case 22:
        Dn = (s = Dn) || r.memoizedState !== null, jr(
          n,
          a,
          r
        ), Dn = s;
        break;
      default:
        jr(
          n,
          a,
          r
        );
    }
  }
  function U1(n, a) {
    if (a.memoizedState === null && (n = a.alternate, n !== null && (n = n.memoizedState, n !== null && (n = n.dehydrated, n !== null))))
      try {
        to(n);
      } catch (r) {
        nn(a, a.return, r);
      }
  }
  function $m(n) {
    switch (n.tag) {
      case 13:
      case 19:
        var a = n.stateNode;
        return a === null && (a = n.stateNode = new E1()), a;
      case 22:
        return n = n.stateNode, a = n._retryCache, a === null && (a = n._retryCache = new E1()), a;
      default:
        throw Error(p(435, n.tag));
    }
  }
  function T1(n, a) {
    var r = $m(n);
    a.forEach(function(s) {
      var m = dv.bind(null, n, s);
      r.has(s) || (r.add(s), s.then(m, m));
    });
  }
  function Ji(n, a) {
    var r = a.deletions;
    if (r !== null)
      for (var s = 0; s < r.length; s++) {
        var m = r[s], f = n, E = a, _ = E;
        e: for (; _ !== null; ) {
          switch (_.tag) {
            case 27:
              if (Ms(_.type)) {
                Rn = _.stateNode, fi = !1;
                break e;
              }
              break;
            case 5:
              Rn = _.stateNode, fi = !1;
              break e;
            case 3:
            case 4:
              Rn = _.stateNode.containerInfo, fi = !0;
              break e;
          }
          _ = _.return;
        }
        if (Rn === null) throw Error(p(160));
        Dt(f, E, m), Rn = null, fi = !1, f = m.alternate, f !== null && (f.return = null), m.return = null;
      }
    if (a.subtreeFlags & 13878)
      for (a = a.child; a !== null; )
        s0(a, n), a = a.sibling;
  }
  var Li = null;
  function s0(n, a) {
    var r = n.alternate, s = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Ji(a, n), si(n), s & 4 && (Ts(3, n, n.return), o0(3, n), Ts(5, n, n.return));
        break;
      case 1:
        Ji(a, n), si(n), s & 512 && (Dn || r === null || mr(r, r.return)), s & 64 && zr && (n = n.updateQueue, n !== null && (s = n.callbacks, s !== null && (r = n.shared.hiddenCallbacks, n.shared.hiddenCallbacks = r === null ? s : r.concat(s))));
        break;
      case 26:
        var m = Li;
        if (Ji(a, n), si(n), s & 512 && (Dn || r === null || mr(r, r.return)), s & 4) {
          var f = r !== null ? r.memoizedState : null;
          if (s = n.memoizedState, r === null)
            if (s === null)
              if (n.stateNode === null) {
                e: {
                  s = n.type, r = n.memoizedProps, m = m.ownerDocument || m;
                  t: switch (s) {
                    case "title":
                      f = m.getElementsByTagName("title")[0], (!f || f[He] || f[_n] || f.namespaceURI === "http://www.w3.org/2000/svg" || f.hasAttribute("itemprop")) && (f = m.createElement(s), m.head.insertBefore(
                        f,
                        m.querySelector("head > title")
                      )), ut(f, s, r), f[_n] = n, Ke(f), s = f;
                      break e;
                    case "link":
                      var E = Vp(
                        "link",
                        "href",
                        m
                      ).get(s + (r.href || ""));
                      if (E) {
                        for (var _ = 0; _ < E.length; _++)
                          if (f = E[_], f.getAttribute("href") === (r.href == null || r.href === "" ? null : r.href) && f.getAttribute("rel") === (r.rel == null ? null : r.rel) && f.getAttribute("title") === (r.title == null ? null : r.title) && f.getAttribute("crossorigin") === (r.crossOrigin == null ? null : r.crossOrigin)) {
                            E.splice(_, 1);
                            break t;
                          }
                      }
                      f = m.createElement(s), ut(f, s, r), m.head.appendChild(f);
                      break;
                    case "meta":
                      if (E = Vp(
                        "meta",
                        "content",
                        m
                      ).get(s + (r.content || ""))) {
                        for (_ = 0; _ < E.length; _++)
                          if (f = E[_], f.getAttribute("content") === (r.content == null ? null : "" + r.content) && f.getAttribute("name") === (r.name == null ? null : r.name) && f.getAttribute("property") === (r.property == null ? null : r.property) && f.getAttribute("http-equiv") === (r.httpEquiv == null ? null : r.httpEquiv) && f.getAttribute("charset") === (r.charSet == null ? null : r.charSet)) {
                            E.splice(_, 1);
                            break t;
                          }
                      }
                      f = m.createElement(s), ut(f, s, r), m.head.appendChild(f);
                      break;
                    default:
                      throw Error(p(468, s));
                  }
                  f[_n] = n, Ke(f), s = f;
                }
                n.stateNode = s;
              } else
                Cp(
                  m,
                  n.type,
                  n.stateNode
                );
            else
              n.stateNode = O2(
                m,
                s,
                n.memoizedProps
              );
          else
            f !== s ? (f === null ? r.stateNode !== null && (r = r.stateNode, r.parentNode.removeChild(r)) : f.count--, s === null ? Cp(
              m,
              n.type,
              n.stateNode
            ) : O2(
              m,
              s,
              n.memoizedProps
            )) : s === null && n.stateNode !== null && Ym(
              n,
              n.memoizedProps,
              r.memoizedProps
            );
        }
        break;
      case 27:
        Ji(a, n), si(n), s & 512 && (Dn || r === null || mr(r, r.return)), r !== null && s & 4 && Ym(
          n,
          n.memoizedProps,
          r.memoizedProps
        );
        break;
      case 5:
        if (Ji(a, n), si(n), s & 512 && (Dn || r === null || mr(r, r.return)), n.flags & 32) {
          m = n.stateNode;
          try {
            $l(m, "");
          } catch (te) {
            nn(n, n.return, te);
          }
        }
        s & 4 && n.stateNode != null && (m = n.memoizedProps, Ym(
          n,
          m,
          r !== null ? r.memoizedProps : m
        )), s & 1024 && (R1 = !0);
        break;
      case 6:
        if (Ji(a, n), si(n), s & 4) {
          if (n.stateNode === null)
            throw Error(p(162));
          s = n.memoizedProps, r = n.stateNode;
          try {
            r.nodeValue = s;
          } catch (te) {
            nn(n, n.return, te);
          }
        }
        break;
      case 3:
        if (xs = null, m = Li, Li = A1(a.containerInfo), Ji(a, n), Li = m, si(n), s & 4 && r !== null && r.memoizedState.isDehydrated)
          try {
            to(a.containerInfo);
          } catch (te) {
            nn(n, n.return, te);
          }
        R1 && (R1 = !1, ep(n));
        break;
      case 4:
        s = Li, Li = A1(
          n.stateNode.containerInfo
        ), Ji(a, n), si(n), Li = s;
        break;
      case 12:
        Ji(a, n), si(n);
        break;
      case 13:
        Ji(a, n), si(n), n.child.flags & 8192 && n.memoizedState !== null != (r !== null && r.memoizedState !== null) && (lp = vn()), s & 4 && (s = n.updateQueue, s !== null && (n.updateQueue = null, T1(n, s)));
        break;
      case 22:
        m = n.memoizedState !== null;
        var O = r !== null && r.memoizedState !== null, K = zr, me = Dn;
        if (zr = K || m, Dn = me || O, Ji(a, n), Dn = me, zr = K, si(n), s & 8192)
          e: for (a = n.stateNode, a._visibility = m ? a._visibility & -2 : a._visibility | 1, m && (r === null || O || zr || Dn || En(n)), r = null, a = n; ; ) {
            if (a.tag === 5 || a.tag === 26) {
              if (r === null) {
                O = r = a;
                try {
                  if (f = O.stateNode, m)
                    E = f.style, typeof E.setProperty == "function" ? E.setProperty("display", "none", "important") : E.display = "none";
                  else {
                    _ = O.stateNode;
                    var ve = O.memoizedProps.style, $ = ve != null && ve.hasOwnProperty("display") ? ve.display : null;
                    _.style.display = $ == null || typeof $ == "boolean" ? "" : ("" + $).trim();
                  }
                } catch (te) {
                  nn(O, O.return, te);
                }
              }
            } else if (a.tag === 6) {
              if (r === null) {
                O = a;
                try {
                  O.stateNode.nodeValue = m ? "" : O.memoizedProps;
                } catch (te) {
                  nn(O, O.return, te);
                }
              }
            } else if ((a.tag !== 22 && a.tag !== 23 || a.memoizedState === null || a === n) && a.child !== null) {
              a.child.return = a, a = a.child;
              continue;
            }
            if (a === n) break e;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === n) break e;
              r === a && (r = null), a = a.return;
            }
            r === a && (r = null), a.sibling.return = a.return, a = a.sibling;
          }
        s & 4 && (s = n.updateQueue, s !== null && (r = s.retryQueue, r !== null && (s.retryQueue = null, T1(n, r))));
        break;
      case 19:
        Ji(a, n), si(n), s & 4 && (s = n.updateQueue, s !== null && (n.updateQueue = null, T1(n, s)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Ji(a, n), si(n);
    }
  }
  function si(n) {
    var a = n.flags;
    if (a & 2) {
      try {
        for (var r, s = n.return; s !== null; ) {
          if (R2(s)) {
            r = s;
            break;
          }
          s = s.return;
        }
        if (r == null) throw Error(p(160));
        switch (r.tag) {
          case 27:
            var m = r.stateNode, f = za(n);
            v1(n, f, m);
            break;
          case 5:
            var E = r.stateNode;
            r.flags & 32 && ($l(E, ""), r.flags &= -33);
            var _ = za(n);
            v1(n, _, E);
            break;
          case 3:
          case 4:
            var O = r.stateNode.containerInfo, K = za(n);
            yl(
              n,
              K,
              O
            );
            break;
          default:
            throw Error(p(161));
        }
      } catch (me) {
        nn(n, n.return, me);
      }
      n.flags &= -3;
    }
    a & 4096 && (n.flags &= -4097);
  }
  function ep(n) {
    if (n.subtreeFlags & 1024)
      for (n = n.child; n !== null; ) {
        var a = n;
        ep(a), a.tag === 5 && a.flags & 1024 && a.stateNode.reset(), n = n.sibling;
      }
  }
  function Gr(n, a) {
    if (a.subtreeFlags & 8772)
      for (a = a.child; a !== null; )
        Km(n, a.alternate, a), a = a.sibling;
  }
  function En(n) {
    for (n = n.child; n !== null; ) {
      var a = n;
      switch (a.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Ts(4, a, a.return), En(a);
          break;
        case 1:
          mr(a, a.return);
          var r = a.stateNode;
          typeof r.componentWillUnmount == "function" && Pm(
            a,
            a.return,
            r
          ), En(a);
          break;
        case 27:
          ra(a.stateNode);
        case 26:
        case 5:
          mr(a, a.return), En(a);
          break;
        case 22:
          a.memoizedState === null && En(a);
          break;
        case 30:
          En(a);
          break;
        default:
          En(a);
      }
      n = n.sibling;
    }
  }
  function ys(n, a, r) {
    for (r = r && (a.subtreeFlags & 8772) !== 0, a = a.child; a !== null; ) {
      var s = a.alternate, m = n, f = a, E = f.flags;
      switch (f.tag) {
        case 0:
        case 11:
        case 15:
          ys(
            m,
            f,
            r
          ), o0(4, f);
          break;
        case 1:
          if (ys(
            m,
            f,
            r
          ), s = f, m = s.stateNode, typeof m.componentDidMount == "function")
            try {
              m.componentDidMount();
            } catch (K) {
              nn(s, s.return, K);
            }
          if (s = f, m = s.updateQueue, m !== null) {
            var _ = s.stateNode;
            try {
              var O = m.shared.hiddenCallbacks;
              if (O !== null)
                for (m.shared.hiddenCallbacks = null, m = 0; m < O.length; m++)
                  wu(O[m], _);
            } catch (K) {
              nn(s, s.return, K);
            }
          }
          r && E & 64 && g1(f), Cc(f, f.return);
          break;
        case 27:
          S1(f);
        case 26:
        case 5:
          ys(
            m,
            f,
            r
          ), r && s === null && E & 4 && Fc(f), Cc(f, f.return);
          break;
        case 12:
          ys(
            m,
            f,
            r
          );
          break;
        case 13:
          ys(
            m,
            f,
            r
          ), r && E & 4 && U1(m, f);
          break;
        case 22:
          f.memoizedState === null && ys(
            m,
            f,
            r
          ), Cc(f, f.return);
          break;
        case 30:
          break;
        default:
          ys(
            m,
            f,
            r
          );
      }
      a = a.sibling;
    }
  }
  function ja(n, a) {
    var r = null;
    n !== null && n.memoizedState !== null && n.memoizedState.cachePool !== null && (r = n.memoizedState.cachePool.pool), n = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (n = a.memoizedState.cachePool.pool), n !== r && (n != null && n.refCount++, r != null && xr(r));
  }
  function y1(n, a) {
    n = null, a.alternate !== null && (n = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== n && (a.refCount++, n != null && xr(n));
  }
  function gi(n, a, r, s) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; )
        tp(
          n,
          a,
          r,
          s
        ), a = a.sibling;
  }
  function tp(n, a, r, s) {
    var m = a.flags;
    switch (a.tag) {
      case 0:
      case 11:
      case 15:
        gi(
          n,
          a,
          r,
          s
        ), m & 2048 && o0(9, a);
        break;
      case 1:
        gi(
          n,
          a,
          r,
          s
        );
        break;
      case 3:
        gi(
          n,
          a,
          r,
          s
        ), m & 2048 && (n = null, a.alternate !== null && (n = a.alternate.memoizedState.cache), a = a.memoizedState.cache, a !== n && (a.refCount++, n != null && xr(n)));
        break;
      case 12:
        if (m & 2048) {
          gi(
            n,
            a,
            r,
            s
          ), n = a.stateNode;
          try {
            var f = a.memoizedProps, E = f.id, _ = f.onPostCommit;
            typeof _ == "function" && _(
              E,
              a.alternate === null ? "mount" : "update",
              n.passiveEffectDuration,
              -0
            );
          } catch (O) {
            nn(a, a.return, O);
          }
        } else
          gi(
            n,
            a,
            r,
            s
          );
        break;
      case 13:
        gi(
          n,
          a,
          r,
          s
        );
        break;
      case 23:
        break;
      case 22:
        f = a.stateNode, E = a.alternate, a.memoizedState !== null ? f._visibility & 2 ? gi(
          n,
          a,
          r,
          s
        ) : jt(n, a) : f._visibility & 2 ? gi(
          n,
          a,
          r,
          s
        ) : (f._visibility |= 2, xo(
          n,
          a,
          r,
          s,
          (a.subtreeFlags & 10256) !== 0
        )), m & 2048 && ja(E, a);
        break;
      case 24:
        gi(
          n,
          a,
          r,
          s
        ), m & 2048 && y1(a.alternate, a);
        break;
      default:
        gi(
          n,
          a,
          r,
          s
        );
    }
  }
  function xo(n, a, r, s, m) {
    for (m = m && (a.subtreeFlags & 10256) !== 0, a = a.child; a !== null; ) {
      var f = n, E = a, _ = r, O = s, K = E.flags;
      switch (E.tag) {
        case 0:
        case 11:
        case 15:
          xo(
            f,
            E,
            _,
            O,
            m
          ), o0(8, E);
          break;
        case 23:
          break;
        case 22:
          var me = E.stateNode;
          E.memoizedState !== null ? me._visibility & 2 ? xo(
            f,
            E,
            _,
            O,
            m
          ) : jt(
            f,
            E
          ) : (me._visibility |= 2, xo(
            f,
            E,
            _,
            O,
            m
          )), m && K & 2048 && ja(
            E.alternate,
            E
          );
          break;
        case 24:
          xo(
            f,
            E,
            _,
            O,
            m
          ), m && K & 2048 && y1(E.alternate, E);
          break;
        default:
          xo(
            f,
            E,
            _,
            O,
            m
          );
      }
      a = a.sibling;
    }
  }
  function jt(n, a) {
    if (a.subtreeFlags & 10256)
      for (a = a.child; a !== null; ) {
        var r = n, s = a, m = s.flags;
        switch (s.tag) {
          case 22:
            jt(r, s), m & 2048 && ja(
              s.alternate,
              s
            );
            break;
          case 24:
            jt(r, s), m & 2048 && y1(s.alternate, s);
            break;
          default:
            jt(r, s);
        }
        a = a.sibling;
      }
  }
  var Nl = 8192;
  function xn(n) {
    if (n.subtreeFlags & Nl)
      for (n = n.child; n !== null; )
        E2(n), n = n.sibling;
  }
  function E2(n) {
    switch (n.tag) {
      case 26:
        xn(n), n.flags & Nl && n.memoizedState !== null && A2(
          Li,
          n.memoizedState,
          n.memoizedProps
        );
        break;
      case 5:
        xn(n);
        break;
      case 3:
      case 4:
        var a = Li;
        Li = A1(n.stateNode.containerInfo), xn(n), Li = a;
        break;
      case 22:
        n.memoizedState === null && (a = n.alternate, a !== null && a.memoizedState !== null ? (a = Nl, Nl = 16777216, xn(n), Nl = a) : xn(n));
        break;
      default:
        xn(n);
    }
  }
  function np(n) {
    var a = n.alternate;
    if (a !== null && (n = a.child, n !== null)) {
      a.child = null;
      do
        a = n.sibling, n.sibling = null, n = a;
      while (n !== null);
    }
  }
  function bl(n) {
    var a = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (a !== null)
        for (var r = 0; r < a.length; r++) {
          var s = a[r];
          $n = s, ap(
            s,
            n
          );
        }
      np(n);
    }
    if (n.subtreeFlags & 10256)
      for (n = n.child; n !== null; )
        ip(n), n = n.sibling;
  }
  function ip(n) {
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        bl(n), n.flags & 2048 && Ts(9, n, n.return);
        break;
      case 3:
        bl(n);
        break;
      case 12:
        bl(n);
        break;
      case 22:
        var a = n.stateNode;
        n.memoizedState !== null && a._visibility & 2 && (n.return === null || n.return.tag !== 13) ? (a._visibility &= -3, Ii(n)) : bl(n);
        break;
      default:
        bl(n);
    }
  }
  function Ii(n) {
    var a = n.deletions;
    if ((n.flags & 16) !== 0) {
      if (a !== null)
        for (var r = 0; r < a.length; r++) {
          var s = a[r];
          $n = s, ap(
            s,
            n
          );
        }
      np(n);
    }
    for (n = n.child; n !== null; ) {
      switch (a = n, a.tag) {
        case 0:
        case 11:
        case 15:
          Ts(8, a, a.return), Ii(a);
          break;
        case 22:
          r = a.stateNode, r._visibility & 2 && (r._visibility &= -3, Ii(a));
          break;
        default:
          Ii(a);
      }
      n = n.sibling;
    }
  }
  function ap(n, a) {
    for (; $n !== null; ) {
      var r = $n;
      switch (r.tag) {
        case 0:
        case 11:
        case 15:
          Ts(8, r, a);
          break;
        case 23:
        case 22:
          if (r.memoizedState !== null && r.memoizedState.cachePool !== null) {
            var s = r.memoizedState.cachePool.pool;
            s != null && s.refCount++;
          }
          break;
        case 24:
          xr(r.memoizedState.cache);
      }
      if (s = r.child, s !== null) s.return = r, $n = s;
      else
        e: for (r = n; $n !== null; ) {
          s = $n;
          var m = s.sibling, f = s.return;
          if (qm(s), s === r) {
            $n = null;
            break e;
          }
          if (m !== null) {
            m.return = f, $n = m;
            break e;
          }
          $n = f;
        }
    }
  }
  var rp = {
    getCacheForType: function(n) {
      var a = ai(Xn), r = a.data.get(n);
      return r === void 0 && (r = n(), a.data.set(n, r)), r;
    }
  }, U2 = typeof WeakMap == "function" ? WeakMap : Map, Xt = 0, dn = null, xt = null, Zt = 0, $t = 0, na = null, Pr = !1, _c = !1, op = !1, Zo = 0, Zn = 0, Oo = 0, Vl = 0, Yr = 0, Ga = 0, Mc = 0, kc = null, ia = null, sp = !1, lp = 0, N1 = 1 / 0, Qc = null, Ns = null, vi = 0, Xr = null, Dc = null, Si = 0, b1 = 0, V1 = null, cp = null, xc = 0, dp = null;
  function Sa() {
    if ((Xt & 2) !== 0 && Zt !== 0)
      return Zt & -Zt;
    if (Z.T !== null) {
      var n = Ia;
      return n !== 0 ? n : Ml();
    }
    return $o();
  }
  function up() {
    Ga === 0 && (Ga = (Zt & 536870912) === 0 || Wt ? ke() : 536870912);
    var n = va.current;
    return n !== null && (n.flags |= 32), Ga;
  }
  function Ra(n, a, r) {
    (n === dn && ($t === 2 || $t === 9) || n.cancelPendingCommit !== null) && (Kr(n, 0), Bo(
      n,
      Zt,
      Ga,
      !1
    )), nt(n, r), ((Xt & 2) === 0 || n !== dn) && (n === dn && ((Xt & 2) === 0 && (Vl |= r), Zn === 4 && Bo(
      n,
      Zt,
      Ga,
      !1
    )), aa(n));
  }
  function Zc(n, a, r) {
    if ((Xt & 6) !== 0) throw Error(p(327));
    var s = !r && (a & 124) === 0 && (a & n.expiredLanes) === 0 || C(n, a), m = s ? mp(n, a) : C1(n, a, !0), f = s;
    do {
      if (m === 0) {
        _c && !s && Bo(n, a, 0, !1);
        break;
      } else {
        if (r = n.current.alternate, f && !T2(r)) {
          m = C1(n, a, !1), f = !1;
          continue;
        }
        if (m === 2) {
          if (f = a, n.errorRecoveryDisabledLanes & f)
            var E = 0;
          else
            E = n.pendingLanes & -536870913, E = E !== 0 ? E : E & 536870912 ? 536870912 : 0;
          if (E !== 0) {
            a = E;
            e: {
              var _ = n;
              m = kc;
              var O = _.current.memoizedState.isDehydrated;
              if (O && (Kr(_, E).flags |= 256), E = C1(
                _,
                E,
                !1
              ), E !== 2) {
                if (op && !O) {
                  _.errorRecoveryDisabledLanes |= f, Vl |= f, m = 4;
                  break e;
                }
                f = ia, ia = m, f !== null && (ia === null ? ia = f : ia.push.apply(
                  ia,
                  f
                ));
              }
              m = E;
            }
            if (f = !1, m !== 2) continue;
          }
        }
        if (m === 1) {
          Kr(n, 0), Bo(n, a, 0, !0);
          break;
        }
        e: {
          switch (s = n, f = m, f) {
            case 0:
            case 1:
              throw Error(p(345));
            case 4:
              if ((a & 4194048) !== a) break;
            case 6:
              Bo(
                s,
                a,
                Ga,
                !Pr
              );
              break e;
            case 2:
              ia = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(p(329));
          }
          if ((a & 62914560) === a && (m = lp + 300 - vn(), 10 < m)) {
            if (Bo(
              s,
              a,
              Ga,
              !Pr
            ), Oi(s, 0, !0) !== 0) break e;
            s.timeoutHandle = B1(
              l0.bind(
                null,
                s,
                r,
                ia,
                Qc,
                sp,
                a,
                Ga,
                Vl,
                Mc,
                Pr,
                f,
                2,
                -0,
                0
              ),
              m
            );
            break e;
          }
          l0(
            s,
            r,
            ia,
            Qc,
            sp,
            a,
            Ga,
            Vl,
            Mc,
            Pr,
            f,
            0,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    aa(n);
  }
  function l0(n, a, r, s, m, f, E, _, O, K, me, ve, $, te) {
    if (n.timeoutHandle = -1, ve = a.subtreeFlags, (ve & 8192 || (ve & 16785408) === 16785408) && (Gc = { stylesheets: null, count: 0, unsuspend: w2 }, E2(a), ve = _p(), ve !== null)) {
      n.cancelPendingCommit = ve(
        b2.bind(
          null,
          n,
          a,
          f,
          r,
          s,
          m,
          E,
          _,
          O,
          me,
          1,
          $,
          te
        )
      ), Bo(n, f, E, !K);
      return;
    }
    b2(
      n,
      a,
      f,
      r,
      s,
      m,
      E,
      _,
      O
    );
  }
  function T2(n) {
    for (var a = n; ; ) {
      var r = a.tag;
      if ((r === 0 || r === 11 || r === 15) && a.flags & 16384 && (r = a.updateQueue, r !== null && (r = r.stores, r !== null)))
        for (var s = 0; s < r.length; s++) {
          var m = r[s], f = m.getSnapshot;
          m = m.value;
          try {
            if (!pi(f(), m)) return !1;
          } catch {
            return !1;
          }
        }
      if (r = a.child, a.subtreeFlags & 16384 && r !== null)
        r.return = a, a = r;
      else {
        if (a === n) break;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === n) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
    }
    return !0;
  }
  function Bo(n, a, r, s) {
    a &= ~Yr, a &= ~Vl, n.suspendedLanes |= a, n.pingedLanes &= ~a, s && (n.warmLanes |= a), s = n.expirationTimes;
    for (var m = a; 0 < m; ) {
      var f = 31 - Ln(m), E = 1 << f;
      s[f] = -1, m &= ~E;
    }
    r !== 0 && Ct(n, r, a);
  }
  function Cl() {
    return (Xt & 6) === 0 ? (h0(0), !1) : !0;
  }
  function bs() {
    if (xt !== null) {
      if ($t === 0)
        var n = xt.return;
      else
        n = xt, cr = Co = null, Iu(n), vl = null, Tc = 0, n = xt;
      for (; n !== null; )
        Gm(n.alternate, n), n = n.return;
      xt = null;
    }
  }
  function Kr(n, a) {
    var r = n.timeoutHandle;
    r !== -1 && (n.timeoutHandle = -1, pv(r)), r = n.cancelPendingCommit, r !== null && (n.cancelPendingCommit = null, r()), bs(), dn = n, xt = r = sr(n.current, null), Zt = a, $t = 0, na = null, Pr = !1, _c = C(n, a), op = !1, Mc = Ga = Yr = Vl = Oo = Zn = 0, ia = kc = null, sp = !1, (a & 8) !== 0 && (a |= a & 32);
    var s = n.entangledLanes;
    if (s !== 0)
      for (n = n.entanglements, s &= a; 0 < s; ) {
        var m = 31 - Ln(s), f = 1 << m;
        a |= n[m], s &= ~f;
      }
    return Zo = a, or(), r;
  }
  function hp(n, a) {
    Et = null, Z.H = i1, a === fs || a === wd ? (a = gm(), $t = 3) : a === Du ? (a = gm(), $t = 4) : $t = a === Qn ? 8 : a !== null && typeof a == "object" && typeof a.then == "function" ? 6 : 1, na = a, xt === null && (Zn = 1, n0(
      n,
      pa(a, n.current)
    ));
  }
  function y2() {
    var n = Z.H;
    return Z.H = i1, n === null ? i1 : n;
  }
  function Fl() {
    var n = Z.A;
    return Z.A = rp, n;
  }
  function _l() {
    Zn = 4, Pr || (Zt & 4194048) !== Zt && va.current !== null || (_c = !0), (Oo & 134217727) === 0 && (Vl & 134217727) === 0 || dn === null || Bo(
      dn,
      Zt,
      Ga,
      !1
    );
  }
  function C1(n, a, r) {
    var s = Xt;
    Xt |= 2;
    var m = y2(), f = Fl();
    (dn !== n || Zt !== a) && (Qc = null, Kr(n, a)), a = !1;
    var E = Zn;
    e: do
      try {
        if ($t !== 0 && xt !== null) {
          var _ = xt, O = na;
          switch ($t) {
            case 8:
              bs(), E = 6;
              break e;
            case 3:
            case 2:
            case 9:
            case 6:
              va.current === null && (a = !0);
              var K = $t;
              if ($t = 0, na = null, Oc(n, _, O, K), r && _c) {
                E = 0;
                break e;
              }
              break;
            default:
              K = $t, $t = 0, na = null, Oc(n, _, O, K);
          }
        }
        F1(), E = Zn;
        break;
      } catch (me) {
        hp(n, me);
      }
    while (!0);
    return a && n.shellSuspendCounter++, cr = Co = null, Xt = s, Z.H = m, Z.A = f, xt === null && (dn = null, Zt = 0, or()), E;
  }
  function F1() {
    for (; xt !== null; ) fp(xt);
  }
  function mp(n, a) {
    var r = Xt;
    Xt |= 2;
    var s = y2(), m = Fl();
    dn !== n || Zt !== a ? (Qc = null, N1 = vn() + 500, Kr(n, a)) : _c = C(
      n,
      a
    );
    e: do
      try {
        if ($t !== 0 && xt !== null) {
          a = xt;
          var f = na;
          t: switch ($t) {
            case 1:
              $t = 0, na = null, Oc(n, a, f, 1);
              break;
            case 2:
            case 9:
              if (Zu(f)) {
                $t = 0, na = null, gp(a);
                break;
              }
              a = function() {
                $t !== 2 && $t !== 9 || dn !== n || ($t = 7), aa(n);
              }, f.then(a, a);
              break e;
            case 3:
              $t = 7;
              break e;
            case 4:
              $t = 5;
              break e;
            case 7:
              Zu(f) ? ($t = 0, na = null, gp(a)) : ($t = 0, na = null, Oc(n, a, f, 7));
              break;
            case 5:
              var E = null;
              switch (xt.tag) {
                case 26:
                  E = xt.memoizedState;
                case 5:
                case 27:
                  var _ = xt;
                  if (!E || Fp(E)) {
                    $t = 0, na = null;
                    var O = _.sibling;
                    if (O !== null) xt = O;
                    else {
                      var K = _.return;
                      K !== null ? (xt = K, c0(K)) : xt = null;
                    }
                    break t;
                  }
              }
              $t = 0, na = null, Oc(n, a, f, 5);
              break;
            case 6:
              $t = 0, na = null, Oc(n, a, f, 6);
              break;
            case 8:
              bs(), Zn = 6;
              break e;
            default:
              throw Error(p(462));
          }
        }
        pp();
        break;
      } catch (me) {
        hp(n, me);
      }
    while (!0);
    return cr = Co = null, Z.H = s, Z.A = m, Xt = r, xt !== null ? 0 : (dn = null, Zt = 0, or(), Zn);
  }
  function pp() {
    for (; xt !== null && !go(); )
      fp(xt);
  }
  function fp(n) {
    var a = S2(n.alternate, n, Zo);
    n.memoizedProps = n.pendingProps, a === null ? c0(n) : xt = a;
  }
  function gp(n) {
    var a = n, r = a.alternate;
    switch (a.tag) {
      case 15:
      case 0:
        a = Im(
          r,
          a,
          a.pendingProps,
          a.type,
          void 0,
          Zt
        );
        break;
      case 11:
        a = Im(
          r,
          a,
          a.pendingProps,
          a.type.render,
          a.ref,
          Zt
        );
        break;
      case 5:
        Iu(a);
      default:
        Gm(r, a), a = xt = Ft(a, Zo), a = S2(r, a, Zo);
    }
    n.memoizedProps = n.pendingProps, a === null ? c0(n) : xt = a;
  }
  function Oc(n, a, r, s) {
    cr = Co = null, Iu(a), vl = null, Tc = 0;
    var m = a.return;
    try {
      if (f2(
        n,
        m,
        a,
        r,
        Zt
      )) {
        Zn = 1, n0(
          n,
          pa(r, n.current)
        ), xt = null;
        return;
      }
    } catch (f) {
      if (m !== null) throw xt = m, f;
      Zn = 1, n0(
        n,
        pa(r, n.current)
      ), xt = null;
      return;
    }
    a.flags & 32768 ? (Wt || s === 1 ? n = !0 : _c || (Zt & 536870912) !== 0 ? n = !1 : (Pr = n = !0, (s === 2 || s === 9 || s === 3 || s === 6) && (s = va.current, s !== null && s.tag === 13 && (s.flags |= 16384))), N2(a, n)) : c0(a);
  }
  function c0(n) {
    var a = n;
    do {
      if ((a.flags & 32768) !== 0) {
        N2(
          a,
          Pr
        );
        return;
      }
      n = a.return;
      var r = jm(
        a.alternate,
        a,
        Zo
      );
      if (r !== null) {
        xt = r;
        return;
      }
      if (a = a.sibling, a !== null) {
        xt = a;
        return;
      }
      xt = a = n;
    } while (a !== null);
    Zn === 0 && (Zn = 5);
  }
  function N2(n, a) {
    do {
      var r = lv(n.alternate, n);
      if (r !== null) {
        r.flags &= 32767, xt = r;
        return;
      }
      if (r = n.return, r !== null && (r.flags |= 32768, r.subtreeFlags = 0, r.deletions = null), !a && (n = n.sibling, n !== null)) {
        xt = n;
        return;
      }
      xt = n = r;
    } while (n !== null);
    Zn = 6, xt = null;
  }
  function b2(n, a, r, s, m, f, E, _, O) {
    n.cancelPendingCommit = null;
    do
      M1();
    while (vi !== 0);
    if ((Xt & 6) !== 0) throw Error(p(327));
    if (a !== null) {
      if (a === n.current) throw Error(p(177));
      if (f = a.lanes | a.childLanes, f |= Mr, mt(
        n,
        r,
        f,
        E,
        _,
        O
      ), n === dn && (xt = dn = null, Zt = 0), Dc = a, Xr = n, Si = r, b1 = f, V1 = m, cp = s, (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? (n.callbackNode = null, n.callbackPriority = 0, uv(bi, function() {
        return vp(), null;
      })) : (n.callbackNode = null, n.callbackPriority = 0), s = (a.flags & 13878) !== 0, (a.subtreeFlags & 13878) !== 0 || s) {
        s = Z.T, Z.T = null, m = X.p, X.p = 2, E = Xt, Xt |= 4;
        try {
          Xm(n, a, r);
        } finally {
          Xt = E, X.p = m, Z.T = s;
        }
      }
      vi = 1, V2(), d0(), _1();
    }
  }
  function V2() {
    if (vi === 1) {
      vi = 0;
      var n = Xr, a = Dc, r = (a.flags & 13878) !== 0;
      if ((a.subtreeFlags & 13878) !== 0 || r) {
        r = Z.T, Z.T = null;
        var s = X.p;
        X.p = 2;
        var m = Xt;
        Xt |= 4;
        try {
          s0(a, n);
          var f = E0, E = rm(n.containerInfo), _ = f.focusedElem, O = f.selectionRange;
          if (E !== _ && _ && _.ownerDocument && Cd(
            _.ownerDocument.documentElement,
            _
          )) {
            if (O !== null && Fd(_)) {
              var K = O.start, me = O.end;
              if (me === void 0 && (me = K), "selectionStart" in _)
                _.selectionStart = K, _.selectionEnd = Math.min(
                  me,
                  _.value.length
                );
              else {
                var ve = _.ownerDocument || document, $ = ve && ve.defaultView || window;
                if ($.getSelection) {
                  var te = $.getSelection(), it = _.textContent.length, at = Math.min(O.start, it), Gt = O.end === void 0 ? at : Math.min(O.end, it);
                  !te.extend && at > Gt && (E = Gt, Gt = at, at = E);
                  var G = mn(
                    _,
                    at
                  ), W = mn(
                    _,
                    Gt
                  );
                  if (G && W && (te.rangeCount !== 1 || te.anchorNode !== G.node || te.anchorOffset !== G.offset || te.focusNode !== W.node || te.focusOffset !== W.offset)) {
                    var Y = ve.createRange();
                    Y.setStart(G.node, G.offset), te.removeAllRanges(), at > Gt ? (te.addRange(Y), te.extend(W.node, W.offset)) : (Y.setEnd(W.node, W.offset), te.addRange(Y));
                  }
                }
              }
            }
            for (ve = [], te = _; te = te.parentNode; )
              te.nodeType === 1 && ve.push({
                element: te,
                left: te.scrollLeft,
                top: te.scrollTop
              });
            for (typeof _.focus == "function" && _.focus(), _ = 0; _ < ve.length; _++) {
              var ge = ve[_];
              ge.element.scrollLeft = ge.left, ge.element.scrollTop = ge.top;
            }
          }
          b0 = !!R0, E0 = R0 = null;
        } finally {
          Xt = m, X.p = s, Z.T = r;
        }
      }
      n.current = a, vi = 2;
    }
  }
  function d0() {
    if (vi === 2) {
      vi = 0;
      var n = Xr, a = Dc, r = (a.flags & 8772) !== 0;
      if ((a.subtreeFlags & 8772) !== 0 || r) {
        r = Z.T, Z.T = null;
        var s = X.p;
        X.p = 2;
        var m = Xt;
        Xt |= 4;
        try {
          Km(n, a.alternate, a);
        } finally {
          Xt = m, X.p = s, Z.T = r;
        }
      }
      vi = 3;
    }
  }
  function _1() {
    if (vi === 4 || vi === 3) {
      vi = 0, Qt();
      var n = Xr, a = Dc, r = Si, s = cp;
      (a.subtreeFlags & 10256) !== 0 || (a.flags & 10256) !== 0 ? vi = 5 : (vi = 0, Dc = Xr = null, C2(n, n.pendingLanes));
      var m = n.pendingLanes;
      if (m === 0 && (Ns = null), Bi(r), a = a.stateNode, Jn && typeof Jn.onCommitFiberRoot == "function")
        try {
          Jn.onCommitFiberRoot(
            ni,
            a,
            void 0,
            (a.current.flags & 128) === 128
          );
        } catch {
        }
      if (s !== null) {
        a = Z.T, m = X.p, X.p = 2, Z.T = null;
        try {
          for (var f = n.onRecoverableError, E = 0; E < s.length; E++) {
            var _ = s[E];
            f(_.value, {
              componentStack: _.stack
            });
          }
        } finally {
          Z.T = a, X.p = m;
        }
      }
      (Si & 3) !== 0 && M1(), aa(n), m = n.pendingLanes, (r & 4194090) !== 0 && (m & 42) !== 0 ? n === dp ? xc++ : (xc = 0, dp = n) : xc = 0, h0(0);
    }
  }
  function C2(n, a) {
    (n.pooledCacheLanes &= a) === 0 && (a = n.pooledCache, a != null && (n.pooledCache = null, xr(a)));
  }
  function M1(n) {
    return V2(), d0(), _1(), vp();
  }
  function vp() {
    if (vi !== 5) return !1;
    var n = Xr, a = b1;
    b1 = 0;
    var r = Bi(Si), s = Z.T, m = X.p;
    try {
      X.p = 32 > r ? 32 : r, Z.T = null, r = V1, V1 = null;
      var f = Xr, E = Si;
      if (vi = 0, Dc = Xr = null, Si = 0, (Xt & 6) !== 0) throw Error(p(331));
      var _ = Xt;
      if (Xt |= 4, ip(f.current), tp(
        f,
        f.current,
        E,
        r
      ), Xt = _, h0(0, !1), Jn && typeof Jn.onPostCommitFiberRoot == "function")
        try {
          Jn.onPostCommitFiberRoot(ni, f);
        } catch {
        }
      return !0;
    } finally {
      X.p = m, Z.T = s, C2(n, a);
    }
  }
  function Sp(n, a, r) {
    a = pa(r, a), a = Jm(n.stateNode, a, 2), n = Br(n, a, 2), n !== null && (nt(n, 2), aa(n));
  }
  function nn(n, a, r) {
    if (n.tag === 3)
      Sp(n, n, r);
    else
      for (; a !== null; ) {
        if (a.tag === 3) {
          Sp(
            a,
            n,
            r
          );
          break;
        } else if (a.tag === 1) {
          var s = a.stateNode;
          if (typeof a.type.getDerivedStateFromError == "function" || typeof s.componentDidCatch == "function" && (Ns === null || !Ns.has(s))) {
            n = pa(r, n), r = Lm(2), s = Br(a, r, 2), s !== null && (ta(
              r,
              s,
              a,
              n
            ), nt(s, 2), aa(s));
            break;
          }
        }
        a = a.return;
      }
  }
  function k1(n, a, r) {
    var s = n.pingCache;
    if (s === null) {
      s = n.pingCache = new U2();
      var m = /* @__PURE__ */ new Set();
      s.set(a, m);
    } else
      m = s.get(a), m === void 0 && (m = /* @__PURE__ */ new Set(), s.set(a, m));
    m.has(r) || (op = !0, m.add(r), n = Rp.bind(null, n, a, r), a.then(n, n));
  }
  function Rp(n, a, r) {
    var s = n.pingCache;
    s !== null && s.delete(a), n.pingedLanes |= n.suspendedLanes & r, n.warmLanes &= ~r, dn === n && (Zt & r) === r && (Zn === 4 || Zn === 3 && (Zt & 62914560) === Zt && 300 > vn() - lp ? (Xt & 2) === 0 && Kr(n, 0) : Yr |= r, Mc === Zt && (Mc = 0)), aa(n);
  }
  function Ep(n, a) {
    a === 0 && (a = Oe()), n = kr(n, a), n !== null && (nt(n, a), aa(n));
  }
  function cv(n) {
    var a = n.memoizedState, r = 0;
    a !== null && (r = a.retryLane), Ep(n, r);
  }
  function dv(n, a) {
    var r = 0;
    switch (n.tag) {
      case 13:
        var s = n.stateNode, m = n.memoizedState;
        m !== null && (r = m.retryLane);
        break;
      case 19:
        s = n.stateNode;
        break;
      case 22:
        s = n.stateNode._retryCache;
        break;
      default:
        throw Error(p(314));
    }
    s !== null && s.delete(a), Ep(n, r);
  }
  function uv(n, a) {
    return gn(n, a);
  }
  var Q1 = null, Vs = null, u0 = !1, Bc = !1, D1 = !1, Cs = 0;
  function aa(n) {
    n !== Vs && n.next === null && (Vs === null ? Q1 = Vs = n : Vs = Vs.next = n), Bc = !0, u0 || (u0 = !0, M2());
  }
  function h0(n, a) {
    if (!D1 && Bc) {
      D1 = !0;
      do
        for (var r = !1, s = Q1; s !== null; ) {
          if (n !== 0) {
            var m = s.pendingLanes;
            if (m === 0) var f = 0;
            else {
              var E = s.suspendedLanes, _ = s.pingedLanes;
              f = (1 << 31 - Ln(42 | n) + 1) - 1, f &= m & ~(E & ~_), f = f & 201326741 ? f & 201326741 | 1 : f ? f | 2 : 0;
            }
            f !== 0 && (r = !0, p0(s, f));
          } else
            f = Zt, f = Oi(
              s,
              s === dn ? f : 0,
              s.cancelPendingCommit !== null || s.timeoutHandle !== -1
            ), (f & 3) === 0 || C(s, f) || (r = !0, p0(s, f));
          s = s.next;
        }
      while (r);
      D1 = !1;
    }
  }
  function F2() {
    m0();
  }
  function m0() {
    Bc = u0 = !1;
    var n = 0;
    Cs !== 0 && (Jo() && (n = Cs), Cs = 0);
    for (var a = vn(), r = null, s = Q1; s !== null; ) {
      var m = s.next, f = Up(s, a);
      f === 0 ? (s.next = null, r === null ? Q1 = m : r.next = m, m === null && (Vs = r)) : (r = s, (n !== 0 || (f & 3) !== 0) && (Bc = !0)), s = m;
    }
    h0(n);
  }
  function Up(n, a) {
    for (var r = n.suspendedLanes, s = n.pingedLanes, m = n.expirationTimes, f = n.pendingLanes & -62914561; 0 < f; ) {
      var E = 31 - Ln(f), _ = 1 << E, O = m[E];
      O === -1 ? ((_ & r) === 0 || (_ & s) !== 0) && (m[E] = j(_, a)) : O <= a && (n.expiredLanes |= _), f &= ~_;
    }
    if (a = dn, r = Zt, r = Oi(
      n,
      n === a ? r : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), s = n.callbackNode, r === 0 || n === a && ($t === 2 || $t === 9) || n.cancelPendingCommit !== null)
      return s !== null && s !== null && Ma(s), n.callbackNode = null, n.callbackPriority = 0;
    if ((r & 3) === 0 || C(n, r)) {
      if (a = r & -r, a === n.callbackPriority) return a;
      switch (s !== null && Ma(s), Bi(r)) {
        case 2:
        case 8:
          r = gt;
          break;
        case 32:
          r = bi;
          break;
        case 268435456:
          r = xi;
          break;
        default:
          r = bi;
      }
      return s = _2.bind(null, n), r = gn(r, s), n.callbackPriority = a, n.callbackNode = r, a;
    }
    return s !== null && s !== null && Ma(s), n.callbackPriority = 2, n.callbackNode = null, 2;
  }
  function _2(n, a) {
    if (vi !== 0 && vi !== 5)
      return n.callbackNode = null, n.callbackPriority = 0, null;
    var r = n.callbackNode;
    if (M1() && n.callbackNode !== r)
      return null;
    var s = Zt;
    return s = Oi(
      n,
      n === dn ? s : 0,
      n.cancelPendingCommit !== null || n.timeoutHandle !== -1
    ), s === 0 ? null : (Zc(n, s, a), Up(n, vn()), n.callbackNode != null && n.callbackNode === r ? _2.bind(null, n) : null);
  }
  function p0(n, a) {
    if (M1()) return null;
    Zc(n, a, !0);
  }
  function M2() {
    fv(function() {
      (Xt & 6) !== 0 ? gn(
        Rr,
        F2
      ) : m0();
    });
  }
  function Ml() {
    return Cs === 0 && (Cs = ke()), Cs;
  }
  function x1(n) {
    return n == null || typeof n == "symbol" || typeof n == "boolean" ? null : typeof n == "function" ? n : Rd("" + n);
  }
  function f0(n, a) {
    var r = a.ownerDocument.createElement("input");
    return r.name = a.name, r.value = a.value, n.id && r.setAttribute("form", n.id), a.parentNode.insertBefore(r, a), n = new FormData(n), r.parentNode.removeChild(r), n;
  }
  function k2(n, a, r, s, m) {
    if (a === "submit" && r && r.stateNode === m) {
      var f = x1(
        (m[Yn] || null).action
      ), E = s.submitter;
      E && (a = (a = E[Yn] || null) ? x1(a.formAction) : E.getAttribute("formAction"), a !== null && (f = a, E = null));
      var _ = new gu(
        "action",
        "action",
        null,
        s,
        m
      );
      n.push({
        event: _,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (s.defaultPrevented) {
                if (Cs !== 0) {
                  var O = E ? f0(m, E) : new FormData(m);
                  n1(
                    r,
                    {
                      pending: !0,
                      data: O,
                      method: m.method,
                      action: f
                    },
                    null,
                    O
                  );
                }
              } else
                typeof f == "function" && (_.preventDefault(), O = E ? f0(m, E) : new FormData(m), n1(
                  r,
                  {
                    pending: !0,
                    data: O,
                    method: m.method,
                    action: f
                  },
                  f,
                  O
                ));
            },
            currentTarget: m
          }
        ]
      });
    }
  }
  for (var On = 0; On < rc.length; On++) {
    var g0 = rc[On], hv = g0.toLowerCase(), bt = g0[0].toUpperCase() + g0.slice(1);
    Ba(
      hv,
      "on" + bt
    );
  }
  Ba(e2, "onAnimationEnd"), Ba(om, "onAnimationIteration"), Ba(t2, "onAnimationStart"), Ba("dblclick", "onDoubleClick"), Ba("focusin", "onFocus"), Ba("focusout", "onBlur"), Ba(sm, "onTransitionRun"), Ba(bu, "onTransitionStart"), Ba(n2, "onTransitionCancel"), Ba(lm, "onTransitionEnd"), Gi("onMouseEnter", ["mouseout", "mouseover"]), Gi("onMouseLeave", ["mouseout", "mouseover"]), Gi("onPointerEnter", ["pointerout", "pointerover"]), Gi("onPointerLeave", ["pointerout", "pointerover"]), qt(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), qt(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), qt("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), qt(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), qt(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), qt(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var v0 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Fs = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(v0)
  );
  function kl(n, a) {
    a = (a & 4) !== 0;
    for (var r = 0; r < n.length; r++) {
      var s = n[r], m = s.event;
      s = s.listeners;
      e: {
        var f = void 0;
        if (a)
          for (var E = s.length - 1; 0 <= E; E--) {
            var _ = s[E], O = _.instance, K = _.currentTarget;
            if (_ = _.listener, O !== f && m.isPropagationStopped())
              break e;
            f = _, m.currentTarget = K;
            try {
              f(m);
            } catch (me) {
              e0(me);
            }
            m.currentTarget = null, f = O;
          }
        else
          for (E = 0; E < s.length; E++) {
            if (_ = s[E], O = _.instance, K = _.currentTarget, _ = _.listener, O !== f && m.isPropagationStopped())
              break e;
            f = _, m.currentTarget = K;
            try {
              f(m);
            } catch (me) {
              e0(me);
            }
            m.currentTarget = null, f = O;
          }
      }
    }
  }
  function Ut(n, a) {
    var r = a[Ur];
    r === void 0 && (r = a[Ur] = /* @__PURE__ */ new Set());
    var s = n + "__bubble";
    r.has(s) || (Z1(a, n, 2, !1), r.add(s));
  }
  function wc(n, a, r) {
    var s = 0;
    a && (s |= 4), Z1(
      r,
      n,
      s,
      a
    );
  }
  var Ac = "_reactListening" + Math.random().toString(36).slice(2);
  function Tp(n) {
    if (!n[Ac]) {
      n[Ac] = !0, qe.forEach(function(r) {
        r !== "selectionchange" && (Fs.has(r) || wc(r, !1, n), wc(r, !0, n));
      });
      var a = n.nodeType === 9 ? n : n.ownerDocument;
      a === null || a[Ac] || (a[Ac] = !0, wc("selectionchange", !1, a));
    }
  }
  function Z1(n, a, r, s) {
    switch (Bp(a)) {
      case 2:
        var m = J2;
        break;
      case 8:
        m = L2;
        break;
      default:
        m = Zp;
    }
    r = m.bind(
      null,
      a,
      r,
      n
    ), m = void 0, !mu || a !== "touchstart" && a !== "touchmove" && a !== "wheel" || (m = !0), s ? m !== void 0 ? n.addEventListener(a, r, {
      capture: !0,
      passive: m
    }) : n.addEventListener(a, r, !0) : m !== void 0 ? n.addEventListener(a, r, {
      passive: m
    }) : n.addEventListener(a, r, !1);
  }
  function Pa(n, a, r, s, m) {
    var f = s;
    if ((a & 1) === 0 && (a & 2) === 0 && s !== null)
      e: for (; ; ) {
        if (s === null) return;
        var E = s.tag;
        if (E === 3 || E === 4) {
          var _ = s.stateNode.containerInfo;
          if (_ === m) break;
          if (E === 4)
            for (E = s.return; E !== null; ) {
              var O = E.tag;
              if ((O === 3 || O === 4) && E.stateNode.containerInfo === m)
                return;
              E = E.return;
            }
          for (; _ !== null; ) {
            if (E = B(_), E === null) return;
            if (O = E.tag, O === 5 || O === 6 || O === 26 || O === 27) {
              s = f = E;
              continue e;
            }
            _ = _.parentNode;
          }
        }
        s = s.return;
      }
    nc(function() {
      var K = f, me = hu(r), ve = [];
      e: {
        var $ = cm.get(n);
        if ($ !== void 0) {
          var te = gu, it = n;
          switch (n) {
            case "keypress":
              if (mi(r) === 0) break e;
            case "keydown":
            case "keyup":
              te = tr;
              break;
            case "focusin":
              it = "focus", te = Hh;
              break;
            case "focusout":
              it = "blur", te = Hh;
              break;
            case "beforeblur":
            case "afterblur":
              te = Hh;
              break;
            case "click":
              if (r.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              te = Wh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              te = zf;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              te = Gh;
              break;
            case e2:
            case om:
            case t2:
              te = av;
              break;
            case lm:
              te = Xf;
              break;
            case "scroll":
            case "scrollend":
              te = Wf;
              break;
            case "wheel":
              te = el;
              break;
            case "copy":
            case "cut":
            case "paste":
              te = Td;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              te = yd;
              break;
            case "toggle":
            case "beforetoggle":
              te = Kf;
          }
          var at = (a & 4) !== 0, Gt = !at && (n === "scroll" || n === "scrollend"), G = at ? $ !== null ? $ + "Capture" : null : $;
          at = [];
          for (var W = K, Y; W !== null; ) {
            var ge = W;
            if (Y = ge.stateNode, ge = ge.tag, ge !== 5 && ge !== 26 && ge !== 27 || Y === null || G === null || (ge = Xs(W, G), ge != null && at.push(
              wo(W, ge, Y)
            )), Gt) break;
            W = W.return;
          }
          0 < at.length && ($ = new te(
            $,
            it,
            null,
            r,
            me
          ), ve.push({ event: $, listeners: at }));
        }
      }
      if ((a & 7) === 0) {
        e: {
          if ($ = n === "mouseover" || n === "pointerover", te = n === "mouseout" || n === "pointerout", $ && r !== Ys && (it = r.relatedTarget || r.fromElement) && (B(it) || it[Da]))
            break e;
          if ((te || $) && ($ = me.window === me ? me : ($ = me.ownerDocument) ? $.defaultView || $.parentWindow : window, te ? (it = r.relatedTarget || r.toElement, te = K, it = it ? B(it) : null, it !== null && (Gt = R(it), at = it.tag, it !== Gt || at !== 5 && at !== 27 && at !== 6) && (it = null)) : (te = null, it = K), te !== it)) {
            if (at = Wh, ge = "onMouseLeave", G = "onMouseEnter", W = "mouse", (n === "pointerout" || n === "pointerover") && (at = yd, ge = "onPointerLeave", G = "onPointerEnter", W = "pointer"), Gt = te == null ? $ : Ie(te), Y = it == null ? $ : Ie(it), $ = new at(
              ge,
              W + "leave",
              te,
              r,
              me
            ), $.target = Gt, $.relatedTarget = Y, ge = null, B(me) === K && (at = new at(
              G,
              W + "enter",
              it,
              r,
              me
            ), at.target = Y, at.relatedTarget = Gt, ge = at), Gt = ge, te && it)
              t: {
                for (at = te, G = it, W = 0, Y = at; Y; Y = _s(Y))
                  W++;
                for (Y = 0, ge = G; ge; ge = _s(ge))
                  Y++;
                for (; 0 < W - Y; )
                  at = _s(at), W--;
                for (; 0 < Y - W; )
                  G = _s(G), Y--;
                for (; W--; ) {
                  if (at === G || G !== null && at === G.alternate)
                    break t;
                  at = _s(at), G = _s(G);
                }
                at = null;
              }
            else at = null;
            te !== null && S0(
              ve,
              $,
              te,
              at,
              !1
            ), it !== null && Gt !== null && S0(
              ve,
              Gt,
              it,
              at,
              !0
            );
          }
        }
        e: {
          if ($ = K ? Ie(K) : window, te = $.nodeName && $.nodeName.toLowerCase(), te === "select" || te === "input" && $.type === "file")
            var ze = $h;
          else if (Uu($))
            if (em)
              ze = im;
            else {
              ze = rs;
              var _t = yu;
            }
          else
            te = $.nodeName, !te || te.toLowerCase() !== "input" || $.type !== "checkbox" && $.type !== "radio" ? K && Ps(K.elementType) && (ze = $h) : ze = yo;
          if (ze && (ze = ze(n, K))) {
            Tu(
              ve,
              ze,
              r,
              me
            );
            break e;
          }
          _t && _t(n, $, K), n === "focusout" && K && $.type === "number" && K.memoizedProps.value != null && vd($, "number", $.value);
        }
        switch (_t = K ? Ie(K) : window, n) {
          case "focusin":
            (Uu(_t) || _t.contentEditable === "true") && (Fr = _t, ar = K, ls = null);
            break;
          case "focusout":
            ls = ar = Fr = null;
            break;
          case "mousedown":
            rl = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            rl = !1, Nu(ve, r, me);
            break;
          case "selectionchange":
            if (al) break;
          case "keydown":
          case "keyup":
            Nu(ve, r, me);
        }
        var et;
        if (Nd)
          e: {
            switch (n) {
              case "compositionstart":
                var lt = "onCompositionStart";
                break e;
              case "compositionend":
                lt = "onCompositionEnd";
                break e;
              case "compositionupdate":
                lt = "onCompositionUpdate";
                break e;
            }
            lt = void 0;
          }
        else
          as ? Vd(n, r) && (lt = "onCompositionEnd") : n === "keydown" && r.keyCode === 229 && (lt = "onCompositionStart");
        lt && (Vr && r.locale !== "ko" && (as || lt !== "onCompositionStart" ? lt === "onCompositionEnd" && as && (et = Lh()) : (Uo = me, ic = "value" in Uo ? Uo.value : Uo.textContent, as = !0)), _t = Jc(K, lt), 0 < _t.length && (lt = new zh(
          lt,
          n,
          null,
          r,
          me
        ), ve.push({ event: lt, listeners: _t }), et ? lt.data = et : (et = is(r), et !== null && (lt.data = et)))), (et = Yh ? Kh(n, r) : tl(n, r)) && (lt = Jc(K, "onBeforeInput"), 0 < lt.length && (_t = new zh(
          "onBeforeInput",
          "beforeinput",
          null,
          r,
          me
        ), ve.push({
          event: _t,
          listeners: lt
        }), _t.data = et)), k2(
          ve,
          n,
          K,
          r,
          me
        );
      }
      kl(ve, a);
    });
  }
  function wo(n, a, r) {
    return {
      instance: n,
      listener: a,
      currentTarget: r
    };
  }
  function Jc(n, a) {
    for (var r = a + "Capture", s = []; n !== null; ) {
      var m = n, f = m.stateNode;
      if (m = m.tag, m !== 5 && m !== 26 && m !== 27 || f === null || (m = Xs(n, r), m != null && s.unshift(
        wo(n, m, f)
      ), m = Xs(n, a), m != null && s.push(
        wo(n, m, f)
      )), n.tag === 3) return s;
      n = n.return;
    }
    return [];
  }
  function _s(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5 && n.tag !== 27);
    return n || null;
  }
  function S0(n, a, r, s, m) {
    for (var f = a._reactName, E = []; r !== null && r !== s; ) {
      var _ = r, O = _.alternate, K = _.stateNode;
      if (_ = _.tag, O !== null && O === s) break;
      _ !== 5 && _ !== 26 && _ !== 27 || K === null || (O = K, m ? (K = Xs(r, f), K != null && E.unshift(
        wo(r, K, O)
      )) : m || (K = Xs(r, f), K != null && E.push(
        wo(r, K, O)
      ))), r = r.return;
    }
    E.length !== 0 && n.push({ event: a, listeners: E });
  }
  var Ea = /\r\n?/g, yp = /\u0000|\uFFFD/g;
  function Q2(n) {
    return (typeof n == "string" ? n : "" + n).replace(Ea, `
`).replace(yp, "");
  }
  function Np(n, a) {
    return a = Q2(a), Q2(n) === a;
  }
  function O1() {
  }
  function vt(n, a, r, s, m, f) {
    switch (r) {
      case "children":
        typeof s == "string" ? a === "body" || a === "textarea" && s === "" || $l(n, s) : (typeof s == "number" || typeof s == "bigint") && a !== "body" && $l(n, "" + s);
        break;
      case "className":
        fd(n, "class", s);
        break;
      case "tabIndex":
        fd(n, "tabindex", s);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        fd(n, r, s);
        break;
      case "style":
        Sd(n, s, f);
        break;
      case "data":
        if (a !== "object") {
          fd(n, "data", s);
          break;
        }
      case "src":
      case "href":
        if (s === "" && (a !== "a" || r !== "href")) {
          n.removeAttribute(r);
          break;
        }
        if (s == null || typeof s == "function" || typeof s == "symbol" || typeof s == "boolean") {
          n.removeAttribute(r);
          break;
        }
        s = Rd("" + s), n.setAttribute(r, s);
        break;
      case "action":
      case "formAction":
        if (typeof s == "function") {
          n.setAttribute(
            r,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof f == "function" && (r === "formAction" ? (a !== "input" && vt(n, a, "name", m.name, m, null), vt(
            n,
            a,
            "formEncType",
            m.formEncType,
            m,
            null
          ), vt(
            n,
            a,
            "formMethod",
            m.formMethod,
            m,
            null
          ), vt(
            n,
            a,
            "formTarget",
            m.formTarget,
            m,
            null
          )) : (vt(n, a, "encType", m.encType, m, null), vt(n, a, "method", m.method, m, null), vt(n, a, "target", m.target, m, null)));
        if (s == null || typeof s == "symbol" || typeof s == "boolean") {
          n.removeAttribute(r);
          break;
        }
        s = Rd("" + s), n.setAttribute(r, s);
        break;
      case "onClick":
        s != null && (n.onclick = O1);
        break;
      case "onScroll":
        s != null && Ut("scroll", n);
        break;
      case "onScrollEnd":
        s != null && Ut("scrollend", n);
        break;
      case "dangerouslySetInnerHTML":
        if (s != null) {
          if (typeof s != "object" || !("__html" in s))
            throw Error(p(61));
          if (r = s.__html, r != null) {
            if (m.children != null) throw Error(p(60));
            n.innerHTML = r;
          }
        }
        break;
      case "multiple":
        n.multiple = s && typeof s != "function" && typeof s != "symbol";
        break;
      case "muted":
        n.muted = s && typeof s != "function" && typeof s != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (s == null || typeof s == "function" || typeof s == "boolean" || typeof s == "symbol") {
          n.removeAttribute("xlink:href");
          break;
        }
        r = Rd("" + s), n.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          r
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        s != null && typeof s != "function" && typeof s != "symbol" ? n.setAttribute(r, "" + s) : n.removeAttribute(r);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        s && typeof s != "function" && typeof s != "symbol" ? n.setAttribute(r, "") : n.removeAttribute(r);
        break;
      case "capture":
      case "download":
        s === !0 ? n.setAttribute(r, "") : s !== !1 && s != null && typeof s != "function" && typeof s != "symbol" ? n.setAttribute(r, s) : n.removeAttribute(r);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        s != null && typeof s != "function" && typeof s != "symbol" && !isNaN(s) && 1 <= s ? n.setAttribute(r, s) : n.removeAttribute(r);
        break;
      case "rowSpan":
      case "start":
        s == null || typeof s == "function" || typeof s == "symbol" || isNaN(s) ? n.removeAttribute(r) : n.setAttribute(r, s);
        break;
      case "popover":
        Ut("beforetoggle", n), Ut("toggle", n), Ro(n, "popover", s);
        break;
      case "xlinkActuate":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          s
        );
        break;
      case "xlinkArcrole":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          s
        );
        break;
      case "xlinkRole":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          s
        );
        break;
      case "xlinkShow":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          s
        );
        break;
      case "xlinkTitle":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          s
        );
        break;
      case "xlinkType":
        Nr(
          n,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          s
        );
        break;
      case "xmlBase":
        Nr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          s
        );
        break;
      case "xmlLang":
        Nr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          s
        );
        break;
      case "xmlSpace":
        Nr(
          n,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          s
        );
        break;
      case "is":
        Ro(n, "is", s);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < r.length) || r[0] !== "o" && r[0] !== "O" || r[1] !== "n" && r[1] !== "N") && (r = tv.get(r) || r, Ro(n, r, s));
    }
  }
  function oe(n, a, r, s, m, f) {
    switch (r) {
      case "style":
        Sd(n, s, f);
        break;
      case "dangerouslySetInnerHTML":
        if (s != null) {
          if (typeof s != "object" || !("__html" in s))
            throw Error(p(61));
          if (r = s.__html, r != null) {
            if (m.children != null) throw Error(p(60));
            n.innerHTML = r;
          }
        }
        break;
      case "children":
        typeof s == "string" ? $l(n, s) : (typeof s == "number" || typeof s == "bigint") && $l(n, "" + s);
        break;
      case "onScroll":
        s != null && Ut("scroll", n);
        break;
      case "onScrollEnd":
        s != null && Ut("scrollend", n);
        break;
      case "onClick":
        s != null && (n.onclick = O1);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!dt.hasOwnProperty(r))
          e: {
            if (r[0] === "o" && r[1] === "n" && (m = r.endsWith("Capture"), a = r.slice(2, m ? r.length - 7 : void 0), f = n[Yn] || null, f = f != null ? f[r] : null, typeof f == "function" && n.removeEventListener(a, f, m), typeof s == "function")) {
              typeof f != "function" && f !== null && (r in n ? n[r] = null : n.hasAttribute(r) && n.removeAttribute(r)), n.addEventListener(a, s, m);
              break e;
            }
            r in n ? n[r] = s : s === !0 ? n.setAttribute(r, "") : Ro(n, r, s);
          }
    }
  }
  function ut(n, a, r) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        Ut("error", n), Ut("load", n);
        var s = !1, m = !1, f;
        for (f in r)
          if (r.hasOwnProperty(f)) {
            var E = r[f];
            if (E != null)
              switch (f) {
                case "src":
                  s = !0;
                  break;
                case "srcSet":
                  m = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(p(137, a));
                default:
                  vt(n, a, f, E, r, null);
              }
          }
        m && vt(n, a, "srcSet", r.srcSet, r, null), s && vt(n, a, "src", r.src, r, null);
        return;
      case "input":
        Ut("invalid", n);
        var _ = f = E = m = null, O = null, K = null;
        for (s in r)
          if (r.hasOwnProperty(s)) {
            var me = r[s];
            if (me != null)
              switch (s) {
                case "name":
                  m = me;
                  break;
                case "type":
                  E = me;
                  break;
                case "checked":
                  O = me;
                  break;
                case "defaultChecked":
                  K = me;
                  break;
                case "value":
                  f = me;
                  break;
                case "defaultValue":
                  _ = me;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (me != null)
                    throw Error(p(137, a));
                  break;
                default:
                  vt(n, a, s, me, r, null);
              }
          }
        du(
          n,
          f,
          _,
          O,
          K,
          E,
          m,
          !1
        ), ts(n);
        return;
      case "select":
        Ut("invalid", n), s = E = f = null;
        for (m in r)
          if (r.hasOwnProperty(m) && (_ = r[m], _ != null))
            switch (m) {
              case "value":
                f = _;
                break;
              case "defaultValue":
                E = _;
                break;
              case "multiple":
                s = _;
              default:
                vt(n, a, m, _, r, null);
            }
        a = f, r = E, n.multiple = !!s, a != null ? Gs(n, !!s, a, !1) : r != null && Gs(n, !!s, r, !0);
        return;
      case "textarea":
        Ut("invalid", n), f = m = s = null;
        for (E in r)
          if (r.hasOwnProperty(E) && (_ = r[E], _ != null))
            switch (E) {
              case "value":
                s = _;
                break;
              case "defaultValue":
                m = _;
                break;
              case "children":
                f = _;
                break;
              case "dangerouslySetInnerHTML":
                if (_ != null) throw Error(p(91));
                break;
              default:
                vt(n, a, E, _, r, null);
            }
        Ah(n, s, m, f), ts(n);
        return;
      case "option":
        for (O in r)
          if (r.hasOwnProperty(O) && (s = r[O], s != null))
            switch (O) {
              case "selected":
                n.selected = s && typeof s != "function" && typeof s != "symbol";
                break;
              default:
                vt(n, a, O, s, r, null);
            }
        return;
      case "dialog":
        Ut("beforetoggle", n), Ut("toggle", n), Ut("cancel", n), Ut("close", n);
        break;
      case "iframe":
      case "object":
        Ut("load", n);
        break;
      case "video":
      case "audio":
        for (s = 0; s < v0.length; s++)
          Ut(v0[s], n);
        break;
      case "image":
        Ut("error", n), Ut("load", n);
        break;
      case "details":
        Ut("toggle", n);
        break;
      case "embed":
      case "source":
      case "link":
        Ut("error", n), Ut("load", n);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (K in r)
          if (r.hasOwnProperty(K) && (s = r[K], s != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(p(137, a));
              default:
                vt(n, a, K, s, r, null);
            }
        return;
      default:
        if (Ps(a)) {
          for (me in r)
            r.hasOwnProperty(me) && (s = r[me], s !== void 0 && oe(
              n,
              a,
              me,
              s,
              r,
              void 0
            ));
          return;
        }
    }
    for (_ in r)
      r.hasOwnProperty(_) && (s = r[_], s != null && vt(n, a, _, s, r, null));
  }
  function mv(n, a, r, s) {
    switch (a) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var m = null, f = null, E = null, _ = null, O = null, K = null, me = null;
        for (te in r) {
          var ve = r[te];
          if (r.hasOwnProperty(te) && ve != null)
            switch (te) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                O = ve;
              default:
                s.hasOwnProperty(te) || vt(n, a, te, null, s, ve);
            }
        }
        for (var $ in s) {
          var te = s[$];
          if (ve = r[$], s.hasOwnProperty($) && (te != null || ve != null))
            switch ($) {
              case "type":
                f = te;
                break;
              case "name":
                m = te;
                break;
              case "checked":
                K = te;
                break;
              case "defaultChecked":
                me = te;
                break;
              case "value":
                E = te;
                break;
              case "defaultValue":
                _ = te;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (te != null)
                  throw Error(p(137, a));
                break;
              default:
                te !== ve && vt(
                  n,
                  a,
                  $,
                  te,
                  s,
                  ve
                );
            }
        }
        cu(
          n,
          E,
          _,
          O,
          K,
          me,
          f,
          m
        );
        return;
      case "select":
        te = E = _ = $ = null;
        for (f in r)
          if (O = r[f], r.hasOwnProperty(f) && O != null)
            switch (f) {
              case "value":
                break;
              case "multiple":
                te = O;
              default:
                s.hasOwnProperty(f) || vt(
                  n,
                  a,
                  f,
                  null,
                  s,
                  O
                );
            }
        for (m in s)
          if (f = s[m], O = r[m], s.hasOwnProperty(m) && (f != null || O != null))
            switch (m) {
              case "value":
                $ = f;
                break;
              case "defaultValue":
                _ = f;
                break;
              case "multiple":
                E = f;
              default:
                f !== O && vt(
                  n,
                  a,
                  m,
                  f,
                  s,
                  O
                );
            }
        a = _, r = E, s = te, $ != null ? Gs(n, !!r, $, !1) : !!s != !!r && (a != null ? Gs(n, !!r, a, !0) : Gs(n, !!r, r ? [] : "", !1));
        return;
      case "textarea":
        te = $ = null;
        for (_ in r)
          if (m = r[_], r.hasOwnProperty(_) && m != null && !s.hasOwnProperty(_))
            switch (_) {
              case "value":
                break;
              case "children":
                break;
              default:
                vt(n, a, _, null, s, m);
            }
        for (E in s)
          if (m = s[E], f = r[E], s.hasOwnProperty(E) && (m != null || f != null))
            switch (E) {
              case "value":
                $ = m;
                break;
              case "defaultValue":
                te = m;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (m != null) throw Error(p(91));
                break;
              default:
                m !== f && vt(n, a, E, m, s, f);
            }
        wh(n, $, te);
        return;
      case "option":
        for (var it in r)
          if ($ = r[it], r.hasOwnProperty(it) && $ != null && !s.hasOwnProperty(it))
            switch (it) {
              case "selected":
                n.selected = !1;
                break;
              default:
                vt(
                  n,
                  a,
                  it,
                  null,
                  s,
                  $
                );
            }
        for (O in s)
          if ($ = s[O], te = r[O], s.hasOwnProperty(O) && $ !== te && ($ != null || te != null))
            switch (O) {
              case "selected":
                n.selected = $ && typeof $ != "function" && typeof $ != "symbol";
                break;
              default:
                vt(
                  n,
                  a,
                  O,
                  $,
                  s,
                  te
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var at in r)
          $ = r[at], r.hasOwnProperty(at) && $ != null && !s.hasOwnProperty(at) && vt(n, a, at, null, s, $);
        for (K in s)
          if ($ = s[K], te = r[K], s.hasOwnProperty(K) && $ !== te && ($ != null || te != null))
            switch (K) {
              case "children":
              case "dangerouslySetInnerHTML":
                if ($ != null)
                  throw Error(p(137, a));
                break;
              default:
                vt(
                  n,
                  a,
                  K,
                  $,
                  s,
                  te
                );
            }
        return;
      default:
        if (Ps(a)) {
          for (var Gt in r)
            $ = r[Gt], r.hasOwnProperty(Gt) && $ !== void 0 && !s.hasOwnProperty(Gt) && oe(
              n,
              a,
              Gt,
              void 0,
              s,
              $
            );
          for (me in s)
            $ = s[me], te = r[me], !s.hasOwnProperty(me) || $ === te || $ === void 0 && te === void 0 || oe(
              n,
              a,
              me,
              $,
              s,
              te
            );
          return;
        }
    }
    for (var G in r)
      $ = r[G], r.hasOwnProperty(G) && $ != null && !s.hasOwnProperty(G) && vt(n, a, G, null, s, $);
    for (ve in s)
      $ = s[ve], te = r[ve], !s.hasOwnProperty(ve) || $ === te || $ == null && te == null || vt(n, a, ve, $, s, te);
  }
  var R0 = null, E0 = null;
  function Ya(n) {
    return n.nodeType === 9 ? n : n.ownerDocument;
  }
  function Ao(n) {
    switch (n) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Lc(n, a) {
    if (n === 0)
      switch (a) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return n === 1 && a === "foreignObject" ? 0 : n;
  }
  function qr(n, a) {
    return n === "textarea" || n === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.children == "bigint" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
  }
  var Ic = null;
  function Jo() {
    var n = window.event;
    return n && n.type === "popstate" ? n === Ic ? !1 : (Ic = n, !0) : (Ic = null, !1);
  }
  var B1 = typeof setTimeout == "function" ? setTimeout : void 0, pv = typeof clearTimeout == "function" ? clearTimeout : void 0, D2 = typeof Promise == "function" ? Promise : void 0, fv = typeof queueMicrotask == "function" ? queueMicrotask : typeof D2 < "u" ? function(n) {
    return D2.resolve(null).then(n).catch($r);
  } : B1;
  function $r(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function Ms(n) {
    return n === "head";
  }
  function w1(n, a) {
    var r = a, s = 0, m = 0;
    do {
      var f = r.nextSibling;
      if (n.removeChild(r), f && f.nodeType === 8)
        if (r = f.data, r === "/$") {
          if (0 < s && 8 > s) {
            r = s;
            var E = n.ownerDocument;
            if (r & 1 && ra(E.documentElement), r & 2 && ra(E.body), r & 4)
              for (r = E.head, ra(r), E = r.firstChild; E; ) {
                var _ = E.nextSibling, O = E.nodeName;
                E[He] || O === "SCRIPT" || O === "STYLE" || O === "LINK" && E.rel.toLowerCase() === "stylesheet" || r.removeChild(E), E = _;
              }
          }
          if (m === 0) {
            n.removeChild(f), to(a);
            return;
          }
          m--;
        } else
          r === "$" || r === "$?" || r === "$!" ? m++ : s = r.charCodeAt(0) - 48;
      else s = 0;
      r = f;
    } while (r);
    to(a);
  }
  function U0(n) {
    var a = n.firstChild;
    for (a && a.nodeType === 10 && (a = a.nextSibling); a; ) {
      var r = a;
      switch (a = a.nextSibling, r.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          U0(r), D(r);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (r.rel.toLowerCase() === "stylesheet") continue;
      }
      n.removeChild(r);
    }
  }
  function Wc(n, a, r, s) {
    for (; n.nodeType === 1; ) {
      var m = r;
      if (n.nodeName.toLowerCase() !== a.toLowerCase()) {
        if (!s && (n.nodeName !== "INPUT" || n.type !== "hidden"))
          break;
      } else if (s) {
        if (!n[He])
          switch (a) {
            case "meta":
              if (!n.hasAttribute("itemprop")) break;
              return n;
            case "link":
              if (f = n.getAttribute("rel"), f === "stylesheet" && n.hasAttribute("data-precedence"))
                break;
              if (f !== m.rel || n.getAttribute("href") !== (m.href == null || m.href === "" ? null : m.href) || n.getAttribute("crossorigin") !== (m.crossOrigin == null ? null : m.crossOrigin) || n.getAttribute("title") !== (m.title == null ? null : m.title))
                break;
              return n;
            case "style":
              if (n.hasAttribute("data-precedence")) break;
              return n;
            case "script":
              if (f = n.getAttribute("src"), (f !== (m.src == null ? null : m.src) || n.getAttribute("type") !== (m.type == null ? null : m.type) || n.getAttribute("crossorigin") !== (m.crossOrigin == null ? null : m.crossOrigin)) && f && n.hasAttribute("async") && !n.hasAttribute("itemprop"))
                break;
              return n;
            default:
              return n;
          }
      } else if (a === "input" && n.type === "hidden") {
        var f = m.name == null ? null : "" + m.name;
        if (m.type === "hidden" && n.getAttribute("name") === f)
          return n;
      } else return n;
      if (n = pr(n.nextSibling), n === null) break;
    }
    return null;
  }
  function gv(n, a, r) {
    if (a === "") return null;
    for (; n.nodeType !== 3; )
      if ((n.nodeType !== 1 || n.nodeName !== "INPUT" || n.type !== "hidden") && !r || (n = pr(n.nextSibling), n === null)) return null;
    return n;
  }
  function T0(n) {
    return n.data === "$!" || n.data === "$?" && n.ownerDocument.readyState === "complete";
  }
  function vv(n, a) {
    var r = n.ownerDocument;
    if (n.data !== "$?" || r.readyState === "complete")
      a();
    else {
      var s = function() {
        a(), r.removeEventListener("DOMContentLoaded", s);
      };
      r.addEventListener("DOMContentLoaded", s), n._reactRetry = s;
    }
  }
  function pr(n) {
    for (; n != null; n = n.nextSibling) {
      var a = n.nodeType;
      if (a === 1 || a === 3) break;
      if (a === 8) {
        if (a = n.data, a === "$" || a === "$!" || a === "$?" || a === "F!" || a === "F")
          break;
        if (a === "/$") return null;
      }
    }
    return n;
  }
  var ks = null;
  function Ri(n) {
    n = n.previousSibling;
    for (var a = 0; n; ) {
      if (n.nodeType === 8) {
        var r = n.data;
        if (r === "$" || r === "$!" || r === "$?") {
          if (a === 0) return n;
          a--;
        } else r === "/$" && a++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  function Le(n, a, r) {
    switch (a = Ya(r), n) {
      case "html":
        if (n = a.documentElement, !n) throw Error(p(452));
        return n;
      case "head":
        if (n = a.head, !n) throw Error(p(453));
        return n;
      case "body":
        if (n = a.body, !n) throw Error(p(454));
        return n;
      default:
        throw Error(p(451));
    }
  }
  function ra(n) {
    for (var a = n.attributes; a.length; )
      n.removeAttributeNode(a[0]);
    D(n);
  }
  var Bn = /* @__PURE__ */ new Map(), Mi = /* @__PURE__ */ new Set();
  function A1(n) {
    return typeof n.getRootNode == "function" ? n.getRootNode() : n.nodeType === 9 ? n : n.ownerDocument;
  }
  var Lo = X.d;
  X.d = {
    f: J1,
    r: L1,
    D: Io,
    C: I1,
    L: Qs,
    m: ki,
    X: Ds,
    S: oa,
    M: bp
  };
  function J1() {
    var n = Lo.f(), a = Cl();
    return n || a;
  }
  function L1(n) {
    var a = pe(n);
    a !== null && a.tag === 5 && a.type === "form" ? Uc(a) : Lo.r(n);
  }
  var Ei = typeof document > "u" ? null : document;
  function fr(n, a, r) {
    var s = Ei;
    if (s && typeof a == "string" && a) {
      var m = Za(a);
      m = 'link[rel="' + n + '"][href="' + m + '"]', typeof r == "string" && (m += '[crossorigin="' + r + '"]'), Mi.has(m) || (Mi.add(m), n = { rel: n, crossOrigin: r, href: a }, s.querySelector(m) === null && (a = s.createElement("link"), ut(a, "link", n), Ke(a), s.head.appendChild(a)));
    }
  }
  function Io(n) {
    Lo.D(n), fr("dns-prefetch", n, null);
  }
  function I1(n, a) {
    Lo.C(n, a), fr("preconnect", n, a);
  }
  function Qs(n, a, r) {
    Lo.L(n, a, r);
    var s = Ei;
    if (s && n && a) {
      var m = 'link[rel="preload"][as="' + Za(a) + '"]';
      a === "image" && r && r.imageSrcSet ? (m += '[imagesrcset="' + Za(
        r.imageSrcSet
      ) + '"]', typeof r.imageSizes == "string" && (m += '[imagesizes="' + Za(
        r.imageSizes
      ) + '"]')) : m += '[href="' + Za(n) + '"]';
      var f = m;
      switch (a) {
        case "style":
          f = Hc(n);
          break;
        case "script":
          f = Xa(n);
      }
      Bn.has(f) || (n = V(
        {
          rel: "preload",
          href: a === "image" && r && r.imageSrcSet ? void 0 : n,
          as: a
        },
        r
      ), Bn.set(f, n), s.querySelector(m) !== null || a === "style" && s.querySelector(zc(f)) || a === "script" && s.querySelector(Ql(f)) || (a = s.createElement("link"), ut(a, "link", n), Ke(a), s.head.appendChild(a)));
    }
  }
  function ki(n, a) {
    Lo.m(n, a);
    var r = Ei;
    if (r && n) {
      var s = a && typeof a.as == "string" ? a.as : "script", m = 'link[rel="modulepreload"][as="' + Za(s) + '"][href="' + Za(n) + '"]', f = m;
      switch (s) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          f = Xa(n);
      }
      if (!Bn.has(f) && (n = V({ rel: "modulepreload", href: n }, a), Bn.set(f, n), r.querySelector(m) === null)) {
        switch (s) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (r.querySelector(Ql(f)))
              return;
        }
        s = r.createElement("link"), ut(s, "link", n), Ke(s), r.head.appendChild(s);
      }
    }
  }
  function oa(n, a, r) {
    Lo.S(n, a, r);
    var s = Ei;
    if (s && n) {
      var m = ot(s).hoistableStyles, f = Hc(n);
      a = a || "default";
      var E = m.get(f);
      if (!E) {
        var _ = { loading: 0, preload: null };
        if (E = s.querySelector(
          zc(f)
        ))
          _.loading = 5;
        else {
          n = V(
            { rel: "stylesheet", href: n, "data-precedence": a },
            r
          ), (r = Bn.get(f)) && H1(n, r);
          var O = E = s.createElement("link");
          Ke(O), ut(O, "link", n), O._p = new Promise(function(K, me) {
            O.onload = K, O.onerror = me;
          }), O.addEventListener("load", function() {
            _.loading |= 1;
          }), O.addEventListener("error", function() {
            _.loading |= 2;
          }), _.loading |= 4, W1(E, a, s);
        }
        E = {
          type: "stylesheet",
          instance: E,
          count: 1,
          state: _
        }, m.set(f, E);
      }
    }
  }
  function Ds(n, a) {
    Lo.X(n, a);
    var r = Ei;
    if (r && n) {
      var s = ot(r).hoistableScripts, m = Xa(n), f = s.get(m);
      f || (f = r.querySelector(Ql(m)), f || (n = V({ src: n, async: !0 }, a), (a = Bn.get(m)) && z1(n, a), f = r.createElement("script"), Ke(f), ut(f, "link", n), r.head.appendChild(f)), f = {
        type: "script",
        instance: f,
        count: 1,
        state: null
      }, s.set(m, f));
    }
  }
  function bp(n, a) {
    Lo.M(n, a);
    var r = Ei;
    if (r && n) {
      var s = ot(r).hoistableScripts, m = Xa(n), f = s.get(m);
      f || (f = r.querySelector(Ql(m)), f || (n = V({ src: n, async: !0, type: "module" }, a), (a = Bn.get(m)) && z1(n, a), f = r.createElement("script"), Ke(f), ut(f, "link", n), r.head.appendChild(f)), f = {
        type: "script",
        instance: f,
        count: 1,
        state: null
      }, s.set(m, f));
    }
  }
  function x2(n, a, r, s) {
    var m = (m = Ze.current) ? A1(m) : null;
    if (!m) throw Error(p(446));
    switch (n) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof r.precedence == "string" && typeof r.href == "string" ? (a = Hc(r.href), r = ot(
          m
        ).hoistableStyles, s = r.get(a), s || (s = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, r.set(a, s)), s) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (r.rel === "stylesheet" && typeof r.href == "string" && typeof r.precedence == "string") {
          n = Hc(r.href);
          var f = ot(
            m
          ).hoistableStyles, E = f.get(n);
          if (E || (m = m.ownerDocument || m, E = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, f.set(n, E), (f = m.querySelector(
            zc(n)
          )) && !f._p && (E.instance = f, E.state.loading = 5), Bn.has(n) || (r = {
            rel: "preload",
            as: "style",
            href: r.href,
            crossOrigin: r.crossOrigin,
            integrity: r.integrity,
            media: r.media,
            hrefLang: r.hrefLang,
            referrerPolicy: r.referrerPolicy
          }, Bn.set(n, r), f || Z2(
            m,
            n,
            r,
            E.state
          ))), a && s === null)
            throw Error(p(528, ""));
          return E;
        }
        if (a && s !== null)
          throw Error(p(529, ""));
        return null;
      case "script":
        return a = r.async, r = r.src, typeof r == "string" && a && typeof a != "function" && typeof a != "symbol" ? (a = Xa(r), r = ot(
          m
        ).hoistableScripts, s = r.get(a), s || (s = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, r.set(a, s)), s) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(p(444, n));
    }
  }
  function Hc(n) {
    return 'href="' + Za(n) + '"';
  }
  function zc(n) {
    return 'link[rel="stylesheet"][' + n + "]";
  }
  function jc(n) {
    return V({}, n, {
      "data-precedence": n.precedence,
      precedence: null
    });
  }
  function Z2(n, a, r, s) {
    n.querySelector('link[rel="preload"][as="style"][' + a + "]") ? s.loading = 1 : (a = n.createElement("link"), s.preload = a, a.addEventListener("load", function() {
      return s.loading |= 1;
    }), a.addEventListener("error", function() {
      return s.loading |= 2;
    }), ut(a, "link", r), Ke(a), n.head.appendChild(a));
  }
  function Xa(n) {
    return '[src="' + Za(n) + '"]';
  }
  function Ql(n) {
    return "script[async]" + n;
  }
  function O2(n, a, r) {
    if (a.count++, a.instance === null)
      switch (a.type) {
        case "style":
          var s = n.querySelector(
            'style[data-href~="' + Za(r.href) + '"]'
          );
          if (s)
            return a.instance = s, Ke(s), s;
          var m = V({}, r, {
            "data-href": r.href,
            "data-precedence": r.precedence,
            href: null,
            precedence: null
          });
          return s = (n.ownerDocument || n).createElement(
            "style"
          ), Ke(s), ut(s, "style", m), W1(s, r.precedence, n), a.instance = s;
        case "stylesheet":
          m = Hc(r.href);
          var f = n.querySelector(
            zc(m)
          );
          if (f)
            return a.state.loading |= 4, a.instance = f, Ke(f), f;
          s = jc(r), (m = Bn.get(m)) && H1(s, m), f = (n.ownerDocument || n).createElement("link"), Ke(f);
          var E = f;
          return E._p = new Promise(function(_, O) {
            E.onload = _, E.onerror = O;
          }), ut(f, "link", s), a.state.loading |= 4, W1(f, r.precedence, n), a.instance = f;
        case "script":
          return f = Xa(r.src), (m = n.querySelector(
            Ql(f)
          )) ? (a.instance = m, Ke(m), m) : (s = r, (m = Bn.get(f)) && (s = V({}, r), z1(s, m)), n = n.ownerDocument || n, m = n.createElement("script"), Ke(m), ut(m, "link", s), n.head.appendChild(m), a.instance = m);
        case "void":
          return null;
        default:
          throw Error(p(443, a.type));
      }
    else
      a.type === "stylesheet" && (a.state.loading & 4) === 0 && (s = a.instance, a.state.loading |= 4, W1(s, r.precedence, n));
    return a.instance;
  }
  function W1(n, a, r) {
    for (var s = r.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), m = s.length ? s[s.length - 1] : null, f = m, E = 0; E < s.length; E++) {
      var _ = s[E];
      if (_.dataset.precedence === a) f = _;
      else if (f !== m) break;
    }
    f ? f.parentNode.insertBefore(n, f.nextSibling) : (a = r.nodeType === 9 ? r.head : r, a.insertBefore(n, a.firstChild));
  }
  function H1(n, a) {
    n.crossOrigin == null && (n.crossOrigin = a.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = a.referrerPolicy), n.title == null && (n.title = a.title);
  }
  function z1(n, a) {
    n.crossOrigin == null && (n.crossOrigin = a.crossOrigin), n.referrerPolicy == null && (n.referrerPolicy = a.referrerPolicy), n.integrity == null && (n.integrity = a.integrity);
  }
  var xs = null;
  function Vp(n, a, r) {
    if (xs === null) {
      var s = /* @__PURE__ */ new Map(), m = xs = /* @__PURE__ */ new Map();
      m.set(r, s);
    } else
      m = xs, s = m.get(r), s || (s = /* @__PURE__ */ new Map(), m.set(r, s));
    if (s.has(n)) return s;
    for (s.set(n, null), r = r.getElementsByTagName(n), m = 0; m < r.length; m++) {
      var f = r[m];
      if (!(f[He] || f[_n] || n === "link" && f.getAttribute("rel") === "stylesheet") && f.namespaceURI !== "http://www.w3.org/2000/svg") {
        var E = f.getAttribute(a) || "";
        E = n + E;
        var _ = s.get(E);
        _ ? _.push(f) : s.set(E, [f]);
      }
    }
    return s;
  }
  function Cp(n, a, r) {
    n = n.ownerDocument || n, n.head.insertBefore(
      r,
      a === "title" ? n.querySelector("head > title") : null
    );
  }
  function B2(n, a, r) {
    if (r === 1 || a.itemProp != null) return !1;
    switch (n) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof a.precedence != "string" || typeof a.href != "string" || a.href === "")
          break;
        return !0;
      case "link":
        if (typeof a.rel != "string" || typeof a.href != "string" || a.href === "" || a.onLoad || a.onError)
          break;
        switch (a.rel) {
          case "stylesheet":
            return n = a.disabled, typeof a.precedence == "string" && n == null;
          default:
            return !0;
        }
      case "script":
        if (a.async && typeof a.async != "function" && typeof a.async != "symbol" && !a.onLoad && !a.onError && a.src && typeof a.src == "string")
          return !0;
    }
    return !1;
  }
  function Fp(n) {
    return !(n.type === "stylesheet" && (n.state.loading & 3) === 0);
  }
  var Gc = null;
  function w2() {
  }
  function A2(n, a, r) {
    if (Gc === null) throw Error(p(475));
    var s = Gc;
    if (a.type === "stylesheet" && (typeof r.media != "string" || matchMedia(r.media).matches !== !1) && (a.state.loading & 4) === 0) {
      if (a.instance === null) {
        var m = Hc(r.href), f = n.querySelector(
          zc(m)
        );
        if (f) {
          n = f._p, n !== null && typeof n == "object" && typeof n.then == "function" && (s.count++, s = y0.bind(s), n.then(s, s)), a.state.loading |= 4, a.instance = f, Ke(f);
          return;
        }
        f = n.ownerDocument || n, r = jc(r), (m = Bn.get(m)) && H1(r, m), f = f.createElement("link"), Ke(f);
        var E = f;
        E._p = new Promise(function(_, O) {
          E.onload = _, E.onerror = O;
        }), ut(f, "link", r), a.instance = f;
      }
      s.stylesheets === null && (s.stylesheets = /* @__PURE__ */ new Map()), s.stylesheets.set(a, n), (n = a.state.preload) && (a.state.loading & 3) === 0 && (s.count++, a = y0.bind(s), n.addEventListener("load", a), n.addEventListener("error", a));
    }
  }
  function _p() {
    if (Gc === null) throw Error(p(475));
    var n = Gc;
    return n.stylesheets && n.count === 0 && N0(n, n.stylesheets), 0 < n.count ? function(a) {
      var r = setTimeout(function() {
        if (n.stylesheets && N0(n, n.stylesheets), n.unsuspend) {
          var s = n.unsuspend;
          n.unsuspend = null, s();
        }
      }, 6e4);
      return n.unsuspend = a, function() {
        n.unsuspend = null, clearTimeout(r);
      };
    } : null;
  }
  function y0() {
    if (this.count--, this.count === 0) {
      if (this.stylesheets) N0(this, this.stylesheets);
      else if (this.unsuspend) {
        var n = this.unsuspend;
        this.unsuspend = null, n();
      }
    }
  }
  var Pc = null;
  function N0(n, a) {
    n.stylesheets = null, n.unsuspend !== null && (n.count++, Pc = /* @__PURE__ */ new Map(), a.forEach(Ua, n), Pc = null, y0.call(n));
  }
  function Ua(n, a) {
    if (!(a.state.loading & 4)) {
      var r = Pc.get(n);
      if (r) var s = r.get(null);
      else {
        r = /* @__PURE__ */ new Map(), Pc.set(n, r);
        for (var m = n.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), f = 0; f < m.length; f++) {
          var E = m[f];
          (E.nodeName === "LINK" || E.getAttribute("media") !== "not all") && (r.set(E.dataset.precedence, E), s = E);
        }
        s && r.set(null, s);
      }
      m = a.instance, E = m.getAttribute("data-precedence"), f = r.get(E) || s, f === s && r.set(null, m), r.set(E, m), this.count++, s = y0.bind(this), m.addEventListener("load", s), m.addEventListener("error", s), f ? f.parentNode.insertBefore(m, f.nextSibling) : (n = n.nodeType === 9 ? n.head : n, n.insertBefore(m, n.firstChild)), a.state.loading |= 4;
    }
  }
  var sa = {
    $$typeof: Ve,
    Provider: null,
    Consumer: null,
    _currentValue: ae,
    _currentValue2: ae,
    _threadCount: 0
  };
  function Sv(n, a, r, s, m, f, E, _) {
    this.tag = 1, this.containerInfo = n, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Je(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Je(0), this.hiddenUpdates = Je(null), this.identifierPrefix = s, this.onUncaughtError = m, this.onCaughtError = f, this.onRecoverableError = E, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = _, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function Mp(n, a, r, s, m, f, E, _, O, K, me, ve) {
    return n = new Sv(
      n,
      a,
      r,
      E,
      _,
      O,
      K,
      ve
    ), a = 1, f === !0 && (a |= 24), f = Xi(3, null, null, a), n.current = f, f.stateNode = n, a = gc(), a.refCount++, n.pooledCache = a, a.refCount++, f.memoizedState = {
      element: s,
      isDehydrated: r,
      cache: a
    }, Ou(f), n;
  }
  function kp(n) {
    return n ? (n = lc, n) : lc;
  }
  function Qp(n, a, r, s, m, f) {
    m = kp(m), s.context === null ? s.context = m : s.pendingContext = m, s = qi(a), s.payload = { element: r }, f = f === void 0 ? null : f, f !== null && (s.callback = f), r = Br(n, s, a), r !== null && (Ra(r, n, a), ul(r, n, a));
  }
  function Dp(n, a) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var r = n.retryLane;
      n.retryLane = r !== 0 && r < a ? r : a;
    }
  }
  function j1(n, a) {
    Dp(n, a), (n = n.alternate) && Dp(n, a);
  }
  function xp(n) {
    if (n.tag === 13) {
      var a = kr(n, 67108864);
      a !== null && Ra(a, n, 67108864), j1(n, 67108864);
    }
  }
  var b0 = !0;
  function J2(n, a, r, s) {
    var m = Z.T;
    Z.T = null;
    var f = X.p;
    try {
      X.p = 2, Zp(n, a, r, s);
    } finally {
      X.p = f, Z.T = m;
    }
  }
  function L2(n, a, r, s) {
    var m = Z.T;
    Z.T = null;
    var f = X.p;
    try {
      X.p = 8, Zp(n, a, r, s);
    } finally {
      X.p = f, Z.T = m;
    }
  }
  function Zp(n, a, r, s) {
    if (b0) {
      var m = G1(s);
      if (m === null)
        Pa(
          n,
          a,
          s,
          P1,
          r
        ), Dl(n, s);
      else if (W2(
        m,
        n,
        a,
        r,
        s
      ))
        s.stopPropagation();
      else if (Dl(n, s), a & 4 && -1 < I2.indexOf(n)) {
        for (; m !== null; ) {
          var f = pe(m);
          if (f !== null)
            switch (f.tag) {
              case 3:
                if (f = f.stateNode, f.current.memoizedState.isDehydrated) {
                  var E = In(f.pendingLanes);
                  if (E !== 0) {
                    var _ = f;
                    for (_.pendingLanes |= 2, _.entangledLanes |= 2; E; ) {
                      var O = 1 << 31 - Ln(E);
                      _.entanglements[1] |= O, E &= ~O;
                    }
                    aa(f), (Xt & 6) === 0 && (N1 = vn() + 500, h0(0));
                  }
                }
                break;
              case 13:
                _ = kr(f, 2), _ !== null && Ra(_, f, 2), Cl(), j1(f, 2);
            }
          if (f = G1(s), f === null && Pa(
            n,
            a,
            s,
            P1,
            r
          ), f === m) break;
          m = f;
        }
        m !== null && s.stopPropagation();
      } else
        Pa(
          n,
          a,
          s,
          null,
          r
        );
    }
  }
  function G1(n) {
    return n = hu(n), Op(n);
  }
  var P1 = null;
  function Op(n) {
    if (P1 = null, n = B(n), n !== null) {
      var a = R(n);
      if (a === null) n = null;
      else {
        var r = a.tag;
        if (r === 13) {
          if (n = y(a), n !== null) return n;
          n = null;
        } else if (r === 3) {
          if (a.stateNode.current.memoizedState.isDehydrated)
            return a.tag === 3 ? a.stateNode.containerInfo : null;
          n = null;
        } else a !== n && (n = null);
      }
    }
    return P1 = n, null;
  }
  function Bp(n) {
    switch (n) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (ka()) {
          case Rr:
            return 2;
          case gt:
            return 8;
          case bi:
          case Lt:
            return 32;
          case xi:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var Yc = !1, eo = null, Wo = null, Ho = null, V0 = /* @__PURE__ */ new Map(), C0 = /* @__PURE__ */ new Map(), Zs = [], I2 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function Dl(n, a) {
    switch (n) {
      case "focusin":
      case "focusout":
        eo = null;
        break;
      case "dragenter":
      case "dragleave":
        Wo = null;
        break;
      case "mouseover":
      case "mouseout":
        Ho = null;
        break;
      case "pointerover":
      case "pointerout":
        V0.delete(a.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        C0.delete(a.pointerId);
    }
  }
  function xl(n, a, r, s, m, f) {
    return n === null || n.nativeEvent !== f ? (n = {
      blockedOn: a,
      domEventName: r,
      eventSystemFlags: s,
      nativeEvent: f,
      targetContainers: [m]
    }, a !== null && (a = pe(a), a !== null && xp(a)), n) : (n.eventSystemFlags |= s, a = n.targetContainers, m !== null && a.indexOf(m) === -1 && a.push(m), n);
  }
  function W2(n, a, r, s, m) {
    switch (a) {
      case "focusin":
        return eo = xl(
          eo,
          n,
          a,
          r,
          s,
          m
        ), !0;
      case "dragenter":
        return Wo = xl(
          Wo,
          n,
          a,
          r,
          s,
          m
        ), !0;
      case "mouseover":
        return Ho = xl(
          Ho,
          n,
          a,
          r,
          s,
          m
        ), !0;
      case "pointerover":
        var f = m.pointerId;
        return V0.set(
          f,
          xl(
            V0.get(f) || null,
            n,
            a,
            r,
            s,
            m
          )
        ), !0;
      case "gotpointercapture":
        return f = m.pointerId, C0.set(
          f,
          xl(
            C0.get(f) || null,
            n,
            a,
            r,
            s,
            m
          )
        ), !0;
    }
    return !1;
  }
  function wp(n) {
    var a = B(n.target);
    if (a !== null) {
      var r = R(a);
      if (r !== null) {
        if (a = r.tag, a === 13) {
          if (a = y(r), a !== null) {
            n.blockedOn = a, Ws(n.priority, function() {
              if (r.tag === 13) {
                var s = Sa();
                s = Sn(s);
                var m = kr(r, s);
                m !== null && Ra(m, r, s), j1(r, s);
              }
            });
            return;
          }
        } else if (a === 3 && r.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = r.tag === 3 ? r.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function F0(n) {
    if (n.blockedOn !== null) return !1;
    for (var a = n.targetContainers; 0 < a.length; ) {
      var r = G1(n.nativeEvent);
      if (r === null) {
        r = n.nativeEvent;
        var s = new r.constructor(
          r.type,
          r
        );
        Ys = s, r.target.dispatchEvent(s), Ys = null;
      } else
        return a = pe(r), a !== null && xp(a), n.blockedOn = r, !1;
      a.shift();
    }
    return !0;
  }
  function _0(n, a, r) {
    F0(n) && r.delete(a);
  }
  function Xc() {
    Yc = !1, eo !== null && F0(eo) && (eo = null), Wo !== null && F0(Wo) && (Wo = null), Ho !== null && F0(Ho) && (Ho = null), V0.forEach(_0), C0.forEach(_0);
  }
  function Y1(n, a) {
    n.blockedOn === a && (n.blockedOn = null, Yc || (Yc = !0, d.unstable_scheduleCallback(
      d.unstable_NormalPriority,
      Xc
    )));
  }
  var Zl = null;
  function Ap(n) {
    Zl !== n && (Zl = n, d.unstable_scheduleCallback(
      d.unstable_NormalPriority,
      function() {
        Zl === n && (Zl = null);
        for (var a = 0; a < n.length; a += 3) {
          var r = n[a], s = n[a + 1], m = n[a + 2];
          if (typeof s != "function") {
            if (Op(s || r) === null)
              continue;
            break;
          }
          var f = pe(r);
          f !== null && (n.splice(a, 3), a -= 3, n1(
            f,
            {
              pending: !0,
              data: m,
              method: r.method,
              action: s
            },
            s,
            m
          ));
        }
      }
    ));
  }
  function to(n) {
    function a(O) {
      return Y1(O, n);
    }
    eo !== null && Y1(eo, n), Wo !== null && Y1(Wo, n), Ho !== null && Y1(Ho, n), V0.forEach(a), C0.forEach(a);
    for (var r = 0; r < Zs.length; r++) {
      var s = Zs[r];
      s.blockedOn === n && (s.blockedOn = null);
    }
    for (; 0 < Zs.length && (r = Zs[0], r.blockedOn === null); )
      wp(r), r.blockedOn === null && Zs.shift();
    if (r = (n.ownerDocument || n).$$reactFormReplay, r != null)
      for (s = 0; s < r.length; s += 3) {
        var m = r[s], f = r[s + 1], E = m[Yn] || null;
        if (typeof f == "function")
          E || Ap(r);
        else if (E) {
          var _ = null;
          if (f && f.hasAttribute("formAction")) {
            if (m = f, E = f[Yn] || null)
              _ = E.formAction;
            else if (Op(m) !== null) continue;
          } else _ = E.action;
          typeof _ == "function" ? r[s + 1] = _ : (r.splice(s, 3), s -= 3), Ap(r);
        }
      }
  }
  function Jp(n) {
    this._internalRoot = n;
  }
  X1.prototype.render = Jp.prototype.render = function(n) {
    var a = this._internalRoot;
    if (a === null) throw Error(p(409));
    var r = a.current, s = Sa();
    Qp(r, s, n, a, null, null);
  }, X1.prototype.unmount = Jp.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var a = n.containerInfo;
      Qp(n.current, 2, null, n, null, null), Cl(), a[Da] = null;
    }
  };
  function X1(n) {
    this._internalRoot = n;
  }
  X1.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var a = $o();
      n = { blockedOn: null, target: n, priority: a };
      for (var r = 0; r < Zs.length && a !== 0 && a < Zs[r].priority; r++) ;
      Zs.splice(r, 0, n), r === 0 && wp(n);
    }
  };
  var Lp = l.version;
  if (Lp !== "19.1.0")
    throw Error(
      p(
        527,
        Lp,
        "19.1.0"
      )
    );
  X.findDOMNode = function(n) {
    var a = n._reactInternals;
    if (a === void 0)
      throw typeof n.render == "function" ? Error(p(188)) : (n = Object.keys(n).join(","), Error(p(268, n)));
    return n = T(a), n = n !== null ? k(n) : null, n = n === null ? null : n.stateNode, n;
  };
  var Wi = {
    bundleType: 0,
    version: "19.1.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: Z,
    reconcilerVersion: "19.1.0"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var M0 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!M0.isDisabled && M0.supportsFiber)
      try {
        ni = M0.inject(
          Wi
        ), Jn = M0;
      } catch {
      }
  }
  return Vf.createRoot = function(n, a) {
    if (!g(n)) throw Error(p(299));
    var r = !1, s = "", m = Nc, f = wm, E = t0, _ = null;
    return a != null && (a.unstable_strictMode === !0 && (r = !0), a.identifierPrefix !== void 0 && (s = a.identifierPrefix), a.onUncaughtError !== void 0 && (m = a.onUncaughtError), a.onCaughtError !== void 0 && (f = a.onCaughtError), a.onRecoverableError !== void 0 && (E = a.onRecoverableError), a.unstable_transitionCallbacks !== void 0 && (_ = a.unstable_transitionCallbacks)), a = Mp(
      n,
      1,
      !1,
      null,
      null,
      r,
      s,
      m,
      f,
      E,
      _,
      null
    ), n[Da] = a.current, Tp(n), new Jp(a);
  }, Vf.hydrateRoot = function(n, a, r) {
    if (!g(n)) throw Error(p(299));
    var s = !1, m = "", f = Nc, E = wm, _ = t0, O = null, K = null;
    return r != null && (r.unstable_strictMode === !0 && (s = !0), r.identifierPrefix !== void 0 && (m = r.identifierPrefix), r.onUncaughtError !== void 0 && (f = r.onUncaughtError), r.onCaughtError !== void 0 && (E = r.onCaughtError), r.onRecoverableError !== void 0 && (_ = r.onRecoverableError), r.unstable_transitionCallbacks !== void 0 && (O = r.unstable_transitionCallbacks), r.formState !== void 0 && (K = r.formState)), a = Mp(
      n,
      1,
      !0,
      a,
      r ?? null,
      s,
      m,
      f,
      E,
      _,
      O,
      K
    ), a.context = kp(null), r = a.current, s = Sa(), s = Sn(s), m = qi(s), m.callback = null, Br(r, m, s), r = s, a.current.lanes = r, nt(a, r), aa(a), n[Da] = a.current, Tp(n), new X1(a);
  }, Vf.version = "19.1.0", Vf;
}
var Cf = {};
/**
 * @license React
 * react-dom-client.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var B3;
function vy() {
  return B3 || (B3 = 1, process.env.NODE_ENV !== "production" && function() {
    function d(e, t) {
      for (e = e.memoizedState; e !== null && 0 < t; )
        e = e.next, t--;
      return e;
    }
    function l(e, t, i, o) {
      if (i >= t.length) return o;
      var c = t[i], h = vt(e) ? e.slice() : bt({}, e);
      return h[c] = l(e[c], t, i + 1, o), h;
    }
    function u(e, t, i) {
      if (t.length === i.length) {
        for (var o = 0; o < i.length - 1; o++)
          if (t[o] !== i[o])
            return;
        return p(e, t, i, 0);
      }
    }
    function p(e, t, i, o) {
      var c = t[o], h = vt(e) ? e.slice() : bt({}, e);
      return o + 1 === t.length ? (h[i[o]] = h[c], vt(h) ? h.splice(c, 1) : delete h[c]) : h[c] = p(
        e[c],
        t,
        i,
        o + 1
      ), h;
    }
    function g(e, t, i) {
      var o = t[i], c = vt(e) ? e.slice() : bt({}, e);
      return i + 1 === t.length ? (vt(c) ? c.splice(o, 1) : delete c[o], c) : (c[o] = g(e[o], t, i + 1), c);
    }
    function R() {
      return !1;
    }
    function y() {
      return null;
    }
    function Q() {
    }
    function T() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function k() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function V() {
    }
    function N(e) {
      var t = [];
      return e.forEach(function(i) {
        t.push(i);
      }), t.sort().join(", ");
    }
    function b(e, t, i, o) {
      return new bd(e, t, i, o);
    }
    function A(e, t) {
      e.context === Kc && (nn(e.current, 2, t, e, null, null), Ul());
    }
    function Ne(e, t) {
      if (io !== null) {
        var i = t.staleFamilies;
        t = t.updatedFamilies, bc(), Nd(
          e.current,
          t,
          i
        ), Ul();
      }
    }
    function Ee(e) {
      io = e;
    }
    function Fe(e) {
      return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
    }
    function he(e) {
      var t = e, i = e;
      if (e.alternate) for (; t.return; ) t = t.return;
      else {
        e = t;
        do
          t = e, (t.flags & 4098) !== 0 && (i = t.return), e = t.return;
        while (e);
      }
      return t.tag === 3 ? i : null;
    }
    function ie(e) {
      if (e.tag === 13) {
        var t = e.memoizedState;
        if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
      }
      return null;
    }
    function Ve(e) {
      if (he(e) !== e)
        throw Error("Unable to find node on an unmounted component.");
    }
    function _e(e) {
      var t = e.alternate;
      if (!t) {
        if (t = he(e), t === null)
          throw Error("Unable to find node on an unmounted component.");
        return t !== e ? null : e;
      }
      for (var i = e, o = t; ; ) {
        var c = i.return;
        if (c === null) break;
        var h = c.alternate;
        if (h === null) {
          if (o = c.return, o !== null) {
            i = o;
            continue;
          }
          break;
        }
        if (c.child === h.child) {
          for (h = c.child; h; ) {
            if (h === i) return Ve(c), e;
            if (h === o) return Ve(c), t;
            h = h.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (i.return !== o.return) i = c, o = h;
        else {
          for (var v = !1, S = c.child; S; ) {
            if (S === i) {
              v = !0, i = c, o = h;
              break;
            }
            if (S === o) {
              v = !0, o = c, i = h;
              break;
            }
            S = S.sibling;
          }
          if (!v) {
            for (S = h.child; S; ) {
              if (S === i) {
                v = !0, i = h, o = c;
                break;
              }
              if (S === o) {
                v = !0, o = h, i = c;
                break;
              }
              S = S.sibling;
            }
            if (!v)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (i.alternate !== o)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (i.tag !== 3)
        throw Error("Unable to find node on an unmounted component.");
      return i.stateNode.current === i ? e : t;
    }
    function z(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6) return e;
      for (e = e.child; e !== null; ) {
        if (t = z(e), t !== null) return t;
        e = e.sibling;
      }
      return null;
    }
    function Ce(e) {
      return e === null || typeof e != "object" ? null : (e = Np && e[Np] || e["@@iterator"], typeof e == "function" ? e : null);
    }
    function Re(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === O1 ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case Ut:
          return "Fragment";
        case Ac:
          return "Profiler";
        case wc:
          return "StrictMode";
        case Jc:
          return "Suspense";
        case _s:
          return "SuspenseList";
        case yp:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case kl:
            return "Portal";
          case Pa:
            return (e.displayName || "Context") + ".Provider";
          case Z1:
            return (e._context.displayName || "Context") + ".Consumer";
          case wo:
            var t = e.render;
            return e = e.displayName, e || (e = t.displayName || t.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case S0:
            return t = e.displayName || null, t !== null ? t : Re(e.type) || "Memo";
          case Ea:
            t = e._payload, e = e._init;
            try {
              return Re(e(t));
            } catch {
            }
        }
      return null;
    }
    function Ue(e) {
      return typeof e.tag == "number" ? Se(e) : typeof e.name == "string" ? e.name : null;
    }
    function Se(e) {
      var t = e.type;
      switch (e.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (t._context.displayName || "Context") + ".Consumer";
        case 10:
          return (t.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return e = t.render, e = e.displayName || e.name || "", t.displayName || (e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return t;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return Re(t);
        case 8:
          return t === wc ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if (typeof t == "function")
            return t.displayName || t.name || null;
          if (typeof t == "string") return t;
          break;
        case 29:
          if (t = e._debugInfo, t != null) {
            for (var i = t.length - 1; 0 <= i; i--)
              if (typeof t[i].name == "string") return t[i].name;
          }
          if (e.return !== null)
            return Se(e.return);
      }
      return null;
    }
    function xe(e) {
      return { current: e };
    }
    function Qe(e, t) {
      0 > Ya ? console.error("Unexpected pop.") : (t !== E0[Ya] && console.error("Unexpected Fiber popped."), e.current = R0[Ya], R0[Ya] = null, E0[Ya] = null, Ya--);
    }
    function fe(e, t, i) {
      Ya++, R0[Ya] = e.current, E0[Ya] = i, e.current = t;
    }
    function be(e) {
      return e === null && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      ), e;
    }
    function Be(e, t) {
      fe(qr, t, e), fe(Lc, e, e), fe(Ao, null, e);
      var i = t.nodeType;
      switch (i) {
        case 9:
        case 11:
          i = i === 9 ? "#document" : "#fragment", t = (t = t.documentElement) && (t = t.namespaceURI) ? $t(t) : zl;
          break;
        default:
          if (i = t.tagName, t = t.namespaceURI)
            t = $t(t), t = na(
              t,
              i
            );
          else
            switch (i) {
              case "svg":
                t = Nh;
                break;
              case "math":
                t = Rg;
                break;
              default:
                t = zl;
            }
      }
      i = i.toLowerCase(), i = wh(null, i), i = {
        context: t,
        ancestorInfo: i
      }, Qe(Ao, e), fe(Ao, i, e);
    }
    function De(e) {
      Qe(Ao, e), Qe(Lc, e), Qe(qr, e);
    }
    function Z() {
      return be(Ao.current);
    }
    function X(e) {
      e.memoizedState !== null && fe(Ic, e, e);
      var t = be(Ao.current), i = e.type, o = na(t.context, i);
      i = wh(t.ancestorInfo, i), o = { context: o, ancestorInfo: i }, t !== o && (fe(Lc, e, e), fe(Ao, o, e));
    }
    function ae(e) {
      Lc.current === e && (Qe(Ao, e), Qe(Lc, e)), Ic.current === e && (Qe(Ic, e), Ef._currentValue = P0);
    }
    function Te(e) {
      return typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
    }
    function F(e) {
      try {
        return H(e), !1;
      } catch {
        return !0;
      }
    }
    function H(e) {
      return "" + e;
    }
    function L(e, t) {
      if (F(e))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          Te(e)
        ), H(e);
    }
    function de(e, t) {
      if (F(e))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          t,
          Te(e)
        ), H(e);
    }
    function ye(e) {
      if (F(e))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          Te(e)
        ), H(e);
    }
    function Ae(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u") return !1;
      var t = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (t.isDisabled) return !0;
      if (!t.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), !0;
      try {
        ks = t.inject(e), Ri = t;
      } catch (i) {
        console.error("React instrumentation encountered an error: %s.", i);
      }
      return !!t.checkDCE;
    }
    function Ze(e) {
      if (typeof vv == "function" && pr(e), Ri && typeof Ri.setStrictMode == "function")
        try {
          Ri.setStrictMode(ks, e);
        } catch (t) {
          ra || (ra = !0, console.error(
            "React instrumentation encountered an error: %s",
            t
          ));
        }
    }
    function Bt(e) {
      Le = e;
    }
    function $e() {
      Le !== null && typeof Le.markCommitStopped == "function" && Le.markCommitStopped();
    }
    function Ht(e) {
      Le !== null && typeof Le.markComponentRenderStarted == "function" && Le.markComponentRenderStarted(e);
    }
    function Nn() {
      Le !== null && typeof Le.markComponentRenderStopped == "function" && Le.markComponentRenderStopped();
    }
    function rn(e) {
      Le !== null && typeof Le.markRenderStarted == "function" && Le.markRenderStarted(e);
    }
    function tn() {
      Le !== null && typeof Le.markRenderStopped == "function" && Le.markRenderStopped();
    }
    function gn(e, t) {
      Le !== null && typeof Le.markStateUpdateScheduled == "function" && Le.markStateUpdateScheduled(e, t);
    }
    function Ma(e) {
      return e >>>= 0, e === 0 ? 32 : 31 - (A1(e) / Lo | 0) | 0;
    }
    function go(e) {
      if (e & 1) return "SyncHydrationLane";
      if (e & 2) return "Sync";
      if (e & 4) return "InputContinuousHydration";
      if (e & 8) return "InputContinuous";
      if (e & 16) return "DefaultHydration";
      if (e & 32) return "Default";
      if (e & 128) return "TransitionHydration";
      if (e & 4194048) return "Transition";
      if (e & 62914560) return "Retry";
      if (e & 67108864) return "SelectiveHydration";
      if (e & 134217728) return "IdleHydration";
      if (e & 268435456) return "Idle";
      if (e & 536870912) return "Offscreen";
      if (e & 1073741824) return "Deferred";
    }
    function Qt(e) {
      var t = e & 42;
      if (t !== 0) return t;
      switch (e & -e) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return e & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return e & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), e;
      }
    }
    function vn(e, t, i) {
      var o = e.pendingLanes;
      if (o === 0) return 0;
      var c = 0, h = e.suspendedLanes, v = e.pingedLanes;
      e = e.warmLanes;
      var S = o & 134217727;
      return S !== 0 ? (o = S & ~h, o !== 0 ? c = Qt(o) : (v &= S, v !== 0 ? c = Qt(v) : i || (i = S & ~e, i !== 0 && (c = Qt(i))))) : (S = o & ~h, S !== 0 ? c = Qt(S) : v !== 0 ? c = Qt(v) : i || (i = o & ~e, i !== 0 && (c = Qt(i)))), c === 0 ? 0 : t !== 0 && t !== c && (t & h) === 0 && (h = c & -c, i = t & -t, h >= i || h === 32 && (i & 4194048) !== 0) ? t : c;
    }
    function ka(e, t) {
      return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
    }
    function Rr(e, t) {
      switch (e) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return t + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return t + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function gt() {
      var e = J1;
      return J1 <<= 1, (J1 & 4194048) === 0 && (J1 = 256), e;
    }
    function bi() {
      var e = L1;
      return L1 <<= 1, (L1 & 62914560) === 0 && (L1 = 4194304), e;
    }
    function Lt(e) {
      for (var t = [], i = 0; 31 > i; i++) t.push(e);
      return t;
    }
    function xi(e, t) {
      e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
    }
    function qo(e, t, i, o, c, h) {
      var v = e.pendingLanes;
      e.pendingLanes = i, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= i, e.entangledLanes &= i, e.errorRecoveryDisabledLanes &= i, e.shellSuspendCounter = 0;
      var S = e.entanglements, M = e.expirationTimes, x = e.hiddenUpdates;
      for (i = v & ~i; 0 < i; ) {
        var ee = 31 - Mi(i), le = 1 << ee;
        S[ee] = 0, M[ee] = -1;
        var q = x[ee];
        if (q !== null)
          for (x[ee] = null, ee = 0; ee < q.length; ee++) {
            var ce = q[ee];
            ce !== null && (ce.lane &= -536870913);
          }
        i &= ~le;
      }
      o !== 0 && vo(e, o, 0), h !== 0 && c === 0 && e.tag !== 0 && (e.suspendedLanes |= h & ~(v & ~t));
    }
    function vo(e, t, i) {
      e.pendingLanes |= t, e.suspendedLanes &= ~t;
      var o = 31 - Mi(t);
      e.entangledLanes |= t, e.entanglements[o] = e.entanglements[o] | 1073741824 | i & 4194090;
    }
    function ni(e, t) {
      var i = e.entangledLanes |= t;
      for (e = e.entanglements; i; ) {
        var o = 31 - Mi(i), c = 1 << o;
        c & t | e[o] & t && (e[o] |= t), i &= ~c;
      }
    }
    function Jn(e) {
      switch (e) {
        case 2:
          e = 1;
          break;
        case 8:
          e = 4;
          break;
        case 32:
          e = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          e = 128;
          break;
        case 268435456:
          e = 134217728;
          break;
        default:
          e = 0;
      }
      return e;
    }
    function un(e, t, i) {
      if (Bn)
        for (e = e.pendingUpdatersLaneMap; 0 < i; ) {
          var o = 31 - Mi(i), c = 1 << o;
          e[o].add(t), i &= ~c;
        }
    }
    function Ln(e, t) {
      if (Bn)
        for (var i = e.pendingUpdatersLaneMap, o = e.memoizedUpdaters; 0 < t; ) {
          var c = 31 - Mi(t);
          e = 1 << c, c = i[c], 0 < c.size && (c.forEach(function(h) {
            var v = h.alternate;
            v !== null && o.has(v) || o.add(h);
          }), c.clear()), t &= ~e;
        }
    }
    function Qa(e) {
      return e &= -e, Ei < e ? fr < e ? (e & 134217727) !== 0 ? Io : I1 : fr : Ei;
    }
    function So() {
      var e = ut.p;
      return e !== 0 ? e : (e = window.event, e === void 0 ? Io : D1(e.type));
    }
    function Er(e, t) {
      var i = ut.p;
      try {
        return ut.p = e, t();
      } finally {
        ut.p = i;
      }
    }
    function Zi(e) {
      delete e[ki], delete e[oa], delete e[bp], delete e[x2], delete e[Hc];
    }
    function ii(e) {
      var t = e[ki];
      if (t) return t;
      for (var i = e.parentNode; i; ) {
        if (t = i[Ds] || i[ki]) {
          if (i = t.alternate, t.child !== null || i !== null && i.child !== null)
            for (e = xc(e); e !== null; ) {
              if (i = e[ki])
                return i;
              e = xc(e);
            }
          return t;
        }
        e = i, i = e.parentNode;
      }
      return null;
    }
    function In(e) {
      if (e = e[ki] || e[Ds]) {
        var t = e.tag;
        if (t === 5 || t === 6 || t === 13 || t === 26 || t === 27 || t === 3)
          return e;
      }
      return null;
    }
    function Oi(e) {
      var t = e.tag;
      if (t === 5 || t === 26 || t === 27 || t === 6)
        return e.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function C(e) {
      var t = e[zc];
      return t || (t = e[zc] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
    }
    function j(e) {
      e[jc] = !0;
    }
    function ke(e, t) {
      Oe(e, t), Oe(e + "Capture", t);
    }
    function Oe(e, t) {
      Xa[e] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        e
      ), Xa[e] = t;
      var i = e.toLowerCase();
      for (Ql[i] = e, e === "onDoubleClick" && (Ql.ondblclick = e), e = 0; e < t.length; e++)
        Z2.add(t[e]);
    }
    function Je(e, t) {
      O2[t.type] || t.onChange || t.onInput || t.readOnly || t.disabled || t.value == null || console.error(
        e === "select" ? "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`." : "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ), t.onChange || t.readOnly || t.disabled || t.checked == null || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function nt(e) {
      return Jo.call(z1, e) ? !0 : Jo.call(H1, e) ? !1 : W1.test(e) ? z1[e] = !0 : (H1[e] = !0, console.error("Invalid attribute name: `%s`", e), !1);
    }
    function mt(e, t, i) {
      if (nt(t)) {
        if (!e.hasAttribute(t)) {
          switch (typeof i) {
            case "symbol":
            case "object":
              return i;
            case "function":
              return i;
            case "boolean":
              if (i === !1) return i;
          }
          return i === void 0 ? void 0 : null;
        }
        return e = e.getAttribute(t), e === "" && i === !0 ? !0 : (L(i, t), e === "" + i ? i : e);
      }
    }
    function Ct(e, t, i) {
      if (nt(t))
        if (i === null) e.removeAttribute(t);
        else {
          switch (typeof i) {
            case "undefined":
            case "function":
            case "symbol":
              e.removeAttribute(t);
              return;
            case "boolean":
              var o = t.toLowerCase().slice(0, 5);
              if (o !== "data-" && o !== "aria-") {
                e.removeAttribute(t);
                return;
              }
          }
          L(i, t), e.setAttribute(t, "" + i);
        }
    }
    function ct(e, t, i) {
      if (i === null) e.removeAttribute(t);
      else {
        switch (typeof i) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(t);
            return;
        }
        L(i, t), e.setAttribute(t, "" + i);
      }
    }
    function Sn(e, t, i, o) {
      if (o === null) e.removeAttribute(i);
      else {
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            e.removeAttribute(i);
            return;
        }
        L(o, i), e.setAttributeNS(t, i, "" + o);
      }
    }
    function Bi() {
    }
    function $o() {
      if (xs === 0) {
        Vp = console.log, Cp = console.info, B2 = console.warn, Fp = console.error, Gc = console.group, w2 = console.groupCollapsed, A2 = console.groupEnd;
        var e = {
          configurable: !0,
          enumerable: !0,
          value: Bi,
          writable: !0
        };
        Object.defineProperties(console, {
          info: e,
          log: e,
          warn: e,
          error: e,
          group: e,
          groupCollapsed: e,
          groupEnd: e
        });
      }
      xs++;
    }
    function Ws() {
      if (xs--, xs === 0) {
        var e = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: bt({}, e, { value: Vp }),
          info: bt({}, e, { value: Cp }),
          warn: bt({}, e, { value: B2 }),
          error: bt({}, e, { value: Fp }),
          group: bt({}, e, { value: Gc }),
          groupCollapsed: bt({}, e, { value: w2 }),
          groupEnd: bt({}, e, { value: A2 })
        });
      }
      0 > xs && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function bn(e) {
      if (_p === void 0)
        try {
          throw Error();
        } catch (i) {
          var t = i.stack.trim().match(/\n( *(at )?)/);
          _p = t && t[1] || "", y0 = -1 < i.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < i.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + _p + e + y0;
    }
    function _n(e, t) {
      if (!e || Pc) return "";
      var i = N0.get(e);
      if (i !== void 0) return i;
      Pc = !0, i = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var o = null;
      o = oe.H, oe.H = null, $o();
      try {
        var c = {
          DetermineComponentFrameRoot: function() {
            try {
              if (t) {
                var q = function() {
                  throw Error();
                };
                if (Object.defineProperty(q.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(q, []);
                  } catch (je) {
                    var ce = je;
                  }
                  Reflect.construct(e, [], q);
                } else {
                  try {
                    q.call();
                  } catch (je) {
                    ce = je;
                  }
                  e.call(q.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (je) {
                  ce = je;
                }
                (q = e()) && typeof q.catch == "function" && q.catch(function() {
                });
              }
            } catch (je) {
              if (je && ce && typeof je.stack == "string")
                return [je.stack, ce.stack];
            }
            return [null, null];
          }
        };
        c.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var h = Object.getOwnPropertyDescriptor(
          c.DetermineComponentFrameRoot,
          "name"
        );
        h && h.configurable && Object.defineProperty(
          c.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var v = c.DetermineComponentFrameRoot(), S = v[0], M = v[1];
        if (S && M) {
          var x = S.split(`
`), ee = M.split(`
`);
          for (v = h = 0; h < x.length && !x[h].includes(
            "DetermineComponentFrameRoot"
          ); )
            h++;
          for (; v < ee.length && !ee[v].includes(
            "DetermineComponentFrameRoot"
          ); )
            v++;
          if (h === x.length || v === ee.length)
            for (h = x.length - 1, v = ee.length - 1; 1 <= h && 0 <= v && x[h] !== ee[v]; )
              v--;
          for (; 1 <= h && 0 <= v; h--, v--)
            if (x[h] !== ee[v]) {
              if (h !== 1 || v !== 1)
                do
                  if (h--, v--, 0 > v || x[h] !== ee[v]) {
                    var le = `
` + x[h].replace(
                      " at new ",
                      " at "
                    );
                    return e.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", e.displayName)), typeof e == "function" && N0.set(e, le), le;
                  }
                while (1 <= h && 0 <= v);
              break;
            }
        }
      } finally {
        Pc = !1, oe.H = o, Ws(), Error.prepareStackTrace = i;
      }
      return x = (x = e ? e.displayName || e.name : "") ? bn(x) : "", typeof e == "function" && N0.set(e, x), x;
    }
    function Yn(e) {
      var t = Error.prepareStackTrace;
      if (Error.prepareStackTrace = void 0, e = e.stack, Error.prepareStackTrace = t, e.startsWith(`Error: react-stack-top-frame
`) && (e = e.slice(29)), t = e.indexOf(`
`), t !== -1 && (e = e.slice(t + 1)), t = e.indexOf("react-stack-bottom-frame"), t !== -1 && (t = e.lastIndexOf(
        `
`,
        t
      )), t !== -1)
        e = e.slice(0, t);
      else return "";
      return e;
    }
    function Da(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return bn(e.type);
        case 16:
          return bn("Lazy");
        case 13:
          return bn("Suspense");
        case 19:
          return bn("SuspenseList");
        case 0:
        case 15:
          return _n(e.type, !1);
        case 11:
          return _n(e.type.render, !1);
        case 1:
          return _n(e.type, !0);
        case 31:
          return bn("Activity");
        default:
          return "";
      }
    }
    function Ur(e) {
      try {
        var t = "";
        do {
          t += Da(e);
          var i = e._debugInfo;
          if (i)
            for (var o = i.length - 1; 0 <= o; o--) {
              var c = i[o];
              if (typeof c.name == "string") {
                var h = t, v = c.env, S = bn(
                  c.name + (v ? " [" + v + "]" : "")
                );
                t = h + S;
              }
            }
          e = e.return;
        } while (e);
        return t;
      } catch (M) {
        return `
Error generating stack: ` + M.message + `
` + M.stack;
      }
    }
    function xa(e) {
      return (e = e ? e.displayName || e.name : "") ? bn(e) : "";
    }
    function Tr() {
      if (Ua === null) return null;
      var e = Ua._debugOwner;
      return e != null ? Ue(e) : null;
    }
    function yr() {
      if (Ua === null) return "";
      var e = Ua;
      try {
        var t = "";
        switch (e.tag === 6 && (e = e.return), e.tag) {
          case 26:
          case 27:
          case 5:
            t += bn(e.type);
            break;
          case 13:
            t += bn("Suspense");
            break;
          case 19:
            t += bn("SuspenseList");
            break;
          case 31:
            t += bn("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            e._debugOwner || t !== "" || (t += xa(
              e.type
            ));
            break;
          case 11:
            e._debugOwner || t !== "" || (t += xa(
              e.type.render
            ));
        }
        for (; e; )
          if (typeof e.tag == "number") {
            var i = e;
            e = i._debugOwner;
            var o = i._debugStack;
            e && o && (typeof o != "string" && (i._debugStack = o = Yn(o)), o !== "" && (t += `
` + o));
          } else if (e.debugStack != null) {
            var c = e.debugStack;
            (e = e.owner) && c && (t += `
` + Yn(c));
          } else break;
        var h = t;
      } catch (v) {
        h = `
Error generating stack: ` + v.message + `
` + v.stack;
      }
      return h;
    }
    function He(e, t, i, o, c, h, v) {
      var S = Ua;
      D(e);
      try {
        return e !== null && e._debugTask ? e._debugTask.run(
          t.bind(null, i, o, c, h, v)
        ) : t(i, o, c, h, v);
      } finally {
        D(S);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function D(e) {
      oe.getCurrentStack = e === null ? null : yr, sa = !1, Ua = e;
    }
    function B(e) {
      switch (typeof e) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return ye(e), e;
        default:
          return "";
      }
    }
    function pe(e) {
      var t = e.type;
      return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
    }
    function Ie(e) {
      var t = pe(e) ? "checked" : "value", i = Object.getOwnPropertyDescriptor(
        e.constructor.prototype,
        t
      );
      ye(e[t]);
      var o = "" + e[t];
      if (!e.hasOwnProperty(t) && typeof i < "u" && typeof i.get == "function" && typeof i.set == "function") {
        var c = i.get, h = i.set;
        return Object.defineProperty(e, t, {
          configurable: !0,
          get: function() {
            return c.call(this);
          },
          set: function(v) {
            ye(v), o = "" + v, h.call(this, v);
          }
        }), Object.defineProperty(e, t, {
          enumerable: i.enumerable
        }), {
          getValue: function() {
            return o;
          },
          setValue: function(v) {
            ye(v), o = "" + v;
          },
          stopTracking: function() {
            e._valueTracker = null, delete e[t];
          }
        };
      }
    }
    function ot(e) {
      e._valueTracker || (e._valueTracker = Ie(e));
    }
    function Ke(e) {
      if (!e) return !1;
      var t = e._valueTracker;
      if (!t) return !0;
      var i = t.getValue(), o = "";
      return e && (o = pe(e) ? e.checked ? "true" : "false" : e.value), e = o, e !== i ? (t.setValue(e), !0) : !1;
    }
    function qe(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u") return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    function dt(e) {
      return e.replace(
        Sv,
        function(t) {
          return "\\" + t.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function qt(e, t) {
      t.checked === void 0 || t.defaultChecked === void 0 || kp || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Tr() || "A component",
        t.type
      ), kp = !0), t.value === void 0 || t.defaultValue === void 0 || Mp || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        Tr() || "A component",
        t.type
      ), Mp = !0);
    }
    function Gi(e, t, i, o, c, h, v, S) {
      e.name = "", v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" ? (L(v, "type"), e.type = v) : e.removeAttribute("type"), t != null ? v === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + B(t)) : e.value !== "" + B(t) && (e.value = "" + B(t)) : v !== "submit" && v !== "reset" || e.removeAttribute("value"), t != null ? su(e, v, B(t)) : i != null ? su(e, v, B(i)) : o != null && e.removeAttribute("value"), c == null && h != null && (e.defaultChecked = !!h), c != null && (e.checked = c && typeof c != "function" && typeof c != "symbol"), S != null && typeof S != "function" && typeof S != "symbol" && typeof S != "boolean" ? (L(S, "name"), e.name = "" + B(S)) : e.removeAttribute("name");
    }
    function wf(e, t, i, o, c, h, v, S) {
      if (h != null && typeof h != "function" && typeof h != "symbol" && typeof h != "boolean" && (L(h, "type"), e.type = h), t != null || i != null) {
        if (!(h !== "submit" && h !== "reset" || t != null))
          return;
        i = i != null ? "" + B(i) : "", t = t != null ? "" + B(t) : i, S || t === e.value || (e.value = t), e.defaultValue = t;
      }
      o = o ?? c, o = typeof o != "function" && typeof o != "symbol" && !!o, e.checked = S ? e.checked : !!o, e.defaultChecked = !!o, v != null && typeof v != "function" && typeof v != "symbol" && typeof v != "boolean" && (L(v, "name"), e.name = v);
    }
    function su(e, t, i) {
      t === "number" && qe(e.ownerDocument) === e || e.defaultValue === "" + i || (e.defaultValue = "" + i);
    }
    function xh(e, t) {
      t.value == null && (typeof t.children == "object" && t.children !== null ? g0.Children.forEach(t.children, function(i) {
        i == null || typeof i == "string" || typeof i == "number" || typeof i == "bigint" || Dp || (Dp = !0, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : t.dangerouslySetInnerHTML == null || j1 || (j1 = !0, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      ))), t.selected == null || Qp || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), Qp = !0);
    }
    function Af() {
      var e = Tr();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    function Ro(e, t, i, o) {
      if (e = e.options, t) {
        t = {};
        for (var c = 0; c < i.length; c++)
          t["$" + i[c]] = !0;
        for (i = 0; i < e.length; i++)
          c = t.hasOwnProperty("$" + e[i].value), e[i].selected !== c && (e[i].selected = c), c && o && (e[i].defaultSelected = !0);
      } else {
        for (i = "" + B(i), t = null, c = 0; c < e.length; c++) {
          if (e[c].value === i) {
            e[c].selected = !0, o && (e[c].defaultSelected = !0);
            return;
          }
          t !== null || e[c].disabled || (t = e[c]);
        }
        t !== null && (t.selected = !0);
      }
    }
    function fd(e, t) {
      for (e = 0; e < b0.length; e++) {
        var i = b0[e];
        if (t[i] != null) {
          var o = vt(t[i]);
          t.multiple && !o ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            i,
            Af()
          ) : !t.multiple && o && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            i,
            Af()
          );
        }
      }
      t.value === void 0 || t.defaultValue === void 0 || xp || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), xp = !0);
    }
    function Nr(e, t) {
      t.value === void 0 || t.defaultValue === void 0 || J2 || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        Tr() || "A component"
      ), J2 = !0), t.children != null && t.value == null && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function lu(e, t, i) {
      if (t != null && (t = "" + B(t), t !== e.value && (e.value = t), i == null)) {
        e.defaultValue !== t && (e.defaultValue = t);
        return;
      }
      e.defaultValue = i != null ? "" + B(i) : "";
    }
    function Zh(e, t, i, o) {
      if (t == null) {
        if (o != null) {
          if (i != null)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (vt(o)) {
            if (1 < o.length)
              throw Error("<textarea> can only have at most one child.");
            o = o[0];
          }
          i = o;
        }
        i == null && (i = ""), t = i;
      }
      i = B(t), e.defaultValue = i, o = e.textContent, o === i && o !== "" && o !== null && (e.value = o);
    }
    function Hs(e, t) {
      return e.serverProps === void 0 && e.serverTail.length === 0 && e.children.length === 1 && 3 < e.distanceFromLeaf && e.distanceFromLeaf > 15 - t ? Hs(e.children[0], t) : e;
    }
    function wi(e) {
      return "  " + "  ".repeat(e);
    }
    function es(e) {
      return "+ " + "  ".repeat(e);
    }
    function zs(e) {
      return "- " + "  ".repeat(e);
    }
    function Oh(e) {
      switch (e.tag) {
        case 26:
        case 27:
        case 5:
          return e.type;
        case 16:
          return "Lazy";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return e = e.type, e.displayName || e.name || null;
        case 11:
          return e = e.type.render, e.displayName || e.name || null;
        case 1:
          return e = e.type, e.displayName || e.name || null;
        default:
          return null;
      }
    }
    function Vi(e, t) {
      return L2.test(e) ? (e = JSON.stringify(e), e.length > t - 2 ? 8 > t ? '{"..."}' : "{" + e.slice(0, t - 7) + '..."}' : "{" + e + "}") : e.length > t ? 5 > t ? '{"..."}' : e.slice(0, t - 3) + "..." : e;
    }
    function gd(e, t, i) {
      var o = 120 - 2 * i;
      if (t === null)
        return es(i) + Vi(e, o) + `
`;
      if (typeof t == "string") {
        for (var c = 0; c < t.length && c < e.length && t.charCodeAt(c) === e.charCodeAt(c); c++) ;
        return c > o - 8 && 10 < c && (e = "..." + e.slice(c - 8), t = "..." + t.slice(c - 8)), es(i) + Vi(e, o) + `
` + zs(i) + Vi(t, o) + `
`;
      }
      return wi(i) + Vi(e, o) + `
`;
    }
    function Bh(e) {
      return Object.prototype.toString.call(e).replace(/^\[object (.*)\]$/, function(t, i) {
        return i;
      });
    }
    function ts(e, t) {
      switch (typeof e) {
        case "string":
          return e = JSON.stringify(e), e.length > t ? 5 > t ? '"..."' : e.slice(0, t - 4) + '..."' : e;
        case "object":
          if (e === null) return "null";
          if (vt(e)) return "[...]";
          if (e.$$typeof === Fs)
            return (t = Re(e.type)) ? "<" + t + ">" : "<...>";
          var i = Bh(e);
          if (i === "Object") {
            i = "", t -= 2;
            for (var o in e)
              if (e.hasOwnProperty(o)) {
                var c = JSON.stringify(o);
                if (c !== '"' + o + '"' && (o = c), t -= o.length - 2, c = ts(
                  e[o],
                  15 > t ? t : 15
                ), t -= c.length, 0 > t) {
                  i += i === "" ? "..." : ", ...";
                  break;
                }
                i += (i === "" ? "" : ",") + o + ":" + c;
              }
            return "{" + i + "}";
          }
          return i;
        case "function":
          return (t = e.displayName || e.name) ? "function " + t : "function";
        default:
          return String(e);
      }
    }
    function js(e, t) {
      return typeof e != "string" || L2.test(e) ? "{" + ts(e, t - 2) + "}" : e.length > t - 2 ? 5 > t ? '"..."' : '"' + e.slice(0, t - 5) + '..."' : '"' + e + '"';
    }
    function ql(e, t, i) {
      var o = 120 - i.length - e.length, c = [], h;
      for (h in t)
        if (t.hasOwnProperty(h) && h !== "children") {
          var v = js(
            t[h],
            120 - i.length - h.length - 1
          );
          o -= h.length + v.length + 2, c.push(h + "=" + v);
        }
      return c.length === 0 ? i + "<" + e + `>
` : 0 < o ? i + "<" + e + " " + c.join(" ") + `>
` : i + "<" + e + `
` + i + "  " + c.join(`
` + i + "  ") + `
` + i + `>
`;
    }
    function ev(e, t, i) {
      var o = "", c = bt({}, t), h;
      for (h in e)
        if (e.hasOwnProperty(h)) {
          delete c[h];
          var v = 120 - 2 * i - h.length - 2, S = ts(e[h], v);
          t.hasOwnProperty(h) ? (v = ts(t[h], v), o += es(i) + h + ": " + S + `
`, o += zs(i) + h + ": " + v + `
`) : o += es(i) + h + ": " + S + `
`;
        }
      for (var M in c)
        c.hasOwnProperty(M) && (e = ts(
          c[M],
          120 - 2 * i - M.length - 2
        ), o += zs(i) + M + ": " + e + `
`);
      return o;
    }
    function Za(e, t, i, o) {
      var c = "", h = /* @__PURE__ */ new Map();
      for (x in i)
        i.hasOwnProperty(x) && h.set(
          x.toLowerCase(),
          x
        );
      if (h.size === 1 && h.has("children"))
        c += ql(
          e,
          t,
          wi(o)
        );
      else {
        for (var v in t)
          if (t.hasOwnProperty(v) && v !== "children") {
            var S = 120 - 2 * (o + 1) - v.length - 1, M = h.get(v.toLowerCase());
            if (M !== void 0) {
              h.delete(v.toLowerCase());
              var x = t[v];
              M = i[M];
              var ee = js(
                x,
                S
              );
              S = js(
                M,
                S
              ), typeof x == "object" && x !== null && typeof M == "object" && M !== null && Bh(x) === "Object" && Bh(M) === "Object" && (2 < Object.keys(x).length || 2 < Object.keys(M).length || -1 < ee.indexOf("...") || -1 < S.indexOf("...")) ? c += wi(o + 1) + v + `={{
` + ev(
                x,
                M,
                o + 2
              ) + wi(o + 1) + `}}
` : (c += es(o + 1) + v + "=" + ee + `
`, c += zs(o + 1) + v + "=" + S + `
`);
            } else
              c += wi(o + 1) + v + "=" + js(t[v], S) + `
`;
          }
        h.forEach(function(le) {
          if (le !== "children") {
            var q = 120 - 2 * (o + 1) - le.length - 1;
            c += zs(o + 1) + le + "=" + js(i[le], q) + `
`;
          }
        }), c = c === "" ? wi(o) + "<" + e + `>
` : wi(o) + "<" + e + `
` + c + wi(o) + `>
`;
      }
      return e = i.children, t = t.children, typeof e == "string" || typeof e == "number" || typeof e == "bigint" ? (h = "", (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (h = "" + t), c += gd(h, "" + e, o + 1)) : (typeof t == "string" || typeof t == "number" || typeof t == "bigint") && (c = e == null ? c + gd("" + t, null, o + 1) : c + gd("" + t, void 0, o + 1)), c;
    }
    function cu(e, t) {
      var i = Oh(e);
      if (i === null) {
        for (i = "", e = e.child; e; )
          i += cu(e, t), e = e.sibling;
        return i;
      }
      return wi(t) + "<" + i + `>
`;
    }
    function du(e, t) {
      var i = Hs(e, t);
      if (i !== e && (e.children.length !== 1 || e.children[0] !== i))
        return wi(t) + `...
` + du(i, t + 1);
      i = "";
      var o = e.fiber._debugInfo;
      if (o)
        for (var c = 0; c < o.length; c++) {
          var h = o[c].name;
          typeof h == "string" && (i += wi(t) + "<" + h + `>
`, t++);
        }
      if (o = "", c = e.fiber.pendingProps, e.fiber.tag === 6)
        o = gd(c, e.serverProps, t), t++;
      else if (h = Oh(e.fiber), h !== null)
        if (e.serverProps === void 0) {
          o = t;
          var v = 120 - 2 * o - h.length - 2, S = "";
          for (x in c)
            if (c.hasOwnProperty(x) && x !== "children") {
              var M = js(c[x], 15);
              if (v -= x.length + M.length + 2, 0 > v) {
                S += " ...";
                break;
              }
              S += " " + x + "=" + M;
            }
          o = wi(o) + "<" + h + S + `>
`, t++;
        } else
          e.serverProps === null ? (o = ql(
            h,
            c,
            es(t)
          ), t++) : typeof e.serverProps == "string" ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (o = Za(
            h,
            c,
            e.serverProps,
            t
          ), t++);
      var x = "";
      for (c = e.fiber.child, h = 0; c && h < e.children.length; )
        v = e.children[h], v.fiber === c ? (x += du(v, t), h++) : x += cu(c, t), c = c.sibling;
      for (c && 0 < e.children.length && (x += wi(t) + `...
`), c = e.serverTail, e.serverProps === null && t--, e = 0; e < c.length; e++)
        h = c[e], x = typeof h == "string" ? x + (zs(t) + Vi(h, 120 - 2 * t) + `
`) : x + ql(
          h.type,
          h.props,
          zs(t)
        );
      return i + o + x;
    }
    function vd(e) {
      try {
        return `

` + du(e, 0);
      } catch {
        return "";
      }
    }
    function Gs(e, t, i) {
      for (var o = t, c = null, h = 0; o; )
        o === e && (h = 0), c = {
          fiber: o,
          children: c !== null ? [c] : [],
          serverProps: o === t ? i : o === e ? null : void 0,
          serverTail: [],
          distanceFromLeaf: h
        }, h++, o = o.return;
      return c !== null ? vd(c).replaceAll(/^[+-]/gm, ">") : "";
    }
    function wh(e, t) {
      var i = bt({}, e || Bp), o = { tag: t };
      return G1.indexOf(t) !== -1 && (i.aTagInScope = null, i.buttonTagInScope = null, i.nobrTagInScope = null), P1.indexOf(t) !== -1 && (i.pTagInButtonScope = null), Zp.indexOf(t) !== -1 && t !== "address" && t !== "div" && t !== "p" && (i.listItemTagAutoclosing = null, i.dlItemTagAutoclosing = null), i.current = o, t === "form" && (i.formTag = o), t === "a" && (i.aTagInScope = o), t === "button" && (i.buttonTagInScope = o), t === "nobr" && (i.nobrTagInScope = o), t === "p" && (i.pTagInButtonScope = o), t === "li" && (i.listItemTagAutoclosing = o), (t === "dd" || t === "dt") && (i.dlItemTagAutoclosing = o), t === "#document" || t === "html" ? i.containerTagInScope = null : i.containerTagInScope || (i.containerTagInScope = o), e !== null || t !== "#document" && t !== "html" && t !== "body" ? i.implicitRootScope === !0 && (i.implicitRootScope = !1) : i.implicitRootScope = !0, i;
    }
    function Ah(e, t, i) {
      switch (t) {
        case "select":
          return e === "hr" || e === "option" || e === "optgroup" || e === "script" || e === "template" || e === "#text";
        case "optgroup":
          return e === "option" || e === "#text";
        case "option":
          return e === "#text";
        case "tr":
          return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
        case "tbody":
        case "thead":
        case "tfoot":
          return e === "tr" || e === "style" || e === "script" || e === "template";
        case "colgroup":
          return e === "col" || e === "template";
        case "table":
          return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
        case "head":
          return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
        case "html":
          if (i) break;
          return e === "head" || e === "body" || e === "frameset";
        case "frameset":
          return e === "frame";
        case "#document":
          if (!i) return e === "html";
      }
      switch (e) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t !== "h1" && t !== "h2" && t !== "h3" && t !== "h4" && t !== "h5" && t !== "h6";
        case "rp":
        case "rt":
          return Op.indexOf(t) === -1;
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return t == null;
        case "head":
          return i || t === null;
        case "html":
          return i && t === "#document" || t === null;
        case "body":
          return i && (t === "#document" || t === "html") || t === null;
      }
      return !0;
    }
    function $l(e, t) {
      switch (e) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return t.pTagInButtonScope;
        case "form":
          return t.formTag || t.pTagInButtonScope;
        case "li":
          return t.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return t.dlItemTagAutoclosing;
        case "button":
          return t.buttonTagInScope;
        case "a":
          return t.aTagInScope;
        case "nobr":
          return t.nobrTagInScope;
      }
      return null;
    }
    function Jf(e, t) {
      for (; e; ) {
        switch (e.tag) {
          case 5:
          case 26:
          case 27:
            if (e.type === t) return e;
        }
        e = e.return;
      }
      return null;
    }
    function uu(e, t) {
      t = t || Bp;
      var i = t.current;
      if (t = (i = Ah(
        e,
        i && i.tag,
        t.implicitRootScope
      ) ? null : i) ? null : $l(e, t), t = i || t, !t) return !0;
      var o = t.tag;
      if (t = String(!!i) + "|" + e + "|" + o, Yc[t]) return !1;
      Yc[t] = !0;
      var c = (t = Ua) ? Jf(t.return, o) : null, h = t !== null && c !== null ? Gs(c, t, null) : "", v = "<" + e + ">";
      return i ? (i = "", o === "table" && e === "tr" && (i += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        `In HTML, %s cannot be a child of <%s>.%s
This will cause a hydration error.%s`,
        v,
        o,
        i,
        h
      )) : console.error(
        `In HTML, %s cannot be a descendant of <%s>.
This will cause a hydration error.%s`,
        v,
        o,
        h
      ), t && (e = t.return, c === null || e === null || c === e && e._debugOwner === t._debugOwner || He(c, function() {
        console.error(
          `<%s> cannot contain a nested %s.
See this log for the ancestor stack trace.`,
          o,
          v
        );
      })), !1;
    }
    function Sd(e, t, i) {
      if (i || Ah("#text", t, !1))
        return !0;
      if (i = "#text|" + t, Yc[i]) return !1;
      Yc[i] = !0;
      var o = (i = Ua) ? Jf(i, t) : null;
      return i = i !== null && o !== null ? Gs(
        o,
        i,
        i.tag !== 6 ? { children: null } : null
      ) : "", /\S/.test(e) ? console.error(
        `In HTML, text nodes cannot be a child of <%s>.
This will cause a hydration error.%s`,
        t,
        i
      ) : console.error(
        `In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.
This will cause a hydration error.%s`,
        t,
        i
      ), !1;
    }
    function Ps(e, t) {
      if (t) {
        var i = e.firstChild;
        if (i && i === e.lastChild && i.nodeType === 3) {
          i.nodeValue = t;
          return;
        }
      }
      e.textContent = t;
    }
    function tv(e) {
      return e.replace(Zs, function(t, i) {
        return i.toUpperCase();
      });
    }
    function Lf(e, t, i) {
      var o = t.indexOf("--") === 0;
      o || (-1 < t.indexOf("-") ? Dl.hasOwnProperty(t) && Dl[t] || (Dl[t] = !0, console.error(
        "Unsupported style property %s. Did you mean %s?",
        t,
        tv(t.replace(C0, "ms-"))
      )) : V0.test(t) ? Dl.hasOwnProperty(t) && Dl[t] || (Dl[t] = !0, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        t,
        t.charAt(0).toUpperCase() + t.slice(1)
      )) : !I2.test(i) || xl.hasOwnProperty(i) && xl[i] || (xl[i] = !0, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        t,
        i.replace(I2, "")
      )), typeof i == "number" && (isNaN(i) ? W2 || (W2 = !0, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        t
      )) : isFinite(i) || wp || (wp = !0, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        t
      )))), i == null || typeof i == "boolean" || i === "" ? o ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : o ? e.setProperty(t, i) : typeof i != "number" || i === 0 || F0.has(t) ? t === "float" ? e.cssFloat = i : (de(i, t), e[t] = ("" + i).trim()) : e[t] = i + "px";
    }
    function Rd(e, t, i) {
      if (t != null && typeof t != "object")
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      if (t && Object.freeze(t), e = e.style, i != null) {
        if (t) {
          var o = {};
          if (i) {
            for (var c in i)
              if (i.hasOwnProperty(c) && !t.hasOwnProperty(c))
                for (var h = eo[c] || [c], v = 0; v < h.length; v++)
                  o[h[v]] = c;
          }
          for (var S in t)
            if (t.hasOwnProperty(S) && (!i || i[S] !== t[S]))
              for (c = eo[S] || [S], h = 0; h < c.length; h++)
                o[c[h]] = S;
          S = {};
          for (var M in t)
            for (c = eo[M] || [M], h = 0; h < c.length; h++)
              S[c[h]] = M;
          M = {};
          for (var x in o)
            if (c = o[x], (h = S[x]) && c !== h && (v = c + "," + h, !M[v])) {
              M[v] = !0, v = console;
              var ee = t[c];
              v.error.call(
                v,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                ee == null || typeof ee == "boolean" || ee === "" ? "Removing" : "Updating",
                c,
                h
              );
            }
        }
        for (var le in i)
          !i.hasOwnProperty(le) || t != null && t.hasOwnProperty(le) || (le.indexOf("--") === 0 ? e.setProperty(le, "") : le === "float" ? e.cssFloat = "" : e[le] = "");
        for (var q in t)
          x = t[q], t.hasOwnProperty(q) && i[q] !== x && Lf(e, q, x);
      } else
        for (o in t)
          t.hasOwnProperty(o) && Lf(e, o, t[o]);
    }
    function Ys(e) {
      if (e.indexOf("-") === -1) return !1;
      switch (e) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    function hu(e) {
      return Y1.get(e) || e;
    }
    function ec(e, t) {
      if (Jo.call(to, t) && to[t])
        return !0;
      if (X1.test(t)) {
        if (e = "aria-" + t.slice(4).toLowerCase(), e = Ap.hasOwnProperty(e) ? e : null, e == null)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            t
          ), to[t] = !0;
        if (t !== e)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            t,
            e
          ), to[t] = !0;
      }
      if (Jp.test(t)) {
        if (e = t.toLowerCase(), e = Ap.hasOwnProperty(e) ? e : null, e == null) return to[t] = !0, !1;
        t !== e && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          t,
          e
        ), to[t] = !0);
      }
      return !0;
    }
    function tc(e, t) {
      var i = [], o;
      for (o in t)
        ec(e, o) || i.push(o);
      t = i.map(function(c) {
        return "`" + c + "`";
      }).join(", "), i.length === 1 ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      ) : 1 < i.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        t,
        e
      );
    }
    function If(e, t, i, o) {
      if (Jo.call(Wi, t) && Wi[t])
        return !0;
      var c = t.toLowerCase();
      if (c === "onfocusin" || c === "onfocusout")
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), Wi[t] = !0;
      if (typeof i == "function" && (e === "form" && t === "action" || e === "input" && t === "formAction" || e === "button" && t === "formAction"))
        return !0;
      if (o != null) {
        if (e = o.possibleRegistrationNames, o.registrationNameDependencies.hasOwnProperty(t))
          return !0;
        if (o = e.hasOwnProperty(c) ? e[c] : null, o != null)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            t,
            o
          ), Wi[t] = !0;
        if (M0.test(t))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            t
          ), Wi[t] = !0;
      } else if (M0.test(t))
        return n.test(t) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          t
        ), Wi[t] = !0;
      if (a.test(t) || r.test(t)) return !0;
      if (c === "innerhtml")
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), Wi[t] = !0;
      if (c === "aria")
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), Wi[t] = !0;
      if (c === "is" && i !== null && i !== void 0 && typeof i != "string")
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof i
        ), Wi[t] = !0;
      if (typeof i == "number" && isNaN(i))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          t
        ), Wi[t] = !0;
      if (Zl.hasOwnProperty(c)) {
        if (c = Zl[c], c !== t)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            t,
            c
          ), Wi[t] = !0;
      } else if (t !== c)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          t,
          c
        ), Wi[t] = !0;
      switch (t) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return !0;
        case "innerText":
        case "textContent":
          return !0;
      }
      switch (typeof i) {
        case "boolean":
          switch (t) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return !0;
            default:
              return c = t.toLowerCase().slice(0, 5), c === "data-" || c === "aria-" ? !0 : (i ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                i,
                t,
                t,
                i,
                t
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                i,
                t,
                t,
                i,
                t,
                t,
                t
              ), Wi[t] = !0);
          }
        case "function":
        case "symbol":
          return Wi[t] = !0, !1;
        case "string":
          if (i === "false" || i === "true") {
            switch (t) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return !0;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              i,
              t,
              i === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              t,
              i
            ), Wi[t] = !0;
          }
      }
      return !0;
    }
    function Jh(e, t, i) {
      var o = [], c;
      for (c in t)
        If(e, c, t[c], i) || o.push(c);
      t = o.map(function(h) {
        return "`" + h + "`";
      }).join(", "), o.length === 1 ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      ) : 1 < o.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        t,
        e
      );
    }
    function nc(e) {
      return s.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
    }
    function Xs(e) {
      return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
    }
    function br(e) {
      var t = In(e);
      if (t && (e = t.stateNode)) {
        var i = e[oa] || null;
        e: switch (e = t.stateNode, t.type) {
          case "input":
            if (Gi(
              e,
              i.value,
              i.defaultValue,
              i.defaultValue,
              i.checked,
              i.defaultChecked,
              i.type,
              i.name
            ), t = i.name, i.type === "radio" && t != null) {
              for (i = e; i.parentNode; ) i = i.parentNode;
              for (L(t, "name"), i = i.querySelectorAll(
                'input[name="' + dt(
                  "" + t
                ) + '"][type="radio"]'
              ), t = 0; t < i.length; t++) {
                var o = i[t];
                if (o !== e && o.form === e.form) {
                  var c = o[oa] || null;
                  if (!c)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  Gi(
                    o,
                    c.value,
                    c.defaultValue,
                    c.defaultValue,
                    c.checked,
                    c.defaultChecked,
                    c.type,
                    c.name
                  );
                }
              }
              for (t = 0; t < i.length; t++)
                o = i[t], o.form === e.form && Ke(o);
            }
            break e;
          case "textarea":
            lu(e, i.value, i.defaultValue);
            break e;
          case "select":
            t = i.value, t != null && Ro(e, !!i.multiple, t, !1);
        }
      }
    }
    function mu(e, t, i) {
      if (_) return e(t, i);
      _ = !0;
      try {
        var o = e(t);
        return o;
      } finally {
        if (_ = !1, (f !== null || E !== null) && (Ul(), f && (t = f, e = E, E = f = null, br(t), e)))
          for (t = 0; t < e.length; t++) br(e[t]);
      }
    }
    function Eo(e, t) {
      var i = e.stateNode;
      if (i === null) return null;
      var o = i[oa] || null;
      if (o === null) return null;
      i = o[t];
      e: switch (t) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (o = !o.disabled) || (e = e.type, o = !(e === "button" || e === "input" || e === "select" || e === "textarea")), e = !o;
          break e;
        default:
          e = !1;
      }
      if (e) return null;
      if (i && typeof i != "function")
        throw Error(
          "Expected `" + t + "` listener to be a function, instead got a value of `" + typeof i + "` type."
        );
      return i;
    }
    function Uo() {
      if (te) return te;
      var e, t = $, i = t.length, o, c = "value" in ve ? ve.value : ve.textContent, h = c.length;
      for (e = 0; e < i && t[e] === c[e]; e++) ;
      var v = i - e;
      for (o = 1; o <= v && t[i - o] === c[h - o]; o++) ;
      return te = c.slice(e, 1 < o ? 1 - o : void 0);
    }
    function ic(e) {
      var t = e.keyCode;
      return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
    }
    function Ks() {
      return !0;
    }
    function Lh() {
      return !1;
    }
    function mi(e) {
      function t(i, o, c, h, v) {
        this._reactName = i, this._targetInst = c, this.type = o, this.nativeEvent = h, this.target = v, this.currentTarget = null;
        for (var S in e)
          e.hasOwnProperty(S) && (i = e[S], this[S] = i ? i(h) : h[S]);
        return this.isDefaultPrevented = (h.defaultPrevented != null ? h.defaultPrevented : h.returnValue === !1) ? Ks : Lh, this.isPropagationStopped = Lh, this;
      }
      return bt(t.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var i = this.nativeEvent;
          i && (i.preventDefault ? i.preventDefault() : typeof i.returnValue != "unknown" && (i.returnValue = !1), this.isDefaultPrevented = Ks);
        },
        stopPropagation: function() {
          var i = this.nativeEvent;
          i && (i.stopPropagation ? i.stopPropagation() : typeof i.cancelBubble != "unknown" && (i.cancelBubble = !0), this.isPropagationStopped = Ks);
        },
        persist: function() {
        },
        isPersistent: Ks
      }), t;
    }
    function pu(e) {
      var t = this.nativeEvent;
      return t.getModifierState ? t.getModifierState(e) : (e = dE[e]) ? !!t[e] : !1;
    }
    function fu() {
      return pu;
    }
    function Ai(e, t) {
      switch (e) {
        case "keyup":
          return TE.indexOf(t.keyCode) !== -1;
        case "keydown":
          return t.keyCode !== hR;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function ns(e) {
      return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
    }
    function gu(e, t) {
      switch (e) {
        case "compositionend":
          return ns(t);
        case "keypress":
          return t.which !== pR ? null : (gR = !0, fR);
        case "textInput":
          return e = t.data, e === fR && gR ? null : e;
        default:
          return null;
      }
    }
    function Ed(e, t) {
      if (K1)
        return e === "compositionend" || !Ev && Ai(e, t) ? (e = Uo(), te = $ = ve = null, K1 = !1, e) : null;
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
            if (t.char && 1 < t.char.length)
              return t.char;
            if (t.which)
              return String.fromCharCode(t.which);
          }
          return null;
        case "compositionend":
          return mR && t.locale !== "ko" ? null : t.data;
        default:
          return null;
      }
    }
    function Wf(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t === "input" ? !!NE[e.type] : t === "textarea";
    }
    function Ih(e) {
      if (!O) return !1;
      e = "on" + e;
      var t = e in document;
      return t || (t = document.createElement("div"), t.setAttribute(e, "return;"), t = typeof t[e] == "function"), t;
    }
    function vu(e, t, i, o) {
      f ? E ? E.push(o) : E = [o] : f = o, t = s0(t, "onChange"), 0 < t.length && (i = new at(
        "onChange",
        "change",
        null,
        i,
        o
      ), e.push({ event: i, listeners: t }));
    }
    function Ud(e) {
      jr(e, 0);
    }
    function qs(e) {
      var t = Oi(e);
      if (Ke(t)) return e;
    }
    function Wh(e, t) {
      if (e === "change") return t;
    }
    function Hf() {
      Wp && (Wp.detachEvent("onpropertychange", zf), Hp = Wp = null);
    }
    function zf(e) {
      if (e.propertyName === "value" && qs(Hp)) {
        var t = [];
        vu(
          t,
          Hp,
          e,
          Xs(e)
        ), mu(Ud, t);
      }
    }
    function nv(e, t, i) {
      e === "focusin" ? (Hf(), Wp = t, Hp = i, Wp.attachEvent("onpropertychange", zf)) : e === "focusout" && Hf();
    }
    function Hh(e) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return qs(Hp);
    }
    function iv(e, t) {
      if (e === "click") return qs(t);
    }
    function av(e, t) {
      if (e === "input" || e === "change")
        return qs(t);
    }
    function rv(e, t) {
      return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
    }
    function Td(e, t) {
      if (Ta(e, t)) return !0;
      if (typeof e != "object" || e === null || typeof t != "object" || t === null)
        return !1;
      var i = Object.keys(e), o = Object.keys(t);
      if (i.length !== o.length) return !1;
      for (o = 0; o < i.length; o++) {
        var c = i[o];
        if (!Jo.call(t, c) || !Ta(e[c], t[c]))
          return !1;
      }
      return !0;
    }
    function jf(e) {
      for (; e && e.firstChild; ) e = e.firstChild;
      return e;
    }
    function zh(e, t) {
      var i = jf(e);
      e = 0;
      for (var o; i; ) {
        if (i.nodeType === 3) {
          if (o = e + i.textContent.length, e <= t && o >= t)
            return { node: i, offset: t - e };
          e = o;
        }
        e: {
          for (; i; ) {
            if (i.nextSibling) {
              i = i.nextSibling;
              break e;
            }
            i = i.parentNode;
          }
          i = void 0;
        }
        i = jf(i);
      }
    }
    function Gf(e, t) {
      return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? Gf(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
    }
    function Pf(e) {
      e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
      for (var t = qe(e.document); t instanceof e.HTMLIFrameElement; ) {
        try {
          var i = typeof t.contentWindow.location.href == "string";
        } catch {
          i = !1;
        }
        if (i) e = t.contentWindow;
        else break;
        t = qe(e.document);
      }
      return t;
    }
    function jh(e) {
      var t = e && e.nodeName && e.nodeName.toLowerCase();
      return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
    }
    function Yf(e, t, i) {
      var o = i.window === i ? i.document : i.nodeType === 9 ? i : i.ownerDocument;
      Tv || q1 == null || q1 !== qe(o) || (o = q1, "selectionStart" in o && jh(o) ? o = { start: o.selectionStart, end: o.selectionEnd } : (o = (o.ownerDocument && o.ownerDocument.defaultView || window).getSelection(), o = {
        anchorNode: o.anchorNode,
        anchorOffset: o.anchorOffset,
        focusNode: o.focusNode,
        focusOffset: o.focusOffset
      }), zp && Td(zp, o) || (zp = o, o = s0(Uv, "onSelect"), 0 < o.length && (t = new at(
        "onSelect",
        "select",
        null,
        t,
        i
      ), e.push({ event: t, listeners: o }), t.target = q1)));
    }
    function To(e, t) {
      var i = {};
      return i[e.toLowerCase()] = t.toLowerCase(), i["Webkit" + e] = "webkit" + t, i["Moz" + e] = "moz" + t, i;
    }
    function $s(e) {
      if (yv[e]) return yv[e];
      if (!$1[e]) return e;
      var t = $1[e], i;
      for (i in t)
        if (t.hasOwnProperty(i) && i in SR)
          return yv[e] = t[i];
      return e;
    }
    function tr(e, t) {
      yR.set(e, t), ke(t, [e]);
    }
    function ma(e, t) {
      if (typeof e == "object" && e !== null) {
        var i = bv.get(e);
        return i !== void 0 ? i : (t = {
          value: e,
          source: t,
          stack: Ur(t)
        }, bv.set(e, t), t);
      }
      return {
        value: e,
        source: t,
        stack: Ur(t)
      };
    }
    function yd() {
      for (var e = eh, t = Vv = eh = 0; t < e; ) {
        var i = no[t];
        no[t++] = null;
        var o = no[t];
        no[t++] = null;
        var c = no[t];
        no[t++] = null;
        var h = no[t];
        if (no[t++] = null, o !== null && c !== null) {
          var v = o.pending;
          v === null ? c.next = c : (c.next = v.next, v.next = c), o.pending = c;
        }
        h !== 0 && Xf(i, c, h);
      }
    }
    function Su(e, t, i, o) {
      no[eh++] = e, no[eh++] = t, no[eh++] = i, no[eh++] = o, Vv |= o, e.lanes |= o, e = e.alternate, e !== null && (e.lanes |= o);
    }
    function Gh(e, t, i, o) {
      return Su(e, t, i, o), Ru(e);
    }
    function Pi(e, t) {
      return Su(e, null, null, t), Ru(e);
    }
    function Xf(e, t, i) {
      e.lanes |= i;
      var o = e.alternate;
      o !== null && (o.lanes |= i);
      for (var c = !1, h = e.return; h !== null; )
        h.childLanes |= i, o = h.alternate, o !== null && (o.childLanes |= i), h.tag === 22 && (e = h.stateNode, e === null || e._visibility & H2 || (c = !0)), e = h, h = h.return;
      return e.tag === 3 ? (h = e.stateNode, c && t !== null && (c = 31 - Mi(i), e = h.hiddenUpdates, o = e[c], o === null ? e[c] = [t] : o.push(t), t.lane = i | 536870912), h) : null;
    }
    function Ru(e) {
      if (pf > GE)
        throw W0 = pf = 0, ff = nS = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      W0 > PE && (W0 = 0, ff = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      )), e.alternate === null && (e.flags & 4098) !== 0 && mr(e);
      for (var t = e, i = t.return; i !== null; )
        t.alternate === null && (t.flags & 4098) !== 0 && mr(e), t = i, i = t.return;
      return t.tag === 3 ? t.stateNode : null;
    }
    function el(e) {
      if (io === null) return e;
      var t = io(e);
      return t === void 0 ? e : t.current;
    }
    function Ph(e) {
      if (io === null) return e;
      var t = io(e);
      return t === void 0 ? e != null && typeof e.render == "function" && (t = el(e.render), e.render !== t) ? (t = { $$typeof: wo, render: t }, e.displayName !== void 0 && (t.displayName = e.displayName), t) : e : t.current;
    }
    function Kf(e, t) {
      if (io === null) return !1;
      var i = e.elementType;
      t = t.type;
      var o = !1, c = typeof t == "object" && t !== null ? t.$$typeof : null;
      switch (e.tag) {
        case 1:
          typeof t == "function" && (o = !0);
          break;
        case 0:
          (typeof t == "function" || c === Ea) && (o = !0);
          break;
        case 11:
          (c === wo || c === Ea) && (o = !0);
          break;
        case 14:
        case 15:
          (c === S0 || c === Ea) && (o = !0);
          break;
        default:
          return !1;
      }
      return !!(o && (e = io(i), e !== void 0 && e === io(t)));
    }
    function qf(e) {
      io !== null && typeof WeakSet == "function" && (th === null && (th = /* @__PURE__ */ new WeakSet()), th.add(e));
    }
    function Nd(e, t, i) {
      var o = e.alternate, c = e.child, h = e.sibling, v = e.tag, S = e.type, M = null;
      switch (v) {
        case 0:
        case 15:
        case 1:
          M = S;
          break;
        case 11:
          M = S.render;
      }
      if (io === null)
        throw Error("Expected resolveFamily to be set during hot reload.");
      var x = !1;
      S = !1, M !== null && (M = io(M), M !== void 0 && (i.has(M) ? S = !0 : t.has(M) && (v === 1 ? S = !0 : x = !0))), th !== null && (th.has(e) || o !== null && th.has(o)) && (S = !0), S && (e._debugNeedsRemount = !0), (S || x) && (o = Pi(e, 2), o !== null && Qn(o, e, 2)), c === null || S || Nd(
        c,
        t,
        i
      ), h !== null && Nd(
        h,
        t,
        i
      );
    }
    function bd(e, t, i, o) {
      this.tag = e, this.key = i, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = o, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null, this.actualDuration = -0, this.actualStartTime = -1.1, this.treeBaseDuration = this.selfBaseDuration = -0, this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, bR || typeof Object.preventExtensions != "function" || Object.preventExtensions(this);
    }
    function Yh(e) {
      return e = e.prototype, !(!e || !e.isReactComponent);
    }
    function Vr(e, t) {
      var i = e.alternate;
      switch (i === null ? (i = b(
        e.tag,
        t,
        e.key,
        e.mode
      ), i.elementType = e.elementType, i.type = e.type, i.stateNode = e.stateNode, i._debugOwner = e._debugOwner, i._debugStack = e._debugStack, i._debugTask = e._debugTask, i._debugHookTypes = e._debugHookTypes, i.alternate = e, e.alternate = i) : (i.pendingProps = t, i.type = e.type, i.flags = 0, i.subtreeFlags = 0, i.deletions = null, i.actualDuration = -0, i.actualStartTime = -1.1), i.flags = e.flags & 65011712, i.childLanes = e.childLanes, i.lanes = e.lanes, i.child = e.child, i.memoizedProps = e.memoizedProps, i.memoizedState = e.memoizedState, i.updateQueue = e.updateQueue, t = e.dependencies, i.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, i.sibling = e.sibling, i.index = e.index, i.ref = e.ref, i.refCleanup = e.refCleanup, i.selfBaseDuration = e.selfBaseDuration, i.treeBaseDuration = e.treeBaseDuration, i._debugInfo = e._debugInfo, i._debugNeedsRemount = e._debugNeedsRemount, i.tag) {
        case 0:
        case 15:
          i.type = el(e.type);
          break;
        case 1:
          i.type = el(e.type);
          break;
        case 11:
          i.type = Ph(e.type);
      }
      return i;
    }
    function Xh(e, t) {
      e.flags &= 65011714;
      var i = e.alternate;
      return i === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0) : (e.childLanes = i.childLanes, e.lanes = i.lanes, e.child = i.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = i.memoizedProps, e.memoizedState = i.memoizedState, e.updateQueue = i.updateQueue, e.type = i.type, t = i.dependencies, e.dependencies = t === null ? null : {
        lanes: t.lanes,
        firstContext: t.firstContext,
        _debugThenableState: t._debugThenableState
      }, e.selfBaseDuration = i.selfBaseDuration, e.treeBaseDuration = i.treeBaseDuration), e;
    }
    function Eu(e, t, i, o, c, h) {
      var v = 0, S = e;
      if (typeof e == "function")
        Yh(e) && (v = 1), S = el(S);
      else if (typeof e == "string")
        v = Z(), v = Oc(e, i, v) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
      else
        e: switch (e) {
          case yp:
            return t = b(31, i, t, c), t.elementType = yp, t.lanes = h, t;
          case Ut:
            return is(
              i.children,
              c,
              h,
              t
            );
          case wc:
            v = 8, c |= la, c |= zo;
            break;
          case Ac:
            return e = i, o = c, typeof e.id != "string" && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof e.id
            ), t = b(12, e, t, o | Hi), t.elementType = Ac, t.lanes = h, t.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, t;
          case Jc:
            return t = b(13, i, t, c), t.elementType = Jc, t.lanes = h, t;
          case _s:
            return t = b(19, i, t, c), t.elementType = _s, t.lanes = h, t;
          default:
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case Tp:
                case Pa:
                  v = 10;
                  break e;
                case Z1:
                  v = 9;
                  break e;
                case wo:
                  v = 11, S = Ph(S);
                  break e;
                case S0:
                  v = 14;
                  break e;
                case Ea:
                  v = 16, S = null;
                  break e;
              }
            S = "", (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (S += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), e === null ? i = "null" : vt(e) ? i = "array" : e !== void 0 && e.$$typeof === Fs ? (i = "<" + (Re(e.type) || "Unknown") + " />", S = " Did you accidentally export a JSX literal instead of a component?") : i = typeof e, (v = o ? Ue(o) : null) && (S += `

Check the render method of \`` + v + "`."), v = 29, i = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (i + "." + S)
            ), S = null;
        }
      return t = b(v, i, t, c), t.elementType = e, t.type = S, t.lanes = h, t._debugOwner = o, t;
    }
    function Vd(e, t, i) {
      return t = Eu(
        e.type,
        e.key,
        e.props,
        e._owner,
        t,
        i
      ), t._debugOwner = e._owner, t._debugStack = e._debugStack, t._debugTask = e._debugTask, t;
    }
    function is(e, t, i, o) {
      return e = b(7, e, o, t), e.lanes = i, e;
    }
    function as(e, t, i) {
      return e = b(6, e, null, t), e.lanes = i, e;
    }
    function Kh(e, t, i) {
      return t = b(
        4,
        e.children !== null ? e.children : [],
        e.key,
        t
      ), t.lanes = i, t.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        implementation: e.implementation
      }, t;
    }
    function tl(e, t) {
      nr(), nh[ih++] = j2, nh[ih++] = z2, z2 = e, j2 = t;
    }
    function $f(e, t, i) {
      nr(), ao[ro++] = Bl, ao[ro++] = wl, ao[ro++] = k0, k0 = e;
      var o = Bl;
      e = wl;
      var c = 32 - Mi(o) - 1;
      o &= ~(1 << c), i += 1;
      var h = 32 - Mi(t) + c;
      if (30 < h) {
        var v = c - c % 5;
        h = (o & (1 << v) - 1).toString(32), o >>= v, c -= v, Bl = 1 << 32 - Mi(t) + c | i << c | o, wl = h + e;
      } else
        Bl = 1 << h | i << c | o, wl = e;
    }
    function Uu(e) {
      nr(), e.return !== null && (tl(e, 1), $f(e, 1, 0));
    }
    function Tu(e) {
      for (; e === z2; )
        z2 = nh[--ih], nh[ih] = null, j2 = nh[--ih], nh[ih] = null;
      for (; e === k0; )
        k0 = ao[--ro], ao[ro] = null, wl = ao[--ro], ao[ro] = null, Bl = ao[--ro], ao[ro] = null;
    }
    function nr() {
      Pt || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function ir(e, t) {
      if (e.return === null) {
        if (oo === null)
          oo = {
            fiber: e,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf: t
          };
        else {
          if (oo.fiber !== e)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          oo.distanceFromLeaf > t && (oo.distanceFromLeaf = t);
        }
        return oo;
      }
      var i = ir(
        e.return,
        t + 1
      ).children;
      return 0 < i.length && i[i.length - 1].fiber === e ? (i = i[i.length - 1], i.distanceFromLeaf > t && (i.distanceFromLeaf = t), i) : (t = {
        fiber: e,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf: t
      }, i.push(t), t);
    }
    function qh(e, t) {
      Al || (e = ir(e, 0), e.serverProps = null, t !== null && (t = b1(t), e.serverTail.push(t)));
    }
    function Cr(e) {
      var t = "", i = oo;
      throw i !== null && (oo = null, t = vd(i)), ac(
        ma(
          Error(
            `Hydration failed because the server rendered HTML didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

https://react.dev/link/hydration-mismatch` + t
          ),
          e
        )
      ), Cv;
    }
    function $h(e) {
      var t = e.stateNode, i = e.type, o = e.memoizedProps;
      switch (t[ki] = e, t[oa] = o, Gr(i, o), i) {
        case "dialog":
          Dt("cancel", t), Dt("close", t);
          break;
        case "iframe":
        case "object":
        case "embed":
          Dt("load", t);
          break;
        case "video":
        case "audio":
          for (i = 0; i < gf.length; i++)
            Dt(gf[i], t);
          break;
        case "source":
          Dt("error", t);
          break;
        case "img":
        case "image":
        case "link":
          Dt("error", t), Dt("load", t);
          break;
        case "details":
          Dt("toggle", t);
          break;
        case "input":
          Je("input", o), Dt("invalid", t), qt(t, o), wf(
            t,
            o.value,
            o.defaultValue,
            o.checked,
            o.defaultChecked,
            o.type,
            o.name,
            !0
          ), ot(t);
          break;
        case "option":
          xh(t, o);
          break;
        case "select":
          Je("select", o), Dt("invalid", t), fd(t, o);
          break;
        case "textarea":
          Je("textarea", o), Dt("invalid", t), Nr(t, o), Zh(
            t,
            o.value,
            o.defaultValue,
            o.children
          ), ot(t);
      }
      i = o.children, typeof i != "string" && typeof i != "number" && typeof i != "bigint" || t.textContent === "" + i || o.suppressHydrationWarning === !0 || tp(t.textContent, i) ? (o.popover != null && (Dt("beforetoggle", t), Dt("toggle", t)), o.onScroll != null && Dt("scroll", t), o.onScrollEnd != null && Dt("scrollend", t), o.onClick != null && (t.onclick = xo), t = !0) : t = !1, t || Cr(e);
    }
    function em(e) {
      for (ya = e.return; ya; )
        switch (ya.tag) {
          case 5:
          case 13:
            Bs = !1;
            return;
          case 27:
          case 3:
            Bs = !0;
            return;
          default:
            ya = ya.return;
        }
    }
    function nl(e) {
      if (e !== ya) return !1;
      if (!Pt)
        return em(e), Pt = !0, !1;
      var t = e.tag, i;
      if ((i = t !== 3 && t !== 27) && ((i = t === 5) && (i = e.type, i = !(i !== "form" && i !== "button") || Pr(e.type, e.memoizedProps)), i = !i), i && Gn) {
        for (i = Gn; i; ) {
          var o = ir(e, 0), c = b1(i);
          o.serverTail.push(c), i = c.type === "Suspense" ? cp(i) : Si(i.nextSibling);
        }
        Cr(e);
      }
      if (em(e), t === 13) {
        if (e = e.memoizedState, e = e !== null ? e.dehydrated : null, !e)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        Gn = cp(e);
      } else
        t === 27 ? (t = Gn, Yr(e.type) ? (e = pS, pS = null, Gn = e) : Gn = t) : Gn = ya ? Si(e.stateNode.nextSibling) : null;
      return !0;
    }
    function il() {
      Gn = ya = null, Al = Pt = !1;
    }
    function tm() {
      var e = Q0;
      return e !== null && (Va === null ? Va = e : Va.push.apply(
        Va,
        e
      ), Q0 = null), e;
    }
    function ac(e) {
      Q0 === null ? Q0 = [e] : Q0.push(e);
    }
    function nm() {
      var e = oo;
      if (e !== null) {
        oo = null;
        for (var t = vd(e); 0 < e.children.length; )
          e = e.children[0];
        He(e.fiber, function() {
          console.error(
            `A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:

- A server/client branch \`if (typeof window !== 'undefined')\`.
- Variable input such as \`Date.now()\` or \`Math.random()\` which changes each time it's called.
- Date formatting in a user's locale which doesn't match the server.
- External changing data without sending a snapshot of it along with the HTML.
- Invalid HTML tag nesting.

It can also happen if the client has a browser extension installed which messes with the HTML before React loaded.

%s%s`,
            "https://react.dev/link/hydration-mismatch",
            t
          );
        });
      }
    }
    function yu() {
      ah = G2 = null, rh = !1;
    }
    function rs(e, t, i) {
      fe(Fv, t._currentValue, e), t._currentValue = i, fe(_v, t._currentRenderer, e), t._currentRenderer !== void 0 && t._currentRenderer !== null && t._currentRenderer !== _R && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      ), t._currentRenderer = _R;
    }
    function yo(e, t) {
      e._currentValue = Fv.current;
      var i = _v.current;
      Qe(_v, t), e._currentRenderer = i, Qe(Fv, t);
    }
    function im(e, t, i) {
      for (; e !== null; ) {
        var o = e.alternate;
        if ((e.childLanes & t) !== t ? (e.childLanes |= t, o !== null && (o.childLanes |= t)) : o !== null && (o.childLanes & t) !== t && (o.childLanes |= t), e === i) break;
        e = e.return;
      }
      e !== i && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function am(e, t, i, o) {
      var c = e.child;
      for (c !== null && (c.return = e); c !== null; ) {
        var h = c.dependencies;
        if (h !== null) {
          var v = c.child;
          h = h.firstContext;
          e: for (; h !== null; ) {
            var S = h;
            h = c;
            for (var M = 0; M < t.length; M++)
              if (S.context === t[M]) {
                h.lanes |= i, S = h.alternate, S !== null && (S.lanes |= i), im(
                  h.return,
                  i,
                  e
                ), o || (v = null);
                break e;
              }
            h = S.next;
          }
        } else if (c.tag === 18) {
          if (v = c.return, v === null)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          v.lanes |= i, h = v.alternate, h !== null && (h.lanes |= i), im(
            v,
            i,
            e
          ), v = null;
        } else v = c.child;
        if (v !== null) v.return = c;
        else
          for (v = c; v !== null; ) {
            if (v === e) {
              v = null;
              break;
            }
            if (c = v.sibling, c !== null) {
              c.return = v.return, v = c;
              break;
            }
            v = v.return;
          }
        c = v;
      }
    }
    function pi(e, t, i, o) {
      e = null;
      for (var c = t, h = !1; c !== null; ) {
        if (!h) {
          if ((c.flags & 524288) !== 0) h = !0;
          else if ((c.flags & 262144) !== 0) break;
        }
        if (c.tag === 10) {
          var v = c.alternate;
          if (v === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          if (v = v.memoizedProps, v !== null) {
            var S = c.type;
            Ta(c.pendingProps.value, v.value) || (e !== null ? e.push(S) : e = [S]);
          }
        } else if (c === Ic.current) {
          if (v = c.alternate, v === null)
            throw Error("Should have a current fiber. This is a bug in React.");
          v.memoizedState.memoizedState !== c.memoizedState.memoizedState && (e !== null ? e.push(Ef) : e = [Ef]);
        }
        c = c.return;
      }
      e !== null && am(
        t,
        e,
        i,
        o
      ), t.flags |= 262144;
    }
    function os(e) {
      for (e = e.firstContext; e !== null; ) {
        if (!Ta(
          e.context._currentValue,
          e.memoizedValue
        ))
          return !0;
        e = e.next;
      }
      return !1;
    }
    function ss(e) {
      G2 = e, ah = null, e = e.dependencies, e !== null && (e.firstContext = null);
    }
    function mn(e) {
      return rh && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      ), rm(G2, e);
    }
    function Cd(e, t) {
      return G2 === null && ss(e), rm(e, t);
    }
    function rm(e, t) {
      var i = t._currentValue;
      if (t = { context: t, memoizedValue: i, next: null }, ah === null) {
        if (e === null)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        ah = t, e.dependencies = {
          lanes: 0,
          firstContext: t,
          _debugThenableState: null
        }, e.flags |= 524288;
      } else ah = ah.next = t;
      return i;
    }
    function Fd() {
      return {
        controller: new QE(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function al(e) {
      e.controller.signal.aborted, e.refCount++;
    }
    function Fr(e) {
      e.refCount--, 0 > e.refCount, e.refCount === 0 && DE(xE, function() {
        e.controller.abort();
      });
    }
    function ar() {
      var e = D0;
      return D0 = 0, e;
    }
    function ls(e) {
      var t = D0;
      return D0 = e, t;
    }
    function rl(e) {
      var t = D0;
      return D0 += e, t;
    }
    function Nu(e) {
      Ka = oh(), 0 > e.actualStartTime && (e.actualStartTime = Ka);
    }
    function No(e) {
      if (0 <= Ka) {
        var t = oh() - Ka;
        e.actualDuration += t, e.selfBaseDuration = t, Ka = -1;
      }
    }
    function ol(e) {
      if (0 <= Ka) {
        var t = oh() - Ka;
        e.actualDuration += t, Ka = -1;
      }
    }
    function Oa() {
      if (0 <= Ka) {
        var e = oh() - Ka;
        Ka = -1, D0 += e;
      }
    }
    function rr() {
      Ka = oh();
    }
    function _r(e) {
      for (var t = e.child; t; )
        e.actualDuration += t.actualDuration, t = t.sibling;
    }
    function e2(e, t) {
      if (jp === null) {
        var i = jp = [];
        Mv = 0, x0 = Xm(), sh = {
          status: "pending",
          value: void 0,
          then: function(o) {
            i.push(o);
          }
        };
      }
      return Mv++, t.then(om, om), t;
    }
    function om() {
      if (--Mv === 0 && jp !== null) {
        sh !== null && (sh.status = "fulfilled");
        var e = jp;
        jp = null, x0 = 0, sh = null;
        for (var t = 0; t < e.length; t++) (0, e[t])();
      }
    }
    function t2(e, t) {
      var i = [], o = {
        status: "pending",
        value: null,
        reason: null,
        then: function(c) {
          i.push(c);
        }
      };
      return e.then(
        function() {
          o.status = "fulfilled", o.value = t;
          for (var c = 0; c < i.length; c++) (0, i[c])(t);
        },
        function(c) {
          for (o.status = "rejected", o.reason = c, c = 0; c < i.length; c++)
            (0, i[c])(void 0);
        }
      ), o;
    }
    function sm() {
      var e = Z0.current;
      return e !== null ? e : pn.pooledCache;
    }
    function bu(e, t) {
      t === null ? fe(Z0, Z0.current, e) : fe(Z0, t.pool, e);
    }
    function n2() {
      var e = sm();
      return e === null ? null : { parent: Ui._currentValue, pool: e };
    }
    function lm() {
      return { didWarnAboutUncachedPromise: !1, thenables: [] };
    }
    function cm(e) {
      return e = e.status, e === "fulfilled" || e === "rejected";
    }
    function rc() {
    }
    function Ba(e, t, i) {
      oe.actQueue !== null && (oe.didUsePromise = !0);
      var o = e.thenables;
      switch (i = o[i], i === void 0 ? o.push(t) : i !== t && (e.didWarnAboutUncachedPromise || (e.didWarnAboutUncachedPromise = !0, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), t.then(rc, rc), t = i), t.status) {
        case "fulfilled":
          return t.value;
        case "rejected":
          throw e = t.reason, pa(e), e;
        default:
          if (typeof t.status == "string")
            t.then(rc, rc);
          else {
            if (e = pn, e !== null && 100 < e.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            e = t, e.status = "pending", e.then(
              function(c) {
                if (t.status === "pending") {
                  var h = t;
                  h.status = "fulfilled", h.value = c;
                }
              },
              function(c) {
                if (t.status === "pending") {
                  var h = t;
                  h.status = "rejected", h.reason = c;
                }
              }
            );
          }
          switch (t.status) {
            case "fulfilled":
              return t.value;
            case "rejected":
              throw e = t.reason, pa(e), e;
          }
          throw ef = t, $2 = !0, $p;
      }
    }
    function dm() {
      if (ef === null)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var e = ef;
      return ef = null, $2 = !1, e;
    }
    function pa(e) {
      if (e === $p || e === q2)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function Yi(e) {
      e.updateQueue = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function cs(e, t) {
      e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
        baseState: e.baseState,
        firstBaseUpdate: e.firstBaseUpdate,
        lastBaseUpdate: e.lastBaseUpdate,
        shared: e.shared,
        callbacks: null
      });
    }
    function Mr(e) {
      return {
        lane: e,
        tag: xR,
        payload: null,
        callback: null,
        next: null
      };
    }
    function or(e, t, i) {
      var o = e.updateQueue;
      if (o === null) return null;
      if (o = o.shared, Dv === o && !BR) {
        var c = Se(e);
        console.error(
          `An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.

Please update the following component: %s`,
          c
        ), BR = !0;
      }
      return (an & ba) !== gr ? (c = o.pending, c === null ? t.next = t : (t.next = c.next, c.next = t), o.pending = t, t = Ru(e), Xf(e, null, i), t) : (Su(e, o, t, i), Ru(e));
    }
    function ds(e, t, i) {
      if (t = t.updateQueue, t !== null && (t = t.shared, (i & 4194048) !== 0)) {
        var o = t.lanes;
        o &= e.pendingLanes, i |= o, t.lanes = i, ni(e, i);
      }
    }
    function oc(e, t) {
      var i = e.updateQueue, o = e.alternate;
      if (o !== null && (o = o.updateQueue, i === o)) {
        var c = null, h = null;
        if (i = i.firstBaseUpdate, i !== null) {
          do {
            var v = {
              lane: i.lane,
              tag: i.tag,
              payload: i.payload,
              callback: null,
              next: null
            };
            h === null ? c = h = v : h = h.next = v, i = i.next;
          } while (i !== null);
          h === null ? c = h = t : h = h.next = t;
        } else c = h = t;
        i = {
          baseState: o.baseState,
          firstBaseUpdate: c,
          lastBaseUpdate: h,
          shared: o.shared,
          callbacks: o.callbacks
        }, e.updateQueue = i;
        return;
      }
      e = i.lastBaseUpdate, e === null ? i.firstBaseUpdate = t : e.next = t, i.lastBaseUpdate = t;
    }
    function kr() {
      if (xv) {
        var e = sh;
        if (e !== null) throw e;
      }
    }
    function sc(e, t, i, o) {
      xv = !1;
      var c = e.updateQueue;
      qc = !1, Dv = c.shared;
      var h = c.firstBaseUpdate, v = c.lastBaseUpdate, S = c.shared.pending;
      if (S !== null) {
        c.shared.pending = null;
        var M = S, x = M.next;
        M.next = null, v === null ? h = x : v.next = x, v = M;
        var ee = e.alternate;
        ee !== null && (ee = ee.updateQueue, S = ee.lastBaseUpdate, S !== v && (S === null ? ee.firstBaseUpdate = x : S.next = x, ee.lastBaseUpdate = M));
      }
      if (h !== null) {
        var le = c.baseState;
        v = 0, ee = x = M = null, S = h;
        do {
          var q = S.lane & -536870913, ce = q !== S.lane;
          if (ce ? (wt & q) === q : (o & q) === q) {
            q !== 0 && q === x0 && (xv = !0), ee !== null && (ee = ee.next = {
              lane: 0,
              tag: S.tag,
              payload: S.payload,
              callback: null,
              next: null
            });
            e: {
              q = e;
              var je = S, ht = t, fn = i;
              switch (je.tag) {
                case ZR:
                  if (je = je.payload, typeof je == "function") {
                    rh = !0;
                    var Jt = je.call(
                      fn,
                      le,
                      ht
                    );
                    if (q.mode & la) {
                      Ze(!0);
                      try {
                        je.call(fn, le, ht);
                      } finally {
                        Ze(!1);
                      }
                    }
                    rh = !1, le = Jt;
                    break e;
                  }
                  le = je;
                  break e;
                case Qv:
                  q.flags = q.flags & -65537 | 128;
                case xR:
                  if (Jt = je.payload, typeof Jt == "function") {
                    if (rh = !0, je = Jt.call(
                      fn,
                      le,
                      ht
                    ), q.mode & la) {
                      Ze(!0);
                      try {
                        Jt.call(fn, le, ht);
                      } finally {
                        Ze(!1);
                      }
                    }
                    rh = !1;
                  } else je = Jt;
                  if (je == null) break e;
                  le = bt({}, le, je);
                  break e;
                case OR:
                  qc = !0;
              }
            }
            q = S.callback, q !== null && (e.flags |= 64, ce && (e.flags |= 8192), ce = c.callbacks, ce === null ? c.callbacks = [q] : ce.push(q));
          } else
            ce = {
              lane: q,
              tag: S.tag,
              payload: S.payload,
              callback: S.callback,
              next: null
            }, ee === null ? (x = ee = ce, M = le) : ee = ee.next = ce, v |= q;
          if (S = S.next, S === null) {
            if (S = c.shared.pending, S === null)
              break;
            ce = S, S = ce.next, ce.next = null, c.lastBaseUpdate = ce, c.shared.pending = null;
          }
        } while (!0);
        ee === null && (M = le), c.baseState = M, c.firstBaseUpdate = x, c.lastBaseUpdate = ee, h === null && (c.shared.lanes = 0), nd |= v, e.lanes = v, e.memoizedState = le;
      }
      Dv = null;
    }
    function _d(e, t) {
      if (typeof e != "function")
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + e
        );
      e.call(t);
    }
    function lc(e, t) {
      var i = e.shared.hiddenCallbacks;
      if (i !== null)
        for (e.shared.hiddenCallbacks = null, e = 0; e < i.length; e++)
          _d(i[e], t);
    }
    function i2(e, t) {
      var i = e.callbacks;
      if (i !== null)
        for (e.callbacks = null, e = 0; e < i.length; e++)
          _d(i[e], t);
    }
    function Xi(e, t) {
      var i = Js;
      fe(eg, i, e), fe(lh, t, e), Js = i | t.baseLanes;
    }
    function Md(e) {
      fe(eg, Js, e), fe(
        lh,
        lh.current,
        e
      );
    }
    function sr(e) {
      Js = eg.current, Qe(lh, e), Qe(eg, e);
    }
    function Ft() {
      var e = se;
      co === null ? co = [e] : co.push(e);
    }
    function Me() {
      var e = se;
      if (co !== null && (Ll++, co[Ll] !== e)) {
        var t = Se(St);
        if (!wR.has(t) && (wR.add(t), co !== null)) {
          for (var i = "", o = 0; o <= Ll; o++) {
            var c = co[o], h = o === Ll ? e : c;
            for (c = o + 1 + ". " + c; 30 > c.length; )
              c += " ";
            c += h + `
`, i += c;
          }
          console.error(
            `React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`,
            t,
            i
          );
        }
      }
    }
    function wa(e) {
      e == null || vt(e) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        se,
        typeof e
      );
    }
    function cc() {
      var e = Se(St);
      JR.has(e) || (JR.add(e), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        e
      ));
    }
    function Vn() {
      throw Error(
        `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
      );
    }
    function us(e, t) {
      if (nf) return !1;
      if (t === null)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          se
        ), !1;
      e.length !== t.length && console.error(
        `The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`,
        se,
        "[" + t.join(", ") + "]",
        "[" + e.join(", ") + "]"
      );
      for (var i = 0; i < t.length && i < e.length; i++)
        if (!Ta(e[i], t[i])) return !1;
      return !0;
    }
    function hs(e, t, i, o, c, h) {
      $c = h, St = t, co = e !== null ? e._debugHookTypes : null, Ll = -1, nf = e !== null && e.type !== t.type, (Object.prototype.toString.call(i) === "[object AsyncFunction]" || Object.prototype.toString.call(i) === "[object AsyncGeneratorFunction]") && (h = Se(St), Zv.has(h) || (Zv.add(h), console.error(
        "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
        h === null ? "An unknown Component" : "<" + h + ">"
      ))), t.memoizedState = null, t.updateQueue = null, t.lanes = 0, oe.H = e !== null && e.memoizedState !== null ? Bv : co !== null ? LR : Ov, B0 = h = (t.mode & la) !== Un;
      var v = wv(i, o, c);
      if (B0 = !1, dh && (v = dc(
        t,
        i,
        o,
        c
      )), h) {
        Ze(!0);
        try {
          v = dc(
            t,
            i,
            o,
            c
          );
        } finally {
          Ze(!1);
        }
      }
      return kd(e, t), v;
    }
    function kd(e, t) {
      t._debugHookTypes = co, t.dependencies === null ? Jl !== null && (t.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: Jl
      }) : t.dependencies._debugThenableState = Jl, oe.H = ig;
      var i = hn !== null && hn.next !== null;
      if ($c = 0, co = se = ci = hn = St = null, Ll = -1, e !== null && (e.flags & 65011712) !== (t.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      ), tg = !1, tf = 0, Jl = null, i)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      e === null || Qi || (e = e.dependencies, e !== null && os(e) && (Qi = !0)), $2 ? ($2 = !1, e = !0) : e = !1, e && (t = Se(t) || "Unknown", AR.has(t) || Zv.has(t) || (AR.add(t), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function dc(e, t, i, o) {
      St = e;
      var c = 0;
      do {
        if (dh && (Jl = null), tf = 0, dh = !1, c >= OE)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        if (c += 1, nf = !1, ci = hn = null, e.updateQueue != null) {
          var h = e.updateQueue;
          h.lastEffect = null, h.events = null, h.stores = null, h.memoCache != null && (h.memoCache.index = 0);
        }
        Ll = -1, oe.H = IR, h = wv(t, i, o);
      } while (dh);
      return h;
    }
    function Aa() {
      var e = oe.H, t = e.useState()[0];
      return t = typeof t.then == "function" ? sl(t) : t, e = e.useState()[0], (hn !== null ? hn.memoizedState : null) !== e && (St.flags |= 1024), t;
    }
    function Ki() {
      var e = ng !== 0;
      return ng = 0, e;
    }
    function bo(e, t, i) {
      t.updateQueue = e.updateQueue, t.flags = (t.mode & zo) !== Un ? t.flags & -402655237 : t.flags & -2053, e.lanes &= ~i;
    }
    function lr(e) {
      if (tg) {
        for (e = e.memoizedState; e !== null; ) {
          var t = e.queue;
          t !== null && (t.pending = null), e = e.next;
        }
        tg = !1;
      }
      $c = 0, co = ci = hn = St = null, Ll = -1, se = null, dh = !1, tf = ng = 0, Jl = null;
    }
    function Mn() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return ci === null ? St.memoizedState = ci = e : ci = ci.next = e, ci;
    }
    function At() {
      if (hn === null) {
        var e = St.alternate;
        e = e !== null ? e.memoizedState : null;
      } else e = hn.next;
      var t = ci === null ? St.memoizedState : ci.next;
      if (t !== null)
        ci = t, hn = e;
      else {
        if (e === null)
          throw St.alternate === null ? Error(
            "Update hook called on initial render. This is likely a bug in React. Please file an issue."
          ) : Error("Rendered more hooks than during the previous render.");
        hn = e, e = {
          memoizedState: hn.memoizedState,
          baseState: hn.baseState,
          baseQueue: hn.baseQueue,
          queue: hn.queue,
          next: null
        }, ci === null ? St.memoizedState = ci = e : ci = ci.next = e;
      }
      return ci;
    }
    function Vu() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function sl(e) {
      var t = tf;
      return tf += 1, Jl === null && (Jl = lm()), e = Ba(Jl, e, t), t = St, (ci === null ? t.memoizedState : ci.next) === null && (t = t.alternate, oe.H = t !== null && t.memoizedState !== null ? Bv : Ov), e;
    }
    function Qr(e) {
      if (e !== null && typeof e == "object") {
        if (typeof e.then == "function") return sl(e);
        if (e.$$typeof === Pa) return mn(e);
      }
      throw Error("An unsupported type was passed to use(): " + String(e));
    }
    function Wn(e) {
      var t = null, i = St.updateQueue;
      if (i !== null && (t = i.memoCache), t == null) {
        var o = St.alternate;
        o !== null && (o = o.updateQueue, o !== null && (o = o.memoCache, o != null && (t = {
          data: o.data.map(function(c) {
            return c.slice();
          }),
          index: 0
        })));
      }
      if (t == null && (t = { data: [], index: 0 }), i === null && (i = Vu(), St.updateQueue = i), i.memoCache = t, i = t.data[t.index], i === void 0 || nf)
        for (i = t.data[t.index] = Array(e), o = 0; o < e; o++)
          i[o] = Q2;
      else
        i.length !== e && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          i.length,
          e
        );
      return t.index++, i;
    }
    function zt(e, t) {
      return typeof t == "function" ? t(e) : t;
    }
    function Wt(e, t, i) {
      var o = Mn();
      if (i !== void 0) {
        var c = i(t);
        if (B0) {
          Ze(!0);
          try {
            i(t);
          } finally {
            Ze(!1);
          }
        }
      } else c = t;
      return o.memoizedState = o.baseState = c, e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: c
      }, o.queue = e, e = e.dispatch = Rm.bind(
        null,
        St,
        e
      ), [o.memoizedState, e];
    }
    function Ja(e) {
      var t = At();
      return La(t, hn, e);
    }
    function La(e, t, i) {
      var o = e.queue;
      if (o === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      o.lastRenderedReducer = i;
      var c = e.baseQueue, h = o.pending;
      if (h !== null) {
        if (c !== null) {
          var v = c.next;
          c.next = h.next, h.next = v;
        }
        t.baseQueue !== c && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        ), t.baseQueue = c = h, o.pending = null;
      }
      if (h = e.baseState, c === null) e.memoizedState = h;
      else {
        t = c.next;
        var S = v = null, M = null, x = t, ee = !1;
        do {
          var le = x.lane & -536870913;
          if (le !== x.lane ? (wt & le) === le : ($c & le) === le) {
            var q = x.revertLane;
            if (q === 0)
              M !== null && (M = M.next = {
                lane: 0,
                revertLane: 0,
                action: x.action,
                hasEagerState: x.hasEagerState,
                eagerState: x.eagerState,
                next: null
              }), le === x0 && (ee = !0);
            else if (($c & q) === q) {
              x = x.next, q === x0 && (ee = !0);
              continue;
            } else
              le = {
                lane: 0,
                revertLane: x.revertLane,
                action: x.action,
                hasEagerState: x.hasEagerState,
                eagerState: x.eagerState,
                next: null
              }, M === null ? (S = M = le, v = h) : M = M.next = le, St.lanes |= q, nd |= q;
            le = x.action, B0 && i(h, le), h = x.hasEagerState ? x.eagerState : i(h, le);
          } else
            q = {
              lane: le,
              revertLane: x.revertLane,
              action: x.action,
              hasEagerState: x.hasEagerState,
              eagerState: x.eagerState,
              next: null
            }, M === null ? (S = M = q, v = h) : M = M.next = q, St.lanes |= le, nd |= le;
          x = x.next;
        } while (x !== null && x !== t);
        if (M === null ? v = h : M.next = S, !Ta(h, e.memoizedState) && (Qi = !0, ee && (i = sh, i !== null)))
          throw i;
        e.memoizedState = h, e.baseState = v, e.baseQueue = M, o.lastRenderedState = h;
      }
      return c === null && (o.lanes = 0), [e.memoizedState, o.dispatch];
    }
    function ll(e) {
      var t = At(), i = t.queue;
      if (i === null)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      i.lastRenderedReducer = e;
      var o = i.dispatch, c = i.pending, h = t.memoizedState;
      if (c !== null) {
        i.pending = null;
        var v = c = c.next;
        do
          h = e(h, v.action), v = v.next;
        while (v !== c);
        Ta(h, t.memoizedState) || (Qi = !0), t.memoizedState = h, t.baseQueue === null && (t.baseState = h), i.lastRenderedState = h;
      }
      return [h, o];
    }
    function Vo(e, t, i) {
      var o = St, c = Mn();
      if (Pt) {
        if (i === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var h = i();
        ch || h === i() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), ch = !0);
      } else {
        if (h = t(), ch || (i = t(), Ta(h, i) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), ch = !0)), pn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        (wt & 124) !== 0 || um(o, t, h);
      }
      return c.memoizedState = h, i = { value: h, getSnapshot: t }, c.queue = i, _u(
        hc.bind(null, o, i, e),
        [e]
      ), o.flags |= 2048, xr(
        lo | Ti,
        ps(),
        uc.bind(
          null,
          o,
          i,
          h,
          t
        ),
        null
      ), h;
    }
    function Qd(e, t, i) {
      var o = St, c = At(), h = Pt;
      if (h) {
        if (i === void 0)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        i = i();
      } else if (i = t(), !ch) {
        var v = t();
        Ta(i, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), ch = !0);
      }
      (v = !Ta(
        (hn || c).memoizedState,
        i
      )) && (c.memoizedState = i, Qi = !0), c = c.queue;
      var S = hc.bind(null, o, c, e);
      if (Kn(2048, Ti, S, [e]), c.getSnapshot !== t || v || ci !== null && ci.memoizedState.tag & lo) {
        if (o.flags |= 2048, xr(
          lo | Ti,
          ps(),
          uc.bind(
            null,
            o,
            c,
            i,
            t
          ),
          null
        ), pn === null)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        h || ($c & 124) !== 0 || um(o, t, i);
      }
      return i;
    }
    function um(e, t, i) {
      e.flags |= 16384, e = { getSnapshot: t, value: i }, t = St.updateQueue, t === null ? (t = Vu(), St.updateQueue = t, t.stores = [e]) : (i = t.stores, i === null ? t.stores = [e] : i.push(e));
    }
    function uc(e, t, i, o) {
      t.value = i, t.getSnapshot = o, hm(t) && mc(e);
    }
    function hc(e, t, i) {
      return i(function() {
        hm(t) && mc(e);
      });
    }
    function hm(e) {
      var t = e.getSnapshot;
      e = e.value;
      try {
        var i = t();
        return !Ta(e, i);
      } catch {
        return !0;
      }
    }
    function mc(e) {
      var t = Pi(e, 2);
      t !== null && Qn(t, e, 2);
    }
    function Dd(e) {
      var t = Mn();
      if (typeof e == "function") {
        var i = e;
        if (e = i(), B0) {
          Ze(!0);
          try {
            i();
          } finally {
            Ze(!1);
          }
        }
      }
      return t.memoizedState = t.baseState = e, t.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: zt,
        lastRenderedState: e
      }, t;
    }
    function Co(e) {
      e = Dd(e);
      var t = e.queue, i = vc.bind(null, St, t);
      return t.dispatch = i, [e.memoizedState, i];
    }
    function cr(e) {
      var t = Mn();
      t.memoizedState = t.baseState = e;
      var i = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = i, t = wu.bind(
        null,
        St,
        !0,
        i
      ), i.dispatch = t, [e, t];
    }
    function Fo(e, t) {
      var i = At();
      return Dr(i, hn, e, t);
    }
    function Dr(e, t, i, o) {
      return e.baseState = i, La(
        e,
        hn,
        typeof o == "function" ? o : zt
      );
    }
    function Cu(e, t) {
      var i = At();
      return hn !== null ? Dr(i, hn, e, t) : (i.baseState = e, [e, i.queue.dispatch]);
    }
    function mm(e, t, i, o, c) {
      if (Jd(e))
        throw Error("Cannot update form state while rendering.");
      if (e = t.action, e !== null) {
        var h = {
          payload: c,
          action: e,
          next: null,
          isTransition: !0,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(v) {
            h.listeners.push(v);
          }
        };
        oe.T !== null ? i(!0) : h.isTransition = !1, o(h), i = t.pending, i === null ? (h.next = t.pending = h, pc(t, h)) : (h.next = i.next, t.pending = i.next = h);
      }
    }
    function pc(e, t) {
      var i = t.action, o = t.payload, c = e.state;
      if (t.isTransition) {
        var h = oe.T, v = {};
        oe.T = v, oe.T._updatedFibers = /* @__PURE__ */ new Set();
        try {
          var S = i(c, o), M = oe.S;
          M !== null && M(v, S), xd(e, t, S);
        } catch (x) {
          ai(e, t, x);
        } finally {
          oe.T = h, h === null && v._updatedFibers && (e = v._updatedFibers.size, v._updatedFibers.clear(), 10 < e);
        }
      } else
        try {
          v = i(c, o), xd(e, t, v);
        } catch (x) {
          ai(e, t, x);
        }
    }
    function xd(e, t, i) {
      i !== null && typeof i == "object" && typeof i.then == "function" ? (i.then(
        function(o) {
          ms(e, t, o);
        },
        function(o) {
          return ai(e, t, o);
        }
      ), t.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : ms(e, t, i);
    }
    function ms(e, t, i) {
      t.status = "fulfilled", t.value = i, Zd(t), e.state = i, t = e.pending, t !== null && (i = t.next, i === t ? e.pending = null : (i = i.next, t.next = i, pc(e, i)));
    }
    function ai(e, t, i) {
      var o = e.pending;
      if (e.pending = null, o !== null) {
        o = o.next;
        do
          t.status = "rejected", t.reason = i, Zd(t), t = t.next;
        while (t !== o);
      }
      e.action = null;
    }
    function Zd(e) {
      e = e.listeners;
      for (var t = 0; t < e.length; t++) (0, e[t])();
    }
    function pm(e, t) {
      return t;
    }
    function fc(e, t) {
      if (Pt) {
        var i = pn.formState;
        if (i !== null) {
          e: {
            var o = St;
            if (Pt) {
              if (Gn) {
                t: {
                  for (var c = Gn, h = Bs; c.nodeType !== 8; ) {
                    if (!h) {
                      c = null;
                      break t;
                    }
                    if (c = Si(
                      c.nextSibling
                    ), c === null) {
                      c = null;
                      break t;
                    }
                  }
                  h = c.data, c = h === dS || h === J6 ? c : null;
                }
                if (c) {
                  Gn = Si(
                    c.nextSibling
                  ), o = c.data === dS;
                  break e;
                }
              }
              Cr(o);
            }
            o = !1;
          }
          o && (t = i[0]);
        }
      }
      return i = Mn(), i.memoizedState = i.baseState = t, o = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: pm,
        lastRenderedState: t
      }, i.queue = o, i = vc.bind(
        null,
        St,
        o
      ), o.dispatch = i, o = Dd(!1), h = wu.bind(
        null,
        St,
        !1,
        o.queue
      ), o = Mn(), c = {
        state: t,
        dispatch: null,
        action: e,
        pending: null
      }, o.queue = c, i = mm.bind(
        null,
        St,
        c,
        h,
        i
      ), c.dispatch = i, o.memoizedState = e, [t, i, !1];
    }
    function Fu(e) {
      var t = At();
      return a2(t, hn, e);
    }
    function a2(e, t, i) {
      if (t = La(
        e,
        t,
        pm
      )[0], e = Ja(zt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
        try {
          var o = sl(t);
        } catch (v) {
          throw v === $p ? q2 : v;
        }
      else o = t;
      t = At();
      var c = t.queue, h = c.dispatch;
      return i !== t.memoizedState && (St.flags |= 2048, xr(
        lo | Ti,
        ps(),
        Xn.bind(null, c, i),
        null
      )), [o, h, e];
    }
    function Xn(e, t) {
      e.action = t;
    }
    function gc(e) {
      var t = At(), i = hn;
      if (i !== null)
        return a2(t, i, e);
      At(), t = t.memoizedState, i = At();
      var o = i.queue.dispatch;
      return i.memoizedState = e, [t, o, !1];
    }
    function xr(e, t, i, o) {
      return e = {
        tag: e,
        create: i,
        deps: o,
        inst: t,
        next: null
      }, t = St.updateQueue, t === null && (t = Vu(), St.updateQueue = t), i = t.lastEffect, i === null ? t.lastEffect = e.next = e : (o = i.next, i.next = e, e.next = o, t.lastEffect = e), e;
    }
    function ps() {
      return { destroy: void 0, resource: void 0 };
    }
    function Od(e) {
      var t = Mn();
      return e = { current: e }, t.memoizedState = e;
    }
    function Ia(e, t, i, o) {
      var c = Mn();
      o = o === void 0 ? null : o, St.flags |= e, c.memoizedState = xr(
        lo | t,
        ps(),
        i,
        o
      );
    }
    function Kn(e, t, i, o) {
      var c = At();
      o = o === void 0 ? null : o;
      var h = c.memoizedState.inst;
      hn !== null && o !== null && us(o, hn.memoizedState.deps) ? c.memoizedState = xr(t, h, i, o) : (St.flags |= e, c.memoizedState = xr(
        lo | t,
        h,
        i,
        o
      ));
    }
    function _u(e, t) {
      (St.mode & zo) !== Un && (St.mode & NR) === Un ? Ia(276826112, Ti, e, t) : Ia(8390656, Ti, e, t);
    }
    function Mu(e, t) {
      var i = 4194308;
      return (St.mode & zo) !== Un && (i |= 134217728), Ia(i, zi, e, t);
    }
    function r2(e, t) {
      if (typeof t == "function") {
        e = e();
        var i = t(e);
        return function() {
          typeof i == "function" ? i() : t(null);
        };
      }
      if (t != null)
        return t.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(t).join(", ") + "}"
        ), e = e(), t.current = e, function() {
          t.current = null;
        };
    }
    function ku(e, t, i) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), i = i != null ? i.concat([e]) : null;
      var o = 4194308;
      (St.mode & zo) !== Un && (o |= 134217728), Ia(
        o,
        zi,
        r2.bind(null, t, e),
        i
      );
    }
    function Zr(e, t, i) {
      typeof t != "function" && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        t !== null ? typeof t : "null"
      ), i = i != null ? i.concat([e]) : null, Kn(
        4,
        zi,
        r2.bind(null, t, e),
        i
      );
    }
    function Bd(e, t) {
      return Mn().memoizedState = [
        e,
        t === void 0 ? null : t
      ], e;
    }
    function cl(e, t) {
      var i = At();
      t = t === void 0 ? null : t;
      var o = i.memoizedState;
      return t !== null && us(t, o[1]) ? o[0] : (i.memoizedState = [e, t], e);
    }
    function Qu(e, t) {
      var i = Mn();
      t = t === void 0 ? null : t;
      var o = e();
      if (B0) {
        Ze(!0);
        try {
          e();
        } finally {
          Ze(!1);
        }
      }
      return i.memoizedState = [o, t], o;
    }
    function fs(e, t) {
      var i = At();
      t = t === void 0 ? null : t;
      var o = i.memoizedState;
      if (t !== null && us(t, o[1]))
        return o[0];
      if (o = e(), B0) {
        Ze(!0);
        try {
          e();
        } finally {
          Ze(!1);
        }
      }
      return i.memoizedState = [o, t], o;
    }
    function Du(e, t) {
      var i = Mn();
      return Zu(i, e, t);
    }
    function wd(e, t) {
      var i = At();
      return Ad(
        i,
        hn.memoizedState,
        e,
        t
      );
    }
    function xu(e, t) {
      var i = At();
      return hn === null ? Zu(i, e, t) : Ad(
        i,
        hn.memoizedState,
        e,
        t
      );
    }
    function Zu(e, t, i) {
      return i === void 0 || ($c & 1073741824) !== 0 ? e.memoizedState = t : (e.memoizedState = i, e = f2(), St.lanes |= e, nd |= e, i);
    }
    function Ad(e, t, i, o) {
      return Ta(i, t) ? i : lh.current !== null ? (e = Zu(e, i, o), Ta(e, t) || (Qi = !0), e) : ($c & 42) === 0 ? (Qi = !0, e.memoizedState = i) : (e = f2(), St.lanes |= e, nd |= e, t);
    }
    function fm(e, t, i, o, c) {
      var h = ut.p;
      ut.p = h !== 0 && h < fr ? h : fr;
      var v = oe.T, S = {};
      oe.T = S, wu(e, !1, t, i), S._updatedFibers = /* @__PURE__ */ new Set();
      try {
        var M = c(), x = oe.S;
        if (x !== null && x(S, M), M !== null && typeof M == "object" && typeof M.then == "function") {
          var ee = t2(
            M,
            o
          );
          _o(
            e,
            t,
            ee,
            ta(e)
          );
        } else
          _o(
            e,
            t,
            o,
            ta(e)
          );
      } catch (le) {
        _o(
          e,
          t,
          { then: function() {
          }, status: "rejected", reason: le },
          ta(e)
        );
      } finally {
        ut.p = h, oe.T = v, v === null && S._updatedFibers && (e = S._updatedFibers.size, S._updatedFibers.clear(), 10 < e);
      }
    }
    function dl(e, t, i, o) {
      if (e.tag !== 5)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var c = gm(e).queue;
      fm(
        e,
        c,
        t,
        P0,
        i === null ? V : function() {
          return vm(e), i(o);
        }
      );
    }
    function gm(e) {
      var t = e.memoizedState;
      if (t !== null) return t;
      t = {
        memoizedState: P0,
        baseState: P0,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: zt,
          lastRenderedState: P0
        },
        next: null
      };
      var i = {};
      return t.next = {
        memoizedState: i,
        baseState: i,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: zt,
          lastRenderedState: i
        },
        next: null
      }, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
    }
    function vm(e) {
      oe.T === null && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var t = gm(e).next.queue;
      _o(
        e,
        t,
        {},
        ta(e)
      );
    }
    function Or() {
      var e = Dd(!1);
      return e = fm.bind(
        null,
        St,
        e.queue,
        !0,
        !1
      ), Mn().memoizedState = e, [!1, e];
    }
    function Ou() {
      var e = Ja(zt)[0], t = At().memoizedState;
      return [
        typeof e == "boolean" ? e : sl(e),
        t
      ];
    }
    function Bu() {
      var e = ll(zt)[0], t = At().memoizedState;
      return [
        typeof e == "boolean" ? e : sl(e),
        t
      ];
    }
    function qi() {
      return mn(Ef);
    }
    function Br() {
      var e = Mn(), t = pn.identifierPrefix;
      if (Pt) {
        var i = wl, o = Bl;
        i = (o & ~(1 << 32 - Mi(o) - 1)).toString(32) + i, t = "«" + t + "R" + i, i = ng++, 0 < i && (t += "H" + i.toString(32)), t += "»";
      } else
        i = ZE++, t = "«" + t + "r" + i.toString(32) + "»";
      return e.memoizedState = t;
    }
    function ul() {
      return Mn().memoizedState = Sm.bind(
        null,
        St
      );
    }
    function Sm(e, t) {
      for (var i = e.return; i !== null; ) {
        switch (i.tag) {
          case 24:
          case 3:
            var o = ta(i);
            e = Mr(o);
            var c = or(i, e, o);
            c !== null && (Qn(c, i, o), ds(c, i, o)), i = Fd(), t != null && c !== null && console.error(
              "The seed argument is not enabled outside experimental channels."
            ), e.payload = { cache: i };
            return;
        }
        i = i.return;
      }
    }
    function Rm(e, t, i) {
      var o = arguments;
      typeof o[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), o = ta(e);
      var c = {
        lane: o,
        revertLane: 0,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      Jd(e) ? hl(t, c) : (c = Gh(e, t, c, o), c !== null && (Qn(c, e, o), Ld(c, t, o))), gn(e, o);
    }
    function vc(e, t, i) {
      var o = arguments;
      typeof o[3] == "function" && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      ), o = ta(e), _o(e, t, i, o), gn(e, o);
    }
    function _o(e, t, i, o) {
      var c = {
        lane: o,
        revertLane: 0,
        action: i,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (Jd(e)) hl(t, c);
      else {
        var h = e.alternate;
        if (e.lanes === 0 && (h === null || h.lanes === 0) && (h = t.lastRenderedReducer, h !== null)) {
          var v = oe.H;
          oe.H = Go;
          try {
            var S = t.lastRenderedState, M = h(S, i);
            if (c.hasEagerState = !0, c.eagerState = M, Ta(M, S))
              return Su(e, t, c, 0), pn === null && yd(), !1;
          } catch {
          } finally {
            oe.H = v;
          }
        }
        if (i = Gh(e, t, c, o), i !== null)
          return Qn(i, e, o), Ld(i, t, o), !0;
      }
      return !1;
    }
    function wu(e, t, i, o) {
      if (oe.T === null && x0 === 0 && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      ), o = {
        lane: 2,
        revertLane: Xm(),
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null
      }, Jd(e)) {
        if (t)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        t = Gh(
          e,
          i,
          o,
          2
        ), t !== null && Qn(t, e, 2);
      gn(e, 2);
    }
    function Jd(e) {
      var t = e.alternate;
      return e === St || t !== null && t === St;
    }
    function hl(e, t) {
      dh = tg = !0;
      var i = e.pending;
      i === null ? t.next = t : (t.next = i.next, i.next = t), e.pending = t;
    }
    function Ld(e, t, i) {
      if ((i & 4194048) !== 0) {
        var o = t.lanes;
        o &= e.pendingLanes, i |= o, t.lanes = i, ni(e, i);
      }
    }
    function ri(e) {
      var t = Mt;
      return e != null && (Mt = t === null ? e : t.concat(e)), t;
    }
    function Sc(e, t, i) {
      for (var o = Object.keys(e.props), c = 0; c < o.length; c++) {
        var h = o[c];
        if (h !== "children" && h !== "key") {
          t === null && (t = Vd(e, i.mode, 0), t._debugInfo = Mt, t.return = i), He(
            t,
            function(v) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                v
              );
            },
            h
          );
          break;
        }
      }
    }
    function Rc(e) {
      var t = af;
      return af += 1, uh === null && (uh = lm()), Ba(uh, e, t);
    }
    function Wa(e, t) {
      t = t.props.ref, e.ref = t !== void 0 ? t : null;
    }
    function Et(e, t) {
      throw t.$$typeof === v0 ? Error(
        `A React Element from an older version of React was rendered. This is not supported. It can happen if:
- Multiple copies of the "react" package is used.
- A library pre-bundled an old copy of "react" or "react/jsx-runtime".
- A compiler tries to "inline" JSX instead of using the runtime.`
      ) : (e = Object.prototype.toString.call(t), Error(
        "Objects are not valid as a React child (found: " + (e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e) + "). If you meant to render a collection of children, use an array instead."
      ));
    }
    function Yt(e, t) {
      var i = Se(e) || "Component";
      i6[i] || (i6[i] = !0, t = t.displayName || t.name || "Component", e.tag === 3 ? console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  root.render(%s)`,
        t,
        t,
        t
      ) : console.error(
        `Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.
  <%s>{%s}</%s>`,
        t,
        t,
        i,
        t,
        i
      ));
    }
    function Cn(e, t) {
      var i = Se(e) || "Component";
      a6[i] || (a6[i] = !0, t = String(t), e.tag === 3 ? console.error(
        `Symbols are not valid as a React child.
  root.render(%s)`,
        t
      ) : console.error(
        `Symbols are not valid as a React child.
  <%s>%s</%s>`,
        i,
        t,
        i
      ));
    }
    function Id(e) {
      function t(w, J) {
        if (e) {
          var I = w.deletions;
          I === null ? (w.deletions = [J], w.flags |= 16) : I.push(J);
        }
      }
      function i(w, J) {
        if (!e) return null;
        for (; J !== null; )
          t(w, J), J = J.sibling;
        return null;
      }
      function o(w) {
        for (var J = /* @__PURE__ */ new Map(); w !== null; )
          w.key !== null ? J.set(w.key, w) : J.set(w.index, w), w = w.sibling;
        return J;
      }
      function c(w, J) {
        return w = Vr(w, J), w.index = 0, w.sibling = null, w;
      }
      function h(w, J, I) {
        return w.index = I, e ? (I = w.alternate, I !== null ? (I = I.index, I < J ? (w.flags |= 67108866, J) : I) : (w.flags |= 67108866, J)) : (w.flags |= 1048576, J);
      }
      function v(w) {
        return e && w.alternate === null && (w.flags |= 67108866), w;
      }
      function S(w, J, I, ue) {
        return J === null || J.tag !== 6 ? (J = as(
          I,
          w.mode,
          ue
        ), J.return = w, J._debugOwner = w, J._debugTask = w._debugTask, J._debugInfo = Mt, J) : (J = c(J, I), J.return = w, J._debugInfo = Mt, J);
      }
      function M(w, J, I, ue) {
        var we = I.type;
        return we === Ut ? (J = ee(
          w,
          J,
          I.props.children,
          ue,
          I.key
        ), Sc(I, J, w), J) : J !== null && (J.elementType === we || Kf(J, I) || typeof we == "object" && we !== null && we.$$typeof === Ea && ed(we) === J.type) ? (J = c(J, I.props), Wa(J, I), J.return = w, J._debugOwner = I._owner, J._debugInfo = Mt, J) : (J = Vd(I, w.mode, ue), Wa(J, I), J.return = w, J._debugInfo = Mt, J);
      }
      function x(w, J, I, ue) {
        return J === null || J.tag !== 4 || J.stateNode.containerInfo !== I.containerInfo || J.stateNode.implementation !== I.implementation ? (J = Kh(I, w.mode, ue), J.return = w, J._debugInfo = Mt, J) : (J = c(J, I.children || []), J.return = w, J._debugInfo = Mt, J);
      }
      function ee(w, J, I, ue, we) {
        return J === null || J.tag !== 7 ? (J = is(
          I,
          w.mode,
          ue,
          we
        ), J.return = w, J._debugOwner = w, J._debugTask = w._debugTask, J._debugInfo = Mt, J) : (J = c(J, I), J.return = w, J._debugInfo = Mt, J);
      }
      function le(w, J, I) {
        if (typeof J == "string" && J !== "" || typeof J == "number" || typeof J == "bigint")
          return J = as(
            "" + J,
            w.mode,
            I
          ), J.return = w, J._debugOwner = w, J._debugTask = w._debugTask, J._debugInfo = Mt, J;
        if (typeof J == "object" && J !== null) {
          switch (J.$$typeof) {
            case Fs:
              return I = Vd(
                J,
                w.mode,
                I
              ), Wa(I, J), I.return = w, w = ri(J._debugInfo), I._debugInfo = Mt, Mt = w, I;
            case kl:
              return J = Kh(
                J,
                w.mode,
                I
              ), J.return = w, J._debugInfo = Mt, J;
            case Ea:
              var ue = ri(J._debugInfo);
              return J = ed(J), w = le(w, J, I), Mt = ue, w;
          }
          if (vt(J) || Ce(J))
            return I = is(
              J,
              w.mode,
              I,
              null
            ), I.return = w, I._debugOwner = w, I._debugTask = w._debugTask, w = ri(J._debugInfo), I._debugInfo = Mt, Mt = w, I;
          if (typeof J.then == "function")
            return ue = ri(J._debugInfo), w = le(
              w,
              Rc(J),
              I
            ), Mt = ue, w;
          if (J.$$typeof === Pa)
            return le(
              w,
              Cd(w, J),
              I
            );
          Et(w, J);
        }
        return typeof J == "function" && Yt(w, J), typeof J == "symbol" && Cn(w, J), null;
      }
      function q(w, J, I, ue) {
        var we = J !== null ? J.key : null;
        if (typeof I == "string" && I !== "" || typeof I == "number" || typeof I == "bigint")
          return we !== null ? null : S(w, J, "" + I, ue);
        if (typeof I == "object" && I !== null) {
          switch (I.$$typeof) {
            case Fs:
              return I.key === we ? (we = ri(I._debugInfo), w = M(
                w,
                J,
                I,
                ue
              ), Mt = we, w) : null;
            case kl:
              return I.key === we ? x(w, J, I, ue) : null;
            case Ea:
              return we = ri(I._debugInfo), I = ed(I), w = q(
                w,
                J,
                I,
                ue
              ), Mt = we, w;
          }
          if (vt(I) || Ce(I))
            return we !== null ? null : (we = ri(I._debugInfo), w = ee(
              w,
              J,
              I,
              ue,
              null
            ), Mt = we, w);
          if (typeof I.then == "function")
            return we = ri(I._debugInfo), w = q(
              w,
              J,
              Rc(I),
              ue
            ), Mt = we, w;
          if (I.$$typeof === Pa)
            return q(
              w,
              J,
              Cd(w, I),
              ue
            );
          Et(w, I);
        }
        return typeof I == "function" && Yt(w, I), typeof I == "symbol" && Cn(w, I), null;
      }
      function ce(w, J, I, ue, we) {
        if (typeof ue == "string" && ue !== "" || typeof ue == "number" || typeof ue == "bigint")
          return w = w.get(I) || null, S(J, w, "" + ue, we);
        if (typeof ue == "object" && ue !== null) {
          switch (ue.$$typeof) {
            case Fs:
              return I = w.get(
                ue.key === null ? I : ue.key
              ) || null, w = ri(ue._debugInfo), J = M(
                J,
                I,
                ue,
                we
              ), Mt = w, J;
            case kl:
              return w = w.get(
                ue.key === null ? I : ue.key
              ) || null, x(J, w, ue, we);
            case Ea:
              var Tt = ri(ue._debugInfo);
              return ue = ed(ue), J = ce(
                w,
                J,
                I,
                ue,
                we
              ), Mt = Tt, J;
          }
          if (vt(ue) || Ce(ue))
            return I = w.get(I) || null, w = ri(ue._debugInfo), J = ee(
              J,
              I,
              ue,
              we,
              null
            ), Mt = w, J;
          if (typeof ue.then == "function")
            return Tt = ri(ue._debugInfo), J = ce(
              w,
              J,
              I,
              Rc(ue),
              we
            ), Mt = Tt, J;
          if (ue.$$typeof === Pa)
            return ce(
              w,
              J,
              I,
              Cd(J, ue),
              we
            );
          Et(J, ue);
        }
        return typeof ue == "function" && Yt(J, ue), typeof ue == "symbol" && Cn(J, ue), null;
      }
      function je(w, J, I, ue) {
        if (typeof I != "object" || I === null) return ue;
        switch (I.$$typeof) {
          case Fs:
          case kl:
            Q(w, J, I);
            var we = I.key;
            if (typeof we != "string") break;
            if (ue === null) {
              ue = /* @__PURE__ */ new Set(), ue.add(we);
              break;
            }
            if (!ue.has(we)) {
              ue.add(we);
              break;
            }
            He(J, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                we
              );
            });
            break;
          case Ea:
            I = ed(I), je(w, J, I, ue);
        }
        return ue;
      }
      function ht(w, J, I, ue) {
        for (var we = null, Tt = null, Ge = null, yt = J, Nt = J = 0, Tn = null; yt !== null && Nt < I.length; Nt++) {
          yt.index > Nt ? (Tn = yt, yt = null) : Tn = yt.sibling;
          var ti = q(
            w,
            yt,
            I[Nt],
            ue
          );
          if (ti === null) {
            yt === null && (yt = Tn);
            break;
          }
          we = je(
            w,
            ti,
            I[Nt],
            we
          ), e && yt && ti.alternate === null && t(w, yt), J = h(ti, J, Nt), Ge === null ? Tt = ti : Ge.sibling = ti, Ge = ti, yt = Tn;
        }
        if (Nt === I.length)
          return i(w, yt), Pt && tl(w, Nt), Tt;
        if (yt === null) {
          for (; Nt < I.length; Nt++)
            yt = le(w, I[Nt], ue), yt !== null && (we = je(
              w,
              yt,
              I[Nt],
              we
            ), J = h(
              yt,
              J,
              Nt
            ), Ge === null ? Tt = yt : Ge.sibling = yt, Ge = yt);
          return Pt && tl(w, Nt), Tt;
        }
        for (yt = o(yt); Nt < I.length; Nt++)
          Tn = ce(
            yt,
            w,
            Nt,
            I[Nt],
            ue
          ), Tn !== null && (we = je(
            w,
            Tn,
            I[Nt],
            we
          ), e && Tn.alternate !== null && yt.delete(
            Tn.key === null ? Nt : Tn.key
          ), J = h(
            Tn,
            J,
            Nt
          ), Ge === null ? Tt = Tn : Ge.sibling = Tn, Ge = Tn);
        return e && yt.forEach(function(Gl) {
          return t(w, Gl);
        }), Pt && tl(w, Nt), Tt;
      }
      function fn(w, J, I, ue) {
        if (I == null)
          throw Error("An iterable object provided no iterator.");
        for (var we = null, Tt = null, Ge = J, yt = J = 0, Nt = null, Tn = null, ti = I.next(); Ge !== null && !ti.done; yt++, ti = I.next()) {
          Ge.index > yt ? (Nt = Ge, Ge = null) : Nt = Ge.sibling;
          var Gl = q(w, Ge, ti.value, ue);
          if (Gl === null) {
            Ge === null && (Ge = Nt);
            break;
          }
          Tn = je(
            w,
            Gl,
            ti.value,
            Tn
          ), e && Ge && Gl.alternate === null && t(w, Ge), J = h(Gl, J, yt), Tt === null ? we = Gl : Tt.sibling = Gl, Tt = Gl, Ge = Nt;
        }
        if (ti.done)
          return i(w, Ge), Pt && tl(w, yt), we;
        if (Ge === null) {
          for (; !ti.done; yt++, ti = I.next())
            Ge = le(w, ti.value, ue), Ge !== null && (Tn = je(
              w,
              Ge,
              ti.value,
              Tn
            ), J = h(
              Ge,
              J,
              yt
            ), Tt === null ? we = Ge : Tt.sibling = Ge, Tt = Ge);
          return Pt && tl(w, yt), we;
        }
        for (Ge = o(Ge); !ti.done; yt++, ti = I.next())
          Nt = ce(
            Ge,
            w,
            yt,
            ti.value,
            ue
          ), Nt !== null && (Tn = je(
            w,
            Nt,
            ti.value,
            Tn
          ), e && Nt.alternate !== null && Ge.delete(
            Nt.key === null ? yt : Nt.key
          ), J = h(
            Nt,
            J,
            yt
          ), Tt === null ? we = Nt : Tt.sibling = Nt, Tt = Nt);
        return e && Ge.forEach(function(lU) {
          return t(w, lU);
        }), Pt && tl(w, yt), we;
      }
      function Jt(w, J, I, ue) {
        if (typeof I == "object" && I !== null && I.type === Ut && I.key === null && (Sc(I, null, w), I = I.props.children), typeof I == "object" && I !== null) {
          switch (I.$$typeof) {
            case Fs:
              var we = ri(I._debugInfo);
              e: {
                for (var Tt = I.key; J !== null; ) {
                  if (J.key === Tt) {
                    if (Tt = I.type, Tt === Ut) {
                      if (J.tag === 7) {
                        i(
                          w,
                          J.sibling
                        ), ue = c(
                          J,
                          I.props.children
                        ), ue.return = w, ue._debugOwner = I._owner, ue._debugInfo = Mt, Sc(I, ue, w), w = ue;
                        break e;
                      }
                    } else if (J.elementType === Tt || Kf(
                      J,
                      I
                    ) || typeof Tt == "object" && Tt !== null && Tt.$$typeof === Ea && ed(Tt) === J.type) {
                      i(
                        w,
                        J.sibling
                      ), ue = c(J, I.props), Wa(ue, I), ue.return = w, ue._debugOwner = I._owner, ue._debugInfo = Mt, w = ue;
                      break e;
                    }
                    i(w, J);
                    break;
                  } else t(w, J);
                  J = J.sibling;
                }
                I.type === Ut ? (ue = is(
                  I.props.children,
                  w.mode,
                  ue,
                  I.key
                ), ue.return = w, ue._debugOwner = w, ue._debugTask = w._debugTask, ue._debugInfo = Mt, Sc(I, ue, w), w = ue) : (ue = Vd(
                  I,
                  w.mode,
                  ue
                ), Wa(ue, I), ue.return = w, ue._debugInfo = Mt, w = ue);
              }
              return w = v(w), Mt = we, w;
            case kl:
              e: {
                for (we = I, I = we.key; J !== null; ) {
                  if (J.key === I)
                    if (J.tag === 4 && J.stateNode.containerInfo === we.containerInfo && J.stateNode.implementation === we.implementation) {
                      i(
                        w,
                        J.sibling
                      ), ue = c(
                        J,
                        we.children || []
                      ), ue.return = w, w = ue;
                      break e;
                    } else {
                      i(w, J);
                      break;
                    }
                  else t(w, J);
                  J = J.sibling;
                }
                ue = Kh(
                  we,
                  w.mode,
                  ue
                ), ue.return = w, w = ue;
              }
              return v(w);
            case Ea:
              return we = ri(I._debugInfo), I = ed(I), w = Jt(
                w,
                J,
                I,
                ue
              ), Mt = we, w;
          }
          if (vt(I))
            return we = ri(I._debugInfo), w = ht(
              w,
              J,
              I,
              ue
            ), Mt = we, w;
          if (Ce(I)) {
            if (we = ri(I._debugInfo), Tt = Ce(I), typeof Tt != "function")
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var Ge = Tt.call(I);
            return Ge === I ? (w.tag !== 0 || Object.prototype.toString.call(w.type) !== "[object GeneratorFunction]" || Object.prototype.toString.call(Ge) !== "[object Generator]") && (t6 || console.error(
              "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
            ), t6 = !0) : I.entries !== Tt || Jv || (console.error(
              "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
            ), Jv = !0), w = fn(
              w,
              J,
              Ge,
              ue
            ), Mt = we, w;
          }
          if (typeof I.then == "function")
            return we = ri(I._debugInfo), w = Jt(
              w,
              J,
              Rc(I),
              ue
            ), Mt = we, w;
          if (I.$$typeof === Pa)
            return Jt(
              w,
              J,
              Cd(w, I),
              ue
            );
          Et(w, I);
        }
        return typeof I == "string" && I !== "" || typeof I == "number" || typeof I == "bigint" ? (we = "" + I, J !== null && J.tag === 6 ? (i(
          w,
          J.sibling
        ), ue = c(J, we), ue.return = w, w = ue) : (i(w, J), ue = as(
          we,
          w.mode,
          ue
        ), ue.return = w, ue._debugOwner = w, ue._debugTask = w._debugTask, ue._debugInfo = Mt, w = ue), v(w)) : (typeof I == "function" && Yt(w, I), typeof I == "symbol" && Cn(w, I), i(w, J));
      }
      return function(w, J, I, ue) {
        var we = Mt;
        Mt = null;
        try {
          af = 0;
          var Tt = Jt(
            w,
            J,
            I,
            ue
          );
          return uh = null, Tt;
        } catch (Tn) {
          if (Tn === $p || Tn === q2) throw Tn;
          var Ge = b(29, Tn, null, w.mode);
          Ge.lanes = ue, Ge.return = w;
          var yt = Ge._debugInfo = Mt;
          if (Ge._debugOwner = w._debugOwner, Ge._debugTask = w._debugTask, yt != null) {
            for (var Nt = yt.length - 1; 0 <= Nt; Nt--)
              if (typeof yt[Nt].stack == "string") {
                Ge._debugOwner = yt[Nt], Ge._debugTask = yt[Nt].debugTask;
                break;
              }
          }
          return Ge;
        } finally {
          Mt = we;
        }
      };
    }
    function fa(e) {
      var t = e.alternate;
      fe(
        yi,
        yi.current & mh,
        e
      ), fe(uo, e, e), As === null && (t === null || lh.current !== null || t.memoizedState !== null) && (As = e);
    }
    function gs(e) {
      if (e.tag === 22) {
        if (fe(yi, yi.current, e), fe(uo, e, e), As === null) {
          var t = e.alternate;
          t !== null && t.memoizedState !== null && (As = e);
        }
      } else dr(e);
    }
    function dr(e) {
      fe(yi, yi.current, e), fe(
        uo,
        uo.current,
        e
      );
    }
    function ga(e) {
      Qe(uo, e), As === e && (As = null), Qe(yi, e);
    }
    function Mo(e) {
      for (var t = e; t !== null; ) {
        if (t.tag === 13) {
          var i = t.memoizedState;
          if (i !== null && (i = i.dehydrated, i === null || i.data === Hl || Xr(i)))
            return t;
        } else if (t.tag === 19 && t.memoizedProps.revealOrder !== void 0) {
          if ((t.flags & 128) !== 0) return t;
        } else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e) return null;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
      return null;
    }
    function Em(e) {
      if (e !== null && typeof e != "function") {
        var t = String(e);
        g6.has(t) || (g6.add(t), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          e
        ));
      }
    }
    function Fn(e, t, i, o) {
      var c = e.memoizedState, h = i(o, c);
      if (e.mode & la) {
        Ze(!0);
        try {
          h = i(o, c);
        } finally {
          Ze(!1);
        }
      }
      h === void 0 && (t = Re(t) || "Component", h6.has(t) || (h6.add(t), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        t
      ))), c = h == null ? c : bt({}, c, h), e.memoizedState = c, e.lanes === 0 && (e.updateQueue.baseState = c);
    }
    function Au(e, t, i, o, c, h, v) {
      var S = e.stateNode;
      if (typeof S.shouldComponentUpdate == "function") {
        if (i = S.shouldComponentUpdate(
          o,
          h,
          v
        ), e.mode & la) {
          Ze(!0);
          try {
            i = S.shouldComponentUpdate(
              o,
              h,
              v
            );
          } finally {
            Ze(!1);
          }
        }
        return i === void 0 && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          Re(t) || "Component"
        ), i;
      }
      return t.prototype && t.prototype.isPureReactComponent ? !Td(i, o) || !Td(c, h) : !0;
    }
    function Ju(e, t, i, o) {
      var c = t.state;
      typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(i, o), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(i, o), t.state !== c && (e = Se(e) || "Component", s6.has(e) || (s6.add(e), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        e
      )), Lv.enqueueReplaceState(
        t,
        t.state,
        null
      ));
    }
    function vs(e, t) {
      var i = t;
      if ("ref" in t) {
        i = {};
        for (var o in t)
          o !== "ref" && (i[o] = t[o]);
      }
      if (e = e.defaultProps) {
        i === t && (i = bt({}, i));
        for (var c in e)
          i[c] === void 0 && (i[c] = e[c]);
      }
      return i;
    }
    function Um(e) {
      Iv(e), ph && "" + ph;
    }
    function o2(e) {
      var t = ph ? "The above error occurred in the <" + ph + "> component." : "The above error occurred in one of your React components.", i = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((Wv || "Anonymous") + ".");
      if (typeof e == "object" && e !== null && typeof e.environmentName == "string") {
        var o = e.environmentName;
        e = [
          `%o

%s

%s
`,
          e,
          t,
          i
        ].slice(0), typeof e[0] == "string" ? e.splice(
          0,
          1,
          P6 + e[0],
          Y6,
          Tg + o + Tg,
          X6
        ) : e.splice(
          0,
          0,
          P6,
          Y6,
          Tg + o + Tg,
          X6
        ), e.unshift(console), o = oU.apply(console.error, e), o();
      } else
        console.error(
          `%o

%s

%s
`,
          e,
          t,
          i
        );
    }
    function Lu(e) {
      Iv(e);
    }
    function Ec(e, t) {
      try {
        ph = t.source ? Se(t.source) : null, Wv = null;
        var i = t.value;
        if (oe.actQueue !== null)
          oe.thrownErrors.push(i);
        else {
          var o = e.onUncaughtError;
          o(i, { componentStack: t.stack });
        }
      } catch (c) {
        setTimeout(function() {
          throw c;
        });
      }
    }
    function Iu(e, t, i) {
      try {
        ph = i.source ? Se(i.source) : null, Wv = Se(t);
        var o = e.onCaughtError;
        o(i.value, {
          componentStack: i.stack,
          errorBoundary: t.tag === 1 ? t.stateNode : null
        });
      } catch (c) {
        setTimeout(function() {
          throw c;
        });
      }
    }
    function Ci(e, t, i) {
      return i = Mr(i), i.tag = Qv, i.payload = { element: null }, i.callback = function() {
        He(t.source, Ec, e, t);
      }, i;
    }
    function kn(e) {
      return e = Mr(e), e.tag = Qv, e;
    }
    function Wd(e, t, i, o) {
      var c = i.type.getDerivedStateFromError;
      if (typeof c == "function") {
        var h = o.value;
        e.payload = function() {
          return c(h);
        }, e.callback = function() {
          qf(i), He(
            o.source,
            Iu,
            t,
            i,
            o
          );
        };
      }
      var v = i.stateNode;
      v !== null && typeof v.componentDidCatch == "function" && (e.callback = function() {
        qf(i), He(
          o.source,
          Iu,
          t,
          i,
          o
        ), typeof c != "function" && (ad === null ? ad = /* @__PURE__ */ new Set([this]) : ad.add(this)), BE(this, o), typeof c == "function" || (i.lanes & 2) === 0 && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          Se(i) || "Unknown"
        );
      });
    }
    function Hd(e, t, i, o, c) {
      if (i.flags |= 32768, Bn && Fc(e, c), o !== null && typeof o == "object" && typeof o.then == "function") {
        if (t = i.alternate, t !== null && pi(
          t,
          i,
          c,
          !0
        ), Pt && (Al = !0), i = uo.current, i !== null) {
          switch (i.tag) {
            case 13:
              return As === null ? l1() : i.alternate === null && Pn === Wl && (Pn = Gv), i.flags &= -257, i.flags |= 65536, i.lanes = c, o === kv ? i.flags |= 16384 : (t = i.updateQueue, t === null ? i.updateQueue = /* @__PURE__ */ new Set([o]) : t.add(o), jm(e, o, c)), !1;
            case 22:
              return i.flags |= 65536, o === kv ? i.flags |= 16384 : (t = i.updateQueue, t === null ? (t = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([o])
              }, i.updateQueue = t) : (i = t.retryQueue, i === null ? t.retryQueue = /* @__PURE__ */ new Set([o]) : i.add(o)), jm(e, o, c)), !1;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + i.tag + "). This is a bug in React."
          );
        }
        return jm(e, o, c), l1(), !1;
      }
      if (Pt)
        return Al = !0, t = uo.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = c, o !== Cv && ac(
          ma(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: o }
            ),
            i
          )
        )) : (o !== Cv && ac(
          ma(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: o }
            ),
            i
          )
        ), e = e.current.alternate, e.flags |= 65536, c &= -c, e.lanes |= c, o = ma(o, i), c = Ci(
          e.stateNode,
          o,
          c
        ), oc(e, c), Pn !== w0 && (Pn = Sh)), !1;
      var h = ma(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: o }
        ),
        i
      );
      if (hf === null ? hf = [h] : hf.push(h), Pn !== w0 && (Pn = Sh), t === null) return !0;
      o = ma(o, i), i = t;
      do {
        switch (i.tag) {
          case 3:
            return i.flags |= 65536, e = c & -c, i.lanes |= e, e = Ci(
              i.stateNode,
              o,
              e
            ), oc(i, e), !1;
          case 1:
            if (t = i.type, h = i.stateNode, (i.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || h !== null && typeof h.componentDidCatch == "function" && (ad === null || !ad.has(h))))
              return i.flags |= 65536, c &= -c, i.lanes |= c, c = kn(c), Wd(
                c,
                e,
                i,
                o
              ), oc(i, c), !1;
        }
        i = i.return;
      } while (i !== null);
      return !1;
    }
    function jn(e, t, i, o) {
      t.child = e === null ? r6(t, null, i, o) : hh(
        t,
        e.child,
        i,
        o
      );
    }
    function Wu(e, t, i, o, c) {
      i = i.render;
      var h = t.ref;
      if ("ref" in o) {
        var v = {};
        for (var S in o)
          S !== "ref" && (v[S] = o[S]);
      } else v = o;
      return ss(t), Ht(t), o = hs(
        e,
        t,
        i,
        v,
        h,
        c
      ), S = Ki(), Nn(), e !== null && !Qi ? (bo(e, t, c), Ar(e, t, c)) : (Pt && S && Uu(t), t.flags |= 1, jn(e, t, o, c), t.child);
    }
    function wr(e, t, i, o, c) {
      if (e === null) {
        var h = i.type;
        return typeof h == "function" && !Yh(h) && h.defaultProps === void 0 && i.compare === null ? (i = el(h), t.tag = 15, t.type = i, Gu(t, h), zd(
          e,
          t,
          i,
          o,
          c
        )) : (e = Eu(
          i.type,
          null,
          o,
          t,
          t.mode,
          c
        ), e.ref = t.ref, e.return = t, t.child = e);
      }
      if (h = e.child, !$u(e, c)) {
        var v = h.memoizedProps;
        if (i = i.compare, i = i !== null ? i : Td, i(v, o) && e.ref === t.ref)
          return Ar(
            e,
            t,
            c
          );
      }
      return t.flags |= 1, e = Vr(h, o), e.ref = t.ref, e.return = t, t.child = e;
    }
    function zd(e, t, i, o, c) {
      if (e !== null) {
        var h = e.memoizedProps;
        if (Td(h, o) && e.ref === t.ref && t.type === e.type)
          if (Qi = !1, t.pendingProps = o = h, $u(e, c))
            (e.flags & 131072) !== 0 && (Qi = !0);
          else
            return t.lanes = e.lanes, Ar(e, t, c);
      }
      return ju(
        e,
        t,
        i,
        o,
        c
      );
    }
    function Hu(e, t, i) {
      var o = t.pendingProps, c = o.children, h = e !== null ? e.memoizedState : null;
      if (o.mode === "hidden") {
        if ((t.flags & 128) !== 0) {
          if (o = h !== null ? h.baseLanes | i : i, e !== null) {
            for (c = t.child = e.child, h = 0; c !== null; )
              h = h | c.lanes | c.childLanes, c = c.sibling;
            t.childLanes = h & ~o;
          } else t.childLanes = 0, t.child = null;
          return zu(
            e,
            t,
            o,
            i
          );
        }
        if ((i & 536870912) !== 0)
          t.memoizedState = { baseLanes: 0, cachePool: null }, e !== null && bu(
            t,
            h !== null ? h.cachePool : null
          ), h !== null ? Xi(t, h) : Md(t), gs(t);
        else
          return t.lanes = t.childLanes = 536870912, zu(
            e,
            t,
            h !== null ? h.baseLanes | i : i,
            i
          );
      } else
        h !== null ? (bu(t, h.cachePool), Xi(t, h), dr(t), t.memoizedState = null) : (e !== null && bu(t, null), Md(t), dr(t));
      return jn(e, t, c, i), t.child;
    }
    function zu(e, t, i, o) {
      var c = sm();
      return c = c === null ? null : {
        parent: Ui._currentValue,
        pool: c
      }, t.memoizedState = {
        baseLanes: i,
        cachePool: c
      }, e !== null && bu(t, null), Md(t), gs(t), e !== null && pi(e, t, o, !0), null;
    }
    function jd(e, t) {
      var i = t.ref;
      if (i === null)
        e !== null && e.ref !== null && (t.flags |= 4194816);
      else {
        if (typeof i != "function" && typeof i != "object")
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        (e === null || e.ref !== i) && (t.flags |= 4194816);
      }
    }
    function ju(e, t, i, o, c) {
      if (i.prototype && typeof i.prototype.render == "function") {
        var h = Re(i) || "Unknown";
        S6[h] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          h,
          h
        ), S6[h] = !0);
      }
      return t.mode & la && jo.recordLegacyContextWarning(
        t,
        null
      ), e === null && (Gu(t, t.type), i.contextTypes && (h = Re(i) || "Unknown", E6[h] || (E6[h] = !0, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        h
      )))), ss(t), Ht(t), i = hs(
        e,
        t,
        i,
        o,
        void 0,
        c
      ), o = Ki(), Nn(), e !== null && !Qi ? (bo(e, t, c), Ar(e, t, c)) : (Pt && o && Uu(t), t.flags |= 1, jn(e, t, i, c), t.child);
    }
    function Tm(e, t, i, o, c, h) {
      return ss(t), Ht(t), Ll = -1, nf = e !== null && e.type !== t.type, t.updateQueue = null, i = dc(
        t,
        o,
        i,
        c
      ), kd(e, t), o = Ki(), Nn(), e !== null && !Qi ? (bo(e, t, h), Ar(e, t, h)) : (Pt && o && Uu(t), t.flags |= 1, jn(e, t, i, h), t.child);
    }
    function ym(e, t, i, o, c) {
      switch (y(t)) {
        case !1:
          var h = t.stateNode, v = new t.type(
            t.memoizedProps,
            h.context
          ).state;
          h.updater.enqueueSetState(h, v, null);
          break;
        case !0:
          t.flags |= 128, t.flags |= 65536, h = Error("Simulated error coming from DevTools");
          var S = c & -c;
          if (t.lanes |= S, v = pn, v === null)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          S = kn(S), Wd(
            S,
            v,
            t,
            ma(h, t)
          ), oc(t, S);
      }
      if (ss(t), t.stateNode === null) {
        if (v = Kc, h = i.contextType, "contextType" in i && h !== null && (h === void 0 || h.$$typeof !== Pa) && !f6.has(i) && (f6.add(i), S = h === void 0 ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof h != "object" ? " However, it is set to a " + typeof h + "." : h.$$typeof === Z1 ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(h).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          Re(i) || "Component",
          S
        )), typeof h == "object" && h !== null && (v = mn(h)), h = new i(o, v), t.mode & la) {
          Ze(!0);
          try {
            h = new i(o, v);
          } finally {
            Ze(!1);
          }
        }
        if (v = t.memoizedState = h.state !== null && h.state !== void 0 ? h.state : null, h.updater = Lv, t.stateNode = h, h._reactInternals = t, h._reactInternalInstance = o6, typeof i.getDerivedStateFromProps == "function" && v === null && (v = Re(i) || "Component", l6.has(v) || (l6.add(v), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          v,
          h.state === null ? "null" : "undefined",
          v
        ))), typeof i.getDerivedStateFromProps == "function" || typeof h.getSnapshotBeforeUpdate == "function") {
          var M = S = v = null;
          if (typeof h.componentWillMount == "function" && h.componentWillMount.__suppressDeprecationWarning !== !0 ? v = "componentWillMount" : typeof h.UNSAFE_componentWillMount == "function" && (v = "UNSAFE_componentWillMount"), typeof h.componentWillReceiveProps == "function" && h.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? S = "componentWillReceiveProps" : typeof h.UNSAFE_componentWillReceiveProps == "function" && (S = "UNSAFE_componentWillReceiveProps"), typeof h.componentWillUpdate == "function" && h.componentWillUpdate.__suppressDeprecationWarning !== !0 ? M = "componentWillUpdate" : typeof h.UNSAFE_componentWillUpdate == "function" && (M = "UNSAFE_componentWillUpdate"), v !== null || S !== null || M !== null) {
            h = Re(i) || "Component";
            var x = typeof i.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            d6.has(h) || (d6.add(h), console.error(
              `Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://react.dev/link/unsafe-component-lifecycles`,
              h,
              x,
              v !== null ? `
  ` + v : "",
              S !== null ? `
  ` + S : "",
              M !== null ? `
  ` + M : ""
            ));
          }
        }
        h = t.stateNode, v = Re(i) || "Component", h.render || (i.prototype && typeof i.prototype.render == "function" ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          v
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          v
        )), !h.getInitialState || h.getInitialState.isReactClassApproved || h.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          v
        ), h.getDefaultProps && !h.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          v
        ), h.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          v
        ), i.childContextTypes && !p6.has(i) && (p6.add(i), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          v
        )), i.contextTypes && !m6.has(i) && (m6.add(i), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          v
        )), typeof h.componentShouldUpdate == "function" && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          v
        ), i.prototype && i.prototype.isPureReactComponent && typeof h.shouldComponentUpdate < "u" && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          Re(i) || "A pure component"
        ), typeof h.componentDidUnmount == "function" && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          v
        ), typeof h.componentDidReceiveProps == "function" && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          v
        ), typeof h.componentWillRecieveProps == "function" && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          v
        ), typeof h.UNSAFE_componentWillRecieveProps == "function" && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          v
        ), S = h.props !== o, h.props !== void 0 && S && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          v
        ), h.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          v,
          v
        ), typeof h.getSnapshotBeforeUpdate != "function" || typeof h.componentDidUpdate == "function" || c6.has(i) || (c6.add(i), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          Re(i)
        )), typeof h.getDerivedStateFromProps == "function" && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          v
        ), typeof h.getDerivedStateFromError == "function" && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          v
        ), typeof i.getSnapshotBeforeUpdate == "function" && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          v
        ), (S = h.state) && (typeof S != "object" || vt(S)) && console.error("%s.state: must be set to an object or null", v), typeof h.getChildContext == "function" && typeof i.childContextTypes != "object" && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          v
        ), h = t.stateNode, h.props = o, h.state = t.memoizedState, h.refs = {}, Yi(t), v = i.contextType, h.context = typeof v == "object" && v !== null ? mn(v) : Kc, h.state === o && (v = Re(i) || "Component", u6.has(v) || (u6.add(v), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          v
        ))), t.mode & la && jo.recordLegacyContextWarning(
          t,
          h
        ), jo.recordUnsafeLifecycleWarnings(
          t,
          h
        ), h.state = t.memoizedState, v = i.getDerivedStateFromProps, typeof v == "function" && (Fn(
          t,
          i,
          v,
          o
        ), h.state = t.memoizedState), typeof i.getDerivedStateFromProps == "function" || typeof h.getSnapshotBeforeUpdate == "function" || typeof h.UNSAFE_componentWillMount != "function" && typeof h.componentWillMount != "function" || (v = h.state, typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount(), v !== h.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          Se(t) || "Component"
        ), Lv.enqueueReplaceState(
          h,
          h.state,
          null
        )), sc(t, o, h, c), kr(), h.state = t.memoizedState), typeof h.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & zo) !== Un && (t.flags |= 134217728), h = !0;
      } else if (e === null) {
        h = t.stateNode;
        var ee = t.memoizedProps;
        S = vs(i, ee), h.props = S;
        var le = h.context;
        M = i.contextType, v = Kc, typeof M == "object" && M !== null && (v = mn(M)), x = i.getDerivedStateFromProps, M = typeof x == "function" || typeof h.getSnapshotBeforeUpdate == "function", ee = t.pendingProps !== ee, M || typeof h.UNSAFE_componentWillReceiveProps != "function" && typeof h.componentWillReceiveProps != "function" || (ee || le !== v) && Ju(
          t,
          h,
          o,
          v
        ), qc = !1;
        var q = t.memoizedState;
        h.state = q, sc(t, o, h, c), kr(), le = t.memoizedState, ee || q !== le || qc ? (typeof x == "function" && (Fn(
          t,
          i,
          x,
          o
        ), le = t.memoizedState), (S = qc || Au(
          t,
          i,
          S,
          o,
          q,
          le,
          v
        )) ? (M || typeof h.UNSAFE_componentWillMount != "function" && typeof h.componentWillMount != "function" || (typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & zo) !== Un && (t.flags |= 134217728)) : (typeof h.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & zo) !== Un && (t.flags |= 134217728), t.memoizedProps = o, t.memoizedState = le), h.props = o, h.state = le, h.context = v, h = S) : (typeof h.componentDidMount == "function" && (t.flags |= 4194308), (t.mode & zo) !== Un && (t.flags |= 134217728), h = !1);
      } else {
        h = t.stateNode, cs(e, t), v = t.memoizedProps, M = vs(i, v), h.props = M, x = t.pendingProps, q = h.context, le = i.contextType, S = Kc, typeof le == "object" && le !== null && (S = mn(le)), ee = i.getDerivedStateFromProps, (le = typeof ee == "function" || typeof h.getSnapshotBeforeUpdate == "function") || typeof h.UNSAFE_componentWillReceiveProps != "function" && typeof h.componentWillReceiveProps != "function" || (v !== x || q !== S) && Ju(
          t,
          h,
          o,
          S
        ), qc = !1, q = t.memoizedState, h.state = q, sc(t, o, h, c), kr();
        var ce = t.memoizedState;
        v !== x || q !== ce || qc || e !== null && e.dependencies !== null && os(e.dependencies) ? (typeof ee == "function" && (Fn(
          t,
          i,
          ee,
          o
        ), ce = t.memoizedState), (M = qc || Au(
          t,
          i,
          M,
          o,
          q,
          ce,
          S
        ) || e !== null && e.dependencies !== null && os(e.dependencies)) ? (le || typeof h.UNSAFE_componentWillUpdate != "function" && typeof h.componentWillUpdate != "function" || (typeof h.componentWillUpdate == "function" && h.componentWillUpdate(o, ce, S), typeof h.UNSAFE_componentWillUpdate == "function" && h.UNSAFE_componentWillUpdate(
          o,
          ce,
          S
        )), typeof h.componentDidUpdate == "function" && (t.flags |= 4), typeof h.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof h.componentDidUpdate != "function" || v === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof h.getSnapshotBeforeUpdate != "function" || v === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), t.memoizedProps = o, t.memoizedState = ce), h.props = o, h.state = ce, h.context = S, h = M) : (typeof h.componentDidUpdate != "function" || v === e.memoizedProps && q === e.memoizedState || (t.flags |= 4), typeof h.getSnapshotBeforeUpdate != "function" || v === e.memoizedProps && q === e.memoizedState || (t.flags |= 1024), h = !1);
      }
      if (S = h, jd(e, t), v = (t.flags & 128) !== 0, S || v) {
        if (S = t.stateNode, D(t), v && typeof i.getDerivedStateFromError != "function")
          i = null, Ka = -1;
        else {
          if (Ht(t), i = zR(S), t.mode & la) {
            Ze(!0);
            try {
              zR(S);
            } finally {
              Ze(!1);
            }
          }
          Nn();
        }
        t.flags |= 1, e !== null && v ? (t.child = hh(
          t,
          e.child,
          null,
          c
        ), t.child = hh(
          t,
          null,
          i,
          c
        )) : jn(e, t, i, c), t.memoizedState = S.state, e = t.child;
      } else
        e = Ar(
          e,
          t,
          c
        );
      return c = t.stateNode, h && c.props !== o && (fh || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        Se(t) || "a component"
      ), fh = !0), e;
    }
    function Nm(e, t, i, o) {
      return il(), t.flags |= 256, jn(e, t, i, o), t.child;
    }
    function Gu(e, t) {
      t && t.childContextTypes && console.error(
        `childContextTypes cannot be defined on a function component.
  %s.childContextTypes = ...`,
        t.displayName || t.name || "Component"
      ), typeof t.getDerivedStateFromProps == "function" && (e = Re(t) || "Unknown", U6[e] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        e
      ), U6[e] = !0)), typeof t.contextType == "object" && t.contextType !== null && (t = Re(t) || "Unknown", R6[t] || (console.error(
        "%s: Function components do not support contextType.",
        t
      ), R6[t] = !0));
    }
    function Gd(e) {
      return { baseLanes: e, cachePool: n2() };
    }
    function Pu(e, t, i) {
      return e = e !== null ? e.childLanes & ~i : 0, t && (e |= Sr), e;
    }
    function s2(e, t, i) {
      var o, c = t.pendingProps;
      R(t) && (t.flags |= 128);
      var h = !1, v = (t.flags & 128) !== 0;
      if ((o = v) || (o = e !== null && e.memoizedState === null ? !1 : (yi.current & rf) !== 0), o && (h = !0, t.flags &= -129), o = (t.flags & 32) !== 0, t.flags &= -33, e === null) {
        if (Pt) {
          if (h ? fa(t) : dr(t), Pt) {
            var S = Gn, M;
            if (!(M = !S)) {
              e: {
                var x = S;
                for (M = Bs; x.nodeType !== 8; ) {
                  if (!M) {
                    M = null;
                    break e;
                  }
                  if (x = Si(x.nextSibling), x === null) {
                    M = null;
                    break e;
                  }
                }
                M = x;
              }
              M !== null ? (nr(), t.memoizedState = {
                dehydrated: M,
                treeContext: k0 !== null ? { id: Bl, overflow: wl } : null,
                retryLane: 536870912,
                hydrationErrors: null
              }, x = b(18, null, null, Un), x.stateNode = M, x.return = t, t.child = x, ya = t, Gn = null, M = !0) : M = !1, M = !M;
            }
            M && (qh(
              t,
              S
            ), Cr(t));
          }
          if (S = t.memoizedState, S !== null && (S = S.dehydrated, S !== null))
            return Xr(S) ? t.lanes = 32 : t.lanes = 536870912, null;
          ga(t);
        }
        return S = c.children, c = c.fallback, h ? (dr(t), h = t.mode, S = Pd(
          {
            mode: "hidden",
            children: S
          },
          h
        ), c = is(
          c,
          h,
          i,
          null
        ), S.return = t, c.return = t, S.sibling = c, t.child = S, h = t.child, h.memoizedState = Gd(i), h.childLanes = Pu(
          e,
          o,
          i
        ), t.memoizedState = zv, c) : (fa(t), Yu(
          t,
          S
        ));
      }
      var ee = e.memoizedState;
      if (ee !== null && (S = ee.dehydrated, S !== null)) {
        if (v)
          t.flags & 256 ? (fa(t), t.flags &= -257, t = Xu(
            e,
            t,
            i
          )) : t.memoizedState !== null ? (dr(t), t.child = e.child, t.flags |= 128, t = null) : (dr(t), h = c.fallback, S = t.mode, c = Pd(
            {
              mode: "visible",
              children: c.children
            },
            S
          ), h = is(
            h,
            S,
            i,
            null
          ), h.flags |= 2, c.return = t, h.return = t, c.sibling = h, t.child = c, hh(
            t,
            e.child,
            null,
            i
          ), c = t.child, c.memoizedState = Gd(i), c.childLanes = Pu(
            e,
            o,
            i
          ), t.memoizedState = zv, t = h);
        else if (fa(t), Pt && console.error(
          "We should not be hydrating here. This is a bug in React. Please file a bug."
        ), Xr(S)) {
          if (o = S.nextSibling && S.nextSibling.dataset, o) {
            M = o.dgst;
            var le = o.msg;
            x = o.stck;
            var q = o.cstck;
          }
          S = le, o = M, c = x, M = h = q, h = Error(S || "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."), h.stack = c || "", h.digest = o, o = M === void 0 ? null : M, c = {
            value: h,
            source: null,
            stack: o
          }, typeof o == "string" && bv.set(
            h,
            c
          ), ac(c), t = Xu(
            e,
            t,
            i
          );
        } else if (Qi || pi(
          e,
          t,
          i,
          !1
        ), o = (i & e.childLanes) !== 0, Qi || o) {
          if (o = pn, o !== null && (c = i & -i, c = (c & 42) !== 0 ? 1 : Jn(
            c
          ), c = (c & (o.suspendedLanes | i)) !== 0 ? 0 : c, c !== 0 && c !== ee.retryLane))
            throw ee.retryLane = c, Pi(
              e,
              c
            ), Qn(
              o,
              e,
              c
            ), v6;
          S.data === Hl || l1(), t = Xu(
            e,
            t,
            i
          );
        } else
          S.data === Hl ? (t.flags |= 192, t.child = e.child, t = null) : (e = ee.treeContext, Gn = Si(
            S.nextSibling
          ), ya = t, Pt = !0, Q0 = null, Al = !1, oo = null, Bs = !1, e !== null && (nr(), ao[ro++] = Bl, ao[ro++] = wl, ao[ro++] = k0, Bl = e.id, wl = e.overflow, k0 = t), t = Yu(
            t,
            c.children
          ), t.flags |= 4096);
        return t;
      }
      return h ? (dr(t), h = c.fallback, S = t.mode, M = e.child, x = M.sibling, c = Vr(
        M,
        {
          mode: "hidden",
          children: c.children
        }
      ), c.subtreeFlags = M.subtreeFlags & 65011712, x !== null ? h = Vr(
        x,
        h
      ) : (h = is(
        h,
        S,
        i,
        null
      ), h.flags |= 2), h.return = t, c.return = t, c.sibling = h, t.child = c, c = h, h = t.child, S = e.child.memoizedState, S === null ? S = Gd(i) : (M = S.cachePool, M !== null ? (x = Ui._currentValue, M = M.parent !== x ? { parent: x, pool: x } : M) : M = n2(), S = {
        baseLanes: S.baseLanes | i,
        cachePool: M
      }), h.memoizedState = S, h.childLanes = Pu(
        e,
        o,
        i
      ), t.memoizedState = zv, c) : (fa(t), i = e.child, e = i.sibling, i = Vr(i, {
        mode: "visible",
        children: c.children
      }), i.return = t, i.sibling = null, e !== null && (o = t.deletions, o === null ? (t.deletions = [e], t.flags |= 16) : o.push(e)), t.child = i, t.memoizedState = null, i);
    }
    function Yu(e, t) {
      return t = Pd(
        { mode: "visible", children: t },
        e.mode
      ), t.return = e, e.child = t;
    }
    function Pd(e, t) {
      return e = b(22, e, null, t), e.lanes = 0, e.stateNode = {
        _visibility: H2,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      }, e;
    }
    function Xu(e, t, i) {
      return hh(t, e.child, null, i), e = Yu(
        t,
        t.pendingProps.children
      ), e.flags |= 2, t.memoizedState = null, e;
    }
    function Ku(e, t, i) {
      e.lanes |= t;
      var o = e.alternate;
      o !== null && (o.lanes |= t), im(
        e.return,
        t,
        i
      );
    }
    function bm(e, t) {
      var i = vt(e);
      return e = !i && typeof Ce(e) == "function", i || e ? (i = i ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        i,
        t,
        i
      ), !1) : !0;
    }
    function qu(e, t, i, o, c) {
      var h = e.memoizedState;
      h === null ? e.memoizedState = {
        isBackwards: t,
        rendering: null,
        renderingStartTime: 0,
        last: o,
        tail: i,
        tailMode: c
      } : (h.isBackwards = t, h.rendering = null, h.renderingStartTime = 0, h.last = o, h.tail = i, h.tailMode = c);
    }
    function Vm(e, t, i) {
      var o = t.pendingProps, c = o.revealOrder, h = o.tail;
      if (o = o.children, c !== void 0 && c !== "forwards" && c !== "backwards" && c !== "together" && !T6[c])
        if (T6[c] = !0, typeof c == "string")
          switch (c.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                c,
                c.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                c,
                c.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
                c
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?',
            c
          );
      h === void 0 || Hv[h] || (h !== "collapsed" && h !== "hidden" ? (Hv[h] = !0, console.error(
        '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?',
        h
      )) : c !== "forwards" && c !== "backwards" && (Hv[h] = !0, console.error(
        '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
        h
      )));
      e: if ((c === "forwards" || c === "backwards") && o !== void 0 && o !== null && o !== !1)
        if (vt(o)) {
          for (var v = 0; v < o.length; v++)
            if (!bm(o[v], v)) break e;
        } else if (v = Ce(o), typeof v == "function") {
          if (v = v.call(o))
            for (var S = v.next(), M = 0; !S.done; S = v.next()) {
              if (!bm(S.value, M)) break e;
              M++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            c
          );
      if (jn(e, t, o, i), o = yi.current, (o & rf) !== 0)
        o = o & mh | rf, t.flags |= 128;
      else {
        if (e !== null && (e.flags & 128) !== 0)
          e: for (e = t.child; e !== null; ) {
            if (e.tag === 13)
              e.memoizedState !== null && Ku(
                e,
                i,
                t
              );
            else if (e.tag === 19)
              Ku(e, i, t);
            else if (e.child !== null) {
              e.child.return = e, e = e.child;
              continue;
            }
            if (e === t) break e;
            for (; e.sibling === null; ) {
              if (e.return === null || e.return === t)
                break e;
              e = e.return;
            }
            e.sibling.return = e.return, e = e.sibling;
          }
        o &= mh;
      }
      switch (fe(yi, o, t), c) {
        case "forwards":
          for (i = t.child, c = null; i !== null; )
            e = i.alternate, e !== null && Mo(e) === null && (c = i), i = i.sibling;
          i = c, i === null ? (c = t.child, t.child = null) : (c = i.sibling, i.sibling = null), qu(
            t,
            !1,
            c,
            i,
            h
          );
          break;
        case "backwards":
          for (i = null, c = t.child, t.child = null; c !== null; ) {
            if (e = c.alternate, e !== null && Mo(e) === null) {
              t.child = c;
              break;
            }
            e = c.sibling, c.sibling = i, i = c, c = e;
          }
          qu(
            t,
            !0,
            i,
            null,
            h
          );
          break;
        case "together":
          qu(t, !1, null, null, void 0);
          break;
        default:
          t.memoizedState = null;
      }
      return t.child;
    }
    function Ar(e, t, i) {
      if (e !== null && (t.dependencies = e.dependencies), Ka = -1, nd |= t.lanes, (i & t.childLanes) === 0)
        if (e !== null) {
          if (pi(
            e,
            t,
            i,
            !1
          ), (i & t.childLanes) === 0)
            return null;
        } else return null;
      if (e !== null && t.child !== e.child)
        throw Error("Resuming work not yet implemented.");
      if (t.child !== null) {
        for (e = t.child, i = Vr(e, e.pendingProps), t.child = i, i.return = t; e.sibling !== null; )
          e = e.sibling, i = i.sibling = Vr(e, e.pendingProps), i.return = t;
        i.sibling = null;
      }
      return t.child;
    }
    function $u(e, t) {
      return (e.lanes & t) !== 0 ? !0 : (e = e.dependencies, !!(e !== null && os(e)));
    }
    function ov(e, t, i) {
      switch (t.tag) {
        case 3:
          Be(
            t,
            t.stateNode.containerInfo
          ), rs(
            t,
            Ui,
            e.memoizedState.cache
          ), il();
          break;
        case 27:
        case 5:
          X(t);
          break;
        case 4:
          Be(
            t,
            t.stateNode.containerInfo
          );
          break;
        case 10:
          rs(
            t,
            t.type,
            t.memoizedProps.value
          );
          break;
        case 12:
          (i & t.childLanes) !== 0 && (t.flags |= 4), t.flags |= 2048;
          var o = t.stateNode;
          o.effectDuration = -0, o.passiveEffectDuration = -0;
          break;
        case 13:
          if (o = t.memoizedState, o !== null)
            return o.dehydrated !== null ? (fa(t), t.flags |= 128, null) : (i & t.child.childLanes) !== 0 ? s2(
              e,
              t,
              i
            ) : (fa(t), e = Ar(
              e,
              t,
              i
            ), e !== null ? e.sibling : null);
          fa(t);
          break;
        case 19:
          var c = (e.flags & 128) !== 0;
          if (o = (i & t.childLanes) !== 0, o || (pi(
            e,
            t,
            i,
            !1
          ), o = (i & t.childLanes) !== 0), c) {
            if (o)
              return Vm(
                e,
                t,
                i
              );
            t.flags |= 128;
          }
          if (c = t.memoizedState, c !== null && (c.rendering = null, c.tail = null, c.lastEffect = null), fe(
            yi,
            yi.current,
            t
          ), o) break;
          return null;
        case 22:
        case 23:
          return t.lanes = 0, Hu(e, t, i);
        case 24:
          rs(
            t,
            Ui,
            e.memoizedState.cache
          );
      }
      return Ar(e, t, i);
    }
    function e1(e, t, i) {
      if (t._debugNeedsRemount && e !== null) {
        i = Eu(
          t.type,
          t.key,
          t.pendingProps,
          t._debugOwner || null,
          t.mode,
          t.lanes
        ), i._debugStack = t._debugStack, i._debugTask = t._debugTask;
        var o = t.return;
        if (o === null) throw Error("Cannot swap the root fiber.");
        if (e.alternate = null, t.alternate = null, i.index = t.index, i.sibling = t.sibling, i.return = t.return, i.ref = t.ref, i._debugInfo = t._debugInfo, t === o.child)
          o.child = i;
        else {
          var c = o.child;
          if (c === null)
            throw Error("Expected parent to have a child.");
          for (; c.sibling !== t; )
            if (c = c.sibling, c === null)
              throw Error("Expected to find the previous sibling.");
          c.sibling = i;
        }
        return t = o.deletions, t === null ? (o.deletions = [e], o.flags |= 16) : t.push(e), i.flags |= 2, i;
      }
      if (e !== null)
        if (e.memoizedProps !== t.pendingProps || t.type !== e.type)
          Qi = !0;
        else {
          if (!$u(e, i) && (t.flags & 128) === 0)
            return Qi = !1, ov(
              e,
              t,
              i
            );
          Qi = (e.flags & 131072) !== 0;
        }
      else
        Qi = !1, (o = Pt) && (nr(), o = (t.flags & 1048576) !== 0), o && (o = t.index, nr(), $f(t, j2, o));
      switch (t.lanes = 0, t.tag) {
        case 16:
          e: if (o = t.pendingProps, e = ed(t.elementType), t.type = e, typeof e == "function")
            Yh(e) ? (o = vs(
              e,
              o
            ), t.tag = 1, t.type = e = el(e), t = ym(
              null,
              t,
              e,
              o,
              i
            )) : (t.tag = 0, Gu(t, e), t.type = e = el(e), t = ju(
              null,
              t,
              e,
              o,
              i
            ));
          else {
            if (e != null) {
              if (c = e.$$typeof, c === wo) {
                t.tag = 11, t.type = e = Ph(e), t = Wu(
                  null,
                  t,
                  e,
                  o,
                  i
                );
                break e;
              } else if (c === S0) {
                t.tag = 14, t = wr(
                  null,
                  t,
                  e,
                  o,
                  i
                );
                break e;
              }
            }
            throw t = "", e !== null && typeof e == "object" && e.$$typeof === Ea && (t = " Did you wrap a component in React.lazy() more than once?"), e = Re(e) || e, Error(
              "Element type is invalid. Received a promise that resolves to: " + e + ". Lazy element type must resolve to a class or function." + t
            );
          }
          return t;
        case 0:
          return ju(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 1:
          return o = t.type, c = vs(
            o,
            t.pendingProps
          ), ym(
            e,
            t,
            o,
            c,
            i
          );
        case 3:
          e: {
            if (Be(
              t,
              t.stateNode.containerInfo
            ), e === null)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            o = t.pendingProps;
            var h = t.memoizedState;
            c = h.element, cs(e, t), sc(t, o, null, i);
            var v = t.memoizedState;
            if (o = v.cache, rs(t, Ui, o), o !== h.cache && am(
              t,
              [Ui],
              i,
              !0
            ), kr(), o = v.element, h.isDehydrated)
              if (h = {
                element: o,
                isDehydrated: !1,
                cache: v.cache
              }, t.updateQueue.baseState = h, t.memoizedState = h, t.flags & 256) {
                t = Nm(
                  e,
                  t,
                  o,
                  i
                );
                break e;
              } else if (o !== c) {
                c = ma(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  t
                ), ac(c), t = Nm(
                  e,
                  t,
                  o,
                  i
                );
                break e;
              } else {
                switch (e = t.stateNode.containerInfo, e.nodeType) {
                  case 9:
                    e = e.body;
                    break;
                  default:
                    e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
                }
                for (Gn = Si(e.firstChild), ya = t, Pt = !0, Q0 = null, Al = !1, oo = null, Bs = !0, e = r6(
                  t,
                  null,
                  o,
                  i
                ), t.child = e; e; )
                  e.flags = e.flags & -3 | 4096, e = e.sibling;
              }
            else {
              if (il(), o === c) {
                t = Ar(
                  e,
                  t,
                  i
                );
                break e;
              }
              jn(
                e,
                t,
                o,
                i
              );
            }
            t = t.child;
          }
          return t;
        case 26:
          return jd(e, t), e === null ? (e = Bo(
            t.type,
            null,
            t.pendingProps,
            null
          )) ? t.memoizedState = e : Pt || (e = t.type, i = t.pendingProps, o = be(
            qr.current
          ), o = Zt(
            o
          ).createElement(e), o[ki] = t, o[oa] = i, xn(o, e, i), j(o), t.stateNode = o) : t.memoizedState = Bo(
            t.type,
            e.memoizedProps,
            t.pendingProps,
            e.memoizedState
          ), null;
        case 27:
          return X(t), e === null && Pt && (o = be(qr.current), c = Z(), o = t.stateNode = up(
            t.type,
            t.pendingProps,
            o,
            c,
            !1
          ), Al || (c = dn(
            o,
            t.type,
            t.pendingProps,
            c
          ), c !== null && (ir(t, 0).serverProps = c)), ya = t, Bs = !0, c = Gn, Yr(t.type) ? (pS = c, Gn = Si(
            o.firstChild
          )) : Gn = c), jn(
            e,
            t,
            t.pendingProps.children,
            i
          ), jd(e, t), e === null && (t.flags |= 4194304), t.child;
        case 5:
          return e === null && Pt && (h = Z(), o = uu(
            t.type,
            h.ancestorInfo
          ), c = Gn, (v = !c) || (v = Ns(
            c,
            t.type,
            t.pendingProps,
            Bs
          ), v !== null ? (t.stateNode = v, Al || (h = dn(
            v,
            t.type,
            t.pendingProps,
            h
          ), h !== null && (ir(t, 0).serverProps = h)), ya = t, Gn = Si(
            v.firstChild
          ), Bs = !1, h = !0) : h = !1, v = !h), v && (o && qh(t, c), Cr(t))), X(t), c = t.type, h = t.pendingProps, v = e !== null ? e.memoizedProps : null, o = h.children, Pr(c, h) ? o = null : v !== null && Pr(c, v) && (t.flags |= 32), t.memoizedState !== null && (c = hs(
            e,
            t,
            Aa,
            null,
            null,
            i
          ), Ef._currentValue = c), jd(e, t), jn(
            e,
            t,
            o,
            i
          ), t.child;
        case 6:
          return e === null && Pt && (e = t.pendingProps, i = Z(), o = i.ancestorInfo.current, e = o != null ? Sd(
            e,
            o.tag,
            i.ancestorInfo.implicitRootScope
          ) : !0, i = Gn, (o = !i) || (o = vi(
            i,
            t.pendingProps,
            Bs
          ), o !== null ? (t.stateNode = o, ya = t, Gn = null, o = !0) : o = !1, o = !o), o && (e && qh(t, i), Cr(t))), null;
        case 13:
          return s2(e, t, i);
        case 4:
          return Be(
            t,
            t.stateNode.containerInfo
          ), o = t.pendingProps, e === null ? t.child = hh(
            t,
            null,
            o,
            i
          ) : jn(
            e,
            t,
            o,
            i
          ), t.child;
        case 11:
          return Wu(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 7:
          return jn(
            e,
            t,
            t.pendingProps,
            i
          ), t.child;
        case 8:
          return jn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 12:
          return t.flags |= 4, t.flags |= 2048, o = t.stateNode, o.effectDuration = -0, o.passiveEffectDuration = -0, jn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 10:
          return o = t.type, c = t.pendingProps, h = c.value, "value" in c || y6 || (y6 = !0, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), rs(t, o, h), jn(
            e,
            t,
            c.children,
            i
          ), t.child;
        case 9:
          return c = t.type._context, o = t.pendingProps.children, typeof o != "function" && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), ss(t), c = mn(c), Ht(t), o = wv(
            o,
            c,
            void 0
          ), Nn(), t.flags |= 1, jn(
            e,
            t,
            o,
            i
          ), t.child;
        case 14:
          return wr(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 15:
          return zd(
            e,
            t,
            t.type,
            t.pendingProps,
            i
          );
        case 19:
          return Vm(
            e,
            t,
            i
          );
        case 31:
          return o = t.pendingProps, i = t.mode, o = {
            mode: o.mode,
            children: o.children
          }, e === null ? (e = Pd(
            o,
            i
          ), e.ref = t.ref, t.child = e, e.return = t, t = e) : (e = Vr(e.child, o), e.ref = t.ref, t.child = e, e.return = t, t = e), t;
        case 22:
          return Hu(e, t, i);
        case 24:
          return ss(t), o = mn(Ui), e === null ? (c = sm(), c === null && (c = pn, h = Fd(), c.pooledCache = h, al(h), h !== null && (c.pooledCacheLanes |= i), c = h), t.memoizedState = {
            parent: o,
            cache: c
          }, Yi(t), rs(t, Ui, c)) : ((e.lanes & i) !== 0 && (cs(e, t), sc(t, null, null, i), kr()), c = e.memoizedState, h = t.memoizedState, c.parent !== o ? (c = {
            parent: o,
            cache: o
          }, t.memoizedState = c, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = c), rs(t, Ui, o)) : (o = h.cache, rs(t, Ui, o), o !== c.cache && am(
            t,
            [Ui],
            i,
            !0
          ))), jn(
            e,
            t,
            t.pendingProps.children,
            i
          ), t.child;
        case 29:
          throw t.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function $i(e) {
      e.flags |= 4;
    }
    function Yd(e, t) {
      if (t.type !== "stylesheet" || (t.state.loading & ho) !== G0)
        e.flags &= -16777217;
      else if (e.flags |= 16777216, !c0(t)) {
        if (t = uo.current, t !== null && ((wt & 4194048) === wt ? As !== null : (wt & 62914560) !== wt && (wt & 536870912) === 0 || t !== As))
          throw ef = kv, DR;
        e.flags |= 8192;
      }
    }
    function Xd(e, t) {
      t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag !== 22 ? bi() : 536870912, e.lanes |= t, L0 |= t);
    }
    function Ss(e, t) {
      if (!Pt)
        switch (e.tailMode) {
          case "hidden":
            t = e.tail;
            for (var i = null; t !== null; )
              t.alternate !== null && (i = t), t = t.sibling;
            i === null ? e.tail = null : i.sibling = null;
            break;
          case "collapsed":
            i = e.tail;
            for (var o = null; i !== null; )
              i.alternate !== null && (o = i), i = i.sibling;
            o === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : o.sibling = null;
        }
    }
    function on(e) {
      var t = e.alternate !== null && e.alternate.child === e.child, i = 0, o = 0;
      if (t)
        if ((e.mode & Hi) !== Un) {
          for (var c = e.selfBaseDuration, h = e.child; h !== null; )
            i |= h.lanes | h.childLanes, o |= h.subtreeFlags & 65011712, o |= h.flags & 65011712, c += h.treeBaseDuration, h = h.sibling;
          e.treeBaseDuration = c;
        } else
          for (c = e.child; c !== null; )
            i |= c.lanes | c.childLanes, o |= c.subtreeFlags & 65011712, o |= c.flags & 65011712, c.return = e, c = c.sibling;
      else if ((e.mode & Hi) !== Un) {
        c = e.actualDuration, h = e.selfBaseDuration;
        for (var v = e.child; v !== null; )
          i |= v.lanes | v.childLanes, o |= v.subtreeFlags, o |= v.flags, c += v.actualDuration, h += v.treeBaseDuration, v = v.sibling;
        e.actualDuration = c, e.treeBaseDuration = h;
      } else
        for (c = e.child; c !== null; )
          i |= c.lanes | c.childLanes, o |= c.subtreeFlags, o |= c.flags, c.return = e, c = c.sibling;
      return e.subtreeFlags |= o, e.childLanes = i, t;
    }
    function l2(e, t, i) {
      var o = t.pendingProps;
      switch (Tu(t), t.tag) {
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return on(t), null;
        case 1:
          return on(t), null;
        case 3:
          return i = t.stateNode, o = null, e !== null && (o = e.memoizedState.cache), t.memoizedState.cache !== o && (t.flags |= 2048), yo(Ui, t), De(t), i.pendingContext && (i.context = i.pendingContext, i.pendingContext = null), (e === null || e.child === null) && (nl(t) ? (nm(), $i(t)) : e === null || e.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, tm())), on(t), null;
        case 26:
          return i = t.memoizedState, e === null ? ($i(t), i !== null ? (on(t), Yd(
            t,
            i
          )) : (on(t), t.flags &= -16777217)) : i ? i !== e.memoizedState ? ($i(t), on(t), Yd(
            t,
            i
          )) : (on(t), t.flags &= -16777217) : (e.memoizedProps !== o && $i(t), on(t), t.flags &= -16777217), null;
        case 27:
          ae(t), i = be(qr.current);
          var c = t.type;
          if (e !== null && t.stateNode != null)
            e.memoizedProps !== o && $i(t);
          else {
            if (!o) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return on(t), null;
            }
            e = Z(), nl(t) ? $h(t) : (e = up(
              c,
              o,
              i,
              e,
              !0
            ), t.stateNode = e, $i(t));
          }
          return on(t), null;
        case 5:
          if (ae(t), i = t.type, e !== null && t.stateNode != null)
            e.memoizedProps !== o && $i(t);
          else {
            if (!o) {
              if (t.stateNode === null)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              return on(t), null;
            }
            if (c = Z(), nl(t))
              $h(t);
            else {
              switch (e = be(qr.current), uu(i, c.ancestorInfo), c = c.context, e = Zt(e), c) {
                case Nh:
                  e = e.createElementNS(Xc, i);
                  break;
                case Rg:
                  e = e.createElementNS(
                    _0,
                    i
                  );
                  break;
                default:
                  switch (i) {
                    case "svg":
                      e = e.createElementNS(
                        Xc,
                        i
                      );
                      break;
                    case "math":
                      e = e.createElementNS(
                        _0,
                        i
                      );
                      break;
                    case "script":
                      e = e.createElement("div"), e.innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild);
                      break;
                    case "select":
                      e = typeof o.is == "string" ? e.createElement("select", { is: o.is }) : e.createElement("select"), o.multiple ? e.multiple = !0 : o.size && (e.size = o.size);
                      break;
                    default:
                      e = typeof o.is == "string" ? e.createElement(i, {
                        is: o.is
                      }) : e.createElement(i), i.indexOf("-") === -1 && (i !== i.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        i
                      ), Object.prototype.toString.call(e) !== "[object HTMLUnknownElement]" || Jo.call(
                        I6,
                        i
                      ) || (I6[i] = !0, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        i
                      )));
                  }
              }
              e[ki] = t, e[oa] = o;
              e: for (c = t.child; c !== null; ) {
                if (c.tag === 5 || c.tag === 6)
                  e.appendChild(c.stateNode);
                else if (c.tag !== 4 && c.tag !== 27 && c.child !== null) {
                  c.child.return = c, c = c.child;
                  continue;
                }
                if (c === t) break e;
                for (; c.sibling === null; ) {
                  if (c.return === null || c.return === t)
                    break e;
                  c = c.return;
                }
                c.sibling.return = c.return, c = c.sibling;
              }
              t.stateNode = e;
              e: switch (xn(e, i, o), i) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  e = !!o.autoFocus;
                  break e;
                case "img":
                  e = !0;
                  break e;
                default:
                  e = !1;
              }
              e && $i(t);
            }
          }
          return on(t), t.flags &= -16777217, null;
        case 6:
          if (e && t.stateNode != null)
            e.memoizedProps !== o && $i(t);
          else {
            if (typeof o != "string" && t.stateNode === null)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            if (e = be(qr.current), i = Z(), nl(t)) {
              e = t.stateNode, i = t.memoizedProps, c = !Al, o = null;
              var h = ya;
              if (h !== null)
                switch (h.tag) {
                  case 3:
                    c && (c = V1(
                      e,
                      i,
                      o
                    ), c !== null && (ir(t, 0).serverProps = c));
                    break;
                  case 27:
                  case 5:
                    o = h.memoizedProps, c && (c = V1(
                      e,
                      i,
                      o
                    ), c !== null && (ir(
                      t,
                      0
                    ).serverProps = c));
                }
              e[ki] = t, e = !!(e.nodeValue === i || o !== null && o.suppressHydrationWarning === !0 || tp(e.nodeValue, i)), e || Cr(t);
            } else
              c = i.ancestorInfo.current, c != null && Sd(
                o,
                c.tag,
                i.ancestorInfo.implicitRootScope
              ), e = Zt(e).createTextNode(
                o
              ), e[ki] = t, t.stateNode = e;
          }
          return on(t), null;
        case 13:
          if (o = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            if (c = nl(t), o !== null && o.dehydrated !== null) {
              if (e === null) {
                if (!c)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                if (c = t.memoizedState, c = c !== null ? c.dehydrated : null, !c)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                c[ki] = t, on(t), (t.mode & Hi) !== Un && o !== null && (c = t.child, c !== null && (t.treeBaseDuration -= c.treeBaseDuration));
              } else
                nm(), il(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4, on(t), (t.mode & Hi) !== Un && o !== null && (c = t.child, c !== null && (t.treeBaseDuration -= c.treeBaseDuration));
              c = !1;
            } else
              c = tm(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = c), c = !0;
            if (!c)
              return t.flags & 256 ? (ga(t), t) : (ga(t), null);
          }
          return ga(t), (t.flags & 128) !== 0 ? (t.lanes = i, (t.mode & Hi) !== Un && _r(t), t) : (i = o !== null, e = e !== null && e.memoizedState !== null, i && (o = t.child, c = null, o.alternate !== null && o.alternate.memoizedState !== null && o.alternate.memoizedState.cachePool !== null && (c = o.alternate.memoizedState.cachePool.pool), h = null, o.memoizedState !== null && o.memoizedState.cachePool !== null && (h = o.memoizedState.cachePool.pool), h !== c && (o.flags |= 2048)), i !== e && i && (t.child.flags |= 8192), Xd(t, t.updateQueue), on(t), (t.mode & Hi) !== Un && i && (e = t.child, e !== null && (t.treeBaseDuration -= e.treeBaseDuration)), null);
        case 4:
          return De(t), e === null && $m(
            t.stateNode.containerInfo
          ), on(t), null;
        case 10:
          return yo(t.type, t), on(t), null;
        case 19:
          if (Qe(yi, t), c = t.memoizedState, c === null) return on(t), null;
          if (o = (t.flags & 128) !== 0, h = c.rendering, h === null)
            if (o) Ss(c, !1);
            else {
              if (Pn !== Wl || e !== null && (e.flags & 128) !== 0)
                for (e = t.child; e !== null; ) {
                  if (h = Mo(e), h !== null) {
                    for (t.flags |= 128, Ss(c, !1), e = h.updateQueue, t.updateQueue = e, Xd(t, e), t.subtreeFlags = 0, e = i, i = t.child; i !== null; )
                      Xh(i, e), i = i.sibling;
                    return fe(
                      yi,
                      yi.current & mh | rf,
                      t
                    ), t.child;
                  }
                  e = e.sibling;
                }
              c.tail !== null && $r() > sg && (t.flags |= 128, o = !0, Ss(c, !1), t.lanes = 4194304);
            }
          else {
            if (!o)
              if (e = Mo(h), e !== null) {
                if (t.flags |= 128, o = !0, e = e.updateQueue, t.updateQueue = e, Xd(t, e), Ss(c, !0), c.tail === null && c.tailMode === "hidden" && !h.alternate && !Pt)
                  return on(t), null;
              } else
                2 * $r() - c.renderingStartTime > sg && i !== 536870912 && (t.flags |= 128, o = !0, Ss(c, !1), t.lanes = 4194304);
            c.isBackwards ? (h.sibling = t.child, t.child = h) : (e = c.last, e !== null ? e.sibling = h : t.child = h, c.last = h);
          }
          return c.tail !== null ? (e = c.tail, c.rendering = e, c.tail = e.sibling, c.renderingStartTime = $r(), e.sibling = null, i = yi.current, i = o ? i & mh | rf : i & mh, fe(yi, i, t), e) : (on(t), null);
        case 22:
        case 23:
          return ga(t), sr(t), o = t.memoizedState !== null, e !== null ? e.memoizedState !== null !== o && (t.flags |= 8192) : o && (t.flags |= 8192), o ? (i & 536870912) !== 0 && (t.flags & 128) === 0 && (on(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : on(t), i = t.updateQueue, i !== null && Xd(t, i.retryQueue), i = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (i = e.memoizedState.cachePool.pool), o = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (o = t.memoizedState.cachePool.pool), o !== i && (t.flags |= 2048), e !== null && Qe(Z0, t), null;
        case 24:
          return i = null, e !== null && (i = e.memoizedState.cache), t.memoizedState.cache !== i && (t.flags |= 2048), yo(Ui, t), on(t), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + t.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function c2(e, t) {
      switch (Tu(t), t.tag) {
        case 1:
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Hi) !== Un && _r(t), t) : null;
        case 3:
          return yo(Ui, t), De(t), e = t.flags, (e & 65536) !== 0 && (e & 128) === 0 ? (t.flags = e & -65537 | 128, t) : null;
        case 26:
        case 27:
        case 5:
          return ae(t), null;
        case 13:
          if (ga(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
            if (t.alternate === null)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            il();
          }
          return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Hi) !== Un && _r(t), t) : null;
        case 19:
          return Qe(yi, t), null;
        case 4:
          return De(t), null;
        case 10:
          return yo(t.type, t), null;
        case 22:
        case 23:
          return ga(t), sr(t), e !== null && Qe(Z0, t), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, (t.mode & Hi) !== Un && _r(t), t) : null;
        case 24:
          return yo(Ui, t), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function Cm(e, t) {
      switch (Tu(t), t.tag) {
        case 3:
          yo(Ui, t), De(t);
          break;
        case 26:
        case 27:
        case 5:
          ae(t);
          break;
        case 4:
          De(t);
          break;
        case 13:
          ga(t);
          break;
        case 19:
          Qe(yi, t);
          break;
        case 10:
          yo(t.type, t);
          break;
        case 22:
        case 23:
          ga(t), sr(t), e !== null && Qe(Z0, t);
          break;
        case 24:
          yo(Ui, t);
      }
    }
    function ur(e) {
      return (e.mode & Hi) !== Un;
    }
    function Fm(e, t) {
      ur(e) ? (rr(), ml(t, e), Oa()) : ml(t, e);
    }
    function t1(e, t, i) {
      ur(e) ? (rr(), pl(
        i,
        e,
        t
      ), Oa()) : pl(
        i,
        e,
        t
      );
    }
    function ml(e, t) {
      try {
        var i = t.updateQueue, o = i !== null ? i.lastEffect : null;
        if (o !== null) {
          var c = o.next;
          i = c;
          do {
            if ((i.tag & e) === e && ((e & Ti) !== so ? Le !== null && typeof Le.markComponentPassiveEffectMountStarted == "function" && Le.markComponentPassiveEffectMountStarted(
              t
            ) : (e & zi) !== so && Le !== null && typeof Le.markComponentLayoutEffectMountStarted == "function" && Le.markComponentLayoutEffectMountStarted(
              t
            ), o = void 0, (e & Na) !== so && (Th = !0), o = He(
              t,
              wE,
              i
            ), (e & Na) !== so && (Th = !1), (e & Ti) !== so ? Le !== null && typeof Le.markComponentPassiveEffectMountStopped == "function" && Le.markComponentPassiveEffectMountStopped() : (e & zi) !== so && Le !== null && typeof Le.markComponentLayoutEffectMountStopped == "function" && Le.markComponentLayoutEffectMountStopped(), o !== void 0 && typeof o != "function")) {
              var h = void 0;
              h = (i.tag & zi) !== 0 ? "useLayoutEffect" : (i.tag & Na) !== 0 ? "useInsertionEffect" : "useEffect";
              var v = void 0;
              v = o === null ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof o.then == "function" ? `

It looks like you wrote ` + h + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + h + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching` : " You returned: " + o, He(
                t,
                function(S, M) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    S,
                    M
                  );
                },
                h,
                v
              );
            }
            i = i.next;
          } while (i !== c);
        }
      } catch (S) {
        st(t, t.return, S);
      }
    }
    function pl(e, t, i) {
      try {
        var o = t.updateQueue, c = o !== null ? o.lastEffect : null;
        if (c !== null) {
          var h = c.next;
          o = h;
          do {
            if ((o.tag & e) === e) {
              var v = o.inst, S = v.destroy;
              S !== void 0 && (v.destroy = void 0, (e & Ti) !== so ? Le !== null && typeof Le.markComponentPassiveEffectUnmountStarted == "function" && Le.markComponentPassiveEffectUnmountStarted(
                t
              ) : (e & zi) !== so && Le !== null && typeof Le.markComponentLayoutEffectUnmountStarted == "function" && Le.markComponentLayoutEffectUnmountStarted(
                t
              ), (e & Na) !== so && (Th = !0), c = t, He(
                c,
                AE,
                c,
                i,
                S
              ), (e & Na) !== so && (Th = !1), (e & Ti) !== so ? Le !== null && typeof Le.markComponentPassiveEffectUnmountStopped == "function" && Le.markComponentPassiveEffectUnmountStopped() : (e & zi) !== so && Le !== null && typeof Le.markComponentLayoutEffectUnmountStopped == "function" && Le.markComponentLayoutEffectUnmountStopped());
            }
            o = o.next;
          } while (o !== h);
        }
      } catch (M) {
        st(t, t.return, M);
      }
    }
    function _m(e, t) {
      ur(e) ? (rr(), ml(t, e), Oa()) : ml(t, e);
    }
    function Kd(e, t, i) {
      ur(e) ? (rr(), pl(
        i,
        e,
        t
      ), Oa()) : pl(
        i,
        e,
        t
      );
    }
    function Mm(e) {
      var t = e.updateQueue;
      if (t !== null) {
        var i = e.stateNode;
        e.type.defaultProps || "ref" in e.memoizedProps || fh || (i.props !== e.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          Se(e) || "instance"
        ), i.state !== e.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          Se(e) || "instance"
        ));
        try {
          He(
            e,
            i2,
            t,
            i
          );
        } catch (o) {
          st(e, e.return, o);
        }
      }
    }
    function d2(e, t, i) {
      return e.getSnapshotBeforeUpdate(t, i);
    }
    function sv(e, t) {
      var i = t.memoizedProps, o = t.memoizedState;
      t = e.stateNode, e.type.defaultProps || "ref" in e.memoizedProps || fh || (t.props !== e.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        Se(e) || "instance"
      ), t.state !== e.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        Se(e) || "instance"
      ));
      try {
        var c = vs(
          e.type,
          i,
          e.elementType === e.type
        ), h = He(
          e,
          d2,
          t,
          c,
          o
        );
        i = N6, h !== void 0 || i.has(e.type) || (i.add(e.type), He(e, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            Se(e)
          );
        })), t.__reactInternalSnapshotBeforeUpdate = h;
      } catch (v) {
        st(e, e.return, v);
      }
    }
    function n1(e, t, i) {
      i.props = vs(
        e.type,
        e.memoizedProps
      ), i.state = e.memoizedState, ur(e) ? (rr(), He(
        e,
        KR,
        e,
        t,
        i
      ), Oa()) : He(
        e,
        KR,
        e,
        t,
        i
      );
    }
    function u2(e) {
      var t = e.ref;
      if (t !== null) {
        switch (e.tag) {
          case 26:
          case 27:
          case 5:
            var i = e.stateNode;
            break;
          case 30:
            i = e.stateNode;
            break;
          default:
            i = e.stateNode;
        }
        if (typeof t == "function")
          if (ur(e))
            try {
              rr(), e.refCleanup = t(i);
            } finally {
              Oa();
            }
          else e.refCleanup = t(i);
        else
          typeof t == "string" ? console.error("String refs are no longer supported.") : t.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            Se(e)
          ), t.current = i;
      }
    }
    function Uc(e, t) {
      try {
        He(e, u2, e);
      } catch (i) {
        st(e, t, i);
      }
    }
    function Ha(e, t) {
      var i = e.ref, o = e.refCleanup;
      if (i !== null)
        if (typeof o == "function")
          try {
            if (ur(e))
              try {
                rr(), He(e, o);
              } finally {
                Oa(e);
              }
            else He(e, o);
          } catch (c) {
            st(e, t, c);
          } finally {
            e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
          }
        else if (typeof i == "function")
          try {
            if (ur(e))
              try {
                rr(), He(e, i, null);
              } finally {
                Oa(e);
              }
            else He(e, i, null);
          } catch (c) {
            st(e, t, c);
          }
        else i.current = null;
    }
    function km(e, t, i, o) {
      var c = e.memoizedProps, h = c.id, v = c.onCommit;
      c = c.onRender, t = t === null ? "mount" : "update", Y2 && (t = "nested-update"), typeof c == "function" && c(
        h,
        t,
        e.actualDuration,
        e.treeBaseDuration,
        e.actualStartTime,
        i
      ), typeof v == "function" && v(
        e.memoizedProps.id,
        t,
        o,
        i
      );
    }
    function h2(e, t, i, o) {
      var c = e.memoizedProps;
      e = c.id, c = c.onPostCommit, t = t === null ? "mount" : "update", Y2 && (t = "nested-update"), typeof c == "function" && c(
        e,
        t,
        o,
        i
      );
    }
    function m2(e) {
      var t = e.type, i = e.memoizedProps, o = e.stateNode;
      try {
        He(
          e,
          Zo,
          o,
          t,
          i,
          e
        );
      } catch (c) {
        st(e, e.return, c);
      }
    }
    function Qm(e, t, i) {
      try {
        He(
          e,
          Zn,
          e.stateNode,
          e.type,
          i,
          t,
          e
        );
      } catch (o) {
        st(e, e.return, o);
      }
    }
    function Dm(e) {
      return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Yr(e.type) || e.tag === 4;
    }
    function fl(e) {
      e: for (; ; ) {
        for (; e.sibling === null; ) {
          if (e.return === null || Dm(e.return)) return null;
          e = e.return;
        }
        for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18; ) {
          if (e.tag === 27 && Yr(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue e;
          e.child.return = e, e = e.child;
        }
        if (!(e.flags & 2)) return e.stateNode;
      }
    }
    function qd(e, t, i) {
      var o = e.tag;
      if (o === 5 || o === 6)
        e = e.stateNode, t ? (i.nodeType === 9 ? i.body : i.nodeName === "HTML" ? i.ownerDocument.body : i).insertBefore(e, t) : (t = i.nodeType === 9 ? i.body : i.nodeName === "HTML" ? i.ownerDocument.body : i, t.appendChild(e), i = i._reactRootContainer, i != null || t.onclick !== null || (t.onclick = xo));
      else if (o !== 4 && (o === 27 && Yr(e.type) && (i = e.stateNode, t = null), e = e.child, e !== null))
        for (qd(e, t, i), e = e.sibling; e !== null; )
          qd(e, t, i), e = e.sibling;
    }
    function gl(e, t, i) {
      var o = e.tag;
      if (o === 5 || o === 6)
        e = e.stateNode, t ? i.insertBefore(e, t) : i.appendChild(e);
      else if (o !== 4 && (o === 27 && Yr(e.type) && (i = e.stateNode), e = e.child, e !== null))
        for (gl(e, t, i), e = e.sibling; e !== null; )
          gl(e, t, i), e = e.sibling;
    }
    function p2(e) {
      for (var t, i = e.return; i !== null; ) {
        if (Dm(i)) {
          t = i;
          break;
        }
        i = i.return;
      }
      if (t == null)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (t.tag) {
        case 27:
          t = t.stateNode, i = fl(e), gl(
            e,
            i,
            t
          );
          break;
        case 5:
          i = t.stateNode, t.flags & 32 && (Oo(i), t.flags &= -33), t = fl(e), gl(
            e,
            t,
            i
          );
          break;
        case 3:
        case 4:
          t = t.stateNode.containerInfo, i = fl(e), qd(
            e,
            i,
            t
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function xm(e) {
      var t = e.stateNode, i = e.memoizedProps;
      try {
        He(
          e,
          Ra,
          e.type,
          i,
          t,
          e
        );
      } catch (o) {
        st(e, e.return, o);
      }
    }
    function i1(e, t) {
      if (e = e.containerInfo, uS = yg, e = Pf(e), jh(e)) {
        if ("selectionStart" in e)
          var i = {
            start: e.selectionStart,
            end: e.selectionEnd
          };
        else
          e: {
            i = (i = e.ownerDocument) && i.defaultView || window;
            var o = i.getSelection && i.getSelection();
            if (o && o.rangeCount !== 0) {
              i = o.anchorNode;
              var c = o.anchorOffset, h = o.focusNode;
              o = o.focusOffset;
              try {
                i.nodeType, h.nodeType;
              } catch {
                i = null;
                break e;
              }
              var v = 0, S = -1, M = -1, x = 0, ee = 0, le = e, q = null;
              t: for (; ; ) {
                for (var ce; le !== i || c !== 0 && le.nodeType !== 3 || (S = v + c), le !== h || o !== 0 && le.nodeType !== 3 || (M = v + o), le.nodeType === 3 && (v += le.nodeValue.length), (ce = le.firstChild) !== null; )
                  q = le, le = ce;
                for (; ; ) {
                  if (le === e) break t;
                  if (q === i && ++x === c && (S = v), q === h && ++ee === o && (M = v), (ce = le.nextSibling) !== null) break;
                  le = q, q = le.parentNode;
                }
                le = ce;
              }
              i = S === -1 || M === -1 ? null : { start: S, end: M };
            } else i = null;
          }
        i = i || { start: 0, end: 0 };
      } else i = null;
      for (hS = {
        focusedElem: e,
        selectionRange: i
      }, yg = !1, Di = t; Di !== null; )
        if (t = Di, e = t.child, (t.subtreeFlags & 1024) !== 0 && e !== null)
          e.return = t, Di = e;
        else
          for (; Di !== null; ) {
            switch (e = t = Di, i = e.alternate, c = e.flags, e.tag) {
              case 0:
                break;
              case 11:
              case 15:
                break;
              case 1:
                (c & 1024) !== 0 && i !== null && sv(e, i);
                break;
              case 3:
                if ((c & 1024) !== 0) {
                  if (e = e.stateNode.containerInfo, i = e.nodeType, i === 9)
                    Qc(e);
                  else if (i === 1)
                    switch (e.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        Qc(e);
                        break;
                      default:
                        e.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if ((c & 1024) !== 0)
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            if (e = t.sibling, e !== null) {
              e.return = t.return, Di = e;
              break;
            }
            Di = t.return;
          }
    }
    function Zm(e, t, i) {
      var o = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          Jr(e, i), o & 4 && Fm(i, zi | lo);
          break;
        case 1:
          if (Jr(e, i), o & 4)
            if (e = i.stateNode, t === null)
              i.type.defaultProps || "ref" in i.memoizedProps || fh || (e.props !== i.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                Se(i) || "instance"
              ), e.state !== i.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                Se(i) || "instance"
              )), ur(i) ? (rr(), He(
                i,
                Av,
                i,
                e
              ), Oa()) : He(
                i,
                Av,
                i,
                e
              );
            else {
              var c = vs(
                i.type,
                t.memoizedProps
              );
              t = t.memoizedState, i.type.defaultProps || "ref" in i.memoizedProps || fh || (e.props !== i.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                Se(i) || "instance"
              ), e.state !== i.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                Se(i) || "instance"
              )), ur(i) ? (rr(), He(
                i,
                PR,
                i,
                e,
                c,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              ), Oa()) : He(
                i,
                PR,
                i,
                e,
                c,
                t,
                e.__reactInternalSnapshotBeforeUpdate
              );
            }
          o & 64 && Mm(i), o & 512 && Uc(i, i.return);
          break;
        case 3:
          if (t = ar(), Jr(e, i), o & 64 && (o = i.updateQueue, o !== null)) {
            if (c = null, i.child !== null)
              switch (i.child.tag) {
                case 27:
                case 5:
                  c = i.child.stateNode;
                  break;
                case 1:
                  c = i.child.stateNode;
              }
            try {
              He(
                i,
                i2,
                o,
                c
              );
            } catch (v) {
              st(i, i.return, v);
            }
          }
          e.effectDuration += ls(t);
          break;
        case 27:
          t === null && o & 4 && xm(i);
        case 26:
        case 5:
          Jr(e, i), t === null && o & 4 && m2(i), o & 512 && Uc(i, i.return);
          break;
        case 12:
          if (o & 4) {
            o = ar(), Jr(e, i), e = i.stateNode, e.effectDuration += rl(o);
            try {
              He(
                i,
                km,
                i,
                t,
                P2,
                e.effectDuration
              );
            } catch (v) {
              st(i, i.return, v);
            }
          } else Jr(e, i);
          break;
        case 13:
          Jr(e, i), o & 4 && Tc(e, i), o & 64 && (e = i.memoizedState, e !== null && (e = e.dehydrated, e !== null && (i = o0.bind(
            null,
            i
          ), Dc(e, i))));
          break;
        case 22:
          if (o = i.memoizedState !== null || Il, !o) {
            t = t !== null && t.memoizedState !== null || ei, c = Il;
            var h = ei;
            Il = o, (ei = t) && !h ? Lr(
              e,
              i,
              (i.subtreeFlags & 8772) !== 0
            ) : Jr(e, i), Il = c, ei = h;
          }
          break;
        case 30:
          break;
        default:
          Jr(e, i);
      }
    }
    function Om(e) {
      var t = e.alternate;
      t !== null && (e.alternate = null, Om(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && Zi(t)), e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
    }
    function ko(e, t, i) {
      for (i = i.child; i !== null; )
        vl(
          e,
          t,
          i
        ), i = i.sibling;
    }
    function vl(e, t, i) {
      if (Ri && typeof Ri.onCommitFiberUnmount == "function")
        try {
          Ri.onCommitFiberUnmount(ks, i);
        } catch (h) {
          ra || (ra = !0, console.error(
            "React instrumentation encountered an error: %s",
            h
          ));
        }
      switch (i.tag) {
        case 26:
          ei || Ha(i, t), ko(
            e,
            t,
            i
          ), i.memoizedState ? i.memoizedState.count-- : i.stateNode && (i = i.stateNode, i.parentNode.removeChild(i));
          break;
        case 27:
          ei || Ha(i, t);
          var o = di, c = qa;
          Yr(i.type) && (di = i.stateNode, qa = !1), ko(
            e,
            t,
            i
          ), He(
            i,
            Zc,
            i.stateNode
          ), di = o, qa = c;
          break;
        case 5:
          ei || Ha(i, t);
        case 6:
          if (o = di, c = qa, di = null, ko(
            e,
            t,
            i
          ), di = o, qa = c, di !== null)
            if (qa)
              try {
                He(
                  i,
                  Mc,
                  di,
                  i.stateNode
                );
              } catch (h) {
                st(
                  i,
                  t,
                  h
                );
              }
            else
              try {
                He(
                  i,
                  Ga,
                  di,
                  i.stateNode
                );
              } catch (h) {
                st(
                  i,
                  t,
                  h
                );
              }
          break;
        case 18:
          di !== null && (qa ? (e = di, kc(
            e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e,
            i.stateNode
          ), Ml(e)) : kc(di, i.stateNode));
          break;
        case 4:
          o = di, c = qa, di = i.stateNode.containerInfo, qa = !0, ko(
            e,
            t,
            i
          ), di = o, qa = c;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          ei || pl(
            Na,
            i,
            t
          ), ei || t1(
            i,
            t,
            zi
          ), ko(
            e,
            t,
            i
          );
          break;
        case 1:
          ei || (Ha(i, t), o = i.stateNode, typeof o.componentWillUnmount == "function" && n1(
            i,
            t,
            o
          )), ko(
            e,
            t,
            i
          );
          break;
        case 21:
          ko(
            e,
            t,
            i
          );
          break;
        case 22:
          ei = (o = ei) || i.memoizedState !== null, ko(
            e,
            t,
            i
          ), ei = o;
          break;
        default:
          ko(
            e,
            t,
            i
          );
      }
    }
    function Tc(e, t) {
      if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null))))
        try {
          He(
            t,
            Sa,
            e
          );
        } catch (i) {
          st(t, t.return, i);
        }
    }
    function a1(e) {
      switch (e.tag) {
        case 13:
        case 19:
          var t = e.stateNode;
          return t === null && (t = e.stateNode = new b6()), t;
        case 22:
          return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new b6()), t;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + e.tag + "). This is a bug in React."
          );
      }
    }
    function Sl(e, t) {
      var i = a1(e);
      t.forEach(function(o) {
        var c = Ts.bind(null, e, o);
        if (!i.has(o)) {
          if (i.add(o), Bn)
            if (gh !== null && vh !== null)
              Fc(vh, gh);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          o.then(c, c);
        }
      });
    }
    function Fi(e, t) {
      var i = t.deletions;
      if (i !== null)
        for (var o = 0; o < i.length; o++) {
          var c = e, h = t, v = i[o], S = h;
          e: for (; S !== null; ) {
            switch (S.tag) {
              case 27:
                if (Yr(S.type)) {
                  di = S.stateNode, qa = !1;
                  break e;
                }
                break;
              case 5:
                di = S.stateNode, qa = !1;
                break e;
              case 3:
              case 4:
                di = S.stateNode.containerInfo, qa = !0;
                break e;
            }
            S = S.return;
          }
          if (di === null)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          vl(c, h, v), di = null, qa = !1, c = v, h = c.alternate, h !== null && (h.return = null), c.return = null;
        }
      if (t.subtreeFlags & 13878)
        for (t = t.child; t !== null; )
          Bm(t, e), t = t.sibling;
    }
    function Bm(e, t) {
      var i = e.alternate, o = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Fi(t, e), ea(e), o & 4 && (pl(
            Na | lo,
            e,
            e.return
          ), ml(Na | lo, e), t1(
            e,
            e.return,
            zi | lo
          ));
          break;
        case 1:
          Fi(t, e), ea(e), o & 512 && (ei || i === null || Ha(i, i.return)), o & 64 && Il && (e = e.updateQueue, e !== null && (o = e.callbacks, o !== null && (i = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = i === null ? o : i.concat(o))));
          break;
        case 26:
          var c = Po;
          if (Fi(t, e), ea(e), o & 512 && (ei || i === null || Ha(i, i.return)), o & 4)
            if (t = i !== null ? i.memoizedState : null, o = e.memoizedState, i === null)
              if (o === null)
                if (e.stateNode === null) {
                  e: {
                    o = e.type, i = e.memoizedProps, t = c.ownerDocument || c;
                    t: switch (o) {
                      case "title":
                        c = t.getElementsByTagName("title")[0], (!c || c[jc] || c[ki] || c.namespaceURI === Xc || c.hasAttribute("itemprop")) && (c = t.createElement(o), t.head.insertBefore(
                          c,
                          t.querySelector("head > title")
                        )), xn(c, o, i), c[ki] = e, j(c), o = c;
                        break e;
                      case "link":
                        var h = fp(
                          "link",
                          "href",
                          t
                        ).get(o + (i.href || ""));
                        if (h) {
                          for (var v = 0; v < h.length; v++)
                            if (c = h[v], c.getAttribute("href") === (i.href == null || i.href === "" ? null : i.href) && c.getAttribute("rel") === (i.rel == null ? null : i.rel) && c.getAttribute("title") === (i.title == null ? null : i.title) && c.getAttribute("crossorigin") === (i.crossOrigin == null ? null : i.crossOrigin)) {
                              h.splice(v, 1);
                              break t;
                            }
                        }
                        c = t.createElement(o), xn(c, o, i), t.head.appendChild(c);
                        break;
                      case "meta":
                        if (h = fp(
                          "meta",
                          "content",
                          t
                        ).get(o + (i.content || ""))) {
                          for (v = 0; v < h.length; v++)
                            if (c = h[v], L(
                              i.content,
                              "content"
                            ), c.getAttribute("content") === (i.content == null ? null : "" + i.content) && c.getAttribute("name") === (i.name == null ? null : i.name) && c.getAttribute("property") === (i.property == null ? null : i.property) && c.getAttribute("http-equiv") === (i.httpEquiv == null ? null : i.httpEquiv) && c.getAttribute("charset") === (i.charSet == null ? null : i.charSet)) {
                              h.splice(v, 1);
                              break t;
                            }
                        }
                        c = t.createElement(o), xn(c, o, i), t.head.appendChild(c);
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + o + '". This is a bug in React.'
                        );
                    }
                    c[ki] = e, j(c), o = c;
                  }
                  e.stateNode = o;
                } else
                  gp(
                    c,
                    e.type,
                    e.stateNode
                  );
              else
                e.stateNode = C1(
                  c,
                  o,
                  e.memoizedProps
                );
            else
              t !== o ? (t === null ? i.stateNode !== null && (i = i.stateNode, i.parentNode.removeChild(i)) : t.count--, o === null ? gp(
                c,
                e.type,
                e.stateNode
              ) : C1(
                c,
                o,
                e.memoizedProps
              )) : o === null && e.stateNode !== null && Qm(
                e,
                e.memoizedProps,
                i.memoizedProps
              );
          break;
        case 27:
          Fi(t, e), ea(e), o & 512 && (ei || i === null || Ha(i, i.return)), i !== null && o & 4 && Qm(
            e,
            e.memoizedProps,
            i.memoizedProps
          );
          break;
        case 5:
          if (Fi(t, e), ea(e), o & 512 && (ei || i === null || Ha(i, i.return)), e.flags & 32) {
            t = e.stateNode;
            try {
              He(e, Oo, t);
            } catch (ee) {
              st(e, e.return, ee);
            }
          }
          o & 4 && e.stateNode != null && (t = e.memoizedProps, Qm(
            e,
            t,
            i !== null ? i.memoizedProps : t
          )), o & 1024 && (jv = !0, e.type !== "form" && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          if (Fi(t, e), ea(e), o & 4) {
            if (e.stateNode === null)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            o = e.memoizedProps, i = i !== null ? i.memoizedProps : o, t = e.stateNode;
            try {
              He(
                e,
                Vl,
                t,
                i,
                o
              );
            } catch (ee) {
              st(e, e.return, ee);
            }
          }
          break;
        case 3:
          if (c = ar(), Eg = null, h = Po, Po = l0(t.containerInfo), Fi(t, e), Po = h, ea(e), o & 4 && i !== null && i.memoizedState.isDehydrated)
            try {
              He(
                e,
                dp,
                t.containerInfo
              );
            } catch (ee) {
              st(e, e.return, ee);
            }
          jv && (jv = !1, Rl(e)), t.effectDuration += ls(c);
          break;
        case 4:
          o = Po, Po = l0(
            e.stateNode.containerInfo
          ), Fi(t, e), ea(e), Po = o;
          break;
        case 12:
          o = ar(), Fi(t, e), ea(e), e.stateNode.effectDuration += rl(o);
          break;
        case 13:
          Fi(t, e), ea(e), e.child.flags & 8192 && e.memoizedState !== null != (i !== null && i.memoizedState !== null) && (qv = $r()), o & 4 && (o = e.updateQueue, o !== null && (e.updateQueue = null, Sl(e, o)));
          break;
        case 22:
          c = e.memoizedState !== null;
          var S = i !== null && i.memoizedState !== null, M = Il, x = ei;
          if (Il = M || c, ei = x || S, Fi(t, e), ei = x, Il = M, ea(e), o & 8192)
            e: for (t = e.stateNode, t._visibility = c ? t._visibility & ~H2 : t._visibility | H2, c && (i === null || S || Il || ei || _i(e)), i = null, t = e; ; ) {
              if (t.tag === 5 || t.tag === 26) {
                if (i === null) {
                  S = i = t;
                  try {
                    h = S.stateNode, c ? He(S, ia, h) : He(
                      S,
                      lp,
                      S.stateNode,
                      S.memoizedProps
                    );
                  } catch (ee) {
                    st(S, S.return, ee);
                  }
                }
              } else if (t.tag === 6) {
                if (i === null) {
                  S = t;
                  try {
                    v = S.stateNode, c ? He(S, sp, v) : He(
                      S,
                      N1,
                      v,
                      S.memoizedProps
                    );
                  } catch (ee) {
                    st(S, S.return, ee);
                  }
                }
              } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
                t.child.return = t, t = t.child;
                continue;
              }
              if (t === e) break e;
              for (; t.sibling === null; ) {
                if (t.return === null || t.return === e)
                  break e;
                i === t && (i = null), t = t.return;
              }
              i === t && (i = null), t.sibling.return = t.return, t = t.sibling;
            }
          o & 4 && (o = e.updateQueue, o !== null && (i = o.retryQueue, i !== null && (o.retryQueue = null, Sl(e, i))));
          break;
        case 19:
          Fi(t, e), ea(e), o & 4 && (o = e.updateQueue, o !== null && (e.updateQueue = null, Sl(e, o)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          Fi(t, e), ea(e);
      }
    }
    function ea(e) {
      var t = e.flags;
      if (t & 2) {
        try {
          He(e, p2, e);
        } catch (i) {
          st(e, e.return, i);
        }
        e.flags &= -3;
      }
      t & 4096 && (e.flags &= -4097);
    }
    function Rl(e) {
      if (e.subtreeFlags & 1024)
        for (e = e.child; e !== null; ) {
          var t = e;
          Rl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
        }
    }
    function Jr(e, t) {
      if (t.subtreeFlags & 8772)
        for (t = t.child; t !== null; )
          Zm(e, t.alternate, t), t = t.sibling;
    }
    function va(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          t1(
            e,
            e.return,
            zi
          ), _i(e);
          break;
        case 1:
          Ha(e, e.return);
          var t = e.stateNode;
          typeof t.componentWillUnmount == "function" && n1(
            e,
            e.return,
            t
          ), _i(e);
          break;
        case 27:
          He(
            e,
            Zc,
            e.stateNode
          );
        case 26:
        case 5:
          Ha(e, e.return), _i(e);
          break;
        case 22:
          e.memoizedState === null && _i(e);
          break;
        case 30:
          _i(e);
          break;
        default:
          _i(e);
      }
    }
    function _i(e) {
      for (e = e.child; e !== null; )
        va(e), e = e.sibling;
    }
    function Qo(e, t, i, o) {
      var c = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          Lr(
            e,
            i,
            o
          ), Fm(i, zi);
          break;
        case 1:
          if (Lr(
            e,
            i,
            o
          ), t = i.stateNode, typeof t.componentDidMount == "function" && He(
            i,
            Av,
            i,
            t
          ), t = i.updateQueue, t !== null) {
            e = i.stateNode;
            try {
              He(
                i,
                lc,
                t,
                e
              );
            } catch (h) {
              st(i, i.return, h);
            }
          }
          o && c & 64 && Mm(i), Uc(i, i.return);
          break;
        case 27:
          xm(i);
        case 26:
        case 5:
          Lr(
            e,
            i,
            o
          ), o && t === null && c & 4 && m2(i), Uc(i, i.return);
          break;
        case 12:
          if (o && c & 4) {
            c = ar(), Lr(
              e,
              i,
              o
            ), o = i.stateNode, o.effectDuration += rl(c);
            try {
              He(
                i,
                km,
                i,
                t,
                P2,
                o.effectDuration
              );
            } catch (h) {
              st(i, i.return, h);
            }
          } else
            Lr(
              e,
              i,
              o
            );
          break;
        case 13:
          Lr(
            e,
            i,
            o
          ), o && c & 4 && Tc(e, i);
          break;
        case 22:
          i.memoizedState === null && Lr(
            e,
            i,
            o
          ), Uc(i, i.return);
          break;
        case 30:
          break;
        default:
          Lr(
            e,
            i,
            o
          );
      }
    }
    function Lr(e, t, i) {
      for (i = i && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; )
        Qo(
          e,
          t.alternate,
          t,
          i
        ), t = t.sibling;
    }
    function Ir(e, t) {
      var i = null;
      e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (i = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== i && (e != null && al(e), i != null && Fr(i));
    }
    function hr(e, t) {
      e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (al(t), e != null && Fr(e));
    }
    function sn(e, t, i, o) {
      if (t.subtreeFlags & 10256)
        for (t = t.child; t !== null; )
          $d(
            e,
            t,
            i,
            o
          ), t = t.sibling;
    }
    function $d(e, t, i, o) {
      var c = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          sn(
            e,
            t,
            i,
            o
          ), c & 2048 && _m(t, Ti | lo);
          break;
        case 1:
          sn(
            e,
            t,
            i,
            o
          );
          break;
        case 3:
          var h = ar();
          sn(
            e,
            t,
            i,
            o
          ), c & 2048 && (i = null, t.alternate !== null && (i = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== i && (al(t), i != null && Fr(i))), e.passiveEffectDuration += ls(h);
          break;
        case 12:
          if (c & 2048) {
            c = ar(), sn(
              e,
              t,
              i,
              o
            ), e = t.stateNode, e.passiveEffectDuration += rl(c);
            try {
              He(
                t,
                h2,
                t,
                t.alternate,
                P2,
                e.passiveEffectDuration
              );
            } catch (S) {
              st(t, t.return, S);
            }
          } else
            sn(
              e,
              t,
              i,
              o
            );
          break;
        case 13:
          sn(
            e,
            t,
            i,
            o
          );
          break;
        case 23:
          break;
        case 22:
          h = t.stateNode;
          var v = t.alternate;
          t.memoizedState !== null ? h._visibility & Ol ? sn(
            e,
            t,
            i,
            o
          ) : yc(
            e,
            t
          ) : h._visibility & Ol ? sn(
            e,
            t,
            i,
            o
          ) : (h._visibility |= Ol, Rs(
            e,
            t,
            i,
            o,
            (t.subtreeFlags & 10256) !== 0
          )), c & 2048 && Ir(v, t);
          break;
        case 24:
          sn(
            e,
            t,
            i,
            o
          ), c & 2048 && hr(t.alternate, t);
          break;
        default:
          sn(
            e,
            t,
            i,
            o
          );
      }
    }
    function Rs(e, t, i, o, c) {
      for (c = c && (t.subtreeFlags & 10256) !== 0, t = t.child; t !== null; )
        r1(
          e,
          t,
          i,
          o,
          c
        ), t = t.sibling;
    }
    function r1(e, t, i, o, c) {
      var h = t.flags;
      switch (t.tag) {
        case 0:
        case 11:
        case 15:
          Rs(
            e,
            t,
            i,
            o,
            c
          ), _m(t, Ti);
          break;
        case 23:
          break;
        case 22:
          var v = t.stateNode;
          t.memoizedState !== null ? v._visibility & Ol ? Rs(
            e,
            t,
            i,
            o,
            c
          ) : yc(
            e,
            t
          ) : (v._visibility |= Ol, Rs(
            e,
            t,
            i,
            o,
            c
          )), c && h & 2048 && Ir(
            t.alternate,
            t
          );
          break;
        case 24:
          Rs(
            e,
            t,
            i,
            o,
            c
          ), c && h & 2048 && hr(t.alternate, t);
          break;
        default:
          Rs(
            e,
            t,
            i,
            o,
            c
          );
      }
    }
    function yc(e, t) {
      if (t.subtreeFlags & 10256)
        for (t = t.child; t !== null; ) {
          var i = e, o = t, c = o.flags;
          switch (o.tag) {
            case 22:
              yc(
                i,
                o
              ), c & 2048 && Ir(
                o.alternate,
                o
              );
              break;
            case 24:
              yc(
                i,
                o
              ), c & 2048 && hr(
                o.alternate,
                o
              );
              break;
            default:
              yc(
                i,
                o
              );
          }
          t = t.sibling;
        }
    }
    function El(e) {
      if (e.subtreeFlags & of)
        for (e = e.child; e !== null; )
          Es(e), e = e.sibling;
    }
    function Es(e) {
      switch (e.tag) {
        case 26:
          El(e), e.flags & of && e.memoizedState !== null && b2(
            Po,
            e.memoizedState,
            e.memoizedProps
          );
          break;
        case 5:
          El(e);
          break;
        case 3:
        case 4:
          var t = Po;
          Po = l0(
            e.stateNode.containerInfo
          ), El(e), Po = t;
          break;
        case 22:
          e.memoizedState === null && (t = e.alternate, t !== null && t.memoizedState !== null ? (t = of, of = 16777216, El(e), of = t) : El(e));
          break;
        default:
          El(e);
      }
    }
    function e0(e) {
      var t = e.alternate;
      if (t !== null && (e = t.child, e !== null)) {
        t.child = null;
        do
          t = e.sibling, e.sibling = null, e = t;
        while (e !== null);
      }
    }
    function Nc(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var i = 0; i < t.length; i++) {
            var o = t[i];
            Di = o, Am(
              o,
              e
            );
          }
        e0(e);
      }
      if (e.subtreeFlags & 10256)
        for (e = e.child; e !== null; )
          wm(e), e = e.sibling;
    }
    function wm(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Nc(e), e.flags & 2048 && Kd(
            e,
            e.return,
            Ti | lo
          );
          break;
        case 3:
          var t = ar();
          Nc(e), e.stateNode.passiveEffectDuration += ls(t);
          break;
        case 12:
          t = ar(), Nc(e), e.stateNode.passiveEffectDuration += rl(t);
          break;
        case 22:
          t = e.stateNode, e.memoizedState !== null && t._visibility & Ol && (e.return === null || e.return.tag !== 13) ? (t._visibility &= ~Ol, t0(e)) : Nc(e);
          break;
        default:
          Nc(e);
      }
    }
    function t0(e) {
      var t = e.deletions;
      if ((e.flags & 16) !== 0) {
        if (t !== null)
          for (var i = 0; i < t.length; i++) {
            var o = t[i];
            Di = o, Am(
              o,
              e
            );
          }
        e0(e);
      }
      for (e = e.child; e !== null; )
        n0(e), e = e.sibling;
    }
    function n0(e) {
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          Kd(
            e,
            e.return,
            Ti
          ), t0(e);
          break;
        case 22:
          var t = e.stateNode;
          t._visibility & Ol && (t._visibility &= ~Ol, t0(e));
          break;
        default:
          t0(e);
      }
    }
    function Am(e, t) {
      for (; Di !== null; ) {
        var i = Di, o = i;
        switch (o.tag) {
          case 0:
          case 11:
          case 15:
            Kd(
              o,
              t,
              Ti
            );
            break;
          case 23:
          case 22:
            o.memoizedState !== null && o.memoizedState.cachePool !== null && (o = o.memoizedState.cachePool.pool, o != null && al(o));
            break;
          case 24:
            Fr(o.memoizedState.cache);
        }
        if (o = i.child, o !== null) o.return = i, Di = o;
        else
          e: for (i = e; Di !== null; ) {
            o = Di;
            var c = o.sibling, h = o.return;
            if (Om(o), o === i) {
              Di = null;
              break e;
            }
            if (c !== null) {
              c.return = h, Di = c;
              break e;
            }
            Di = h;
          }
      }
    }
    function Jm() {
      LE.forEach(function(e) {
        return e();
      });
    }
    function Lm() {
      var e = typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0;
      return e || oe.actQueue === null || console.error(
        "The current testing environment is not configured to support act(...)"
      ), e;
    }
    function ta(e) {
      if ((an & ba) !== gr && wt !== 0)
        return wt & -wt;
      var t = oe.T;
      return t !== null ? (t._updatedFibers || (t._updatedFibers = /* @__PURE__ */ new Set()), t._updatedFibers.add(e), e = x0, e !== 0 ? e : Xm()) : So();
    }
    function f2() {
      Sr === 0 && (Sr = (wt & 536870912) === 0 || Pt ? gt() : 536870912);
      var e = uo.current;
      return e !== null && (e.flags |= 32), Sr;
    }
    function Qn(e, t, i) {
      if (Th && console.error("useInsertionEffect must not schedule updates."), iS && (lg = !0), (e === pn && (ln === A0 || ln === J0) || e.cancelPendingCommit !== null) && (Tl(e, 0), Do(
        e,
        wt,
        Sr,
        !1
      )), xi(e, i), (an & ba) !== 0 && e === pn) {
        if (sa)
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
              e = Ot && Se(Ot) || "Unknown", Z6.has(e) || (Z6.add(e), t = Se(t) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                t,
                e,
                e
              ));
              break;
            case 1:
              x6 || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), x6 = !0);
          }
      } else
        Bn && un(e, t, i), R2(t), e === pn && ((an & ba) === gr && (id |= i), Pn === w0 && Do(
          e,
          wt,
          Sr,
          !1
        )), za(e);
    }
    function qn(e, t, i) {
      if ((an & (ba | Yo)) !== gr)
        throw Error("Should not already be working.");
      var o = !i && (t & 124) === 0 && (t & e.expiredLanes) === 0 || ka(e, t), c = o ? Wm(e, t) : c1(e, t, !0), h = o;
      do {
        if (c === Wl) {
          Eh && !o && Do(e, t, 0, !1);
          break;
        } else {
          if (i = e.current.alternate, h && !g2(i)) {
            c = c1(e, t, !1), h = !1;
            continue;
          }
          if (c === Sh) {
            if (h = t, e.errorRecoveryDisabledLanes & h)
              var v = 0;
            else
              v = e.pendingLanes & -536870913, v = v !== 0 ? v : v & 536870912 ? 536870912 : 0;
            if (v !== 0) {
              t = v;
              e: {
                c = e;
                var S = v;
                v = hf;
                var M = c.current.memoizedState.isDehydrated;
                if (M && (Tl(
                  c,
                  S
                ).flags |= 256), S = c1(
                  c,
                  S,
                  !1
                ), S !== Sh) {
                  if (Xv && !M) {
                    c.errorRecoveryDisabledLanes |= h, id |= h, c = w0;
                    break e;
                  }
                  c = Va, Va = v, c !== null && (Va === null ? Va = c : Va.push.apply(
                    Va,
                    c
                  ));
                }
                c = S;
              }
              if (h = !1, c !== Sh) continue;
            }
          }
          if (c === lf) {
            Tl(e, 0), Do(e, t, 0, !0);
            break;
          }
          e: {
            switch (o = e, c) {
              case Wl:
              case lf:
                throw Error("Root did not complete. This is a bug in React.");
              case w0:
                if ((t & 4194048) !== t) break;
              case rg:
                Do(
                  o,
                  t,
                  Sr,
                  !td
                );
                break e;
              case Sh:
                Va = null;
                break;
              case Gv:
              case V6:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (oe.actQueue !== null)
              p1(
                o,
                i,
                t,
                Va,
                mf,
                og,
                Sr,
                id,
                L0
              );
            else {
              if ((t & 62914560) === t && (h = qv + F6 - $r(), 10 < h)) {
                if (Do(
                  o,
                  t,
                  Sr,
                  !td
                ), vn(o, 0, !0) !== 0) break e;
                o.timeoutHandle = W6(
                  oi.bind(
                    null,
                    o,
                    i,
                    Va,
                    mf,
                    og,
                    t,
                    Sr,
                    id,
                    L0,
                    td,
                    c,
                    zE,
                    MR,
                    0
                  ),
                  h
                );
                break e;
              }
              oi(
                o,
                i,
                Va,
                mf,
                og,
                t,
                Sr,
                id,
                L0,
                td,
                c,
                WE,
                MR,
                0
              );
            }
          }
        }
        break;
      } while (!0);
      za(e);
    }
    function oi(e, t, i, o, c, h, v, S, M, x, ee, le, q, ce) {
      if (e.timeoutHandle = j0, le = t.subtreeFlags, (le & 8192 || (le & 16785408) === 16785408) && (Rf = { stylesheets: null, count: 0, unsuspend: N2 }, Es(t), le = V2(), le !== null)) {
        e.cancelPendingCommit = le(
          p1.bind(
            null,
            e,
            t,
            h,
            i,
            o,
            c,
            v,
            S,
            M,
            ee,
            HE,
            q,
            ce
          )
        ), Do(
          e,
          h,
          v,
          !x
        );
        return;
      }
      p1(
        e,
        t,
        h,
        i,
        o,
        c,
        v,
        S,
        M
      );
    }
    function g2(e) {
      for (var t = e; ; ) {
        var i = t.tag;
        if ((i === 0 || i === 11 || i === 15) && t.flags & 16384 && (i = t.updateQueue, i !== null && (i = i.stores, i !== null)))
          for (var o = 0; o < i.length; o++) {
            var c = i[o], h = c.getSnapshot;
            c = c.value;
            try {
              if (!Ta(h(), c)) return !1;
            } catch {
              return !1;
            }
          }
        if (i = t.child, t.subtreeFlags & 16384 && i !== null)
          i.return = t, t = i;
        else {
          if (t === e) break;
          for (; t.sibling === null; ) {
            if (t.return === null || t.return === e) return !0;
            t = t.return;
          }
          t.sibling.return = t.return, t = t.sibling;
        }
      }
      return !0;
    }
    function Do(e, t, i, o) {
      t &= ~Kv, t &= ~id, e.suspendedLanes |= t, e.pingedLanes &= ~t, o && (e.warmLanes |= t), o = e.expirationTimes;
      for (var c = t; 0 < c; ) {
        var h = 31 - Mi(c), v = 1 << h;
        o[h] = -1, c &= ~v;
      }
      i !== 0 && vo(e, i, t);
    }
    function Ul() {
      return (an & (ba | Yo)) === gr ? (yl(0), !1) : !0;
    }
    function o1() {
      if (Ot !== null) {
        if (ln === $a)
          var e = Ot.return;
        else
          e = Ot, yu(), lr(e), uh = null, af = 0, e = Ot;
        for (; e !== null; )
          Cm(e.alternate, e), e = e.return;
        Ot = null;
      }
    }
    function Tl(e, t) {
      var i = e.timeoutHandle;
      i !== j0 && (e.timeoutHandle = j0, aU(i)), i = e.cancelPendingCommit, i !== null && (e.cancelPendingCommit = null, i()), o1(), pn = e, Ot = i = Vr(e.current, null), wt = t, ln = $a, vr = null, td = !1, Eh = ka(e, t), Xv = !1, Pn = Wl, L0 = Sr = Kv = id = nd = 0, Va = hf = null, og = !1, (t & 8) !== 0 && (t |= t & 32);
      var o = e.entangledLanes;
      if (o !== 0)
        for (e = e.entanglements, o &= t; 0 < o; ) {
          var c = 31 - Mi(o), h = 1 << c;
          t |= e[c], o &= ~h;
        }
      return Js = t, yd(), t = FR(), 1e3 < t - CR && (oe.recentlyCreatedOwnerStacks = 0, CR = t), jo.discardPendingWarnings(), i;
    }
    function i0(e, t) {
      St = null, oe.H = ig, oe.getCurrentStack = null, sa = !1, Ua = null, t === $p || t === q2 ? (t = dm(), ln = df) : t === DR ? (t = dm(), ln = C6) : ln = t === v6 ? Yv : t !== null && typeof t == "object" && typeof t.then == "function" ? Rh : cf, vr = t;
      var i = Ot;
      if (i === null)
        Pn = lf, Ec(
          e,
          ma(t, e.current)
        );
      else
        switch (i.mode & Hi && No(i), Nn(), ln) {
          case cf:
            Le !== null && typeof Le.markComponentErrored == "function" && Le.markComponentErrored(
              i,
              t,
              wt
            );
            break;
          case A0:
          case J0:
          case df:
          case Rh:
          case uf:
            Le !== null && typeof Le.markComponentSuspended == "function" && Le.markComponentSuspended(
              i,
              t,
              wt
            );
        }
    }
    function s1() {
      var e = oe.H;
      return oe.H = ig, e === null ? ig : e;
    }
    function Im() {
      var e = oe.A;
      return oe.A = JE, e;
    }
    function l1() {
      Pn = w0, td || (wt & 4194048) !== wt && uo.current !== null || (Eh = !0), (nd & 134217727) === 0 && (id & 134217727) === 0 || pn === null || Do(
        pn,
        wt,
        Sr,
        !1
      );
    }
    function c1(e, t, i) {
      var o = an;
      an |= ba;
      var c = s1(), h = Im();
      if (pn !== e || wt !== t) {
        if (Bn) {
          var v = e.memoizedUpdaters;
          0 < v.size && (Fc(e, wt), v.clear()), Ln(e, t);
        }
        mf = null, Tl(e, t);
      }
      rn(t), t = !1, v = Pn;
      e: do
        try {
          if (ln !== $a && Ot !== null) {
            var S = Ot, M = vr;
            switch (ln) {
              case Yv:
                o1(), v = rg;
                break e;
              case df:
              case A0:
              case J0:
              case Rh:
                uo.current === null && (t = !0);
                var x = ln;
                if (ln = $a, vr = null, Us(e, S, M, x), i && Eh) {
                  v = Wl;
                  break e;
                }
                break;
              default:
                x = ln, ln = $a, vr = null, Us(e, S, M, x);
            }
          }
          d1(), v = Pn;
          break;
        } catch (ee) {
          i0(e, ee);
        }
      while (!0);
      return t && e.shellSuspendCounter++, yu(), an = o, oe.H = c, oe.A = h, tn(), Ot === null && (pn = null, wt = 0, yd()), v;
    }
    function d1() {
      for (; Ot !== null; ) zm(Ot);
    }
    function Wm(e, t) {
      var i = an;
      an |= ba;
      var o = s1(), c = Im();
      if (pn !== e || wt !== t) {
        if (Bn) {
          var h = e.memoizedUpdaters;
          0 < h.size && (Fc(e, wt), h.clear()), Ln(e, t);
        }
        mf = null, sg = $r() + _6, Tl(e, t);
      } else
        Eh = ka(
          e,
          t
        );
      rn(t);
      e: do
        try {
          if (ln !== $a && Ot !== null)
            t: switch (t = Ot, h = vr, ln) {
              case cf:
                ln = $a, vr = null, Us(
                  e,
                  t,
                  h,
                  cf
                );
                break;
              case A0:
              case J0:
                if (cm(h)) {
                  ln = $a, vr = null, u1(t);
                  break;
                }
                t = function() {
                  ln !== A0 && ln !== J0 || pn !== e || (ln = uf), za(e);
                }, h.then(t, t);
                break e;
              case df:
                ln = uf;
                break e;
              case C6:
                ln = Pv;
                break e;
              case uf:
                cm(h) ? (ln = $a, vr = null, u1(t)) : (ln = $a, vr = null, Us(
                  e,
                  t,
                  h,
                  uf
                ));
                break;
              case Pv:
                var v = null;
                switch (Ot.tag) {
                  case 26:
                    v = Ot.memoizedState;
                  case 5:
                  case 27:
                    var S = Ot;
                    if (!v || c0(v)) {
                      ln = $a, vr = null;
                      var M = S.sibling;
                      if (M !== null) Ot = M;
                      else {
                        var x = S.return;
                        x !== null ? (Ot = x, a0(x)) : Ot = null;
                      }
                      break t;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                ln = $a, vr = null, Us(
                  e,
                  t,
                  h,
                  Pv
                );
                break;
              case Rh:
                ln = $a, vr = null, Us(
                  e,
                  t,
                  h,
                  Rh
                );
                break;
              case Yv:
                o1(), Pn = rg;
                break e;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          oe.actQueue !== null ? d1() : Hm();
          break;
        } catch (ee) {
          i0(e, ee);
        }
      while (!0);
      return yu(), oe.H = o, oe.A = c, an = i, Ot !== null ? (Le !== null && typeof Le.markRenderYielded == "function" && Le.markRenderYielded(), Wl) : (tn(), pn = null, wt = 0, yd(), Pn);
    }
    function Hm() {
      for (; Ot !== null && !D2(); )
        zm(Ot);
    }
    function zm(e) {
      var t = e.alternate;
      (e.mode & Hi) !== Un ? (Nu(e), t = He(
        e,
        e1,
        t,
        e,
        Js
      ), No(e)) : t = He(
        e,
        e1,
        t,
        e,
        Js
      ), e.memoizedProps = e.pendingProps, t === null ? a0(e) : Ot = t;
    }
    function u1(e) {
      var t = He(e, h1, e);
      e.memoizedProps = e.pendingProps, t === null ? a0(e) : Ot = t;
    }
    function h1(e) {
      var t = e.alternate, i = (e.mode & Hi) !== Un;
      switch (i && Nu(e), e.tag) {
        case 15:
        case 0:
          t = Tm(
            t,
            e,
            e.pendingProps,
            e.type,
            void 0,
            wt
          );
          break;
        case 11:
          t = Tm(
            t,
            e,
            e.pendingProps,
            e.type.render,
            e.ref,
            wt
          );
          break;
        case 5:
          lr(e);
        default:
          Cm(t, e), e = Ot = Xh(e, Js), t = e1(t, e, Js);
      }
      return i && No(e), t;
    }
    function Us(e, t, i, o) {
      yu(), lr(t), uh = null, af = 0;
      var c = t.return;
      try {
        if (Hd(
          e,
          c,
          t,
          i,
          wt
        )) {
          Pn = lf, Ec(
            e,
            ma(i, e.current)
          ), Ot = null;
          return;
        }
      } catch (h) {
        if (c !== null) throw Ot = c, h;
        Pn = lf, Ec(
          e,
          ma(i, e.current)
        ), Ot = null;
        return;
      }
      t.flags & 32768 ? (Pt || o === cf ? e = !0 : Eh || (wt & 536870912) !== 0 ? e = !1 : (td = e = !0, (o === A0 || o === J0 || o === df || o === Rh) && (o = uo.current, o !== null && o.tag === 13 && (o.flags |= 16384))), m1(t, e)) : a0(t);
    }
    function a0(e) {
      var t = e;
      do {
        if ((t.flags & 32768) !== 0) {
          m1(
            t,
            td
          );
          return;
        }
        var i = t.alternate;
        if (e = t.return, Nu(t), i = He(
          t,
          l2,
          i,
          t,
          Js
        ), (t.mode & Hi) !== Un && ol(t), i !== null) {
          Ot = i;
          return;
        }
        if (t = t.sibling, t !== null) {
          Ot = t;
          return;
        }
        Ot = t = e;
      } while (t !== null);
      Pn === Wl && (Pn = V6);
    }
    function m1(e, t) {
      do {
        var i = c2(e.alternate, e);
        if (i !== null) {
          i.flags &= 32767, Ot = i;
          return;
        }
        if ((e.mode & Hi) !== Un) {
          ol(e), i = e.actualDuration;
          for (var o = e.child; o !== null; )
            i += o.actualDuration, o = o.sibling;
          e.actualDuration = i;
        }
        if (i = e.return, i !== null && (i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null), !t && (e = e.sibling, e !== null)) {
          Ot = e;
          return;
        }
        Ot = e = i;
      } while (e !== null);
      Pn = rg, Ot = null;
    }
    function p1(e, t, i, o, c, h, v, S, M) {
      e.cancelPendingCommit = null;
      do
        bc();
      while (ji !== I0);
      if (jo.flushLegacyContextWarning(), jo.flushPendingUnsafeLifecycleWarnings(), (an & (ba | Yo)) !== gr)
        throw Error("Should not already be working.");
      if (Le !== null && typeof Le.markCommitStarted == "function" && Le.markCommitStarted(i), t === null) $e();
      else {
        if (i === 0 && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        ), t === e.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        if (h = t.lanes | t.childLanes, h |= Vv, qo(
          e,
          i,
          h,
          v,
          S,
          M
        ), e === pn && (Ot = pn = null, wt = 0), Uh = t, rd = e, od = i, eS = h, tS = c, D6 = o, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (e.callbackNode = null, e.callbackPriority = 0, Ym(Wc, function() {
          return r0(), null;
        })) : (e.callbackNode = null, e.callbackPriority = 0), P2 = oh(), o = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || o) {
          o = oe.T, oe.T = null, c = ut.p, ut.p = Ei, v = an, an |= Yo;
          try {
            i1(e, t, i);
          } finally {
            an = v, ut.p = c, oe.T = o;
          }
        }
        ji = M6, Wr(), f1(), v2();
      }
    }
    function Wr() {
      if (ji === M6) {
        ji = I0;
        var e = rd, t = Uh, i = od, o = (t.flags & 13878) !== 0;
        if ((t.subtreeFlags & 13878) !== 0 || o) {
          o = oe.T, oe.T = null;
          var c = ut.p;
          ut.p = Ei;
          var h = an;
          an |= Yo;
          try {
            gh = i, vh = e, Bm(t, e), vh = gh = null, i = hS;
            var v = Pf(e.containerInfo), S = i.focusedElem, M = i.selectionRange;
            if (v !== S && S && S.ownerDocument && Gf(
              S.ownerDocument.documentElement,
              S
            )) {
              if (M !== null && jh(S)) {
                var x = M.start, ee = M.end;
                if (ee === void 0 && (ee = x), "selectionStart" in S)
                  S.selectionStart = x, S.selectionEnd = Math.min(
                    ee,
                    S.value.length
                  );
                else {
                  var le = S.ownerDocument || document, q = le && le.defaultView || window;
                  if (q.getSelection) {
                    var ce = q.getSelection(), je = S.textContent.length, ht = Math.min(
                      M.start,
                      je
                    ), fn = M.end === void 0 ? ht : Math.min(M.end, je);
                    !ce.extend && ht > fn && (v = fn, fn = ht, ht = v);
                    var Jt = zh(
                      S,
                      ht
                    ), w = zh(
                      S,
                      fn
                    );
                    if (Jt && w && (ce.rangeCount !== 1 || ce.anchorNode !== Jt.node || ce.anchorOffset !== Jt.offset || ce.focusNode !== w.node || ce.focusOffset !== w.offset)) {
                      var J = le.createRange();
                      J.setStart(Jt.node, Jt.offset), ce.removeAllRanges(), ht > fn ? (ce.addRange(J), ce.extend(w.node, w.offset)) : (J.setEnd(w.node, w.offset), ce.addRange(J));
                    }
                  }
                }
              }
              for (le = [], ce = S; ce = ce.parentNode; )
                ce.nodeType === 1 && le.push({
                  element: ce,
                  left: ce.scrollLeft,
                  top: ce.scrollTop
                });
              for (typeof S.focus == "function" && S.focus(), S = 0; S < le.length; S++) {
                var I = le[S];
                I.element.scrollLeft = I.left, I.element.scrollTop = I.top;
              }
            }
            yg = !!uS, hS = uS = null;
          } finally {
            an = h, ut.p = c, oe.T = o;
          }
        }
        e.current = t, ji = k6;
      }
    }
    function f1() {
      if (ji === k6) {
        ji = I0;
        var e = rd, t = Uh, i = od, o = (t.flags & 8772) !== 0;
        if ((t.subtreeFlags & 8772) !== 0 || o) {
          o = oe.T, oe.T = null;
          var c = ut.p;
          ut.p = Ei;
          var h = an;
          an |= Yo;
          try {
            Le !== null && typeof Le.markLayoutEffectsStarted == "function" && Le.markLayoutEffectsStarted(i), gh = i, vh = e, Zm(
              e,
              t.alternate,
              t
            ), vh = gh = null, Le !== null && typeof Le.markLayoutEffectsStopped == "function" && Le.markLayoutEffectsStopped();
          } finally {
            an = h, ut.p = c, oe.T = o;
          }
        }
        ji = Q6;
      }
    }
    function v2() {
      if (ji === jE || ji === Q6) {
        ji = I0, fv();
        var e = rd, t = Uh, i = od, o = D6, c = (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0;
        c ? ji = $v : (ji = I0, Uh = rd = null, Hr(e, e.pendingLanes), W0 = 0, ff = null);
        var h = e.pendingLanes;
        if (h === 0 && (ad = null), c || Cc(e), c = Qa(i), t = t.stateNode, Ri && typeof Ri.onCommitFiberRoot == "function")
          try {
            var v = (t.current.flags & 128) === 128;
            switch (c) {
              case Ei:
                var S = w1;
                break;
              case fr:
                S = U0;
                break;
              case Io:
                S = Wc;
                break;
              case I1:
                S = T0;
                break;
              default:
                S = Wc;
            }
            Ri.onCommitFiberRoot(
              ks,
              t,
              S,
              v
            );
          } catch (le) {
            ra || (ra = !0, console.error(
              "React instrumentation encountered an error: %s",
              le
            ));
          }
        if (Bn && e.memoizedUpdaters.clear(), Jm(), o !== null) {
          v = oe.T, S = ut.p, ut.p = Ei, oe.T = null;
          try {
            var M = e.onRecoverableError;
            for (t = 0; t < o.length; t++) {
              var x = o[t], ee = S2(x.stack);
              He(
                x.source,
                M,
                x.value,
                ee
              );
            }
          } finally {
            oe.T = v, ut.p = S;
          }
        }
        (od & 3) !== 0 && bc(), za(e), h = e.pendingLanes, (i & 4194090) !== 0 && (h & 42) !== 0 ? (X2 = !0, e === nS ? pf++ : (pf = 0, nS = e)) : pf = 0, yl(0), $e();
      }
    }
    function S2(e) {
      return e = { componentStack: e }, Object.defineProperty(e, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      }), e;
    }
    function Hr(e, t) {
      (e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, Fr(t)));
    }
    function bc(e) {
      return Wr(), f1(), v2(), r0();
    }
    function r0() {
      if (ji !== $v) return !1;
      var e = rd, t = eS;
      eS = 0;
      var i = Qa(od), o = Io > i ? Io : i;
      i = oe.T;
      var c = ut.p;
      try {
        ut.p = o, oe.T = null, o = tS, tS = null;
        var h = rd, v = od;
        if (ji = I0, Uh = rd = null, od = 0, (an & (ba | Yo)) !== gr)
          throw Error("Cannot flush passive effects while already rendering.");
        iS = !0, lg = !1, Le !== null && typeof Le.markPassiveEffectsStarted == "function" && Le.markPassiveEffectsStarted(v);
        var S = an;
        if (an |= Yo, wm(h.current), $d(
          h,
          h.current,
          v,
          o
        ), Le !== null && typeof Le.markPassiveEffectsStopped == "function" && Le.markPassiveEffectsStopped(), Cc(h), an = S, yl(0, !1), lg ? h === ff ? W0++ : (W0 = 0, ff = h) : W0 = 0, lg = iS = !1, Ri && typeof Ri.onPostCommitFiberRoot == "function")
          try {
            Ri.onPostCommitFiberRoot(ks, h);
          } catch (x) {
            ra || (ra = !0, console.error(
              "React instrumentation encountered an error: %s",
              x
            ));
          }
        var M = h.current.stateNode;
        return M.effectDuration = 0, M.passiveEffectDuration = 0, !0;
      } finally {
        ut.p = c, oe.T = i, Hr(e, t);
      }
    }
    function Vc(e, t, i) {
      t = ma(i, t), t = Ci(e.stateNode, t, 2), e = or(e, t, 2), e !== null && (xi(e, 2), za(e));
    }
    function st(e, t, i) {
      if (Th = !1, e.tag === 3)
        Vc(e, e, i);
      else {
        for (; t !== null; ) {
          if (t.tag === 3) {
            Vc(
              t,
              e,
              i
            );
            return;
          }
          if (t.tag === 1) {
            var o = t.stateNode;
            if (typeof t.type.getDerivedStateFromError == "function" || typeof o.componentDidCatch == "function" && (ad === null || !ad.has(o))) {
              e = ma(i, e), i = kn(2), o = or(t, i, 2), o !== null && (Wd(
                i,
                o,
                t,
                e
              ), xi(o, 2), za(o));
              return;
            }
          }
          t = t.return;
        }
        console.error(
          `Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`,
          i
        );
      }
    }
    function jm(e, t, i) {
      var o = e.pingCache;
      if (o === null) {
        o = e.pingCache = new IE();
        var c = /* @__PURE__ */ new Set();
        o.set(t, c);
      } else
        c = o.get(t), c === void 0 && (c = /* @__PURE__ */ new Set(), o.set(t, c));
      c.has(i) || (Xv = !0, c.add(i), o = lv.bind(null, e, t, i), Bn && Fc(e, i), t.then(o, o));
    }
    function lv(e, t, i) {
      var o = e.pingCache;
      o !== null && o.delete(t), e.pingedLanes |= e.suspendedLanes & i, e.warmLanes &= ~i, Lm() && oe.actQueue === null && console.error(
        `A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`
      ), pn === e && (wt & i) === i && (Pn === w0 || Pn === Gv && (wt & 62914560) === wt && $r() - qv < F6 ? (an & ba) === gr && Tl(e, 0) : Kv |= i, L0 === wt && (L0 = 0)), za(e);
    }
    function Gm(e, t) {
      t === 0 && (t = bi()), e = Pi(e, t), e !== null && (xi(e, t), za(e));
    }
    function o0(e) {
      var t = e.memoizedState, i = 0;
      t !== null && (i = t.retryLane), Gm(e, i);
    }
    function Ts(e, t) {
      var i = 0;
      switch (e.tag) {
        case 13:
          var o = e.stateNode, c = e.memoizedState;
          c !== null && (i = c.retryLane);
          break;
        case 19:
          o = e.stateNode;
          break;
        case 22:
          o = e.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      o !== null && o.delete(t), Gm(e, i);
    }
    function g1(e, t, i) {
      if ((t.subtreeFlags & 67117056) !== 0)
        for (t = t.child; t !== null; ) {
          var o = e, c = t, h = c.type === wc;
          h = i || h, c.tag !== 22 ? c.flags & 67108864 ? h && He(
            c,
            Pm,
            o,
            c,
            (c.mode & NR) === Un
          ) : g1(
            o,
            c,
            h
          ) : c.memoizedState === null && (h && c.flags & 8192 ? He(
            c,
            Pm,
            o,
            c
          ) : c.subtreeFlags & 67108864 && He(
            c,
            g1,
            o,
            c,
            h
          )), t = t.sibling;
        }
    }
    function Pm(e, t) {
      var i = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : !0;
      Ze(!0);
      try {
        va(t), i && n0(t), Qo(e, t.alternate, t, !1), i && r1(e, t, 0, null, !1, 0);
      } finally {
        Ze(!1);
      }
    }
    function Cc(e) {
      var t = !0;
      e.current.mode & (la | zo) || (t = !1), g1(
        e,
        e.current,
        t
      );
    }
    function mr(e) {
      if ((an & ba) === gr) {
        var t = e.tag;
        if (t === 3 || t === 1 || t === 0 || t === 11 || t === 14 || t === 15) {
          if (t = Se(e) || "ReactComponent", cg !== null) {
            if (cg.has(t)) return;
            cg.add(t);
          } else cg = /* @__PURE__ */ new Set([t]);
          He(e, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function Fc(e, t) {
      Bn && e.memoizedUpdaters.forEach(function(i) {
        un(e, i, t);
      });
    }
    function Ym(e, t) {
      var i = oe.actQueue;
      return i !== null ? (i.push(t), YE) : B1(e, t);
    }
    function R2(e) {
      Lm() && oe.actQueue === null && He(e, function() {
        console.error(
          `An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act`,
          Se(e)
        );
      });
    }
    function za(e) {
      e !== yh && e.next === null && (yh === null ? dg = yh = e : yh = yh.next = e), ug = !0, oe.actQueue !== null ? rS || (rS = !0, $n()) : aS || (aS = !0, $n());
    }
    function yl(e, t) {
      if (!oS && ug) {
        oS = !0;
        do
          for (var i = !1, o = dg; o !== null; ) {
            if (e !== 0) {
              var c = o.pendingLanes;
              if (c === 0) var h = 0;
              else {
                var v = o.suspendedLanes, S = o.pingedLanes;
                h = (1 << 31 - Mi(42 | e) + 1) - 1, h &= c & ~(v & ~S), h = h & 201326741 ? h & 201326741 | 1 : h ? h | 2 : 0;
              }
              h !== 0 && (i = !0, R1(o, h));
            } else
              h = wt, h = vn(
                o,
                o === pn ? h : 0,
                o.cancelPendingCommit !== null || o.timeoutHandle !== j0
              ), (h & 3) === 0 || ka(o, h) || (i = !0, R1(o, h));
            o = o.next;
          }
        while (i);
        oS = !1;
      }
    }
    function v1() {
      S1();
    }
    function S1() {
      ug = rS = aS = !1;
      var e = 0;
      H0 !== 0 && (_c() && (e = H0), H0 = 0);
      for (var t = $r(), i = null, o = dg; o !== null; ) {
        var c = o.next, h = zr(o, t);
        h === 0 ? (o.next = null, i === null ? dg = c : i.next = c, c === null && (yh = i)) : (i = o, (e !== 0 || (h & 3) !== 0) && (ug = !0)), o = c;
      }
      yl(e);
    }
    function zr(e, t) {
      for (var i = e.suspendedLanes, o = e.pingedLanes, c = e.expirationTimes, h = e.pendingLanes & -62914561; 0 < h; ) {
        var v = 31 - Mi(h), S = 1 << v, M = c[v];
        M === -1 ? ((S & i) === 0 || (S & o) !== 0) && (c[v] = Rr(S, t)) : M <= t && (e.expiredLanes |= S), h &= ~S;
      }
      if (t = pn, i = wt, i = vn(
        e,
        e === t ? i : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== j0
      ), o = e.callbackNode, i === 0 || e === t && (ln === A0 || ln === J0) || e.cancelPendingCommit !== null)
        return o !== null && E1(o), e.callbackNode = null, e.callbackPriority = 0;
      if ((i & 3) === 0 || ka(e, i)) {
        if (t = i & -i, t !== e.callbackPriority || oe.actQueue !== null && o !== sS)
          E1(o);
        else return t;
        switch (Qa(i)) {
          case Ei:
          case fr:
            i = U0;
            break;
          case Io:
            i = Wc;
            break;
          case I1:
            i = T0;
            break;
          default:
            i = Wc;
        }
        return o = Dn.bind(null, e), oe.actQueue !== null ? (oe.actQueue.push(o), i = sS) : i = B1(i, o), e.callbackPriority = t, e.callbackNode = i, t;
      }
      return o !== null && E1(o), e.callbackPriority = 2, e.callbackNode = null, 2;
    }
    function Dn(e, t) {
      if (X2 = Y2 = !1, ji !== I0 && ji !== $v)
        return e.callbackNode = null, e.callbackPriority = 0, null;
      var i = e.callbackNode;
      if (bc() && e.callbackNode !== i)
        return null;
      var o = wt;
      return o = vn(
        e,
        e === pn ? o : 0,
        e.cancelPendingCommit !== null || e.timeoutHandle !== j0
      ), o === 0 ? null : (qn(
        e,
        o,
        t
      ), zr(e, $r()), e.callbackNode != null && e.callbackNode === i ? Dn.bind(null, e) : null);
    }
    function R1(e, t) {
      if (bc()) return null;
      Y2 = X2, X2 = !1, qn(e, t, !0);
    }
    function E1(e) {
      e !== sS && e !== null && pv(e);
    }
    function $n() {
      oe.actQueue !== null && oe.actQueue.push(function() {
        return S1(), null;
      }), rU(function() {
        (an & (ba | Yo)) !== gr ? B1(
          w1,
          v1
        ) : S1();
      });
    }
    function Xm() {
      return H0 === 0 && (H0 = gt()), H0;
    }
    function Km(e) {
      return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : (L(e, "action"), nc("" + e));
    }
    function qm(e, t) {
      var i = t.ownerDocument.createElement("input");
      return i.name = t.name, i.value = t.value, e.id && i.setAttribute("form", e.id), t.parentNode.insertBefore(i, t), e = new FormData(e), i.parentNode.removeChild(i), e;
    }
    function Rn(e, t, i, o, c) {
      if (t === "submit" && i && i.stateNode === c) {
        var h = Km(
          (c[oa] || null).action
        ), v = o.submitter;
        v && (t = (t = v[oa] || null) ? Km(t.formAction) : v.getAttribute("formAction"), t !== null && (h = t, v = null));
        var S = new at(
          "action",
          "action",
          null,
          o,
          c
        );
        e.push({
          event: S,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (o.defaultPrevented) {
                  if (H0 !== 0) {
                    var M = v ? qm(
                      c,
                      v
                    ) : new FormData(c), x = {
                      pending: !0,
                      data: M,
                      method: c.method,
                      action: h
                    };
                    Object.freeze(x), dl(
                      i,
                      x,
                      null,
                      M
                    );
                  }
                } else
                  typeof h == "function" && (S.preventDefault(), M = v ? qm(
                    c,
                    v
                  ) : new FormData(c), x = {
                    pending: !0,
                    data: M,
                    method: c.method,
                    action: h
                  }, Object.freeze(x), dl(
                    i,
                    x,
                    h,
                    M
                  ));
              },
              currentTarget: c
            }
          ]
        });
      }
    }
    function fi(e, t, i) {
      e.currentTarget = i;
      try {
        t(e);
      } catch (o) {
        Iv(o);
      }
      e.currentTarget = null;
    }
    function jr(e, t) {
      t = (t & 4) !== 0;
      for (var i = 0; i < e.length; i++) {
        var o = e[i];
        e: {
          var c = void 0, h = o.event;
          if (o = o.listeners, t)
            for (var v = o.length - 1; 0 <= v; v--) {
              var S = o[v], M = S.instance, x = S.currentTarget;
              if (S = S.listener, M !== c && h.isPropagationStopped())
                break e;
              M !== null ? He(
                M,
                fi,
                h,
                S,
                x
              ) : fi(h, S, x), c = M;
            }
          else
            for (v = 0; v < o.length; v++) {
              if (S = o[v], M = S.instance, x = S.currentTarget, S = S.listener, M !== c && h.isPropagationStopped())
                break e;
              M !== null ? He(
                M,
                fi,
                h,
                S,
                x
              ) : fi(h, S, x), c = M;
            }
        }
      }
    }
    function Dt(e, t) {
      lS.has(e) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        e
      );
      var i = t[bp];
      i === void 0 && (i = t[bp] = /* @__PURE__ */ new Set());
      var o = e + "__bubble";
      i.has(o) || (T1(t, e, 2, !1), i.add(o));
    }
    function U1(e, t, i) {
      lS.has(e) && !t && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        e
      );
      var o = 0;
      t && (o |= 4), T1(
        i,
        e,
        o,
        t
      );
    }
    function $m(e) {
      if (!e[hg]) {
        e[hg] = !0, Z2.forEach(function(i) {
          i !== "selectionchange" && (lS.has(i) || U1(i, !1, e), U1(i, !0, e));
        });
        var t = e.nodeType === 9 ? e : e.ownerDocument;
        t === null || t[hg] || (t[hg] = !0, U1("selectionchange", !1, t));
      }
    }
    function T1(e, t, i, o) {
      switch (D1(t)) {
        case Ei:
          var c = uv;
          break;
        case fr:
          c = Q1;
          break;
        default:
          c = Vs;
      }
      i = c.bind(
        null,
        t,
        i,
        e
      ), c = void 0, !K || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (c = !0), o ? c !== void 0 ? e.addEventListener(t, i, {
        capture: !0,
        passive: c
      }) : e.addEventListener(t, i, !0) : c !== void 0 ? e.addEventListener(t, i, {
        passive: c
      }) : e.addEventListener(
        t,
        i,
        !1
      );
    }
    function Ji(e, t, i, o, c) {
      var h = o;
      if ((t & 1) === 0 && (t & 2) === 0 && o !== null)
        e: for (; ; ) {
          if (o === null) return;
          var v = o.tag;
          if (v === 3 || v === 4) {
            var S = o.stateNode.containerInfo;
            if (S === c) break;
            if (v === 4)
              for (v = o.return; v !== null; ) {
                var M = v.tag;
                if ((M === 3 || M === 4) && v.stateNode.containerInfo === c)
                  return;
                v = v.return;
              }
            for (; S !== null; ) {
              if (v = ii(S), v === null) return;
              if (M = v.tag, M === 5 || M === 6 || M === 26 || M === 27) {
                o = h = v;
                continue e;
              }
              S = S.parentNode;
            }
          }
          o = o.return;
        }
      mu(function() {
        var x = h, ee = Xs(i), le = [];
        e: {
          var q = yR.get(e);
          if (q !== void 0) {
            var ce = at, je = e;
            switch (e) {
              case "keypress":
                if (ic(i) === 0) break e;
              case "keydown":
              case "keyup":
                ce = hE;
                break;
              case "focusin":
                je = "focus", ce = It;
                break;
              case "focusout":
                je = "blur", ce = It;
                break;
              case "beforeblur":
              case "afterblur":
                ce = It;
                break;
              case "click":
                if (i.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                ce = _t;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                ce = lt;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                ce = fE;
                break;
              case RR:
              case ER:
              case UR:
                ce = Rv;
                break;
              case TR:
                ce = vE;
                break;
              case "scroll":
              case "scrollend":
                ce = G;
                break;
              case "wheel":
                ce = RE;
                break;
              case "copy":
              case "cut":
              case "paste":
                ce = rE;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                ce = uR;
                break;
              case "toggle":
              case "beforetoggle":
                ce = UE;
            }
            var ht = (t & 4) !== 0, fn = !ht && (e === "scroll" || e === "scrollend"), Jt = ht ? q !== null ? q + "Capture" : null : q;
            ht = [];
            for (var w = x, J; w !== null; ) {
              var I = w;
              if (J = I.stateNode, I = I.tag, I !== 5 && I !== 26 && I !== 27 || J === null || Jt === null || (I = Eo(w, Jt), I != null && ht.push(
                Li(
                  w,
                  I,
                  J
                )
              )), fn) break;
              w = w.return;
            }
            0 < ht.length && (q = new ce(
              q,
              je,
              null,
              i,
              ee
            ), le.push({
              event: q,
              listeners: ht
            }));
          }
        }
        if ((t & 7) === 0) {
          e: {
            if (q = e === "mouseover" || e === "pointerover", ce = e === "mouseout" || e === "pointerout", q && i !== m && (je = i.relatedTarget || i.fromElement) && (ii(je) || je[Ds]))
              break e;
            if ((ce || q) && (q = ee.window === ee ? ee : (q = ee.ownerDocument) ? q.defaultView || q.parentWindow : window, ce ? (je = i.relatedTarget || i.toElement, ce = x, je = je ? ii(je) : null, je !== null && (fn = he(je), ht = je.tag, je !== fn || ht !== 5 && ht !== 27 && ht !== 6) && (je = null)) : (ce = null, je = x), ce !== je)) {
              if (ht = _t, I = "onMouseLeave", Jt = "onMouseEnter", w = "mouse", (e === "pointerout" || e === "pointerover") && (ht = uR, I = "onPointerLeave", Jt = "onPointerEnter", w = "pointer"), fn = ce == null ? q : Oi(ce), J = je == null ? q : Oi(je), q = new ht(
                I,
                w + "leave",
                ce,
                i,
                ee
              ), q.target = fn, q.relatedTarget = J, I = null, ii(ee) === x && (ht = new ht(
                Jt,
                w + "enter",
                je,
                i,
                ee
              ), ht.target = J, ht.relatedTarget = fn, I = ht), fn = I, ce && je)
                t: {
                  for (ht = ce, Jt = je, w = 0, J = ht; J; J = si(J))
                    w++;
                  for (J = 0, I = Jt; I; I = si(I))
                    J++;
                  for (; 0 < w - J; )
                    ht = si(ht), w--;
                  for (; 0 < J - w; )
                    Jt = si(Jt), J--;
                  for (; w--; ) {
                    if (ht === Jt || Jt !== null && ht === Jt.alternate)
                      break t;
                    ht = si(ht), Jt = si(Jt);
                  }
                  ht = null;
                }
              else ht = null;
              ce !== null && ep(
                le,
                q,
                ce,
                ht,
                !1
              ), je !== null && fn !== null && ep(
                le,
                fn,
                je,
                ht,
                !0
              );
            }
          }
          e: {
            if (q = x ? Oi(x) : window, ce = q.nodeName && q.nodeName.toLowerCase(), ce === "select" || ce === "input" && q.type === "file")
              var ue = Wh;
            else if (Wf(q))
              if (vR)
                ue = av;
              else {
                ue = Hh;
                var we = nv;
              }
            else
              ce = q.nodeName, !ce || ce.toLowerCase() !== "input" || q.type !== "checkbox" && q.type !== "radio" ? x && Ys(x.elementType) && (ue = Wh) : ue = iv;
            if (ue && (ue = ue(e, x))) {
              vu(
                le,
                ue,
                i,
                ee
              );
              break e;
            }
            we && we(e, q, x), e === "focusout" && x && q.type === "number" && x.memoizedProps.value != null && su(q, "number", q.value);
          }
          switch (we = x ? Oi(x) : window, e) {
            case "focusin":
              (Wf(we) || we.contentEditable === "true") && (q1 = we, Uv = x, zp = null);
              break;
            case "focusout":
              zp = Uv = q1 = null;
              break;
            case "mousedown":
              Tv = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              Tv = !1, Yf(
                le,
                i,
                ee
              );
              break;
            case "selectionchange":
              if (bE) break;
            case "keydown":
            case "keyup":
              Yf(
                le,
                i,
                ee
              );
          }
          var Tt;
          if (Ev)
            e: {
              switch (e) {
                case "compositionstart":
                  var Ge = "onCompositionStart";
                  break e;
                case "compositionend":
                  Ge = "onCompositionEnd";
                  break e;
                case "compositionupdate":
                  Ge = "onCompositionUpdate";
                  break e;
              }
              Ge = void 0;
            }
          else
            K1 ? Ai(e, i) && (Ge = "onCompositionEnd") : e === "keydown" && i.keyCode === hR && (Ge = "onCompositionStart");
          Ge && (mR && i.locale !== "ko" && (K1 || Ge !== "onCompositionStart" ? Ge === "onCompositionEnd" && K1 && (Tt = Uo()) : (ve = ee, $ = "value" in ve ? ve.value : ve.textContent, K1 = !0)), we = s0(
            x,
            Ge
          ), 0 < we.length && (Ge = new dR(
            Ge,
            e,
            null,
            i,
            ee
          ), le.push({
            event: Ge,
            listeners: we
          }), Tt ? Ge.data = Tt : (Tt = ns(i), Tt !== null && (Ge.data = Tt)))), (Tt = yE ? gu(e, i) : Ed(e, i)) && (Ge = s0(
            x,
            "onBeforeInput"
          ), 0 < Ge.length && (we = new sE(
            "onBeforeInput",
            "beforeinput",
            null,
            i,
            ee
          ), le.push({
            event: we,
            listeners: Ge
          }), we.data = Tt)), Rn(
            le,
            e,
            x,
            i,
            ee
          );
        }
        jr(le, t);
      });
    }
    function Li(e, t, i) {
      return {
        instance: e,
        listener: t,
        currentTarget: i
      };
    }
    function s0(e, t) {
      for (var i = t + "Capture", o = []; e !== null; ) {
        var c = e, h = c.stateNode;
        if (c = c.tag, c !== 5 && c !== 26 && c !== 27 || h === null || (c = Eo(e, i), c != null && o.unshift(
          Li(e, c, h)
        ), c = Eo(e, t), c != null && o.push(
          Li(e, c, h)
        )), e.tag === 3) return o;
        e = e.return;
      }
      return [];
    }
    function si(e) {
      if (e === null) return null;
      do
        e = e.return;
      while (e && e.tag !== 5 && e.tag !== 27);
      return e || null;
    }
    function ep(e, t, i, o, c) {
      for (var h = t._reactName, v = []; i !== null && i !== o; ) {
        var S = i, M = S.alternate, x = S.stateNode;
        if (S = S.tag, M !== null && M === o) break;
        S !== 5 && S !== 26 && S !== 27 || x === null || (M = x, c ? (x = Eo(i, h), x != null && v.unshift(
          Li(i, x, M)
        )) : c || (x = Eo(i, h), x != null && v.push(
          Li(i, x, M)
        ))), i = i.return;
      }
      v.length !== 0 && e.push({ event: t, listeners: v });
    }
    function Gr(e, t) {
      tc(e, t), e !== "input" && e !== "textarea" && e !== "select" || t == null || t.value !== null || Lp || (Lp = !0, e === "select" && t.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        e
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        e
      ));
      var i = {
        registrationNameDependencies: Xa,
        possibleRegistrationNames: Ql
      };
      Ys(e) || typeof t.is == "string" || Jh(e, t, i), t.contentEditable && !t.suppressContentEditableWarning && t.children != null && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function En(e, t, i, o) {
      t !== i && (i = gi(i), gi(t) !== i && (o[e] = t));
    }
    function ys(e, t, i) {
      t.forEach(function(o) {
        i[np(o)] = o === "style" ? bl(e) : e.getAttribute(o);
      });
    }
    function ja(e, t) {
      t === !1 ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        e,
        e,
        e
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        e,
        typeof t
      );
    }
    function y1(e, t) {
      return e = e.namespaceURI === _0 || e.namespaceURI === Xc ? e.ownerDocument.createElementNS(
        e.namespaceURI,
        e.tagName
      ) : e.ownerDocument.createElement(e.tagName), e.innerHTML = t, e.innerHTML;
    }
    function gi(e) {
      return F(e) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        Te(e)
      ), H(e)), (typeof e == "string" ? e : "" + e).replace(XE, `
`).replace(KE, "");
    }
    function tp(e, t) {
      return t = gi(t), gi(e) === t;
    }
    function xo() {
    }
    function jt(e, t, i, o, c, h) {
      switch (i) {
        case "children":
          typeof o == "string" ? (Sd(o, t, !1), t === "body" || t === "textarea" && o === "" || Ps(e, o)) : (typeof o == "number" || typeof o == "bigint") && (Sd("" + o, t, !1), t !== "body" && Ps(e, "" + o));
          break;
        case "className":
          ct(e, "class", o);
          break;
        case "tabIndex":
          ct(e, "tabindex", o);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          ct(e, i, o);
          break;
        case "style":
          Rd(e, o, h);
          break;
        case "data":
          if (t !== "object") {
            ct(e, "data", o);
            break;
          }
        case "src":
        case "href":
          if (o === "" && (t !== "a" || i !== "href")) {
            console.error(
              i === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              i,
              i
            ), e.removeAttribute(i);
            break;
          }
          if (o == null || typeof o == "function" || typeof o == "symbol" || typeof o == "boolean") {
            e.removeAttribute(i);
            break;
          }
          L(o, i), o = nc("" + o), e.setAttribute(i, o);
          break;
        case "action":
        case "formAction":
          if (o != null && (t === "form" ? i === "formAction" ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : typeof o == "function" && (c.encType == null && c.method == null || fg || (fg = !0, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), c.target == null || pg || (pg = !0, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : t === "input" || t === "button" ? i === "action" ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : t !== "input" || c.type === "submit" || c.type === "image" || mg ? t !== "button" || c.type == null || c.type === "submit" || mg ? typeof o == "function" && (c.name == null || w6 || (w6 = !0, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), c.formEncType == null && c.formMethod == null || fg || (fg = !0, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), c.formTarget == null || pg || (pg = !0, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (mg = !0, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (mg = !0, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : console.error(
            i === "action" ? "You can only pass the action prop to <form>." : "You can only pass the formAction prop to <input> or <button>."
          )), typeof o == "function") {
            e.setAttribute(
              i,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            typeof h == "function" && (i === "formAction" ? (t !== "input" && jt(e, t, "name", c.name, c, null), jt(
              e,
              t,
              "formEncType",
              c.formEncType,
              c,
              null
            ), jt(
              e,
              t,
              "formMethod",
              c.formMethod,
              c,
              null
            ), jt(
              e,
              t,
              "formTarget",
              c.formTarget,
              c,
              null
            )) : (jt(
              e,
              t,
              "encType",
              c.encType,
              c,
              null
            ), jt(e, t, "method", c.method, c, null), jt(
              e,
              t,
              "target",
              c.target,
              c,
              null
            )));
          if (o == null || typeof o == "symbol" || typeof o == "boolean") {
            e.removeAttribute(i);
            break;
          }
          L(o, i), o = nc("" + o), e.setAttribute(i, o);
          break;
        case "onClick":
          o != null && (typeof o != "function" && ja(i, o), e.onclick = xo);
          break;
        case "onScroll":
          o != null && (typeof o != "function" && ja(i, o), Dt("scroll", e));
          break;
        case "onScrollEnd":
          o != null && (typeof o != "function" && ja(i, o), Dt("scrollend", e));
          break;
        case "dangerouslySetInnerHTML":
          if (o != null) {
            if (typeof o != "object" || !("__html" in o))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (i = o.__html, i != null) {
              if (c.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = i;
            }
          }
          break;
        case "multiple":
          e.multiple = o && typeof o != "function" && typeof o != "symbol";
          break;
        case "muted":
          e.muted = o && typeof o != "function" && typeof o != "symbol";
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (o == null || typeof o == "function" || typeof o == "boolean" || typeof o == "symbol") {
            e.removeAttribute("xlink:href");
            break;
          }
          L(o, i), i = nc("" + o), e.setAttributeNS(z0, "xlink:href", i);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          o != null && typeof o != "function" && typeof o != "symbol" ? (L(o, i), e.setAttribute(i, "" + o)) : e.removeAttribute(i);
          break;
        case "inert":
          o !== "" || gg[i] || (gg[i] = !0, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            i
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          o && typeof o != "function" && typeof o != "symbol" ? e.setAttribute(i, "") : e.removeAttribute(i);
          break;
        case "capture":
        case "download":
          o === !0 ? e.setAttribute(i, "") : o !== !1 && o != null && typeof o != "function" && typeof o != "symbol" ? (L(o, i), e.setAttribute(i, o)) : e.removeAttribute(i);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          o != null && typeof o != "function" && typeof o != "symbol" && !isNaN(o) && 1 <= o ? (L(o, i), e.setAttribute(i, o)) : e.removeAttribute(i);
          break;
        case "rowSpan":
        case "start":
          o == null || typeof o == "function" || typeof o == "symbol" || isNaN(o) ? e.removeAttribute(i) : (L(o, i), e.setAttribute(i, o));
          break;
        case "popover":
          Dt("beforetoggle", e), Dt("toggle", e), Ct(e, "popover", o);
          break;
        case "xlinkActuate":
          Sn(
            e,
            z0,
            "xlink:actuate",
            o
          );
          break;
        case "xlinkArcrole":
          Sn(
            e,
            z0,
            "xlink:arcrole",
            o
          );
          break;
        case "xlinkRole":
          Sn(
            e,
            z0,
            "xlink:role",
            o
          );
          break;
        case "xlinkShow":
          Sn(
            e,
            z0,
            "xlink:show",
            o
          );
          break;
        case "xlinkTitle":
          Sn(
            e,
            z0,
            "xlink:title",
            o
          );
          break;
        case "xlinkType":
          Sn(
            e,
            z0,
            "xlink:type",
            o
          );
          break;
        case "xmlBase":
          Sn(
            e,
            cS,
            "xml:base",
            o
          );
          break;
        case "xmlLang":
          Sn(
            e,
            cS,
            "xml:lang",
            o
          );
          break;
        case "xmlSpace":
          Sn(
            e,
            cS,
            "xml:space",
            o
          );
          break;
        case "is":
          h != null && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          ), Ct(e, "is", o);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          A6 || o == null || typeof o != "object" || (A6 = !0, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            o
          ));
        default:
          !(2 < i.length) || i[0] !== "o" && i[0] !== "O" || i[1] !== "n" && i[1] !== "N" ? (i = hu(i), Ct(e, i, o)) : Xa.hasOwnProperty(i) && o != null && typeof o != "function" && ja(i, o);
      }
    }
    function Nl(e, t, i, o, c, h) {
      switch (i) {
        case "style":
          Rd(e, o, h);
          break;
        case "dangerouslySetInnerHTML":
          if (o != null) {
            if (typeof o != "object" || !("__html" in o))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            if (i = o.__html, i != null) {
              if (c.children != null)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              e.innerHTML = i;
            }
          }
          break;
        case "children":
          typeof o == "string" ? Ps(e, o) : (typeof o == "number" || typeof o == "bigint") && Ps(e, "" + o);
          break;
        case "onScroll":
          o != null && (typeof o != "function" && ja(i, o), Dt("scroll", e));
          break;
        case "onScrollEnd":
          o != null && (typeof o != "function" && ja(i, o), Dt("scrollend", e));
          break;
        case "onClick":
          o != null && (typeof o != "function" && ja(i, o), e.onclick = xo);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (Xa.hasOwnProperty(i))
            o != null && typeof o != "function" && ja(i, o);
          else
            e: {
              if (i[0] === "o" && i[1] === "n" && (c = i.endsWith("Capture"), t = i.slice(2, c ? i.length - 7 : void 0), h = e[oa] || null, h = h != null ? h[i] : null, typeof h == "function" && e.removeEventListener(t, h, c), typeof o == "function")) {
                typeof h != "function" && h !== null && (i in e ? e[i] = null : e.hasAttribute(i) && e.removeAttribute(i)), e.addEventListener(t, o, c);
                break e;
              }
              i in e ? e[i] = o : o === !0 ? e.setAttribute(i, "") : Ct(e, i, o);
            }
      }
    }
    function xn(e, t, i) {
      switch (Gr(t, i), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          Dt("error", e), Dt("load", e);
          var o = !1, c = !1, h;
          for (h in i)
            if (i.hasOwnProperty(h)) {
              var v = i[h];
              if (v != null)
                switch (h) {
                  case "src":
                    o = !0;
                    break;
                  case "srcSet":
                    c = !0;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    jt(e, t, h, v, i, null);
                }
            }
          c && jt(e, t, "srcSet", i.srcSet, i, null), o && jt(e, t, "src", i.src, i, null);
          return;
        case "input":
          Je("input", i), Dt("invalid", e);
          var S = h = v = c = null, M = null, x = null;
          for (o in i)
            if (i.hasOwnProperty(o)) {
              var ee = i[o];
              if (ee != null)
                switch (o) {
                  case "name":
                    c = ee;
                    break;
                  case "type":
                    v = ee;
                    break;
                  case "checked":
                    M = ee;
                    break;
                  case "defaultChecked":
                    x = ee;
                    break;
                  case "value":
                    h = ee;
                    break;
                  case "defaultValue":
                    S = ee;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (ee != null)
                      throw Error(
                        t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    jt(e, t, o, ee, i, null);
                }
            }
          qt(e, i), wf(
            e,
            h,
            S,
            M,
            x,
            v,
            c,
            !1
          ), ot(e);
          return;
        case "select":
          Je("select", i), Dt("invalid", e), o = v = h = null;
          for (c in i)
            if (i.hasOwnProperty(c) && (S = i[c], S != null))
              switch (c) {
                case "value":
                  h = S;
                  break;
                case "defaultValue":
                  v = S;
                  break;
                case "multiple":
                  o = S;
                default:
                  jt(
                    e,
                    t,
                    c,
                    S,
                    i,
                    null
                  );
              }
          fd(e, i), t = h, i = v, e.multiple = !!o, t != null ? Ro(e, !!o, t, !1) : i != null && Ro(e, !!o, i, !0);
          return;
        case "textarea":
          Je("textarea", i), Dt("invalid", e), h = c = o = null;
          for (v in i)
            if (i.hasOwnProperty(v) && (S = i[v], S != null))
              switch (v) {
                case "value":
                  o = S;
                  break;
                case "defaultValue":
                  c = S;
                  break;
                case "children":
                  h = S;
                  break;
                case "dangerouslySetInnerHTML":
                  if (S != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  jt(
                    e,
                    t,
                    v,
                    S,
                    i,
                    null
                  );
              }
          Nr(e, i), Zh(e, o, c, h), ot(e);
          return;
        case "option":
          xh(e, i);
          for (M in i)
            if (i.hasOwnProperty(M) && (o = i[M], o != null))
              switch (M) {
                case "selected":
                  e.selected = o && typeof o != "function" && typeof o != "symbol";
                  break;
                default:
                  jt(e, t, M, o, i, null);
              }
          return;
        case "dialog":
          Dt("beforetoggle", e), Dt("toggle", e), Dt("cancel", e), Dt("close", e);
          break;
        case "iframe":
        case "object":
          Dt("load", e);
          break;
        case "video":
        case "audio":
          for (o = 0; o < gf.length; o++)
            Dt(gf[o], e);
          break;
        case "image":
          Dt("error", e), Dt("load", e);
          break;
        case "details":
          Dt("toggle", e);
          break;
        case "embed":
        case "source":
        case "link":
          Dt("error", e), Dt("load", e);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (x in i)
            if (i.hasOwnProperty(x) && (o = i[x], o != null))
              switch (x) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  jt(e, t, x, o, i, null);
              }
          return;
        default:
          if (Ys(t)) {
            for (ee in i)
              i.hasOwnProperty(ee) && (o = i[ee], o !== void 0 && Nl(
                e,
                t,
                ee,
                o,
                i,
                void 0
              ));
            return;
          }
      }
      for (S in i)
        i.hasOwnProperty(S) && (o = i[S], o != null && jt(e, t, S, o, i, null));
    }
    function E2(e, t, i, o) {
      switch (Gr(t, o), t) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var c = null, h = null, v = null, S = null, M = null, x = null, ee = null;
          for (ce in i) {
            var le = i[ce];
            if (i.hasOwnProperty(ce) && le != null)
              switch (ce) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  M = le;
                default:
                  o.hasOwnProperty(ce) || jt(
                    e,
                    t,
                    ce,
                    null,
                    o,
                    le
                  );
              }
          }
          for (var q in o) {
            var ce = o[q];
            if (le = i[q], o.hasOwnProperty(q) && (ce != null || le != null))
              switch (q) {
                case "type":
                  h = ce;
                  break;
                case "name":
                  c = ce;
                  break;
                case "checked":
                  x = ce;
                  break;
                case "defaultChecked":
                  ee = ce;
                  break;
                case "value":
                  v = ce;
                  break;
                case "defaultValue":
                  S = ce;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (ce != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  ce !== le && jt(
                    e,
                    t,
                    q,
                    ce,
                    o,
                    le
                  );
              }
          }
          t = i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null, o = o.type === "checkbox" || o.type === "radio" ? o.checked != null : o.value != null, t || !o || B6 || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), B6 = !0), !t || o || O6 || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), O6 = !0), Gi(
            e,
            v,
            S,
            M,
            x,
            ee,
            h,
            c
          );
          return;
        case "select":
          ce = v = S = q = null;
          for (h in i)
            if (M = i[h], i.hasOwnProperty(h) && M != null)
              switch (h) {
                case "value":
                  break;
                case "multiple":
                  ce = M;
                default:
                  o.hasOwnProperty(h) || jt(
                    e,
                    t,
                    h,
                    null,
                    o,
                    M
                  );
              }
          for (c in o)
            if (h = o[c], M = i[c], o.hasOwnProperty(c) && (h != null || M != null))
              switch (c) {
                case "value":
                  q = h;
                  break;
                case "defaultValue":
                  S = h;
                  break;
                case "multiple":
                  v = h;
                default:
                  h !== M && jt(
                    e,
                    t,
                    c,
                    h,
                    o,
                    M
                  );
              }
          o = S, t = v, i = ce, q != null ? Ro(e, !!t, q, !1) : !!i != !!t && (o != null ? Ro(e, !!t, o, !0) : Ro(e, !!t, t ? [] : "", !1));
          return;
        case "textarea":
          ce = q = null;
          for (S in i)
            if (c = i[S], i.hasOwnProperty(S) && c != null && !o.hasOwnProperty(S))
              switch (S) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  jt(e, t, S, null, o, c);
              }
          for (v in o)
            if (c = o[v], h = i[v], o.hasOwnProperty(v) && (c != null || h != null))
              switch (v) {
                case "value":
                  q = c;
                  break;
                case "defaultValue":
                  ce = c;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (c != null)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  c !== h && jt(e, t, v, c, o, h);
              }
          lu(e, q, ce);
          return;
        case "option":
          for (var je in i)
            if (q = i[je], i.hasOwnProperty(je) && q != null && !o.hasOwnProperty(je))
              switch (je) {
                case "selected":
                  e.selected = !1;
                  break;
                default:
                  jt(
                    e,
                    t,
                    je,
                    null,
                    o,
                    q
                  );
              }
          for (M in o)
            if (q = o[M], ce = i[M], o.hasOwnProperty(M) && q !== ce && (q != null || ce != null))
              switch (M) {
                case "selected":
                  e.selected = q && typeof q != "function" && typeof q != "symbol";
                  break;
                default:
                  jt(
                    e,
                    t,
                    M,
                    q,
                    o,
                    ce
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var ht in i)
            q = i[ht], i.hasOwnProperty(ht) && q != null && !o.hasOwnProperty(ht) && jt(
              e,
              t,
              ht,
              null,
              o,
              q
            );
          for (x in o)
            if (q = o[x], ce = i[x], o.hasOwnProperty(x) && q !== ce && (q != null || ce != null))
              switch (x) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (q != null)
                    throw Error(
                      t + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  jt(
                    e,
                    t,
                    x,
                    q,
                    o,
                    ce
                  );
              }
          return;
        default:
          if (Ys(t)) {
            for (var fn in i)
              q = i[fn], i.hasOwnProperty(fn) && q !== void 0 && !o.hasOwnProperty(fn) && Nl(
                e,
                t,
                fn,
                void 0,
                o,
                q
              );
            for (ee in o)
              q = o[ee], ce = i[ee], !o.hasOwnProperty(ee) || q === ce || q === void 0 && ce === void 0 || Nl(
                e,
                t,
                ee,
                q,
                o,
                ce
              );
            return;
          }
      }
      for (var Jt in i)
        q = i[Jt], i.hasOwnProperty(Jt) && q != null && !o.hasOwnProperty(Jt) && jt(e, t, Jt, null, o, q);
      for (le in o)
        q = o[le], ce = i[le], !o.hasOwnProperty(le) || q === ce || q == null && ce == null || jt(e, t, le, q, o, ce);
    }
    function np(e) {
      switch (e) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return e;
      }
    }
    function bl(e) {
      var t = {};
      e = e.style;
      for (var i = 0; i < e.length; i++) {
        var o = e[i];
        t[o] = e.getPropertyValue(o);
      }
      return t;
    }
    function ip(e, t, i) {
      if (t != null && typeof t != "object")
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var o, c = o = "", h;
        for (h in t)
          if (t.hasOwnProperty(h)) {
            var v = t[h];
            v != null && typeof v != "boolean" && v !== "" && (h.indexOf("--") === 0 ? (de(v, h), o += c + h + ":" + ("" + v).trim()) : typeof v != "number" || v === 0 || F0.has(h) ? (de(v, h), o += c + h.replace(Wo, "-$1").toLowerCase().replace(Ho, "-ms-") + ":" + ("" + v).trim()) : o += c + h.replace(Wo, "-$1").toLowerCase().replace(Ho, "-ms-") + ":" + v + "px", c = ";");
          }
        o = o || null, t = e.getAttribute("style"), t !== o && (o = gi(o), gi(t) !== o && (i.style = bl(e)));
      }
    }
    function Ii(e, t, i, o, c, h) {
      if (c.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (o != null)
        switch (typeof o) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (L(o, t), e === "" + o)
              return;
        }
      En(t, e, o, h);
    }
    function ap(e, t, i, o, c, h) {
      if (c.delete(i), e = e.getAttribute(i), e === null) {
        switch (typeof o) {
          case "function":
          case "symbol":
            return;
        }
        if (!o) return;
      } else
        switch (typeof o) {
          case "function":
          case "symbol":
            break;
          default:
            if (o) return;
        }
      En(t, e, o, h);
    }
    function rp(e, t, i, o, c, h) {
      if (c.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (o != null)
        switch (typeof o) {
          case "function":
          case "symbol":
            break;
          default:
            if (L(o, i), e === "" + o)
              return;
        }
      En(t, e, o, h);
    }
    function U2(e, t, i, o, c, h) {
      if (c.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(o)) return;
        }
      else if (o != null)
        switch (typeof o) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(o) && (L(o, t), e === "" + o))
              return;
        }
      En(t, e, o, h);
    }
    function Xt(e, t, i, o, c, h) {
      if (c.delete(i), e = e.getAttribute(i), e === null)
        switch (typeof o) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (o != null)
        switch (typeof o) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (L(o, t), i = nc("" + o), e === i)
              return;
        }
      En(t, e, o, h);
    }
    function dn(e, t, i, o) {
      for (var c = {}, h = /* @__PURE__ */ new Set(), v = e.attributes, S = 0; S < v.length; S++)
        switch (v[S].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            h.add(v[S].name);
        }
      if (Ys(t)) {
        for (var M in i)
          if (i.hasOwnProperty(M)) {
            var x = i[M];
            if (x != null) {
              if (Xa.hasOwnProperty(M))
                typeof x != "function" && ja(M, x);
              else if (i.suppressHydrationWarning !== !0)
                switch (M) {
                  case "children":
                    typeof x != "string" && typeof x != "number" || En(
                      "children",
                      e.textContent,
                      x,
                      c
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    v = e.innerHTML, x = x ? x.__html : void 0, x != null && (x = y1(e, x), En(
                      M,
                      v,
                      x,
                      c
                    ));
                    continue;
                  case "style":
                    h.delete(M), ip(e, x, c);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    h.delete(M.toLowerCase()), console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      M
                    );
                    continue;
                  case "className":
                    h.delete("class"), v = mt(
                      e,
                      "class",
                      x
                    ), En(
                      "className",
                      v,
                      x,
                      c
                    );
                    continue;
                  default:
                    o.context === zl && t !== "svg" && t !== "math" ? h.delete(M.toLowerCase()) : h.delete(M), v = mt(
                      e,
                      M,
                      x
                    ), En(
                      M,
                      v,
                      x,
                      c
                    );
                }
            }
          }
      } else
        for (x in i)
          if (i.hasOwnProperty(x) && (M = i[x], M != null)) {
            if (Xa.hasOwnProperty(x))
              typeof M != "function" && ja(x, M);
            else if (i.suppressHydrationWarning !== !0)
              switch (x) {
                case "children":
                  typeof M != "string" && typeof M != "number" || En(
                    "children",
                    e.textContent,
                    M,
                    c
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  v = e.innerHTML, M = M ? M.__html : void 0, M != null && (M = y1(e, M), v !== M && (c[x] = { __html: v }));
                  continue;
                case "className":
                  Ii(
                    e,
                    x,
                    "class",
                    M,
                    h,
                    c
                  );
                  continue;
                case "tabIndex":
                  Ii(
                    e,
                    x,
                    "tabindex",
                    M,
                    h,
                    c
                  );
                  continue;
                case "style":
                  h.delete(x), ip(e, M, c);
                  continue;
                case "multiple":
                  h.delete(x), En(
                    x,
                    e.multiple,
                    M,
                    c
                  );
                  continue;
                case "muted":
                  h.delete(x), En(
                    x,
                    e.muted,
                    M,
                    c
                  );
                  continue;
                case "autoFocus":
                  h.delete("autofocus"), En(
                    x,
                    e.autofocus,
                    M,
                    c
                  );
                  continue;
                case "data":
                  if (t !== "object") {
                    h.delete(x), v = e.getAttribute("data"), En(
                      x,
                      v,
                      M,
                      c
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!(M !== "" || t === "a" && x === "href" || t === "object" && x === "data")) {
                    console.error(
                      x === "src" ? 'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.' : 'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      x,
                      x
                    );
                    continue;
                  }
                  Xt(
                    e,
                    x,
                    x,
                    M,
                    h,
                    c
                  );
                  continue;
                case "action":
                case "formAction":
                  if (v = e.getAttribute(x), typeof M == "function") {
                    h.delete(x.toLowerCase()), x === "formAction" ? (h.delete("name"), h.delete("formenctype"), h.delete("formmethod"), h.delete("formtarget")) : (h.delete("enctype"), h.delete("method"), h.delete("target"));
                    continue;
                  } else if (v === qE) {
                    h.delete(x.toLowerCase()), En(
                      x,
                      "function",
                      M,
                      c
                    );
                    continue;
                  }
                  Xt(
                    e,
                    x,
                    x.toLowerCase(),
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkHref":
                  Xt(
                    e,
                    x,
                    "xlink:href",
                    M,
                    h,
                    c
                  );
                  continue;
                case "contentEditable":
                  rp(
                    e,
                    x,
                    "contenteditable",
                    M,
                    h,
                    c
                  );
                  continue;
                case "spellCheck":
                  rp(
                    e,
                    x,
                    "spellcheck",
                    M,
                    h,
                    c
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  rp(
                    e,
                    x,
                    x,
                    M,
                    h,
                    c
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  ap(
                    e,
                    x,
                    x.toLowerCase(),
                    M,
                    h,
                    c
                  );
                  continue;
                case "capture":
                case "download":
                  e: {
                    S = e;
                    var ee = v = x, le = c;
                    if (h.delete(ee), S = S.getAttribute(ee), S === null)
                      switch (typeof M) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break e;
                        default:
                          if (M === !1) break e;
                      }
                    else if (M != null)
                      switch (typeof M) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (M === !0 && S === "") break e;
                          break;
                        default:
                          if (L(M, v), S === "" + M)
                            break e;
                      }
                    En(
                      v,
                      S,
                      M,
                      le
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  e: {
                    if (S = e, ee = v = x, le = c, h.delete(ee), S = S.getAttribute(ee), S === null)
                      switch (typeof M) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break e;
                        default:
                          if (isNaN(M) || 1 > M) break e;
                      }
                    else if (M != null)
                      switch (typeof M) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(M) || 1 > M) && (L(M, v), S === "" + M))
                            break e;
                      }
                    En(
                      v,
                      S,
                      M,
                      le
                    );
                  }
                  continue;
                case "rowSpan":
                  U2(
                    e,
                    x,
                    "rowspan",
                    M,
                    h,
                    c
                  );
                  continue;
                case "start":
                  U2(
                    e,
                    x,
                    x,
                    M,
                    h,
                    c
                  );
                  continue;
                case "xHeight":
                  Ii(
                    e,
                    x,
                    "x-height",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkActuate":
                  Ii(
                    e,
                    x,
                    "xlink:actuate",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkArcrole":
                  Ii(
                    e,
                    x,
                    "xlink:arcrole",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkRole":
                  Ii(
                    e,
                    x,
                    "xlink:role",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkShow":
                  Ii(
                    e,
                    x,
                    "xlink:show",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkTitle":
                  Ii(
                    e,
                    x,
                    "xlink:title",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xlinkType":
                  Ii(
                    e,
                    x,
                    "xlink:type",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xmlBase":
                  Ii(
                    e,
                    x,
                    "xml:base",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xmlLang":
                  Ii(
                    e,
                    x,
                    "xml:lang",
                    M,
                    h,
                    c
                  );
                  continue;
                case "xmlSpace":
                  Ii(
                    e,
                    x,
                    "xml:space",
                    M,
                    h,
                    c
                  );
                  continue;
                case "inert":
                  M !== "" || gg[x] || (gg[x] = !0, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    x
                  )), ap(
                    e,
                    x,
                    x,
                    M,
                    h,
                    c
                  );
                  continue;
                default:
                  if (!(2 < x.length) || x[0] !== "o" && x[0] !== "O" || x[1] !== "n" && x[1] !== "N") {
                    S = hu(x), v = !1, o.context === zl && t !== "svg" && t !== "math" ? h.delete(S.toLowerCase()) : (ee = x.toLowerCase(), ee = Zl.hasOwnProperty(
                      ee
                    ) && Zl[ee] || null, ee !== null && ee !== x && (v = !0, h.delete(ee)), h.delete(S));
                    e: if (ee = e, le = S, S = M, nt(le))
                      if (ee.hasAttribute(le))
                        ee = ee.getAttribute(
                          le
                        ), L(
                          S,
                          le
                        ), S = ee === "" + S ? S : ee;
                      else {
                        switch (typeof S) {
                          case "function":
                          case "symbol":
                            break e;
                          case "boolean":
                            if (ee = le.toLowerCase().slice(0, 5), ee !== "data-" && ee !== "aria-")
                              break e;
                        }
                        S = S === void 0 ? void 0 : null;
                      }
                    else S = void 0;
                    v || En(
                      x,
                      S,
                      M,
                      c
                    );
                  }
              }
          }
      return 0 < h.size && i.suppressHydrationWarning !== !0 && ys(e, h, c), Object.keys(c).length === 0 ? null : c;
    }
    function xt(e, t) {
      switch (e.length) {
        case 0:
          return "";
        case 1:
          return e[0];
        case 2:
          return e[0] + " " + t + " " + e[1];
        default:
          return e.slice(0, -1).join(", ") + ", " + t + " " + e[e.length - 1];
      }
    }
    function Zt(e) {
      return e.nodeType === 9 ? e : e.ownerDocument;
    }
    function $t(e) {
      switch (e) {
        case Xc:
          return Nh;
        case _0:
          return Rg;
        default:
          return zl;
      }
    }
    function na(e, t) {
      if (e === zl)
        switch (t) {
          case "svg":
            return Nh;
          case "math":
            return Rg;
          default:
            return zl;
        }
      return e === Nh && t === "foreignObject" ? zl : e;
    }
    function Pr(e, t) {
      return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
    }
    function _c() {
      var e = window.event;
      return e && e.type === "popstate" ? e === mS ? !1 : (mS = e, !0) : (mS = null, !1);
    }
    function op(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function Zo(e, t, i) {
      switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          i.autoFocus && e.focus();
          break;
        case "img":
          i.src ? e.src = i.src : i.srcSet && (e.srcset = i.srcSet);
      }
    }
    function Zn(e, t, i, o) {
      E2(e, t, i, o), e[oa] = o;
    }
    function Oo(e) {
      Ps(e, "");
    }
    function Vl(e, t, i) {
      e.nodeValue = i;
    }
    function Yr(e) {
      return e === "head";
    }
    function Ga(e, t) {
      e.removeChild(t);
    }
    function Mc(e, t) {
      (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).removeChild(t);
    }
    function kc(e, t) {
      var i = t, o = 0, c = 0;
      do {
        var h = i.nextSibling;
        if (e.removeChild(i), h && h.nodeType === 8)
          if (i = h.data, i === Sg) {
            if (0 < o && 8 > o) {
              i = o;
              var v = e.ownerDocument;
              if (i & eU && Zc(v.documentElement), i & tU && Zc(v.body), i & nU)
                for (i = v.head, Zc(i), v = i.firstChild; v; ) {
                  var S = v.nextSibling, M = v.nodeName;
                  v[jc] || M === "SCRIPT" || M === "STYLE" || M === "LINK" && v.rel.toLowerCase() === "stylesheet" || i.removeChild(v), v = S;
                }
            }
            if (c === 0) {
              e.removeChild(h), Ml(t);
              return;
            }
            c--;
          } else
            i === vg || i === Hl || i === vf ? c++ : o = i.charCodeAt(0) - 48;
        else o = 0;
        i = h;
      } while (i);
      Ml(t);
    }
    function ia(e) {
      e = e.style, typeof e.setProperty == "function" ? e.setProperty("display", "none", "important") : e.display = "none";
    }
    function sp(e) {
      e.nodeValue = "";
    }
    function lp(e, t) {
      t = t[iU], t = t != null && t.hasOwnProperty("display") ? t.display : null, e.style.display = t == null || typeof t == "boolean" ? "" : ("" + t).trim();
    }
    function N1(e, t) {
      e.nodeValue = t;
    }
    function Qc(e) {
      var t = e.firstChild;
      for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
        var i = t;
        switch (t = t.nextSibling, i.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            Qc(i), Zi(i);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if (i.rel.toLowerCase() === "stylesheet") continue;
        }
        e.removeChild(i);
      }
    }
    function Ns(e, t, i, o) {
      for (; e.nodeType === 1; ) {
        var c = i;
        if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
          if (!o && (e.nodeName !== "INPUT" || e.type !== "hidden"))
            break;
        } else if (o) {
          if (!e[jc])
            switch (t) {
              case "meta":
                if (!e.hasAttribute("itemprop")) break;
                return e;
              case "link":
                if (h = e.getAttribute("rel"), h === "stylesheet" && e.hasAttribute("data-precedence"))
                  break;
                if (h !== c.rel || e.getAttribute("href") !== (c.href == null || c.href === "" ? null : c.href) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin) || e.getAttribute("title") !== (c.title == null ? null : c.title))
                  break;
                return e;
              case "style":
                if (e.hasAttribute("data-precedence")) break;
                return e;
              case "script":
                if (h = e.getAttribute("src"), (h !== (c.src == null ? null : c.src) || e.getAttribute("type") !== (c.type == null ? null : c.type) || e.getAttribute("crossorigin") !== (c.crossOrigin == null ? null : c.crossOrigin)) && h && e.hasAttribute("async") && !e.hasAttribute("itemprop"))
                  break;
                return e;
              default:
                return e;
            }
        } else if (t === "input" && e.type === "hidden") {
          L(c.name, "name");
          var h = c.name == null ? null : "" + c.name;
          if (c.type === "hidden" && e.getAttribute("name") === h)
            return e;
        } else return e;
        if (e = Si(e.nextSibling), e === null) break;
      }
      return null;
    }
    function vi(e, t, i) {
      if (t === "") return null;
      for (; e.nodeType !== 3; )
        if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !i || (e = Si(e.nextSibling), e === null)) return null;
      return e;
    }
    function Xr(e) {
      return e.data === vf || e.data === Hl && e.ownerDocument.readyState === L6;
    }
    function Dc(e, t) {
      var i = e.ownerDocument;
      if (e.data !== Hl || i.readyState === L6)
        t();
      else {
        var o = function() {
          t(), i.removeEventListener("DOMContentLoaded", o);
        };
        i.addEventListener("DOMContentLoaded", o), e._reactRetry = o;
      }
    }
    function Si(e) {
      for (; e != null; e = e.nextSibling) {
        var t = e.nodeType;
        if (t === 1 || t === 3) break;
        if (t === 8) {
          if (t = e.data, t === vg || t === vf || t === Hl || t === dS || t === J6)
            break;
          if (t === Sg) return null;
        }
      }
      return e;
    }
    function b1(e) {
      if (e.nodeType === 1) {
        for (var t = e.nodeName.toLowerCase(), i = {}, o = e.attributes, c = 0; c < o.length; c++) {
          var h = o[c];
          i[np(h.name)] = h.name.toLowerCase() === "style" ? bl(e) : h.value;
        }
        return { type: t, props: i };
      }
      return e.nodeType === 8 ? { type: "Suspense", props: {} } : e.nodeValue;
    }
    function V1(e, t, i) {
      return i === null || i[$E] !== !0 ? (e.nodeValue === t ? e = null : (t = gi(t), e = gi(e.nodeValue) === t ? null : e.nodeValue), e) : null;
    }
    function cp(e) {
      e = e.nextSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var i = e.data;
          if (i === Sg) {
            if (t === 0)
              return Si(e.nextSibling);
            t--;
          } else
            i !== vg && i !== vf && i !== Hl || t++;
        }
        e = e.nextSibling;
      }
      return null;
    }
    function xc(e) {
      e = e.previousSibling;
      for (var t = 0; e; ) {
        if (e.nodeType === 8) {
          var i = e.data;
          if (i === vg || i === vf || i === Hl) {
            if (t === 0) return e;
            t--;
          } else i === Sg && t++;
        }
        e = e.previousSibling;
      }
      return null;
    }
    function dp(e) {
      Ml(e);
    }
    function Sa(e) {
      Ml(e);
    }
    function up(e, t, i, o, c) {
      switch (c && uu(e, o.ancestorInfo), t = Zt(i), e) {
        case "html":
          if (e = t.documentElement, !e)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "head":
          if (e = t.head, !e)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        case "body":
          if (e = t.body, !e)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return e;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function Ra(e, t, i, o) {
      if (!i[Ds] && In(i)) {
        var c = i.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          c,
          c,
          c
        );
      }
      switch (e) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (c = i.attributes; c.length; )
        i.removeAttributeNode(c[0]);
      xn(i, e, t), i[ki] = o, i[oa] = t;
    }
    function Zc(e) {
      for (var t = e.attributes; t.length; )
        e.removeAttributeNode(t[0]);
      Zi(e);
    }
    function l0(e) {
      return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
    }
    function T2(e, t, i) {
      var o = bh;
      if (o && typeof t == "string" && t) {
        var c = dt(t);
        c = 'link[rel="' + e + '"][href="' + c + '"]', typeof i == "string" && (c += '[crossorigin="' + i + '"]'), G6.has(c) || (G6.add(c), e = { rel: e, crossOrigin: i, href: t }, o.querySelector(c) === null && (t = o.createElement("link"), xn(t, "link", e), j(t), o.head.appendChild(t)));
      }
    }
    function Bo(e, t, i, o) {
      var c = (c = qr.current) ? l0(c) : null;
      if (!c)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (e) {
        case "meta":
        case "title":
          return null;
        case "style":
          return typeof i.precedence == "string" && typeof i.href == "string" ? (i = bs(i.href), t = C(c).hoistableStyles, o = t.get(i), o || (o = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, t.set(i, o)), o) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if (i.rel === "stylesheet" && typeof i.href == "string" && typeof i.precedence == "string") {
            e = bs(i.href);
            var h = C(c).hoistableStyles, v = h.get(e);
            if (!v && (c = c.ownerDocument || c, v = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: G0, preload: null }
            }, h.set(e, v), (h = c.querySelector(
              Kr(e)
            )) && !h._p && (v.instance = h, v.state.loading = Sf | ho), !mo.has(e))) {
              var S = {
                rel: "preload",
                as: "style",
                href: i.href,
                crossOrigin: i.crossOrigin,
                integrity: i.integrity,
                media: i.media,
                hrefLang: i.hrefLang,
                referrerPolicy: i.referrerPolicy
              };
              mo.set(e, S), h || y2(
                c,
                e,
                S,
                v.state
              );
            }
            if (t && o === null)
              throw i = `

  - ` + Cl(t) + `
  + ` + Cl(i), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + i
              );
            return v;
          }
          if (t && o !== null)
            throw i = `

  - ` + Cl(t) + `
  + ` + Cl(i), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + i
            );
          return null;
        case "script":
          return t = i.async, i = i.src, typeof i == "string" && t && typeof t != "function" && typeof t != "symbol" ? (i = Fl(i), t = C(c).hoistableScripts, o = t.get(i), o || (o = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, t.set(i, o)), o) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + e + '". this is a bug in React.'
          );
      }
    }
    function Cl(e) {
      var t = 0, i = "<link";
      return typeof e.rel == "string" ? (t++, i += ' rel="' + e.rel + '"') : Jo.call(e, "rel") && (t++, i += ' rel="' + (e.rel === null ? "null" : "invalid type " + typeof e.rel) + '"'), typeof e.href == "string" ? (t++, i += ' href="' + e.href + '"') : Jo.call(e, "href") && (t++, i += ' href="' + (e.href === null ? "null" : "invalid type " + typeof e.href) + '"'), typeof e.precedence == "string" ? (t++, i += ' precedence="' + e.precedence + '"') : Jo.call(e, "precedence") && (t++, i += " precedence={" + (e.precedence === null ? "null" : "invalid type " + typeof e.precedence) + "}"), Object.getOwnPropertyNames(e).length > t && (i += " ..."), i + " />";
    }
    function bs(e) {
      return 'href="' + dt(e) + '"';
    }
    function Kr(e) {
      return 'link[rel="stylesheet"][' + e + "]";
    }
    function hp(e) {
      return bt({}, e, {
        "data-precedence": e.precedence,
        precedence: null
      });
    }
    function y2(e, t, i, o) {
      e.querySelector(
        'link[rel="preload"][as="style"][' + t + "]"
      ) ? o.loading = Sf : (t = e.createElement("link"), o.preload = t, t.addEventListener("load", function() {
        return o.loading |= Sf;
      }), t.addEventListener("error", function() {
        return o.loading |= z6;
      }), xn(t, "link", i), j(t), e.head.appendChild(t));
    }
    function Fl(e) {
      return '[src="' + dt(e) + '"]';
    }
    function _l(e) {
      return "script[async]" + e;
    }
    function C1(e, t, i) {
      if (t.count++, t.instance === null)
        switch (t.type) {
          case "style":
            var o = e.querySelector(
              'style[data-href~="' + dt(i.href) + '"]'
            );
            if (o)
              return t.instance = o, j(o), o;
            var c = bt({}, i, {
              "data-href": i.href,
              "data-precedence": i.precedence,
              href: null,
              precedence: null
            });
            return o = (e.ownerDocument || e).createElement("style"), j(o), xn(o, "style", c), F1(o, i.precedence, e), t.instance = o;
          case "stylesheet":
            c = bs(i.href);
            var h = e.querySelector(
              Kr(c)
            );
            if (h)
              return t.state.loading |= ho, t.instance = h, j(h), h;
            o = hp(i), (c = mo.get(c)) && mp(o, c), h = (e.ownerDocument || e).createElement("link"), j(h);
            var v = h;
            return v._p = new Promise(function(S, M) {
              v.onload = S, v.onerror = M;
            }), xn(h, "link", o), t.state.loading |= ho, F1(h, i.precedence, e), t.instance = h;
          case "script":
            return h = Fl(i.src), (c = e.querySelector(
              _l(h)
            )) ? (t.instance = c, j(c), c) : (o = i, (c = mo.get(h)) && (o = bt({}, i), pp(o, c)), e = e.ownerDocument || e, c = e.createElement("script"), j(c), xn(c, "link", o), e.head.appendChild(c), t.instance = c);
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + t.type + '". this is a bug in React.'
            );
        }
      else
        t.type === "stylesheet" && (t.state.loading & ho) === G0 && (o = t.instance, t.state.loading |= ho, F1(o, i.precedence, e));
      return t.instance;
    }
    function F1(e, t, i) {
      for (var o = i.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), c = o.length ? o[o.length - 1] : null, h = c, v = 0; v < o.length; v++) {
        var S = o[v];
        if (S.dataset.precedence === t) h = S;
        else if (h !== c) break;
      }
      h ? h.parentNode.insertBefore(e, h.nextSibling) : (t = i.nodeType === 9 ? i.head : i, t.insertBefore(e, t.firstChild));
    }
    function mp(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.title == null && (e.title = t.title);
    }
    function pp(e, t) {
      e.crossOrigin == null && (e.crossOrigin = t.crossOrigin), e.referrerPolicy == null && (e.referrerPolicy = t.referrerPolicy), e.integrity == null && (e.integrity = t.integrity);
    }
    function fp(e, t, i) {
      if (Eg === null) {
        var o = /* @__PURE__ */ new Map(), c = Eg = /* @__PURE__ */ new Map();
        c.set(i, o);
      } else
        c = Eg, o = c.get(i), o || (o = /* @__PURE__ */ new Map(), c.set(i, o));
      if (o.has(e)) return o;
      for (o.set(e, null), i = i.getElementsByTagName(e), c = 0; c < i.length; c++) {
        var h = i[c];
        if (!(h[jc] || h[ki] || e === "link" && h.getAttribute("rel") === "stylesheet") && h.namespaceURI !== Xc) {
          var v = h.getAttribute(t) || "";
          v = e + v;
          var S = o.get(v);
          S ? S.push(h) : o.set(v, [h]);
        }
      }
      return o;
    }
    function gp(e, t, i) {
      e = e.ownerDocument || e, e.head.insertBefore(
        i,
        t === "title" ? e.querySelector("head > title") : null
      );
    }
    function Oc(e, t, i) {
      var o = !i.ancestorInfo.containerTagInScope;
      if (i.context === Nh || t.itemProp != null)
        return !o || t.itemProp == null || e !== "meta" && e !== "title" && e !== "style" && e !== "link" && e !== "script" || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          e,
          e
        ), !1;
      switch (e) {
        case "meta":
        case "title":
          return !0;
        case "style":
          if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") {
            o && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return !0;
        case "link":
          if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) {
            if (t.rel === "stylesheet" && typeof t.precedence == "string") {
              e = t.href;
              var c = t.onError, h = t.disabled;
              i = [], t.onLoad && i.push("`onLoad`"), c && i.push("`onError`"), h != null && i.push("`disabled`"), c = xt(i, "and"), c += i.length === 1 ? " prop" : " props", h = i.length === 1 ? "an " + c : "the " + c, i.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                e,
                h,
                c
              );
            }
            o && (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (t.onError || t.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (t.rel) {
            case "stylesheet":
              return e = t.precedence, t = t.disabled, typeof e != "string" && o && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), typeof e == "string" && t == null;
            default:
              return !0;
          }
        case "script":
          if (e = t.async && typeof t.async != "function" && typeof t.async != "symbol", !e || t.onLoad || t.onError || !t.src || typeof t.src != "string") {
            o && (e ? t.onLoad || t.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return !0;
        case "noscript":
        case "template":
          o && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            e
          );
      }
      return !1;
    }
    function c0(e) {
      return !(e.type === "stylesheet" && (e.state.loading & j6) === G0);
    }
    function N2() {
    }
    function b2(e, t, i) {
      if (Rf === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var o = Rf;
      if (t.type === "stylesheet" && (typeof i.media != "string" || matchMedia(i.media).matches !== !1) && (t.state.loading & ho) === G0) {
        if (t.instance === null) {
          var c = bs(i.href), h = e.querySelector(
            Kr(c)
          );
          if (h) {
            e = h._p, e !== null && typeof e == "object" && typeof e.then == "function" && (o.count++, o = d0.bind(o), e.then(o, o)), t.state.loading |= ho, t.instance = h, j(h);
            return;
          }
          h = e.ownerDocument || e, i = hp(i), (c = mo.get(c)) && mp(i, c), h = h.createElement("link"), j(h);
          var v = h;
          v._p = new Promise(function(S, M) {
            v.onload = S, v.onerror = M;
          }), xn(h, "link", i), t.instance = h;
        }
        o.stylesheets === null && (o.stylesheets = /* @__PURE__ */ new Map()), o.stylesheets.set(t, e), (e = t.state.preload) && (t.state.loading & j6) === G0 && (o.count++, t = d0.bind(o), e.addEventListener("load", t), e.addEventListener("error", t));
      }
    }
    function V2() {
      if (Rf === null)
        throw Error(
          "Internal React Error: suspendedState null when it was expected to exists. Please report this as a React bug."
        );
      var e = Rf;
      return e.stylesheets && e.count === 0 && _1(e, e.stylesheets), 0 < e.count ? function(t) {
        var i = setTimeout(function() {
          if (e.stylesheets && _1(e, e.stylesheets), e.unsuspend) {
            var o = e.unsuspend;
            e.unsuspend = null, o();
          }
        }, 6e4);
        return e.unsuspend = t, function() {
          e.unsuspend = null, clearTimeout(i);
        };
      } : null;
    }
    function d0() {
      if (this.count--, this.count === 0) {
        if (this.stylesheets)
          _1(this, this.stylesheets);
        else if (this.unsuspend) {
          var e = this.unsuspend;
          this.unsuspend = null, e();
        }
      }
    }
    function _1(e, t) {
      e.stylesheets = null, e.unsuspend !== null && (e.count++, Ug = /* @__PURE__ */ new Map(), t.forEach(C2, e), Ug = null, d0.call(e));
    }
    function C2(e, t) {
      if (!(t.state.loading & ho)) {
        var i = Ug.get(e);
        if (i) var o = i.get(fS);
        else {
          i = /* @__PURE__ */ new Map(), Ug.set(e, i);
          for (var c = e.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), h = 0; h < c.length; h++) {
            var v = c[h];
            (v.nodeName === "LINK" || v.getAttribute("media") !== "not all") && (i.set(v.dataset.precedence, v), o = v);
          }
          o && i.set(fS, o);
        }
        c = t.instance, v = c.getAttribute("data-precedence"), h = i.get(v) || o, h === o && i.set(fS, c), i.set(v, c), this.count++, o = d0.bind(this), c.addEventListener("load", o), c.addEventListener("error", o), h ? h.parentNode.insertBefore(c, h.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(c, e.firstChild)), t.state.loading |= ho;
      }
    }
    function M1(e, t, i, o, c, h, v, S) {
      for (this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = j0, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Lt(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Lt(0), this.hiddenUpdates = Lt(null), this.identifierPrefix = o, this.onUncaughtError = c, this.onCaughtError = h, this.onRecoverableError = v, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = S, this.incompleteTransitions = /* @__PURE__ */ new Map(), this.passiveEffectDuration = this.effectDuration = -0, this.memoizedUpdaters = /* @__PURE__ */ new Set(), e = this.pendingUpdatersLaneMap = [], t = 0; 31 > t; t++) e.push(/* @__PURE__ */ new Set());
      this._debugRootType = i ? "hydrateRoot()" : "createRoot()";
    }
    function vp(e, t, i, o, c, h, v, S, M, x, ee, le) {
      return e = new M1(
        e,
        t,
        i,
        v,
        S,
        M,
        x,
        le
      ), t = _E, h === !0 && (t |= la | zo), Bn && (t |= Hi), h = b(3, null, null, t), e.current = h, h.stateNode = e, t = Fd(), al(t), e.pooledCache = t, al(t), h.memoizedState = {
        element: o,
        isDehydrated: i,
        cache: t
      }, Yi(h), e;
    }
    function Sp(e) {
      return e ? (e = Kc, e) : Kc;
    }
    function nn(e, t, i, o, c, h) {
      if (Ri && typeof Ri.onScheduleFiberRoot == "function")
        try {
          Ri.onScheduleFiberRoot(ks, o, i);
        } catch (v) {
          ra || (ra = !0, console.error(
            "React instrumentation encountered an error: %s",
            v
          ));
        }
      Le !== null && typeof Le.markRenderScheduled == "function" && Le.markRenderScheduled(t), c = Sp(c), o.context === null ? o.context = c : o.pendingContext = c, sa && Ua !== null && !K6 && (K6 = !0, console.error(
        `Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`,
        Se(Ua) || "Unknown"
      )), o = Mr(t), o.payload = { element: i }, h = h === void 0 ? null : h, h !== null && (typeof h != "function" && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        h
      ), o.callback = h), i = or(e, o, t), i !== null && (Qn(i, e, t), ds(i, e, t));
    }
    function k1(e, t) {
      if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
        var i = e.retryLane;
        e.retryLane = i !== 0 && i < t ? i : t;
      }
    }
    function Rp(e, t) {
      k1(e, t), (e = e.alternate) && k1(e, t);
    }
    function Ep(e) {
      if (e.tag === 13) {
        var t = Pi(e, 67108864);
        t !== null && Qn(t, e, 67108864), Rp(e, 67108864);
      }
    }
    function cv() {
      return Ua;
    }
    function dv() {
      for (var e = /* @__PURE__ */ new Map(), t = 1, i = 0; 31 > i; i++) {
        var o = go(t);
        e.set(t, o), t *= 2;
      }
      return e;
    }
    function uv(e, t, i, o) {
      var c = oe.T;
      oe.T = null;
      var h = ut.p;
      try {
        ut.p = Ei, Vs(e, t, i, o);
      } finally {
        ut.p = h, oe.T = c;
      }
    }
    function Q1(e, t, i, o) {
      var c = oe.T;
      oe.T = null;
      var h = ut.p;
      try {
        ut.p = fr, Vs(e, t, i, o);
      } finally {
        ut.p = h, oe.T = c;
      }
    }
    function Vs(e, t, i, o) {
      if (yg) {
        var c = u0(o);
        if (c === null)
          Ji(
            e,
            t,
            o,
            Ng,
            i
          ), Cs(e, o);
        else if (h0(
          c,
          e,
          t,
          i,
          o
        ))
          o.stopPropagation();
        else if (Cs(e, o), t & 4 && -1 < sU.indexOf(e)) {
          for (; c !== null; ) {
            var h = In(c);
            if (h !== null)
              switch (h.tag) {
                case 3:
                  if (h = h.stateNode, h.current.memoizedState.isDehydrated) {
                    var v = Qt(h.pendingLanes);
                    if (v !== 0) {
                      var S = h;
                      for (S.pendingLanes |= 2, S.entangledLanes |= 2; v; ) {
                        var M = 1 << 31 - Mi(v);
                        S.entanglements[1] |= M, v &= ~M;
                      }
                      za(h), (an & (ba | Yo)) === gr && (sg = $r() + _6, yl(0));
                    }
                  }
                  break;
                case 13:
                  S = Pi(h, 2), S !== null && Qn(S, h, 2), Ul(), Rp(h, 2);
              }
            if (h = u0(o), h === null && Ji(
              e,
              t,
              o,
              Ng,
              i
            ), h === c) break;
            c = h;
          }
          c !== null && o.stopPropagation();
        } else
          Ji(
            e,
            t,
            o,
            null,
            i
          );
      }
    }
    function u0(e) {
      return e = Xs(e), Bc(e);
    }
    function Bc(e) {
      if (Ng = null, e = ii(e), e !== null) {
        var t = he(e);
        if (t === null) e = null;
        else {
          var i = t.tag;
          if (i === 13) {
            if (e = ie(t), e !== null) return e;
            e = null;
          } else if (i === 3) {
            if (t.stateNode.current.memoizedState.isDehydrated)
              return t.tag === 3 ? t.stateNode.containerInfo : null;
            e = null;
          } else t !== e && (e = null);
        }
      }
      return Ng = e, null;
    }
    function D1(e) {
      switch (e) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return Ei;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return fr;
        case "message":
          switch (Ms()) {
            case w1:
              return Ei;
            case U0:
              return fr;
            case Wc:
            case gv:
              return Io;
            case T0:
              return I1;
            default:
              return Io;
          }
        default:
          return Io;
      }
    }
    function Cs(e, t) {
      switch (e) {
        case "focusin":
        case "focusout":
          sd = null;
          break;
        case "dragenter":
        case "dragleave":
          ld = null;
          break;
        case "mouseover":
        case "mouseout":
          cd = null;
          break;
        case "pointerover":
        case "pointerout":
          Uf.delete(t.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          Tf.delete(t.pointerId);
      }
    }
    function aa(e, t, i, o, c, h) {
      return e === null || e.nativeEvent !== h ? (e = {
        blockedOn: t,
        domEventName: i,
        eventSystemFlags: o,
        nativeEvent: h,
        targetContainers: [c]
      }, t !== null && (t = In(t), t !== null && Ep(t)), e) : (e.eventSystemFlags |= o, t = e.targetContainers, c !== null && t.indexOf(c) === -1 && t.push(c), e);
    }
    function h0(e, t, i, o, c) {
      switch (t) {
        case "focusin":
          return sd = aa(
            sd,
            e,
            t,
            i,
            o,
            c
          ), !0;
        case "dragenter":
          return ld = aa(
            ld,
            e,
            t,
            i,
            o,
            c
          ), !0;
        case "mouseover":
          return cd = aa(
            cd,
            e,
            t,
            i,
            o,
            c
          ), !0;
        case "pointerover":
          var h = c.pointerId;
          return Uf.set(
            h,
            aa(
              Uf.get(h) || null,
              e,
              t,
              i,
              o,
              c
            )
          ), !0;
        case "gotpointercapture":
          return h = c.pointerId, Tf.set(
            h,
            aa(
              Tf.get(h) || null,
              e,
              t,
              i,
              o,
              c
            )
          ), !0;
      }
      return !1;
    }
    function F2(e) {
      var t = ii(e.target);
      if (t !== null) {
        var i = he(t);
        if (i !== null) {
          if (t = i.tag, t === 13) {
            if (t = ie(i), t !== null) {
              e.blockedOn = t, Er(e.priority, function() {
                if (i.tag === 13) {
                  var o = ta(i);
                  o = Jn(o);
                  var c = Pi(
                    i,
                    o
                  );
                  c !== null && Qn(c, i, o), Rp(i, o);
                }
              });
              return;
            }
          } else if (t === 3 && i.stateNode.current.memoizedState.isDehydrated) {
            e.blockedOn = i.tag === 3 ? i.stateNode.containerInfo : null;
            return;
          }
        }
      }
      e.blockedOn = null;
    }
    function m0(e) {
      if (e.blockedOn !== null) return !1;
      for (var t = e.targetContainers; 0 < t.length; ) {
        var i = u0(e.nativeEvent);
        if (i === null) {
          i = e.nativeEvent;
          var o = new i.constructor(
            i.type,
            i
          ), c = o;
          m !== null && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          ), m = c, i.target.dispatchEvent(o), m === null && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          ), m = null;
        } else
          return t = In(i), t !== null && Ep(t), e.blockedOn = i, !1;
        t.shift();
      }
      return !0;
    }
    function Up(e, t, i) {
      m0(e) && i.delete(t);
    }
    function _2() {
      gS = !1, sd !== null && m0(sd) && (sd = null), ld !== null && m0(ld) && (ld = null), cd !== null && m0(cd) && (cd = null), Uf.forEach(Up), Tf.forEach(Up);
    }
    function p0(e, t) {
      e.blockedOn === t && (e.blockedOn = null, gS || (gS = !0, On.unstable_scheduleCallback(
        On.unstable_NormalPriority,
        _2
      )));
    }
    function M2(e) {
      bg !== e && (bg = e, On.unstable_scheduleCallback(
        On.unstable_NormalPriority,
        function() {
          bg === e && (bg = null);
          for (var t = 0; t < e.length; t += 3) {
            var i = e[t], o = e[t + 1], c = e[t + 2];
            if (typeof o != "function") {
              if (Bc(o || i) === null)
                continue;
              break;
            }
            var h = In(i);
            h !== null && (e.splice(t, 3), t -= 3, i = {
              pending: !0,
              data: c,
              method: i.method,
              action: o
            }, Object.freeze(i), dl(
              h,
              i,
              o,
              c
            ));
          }
        }
      ));
    }
    function Ml(e) {
      function t(M) {
        return p0(M, e);
      }
      sd !== null && p0(sd, e), ld !== null && p0(ld, e), cd !== null && p0(cd, e), Uf.forEach(t), Tf.forEach(t);
      for (var i = 0; i < dd.length; i++) {
        var o = dd[i];
        o.blockedOn === e && (o.blockedOn = null);
      }
      for (; 0 < dd.length && (i = dd[0], i.blockedOn === null); )
        F2(i), i.blockedOn === null && dd.shift();
      if (i = (e.ownerDocument || e).$$reactFormReplay, i != null)
        for (o = 0; o < i.length; o += 3) {
          var c = i[o], h = i[o + 1], v = c[oa] || null;
          if (typeof h == "function")
            v || M2(i);
          else if (v) {
            var S = null;
            if (h && h.hasAttribute("formAction")) {
              if (c = h, v = h[oa] || null)
                S = v.formAction;
              else if (Bc(c) !== null) continue;
            } else S = v.action;
            typeof S == "function" ? i[o + 1] = S : (i.splice(o, 3), o -= 3), M2(i);
          }
        }
    }
    function x1(e) {
      this._internalRoot = e;
    }
    function f0(e) {
      this._internalRoot = e;
    }
    function k2(e) {
      e[Ds] && (e._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var On = H5(), g0 = Qh(), hv = z5(), bt = Object.assign, v0 = Symbol.for("react.element"), Fs = Symbol.for("react.transitional.element"), kl = Symbol.for("react.portal"), Ut = Symbol.for("react.fragment"), wc = Symbol.for("react.strict_mode"), Ac = Symbol.for("react.profiler"), Tp = Symbol.for("react.provider"), Z1 = Symbol.for("react.consumer"), Pa = Symbol.for("react.context"), wo = Symbol.for("react.forward_ref"), Jc = Symbol.for("react.suspense"), _s = Symbol.for("react.suspense_list"), S0 = Symbol.for("react.memo"), Ea = Symbol.for("react.lazy"), yp = Symbol.for("react.activity"), Q2 = Symbol.for("react.memo_cache_sentinel"), Np = Symbol.iterator, O1 = Symbol.for("react.client.reference"), vt = Array.isArray, oe = g0.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ut = hv.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, mv = Object.freeze({
      pending: !1,
      data: null,
      method: null,
      action: null
    }), R0 = [], E0 = [], Ya = -1, Ao = xe(null), Lc = xe(null), qr = xe(null), Ic = xe(null), Jo = Object.prototype.hasOwnProperty, B1 = On.unstable_scheduleCallback, pv = On.unstable_cancelCallback, D2 = On.unstable_shouldYield, fv = On.unstable_requestPaint, $r = On.unstable_now, Ms = On.unstable_getCurrentPriorityLevel, w1 = On.unstable_ImmediatePriority, U0 = On.unstable_UserBlockingPriority, Wc = On.unstable_NormalPriority, gv = On.unstable_LowPriority, T0 = On.unstable_IdlePriority, vv = On.log, pr = On.unstable_setDisableYieldValue, ks = null, Ri = null, Le = null, ra = !1, Bn = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u", Mi = Math.clz32 ? Math.clz32 : Ma, A1 = Math.log, Lo = Math.LN2, J1 = 256, L1 = 4194304, Ei = 2, fr = 8, Io = 32, I1 = 268435456, Qs = Math.random().toString(36).slice(2), ki = "__reactFiber$" + Qs, oa = "__reactProps$" + Qs, Ds = "__reactContainer$" + Qs, bp = "__reactEvents$" + Qs, x2 = "__reactListeners$" + Qs, Hc = "__reactHandles$" + Qs, zc = "__reactResources$" + Qs, jc = "__reactMarker$" + Qs, Z2 = /* @__PURE__ */ new Set(), Xa = {}, Ql = {}, O2 = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    }, W1 = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), H1 = {}, z1 = {}, xs = 0, Vp, Cp, B2, Fp, Gc, w2, A2;
    Bi.__reactDisabledLog = !0;
    var _p, y0, Pc = !1, N0 = new (typeof WeakMap == "function" ? WeakMap : Map)(), Ua = null, sa = !1, Sv = /[\n"\\]/g, Mp = !1, kp = !1, Qp = !1, Dp = !1, j1 = !1, xp = !1, b0 = ["value", "defaultValue"], J2 = !1, L2 = /["'&<>\n\t]|^\s|\s$/, Zp = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), G1 = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), P1 = G1.concat(["button"]), Op = "dd dt li option optgroup p rp rt".split(" "), Bp = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: !1
    }, Yc = {}, eo = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, Wo = /([A-Z])/g, Ho = /^ms-/, V0 = /^(?:webkit|moz|o)[A-Z]/, C0 = /^-ms-/, Zs = /-(.)/g, I2 = /;\s*$/, Dl = {}, xl = {}, W2 = !1, wp = !1, F0 = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), _0 = "http://www.w3.org/1998/Math/MathML", Xc = "http://www.w3.org/2000/svg", Y1 = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), Zl = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Ap = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, to = {}, Jp = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), X1 = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), Lp = !1, Wi = {}, M0 = /^on./, n = /^on[^A-Z]/, a = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), r = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), s = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, m = null, f = null, E = null, _ = !1, O = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), K = !1;
    if (O)
      try {
        var me = {};
        Object.defineProperty(me, "passive", {
          get: function() {
            K = !0;
          }
        }), window.addEventListener("test", me, me), window.removeEventListener("test", me, me);
      } catch {
        K = !1;
      }
    var ve = null, $ = null, te = null, it = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, at = mi(it), Gt = bt({}, it, { view: 0, detail: 0 }), G = mi(Gt), W, Y, ge, ze = bt({}, Gt, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: fu,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (e !== ge && (ge && e.type === "mousemove" ? (W = e.screenX - ge.screenX, Y = e.screenY - ge.screenY) : Y = W = 0, ge = e), W);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : Y;
      }
    }), _t = mi(ze), et = bt({}, ze, { dataTransfer: 0 }), lt = mi(et), li = bt({}, Gt, { relatedTarget: 0 }), It = mi(li), Os = bt({}, it, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Rv = mi(Os), aE = bt({}, it, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), rE = mi(aE), oE = bt({}, it, { data: 0 }), dR = mi(
      oE
    ), sE = dR, lE = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, cE = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, dE = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, uE = bt({}, Gt, {
      key: function(e) {
        if (e.key) {
          var t = lE[e.key] || e.key;
          if (t !== "Unidentified") return t;
        }
        return e.type === "keypress" ? (e = ic(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? cE[e.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: fu,
      charCode: function(e) {
        return e.type === "keypress" ? ic(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? ic(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), hE = mi(uE), mE = bt({}, ze, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), uR = mi(mE), pE = bt({}, Gt, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: fu
    }), fE = mi(pE), gE = bt({}, it, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), vE = mi(gE), SE = bt({}, ze, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), RE = mi(SE), EE = bt({}, it, {
      newState: 0,
      oldState: 0
    }), UE = mi(EE), TE = [9, 13, 27, 32], hR = 229, Ev = O && "CompositionEvent" in window, Ip = null;
    O && "documentMode" in document && (Ip = document.documentMode);
    var yE = O && "TextEvent" in window && !Ip, mR = O && (!Ev || Ip && 8 < Ip && 11 >= Ip), pR = 32, fR = String.fromCharCode(pR), gR = !1, K1 = !1, NE = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    }, Wp = null, Hp = null, vR = !1;
    O && (vR = Ih("input") && (!document.documentMode || 9 < document.documentMode));
    var Ta = typeof Object.is == "function" ? Object.is : rv, bE = O && "documentMode" in document && 11 >= document.documentMode, q1 = null, Uv = null, zp = null, Tv = !1, $1 = {
      animationend: To("Animation", "AnimationEnd"),
      animationiteration: To("Animation", "AnimationIteration"),
      animationstart: To("Animation", "AnimationStart"),
      transitionrun: To("Transition", "TransitionRun"),
      transitionstart: To("Transition", "TransitionStart"),
      transitioncancel: To("Transition", "TransitionCancel"),
      transitionend: To("Transition", "TransitionEnd")
    }, yv = {}, SR = {};
    O && (SR = document.createElement("div").style, "AnimationEvent" in window || (delete $1.animationend.animation, delete $1.animationiteration.animation, delete $1.animationstart.animation), "TransitionEvent" in window || delete $1.transitionend.transition);
    var RR = $s("animationend"), ER = $s("animationiteration"), UR = $s("animationstart"), VE = $s("transitionrun"), CE = $s("transitionstart"), FE = $s("transitioncancel"), TR = $s("transitionend"), yR = /* @__PURE__ */ new Map(), Nv = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    Nv.push("scrollEnd");
    var bv = /* @__PURE__ */ new WeakMap(), H2 = 1, Ol = 2, no = [], eh = 0, Vv = 0, Kc = {};
    Object.freeze(Kc);
    var io = null, th = null, Un = 0, _E = 1, Hi = 2, la = 8, zo = 16, NR = 64, bR = !1;
    try {
      var VR = Object.preventExtensions({});
    } catch {
      bR = !0;
    }
    var nh = [], ih = 0, z2 = null, j2 = 0, ao = [], ro = 0, k0 = null, Bl = 1, wl = "", ya = null, Gn = null, Pt = !1, Al = !1, oo = null, Q0 = null, Bs = !1, Cv = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), CR = 0;
    if (typeof performance == "object" && typeof performance.now == "function")
      var ME = performance, FR = function() {
        return ME.now();
      };
    else {
      var kE = Date;
      FR = function() {
        return kE.now();
      };
    }
    var Fv = xe(null), _v = xe(null), _R = {}, G2 = null, ah = null, rh = !1, QE = typeof AbortController < "u" ? AbortController : function() {
      var e = [], t = this.signal = {
        aborted: !1,
        addEventListener: function(i, o) {
          e.push(o);
        }
      };
      this.abort = function() {
        t.aborted = !0, e.forEach(function(i) {
          return i();
        });
      };
    }, DE = On.unstable_scheduleCallback, xE = On.unstable_NormalPriority, Ui = {
      $$typeof: Pa,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, oh = On.unstable_now, MR = -0, P2 = -0, Ka = -1.1, D0 = -0, Y2 = !1, X2 = !1, jp = null, Mv = 0, x0 = 0, sh = null, kR = oe.S;
    oe.S = function(e, t) {
      typeof t == "object" && t !== null && typeof t.then == "function" && e2(e, t), kR !== null && kR(e, t);
    };
    var Z0 = xe(null), jo = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, Gp = [], Pp = [], Yp = [], Xp = [], Kp = [], qp = [], O0 = /* @__PURE__ */ new Set();
    jo.recordUnsafeLifecycleWarnings = function(e, t) {
      O0.has(e.type) || (typeof t.componentWillMount == "function" && t.componentWillMount.__suppressDeprecationWarning !== !0 && Gp.push(e), e.mode & la && typeof t.UNSAFE_componentWillMount == "function" && Pp.push(e), typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && Yp.push(e), e.mode & la && typeof t.UNSAFE_componentWillReceiveProps == "function" && Xp.push(e), typeof t.componentWillUpdate == "function" && t.componentWillUpdate.__suppressDeprecationWarning !== !0 && Kp.push(e), e.mode & la && typeof t.UNSAFE_componentWillUpdate == "function" && qp.push(e));
    }, jo.flushPendingUnsafeLifecycleWarnings = function() {
      var e = /* @__PURE__ */ new Set();
      0 < Gp.length && (Gp.forEach(function(S) {
        e.add(
          Se(S) || "Component"
        ), O0.add(S.type);
      }), Gp = []);
      var t = /* @__PURE__ */ new Set();
      0 < Pp.length && (Pp.forEach(function(S) {
        t.add(
          Se(S) || "Component"
        ), O0.add(S.type);
      }), Pp = []);
      var i = /* @__PURE__ */ new Set();
      0 < Yp.length && (Yp.forEach(function(S) {
        i.add(
          Se(S) || "Component"
        ), O0.add(S.type);
      }), Yp = []);
      var o = /* @__PURE__ */ new Set();
      0 < Xp.length && (Xp.forEach(
        function(S) {
          o.add(
            Se(S) || "Component"
          ), O0.add(S.type);
        }
      ), Xp = []);
      var c = /* @__PURE__ */ new Set();
      0 < Kp.length && (Kp.forEach(function(S) {
        c.add(
          Se(S) || "Component"
        ), O0.add(S.type);
      }), Kp = []);
      var h = /* @__PURE__ */ new Set();
      if (0 < qp.length && (qp.forEach(function(S) {
        h.add(
          Se(S) || "Component"
        ), O0.add(S.type);
      }), qp = []), 0 < t.size) {
        var v = N(
          t
        );
        console.error(
          `Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`,
          v
        );
      }
      0 < o.size && (v = N(
        o
      ), console.error(
        `Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state

Please update the following components: %s`,
        v
      )), 0 < h.size && (v = N(
        h
      ), console.error(
        `Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`,
        v
      )), 0 < e.size && (v = N(e)), 0 < i.size && (v = N(
        i
      )), 0 < c.size && (v = N(c));
    };
    var K2 = /* @__PURE__ */ new Map(), QR = /* @__PURE__ */ new Set();
    jo.recordLegacyContextWarning = function(e, t) {
      for (var i = null, o = e; o !== null; )
        o.mode & la && (i = o), o = o.return;
      i === null ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !QR.has(e.type) && (o = K2.get(i), e.type.contextTypes != null || e.type.childContextTypes != null || t !== null && typeof t.getChildContext == "function") && (o === void 0 && (o = [], K2.set(i, o)), o.push(e));
    }, jo.flushLegacyContextWarning = function() {
      K2.forEach(function(e) {
        if (e.length !== 0) {
          var t = e[0], i = /* @__PURE__ */ new Set();
          e.forEach(function(c) {
            i.add(Se(c) || "Component"), QR.add(c.type);
          });
          var o = N(i);
          He(t, function() {
            console.error(
              `Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://react.dev/link/legacy-context`,
              o
            );
          });
        }
      });
    }, jo.discardPendingWarnings = function() {
      Gp = [], Pp = [], Yp = [], Xp = [], Kp = [], qp = [], K2 = /* @__PURE__ */ new Map();
    };
    var $p = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), DR = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), q2 = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), kv = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, ef = null, $2 = !1, so = 0, lo = 1, Na = 2, zi = 4, Ti = 8, xR = 0, ZR = 1, OR = 2, Qv = 3, qc = !1, BR = !1, Dv = null, xv = !1, lh = xe(null), eg = xe(0), ch, wR = /* @__PURE__ */ new Set(), AR = /* @__PURE__ */ new Set(), Zv = /* @__PURE__ */ new Set(), JR = /* @__PURE__ */ new Set(), $c = 0, St = null, hn = null, ci = null, tg = !1, dh = !1, B0 = !1, ng = 0, tf = 0, Jl = null, ZE = 0, OE = 25, se = null, co = null, Ll = -1, nf = !1, ig = {
      readContext: mn,
      use: Qr,
      useCallback: Vn,
      useContext: Vn,
      useEffect: Vn,
      useImperativeHandle: Vn,
      useLayoutEffect: Vn,
      useInsertionEffect: Vn,
      useMemo: Vn,
      useReducer: Vn,
      useRef: Vn,
      useState: Vn,
      useDebugValue: Vn,
      useDeferredValue: Vn,
      useTransition: Vn,
      useSyncExternalStore: Vn,
      useId: Vn,
      useHostTransitionStatus: Vn,
      useFormState: Vn,
      useActionState: Vn,
      useOptimistic: Vn,
      useMemoCache: Vn,
      useCacheRefresh: Vn
    }, Ov = null, LR = null, Bv = null, IR = null, ws = null, Go = null, ag = null;
    Ov = {
      readContext: function(e) {
        return mn(e);
      },
      use: Qr,
      useCallback: function(e, t) {
        return se = "useCallback", Ft(), wa(t), Bd(e, t);
      },
      useContext: function(e) {
        return se = "useContext", Ft(), mn(e);
      },
      useEffect: function(e, t) {
        return se = "useEffect", Ft(), wa(t), _u(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", Ft(), wa(i), ku(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        se = "useInsertionEffect", Ft(), wa(t), Ia(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", Ft(), wa(t), Mu(e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", Ft(), wa(t);
        var i = oe.H;
        oe.H = ws;
        try {
          return Qu(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", Ft();
        var o = oe.H;
        oe.H = ws;
        try {
          return Wt(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function(e) {
        return se = "useRef", Ft(), Od(e);
      },
      useState: function(e) {
        se = "useState", Ft();
        var t = oe.H;
        oe.H = ws;
        try {
          return Co(e);
        } finally {
          oe.H = t;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", Ft();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", Ft(), Du(e, t);
      },
      useTransition: function() {
        return se = "useTransition", Ft(), Or();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", Ft(), Vo(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", Ft(), Br();
      },
      useFormState: function(e, t) {
        return se = "useFormState", Ft(), cc(), fc(e, t);
      },
      useActionState: function(e, t) {
        return se = "useActionState", Ft(), fc(e, t);
      },
      useOptimistic: function(e) {
        return se = "useOptimistic", Ft(), cr(e);
      },
      useHostTransitionStatus: qi,
      useMemoCache: Wn,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Ft(), ul();
      }
    }, LR = {
      readContext: function(e) {
        return mn(e);
      },
      use: Qr,
      useCallback: function(e, t) {
        return se = "useCallback", Me(), Bd(e, t);
      },
      useContext: function(e) {
        return se = "useContext", Me(), mn(e);
      },
      useEffect: function(e, t) {
        return se = "useEffect", Me(), _u(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", Me(), ku(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        se = "useInsertionEffect", Me(), Ia(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", Me(), Mu(e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", Me();
        var i = oe.H;
        oe.H = ws;
        try {
          return Qu(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", Me();
        var o = oe.H;
        oe.H = ws;
        try {
          return Wt(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function(e) {
        return se = "useRef", Me(), Od(e);
      },
      useState: function(e) {
        se = "useState", Me();
        var t = oe.H;
        oe.H = ws;
        try {
          return Co(e);
        } finally {
          oe.H = t;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", Me();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", Me(), Du(e, t);
      },
      useTransition: function() {
        return se = "useTransition", Me(), Or();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", Me(), Vo(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", Me(), Br();
      },
      useActionState: function(e, t) {
        return se = "useActionState", Me(), fc(e, t);
      },
      useFormState: function(e, t) {
        return se = "useFormState", Me(), cc(), fc(e, t);
      },
      useOptimistic: function(e) {
        return se = "useOptimistic", Me(), cr(e);
      },
      useHostTransitionStatus: qi,
      useMemoCache: Wn,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Me(), ul();
      }
    }, Bv = {
      readContext: function(e) {
        return mn(e);
      },
      use: Qr,
      useCallback: function(e, t) {
        return se = "useCallback", Me(), cl(e, t);
      },
      useContext: function(e) {
        return se = "useContext", Me(), mn(e);
      },
      useEffect: function(e, t) {
        se = "useEffect", Me(), Kn(2048, Ti, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", Me(), Zr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return se = "useInsertionEffect", Me(), Kn(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", Me(), Kn(4, zi, e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", Me();
        var i = oe.H;
        oe.H = Go;
        try {
          return fs(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", Me();
        var o = oe.H;
        oe.H = Go;
        try {
          return Ja(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function() {
        return se = "useRef", Me(), At().memoizedState;
      },
      useState: function() {
        se = "useState", Me();
        var e = oe.H;
        oe.H = Go;
        try {
          return Ja(zt);
        } finally {
          oe.H = e;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", Me();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", Me(), wd(e, t);
      },
      useTransition: function() {
        return se = "useTransition", Me(), Ou();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", Me(), Qd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", Me(), At().memoizedState;
      },
      useFormState: function(e) {
        return se = "useFormState", Me(), cc(), Fu(e);
      },
      useActionState: function(e) {
        return se = "useActionState", Me(), Fu(e);
      },
      useOptimistic: function(e, t) {
        return se = "useOptimistic", Me(), Fo(e, t);
      },
      useHostTransitionStatus: qi,
      useMemoCache: Wn,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Me(), At().memoizedState;
      }
    }, IR = {
      readContext: function(e) {
        return mn(e);
      },
      use: Qr,
      useCallback: function(e, t) {
        return se = "useCallback", Me(), cl(e, t);
      },
      useContext: function(e) {
        return se = "useContext", Me(), mn(e);
      },
      useEffect: function(e, t) {
        se = "useEffect", Me(), Kn(2048, Ti, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", Me(), Zr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return se = "useInsertionEffect", Me(), Kn(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", Me(), Kn(4, zi, e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", Me();
        var i = oe.H;
        oe.H = ag;
        try {
          return fs(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", Me();
        var o = oe.H;
        oe.H = ag;
        try {
          return ll(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function() {
        return se = "useRef", Me(), At().memoizedState;
      },
      useState: function() {
        se = "useState", Me();
        var e = oe.H;
        oe.H = ag;
        try {
          return ll(zt);
        } finally {
          oe.H = e;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", Me();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", Me(), xu(e, t);
      },
      useTransition: function() {
        return se = "useTransition", Me(), Bu();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", Me(), Qd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", Me(), At().memoizedState;
      },
      useFormState: function(e) {
        return se = "useFormState", Me(), cc(), gc(e);
      },
      useActionState: function(e) {
        return se = "useActionState", Me(), gc(e);
      },
      useOptimistic: function(e, t) {
        return se = "useOptimistic", Me(), Cu(e, t);
      },
      useHostTransitionStatus: qi,
      useMemoCache: Wn,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Me(), At().memoizedState;
      }
    }, ws = {
      readContext: function(e) {
        return k(), mn(e);
      },
      use: function(e) {
        return T(), Qr(e);
      },
      useCallback: function(e, t) {
        return se = "useCallback", T(), Ft(), Bd(e, t);
      },
      useContext: function(e) {
        return se = "useContext", T(), Ft(), mn(e);
      },
      useEffect: function(e, t) {
        return se = "useEffect", T(), Ft(), _u(e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", T(), Ft(), ku(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        se = "useInsertionEffect", T(), Ft(), Ia(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", T(), Ft(), Mu(e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", T(), Ft();
        var i = oe.H;
        oe.H = ws;
        try {
          return Qu(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", T(), Ft();
        var o = oe.H;
        oe.H = ws;
        try {
          return Wt(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function(e) {
        return se = "useRef", T(), Ft(), Od(e);
      },
      useState: function(e) {
        se = "useState", T(), Ft();
        var t = oe.H;
        oe.H = ws;
        try {
          return Co(e);
        } finally {
          oe.H = t;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", T(), Ft();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", T(), Ft(), Du(e, t);
      },
      useTransition: function() {
        return se = "useTransition", T(), Ft(), Or();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", T(), Ft(), Vo(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", T(), Ft(), Br();
      },
      useFormState: function(e, t) {
        return se = "useFormState", T(), Ft(), fc(e, t);
      },
      useActionState: function(e, t) {
        return se = "useActionState", T(), Ft(), fc(e, t);
      },
      useOptimistic: function(e) {
        return se = "useOptimistic", T(), Ft(), cr(e);
      },
      useMemoCache: function(e) {
        return T(), Wn(e);
      },
      useHostTransitionStatus: qi,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Ft(), ul();
      }
    }, Go = {
      readContext: function(e) {
        return k(), mn(e);
      },
      use: function(e) {
        return T(), Qr(e);
      },
      useCallback: function(e, t) {
        return se = "useCallback", T(), Me(), cl(e, t);
      },
      useContext: function(e) {
        return se = "useContext", T(), Me(), mn(e);
      },
      useEffect: function(e, t) {
        se = "useEffect", T(), Me(), Kn(2048, Ti, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", T(), Me(), Zr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return se = "useInsertionEffect", T(), Me(), Kn(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", T(), Me(), Kn(4, zi, e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", T(), Me();
        var i = oe.H;
        oe.H = Go;
        try {
          return fs(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", T(), Me();
        var o = oe.H;
        oe.H = Go;
        try {
          return Ja(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function() {
        return se = "useRef", T(), Me(), At().memoizedState;
      },
      useState: function() {
        se = "useState", T(), Me();
        var e = oe.H;
        oe.H = Go;
        try {
          return Ja(zt);
        } finally {
          oe.H = e;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", T(), Me();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", T(), Me(), wd(e, t);
      },
      useTransition: function() {
        return se = "useTransition", T(), Me(), Ou();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", T(), Me(), Qd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", T(), Me(), At().memoizedState;
      },
      useFormState: function(e) {
        return se = "useFormState", T(), Me(), Fu(e);
      },
      useActionState: function(e) {
        return se = "useActionState", T(), Me(), Fu(e);
      },
      useOptimistic: function(e, t) {
        return se = "useOptimistic", T(), Me(), Fo(e, t);
      },
      useMemoCache: function(e) {
        return T(), Wn(e);
      },
      useHostTransitionStatus: qi,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Me(), At().memoizedState;
      }
    }, ag = {
      readContext: function(e) {
        return k(), mn(e);
      },
      use: function(e) {
        return T(), Qr(e);
      },
      useCallback: function(e, t) {
        return se = "useCallback", T(), Me(), cl(e, t);
      },
      useContext: function(e) {
        return se = "useContext", T(), Me(), mn(e);
      },
      useEffect: function(e, t) {
        se = "useEffect", T(), Me(), Kn(2048, Ti, e, t);
      },
      useImperativeHandle: function(e, t, i) {
        return se = "useImperativeHandle", T(), Me(), Zr(e, t, i);
      },
      useInsertionEffect: function(e, t) {
        return se = "useInsertionEffect", T(), Me(), Kn(4, Na, e, t);
      },
      useLayoutEffect: function(e, t) {
        return se = "useLayoutEffect", T(), Me(), Kn(4, zi, e, t);
      },
      useMemo: function(e, t) {
        se = "useMemo", T(), Me();
        var i = oe.H;
        oe.H = Go;
        try {
          return fs(e, t);
        } finally {
          oe.H = i;
        }
      },
      useReducer: function(e, t, i) {
        se = "useReducer", T(), Me();
        var o = oe.H;
        oe.H = Go;
        try {
          return ll(e, t, i);
        } finally {
          oe.H = o;
        }
      },
      useRef: function() {
        return se = "useRef", T(), Me(), At().memoizedState;
      },
      useState: function() {
        se = "useState", T(), Me();
        var e = oe.H;
        oe.H = Go;
        try {
          return ll(zt);
        } finally {
          oe.H = e;
        }
      },
      useDebugValue: function() {
        se = "useDebugValue", T(), Me();
      },
      useDeferredValue: function(e, t) {
        return se = "useDeferredValue", T(), Me(), xu(e, t);
      },
      useTransition: function() {
        return se = "useTransition", T(), Me(), Bu();
      },
      useSyncExternalStore: function(e, t, i) {
        return se = "useSyncExternalStore", T(), Me(), Qd(
          e,
          t,
          i
        );
      },
      useId: function() {
        return se = "useId", T(), Me(), At().memoizedState;
      },
      useFormState: function(e) {
        return se = "useFormState", T(), Me(), gc(e);
      },
      useActionState: function(e) {
        return se = "useActionState", T(), Me(), gc(e);
      },
      useOptimistic: function(e, t) {
        return se = "useOptimistic", T(), Me(), Cu(e, t);
      },
      useMemoCache: function(e) {
        return T(), Wn(e);
      },
      useHostTransitionStatus: qi,
      useCacheRefresh: function() {
        return se = "useCacheRefresh", Me(), At().memoizedState;
      }
    };
    var WR = {
      "react-stack-bottom-frame": function(e, t, i) {
        var o = sa;
        sa = !0;
        try {
          return e(t, i);
        } finally {
          sa = o;
        }
      }
    }, wv = WR["react-stack-bottom-frame"].bind(WR), HR = {
      "react-stack-bottom-frame": function(e) {
        var t = sa;
        sa = !0;
        try {
          return e.render();
        } finally {
          sa = t;
        }
      }
    }, zR = HR["react-stack-bottom-frame"].bind(HR), jR = {
      "react-stack-bottom-frame": function(e, t) {
        try {
          t.componentDidMount();
        } catch (i) {
          st(e, e.return, i);
        }
      }
    }, Av = jR["react-stack-bottom-frame"].bind(jR), GR = {
      "react-stack-bottom-frame": function(e, t, i, o, c) {
        try {
          t.componentDidUpdate(i, o, c);
        } catch (h) {
          st(e, e.return, h);
        }
      }
    }, PR = GR["react-stack-bottom-frame"].bind(GR), YR = {
      "react-stack-bottom-frame": function(e, t) {
        var i = t.stack;
        e.componentDidCatch(t.value, {
          componentStack: i !== null ? i : ""
        });
      }
    }, BE = YR["react-stack-bottom-frame"].bind(YR), XR = {
      "react-stack-bottom-frame": function(e, t, i) {
        try {
          i.componentWillUnmount();
        } catch (o) {
          st(e, t, o);
        }
      }
    }, KR = XR["react-stack-bottom-frame"].bind(XR), qR = {
      "react-stack-bottom-frame": function(e) {
        e.resourceKind != null && console.error(
          "Expected only SimpleEffects when enableUseEffectCRUDOverload is disabled, got %s",
          e.resourceKind
        );
        var t = e.create;
        return e = e.inst, t = t(), e.destroy = t;
      }
    }, wE = qR["react-stack-bottom-frame"].bind(qR), $R = {
      "react-stack-bottom-frame": function(e, t, i) {
        try {
          i();
        } catch (o) {
          st(e, t, o);
        }
      }
    }, AE = $R["react-stack-bottom-frame"].bind($R), e6 = {
      "react-stack-bottom-frame": function(e) {
        var t = e._init;
        return t(e._payload);
      }
    }, ed = e6["react-stack-bottom-frame"].bind(e6), uh = null, af = 0, Mt = null, Jv, t6 = Jv = !1, n6 = {}, i6 = {}, a6 = {};
    Q = function(e, t, i) {
      if (i !== null && typeof i == "object" && i._store && (!i._store.validated && i.key == null || i._store.validated === 2)) {
        if (typeof i._store != "object")
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        i._store.validated = 1;
        var o = Se(e), c = o || "null";
        if (!n6[c]) {
          n6[c] = !0, i = i._owner, e = e._debugOwner;
          var h = "";
          e && typeof e.tag == "number" && (c = Se(e)) && (h = `

Check the render method of \`` + c + "`."), h || o && (h = `

Check the top-level render call using <` + o + ">.");
          var v = "";
          i != null && e !== i && (o = null, typeof i.tag == "number" ? o = Se(i) : typeof i.name == "string" && (o = i.name), o && (v = " It was passed a child from " + o + ".")), He(t, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              h,
              v
            );
          });
        }
      }
    };
    var hh = Id(!0), r6 = Id(!1), uo = xe(null), As = null, mh = 1, rf = 2, yi = xe(0), o6 = {}, s6 = /* @__PURE__ */ new Set(), l6 = /* @__PURE__ */ new Set(), c6 = /* @__PURE__ */ new Set(), d6 = /* @__PURE__ */ new Set(), u6 = /* @__PURE__ */ new Set(), h6 = /* @__PURE__ */ new Set(), m6 = /* @__PURE__ */ new Set(), p6 = /* @__PURE__ */ new Set(), f6 = /* @__PURE__ */ new Set(), g6 = /* @__PURE__ */ new Set();
    Object.freeze(o6);
    var Lv = {
      enqueueSetState: function(e, t, i) {
        e = e._reactInternals;
        var o = ta(e), c = Mr(o);
        c.payload = t, i != null && (Em(i), c.callback = i), t = or(e, c, o), t !== null && (Qn(t, e, o), ds(t, e, o)), gn(e, o);
      },
      enqueueReplaceState: function(e, t, i) {
        e = e._reactInternals;
        var o = ta(e), c = Mr(o);
        c.tag = ZR, c.payload = t, i != null && (Em(i), c.callback = i), t = or(e, c, o), t !== null && (Qn(t, e, o), ds(t, e, o)), gn(e, o);
      },
      enqueueForceUpdate: function(e, t) {
        e = e._reactInternals;
        var i = ta(e), o = Mr(i);
        o.tag = OR, t != null && (Em(t), o.callback = t), t = or(e, o, i), t !== null && (Qn(t, e, i), ds(t, e, i)), Le !== null && typeof Le.markForceUpdateScheduled == "function" && Le.markForceUpdateScheduled(e, i);
      }
    }, Iv = typeof reportError == "function" ? reportError : function(e) {
      if (typeof window == "object" && typeof window.ErrorEvent == "function") {
        var t = new window.ErrorEvent("error", {
          bubbles: !0,
          cancelable: !0,
          message: typeof e == "object" && e !== null && typeof e.message == "string" ? String(e.message) : String(e),
          error: e
        });
        if (!window.dispatchEvent(t)) return;
      } else if (typeof process == "object" && typeof process.emit == "function") {
        process.emit("uncaughtException", e);
        return;
      }
      console.error(e);
    }, ph = null, Wv = null, v6 = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), Qi = !1, S6 = {}, R6 = {}, E6 = {}, U6 = {}, fh = !1, T6 = {}, Hv = {}, zv = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, y6 = !1, N6 = null;
    N6 = /* @__PURE__ */ new Set();
    var Il = !1, ei = !1, jv = !1, b6 = typeof WeakSet == "function" ? WeakSet : Set, Di = null, gh = null, vh = null, di = null, qa = !1, Po = null, of = 8192, JE = {
      getCacheForType: function(e) {
        var t = mn(Ui), i = t.data.get(e);
        return i === void 0 && (i = e(), t.data.set(e, i)), i;
      },
      getOwner: function() {
        return Ua;
      }
    };
    if (typeof Symbol == "function" && Symbol.for) {
      var sf = Symbol.for;
      sf("selector.component"), sf("selector.has_pseudo_class"), sf("selector.role"), sf("selector.test_id"), sf("selector.text");
    }
    var LE = [], IE = typeof WeakMap == "function" ? WeakMap : Map, gr = 0, ba = 2, Yo = 4, Wl = 0, lf = 1, Sh = 2, Gv = 3, w0 = 4, rg = 6, V6 = 5, an = gr, pn = null, Ot = null, wt = 0, $a = 0, cf = 1, A0 = 2, df = 3, C6 = 4, Pv = 5, Rh = 6, uf = 7, Yv = 8, J0 = 9, ln = $a, vr = null, td = !1, Eh = !1, Xv = !1, Js = 0, Pn = Wl, nd = 0, id = 0, Kv = 0, Sr = 0, L0 = 0, hf = null, Va = null, og = !1, qv = 0, F6 = 300, sg = 1 / 0, _6 = 500, mf = null, ad = null, WE = 0, HE = 1, zE = 2, I0 = 0, M6 = 1, k6 = 2, Q6 = 3, jE = 4, $v = 5, ji = 0, rd = null, Uh = null, od = 0, eS = 0, tS = null, D6 = null, GE = 50, pf = 0, nS = null, iS = !1, lg = !1, PE = 50, W0 = 0, ff = null, Th = !1, cg = null, x6 = !1, Z6 = /* @__PURE__ */ new Set(), YE = {}, dg = null, yh = null, aS = !1, rS = !1, ug = !1, oS = !1, H0 = 0, sS = {};
    (function() {
      for (var e = 0; e < Nv.length; e++) {
        var t = Nv[e], i = t.toLowerCase();
        t = t[0].toUpperCase() + t.slice(1), tr(i, "on" + t);
      }
      tr(RR, "onAnimationEnd"), tr(ER, "onAnimationIteration"), tr(UR, "onAnimationStart"), tr("dblclick", "onDoubleClick"), tr("focusin", "onFocus"), tr("focusout", "onBlur"), tr(VE, "onTransitionRun"), tr(CE, "onTransitionStart"), tr(FE, "onTransitionCancel"), tr(TR, "onTransitionEnd");
    })(), Oe("onMouseEnter", ["mouseout", "mouseover"]), Oe("onMouseLeave", ["mouseout", "mouseover"]), Oe("onPointerEnter", ["pointerout", "pointerover"]), Oe("onPointerLeave", ["pointerout", "pointerover"]), ke(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    ), ke(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    ), ke("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]), ke(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    ), ke(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    ), ke(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var gf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), lS = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gf)
    ), hg = "_reactListening" + Math.random().toString(36).slice(2), O6 = !1, B6 = !1, mg = !1, w6 = !1, pg = !1, fg = !1, A6 = !1, gg = {}, XE = /\r\n?/g, KE = /\u0000|\uFFFD/g, z0 = "http://www.w3.org/1999/xlink", cS = "http://www.w3.org/XML/1998/namespace", qE = "javascript:throw new Error('React form unexpectedly submitted.')", $E = "suppressHydrationWarning", vg = "$", Sg = "/$", Hl = "$?", vf = "$!", eU = 1, tU = 2, nU = 4, dS = "F!", J6 = "F", L6 = "complete", iU = "style", zl = 0, Nh = 1, Rg = 2, uS = null, hS = null, I6 = { dialog: !0, webview: !0 }, mS = null, W6 = typeof setTimeout == "function" ? setTimeout : void 0, aU = typeof clearTimeout == "function" ? clearTimeout : void 0, j0 = -1, H6 = typeof Promise == "function" ? Promise : void 0, rU = typeof queueMicrotask == "function" ? queueMicrotask : typeof H6 < "u" ? function(e) {
      return H6.resolve(null).then(e).catch(op);
    } : W6, pS = null, G0 = 0, Sf = 1, z6 = 2, j6 = 3, ho = 4, mo = /* @__PURE__ */ new Map(), G6 = /* @__PURE__ */ new Set(), jl = ut.d;
    ut.d = {
      f: function() {
        var e = jl.f(), t = Ul();
        return e || t;
      },
      r: function(e) {
        var t = In(e);
        t !== null && t.tag === 5 && t.type === "form" ? vm(t) : jl.r(e);
      },
      D: function(e) {
        jl.D(e), T2("dns-prefetch", e, null);
      },
      C: function(e, t) {
        jl.C(e, t), T2("preconnect", e, t);
      },
      L: function(e, t, i) {
        jl.L(e, t, i);
        var o = bh;
        if (o && e && t) {
          var c = 'link[rel="preload"][as="' + dt(t) + '"]';
          t === "image" && i && i.imageSrcSet ? (c += '[imagesrcset="' + dt(
            i.imageSrcSet
          ) + '"]', typeof i.imageSizes == "string" && (c += '[imagesizes="' + dt(
            i.imageSizes
          ) + '"]')) : c += '[href="' + dt(e) + '"]';
          var h = c;
          switch (t) {
            case "style":
              h = bs(e);
              break;
            case "script":
              h = Fl(e);
          }
          mo.has(h) || (e = bt(
            {
              rel: "preload",
              href: t === "image" && i && i.imageSrcSet ? void 0 : e,
              as: t
            },
            i
          ), mo.set(h, e), o.querySelector(c) !== null || t === "style" && o.querySelector(
            Kr(h)
          ) || t === "script" && o.querySelector(_l(h)) || (t = o.createElement("link"), xn(t, "link", e), j(t), o.head.appendChild(t)));
        }
      },
      m: function(e, t) {
        jl.m(e, t);
        var i = bh;
        if (i && e) {
          var o = t && typeof t.as == "string" ? t.as : "script", c = 'link[rel="modulepreload"][as="' + dt(o) + '"][href="' + dt(e) + '"]', h = c;
          switch (o) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              h = Fl(e);
          }
          if (!mo.has(h) && (e = bt({ rel: "modulepreload", href: e }, t), mo.set(h, e), i.querySelector(c) === null)) {
            switch (o) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (i.querySelector(_l(h)))
                  return;
            }
            o = i.createElement("link"), xn(o, "link", e), j(o), i.head.appendChild(o);
          }
        }
      },
      X: function(e, t) {
        jl.X(e, t);
        var i = bh;
        if (i && e) {
          var o = C(i).hoistableScripts, c = Fl(e), h = o.get(c);
          h || (h = i.querySelector(
            _l(c)
          ), h || (e = bt({ src: e, async: !0 }, t), (t = mo.get(c)) && pp(e, t), h = i.createElement("script"), j(h), xn(h, "link", e), i.head.appendChild(h)), h = {
            type: "script",
            instance: h,
            count: 1,
            state: null
          }, o.set(c, h));
        }
      },
      S: function(e, t, i) {
        jl.S(e, t, i);
        var o = bh;
        if (o && e) {
          var c = C(o).hoistableStyles, h = bs(e);
          t = t || "default";
          var v = c.get(h);
          if (!v) {
            var S = { loading: G0, preload: null };
            if (v = o.querySelector(
              Kr(h)
            ))
              S.loading = Sf | ho;
            else {
              e = bt(
                {
                  rel: "stylesheet",
                  href: e,
                  "data-precedence": t
                },
                i
              ), (i = mo.get(h)) && mp(e, i);
              var M = v = o.createElement("link");
              j(M), xn(M, "link", e), M._p = new Promise(function(x, ee) {
                M.onload = x, M.onerror = ee;
              }), M.addEventListener("load", function() {
                S.loading |= Sf;
              }), M.addEventListener("error", function() {
                S.loading |= z6;
              }), S.loading |= ho, F1(v, t, o);
            }
            v = {
              type: "stylesheet",
              instance: v,
              count: 1,
              state: S
            }, c.set(h, v);
          }
        }
      },
      M: function(e, t) {
        jl.M(e, t);
        var i = bh;
        if (i && e) {
          var o = C(i).hoistableScripts, c = Fl(e), h = o.get(c);
          h || (h = i.querySelector(
            _l(c)
          ), h || (e = bt({ src: e, async: !0, type: "module" }, t), (t = mo.get(c)) && pp(e, t), h = i.createElement("script"), j(h), xn(h, "link", e), i.head.appendChild(h)), h = {
            type: "script",
            instance: h,
            count: 1,
            state: null
          }, o.set(c, h));
        }
      }
    };
    var bh = typeof document > "u" ? null : document, Eg = null, Rf = null, fS = null, Ug = null, P0 = mv, Ef = {
      $$typeof: Pa,
      Provider: null,
      Consumer: null,
      _currentValue: P0,
      _currentValue2: P0,
      _threadCount: 0
    }, P6 = "%c%s%c ", Y6 = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", X6 = "", Tg = " ", oU = Function.prototype.bind, K6 = !1, q6 = null, $6 = null, e3 = null, t3 = null, n3 = null, i3 = null, a3 = null, r3 = null, o3 = null;
    q6 = function(e, t, i, o) {
      t = d(e, t), t !== null && (i = l(t.memoizedState, i, 0, o), t.memoizedState = i, t.baseState = i, e.memoizedProps = bt({}, e.memoizedProps), i = Pi(e, 2), i !== null && Qn(i, e, 2));
    }, $6 = function(e, t, i) {
      t = d(e, t), t !== null && (i = g(t.memoizedState, i, 0), t.memoizedState = i, t.baseState = i, e.memoizedProps = bt({}, e.memoizedProps), i = Pi(e, 2), i !== null && Qn(i, e, 2));
    }, e3 = function(e, t, i, o) {
      t = d(e, t), t !== null && (i = u(t.memoizedState, i, o), t.memoizedState = i, t.baseState = i, e.memoizedProps = bt({}, e.memoizedProps), i = Pi(e, 2), i !== null && Qn(i, e, 2));
    }, t3 = function(e, t, i) {
      e.pendingProps = l(e.memoizedProps, t, 0, i), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Pi(e, 2), t !== null && Qn(t, e, 2);
    }, n3 = function(e, t) {
      e.pendingProps = g(e.memoizedProps, t, 0), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Pi(e, 2), t !== null && Qn(t, e, 2);
    }, i3 = function(e, t, i) {
      e.pendingProps = u(
        e.memoizedProps,
        t,
        i
      ), e.alternate && (e.alternate.pendingProps = e.pendingProps), t = Pi(e, 2), t !== null && Qn(t, e, 2);
    }, a3 = function(e) {
      var t = Pi(e, 2);
      t !== null && Qn(t, e, 2);
    }, r3 = function(e) {
      y = e;
    }, o3 = function(e) {
      R = e;
    };
    var yg = !0, Ng = null, gS = !1, sd = null, ld = null, cd = null, Uf = /* @__PURE__ */ new Map(), Tf = /* @__PURE__ */ new Map(), dd = [], sU = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), bg = null;
    if (f0.prototype.render = x1.prototype.render = function(e) {
      var t = this._internalRoot;
      if (t === null) throw Error("Cannot update an unmounted root.");
      var i = arguments;
      typeof i[1] == "function" ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : Fe(i[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : typeof i[1] < "u" && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      ), i = e;
      var o = t.current, c = ta(o);
      nn(o, c, i, t, null, null);
    }, f0.prototype.unmount = x1.prototype.unmount = function() {
      var e = arguments;
      if (typeof e[0] == "function" && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ), e = this._internalRoot, e !== null) {
        this._internalRoot = null;
        var t = e.containerInfo;
        (an & (ba | Yo)) !== gr && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        ), nn(e.current, 2, null, e, null, null), Ul(), t[Ds] = null;
      }
    }, f0.prototype.unstable_scheduleHydration = function(e) {
      if (e) {
        var t = So();
        e = { blockedOn: null, target: e, priority: t };
        for (var i = 0; i < dd.length && t !== 0 && t < dd[i].priority; i++) ;
        dd.splice(i, 0, e), i === 0 && F2(e);
      }
    }, function() {
      var e = g0.version;
      if (e !== "19.1.0")
        throw Error(
          `Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:
  - react:      ` + (e + `
  - react-dom:  19.1.0
Learn more: https://react.dev/warnings/version-mismatch`)
        );
    }(), typeof Map == "function" && Map.prototype != null && typeof Map.prototype.forEach == "function" && typeof Set == "function" && Set.prototype != null && typeof Set.prototype.clear == "function" && typeof Set.prototype.forEach == "function" || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    ), ut.findDOMNode = function(e) {
      var t = e._reactInternals;
      if (t === void 0)
        throw typeof e.render == "function" ? Error("Unable to find node on an unmounted component.") : (e = Object.keys(e).join(","), Error(
          "Argument appears to not be a ReactComponent. Keys: " + e
        ));
      return e = _e(t), e = e !== null ? z(e) : null, e = e === null ? null : e.stateNode, e;
    }, !function() {
      var e = {
        bundleType: 1,
        version: "19.1.0",
        rendererPackageName: "react-dom",
        currentDispatcherRef: oe,
        reconcilerVersion: "19.1.0"
      };
      return e.overrideHookState = q6, e.overrideHookStateDeletePath = $6, e.overrideHookStateRenamePath = e3, e.overrideProps = t3, e.overridePropsDeletePath = n3, e.overridePropsRenamePath = i3, e.scheduleUpdate = a3, e.setErrorHandler = r3, e.setSuspenseHandler = o3, e.scheduleRefresh = Ne, e.scheduleRoot = A, e.setRefreshHandler = Ee, e.getCurrentFiber = cv, e.getLaneLabelMap = dv, e.injectProfilingHooks = Bt, Ae(e);
    }() && O && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && navigator.userAgent.indexOf("Edge") === -1 || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var s3 = window.location.protocol;
      /^(https?|file):$/.test(s3) && "" + (s3 === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq` : "");
    }
    Cf.createRoot = function(e, t) {
      if (!Fe(e))
        throw Error("Target container is not a DOM element.");
      k2(e);
      var i = !1, o = "", c = Um, h = o2, v = Lu, S = null;
      return t != null && (t.hydrate || typeof t == "object" && t !== null && t.$$typeof === Fs && console.error(
        `You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`
      ), t.unstable_strictMode === !0 && (i = !0), t.identifierPrefix !== void 0 && (o = t.identifierPrefix), t.onUncaughtError !== void 0 && (c = t.onUncaughtError), t.onCaughtError !== void 0 && (h = t.onCaughtError), t.onRecoverableError !== void 0 && (v = t.onRecoverableError), t.unstable_transitionCallbacks !== void 0 && (S = t.unstable_transitionCallbacks)), t = vp(
        e,
        1,
        !1,
        null,
        null,
        i,
        o,
        c,
        h,
        v,
        S,
        null
      ), e[Ds] = t.current, $m(e), new x1(t);
    }, Cf.hydrateRoot = function(e, t, i) {
      if (!Fe(e))
        throw Error("Target container is not a DOM element.");
      k2(e), t === void 0 && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var o = !1, c = "", h = Um, v = o2, S = Lu, M = null, x = null;
      return i != null && (i.unstable_strictMode === !0 && (o = !0), i.identifierPrefix !== void 0 && (c = i.identifierPrefix), i.onUncaughtError !== void 0 && (h = i.onUncaughtError), i.onCaughtError !== void 0 && (v = i.onCaughtError), i.onRecoverableError !== void 0 && (S = i.onRecoverableError), i.unstable_transitionCallbacks !== void 0 && (M = i.unstable_transitionCallbacks), i.formState !== void 0 && (x = i.formState)), t = vp(
        e,
        1,
        !0,
        t,
        i ?? null,
        o,
        c,
        h,
        v,
        S,
        M,
        x
      ), t.context = Sp(null), i = t.current, o = ta(i), o = Jn(o), c = Mr(o), c.callback = null, or(i, c, o), i = o, t.current.lanes = i, xi(t, i), za(t), e[Ds] = t.current, $m(e), new f0(t);
    }, Cf.version = "19.1.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Cf;
}
var w3;
function Sy() {
  if (w3) return Mg.exports;
  w3 = 1;
  function d() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(d);
      } catch (l) {
        console.error(l);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (d(), Mg.exports = gy()) : Mg.exports = vy(), Mg.exports;
}
var Ry = Sy();
function j5(d) {
  var l, u, p = "";
  if (typeof d == "string" || typeof d == "number") p += d;
  else if (typeof d == "object") if (Array.isArray(d)) {
    var g = d.length;
    for (l = 0; l < g; l++) d[l] && (u = j5(d[l])) && (p && (p += " "), p += u);
  } else for (u in d) d[u] && (p && (p += " "), p += u);
  return p;
}
function en() {
  for (var d, l, u = 0, p = "", g = arguments.length; u < g; u++) (d = arguments[u]) && (l = j5(d)) && (p && (p += " "), p += l);
  return p;
}
function G5() {
  if (typeof navigator > "u" || !navigator.userAgent)
    return "unknown";
  const d = navigator.userAgent.toLowerCase();
  return /android/.test(d) ? "android" : /iphone|ipad|ipod/.test(d) ? "ios" : /mac os x/.test(d) ? "macos" : /win/.test(d) ? "windows" : /linux/.test(d) ? "linux" : "unknown";
}
function Ey() {
  const d = G5();
  return d === "android" || d === "ios";
}
ne.setState({
  webOSName: G5(),
  isMobileBrowser: Ey()
});
ne.subscribe(
  (d) => d.audioInputDevice,
  async (d, l) => {
    var p;
    if (!(ne.getState().isMobile() && (d == null ? void 0 : d.deviceId) !== null) && !(d != null && d.skipSubscribe) && (l == null ? void 0 : l.deviceId) !== "" && d && l) {
      if (d.deviceId === l.deviceId) {
        const R = yn(We.AUDIO);
        R && await ((p = R.originalTrack) == null ? void 0 : p.dispose());
      }
      wU(d.deviceId);
      const g = ne.getState().audioInputDevice;
      g && Ye.publish({
        type: Dh.MediaEventsListener.onAudioInputDeviceChanged,
        payload: g
      });
    }
  },
  {
    equalityFn: p5
  }
);
ne.subscribe(
  (d) => d.audioInputDevices,
  (d) => {
    Ye.publish({
      type: Dh.MediaEventsListener.onAudioInputDevicesChanged,
      payload: d
    });
  }
);
ne.subscribe(
  (d) => d.videoInputDevices,
  (d) => {
    Ye.publish({
      type: Dh.MediaEventsListener.onVideoInputDevicesChanged,
      payload: d
    });
  }
);
ne.subscribe(
  (d) => d.audioOutputDevices,
  (d) => {
    Ye.publish({
      type: Dh.MediaEventsListener.onAudioOutputDevicesChanged,
      payload: d
    });
  }
);
ne.subscribe(
  (d) => {
    var l;
    return (l = d.audioOutputDevice) == null ? void 0 : l.deviceId;
  },
  (d) => {
    if (typeof d == "string") {
      XS(d);
      const l = ne.getState().audioOutputDevice;
      l && Ye.publish({
        type: Dh.MediaEventsListener.onAudioOutputDeviceChanged,
        payload: l
      });
    }
  }
);
ne.subscribe(
  (d) => d.videoInputDevice,
  async (d, l) => {
    if (!(ne.getState().isMobile() && (d == null ? void 0 : d.deviceId) !== null) && l && d) {
      v5(d.deviceId);
      const p = ne.getState().videoInputDevice;
      if (d.deviceId === l.deviceId) {
        const g = yn(We.VIDEO);
        g && await g.originalTrack.dispose();
      }
      p && Ye.publish({
        type: Dh.MediaEventsListener.onVideoInputDeviceChanged,
        payload: p
      });
    }
  },
  {
    equalityFn: p5
  }
);
Ye.subscribe(An.onConnectionEstablished, () => {
  ne.setState({
    isDesktopSharingEnabled: tt.isDesktopSharingEnabled()
  });
  {
    const d = document.createElement("canvas"), l = d.getContext("2d"), u = typeof (l == null ? void 0 : l.filter) < "u";
    ne.setState({ isBlurSupported: u }), d.remove();
  }
});
const Uy = "data:text/javascript;base64,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";
let ud;
class Ty {
  /**
   * Instantiates a noise suppressor audio effect which will use rnnoise.
   */
  constructor() {
    /**
     * Source that will be attached to the track affected by the effect.
     */
    P(this, "_audioSource");
    /**
     * Destination that will contain denoised audio from the audio worklet.
     */
    P(this, "_audioDestination");
    /**
     * `AudioWorkletProcessor` associated node.
     */
    P(this, "_noiseSuppressorNode");
    /**
     * Audio track extracted from the original MediaStream to which the effect is applied.
     */
    P(this, "_originalMediaTrack");
    /**
     * Noise suppressed audio track extracted from the media destination node.
     */
    P(this, "_outputMediaTrack");
  }
  /**
   * Effect interface called by source JitsiLocalTrack.
   * Applies effect that uses a {@code NoiseSuppressor} service initialized with {@code RnnoiseProcessor}
   * for denoising.
   *
   * @param {MediaStream} audioStream - Audio stream which will be mixed with _mixAudio.
   * @returns {MediaStream} - MediaStream containing both audio tracks mixed together.
   */
  startEffect(l) {
    return this._originalMediaTrack = l.getAudioTracks()[0], ud || (ud = new AudioContext()), this._audioSource = ud.createMediaStreamSource(l), this._audioDestination = ud.createMediaStreamDestination(), this._outputMediaTrack = this._audioDestination.stream.getAudioTracks()[0], yy().then((p) => {
      this._noiseSuppressorNode = p;
    }).then(() => {
      this._noiseSuppressorNode && (this._audioSource.connect(this._noiseSuppressorNode), this._noiseSuppressorNode.connect(this._audioDestination));
    }), this._outputMediaTrack.enabled = this._originalMediaTrack.enabled, this._originalMediaTrack.enabled = !0, this._audioDestination.stream;
  }
  /**
   * Checks if the JitsiLocalTrack supports this effect.
   *
   * @param {JitsiLocalTrack} sourceLocalTrack - Track to which the effect will be applied.
   * @returns {boolean} - Returns true if this effect can run on the specified track, false otherwise.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isEnabled(l) {
    return l.isAudioTrack();
  }
  /**
   * Clean up resources acquired by noise suppressor and rnnoise processor.
   *
   * @returns {void}
   */
  stopEffect() {
    var l, u, p, g, R;
    this._originalMediaTrack.enabled = this._outputMediaTrack.enabled, (u = (l = this._noiseSuppressorNode) == null ? void 0 : l.port) == null || u.close(), (p = this._audioDestination) == null || p.disconnect(), (g = this._noiseSuppressorNode) == null || g.disconnect(), (R = this._audioSource) == null || R.disconnect(), ud.suspend();
  }
}
async function yy() {
  await ud.resume();
  try {
    await ud.audioWorklet.addModule(Uy);
  } catch (d) {
    console.error("Error while adding audio worklet module: ", d);
    return;
  }
  return new AudioWorkletNode(ud, "NoiseSuppressorWorklet");
}
function P5() {
  var l;
  const d = (l = yn(We.AUDIO)) == null ? void 0 : l.originalTrack;
  d && d.setEffect(new Ty()).then(() => {
  });
}
function Ny() {
  var l;
  const d = (l = yn(We.AUDIO)) == null ? void 0 : l.originalTrack;
  d && d.setEffect(void 0).then(() => {
  }).catch((u) => {
    console.error("Error removing noise suppression effect:", u);
  });
}
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.AUDIO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d) => {
    d && ne.getState().enableNoiseReduction && P5();
  }
);
ne.subscribe(
  (d) => d.enableNoiseReduction,
  (d) => {
    d ? P5() : Ny();
  }
);
async function by() {
  try {
    const [d, l] = await Promise.all([
      navigator.permissions.query({ name: "camera" }),
      navigator.permissions.query({ name: "microphone" })
    ]);
    ft.setState((u) => ({
      permissions: {
        ...u.permissions,
        video: d.state === "granted",
        audio: l.state === "granted",
        initialized: !0
      }
    }));
  } catch {
  }
}
function Vy() {
  const { mediaDevices: d } = tt;
  d.addEventListener(
    tt.events.mediaDevices.PERMISSIONS_CHANGED,
    (l) => {
      ft.setState((u) => ({
        permissions: {
          ...u.permissions,
          ...l
        }
      }));
    }
  );
}
Ye.subscribe(An.lifecycle.SDKInitialized, () => {
  by(), Vy();
});
let $0;
async function Y5() {
  $0 != null && $0.released && document.visibilityState === "visible" && (await K5(), X5());
}
async function X5() {
  var d;
  (d = navigator.wakeLock) != null && d.request && navigator.wakeLock.request("screen").then((l) => {
    $0 = l;
  }).catch((l) => {
    console.error("Failed to acquire wake lock:", l);
  });
}
async function K5() {
  $0 && (await $0.release(), $0 = void 0);
}
Ye.subscribe(An.onConnectionEstablished, () => {
  X5(), document.addEventListener("visibilitychange", Y5);
});
Ye.subscribe(An.connectionWillClose, () => {
  document.removeEventListener("visibilitychange", Y5), K5();
});
const Cy = ({ autoPlay: d = !0, audioTrack: l, id: u }) => {
  const p = re.useRef(null);
  return re.useEffect(() => {
    const g = p.current;
    return g && l && l.attach(g).catch((R) => {
      console.error("Error attaching audio track:", R);
    }), () => {
      g && l && l.detach(g);
    };
  }, [l]), /* @__PURE__ */ U.jsx("audio", { autoPlay: d, id: u, ref: p });
}, Fy = () => {
  const d = ft((p) => p.tracks);
  if (Rt(
    (p) => p.enableCompanionMode
  ))
    return null;
  const u = d.filter(
    (p) => p.mediaType === We.AUDIO && !p.local && p.originalTrack
  );
  return /* @__PURE__ */ U.jsx(U.Fragment, { children: u.map((p, g) => {
    var R, y, Q, T;
    return /* @__PURE__ */ U.jsx(
      Cy,
      {
        id: `cc-rt-${((y = (R = p.originalTrack).getId) == null ? void 0 : y.call(R)) || ""}`,
        audioTrack: p.originalTrack
      },
      ((T = (Q = p.originalTrack).getId) == null ? void 0 : T.call(Q)) || g
    );
  }) });
};
function _y({ className: d, size: l = 40 }) {
  return /* @__PURE__ */ U.jsx(
    "svg",
    {
      className: en("cometchat-calls-loading-spinner", d),
      style: { width: l, height: l },
      viewBox: "0 0 33 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M16.4963 31.8337C14.3288 31.8337 12.2826 31.4184 10.3576 30.5878C8.43283 29.7573 6.752 28.6235 5.31505 27.1866C3.87811 25.7496 2.74436 24.0688 1.9138 22.1441C1.08325 20.2191 0.667969 18.1728 0.667969 16.0053C0.667969 13.8114 1.08408 11.7563 1.9163 9.83991C2.74852 7.92324 3.88158 6.2481 5.31547 4.81449C6.74908 3.3806 8.43019 2.24755 10.3588 1.41533C12.2874 0.583104 14.3349 0.166992 16.5013 0.166992C16.8555 0.166992 17.1523 0.286853 17.3917 0.526576C17.6314 0.766298 17.7513 1.06324 17.7513 1.41741C17.7513 1.77185 17.6314 2.06866 17.3917 2.30783C17.1523 2.54727 16.8555 2.66699 16.5013 2.66699C12.8069 2.66699 9.66102 3.9656 7.0638 6.56283C4.46658 9.16005 3.16797 12.3059 3.16797 16.0003C3.16797 19.6948 4.46658 22.8406 7.0638 25.4378C9.66102 28.035 12.8069 29.3337 16.5013 29.3337C20.1957 29.3337 23.3416 28.035 25.9388 25.4378C28.536 22.8406 29.8346 19.6948 29.8346 16.0003C29.8346 15.6456 29.9545 15.3487 30.1942 15.1095C30.4339 14.87 30.7309 14.7503 31.0851 14.7503C31.4395 14.7503 31.7363 14.8702 31.9755 15.1099C32.2149 15.3494 32.3346 15.6462 32.3346 16.0003C32.3346 18.1667 31.9185 20.2142 31.0863 22.1428C30.2541 24.0714 29.121 25.7525 27.6871 27.1862C26.2535 28.62 24.5784 29.7531 22.6617 30.5853C20.7453 31.4175 18.6902 31.8337 16.4963 31.8337Z",
          fill: "white"
        }
      )
    }
  );
}
function A3({
  message: d,
  showLoading: l = !0,
  description: u = "",
  className: p = ""
}) {
  return /* @__PURE__ */ U.jsxs("div", { className: `cometchat-calls-processing-overlay ${p}`, children: [
    l && /* @__PURE__ */ U.jsx(_y, {}),
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-processing-message", children: d }),
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-processing-message cometchat-calls-description", children: u })
  ] });
}
const My = ({
  className: d = ""
}) => {
  const l = b5(), u = Rt(
    (p) => p.hideRecordingStatusIndicator
  );
  return !l || u ? null : /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-recording-indicator-position", children: /* @__PURE__ */ U.jsxs("div", { className: en("cometchat-calls-recording-indicator", d), children: [
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-recording-indicator-dot" }),
    /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-recording-indicator-text", children: "REC" })
  ] }) });
}, aR = ({ name: d, imageUrl: l, size: u, fontSize: p }) => /* @__PURE__ */ U.jsx(
  "div",
  {
    className: "cometchat-calls-avatar-wrapper",
    style: u ? { width: u, height: u } : {},
    children: l ? /* @__PURE__ */ U.jsx(
      "img",
      {
        src: l,
        alt: d,
        className: "cometchat-calls-avatar-image"
      }
    ) : /* @__PURE__ */ U.jsx(
      "div",
      {
        className: "cometchat-calls-avatar-fallback",
        style: p ? { fontSize: p } : {},
        children: QU(d)
      }
    )
  }
), ky = ({ videoTrack: d }) => {
  const [l, u] = re.useState(null);
  return re.useEffect(() => {
    if (!d) {
      u(null);
      return;
    }
    const p = () => {
      var y, Q;
      const R = (Q = (y = d == null ? void 0 : d.track) == null ? void 0 : y.getSettings) == null ? void 0 : Q.call(y);
      R != null && R.frameRate && u(Math.round(R.frameRate));
    };
    p();
    const g = setInterval(p, 1e3);
    return () => clearInterval(g);
  }, [d]), l === null ? null : /* @__PURE__ */ U.jsxs("span", { className: "cometchat-calls-frame-rate-indicator", children: [
    l,
    " fps"
  ] });
}, FS = {
  add: "M17.5 20.5H3.5V6.5H12.5V4.5H3.5C2.4 4.5 1.5 5.4 1.5 6.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H17.5C18.6 22.5 19.5 21.6 19.5 20.5V11.5H17.5V20.5ZM9.71 17.33L7.75 14.97L5 18.5H16L12.46 13.79L9.71 17.33ZM19.5 4.5V1.5H17.5V4.5H14.5C14.51 4.51 14.5 6.5 14.5 6.5H17.5V9.49C17.51 9.5 19.5 9.49 19.5 9.49V6.5H22.5V4.5H19.5Z",
  alert: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z",
  "arrow-up": "M12.0005 10.4538L7.9275 14.527C7.789 14.6653 7.61492 14.7362 7.40525 14.7395C7.19575 14.7427 7.0185 14.6718 6.8735 14.527C6.72867 14.382 6.65625 14.2063 6.65625 14C6.65625 13.7937 6.72867 13.618 6.8735 13.473L11.3678 8.97876C11.5486 8.7981 11.7595 8.70776 12.0005 8.70776C12.2415 8.70776 12.4524 8.7981 12.6333 8.97876L17.1275 13.473C17.2658 13.6115 17.3367 13.7856 17.34 13.9953C17.3432 14.2048 17.2723 14.382 17.1275 14.527C16.9825 14.6718 16.8068 14.7443 16.6005 14.7443C16.3942 14.7443 16.2185 14.6718 16.0735 14.527L12.0005 10.4538Z",
  bluetooth: "M17.65 6.99663L13.36 2.70663C12.73 2.07663 11.65 2.51663 11.65 3.40663V9.58663L7.76 5.69663C7.37 5.30663 6.74 5.30663 6.35 5.69663C5.96 6.08663 5.96 6.71663 6.35 7.10663L11.24 11.9966L6.35 16.8866C5.96 17.2766 5.96 17.9066 6.35 18.2966C6.74 18.6866 7.37 18.6866 7.76 18.2966L11.65 14.4066V20.5866C11.65 21.4766 12.73 21.9266 13.36 21.2966L17.65 16.9966C18.04 16.6066 18.04 15.9766 17.65 15.5866L14.06 11.9966L17.65 8.41663C18.04 8.02663 18.04 7.38663 17.65 6.99663ZM13.65 5.82663L15.53 7.70663L13.65 9.58663V5.82663ZM15.53 16.2866L13.65 18.1666V14.4066L15.53 16.2866Z",
  "call-end": "M4.58108 16.0302L6.58108 14.4402C7.06108 14.0602 7.34108 13.4802 7.34108 12.8702V10.2702C10.3611 9.29016 13.6311 9.28016 16.6611 10.2702V12.8802C16.6611 13.4902 16.9411 14.0702 17.4211 14.4502L19.4111 16.0302C20.2111 16.6602 21.3511 16.6002 22.0711 15.8802L23.2911 14.6602C24.0911 13.8602 24.0911 12.5302 23.2411 11.7802C16.8311 6.12016 7.17108 6.12016 0.76108 11.7802C-0.0889204 12.5302 -0.0889204 13.8602 0.71108 14.6602L1.93108 15.8802C2.64108 16.6002 3.78108 16.6602 4.58108 16.0302Z",
  car: "M18.92 5.01C18.72 4.42 18.16 4 17.5 4H6.5C5.84 4 5.29 4.42 5.08 5.01L3.11 10.68C3.04 10.89 3 11.11 3 11.34V18.5C3 19.33 3.67 20 4.5 20C5.33 20 6 19.33 6 18.5V18H18V18.5C18 19.32 18.67 20 19.5 20C20.32 20 21 19.33 21 18.5V11.34C21 11.12 20.96 10.89 20.89 10.68L18.92 5.01ZM6.5 15C5.67 15 5 14.33 5 13.5C5 12.67 5.67 12 6.5 12C7.33 12 8 12.67 8 13.5C8 14.33 7.33 15 6.5 15ZM17.5 15C16.67 15 16 14.33 16 13.5C16 12.67 16.67 12 17.5 12C18.33 12 19 12.67 19 13.5C19 14.33 18.33 15 17.5 15ZM5 10L6.27 6.18C6.41 5.78 6.79 5.5 7.22 5.5H16.78C17.21 5.5 17.59 5.78 17.73 6.18L19 10H5Z",
  chat: "M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM7 9H17C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11H7C6.45 11 6 10.55 6 10C6 9.45 6.45 9 7 9ZM13 14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM17 8H7C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6H17C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8Z",
  "check-fill": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z",
  close: "M11.999 13.1163L6.89479 18.2203C6.73379 18.3815 6.54629 18.4614 6.33229 18.4601C6.11845 18.4586 5.93379 18.3773 5.77829 18.2163C5.61995 18.0552 5.54287 17.8697 5.54704 17.6601C5.5512 17.4502 5.62962 17.269 5.78229 17.1163L10.8823 11.9996L5.78229 6.88283C5.62962 6.73016 5.55329 6.54891 5.55329 6.33908C5.55329 6.12941 5.62962 5.944 5.78229 5.78283C5.93512 5.62183 6.11845 5.54058 6.33229 5.53908C6.54629 5.53775 6.73379 5.61483 6.89479 5.77033L11.999 10.8828L17.1115 5.77033C17.267 5.61483 17.4518 5.53775 17.6658 5.53908C17.8796 5.54058 18.0671 5.62183 18.2283 5.78283C18.381 5.944 18.4552 6.12941 18.451 6.33908C18.4469 6.54891 18.3685 6.73016 18.2158 6.88283L13.1158 11.9996L18.2158 17.1163C18.3685 17.269 18.4448 17.4502 18.4448 17.6601C18.4448 17.8697 18.3685 18.0552 18.2158 18.2163C18.063 18.3773 17.8796 18.4586 17.6658 18.4601C17.4518 18.4614 17.267 18.3815 17.1115 18.2203L11.999 13.1163Z",
  earpiece: "M19.7885 11.7299C19.5858 11.7299 19.4076 11.658 19.2538 11.5144C19.0999 11.3709 19.0096 11.1927 18.9828 10.9799C18.7661 9.36569 18.0863 7.98719 16.9433 6.84436C15.8003 5.70136 14.4218 5.02153 12.8078 4.80486C12.5949 4.77786 12.4167 4.69003 12.273 4.54136C12.1295 4.39269 12.0578 4.21194 12.0578 3.99911C12.0578 3.78628 12.1321 3.60811 12.2808 3.46461C12.4294 3.32094 12.6051 3.26261 12.8078 3.28961C14.8436 3.51011 16.5792 4.33794 18.0145 5.77311C19.4497 7.20844 20.2775 8.94403 20.498 10.9799C20.525 11.1824 20.4667 11.358 20.323 11.5069C20.1795 11.6555 20.0013 11.7299 19.7885 11.7299ZM15.652 11.7299C15.4865 11.7299 15.3413 11.6741 15.2163 11.5626C15.0913 11.4511 14.9968 11.3024 14.9328 11.1164C14.7801 10.5754 14.5002 10.0981 14.0933 9.68461C13.6863 9.27111 13.2123 8.99136 12.6713 8.84536C12.4853 8.78119 12.3365 8.68661 12.225 8.56161C12.1135 8.43661 12.0578 8.28628 12.0578 8.11061C12.0578 7.86061 12.1439 7.65869 12.3163 7.50486C12.4888 7.35103 12.6846 7.30103 12.9038 7.35486C13.7794 7.55869 14.5339 7.97728 15.1673 8.61061C15.8006 9.24394 16.2224 10.0016 16.4328 10.8836C16.4866 11.1029 16.4324 11.2988 16.2703 11.4711C16.1081 11.6436 15.902 11.7299 15.652 11.7299ZM19.4403 20.4991C17.5558 20.4991 15.6625 20.0609 13.7605 19.1846C11.8587 18.3083 10.1097 17.0721 8.5135 15.4761C6.92383 13.8799 5.69083 12.1324 4.8145 10.2336C3.93817 8.33494 3.5 6.44336 3.5 4.55886C3.5 4.25886 3.6 4.00719 3.8 3.80386C4 3.60069 4.25 3.49911 4.55 3.49911H7.8115C8.064 3.49911 8.28675 3.58153 8.47975 3.74636C8.67275 3.91103 8.7955 4.11453 8.848 4.35686L9.42125 7.29911C9.46092 7.57211 9.45258 7.80669 9.39625 8.00286C9.33975 8.19903 9.23842 8.36378 9.09225 8.49711L6.78275 10.7454C7.15442 11.426 7.57908 12.0699 8.05675 12.6771C8.53425 13.2841 9.05125 13.8639 9.60775 14.4164C10.1564 14.9652 10.7398 15.4749 11.3578 15.9454C11.9757 16.4159 12.6431 16.8537 13.3598 17.2589L15.6038 14.9954C15.7603 14.8325 15.9498 14.7184 16.1723 14.6529C16.3946 14.5875 16.6257 14.5715 16.8655 14.6049L19.6423 15.1704C19.8948 15.237 20.1008 15.3659 20.2605 15.5569C20.4202 15.7479 20.5 15.9645 20.5 16.2069V19.4491C20.5 19.7491 20.3984 19.9991 20.1953 20.1991C19.9919 20.3991 19.7403 20.4991 19.4403 20.4991Z",
  "empty-search": "M11.0001 11.6921C10.0348 11.6921 9.2101 11.3501 8.5261 10.6661C7.8421 9.98228 7.5001 9.15761 7.5001 8.19211C7.5001 7.22678 7.8421 6.40211 8.5261 5.71811C9.2101 5.03411 10.0348 4.69211 11.0001 4.69211C11.9654 4.69211 12.7901 5.03411 13.4741 5.71811C14.1581 6.40211 14.5001 7.22678 14.5001 8.19211C14.5001 9.15761 14.1581 9.98228 13.4741 10.6661C12.7901 11.3501 11.9654 11.6921 11.0001 11.6921ZM21.1308 22.1844L18.7271 19.7806C18.3899 19.9934 18.0341 20.1601 17.6596 20.2806C17.2853 20.4011 16.8988 20.4614 16.5001 20.4614C15.3976 20.4614 14.4617 20.0768 13.6923 19.3076C12.9232 18.5383 12.5386 17.6024 12.5386 16.4999C12.5386 15.3974 12.9232 14.4614 13.6923 13.6921C14.4617 12.9229 15.3976 12.5384 16.5001 12.5384C17.6026 12.5384 18.5385 12.9229 19.3078 13.6921C20.077 14.4614 20.4616 15.3974 20.4616 16.4999C20.4616 16.8985 20.4013 17.285 20.2808 17.6594C20.1603 18.0339 19.9937 18.3897 19.7808 18.7269L22.1846 21.1306C22.3231 21.2691 22.3939 21.4431 22.3971 21.6526C22.4003 21.8623 22.3294 22.0395 22.1846 22.1844C22.0398 22.3292 21.8642 22.4016 21.6578 22.4016C21.4513 22.4016 21.2757 22.3292 21.1308 22.1844ZM16.5001 18.9614C17.1938 18.9614 17.7774 18.7245 18.2511 18.2509C18.7248 17.7772 18.9616 17.1935 18.9616 16.4999C18.9616 15.8062 18.7248 15.2225 18.2511 14.7489C17.7774 14.2752 17.1938 14.0384 16.5001 14.0384C15.8064 14.0384 15.2228 14.2752 14.7491 14.7489C14.2754 15.2225 14.0386 15.8062 14.0386 16.4999C14.0386 17.1935 14.2754 17.7772 14.7491 18.2509C15.2228 18.7245 15.8064 18.9614 16.5001 18.9614ZM5.01935 19.3076C4.59751 19.3076 4.23885 19.1599 3.94335 18.8644C3.64785 18.5687 3.5001 18.21 3.5001 17.7884V17.0999C3.5001 16.6037 3.6306 16.1476 3.8916 15.7316C4.15243 15.3156 4.51043 14.9922 4.9656 14.7614C5.66426 14.4037 6.49018 14.0842 7.44335 13.8029C8.39651 13.5214 9.43726 13.3614 10.5656 13.3229C10.7591 13.3127 10.9058 13.3944 11.0058 13.5681C11.1058 13.7418 11.1174 13.9254 11.0406 14.1191C10.8764 14.5038 10.7518 14.8977 10.6666 15.3009C10.5813 15.704 10.5386 16.1114 10.5386 16.5229C10.5386 16.8472 10.5648 17.1741 10.6173 17.5036C10.67 17.8331 10.7592 18.1498 10.8848 18.4536C10.9592 18.6678 10.9396 18.8636 10.8261 19.0411C10.7126 19.2188 10.5488 19.3076 10.3348 19.3076H5.01935Z",
  error: "M9.16602 12.5003H10.8327V14.167H9.16602V12.5003ZM9.16602 5.83366H10.8327V10.8337H9.16602V5.83366ZM9.99102 1.66699C5.39102 1.66699 1.66602 5.40033 1.66602 10.0003C1.66602 14.6003 5.39102 18.3337 9.99102 18.3337C14.5993 18.3337 18.3327 14.6003 18.3327 10.0003C18.3327 5.40033 14.5993 1.66699 9.99102 1.66699ZM9.99935 16.667C6.31602 16.667 3.33268 13.6837 3.33268 10.0003C3.33268 6.31699 6.31602 3.33366 9.99935 3.33366C13.6827 3.33366 16.666 6.31699 16.666 10.0003C16.666 13.6837 13.6827 16.667 9.99935 16.667Z",
  headphones: "M3 12V19C3 20.1 3.9 21 5 21H7C8.1 21 9 20.1 9 19V15C9 13.9 8.1 13 7 13H5V12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12V13H17C15.9 13 15 13.9 15 15V19C15 20.1 15.9 21 17 21H19C20.1 21 21 20.1 21 19V12C21 7.03 16.97 3 12 3C7.03 3 3 7.03 3 12Z",
  image: "M17.5 20.5H3.5V6.5H12.5V4.5H3.5C2.4 4.5 1.5 5.4 1.5 6.5V20.5C1.5 21.6 2.4 22.5 3.5 22.5H17.5C18.6 22.5 19.5 21.6 19.5 20.5V11.5H17.5V20.5ZM9.71 17.33L7.75 14.97L5 18.5H16L12.46 13.79L9.71 17.33ZM19.5 4.5V1.5H17.5V4.5H14.5C14.51 4.51 14.5 6.5 14.5 6.5H17.5V9.49C17.51 9.5 19.5 9.49 19.5 9.49V6.5H22.5V4.5H19.5Z",
  invite: "M18.125 10.7501H15.875C15.6625 10.7501 15.4844 10.6782 15.3408 10.5344C15.1969 10.3905 15.125 10.2124 15.125 9.99988C15.125 9.78722 15.1969 9.60913 15.3408 9.46563C15.4844 9.32197 15.6625 9.25013 15.875 9.25013H18.125V7.00013C18.125 6.78763 18.1969 6.60955 18.3407 6.46588C18.4846 6.32205 18.6628 6.25013 18.8752 6.25013C19.0879 6.25013 19.266 6.32205 19.4095 6.46588C19.5532 6.60955 19.625 6.78763 19.625 7.00013V9.25013H21.875C22.0875 9.25013 22.2656 9.32205 22.4093 9.46588C22.5531 9.60972 22.625 9.78788 22.625 10.0004C22.625 10.213 22.5531 10.3911 22.4093 10.5346C22.2656 10.6783 22.0875 10.7501 21.875 10.7501H19.625V13.0001C19.625 13.2126 19.5531 13.3907 19.4093 13.5344C19.2654 13.6782 19.0872 13.7501 18.8748 13.7501C18.6621 13.7501 18.484 13.6782 18.3405 13.5344C18.1968 13.3907 18.125 13.2126 18.125 13.0001V10.7501ZM9 11.6924C8.0375 11.6924 7.21358 11.3497 6.52825 10.6644C5.84275 9.97888 5.5 9.15488 5.5 8.19238C5.5 7.22988 5.84275 6.40597 6.52825 5.72063C7.21358 5.03513 8.0375 4.69238 9 4.69238C9.9625 4.69238 10.7864 5.03513 11.4718 5.72063C12.1573 6.40597 12.5 7.22988 12.5 8.19238C12.5 9.15488 12.1573 9.97888 11.4718 10.6644C10.7864 11.3497 9.9625 11.6924 9 11.6924ZM1.5 17.7886V17.0846C1.5 16.595 1.633 16.1415 1.899 15.7241C2.165 15.3068 2.5205 14.986 2.9655 14.7616C3.95383 14.2771 4.95092 13.9137 5.95675 13.6714C6.96258 13.429 7.977 13.3079 9 13.3079C10.023 13.3079 11.0374 13.429 12.0433 13.6714C13.0491 13.9137 14.0462 14.2771 15.0345 14.7616C15.4795 14.986 15.835 15.3068 16.101 15.7241C16.367 16.1415 16.5 16.595 16.5 17.0846V17.7886C16.5 18.2103 16.3523 18.569 16.0568 18.8646C15.7613 19.1601 15.4026 19.3079 14.9808 19.3079H3.01925C2.59742 19.3079 2.23875 19.1601 1.94325 18.8646C1.64775 18.569 1.5 18.2103 1.5 17.7886ZM3 17.8079H15V17.0846C15 16.8821 14.9413 16.6946 14.824 16.5221C14.7067 16.3498 14.5474 16.2091 14.3462 16.1001C13.4846 15.6758 12.6061 15.3543 11.7107 15.1356C10.8153 14.9171 9.91167 14.8079 9 14.8079C8.08833 14.8079 7.18475 14.9171 6.28925 15.1356C5.39392 15.3543 4.51542 15.6758 3.65375 16.1001C3.45258 16.2091 3.29333 16.3498 3.176 16.5221C3.05867 16.6946 3 16.8821 3 17.0846V17.8079ZM9 10.1924C9.55 10.1924 10.0208 9.99655 10.4125 9.60488C10.8042 9.21322 11 8.74238 11 8.19238C11 7.64238 10.8042 7.17155 10.4125 6.77988C10.0208 6.38822 9.55 6.19238 9 6.19238C8.45 6.19238 7.97917 6.38822 7.5875 6.77988C7.19583 7.17155 7 7.64238 7 8.19238C7 8.74238 7.19583 9.21322 7.5875 9.60488C7.97917 9.99655 8.45 10.1924 9 10.1924Z",
  mic: "M12 14.5C13.66 14.5 15 13.16 15 11.5V5.5C15 3.84 13.66 2.5 12 2.5C10.34 2.5 9 3.84 9 5.5V11.5C9 13.16 10.34 14.5 12 14.5ZM11 5.5C11 4.95 11.45 4.5 12 4.5C12.55 4.5 13 4.95 13 5.5V11.5C13 12.05 12.55 12.5 12 12.5C11.45 12.5 11 12.05 11 11.5V5.5ZM17 11.5C17 14.26 14.76 16.5 12 16.5C9.24 16.5 7 14.26 7 11.5H5C5 15.03 7.61 17.93 11 18.42V21.5H13V18.42C16.39 17.93 19 15.03 19 11.5H17Z",
  "mic-fill": "M11.999 14.5C13.659 14.5 14.999 13.16 14.999 11.5V5.5C14.999 3.84 13.659 2.5 11.999 2.5C10.339 2.5 8.99901 3.84 8.99901 5.5V11.5C8.99901 13.16 10.339 14.5 11.999 14.5ZM17.909 11.5C17.419 11.5 17.009 11.86 16.929 12.35C16.519 14.7 14.469 16.5 11.999 16.5C9.52901 16.5 7.47901 14.7 7.06901 12.35C6.98901 11.86 6.57901 11.5 6.08901 11.5C5.47901 11.5 4.99901 12.04 5.08901 12.64C5.57901 15.64 7.97901 17.99 10.999 18.42V20.5C10.999 21.05 11.449 21.5 11.999 21.5C12.549 21.5 12.999 21.05 12.999 20.5V18.42C16.019 17.99 18.419 15.64 18.909 12.64C19.009 12.04 18.519 11.5 17.909 11.5Z",
  "mic-off": "M10.7219 5.38999C10.7219 4.72999 11.2619 4.18999 11.9219 4.18999C12.5819 4.18999 13.1219 4.72999 13.1219 5.38999L13.1119 9.29999L14.9219 11.09V5.48999C14.9219 3.82999 13.5819 2.48999 11.9219 2.48999C10.3819 2.48999 9.13188 3.64999 8.96187 5.13999L10.7219 6.89999V5.38999ZM18.9219 11.49H17.2219C17.2219 12.07 17.1219 12.62 16.9519 13.13L18.2219 14.4C18.6619 13.52 18.9219 12.53 18.9219 11.49ZM4.33187 3.34999L2.92188 4.75999L8.92188 10.76V11.49C8.92188 13.15 10.2619 14.49 11.9219 14.49C12.1519 14.49 12.3619 14.46 12.5719 14.41L14.2319 16.07C13.5219 16.4 12.7319 16.59 11.9219 16.59C9.16187 16.59 6.62187 14.49 6.62187 11.49H4.92188C4.92188 14.9 7.64188 17.72 10.9219 18.21V21.49H12.9219V18.21C13.8319 18.08 14.6919 17.76 15.4719 17.31L19.6719 21.51L21.0819 20.1L4.33187 3.34999Z",
  "mic-off-fill": "M16.5203 13.9018C16.3446 13.8069 16.2282 13.6557 16.171 13.448C16.114 13.2403 16.133 13.0487 16.2278 12.873C16.3253 12.7025 16.4003 12.5211 16.4528 12.3287C16.5055 12.1364 16.5452 11.9416 16.572 11.7443C16.6195 11.5314 16.715 11.3542 16.8585 11.2125C17.0022 11.0708 17.1805 11 17.3933 11C17.6061 11 17.7817 11.0776 17.92 11.2327C18.0585 11.3877 18.1175 11.5717 18.097 11.7845C18.0599 12.0973 17.998 12.4067 17.9115 12.7125C17.825 13.0182 17.7042 13.3088 17.549 13.5845C17.4542 13.7667 17.3045 13.8888 17.1 13.951C16.8955 14.0132 16.7023 13.9968 16.5203 13.9018ZM12.8278 9.7385L9.67029 6.5615C9.50612 6.39733 9.37729 6.20408 9.28379 5.98175C9.19012 5.75925 9.14329 5.5275 9.14329 5.2865V5C9.14329 4.30133 9.38529 3.71 9.86929 3.226C10.3533 2.742 10.9446 2.5 11.6433 2.5C12.342 2.5 12.9333 2.742 13.4173 3.226C13.9013 3.71 14.1433 4.30133 14.1433 5V9.1865C14.1433 9.534 13.9855 9.77442 13.67 9.90775C13.3547 10.0411 13.074 9.98467 12.8278 9.7385ZM10.8933 20V17.4578C9.40479 17.2832 8.12912 16.6704 7.06629 15.6193C6.00346 14.5679 5.38104 13.2865 5.19904 11.775C5.17221 11.5622 5.22796 11.3798 5.36629 11.228C5.50479 11.076 5.68046 11 5.89329 11C6.10612 11 6.28429 11.0734 6.42779 11.2203C6.57146 11.3669 6.66696 11.5467 6.71429 11.7595C6.89646 12.984 7.45646 13.9968 8.39429 14.798C9.33212 15.5993 10.4151 16 11.6433 16C12.2868 16 12.8916 15.8852 13.4578 15.6557C14.0238 15.4262 14.5247 15.1083 14.9605 14.702L16.0298 15.771C15.5465 16.225 14.9965 16.5988 14.3798 16.8923C13.7631 17.1859 13.101 17.3744 12.3933 17.4578V20C12.3933 20.2128 12.3215 20.391 12.1778 20.5345C12.0343 20.6782 11.8561 20.75 11.6433 20.75C11.4305 20.75 11.2522 20.6782 11.1085 20.5345C10.965 20.391 10.8933 20.2128 10.8933 20ZM19.3395 21.1885L2.20479 4.05375C2.06629 3.91525 1.99546 3.74125 1.99229 3.53175C1.98912 3.32208 2.05996 3.14483 2.20479 3C2.34962 2.85517 2.52529 2.78275 2.73179 2.78275C2.93812 2.78275 3.11371 2.85517 3.25854 3L20.3933 20.1345C20.5318 20.273 20.6026 20.4471 20.6058 20.6568C20.609 20.8663 20.5381 21.0435 20.3933 21.1885C20.2485 21.3333 20.0728 21.4058 19.8663 21.4058C19.66 21.4058 19.4844 21.3333 19.3395 21.1885Z",
  "mood-fill": "M15.406 10.8077C15.77 10.8077 16.0786 10.6803 16.3318 10.4255C16.5849 10.1708 16.7115 9.86158 16.7115 9.49775C16.7115 9.13392 16.5842 8.82542 16.3295 8.57225C16.0748 8.31892 15.7655 8.19225 15.4015 8.19225C15.0377 8.19225 14.7292 8.31967 14.476 8.5745C14.2228 8.82917 14.0962 9.13842 14.0962 9.50225C14.0962 9.86608 14.2236 10.1746 14.4783 10.4277C14.7329 10.6811 15.0422 10.8077 15.406 10.8077ZM8.5985 10.8077C8.96233 10.8077 9.27083 10.6803 9.524 10.4255C9.77717 10.1708 9.90375 9.86158 9.90375 9.49775C9.90375 9.13392 9.77642 8.82542 9.52175 8.57225C9.26708 8.31892 8.95783 8.19225 8.594 8.19225C8.23 8.19225 7.92142 8.31967 7.66825 8.5745C7.41508 8.82917 7.2885 9.13842 7.2885 9.50225C7.2885 9.86608 7.41583 10.1746 7.6705 10.4277C7.92517 10.6811 8.2345 10.8077 8.5985 10.8077ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 17.1923C12.8975 17.1923 13.7254 16.9798 14.4837 16.5548C15.2421 16.1298 15.8578 15.5532 16.331 14.825C16.4257 14.643 16.4227 14.46 16.322 14.276C16.2215 14.092 16.0642 14 15.85 14H8.15C7.93583 14 7.7785 14.092 7.678 14.276C7.57733 14.46 7.57433 14.643 7.669 14.825C8.14217 15.5532 8.76183 16.1298 9.528 16.5548C10.294 16.9798 11.118 17.1923 12 17.1923Z",
  more: "M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z",
  "noise-reduction": [
    "M15.6204 16.45C15.9804 15.8 15.4704 15 14.7204 15C14.3804 15 14.0404 15.16 13.8804 15.47C13.7204 15.78 13.3804 16 13.0004 16C12.5704 16 12.1904 15.73 12.0504 15.32C11.9004 14.88 11.6504 14.24 11.1204 13.71L9.76039 12.35C9.28039 11.87 9.00039 11.19 9.00039 10.5C9.00039 9.12 10.1204 8 11.5004 8C12.4804 8 13.3404 8.57 13.7404 9.4C13.9204 9.76 14.2604 10 14.6504 10C15.4004 10 15.8704 9.21 15.5404 8.54C14.8204 7.04 13.2804 6 11.5004 6C8.61038 6 6.35038 8.74 7.17038 11.76C7.39038 12.56 7.85038 13.27 8.44038 13.86L9.71039 15.13C9.86039 15.29 9.99039 15.51 10.1104 15.84C10.5204 16.97 11.4904 17.88 12.6904 18C13.9504 18.11 15.0704 17.46 15.6204 16.45Z",
    "M13.5004 14C14.3288 14 15.0004 13.3284 15.0004 12.5C15.0004 11.6716 14.3288 11 13.5004 11C12.672 11 12.0004 11.6716 12.0004 12.5C12.0004 13.3284 12.672 14 13.5004 14Z",
    "M12.0004 4C12.5527 4 13.0004 3.55228 13.0004 3C13.0004 2.44772 12.5527 2 12.0004 2C11.4481 2 11.0004 2.44772 11.0004 3C11.0004 3.55228 11.4481 4 12.0004 4Z",
    "M12.0004 22C12.5527 22 13.0004 21.5523 13.0004 21C13.0004 20.4477 12.5527 20 12.0004 20C11.4481 20 11.0004 20.4477 11.0004 21C11.0004 21.5523 11.4481 22 12.0004 22Z",
    "M5.75038 7.01C6.09038 6.58 6.02039 5.95 5.59038 5.6C5.16038 5.26 4.53038 5.33 4.18038 5.77C3.84038 6.2 3.91038 6.83 4.34038 7.17C4.77039 7.51 5.40038 7.44 5.75038 7.01Z",
    "M18.2504 16.99C17.9104 17.42 17.9804 18.05 18.4104 18.4C18.8404 18.75 19.4704 18.67 19.8204 18.24C20.1604 17.81 20.0904 17.18 19.6604 16.83C19.2304 16.49 18.6004 16.56 18.2504 16.99Z",
    "M4.20038 13.78C4.08038 13.24 3.54038 12.9 3.00038 13.03C2.46038 13.16 2.12038 13.69 2.25038 14.23C2.37038 14.77 2.91038 15.11 3.45038 14.98C3.99038 14.86 4.32038 14.32 4.20038 13.78Z",
    "M19.8004 10.22C19.9204 10.76 20.4604 11.1 21.0004 10.97C21.5404 10.84 21.8804 10.31 21.7504 9.77C21.6204 9.23 21.0904 8.89 20.5504 9.02C20.0104 9.14 19.6804 9.68 19.8004 10.22Z",
    "M8.53038 19.21C8.03038 18.97 7.43038 19.18 7.20038 19.68C6.96038 20.18 7.17038 20.78 7.67038 21.01C8.17038 21.25 8.77038 21.04 9.00038 20.54C9.24038 20.05 9.03038 19.45 8.53038 19.21Z",
    "M15.4704 4.79C15.9704 5.03 16.5704 4.82 16.8004 4.32C17.0404 3.82 16.8304 3.22 16.3304 2.99C15.8304 2.75 15.2304 2.96 15.0004 3.46C14.7604 3.95 14.9704 4.55 15.4704 4.79Z",
    "M15.4704 19.21C14.9704 19.45 14.7604 20.05 15.0004 20.54C15.2404 21.03 15.8404 21.25 16.3304 21.01C16.8304 20.77 17.0404 20.17 16.8004 19.68C16.5704 19.18 15.9704 18.97 15.4704 19.21Z",
    "M8.53038 4.79C9.03038 4.55 9.23038 3.96 9.00038 3.46C8.76039 2.96 8.16039 2.75 7.67038 2.99C7.18038 3.23 6.95039 3.83 7.19038 4.33C7.43038 4.83 8.03038 5.03 8.53038 4.79Z",
    "M21.0004 13.03C20.4604 12.91 19.9304 13.24 19.8004 13.78C19.6804 14.32 20.0104 14.85 20.5504 14.98C21.0904 15.1 21.6204 14.77 21.7504 14.23C21.8704 13.69 21.5404 13.15 21.0004 13.03Z",
    "M3.00038 10.97C3.54038 11.09 4.07038 10.76 4.20038 10.22C4.32038 9.68 3.99038 9.15 3.45038 9.02C2.91038 8.89 2.38038 9.23 2.25038 9.77C2.13038 10.31 2.46038 10.85 3.00038 10.97Z",
    "M19.6604 7.17C20.0904 6.83 20.1604 6.2 19.8204 5.76C19.4804 5.32 18.8504 5.26 18.4104 5.6C17.9804 5.94 17.9104 6.57 18.2504 7.01C18.6004 7.44 19.2304 7.51 19.6604 7.17Z",
    "M4.34038 16.83C3.91038 17.17 3.84038 17.8 4.18038 18.24C4.52038 18.67 5.15038 18.74 5.59038 18.4C6.02039 18.06 6.09038 17.43 5.75038 16.99C5.41038 16.55 4.77039 16.49 4.34038 16.83Z"
  ],
  participants: "M1.79688 17.0837C1.79688 16.5683 1.92987 16.1084 2.19588 15.7039C2.46188 15.2994 2.81713 14.9847 3.26163 14.7599C4.21196 14.2951 5.16754 13.9367 6.12838 13.6847C7.08938 13.4328 8.14546 13.3069 9.29663 13.3069C10.448 13.3069 11.504 13.4328 12.4649 13.6847C13.4259 13.9367 14.3815 14.2951 15.3319 14.7599C15.7764 14.9847 16.1316 15.2994 16.3976 15.7039C16.6636 16.1084 16.7966 16.5683 16.7966 17.0837V17.7877C16.7966 18.1902 16.6489 18.544 16.3534 18.8492C16.0579 19.1543 15.6992 19.3069 15.2774 19.3069H3.31588C2.89421 19.3069 2.53563 19.1592 2.24013 18.8637C1.94463 18.568 1.79688 18.2093 1.79688 17.7877V17.0837ZM18.4101 19.3069C18.5358 19.0774 18.6316 18.8332 18.6976 18.5742C18.7636 18.3152 18.7966 18.053 18.7966 17.7877V16.9607C18.7966 16.3043 18.636 15.6787 18.3146 15.0839C17.9931 14.4892 17.5371 13.979 16.9466 13.5532C17.6171 13.6532 18.2537 13.8079 18.8564 14.0174C19.4589 14.2271 20.0339 14.4748 20.5814 14.7607C21.098 15.0363 21.497 15.3612 21.7784 15.7354C22.0597 16.1094 22.2004 16.5178 22.2004 16.9607V17.7877C22.2004 18.2093 22.0526 18.568 21.7571 18.8637C21.4616 19.1592 21.103 19.3069 20.6814 19.3069H18.4101ZM9.29663 11.6914C8.33413 11.6914 7.51021 11.3487 6.82488 10.6634C6.13954 9.97791 5.79688 9.15391 5.79688 8.19141C5.79688 7.22891 6.13954 6.40499 6.82488 5.71966C7.51021 5.03416 8.33413 4.69141 9.29663 4.69141C10.2591 4.69141 11.0831 5.03416 11.7686 5.71966C12.454 6.40499 12.7966 7.22891 12.7966 8.19141C12.7966 9.15391 12.454 9.97791 11.7686 10.6634C11.0831 11.3487 10.2591 11.6914 9.29663 11.6914ZM17.9311 8.19141C17.9311 9.15391 17.5885 9.97791 16.9031 10.6634C16.2178 11.3487 15.3939 11.6914 14.4314 11.6914C14.3185 11.6914 14.175 11.6786 14.0006 11.6529C13.8261 11.6272 13.6825 11.5991 13.5699 11.5684C13.9642 11.0942 14.2673 10.5682 14.4791 9.99041C14.6908 9.41257 14.7966 8.81257 14.7966 8.19041C14.7966 7.56807 14.6886 6.97032 14.4726 6.39716C14.2566 5.82416 13.9557 5.29666 13.5699 4.81466C13.7134 4.76332 13.857 4.72999 14.0006 4.71466C14.1441 4.69916 14.2877 4.69141 14.4314 4.69141C15.3939 4.69141 16.2178 5.03416 16.9031 5.71966C17.5885 6.40499 17.9311 7.22891 17.9311 8.19141Z",
  pin: "M15.4994 5.6V12.8115L17.0647 14.377C17.139 14.4513 17.1949 14.535 17.2322 14.628C17.2694 14.7208 17.2879 14.8168 17.2879 14.916V15.3435C17.2879 15.5542 17.2151 15.7329 17.0694 15.8797C16.9239 16.0266 16.7435 16.1 16.5282 16.1H12.7494V21.4885C12.7494 21.701 12.6775 21.8791 12.5337 22.0227C12.3899 22.1664 12.2117 22.2382 11.9992 22.2382C11.7865 22.2382 11.6084 22.1664 11.4649 22.0227C11.3213 21.8791 11.2494 21.701 11.2494 21.4885V16.1H7.47069C7.25535 16.1 7.07494 16.0266 6.92944 15.8797C6.78377 15.7329 6.71094 15.5542 6.71094 15.3435V14.916C6.71094 14.8168 6.72952 14.7208 6.76669 14.628C6.80402 14.535 6.85985 14.4513 6.93419 14.377L8.49944 12.8115V5.6H8.24944C8.03694 5.6 7.85885 5.52808 7.71519 5.38425C7.57135 5.24041 7.49944 5.06225 7.49944 4.84975C7.49944 4.63708 7.57135 4.459 7.71519 4.3155C7.85885 4.17183 8.03694 4.1 8.24944 4.1H15.7494C15.9619 4.1 16.14 4.17192 16.2837 4.31575C16.4275 4.45958 16.4994 4.63775 16.4994 4.85025C16.4994 5.06292 16.4275 5.241 16.2837 5.3845C16.14 5.52817 15.9619 5.6 15.7494 5.6H15.4994Z",
  "raise-hand": "M18.37 23.9949H11.82C10.74 23.9949 9.68 23.5449 8.93 22.7649L1.63 15.1549L3.7 13.3249C4.32 12.7749 5.23 12.6649 5.96 13.0549L8.37 14.3349V4.78488C8.37 3.40488 9.49 2.28488 10.87 2.28488C11.04 2.28488 11.21 2.30488 11.38 2.33488C11.47 1.03488 12.55 0.00488281 13.87 0.00488281C14.73 0.00488281 15.48 0.434883 15.93 1.09488C16.22 0.974883 16.54 0.914883 16.87 0.914883C18.25 0.914883 19.37 2.03488 19.37 3.41488V3.69488C19.53 3.66488 19.7 3.64488 19.87 3.64488C21.25 3.64488 22.37 4.76488 22.37 6.14488V19.9949C22.37 22.2049 20.58 23.9949 18.37 23.9949ZM4.51 15.2749L10.37 21.3749C10.75 21.7649 11.27 21.9949 11.81 21.9949H18.37C19.47 21.9949 20.37 21.0949 20.37 19.9949V6.14488C20.37 5.86488 20.15 5.64488 19.87 5.64488C19.59 5.64488 19.37 5.86488 19.37 6.14488V11.9949H17.37V3.41488C17.37 3.13488 17.15 2.91488 16.87 2.91488C16.59 2.91488 16.37 3.13488 16.37 3.41488V11.9949H14.37V2.50488C14.37 2.22488 14.15 2.00488 13.87 2.00488C13.59 2.00488 13.37 2.22488 13.37 2.50488V11.9949H11.37V4.78488C11.37 4.50488 11.15 4.28488 10.87 4.28488C10.59 4.28488 10.37 4.51488 10.37 4.78488V17.6549L5.02 14.8249L4.51 15.2749Z",
  "raise-hand-fill": "M21.1818 4C20.3518 4 19.6818 4.67 19.6818 5.5V10.5C19.6818 10.78 19.4618 11 19.1818 11C18.9018 11 18.6818 10.78 18.6818 10.5V2.5C18.6818 1.67 18.0118 1 17.1818 1C16.3518 1 15.6818 1.67 15.6818 2.5V10.5C15.6818 10.78 15.4618 11 15.1818 11C14.9018 11 14.6818 10.78 14.6818 10.5V1.5C14.6818 0.67 14.0118 0 13.1818 0C12.3518 0 11.6818 0.67 11.6818 1.5V10.49C11.6818 10.77 11.4618 10.99 11.1818 10.99C10.9018 10.99 10.6818 10.77 10.6818 10.49V4.5C10.6818 3.67 10.0118 3 9.18176 3C8.35176 3 7.68176 3.67 7.68176 4.5V15.91L3.56176 13.56C2.98176 13.23 2.26176 13.32 1.78176 13.78C1.18176 14.36 1.16176 15.32 1.75176 15.91L8.53176 22.8C9.28176 23.57 10.3018 24 11.3818 24H18.6818C20.8918 24 22.6818 22.21 22.6818 20V5.5C22.6818 4.67 22.0118 4 21.1818 4Z",
  "record-fill": "M12 16.5C13.2487 16.5 14.3108 16.0622 15.1865 15.1865C16.0622 14.3108 16.5 13.2487 16.5 12C16.5 10.7513 16.0622 9.68917 15.1865 8.8135C14.3108 7.93783 13.2487 7.5 12 7.5C10.7513 7.5 9.68917 7.93783 8.8135 8.8135C7.93783 9.68917 7.5 10.7513 7.5 12C7.5 13.2487 7.93783 14.3108 8.8135 15.1865C9.68917 16.0622 10.7513 16.5 12 16.5ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
  "record-stop-fill": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15 16H9C8.45 16 8 15.55 8 15V9C8 8.45 8.45 8 9 8H15C15.55 8 16 8.45 16 9V15C16 15.55 15.55 16 15 16Z",
  recording: [
    "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
    "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
  ],
  remove: "M12.0022 21.8335C10.6404 21.8335 9.36222 21.5752 8.16772 21.0587C6.97322 20.5421 5.9323 19.8407 5.04497 18.9545C4.15747 18.0683 3.45605 17.0284 2.94072 15.8347C2.42555 14.6409 2.16797 13.3631 2.16797 12.0012C2.16797 10.6394 2.42622 9.36124 2.94272 8.16674C3.45939 6.97224 4.1608 5.93133 5.04697 5.04399C5.93314 4.15649 6.97305 3.45508 8.16672 2.93974C9.36055 2.42458 10.6384 2.16699 12.0002 2.16699C13.3621 2.16699 14.6402 2.42524 15.8347 2.94174C17.0292 3.45841 18.0701 4.15983 18.9575 5.04599C19.845 5.93216 20.5464 6.97208 21.0617 8.16574C21.5769 9.35958 21.8345 10.6374 21.8345 11.9992C21.8345 13.3611 21.5762 14.6392 21.0597 15.8337C20.5431 17.0282 19.8416 18.0692 18.9555 18.9565C18.0693 19.844 17.0294 20.5454 15.8357 21.0607C14.6419 21.5759 13.3641 21.8335 12.0022 21.8335ZM12.0012 20.2502C12.9807 20.2502 13.9197 20.0877 14.8182 19.7627C15.7169 19.4377 16.5335 18.9669 17.268 18.3502L5.65472 6.73349C5.04689 7.47799 4.57764 8.29791 4.24697 9.19324C3.91647 10.0886 3.75122 11.0242 3.75122 12.0002C3.75122 14.3016 4.55089 16.2519 6.15022 17.8512C7.74955 19.4506 9.69989 20.2502 12.0012 20.2502ZM18.3312 17.267C18.9279 16.5337 19.3971 15.7175 19.7387 14.8185C20.0804 13.9195 20.2512 12.9801 20.2512 12.0002C20.2512 9.69891 19.4516 7.74858 17.8522 6.14924C16.2529 4.54991 14.3026 3.75024 12.0012 3.75024C11.0257 3.75024 10.0905 3.91549 9.19547 4.24599C8.30047 4.57666 7.48014 5.05033 6.73447 5.66699L18.3312 17.267Z",
  "screen-share": "M11.1348 10.8075H13.1348V11.919C13.1348 12.0228 13.1799 12.094 13.2703 12.1325C13.3606 12.1708 13.4443 12.1516 13.5213 12.0747L15.2173 10.3785C15.3109 10.285 15.3578 10.178 15.3578 10.0575C15.3578 9.93697 15.3109 9.82989 15.2173 9.73622L13.5213 8.04022C13.4443 7.96322 13.3606 7.94397 13.2703 7.98247C13.1799 8.02097 13.1348 8.09214 13.1348 8.19597V9.30747H11.1348C10.3719 9.30747 9.72285 9.57505 9.18752 10.1102C8.65235 10.6456 8.38477 11.2946 8.38477 12.0575V13.3075C8.38477 13.5203 8.45652 13.6985 8.60002 13.842C8.74368 13.9856 8.92193 14.0575 9.13477 14.0575C9.34743 14.0575 9.5256 13.9856 9.66927 13.842C9.81277 13.6985 9.88452 13.5203 9.88452 13.3075V12.0575C9.88452 11.71 10.006 11.4147 10.249 11.1717C10.492 10.9289 10.7873 10.8075 11.1348 10.8075ZM2.13477 20.2305C1.92193 20.2305 1.74368 20.1586 1.60002 20.015C1.45652 19.8715 1.38477 19.6933 1.38477 19.4805C1.38477 19.2676 1.45652 19.0895 1.60002 18.946C1.74368 18.8023 1.92193 18.7305 2.13477 18.7305H21.8653C22.0781 18.7305 22.2563 18.8023 22.4 18.946C22.5435 19.0895 22.6153 19.2676 22.6153 19.4805C22.6153 19.6933 22.5435 19.8715 22.4 20.015C22.2563 20.1586 22.0781 20.2305 21.8653 20.2305H2.13477ZM4.30777 17.7305C3.8026 17.7305 3.37502 17.5555 3.02502 17.2055C2.67502 16.8555 2.50002 16.4279 2.50002 15.9227V5.53822C2.50002 5.03305 2.67502 4.60547 3.02502 4.25547C3.37502 3.90547 3.8026 3.73047 4.30777 3.73047H19.6923C20.1974 3.73047 20.625 3.90547 20.975 4.25547C21.325 4.60547 21.5 5.03305 21.5 5.53822V15.9227C21.5 16.4279 21.325 16.8555 20.975 17.2055C20.625 17.5555 20.1974 17.7305 19.6923 17.7305H4.30777Z",
  "screen-share-stop": "M23 17.8602H21.8L23.59 19.6502C23.83 19.4702 24 19.1902 24 18.8602C24 18.3102 23.55 17.8602 23 17.8602ZM3.23 2.14016C2.84 1.75016 2.2 1.75016 1.81 2.14016C1.42 2.53016 1.42 3.16016 1.81 3.55016L2.65 4.41016C2.65 4.41016 1.99 4.98016 1.99 5.88016C2 6.78016 2 15.8602 2 15.8602L2.01 15.8702C2.01 16.9602 2.89 17.8502 3.98 17.8602H1C0.45 17.8602 0 18.3102 0 18.8602C0 19.4102 0.45 19.8602 1 19.8602H18.13L20.13 21.8602C20.52 22.2502 21.15 22.2502 21.54 21.8602C21.93 21.4702 21.93 20.8402 21.54 20.4502L3.23 2.14016ZM7 14.8602C7.31 13.3802 7.94 11.9302 9.08 10.8102L10.67 12.4002C9.13 12.7802 7.96 13.5702 7 14.8602ZM13 8.99016V8.01016C13 7.57016 13.52 7.35016 13.84 7.64016L15 8.73016L16.61 10.2302C16.82 10.4302 16.82 10.7602 16.61 10.9602L15.72 11.7902L21.3 17.3702C21.73 17.0002 22 16.4702 22 15.8602V5.86016C22 4.77016 21.11 3.88016 20.02 3.88016H7.8L12.94 9.01016C12.96 9.00016 12.98 8.99016 13 8.99016Z",
  search: "M9.50244 15.7502C7.7266 15.7502 6.22369 15.1352 4.99369 13.9052C3.76352 12.675 3.14844 11.1847 3.14844 9.43419C3.14844 7.68369 3.76194 6.19319 4.98894 4.96269C6.21594 3.73219 7.70902 3.11694 9.46819 3.11694C11.2274 3.11694 12.7194 3.73228 13.9444 4.96294C15.1694 6.19361 15.7819 7.68553 15.7819 9.43869C15.7819 10.1464 15.6666 10.8287 15.4359 11.4857C15.2054 12.1425 14.8721 12.7474 14.4359 13.3002L20.3014 19.1204C20.4551 19.2743 20.5319 19.4635 20.5319 19.6882C20.5319 19.9129 20.4528 20.1058 20.2944 20.2669C20.1361 20.4279 19.9432 20.5084 19.7157 20.5084C19.4882 20.5084 19.3002 20.429 19.1517 20.2702L13.3067 14.4209C12.8124 14.8488 12.2363 15.1773 11.5784 15.4064C10.9204 15.6356 10.2284 15.7502 9.50244 15.7502ZM9.48194 14.1669C10.7929 14.1669 11.9068 13.7062 12.8234 12.7847C13.7401 11.8632 14.1984 10.7458 14.1984 9.43244C14.1984 8.11928 13.7401 7.00228 12.8234 6.08144C11.9068 5.16061 10.7915 4.70019 9.47769 4.70019C8.15452 4.70019 7.03277 5.16094 6.11244 6.08244C5.1921 7.00394 4.73194 8.12128 4.73194 9.43444C4.73194 10.7478 5.19235 11.8649 6.11319 12.7857C7.03402 13.7065 8.15694 14.1669 9.48194 14.1669Z",
  settings: "M19.5006 12C19.5006 11.77 19.4906 11.55 19.4706 11.32L21.3306 9.91C21.7306 9.61 21.8406 9.05 21.5906 8.61L19.7206 5.38C19.4706 4.94 18.9306 4.76 18.4706 4.96L16.3206 5.87C15.9506 5.61 15.5606 5.38 15.1506 5.19L14.8606 2.88C14.8006 2.38 14.3706 2 13.8706 2H10.1406C9.63064 2 9.20064 2.38 9.14064 2.88L8.85064 5.19C8.44064 5.38 8.05064 5.61 7.68064 5.87L5.53064 4.96C5.07064 4.76 4.53064 4.94 4.28064 5.38L2.41064 8.62C2.16064 9.06 2.27064 9.61 2.67064 9.92L4.53064 11.33C4.51064 11.55 4.50064 11.77 4.50064 12C4.50064 12.23 4.51064 12.45 4.53064 12.68L2.67064 14.09C2.27064 14.39 2.16064 14.95 2.41064 15.39L4.28064 18.62C4.53064 19.06 5.07064 19.24 5.53064 19.04L7.68064 18.13C8.05064 18.39 8.44064 18.62 8.85064 18.81L9.14064 21.12C9.20064 21.62 9.63064 22 10.1306 22H13.8606C14.3606 22 14.7906 21.62 14.8506 21.12L15.1406 18.81C15.5506 18.62 15.9406 18.39 16.3106 18.13L18.4606 19.04C18.9206 19.24 19.4606 19.06 19.7106 18.62L21.5806 15.39C21.8306 14.95 21.7206 14.4 21.3206 14.09L19.4606 12.68C19.4906 12.45 19.5006 12.23 19.5006 12ZM12.0406 15.5C10.1106 15.5 8.54064 13.93 8.54064 12C8.54064 10.07 10.1106 8.5 12.0406 8.5C13.9706 8.5 15.5406 10.07 15.5406 12C15.5406 13.93 13.9706 15.5 12.0406 15.5Z",
  sidebar: "M15 20H3C2.45 20 2 19.55 2 19V5C2 4.45 2.45 4 3 4H15C15.55 4 16 4.45 16 5V19C16 19.55 15.55 20 15 20ZM19 8H21C21.55 8 22 7.55 22 7V5C22 4.45 21.55 4 21 4H19C18.45 4 18 4.45 18 5V7C18 7.55 18.45 8 19 8ZM19 20H21C21.55 20 22 19.55 22 19V17C22 16.45 21.55 16 21 16H19C18.45 16 18 16.45 18 17V19C18 19.55 18.45 20 19 20ZM19 14H21C21.55 14 22 13.55 22 13V11C22 10.45 21.55 10 21 10H19C18.45 10 18 10.45 18 11V13C18 13.55 18.45 14 19 14Z",
  signal: "M18 4C18.83 4 19.5 4.67 19.5 5.5V18.5C19.5 19.33 18.83 20 18 20C17.17 20 16.5 19.33 16.5 18.5V5.5C16.5 4.67 17.17 4 18 4ZM6 14C6.83 14 7.5 14.67 7.5 15.5V18.5C7.5 19.33 6.83 20 6 20C5.17 20 4.5 19.33 4.5 18.5V15.5C4.5 14.67 5.17 14 6 14ZM12 9C12.83 9 13.5 9.67 13.5 10.5V18.5C13.5 19.33 12.83 20 12 20C11.17 20 10.5 19.33 10.5 18.5V10.5C10.5 9.67 11.17 9 12 9Z",
  "speaker-fill": "M3 10.002V14.002C3 14.552 3.45 15.002 4 15.002H7L10.29 18.292C10.92 18.922 12 18.472 12 17.582V6.41204C12 5.52204 10.92 5.07204 10.29 5.70204L7 9.00204H4C3.45 9.00204 3 9.45204 3 10.002ZM16.5 12.002C16.5 10.232 15.48 8.71204 14 7.97204V16.022C15.48 15.292 16.5 13.772 16.5 12.002ZM14 4.45204V4.65204C14 5.03204 14.25 5.36204 14.6 5.50204C17.18 6.53204 19 9.06204 19 12.002C19 14.942 17.18 17.472 14.6 18.502C14.24 18.642 14 18.972 14 19.352V19.552C14 20.182 14.63 20.622 15.21 20.402C18.6 19.112 21 15.842 21 12.002C21 8.16204 18.6 4.89204 15.21 3.60204C14.63 3.37204 14 3.82204 14 4.45204Z",
  spotlight: "M2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6Z",
  stats: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 17C7.45 17 7 16.55 7 16V11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11V16C9 16.55 8.55 17 8 17ZM12 17C11.45 17 11 16.55 11 16V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V16C13 16.55 12.55 17 12 17ZM16 17C15.45 17 15 16.55 15 16V14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14V16C17 16.55 16.55 17 16 17Z",
  "switch-camera": "M4.30775 20.5C3.80258 20.5 3.375 20.325 3.025 19.975C2.675 19.625 2.5 19.1974 2.5 18.6923V7.30775C2.5 6.80258 2.675 6.375 3.025 6.025C3.375 5.675 3.80258 5.5 4.30775 5.5H7.3615L8.66925 4.08275C8.83342 3.90192 9.03183 3.75958 9.2645 3.65575C9.49717 3.55192 9.74233 3.5 10 3.5H14C14.2577 3.5 14.5028 3.55192 14.7355 3.65575C14.9682 3.75958 15.1666 3.90192 15.3307 4.08275L16.6385 5.5H19.6923C20.1974 5.5 20.625 5.675 20.975 6.025C21.325 6.375 21.5 6.80258 21.5 7.30775V18.6923C21.5 19.1974 21.325 19.625 20.975 19.975C20.625 20.325 20.1974 20.5 19.6923 20.5H4.30775ZM15.6038 13.0345C15.5166 14.0333 15.1384 14.8863 14.4693 15.5933C13.8001 16.3003 12.977 16.6538 12 16.6538C11.8603 16.6538 11.7206 16.6438 11.5808 16.624C11.4411 16.6042 11.3013 16.5776 11.1615 16.5443C11.041 16.5173 10.9153 16.5204 10.7845 16.5538C10.6538 16.5871 10.5513 16.6506 10.477 16.7443C10.3513 16.8891 10.3119 17.057 10.3588 17.248C10.4054 17.439 10.5166 17.5666 10.6923 17.6308C10.9064 17.7141 11.1228 17.7708 11.3413 17.801C11.5599 17.8312 11.7795 17.8463 12 17.8463C13.3167 17.8463 14.4292 17.3748 15.3375 16.4318C16.2458 15.4888 16.7321 14.3461 16.7962 13.0038L17.2807 13.4443C17.4051 13.5519 17.5464 13.6042 17.7048 13.601C17.8631 13.5978 17.9961 13.5423 18.1038 13.4345C18.2281 13.3102 18.2928 13.1679 18.298 13.0078C18.3032 12.8474 18.2436 12.7051 18.1193 12.5808L16.8828 11.3443C16.7123 11.1738 16.5013 11.0885 16.25 11.0885C15.9987 11.0885 15.7878 11.1738 15.6173 11.3443L14.3807 12.5808C14.2564 12.7051 14.1943 12.8448 14.1943 13C14.1943 13.1552 14.2564 13.2949 14.3807 13.4193C14.5051 13.5436 14.6448 13.6058 14.8 13.6058C14.9552 13.6058 15.0949 13.5436 15.2193 13.4193L15.6038 13.0345ZM7.20375 12.9963L6.71925 12.5558C6.59492 12.4481 6.45358 12.3958 6.29525 12.399C6.13692 12.4022 6.00392 12.4577 5.89625 12.5655C5.77192 12.6898 5.70717 12.8321 5.702 12.9923C5.69683 13.1526 5.75642 13.2949 5.88075 13.4193L7.11725 14.6558C7.28775 14.8263 7.49867 14.9115 7.75 14.9115C8.00133 14.9115 8.21225 14.8263 8.38275 14.6558L9.61925 13.4193C9.74358 13.2949 9.80575 13.1552 9.80575 13C9.80575 12.8448 9.74358 12.7051 9.61925 12.5808C9.49492 12.4564 9.35517 12.3943 9.2 12.3943C9.04483 12.3943 8.90508 12.4564 8.78075 12.5808L8.39625 12.9655C8.48342 11.9667 8.86158 11.1138 9.53075 10.4068C10.1999 9.69975 11.023 9.34625 12 9.34625C12.1397 9.34625 12.2794 9.35617 12.4192 9.376C12.5589 9.39583 12.6954 9.42242 12.8288 9.45575C12.9493 9.48908 13.0765 9.48908 13.2105 9.45575C13.3445 9.42242 13.4487 9.35575 13.523 9.25575C13.6487 9.11092 13.6897 8.943 13.6462 8.752C13.6026 8.561 13.4929 8.43342 13.3173 8.36925C13.0968 8.29875 12.8788 8.24525 12.6635 8.20875C12.4482 8.17208 12.227 8.15375 12 8.15375C10.6833 8.15375 9.57083 8.62525 8.6625 9.56825C7.75417 10.5113 7.26792 11.6539 7.20375 12.9963Z",
  "tile-fill": "M5 11C4.591 11 4.23875 10.8523 3.94325 10.5568C3.64775 10.2613 3.5 9.909 3.5 9.5V5C3.5 4.591 3.64775 4.23875 3.94325 3.94325C4.23875 3.64775 4.591 3.5 5 3.5H9.5C9.909 3.5 10.2613 3.64775 10.5568 3.94325C10.8523 4.23875 11 4.591 11 5V9.5C11 9.909 10.8523 10.2613 10.5568 10.5568C10.2613 10.8523 9.909 11 9.5 11H5ZM5 20.5C4.591 20.5 4.23875 20.3523 3.94325 20.0568C3.64775 19.7613 3.5 19.409 3.5 19V14.5C3.5 14.091 3.64775 13.7388 3.94325 13.4433C4.23875 13.1478 4.591 13 5 13H9.5C9.909 13 10.2613 13.1478 10.5568 13.4433C10.8523 13.7388 11 14.091 11 14.5V19C11 19.409 10.8523 19.7613 10.5568 20.0568C10.2613 20.3523 9.909 20.5 9.5 20.5H5ZM14.5 11C14.091 11 13.7388 10.8523 13.4433 10.5568C13.1478 10.2613 13 9.909 13 9.5V5C13 4.591 13.1478 4.23875 13.4433 3.94325C13.7388 3.64775 14.091 3.5 14.5 3.5H19C19.409 3.5 19.7613 3.64775 20.0568 3.94325C20.3523 4.23875 20.5 4.591 20.5 5V9.5C20.5 9.909 20.3523 10.2613 20.0568 10.5568C19.7613 10.8523 19.409 11 19 11H14.5ZM14.5 20.5C14.091 20.5 13.7388 20.3523 13.4433 20.0568C13.1478 19.7613 13 19.409 13 19V14.5C13 14.091 13.1478 13.7388 13.4433 13.4433C13.7388 13.1478 14.091 13 14.5 13H19C19.409 13 19.7613 13.1478 20.0568 13.4433C20.3523 13.7388 20.5 14.091 20.5 14.5V19C20.5 19.409 20.3523 19.7613 20.0568 20.0568C19.7613 20.3523 19.409 20.5 19 20.5H14.5Z",
  unpin: "M14.1851 11.3595L7.56988 4.74425C7.49172 4.66608 7.43655 4.58658 7.40438 4.50575C7.37238 4.42508 7.35638 4.33791 7.35638 4.24425C7.35638 4.05458 7.42022 3.88308 7.54788 3.72975C7.67538 3.57658 7.8513 3.5 8.07563 3.5H15.7506C15.9631 3.5 16.1412 3.57216 16.2849 3.7165C16.4287 3.86066 16.5006 4.03941 16.5006 4.25275C16.5006 4.45341 16.4135 4.59991 16.2391 4.69225C16.0648 4.78458 15.902 4.88716 15.7506 5H15.5006V10.8077C15.5006 11.1531 15.343 11.3929 15.0276 11.5272C14.7121 11.6616 14.4313 11.6057 14.1851 11.3595ZM11.2506 21V15.5H8.17963C7.81247 15.5 7.51872 15.3717 7.29838 15.1152C7.07822 14.8589 6.96813 14.5731 6.96813 14.2577C6.96813 14.1001 6.99955 13.9438 7.06238 13.789C7.12522 13.6343 7.22647 13.4867 7.36613 13.3462L8.50063 12.2115V10.6385L2.65838 4.76525C2.51988 4.62691 2.44647 4.4555 2.43813 4.251C2.4298 4.0465 2.50388 3.866 2.66038 3.7095C2.80388 3.566 2.97888 3.49425 3.18538 3.49425C3.39172 3.49425 3.5673 3.56666 3.71213 3.7115L19.8891 19.8885C20.0378 20.0372 20.1111 20.2137 20.1091 20.4182C20.1073 20.6227 20.0288 20.8032 19.8736 20.9597C19.7185 21.1032 19.5428 21.1775 19.3466 21.1825C19.1506 21.1877 18.975 21.1127 18.8199 20.9575L13.3621 15.5H12.7506V21C12.7506 21.2125 12.6787 21.3906 12.5349 21.5342C12.391 21.6781 12.2129 21.75 12.0004 21.75C11.7877 21.75 11.6096 21.6781 11.4661 21.5342C11.3225 21.3906 11.2506 21.2125 11.2506 21Z",
  video: "M15 8V16H5V8H15ZM16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5V7C17 6.45 16.55 6 16 6Z",
  "video-fill": "M17.332 10.5V7C17.332 6.45 16.882 6 16.332 6H4.33203C3.78203 6 3.33203 6.45 3.33203 7V17C3.33203 17.55 3.78203 18 4.33203 18H16.332C16.882 18 17.332 17.55 17.332 17V13.5L19.622 15.79C20.252 16.42 21.332 15.97 21.332 15.08V8.91C21.332 8.02 20.252 7.57 19.622 8.2L17.332 10.5Z",
  "video-off": "M9.98969 8.57005L7.98969 6.57005L3.83969 2.43005L2.42969 3.84005L5.15969 6.57005H4.42969C3.87969 6.57005 3.42969 7.02005 3.42969 7.57005V17.5701C3.42969 18.1201 3.87969 18.5701 4.42969 18.5701H16.4297C16.6397 18.5701 16.8197 18.4901 16.9797 18.3901L20.1597 21.5701L21.5697 20.1601L12.7097 11.3001L9.98969 8.57005ZM5.42969 16.5701V8.57005H7.15969L15.1597 16.5701H5.42969ZM15.4297 8.57005V11.1801L21.4297 17.1801V7.07005L17.4297 11.0701V7.57005C17.4297 7.02005 16.9797 6.57005 16.4297 6.57005H10.8197L12.8197 8.57005H15.4297Z",
  "video-off-fill": "M17.768 10.8844L20.514 8.13811C20.6615 7.99061 20.8273 7.95378 21.0113 8.02761C21.1953 8.10128 21.2873 8.24194 21.2873 8.44961V15.5496C21.2873 15.7573 21.1953 15.8979 21.0113 15.9716C20.8273 16.0454 20.6615 16.0086 20.514 15.8611L17.6603 13.0074V13.1804C17.5578 13.4522 17.3523 13.6275 17.044 13.7064C16.7357 13.7852 16.4648 13.7079 16.2315 13.4746L8.79301 6.03611C8.64551 5.88878 8.56092 5.73144 8.53926 5.56411C8.51742 5.39678 8.54176 5.23103 8.61226 5.06686C8.68276 4.90286 8.78659 4.76728 8.92376 4.66011C9.06092 4.55311 9.23334 4.49961 9.44101 4.49961H15.9603C16.4654 4.49961 16.893 4.67461 17.243 5.02461C17.593 5.37461 17.768 5.80219 17.768 6.30736V10.8844ZM19.4448 21.6304L2.06026 4.24586C1.92192 4.10736 1.85109 3.93328 1.84776 3.72361C1.84459 3.51411 1.91542 3.33686 2.06026 3.19186C2.20526 3.04703 2.38092 2.97461 2.58726 2.97461C2.79359 2.97461 2.96926 3.04703 3.11426 3.19186L20.4988 20.5764C20.6373 20.7149 20.7081 20.8889 20.7113 21.0986C20.7144 21.3083 20.6436 21.4855 20.4988 21.6304C20.3539 21.7752 20.1783 21.8476 19.9718 21.8476C19.7654 21.8476 19.5898 21.7752 19.4448 21.6304ZM4.44101 4.51886L17.7488 17.8266C17.7168 18.2933 17.5305 18.6888 17.19 19.0131C16.8497 19.3374 16.4398 19.4996 15.9603 19.4996H4.57576C4.07059 19.4996 3.64301 19.3246 3.29301 18.9746C2.94301 18.6246 2.76801 18.197 2.76801 17.6919V6.30736C2.76801 5.82786 2.93017 5.41794 3.25451 5.07761C3.57884 4.73711 3.97434 4.55086 4.44101 4.51886Z",
  "virtual-background": "M4 5C4 4.45 4.45 4 5 4H10C10.55 4 11 3.55 11 3C11 2.45 10.55 2 10 2H4C2.9 2 2 2.9 2 4V10C2 10.55 2.45 11 3 11C3.55 11 4 10.55 4 10V5ZM9.61 13.49L6.65 17.19C6.39 17.52 6.62 18 7.04 18H17C17.41 18 17.65 17.53 17.4 17.2L15.4 14.53C15.2 14.26 14.8 14.26 14.6 14.53L12.97 16.71L10.39 13.49C10.19 13.24 9.81 13.24 9.61 13.49ZM17 8.5C17 7.67 16.33 7 15.5 7C14.67 7 14 7.67 14 8.5C14 9.33 14.67 10 15.5 10C16.33 10 17 9.33 17 8.5ZM20 2H14C13.45 2 13 2.45 13 3C13 3.55 13.45 4 14 4H19C19.55 4 20 4.45 20 5V10C20 10.55 20.45 11 21 11C21.55 11 22 10.55 22 10V4C22 2.9 21.1 2 20 2ZM20 19C20 19.55 19.55 20 19 20H14C13.45 20 13 20.45 13 21C13 21.55 13.45 22 14 22H20C21.1 22 22 21.1 22 20V14C22 13.45 21.55 13 21 13C20.45 13 20 13.45 20 14V19ZM3 13C2.45 13 2 13.45 2 14V20C2 21.1 2.9 22 4 22H10C10.55 22 11 21.55 11 21C11 20.45 10.55 20 10 20H5C4.45 20 4 19.55 4 19V14C4 13.45 3.55 13 3 13Z",
  wave: "M7.375 16.8077V7.19225C7.375 6.97975 7.44692 6.80167 7.59075 6.658C7.73458 6.51417 7.91275 6.44225 8.12525 6.44225C8.33792 6.44225 8.516 6.51417 8.6595 6.658C8.80317 6.80167 8.875 6.97975 8.875 7.19225V16.8077C8.875 17.0203 8.80308 17.1983 8.65925 17.342C8.51542 17.4858 8.33725 17.5577 8.12475 17.5577C7.91208 17.5577 7.734 17.4858 7.5905 17.342C7.44683 17.1983 7.375 17.0203 7.375 16.8077ZM11.25 20.75V3.25C11.25 3.0375 11.3219 2.85942 11.4658 2.71575C11.6096 2.57192 11.7878 2.5 12.0003 2.5C12.2129 2.5 12.391 2.57192 12.5345 2.71575C12.6782 2.85942 12.75 3.0375 12.75 3.25V20.75C12.75 20.9625 12.6781 21.1406 12.5343 21.2843C12.3904 21.4281 12.2122 21.5 11.9998 21.5C11.7871 21.5 11.609 21.4281 11.4655 21.2843C11.3218 21.1406 11.25 20.9625 11.25 20.75ZM3.5 12.9038V11.0962C3.5 10.8837 3.57192 10.7056 3.71575 10.5617C3.85958 10.4181 4.03775 10.3462 4.25025 10.3462C4.46292 10.3462 4.641 10.4181 4.7845 10.5617C4.92817 10.7056 5 10.8837 5 11.0962V12.9038C5 13.1163 4.92808 13.2944 4.78425 13.4383C4.64042 13.5819 4.46225 13.6538 4.24975 13.6538C4.03708 13.6538 3.859 13.5819 3.7155 13.4383C3.57183 13.2944 3.5 13.1163 3.5 12.9038ZM15.125 16.8077V7.19225C15.125 6.97975 15.1969 6.80167 15.3408 6.658C15.4846 6.51417 15.6628 6.44225 15.8753 6.44225C16.0879 6.44225 16.266 6.51417 16.4095 6.658C16.5532 6.80167 16.625 6.97975 16.625 7.19225V16.8077C16.625 17.0203 16.5531 17.1983 16.4093 17.342C16.2654 17.4858 16.0872 17.5577 15.8748 17.5577C15.6621 17.5577 15.484 17.4858 15.3405 17.342C15.1968 17.1983 15.125 17.0203 15.125 16.8077ZM19 12.9038V11.0962C19 10.8837 19.0719 10.7056 19.2158 10.5617C19.3596 10.4181 19.5378 10.3462 19.7502 10.3462C19.9629 10.3462 20.141 10.4181 20.2845 10.5617C20.4282 10.7056 20.5 10.8837 20.5 11.0962V12.9038C20.5 13.1163 20.4281 13.2944 20.2843 13.4383C20.1404 13.5819 19.9622 13.6538 19.7498 13.6538C19.5371 13.6538 19.359 13.5819 19.2155 13.4383C19.0718 13.2944 19 13.1163 19 12.9038Z"
}, pt = ({
  name: d,
  size: l = 24,
  fill: u,
  viewBox: p = "0 0 24 24"
}) => {
  const g = typeof FS[d] == "string" ? [FS[d]] : FS[d];
  return /* @__PURE__ */ U.jsx("svg", { width: l, height: l, viewBox: p, fill: "none", children: g.map((R, y) => /* @__PURE__ */ U.jsx("path", { d: R, fill: u }, y)) });
}, q5 = ({
  ruid: d,
  closeMenu: l,
  iconFill: u
}) => {
  const [p, g] = re.useState(!1), [R, y] = re.useState(window.innerWidth < 768), [Q, T] = re.useState("below"), k = re.useRef(null), V = re.useRef(null), N = ru().find((ie) => ie.ruid === d), b = Pe((ie) => ie.localParticipant), A = D5(
    (N == null ? void 0 : N.pid) ?? "",
    (N == null ? void 0 : N.type) ?? "human"
  ), Ne = ou(We.AUDIO, N == null ? void 0 : N.pid);
  re.useEffect(() => {
    const ie = () => {
      y(window.innerWidth < 768);
    };
    return window.addEventListener("resize", ie), () => window.removeEventListener("resize", ie);
  }, []), re.useEffect(() => {
    l && p && g(!1);
  }, [l, p]), re.useEffect(() => {
    const ie = (Ve) => {
      var _e;
      V.current && !V.current.contains(Ve.target) && !((_e = k.current) != null && _e.contains(Ve.target)) && g(!1);
    };
    if (p)
      return document.addEventListener("mousedown", ie), () => document.removeEventListener("mousedown", ie);
  }, [p]);
  const Ee = re.useMemo(() => {
    const ie = [
      {
        label: A ? "Unpin" : "Pin to screen",
        iconName: A ? "unpin" : "pin",
        onPress: () => {
          A ? T5() : N && U5(N.pid, N.type), g(!1);
        }
      }
    ];
    return N && b.role === "moderator" && N.pid !== b.pid && (N == null ? void 0 : N.type) === "human" && (Ne || ie.push({
      label: "Mute Audio",
      iconName: "mic-off",
      onPress: () => {
        Z5(N.pid), g(!1);
      }
    })), ie;
  }, [
    A,
    N,
    b.role,
    b.pid,
    Ne
  ]);
  if (!N)
    return null;
  const Fe = () => {
    if (!p && k.current) {
      const ie = k.current.getBoundingClientRect(), Ve = ie.top + ie.height / 2, _e = window.innerHeight / 2, z = Ve > _e;
      T(z ? "above" : "below");
    }
    g(!p);
  }, he = (ie) => {
    ie.key === "Escape" && g(!1);
  };
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-more-option-container", children: [
    /* @__PURE__ */ U.jsx(
      "button",
      {
        ref: k,
        className: `cometchat-calls-more-option-button ${p ? "cometchat-calls-more-option-button--active" : ""}`,
        onClick: Fe,
        onKeyDown: he,
        "aria-label": `More options for ${N.name}`,
        "aria-expanded": p,
        "aria-haspopup": "menu",
        type: "button",
        children: /* @__PURE__ */ U.jsx(
          pt,
          {
            name: "more",
            size: 20,
            fill: u || p ? "var(--cometchat-calls-primary-button-icon)" : "var(--cometchat-calls-icon-color-secondary)"
          }
        )
      }
    ),
    p && /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
      /* @__PURE__ */ U.jsx(
        "div",
        {
          className: "cometchat-calls-more-option-overlay",
          onClick: () => g(!1)
        }
      ),
      /* @__PURE__ */ U.jsx(
        "div",
        {
          ref: V,
          className: `cometchat-calls-more-option-menu ${R ? "cometchat-calls-more-option-menu--mobile" : ""} ${Q === "above" ? "cometchat-calls-more-option-menu--above" : ""}`,
          role: "menu",
          "aria-orientation": "vertical",
          children: Ee.map((ie, Ve) => /* @__PURE__ */ U.jsxs(
            "button",
            {
              className: `cometchat-calls-more-option-menu__item ${ie.selected ? "cometchat-calls-more-option-menu__item--selected" : ""}`,
              onClick: ie.onPress,
              role: "menuitem",
              "aria-label": ie.label,
              type: "button",
              children: [
                ie.iconName && /* @__PURE__ */ U.jsx(
                  pt,
                  {
                    name: ie.iconName,
                    size: 24,
                    fill: "var(--cometchat-calls-icon-color-secondary)"
                  }
                ),
                /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-more-option-menu__item-text", children: ie.label })
              ]
            },
            Ve
          ))
        }
      )
    ] })
  ] });
}, Qy = ({ pid: d }) => {
  var Q;
  const [l, u] = re.useState(50), p = (Q = qS(d, We.AUDIO)) == null ? void 0 : Q.originalTrack, g = re.useCallback((T) => {
    u(Math.min(1200 * T, 200));
  }, []);
  re.useEffect(() => (p == null || p.on(tt.events.track.TRACK_AUDIO_LEVEL_CHANGED, g), () => {
    p == null || p.off(
      tt.events.track.TRACK_AUDIO_LEVEL_CHANGED,
      g
    );
  }), [g, p]);
  const R = Math.max(100, l), y = R <= 100 ? [1, 1, 1, 1, 1] : [
    1 + Math.random(),
    1 + Math.random() * 1.5,
    1 + Math.random() * 1,
    1 + Math.random() * 1.5,
    1 + Math.random()
  ];
  return /* @__PURE__ */ U.jsxs(
    "div",
    {
      className: "cometchat-calls-wave-container",
      style: { "--wave-scale": `${R}%` },
      children: [
        /* @__PURE__ */ U.jsx(
          "div",
          {
            className: "cometchat-calls-wave-rect",
            style: {
              transform: `scaleY(calc(var(--wave-scale) * ${y[0]}))`
            }
          }
        ),
        /* @__PURE__ */ U.jsx(
          "div",
          {
            className: "cometchat-calls-wave-rect",
            style: {
              transform: `scaleY(calc(var(--wave-scale) * ${y[2]}))`
            }
          }
        ),
        /* @__PURE__ */ U.jsx(
          "div",
          {
            className: "cometchat-calls-wave-rect",
            style: {
              transform: `scaleY(calc(var(--wave-scale) * ${y[4]}))`
            }
          }
        )
      ]
    }
  );
}, _S = {
  secondary: "var(--cometchat-calls-icon-color-secondary)",
  primary: "var(--cometchat-calls-static-black)"
}, Dy = re.memo(
  ({
    type: d,
    muted: l,
    raisedHandTimestamp: u,
    pid: p
  }) => d === "screen-share" ? /* @__PURE__ */ U.jsx(pt, { name: "screen-share", size: 16, fill: _S.secondary }) : u ? /* @__PURE__ */ U.jsx(pt, { name: "raise-hand-fill", size: 16, fill: _S.primary }) : l ? /* @__PURE__ */ U.jsx(pt, { name: "mic-off-fill", size: 16, fill: _S.secondary }) : /* @__PURE__ */ U.jsx(Qy, { pid: p })
), xy = ({ participant: d, className: l }) => {
  const { name: u, isLocal: p, type: g, pid: R } = d, y = ou(We.AUDIO, R), Q = Yg(R, g), T = Rt(
    (b) => b.enableCompanionMode
  ), k = !!Q && g === "human", V = re.useMemo(
    () => en(
      "cometchat-calls-tile-label",
      k && "cometchat-calls-tile-label--raised-hand",
      l
    ),
    [k, l]
  ), N = re.useMemo(() => `cometchat-calls-tile-label-name ${k ? "cometchat-calls-tile-label-name--raised-hand" : ""}`, [k]);
  return /* @__PURE__ */ U.jsxs("div", { className: V, children: [
    /* @__PURE__ */ U.jsx(
      Dy,
      {
        type: g,
        muted: p && T ? !0 : y,
        raisedHandTimestamp: Q,
        pid: R
      }
    ),
    /* @__PURE__ */ U.jsxs("span", { className: N, children: [
      u,
      " ",
      p && "(You)"
    ] })
  ] });
}, rR = ({
  autoPlay: d = !0,
  className: l = "",
  muted: u = !0,
  playsinline: p = !0,
  style: g = {},
  videoTrack: R
}) => {
  const y = re.useRef(null);
  return re.useEffect(() => {
    const Q = y.current;
    return Q && R && R.attach(Q).catch((T) => {
      console.error("Error attaching video track:", T);
    }), () => {
      Q && R && R.detach(Q);
    };
  }, [R]), /* @__PURE__ */ U.jsx(
    "video",
    {
      autoPlay: d,
      className: en("cometchat-calls-video", l),
      muted: u,
      playsInline: p,
      ref: y,
      style: g
    }
  );
}, xf = ({ participant: d }) => {
  const { name: l, avatar: u, isLocal: p, type: g, pid: R, ruid: y } = d, [Q, T] = re.useState(!1), k = ST(), V = Rt((Ne) => Ne.showFrameRate), N = qS(
    R,
    g === "screen-share" ? We.SCREENSHARE : We.VIDEO
  ), b = ou(
    g === "screen-share" ? We.SCREENSHARE : We.VIDEO,
    R
  ), A = ne((Ne) => Ne.mirrorLocalVideo);
  return /* @__PURE__ */ U.jsxs(
    "div",
    {
      className: "cometchat-calls-tile-container",
      onMouseEnter: () => T(!0),
      onMouseLeave: () => T(!1),
      children: [
        k && /* @__PURE__ */ U.jsx(
          q5,
          {
            ruid: y,
            closeMenu: !Q,
            iconFill: "var(--cometchat-calls-primary-button-icon)"
          }
        ),
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-tile-content", children: [
          /* @__PURE__ */ U.jsx(
            rR,
            {
              videoTrack: N == null ? void 0 : N.originalTrack,
              className: en(
                b ? "cometchat-calls-video--fade-out" : "cometchat-calls-video--fade-in",
                {
                  "cometchat-calls-video--mirrored": p && g !== "screen-share" && A,
                  "cometchat-calls-tile-video--contain": g === "screen-share"
                }
              )
            }
          ),
          /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-tile-avatar-container", children: /* @__PURE__ */ U.jsx(aR, { name: l, imageUrl: u }) }),
          /* @__PURE__ */ U.jsx(xy, { participant: d }),
          V && !b && /* @__PURE__ */ U.jsx(ky, { videoTrack: N == null ? void 0 : N.originalTrack })
        ] })
      ]
    }
  );
}, Zy = ({
  startIndex: d = 4,
  style: l
}) => {
  const p = ru().slice(d), g = p.length, R = p.slice(
    0,
    Math.min(4, g > 4 ? 3 : 4)
  ), y = Math.max(0, g - 3);
  return /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-group-avatar-container",
      style: l,
      onClick: $S,
      children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-group-avatar-grid", children: [
        R.map((Q) => /* @__PURE__ */ U.jsx(
          aR,
          {
            size: 40,
            name: Q.name,
            imageUrl: Q.avatar
          },
          Q.ruid
        )),
        g > 4 && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-group-avatar-overflow-circle", children: /* @__PURE__ */ U.jsxs("span", { className: "cometchat-calls-group-avatar-overflow-text", children: [
          " ",
          "+",
          y
        ] }) })
      ] })
    }
  );
}, Oy = () => {
  const d = ru(), l = re.useRef(null), [u, p] = re.useState({
    mainTileWidth: 0,
    mainTileHeight: 0,
    sidebarWidth: 200,
    maxSidebarTiles: 10
  }), [g, R] = re.useState(window.innerWidth), y = Q5();
  if (re.useLayoutEffect(() => {
    const Fe = () => R(window.innerWidth);
    return window.addEventListener("resize", Fe), () => window.removeEventListener("resize", Fe);
  }, []), re.useLayoutEffect(() => {
    const Fe = l.current;
    if (!Fe) return;
    const he = new ResizeObserver((ie) => {
      const { width: Ve, height: _e } = ie[0].contentRect;
      let z = 0, Ce = Ve;
      const Re = _e;
      Ce = Ve - z - Kl, d.length > 1 && d.length <= 9 ? z = 210 : z = 440, p({
        mainTileWidth: Ce,
        mainTileHeight: Re,
        sidebarWidth: z,
        maxSidebarTiles: 10
      });
    });
    return he.observe(Fe), () => he.unobserve(Fe);
  }, [d.length]), d.length === 0) return null;
  const Q = d, T = g >= 681 && g <= 1024, k = g <= 680, V = Q.length;
  let N;
  k ? N = V >= 9 : T ? N = V >= 6 : V <= 5 ? N = !1 : V >= 6 && V <= 9 ? N = !0 : V === 10 ? N = !1 : N = !0;
  let b;
  N ? k ? b = 7 : T || V >= 6 && V <= 9 ? b = 4 : b = 9 : b = Q.length;
  const A = Q.slice(
    0,
    b
  ), Ne = () => {
    const Fe = "cometchat-calls-sidebar-layout-container";
    if (!k) return Fe;
    const he = d.length;
    return `${Fe} cometchat-calls-mobile-${he}-participants`;
  }, Ee = () => Q.length === 1 ? null : /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-sidebar-layout-sidebar-container",
      style: g > 1024 ? { width: u.sidebarWidth } : { width: "100%" },
      children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-sidebar-layout-grid", children: [
        A.map((Fe) => /* @__PURE__ */ U.jsx(
          "div",
          {
            className: "cometchat-calls-sidebar-layout-tile",
            children: /* @__PURE__ */ U.jsx(xf, { participant: Fe })
          },
          Fe.ruid
        )),
        N && /* @__PURE__ */ U.jsx(
          "div",
          {
            className: T ? "cometchat-calls-sidebar-layout-tile cometchat-calls-grouptile-component" : "cometchat-calls-sidebar-layout-tile",
            children: /* @__PURE__ */ U.jsx(
              Zy,
              {
                startIndex: b,
                style: {
                  width: "100%",
                  height: "100%"
                }
              }
            )
          }
        )
      ] })
    }
  );
  return /* @__PURE__ */ U.jsxs("div", { ref: l, className: Ne(), children: [
    /* @__PURE__ */ U.jsx(
      "div",
      {
        className: "cometchat-calls-sidebar-layout-main-view",
        style: g > 1024 ? {
          width: u.mainTileWidth,
          height: u.mainTileHeight
        } : {},
        children: /* @__PURE__ */ U.jsx(xf, { participant: y })
      }
    ),
    Ee()
  ] });
}, ui = 10, By = ({
  containerBounds: d,
  disableDrag: l = !0
}) => {
  const u = Of(), p = re.useRef(null), [g, R] = re.useState(!1), [y, Q] = re.useState(!1), [T, k] = re.useState({ x: 0, y: 0 }), [V, N] = re.useState({ x: ui, y: ui }), [b, A] = re.useState({ width: 230, height: 130 }), [Ne, Ee] = re.useState(!1), [Fe, he] = re.useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }), [ie, Ve] = re.useState("top-left"), _e = { width: 200, height: 100 }, z = { width: 400, height: 200 }, Ce = 2, Re = re.useCallback(
    (be) => {
      const { width: Be, height: De } = d, { width: Z, height: X } = b, ae = Be / 2, Te = De / 2, F = be.x + Z / 2, H = be.y + X / 2;
      let L;
      return F < ae && H < Te ? L = "top-left" : F >= ae && H < Te ? L = "top-right" : F < ae && H >= Te ? L = "bottom-left" : L = "bottom-right", Ve(L), L;
    },
    [d, b]
  ), Ue = re.useCallback(
    (be) => {
      const { width: Be, height: De } = d, { width: Z, height: X } = b, ae = [
        { x: ui, y: ui, name: "top-left" },
        // top-left
        {
          x: Be - Z - ui,
          y: ui,
          name: "top-right"
        },
        // top-right
        {
          x: ui,
          y: De - X - ui,
          name: "bottom-left"
        },
        // bottom-left
        {
          x: Be - Z - ui,
          y: De - X - ui,
          name: "bottom-right"
        }
        // bottom-right
      ];
      let Te = ae[0], F = 1 / 0;
      return ae.forEach((H) => {
        const L = Math.sqrt(
          Math.pow(be.x - H.x, 2) + Math.pow(be.y - H.y, 2)
        );
        L < F && (F = L, Te = H);
      }), { x: Te.x, y: Te.y };
    },
    [d, b]
  );
  re.useEffect(() => {
    Re(V);
  }, [V, Re]);
  const Se = re.useCallback(
    (be) => {
      if (l || be.target.classList.contains(
        "cometchat-calls-draggable-tile-resize-handle"
      ))
        return;
      be.preventDefault(), R(!0);
      const Be = p.current.getBoundingClientRect();
      k({
        x: be.clientX - Be.left,
        y: be.clientY - Be.top
      });
    },
    [l]
  ), xe = re.useCallback(
    (be) => {
      be.preventDefault(), be.stopPropagation(), Q(!0), he({
        x: be.clientX,
        y: be.clientY,
        width: b.width,
        height: b.height
      });
    },
    [b]
  );
  re.useEffect(() => {
    const be = (De) => {
      var Z;
      if (g && !y) {
        const X = (Z = p.current) == null ? void 0 : Z.parentElement;
        if (!X) return;
        const ae = X.getBoundingClientRect(), Te = De.clientX - ae.left - T.x, F = De.clientY - ae.top - T.y, H = Math.max(
          0,
          Math.min(Te, d.width - b.width)
        ), L = Math.max(
          0,
          Math.min(F, d.height - b.height)
        );
        N({ x: H, y: L });
      } else if (y) {
        let X = De.clientX - Fe.x, ae = De.clientY - Fe.y;
        ie === "top-left" || (ie === "top-right" ? X = -X : ie === "bottom-left" ? ae = -ae : ie === "bottom-right" && (X = -X, ae = -ae));
        const Te = Math.abs(X) > Math.abs(ae) ? X : ae, F = Math.max(
          Te,
          -(Fe.width - _e.width)
        );
        let H = Fe.width + F, L = H / Ce;
        H < _e.width ? (H = _e.width, L = _e.height) : H > z.width && (H = z.width, L = z.height);
        let de = d.width - 2 * ui, ye = d.height - ui;
        ie === "top-left" ? (de = d.width - V.x - ui, ye = d.height - V.y - ui) : ie === "top-right" ? (de = V.x + b.width - ui, ye = d.height - V.y - ui) : ie === "bottom-left" ? (de = d.width - V.x - ui, ye = V.y + b.height - ui) : ie === "bottom-right" && (de = V.x + b.width - ui, ye = V.y + b.height - ui), H > de && (H = de, L = H / Ce), L > ye && (L = ye, H = L * Ce);
        const Ae = { ...V };
        ie === "top-left" || (ie === "top-right" ? Ae.x = V.x - (H - b.width) : ie === "bottom-left" ? Ae.y = V.y - (L - b.height) : ie === "bottom-right" && (Ae.x = V.x - (H - b.width), Ae.y = V.y - (L - b.height))), Ae.x = Math.max(
          0,
          Math.min(Ae.x, d.width - H)
        ), Ae.y = Math.max(
          0,
          Math.min(Ae.y, d.height - L)
        ), A({ width: H, height: L }), N(Ae);
      }
    }, Be = () => {
      if (g && !y) {
        Ee(!0);
        const De = Ue(V);
        N(De), setTimeout(() => {
          Ee(!1);
        }, 300);
      }
      R(!1), Q(!1);
    };
    if (g || y)
      return document.addEventListener("mousemove", be), document.addEventListener("mouseup", Be), () => {
        document.removeEventListener("mousemove", be), document.removeEventListener("mouseup", Be);
      };
  }, [
    g,
    y,
    T,
    V,
    b,
    Ue,
    d,
    Fe,
    ie
  ]);
  const Qe = re.useCallback(
    (be) => {
      if (l || be.target.classList.contains(
        "cometchat-calls-draggable-tile-resize-handle"
      ))
        return;
      be.preventDefault(), R(!0);
      const Be = p.current.getBoundingClientRect(), De = be.touches[0];
      k({
        x: De.clientX - Be.left,
        y: De.clientY - Be.top
      });
    },
    [l]
  );
  re.useEffect(() => {
    const be = (De) => {
      var Z;
      if (g && !y) {
        De.preventDefault();
        const X = De.touches[0], ae = (Z = p.current) == null ? void 0 : Z.parentElement;
        if (!ae) return;
        const Te = ae.getBoundingClientRect(), F = X.clientX - Te.left - T.x, H = X.clientY - Te.top - T.y, L = Math.max(
          0,
          Math.min(F, d.width - b.width)
        ), de = Math.max(
          0,
          Math.min(H, d.height - b.height)
        );
        N({ x: L, y: de });
      }
    }, Be = () => {
      if (g && !y) {
        Ee(!0);
        const De = Ue(V);
        N(De), setTimeout(() => {
          Ee(!1);
        }, 300);
      }
      R(!1), Q(!1);
    };
    if (g || y)
      return document.addEventListener("touchmove", be, {
        passive: !1
      }), document.addEventListener("touchend", Be), () => {
        document.removeEventListener("touchmove", be), document.removeEventListener("touchend", Be);
      };
  }, [
    g,
    y,
    T,
    V,
    b,
    Ue,
    d
  ]), re.useEffect(() => {
    const be = Math.max(0, d.width - b.width), Be = Math.max(0, d.height - b.height);
    let De = Math.max(0, Math.min(V.x, be)), Z = Math.max(0, Math.min(V.y, Be));
    const X = Ue({ x: De, y: Z });
    De = X.x, Z = X.y, (De !== V.x || Z !== V.y) && N({ x: De, y: Z }), setTimeout(() => {
      Re({ x: De, y: Z });
    }, 0);
  }, [
    d.width,
    d.height,
    b.width,
    b.height,
    Ue
  ]);
  const fe = () => {
    switch (ie) {
      case "top-left":
        return "cometchat-calls-draggable-tile-resize-handle--bottom-right";
      case "top-right":
        return "cometchat-calls-draggable-tile-resize-handle--bottom-left";
      case "bottom-left":
        return "cometchat-calls-draggable-tile-resize-handle--top-right";
      case "bottom-right":
        return "cometchat-calls-draggable-tile-resize-handle--top-left";
      default:
        return "cometchat-calls-draggable-tile-resize-handle--bottom-right";
    }
  };
  return /* @__PURE__ */ U.jsxs(
    "div",
    {
      ref: p,
      className: en("cometchat-calls-draggable-tile", {
        "cometchat-calls-draggable-tile--dragging": g,
        "cometchat-calls-draggable-tile--animating": Ne
      }),
      style: {
        position: "absolute",
        left: V.x,
        top: V.y,
        width: b.width,
        height: b.height,
        zIndex: 100,
        cursor: l ? "default" : g ? "grabbing" : "grab"
      },
      onMouseDown: Se,
      onTouchStart: Qe,
      children: [
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-draggable-tile-content", children: /* @__PURE__ */ U.jsx(xf, { participant: u }) }),
        !l && /* @__PURE__ */ U.jsx(
          "div",
          {
            className: en(
              "cometchat-calls-draggable-tile-resize-handle",
              fe()
            ),
            onMouseDown: xe,
            onTouchStart: (be) => {
              be.preventDefault(), be.stopPropagation();
              const Be = be.touches[0];
              Q(!0), he({
                x: Be.clientX,
                y: Be.clientY,
                width: b.width,
                height: b.height
              });
            }
          }
        )
      ]
    }
  );
}, wy = () => {
  const d = ru(), l = Q5(), u = re.useRef(null), p = Rt(
    (Q) => Q.enableSpotlightDrag
  ), [g, R] = re.useState({
    width: 0,
    height: 0
  });
  re.useEffect(() => {
    (() => {
      if (u.current) {
        const k = u.current.getBoundingClientRect(), V = {
          width: k.width,
          height: k.height
        };
        R((N) => N.width !== V.width || N.height !== V.height ? V : N);
      }
    })();
    let T = null;
    return u.current && (T = new ResizeObserver((k) => {
      for (const V of k) {
        const { width: N, height: b } = V.contentRect, A = { width: N, height: b };
        R((Ne) => Ne.width !== A.width || Ne.height !== A.height ? A : Ne);
      }
    }), T.observe(u.current)), () => {
      T && u.current && (T.unobserve(u.current), T.disconnect());
    };
  }, []);
  const y = d.find((Q) => !Q.isLocal) || l;
  return /* @__PURE__ */ U.jsxs("div", { ref: u, className: "cometchat-calls-spotlight-container", children: [
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-spotlight-main-view", children: /* @__PURE__ */ U.jsx(xf, { participant: y }) }),
    d.length > 1 && g.width > 0 && g.height > 0 && /* @__PURE__ */ U.jsx(
      By,
      {
        disableDrag: !p,
        containerBounds: g
      }
    )
  ] });
};
function wS() {
  return wS = Object.assign ? Object.assign.bind() : function(d) {
    for (var l = 1; l < arguments.length; l++) {
      var u = arguments[l];
      for (var p in u) ({}).hasOwnProperty.call(u, p) && (d[p] = u[p]);
    }
    return d;
  }, wS.apply(null, arguments);
}
function J3(d) {
  if (d === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return d;
}
function AS(d, l) {
  return AS = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, p) {
    return u.__proto__ = p, u;
  }, AS(d, l);
}
function Ay(d, l) {
  d.prototype = Object.create(l.prototype), d.prototype.constructor = d, AS(d, l);
}
var L3 = Number.isNaN || function(l) {
  return typeof l == "number" && l !== l;
};
function Jy(d, l) {
  return !!(d === l || L3(d) && L3(l));
}
function Ly(d, l) {
  if (d.length !== l.length)
    return !1;
  for (var u = 0; u < d.length; u++)
    if (!Jy(d[u], l[u]))
      return !1;
  return !0;
}
function MS(d, l) {
  l === void 0 && (l = Ly);
  var u, p = [], g, R = !1;
  function y() {
    for (var Q = [], T = 0; T < arguments.length; T++)
      Q[T] = arguments[T];
    return R && u === this && l(Q, p) || (g = d.apply(this, Q), R = !0, u = this, p = Q), g;
  }
  return y;
}
var Iy = typeof performance == "object" && typeof performance.now == "function", I3 = Iy ? function() {
  return performance.now();
} : function() {
  return Date.now();
};
function W3(d) {
  cancelAnimationFrame(d.id);
}
function Wy(d, l) {
  var u = I3();
  function p() {
    I3() - u >= l ? d.call(null) : g.id = requestAnimationFrame(p);
  }
  var g = {
    id: requestAnimationFrame(p)
  };
  return g;
}
var kS = -1;
function Hy(d) {
  if (d === void 0 && (d = !1), kS === -1 || d) {
    var l = document.createElement("div"), u = l.style;
    u.width = "50px", u.height = "50px", u.overflow = "scroll", document.body.appendChild(l), kS = l.offsetWidth - l.clientWidth, document.body.removeChild(l);
  }
  return kS;
}
var Fh = null;
function H3(d) {
  if (d === void 0 && (d = !1), Fh === null || d) {
    var l = document.createElement("div"), u = l.style;
    u.width = "50px", u.height = "50px", u.overflow = "scroll", u.direction = "rtl";
    var p = document.createElement("div"), g = p.style;
    return g.width = "100px", g.height = "100px", l.appendChild(p), document.body.appendChild(l), l.scrollLeft > 0 ? Fh = "positive-descending" : (l.scrollLeft = 1, l.scrollLeft === 0 ? Fh = "negative" : Fh = "positive-ascending"), document.body.removeChild(l), Fh;
  }
  return Fh;
}
var zy = 150, jy = function(l) {
  var u = l.columnIndex;
  l.data;
  var p = l.rowIndex;
  return p + ":" + u;
}, Og = null, Bg = null, wg = null;
process.env.NODE_ENV !== "production" && typeof window < "u" && typeof window.WeakSet < "u" && (Og = /* @__PURE__ */ new WeakSet(), Bg = /* @__PURE__ */ new WeakSet(), wg = /* @__PURE__ */ new WeakSet());
function Gy(d) {
  var l, u = d.getColumnOffset, p = d.getColumnStartIndexForOffset, g = d.getColumnStopIndexForStartIndex, R = d.getColumnWidth, y = d.getEstimatedTotalHeight, Q = d.getEstimatedTotalWidth, T = d.getOffsetForColumnAndAlignment, k = d.getOffsetForRowAndAlignment, V = d.getRowHeight, N = d.getRowOffset, b = d.getRowStartIndexForOffset, A = d.getRowStopIndexForStartIndex, Ne = d.initInstanceProps, Ee = d.shouldResetStyleCacheOnItemSizeChange, Fe = d.validateProps;
  return l = /* @__PURE__ */ function(he) {
    Ay(ie, he);
    function ie(_e) {
      var z;
      return z = he.call(this, _e) || this, z._instanceProps = Ne(z.props, J3(z)), z._resetIsScrollingTimeoutId = null, z._outerRef = void 0, z.state = {
        instance: J3(z),
        isScrolling: !1,
        horizontalScrollDirection: "forward",
        scrollLeft: typeof z.props.initialScrollLeft == "number" ? z.props.initialScrollLeft : 0,
        scrollTop: typeof z.props.initialScrollTop == "number" ? z.props.initialScrollTop : 0,
        scrollUpdateWasRequested: !1,
        verticalScrollDirection: "forward"
      }, z._callOnItemsRendered = void 0, z._callOnItemsRendered = MS(function(Ce, Re, Ue, Se, xe, Qe, fe, be) {
        return z.props.onItemsRendered({
          overscanColumnStartIndex: Ce,
          overscanColumnStopIndex: Re,
          overscanRowStartIndex: Ue,
          overscanRowStopIndex: Se,
          visibleColumnStartIndex: xe,
          visibleColumnStopIndex: Qe,
          visibleRowStartIndex: fe,
          visibleRowStopIndex: be
        });
      }), z._callOnScroll = void 0, z._callOnScroll = MS(function(Ce, Re, Ue, Se, xe) {
        return z.props.onScroll({
          horizontalScrollDirection: Ue,
          scrollLeft: Ce,
          scrollTop: Re,
          verticalScrollDirection: Se,
          scrollUpdateWasRequested: xe
        });
      }), z._getItemStyle = void 0, z._getItemStyle = function(Ce, Re) {
        var Ue = z.props, Se = Ue.columnWidth, xe = Ue.direction, Qe = Ue.rowHeight, fe = z._getItemStyleCache(Ee && Se, Ee && xe, Ee && Qe), be = Ce + ":" + Re, Be;
        if (fe.hasOwnProperty(be))
          Be = fe[be];
        else {
          var De = u(z.props, Re, z._instanceProps), Z = xe === "rtl";
          fe[be] = Be = {
            position: "absolute",
            left: Z ? void 0 : De,
            right: Z ? De : void 0,
            top: N(z.props, Ce, z._instanceProps),
            height: V(z.props, Ce, z._instanceProps),
            width: R(z.props, Re, z._instanceProps)
          };
        }
        return Be;
      }, z._getItemStyleCache = void 0, z._getItemStyleCache = MS(function(Ce, Re, Ue) {
        return {};
      }), z._onScroll = function(Ce) {
        var Re = Ce.currentTarget, Ue = Re.clientHeight, Se = Re.clientWidth, xe = Re.scrollLeft, Qe = Re.scrollTop, fe = Re.scrollHeight, be = Re.scrollWidth;
        z.setState(function(Be) {
          if (Be.scrollLeft === xe && Be.scrollTop === Qe)
            return null;
          var De = z.props.direction, Z = xe;
          if (De === "rtl")
            switch (H3()) {
              case "negative":
                Z = -xe;
                break;
              case "positive-descending":
                Z = be - Se - xe;
                break;
            }
          Z = Math.max(0, Math.min(Z, be - Se));
          var X = Math.max(0, Math.min(Qe, fe - Ue));
          return {
            isScrolling: !0,
            horizontalScrollDirection: Be.scrollLeft < xe ? "forward" : "backward",
            scrollLeft: Z,
            scrollTop: X,
            verticalScrollDirection: Be.scrollTop < Qe ? "forward" : "backward",
            scrollUpdateWasRequested: !1
          };
        }, z._resetIsScrollingDebounced);
      }, z._outerRefSetter = function(Ce) {
        var Re = z.props.outerRef;
        z._outerRef = Ce, typeof Re == "function" ? Re(Ce) : Re != null && typeof Re == "object" && Re.hasOwnProperty("current") && (Re.current = Ce);
      }, z._resetIsScrollingDebounced = function() {
        z._resetIsScrollingTimeoutId !== null && W3(z._resetIsScrollingTimeoutId), z._resetIsScrollingTimeoutId = Wy(z._resetIsScrolling, zy);
      }, z._resetIsScrolling = function() {
        z._resetIsScrollingTimeoutId = null, z.setState({
          isScrolling: !1
        }, function() {
          z._getItemStyleCache(-1);
        });
      }, z;
    }
    ie.getDerivedStateFromProps = function(z, Ce) {
      return Py(z, Ce), Fe(z), null;
    };
    var Ve = ie.prototype;
    return Ve.scrollTo = function(z) {
      var Ce = z.scrollLeft, Re = z.scrollTop;
      Ce !== void 0 && (Ce = Math.max(0, Ce)), Re !== void 0 && (Re = Math.max(0, Re)), this.setState(function(Ue) {
        return Ce === void 0 && (Ce = Ue.scrollLeft), Re === void 0 && (Re = Ue.scrollTop), Ue.scrollLeft === Ce && Ue.scrollTop === Re ? null : {
          horizontalScrollDirection: Ue.scrollLeft < Ce ? "forward" : "backward",
          scrollLeft: Ce,
          scrollTop: Re,
          scrollUpdateWasRequested: !0,
          verticalScrollDirection: Ue.scrollTop < Re ? "forward" : "backward"
        };
      }, this._resetIsScrollingDebounced);
    }, Ve.scrollToItem = function(z) {
      var Ce = z.align, Re = Ce === void 0 ? "auto" : Ce, Ue = z.columnIndex, Se = z.rowIndex, xe = this.props, Qe = xe.columnCount, fe = xe.height, be = xe.rowCount, Be = xe.width, De = this.state, Z = De.scrollLeft, X = De.scrollTop, ae = Hy();
      Ue !== void 0 && (Ue = Math.max(0, Math.min(Ue, Qe - 1))), Se !== void 0 && (Se = Math.max(0, Math.min(Se, be - 1)));
      var Te = y(this.props, this._instanceProps), F = Q(this.props, this._instanceProps), H = F > Be ? ae : 0, L = Te > fe ? ae : 0;
      this.scrollTo({
        scrollLeft: Ue !== void 0 ? T(this.props, Ue, Re, Z, this._instanceProps, L) : Z,
        scrollTop: Se !== void 0 ? k(this.props, Se, Re, X, this._instanceProps, H) : X
      });
    }, Ve.componentDidMount = function() {
      var z = this.props, Ce = z.initialScrollLeft, Re = z.initialScrollTop;
      if (this._outerRef != null) {
        var Ue = this._outerRef;
        typeof Ce == "number" && (Ue.scrollLeft = Ce), typeof Re == "number" && (Ue.scrollTop = Re);
      }
      this._callPropsCallbacks();
    }, Ve.componentDidUpdate = function() {
      var z = this.props.direction, Ce = this.state, Re = Ce.scrollLeft, Ue = Ce.scrollTop, Se = Ce.scrollUpdateWasRequested;
      if (Se && this._outerRef != null) {
        var xe = this._outerRef;
        if (z === "rtl")
          switch (H3()) {
            case "negative":
              xe.scrollLeft = -Re;
              break;
            case "positive-ascending":
              xe.scrollLeft = Re;
              break;
            default:
              var Qe = xe.clientWidth, fe = xe.scrollWidth;
              xe.scrollLeft = fe - Qe - Re;
              break;
          }
        else
          xe.scrollLeft = Math.max(0, Re);
        xe.scrollTop = Math.max(0, Ue);
      }
      this._callPropsCallbacks();
    }, Ve.componentWillUnmount = function() {
      this._resetIsScrollingTimeoutId !== null && W3(this._resetIsScrollingTimeoutId);
    }, Ve.render = function() {
      var z = this.props, Ce = z.children, Re = z.className, Ue = z.columnCount, Se = z.direction, xe = z.height, Qe = z.innerRef, fe = z.innerElementType, be = z.innerTagName, Be = z.itemData, De = z.itemKey, Z = De === void 0 ? jy : De, X = z.outerElementType, ae = z.outerTagName, Te = z.rowCount, F = z.style, H = z.useIsScrolling, L = z.width, de = this.state.isScrolling, ye = this._getHorizontalRangeToRender(), Ae = ye[0], Ze = ye[1], Bt = this._getVerticalRangeToRender(), $e = Bt[0], Ht = Bt[1], Nn = [];
      if (Ue > 0 && Te)
        for (var rn = $e; rn <= Ht; rn++)
          for (var tn = Ae; tn <= Ze; tn++)
            Nn.push(re.createElement(Ce, {
              columnIndex: tn,
              data: Be,
              isScrolling: H ? de : void 0,
              key: Z({
                columnIndex: tn,
                data: Be,
                rowIndex: rn
              }),
              rowIndex: rn,
              style: this._getItemStyle(rn, tn)
            }));
      var gn = y(this.props, this._instanceProps), Ma = Q(this.props, this._instanceProps);
      return re.createElement(X || ae || "div", {
        className: Re,
        onScroll: this._onScroll,
        ref: this._outerRefSetter,
        style: wS({
          position: "relative",
          height: xe,
          width: L,
          overflow: "auto",
          WebkitOverflowScrolling: "touch",
          willChange: "transform",
          direction: Se
        }, F)
      }, re.createElement(fe || be || "div", {
        children: Nn,
        ref: Qe,
        style: {
          height: gn,
          pointerEvents: de ? "none" : void 0,
          width: Ma
        }
      }));
    }, Ve._callPropsCallbacks = function() {
      var z = this.props, Ce = z.columnCount, Re = z.onItemsRendered, Ue = z.onScroll, Se = z.rowCount;
      if (typeof Re == "function" && Ce > 0 && Se > 0) {
        var xe = this._getHorizontalRangeToRender(), Qe = xe[0], fe = xe[1], be = xe[2], Be = xe[3], De = this._getVerticalRangeToRender(), Z = De[0], X = De[1], ae = De[2], Te = De[3];
        this._callOnItemsRendered(Qe, fe, Z, X, be, Be, ae, Te);
      }
      if (typeof Ue == "function") {
        var F = this.state, H = F.horizontalScrollDirection, L = F.scrollLeft, de = F.scrollTop, ye = F.scrollUpdateWasRequested, Ae = F.verticalScrollDirection;
        this._callOnScroll(L, de, H, Ae, ye);
      }
    }, Ve._getHorizontalRangeToRender = function() {
      var z = this.props, Ce = z.columnCount, Re = z.overscanColumnCount, Ue = z.overscanColumnsCount, Se = z.overscanCount, xe = z.rowCount, Qe = this.state, fe = Qe.horizontalScrollDirection, be = Qe.isScrolling, Be = Qe.scrollLeft, De = Re || Ue || Se || 1;
      if (Ce === 0 || xe === 0)
        return [0, 0, 0, 0];
      var Z = p(this.props, Be, this._instanceProps), X = g(this.props, Z, Be, this._instanceProps), ae = !be || fe === "backward" ? Math.max(1, De) : 1, Te = !be || fe === "forward" ? Math.max(1, De) : 1;
      return [Math.max(0, Z - ae), Math.max(0, Math.min(Ce - 1, X + Te)), Z, X];
    }, Ve._getVerticalRangeToRender = function() {
      var z = this.props, Ce = z.columnCount, Re = z.overscanCount, Ue = z.overscanRowCount, Se = z.overscanRowsCount, xe = z.rowCount, Qe = this.state, fe = Qe.isScrolling, be = Qe.verticalScrollDirection, Be = Qe.scrollTop, De = Ue || Se || Re || 1;
      if (Ce === 0 || xe === 0)
        return [0, 0, 0, 0];
      var Z = b(this.props, Be, this._instanceProps), X = A(this.props, Z, Be, this._instanceProps), ae = !fe || be === "backward" ? Math.max(1, De) : 1, Te = !fe || be === "forward" ? Math.max(1, De) : 1;
      return [Math.max(0, Z - ae), Math.max(0, Math.min(xe - 1, X + Te)), Z, X];
    }, ie;
  }(re.PureComponent), l.defaultProps = {
    direction: "ltr",
    itemData: void 0,
    useIsScrolling: !1
  }, l;
}
var Py = function(l, u) {
  var p = l.children, g = l.direction, R = l.height, y = l.innerTagName, Q = l.outerTagName, T = l.overscanColumnsCount, k = l.overscanCount, V = l.overscanRowsCount, N = l.width, b = u.instance;
  if (process.env.NODE_ENV !== "production") {
    if (typeof k == "number" && Og && !Og.has(b) && Og.add(b), (typeof T == "number" || typeof V == "number") && Bg && !Bg.has(b) && Bg.add(b), (y != null || Q != null) && wg && !wg.has(b) && wg.add(b), p == null)
      throw Error('An invalid "children" prop has been specified. Value should be a React component. ' + ('"' + (p === null ? "null" : typeof p) + '" was specified.'));
    switch (g) {
      case "ltr":
      case "rtl":
        break;
      default:
        throw Error('An invalid "direction" prop has been specified. Value should be either "ltr" or "rtl". ' + ('"' + g + '" was specified.'));
    }
    if (typeof N != "number")
      throw Error('An invalid "width" prop has been specified. Grids must specify a number for width. ' + ('"' + (N === null ? "null" : typeof N) + '" was specified.'));
    if (typeof R != "number")
      throw Error('An invalid "height" prop has been specified. Grids must specify a number for height. ' + ('"' + (R === null ? "null" : typeof R) + '" was specified.'));
  }
};
process.env.NODE_ENV;
var Yy = /* @__PURE__ */ Gy({
  getColumnOffset: function(l, u) {
    var p = l.columnWidth;
    return u * p;
  },
  getColumnWidth: function(l, u) {
    var p = l.columnWidth;
    return p;
  },
  getRowOffset: function(l, u) {
    var p = l.rowHeight;
    return u * p;
  },
  getRowHeight: function(l, u) {
    var p = l.rowHeight;
    return p;
  },
  getEstimatedTotalHeight: function(l) {
    var u = l.rowCount, p = l.rowHeight;
    return p * u;
  },
  getEstimatedTotalWidth: function(l) {
    var u = l.columnCount, p = l.columnWidth;
    return p * u;
  },
  getOffsetForColumnAndAlignment: function(l, u, p, g, R, y) {
    var Q = l.columnCount, T = l.columnWidth, k = l.width, V = Math.max(0, Q * T - k), N = Math.min(V, u * T), b = Math.max(0, u * T - k + y + T);
    switch (p === "smart" && (g >= b - k && g <= N + k ? p = "auto" : p = "center"), p) {
      case "start":
        return N;
      case "end":
        return b;
      case "center":
        var A = Math.round(b + (N - b) / 2);
        return A < Math.ceil(k / 2) ? 0 : A > V + Math.floor(k / 2) ? V : A;
      case "auto":
      default:
        return g >= b && g <= N ? g : b > N || g < b ? b : N;
    }
  },
  getOffsetForRowAndAlignment: function(l, u, p, g, R, y) {
    var Q = l.rowHeight, T = l.height, k = l.rowCount, V = Math.max(0, k * Q - T), N = Math.min(V, u * Q), b = Math.max(0, u * Q - T + y + Q);
    switch (p === "smart" && (g >= b - T && g <= N + T ? p = "auto" : p = "center"), p) {
      case "start":
        return N;
      case "end":
        return b;
      case "center":
        var A = Math.round(b + (N - b) / 2);
        return A < Math.ceil(T / 2) ? 0 : A > V + Math.floor(T / 2) ? V : A;
      case "auto":
      default:
        return g >= b && g <= N ? g : b > N || g < b ? b : N;
    }
  },
  getColumnStartIndexForOffset: function(l, u) {
    var p = l.columnWidth, g = l.columnCount;
    return Math.max(0, Math.min(g - 1, Math.floor(u / p)));
  },
  getColumnStopIndexForStartIndex: function(l, u, p) {
    var g = l.columnWidth, R = l.columnCount, y = l.width, Q = u * g, T = Math.ceil((y + p - Q) / g);
    return Math.max(0, Math.min(
      R - 1,
      u + T - 1
      // -1 is because stop index is inclusive
    ));
  },
  getRowStartIndexForOffset: function(l, u) {
    var p = l.rowHeight, g = l.rowCount;
    return Math.max(0, Math.min(g - 1, Math.floor(u / p)));
  },
  getRowStopIndexForStartIndex: function(l, u, p) {
    var g = l.rowHeight, R = l.rowCount, y = l.height, Q = u * g, T = Math.ceil((y + p - Q) / g);
    return Math.max(0, Math.min(
      R - 1,
      u + T - 1
      // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function(l) {
  },
  shouldResetStyleCacheOnItemSizeChange: !0,
  validateProps: function(l) {
    var u = l.columnWidth, p = l.rowHeight;
    if (process.env.NODE_ENV !== "production") {
      if (typeof u != "number")
        throw Error('An invalid "columnWidth" prop has been specified. Value should be a number. ' + ('"' + (u === null ? "null" : typeof u) + '" was specified.'));
      if (typeof p != "number")
        throw Error('An invalid "rowHeight" prop has been specified. Value should be a number. ' + ('"' + (p === null ? "null" : typeof p) + '" was specified.'));
    }
  }
});
const Xy = ({
  columnIndex: d,
  rowIndex: l,
  style: u,
  data: p
}) => {
  const { tileCount: g, columnCount: R, rowCount: y, allocatedWidth: Q, TileComponent: T } = p, k = l * R + d;
  if (k + 1 > g)
    return null;
  const V = l === y - 1;
  let N = 0, b = 0;
  if (V) {
    const A = g - R * l;
    if (A < R && typeof u.height == "number" && typeof u.width == "number") {
      const Ne = Math.min(
        u.height * 1.7777777777777777 * A,
        Q
      );
      b = Ne / A - u.width, N = (Q - Ne) / 2 + b * d;
    }
  }
  return /* @__PURE__ */ U.jsx(
    "div",
    {
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...u,
        left: typeof u.left == "number" ? u.left + d * 0 + N : u.left,
        width: typeof u.width == "number" ? u.width + b : u.width,
        padding: Kl >> 1,
        boxSizing: "border-box"
      },
      children: /* @__PURE__ */ U.jsx(
        T,
        {
          columnIndex: d,
          rowIndex: l,
          index: k
        }
      )
    }
  );
};
function Ky({
  TileComponent: d,
  listData: l,
  keyExtractor: u
}) {
  const p = re.useRef(null), [g, R] = re.useState({
    rows: 1,
    columns: 1,
    tileWidth: 0,
    tileHeight: 0,
    paddingVertical: 0,
    allocatedWidth: 0,
    allocatedHeight: 0
  });
  return re.useEffect(() => {
    ne.setState({
      tileDimensions: {
        tileHeight: g.tileHeight,
        tileWidth: g.tileWidth
      }
    });
  }, [g.tileHeight, g.tileWidth]), re.useLayoutEffect(() => {
    const y = p.current;
    if (!y)
      return;
    const Q = new ResizeObserver((T) => {
      R(
        _U(
          T[0].borderBoxSize[0].inlineSize,
          T[0].borderBoxSize[0].blockSize,
          l.length
        )
      );
    });
    return Q.observe(y), () => {
      Q.unobserve(y);
    };
  }, [l.length, p]), /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-tile-grid-container",
      ref: p,
      style: {
        height: "calc(100% - var(--cometchat-calls-call-footer-height) - var(--cometchat-calls-call-header-height))",
        width: "100%",
        display: "flex",
        paddingTop: g.paddingVertical,
        paddingBottom: g.paddingVertical,
        boxSizing: "border-box",
        justifyContent: "center"
      },
      children: /* @__PURE__ */ U.jsx(
        Yy,
        {
          initialScrollLeft: 0,
          initialScrollTop: 0,
          overscanRowCount: 1,
          columnCount: g.columns,
          columnWidth: g.tileWidth + Kl,
          height: g.allocatedHeight,
          rowCount: g.rows,
          rowHeight: g.tileHeight + Kl,
          itemKey: ({ rowIndex: y, columnIndex: Q, data: T }) => {
            const k = y * T.columnCount + Q;
            return k + 1 > T.tileCount ? `empty-${y}-${Q}` : u(l[k]);
          },
          width: g.allocatedWidth,
          onItemsRendered: ({
            visibleRowStartIndex: y,
            visibleRowStopIndex: Q,
            visibleColumnStartIndex: T,
            visibleColumnStopIndex: k
          }) => {
            const V = y * g.columns + T, N = Q * g.columns + k;
            ne.setState({
              visibleParticipants: {
                startIndex: V,
                endIndex: N
              }
            });
          },
          style: {
            overflow: "scroll",
            scrollbarWidth: "none"
          },
          itemData: {
            tileCount: l.length,
            columnCount: g.columns,
            rowCount: g.rows,
            allocatedWidth: g.allocatedWidth,
            allocatedHeight: g.allocatedHeight,
            TileComponent: d
          },
          children: Xy
        }
      )
    }
  );
}
const qy = ({ index: d }) => {
  const l = ru()[d];
  return /* @__PURE__ */ U.jsx(xf, { participant: l });
};
function $y() {
  const d = ru(), l = Pg(), u = fT(), p = ET(), { t: g } = fo();
  return d.length <= 0 ? null : /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
    l === ha.SPOTLIGHT && /* @__PURE__ */ U.jsx(wy, {}),
    l === ha.SIDEBAR && /* @__PURE__ */ U.jsx(Oy, {}),
    l === ha.TILE && /* @__PURE__ */ U.jsx(
      Ky,
      {
        listData: d,
        TileComponent: qy,
        keyExtractor: (R) => R.ruid
      }
    ),
    u && /* @__PURE__ */ U.jsx(A3, { message: "You've been disconnected. Attempting to reconnect…" }),
    p && /* @__PURE__ */ U.jsx(
      A3,
      {
        message: g("general.error"),
        description: p,
        showLoading: !1
      }
    ),
    /* @__PURE__ */ U.jsx(My, {}),
    /* @__PURE__ */ U.jsx(Fy, {})
  ] });
}
const z3 = (d) => {
  let l;
  const u = /* @__PURE__ */ new Set(), p = (k, V) => {
    const N = typeof k == "function" ? k(l) : k;
    if (!Object.is(N, l)) {
      const b = l;
      l = V ?? (typeof N != "object" || N === null) ? N : Object.assign({}, l, N), u.forEach((A) => A(l, b));
    }
  }, g = () => l, Q = { setState: p, getState: g, getInitialState: () => T, subscribe: (k) => (u.add(k), () => u.delete(k)) }, T = l = d(p, g, Q);
  return Q;
}, e4 = (d) => d ? z3(d) : z3, t4 = (d) => d;
function n4(d, l = t4) {
  const u = md.useSyncExternalStore(
    d.subscribe,
    () => l(d.getState()),
    () => l(d.getInitialState())
  );
  return md.useDebugValue(u), u;
}
const j3 = (d) => {
  const l = e4(d), u = (p) => n4(l, p);
  return Object.assign(u, l), u;
}, $5 = (d) => d ? j3(d) : j3, i4 = (d) => (l, u, p) => {
  const g = p.subscribe;
  return p.subscribe = (y, Q, T) => {
    let k = y;
    if (Q) {
      const V = (T == null ? void 0 : T.equalityFn) || Object.is;
      let N = y(p.getState());
      k = (b) => {
        const A = y(b);
        if (!V(N, A)) {
          const Ne = N;
          Q(N = A, Ne);
        }
      }, T != null && T.fireImmediately && Q(N, N);
    }
    return g(k);
  }, d(l, u, p);
}, a4 = i4;
function eE(d, l) {
  return (...u) => Object.assign({}, d, l(...u));
}
function r4(d, l) {
  let u;
  try {
    u = d();
  } catch {
    return;
  }
  return {
    getItem: (g) => {
      var R;
      const y = (T) => T === null ? null : JSON.parse(T, void 0), Q = (R = u.getItem(g)) != null ? R : null;
      return Q instanceof Promise ? Q.then(y) : y(Q);
    },
    setItem: (g, R) => u.setItem(g, JSON.stringify(R, void 0)),
    removeItem: (g) => u.removeItem(g)
  };
}
const JS = (d) => (l) => {
  try {
    const u = d(l);
    return u instanceof Promise ? u : {
      then(p) {
        return JS(p)(u);
      },
      catch(p) {
        return this;
      }
    };
  } catch (u) {
    return {
      then(p) {
        return this;
      },
      catch(p) {
        return JS(p)(u);
      }
    };
  }
}, o4 = (d, l) => (u, p, g) => {
  let R = {
    storage: r4(() => localStorage),
    partialize: (Ee) => Ee,
    version: 0,
    merge: (Ee, Fe) => ({
      ...Fe,
      ...Ee
    }),
    ...l
  }, y = !1;
  const Q = /* @__PURE__ */ new Set(), T = /* @__PURE__ */ new Set();
  let k = R.storage;
  if (!k)
    return d(
      (...Ee) => {
        `${R.name}`, u(...Ee);
      },
      p,
      g
    );
  const V = () => {
    const Ee = R.partialize({ ...p() });
    return k.setItem(R.name, {
      state: Ee,
      version: R.version
    });
  }, N = g.setState;
  g.setState = (Ee, Fe) => {
    N(Ee, Fe), V();
  };
  const b = d(
    (...Ee) => {
      u(...Ee), V();
    },
    p,
    g
  );
  g.getInitialState = () => b;
  let A;
  const Ne = () => {
    var Ee, Fe;
    if (!k) return;
    y = !1, Q.forEach((ie) => {
      var Ve;
      return ie((Ve = p()) != null ? Ve : b);
    });
    const he = ((Fe = R.onRehydrateStorage) == null ? void 0 : Fe.call(R, (Ee = p()) != null ? Ee : b)) || void 0;
    return JS(k.getItem.bind(k))(R.name).then((ie) => {
      if (ie)
        if (typeof ie.version == "number" && ie.version !== R.version) {
          if (R.migrate) {
            const Ve = R.migrate(
              ie.state,
              ie.version
            );
            return Ve instanceof Promise ? Ve.then((_e) => [!0, _e]) : [!0, Ve];
          }
          console.error(
            "State loaded from storage couldn't be migrated since no migrate function was provided"
          );
        } else
          return [!1, ie.state];
      return [!1, void 0];
    }).then((ie) => {
      var Ve;
      const [_e, z] = ie;
      if (A = R.merge(
        z,
        (Ve = p()) != null ? Ve : b
      ), u(A, !0), _e)
        return V();
    }).then(() => {
      he == null || he(A, void 0), A = p(), y = !0, T.forEach((ie) => ie(A));
    }).catch((ie) => {
      he == null || he(void 0, ie);
    });
  };
  return g.persist = {
    setOptions: (Ee) => {
      R = {
        ...R,
        ...Ee
      }, Ee.storage && (k = Ee.storage);
    },
    clearStorage: () => {
      k == null || k.removeItem(R.name);
    },
    getOptions: () => R,
    rehydrate: () => Ne(),
    hasHydrated: () => y,
    onHydrate: (Ee) => (Q.add(Ee), () => {
      Q.delete(Ee);
    }),
    onFinishHydration: (Ee) => (T.add(Ee), () => {
      T.delete(Ee);
    })
  }, R.skipHydration || Ne(), A || b;
}, s4 = o4, LS = {
  title: "",
  description: "",
  cancelText: "",
  confirmText: "",
  visible: !1
}, X0 = $5(
  eE(LS, (d) => ({
    onCancel: () => {
      d({ visible: !1 });
    },
    onConfirm: () => {
      d({ visible: !1 });
    },
    onBackdropClick: () => {
      d({ visible: !1 });
    },
    reset: () => {
      d(LS);
    }
  }))
);
function G3() {
  X0.setState(LS), X0.setState({
    onCancel: () => {
      X0.setState({ visible: !1 });
    },
    onConfirm: () => {
      X0.setState({ visible: !1 });
    },
    onBackdropClick: () => {
      X0.setState({ visible: !1 });
    }
  });
}
function l4(d, l, u, p, g = () => {
}, R = () => {
}) {
  X0.setState({
    title: d,
    description: l,
    confirmText: u,
    cancelText: p,
    onConfirm: () => {
      g(), G3();
    },
    onCancel: () => {
      R(), G3();
    },
    visible: !0
  });
}
function c4() {
  const {
    title: d,
    description: l,
    cancelText: u,
    confirmText: p,
    onCancel: g,
    onConfirm: R,
    onBackdropClick: y,
    visible: Q
  } = X0(), T = (k) => {
    k.target === k.currentTarget && y && y();
  };
  return Q ? /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-confirmation-dialog-backdrop",
      onClick: T,
      children: /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-confirmation-dialog", children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-confirmation-dialog-content", children: [
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-confirmation-dialog-text", children: [
          /* @__PURE__ */ U.jsx("h2", { className: "cometchat-calls-confirmation-dialog-title", children: d }),
          /* @__PURE__ */ U.jsx("p", { className: "cometchat-calls-confirmation-dialog-description", children: l })
        ] }),
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-confirmation-dialog-buttons", children: [
          /* @__PURE__ */ U.jsx(
            "button",
            {
              className: "cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-secondary",
              "data-testid": "cometchat-confirmation-dialog-cancel-button",
              onClick: g,
              children: u
            }
          ),
          /* @__PURE__ */ U.jsx(
            "button",
            {
              className: "cometchat-calls-confirmation-dialog-button cometchat-calls-confirmation-dialog-button-primary",
              "data-testid": "cometchat-confirmation-dialog-confirm-button",
              onClick: R,
              children: p
            }
          )
        ] })
      ] }) })
    }
  ) : null;
}
const d4 = [5, 15, 30], u4 = () => {
  const { t: d } = fo(), l = ne((g) => g.previewVideoTrack), u = ne((g) => g.mirrorLocalVideo), p = ne(
    (g) => g.previewVideoInputDevice
  );
  return re.useEffect(() => (YS("video", p == null ? void 0 : p.deviceId).then((g) => {
    ne.setState({ previewVideoTrack: g });
  }).catch((g) => {
    console.error("Error creating local video track:", g);
  }), () => {
    ne.setState({ previewVideoTrack: void 0 });
  }), [p]), /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-video-preview__container", children: [
    /* @__PURE__ */ U.jsx(
      rR,
      {
        videoTrack: l,
        className: en({
          "cometchat-calls-settings-video-preview__video--mirrored": u
        })
      }
    ),
    !l && /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-video-preview__placeholder", children: [
      /* @__PURE__ */ U.jsx(pt, { name: "video-fill", size: 48 }),
      /* @__PURE__ */ U.jsx("span", { children: d(
        "controlPanel.settingsDialog.videoSettings.selectCameraToSeePreview"
      ) })
    ] })
  ] });
}, oR = ({
  visible: d = !1,
  onClose: l,
  selectedTab: u = "audio"
}) => {
  const [p, g] = re.useState(u), R = ne((L) => L.audioInputDevices), y = ne((L) => L.audioOutputDevices), Q = ne((L) => L.videoInputDevices), T = ne((L) => L.audioInputDevice), k = ne((L) => L.audioOutputDevice), V = ne((L) => L.videoInputDevice), N = Rt((L) => L.sessionType), b = ne((L) => L.previewVideoInputDevice) || V, [A, Ne] = re.useState(null), Ee = ne(
    (L) => L.desktopSharingFrameRate
  ), [Fe, he] = re.useState(Ee), { t: ie } = fo(), Ve = ft((L) => L.permissions.audio), _e = ft((L) => L.permissions.video), z = ne(
    (L) => L.enableNoiseReduction
  ), Ce = re.useRef(null), Re = ne((L) => L.mirrorLocalVideo), Ue = re.useRef(null), Se = re.useRef(null), xe = re.useCallback((L) => {
    Mh(L);
  }, []), Qe = re.useCallback((L) => {
    ne.setState({
      audioOutputDevice: L
    });
  }, []), fe = re.useCallback(
    async (L) => {
      ne.setState({
        previewVideoInputDevice: L
      });
    },
    []
  ), be = re.useCallback(() => {
    kh(b), l == null || l();
  }, [l, b]), Be = (L) => {
    switch (L) {
      case "Microphone":
        return "mic-fill";
      case "Speaker":
        return "speaker-fill";
      case "Camera":
        return "video-fill";
      default:
        return "mic-fill";
    }
  }, De = re.useCallback(() => {
    Ne(null);
  }, []);
  if (re.useEffect(() => {
    if (A === "framerate") {
      const L = setTimeout(() => {
        const de = document.querySelector(
          '.cometchat-calls-settings-dropdown__list[aria-label="Frame rate options"]'
        ), ye = document.querySelector(
          ".cometchat-calls-settings-content"
        );
        if (de && ye) {
          const Ae = de.getBoundingClientRect(), Ze = ye.getBoundingClientRect();
          if (Ae.bottom, Ze.bottom, Ae.bottom > Ze.bottom) {
            const Bt = Ae.bottom - Ze.bottom + 30;
            ye.scrollBy({
              top: Bt,
              behavior: "smooth"
            });
          }
        }
      }, 10);
      return () => clearTimeout(L);
    }
  }, [A]), re.useEffect(() => {
    const L = (de) => {
      if (A && de.target instanceof Element) {
        const ye = document.querySelectorAll(
          ".cometchat-calls-settings-dropdown"
        );
        let Ae = !1;
        ye.forEach((Ze) => {
          Ze.contains(de.target) && (Ae = !0);
        }), Ae || De();
      }
    };
    if (d && A)
      return document.addEventListener("mousedown", L), () => {
        document.removeEventListener("mousedown", L);
      };
  }, [d, A, De]), re.useEffect(() => {
    if (!d) {
      Ue.current && (clearInterval(Ue.current), Ue.current = null), Se.current && (navigator.mediaDevices.removeEventListener(
        "devicechange",
        Se.current
      ), Se.current = null);
      return;
    }
    return () => {
      Ue.current && (clearInterval(Ue.current), Ue.current = null), Se.current && (navigator.mediaDevices.removeEventListener(
        "devicechange",
        Se.current
      ), Se.current = null);
    };
  }, [d]), !d)
    return null;
  const Z = (L, de, ye) => /* @__PURE__ */ U.jsxs(
    "button",
    {
      className: `cometchat-calls-settings-tab ${p === L ? "cometchat-calls-settings-tab--active" : ""}`,
      onClick: () => g(L),
      "aria-label": `${de} settings`,
      "aria-pressed": p === L,
      children: [
        /* @__PURE__ */ U.jsx(pt, { name: ye, size: 24, fill: "#858585" }),
        /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-tab__label", children: de })
      ]
    },
    L
  ), X = () => {
    if (_e && Ve)
      return null;
    const L = [];
    return Ve || L.push("microphone"), _e || L.push("camera"), /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-error-notification", children: [
      /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-error-notification__icon", children: /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "error",
          size: 20,
          fill: "var(--cometchat-calls-permission-error-color)"
        }
      ) }),
      /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-error-notification__content", children: [
        /* @__PURE__ */ U.jsx("h4", { className: "cometchat-calls-settings-error-notification__title", children: "Some permissions are missing" }),
        /* @__PURE__ */ U.jsxs("p", { className: "cometchat-calls-settings-error-notification__message", children: [
          "Access to your ",
          L.join(" and "),
          " is blocked. Please check your browser settings."
        ] })
      ] })
    ] });
  }, ae = (L, de, ye, Ae, Ze, Bt = !1) => {
    const $e = A === Ze, Ht = () => {
      Bt || Ne($e ? null : Ze);
    }, Nn = (rn) => {
      Bt || (Ae(rn), De());
    };
    return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-device-section", children: [
      /* @__PURE__ */ U.jsx("label", { className: "cometchat-calls-settings-device-label", children: L }),
      /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-dropdown", children: [
        /* @__PURE__ */ U.jsxs(
          "button",
          {
            className: `cometchat-calls-settings-dropdown__header ${$e ? "cometchat-calls-settings-dropdown__header--open" : ""} ${Bt ? "cometchat-calls-settings-dropdown__header--disabled" : ""}`,
            onClick: Ht,
            "aria-expanded": $e,
            "aria-haspopup": "listbox",
            "aria-label": `Select ${L.toLowerCase()}`,
            disabled: Bt,
            children: [
              /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-dropdown__selected", children: [
                ye && !Bt && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-dropdown__icon", children: /* @__PURE__ */ U.jsx(pt, { name: Be(L), size: 16, fill: "#fff" }) }),
                /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-dropdown__text", children: (ye == null ? void 0 : ye.label) || `No ${L.toLowerCase()} selected` })
              ] }),
              !Bt && /* @__PURE__ */ U.jsx(
                "div",
                {
                  className: `cometchat-calls-settings-dropdown__arrow ${$e ? "cometchat-calls-settings-dropdown__arrow--rotated" : ""}`,
                  children: /* @__PURE__ */ U.jsx(pt, { name: "arrow-up", size: 20, fill: "#858585" })
                }
              )
            ]
          }
        ),
        $e && !Bt && /* @__PURE__ */ U.jsx(
          "ul",
          {
            className: "cometchat-calls-settings-dropdown__list",
            role: "listbox",
            "aria-label": `${L} options`,
            children: de.map((rn) => /* @__PURE__ */ U.jsx(
              "li",
              {
                className: `cometchat-calls-settings-dropdown__option ${rn.deviceId === (ye == null ? void 0 : ye.deviceId) ? "cometchat-calls-settings-dropdown__option--selected" : ""}`,
                onClick: () => Nn(rn),
                role: "option",
                "aria-selected": rn.deviceId === (ye == null ? void 0 : ye.deviceId),
                children: /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-dropdown__option-text", children: rn.label })
              },
              rn.deviceId
            ))
          }
        )
      ] })
    ] });
  }, Te = () => /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-tab-content cometchat-calls-settings-tab-content--audio", children: [
    ae(
      ie("controlPanel.settingsDialog.deviceLabels.microphone"),
      R,
      T,
      xe,
      "microphone"
    ),
    ae(
      ie("controlPanel.settingsDialog.deviceLabels.speaker"),
      y,
      k,
      Qe,
      "speaker"
    ),
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-checkbox", children: /* @__PURE__ */ U.jsxs("label", { className: "cometchat-calls-settings-checkbox__container", children: [
      /* @__PURE__ */ U.jsx(
        "input",
        {
          type: "checkbox",
          checked: z,
          onChange: sT,
          className: "cometchat-calls-settings-checkbox__input"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "span",
        {
          className: "cometchat-calls-settings-checkbox__custom",
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-checkbox__label", children: ie(
        "controlPanel.settingsDialog.audioSettings.enableNoiseReduction"
      ) })
    ] }) })
  ] }), F = () => /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-tab-content cometchat-calls-settings-tab-content--video", children: [
    _e && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-video-preview", children: /* @__PURE__ */ U.jsx(u4, {}) }),
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-video-controls", children: [
      ae(
        ie("controlPanel.settingsDialog.deviceLabels.camera"),
        Q,
        b,
        fe,
        "camera"
      ),
      _e && /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-checkbox", children: /* @__PURE__ */ U.jsxs("label", { className: "cometchat-calls-settings-checkbox__container", children: [
          /* @__PURE__ */ U.jsx(
            "input",
            {
              type: "checkbox",
              checked: Re,
              onChange: oT,
              className: "cometchat-calls-settings-checkbox__input",
              "aria-describedby": "mirror-video-description"
            }
          ),
          /* @__PURE__ */ U.jsx(
            "span",
            {
              className: "cometchat-calls-settings-checkbox__custom",
              "aria-hidden": "true"
            }
          ),
          /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-checkbox__label", children: ie("controlPanel.settingsDialog.videoSettings.mirrorMyVideo") })
        ] }) }),
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-device-section", children: [
          /* @__PURE__ */ U.jsx("label", { className: "cometchat-calls-settings-device-label", children: ie("controlPanel.settingsDialog.deviceLabels.frameRate") }),
          /* @__PURE__ */ U.jsxs(
            "div",
            {
              className: "cometchat-calls-settings-dropdown",
              ref: Ce,
              children: [
                /* @__PURE__ */ U.jsxs(
                  "button",
                  {
                    className: `cometchat-calls-settings-dropdown__header ${A === "framerate" ? "cometchat-calls-settings-dropdown__header--open" : ""}`,
                    onClick: () => Ne(
                      A === "framerate" ? null : "framerate"
                    ),
                    "aria-expanded": A === "framerate",
                    "aria-haspopup": "listbox",
                    "aria-label": "Select frame rate",
                    children: [
                      /* @__PURE__ */ U.jsxs("span", { className: "cometchat-calls-settings-dropdown__text", children: [
                        Fe,
                        " ",
                        ie(
                          "controlPanel.settingsDialog.videoSettings.frameRateUnit"
                        )
                      ] }),
                      /* @__PURE__ */ U.jsx(
                        "div",
                        {
                          className: `cometchat-calls-settings-dropdown__arrow ${A === "framerate" ? "cometchat-calls-settings-dropdown__arrow--rotated" : ""}`,
                          children: /* @__PURE__ */ U.jsx(pt, { name: "arrow-up", size: 20, fill: "#858585" })
                        }
                      )
                    ]
                  }
                ),
                A === "framerate" && /* @__PURE__ */ U.jsx(
                  "ul",
                  {
                    className: "cometchat-calls-settings-dropdown__list",
                    role: "listbox",
                    "aria-label": "Frame rate options",
                    children: d4.map((L) => /* @__PURE__ */ U.jsx(
                      "li",
                      {
                        className: `cometchat-calls-settings-dropdown__option ${L === Fe ? "cometchat-calls-settings-dropdown__option--selected" : ""}`,
                        onClick: () => {
                          he(L), De();
                        },
                        role: "option",
                        "aria-selected": L === Fe,
                        children: /* @__PURE__ */ U.jsxs("span", { className: "cometchat-calls-settings-dropdown__option-text", children: [
                          L,
                          " ",
                          ie(
                            "controlPanel.settingsDialog.videoSettings.frameRateUnit"
                          )
                        ] })
                      },
                      L
                    ))
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-notice", children: /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-settings-notice__text", children: ie("controlPanel.settingsDialog.videoSettings.frameRateNotice") }) })
      ] })
    ] })
  ] }), H = () => {
    switch (p) {
      case "audio":
        return Te();
      case "video":
        return F();
      default:
        return /* @__PURE__ */ U.jsx(U.Fragment, {});
    }
  };
  return /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-settings-overlay", onClick: l, children: /* @__PURE__ */ U.jsxs(
    "div",
    {
      className: "cometchat-calls-settings-modal",
      onClick: (L) => L.stopPropagation(),
      children: [
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-sidebar-wrapper", children: [
          /* @__PURE__ */ U.jsx("h2", { className: "cometchat-calls-settings-sidebar__header", children: ie("controlPanel.settingsDialog.title") }),
          /* @__PURE__ */ U.jsxs(
            "nav",
            {
              className: "cometchat-calls-settings-sidebar",
              role: "navigation",
              "aria-label": ie("controlPanel.settingsDialog.title"),
              children: [
                Z(
                  "audio",
                  ie("controlPanel.settingsDialog.tabs.audio"),
                  "mic-fill"
                ),
                N === "VIDEO" && Z(
                  "video",
                  ie("controlPanel.settingsDialog.tabs.video"),
                  "video-fill"
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-content-wrapper", children: [
          /* @__PURE__ */ U.jsx("main", { className: "cometchat-calls-settings-body", children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-settings-content", children: [
            X(),
            H()
          ] }) }),
          /* @__PURE__ */ U.jsxs("footer", { className: "cometchat-calls-settings-footer", children: [
            /* @__PURE__ */ U.jsx(
              "button",
              {
                className: "cometchat-calls-settings-button cometchat-calls-settings-button--secondary",
                onClick: l,
                children: ie("controlPanel.settingsDialog.buttons.cancel")
              }
            ),
            /* @__PURE__ */ U.jsx(
              "button",
              {
                className: "cometchat-calls-settings-button cometchat-calls-settings-button--primary",
                onClick: be,
                children: ie("controlPanel.settingsDialog.buttons.done")
              }
            )
          ] })
        ] })
      ]
    }
  ) });
}, h4 = () => {
  const d = ou(We.AUDIO), l = uT(), { t: u } = fo(), [p, g] = re.useState(!1), [R, y] = re.useState(!1), [Q, T] = re.useState(!1), k = ft((fe) => fe.permissions.audio), V = TT(), [N, b] = re.useState("microphone"), A = re.useRef(null), Ne = ne((fe) => fe.audioInputDevices), Ee = ne((fe) => fe.audioOutputDevices), Fe = ne((fe) => fe.audioInputDevice), he = ne((fe) => fe.audioOutputDevice);
  re.useEffect(() => {
    const fe = (be) => {
      A.current && !A.current.contains(be.target) && (g(!1), y(!1));
    };
    if (p)
      return document.addEventListener("mousedown", fe), () => document.removeEventListener("mousedown", fe);
  }, [p]), re.useEffect(() => {
    const fe = (be) => {
      be.key === "Escape" && (p || R) && (g(!1), y(!1));
    };
    if (p || R)
      return document.addEventListener("keydown", fe), () => document.removeEventListener("keydown", fe);
  }, [p, R]);
  const ie = re.useCallback(() => {
    g((fe) => !fe), y(!1);
  }, []), Ve = re.useCallback((fe) => {
    y((be) => !be), b(fe);
  }, []), _e = re.useCallback(() => {
    T((fe) => !fe), y(!1), g(!1);
  }, []), z = re.useCallback((fe) => {
    Mh(fe), y(!1);
  }, []), Ce = re.useCallback((fe) => {
    ne.setState({
      audioOutputDevice: fe
    }), y(!1);
  }, []), Re = re.useCallback(() => {
    Ye.publish({
      type: Vt.ButtonClickListener.onToggleAudioButtonClicked
    }), $U();
  }, []);
  if (l)
    return null;
  const Ue = (fe, be) => {
    const Be = be === "microphone" ? Fe : he, De = N === be;
    return Be ? /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-selector", children: /* @__PURE__ */ U.jsx(
      "button",
      {
        className: "cometchat-calls-audio-selector__button",
        onClick: () => Ve(be),
        "aria-expanded": R && De,
        "aria-haspopup": "listbox",
        children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-audio-selector__content", children: [
          /* @__PURE__ */ U.jsx(
            pt,
            {
              name: fe,
              fill: "var(--cometchat-calls-static-white)",
              size: 24
            }
          ),
          /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-audio-selector__device-label", children: Be.label }),
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: en("cometchat-calls-audio-selector__arrow", {
                "cometchat-calls-audio-selector__arrow--open": R && De
              }),
              children: /* @__PURE__ */ U.jsx(
                pt,
                {
                  name: "arrow-up",
                  fill: "var(--cometchat-calls-static-white)",
                  size: 24
                }
              )
            }
          )
        ] })
      }
    ) }) : null;
  }, Se = N === "microphone" ? Ne : Ee, xe = N === "microphone" ? Fe : he, Qe = N === "microphone" ? z : Ce;
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-audio-control", ref: A, children: [
    !k && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-control__warning", children: /* @__PURE__ */ U.jsx(
      pt,
      {
        name: "alert",
        fill: "var(--cometchat-calls-warning-color)",
        size: 20
      }
    ) }),
    /* @__PURE__ */ U.jsx(oR, { visible: Q, onClose: _e }),
    p && /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-audio-control__dropdown-wrapper", children: [
      R && /* @__PURE__ */ U.jsx(
        "div",
        {
          className: en("cometchat-calls-audio-control__device-menu", {
            "cometchat-calls-audio-control__device-menu-speaker": N == "speaker"
          }),
          role: "listbox",
          children: Se.map((fe) => /* @__PURE__ */ U.jsxs(
            "div",
            {
              className: en(
                "cometchat-calls-audio-control__device-menu-item",
                {
                  "cometchat-calls-audio-control__device-menu-item--selected": fe.deviceId === (xe == null ? void 0 : xe.deviceId)
                }
              ),
              onClick: () => Qe(fe),
              onKeyDown: (be) => {
                (be.key === "Enter" || be.key === " ") && (be.preventDefault(), Qe(fe));
              },
              role: "option",
              "aria-selected": fe.deviceId === (xe == null ? void 0 : xe.deviceId),
              tabIndex: 0,
              children: [
                /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-control__device-menu-icon", children: fe.deviceId === (xe == null ? void 0 : xe.deviceId) ? /* @__PURE__ */ U.jsx(
                  pt,
                  {
                    name: "check-fill",
                    fill: "var(--cometchat-calls-static-white)",
                    size: 24
                  }
                ) : null }),
                /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-audio-control__device-menu-label", children: fe.label })
              ]
            },
            fe.deviceId
          ))
        }
      ),
      /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-audio-control__dropdown-bar", children: [
        Fe && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-control__section", children: Ue("mic-fill", "microphone") }),
        he && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-control__section", children: Ue("speaker-fill", "speaker") }),
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-audio-control__section cometchat-calls-audio-control__section--settings", children: /* @__PURE__ */ U.jsx(
          "button",
          {
            className: "cometchat-calls-audio-control__settings-button",
            onClick: _e,
            "aria-label": u("controlPanel.audioControl.audioSettings"),
            title: u("controlPanel.audioControl.audioSettings"),
            children: /* @__PURE__ */ U.jsx(
              pt,
              {
                name: "settings",
                fill: "var(--cometchat-calls-static-white)",
                size: 24
              }
            )
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ U.jsxs(
      "div",
      {
        className: en("cometchat-calls-audio-control__wrapper", {
          "cometchat-calls-audio-control__wrapper--active": d
        }),
        children: [
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__button-wrapper",
              onClick: Re,
              "data-testid": "cometchat-audio-toggle-button",
              "aria-label": u(d ? "controlPanel.audioControl.unmuteMicrophone" : "controlPanel.audioControl.muteMicrophone"),
              children: /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-audio-control__button",
                  title: u(d ? "controlPanel.audioControl.unmuteMicrophone" : "controlPanel.audioControl.muteMicrophone"),
                  children: /* @__PURE__ */ U.jsx(
                    pt,
                    {
                      name: d ? "mic-off-fill" : "mic-fill",
                      fill: d ? "var(--cometchat-calls-error-color)" : "var(--cometchat-calls-static-white)"
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__divider",
              onClick: Re
            }
          ),
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-audio-control__arrow-wrapper",
              onClick: V ? ie : void 0,
              "aria-label": u("controlPanel.audioControl.audioDeviceOptions"),
              "aria-expanded": p,
              "aria-disabled": !V,
              children: /* @__PURE__ */ U.jsx(
                "button",
                {
                  disabled: !V,
                  className: en("cometchat-calls-audio-control__arrow-button", {
                    "cometchat-calls-audio-control__arrow-button-open": p
                  }),
                  title: u("controlPanel.audioControl.audioDeviceOptions"),
                  children: /* @__PURE__ */ U.jsx(
                    pt,
                    {
                      name: "arrow-up",
                      fill: "var(--cometchat-calls-static-white)",
                      size: 16
                    }
                  )
                }
              )
            }
          )
        ]
      }
    )
  ] });
}, m4 = () => {
  const d = ou(We.VIDEO), { t: l } = fo(), u = hT(), [p, g] = re.useState(!1), [R, y] = re.useState(!1), Q = re.useRef(null), T = ne((_e) => _e.videoInputDevices), k = ft((_e) => _e.permissions.video), V = yT(), N = ne((_e) => _e.videoInputDevice), [b, A] = re.useState(!1), Ne = re.useCallback(() => {
    A((_e) => !_e), y(!1), g(!1);
  }, []);
  re.useEffect(() => {
    const _e = (z) => {
      Q.current && !Q.current.contains(z.target) && (g(!1), y(!1));
    };
    if (p)
      return document.addEventListener("mousedown", _e), () => document.removeEventListener("mousedown", _e);
  }, [p]), re.useEffect(() => {
    const _e = (z) => {
      z.key === "Escape" && (p || R) && (g(!1), y(!1));
    };
    if (p || R)
      return document.addEventListener("keydown", _e), () => document.removeEventListener("keydown", _e);
  }, [p, R]);
  const Ee = re.useCallback(() => {
    g((_e) => !_e), y(!1);
  }, []), Fe = re.useCallback(() => {
    y((_e) => !_e);
  }, []), he = re.useCallback(
    async (_e) => {
      kh(_e), y(!1);
    },
    []
  ), ie = re.useCallback(() => {
    Ye.publish({
      type: Vt.ButtonClickListener.onToggleVideoButtonClicked
    }), eT();
  }, []);
  if (u)
    return null;
  const Ve = () => N ? /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-video-selector", children: /* @__PURE__ */ U.jsx(
    "button",
    {
      className: "cometchat-calls-video-selector__button",
      onClick: Fe,
      "aria-expanded": R,
      "aria-haspopup": "listbox",
      children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-video-selector__content", children: [
        /* @__PURE__ */ U.jsx(
          pt,
          {
            name: "video-fill",
            fill: "var(--cometchat-calls-static-white)",
            size: 24
          }
        ),
        /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-video-selector__device-label", children: N.label }),
        /* @__PURE__ */ U.jsx(
          "div",
          {
            className: en("cometchat-calls-video-selector__arrow", {
              "cometchat-calls-video-selector__arrow--open": R
            }),
            children: /* @__PURE__ */ U.jsx(
              pt,
              {
                name: "arrow-up",
                fill: "var(--cometchat-calls-static-white)",
                size: 24
              }
            )
          }
        )
      ] })
    }
  ) }) : null;
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-video-control", ref: Q, children: [
    !k && /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-video-control__warning", children: [
      " ",
      /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "alert",
          fill: "var(--cometchat-calls-warning-color)",
          size: 20
        }
      )
    ] }),
    /* @__PURE__ */ U.jsx(
      oR,
      {
        selectedTab: "video",
        visible: b,
        onClose: Ne
      }
    ),
    p && /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-video-control__dropdown-wrapper", children: [
      R && /* @__PURE__ */ U.jsx(
        "div",
        {
          className: "cometchat-calls-video-control__device-menu",
          role: "listbox",
          children: T.map((_e) => /* @__PURE__ */ U.jsxs(
            "div",
            {
              className: en(
                "cometchat-calls-video-control__device-menu-item",
                {
                  "cometchat-calls-video-control__device-menu-item--selected": _e.deviceId === (N == null ? void 0 : N.deviceId)
                }
              ),
              onClick: () => he(_e),
              onKeyDown: (z) => {
                (z.key === "Enter" || z.key === " ") && (z.preventDefault(), he(_e));
              },
              role: "option",
              "aria-selected": _e.deviceId === (N == null ? void 0 : N.deviceId),
              tabIndex: 0,
              children: [
                /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-video-control__device-menu-icon", children: _e.deviceId === (N == null ? void 0 : N.deviceId) ? /* @__PURE__ */ U.jsx(
                  pt,
                  {
                    name: "check-fill",
                    fill: "var(--cometchat-calls-static-white)",
                    size: 24
                  }
                ) : null }),
                /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-video-control__device-menu-label", children: _e.label })
              ]
            },
            _e.deviceId
          ))
        }
      ),
      /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-video-control__dropdown-bar", children: [
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-video-control__section", children: Ve() }),
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-video-control__section cometchat-calls-video-control__section--settings", children: /* @__PURE__ */ U.jsx(
          "button",
          {
            className: "cometchat-calls-video-control__settings-button",
            onClick: Ne,
            "aria-label": l("controlPanel.videoControl.videoSettings"),
            title: l("controlPanel.videoControl.videoSettings"),
            children: /* @__PURE__ */ U.jsx(
              pt,
              {
                name: "settings",
                fill: "var(--cometchat-calls-static-white)",
                size: 24
              }
            )
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ U.jsxs(
      "div",
      {
        className: en("cometchat-calls-video-control__wrapper", {
          "cometchat-calls-video-control__wrapper--active": d
        }),
        children: [
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__button-wrapper",
              onClick: ie,
              "data-testid": "cometchat-video-toggle-button",
              "aria-label": l(d ? "controlPanel.videoControl.turnOnCamera" : "controlPanel.videoControl.turnOffCamera"),
              children: /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-video-control__button",
                  title: l(d ? "controlPanel.videoControl.turnOnCamera" : "controlPanel.videoControl.turnOffCamera"),
                  children: /* @__PURE__ */ U.jsx(
                    pt,
                    {
                      name: d ? "video-off-fill" : "video-fill",
                      fill: d ? "var(--cometchat-calls-error-color)" : "var(--cometchat-calls-static-white)"
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__divider",
              onClick: ie
            }
          ),
          /* @__PURE__ */ U.jsx(
            "div",
            {
              className: "cometchat-calls-video-control__arrow-wrapper",
              onClick: V ? Ee : void 0,
              "aria-disabled": !V,
              children: /* @__PURE__ */ U.jsx(
                "button",
                {
                  disabled: !V,
                  className: en("cometchat-calls-video-control__arrow-button", {
                    "cometchat-calls-video-control__arrow-button-open": p
                  }),
                  "aria-label": l("controlPanel.videoControl.videoDeviceOptions"),
                  "aria-expanded": p,
                  title: l("controlPanel.videoControl.videoDeviceOptions"),
                  children: /* @__PURE__ */ U.jsx(
                    pt,
                    {
                      name: "arrow-up",
                      fill: "var(--cometchat-calls-static-white)",
                      size: 16
                    }
                  )
                }
              )
            }
          )
        ]
      }
    )
  ] });
}, p4 = ({
  iconName: d,
  label: l,
  onClick: u,
  selected: p = !1,
  disabled: g = !1
}) => /* @__PURE__ */ U.jsxs(
  "div",
  {
    className: en(
      "cometchat-calls-more-menu-item",
      p && "cometchat-calls-more-menu-item--selected",
      g && "cometchat-calls-more-menu-item--disabled"
    ),
    onClick: () => {
      g || u();
    },
    role: "menuitem",
    tabIndex: g ? -1 : 0,
    "aria-selected": p,
    "aria-disabled": g,
    onKeyDown: (R) => {
      !g && (R.key === "Enter" || R.key === " ") && u();
    },
    children: [
      /* @__PURE__ */ U.jsx(
        pt,
        {
          name: d,
          size: 24,
          fill: "var(--cometchat-calls-text-color-secondary)"
        }
      ),
      " ",
      /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-more-menu-item-label", children: l })
    ]
  }
), f4 = ({
  isVisible: d,
  onClose: l,
  anchorElement: u,
  toggleSettings: p,
  toggleVirtualBackground: g,
  isMobileView: R = !1
}) => {
  const y = re.useRef(null), { t: Q } = fo(), T = ne((Ue) => Ue.isMobileBrowser), k = UT(), V = re.useCallback(() => {
    if (!u || !y.current)
      return;
    const Ue = u.getBoundingClientRect(), Se = y.current, xe = Se.getBoundingClientRect(), Qe = window.innerWidth, fe = window.innerHeight;
    let be = fe - Ue.top + 8, Be = Ue.left + Ue.width / 2 - xe.width / 2;
    Be < 8 ? Be = 8 : Be + xe.width > Qe - 8 && (Be = Qe - xe.width - 8), be + xe.height > fe - 8 && (be = fe - Ue.bottom - 8), be + xe.height > fe - 8 && (be = 8), Se.style.bottom = `${be}px`, Se.style.left = `${Be}px`, Se.style.top = "auto";
  }, [u]);
  re.useEffect(() => {
    const Ue = () => {
      d && u && y.current && V();
    };
    if (d)
      return window.addEventListener("resize", Ue), () => window.removeEventListener("resize", Ue);
  }, [d, u, V]), re.useEffect(() => {
    d && u && y.current && requestAnimationFrame(() => {
      V();
    });
  }, [d, u, V, R]), re.useEffect(() => {
    const Ue = (Se) => {
      y.current && !y.current.contains(Se.target) && !(u != null && u.contains(Se.target)) && (l == null || l());
    };
    if (d)
      return document.addEventListener("mousedown", Ue), () => document.removeEventListener("mousedown", Ue);
  }, [d, l, u]);
  const N = Yg(), b = b5(), A = gT(), Ne = vT(), Ee = Rt(
    (Ue) => Ue.hideRaiseHandButton
  ), Fe = k5(), he = re.useCallback(
    (Ue) => {
      Ue(), l == null || l();
    },
    [l]
  ), ie = re.useCallback(() => {
    Ye.publish({
      type: Vt.ButtonClickListener.onRecordingToggleButtonClicked
    }), l4(
      Q(b ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      Q(b ? "controlPanel.recording.stopRecordingConfirmation" : "controlPanel.recording.startRecordingConfirmation"),
      Q(b ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      Q("controlPanel.recording.cancel"),
      () => {
        YU();
      }
    );
  }, [b, Q]), Ve = () => {
    g && g();
  }, _e = () => {
    p && p();
  }, z = [
    !Ne && {
      iconName: "virtual-background",
      label: "Virtual Background",
      onClick: () => he(Ve),
      id: "vb"
    },
    !A && {
      iconName: b ? "record-stop-fill" : "record-fill",
      label: Q(b ? "controlPanel.recording.stopRecording" : "controlPanel.recording.startRecording"),
      onClick: () => he(ie),
      id: "rec"
    },
    // {
    //   iconName: 'stats' as IconName,
    //   label: 'Participants Stats',
    //   onClick: () => handleItemClick(handleParticipantsStats),
    //   id: 'pstats',
    // },
    !T && {
      iconName: "settings",
      label: "Settings",
      onClick: () => he(_e),
      id: "settings"
    },
    k && {
      iconName: "switch-camera",
      label: "Switch Camera",
      onClick: () => {
        he(x5);
      },
      id: "switch-camera"
    }
  ].filter(Boolean), Ce = [
    !Ee && {
      iconName: "raise-hand-fill",
      label: N ? "Lower Hand" : "Raise Hand",
      onClick: () => he(N5),
      selected: !!N,
      id: "raisehand"
    },
    !Fe && {
      iconName: "screen-share",
      label: "Start Screen Share",
      onClick: () => he(eR),
      id: "screenshare"
    }
  ].filter(Boolean), Re = R ? [...Ce, ...z] : z;
  return d ? /* @__PURE__ */ U.jsxs(U.Fragment, { children: [
    /* @__PURE__ */ U.jsx(
      "div",
      {
        className: "cometchat-calls-more-menu-overlay",
        onClick: l,
        "data-testid": "more-menu-overlay"
      }
    ),
    /* @__PURE__ */ U.jsx(
      "div",
      {
        ref: y,
        className: "cometchat-calls-more-menu-container",
        role: "menu",
        "aria-orientation": "vertical",
        children: Re.map((Ue) => /* @__PURE__ */ U.jsx(
          p4,
          {
            iconName: Ue.iconName,
            label: Ue.label,
            onClick: Ue.onClick,
            selected: Ue.selected || !1
          },
          Ue.id
        ))
      }
    )
  ] }) : null;
};
function g4() {
  return WebAssembly.validate(
    new Uint8Array([
      0,
      97,
      115,
      109,
      1,
      0,
      0,
      0,
      1,
      5,
      1,
      96,
      0,
      1,
      123,
      3,
      2,
      1,
      0,
      10,
      10,
      1,
      8,
      0,
      65,
      0,
      253,
      15,
      253,
      98,
      11
    ])
  );
}
const Dg = {
  IMAGE: "image"
}, IS = 1, tE = 2, nE = 3, v4 = `
    var timer;

    onmessage = function(request) {
        switch (request.data.id) {
        case ${IS}: {
            timer = setTimeout(() => {
                postMessage({ id: ${nE} });
            }, request.data.timeMs);
            break;
        }
        case ${tE}: {
            if (timer) {
                clearTimeout(timer);
            }
            break;
        }
        }
    };
`, S4 = URL.createObjectURL(
  new Blob([v4], { type: "application/javascript" })
);
class R4 {
  /**
   * Represents a modified video MediaStream track.
   *
   * @class
   * @param {Object} model - Meet model.
   * @param {Object} options - Segmentation dimensions.
   */
  constructor(l, u) {
    P(this, "_model");
    P(this, "_options");
    P(this, "_stream");
    P(this, "_segmentationPixelCount");
    P(this, "_inputVideoElement");
    P(this, "_maskFrameTimerWorker");
    P(this, "_outputCanvasElement");
    P(this, "_outputCanvasCtx", null);
    P(this, "_segmentationMaskCtx", null);
    P(this, "_segmentationMask");
    P(this, "_segmentationMaskCanvas");
    P(this, "_virtualImage");
    P(this, "_virtualVideo");
    this._options = u, this._options.virtualBackground.backgroundType === Dg.IMAGE && (this._virtualImage = document.createElement("img"), this._virtualImage.crossOrigin = "anonymous", this._virtualImage.src = this._options.virtualBackground.virtualSource ?? ""), this._model = l, this._segmentationPixelCount = this._options.width * this._options.height, this._onMaskFrameTimer = this._onMaskFrameTimer.bind(this), this._outputCanvasElement = document.createElement("canvas"), this._outputCanvasElement.getContext("2d"), this._inputVideoElement = document.createElement("video");
  }
  /**
   * EventHandler onmessage for the maskFrameTimerWorker WebWorker.
   *
   * @private
   * @param {EventHandler} response - The onmessage EventHandler parameter.
   * @returns {void}
   */
  _onMaskFrameTimer(l) {
    l.data.id === nE && this._renderMask();
  }
  /**
   * Represents the run post processing.
   *
   * @returns {void}
   */
  runPostProcessing() {
    var R, y, Q, T;
    const l = this._stream.getVideoTracks()[0], { height: u, width: p } = l.getSettings() ?? l.getConstraints(), { backgroundType: g } = this._options.virtualBackground;
    this._outputCanvasCtx && (this._outputCanvasElement.height = u, this._outputCanvasElement.width = p, this._outputCanvasCtx.globalCompositeOperation = "copy", this._outputCanvasCtx.filter = g === Dg.IMAGE ? "blur(4px)" : "blur(8px)", (R = this._outputCanvasCtx) == null || R.drawImage(
      this._segmentationMaskCanvas,
      0,
      0,
      this._options.width,
      this._options.height,
      0,
      0,
      this._inputVideoElement.width,
      this._inputVideoElement.height
    ), this._outputCanvasCtx.globalCompositeOperation = "source-in", this._outputCanvasCtx.filter = "none", (y = this._outputCanvasCtx) == null || y.drawImage(this._inputVideoElement, 0, 0), this._outputCanvasCtx.globalCompositeOperation = "destination-over", g === Dg.IMAGE ? (Q = this._outputCanvasCtx) == null || Q.drawImage(
      g === Dg.IMAGE ? this._virtualImage : this._virtualVideo,
      0,
      0,
      this._outputCanvasElement.width,
      this._outputCanvasElement.height
    ) : (this._outputCanvasCtx.filter = `blur(${this._options.virtualBackground.blurValue}px)`, (T = this._outputCanvasCtx) == null || T.drawImage(this._inputVideoElement, 0, 0)));
  }
  /**
   * Represents the run Tensorflow Interference.
   *
   * @returns {void}
   */
  runInference() {
    var u;
    this._model._runInference();
    const l = this._model._getOutputMemoryOffset() / 4;
    for (let p = 0; p < this._segmentationPixelCount; p++) {
      const g = this._model.HEAPF32[l + p];
      this._segmentationMask.data[p * 4 + 3] = 255 * g;
    }
    (u = this._segmentationMaskCtx) == null || u.putImageData(this._segmentationMask, 0, 0);
  }
  /**
   * Loop function to render the background mask.
   *
   * @private
   * @returns {void}
   */
  _renderMask() {
    this.resizeSource(), this.runInference(), this.runPostProcessing(), this._maskFrameTimerWorker.postMessage({
      id: IS,
      timeMs: 1e3 / 30
    });
  }
  /**
   * Represents the resize source process.
   *
   * @returns {void}
   */
  resizeSource() {
    var p, g;
    (p = this._segmentationMaskCtx) == null || p.drawImage(
      this._inputVideoElement,
      0,
      0,
      this._inputVideoElement.width,
      this._inputVideoElement.height,
      0,
      0,
      this._options.width,
      this._options.height
    );
    const l = (g = this._segmentationMaskCtx) == null ? void 0 : g.getImageData(
      0,
      0,
      this._options.width,
      this._options.height
    ), u = this._model._getInputMemoryOffset() / 4;
    for (let R = 0; R < this._segmentationPixelCount; R++)
      this._model.HEAPF32[u + R * 3] = Number(l == null ? void 0 : l.data[R * 4]) / 255, this._model.HEAPF32[u + R * 3 + 1] = Number(l == null ? void 0 : l.data[R * 4 + 1]) / 255, this._model.HEAPF32[u + R * 3 + 2] = Number(l == null ? void 0 : l.data[R * 4 + 2]) / 255;
  }
  /**
   * Checks if the local track supports this effect.
   *
   * @param {JitsiLocalTrack} jitsiLocalTrack - Track to apply effect.
   * @returns {boolean} - Returns true if this effect can run on the specified track
   * false otherwise.
   */
  isEnabled(l) {
    return l.isVideoTrack() && l.videoType === "camera";
  }
  /**
   * Starts loop to capture video frame and render the segmentation mask.
   *
   * @param {MediaStream} stream - Stream to be used for processing.
   * @returns {MediaStream} - The stream with the applied effect.
   */
  startEffect(l) {
    this._stream = l, this._maskFrameTimerWorker = new Worker(S4, {
      name: "Blur effect worker"
    }), this._maskFrameTimerWorker.onmessage = this._onMaskFrameTimer;
    const u = this._stream.getVideoTracks()[0], { height: p, frameRate: g, width: R } = u.getSettings ? u.getSettings() : u.getConstraints();
    return this._segmentationMask = new ImageData(
      this._options.width,
      this._options.height
    ), this._segmentationMaskCanvas = document.createElement("canvas"), this._segmentationMaskCanvas.width = this._options.width, this._segmentationMaskCanvas.height = this._options.height, this._segmentationMaskCtx = this._segmentationMaskCanvas.getContext("2d", {
      willReadFrequently: !0
    }), this._outputCanvasElement.width = parseInt(R, 10), this._outputCanvasElement.height = parseInt(p, 10), this._outputCanvasCtx = this._outputCanvasElement.getContext("2d"), this._inputVideoElement.width = parseInt(R, 10), this._inputVideoElement.height = parseInt(p, 10), this._inputVideoElement.autoplay = !0, this._inputVideoElement.srcObject = this._stream, this._inputVideoElement.onloadeddata = () => {
      this._maskFrameTimerWorker.postMessage({
        id: IS,
        timeMs: 1e3 / 30
      });
    }, this._outputCanvasElement.captureStream(parseInt(g, 10));
  }
  /**
   * Stops the capture and render loop.
   *
   * @returns {void}
   */
  stopEffect() {
    this._maskFrameTimerWorker.postMessage({
      id: tE
    }), this._maskFrameTimerWorker.terminate();
  }
}
function P3(d, l) {
  return new Promise((u, p) => {
    setTimeout(() => {
      p(new Error("408"));
    }, d), l.then(u, p);
  });
}
const E4 = "https://cdn.cometchat-staging.com/calls/v5/tflite.wasm";
var Ag = function() {
  var d = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (d = d || __filename), function(l) {
    l = l || {}, l.locateFile = function(D, B) {
      return D.endsWith(".wasm") ? D : B + D;
    };
    var u = typeof l < "u" ? l : {}, p, g;
    u.ready = new Promise(function(D, B) {
      p = D, g = B;
    });
    var R = {}, y;
    for (y in u)
      u.hasOwnProperty(y) && (R[y] = u[y]);
    var Q = "./this.program", T = function(D, B) {
      throw B;
    }, k = !1, V = !1, N = !1, b = !1;
    k = typeof window == "object", V = typeof importScripts == "function", N = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string", b = !k && !N && !V;
    var A = "";
    function Ne(D) {
      return u.locateFile ? u.locateFile(D, A) : A + D;
    }
    var Ee, Fe, he, ie, Ve;
    N ? (V ? A = require("path").dirname(A) + "/" : A = __dirname + "/", Ee = function(B, pe) {
      return ie || (ie = require("fs")), Ve || (Ve = require("path")), B = Ve.normalize(B), ie.readFileSync(B, pe ? null : "utf8");
    }, he = function(B) {
      var pe = Ee(B, !0);
      return pe.buffer || (pe = new Uint8Array(pe)), xe(pe.buffer), pe;
    }, process.argv.length > 1 && (Q = process.argv[1].replace(/\\/g, "/")), process.argv.slice(2), process.on("uncaughtException", function(D) {
      if (!(D instanceof Tr))
        throw D;
    }), process.on("unhandledRejection", Qt), T = function(D) {
      process.exit(D);
    }, u.inspect = function() {
      return "[Emscripten Module object]";
    }) : b ? (typeof read < "u" && (Ee = function(B) {
      return read(B);
    }), he = function(B) {
      var pe;
      return typeof readbuffer == "function" ? new Uint8Array(readbuffer(B)) : (pe = read(B, "binary"), xe(typeof pe == "object"), pe);
    }, typeof scriptArgs < "u" && scriptArgs, typeof quit == "function" && (T = function(D) {
      quit(D);
    }), typeof print < "u" && (typeof console > "u" && (console = {}), console.log = print, console.warn = console.error = typeof printErr < "u" ? printErr : print)) : (k || V) && (V ? A = self.location.href : typeof document < "u" && document.currentScript && (A = document.currentScript.src), d && (A = d), A.indexOf("blob:") !== 0 ? A = A.substr(0, A.lastIndexOf("/") + 1) : A = "", Ee = function(D) {
      var B = new XMLHttpRequest();
      return B.open("GET", D, !1), B.send(null), B.responseText;
    }, V && (he = function(D) {
      var B = new XMLHttpRequest();
      return B.open("GET", D, !1), B.responseType = "arraybuffer", B.send(null), new Uint8Array(B.response);
    }), Fe = function(D, B, pe) {
      var Ie = new XMLHttpRequest();
      Ie.open("GET", D, !0), Ie.responseType = "arraybuffer", Ie.onload = function() {
        if (Ie.status == 200 || Ie.status == 0 && Ie.response) {
          B(Ie.response);
          return;
        }
        pe();
      }, Ie.onerror = pe, Ie.send(null);
    });
    var _e = u.print || console.log.bind(console), z = u.printErr || console.warn.bind(console);
    for (y in R)
      R.hasOwnProperty(y) && (u[y] = R[y]);
    R = null, u.arguments && u.arguments, u.thisProgram && (Q = u.thisProgram), u.quit && (T = u.quit);
    var Ce;
    u.wasmBinary && (Ce = u.wasmBinary);
    var Re;
    u.noExitRuntime && (Re = u.noExitRuntime), typeof WebAssembly != "object" && Qt("no native wasm support detected");
    var Ue, Se = !1;
    function xe(D, B) {
      D || Qt("Assertion failed: " + B);
    }
    var Qe = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function fe(D, B, pe) {
      for (var Ie = B + pe, ot = B; D[ot] && !(ot >= Ie); ) ++ot;
      if (ot - B > 16 && D.subarray && Qe)
        return Qe.decode(D.subarray(B, ot));
      for (var Ke = ""; B < ot; ) {
        var qe = D[B++];
        if (!(qe & 128)) {
          Ke += String.fromCharCode(qe);
          continue;
        }
        var dt = D[B++] & 63;
        if ((qe & 224) == 192) {
          Ke += String.fromCharCode((qe & 31) << 6 | dt);
          continue;
        }
        var qt = D[B++] & 63;
        if ((qe & 240) == 224 ? qe = (qe & 15) << 12 | dt << 6 | qt : qe = (qe & 7) << 18 | dt << 12 | qt << 6 | D[B++] & 63, qe < 65536)
          Ke += String.fromCharCode(qe);
        else {
          var Gi = qe - 65536;
          Ke += String.fromCharCode(55296 | Gi >> 10, 56320 | Gi & 1023);
        }
      }
      return Ke;
    }
    function be(D, B) {
      return D ? fe(ae, D, B) : "";
    }
    function Be(D, B, pe) {
      for (var Ie = 0; Ie < D.length; ++Ie)
        X[B++ >> 0] = D.charCodeAt(Ie);
      X[B >> 0] = 0;
    }
    function De(D, B) {
      return D % B > 0 && (D += B - D % B), D;
    }
    var Z, X, ae, Te;
    function F(D) {
      Z = D, u.HEAP8 = X = new Int8Array(D), u.HEAP16 = new Int16Array(D), u.HEAP32 = Te = new Int32Array(D), u.HEAPU8 = ae = new Uint8Array(D), u.HEAPU16 = new Uint16Array(D), u.HEAPU32 = new Uint32Array(D), u.HEAPF32 = new Float32Array(D), u.HEAPF64 = new Float64Array(D);
    }
    u.INITIAL_MEMORY;
    var H, L = [], de = [], ye = [], Ae = [];
    de.push({ func: function() {
      Da();
    } });
    function Ze() {
      if (u.preRun)
        for (typeof u.preRun == "function" && (u.preRun = [u.preRun]); u.preRun.length; )
          Nn(u.preRun.shift());
      ni(L);
    }
    function Bt() {
      ni(de);
    }
    function $e() {
      ni(ye);
    }
    function Ht() {
      if (u.postRun)
        for (typeof u.postRun == "function" && (u.postRun = [u.postRun]); u.postRun.length; )
          rn(u.postRun.shift());
      ni(Ae);
    }
    function Nn(D) {
      L.unshift(D);
    }
    function rn(D) {
      Ae.unshift(D);
    }
    var tn = 0, gn = null;
    function Ma(D) {
      tn++, u.monitorRunDependencies && u.monitorRunDependencies(tn);
    }
    function go(D) {
      if (tn--, u.monitorRunDependencies && u.monitorRunDependencies(tn), tn == 0 && gn) {
        var B = gn;
        gn = null, B();
      }
    }
    u.preloadedImages = {}, u.preloadedAudios = {};
    function Qt(D) {
      u.onAbort && u.onAbort(D), D += "", z(D), Se = !0, D = "abort(" + D + "). Build with -s ASSERTIONS=1 for more info.";
      var B = new WebAssembly.RuntimeError(D);
      throw g(B), B;
    }
    function vn(D, B) {
      return String.prototype.startsWith ? D.startsWith(B) : D.indexOf(B) === 0;
    }
    var ka = "data:application/octet-stream;base64,";
    function Rr(D) {
      return vn(D, ka);
    }
    var gt = "file://";
    function bi(D) {
      return vn(D, gt);
    }
    var Lt = E4;
    Rr(Lt) || (Lt = Ne(Lt));
    function xi(D) {
      try {
        if (D == Lt && Ce)
          return new Uint8Array(Ce);
        if (he)
          return he(D);
        throw "both async and sync fetching of the wasm failed";
      } catch (B) {
        Qt(B);
      }
    }
    function qo() {
      if (!Ce && (k || V)) {
        if (typeof fetch == "function" && !bi(Lt))
          return fetch(Lt, { credentials: "same-origin" }).then(function(D) {
            if (!D.ok)
              throw "failed to load wasm binary file at '" + Lt + "'";
            return D.arrayBuffer();
          }).catch(function() {
            return xi(Lt);
          });
        if (Fe)
          return new Promise(function(D, B) {
            Fe(Lt, function(pe) {
              D(new Uint8Array(pe));
            }, B);
          });
      }
      return Promise.resolve().then(function() {
        return xi(Lt);
      });
    }
    function vo() {
      var D = { a: Yn };
      function B(qe, dt) {
        var qt = qe.exports;
        u.asm = qt, Ue = u.asm.q, F(Ue.buffer), H = u.asm.D, go();
      }
      Ma();
      function pe(qe) {
        B(qe.instance);
      }
      function Ie(qe) {
        return qo().then(function(dt) {
          return WebAssembly.instantiate(dt, D);
        }).then(qe, function(dt) {
          z("failed to asynchronously prepare wasm: " + dt), Qt(dt);
        });
      }
      function ot() {
        return !Ce && typeof WebAssembly.instantiateStreaming == "function" && !Rr(Lt) && !bi(Lt) && typeof fetch == "function" ? fetch(Lt, { credentials: "same-origin" }).then(function(qe) {
          var dt = WebAssembly.instantiateStreaming(qe, D);
          return dt.then(pe, function(qt) {
            return z("wasm streaming compile failed: " + qt), z("falling back to ArrayBuffer instantiation"), Ie(pe);
          });
        }) : Ie(pe);
      }
      if (u.instantiateWasm)
        try {
          var Ke = u.instantiateWasm(D, B);
          return Ke;
        } catch (qe) {
          return z("Module.instantiateWasm callback failed with error: " + qe), !1;
        }
      return ot().catch(g), {};
    }
    function ni(D) {
      for (; D.length > 0; ) {
        var B = D.shift();
        if (typeof B == "function") {
          B(u);
          continue;
        }
        var pe = B.func;
        typeof pe == "number" ? B.arg === void 0 ? H.get(pe)() : H.get(pe)(B.arg) : pe(B.arg === void 0 ? null : B.arg);
      }
    }
    function Jn() {
      Qt();
    }
    var un;
    N ? un = function() {
      var D = process.hrtime();
      return D[0] * 1e3 + D[1] / 1e6;
    } : typeof dateNow < "u" ? un = dateNow : un = function() {
      return performance.now();
    };
    var Ln = !0;
    function Qa(D) {
      return Te[Ur() >> 2] = D, D;
    }
    function So(D, B) {
      var pe;
      if (D === 0)
        pe = Date.now();
      else if ((D === 1 || D === 4) && Ln)
        pe = un();
      else
        return Qa(28), -1;
      return Te[B >> 2] = pe / 1e3 | 0, Te[B + 4 >> 2] = pe % 1e3 * 1e3 * 1e3 | 0, 0;
    }
    function Er(D, B) {
      Qt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function Zi(D, B) {
      Qt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function ii(D, B, pe) {
      ae.copyWithin(D, B, B + pe);
    }
    function In() {
      return ae.length;
    }
    function Oi(D) {
      try {
        return Ue.grow(D - Z.byteLength + 65535 >>> 16), F(Ue.buffer), 1;
      } catch {
      }
    }
    function C(D) {
      D = D >>> 0;
      var B = In(), pe = 2147483648;
      if (D > pe)
        return !1;
      for (var Ie = 16777216, ot = 1; ot <= 4; ot *= 2) {
        var Ke = B * (1 + 0.2 / ot);
        Ke = Math.min(Ke, D + 100663296);
        var qe = Math.min(pe, De(Math.max(Ie, D, Ke), 65536)), dt = Oi(qe);
        if (dt)
          return !0;
      }
      return !1;
    }
    function j(D) {
      for (var B = un(); un() - B < D; )
        ;
    }
    var ke = {};
    function Oe() {
      return Q || "./this.program";
    }
    function Je() {
      if (!Je.strings) {
        var D = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", B = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: D, _: Oe() };
        for (var pe in ke)
          B[pe] = ke[pe];
        var Ie = [];
        for (var pe in B)
          Ie.push(pe + "=" + B[pe]);
        Je.strings = Ie;
      }
      return Je.strings;
    }
    var nt = { mappings: {}, buffers: [null, [], []], printChar: function(D, B) {
      var pe = nt.buffers[D];
      B === 0 || B === 10 ? ((D === 1 ? _e : z)(fe(pe, 0)), pe.length = 0) : pe.push(B);
    }, varargs: void 0, get: function() {
      nt.varargs += 4;
      var D = Te[nt.varargs - 4 >> 2];
      return D;
    }, getStr: function(D) {
      var B = be(D);
      return B;
    }, get64: function(D, B) {
      return D;
    } };
    function mt(D, B) {
      var pe = 0;
      return Je().forEach(function(Ie, ot) {
        var Ke = B + pe;
        Te[D + ot * 4 >> 2] = Ke, Be(Ie, Ke), pe += Ie.length + 1;
      }), 0;
    }
    function Ct(D, B) {
      var pe = Je();
      Te[D >> 2] = pe.length;
      var Ie = 0;
      return pe.forEach(function(ot) {
        Ie += ot.length + 1;
      }), Te[B >> 2] = Ie, 0;
    }
    function ct(D) {
      He(D);
    }
    function Sn(D) {
      return 0;
    }
    function Bi(D, B, pe, Ie, ot) {
    }
    function $o(D, B, pe, Ie) {
      for (var ot = 0, Ke = 0; Ke < pe; Ke++) {
        for (var qe = Te[B + Ke * 8 >> 2], dt = Te[B + (Ke * 8 + 4) >> 2], qt = 0; qt < dt; qt++)
          nt.printChar(D, ae[qe + qt]);
        ot += dt;
      }
      return Te[Ie >> 2] = ot, 0;
    }
    function Ws() {
      return 6;
    }
    function bn() {
      return 28;
    }
    function _n(D) {
      switch (D) {
        case 30:
          return 16384;
        case 85:
          var B = 2147483648;
          return B / 16384;
        case 132:
        case 133:
        case 12:
        case 137:
        case 138:
        case 15:
        case 235:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 149:
        case 13:
        case 10:
        case 236:
        case 153:
        case 9:
        case 21:
        case 22:
        case 159:
        case 154:
        case 14:
        case 77:
        case 78:
        case 139:
        case 82:
        case 68:
        case 67:
        case 164:
        case 11:
        case 29:
        case 47:
        case 48:
        case 95:
        case 52:
        case 51:
        case 46:
          return 200809;
        case 27:
        case 246:
        case 127:
        case 128:
        case 23:
        case 24:
        case 160:
        case 161:
        case 181:
        case 182:
        case 242:
        case 183:
        case 184:
        case 243:
        case 244:
        case 245:
        case 165:
        case 178:
        case 179:
        case 49:
        case 50:
        case 168:
        case 169:
        case 175:
        case 170:
        case 171:
        case 172:
        case 97:
        case 76:
        case 32:
        case 173:
        case 35:
        case 80:
        case 81:
        case 79:
          return -1;
        case 176:
        case 177:
        case 7:
        case 155:
        case 8:
        case 157:
        case 125:
        case 126:
        case 92:
        case 93:
        case 129:
        case 130:
        case 131:
        case 94:
        case 91:
          return 1;
        case 74:
        case 60:
        case 69:
        case 70:
        case 4:
          return 1024;
        case 31:
        case 42:
        case 72:
          return 32;
        case 87:
        case 26:
        case 33:
          return 2147483647;
        case 34:
        case 1:
          return 47839;
        case 38:
        case 36:
          return 99;
        case 43:
        case 37:
          return 2048;
        case 0:
          return 2097152;
        case 3:
          return 65536;
        case 28:
          return 32768;
        case 44:
          return 32767;
        case 75:
          return 16384;
        case 39:
          return 1e3;
        case 89:
          return 700;
        case 71:
          return 256;
        case 40:
          return 255;
        case 2:
          return 100;
        case 180:
          return 64;
        case 25:
          return 20;
        case 5:
          return 16;
        case 6:
          return 6;
        case 73:
          return 4;
        case 84:
          return typeof navigator == "object" && navigator.hardwareConcurrency || 1;
      }
      return Qa(28), -1;
    }
    var Yn = { a: Jn, n: So, i: Er, e: Zi, l: ii, m: C, o: j, p: mt, g: Ct, j: ct, h: Sn, k: Bi, c: $o, d: Ws, f: bn, b: _n };
    vo();
    var Da = u.___wasm_call_ctors = function() {
      return (Da = u.___wasm_call_ctors = u.asm.r).apply(null, arguments);
    };
    u._getModelBufferMemoryOffset = function() {
      return (u._getModelBufferMemoryOffset = u.asm.s).apply(null, arguments);
    }, u._getInputMemoryOffset = function() {
      return (u._getInputMemoryOffset = u.asm.t).apply(null, arguments);
    }, u._getInputHeight = function() {
      return (u._getInputHeight = u.asm.u).apply(null, arguments);
    }, u._getInputWidth = function() {
      return (u._getInputWidth = u.asm.v).apply(null, arguments);
    }, u._getInputChannelCount = function() {
      return (u._getInputChannelCount = u.asm.w).apply(null, arguments);
    }, u._getOutputMemoryOffset = function() {
      return (u._getOutputMemoryOffset = u.asm.x).apply(null, arguments);
    }, u._getOutputHeight = function() {
      return (u._getOutputHeight = u.asm.y).apply(null, arguments);
    }, u._getOutputWidth = function() {
      return (u._getOutputWidth = u.asm.z).apply(null, arguments);
    }, u._getOutputChannelCount = function() {
      return (u._getOutputChannelCount = u.asm.A).apply(null, arguments);
    }, u._loadModel = function() {
      return (u._loadModel = u.asm.B).apply(null, arguments);
    }, u._runInference = function() {
      return (u._runInference = u.asm.C).apply(null, arguments);
    };
    var Ur = u.___errno_location = function() {
      return (Ur = u.___errno_location = u.asm.E).apply(null, arguments);
    }, xa;
    function Tr(D) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + D + ")", this.status = D;
    }
    gn = function D() {
      xa || yr(), xa || (gn = D);
    };
    function yr(D) {
      if (tn > 0 || (Ze(), tn > 0))
        return;
      function B() {
        xa || (xa = !0, u.calledRun = !0, !Se && (Bt(), $e(), p(u), u.onRuntimeInitialized && u.onRuntimeInitialized(), Ht()));
      }
      u.setStatus ? (u.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          u.setStatus("");
        }, 1), B();
      }, 1)) : B();
    }
    u.run = yr;
    function He(D, B) {
      Re || (u.onExit && u.onExit(D), Se = !0), T(D, new Tr(D));
    }
    if (u.preInit)
      for (typeof u.preInit == "function" && (u.preInit = [u.preInit]); u.preInit.length > 0; )
        u.preInit.pop()();
    return Re = !0, yr(), l.ready;
  };
}();
typeof exports == "object" && typeof module == "object" ? module.exports = Ag : typeof define == "function" && define.amd ? define([], function() {
  return Ag;
}) : typeof exports == "object" && (exports.createTFLiteModule = Ag);
const U4 = "https://cdn.cometchat-staging.com/calls/v5/tflite-simd.wasm";
var Jg = function() {
  var d = typeof document < "u" && document.currentScript ? document.currentScript.src : void 0;
  return typeof __filename < "u" && (d = d || __filename), function(l) {
    l = l || {}, l.locateFile = function(D, B) {
      return D.endsWith(".wasm") ? D : B + D;
    };
    var u = typeof l < "u" ? l : {}, p, g;
    u.ready = new Promise(function(D, B) {
      p = D, g = B;
    });
    var R = {}, y;
    for (y in u)
      u.hasOwnProperty(y) && (R[y] = u[y]);
    var Q = "./this.program", T = function(D, B) {
      throw B;
    }, k = !1, V = !1, N = !1, b = !1;
    k = typeof window == "object", V = typeof importScripts == "function", N = typeof process == "object" && typeof process.versions == "object" && typeof process.versions.node == "string", b = !k && !N && !V;
    var A = "";
    function Ne(D) {
      return u.locateFile ? u.locateFile(D, A) : A + D;
    }
    var Ee, Fe, he, ie, Ve;
    N ? (V ? A = require("path").dirname(A) + "/" : A = __dirname + "/", Ee = function(B, pe) {
      return ie || (ie = require("fs")), Ve || (Ve = require("path")), B = Ve.normalize(B), ie.readFileSync(B, pe ? null : "utf8");
    }, he = function(B) {
      var pe = Ee(B, !0);
      return pe.buffer || (pe = new Uint8Array(pe)), xe(pe.buffer), pe;
    }, process.argv.length > 1 && (Q = process.argv[1].replace(/\\/g, "/")), process.argv.slice(2), process.on("uncaughtException", function(D) {
      if (!(D instanceof Tr))
        throw D;
    }), process.on("unhandledRejection", Qt), T = function(D) {
      process.exit(D);
    }, u.inspect = function() {
      return "[Emscripten Module object]";
    }) : b ? (typeof read < "u" && (Ee = function(B) {
      return read(B);
    }), he = function(B) {
      var pe;
      return typeof readbuffer == "function" ? new Uint8Array(readbuffer(B)) : (pe = read(B, "binary"), xe(typeof pe == "object"), pe);
    }, typeof scriptArgs < "u" && scriptArgs, typeof quit == "function" && (T = function(D) {
      quit(D);
    }), typeof print < "u" && (typeof console > "u" && (console = {}), console.log = print, console.warn = console.error = typeof printErr < "u" ? printErr : print)) : (k || V) && (V ? A = self.location.href : typeof document < "u" && document.currentScript && (A = document.currentScript.src), d && (A = d), A.indexOf("blob:") !== 0 ? A = A.substr(0, A.lastIndexOf("/") + 1) : A = "", Ee = function(D) {
      var B = new XMLHttpRequest();
      return B.open("GET", D, !1), B.send(null), B.responseText;
    }, V && (he = function(D) {
      var B = new XMLHttpRequest();
      return B.open("GET", D, !1), B.responseType = "arraybuffer", B.send(null), new Uint8Array(B.response);
    }), Fe = function(D, B, pe) {
      var Ie = new XMLHttpRequest();
      Ie.open("GET", D, !0), Ie.responseType = "arraybuffer", Ie.onload = function() {
        if (Ie.status == 200 || Ie.status == 0 && Ie.response) {
          B(Ie.response);
          return;
        }
        pe();
      }, Ie.onerror = pe, Ie.send(null);
    });
    var _e = u.print || console.log.bind(console), z = u.printErr || console.warn.bind(console);
    for (y in R)
      R.hasOwnProperty(y) && (u[y] = R[y]);
    R = null, u.arguments && u.arguments, u.thisProgram && (Q = u.thisProgram), u.quit && (T = u.quit);
    var Ce;
    u.wasmBinary && (Ce = u.wasmBinary);
    var Re;
    u.noExitRuntime && (Re = u.noExitRuntime), typeof WebAssembly != "object" && Qt("no native wasm support detected");
    var Ue, Se = !1;
    function xe(D, B) {
      D || Qt("Assertion failed: " + B);
    }
    var Qe = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
    function fe(D, B, pe) {
      for (var Ie = B + pe, ot = B; D[ot] && !(ot >= Ie); ) ++ot;
      if (ot - B > 16 && D.subarray && Qe)
        return Qe.decode(D.subarray(B, ot));
      for (var Ke = ""; B < ot; ) {
        var qe = D[B++];
        if (!(qe & 128)) {
          Ke += String.fromCharCode(qe);
          continue;
        }
        var dt = D[B++] & 63;
        if ((qe & 224) == 192) {
          Ke += String.fromCharCode((qe & 31) << 6 | dt);
          continue;
        }
        var qt = D[B++] & 63;
        if ((qe & 240) == 224 ? qe = (qe & 15) << 12 | dt << 6 | qt : qe = (qe & 7) << 18 | dt << 12 | qt << 6 | D[B++] & 63, qe < 65536)
          Ke += String.fromCharCode(qe);
        else {
          var Gi = qe - 65536;
          Ke += String.fromCharCode(55296 | Gi >> 10, 56320 | Gi & 1023);
        }
      }
      return Ke;
    }
    function be(D, B) {
      return D ? fe(ae, D, B) : "";
    }
    function Be(D, B, pe) {
      for (var Ie = 0; Ie < D.length; ++Ie)
        X[B++ >> 0] = D.charCodeAt(Ie);
      X[B >> 0] = 0;
    }
    function De(D, B) {
      return D % B > 0 && (D += B - D % B), D;
    }
    var Z, X, ae, Te;
    function F(D) {
      Z = D, u.HEAP8 = X = new Int8Array(D), u.HEAP16 = new Int16Array(D), u.HEAP32 = Te = new Int32Array(D), u.HEAPU8 = ae = new Uint8Array(D), u.HEAPU16 = new Uint16Array(D), u.HEAPU32 = new Uint32Array(D), u.HEAPF32 = new Float32Array(D), u.HEAPF64 = new Float64Array(D);
    }
    u.INITIAL_MEMORY;
    var H, L = [], de = [], ye = [], Ae = [];
    de.push({ func: function() {
      Da();
    } });
    function Ze() {
      if (u.preRun)
        for (typeof u.preRun == "function" && (u.preRun = [u.preRun]); u.preRun.length; )
          Nn(u.preRun.shift());
      ni(L);
    }
    function Bt() {
      ni(de);
    }
    function $e() {
      ni(ye);
    }
    function Ht() {
      if (u.postRun)
        for (typeof u.postRun == "function" && (u.postRun = [u.postRun]); u.postRun.length; )
          rn(u.postRun.shift());
      ni(Ae);
    }
    function Nn(D) {
      L.unshift(D);
    }
    function rn(D) {
      Ae.unshift(D);
    }
    var tn = 0, gn = null;
    function Ma(D) {
      tn++, u.monitorRunDependencies && u.monitorRunDependencies(tn);
    }
    function go(D) {
      if (tn--, u.monitorRunDependencies && u.monitorRunDependencies(tn), tn == 0 && gn) {
        var B = gn;
        gn = null, B();
      }
    }
    u.preloadedImages = {}, u.preloadedAudios = {};
    function Qt(D) {
      u.onAbort && u.onAbort(D), D += "", z(D), Se = !0, D = "abort(" + D + "). Build with -s ASSERTIONS=1 for more info.";
      var B = new WebAssembly.RuntimeError(D);
      throw g(B), B;
    }
    function vn(D, B) {
      return String.prototype.startsWith ? D.startsWith(B) : D.indexOf(B) === 0;
    }
    var ka = "data:application/octet-stream;base64,";
    function Rr(D) {
      return vn(D, ka);
    }
    var gt = "file://";
    function bi(D) {
      return vn(D, gt);
    }
    var Lt = U4;
    Rr(Lt) || (Lt = Ne(Lt));
    function xi(D) {
      try {
        if (D == Lt && Ce)
          return new Uint8Array(Ce);
        if (he)
          return he(D);
        throw "both async and sync fetching of the wasm failed";
      } catch (B) {
        Qt(B);
      }
    }
    function qo() {
      if (!Ce && (k || V)) {
        if (typeof fetch == "function" && !bi(Lt))
          return fetch(Lt, { credentials: "same-origin" }).then(function(D) {
            if (!D.ok)
              throw "failed to load wasm binary file at '" + Lt + "'";
            return D.arrayBuffer();
          }).catch(function() {
            return xi(Lt);
          });
        if (Fe)
          return new Promise(function(D, B) {
            Fe(Lt, function(pe) {
              D(new Uint8Array(pe));
            }, B);
          });
      }
      return Promise.resolve().then(function() {
        return xi(Lt);
      });
    }
    function vo() {
      var D = { a: Yn };
      function B(qe, dt) {
        var qt = qe.exports;
        u.asm = qt, Ue = u.asm.q, F(Ue.buffer), H = u.asm.D, go();
      }
      Ma();
      function pe(qe) {
        B(qe.instance);
      }
      function Ie(qe) {
        return qo().then(function(dt) {
          return WebAssembly.instantiate(dt, D);
        }).then(qe, function(dt) {
          z("failed to asynchronously prepare wasm: " + dt), Qt(dt);
        });
      }
      function ot() {
        return !Ce && typeof WebAssembly.instantiateStreaming == "function" && !Rr(Lt) && !bi(Lt) && typeof fetch == "function" ? fetch(Lt, { credentials: "same-origin" }).then(function(qe) {
          var dt = WebAssembly.instantiateStreaming(qe, D);
          return dt.then(pe, function(qt) {
            return z("wasm streaming compile failed: " + qt), z("falling back to ArrayBuffer instantiation"), Ie(pe);
          });
        }) : Ie(pe);
      }
      if (u.instantiateWasm)
        try {
          var Ke = u.instantiateWasm(D, B);
          return Ke;
        } catch (qe) {
          return z("Module.instantiateWasm callback failed with error: " + qe), !1;
        }
      return ot().catch(g), {};
    }
    function ni(D) {
      for (; D.length > 0; ) {
        var B = D.shift();
        if (typeof B == "function") {
          B(u);
          continue;
        }
        var pe = B.func;
        typeof pe == "number" ? B.arg === void 0 ? H.get(pe)() : H.get(pe)(B.arg) : pe(B.arg === void 0 ? null : B.arg);
      }
    }
    function Jn() {
      Qt();
    }
    var un;
    N ? un = function() {
      var D = process.hrtime();
      return D[0] * 1e3 + D[1] / 1e6;
    } : typeof dateNow < "u" ? un = dateNow : un = function() {
      return performance.now();
    };
    var Ln = !0;
    function Qa(D) {
      return Te[Ur() >> 2] = D, D;
    }
    function So(D, B) {
      var pe;
      if (D === 0)
        pe = Date.now();
      else if ((D === 1 || D === 4) && Ln)
        pe = un();
      else
        return Qa(28), -1;
      return Te[B >> 2] = pe / 1e3 | 0, Te[B + 4 >> 2] = pe % 1e3 * 1e3 * 1e3 | 0, 0;
    }
    function Er(D, B) {
      Qt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function Zi(D, B) {
      Qt("To use dlopen, you need to use Emscripten's linking support, see https://github.com/emscripten-core/emscripten/wiki/Linking");
    }
    function ii(D, B, pe) {
      ae.copyWithin(D, B, B + pe);
    }
    function In() {
      return ae.length;
    }
    function Oi(D) {
      try {
        return Ue.grow(D - Z.byteLength + 65535 >>> 16), F(Ue.buffer), 1;
      } catch {
      }
    }
    function C(D) {
      D = D >>> 0;
      var B = In(), pe = 2147483648;
      if (D > pe)
        return !1;
      for (var Ie = 16777216, ot = 1; ot <= 4; ot *= 2) {
        var Ke = B * (1 + 0.2 / ot);
        Ke = Math.min(Ke, D + 100663296);
        var qe = Math.min(pe, De(Math.max(Ie, D, Ke), 65536)), dt = Oi(qe);
        if (dt)
          return !0;
      }
      return !1;
    }
    function j(D) {
      for (var B = un(); un() - B < D; )
        ;
    }
    var ke = {};
    function Oe() {
      return Q || "./this.program";
    }
    function Je() {
      if (!Je.strings) {
        var D = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", B = { USER: "web_user", LOGNAME: "web_user", PATH: "/", PWD: "/", HOME: "/home/web_user", LANG: D, _: Oe() };
        for (var pe in ke)
          B[pe] = ke[pe];
        var Ie = [];
        for (var pe in B)
          Ie.push(pe + "=" + B[pe]);
        Je.strings = Ie;
      }
      return Je.strings;
    }
    var nt = { mappings: {}, buffers: [null, [], []], printChar: function(D, B) {
      var pe = nt.buffers[D];
      B === 0 || B === 10 ? ((D === 1 ? _e : z)(fe(pe, 0)), pe.length = 0) : pe.push(B);
    }, varargs: void 0, get: function() {
      nt.varargs += 4;
      var D = Te[nt.varargs - 4 >> 2];
      return D;
    }, getStr: function(D) {
      var B = be(D);
      return B;
    }, get64: function(D, B) {
      return D;
    } };
    function mt(D, B) {
      var pe = 0;
      return Je().forEach(function(Ie, ot) {
        var Ke = B + pe;
        Te[D + ot * 4 >> 2] = Ke, Be(Ie, Ke), pe += Ie.length + 1;
      }), 0;
    }
    function Ct(D, B) {
      var pe = Je();
      Te[D >> 2] = pe.length;
      var Ie = 0;
      return pe.forEach(function(ot) {
        Ie += ot.length + 1;
      }), Te[B >> 2] = Ie, 0;
    }
    function ct(D) {
      He(D);
    }
    function Sn(D) {
      return 0;
    }
    function Bi(D, B, pe, Ie, ot) {
    }
    function $o(D, B, pe, Ie) {
      for (var ot = 0, Ke = 0; Ke < pe; Ke++) {
        for (var qe = Te[B + Ke * 8 >> 2], dt = Te[B + (Ke * 8 + 4) >> 2], qt = 0; qt < dt; qt++)
          nt.printChar(D, ae[qe + qt]);
        ot += dt;
      }
      return Te[Ie >> 2] = ot, 0;
    }
    function Ws() {
      return 6;
    }
    function bn() {
      return 28;
    }
    function _n(D) {
      switch (D) {
        case 30:
          return 16384;
        case 85:
          var B = 2147483648;
          return B / 16384;
        case 132:
        case 133:
        case 12:
        case 137:
        case 138:
        case 15:
        case 235:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
        case 149:
        case 13:
        case 10:
        case 236:
        case 153:
        case 9:
        case 21:
        case 22:
        case 159:
        case 154:
        case 14:
        case 77:
        case 78:
        case 139:
        case 82:
        case 68:
        case 67:
        case 164:
        case 11:
        case 29:
        case 47:
        case 48:
        case 95:
        case 52:
        case 51:
        case 46:
          return 200809;
        case 27:
        case 246:
        case 127:
        case 128:
        case 23:
        case 24:
        case 160:
        case 161:
        case 181:
        case 182:
        case 242:
        case 183:
        case 184:
        case 243:
        case 244:
        case 245:
        case 165:
        case 178:
        case 179:
        case 49:
        case 50:
        case 168:
        case 169:
        case 175:
        case 170:
        case 171:
        case 172:
        case 97:
        case 76:
        case 32:
        case 173:
        case 35:
        case 80:
        case 81:
        case 79:
          return -1;
        case 176:
        case 177:
        case 7:
        case 155:
        case 8:
        case 157:
        case 125:
        case 126:
        case 92:
        case 93:
        case 129:
        case 130:
        case 131:
        case 94:
        case 91:
          return 1;
        case 74:
        case 60:
        case 69:
        case 70:
        case 4:
          return 1024;
        case 31:
        case 42:
        case 72:
          return 32;
        case 87:
        case 26:
        case 33:
          return 2147483647;
        case 34:
        case 1:
          return 47839;
        case 38:
        case 36:
          return 99;
        case 43:
        case 37:
          return 2048;
        case 0:
          return 2097152;
        case 3:
          return 65536;
        case 28:
          return 32768;
        case 44:
          return 32767;
        case 75:
          return 16384;
        case 39:
          return 1e3;
        case 89:
          return 700;
        case 71:
          return 256;
        case 40:
          return 255;
        case 2:
          return 100;
        case 180:
          return 64;
        case 25:
          return 20;
        case 5:
          return 16;
        case 6:
          return 6;
        case 73:
          return 4;
        case 84:
          return typeof navigator == "object" && navigator.hardwareConcurrency || 1;
      }
      return Qa(28), -1;
    }
    var Yn = { a: Jn, n: So, i: Er, e: Zi, l: ii, m: C, o: j, p: mt, g: Ct, j: ct, h: Sn, k: Bi, c: $o, d: Ws, f: bn, b: _n };
    vo();
    var Da = u.___wasm_call_ctors = function() {
      return (Da = u.___wasm_call_ctors = u.asm.r).apply(null, arguments);
    };
    u._getModelBufferMemoryOffset = function() {
      return (u._getModelBufferMemoryOffset = u.asm.s).apply(null, arguments);
    }, u._getInputMemoryOffset = function() {
      return (u._getInputMemoryOffset = u.asm.t).apply(null, arguments);
    }, u._getInputHeight = function() {
      return (u._getInputHeight = u.asm.u).apply(null, arguments);
    }, u._getInputWidth = function() {
      return (u._getInputWidth = u.asm.v).apply(null, arguments);
    }, u._getInputChannelCount = function() {
      return (u._getInputChannelCount = u.asm.w).apply(null, arguments);
    }, u._getOutputMemoryOffset = function() {
      return (u._getOutputMemoryOffset = u.asm.x).apply(null, arguments);
    }, u._getOutputHeight = function() {
      return (u._getOutputHeight = u.asm.y).apply(null, arguments);
    }, u._getOutputWidth = function() {
      return (u._getOutputWidth = u.asm.z).apply(null, arguments);
    }, u._getOutputChannelCount = function() {
      return (u._getOutputChannelCount = u.asm.A).apply(null, arguments);
    }, u._loadModel = function() {
      return (u._loadModel = u.asm.B).apply(null, arguments);
    }, u._runInference = function() {
      return (u._runInference = u.asm.C).apply(null, arguments);
    };
    var Ur = u.___errno_location = function() {
      return (Ur = u.___errno_location = u.asm.E).apply(null, arguments);
    }, xa;
    function Tr(D) {
      this.name = "ExitStatus", this.message = "Program terminated with exit(" + D + ")", this.status = D;
    }
    gn = function D() {
      xa || yr(), xa || (gn = D);
    };
    function yr(D) {
      if (tn > 0 || (Ze(), tn > 0))
        return;
      function B() {
        xa || (xa = !0, u.calledRun = !0, !Se && (Bt(), $e(), p(u), u.onRuntimeInitialized && u.onRuntimeInitialized(), Ht()));
      }
      u.setStatus ? (u.setStatus("Running..."), setTimeout(function() {
        setTimeout(function() {
          u.setStatus("");
        }, 1), B();
      }, 1)) : B();
    }
    u.run = yr;
    function He(D, B) {
      Re || (u.onExit && u.onExit(D), Se = !0), T(D, new Tr(D));
    }
    if (u.preInit)
      for (typeof u.preInit == "function" && (u.preInit = [u.preInit]); u.preInit.length > 0; )
        u.preInit.pop()();
    return Re = !0, yr(), l.ready;
  };
}();
typeof exports == "object" && typeof module == "object" ? module.exports = Jg : typeof define == "function" && define.amd ? define([], function() {
  return Jg;
}) : typeof exports == "object" && (exports.createTFLiteSIMDModule = Jg);
const T4 = {
  modelLandscape: "https://cdn.cometchat-staging.com/calls/v5/selfie_segmentation_landscape.tflite"
};
let xg, Y0, Y3 = !1;
const y4 = {
  modelLandscape: {
    height: 144,
    width: 256
  }
};
async function N4(d) {
  if (!MediaStreamTrack.prototype.getSettings && !MediaStreamTrack.prototype.getConstraints)
    throw new Error("JitsiStreamBackgroundEffect not supported!");
  if (Y3)
    return;
  if (!Y0)
    try {
      g4() ? Y0 = await P3(1e4, Jg()) : Y0 = await P3(1e4, Ag());
    } catch (u) {
      (u == null ? void 0 : u.message) === "408" ? console.error("Failed to download tflite model!") : (Y3 = !0, console.error(
        "Looks like WebAssembly is disabled or not supported on this browser",
        u
      ));
      return;
    }
  if (!xg) {
    const u = await fetch(T4.modelLandscape);
    if (!u.ok)
      throw new Error("Failed to download tflite model!");
    xg = await u.arrayBuffer(), Y0.HEAPU8.set(
      new Uint8Array(xg),
      Y0._getModelBufferMemoryOffset()
    ), Y0._loadModel(xg.byteLength);
  }
  const l = {
    ...y4.modelLandscape,
    virtualBackground: d
  };
  return new R4(Y0, l);
}
const X3 = {
  subscriptions: [],
  previewVirtualBackground: {
    backgroundType: "none"
  },
  virtualBackground: {
    backgroundType: "none"
  },
  selectedBackgroundId: "none",
  backgrounds: [
    { id: "none", type: "none", label: "None", selected: !1 },
    { id: "half-blur", type: "blur", label: "Slightly Blur", selected: !1 },
    { id: "blur", type: "blur", label: "Blur", selected: !1 },
    {
      id: "add-background",
      type: "add",
      label: "Add Background",
      selected: !1
    },
    {
      id: "background-1",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-1.jpg",
      label: "Background 1",
      selected: !1
    },
    {
      id: "background-2",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-2.jpg",
      label: "Background 2",
      selected: !1
    },
    {
      id: "background-3",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-3.jpg",
      label: "Background 3",
      selected: !1
    },
    {
      id: "background-4",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-4.jpg",
      label: "Background 4",
      selected: !1
    },
    {
      id: "background-5",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-5.jpg",
      label: "Background 5",
      selected: !1
    },
    {
      id: "background-6",
      type: "image",
      src: "https://cdn.cometchat.io/calls/v5/virtual-backgrounds/background-6.jpg",
      label: "Background 6",
      selected: !1
    }
  ]
}, wn = $5()(
  a4(
    s4(
      eE(X3, (d) => ({
        addSubscriptions: (l) => {
          wn.setState((u) => ({
            subscriptions: [...u.subscriptions, ...l]
          }));
        },
        setPreviewVirtualBackground: (l, ...u) => {
          const p = u[0];
          wn.setState(() => l === "none" ? {
            previewVirtualBackground: {
              virtualSource: void 0,
              backgroundType: "none",
              blurValue: void 0
            }
          } : l === "half-blur" ? {
            previewVirtualBackground: {
              virtualSource: void 0,
              backgroundType: "blur",
              blurValue: 8
            }
          } : l === "blur" ? {
            previewVirtualBackground: {
              virtualSource: void 0,
              backgroundType: "blur",
              blurValue: 25
            }
          } : {
            previewVirtualBackground: {
              virtualSource: p,
              backgroundType: "image",
              blurValue: void 0
            }
          });
        },
        setVirtualBackground: (l, ...u) => {
          const p = u[0];
          wn.setState(() => l === "none" ? {
            virtualBackground: {
              virtualSource: void 0,
              backgroundType: "none",
              blurValue: void 0
            }
          } : l === "half-blur" ? {
            virtualBackground: {
              virtualSource: void 0,
              backgroundType: "blur",
              blurValue: 8
            }
          } : l === "blur" ? {
            virtualBackground: {
              virtualSource: void 0,
              backgroundType: "blur",
              blurValue: 25
            }
          } : {
            virtualBackground: {
              virtualSource: p,
              backgroundType: "image",
              blurValue: void 0
            }
          });
        },
        promotePreviewVirtualBackground: () => {
          d((l) => ({
            virtualBackground: l.previewVirtualBackground
          }));
        },
        selectBackground: (l) => {
          d((u) => ({ backgrounds: u.backgrounds.map((g) => ({
            ...g,
            selected: g.id === l
          })) }));
        },
        reset: () => d((l) => ({
          ...X3,
          virtualBackground: l.virtualBackground,
          previewVirtualBackground: l.previewVirtualBackground,
          selectedBackgroundId: l.selectedBackgroundId
        }))
      })),
      {
        name: "cometchat-vb-store",
        partialize: (d) => ({
          virtualBackground: d.virtualBackground,
          previewVirtualBackground: d.previewVirtualBackground,
          selectedBackgroundId: d.selectedBackgroundId
        })
      }
    )
  )
), qg = (d, l) => {
  d && (l.backgroundType === "none" ? d.setEffect(void 0) : N4(l).then((u) => {
    d.setEffect(u);
  }));
}, K3 = (d = 8) => {
  wn.setState({
    virtualBackground: {
      virtualSource: void 0,
      backgroundType: "blur",
      blurValue: d
    }
  });
}, q3 = (d) => {
  wn.setState({
    virtualBackground: {
      virtualSource: d,
      backgroundType: "image",
      blurValue: void 0
    }
  });
};
wn.subscribe(
  (d) => d.virtualBackground,
  (d) => {
    var u;
    const l = (u = yn(We.VIDEO)) == null ? void 0 : u.originalTrack;
    l && (d.backgroundType === "none" ? l.setEffect(void 0) : qg(l, d));
  }
);
wn.subscribe(
  (d) => d.previewVirtualBackground,
  (d) => {
    const l = wn.getState().previewTrack;
    qg(l, d);
  }
);
wn.subscribe(
  (d) => d.previewTrack,
  (d, l) => {
    if (d) {
      const u = wn.getState().previewVirtualBackground;
      qg(d, u);
    }
    l && l.disposed !== !0 && l.dispose();
  }
);
wn.subscribe(
  (d) => d.backgrounds,
  (d) => {
    const l = d.find(
      (u) => u.selected
    );
    if (l) {
      const u = l.id, p = wn.getState();
      if (u === "none")
        p.setPreviewVirtualBackground("none");
      else if (u === "half-blur")
        p.setPreviewVirtualBackground("half-blur");
      else if (u === "blur")
        p.setPreviewVirtualBackground("blur");
      else {
        const g = d.find(
          (R) => R.id === u
        );
        g != null && g.src && p.setPreviewVirtualBackground("image", g.src);
      }
    }
  }
);
ft.subscribe(
  (d) => {
    var l;
    return (l = d.tracks.find((u) => u.mediaType === We.VIDEO && u.local)) == null ? void 0 : l.originalTrack;
  },
  (d) => {
    if (d) {
      const l = wn.getState().virtualBackground;
      qg(d, l);
    }
  }
);
const b4 = () => /* @__PURE__ */ U.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ U.jsx(
        "mask",
        {
          id: "mask0_11949_91557",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "6",
          y: "6",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ U.jsx("rect", { x: "6", y: "6", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ U.jsx("g", { mask: "url(#mask0_11949_91557)", children: /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M16 15.7435C15.1956 15.7435 14.5083 15.4585 13.9383 14.8885C13.3683 14.3186 13.0833 13.6314 13.0833 12.8268C13.0833 12.0224 13.3683 11.3352 13.9383 10.7652C14.5083 10.1952 15.1956 9.91016 16 9.91016C16.8044 9.91016 17.4917 10.1952 18.0617 10.7652C18.6317 11.3352 18.9167 12.0224 18.9167 12.8268C18.9167 13.6314 18.6317 14.3186 18.0617 14.8885C17.4917 15.4585 16.8044 15.7435 16 15.7435ZM9.75 20.8237V20.237C9.75 19.829 9.86083 19.4511 10.0825 19.1033C10.3042 18.7555 10.6004 18.4881 10.9712 18.3012C11.7949 17.8974 12.6258 17.5946 13.464 17.3927C14.3022 17.1907 15.1475 17.0897 16 17.0897C16.8525 17.0897 17.6978 17.1907 18.536 17.3927C19.3742 17.5946 20.2051 17.8974 21.0287 18.3012C21.3996 18.4881 21.6958 18.7555 21.9175 19.1033C22.1392 19.4511 22.25 19.829 22.25 20.237V20.8237C22.25 21.1751 22.1269 21.474 21.8806 21.7204C21.6344 21.9666 21.3355 22.0897 20.984 22.0897H11.016C10.6645 22.0897 10.3656 21.9666 10.1194 21.7204C9.87312 21.474 9.75 21.1751 9.75 20.8237Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M2.00065 21C1.82287 21 1.66732 20.9333 1.53398 20.8C1.40065 20.6667 1.33398 20.5111 1.33398 20.3333C1.33398 20.1556 1.40065 20 1.53398 19.8667C1.66732 19.7333 1.82287 19.6667 2.00065 19.6667C2.17843 19.6667 2.33398 19.7333 2.46732 19.8667C2.60065 20 2.66732 20.1556 2.66732 20.3333C2.66732 20.5111 2.60065 20.6667 2.46732 20.8C2.33398 20.9333 2.17843 21 2.00065 21ZM2.00065 14.6667C1.82287 14.6667 1.66732 14.6 1.53398 14.4667C1.40065 14.3333 1.33398 14.1778 1.33398 14C1.33398 13.8222 1.40065 13.6667 1.53398 13.5333C1.66732 13.4 1.82287 13.3333 2.00065 13.3333C2.17843 13.3333 2.33398 13.4 2.46732 13.5333C2.60065 13.6667 2.66732 13.8222 2.66732 14C2.66732 14.1778 2.60065 14.3333 2.46732 14.4667C2.33398 14.6 2.17843 14.6667 2.00065 14.6667ZM7.00065 27C6.62287 27 6.30621 26.8722 6.05065 26.6167C5.7951 26.3611 5.66732 26.0444 5.66732 25.6667C5.66732 25.2889 5.7951 24.9722 6.05065 24.7167C6.30621 24.4611 6.62287 24.3333 7.00065 24.3333C7.37843 24.3333 7.6951 24.4611 7.95065 24.7167C8.20621 24.9722 8.33398 25.2889 8.33398 25.6667C8.33398 26.0444 8.20621 26.3611 7.95065 26.6167C7.6951 26.8722 7.37843 27 7.00065 27ZM6.00065 21.6667C5.62287 21.6667 5.30621 21.5389 5.05065 21.2833C4.7951 21.0278 4.66732 20.7111 4.66732 20.3333C4.66732 19.9556 4.7951 19.6389 5.05065 19.3833C5.30621 19.1278 5.62287 19 6.00065 19C6.37843 19 6.6951 19.1278 6.95065 19.3833C7.20621 19.6389 7.33398 19.9556 7.33398 20.3333C7.33398 20.7111 7.20621 21.0278 6.95065 21.2833C6.6951 21.5389 6.37843 21.6667 6.00065 21.6667ZM8.00065 15.3333C7.62287 15.3333 7.30621 15.2056 7.05065 14.95C6.7951 14.6944 6.66732 14.3778 6.66732 14C6.66732 13.6222 6.7951 13.3056 7.05065 13.05C7.30621 12.7944 7.62287 12.6667 8.00065 12.6667C8.37843 12.6667 8.6951 12.7944 8.95065 13.05C9.20621 13.3056 9.33398 13.6222 9.33398 14C9.33398 14.3778 9.20621 14.6944 8.95065 14.95C8.6951 15.2056 8.37843 15.3333 8.00065 15.3333ZM13.334 28.3333C13.1562 28.3333 13.0007 28.2667 12.8673 28.1333C12.734 28 12.6673 27.8444 12.6673 27.6667C12.6673 27.4889 12.734 27.3333 12.8673 27.2C13.0007 27.0667 13.1562 27 13.334 27C13.5118 27 13.6673 27.0667 13.8007 27.2C13.934 27.3333 14.0007 27.4889 14.0007 27.6667C14.0007 27.8444 13.934 28 13.8007 28.1333C13.6673 28.2667 13.5118 28.3333 13.334 28.3333ZM13.334 6.33333C13.1562 6.33333 13.0007 6.26667 12.8673 6.13333C12.734 6 12.6673 5.84444 12.6673 5.66667C12.6673 5.48889 12.734 5.33333 12.8673 5.2C13.0007 5.06667 13.1562 5 13.334 5C13.5118 5 13.6673 5.06667 13.8007 5.2C13.934 5.33333 14.0007 5.48889 14.0007 5.66667C14.0007 5.84444 13.934 6 13.8007 6.13333C13.6673 6.26667 13.5118 6.33333 13.334 6.33333ZM18.6673 28.3333C18.4895 28.3333 18.334 28.2667 18.2007 28.1333C18.0673 28 18.0007 27.8444 18.0007 27.6667C18.0007 27.4889 18.0673 27.3333 18.2007 27.2C18.334 27.0667 18.4895 27 18.6673 27C18.8451 27 19.0007 27.0667 19.134 27.2C19.2673 27.3333 19.334 27.4889 19.334 27.6667C19.334 27.8444 19.2673 28 19.134 28.1333C19.0007 28.2667 18.8451 28.3333 18.6673 28.3333ZM18.6673 6.33333C18.4895 6.33333 18.334 6.26667 18.2007 6.13333C18.0673 6 18.0007 5.84444 18.0007 5.66667C18.0007 5.48889 18.0673 5.33333 18.2007 5.2C18.334 5.06667 18.4895 5 18.6673 5C18.8451 5 19.0007 5.06667 19.134 5.2C19.2673 5.33333 19.334 5.48889 19.334 5.66667C19.334 5.84444 19.2673 6 19.134 6.13333C19.0007 6.26667 18.8451 6.33333 18.6673 6.33333ZM26.0007 27C25.6229 27 25.3062 26.8722 25.0507 26.6167C24.7951 26.3611 24.6673 26.0444 24.6673 25.6667C24.6673 25.2889 24.7951 24.9722 25.0507 24.7167C25.3062 24.4611 25.6229 24.3333 26.0007 24.3333C26.3784 24.3333 26.6951 24.4611 26.9507 24.7167C27.2062 24.9722 27.334 25.2889 27.334 25.6667C27.334 26.0444 27.2062 26.3611 26.9507 26.6167C26.6951 26.8722 26.3784 27 26.0007 27ZM27.0007 21.6667C26.6229 21.6667 26.3062 21.5389 26.0507 21.2833C25.7951 21.0278 25.6673 20.7111 25.6673 20.3333C25.6673 19.9556 25.7951 19.6389 26.0507 19.3833C26.3062 19.1278 26.6229 19 27.0007 19C27.3784 19 27.6951 19.1278 27.9507 19.3833C28.2062 19.6389 28.334 19.9556 28.334 20.3333C28.334 20.7111 28.2062 21.0278 27.9507 21.2833C27.6951 21.5389 27.3784 21.6667 27.0007 21.6667ZM25.0007 15.3333C24.6229 15.3333 24.3062 15.2056 24.0507 14.95C23.7951 14.6944 23.6673 14.3778 23.6673 14C23.6673 13.6222 23.7951 13.3056 24.0507 13.05C24.3062 12.7944 24.6229 12.6667 25.0007 12.6667C25.3784 12.6667 25.6951 12.7944 25.9507 13.05C26.2062 13.3056 26.334 13.6222 26.334 14C26.334 14.3778 26.2062 14.6944 25.9507 14.95C25.6951 15.2056 25.3784 15.3333 25.0007 15.3333ZM31.0007 21C30.8229 21 30.6673 20.9333 30.534 20.8C30.4007 20.6667 30.334 20.5111 30.334 20.3333C30.334 20.1556 30.4007 20 30.534 19.8667C30.6673 19.7333 30.8229 19.6667 31.0007 19.6667C31.1784 19.6667 31.334 19.7333 31.4673 19.8667C31.6007 20 31.6673 20.1556 31.6673 20.3333C31.6673 20.5111 31.6007 20.6667 31.4673 20.8C31.334 20.9333 31.1784 21 31.0007 21ZM30.0007 14.6667C29.8229 14.6667 29.6673 14.6 29.534 14.4667C29.4007 14.3333 29.334 14.1778 29.334 14C29.334 13.8222 29.4007 13.6667 29.534 13.5333C29.6673 13.4 29.8229 13.3333 30.0007 13.3333C30.1784 13.3333 30.334 13.4 30.4673 13.5333C30.6007 13.6667 30.6673 13.8222 30.6673 14C30.6673 14.1778 30.6007 14.3333 30.4673 14.4667C30.334 14.6 30.1784 14.6667 30.0007 14.6667Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M9.86797 4.13333C10.0013 4.26667 10.1569 4.33333 10.3346 4.33333C10.5124 4.33333 10.668 4.26667 10.8013 4.13333C10.9346 4 11.0013 3.84444 11.0013 3.66667C11.0013 3.48889 10.9346 3.33333 10.8013 3.2C10.668 3.06667 10.5124 3 10.3346 3C10.1569 3 10.0013 3.06667 9.86797 3.2C9.73464 3.33333 9.66797 3.48889 9.66797 3.66667C9.66797 3.84444 9.73464 4 9.86797 4.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M21.868 4.13333C22.0013 4.26667 22.1569 4.33333 22.3346 4.33333C22.5124 4.33333 22.668 4.26667 22.8013 4.13333C22.9346 4 23.0013 3.84444 23.0013 3.66667C23.0013 3.48889 22.9346 3.33333 22.8013 3.2C22.668 3.06667 22.5124 3 22.3346 3C22.1569 3 22.0013 3.06667 21.868 3.2C21.7346 3.33333 21.668 3.48889 21.668 3.66667C21.668 3.84444 21.7346 4 21.868 4.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M15.868 2.13333C16.0013 2.26667 16.1569 2.33333 16.3346 2.33333C16.5124 2.33333 16.668 2.26667 16.8013 2.13333C16.9346 2 17.0013 1.84444 17.0013 1.66667C17.0013 1.48889 16.9346 1.33333 16.8013 1.2C16.668 1.06667 16.5124 1 16.3346 1C16.1569 1 16.0013 1.06667 15.868 1.2C15.7346 1.33333 15.668 1.48889 15.668 1.66667C15.668 1.84444 15.7346 2 15.868 2.13333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M3.53398 7.46634C3.66732 7.59967 3.82287 7.66634 4.00065 7.66634C4.17843 7.66634 4.33398 7.59967 4.46732 7.46634C4.60065 7.33301 4.66732 7.17745 4.66732 6.99967C4.66732 6.8219 4.60065 6.66634 4.46732 6.53301C4.33398 6.39967 4.17843 6.33301 4.00065 6.33301C3.82287 6.33301 3.66732 6.39967 3.53398 6.53301C3.40065 6.66634 3.33398 6.8219 3.33398 6.99967C3.33398 7.17745 3.40065 7.33301 3.53398 7.46634Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M28.534 7.46634C28.6673 7.59967 28.8229 7.66634 29.0007 7.66634C29.1784 7.66634 29.334 7.59967 29.4673 7.46634C29.6006 7.33301 29.6673 7.17745 29.6673 6.99967C29.6673 6.8219 29.6006 6.66634 29.4673 6.53301C29.334 6.39967 29.1784 6.33301 29.0007 6.33301C28.8229 6.33301 28.6673 6.39967 28.534 6.53301C28.4007 6.66634 28.334 6.8219 28.334 6.99967C28.334 7.17745 28.4007 7.33301 28.534 7.46634Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M8.73464 9.65C8.86797 9.78333 9.02352 9.85 9.2013 9.85C9.37908 9.85 9.53464 9.78333 9.66797 9.65C9.8013 9.51667 9.86797 9.36111 9.86797 9.18333C9.86797 9.00556 9.8013 8.85 9.66797 8.71667C9.53464 8.58333 9.37908 8.51667 9.2013 8.51667C9.02352 8.51667 8.86797 8.58333 8.73464 8.71667C8.6013 8.85 8.53464 9.00556 8.53464 9.18333C8.53464 9.36111 8.6013 9.51667 8.73464 9.65Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M22.3346 9.65C22.468 9.78333 22.6235 9.85 22.8013 9.85C22.9791 9.85 23.1346 9.78333 23.268 9.65C23.4013 9.51667 23.468 9.36111 23.468 9.18333C23.468 9.00556 23.4013 8.85 23.268 8.71667C23.1346 8.58333 22.9791 8.51667 22.8013 8.51667C22.6235 8.51667 22.468 8.58333 22.3346 8.71667C22.2013 8.85 22.1346 9.00556 22.1346 9.18333C22.1346 9.36111 22.2013 9.51667 22.3346 9.65Z",
          fill: "white"
        }
      )
    ]
  }
), V4 = () => /* @__PURE__ */ U.jsxs(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ U.jsx(
        "mask",
        {
          id: "mask0_12042_100098",
          style: { maskType: "alpha" },
          maskUnits: "userSpaceOnUse",
          x: "6",
          y: "6",
          width: "20",
          height: "20",
          children: /* @__PURE__ */ U.jsx("rect", { x: "6", y: "6", width: "20", height: "20", fill: "#D9D9D9" })
        }
      ),
      /* @__PURE__ */ U.jsx("g", { mask: "url(#mask0_12042_100098)", children: /* @__PURE__ */ U.jsx(
        "path",
        {
          d: "M16 15.7435C15.1956 15.7435 14.5083 15.4585 13.9383 14.8885C13.3683 14.3186 13.0833 13.6314 13.0833 12.8268C13.0833 12.0224 13.3683 11.3352 13.9383 10.7652C14.5083 10.1952 15.1956 9.91016 16 9.91016C16.8044 9.91016 17.4917 10.1952 18.0617 10.7652C18.6317 11.3352 18.9167 12.0224 18.9167 12.8268C18.9167 13.6314 18.6317 14.3186 18.0617 14.8885C17.4917 15.4585 16.8044 15.7435 16 15.7435ZM9.75 20.8237V20.237C9.75 19.829 9.86083 19.4511 10.0825 19.1033C10.3042 18.7555 10.6004 18.4881 10.9712 18.3012C11.7949 17.8974 12.6258 17.5946 13.464 17.3927C14.3022 17.1907 15.1475 17.0897 16 17.0897C16.8525 17.0897 17.6978 17.1907 18.536 17.3927C19.3742 17.5946 20.2051 17.8974 21.0287 18.3012C21.3996 18.4881 21.6958 18.7555 21.9175 19.1033C22.1392 19.4511 22.25 19.829 22.25 20.237V20.8237C22.25 21.1751 22.1269 21.474 21.8806 21.7204C21.6344 21.9666 21.3355 22.0897 20.984 22.0897H11.016C10.6645 22.0897 10.3656 21.9666 10.1194 21.7204C9.87312 21.474 9.75 21.1751 9.75 20.8237Z",
          fill: "white"
        }
      ) }),
      /* @__PURE__ */ U.jsxs("g", { opacity: "0.67", children: [
        /* @__PURE__ */ U.jsx(
          "path",
          {
            d: "M2.00065 19C1.82287 19 1.66732 18.9333 1.53398 18.8C1.40065 18.6667 1.33398 18.5111 1.33398 18.3333C1.33398 18.1556 1.40065 18 1.53398 17.8667C1.66732 17.7333 1.82287 17.6667 2.00065 17.6667C2.17843 17.6667 2.33398 17.7333 2.46732 17.8667C2.60065 18 2.66732 18.1556 2.66732 18.3333C2.66732 18.5111 2.60065 18.6667 2.46732 18.8C2.33398 18.9333 2.17843 19 2.00065 19ZM7.00065 27C6.62287 27 6.30621 26.8722 6.05065 26.6167C5.7951 26.3611 5.66732 26.0444 5.66732 25.6667C5.66732 25.2889 5.7951 24.9722 6.05065 24.7167C6.30621 24.4611 6.62287 24.3333 7.00065 24.3333C7.37843 24.3333 7.6951 24.4611 7.95065 24.7167C8.20621 24.9722 8.33398 25.2889 8.33398 25.6667C8.33398 26.0444 8.20621 26.3611 7.95065 26.6167C7.6951 26.8722 7.37843 27 7.00065 27ZM6.00065 21.6667C5.62287 21.6667 5.30621 21.5389 5.05065 21.2833C4.7951 21.0278 4.66732 20.7111 4.66732 20.3333C4.66732 19.9556 4.7951 19.6389 5.05065 19.3833C5.30621 19.1278 5.62287 19 6.00065 19C6.37843 19 6.6951 19.1278 6.95065 19.3833C7.20621 19.6389 7.33398 19.9556 7.33398 20.3333C7.33398 20.7111 7.20621 21.0278 6.95065 21.2833C6.6951 21.5389 6.37843 21.6667 6.00065 21.6667ZM8.00065 15.3333C7.62287 15.3333 7.30621 15.2056 7.05065 14.95C6.7951 14.6944 6.66732 14.3778 6.66732 14C6.66732 13.6222 6.7951 13.3056 7.05065 13.05C7.30621 12.7944 7.62287 12.6667 8.00065 12.6667C8.37843 12.6667 8.6951 12.7944 8.95065 13.05C9.20621 13.3056 9.33398 13.6222 9.33398 14C9.33398 14.3778 9.20621 14.6944 8.95065 14.95C8.6951 15.2056 8.37843 15.3333 8.00065 15.3333ZM13.334 28.3333C13.1562 28.3333 13.0007 28.2667 12.8673 28.1333C12.734 28 12.6673 27.8444 12.6673 27.6667C12.6673 27.4889 12.734 27.3333 12.8673 27.2C13.0007 27.0667 13.1562 27 13.334 27C13.5118 27 13.6673 27.0667 13.8007 27.2C13.934 27.3333 14.0007 27.4889 14.0007 27.6667C14.0007 27.8444 13.934 28 13.8007 28.1333C13.6673 28.2667 13.5118 28.3333 13.334 28.3333ZM13.334 6.33333C13.1562 6.33333 13.0007 6.26667 12.8673 6.13333C12.734 6 12.6673 5.84444 12.6673 5.66667C12.6673 5.48889 12.734 5.33333 12.8673 5.2C13.0007 5.06667 13.1562 5 13.334 5C13.5118 5 13.6673 5.06667 13.8007 5.2C13.934 5.33333 14.0007 5.48889 14.0007 5.66667C14.0007 5.84444 13.934 6 13.8007 6.13333C13.6673 6.26667 13.5118 6.33333 13.334 6.33333ZM18.6673 28.3333C18.4895 28.3333 18.334 28.2667 18.2007 28.1333C18.0673 28 18.0007 27.8444 18.0007 27.6667C18.0007 27.4889 18.0673 27.3333 18.2007 27.2C18.334 27.0667 18.4895 27 18.6673 27C18.8451 27 19.0007 27.0667 19.134 27.2C19.2673 27.3333 19.334 27.4889 19.334 27.6667C19.334 27.8444 19.2673 28 19.134 28.1333C19.0007 28.2667 18.8451 28.3333 18.6673 28.3333ZM18.6673 6.33333C18.4895 6.33333 18.334 6.26667 18.2007 6.13333C18.0673 6 18.0007 5.84444 18.0007 5.66667C18.0007 5.48889 18.0673 5.33333 18.2007 5.2C18.334 5.06667 18.4895 5 18.6673 5C18.8451 5 19.0007 5.06667 19.134 5.2C19.2673 5.33333 19.334 5.48889 19.334 5.66667C19.334 5.84444 19.2673 6 19.134 6.13333C19.0007 6.26667 18.8451 6.33333 18.6673 6.33333ZM26.0007 27C25.6229 27 25.3062 26.8722 25.0507 26.6167C24.7951 26.3611 24.6673 26.0444 24.6673 25.6667C24.6673 25.2889 24.7951 24.9722 25.0507 24.7167C25.3062 24.4611 25.6229 24.3333 26.0007 24.3333C26.3784 24.3333 26.6951 24.4611 26.9507 24.7167C27.2062 24.9722 27.334 25.2889 27.334 25.6667C27.334 26.0444 27.2062 26.3611 26.9507 26.6167C26.6951 26.8722 26.3784 27 26.0007 27ZM27.0007 21.6667C26.6229 21.6667 26.3062 21.5389 26.0507 21.2833C25.7951 21.0278 25.6673 20.7111 25.6673 20.3333C25.6673 19.9556 25.7951 19.6389 26.0507 19.3833C26.3062 19.1278 26.6229 19 27.0007 19C27.3784 19 27.6951 19.1278 27.9507 19.3833C28.2062 19.6389 28.334 19.9556 28.334 20.3333C28.334 20.7111 28.2062 21.0278 27.9507 21.2833C27.6951 21.5389 27.3784 21.6667 27.0007 21.6667ZM25.0007 15.3333C24.6229 15.3333 24.3062 15.2056 24.0507 14.95C23.7951 14.6944 23.6673 14.3778 23.6673 14C23.6673 13.6222 23.7951 13.3056 24.0507 13.05C24.3062 12.7944 24.6229 12.6667 25.0007 12.6667C25.3784 12.6667 25.6951 12.7944 25.9507 13.05C26.2062 13.3056 26.334 13.6222 26.334 14C26.334 14.3778 26.2062 14.6944 25.9507 14.95C25.6951 15.2056 25.3784 15.3333 25.0007 15.3333ZM31.0007 19C30.8229 19 30.6673 18.9333 30.534 18.8C30.4007 18.6667 30.334 18.5111 30.334 18.3333C30.334 18.1556 30.4007 18 30.534 17.8667C30.6673 17.7333 30.8229 17.6667 31.0007 17.6667C31.1784 17.6667 31.334 17.7333 31.4673 17.8667C31.6007 18 31.6673 18.1556 31.6673 18.3333C31.6673 18.5111 31.6007 18.6667 31.4673 18.8C31.334 18.9333 31.1784 19 31.0007 19Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ U.jsx(
          "path",
          {
            d: "M8.73464 9.65C8.86797 9.78333 9.02352 9.85 9.2013 9.85C9.37908 9.85 9.53464 9.78333 9.66797 9.65C9.8013 9.51667 9.86797 9.36111 9.86797 9.18333C9.86797 9.00556 9.8013 8.85 9.66797 8.71667C9.53464 8.58333 9.37908 8.51667 9.2013 8.51667C9.02352 8.51667 8.86797 8.58333 8.73464 8.71667C8.6013 8.85 8.53464 9.00556 8.53464 9.18333C8.53464 9.36111 8.6013 9.51667 8.73464 9.65Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ U.jsx(
          "path",
          {
            d: "M22.3346 9.65C22.468 9.78333 22.6235 9.85 22.8013 9.85C22.9791 9.85 23.1346 9.78333 23.268 9.65C23.4013 9.51667 23.468 9.36111 23.468 9.18333C23.468 9.00556 23.4013 8.85 23.268 8.71667C23.1346 8.58333 22.9791 8.51667 22.8013 8.51667C22.6235 8.51667 22.468 8.58333 22.3346 8.71667C22.2013 8.85 22.1346 9.00556 22.1346 9.18333C22.1346 9.36111 22.2013 9.51667 22.3346 9.65Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ U.jsx(
          "path",
          {
            d: "M3.53398 10.8003C3.66732 10.9337 3.82287 11.0003 4.00065 11.0003C4.17843 11.0003 4.33398 10.9337 4.46732 10.8003C4.60065 10.667 4.66732 10.5114 4.66732 10.3337C4.66732 10.1559 4.60065 10.0003 4.46732 9.86699C4.33398 9.73366 4.17843 9.66699 4.00065 9.66699C3.82287 9.66699 3.66732 9.73366 3.53398 9.86699C3.40065 10.0003 3.33398 10.1559 3.33398 10.3337C3.33398 10.5114 3.40065 10.667 3.53398 10.8003Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ U.jsx(
          "path",
          {
            d: "M27.534 10.8003C27.6673 10.9337 27.8229 11.0003 28.0007 11.0003C28.1784 11.0003 28.334 10.9337 28.4673 10.8003C28.6006 10.667 28.6673 10.5114 28.6673 10.3337C28.6673 10.1559 28.6006 10.0003 28.4673 9.86699C28.334 9.73366 28.1784 9.66699 28.0007 9.66699C27.8229 9.66699 27.6673 9.73366 27.534 9.86699C27.4007 10.0003 27.334 10.1559 27.334 10.3337C27.334 10.5114 27.4007 10.667 27.534 10.8003Z",
            fill: "white"
          }
        )
      ] })
    ]
  }
), $3 = ({
  option: d,
  onSelect: l,
  selected: u
}) => {
  const { t: p } = fo(), g = re.useCallback(() => {
    const R = document.createElement("input");
    R.type = "file", R.accept = "image/*", R.onchange = (y) => {
      var T;
      const Q = (T = y.target.files) == null ? void 0 : T[0];
      if (Q) {
        const k = {
          id: `custom-${Date.now()}`,
          type: "image",
          src: URL.createObjectURL(Q),
          label: Q.name,
          selected: !1
        };
        wn.setState((V) => ({
          backgrounds: [...V.backgrounds, k]
        }));
      }
    }, R.click();
  }, []);
  return d.type === "add" ? /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-option-wrapper", children: /* @__PURE__ */ U.jsx(
    "button",
    {
      className: "cometchat-calls-virtual-background-option cometchat-calls-virtual-background-option--add",
      onClick: g,
      "aria-label": p("virtualBackground.addBackground"),
      title: d.label,
      tabIndex: 0,
      children: /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "add",
          size: 20,
          fill: "var(--cometchat-calls-icon-color-primary)"
        }
      )
    }
  ) }) : /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-option-wrapper", children: [
    u && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-option-checkbox", children: /* @__PURE__ */ U.jsx(
      pt,
      {
        name: "check-fill",
        size: 16,
        fill: "var(--cometchat-calls-icon-color-primary)"
      }
    ) }),
    /* @__PURE__ */ U.jsxs(
      "button",
      {
        className: en("cometchat-calls-virtual-background-option", {
          "cometchat-calls-virtual-background-option--selected": u
        }),
        onClick: () => l(d.id),
        "aria-label": `${d.label} background${u ? ", selected" : ""}`,
        "aria-pressed": u,
        title: d.label,
        children: [
          d.type === "none" && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-option-none", children: /* @__PURE__ */ U.jsx(
            pt,
            {
              name: "remove",
              size: 24,
              fill: "var(--cometchat-calls-icon-color-secondary)"
            }
          ) }),
          d.type === "blur" && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-option-blur", children: d.id == "blur" ? /* @__PURE__ */ U.jsx(b4, {}) : /* @__PURE__ */ U.jsx(V4, {}) }),
          d.type === "image" && /* @__PURE__ */ U.jsx(
            "img",
            {
              className: "cometchat-calls-virtual-background-option-image",
              crossOrigin: "anonymous",
              src: d.src,
              alt: d.label ?? ""
            }
          ),
          u && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-option-selected-indicator" })
        ]
      },
      d.id
    )
  ] });
}, C4 = () => {
  const [d, l] = re.useState(window.innerWidth < 768), [u, p] = re.useState(!1), { t: g } = fo(), R = wn((he) => he.backgrounds), y = wn(
    (he) => he.selectedBackgroundId
  );
  re.useEffect(() => {
    var ie;
    const he = (ie = R.find((Ve) => Ve.selected)) == null ? void 0 : ie.id;
    p(he !== y);
  }, [R, y]);
  const Q = R.filter((he) => he.type !== "image"), T = R.filter((he) => he.type === "image"), k = wn((he) => he.previewTrack), V = ou(We.VIDEO), N = ne((he) => he.mirrorLocalVideo), b = ne(
    (he) => he.virtualBackgroundDialogVisible
  );
  re.useEffect(() => {
    wn.getState().selectBackground(y);
  }, [y, b]), re.useEffect(() => {
    const he = () => {
      l(window.innerWidth < 768);
    };
    return window.addEventListener("resize", he), () => window.removeEventListener("resize", he);
  }, []), re.useEffect(() => (b && YS("video").then((he) => {
    wn.setState({ previewTrack: he });
  }).catch((he) => {
    console.error("Error creating local video track:", he);
  }), () => {
    wn.setState({ previewTrack: void 0 });
  }), [b]), re.useEffect(() => {
    const he = (ie) => {
      ie.key === "Escape" && b && Mf();
    };
    if (b)
      return document.addEventListener("keydown", he), () => document.removeEventListener("keydown", he);
  }, [b]);
  const A = re.useCallback((he) => {
    wn.getState().selectBackground(he);
  }, []), Ne = re.useCallback(() => {
    var ie;
    const he = (ie = R.find((Ve) => Ve.selected)) == null ? void 0 : ie.id;
    wn.setState({
      selectedBackgroundId: he
    }), wn.getState().promotePreviewVirtualBackground(), Mf();
  }, [R]), Ee = () => /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-preview-video-container", children: [
    /* @__PURE__ */ U.jsx(
      rR,
      {
        videoTrack: k,
        className: en(
          "cometchat-calls-virtual-background-preview-video",
          N && "cometchat-calls-video--mirrored"
        )
      }
    ),
    V && /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-preview-placeholder", children: [
      /* @__PURE__ */ U.jsx(pt, { name: "video-off", size: 48, "aria-hidden": "true" }),
      /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-virtual-background-preview-placeholder-text", children: g("virtualBackground.noCameraFeed") })
    ] })
  ] }), Fe = () => /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-options", children: [
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-controls-row", children: Q.map((he) => /* @__PURE__ */ U.jsx(
      $3,
      {
        option: he,
        selected: he.selected,
        onSelect: A
      },
      he.id
    )) }),
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-images-row", children: T.map((he) => /* @__PURE__ */ U.jsx(
      $3,
      {
        option: he,
        selected: he.selected,
        onSelect: A
      },
      he.id
    )) })
  ] });
  return b ? /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-virtual-background-overlay",
      onClick: Mf,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "virtual-background-modal-title",
      children: /* @__PURE__ */ U.jsxs(
        "div",
        {
          className: `cometchat-calls-virtual-background-modal ${d ? "cometchat-calls-virtual-background-modal--mobile" : "cometchat-calls-virtual-background-modal--desktop"}`,
          onClick: (he) => he.stopPropagation(),
          children: [
            /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-header", children: /* @__PURE__ */ U.jsx(
              "h2",
              {
                className: "cometchat-calls-virtual-background-header-title",
                id: "virtual-background-modal-title",
                children: g("virtualBackground.title")
              }
            ) }),
            /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-content", children: [
              /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-virtual-background-preview", children: Ee() }),
              Fe()
            ] }),
            /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-virtual-background-footer", children: [
              /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-virtual-background-button cometchat-calls-virtual-background-button--secondary",
                  onClick: Mf,
                  "aria-label": g("virtualBackground.buttons.cancel"),
                  tabIndex: Q.length + T.length + 2,
                  children: g("virtualBackground.buttons.cancel")
                }
              ),
              /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-virtual-background-button cometchat-calls-virtual-background-button--primary",
                  onClick: Ne,
                  "aria-label": g("virtualBackground.buttons.done"),
                  tabIndex: Q.length + T.length + 3,
                  disabled: !u,
                  children: g("virtualBackground.buttons.done")
                }
              )
            ] })
          ]
        }
      )
    }
  ) : null;
}, F4 = () => {
  const [d, l] = re.useState(!1), u = ne(
    (ie) => ie.settingsDialogVisible
  ), [p, g] = re.useState(!1), [R, y] = re.useState(0), { t: Q } = fo(), T = pT(), k = re.useRef(null);
  re.useEffect(() => {
    const ie = document.querySelector(
      ".cometchat-calls-control-pane"
    );
    if (!ie)
      return;
    const Ve = new ResizeObserver((z) => {
      for (const Ce of z) {
        const Re = Ce.contentRect.width;
        g(Re < 767), y(Re);
      }
    });
    Ve.observe(ie);
    const _e = ie.offsetWidth;
    return g(_e < 767), y(_e), () => {
      Ve.disconnect();
    };
  }, []);
  const V = () => {
    l((ie) => !ie);
  }, N = Yg(), b = re.useCallback(() => R < 480, [R]), A = Rt((ie) => ie.hideControlPanel), Ne = k5(), Ee = Rt(
    (ie) => ie.hideLeaveSessionButton
  ), Fe = re.useCallback(() => {
    Ye.publish({
      type: Vt.ButtonClickListener.onLeaveSessionButtonClicked
    }), Kg();
  }, []), he = re.useCallback(() => {
    Ye.publish({
      type: Vt.ButtonClickListener.onRaiseHandButtonClicked
    }), N5();
  }, []);
  return A ? null : /* @__PURE__ */ U.jsxs(
    "div",
    {
      className: en("cometchat-calls-control-pane", {
        "cometchat-calls-control-pane--mobile": p
      }),
      children: [
        /* @__PURE__ */ U.jsx(h4, {}),
        /* @__PURE__ */ U.jsx(m4, {}),
        /* @__PURE__ */ U.jsx(
          "button",
          {
            className: en(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--raise-hand",
              {
                "cometchat-calls-control-button--active": N,
                "cometchat-calls-control-button--hidden": b()
              }
            ),
            onClick: he,
            "aria-label": Q(N ? "controlPanel.lowerHand" : "controlPanel.raiseHand"),
            title: Q(N ? "controlPanel.lowerHand" : "controlPanel.raiseHand"),
            children: /* @__PURE__ */ U.jsx(
              pt,
              {
                name: "raise-hand-fill",
                fill: `${N ? "var(--cometchat-calls-static-black)" : "var(--cometchat-calls-static-white)"}`
              }
            )
          }
        ),
        !Ne && /* @__PURE__ */ U.jsx(
          "button",
          {
            className: en(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--screen-share",
              {
                "cometchat-calls-control-button--hidden": b(),
                "cometchat-calls-control-button--active": T
              }
            ),
            onClick: T ? tR : eR,
            "aria-label": Q(T ? "controlPanel.stopScreenSharing" : "controlPanel.startScreenSharing"),
            title: Q(T ? "controlPanel.stopScreenSharing" : "controlPanel.startScreenSharing"),
            children: /* @__PURE__ */ U.jsx(
              pt,
              {
                name: T ? "screen-share-stop" : "screen-share",
                fill: "var(--cometchat-calls-static-white)"
              }
            )
          }
        ),
        /* @__PURE__ */ U.jsx(
          "button",
          {
            ref: k,
            className: en(
              "cometchat-calls-control-button",
              "cometchat-calls-control-button--more",
              {
                "cometchat-calls-control-button--active": d
              }
            ),
            onClick: V,
            "data-testid": "cometchat-more-options-button",
            "aria-label": Q("controlPanel.moreOptions"),
            title: Q("controlPanel.moreOptions"),
            children: /* @__PURE__ */ U.jsx(pt, { name: "more", fill: "var(--cometchat-calls-static-white)" })
          }
        ),
        !Ee && /* @__PURE__ */ U.jsx(
          "button",
          {
            className: "cometchat-calls-control-button cometchat-calls-control-button--call-end",
            onClick: Fe,
            "aria-label": Q("controlPanel.leaveSession"),
            title: Q("controlPanel.leaveSession"),
            children: /* @__PURE__ */ U.jsx(pt, { name: "call-end", fill: "var(--cometchat-calls-static-white)" })
          }
        ),
        /* @__PURE__ */ U.jsx(
          oR,
          {
            visible: u,
            onClose: y3
          }
        ),
        /* @__PURE__ */ U.jsx(C4, {}),
        /* @__PURE__ */ U.jsx(
          f4,
          {
            toggleSettings: y3,
            toggleVirtualBackground: _5,
            isVisible: d,
            onClose: V,
            anchorElement: k.current,
            isMobileView: b()
          }
        )
      ]
    }
  );
}, _4 = () => {
  const d = mT(), l = ne(
    (p) => p.chatButtonUnreadCount
  ), u = re.useCallback(() => {
    tT(), Ye.publish({
      type: Vt.ButtonClickListener.onChatButtonClicked
    });
  }, []);
  return d ? null : /* @__PURE__ */ U.jsxs(
    "button",
    {
      className: "cometchat-calls-header-action-button",
      onClick: u,
      "aria-label": "Chat",
      title: "Chat",
      children: [
        /* @__PURE__ */ U.jsx(pt, { name: "chat", fill: "var(--cometchat-calls-static-white)" }),
        l > 0 ? /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-header-badge", children: l > 99 ? "99+" : l }) : null
      ]
    }
  );
}, M4 = () => {
  const d = GU();
  return Rt((u) => u.hideSessionTimer) || d < 0 ? null : /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-header-session-timer",
      "data-testid": "cometchat-session-timer",
      children: DU(d)
    }
  );
}, k4 = () => {
  const [d, l] = re.useState(!1), [u, p] = re.useState(!1), g = re.useRef(null), R = Pg(), { t: y } = fo(), Q = [
    { id: ha.TILE, name: y("header.layouts.tileView"), icon: "tile-fill" },
    {
      id: ha.SIDEBAR,
      name: y("header.layouts.sideLayout"),
      icon: "sidebar"
    },
    {
      id: ha.SPOTLIGHT,
      name: y("header.layouts.spotlight"),
      icon: "spotlight"
    }
  ];
  function T(V) {
    l(V), V ? p(V) : setTimeout(() => {
      p(V);
    }, 150);
  }
  re.useEffect(() => {
    const V = (N) => {
      g.current && !g.current.contains(N.target) && T(!1);
    };
    return document.addEventListener("mousedown", V), () => document.removeEventListener("mousedown", V);
  }, []);
  const k = (V) => {
    eu(V), T(!1);
  };
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-header-layout-dropdown", ref: g, children: [
    /* @__PURE__ */ U.jsx(
      "button",
      {
        className: en(
          "cometchat-calls-header-action-button",
          d && "cometchat-calls-header-action-button--active"
        ),
        onClick: () => {
          Ye.publish({
            type: Vt.ButtonClickListener.onChangeLayoutButtonClicked
          }), T(!d);
        },
        children: /* @__PURE__ */ U.jsx(pt, { name: "tile-fill", fill: "var(--cometchat-calls-static-white)" })
      }
    ),
    u && /* @__PURE__ */ U.jsx(
      "div",
      {
        className: en("cometchat-calls-header-dropdown-menu", {
          "cometchat-calls-header-dropdown-menu--opening": d,
          "cometchat-calls-header-dropdown-menu--closing": !d
        }),
        children: Q.map((V) => /* @__PURE__ */ U.jsxs(
          "button",
          {
            className: en(
              "cometchat-calls-header-dropdown-item",
              R === V.id && "cometchat-calls-header-action-button--active"
            ),
            onClick: () => k(V.id),
            children: [
              /* @__PURE__ */ U.jsx(
                pt,
                {
                  name: V.icon,
                  size: 20,
                  fill: "var(--cometchat-calls-neutral-color-600)"
                }
              ),
              /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-header-dropdown-item-name", children: V.name })
            ]
          },
          V.id
        ))
      }
    )
  ] });
}, Q4 = () => {
  const d = ne(
    (R) => R.participantListVisible
  ), l = Rt(
    (R) => R.hideParticipantListButton
  ), u = Rt(
    (R) => R.hideChangeLayoutButton
  ), p = Rt((R) => R.title);
  return Rt((R) => R.hideHeaderPanel) ? null : /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-header-container", children: [
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-header-session-info", children: [
      /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-header-title", children: p }),
      /* @__PURE__ */ U.jsx(M4, {})
    ] }),
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-header-actions", children: [
      !l && /* @__PURE__ */ U.jsx(
        "button",
        {
          className: en(
            "cometchat-calls-header-action-button",
            d && "cometchat-calls-header-action-button--active"
          ),
          onClick: () => {
            $S(), Ye.publish({
              type: Vt.ButtonClickListener.onParticipantListButtonClicked
            });
          },
          children: /* @__PURE__ */ U.jsx(
            pt,
            {
              name: "participants",
              fill: "var(--cometchat-calls-static-white)"
            }
          )
        }
      ),
      /* @__PURE__ */ U.jsx(_4, {}),
      !u && /* @__PURE__ */ U.jsx(k4, {})
    ] })
  ] });
};
function D4(d) {
  const l = Math.floor(d / 6e4).toString().padStart(2, "0"), u = Math.floor(d % 6e4 / 1e3).toString().padStart(2, "0");
  return `${l}:${u}`;
}
const x4 = ({
  className: d = ""
}) => {
  const l = ne(
    (N) => N.idleTimeoutModalVisible
  ), u = Rt(
    (N) => N.idleTimeoutPeriodAfterPrompt
  ), [p, g] = md.useState(u), R = D4(p), y = Math.ceil(p / 6e4), { t: Q } = fo(), T = () => {
    ne.getState().restartIdealTimeoutTimer();
  }, k = (N) => {
    N.target === N.currentTarget && T();
  }, V = (N) => {
    N.key === "Escape" && T();
  };
  return re.useEffect(() => {
    const N = setInterval(() => {
      if (!l) {
        clearInterval(N);
        return;
      }
      g((b) => b <= 1e3 ? (clearInterval(N), zT(), 0) : b - 1e3);
    }, 1e3);
    return () => clearInterval(N);
  }, [l]), re.useEffect(() => {
    l && g(u);
  }, [l, u]), l ? /* @__PURE__ */ U.jsx(
    "div",
    {
      className: "cometchat-calls-ideal-timeout-modal-overlay",
      onClick: k,
      role: "presentation",
      "aria-hidden": "false",
      children: /* @__PURE__ */ U.jsx(
        "div",
        {
          className: en("cometchat-calls-ideal-timeout-modal", d),
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "ideal-timeout-title",
          "aria-describedby": "ideal-timeout-subtitle",
          onKeyDown: V,
          tabIndex: -1,
          children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__content", children: [
            /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-ideal-timeout-modal__timer-icon", children: /* @__PURE__ */ U.jsx("span", { className: "cometchat-calls-ideal-timeout-modal__timer-text", children: R }) }),
            /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__text-content", children: [
              /* @__PURE__ */ U.jsx(
                "h2",
                {
                  id: "ideal-timeout-title",
                  className: "cometchat-calls-ideal-timeout-modal__title",
                  children: Q("idealTimeout.title")
                }
              ),
              /* @__PURE__ */ U.jsx(
                "p",
                {
                  id: "ideal-timeout-subtitle",
                  className: "cometchat-calls-ideal-timeout-modal__subtitle",
                  children: Q("idealTimeout.subtitle").replace("{minutes}", y.toString()).replace("{plural}", y > 1 ? "s" : "")
                }
              )
            ] }),
            /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-ideal-timeout-modal__actions", children: [
              /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-ideal-timeout-modal__button cometchat-calls-ideal-timeout-modal__button--secondary",
                  onClick: T,
                  type: "button",
                  "aria-label": Q("idealTimeout.buttons.stayInCall"),
                  children: Q("idealTimeout.buttons.stayInCall")
                }
              ),
              /* @__PURE__ */ U.jsx(
                "button",
                {
                  className: "cometchat-calls-ideal-timeout-modal__button cometchat-calls-ideal-timeout-modal__button--primary",
                  onClick: Kg,
                  type: "button",
                  "aria-label": Q("idealTimeout.buttons.leaveNow"),
                  autoFocus: !0,
                  children: Q("idealTimeout.buttons.leaveNow")
                }
              )
            ] })
          ] })
        }
      )
    }
  ) : null;
}, Z4 = ({ text: d }) => /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-info-view-container", children: /* @__PURE__ */ U.jsx("p", { className: "cometchat-calls-info-view-message", children: d }) }), O4 = {
  1: "var(--cometchat-calls-error-color)",
  // Poor - Red
  2: "var(--cometchat-calls-warning-color)",
  // Fair - Orange
  3: "var(--cometchat-calls-success-color)",
  // Good - Green
  4: "var(--cometchat-calls-success-color)"
  // Excellent - Green
}, B4 = ({
  participantId: d
}) => {
  const l = rt(
    (R) => R.connectionQuality.get(d)
  );
  if (Rt(
    (R) => R.hideNetworkIndicator
  ) || l === void 0)
    return null;
  const p = (l >> 5) + 1, g = O4[p];
  return /* @__PURE__ */ U.jsx(pt, { name: "signal", size: 24, fill: g });
}, w4 = ({ participant: d }) => {
  const { pid: l, name: u, avatar: p, type: g, ruid: R } = d, y = d.type === "screen-share" ? "Presentation" : "", Q = ou(We.AUDIO, l), T = Q ? "mic-off" : "mic", k = Q ? "var(--cometchat-calls-icon-color-secondary)" : "var(--cometchat-calls-primary-color)", V = Yg(l, g), N = D5(
    (d == null ? void 0 : d.pid) ?? "",
    (d == null ? void 0 : d.type) ?? "human"
  );
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-item", children: [
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-avatar", children: [
      /* @__PURE__ */ U.jsx(aR, { name: u, imageUrl: p, fontSize: 20 }),
      N && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-pin-icon", children: /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "pin",
          size: 15,
          fill: "var(--cometchat-calls-static-white)"
        }
      ) })
    ] }),
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-text", children: [
      /* @__PURE__ */ U.jsx("h4", { className: "cometchat-calls-participant-name", children: u }),
      y && /* @__PURE__ */ U.jsx("p", { className: "cometchat-calls-participant-description", children: y })
    ] }),
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-icons", children: [
      V && g === "human" && /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "raise-hand-fill",
          size: 22,
          fill: "var(--cometchat-calls-static-white)"
        }
      ),
      g === "screen-share" && /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "screen-share",
          size: 24,
          fill: "var(--cometchat-calls-primary-color)"
        }
      ),
      /* @__PURE__ */ U.jsx(B4, { participantId: l }),
      /* @__PURE__ */ U.jsx(pt, { name: T, size: 24, fill: k }),
      /* @__PURE__ */ U.jsx(q5, { ruid: R })
    ] })
  ] });
}, A4 = () => {
  const [d, l] = re.useState(""), u = RT(), { t: p } = fo(), g = Rt(
    (y) => y.hideShareInviteButton
  ), R = md.useMemo(
    () => u.filter(
      (y) => y.name.toLowerCase().includes(d.toLowerCase())
    ),
    [u, d]
  );
  return /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-list-container", children: [
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-list-header", children: [
      /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-list-header-text", children: /* @__PURE__ */ U.jsxs("h2", { className: "cometchat-calls-participant-list-title", children: [
        p("participantList.header.title"),
        " (",
        R.length,
        ")"
      ] }) }),
      /* @__PURE__ */ U.jsx(
        "button",
        {
          className: "cometchat-calls-participant-list-close-button",
          onClick: $S,
          "aria-label": p("participantList.header.closeButton"),
          children: /* @__PURE__ */ U.jsx(pt, { name: "close", size: 24, fill: "#FFFFFF" })
        }
      )
    ] }),
    /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-search-container", children: [
      !g && /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-list-share-invite-button-container", children: /* @__PURE__ */ U.jsxs(
        "button",
        {
          className: "cometchat-calls-participant-list-share-invite-button",
          onClick: () => {
            Ye.publish({
              type: Vt.ButtonClickListener.onShareInviteButtonClicked
            });
          },
          type: "button",
          children: [
            /* @__PURE__ */ U.jsx(pt, { name: "invite", size: 24, fill: "#FFFFFF" }),
            "Invite User"
          ]
        }
      ) }),
      /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-search-input-container", children: /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-search-input-wrapper", children: [
        /* @__PURE__ */ U.jsx(pt, { name: "search", size: 24, fill: "#858585" }),
        /* @__PURE__ */ U.jsx(
          "input",
          {
            type: "text",
            placeholder: p("participantList.search.placeholder"),
            className: "cometchat-calls-participant-search-input",
            value: d,
            onChange: (y) => l(y.target.value)
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participants-scroll-area", children: R.length === 0 ? /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-list-empty-state", children: [
      /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-list-empty-state-icon", children: /* @__PURE__ */ U.jsx(
        pt,
        {
          name: "empty-search",
          size: 120,
          fill: "var(--cometchat-calls-icon-color-tertiary)"
        }
      ) }),
      /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-participant-list-empty-state-text", children: [
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-list-empty-state-title", children: p("participantList.emptyState.title") }),
        /* @__PURE__ */ U.jsx("p", { className: "cometchat-calls-participant-list-empty-state-subtitle", children: p("participantList.emptyState.subtitle") })
      ] })
    ] }) : R.map((y) => /* @__PURE__ */ U.jsx(w4, { participant: y }, y.ruid)) })
  ] });
};
function J4() {
  const [d, l] = re.useState(!0), [u, p] = re.useState(!0);
  return re.useEffect(() => Ye.subscribe(
    An.onSessionJoined,
    () => {
      l(!1);
    }
  ), []), re.useEffect(() => {
    if (!d) {
      const g = setTimeout(() => {
        p(!1);
      }, 300);
      return () => clearTimeout(g);
    }
  }, [d]), u ? /* @__PURE__ */ U.jsx(
    "div",
    {
      className: en("cometchat-calls-connection-loader-overlay", {
        "cometchat-calls-connection-loader-overlay--fade-out": !d
      }),
      "data-testid": "connecting-overlay",
      children: /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-connection-loader-animation" })
    }
  ) : null;
}
const L4 = ({
  id: d,
  type: l = "default",
  message: u,
  buttonText: p,
  buttonAction: g,
  showCloseIcon: R = !0,
  autoClose: y = !0,
  autoCloseDelay: Q = 2e3,
  onClose: T,
  className: k = ""
}) => {
  const [V, N] = re.useState(!0), b = md.useCallback(() => {
    N(!1), setTimeout(() => {
      T == null || T(d);
    }, 300);
  }, [d, T]);
  re.useEffect(() => {
    if (y && Q > 0) {
      const Ne = setTimeout(() => {
        b();
      }, Q);
      return () => clearTimeout(Ne);
    }
  }, [y, Q, b]);
  const A = () => {
    g == null || g(), b();
  };
  return V ? /* @__PURE__ */ U.jsxs(
    "div",
    {
      className: en(
        "cometchat-calls-notification",
        `cometchat-calls-notification--${l}`,
        k
      ),
      role: "alert",
      "aria-live": "polite",
      children: [
        /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-notification__message", children: u }),
        p && g && /* @__PURE__ */ U.jsx(
          "button",
          {
            className: "cometchat-calls-notification__button",
            onClick: A,
            "aria-label": `${p} - ${u}`,
            type: "button",
            children: p
          }
        ),
        R && /* @__PURE__ */ U.jsx(
          "button",
          {
            className: "cometchat-calls-notification__close",
            onClick: b,
            "aria-label": "Close notification",
            type: "button",
            children: /* @__PURE__ */ U.jsx(pt, { name: "close", size: 24, fill: "#858585" })
          }
        )
      ]
    }
  ) : null;
}, I4 = () => {
  const [d, l] = re.useState([]), u = Rt((g) => g.iAmRecorder), p = (g) => {
    Math.max(g.message.length / 17 * 1e3, 2e3), l((R) => [
      ...R.slice(-4),
      {
        ...g,
        id: Date.now().toString(36),
        autoCloseDelay: Math.max(
          Math.min(g.message.length / 17 * 1e3, 6e3),
          2e3
        )
      }
    ]);
  };
  return re.useEffect(() => u ? void 0 : Ye.subscribe(
    An.notification,
    (R) => {
      p({
        message: R.message,
        type: R.type
      });
    }
  ), [u, d]), /* @__PURE__ */ U.jsx(
    "div",
    {
      style: {
        position: "absolute",
        bottom: 70,
        left: 20,
        display: "flex",
        flexDirection: "column-reverse",
        gap: 10
      },
      children: d.map((g) => /* @__PURE__ */ U.jsx(
        L4,
        {
          id: g.id,
          message: g.message,
          type: g.type,
          autoCloseDelay: g.autoCloseDelay
        },
        g.id
      ))
    }
  );
};
function e5() {
  const d = ne(
    (g) => g.participantListVisible
  ), l = Pg(), [u, p] = md.useState(!1);
  return re.useLayoutEffect(() => (Ye.publish({
    type: An.lifecycle.componentDidMount
  }), () => {
    Ye.publish(
      {
        type: An.lifecycle.componentWillUnmount
      },
      !0
    );
  }), []), re.useEffect(() => {
    IT();
  }, []), re.useEffect(() => Ye.subscribe("onConnectionClosed", () => {
    setTimeout(() => {
      p(!0);
    }, 0);
  }), []), u ? /* @__PURE__ */ U.jsx(Z4, { text: "The session has ended." }) : /* @__PURE__ */ U.jsxs("div", { className: "cometchat-calls-call-screen-container", children: [
    /* @__PURE__ */ U.jsxs(
      "div",
      {
        className: en("cometchat-calls-call-screen-content-wrapper", {
          "cometchat-calls-call-screen--participant-list-open": d,
          "cometchat-calls-call-screen--sidebar-mode": l === "SIDEBAR",
          "cometchat-calls-call-screen--spotlight-mode": l === "SPOTLIGHT"
        }),
        children: [
          /* @__PURE__ */ U.jsxs(
            "div",
            {
              className: "cometchat-calls-call-screen-main-content",
              style: {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                boxSizing: "border-box"
              },
              onClick: ne.getState().restartIdealTimeoutTimer,
              children: [
                /* @__PURE__ */ U.jsx(Q4, {}),
                /* @__PURE__ */ U.jsx(
                  "div",
                  {
                    className: "cometchat-calls-call-stage-wrapper",
                    ref: (g) => {
                      if (g) {
                        const R = new ResizeObserver(
                          g5((y) => {
                            for (const Q of y) {
                              const { width: T, height: k } = Q.contentRect;
                              ne.setState({
                                mainAreaDimension: {
                                  width: T,
                                  height: k
                                }
                              });
                            }
                          }, 1e3)
                        );
                        return R.observe(g), () => R.disconnect();
                      }
                    },
                    children: /* @__PURE__ */ U.jsx($y, {})
                  }
                ),
                /* @__PURE__ */ U.jsx(F4, {}),
                /* @__PURE__ */ U.jsx(J4, {})
              ]
            }
          ),
          /* @__PURE__ */ U.jsx("div", { className: "cometchat-calls-participant-list-wrapper", children: /* @__PURE__ */ U.jsx(A4, {}) })
        ]
      }
    ),
    /* @__PURE__ */ U.jsx(x4, {}),
    /* @__PURE__ */ U.jsx(I4, {}),
    /* @__PURE__ */ U.jsx(c4, {})
  ] });
}
let q0 = null;
function W4(d) {
  q0 ? q0.render(/* @__PURE__ */ U.jsx(e5, {})) : (q0 = Ry.createRoot(d), q0.render(/* @__PURE__ */ U.jsx(e5, {})));
}
Ye.subscribe(
  Vt.SessionStatusListener.onConnectionClosed,
  () => {
    setTimeout(() => {
      q0 && (q0.unmount(), q0 = null);
    }, 0);
  }
);
const H4 = /* @__PURE__ */ iR([
  /* @__PURE__ */ Xo("eu"),
  /* @__PURE__ */ Xo("us"),
  /* @__PURE__ */ Xo("in"),
  /* @__PURE__ */ Xo("EU"),
  /* @__PURE__ */ Xo("US"),
  /* @__PURE__ */ Xo("IN")
]), z4 = /* @__PURE__ */ ly(
  /* @__PURE__ */ Ni(),
  /* @__PURE__ */ J5((d) => d.toLowerCase()),
  H4
), j4 = /* @__PURE__ */ Bf({
  appId: /* @__PURE__ */ Ni(),
  region: z4,
  authKey: /* @__PURE__ */ K0(/* @__PURE__ */ Ni()),
  adminHost: /* @__PURE__ */ K0(/* @__PURE__ */ Ni()),
  clientHost: /* @__PURE__ */ K0(/* @__PURE__ */ Ni()),
  host: /* @__PURE__ */ K0(/* @__PURE__ */ Ni())
}), G4 = {
  LAYOUT: ha,
  TYPE: jS,
  CAMERA_FACING: Lg
}, P4 = /* @__PURE__ */ Bf({
  message: /* @__PURE__ */ Ni(),
  devMessage: /* @__PURE__ */ Ni(),
  source: /* @__PURE__ */ Ni(),
  code: /* @__PURE__ */ Ni()
}), Y4 = /* @__PURE__ */ Bf({
  baseURL: /* @__PURE__ */ Ni(),
  method: /* @__PURE__ */ K0(
    /* @__PURE__ */ iR([
      /* @__PURE__ */ Xo("GET"),
      /* @__PURE__ */ Xo("POST"),
      /* @__PURE__ */ Xo("PUT"),
      /* @__PURE__ */ Xo("DELETE")
    ]),
    "GET"
  ),
  endpoint: /* @__PURE__ */ Ni(),
  headers: /* @__PURE__ */ I5(/* @__PURE__ */ Ni(), /* @__PURE__ */ Ni()),
  body: /* @__PURE__ */ K0(/* @__PURE__ */ W5())
});
async function kf({
  baseURL: d,
  method: l = "GET",
  endpoint: u,
  headers: p,
  body: g
}) {
  const R = /* @__PURE__ */ Df(Y4, {
    baseURL: d,
    method: l,
    endpoint: u,
    headers: p,
    body: g
  });
  if (!R.success)
    return {
      data: null,
      error: {
        name: "VALIDATION_ERROR",
        message: "Invalid request parameters: " + R.issues.map((b) => b.message).join(", "),
        timestamp: Date.now()
      }
    };
  const y = `${d}/${u}`, Q = {
    method: l,
    headers: p
  };
  g && l !== "GET" && (Q.body = typeof g == "string" ? g : JSON.stringify(g));
  const { data: T, error: k } = await Is(
    fetch(y, Q)
  );
  if (k)
    return {
      data: null,
      error: {
        name: "NETWORK_ERROR",
        message: `Network request failed: ${k.message}`,
        details: k,
        timestamp: Date.now()
      }
    };
  const { data: V, error: N } = await Is(
    T.json()
  );
  if (N)
    return {
      data: null,
      error: {
        name: "UNKNOWN_ERROR",
        message: `Failed to parse response JSON: ${N.message}`,
        timestamp: Date.now()
      }
    };
  if (V.error) {
    const b = /* @__PURE__ */ Df(
      P4,
      V.error
    );
    return b.success ? {
      data: null,
      error: {
        name: "COMET_CHAT_API_ERROR",
        message: b.output.message,
        details: b.output,
        timestamp: Date.now()
      }
    } : {
      data: null,
      error: {
        name: "UNKNOWN_ERROR",
        message: "Unknown API error format received from server",
        timestamp: Date.now()
      }
    };
  }
  return {
    data: V.data,
    error: null
  };
}
class X4 extends xU {
  static startScreenSharing() {
    eR();
  }
  static stopScreenSharing() {
    tR();
  }
  static showSettingsDialog() {
    aT();
  }
  static hideSettingsDialog() {
    rT();
  }
  static showVirtualBackgroundDialog() {
    _5();
  }
  static hideVirtualBackgroundDialog() {
    Mf();
  }
  static enablePictureInPictureLayout() {
    nT();
  }
  static disablePictureInPictureLayout() {
    iT();
  }
  static getAudioInputDevices() {
    return ne.getState().audioInputDevices;
  }
  static getAudioOutputDevices() {
    return ne.getState().audioOutputDevices;
  }
  static getVideoInputDevices() {
    return ne.getState().videoInputDevices;
  }
  // TODO: Recheck the implementation of this method
  static setAudioInputDevice(l) {
    const p = ne.getState().audioInputDevices.find((g) => g.deviceId === l);
    p && Mh(p);
  }
  // TODO: Recheck the implementation of this method
  static setAudioOutputDevice(l) {
    ne.getState().audioOutputDevices.find((g) => g.deviceId === l) && XS(l);
  }
  // TODO: Recheck the implementation of this method
  static setVideoInputDevice(l) {
    const p = ne.getState().videoInputDevices.find((g) => g.deviceId === l);
    p && kh(p);
  }
  static clearVirtualBackground() {
    wn.getState().setVirtualBackground("none");
  }
  static setVirtualBackgroundBlurLevel(l) {
    K3(l);
  }
  static setVirtualBackgroundImage(l) {
    q3(l);
  }
  // Legacy Methods
  /**
   * @deprecated use startScreenSharing() instead
   */
  static startScreenShare() {
    this.startScreenSharing();
  }
  /**
   * @deprecated use stopScreenSharing() instead
   */
  static stopScreenShare() {
    this.stopScreenSharing();
  }
  /**
   * @deprecated use setLayout() instead
   */
  static setMode(l) {
    const u = l === "DEFAULT" ? "SIDEBAR" : l;
    this.setLayout(u);
  }
  /**
   * @deprecated use showVirtualBackgroundDialog() instead
   */
  static openVirtualBackground() {
    this.showVirtualBackgroundDialog();
  }
  /**
   * @deprecated use hideVirtualBackgroundDialog() instead
   */
  static closeVirtualBackground() {
    this.hideVirtualBackgroundDialog();
  }
  /**
   * @deprecated use setVirtualBackgroundBlurLevel() instead
   */
  static setBackgroundBlur(l) {
    K3(l);
  }
  /**
   * @deprecated use setVirtualBackgroundImage() instead
   */
  static setBackgroundImage(l) {
    q3(l);
  }
}
const cn = {
  MODE: {
    DEFAULT: "DEFAULT"
  },
  RECEIVER_TYPE_USER: "user",
  CALL_KEYS: {
    CALL_DATA: "data",
    CALL_RECEIVER: "receiver",
    CALL_INITIATOR: "initiator",
    CALL_ENTITIES: "entities",
    CALL_ENTITY: "entity"
  }
};
class K4 {
  constructor(l) {
    P(this, "appId");
    P(this, "region");
    // host is an optional parameter, it will be used for on-premises support.
    P(this, "host");
    this.appId = l.appId, this.region = l.region, this.host = l.host;
  }
  setAppId(l) {
    return this.appId = l, this;
  }
  setRegion(l) {
    return this.region = l, this;
  }
  setHost(l) {
    return this.host = l, this;
  }
  getAppId() {
    return this.appId;
  }
  getRegion() {
    return this.region;
  }
  getHost() {
    return this.host;
  }
}
class q4 {
  constructor() {
    P(this, "appId");
    P(this, "region");
    // host is an optional parameter, it will be used for on-premises support.
    P(this, "host");
  }
  /**
   * Method to set appId of the app.
   * @param {string} appId appId of the app
   * @returns
   */
  setAppId(l) {
    return this.appId = l, this;
  }
  /**
   * Method to set region of the app.
   * @param {Region} region region of the app.
   * @returns {void}
   */
  setRegion(l) {
    return this.region = l, this;
  }
  /**
   * Method to set host/domain of the app.
   * @param {string} host host/domain of the app.
   * @returns {void}
   */
  setHost(l) {
    return console.error("Host configuration is deprecated. It has no effect."), this.host = l, this;
  }
  /**
   * This method will return an object of the CallsAppSettings class.
   * @returns {CallAppSettings} Returns the CallsAppSettings instance
   */
  build() {
    return new K4(this);
  }
}
class Ls {
  constructor(l) {
    P(this, "defaultLayout");
    P(this, "isAudioOnly");
    P(this, "mode");
    P(this, "ShowEndCallButton");
    P(this, "ShowMuteAudioButton");
    P(this, "ShowPauseVideoButton");
    P(this, "ShowScreenShareButton");
    P(this, "ShowSwitchModeButton");
    P(this, "StartAudioMuted");
    P(this, "StartVideoMuted");
    // TODO below
    P(this, "localizedObject");
    P(this, "ShowRecordingButton");
    P(this, "idleTimeoutPeriod");
    P(this, "StartRecordingOnCallStart");
    P(this, "callListener");
    P(this, "ShowSwitchToVideoCallButton");
    P(this, "VirtualBackground");
    P(this, "ShowVirtualBackgroundSetting");
    this.defaultLayout = l.defaultLayout, this.isAudioOnly = l.isAudioOnly, this.mode = l.mode, this.ShowEndCallButton = l.ShowEndCallButton, this.ShowMuteAudioButton = l.ShowMuteAudioButton, this.ShowPauseVideoButton = l.ShowPauseVideoButton, this.ShowScreenShareButton = l.ShowScreenShareButton, this.ShowSwitchModeButton = l.ShowSwitchModeButton, this.StartAudioMuted = l.StartAudioMuted, this.StartVideoMuted = l.StartVideoMuted, this.localizedObject = l.localizedObject, this.ShowRecordingButton = l.ShowRecordingButton, this.idleTimeoutPeriod = l.idleTimeoutPeriod, this.StartRecordingOnCallStart = l.StartRecordingOnCallStart, this.callListener = l.callListener, this.ShowSwitchToVideoCallButton = l.ShowSwitchToVideoCallButton, this.VirtualBackground = l.virtualBackground, this.ShowVirtualBackgroundSetting = l.ShowVirtualBackgroundSetting;
  }
  getCallListener() {
    return this.callListener;
  }
  isRecordingButtonEnabled() {
    return this.ShowRecordingButton;
  }
  getIdleTimeoutPeriod() {
    return this.idleTimeoutPeriod;
  }
  shouldStartRecordingOnCallStart() {
    return this.StartRecordingOnCallStart;
  }
  isAudioOnlyCall() {
    return this.isAudioOnly;
  }
  isDefaultLayoutEnabled() {
    return this.defaultLayout;
  }
  getMode() {
    return this.mode;
  }
  getStartWithAudioMuted() {
    return this.StartAudioMuted;
  }
  getStartWithVideoMuted() {
    return this.StartVideoMuted;
  }
  isEndCallButtonEnabled() {
    return this.ShowEndCallButton;
  }
  isMuteAudioButtonEnabled() {
    return this.ShowMuteAudioButton;
  }
  isPauseVideoButtonEnabled() {
    return this.ShowPauseVideoButton;
  }
  isScreenShareButtonEnabled() {
    return this.ShowScreenShareButton;
  }
  isModeButtonEnabled() {
    return this.ShowSwitchModeButton;
  }
  getLocalizedStringObject() {
    return this.localizedObject;
  }
  isAudioToVideoButtonEnabled() {
    return this.ShowSwitchToVideoCallButton;
  }
  getVirtualBackground() {
    return this.VirtualBackground;
  }
  isVirtualBackgroundSettingEnabled() {
    return this.ShowVirtualBackgroundSetting;
  }
}
P(Ls, "POSITION_TOP_LEFT", "top-left"), P(Ls, "POSITION_TOP_RIGHT", "top-right"), P(Ls, "POSITION_BOTTOM_LEFT", "bottom-left"), P(Ls, "POSITION_BOTTOM_RIGHT", "bottom-right"), P(Ls, "POSITION", {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right"
}), P(Ls, "ASPECT_RATIO_DEFAULT", "default"), P(Ls, "ASPECT_RATIO_CONTAIN", "contain"), P(Ls, "ASPECT_RATIO_COVER", "cover"), P(Ls, "ASPECT_RATIO", {
  DEFAULT: "default",
  CONTAIN: "contain",
  COVER: "cover"
});
class $4 {
  constructor() {
    /** @private */
    P(this, "defaultLayout", !0);
    /** @private */
    P(this, "isAudioOnly", !1);
    /** @private */
    P(this, "mode", cn.MODE.DEFAULT);
    /** @private */
    P(this, "ShowEndCallButton", !0);
    /** @private */
    P(this, "ShowMuteAudioButton", !0);
    /** @private */
    P(this, "ShowPauseVideoButton", !0);
    /** @private */
    P(this, "ShowScreenShareButton", !0);
    /** @private */
    P(this, "ShowSwitchModeButton", !0);
    /** @private */
    P(this, "StartAudioMuted", !1);
    /** @private */
    P(this, "StartVideoMuted", !1);
    /** @private */
    P(this, "localizedObject", {});
    /** @private */
    P(this, "ShowRecordingButton", !1);
    /** @private */
    P(this, "idleTimeoutPeriod", 180);
    /** @private */
    P(this, "StartRecordingOnCallStart", !1);
    /** @private */
    P(this, "ShowSwitchToVideoCallButton", !0);
    /** @private */
    P(this, "virtualBackground", new t8().build());
    /** @private */
    P(this, "ShowVirtualBackgroundSetting", !0);
    /** @private */
    P(this, "callListener");
  }
  /**
   *
   * @param {boolean} defaultLayout
   * This methods shows/hides the default button layout.
   * If set to true the default button layout will be shown.
   * If set to false the default button layout will be hidden.
   * Default value is true
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  enableDefaultLayout(l) {
    return this.defaultLayout = l, this;
  }
  /**
   *
   * @param {boolean} isAudioOnly
   * This methods sets the type(audio/video) of the call.
   * If set to true, the call will be strictly an audio call.
   * If set to false, the call will be an audio-video call.
   * Default value is false
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setIsAudioOnlyCall(l) {
    return this.isAudioOnly = l, this;
  }
  /**
   *
   * @param {string} mode
   * This method sets the mode of the call.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setMode(l) {
    return this.mode = l, this;
  }
  /**
   *
   * @param {boolean} showEndCallButton
   * This method shows/hides the end call button.
   * If set to true it will display the end call button.
   * If set to false it will hide the end call button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showEndCallButton(l) {
    return this.ShowEndCallButton = l, this;
  }
  /**
   *
   * @param {boolean} showMuteAudioButton
   * This method shows/hides the mute audio button.
   * If set to true it will display the mute audio button.
   * If set to false it will hide the mute audio button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showMuteAudioButton(l) {
    return this.ShowMuteAudioButton = l, this;
  }
  /**
   *
   * @param {boolean} showPauseVideoButton
   * This method shows/hides the pause video button.
   * If set to true it will display the pause video button.
   * If set to false it will hide the pause video button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showPauseVideoButton(l) {
    return this.ShowPauseVideoButton = l, this;
  }
  /**
   *
   * @param {boolean} showScreenShareButton
   * This method shows/hides the screen share button.
   * If set to true it will display the screen share button.
   * If set to false it will hide the screen share button.
   * Default value is true.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showScreenShareButton(l) {
    return this.ShowScreenShareButton = l, this;
  }
  /**
   *
   * @param {boolean} showModeButton
   * This method shows/hides the switch mode button.
   * If set to true it will display the switch mode button.
   * If set to false it will hide the switch mode button.
   * Default value is true.
   * @returns
   */
  showModeButton(l) {
    return this.ShowSwitchModeButton = l, this;
  }
  /**
   *
   * @param {Object} localizedStringObject
   * This method will set the localized text in the call screen.
   * @returns
   */
  setLocalizedStringObject(l) {
    return console.error("setLocalizedStringObject is deprecated and have no effect."), this.localizedObject = l, this;
  }
  /**
   *
   * @param {boolean} audioMuted
   * This method allows the call to be started with audio muted.
   * If set to true, the call will start with audio muted.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startWithAudioMuted(l) {
    return this.StartAudioMuted = l, this;
  }
  /**
   *
   * @param {boolean} videoMuted
   * This method allows the call to be started with video muted.
   * If set to true, the call will start with video muted.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startWithVideoMuted(l) {
    return this.StartVideoMuted = l, this;
  }
  /**
   *
   * @param {boolean} customCSS
   * This method will set the custom CSS of the call screen.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setCustomCSS(l) {
    return console.error("setCustomCSS is deprecated and have no effect."), this;
  }
  /**
   *
   * @param {boolean} showRecordingButton
   * This method shows/hides the recording button.
   * If set to true it will display the recording button.
   * If set to false it will hide the recording button.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  showRecordingButton(l) {
    return this.ShowRecordingButton = l, this;
  }
  /**
   *
   * @param {number} idleTimeoutPeriod
   * This method sets the idle timeout period for the call.
   * If set and you are the only one in call, the call will end
   * after the idle timeout period, giving you the option to
   * extend the call 60 seconds before the call ends.
   * Default value is 180 seconds.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  setIdleTimeoutPeriod(l) {
    return this.idleTimeoutPeriod = l, this;
  }
  /**
   *
   * @param {boolean} startRecordingOnCallStart
   * This method starts the recording as soon as the call start.
   * If set to true it will start the recording as soon as the call start.
   * Default value is false.
   * @returns {CallSettingsBuilder} Returns the CallSettingsBuilder instance
   */
  startRecordingOnCallStart(l) {
    return this.StartRecordingOnCallStart = l, this;
  }
  /**
   *
   * @param {boolean} _showAudioToVideoSwitchButton
   * This method shows/hides the switch to video call button.
   * If set to true it will display the switch to video call button.
   * If set to false it will hide the switch to video call button.
   * Default value is true.
   * @returns
   */
  showSwitchToVideoCallButton(l) {
    return console.error(
      "showSwitchToVideoCallButton is deprecated and has no effect."
    ), this;
  }
  /**
   *
   * @param {VirtualBackground} virtualBackground
   * This method will set the virtual background setting.
   * This methods takes an Object of VirtualBackground Class.
   * @deprecated Virtual background feature is deprecated and it has no effect.
   * @returns
   */
  setVirtualBackground(l) {
    return console.error("setVirtualBackground is deprecated and has no effect."), this.virtualBackground = l, this;
  }
  /**
   *
   * @param {boolean} showVirtualBackgroundSetting
   * This method shows/hides the virtual background setting button.
   * If set to true it will display the virtual background setting button.
   * If set to false it will hide the virtual background setting button.
   * Default value is true.
   * @returns
   */
  showVirtualBackgroundSetting(l) {
    return this.ShowVirtualBackgroundSetting = l, this;
  }
  /**
   *
   * @param {OngoingCallListener} callListener
   * This method can be used to subscribe to available callings events
   * @returns
   */
  setCallListener(l) {
    return this.callListener = l, this;
  }
  /**
   * This method will return an object of the CallSettings class.
   * @returns {CallSettings} Returns the CallSettings instance
   */
  build() {
    return new Ls(this);
  }
}
class e8 {
  constructor(l) {
    P(this, "AllowBackgroundBlur");
    P(this, "AllowUserImages");
    P(this, "ShowDefaultImages");
    P(this, "SetImages");
    P(this, "EnforceBackgroundBlur");
    P(this, "EnforceBackgroundImage");
    this.AllowBackgroundBlur = l.AllowBackgroundBlur, this.AllowUserImages = l.AllowUserImages, this.ShowDefaultImages = l.ShowDefaultImages, this.SetImages = l.SetImages, this.EnforceBackgroundBlur = l.EnforceBackgroundBlur, this.EnforceBackgroundImage = l.EnforceBackgroundImage;
  }
  shouldAllowBackgroundBlur() {
    return this.AllowBackgroundBlur;
  }
  shouldAllowUserImages() {
    return this.AllowUserImages;
  }
  shouldShowDefaultImages() {
    return this.ShowDefaultImages;
  }
  getImages() {
    return this.SetImages;
  }
  isBackgroundBlurEnforced() {
    return this.EnforceBackgroundBlur;
  }
  getEnforcedBackgroundImage() {
    return this.EnforceBackgroundImage;
  }
}
class t8 {
  constructor() {
    /** @private */
    P(this, "AllowBackgroundBlur", !0);
    /** @private */
    P(this, "AllowUserImages", !0);
    /** @private */
    P(this, "ShowDefaultImages", !0);
    /** @private */
    P(this, "SetImages", []);
    /** @private */
    P(this, "EnforceBackgroundBlur", 0);
    /** @private */
    P(this, "EnforceBackgroundImage", "");
  }
  /**
   *
   * @param {boolean} AllowBackgroundBlur
   * This method will show the background blur option in Virtual Background.
   * If set to true it will show the background blur option.
   * Default value is true.
   * @returns
   */
  allowBackgroundBlur(l) {
    return this.AllowBackgroundBlur = l, this;
  }
  /**
   *
   * @param {boolean} AllowUserImage
   * This method will allow the user to add custom images as background.
   * If set to true it will allow the user to add custom images as background.
   * Default value is true.
   * @returns
   */
  allowUserImages(l) {
    return this.AllowUserImages = l, this;
  }
  /**
   *
   * @param {boolean} ShowDefaultImages
   * This method will show the default images to be used as background.
   * If set to true it will show the default images to be used as background.
   * Default value is true.
   * @returns
   */
  showDefaultImages(l) {
    return this.ShowDefaultImages = l, this;
  }
  /**
   *
   * @param {boolean} SetImages
   * This method will allow user to add custom Images to be used as background. It takes in an array of URLs.
   * @returns
   */
  setImages(l) {
    return this.SetImages = l, this;
  }
  /**
   *
   * @param {number} EnforceBackgroundBlur
   * This method will enforce background blur.
   * This method takes number as input which decides the blur level of the background.
   * Default value is 0.
   * @returns
   */
  enforceBackgroundBlur(l) {
    return this.EnforceBackgroundBlur = l, this;
  }
  /**
   *
   * @param {string} EnforceBackgroundImage
   * This method will enforce background image.
   * If an URL of the image is sent then that image will be set as background.
   * By default no image is set.
   * @returns
   */
  enforceBackgroundImage(l) {
    return this.EnforceBackgroundImage = l, this;
  }
  /**
   * This method will return an object of the VirtualBackground class.
   * @returns {VirtualBackground}
   */
  build() {
    return new e8(this);
  }
}
class Ff {
  constructor(l) {
    P(this, "code");
    P(this, "name");
    P(this, "message");
    P(this, "details");
    "code" in l && (this.code = l.code), "name" in l && (this.name = l.name), "message" in l && (this.message = l.message), "details" in l && (this.details = l.details);
  }
}
function Ca(d) {
  return d != null && (typeof d == "string" && (d = d.trim()), typeof d == "object" && Object.keys(d).length === 0 && (d = void 0)), [
    "",
    0,
    "0",
    !1,
    null,
    "null",
    void 0,
    "undefined"
  ].includes(d);
}
class n8 {
  constructor(l) {
    /**
     * @internal
     */
    P(this, "onYouLeft");
    /**
     * @internal
     */
    P(this, "onYouJoined");
    /**
     * This event is triggered when a user joins the call.
     */
    P(this, "onUserJoined");
    /**
     * This event is triggered when a user leaves the call.
     */
    P(this, "onUserLeft");
    /**
     * This event is triggered when the participant list of the call changes.
     */
    P(this, "onUserListUpdated");
    /**
     * This event is triggered when the media device list changes.
     */
    P(this, "onMediaDeviceListUpdated");
    /**
     * This event is triggered when someone starts recording the call.
     */
    P(this, "onRecordingStarted");
    /**
     * This event is triggered when someone stops recording the call.
     */
    P(this, "onRecordingStopped");
    /**
     * This event is triggered when someone starts sharing their screen in the call.
     */
    P(this, "onScreenShareStarted");
    /**
     * This event is triggered when someone stops sharing their screen in the call.
     */
    P(this, "onScreenShareStopped");
    /**
     * This event is triggered when a user is muted.
     */
    P(this, "onUserMuted");
    /**
     * This event is triggered when a user is unmuted.
     */
    P(this, "onUserUnMuted");
    /**
     * This event is triggered when an audio call is switched to a video call.
     */
    P(this, "onCallSwitchedToVideo");
    /**
     * This event is triggered when the call is ended.
     */
    P(this, "onCallEnded");
    /**
     * This event is triggered when the call is ended due to session timeout.
     */
    P(this, "onSessionTimeout");
    /**
     * This event is triggered when an error occurs.
     */
    P(this, "onError");
    /**
     * This event is triggered when user presses end call button.
     */
    P(this, "onCallEndButtonPressed");
    Ca(l.onUserJoined) || (this.onUserJoined = l.onUserJoined), Ca(l.onUserLeft) || (this.onUserLeft = l.onUserLeft), Ca(l.onUserListUpdated) || (this.onUserListUpdated = l.onUserListUpdated), Ca(l.onMediaDeviceListUpdated) || (this.onMediaDeviceListUpdated = l.onMediaDeviceListUpdated), Ca(l.onRecordingStarted) || (this.onRecordingStarted = l.onRecordingStarted), Ca(l.onRecordingStopped) || (this.onRecordingStopped = l.onRecordingStopped), Ca(l.onScreenShareStarted) || (this.onScreenShareStarted = l.onScreenShareStarted), Ca(l.onScreenShareStopped) || (this.onScreenShareStopped = l.onScreenShareStopped), Ca(l.onUserMuted) || (this.onUserMuted = l.onUserMuted), Ca(l.onUserUnMuted) || (this.onUserUnMuted = l.onUserUnMuted), Ca(l.onCallSwitchedToVideo) || (this.onCallSwitchedToVideo = l.onCallSwitchedToVideo), Ca(l.onCallEnded) || (this.onCallEnded = l.onCallEnded), Ca(l.onSessionTimeout) || (this.onSessionTimeout = l.onSessionTimeout), Ca(l.onError) || (this.onError = l.onError), Ca(l.onCallEndButtonPressed) || (this.onCallEndButtonPressed = l.onCallEndButtonPressed);
  }
}
class sR {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(l) {
    P(this, "guid");
    P(this, "name");
    P(this, "icon");
    Object.assign(this, l);
  }
  getGuid() {
    return this.guid;
  }
  setGuid(l) {
    this.guid = l;
  }
  getName() {
    return this.name;
  }
  setName(l) {
    this.name = l;
  }
  getIcon() {
    return this.icon;
  }
  setIcon(l) {
    this.icon = l;
  }
  toString() {
    return `CallGroup{ guid='${this.guid}', name='${this.name}', icon='${this.icon}' }`;
  }
  static getGroupFromJson(l) {
    return new sR(l);
  }
}
class Hg {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(l) {
    P(this, "uid");
    P(this, "name");
    P(this, "avatar");
    Object.assign(this, l);
  }
  getUid() {
    return this.uid;
  }
  setUid(l) {
    this.uid = l;
  }
  getName() {
    return this.name;
  }
  setName(l) {
    this.name = l;
  }
  getAvatar() {
    return this.avatar;
  }
  setAvatar(l) {
    this.avatar = l;
  }
  toString() {
    return `CallUser{ uid='${this.uid}', name='${this.name}', avatar='${this.avatar}' }`;
  }
  static getUserFromJson(l) {
    return new Hg(l);
  }
}
class lR {
  /**
   * Creates a new instance of Participant.
   * @param object - The object containing the participant data.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(l) {
    /**
     * The unique identifier of the participant.
     */
    P(this, "uid");
    /**
     * The name of the participant.
     */
    P(this, "name");
    /**
     * The avatar of the participant.
     */
    P(this, "avatar");
    /**
     * The total audio minutes of the participant.
     */
    P(this, "totalAudioMinutes");
    /**
     * The total video minutes of the participant.
     */
    P(this, "totalVideoMinutes");
    /**
     * The total duration in minutes of the participant.
     */
    P(this, "totalDurationInMinutes");
    /**
     * The device ID of the participant.
     */
    P(this, "deviceID");
    /**
     * Whether the participant has joined the call or not.
     */
    P(this, "hasJoined");
    /**
     * The timestamp when the participant joined the call.
     */
    P(this, "joinedAt");
    /**
     * The timestamp when the participant left the call.
     */
    P(this, "leftAt");
    /**
     * The media ID of the participant.
     */
    P(this, "mid");
    /**
     * The state of the participant.
     */
    P(this, "state");
    Object.assign(this, l);
  }
  /**
   * Gets the unique identifier of the participant.
   * @returns The unique identifier of the participant.
   */
  getUid() {
    return this.uid;
  }
  /**
   * Sets the unique identifier of the participant.
   * @param value - The unique identifier of the participant.
   */
  setUid(l) {
    this.uid = l;
  }
  /**
   * Gets the name of the participant.
   * @returns The name of the participant.
   */
  getName() {
    return this.name;
  }
  /**
   * Sets the name of the participant.
   * @param value - The name of the participant.
   */
  setName(l) {
    this.name = l;
  }
  /**
   * Gets the avatar of the participant.
   * @returns The avatar of the participant.
   */
  getAvatar() {
    return this.avatar;
  }
  /**
   * Sets the avatar of the participant.
   * @param value - The avatar of the participant.
   */
  setAvatar(l) {
    this.avatar = l;
  }
  /**
   * Gets the total audio minutes of the participant.
   * @returns The total audio minutes of the participant.
   */
  getTotalAudioMinutes() {
    return this.totalAudioMinutes;
  }
  /**
   * Sets the total audio minutes of the participant.
   * @param value - The total audio minutes of the participant.
   */
  setTotalAudioMinutes(l) {
    this.totalAudioMinutes = l;
  }
  /**
   * Gets the total video minutes of the participant.
   * @returns The total video minutes of the participant.
   */
  getTotalVideoMinutes() {
    return this.totalVideoMinutes;
  }
  /**
   * Sets the total video minutes of the participant.
   * @param value - The total video minutes of the participant.
   */
  setTotalVideoMinutes(l) {
    this.totalVideoMinutes = l;
  }
  /**
   * Gets the total duration in minutes of the participant.
   * @returns The total duration in minutes of the participant.
   */
  getTotalDurationInMinutes() {
    return this.totalDurationInMinutes;
  }
  /**
   * Sets the total duration in minutes of the participant.
   * @param value - The total duration in minutes of the participant.
   */
  setTotalDurationInMinutes(l) {
    this.totalDurationInMinutes = l;
  }
  /**
   * Gets the device ID of the participant.
   * @returns The device ID of the participant.
   */
  getDeviceID() {
    return this.deviceID;
  }
  /**
   * Sets the device ID of the participant.
   * @param value - The device ID of the participant.
   */
  setDeviceID(l) {
    this.deviceID = l;
  }
  /**
   * Gets whether the participant has joined the call or not.
   * @returns Whether the participant has joined the call or not.
   */
  getHasJoined() {
    return this.hasJoined;
  }
  /**
   * Sets whether the participant has joined the call or not.
   * @param value - Whether the participant has joined the call or not.
   */
  setHasJoined(l) {
    this.hasJoined = l;
  }
  /**
   * Gets the timestamp when the participant joined the call.
   * @returns The timestamp when the participant joined the call.
   */
  getJoinedAt() {
    return this.joinedAt;
  }
  /**
   * Sets the timestamp when the participant joined the call.
   * @param value - The timestamp when the participant joined the call.
   */
  setJoinedAt(l) {
    this.joinedAt = l;
  }
  /**
   * Gets the timestamp when the participant left the call.
   * @returns The timestamp when the participant left the call.
   */
  getLeftAt() {
    return this.leftAt;
  }
  /**
   * Sets the timestamp when the participant left the call.
   * @param value - The timestamp when the participant left the call.
   */
  setLeftAt(l) {
    this.leftAt = l;
  }
  /**
   * Gets the media ID of the participant.
   * @returns The media ID of the participant.
   */
  getMid() {
    return this.mid;
  }
  /**
   * Sets the media ID of the participant.
   * @param value - The media ID of the participant.
   */
  setMid(l) {
    this.mid = l;
  }
  /**
   * Gets the state of the participant.
   * @returns The state of the participant.
   */
  getState() {
    return this.state;
  }
  /**
   * Sets the state of the participant.
   * @param value - The state of the participant.
   */
  setState(l) {
    this.state = l;
  }
  /**
   * Creates a new instance of Participant from a JSON object.
   * @param object - The JSON object containing the participant data.
   * @returns A new instance of Participant.
   */
  static getParticipantFromJson(l) {
    return new lR(l);
  }
}
class cR {
  /**
   * Creates a new instance of the Recording class.
   * @param data - The data to initialize the recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(l) {
    /**
     * The recording ID.
     */
    P(this, "rid");
    /**
     * The URL of the recording.
     */
    P(this, "recording_url");
    /**
     * The start time of the recording.
     */
    P(this, "startTime");
    /**
     * The end time of the recording.
     */
    P(this, "endTime");
    /**
     * The duration of the recording.
     */
    P(this, "duration");
    Object.assign(this, l);
  }
  /**
   * Gets the recording ID.
   * @returns The recording ID.
   */
  getRid() {
    return this.rid;
  }
  /**
   * Sets the recording ID.
   * @param value - The recording ID to set.
   */
  setRid(l) {
    this.rid = l;
  }
  /**
   * Gets the recording URL.
   * @returns The recording URL.
   */
  getRecordingURL() {
    return this.recording_url;
  }
  /**
   * Sets the recording URL.
   * @param value - The recording URL to set.
   */
  setRecordingURL(l) {
    this.recording_url = l;
  }
  /**
   * Gets the start time of the recording.
   * @returns The start time of the recording.
   */
  getStartTime() {
    return this.startTime;
  }
  /**
   * Sets the start time of the recording.
   * @param value - The start time of the recording to set.
   */
  setStartTime(l) {
    this.startTime = l;
  }
  /**
   * Gets the end time of the recording.
   * @returns The end time of the recording.
   */
  getEndTime() {
    return this.endTime;
  }
  /**
   * Sets the end time of the recording.
   * @param value - The end time of the recording to set.
   */
  setEndTime(l) {
    this.endTime = l;
  }
  /**
   * Gets the duration of the recording.
   * @returns The duration of the recording.
   */
  getDuration() {
    return this.duration;
  }
  /**
   * Sets the duration of the recording.
   * @param value - The duration of the recording to set.
   */
  setDuration(l) {
    this.duration = l;
  }
  /**
   * Creates a new Recording object from the given JSON data.
   * @param data - The JSON data to create the Recording object from.
   * @returns A new Recording object.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static getRecordingFromJson(l) {
    return new cR(l);
  }
}
class $g {
  /**
   * Creates a new instance of CallLog.
   * @param data - The data to initialize the call log with.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(l) {
    /**
     * The session ID of the call log.
     */
    P(this, "sessionId");
    /**
     * The total audio minutes of the call log.
     */
    P(this, "totalAudioMinutes");
    /**
     * The total video minutes of the call log.
     */
    P(this, "totalVideoMinutes");
    /**
     * The total duration of the call log.
     */
    P(this, "totalDuration");
    /**
     * Whether the call log has a recording.
     */
    P(this, "hasRecording");
    /**
     * The time the call was initiated at.
     */
    P(this, "initiatedAt");
    /**
     * The call category of the call log.
     */
    P(this, "callCategory");
    /**
     * @type {CallUser}
     * The initiator of the call log.
     */
    P(this, "initiator");
    /**
     * @type {CallUser | CallGroup}
     * The receiver of the call log.
     */
    P(this, "receiver");
    /**
     * The receiver type of the call log.
     */
    P(this, "receiverType");
    /**
     * The status of the call log.
     */
    P(this, "status");
    /**
     * The total duration in minutes of the call log.
     */
    P(this, "totalDurationInMinutes");
    /**
     * The total number of participants in the call log.
     */
    P(this, "totalParticipants");
    /**
     * The type of the call log.
     */
    P(this, "type");
    /**
     * The message ID of the call log.
     */
    P(this, "mid");
    /**
     * The time the call ended at.
     */
    P(this, "endedAt");
    /**
     * @type {Participant[]}
     * The participants of the call log.
     */
    P(this, "participants");
    /**
     * @type {Recording[]}
     * The recordings of the call log.
     */
    P(this, "recordings");
    Object.assign(this, l);
  }
  /**
   * Gets the session ID of the call log.
   * @returns The session ID of the call log.
   */
  getSessionID() {
    return this.sessionId;
  }
  /**
   * Sets the session ID of the call log.
   * @param value - The session ID to set.
   */
  setSessionID(l) {
    this.sessionId = l;
  }
  /**
   * Gets the total audio minutes of the call log.
   * @returns The total audio minutes of the call log.
   */
  getTotalAudioMinutes() {
    return this.totalAudioMinutes;
  }
  /**
   * Sets the total audio minutes of the call log.
   * @param value - The total audio minutes to set.
   */
  setTotalAudioMinutes(l) {
    this.totalAudioMinutes = l;
  }
  /**
   * Gets the total video minutes of the call log.
   * @returns The total video minutes of the call log.
   */
  getTotalVideoMinutes() {
    return this.totalVideoMinutes;
  }
  /**
   * Sets the total video minutes of the call log.
   * @param value - The total video minutes to set.
   */
  setTotalVideoMinutes(l) {
    this.totalVideoMinutes = l;
  }
  /**
   * Gets the total duration of the call log.
   * @returns The total duration of the call log.
   */
  getTotalDuration() {
    return this.totalDuration;
  }
  /**
   * Sets the total duration of the call log.
   * @param value - The total duration to set.
   */
  setTotalDuration(l) {
    this.totalDuration = l;
  }
  /**
   * Gets whether the call log has a recording.
   * @returns Whether the call log has a recording.
   */
  getHasRecording() {
    return this.hasRecording;
  }
  /**
   * Sets whether the call log has a recording.
   * @param value - Whether the call log has a recording.
   */
  setHasRecording(l) {
    this.hasRecording = l;
  }
  /**
   * Gets the time the call was initiated at.
   * @returns The time the call was initiated at.
   */
  getInitiatedAt() {
    return this.initiatedAt;
  }
  /**
   * Sets the time the call was initiated at.
   * @param value - The time the call was initiated at.
   */
  setInitiatedAt(l) {
    this.initiatedAt = l;
  }
  /**
   * Gets the call category of the call log.
   * @returns The call category of the call log.
   */
  getCallCategory() {
    return this.callCategory;
  }
  /**
   * Sets the call category of the call log.
   * @param value - The call category to set.
   */
  setCallCategory(l) {
    this.callCategory = l;
  }
  /**
   * Gets the initiator of the call log.
   * @returns The initiator of the call log.
   */
  getInitiator() {
    return this.initiator;
  }
  /**
   * Sets the initiator of the call log.
   * @param value - The initiator to set.
   */
  setInitiator(l) {
    this.initiator = l;
  }
  /**
   * Gets the receiver of the call log.
   * @returns The receiver of the call log.
   */
  getReceiver() {
    return this.receiver;
  }
  /**
   * Sets the receiver of the call log.
   * @param value - The receiver to set.
   */
  setReceiver(l) {
    this.receiver = l;
  }
  /**
   * Gets the receiver type of the call log.
   * @returns The receiver type of the call log.
   */
  getReceiverType() {
    return this.receiverType;
  }
  /**
   * Sets the receiver type of the call log.
   * @param value - The receiver type to set.
   */
  setReceiverType(l) {
    this.receiverType = l;
  }
  /**
   * Gets the status of the call log.
   * @returns The status of the call log.
   */
  getStatus() {
    return this.status;
  }
  /**
   * Sets the status of the call log.
   * @param value - The status to set.
   */
  setStatus(l) {
    this.status = l;
  }
  /**
   * Gets the total duration in minutes of the call log.
   * @returns The total duration in minutes of the call log.
   */
  getTotalDurationInMinutes() {
    return this.totalDurationInMinutes;
  }
  /**
   * Sets the total duration in minutes of the call log.
   * @param value - The total duration in minutes to set.
   */
  setTotalDurationInMinutes(l) {
    this.totalDurationInMinutes = l;
  }
  /**
   * Gets the total number of participants in the call log.
   * @returns The total number of participants in the call log.
   */
  getTotalParticipants() {
    return this.totalParticipants;
  }
  /**
   * Sets the total number of participants in the call log.
   * @param value - The total number of participants to set.
   */
  setTotalParticipants(l) {
    this.totalParticipants = l;
  }
  /**
   * Gets the type of the call log.
   * @returns The type of the call log.
   */
  getType() {
    return this.type;
  }
  /**
   * Sets the type of the call log.
   * @param value - The type to set.
   */
  setType(l) {
    this.type = l;
  }
  /**
   * Gets the message ID of the call log.
   * @returns The message ID of the call log.
   */
  getMid() {
    return this.mid;
  }
  /**
   * Sets the message ID of the call log.
   * @param value - The message ID to set.
   */
  setMid(l) {
    this.mid = l;
  }
  /**
   * Gets the time the call ended at.
   * @returns The time the call ended at.
   */
  getEndedAt() {
    return this.endedAt;
  }
  /**
   * Sets the time the call ended at.
   * @param value - The time the call ended at.
   */
  setEndedAt(l) {
    this.endedAt = l;
  }
  /**
   * Gets the participants of the call log.
   * @returns The participants of the call log.
   */
  getParticipants() {
    return this.participants;
  }
  /**
   * Sets the participants of the call log.
   * @param value - The participants to set.
   */
  setParticipants(l) {
    this.participants = l;
  }
  /**
   * Gets the recordings of the call log.
   * @returns The recordings of the call log.
   */
  getRecordings() {
    return this.recordings;
  }
  /**
   * Sets the recordings of the call log.
   * @param value - The recordings to set.
   */
  setRecordings(l) {
    this.recordings = l;
  }
  /**
   * Creates a new instance of CallLog from JSON data.
   * @param data - The JSON data to create the call log from.
   * @returns A new instance of CallLog created from the JSON data.
   */
  static callLogFromJson(l) {
    let u = new $g(l);
    if (l.participants && (u.participants = l.participants.map(
      (p) => lR.getParticipantFromJson(p)
    )), l.recordings && (u.recordings = l.recordings.map(
      (p) => cR.getRecordingFromJson(p)
    )), l.initiator && l[cn.CALL_KEYS.CALL_DATA] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR][cn.CALL_KEYS.CALL_ENTITY]) {
      let p = l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_INITIATOR][cn.CALL_KEYS.CALL_ENTITY];
      u.initiator = Hg.getUserFromJson(p);
    }
    if (l.receiver && l[cn.CALL_KEYS.CALL_DATA] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER] && l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER][cn.CALL_KEYS.CALL_ENTITY]) {
      let p = l[cn.CALL_KEYS.CALL_DATA][cn.CALL_KEYS.CALL_ENTITIES][cn.CALL_KEYS.CALL_RECEIVER][cn.CALL_KEYS.CALL_ENTITY];
      l.receiverType == cn.RECEIVER_TYPE_USER ? u.receiver = Hg.getUserFromJson(p) : u.receiver = sR.getGroupFromJson(p);
    }
    return u;
  }
}
const t5 = {
  CALL_LIST: "calls"
}, WS = "__APP_ID__", HS = "__REGION__", n5 = `https://${WS}.call-${HS}.cometchat.io/v3.0/`, i5 = (d) => new Promise((l) => {
  const u = new Headers();
  if (u.append("Accept", "application/json"), typeof d.headers == "object")
    for (const g in d.headers)
      u.append(g, d.headers[g]);
  const p = {
    method: "GET",
    headers: u
  };
  fetch(d.url, p).then((g) => g.json()).then((g) => {
    l({
      error: null,
      data: g
    });
  }).catch((g) => {
    l({
      error: g,
      data: void 0
    });
  });
});
function i8(d) {
  const l = [];
  for (let u in d)
    l.push(encodeURIComponent(u) + "=" + encodeURIComponent(d[u]));
  return l.join("&");
}
class iE {
  /**
   * Sets the app settings for the APIHandler class.
   * @param appSettings - The CallAppSettings object containing the app settings.
   */
  static setAppSettings(l) {
    this.appSettings = l;
  }
  /**
   * Gets the call log list for the given filter parameters and authentication token.
   * @param params - The object containing the filter parameters.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to an array of call log objects.
   */
  static async getCallLogList(l, u) {
    let p = n5.replace(
      WS,
      this.appSettings.getAppId()
    ).replace(HS, this.appSettings.getRegion());
    this.appSettings.getHost() && (p = this.appSettings.getHost());
    const g = i8(l), R = `${p}${t5.CALL_LIST}?${g}`;
    return i5({
      url: R,
      headers: {
        authToken: u
      }
    });
  }
  /**
   * Gets the call details for the given session ID and authentication token.
   * @param sessionID - The session ID for which the call details are to be fetched.
   * @param authToken - The authentication token.
   * @returns A Promise that resolves to a call details object.
   */
  static async getCallDetails(l, u) {
    let p = n5.replace(
      WS,
      this.appSettings.getAppId()
    ).replace(HS, this.appSettings.getRegion());
    return this.appSettings.getHost() && (p = this.appSettings.getHost()), i5({
      url: `${p}${t5.CALL_LIST}/${l}`,
      headers: {
        authToken: u
      }
    });
  }
}
P(iE, "appSettings");
class a8 {
  /**
   * Creates a new CallLogRequest instance.
   * @param builder The builder object to use for constructing the request.
   */
  constructor(l) {
    /**
     * The maximum number of call logs to fetch.
     */
    P(this, "limit", 30);
    /**
     * The total number of pages of call logs.
     */
    P(this, "totalPages", 0);
    /**
     * The current page of call logs.
     */
    P(this, "currentPage", 0);
    /**
     * The type of call to filter by.
     */
    P(this, "callType");
    /**
     * The status of call to filter by.
     */
    P(this, "callStatus");
    /**
     * Whether the call has a recording or not.
     */
    P(this, "hasRecording");
    /**
     * The category of call to filter by.
     */
    P(this, "callCategory");
    /**
     * The direction of call to filter by.
     */
    P(this, "callDirection");
    /**
     * The user ID to filter by.
     */
    P(this, "uid");
    /**
     * The group ID to filter by.
     */
    P(this, "guid");
    /**
     * The authentication token to use for the API call.
     */
    P(this, "authToken");
    /**
     * Whether an API call is currently in progress.
     */
    P(this, "inProgress", !1);
    this.limit = l.limit, this.callType = l.callType, this.callStatus = l.callStatus, this.hasRecording = l.hasRecording, this.callCategory = l.callCategory, this.callDirection = l.callDirection, this.uid = l.uid, this.guid = l.guid, this.authToken = l.authToken;
  }
  /**
   * Fetches the next page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or rejects with a CometChatCallsException if there was an error.
   */
  fetchNext() {
    return this.makeAPICall(!0);
  }
  /**
   * Fetches the previous page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or an empty array if there are no previous pages, or rejects with a CometChatCallsException if there was an error..
   */
  fetchPrevious() {
    return this.makeAPICall();
  }
  /**
   * Makes an API call to fetch call logs.
   * @param isFetchNext Whether to fetch the next page of call logs.
   * @returns A promise that resolves to an array of CallLog objects, or rejects with a CometChatCallsException if there was an error.
   */
  makeAPICall(l) {
    return new Promise(async (u, p) => {
      var g;
      try {
        if (l ? this.totalPages != 0 && this.totalPages == this.currentPage : this.currentPage == 1) {
          this.inProgress = !1, u([]);
          return;
        }
        if (this.inProgress) {
          this.inProgress = !1, p(
            new Ff({
              code: "REQUEST_IN_PROGRESS",
              name: "REQUEST_IN_PROGRESS",
              message: "Request in progress.",
              details: {}
            })
          );
          return;
        }
        if (this.inProgress = !0, !this.authToken) {
          this.inProgress = !1, p(
            new Ff({
              code: "NOT_ENOUGH_PARAMETERS",
              message: "`Auth Token` is required to use the 'fetchNext()' method."
            })
          );
          return;
        }
        try {
          let y = await iE.getCallLogList(
            this.getParams(l),
            this.authToken
          );
          if ((g = y == null ? void 0 : y.data) != null && g.error) {
            this.inProgress = !1, p(new Ff(y.data.error));
            return;
          }
          let Q = this.getCallLogList(JSON.stringify(y.data));
          u(Q), this.inProgress = !1;
        } catch (y) {
          this.inProgress = !1, p(new Ff(y));
        }
      } catch {
        this.inProgress = !1, p(
          new Ff({
            code: "UNKNOWN ERROR",
            message: "Unknown error"
          })
        );
      }
    });
  }
  /**
   * Gets the filter parameters for the API call.
   * @param isNext Whether to fetch the next page of call logs.
   * @returns The filter parameters object.
   */
  getParams(l) {
    let u = {};
    return l ? u.page = this.currentPage + 1 : u.page = this.currentPage - 1, u.perPage = this.limit, this.hasRecording && (u.hasRecording = this.hasRecording), this.callStatus && (u.status = this.callStatus), this.callType && (u.type = this.callType), this.callCategory && (u.mode = this.callCategory), this.callDirection && (u.direction = this.callDirection), this.uid && (u.uid = this.uid), this.guid && (u.guid = this.guid), u;
  }
  /**
   * Parses the API response and returns an array of CallLog objects.
   * @param response The API response string.
   * @returns An array of CallLog objects.
   */
  getCallLogList(l) {
    let u = [], p = JSON.parse(l), g = p.meta;
    if (g.pagination) {
      let y = g.pagination;
      y.total_pages && (this.totalPages = y.total_pages, this.currentPage = y.current_page);
    }
    let R = p.data;
    for (let y = 0; y < R.length; y++) {
      let Q = R[y], T = $g.callLogFromJson(Q);
      u.push(T);
    }
    return u;
  }
}
class r8 {
  constructor() {
    /** @private */
    P(this, "limit", 30);
    /** @private */
    P(this, "callType");
    /** @private */
    P(this, "callStatus");
    /** @private */
    P(this, "hasRecording");
    /** @private */
    P(this, "callCategory");
    /** @private */
    P(this, "callDirection");
    /** @private */
    P(this, "uid");
    /** @private */
    P(this, "guid");
    /** @private */
    P(this, "authToken");
  }
  /**
   * Sets the limit of call logs to be fetched.
   * @param limit - The number of call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setLimit(l) {
    return this.limit = l, this;
  }
  /**
   * Sets the type of call to be fetched.
   * @param callType - The type of call to be fetched. Can be either 'video' or 'audio'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallType(l) {
    return this.callType = l, this;
  }
  /**
   * Sets the status of call to be fetched.
   * @param callStatus - The status of call to be fetched. Can be either 'ongoing', 'busy', 'rejected', 'cancelled', 'ended' or 'missed'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallStatus(l) {
    return this.callStatus = l, this;
  }
  /**
   * Sets whether the call has recording or not.
   * @param hasRecording - Whether the call has recording or not.
   * @returns The CallLogRequestBuilder object.
   */
  setHasRecording(l) {
    return this.hasRecording = l, this;
  }
  /**
   * Sets the category of call to be fetched.
   * @param callCategory - The category of call to be fetched. Can be either 'call' or 'meet'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallCategory(l) {
    return this.callCategory = l, this;
  }
  /**
   * Sets the direction of call to be fetched.
   * @param callDirection - The direction of call to be fetched. Can be either 'incoming' or 'outgoing'.
   * @returns The CallLogRequestBuilder object.
   */
  setCallDirection(l) {
    return this.callDirection = l, this;
  }
  /**
   * Sets the user ID of the call logs to be fetched.
   * @param uid - The user ID of the call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setUid(l) {
    return this.uid = l, this;
  }
  /**
   * Sets the group ID of the call logs to be fetched.
   * @param guid - The group ID of the call logs to be fetched.
   * @returns The CallLogRequestBuilder object.
   */
  setGuid(l) {
    return this.guid = l, this;
  }
  /**
   * Sets the authorization token for the request.
   * @param authToken - The authorization token for the request.
   * @returns The CallLogRequestBuilder object.
   */
  setAuthToken(l) {
    return this.authToken = l, this;
  }
  /**
   * Builds and returns the CallLogRequest object.
   * @returns The CallLogRequest object.
   */
  build() {
    return new a8(this);
  }
}
const o8 = /* @__PURE__ */ Bf({
  appId: /* @__PURE__ */ Ni(),
  region: /* @__PURE__ */ Ni(),
  calltoken: /* @__PURE__ */ Ni(),
  baseURL: /* @__PURE__ */ Ni()
}), s8 = S5;
async function l8({
  appId: d,
  region: l,
  calltoken: u,
  baseURL: p
}) {
  const g = /* @__PURE__ */ Df(o8, {
    appId: d,
    region: l,
    calltoken: u,
    baseURL: p
  });
  if (!g.success)
    return {
      data: null,
      error: {
        name: "VALIDATION_ERROR",
        message: g.issues.map((Q) => Q.message).join(", ")
      }
    };
  const R = await kf({
    baseURL: p,
    method: "GET",
    endpoint: "call_tokens?configVersion=1",
    headers: {
      calltoken: u,
      appId: d
    }
  });
  if (R.error)
    return R;
  const y = /* @__PURE__ */ Df(s8, R.data);
  return y.success ? {
    data: y.output,
    error: null
  } : {
    data: null,
    error: {
      name: "BAD_RESPONSE",
      message: y.issues.map((Q) => Q.message).join(", ")
    }
  };
}
const zn = class zn extends X4 {
  // v4 related changes end here
  // Initialize the SDK
  static async init(l) {
    const u = /* @__PURE__ */ Df(j4, l);
    if (!u.success)
      return console.error(
        "App settings validation failed:",
        u.issues
      ), {
        success: !1,
        error: {
          name: "VALIDATION_ERROR",
          message: `Invalid app settings: ${u.issues.map((g) => g.message).join(", ")}`,
          timestamp: Date.now()
        }
      };
    this.appSettings = u.output, this.isInitialized = !0, Ye.publish({
      type: An.lifecycle.SDKInitialized
    });
    const p = this.getSavedUser();
    if (p) {
      let g;
      if (typeof p == "string")
        try {
          g = JSON.parse(p);
        } catch {
          g = p;
        }
      else
        g = p;
      this.loggedInUser = g;
    }
    return {
      success: !0,
      error: null
    };
  }
  // Login with UID and Auth Key
  static async login(l, u) {
    var p;
    try {
      if (this.loginInProgress)
        throw {
          errorCode: "ERROR_LOGIN_IN_PROGRESS",
          errorDescription: "Login is already in progress"
        };
      if (!l || l.trim() === "")
        throw {
          errorCode: "ERROR_INVALID_UID",
          errorDescription: "UID cannot be empty"
        };
      if (l.includes(" "))
        throw {
          errorCode: "ERROR_UID_WITH_SPACE",
          errorDescription: "UID cannot contain spaces"
        };
      const g = u || ((p = this.appSettings) == null ? void 0 : p.authKey);
      if (!g || g.trim() === "")
        throw {
          errorCode: "ERROR_API_KEY_NOT_FOUND",
          errorDescription: "Auth Key cannot be empty"
        };
      if (!this.isInitialized)
        throw {
          errorCode: "ERROR_SDK_NOT_INITIALIZED",
          errorDescription: "SDK not initialized. Call init() first"
        };
      if (this.loginInProgress = !0, this.loggedInUser && this.loggedInUser.uid === l && this.loggedInUser.authToken)
        return this.loginInProgress = !1, this.notifyLoginSuccess(this.loggedInUser), this.loggedInUser;
      this.loggedInUser && this.loggedInUser.uid !== l && await this.logoutInternal();
      const R = await this.loginWithUID(l, g), y = await this.authenticateWithToken(R);
      return this.loginInProgress = !1, this.loggedInUser = y, this.saveUser(y), this.notifyLoginSuccess(y), y;
    } catch (g) {
      this.loginInProgress = !1;
      const R = this.createError(g);
      throw this.notifyLoginFailure(R), R;
    }
  }
  // Login with auth token directly
  static async loginWithAuthToken(l) {
    try {
      if (this.loginInProgress)
        throw {
          errorCode: "ERROR_LOGIN_IN_PROGRESS",
          errorDescription: "Login is already in progress"
        };
      if (!l || l.trim() === "")
        throw {
          errorCode: "ERROR_BLANK_AUTHTOKEN",
          errorDescription: "Auth token cannot be empty"
        };
      if (l.includes(" "))
        throw {
          errorCode: "ERROR_AUTHTOKEN_WITH_SPACE",
          errorDescription: "Auth token cannot contain spaces"
        };
      if (this.loginInProgress = !0, this.loggedInUser && this.loggedInUser.authToken === l)
        return this.loginInProgress = !1, this.notifyLoginSuccess(this.loggedInUser), this.loggedInUser;
      this.loggedInUser && this.loggedInUser.authToken !== l && await this.logoutInternal();
      const u = await this.authenticateWithToken(l);
      return this.loginInProgress = !1, this.loggedInUser = u, this.saveUser(u), this.notifyLoginSuccess(u), u;
    } catch (u) {
      this.loginInProgress = !1;
      const p = this.createError(u);
      throw this.notifyLoginFailure(p), p;
    }
  }
  // Logout functionality
  static async logout() {
    try {
      if (!this.loggedInUser)
        throw {
          errorCode: "ERROR_NO_USER_LOGGED_IN",
          errorDescription: "No user is currently logged in"
        };
      return await this.logoutInternal(), this.notifyLogoutSuccess(), "Logout successful";
    } catch (l) {
      const u = this.createError(l);
      throw this.notifyLogoutFailure(u), u;
    }
  }
  // Get logged in user
  static getLoggedInUser() {
    return this.loggedInUser && typeof this.loggedInUser == "string" && (this.loggedInUser = JSON.parse(this.loggedInUser)), this.loggedInUser;
  }
  // Get user auth token
  static getUserAuthToken() {
    var l;
    return ((l = this.loggedInUser) == null ? void 0 : l.authToken) || null;
  }
  // Check if user is logged in
  static isUserLoggedIn() {
    return this.loggedInUser !== null && this.loggedInUser.authToken !== void 0;
  }
  // Add login listener
  static addLoginListener(l, u) {
    this.loginListeners.set(l, u);
  }
  // Remove login listener
  static removeLoginListener(l) {
    this.loginListeners.delete(l);
  }
  // Generate token (enhanced to use logged-in user's authToken)
  static async generateToken(l, u) {
    try {
      if (!l || l.trim() === "")
        throw {
          errorCode: "ERROR_SESSION_ID_MISSING",
          errorDescription: "Session ID cannot be empty"
        };
      const p = u || this.getUserAuthToken();
      if (!p)
        throw {
          errorCode: "ERROR_AUTH_TOKEN_MISSING",
          errorDescription: "Auth token is required. Please login first or provide authToken."
        };
      if (!this.isInitialized)
        throw {
          errorCode: "ERROR_SDK_NOT_INITIALIZED",
          errorDescription: "SDK not initialized"
        };
      return { token: await this.callGenerateTokenAPI(l, p) };
    } catch (p) {
      throw this.createError(p);
    }
  }
  static getBaseURL(l = "call") {
    var R, y, Q, T, k;
    if (l === "call" && ((R = this.appSettings) != null && R.host))
      return this.appSettings.host;
    if (l === "api" && ((y = this.appSettings) != null && y.adminHost))
      return this.appSettings.adminHost;
    if (l === "apiclient" && ((Q = this.appSettings) != null && Q.clientHost))
      return this.appSettings.clientHost;
    const u = ((T = this.appSettings) == null ? void 0 : T.appId) || "", p = ((k = this.appSettings) == null ? void 0 : k.region) || "";
    return `https://${u}.${l}-${p}.cometchat-staging.com/v3.0`;
  }
  // Private helper methods
  static async loginWithUID(l, u) {
    var R;
    const p = ((R = this.appSettings) == null ? void 0 : R.appId) || "", g = await kf({
      baseURL: this.getBaseURL("api"),
      method: "POST",
      endpoint: `users/${l}/auth_tokens`,
      headers: {
        "Content-Type": "application/json",
        apiKey: u,
        appId: p
      },
      body: {
        platform: "web",
        deviceId: this.generateDeviceId()
      }
    });
    if (g.error)
      throw new Error(`Login failed: ${g.error.message}`);
    return g.data.authToken;
  }
  static async authenticateWithToken(l) {
    var R;
    const u = ((R = this.appSettings) == null ? void 0 : R.appId) || "", p = await kf({
      baseURL: this.getBaseURL("apiclient"),
      method: "PUT",
      endpoint: "me",
      headers: {
        "Content-Type": "application/json",
        authToken: l,
        appId: u
      },
      body: {
        platform: "web",
        deviceId: this.generateDeviceId()
      }
    });
    if (p.error)
      throw new Error(`Authentication failed: ${p.error.message}`);
    const g = p.data;
    return {
      uid: g.uid,
      name: g.name,
      authToken: l,
      status: g.status || "online",
      avatar: g.avatar || "",
      lastActiveAt: g.lastActiveAt || Date.now(),
      role: g.role || "default",
      hasBlockedMe: !1,
      blockedByMe: !1,
      deactivatedAt: 0,
      wsChannel: {
        identity: `[${u}]${g.uid}`
      },
      jwt: g.jwt
    };
  }
  static async logoutInternal() {
    var l, u;
    if ((l = this.loggedInUser) != null && l.authToken)
      try {
        await kf({
          baseURL: this.getBaseURL("apiclient"),
          method: "DELETE",
          endpoint: "me",
          headers: {
            authToken: this.loggedInUser.authToken,
            appId: ((u = this.appSettings) == null ? void 0 : u.appId) || ""
          }
        });
      } catch {
      }
    this.loggedInUser = null, this.clearSavedUser();
  }
  static async callGenerateTokenAPI(l, u) {
    var R;
    const p = ((R = this.appSettings) == null ? void 0 : R.appId) || "", g = await kf({
      baseURL: this.getBaseURL(),
      method: "POST",
      endpoint: "call_tokens",
      headers: {
        "Content-Type": "application/json",
        authToken: u,
        appId: p
      },
      body: {
        sessionId: l
      }
    });
    if (g.error)
      throw new Error(`Token generation failed: ${g.error.message}`);
    return g.data.token;
  }
  static async callVerifyTokenAPI(l) {
    var u, p;
    return l8({
      appId: ((u = this.appSettings) == null ? void 0 : u.appId) || "",
      region: ((p = this.appSettings) == null ? void 0 : p.region) || "",
      calltoken: l,
      baseURL: this.getBaseURL()
    });
  }
  static saveUser(l) {
    var u, p;
    try {
      const g = `${(u = this.appSettings) == null ? void 0 : u.appId}:common_store/user`, R = {
        hasBlockedMe: !1,
        blockedByMe: !1,
        deactivatedAt: 0,
        ...l,
        role: l.role || "default",
        wsChannel: l.wsChannel || {
          identity: `[${(p = this.appSettings) == null ? void 0 : p.appId}]${l.uid}`
        }
      };
      localStorage.setItem(g, JSON.stringify(R));
    } catch {
    }
  }
  static getSavedUser() {
    var l;
    try {
      const u = `${(l = this.appSettings) == null ? void 0 : l.appId}:common_store/user`, p = localStorage.getItem(u);
      return p || null;
    } catch {
      return null;
    }
  }
  static clearSavedUser() {
    var l;
    try {
      const u = `${(l = this.appSettings) == null ? void 0 : l.appId}:common_store/user`;
      localStorage.removeItem(u);
    } catch {
    }
  }
  static generateDeviceId() {
    return "web_" + Math.random().toString(36).substr(2, 9);
  }
  static createError(l) {
    return l.errorCode && l.errorDescription ? l : {
      errorCode: "ERROR_UNKNOWN",
      errorDescription: l.message || "An unknown error occurred"
    };
  }
  // Notification methods for listeners
  static notifyLoginSuccess(l) {
    this.loginListeners.forEach((u) => {
      if (u.onLoginSuccess)
        try {
          u.onLoginSuccess(l);
        } catch (p) {
          console.error("Error in login success listener:", p);
        }
    });
  }
  static notifyLoginFailure(l) {
    this.loginListeners.forEach((u) => {
      if (u.onLoginFailure)
        try {
          u.onLoginFailure(l);
        } catch (p) {
          console.error("Error in login failure listener:", p);
        }
    });
  }
  static notifyLogoutSuccess() {
    this.loginListeners.forEach((l) => {
      if (l.onLogoutSuccess)
        try {
          l.onLogoutSuccess();
        } catch (u) {
          console.error("Error in logout success listener:", u);
        }
    });
  }
  static notifyLogoutFailure(l) {
    this.loginListeners.forEach((u) => {
      if (u.onLogoutFailure)
        try {
          u.onLogoutFailure(l);
        } catch (p) {
          console.error("Error in logout failure listener:", p);
        }
    });
  }
  static addEventListener(l, u) {
    return Ye.subscribe(l, u);
  }
  /**
   * @deprecated Use CometChatCalls.joinSession instead.
   */
  static startSession(l, u, p) {
    var Q, T;
    const g = u, R = {
      hideControlPanel: !(g.defaultLayout ?? !1),
      hideLeaveSessionButton: !(g.ShowEndCallButton ?? !0),
      hideRecordingButton: !(g.ShowRecordingButton ?? !0),
      hideChangeLayoutButton: !(g.ShowSwitchModeButton ?? !0),
      hideScreenSharingButton: !(g.ShowScreenShareButton ?? !0),
      hideToggleAudioButton: !(g.ShowMuteAudioButton ?? !0),
      hideToggleVideoButton: !(g.ShowPauseVideoButton ?? !0),
      autoStartRecording: g.StartRecordingOnCallStart ?? !1,
      hideNetworkIndicator: !(((T = (Q = g.MainVideoContainerSetting) == null ? void 0 : Q.network) == null ? void 0 : T.visibility) ?? !0),
      hideVirtualBackgroundButton: !(g.ShowVirtualBackgroundSetting ?? !0),
      layout: g.mode === "DEFAULT" ? "SIDEBAR" : g.mode,
      startAudioMuted: g.StartAudioMuted ?? !1,
      startVideoPaused: g.StartVideoMuted ?? !1,
      idleTimeoutPeriodBeforePrompt: 60 * 1e3,
      idleTimeoutPeriodAfterPrompt: Math.max(
        g.idleTimeoutPeriod ?? 120 * 1e3,
        60 * 1e3
      ),
      sessionType: g.isAudioCall || g.isAudioOnly ? "VOICE" : "VIDEO"
    }, y = [];
    return y.push(
      zn.addEventListener("onLeaveSessionButtonClicked", () => {
        var k, V;
        (V = (k = u.getCallListener()) == null ? void 0 : k.onCallEndButtonPressed) == null || V.call(k), y.forEach((N) => N());
      })
    ), y.push(
      zn.addEventListener("onSessionLeft", () => {
        var k, V;
        (V = (k = u.getCallListener()) == null ? void 0 : k.onCallEnded) == null || V.call(k);
      })
    ), y.push(
      zn.addEventListener("onParticipantLeft", (k) => {
        var V, N;
        (N = (V = u.getCallListener()) == null ? void 0 : V.onUserLeft) == null || N.call(V, k);
      })
    ), y.push(
      zn.addEventListener("onParticipantListChanged", (k) => {
        var N, b, A, Ne;
        const V = Pe.getState().localParticipant;
        (b = (N = u.getCallListener()) == null ? void 0 : N.onUserListUpdated) == null || b.call(N, [
          {
            name: V.name,
            uid: V.uid,
            avatar: V.avatar
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
          },
          ...k
        ]), k.length === 0 && ((Ne = (A = u.getCallListener()) == null ? void 0 : A.onCallEnded) == null || Ne.call(A));
      })
    ), y.push(
      zn.addEventListener("onParticipantJoined", (k) => {
        var V, N;
        (N = (V = u.getCallListener()) == null ? void 0 : V.onUserJoined) == null || N.call(V, k);
      })
    ), y.push(
      zn.addEventListener("onAudioMuted", () => {
        var k, V;
        (V = (k = u.getCallListener()) == null ? void 0 : k.onUserMuted) == null || V.call(k, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { isAudioMuted: !0 },
          mutedBy: void 0
        });
      })
    ), y.push(
      zn.addEventListener("onParticipantAudioMuted", (k) => {
        var V, N;
        (N = (V = u.getCallListener()) == null ? void 0 : V.onUserMuted) == null || N.call(V, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { ...k, isAudioMuted: !0 },
          mutedBy: void 0
        });
      })
    ), y.push(
      zn.addEventListener("onParticipantVideoPaused", (k) => {
        var V, N;
        (N = (V = u.getCallListener()) == null ? void 0 : V.onUserMuted) == null || N.call(V, {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          muted: { ...k, isVideoMuted: !0 },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          mutedBy: void 0
        });
      })
    ), y.push(
      zn.addEventListener("onRecordingStarted", () => {
        var k, V;
        (V = (k = u.getCallListener()) == null ? void 0 : k.onRecordingStarted) == null || V.call(k, void 0);
      })
    ), y.push(
      zn.addEventListener("onRecordingStopped", () => {
        var k, V;
        (V = (k = u.getCallListener()) == null ? void 0 : k.onRecordingStopped) == null || V.call(k);
      })
    ), this.joinSession(l, R, p);
  }
  static async joinSession(l, u, p) {
    B5();
    const { data: g, error: R } = await this.callVerifyTokenAPI(l);
    return R ? {
      data: g,
      error: R
    } : (U3({
      internalSettings: JSON.stringify({ data: g })
    }), U3(u), W4(p), {
      data: void 0,
      error: null
    });
  }
  static getAudioInputDevices() {
    return ne.getState().audioInputDevices;
  }
  static getVideoInputDevices() {
    return ne.getState().videoInputDevices;
  }
  static getAudioOutputDevices() {
    return ne.getState().audioOutputDevices;
  }
  static getCurrentAudioInputDevice() {
    return ne.getState().audioInputDevice;
  }
  static getCurrentVideoInputDevice() {
    return ne.getState().videoInputDevice;
  }
  static getCurrentAudioOutputDevice() {
    return ne.getState().audioOutputDevice;
  }
};
P(zn, "loggedInUser", null), P(zn, "isInitialized", !1), P(zn, "loginInProgress", !1), P(zn, "appSettings", null), P(zn, "loginListeners", /* @__PURE__ */ new Map()), P(zn, "constants", G4), P(zn, "CallLogRequestBuilder", r8), P(zn, "CallLog", $g), // v4 related changes start here
/**
 * @deprecated Use CometChatCalls.init passing object directly.
 */
P(zn, "CallAppSettingsBuilder", q4), /**
 * @deprecated Use CometChatCalls.joinSession passing object directly.
 */
P(zn, "CallSettingsBuilder", $4), /**
 * @deprecated Use CometChatCalls.addEventListener
 */
P(zn, "OngoingCallListener", n8);
let Zf = zn;
process.env.NODE_ENV === "playwright-test" && (window.CometChatCalls = Zf);
window.CometChatCalls = Zf;
const u8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CometChatCalls: Zf
}, Symbol.toStringTag, { value: "Module" }));
export {
  $g as CallLog,
  d8 as CallSession,
  Zf as CometChatCalls,
  u8 as default
};
//# sourceMappingURL=index.es.js.map
